{
  "sv": {
    "Search": {
      "Spotlight": "Sök",
      "$$noContext": "Sök"
    },
    "Global Policy Overview": {
      "Topmenu": "Policyöversikt",
      "$$noContext": "Översikt Global Policy"
    },
    "History Center": {
      "Topmenu": "Historik",
      "$$noContext": "Historiskt centrum"
    },
    "Report Center": {
      "Topmenu": "E-postrapporter",
      "$$noContext": "Rapporteringscenter"
    },
    "Users": {
      "Topmenu": "Användare",
      "$$noContext": "Användare"
    },
    "No content was found": {
      "page-details -> Inventory -> links. No result message": "Inget innehåll hittades",
      "$$noContext": "Inget innehåll hittades"
    },
    "&nbsp;&nbsp;&nbsp;Passwords does not match": "Lösenorden stämmer inte överens",
    "(HTML and documents)": "(HTML och dokument)",
    "(No title found)": "(Ingen titel hittades)",
    "(The HTML snippet is now Marked as Reviewed/Ignored)": "(HTML-strängen har nu markerats som Granskat/ignorerat)",
    "(This policy is marked as unwanted content)": "(Denna policy har markerats som oönskat innehåll)",
    "+ Add new check": "+ Lägg till en ny kontroll",
    "+ Add new user": "+ Lägg till en ny användare",
    "1 min.": "1 min.",
    "1 minute": "1 minut",
    "10 min.": "10 min.",
    "10th to 12th grade": "10:e till 12:e klass",
    "120 min.": "120 minuter.",
    "15 min.": "15 min.",
    "1st": "1:a",
    "2nd": "2:a",
    "30 min.": "30 min.",
    "3rd": "3:e",
    "5 min.": "5 min.",
    "5 minutes": "5 minuter",
    "5th grade": "5:e klass",
    "60 min.": "60 min.",
    "6th grade": "6:e klass",
    "7th grade": "7:e klass",
    "8th to 9th grade": "8:e till 9:e klass",
    "A": "A",
    "A list of all external PDF files already reviewed for accessibility issues": "En lista över alla externa PDF-filer som redan har granskats beträffande tillgänglighetsproblem",
    "A list of all external PDF files that you need to check for accessibility issues": "En lista över alla externa PDF-filer som du behöver kontrollera för tillgänglighetsproblem",
    "A list of all internal PDF files already reviewed for accessibility issues": "En lista över alla externa PDF-filer som redan har granskats beträffande tillgänglighetsproblem",
    "A list of all internal PDF files that have been marked as failed for accessibility issues": "En lista över alla interna PDF-filer som har markerats som underkända på grund av tillgänglighetsproblem ",
    "A list of all internal PDF files that have been marked as queued for accessibility issues": "En lista över alla interna PDF-filer i kö för tillgänglighetstest",
    "A list of all internal PDF files that you need to check for accessibility issues": "En lista över alla interna PDF-filer som du behöver kontrollera för tillgänglighetsproblem",
    "AA": "AA",
    "AAA": "AAA",
    "ACCESSIBILITY OVERVIEW": "TILLGÄNGLIGHETSÖVERSIKT",
    "API Token": "API-symbol",
    "API URL": "URL FÖR API",
    "API User": "API-användare",
    "API User Details": "Information om API-användare",
    "API Users": "API-användare",
    "About": "Om",
    "Accept": "Acceptera",
    "Accessibility": "Tillgänglighet",
    "Accessibility Check": "Tillgänglighetskontroll",
    "Accessibility Diagnostics": "Diagnostik av tillgänglighet",
    "Accessibility Fast Track": "Snabbspår för tillgänglighet",
    "Accessibility Icon": "Ikon för tillgänglighet",
    "Accessibility Snippet": "Tillgänglighetsutdrag",
    "Accessibility Source Code": "Tillgänglighet Källkod",
    "Accessibility checks compliance by level": "Efterlevnad av tillgänglighetskontroller per nivå",
    "Accessibility checks not in compliance with domain": "Tillgänglighetskontroller som inte överensstämmer med domänen",
    "Accessibility error type": "Typ av tillgänglighetsfel",
    "Accessibility errors": "Tillgänglighetsfel",
    "Accessibility fixes": "Korrigeringar av tillgängligheten",
    "Accessibility help center": "Hjälpcenter för tillgänglighet",
    "Accessibility issues": "Tillgänglighetsproblem",
    "Accessibility level": "Tillgänglighetsnivå",
    "Accessibility mode": "Tillgänglighetsläge",
    "Accessibility review type": "Typ av granskning av tillgänglighet",
    "Account dictionary": "Konto-lexikon",
    "Action": "Åtgärd",
    "Actions": "Åtgärder",
    "Actions per visit": "Åtgärder per besök",
    "Active": "Aktiv",
    "Add": "Lägg till",
    "Add Custom Multistep Javascript": "Lägg till anpassat Javascript i flera steg",
    "Add Extension Name": "Lägg till tilläggsnamn",
    "Add Heatmap rule to a Page": "Lägg till en Heatmap-regel på en sida",
    "Add Heatmaps": "Lägg till Heatmaps",
    "Add PageAssist script": "Lägg till PageAssist-skriptet",
    "Add PageCorrect": "Lägg till PageCorrect",
    "Add Profile": "Lägg till profil",
    "Add Rule": "Lägg till regel",
    "Add Skip to PageAssist": "Lägg till Hoppa över till PageAssist",
    "Add a new exemption to your heartbeat check": "Lägg till ett nytt undantag till din drifttidskontroll",
    "Add a new page to start tracking individual pages' performance. Get an overview of load times and opportunities to speed up your site.": "Lägg till en ny sida för att börja spåra enskilda sidors prestanda. Få en överblick över laddningstider och möjligheter att snabba upp din webbplats.",
    "Add a non-user email": "Lägg till en e-postadress för icke-användare",
    "Add another rule": "Lägg till ytterligare en regel",
    "Add email": "Lägg till e-postadress",
    "Add exemption": "Lägg till undantag",
    "Add new check": "Lägg till en ny kontroll",
    "Add new domain": "Lägg till en ny domän",
    "Add new exemption": "Lägg till ett nytt undantag",
    "Add new label": "Lägg till en ny etikett",
    "Add new page": "Lägg till nytt sida",
    "Add new policy": "Lägg till en ny policy",
    "Add new user": "Skapa användare",
    "Add non users": "Lägg till icke-användare",
    "Add reason (Optional)": "Lägg till skäl (valfritt)",
    "Add rule to policy": "Lägg till en regel i en policy",
    "Add rule to the policy": "Lägg till en regel i policyn",
    "Add task": "Lägg till uppgift",
    "Add timeslots where you won't receive notifications on downtime and slow responsetimes.": "Lägg till tidsperioder där du inte får meddelanden om driftstopp och långsamma svarstider.",
    "Add to all languages": "Lägg till alla språk",
    "Add to dictionary": "Lägg till i lexikonet",
    "Add to dictionary for all languages": "Lägg till lexikon för alla språk",
    "Added": "Tillagd",
    "Added by": "Tillagd av",
    "Added date": "Tilläggsdatum",
    "Address": "Adress",
    "Admin": "Admin",
    "Advanced Domain Options": "Avancerade domänalternativ",
    "Affected image": "Berörd bild",
    "Affected pages": "Berörda sidor",
    "Affected pages by priority": "Berörda sidor efter prioritet",
    "Affected pages by severity": "Berörda sidor efter allvarlighetsgrad",
    "Affects": "Påverkar",
    "After": "Efter",
    "All": "Alla",
    "All Failed Internal PDF files": "Alla misslyckade interna PDF-filer",
    "All Pending External PDF files": "Alla väntande externa PDF-filer",
    "All Pending Internal PDF files": "Alla väntande interna PDF-filer",
    "All Queued Internal PDF files": "Alla interna PDF-filer som står i kö",
    "All Reviewed External PDF files": "Alla granskade externa PDF-filer",
    "All Reviewed Internal PDF files": "Alla granskade interna PDF-filer",
    "All assets": "Alla tillgångar",
    "All broken images": "Alla trasiga bilder",
    "All broken links": "Alla trasiga länkar",
    "All heartbeat checkpoints": "Alla kontrollpunkter för drifttid",
    "All incident checkpoints in the selected time span": "Alla kontrollpunkter för incidenter under den valda tidsperioden",
    "All level A accessibility checks": "Alla kontroller av tillgänglighet på nivå A",
    "All level AA accessibility checks": "Alla kontroller av tillgänglighet på nivå AA",
    "All level AAA accessibility checks": "Tillgänglighetskontroller på alla AAA-nivåer",
    "All levels": "Alla nivåer",
    "All modules": "Alla moduler",
    "All modules - Content with Issues": "Alla moduler - Innehåll med Problem",
    "All notifications": "Alla meddelanden",
    "All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.": "Allt du behöver göra är att infoga nedanstående skript i BODY-taggen på din webbplats. Det är bara att kopiera och klistra in det som det är.",
    "Analytics (Last 7 days)": "Analys (de senaste 7 dagarna)",
    "And": "Och",
    "Appears on": "Förekommer på",
    "Apply": "Tillämpa",
    "Archive": "Arkiv",
    "Archive files": "Arkivfiler",
    "Archived": "Arkiverade",
    "Are you sure you want to Mark this link as unignored?": "Är du säker på att du vill markera den här länken som oignorerade?",
    "Are you sure you want to Request All PDF Accessibility checks?": "Är du säker på att du vill begära Alla tillgänglighetskontroller av PDF-filer?",
    "Are you sure you want to add to Request PDF Accessibility check from selection?": "Är du säker på att du vill lägga till Kontroll av tillgänglighet för PDF-filer från urvalet?",
    "Are you sure you want to add to all the dictionaries?": "Är du säker på att du vill lägga till i alla lexikon?",
    "Are you sure you want to add to the dictionary?": "Är du säker på att du vill lägga till i ordlistan?",
    "Are you sure you want to close this form without saving your changes?": "Är du säker på att du vill stänga formuläret utan att spara ändringarna?",
    "Are you sure you want to confirm this misspelling?": "Är du säker på att du vill bekräfta denna felstavning?",
    "Are you sure you want to delete the API User [[apiUserId]]": "Är du säker på att du vill ta bort API-användaren [[apiUserId]]",
    "Are you sure you want to delete this exemption?": "Är du säker på att du vill ta bort detta undantag?",
    "Are you sure you want to delete this source exclude?": "Är du säker på att du vill ta bort den här källan?",
    "Are you sure you want to ignore all errors for this check?": "Är du säker på att du vill ignorera alla fel för denna kontroll?",
    "Are you sure you want to ignore the selected issue on this page?": "Är du säker på att du vill ignorera det valda problemet på den här sidan?",
    "Are you sure you want to ignore this check for this domain?": "Är du säker på att du vill ignorera denna kontroll för den här domänen?",
    "Are you sure you want to ignore this check for this page?": "Är du säker på att du vill ignorera denna kontroll för den här sidan?",
    "Are you sure you want to ignore this issue?": "Är du säker på att du vill ignorera detta problem?",
    "Are you sure you want to ignore this misspelling?": "Är du säker på att du vill ignorera denna felstavning?",
    "Are you sure you want to mark this issue as fixed?": "Är du säker på att du vill markera det här problemet som åtgärdat?",
    "Are you sure you want to mark this issue as not fixed?": "Är du säker på att du vill markera problemet som inte åtgärdat?",
    "Are you sure you want to mark this link as fixed?": "Är du säker på att du vill markera den här länken som fixad?",
    "Are you sure you want to mark this link as ignored?": "Är du säker på att du vill markera länken som ignorerade?",
    "Are you sure you want to mark this link as not fixed?": "Är du säker på att du vill markera den här länken som ej åtgärdad?",
    "Are you sure you want to remove manually added user?": "Är du säker på att du vill ta bort manuellt tillagda användare?",
    "Are you sure you want to remove review for this issue?": "Är du säker på att du vill ta bort granskningen av detta problem?",
    "Are you sure you want to remove review on all errors for this check?": "Är du säker på att du vill ta bort granskning av alla fel för denna kontroll?",
    "Are you sure you want to remove this group?": "Är du säker på att du vill ta bort den här gruppen?",
    "Are you sure you want to remove this host?": "Är du säker på att du vill ta bort den här värden?",
    "Are you sure you want to remove this rule?": "Är du säker på att du vill ta bort den här regeln?",
    "Are you sure you want to remove this?": "Är du säker på att du vill ta bort det här?",
    "Are you sure you want to review all errors for this check?": "Är du säker på att du vill granska alla fel för den här kontrollen?",
    "Are you sure you want to review this issue?": "Är du säker på att du vill granska det här problemet?",
    "Are you sure you want to set this document as reviewed?": "Är du säker på att du vill ange att dokumentet är granskat?",
    "Are you sure you want to start on-demand scan?": "Är du säker på att du vill starta skanning på begäran?",
    "Are you sure you want to stop current crawl?": "Är du säker på att du vill stoppa nuvarande crawl?",
    "Are you sure you want to the request ADA clarification for [[name]]?": "Är du säker på att du vill begära ett ADA-förtydligande för [[name]]?",
    "Are you sure you want to undo review of this document?": "Är du säker på att du vill ångra granskningen av det här dokumentet?",
    "Are you sure you want to undo reviewing this document?": "Är du säker på att du vill ångra granskningen av det här dokumentet?",
    "Are you sure you want to unignore all errors for this check?": "Är du säker på att du vill avignorera alla fel för denna kontroll?",
    "Are you sure you want to unignore the selected issue on this page?": "Är du säker på att du vill avignorera den valda frågan på den här sidan?",
    "Are you sure you want to unignore this check for this domain?": "Är du säker på att du vill avignorera den här kontrollen för den här domänen?",
    "Are you sure you want to unignore this check for this page?": "Är du säker på att du vill avignorera denna kontroll för den här sidan?",
    "Are you sure you want to unignore this issue?": "Är du säker på att du vill avignorera det här problemet?",
    "Are you sure you want to unignore this link?": "Är du säker på att du vill avignorera denna länk?",
    "Are you sure you want to unignore this misspelling?": "Är du säker på att du vill avignorera denna felstavning?",
    "Are you sure you want to unpin this domain": "Är du säker på att du vill ta bort den här domänen?",
    "Are you sure you want unignore this link?": "Är du säker på att du vill avignorera länken?",
    "Assign Heatmap Rule": "Tilldela en Heatmap-regel",
    "Assign to the Performance Module": "Tilldela till prestationsmodulen",
    "Attribute": "Attribut",
    "Audit": "Revision",
    "Audit Log": "Granskningslogg",
    "Autoselect": "Automatiskt val",
    "Average First Contentful Paint": "Genomsnittlig första Contentful Paint",
    "Average First Meaningful Paint": "Genomsnittlig första Meaningful Paint",
    "Average Performance Score": "Genomsnittligt Utförandepoäng",
    "Average Performance score": "Genomsnittlig utförandepoäng",
    "Average Time to Interactive": "Genomsnittlig tid till interaktivitet",
    "Average response time": "Genomsnittlig svarstid",
    "Average time": "Genomsnittlig tid",
    "Average uptime": "Genomsnittlig drifttid",
    "Average visit time": "Genomsnittlig besökstid",
    "Avg. Performance Score": "Medelvärde. Resultat",
    "Avg. Visit Time": "Medelvärde. Besökstid",
    "Avg. response": "Genomsnittligt svar",
    "BETA": "BETA",
    "Back": "Tillbaka",
    "Back to Heartbeat Overview": "Tillbaka till Drifttidsöversikt",
    "Bar": "Bar",
    "Basic Auth": "Grundläggande autentisering",
    "Before": "Före",
    "Below 5th grade": "Under 5:e klass",
    "Below you can see a list of all pages that contains the title": "Nedan kan du se en lista över alla sidor som innehåller titeln",
    "Book online training": "Boka utbildning online",
    "Bounce Rates": "Avvisningsfrekvenser",
    "Bounce rate": "Avvisningsfrekvens",
    "Bounce rates": "Avvisningsfrekvenser",
    "Brand name": "Varumärke",
    "Broken Image": "Trasig bild",
    "Broken Image Links per page": "Trasiga bildlänkar per sida",
    "Broken Images": "Trasiga bilder",
    "Broken Links": "Trasiga länkar",
    "Broken Page Link": "Trasig sidlänk",
    "Broken image affecting most content": "Trasig bild som påverkar det mesta av innehållet",
    "Broken image affecting most pages": "Trasig bild som påverkar de flesta sidor",
    "Broken images": "Trasiga bilder",
    "Broken images with page count": "Trasiga bilder med sidantal",
    "Broken link": "Trasig länk",
    "Broken link affecting most content": "Trasig länk som påverkar flest sidor",
    "Broken link affecting most pages": "Trasig länk som påverkar de flesta sidor",
    "Broken links": "Trasiga länkar",
    "Broken links per page": "Trasiga länkar per sida",
    "Broken links with page count": "Trasiga länkar med sidantal",
    "Browser": "Webbläsare",
    "Browser Extension": "Webbläsartillägg",
    "Browsers": "Webbläsare",
    "Browsers Overview": "Översikt över webbläsare",
    "Bubble": "Bubbla",
    "Build it from scratch": "Bygg det från grunden",
    "By deleting this domain all domain groups related to this domain, will also be deleted": "Om du raderar den här domänen kommer alla domängrupper som är relaterade till den här domänen också att raderas",
    "By user": "Efter användare",
    "CMS": "CMS",
    "CMS url": "CMS-url",
    "CSS": "CSS",
    "CSS Target Selector": "CSS-målväljare",
    "CSS id or class selector to search for": "CSS-id eller klassväljare att söka efter",
    "CSS selector to find submit button": "CSS-väljare för att hitta knappen Skicka",
    "Cache TTL": "Cache TTL",
    "Cancel": "Avbryt",
    "Case sensitive": "Skiftlägeskänslig",
    "Categories": "Kategorier",
    "Category": "Kategori",
    "Change password": "Ändra lösenord",
    "Changed to": "Ändrad till",
    "Changes": "Ändringar",
    "Changes added": "Ändringar har lagts till",
    "Changes in selected time frame:": "Ändringar under den valda tidsramen:",
    "Changes since Previous Crawl": "Ändringar sedan föregående genomsökning",
    "Changes since previous crawl": "Ändringar sedan föregående genomsökning",
    "Characters": "Tecken",
    "Chart": "Diagram",
    "Chart is now showing: [[name]]": "Diagrammet visas nu: [[name]]",
    "Check": "Kontrollera",
    "Check List Export": "Export av checklistor",
    "Check all links in this section": "Kontrollera alla länkar i det här avsnittet",
    "Check all misspellings in this section": "Kontrollera alla felstavningar i detta avsnitt",
    "Check all modules": "Kontrollera alla moduler",
    "Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)": "Kontrollera och åtgärda innehållsproblem på din webbplats (t.ex. felstavningar, trasiga länkar, läsbarhet och andra problem)",
    "Check frequency": "Kontrollera frekvensen",
    "Check frequency:": "Kontrollera frekvensen:",
    "Check is ignored": "Kontrollen ignoreras",
    "Check is ignored for the entire domain": "Kontrollen ignoreras för hela domänen",
    "Check link": "Kontrollera länken",
    "Check misspelling": "Kontrollera felstavning",
    "Check name": "Kontrollera namn",
    "Check off as Reviewed": "Bocka av som granskad",
    "Check passed": "Kontrollen godkändes",
    "Check site status": "Kontrollera webbplatsens status",
    "Checking": "Kolla",
    "Checkpoint exemptions": "Undantag från kontrollpunkter",
    "Checkpoint has been updated.": "Kontrollpunkten har uppdaterats.",
    "Checkpoint information": "Information om kontrollpunkten",
    "Checkpoint:": "Kontrollpunkt:",
    "Checks": "Kontroller",
    "Checks passed": "Kontroller som godkänts",
    "Checks whether your website is responding and measures the response time of the server": "Kontrollerar om din webbplats svarar och mäter serverns svarstid",
    "Choose Operator": "Välj operatör",
    "Choose What to Scan": "Välj vad som ska skannas",
    "Choose a response time": "Välj en svarstid",
    "Choose a response time notification": "Välj ett meddelande om svarstid",
    "Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned": "Välj en befintlig datalag som standardmall för din säkerhetsgranskning. Redigera problemen nedan för att utesluta vissa taggar från att skannas",
    "Choose checks": "Välj kontroller",
    "Choose domains": "Välj domäner",
    "Choose how to view the Heatmaps Dashboard": "Välj hur du vill visa Heatmaps Instrumentpanel",
    "Choose notification time": "Välj tid för avisering",
    "Choose the minimum amount of words to scan for readability on a page": "Välj det minsta antalet ord som ska skannas för läsbarhet på en sida",
    "Choose where the policy should apply": "Välj var policyn ska tillämpas",
    "Chrome extension": "Tillägg till Chrome",
    "City": "Stad",
    "Clear all labels": "Rensa alla etiketter",
    "Clear and close filters": "Rensa och stäng filter",
    "Click here to create your first policy": "Klicka här för att skapa din första policy",
    "Click here to edit": "Klicka här för att redigera",
    "Click to create your first policy": "Klicka för att skapa din första policy",
    "Clone": "Klona",
    "Close": "Stäng",
    "Close filters": "Stäng filter",
    "Collapse": "Minimera",
    "Collapse menu": "Komprimera menyn",
    "College": "Högskola",
    "College graduate": "Högskoleutbildad",
    "Coming soon": "Kommer snart",
    "Comment": "Kommentar",
    "Common policy violations": "Vanliga överträdelser av policyn",
    "Company Info": "Företagsinfo",
    "Compliance": "Efterlevnad",
    "Compliance {{compliancePercentage}}": "Efterlevnad {{compliancePercentage}}",
    "Compound Export": "Export av sammansättning",
    "Compound Report": "Rapport om Sammansättning",
    "Confirm": "Bekräfta",
    "Confirm as misspelling": "Bekräfta som felstavning",
    "Confirm misspelling": "Bekräfta felstavning",
    "Confirm this word as a misspelling": "Bekräfta att detta ord är felstavat",
    "Confirmed": "Bekräftad",
    "Confirmed misspellings": "Bekräftade felstavningar",
    "Congratulations no violations were found": "Gratulerar Inga överträdelser konstaterades",
    "Connection Profile": "Anslutningsprofil",
    "Connections per minute": "Anslutningar per minut",
    "Constraint": "Begränsning",
    "Constraint pattern": "Begränsningsmönster",
    "Contact me about more Performance Pages": "Kontakta mig om fler Prestationssidor",
    "Contact me about more performance profiles": "Kontakta mig om fler prestationsprofiler",
    "Containing": "Innehåller",
    "Contains": "Innehåller",
    "Contains confirmed misspellings, broken links & images": "Innehåller bekräftade felstavningar, trasiga länkar och bilder",
    "Contains confirmed misspellings, broken links or images": "Innehåller bekräftade felstavningar, trasiga länkar eller bilder",
    "Contains high, medium & low opportunities for all pages": "Innehåller höga, medelhöga och låga möjligheter för alla sidor",
    "Contains high, medium & low severity issues for all pages": "Innehåller problem med hög, medelhög och låg svårighetsgrad för alla sidor",
    "Contains issues with high, medium and low priority for all pages": "Innehåller problem med hög, medelhög och låg prioritet för alla sidor",
    "Content": "Innehåll",
    "Content Links": "Länkar till innehåll",
    "Content Policies": "Innehållspolicyer",
    "Content Policy Violations": "Överträdelser av innehållspolicy",
    "Content in compliance": "Innehåll i enlighet med kraven",
    "Content must be robust enough that it can be interpreted reliably by a wide variety of user agents, including assistive technologies.": "Innehållet måste vara tillräckligt robust för att kunna tolkas på ett tillförlitligt sätt av en mängd olika användarprogram, inklusive hjälpmedel.",
    "Content policies": "Innehållspolicyer",
    "Content with Broken Image": "Innehåll med trasig bild",
    "Content with Broken Link": "Innehåll med trasig länk",
    "Content with Broken Links": "Innehåll med trasiga länkar",
    "Content with Data Issues": "Innehåll med dataproblem",
    "Content with Data Issues export": "Innehåll med export av dataproblem",
    "Content with Policy Matches": "Innehåll med policymatchningar",
    "Content with QA Errors": "Innehåll med kvalitetsfel",
    "Content with broken links": "Innehåll med trasiga länkar",
    "Content with issues": "Innehåll med problem",
    "Content with policy violations": "Innehåll med överträdelser av policyn",
    "Content with violations": "Innehåll med överträdelser",
    "Context": "Kontext",
    "Country": "Land",
    "Crawl Automatically": "Automatisk Crawl",
    "Crawl Options": "Crawl-alternativ",
    "Crawl done on": "Crawl utförd på",
    "Crawl finalized on": "Crawl avslutades den",
    "Crawl info": "Crawl-information",
    "Crawl runtime:": "Körtid för crawl:",
    "Crawl started:": "Crawl påbörjad:",
    "Crawl status": "Status för crawl",
    "Crawl status:": "Status för crawl:",
    "Crawled Documents ([[documentCount]])": "Dokument som har crawlats ([[documentCount]])",
    "Crawled at": "Crawlade på",
    "Crawled pages": "Crawlade sidor",
    "Crawling": "Crawlar",
    "Create a policy to make an email as unwanted content": "Skapa en policy för att göra ett e-postmeddelande till oönskat innehåll",
    "Create as policy": "Skapa en policy",
    "Create label": "Skapa etikett",
    "Create new domain group": "Skapa en ny domängrupp",
    "Create new group": "Skapa ny grupp",
    "Create user": "Skapa användare",
    "Create your own policy": "Skapa din egen policy",
    "Created": "Skapad",
    "Created At": "Skapad den",
    "Created at": "Skapad",
    "Created date": "Skapat datum",
    "Created:": "Skapad:",
    "Current domain status": "Aktuell domänstatus",
    "Current status": "Nuvarande status",
    "Custom": "Anpassad",
    "Custom Multistep": "Anpassade flersteg",
    "Custom Profile": "Anpassad profil",
    "Custom fixes": "Anpassade korrigeringar",
    "Custom rule": "Anpassad regel",
    "Customer": "Kund",
    "Customer Report": "Kundrapport",
    "DATA PRIVACY OVERVIEW": "ÖVERSIKT ÖVER DATASKYDD",
    "DISCLAIMER": "ANSVARSFÖRKLARING",
    "Daily": "Dagligen",
    "Danish": "Danska",
    "Dark": "Mörk",
    "Dashboard": "Kontrollpanel",
    "Data Issues": "Dataproblem",
    "Data Privacy": "Dataskydd",
    "Data Privacy Diagnostics": "Diagnostik av dataskydd",
    "Data Privacy Fast Track": "Snabbspår för dataskydd",
    "Data Privacy Help Center": "Hjälpcenter för dataskydd",
    "Data Privacy Info Type Icon": "Info om dataskydd Typ Ikon",
    "Data Privacy Issues": "Problem kring dataskydd",
    "Data Privacy Summary Export": "Sammanfattning av dataskyddet Export",
    "Data Privacy issues found": "Frågor om dataintegritet som upptäckts",
    "Data Regulations": "Dataförordningar",
    "Data Violations": "Överträdelser av Data",
    "Data issues": "Dataproblem",
    "Data issues export": "Export av dataproblem",
    "Data privacy": "Dataskydd",
    "Data privacy violations": "Kränkningar av dataintegritet",
    "Data protection and privacy policy statement": "Meddelande om dataskydd och integritetspolicy",
    "Date": "Datum",
    "Day": "Dag",
    "Days": "Dagar",
    "Dead": "Död",
    "Default": "Standard",
    "Default for CMS": "Standard för CMS",
    "Default value*": "Standardvärde*",
    "Define meta headers to match": "Definiera meta-rubriker som ska matcha",
    "Define size of files to look for": "Definiera storleken på de filer som ska sökas",
    "Define size of images to look for": "Definiera storleken på de bilder som ska sökas",
    "Delete": "Radera",
    "Delete All": "Radera alla",
    "Delete user": "Radera författare",
    "Describe the exclude": "Beskriv den uteslutna",
    "Description": "Beskrivning",
    "Desktop": "Skrivbord",
    "Details": "Detaljer",
    "Device": "Enhet",
    "Device Overview": "Översikt över enheten",
    "Device not found": "Enheten har inte hittats",
    "Device:": "Enhet:",
    "Devices": "Enheter",
    "Diagnostics": "Diagnostik",
    "Dictionary": "Ordbok",
    "Difficulty": "Svårighetsgrad",
    "Direct visits": "Direkta besök",
    "Disabling": "Inaktivera",
    "Display policy in other services": "Visningspolicy i andra tjänster",
    "Display this policy as:": "Visa den här policyn som:",
    "Distribution of Data Privacy levels": "Fördelning av nivåer av dataskydd",
    "Distribution of PageCorrects across all change types": "Fördelning av PageCorrects över alla ändringstyper",
    "Distribution of SEO levels": "Fördelning av SEO-nivåer",
    "Distribution of policies that match their corresponding setting": "Distribution av policyer som matchar motsvarande inställning",
    "Distribution of policies that matches their corresponding setting": "Fördelning av policyer efter typ",
    "Do you want the policy to run every time your website is crawled?": "Vill du att policyn ska köras varje gång din webbplats crawlas?",
    "Do you want to find pages which match the query on one or multiple lines?": "Vill du hitta sidor som matchar sökfrågan på en eller flera rader?",
    "Do you want to find pages which match the query or pages which does not match the query": "Vill du hitta sidor som matchar sökfrågan eller sidor som inte matchar sökfrågan?",
    "Do you want to update the Script Settings, for this Domain?": "Vill du uppdatera skriptinställningarna för den här domänen?",
    "Document": "Dokument",
    "Document Class": "Dokumentklass",
    "Document Dashboard": "Kontrollpanel för dokument",
    "Document Details": "Detaljer om dokumentet",
    "Document Extension": "Förlängning av dokumentet",
    "Document Ignore Class": "Klass för ignorering av dokument",
    "Document first detected": "Dokument som först upptäcktes",
    "Document scan": "Skanning av dokument",
    "Documents": "Dokument",
    "Documents Crawled": "Dokument som har sökts upp",
    "Documents basic": "Grundläggande dokument",
    "Documents crawled": "Dokument som har crawlats",
    "Documents extended": "Utökade dokument",
    "Documents with Broken Image": "Dokument med trasig bild",
    "Documents with Broken Link": "Dokument med trasiga länkar",
    "Domain": "Domän",
    "Domain Compliance": "Efterlevnad av domänen",
    "Domain Data Privacy Settings": "Inställningar för dataskydd för domäner",
    "Domain Detail": "Detaljer om domänen",
    "Domain Details": "Detaljer om domänen",
    "Domain Groups": "Domängrupper",
    "Domain Picker Closed": "Domain Picker stängd",
    "Domain Picker Opened": "Domain Picker öppnad",
    "Domain compliance": "Efterlevnad av domänen",
    "Domain group": "Domängrupp",
    "Domain title and URL": "Domänens titel och URL",
    "Domain:": "Domän:",
    "Domains": "Domäner",
    "Domains/groups selected": "Valda domäner/grupper",
    "Done": "Klar",
    "Download": "Ladda ner",
    "Download the Chrome extension": "Ladda ner Chrome-tillägget",
    "Download the Edge add-on": "Ladda ner tillägget Edge",
    "Download the Firefox add-on": "Ladda ner Firefox-tillägget",
    "Downloads": "Nedladdningar",
    "Downtime": "Nedtid",
    "Downtime (Minutes)": "Nedtid (minuter)",
    "Downtime notification": "Meddelande om driftstopp",
    "Drag and drop the rule to add rules to the policy": "Dra och släpp regeln för att lägga till regler i policyn",
    "Dropdown": "Rullgardin",
    "Duration": "Varaktighet",
    "Easy": "Enkel",
    "Easy to read pages understood by most. Example: fiction literature for adults": "Lättlästa sidor som de flesta förstår. Exempel: skönlitteratur för vuxna",
    "Edge add-on": "Tillägg till Edge",
    "Edit": "Redigera",
    "Edit Labels": "Redigera etiketter",
    "Edit Performance Page": "Redigera sidan för prestanda",
    "Edit customer information": "Redigera kundinformation",
    "Edit domain": "Redigera domän",
    "Edit domain group": "Redigera domängrupp",
    "Edit exemption": "Bearbeta undantaget",
    "Edit label": "Redigera etikett",
    "Edit labels": "Redigera etiketter",
    "Edit my profile": "Redigera min profil",
    "Edit or Delete PageCorrect": "Redigera eller radera PageCorrect",
    "Edit uptime": "Redigera drifttid",
    "Edit user": "Redigera användare",
    "Edit users": "Redigera användare",
    "Edit your exemption": "Redigera ditt undantag",
    "Edit:": "Ändra:",
    "Effect on compliance": "Effekter på efterlevnaden",
    "Effect on overall compliance level": "Effekter på den sammanlagd efterlevnad",
    "Element": "Element",
    "Element Tree Path": "Element Tree Path",
    "Email": "E-post",
    "Email Notifications": "E-postnotifikationer",
    "Email addresses": "E-postadresser",
    "Email receiver *": "E-postmottagare *",
    "Email to login": "E-post för inloggning",
    "Emails": "E-post",
    "Empty": "Tomt",
    "Empty mailto": "Töm mailto",
    "Enable / Disable Accessibility mode": "Aktivera/avaktivera tillgänglighetsläge",
    "Enable Document Tracking": "Aktivera dokumentspårning",
    "Enable Export Email Notification": "Aktivera e-postmeddelanden för export",
    "Enable Statistics": "Aktivera statistik",
    "Enabled features": "Aktiverade funktioner",
    "Enabling": "Aktivera",
    "End at": "Slutar vid",
    "End date": "Slutdatum",
    "End time": "Sluttid",
    "English": "Engelska",
    "Enter the full URL": "Ange den fullständiga webbadressen",
    "Entries": "Poster",
    "Entry": "Post",
    "Entry Pages": "Ingångssidor",
    "Entry and Exit Pages": "Ingångs- och utgångssidor",
    "Error": "Fel",
    "Error Name": "Namnfel",
    "Errors": "Fel",
    "Errors ([[audits]])": "Fel ([[audits]])",
    "Exact": "Exakt",
    "Example: academic publications": "Exempel: akademiska publikationer",
    "Example: children's literature": "Exempel: barnlitteratur",
    "Example: daily newspapers": "Exempel: dagstidningar",
    "Example: fiction books": "Exempel: skönlitterära böcker",
    "Example: legal texts": "Exempel: juridiska texter",
    "Examples": "Exempel",
    "Excel Documents": "Excel-dokument",
    "Exclude": "Exkludera",
    "Exclude links that contains class name": "Exkludera länkar som innehåller klassnamn",
    "Exclude pattern": "Exkludera mönster",
    "Excluded IP addresses from statistics": "Uteslutna IP-adresser från statistiken",
    "Exemption": "Undantag",
    "Exemption options": "Alternativ för undantag",
    "Exemption time": "Tid för undantag",
    "Exemptions": "Undantag",
    "Exit Pages": "Sidor för avslutning",
    "Exits": "Utgångar",
    "Expand": "Expandera",
    "Explain the rationale behind the policy and which actions, editors should take to correct the violation": "Förklara grunden för policyn och vilka åtgärder som redaktörerna bör vidta för att rätta till överträdelsen",
    "Export": "Exportera",
    "Export CSV": "Exportera CSV",
    "Export Compound CSV": "Exportera sammansatt CSV",
    "Export Logs": "Exportera loggar",
    "Export list of broken images organized by page and document title": "Exportera en lista över trasiga bilder organiserade efter sida och dokumenttitel",
    "Export list of broken links organized by page and document title": "Exportera en lista över trasiga länkar organiserade efter sida och dokumenttitel",
    "Export list of downtimes for the domain": "Exportera en lista över nedtidsperioder för domänen",
    "Export list of response times": "Exportera en lista över svarstider",
    "External": "Extern",
    "External Export": "Extern export",
    "External PDF Compliance": "Efterlevnad av externa PDF-filer",
    "External PDFs": "Externa PDF-filer",
    "External Referring Domains": "Externa domäner som hänvisar till andra domäner",
    "External Referring domains": "Externa domäner som hänvisar till andra domäner",
    "External referees overview": "Översikt över externa domare",
    "External referring domains": "Externa hänvisande domäner",
    "FCP": "FCP",
    "FMP": "FMP",
    "Facebook": "Facebook",
    "Fail Example": "Exempel på misslyckande",
    "Failed": "Misslyckad",
    "Failing accessibility checks": "Ej godkända tillgänglighetskontroller",
    "Failing accessibility checks gives you information about the current Accessibility status of the website/group. It may vary from the history if there have been changes in ignored and review of accessibility issues": "Om tillgänglighetsgranskningen inte fungerar ger det dig information om webbplatsens/gruppens aktuella status för tillgänglighet. Den kan skilja sig från historiken om det har skett förändringar i ignorerade och granskade tillgänglighetsproblem",
    "Failing check": "Underkänd kontroll",
    "Failing check found": "Kontrollen misslyckades",
    "Failing checks": "Underkända kontroller",
    "Failing checks found": "Kontroller som misslyckats har hittats",
    "Fast Track": "Snabbspår",
    "Fast track html snippet": "Snabbspår html-utdrag",
    "Faster": "Snabbare",
    "Features": "Funktioner",
    "Feedback submitted": "Återkoppling skickad",
    "File size": "Filstorlek",
    "Filter": "Filtrera",
    "Filter by": "Filtrera efter",
    "Filter by:": "Filtrera enligt:",
    "Filter labels list": "Filtrera listan över etiketter",
    "Find and address violations relating to your content guides and regulatory compliance and find outdated content across your website.": "Hitta och åtgärda överträdelser av innehållsriktlinjerna och efterlevnaden av regelverk samt hitta föråldrat innehåll på din webbplats.",
    "Find word(s) without specific context": "Hitta ord utan specifikt sammanhang",
    "Firefox add-on": "Firefox-tillägg",
    "First Contentful Paint": "Första Contentful Paint",
    "First Meaningful Paint": "Första meaningful paint",
    "First name": "Förnamn",
    "Fixed": "Fast",
    "Fixed or ignored violations": "Fastställda eller ignorerade överträdelser",
    "Flesch Kincaid": "Flesch Kincaid",
    "For this domain": "För denna domän",
    "Form": "Formulär",
    "Form fields": "Formulärfält",
    "Forms": "Formulär",
    "Found": "Hittades",
    "Four times a day": "Fyra gånger om dagen",
    "Frames": "Ramar",
    "Friday": "Fredag",
    "From 2 seconds to 8 seconds": "Från 2 sekunder till 8 sekunder",
    "Generating report": "Skapa en rapport",
    "Get advice on how to handle this check": "Få råd om hur du hanterar denna kontroll",
    "Getting {{ logs }} out of {{totalLogs}} logs": "Hämta {{ logs }} från {{totalLogs}} loggar",
    "Global - All Domains": "Globalt - alla domäner",
    "Global Policies": "Globala policys",
    "Global Policy Dashboard": "Instrumentpanel Global Policy",
    "Global Policy List": "Lista över global policy",
    "Go to Global Policy List": "Gå till listan över globala policyer",
    "Go to My Exports": "Gå till Mina exporter",
    "Go to PDFs": "Gå till PDF-filer",
    "Go to Policy List": "Gå till listan över policyer",
    "Go to broken Links": "Gå till trasiga länkar",
    "Go to broken images": "Gå till trasiga bilder",
    "Go to broken links": "Gå till trasiga länkar",
    "Go to checkpoints": "Gå till kontrollpunkter",
    "Go to data issues": "Gå till dataproblem",
    "Go to domain": "Gå till domänen",
    "Go to help center": "Gå till hjälpcentret",
    "Go to mispellings": "Gå till felstavningar",
    "Go to misspellings": "Gå till felstavningar",
    "Go to most visits pages": "Gå till de mest besökta sidorna",
    "Go to page": "Gå till sida",
    "Go to page details": "Gå till sidinformation",
    "Go to potential misspellings": "Gå till eventuella felstavningar",
    "Go to predefined url": "Gå till en fördefinierad webbadress",
    "Go to the dashboard": "Gå till instrumentpanelen",
    "Go to traffic sources overview": "Gå till översikten över trafikkällor",
    "Go to uptime": "Gå till drifttid",
    "Go to visitor overview": "Gå till översikt över besökare",
    "Good job! No incidents was registered": "Bra jobbat! Inga incidenter har registrerats",
    "Good job! No issues were found": "Bra jobbat! Inga problem hittades",
    "Good job! No violations were found": "Bra jobbat! Inga överträdelser upptäcktes",
    "Google": "Google",
    "Greater than 8 seconds": "Längre än 8 sekunder",
    "Grid View": "Grid View",
    "Groups": "Grupper",
    "Guidelines": "Riktlinjer",
    "Guidelines for WCAG 2.0": "Riktlinjer för WCAG 2.0",
    "Guidelines for WCAG 2.1": "Riktlinjer för WCAG 2.1",
    "H1 on this page": "H1 på denna sida",
    "HTML": "HTML",
    "HTML Pages": "HTML-sidor",
    "HTML pages": "HTML-sidor",
    "HTML snippet": "HTML-utdrag",
    "HTML snippet affecting compliance level": "HTML-utdrag som påverkar efterlevnadsnivån",
    "HTML snippet failing check": "Kontrollen av HTML-utdrag misslyckas",
    "Hard": "Svårt",
    "Hard to read text. Example: popular science magazines and easier academic publications": "Svårt att läsa texten. Exempel: populärvetenskapliga tidskrifter och enklare akademiska publikationer",
    "Harmony CMS": "Harmony CMS",
    "Header type": "Typ av rubrik",
    "Headers": "Sidhuvud",
    "Headlinks": "Huvudlänkar",
    "Heartbeat": "Driftstid",
    "Heartbeat Downtime": "Driftstid Nere",
    "Heartbeat Response Time": "Svarstid för driftstid",
    "Heartbeat status saved": "Driftstidsstatus sparad",
    "Heatmaps": {
      "$$noContext": "Heatmaps",
      "Topmenu": "Värmekartor"
    },
    "Help Center": "Hjälpcenter",
    "Help center": "Hjälpcenter",
    "High": "Hög",
    "High impact": "Stor påverkan",
    "High impact opportunities": "Möjligheter med stor inverkan",
    "High priority": "Hög prioritet",
    "High severity": "Hög svårighetsgrad",
    "High severity issues": "Problem med hög svårighetsgrad",
    "Highest level of readability. Example: complex academic and legal texts": "Högsta möjliga läsbarhet. Exempel: komplexa akademiska och juridiska texter",
    "History": "Historik",
    "Hit": "Träff",
    "Hits": "Träffar",
    "Hits across all domains and modules": "Träffar inom alla områden och moduler",
    "Hits on domain": "Träffar på domänen",
    "Home": "Hem",
    "Host": "Uthyrare",
    "Hosts": "Adresser",
    "Hosts cannot be empty": "Värdarna kan inte vara tomma",
    "Hours": "Timmar",
    "How often the page is checked": "Hur ofta sidan kontrolleras",
    "How to fix this problem": "Hur man löser detta problem",
    "How to prevent": "Hur man förebygger",
    "How to setup this policy": "Hur du ställer in denna policy",
    "IFrames": "IFrames",
    "IP address": "IP-adress",
    "Icon": "Ikon",
    "Icon status": "Ikonstatus",
    "Identifier": "Identifierare",
    "Ignore": "Ignorera",
    "Ignore check": "Ignorera kontroll",
    "Ignore misspelling": "Ignorera felstavning",
    "Ignore on the page": "Ignorera på sidan",
    "Ignore on this page": "Ignorera på denna sida",
    "Ignore this SEO issue": "Ignorera detta SEO-problem",
    "Ignore this check": "Ignorera denna kontroll",
    "Ignore this check for this domain": "Ignorera denna kontroll för denna domän",
    "Ignored": "Ignorerade",
    "Ignored Misspellings": "Ignorerade felstavningar",
    "Ignored Policies": "Ignorerade strategier",
    "Ignored checks": "Ignorerade kontroller",
    "Ignored issue": "Ignorerat problem",
    "Ignored policies": "Ignorerade policyer",
    "Ignoring broken link": "Ignorera trasig länk",
    "Image": "Bild",
    "Image Links": "Länkar till bilder",
    "Image sources that will be fixed": "Bildkällor som kommer att åtgärdas",
    "Images": "Bilder",
    "Import rules": "Regler för import",
    "Import rules from CSV": "Importera regler från CSV",
    "Important Highlights": "Viktiga punkter",
    "Important Notifications": "Viktiga aviseringar",
    "Important notification:": "Viktigt meddelande:",
    "In compliance": "Efterlevs",
    "In progress of ignoring/reviewing all": "Håller på att ignorera/granska alla",
    "Inactive": "Inaktiv",
    "Incidents": "Driftinformation",
    "Includes both documents and pages": "Inkluderar både dokument och sidor",
    "Incoming Links": "Inkommande länkar",
    "Incoming links": "Inkommande länkar",
    "Indicates the difficulty to fix an audit error": "Anger svårigheten att åtgärda ett granskningsfel",
    "Indicates when some parts of the domain are not scanned due to Constraints / Exclusions being applied": "Indikerar när vissa delar av domänen inte skannas på grund av att begränsningar/uteslutningar tillämpas",
    "Individual issues": "Individuella problem",
    "Information": "Information",
    "Information about this Check is not yet available": "Information om denna kontroll finns ännu inte tillgänglig",
    "Information and the operation of user interface must be understandable.": "Information och användargränssnittets funktion måste vara begripliga.",
    "Information and user interface components must be presentable to users in ways they can perceive.": "Information och komponenter i användargränssnittet måste kunna presenteras för användarna på ett sätt som de kan uppfatta.",
    "Inline Images": "Inline-bilder",
    "Inline images": "Inline-bilder",
    "Input selector*": "Ingångsväljare*",
    "Input user data": "Inmatning av användardata",
    "Internal": "Intern",
    "Internal Export": "Intern export",
    "Internal PDF Compliance": "Överensstämmelse med interna PDF-filer",
    "Internal PDFs": "Interna PDF-filer",
    "Internal URLs": "Interna webbadresser",
    "Inventory": "Domäninnehåll",
    "Inventory Documents Export": "Export av inventeringsdokument",
    "Inventory History": "Historisk inventering",
    "Invite to new project": "Bjud in till nytt projekt",
    "Is not a valid url": "Är inte en giltig url",
    "Is not crawling automatically": "Den crawlar inte automatiskt",
    "Is not tagged": "Är inte märkt",
    "Issue": "Problem",
    "Issue changes": "Ändringar av problem",
    "Issue changes since previous crawl": "Ändringar av problem sedan föregående genomsökning",
    "Issue name": "Problemnamn",
    "Issue type": "Problemtyp",
    "Issues": "Problem",
    "Issues by Severities": "Problem efter allvarlighetsgrad",
    "Issues changes since previous crawl": "Problem som ändrats sedan föregående genomsökning",
    "JS": "JS",
    "JavaScript": "JavaScript",
    "Javascript": "Javascript",
    "Javascript crawl": "Javascript crawl",
    "KB": "KB",
    "Keyword": "Nyckelord",
    "Knowledge Base": {
      "$$noContext": "Kunskapsbas",
      "Topmenu": "Kunskapsbas"
    },
    "LIX": "LIX",
    "Label": "Etikett",
    "Label created": "Etikett skapad",
    "Label name": "Namn på etiketten",
    "Label overlay": "Överlagring av etiketter",
    "Label preview": "Förhandsgranskning av etiketter",
    "Label updated": "Etikett uppdaterad",
    "Labels": "Etiketter",
    "Language": "Språk",
    "Language Detected": "Språk som upptäcks",
    "Languages": "Språk",
    "Languages found": "Hittade språk",
    "Last Scan": "Senaste skanning",
    "Last check: [[lastCheckTime]]": "Senaste kontrollen: [[lastCheckTime]]",
    "Last check: [[performanceScannedAt]]": "Senaste kontrollen: [[performanceScannedAt]]",
    "Last downtime:": "Senaste avbrott:",
    "Last load time": "Senaste laddningstid",
    "Last name": "Efternamn",
    "Last run": "Senaste körning",
    "Last run [[date]]": "Senaste körning [[date]]",
    "Last run:": "Senaste körningen:",
    "Last scan": "Senaste skanning",
    "Last scan never": "Senaste skanning aldrig",
    "Last scan: [[duration]] ago": "Senaste skanning: [[duration]] sedan",
    "Latest Updated PageCorrects": "Senast uppdaterad PageCorrect",
    "Latest login": "Senaste inloggningen",
    "Least Popular Pages": "Minst populära sidor",
    "Less than 10": "Mindre än 10",
    "Less than 100": "Mindre än 100",
    "Less than 2 seconds": "Mindre än 2 sekunder",
    "Less than 50": "Mindre än 50",
    "Level": "Nivå",
    "Level A": "Nivå A",
    "Level A Issues": "Frågor på nivå A",
    "Level A accessibility checks": "Tillgänglighetskontroller på nivå A",
    "Level A compliance": "Överensstämmelse med nivå A",
    "Level A failing checks": "Kontroller på nivå A som inte uppfylls",
    "Level AA": "Nivå AA",
    "Level AA Issues": "Frågor på nivå AA",
    "Level AA accessibility checks": "Tillgänglighetskontroller på nivå AA",
    "Level AA compliance": "Överensstämmelse med nivå AA",
    "Level AA failing checks": "Nivå AA för ej godkända kontroller",
    "Level AAA": "Nivå AAA",
    "Level AAA Issues": "Nivå AAA-problem",
    "Level AAA accessibility checks": "Tillgänglighetskontroller på nivå AAA",
    "Level AAA compliance": "Överensstämmelse med nivå AAA",
    "Level AAA failing checks": "Nivå AAA-undersökningskontroller som misslyckas",
    "Level [[level]]": "Nivå [[level]]",
    "Levels": "Nivåer",
    "Likelihood": "Sannolikhet",
    "Likelihood unspecified": "Sannolikhet ospecificerad",
    "Link": "Länk",
    "Link Type": "Länktyp",
    "Link excludes": "Länken utesluter",
    "Link fixes": "Korrigering av länkar",
    "Link is broken": "Länken är trasig",
    "Link of page": "Länk till sidan",
    "Link to image": "Länk till bilden",
    "Linkedin": "LinkedIn",
    "Links": "Länkar",
    "Links To Documents Export": "Länkar till dokument Export",
    "Links from other account domains": "Länkar från andra kontodomäner",
    "Links from own domain": "Länkar från den egna domänen",
    "Links with policy matches": "Länkar med policymatchningar",
    "Links with the rel=\\\"nofollow\\\" attribute will not pass link equity/SEO value to the linked page. This can be used for pages with user generated comments where you want to avoid that a competitor posts a comment with a link to their own website thus benefiting from your original content. This is not an \\\"error\\\" per se but make sure that the link does not have this attribute as a result of an error.": "Länkar med attributet rel=\\\"nofollow\\\" kommer inte att överföra länkvärde/SEO-värde till den länkade sidan. Detta kan användas för sidor med användargenererade kommentarer där du vill undvika att en konkurrent skriver en kommentar med en länk till sin egen webbplats och på så sätt drar nytta av ditt ursprungliga innehåll. Detta är inte ett \\\"fel\\\" i sig, men se till att länken inte har detta attribut på grund av ett fel.",
    "List": "Lista",
    "List of accessibility issues": "Förteckning över tillgänglighetsproblem",
    "List of all labels": "Förteckning över alla etiketter",
    "List of checks with and without issues": "Förteckning över kontroller med och utan brister",
    "List of content containing links": "Förteckning över innehåll som innehåller länkar",
    "List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)": "Lista över var alla dina tillgångar finns på webbplatsen (t.ex. dokument, länkar, e-postadresser, kodutdrag etc.)",
    "List view": "Listvy",
    "Lists all profiles available for your account": "Visar alla profiler som är tillgängliga för ditt konto",
    "Load Times Trend": "Trend för belastningstider",
    "Loading domains, please wait": "Laddar domäner, vänligen vänta",
    "Loading new domain": "Laddning av ny domän",
    "Loading times": "Laddningstider",
    "Locale": "Plats",
    "Location": "Plats",
    "Location not found": "Platsen har inte hittats",
    "Locations": "Platser",
    "Log out": "Logga ut",
    "Login Type": "Inloggningstyp",
    "Long": "Långt",
    "Lookup in Google": "Uppslag i Google",
    "Low": "Låg",
    "Low impact": "Låg påverkan",
    "Low impact opportunities": "Möjligheter med liten inverkan",
    "Low priority": "Låg prioritet",
    "Low severity": "Låg svårighetsgrad",
    "Low severity issues": "Frågor med låg svårighetsgrad",
    "MB": "MB",
    "META content": "META-innehåll",
    "META name/property": "META-namn/egenskap",
    "Main-Thread Blocking Time": "Tid för blockering av huvudtråden",
    "Mark 403 as broken link": "Markera 403 som trasig länk",
    "Mark all as reviewed/ignored": "Markera alla som granskade/ignorerade",
    "Mark as fixed": "Markera som fixad",
    "Mark as ignored": "Markera som ignorerade",
    "Mark as not fixed": "Markera som inte åtgärdat",
    "Marked as fixed": "Markerad som fixad",
    "Marked as reviewed": "Markerad som granskad",
    "Marking broken link as fixed": "Markera trasig länk som fixad",
    "Match": "Match",
    "Match rule": "Matchningsregel",
    "Matches": "Matcher",
    "Max": "Max",
    "Max scanned pages": "Max antal skannade sidor",
    "Measure from": "Mätning från",
    "Measure from:": "Mätning från:",
    "Measurement Settings": "Inställningar för mätning",
    "Measurements since [[date]]": "Mätningar sedan [[date]]",
    "Medium": "Medium",
    "Medium complexity of text. Example: newspapers and magazines": "Texten är av medelhög komplexitet. Exempel: tidningar och tidskrifter",
    "Medium impact": "Medelstor påverkan",
    "Medium impact opportunities": "Möjligheter med medelhög effekt",
    "Medium priority": "Medelhög prioritet",
    "Medium severity": "Medelhög svårighetsgrad",
    "Medium severity issues": "Problem av medelhög svårighetsgrad",
    "Meta Header Expr": "Meta Header Expr",
    "Meta Name": "Metanamn",
    "Metadata": "Metadata",
    "Metadata key": "Metadatanyckel",
    "Milliseconds": "Millisekunder",
    "Minimum words": "Minsta antal ord",
    "Minutes": "Minuter",
    "Minutes of slow response before you get an email": "Minuter av långsam respons innan du får ett e-postmeddelande",
    "Mispelling": "Felstavning av",
    "Misspelling": "Felstavning",
    "Misspelling affecting the most content": "Felstavning som påverkar mest innehåll",
    "Misspellings": "Felaktiga stavningar",
    "Misspellings history": "Felstavningar historia",
    "Mobile": "Mobil",
    "Moderate": "Måttligt",
    "Module": "Modul",
    "Monday": "Måndag",
    "Monitoring": "Övervakning",
    "Monthly": "Månadsvis",
    "Months": "Månader",
    "More info": "Mer info",
    "More than": "Mer än",
    "More than [[count]]": "Mer än [[count]]",
    "Most Downloads": "Flest nedladdningar",
    "Most Frequent": "Mest frekventa",
    "Most Popular Pages": "De mest populära sidorna",
    "Most common SEO checkpoint needing review": "Vanligaste SEO-kontrollpunkt som behöver granskas",
    "Most common language": "Vanligaste språket",
    "Most common misspellings": "De vanligaste felstavningarna",
    "Most common opportunities found": "De vanligaste möjligheterna som hittats",
    "Most common policy violation on this domain": "Den vanligaste överträdelsen av policyn på den här domänen",
    "Most common potential misspellings": "Vanligaste möjliga felstavningar",
    "Most common readability level": "Den vanligaste läsbarhetsnivån",
    "Most of your pages have the readability level": "De flesta av dina sidor har en läsbarhetsnivå   ",
    "Most pages have this readability level": "De flesta sidor har denna läsbarhetsnivå",
    "Most prominent issues ranked by severity level": "De mest framträdande problemen rangordnade efter allvarlighetsgrad",
    "Most serious issues found": "De allvarligaste problemen som konstaterats",
    "Most visited pages": "Mest besökta sidor",
    "Move focus down on domain picker": "Flytta fokus nedåt på domänväljaren",
    "Move focus up on domain picker": "Flytta fokus uppåt på domänväljaren",
    "Multiline": "Flerradig",
    "My Exports": "Mina Exporter",
    "My profile": "Min profil",
    "N/A": "N/A",
    "NA": "Inte tillgänglig",
    "NB! Connection Settings cannot be edited after save": "NB! Anslutningsinställningarna kan inte redigeras efter att de har sparats",
    "NOTE: If you want to copy the Legacy Script. Click {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}here{{anchorEnd}}.": "OBS: Om du vill kopiera Legacy Script. Klicka {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}här{{anchorEnd}}.",
    "Name": {
      "$$noContext": "Namn",
      "Exchange Center Sort by option": "Namn"
    },
    "Network not found": "Nätverket har inte hittats",
    "Network speed": "Nätverkshastighet",
    "Network speed:": "Nätverkshastighet:",
    "Never": "Aldrig",
    "Never scanned": "Aldrig skannat",
    "New": "Nytt",
    "New Performance Page": "Ny sida för prestanda",
    "New Policy": "Ny policy",
    "New password": "Nytt lösenord",
    "Next": "Nästa",
    "No Broken Links marked as Fixed": "Inga trasiga länkar markerade som åtgärdade",
    "No CSS": "Ingen CSS",
    "No Content links": "Inga innehållslänkar",
    "No Data available for selected time frame": "Inga uppgifter finns tillgängliga för den valda tidsramen",
    "No Documents found": "Inga dokument hittades",
    "No Domains or Groups are yet selected for this report": "Inga domäner eller grupper har valts för den här rapporten",
    "No Frames": "Inga ramar",
    "No Frequency": "Ingen frekvens",
    "No HTML Pages found": "Inga HTML-sidor hittades",
    "No Historic data available for Accessibility Level [[lvl]]": "Inga historiska data finns tillgängliga för Tillgänglighetsnivå [[lvl]]",
    "No IFrames": "Inga IFrames",
    "No Ignored Broken Links": "Inga ignorerade trasiga länkar",
    "No Image Links found": "Inga bildlänkar hittades",
    "No PDF's failed": "Inga PDF:er misslyckades",
    "No PDF's pending": "Inga PDF:er väntar på att skickas",
    "No PDF's queued": "Inga PDF-filer i kö ",
    "No PDF's reviewed": "Inga granskade PDF-filer",
    "No PDFs are reviewed": "Inga PDF-filer granskas",
    "No Policies detected": "Inga policyer upptäcktes",
    "No Profiles were found": "Inga profiler hittades",
    "No Spreadsheet links found": "Inga länkar till kalkylblad hittades",
    "No Users are yet selected to receive this report": "Inga användare har valts ut för att få denna rapport",
    "No Word links found": "Inga Word-länkar hittades",
    "No changes": "Spara ändringar",
    "No changes found": "Inga ändringar har hittats",
    "No checks found for this Accessibility category": "Inga kontroller hittades för denna kategori Tillgänglighet",
    "No content policies have been created yet": "Inga innehållspolicyer har skapats ännu",
    "No corrections added to PageCorrect": "Inga korrigeringar har lagts till i PageCorrect",
    "No data available": "Inget data tillgängligt",
    "No data present": "Inga uppgifter finns",
    "No diagnostics issues were found": "Inga diagnostiska problem hittades",
    "No domains were found": "Inga domäner hittades",
    "No downloads found": "Hittade ﻿inga nedladdningar",
    "No errors found": "Inga fel hittades",
    "No exemptions added to this checkpoint": "Inga undantag läggs till för denna kontrollpunkt",
    "No exports available": "Ingen export tillgänglig",
    "No groups were found for this domain": "Inga grupper hittades för denna domän",
    "No historic data available for this domain": "Inga historiska uppgifter finns tillgängliga för detta område",
    "No hits found": "Inga träffar hittades",
    "No ignored checks in this accessibility category": "Inga ignorerade kontroller i denna tillgänglighetskategori",
    "No ignored misspellings found for this page": "Inga ignorerade felstavningar hittades för denna sida",
    "No incidents occurred in the selected time frame": "Inga incidenter har inträffat under den valda tidsramen",
    "No issues found": "Inga problem hittades",
    "No javascript": "Inget javascript",
    "No name defined": "Inget namn definierat",
    "No new notifications": "Inga nya notifikationer",
    "No note has been added": "Ingen anteckning har lagts till",
    "No notifications available": "Inga meddelanden finns tillgängliga",
    "No opportunities were found": "Inga möjligheter hittades",
    "No outages in this period": "Inga avbrott under denna period",
    "No pages found": "Inga sidor hittades",
    "No pages were found": "Inga sidor hittades",
    "No passed checks in this accessibility category": "Inga godkända kontroller i denna tillgänglighetskategori",
    "No performance scan found": "Ingen prestandaundersökning hittades",
    "No performance scans were found": "Inga prestandaskanningar hittades",
    "No policies found": "Inga policyer hittades",
    "No readability score": "Ingen poäng för läsbarhet",
    "No response received": "Inget svar har mottagits",
    "No run present": "Ingen körning förekommer",
    "No scan has yet been performed. Please check back later.": "Ingen skanning har ännu utförts. Vänligen återkom senare.",
    "No slide links found": "Inga länkar till bildspel hittades",
    "No title found": "Ingen titel hittad",
    "No title found on one or more pages": "Ingen titel finns på en eller flera sidor",
    "No title is found on this page": "Ingen titel finns på denna sida",
    "No users available for this domain": "Inga användare finns tillgängliga för denna domän",
    "No violations were found": "Inga överträdelser konstaterades",
    "No visitor profile selected": "Ingen besökarprofil har valts",
    "No visits for this category in selected time frame": "Inga besök i denna kategori under den valda tidsramen ",
    "No words have been added to the default dictionary": "Inga ord har lagts till i standardordboken",
    "No. Visits": "Antal besök",
    "Non-user list": "Förteckning över icke-användare",
    "None": "Ingen",
    "Normal - recommended": "Normal - rekommenderas",
    "Normal violations": "Normala överträdelser",
    "Not case sensitive": "Inte känslig för stora och små bokstäver",
    "Not containing": "Innehåller inte",
    "Not scheduled": "Inte planerad  ",
    "Not valid email": "Ej giltig e-post",
    "Note": "Anteckning",
    "Notes": "Anteckningar",
    "Notifications": "Aviseringar",
    "Number of characters in Meta Header text": "Antal tecken i Meta Header-texten",
    "Number of characters in header text": "Antal tecken i rubriktexten",
    "Number of characters in image text": "Antal tecken i bildtexten",
    "Number of characters in link text": "Antal tecken i länktexten",
    "Number of characters in page title": "Antal tecken i sidans titel",
    "Number of pages": "Antal sidor",
    "Number too high": "För högt antal",
    "Number too low": "För lågt antal",
    "OK": "OK",
    "Office 365 (BETA)": "Office 365 (BETA)",
    "Ok": "Ok",
    "Once a day": "En gång om dagen",
    "Once a week": "En gång i veckan",
    "One or more documents have already been scanned for compliance. Are you sure you want to scan the selected documents again?": "Ett eller flera dokument har redan skannats för att uppfylla kraven. Är du säker på att du vill skanna de valda dokumenten igen?",
    "One or more page on your website has the same H1 text.": "En eller flera sidor på din webbplats har samma H1-text.",
    "One or more pages has been marked as no index": "En eller flera sidor har markerats som utan index",
    "One or more pages on your website has this title": "En eller flera sidor på din webbplats har denna rubrik",
    "Open": "Öppna",
    "Open Accessibility Decision Tree": "Beslutsträd för öppna tillgänglighet",
    "Open Data Privacy": "Öppna Dataskydd",
    "Open Data Privacy Settings": "Öppna inställningar för dataskydd",
    "Open Document Details": "Öppna detaljer om dokumentet",
    "Open Document details": {
      "$$noContext": "Öppna uppgifter om dokumentet",
      "Aria label when clicking on open Document details": "Öppna dokumentdetaljer"
    },
    "Open Fast Track for this HTML snippet": "Öppna Fast Track för detta HTML-utdrag",
    "Open New Help Center": "Öppna ett nytt hjälpcenter",
    "Open Page Details": "Öppna detaljer om sidan",
    "Open Schedule downtime": "Nedtid för öppna schemaläggning",
    "Open document details": "Öppna detaljer om dokumentet",
    "Open domain policy": "Policy för öppna domäner",
    "Open example": "Öppna exempel",
    "Open filters": "Öppna filter",
    "Open group": "Öppna  grupp",
    "Open help center": "Öppna hjälpcentret",
    "Open keyboard shortcuts": "Öppna tangentbordsgenvägar",
    "Open page details": {
      "$$noContext": "Öppna detaljer om sidan",
      "Aria label when clicking on open pagedetails": "Öppna sidinformation"
    },
    "Open received reports": "Öppna mottagna rapporter",
    "Open report": "&Ouml;ppna rapport",
    "Operating System": "Operativsystem",
    "Operating Systems": "Operativsystem",
    "Operating systems": "Operativsystem",
    "Operating systems Overview": "Översikt över operativsystem",
    "Operator*": "Operatör*",
    "Opportunities": "Affärsmöjligheter",
    "Opportunities by Priority": "Möjligheter efter prioritet",
    "Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.": "Du kan också välja det primära språket för domänen. Om du väljer English (UK) kommer all text som upptäcks som engelsk att betraktas som brittisk engelska.",
    "Options": "Alternativ",
    "Or": "Eller",
    "Organizations": "Avsändare",
    "Original Data": "Ursprunglig data",
    "Other Documents": "Andra dokument",
    "Other files": "Andra filer",
    "Others": "Andra",
    "Our suggestion": "Vårt förslag",
    "Our team has been notified of your request. We will soon be in touch.": "Vårt team har informerats om din begäran. Vi kommer snart att kontakta dig.",
    "Outages during the selected time-frame": "Avbrott under den valda tidsramen",
    "Outages end": "Avbrotten upphör",
    "Outages start": "Avbrott börjar",
    "Outgoing Links": "Utgående länkar",
    "Outgoing links": "Utgående länkar",
    "Over 1000 ms.": "Över 1000 ms.",
    "Over 10000 ms.": "Över 10000 ms.",
    "Over 200 ms.": "Över 200 ms.",
    "Over 2000 ms.": "Över 2000 ms.",
    "Over 3000 ms.": "Över 3000 ms.",
    "Over 4000 ms.": "Över 4000 ms.",
    "Over 500 ms.": "Över 500 ms.",
    "Over 5000 ms.": "Över 5000 ms.",
    "Over 6000 ms.": "Över 6000 ms.",
    "Over 7000 ms.": "Över 7000 ms.",
    "Over 8000 ms.": "Över 8000 ms.",
    "Over 9000 ms.": "Över 9000 ms.",
    "Overall Data Privacy compliance for this page": "Övergripande efterlevnad av dataskyddet för denna sida",
    "Overall PageCorrects": "Övergripande PageCorrects",
    "Overall SEO compliance for this page": "Övergripande SEO-överensstämmelse för den här sidan",
    "Overall accessibility compliance for this level": "Överensstämmelse med den allmänna tillgängligheten för denna nivå",
    "Overall accessibility compliance level for this page": "Allmän nivå av överensstämmelse med kraven på tillgänglighet för den här sidan",
    "Overall compliance": "Sammanlagd efterlevnad",
    "Overall policy compliance for this page": "Övergripande efterlevnad av policyn för den här sidan",
    "Owner": "Ägare",
    "PAGE PERFORMANCE OVERVIEW": "ÖVERSIKT ÖVER SIDANS PRESTANDA",
    "PDF": "PDF",
    "PDF Compliance Status": "Status för efterlevnad av PDF",
    "PDF Documents": "PDF Dokumenter",
    "PDF accessibility scan completed at [[date]]": "Skanning av PDF-tillgänglighet slutförd vid [[date]]",
    "PDF accessibility scan requested": "Skanning av PDF-tillgänglighet begärs",
    "PDF files": "PDF-filer",
    "PDF files pending": "PDF-filer i väntan på att bli skickade",
    "PDF files reviewed": "Granskade PDF-filer",
    "PDF files that are reviewed or pending for accessibility": "PDF-filer som har granskats eller är på väg att granskas med avseende på tillgänglighet  ",
    "PDFs": "PDF-filer",
    "POLICIES OVERVIEW": "POLICYÖVERSIKT",
    "Page": "Sida",
    "Page Dashboard": "Sidans instrumentpanel",
    "Page Details": "Detaljer om sidan",
    "Page Performance": "Sidans prestanda",
    "Page Statistics": "Sidstatistik",
    "Page URL": "Sid URL",
    "Page Views": "Sidvisningar",
    "Page compliance": "Efterlevnad i %",
    "Page count in PDF": "Antal sidor i PDF",
    "Page dashboard": "Sidans instrumentpanel",
    "Page details": "Uppgifter om sidan",
    "Page first detected": "Första upptäckta sidan",
    "Page links": "Sidlänkar",
    "PageAssist Logo Position": "PageAssist Logo Position",
    "PageAssist Theme": "Tema PageAssist",
    "PageCorrect": "PageCorrect",
    "PageCorrect Content": "PageCorrect innehåll",
    "PageCorrect Custom Phrase or Word": "PageCorrect anpassad fras eller ord",
    "PageCorrect Details": "PageCorrect Detaljer",
    "PageCorrect Diagnostics": "PageCorrect Diagnostics",
    "PageCorrects categorized": "PageCorrects kategoriserat",
    "PageFixes": "PageFixes",
    "PageFixes Left": "PageFixes vänster",
    "Pages": "Sidor",
    "Pages & documents with confirmed misspellings, broken links or images": "Sidor och dokument med bekräftade felstavningar, trasiga länkar eller bilder",
    "Pages Crawled": "Sidor som har sökts upp",
    "Pages With Opportunities": "Sidor med förbättringsmöjligheter",
    "Pages and documents with policies marked as unwanted or required": "Sidor och dokument med policyer som är markerade som oönskade eller nödvändiga",
    "Pages crawled": "Sidor som har sökts upp",
    "Pages failing check": "Sidor som inte kontrolleras",
    "Pages in compliance": "Sidor som uppfyller kraven",
    "Pages related to policy link": "Sidor relaterade till policylänk",
    "Pages that are difficult to read": "Sidor som är svåra att läsa",
    "Pages that are easily understood by children below 5'th grade": "Sidor som är lätta att förstå för barn under 5:e klass   ",
    "Pages that are easy to read. Conversational English for consumers": "Sidor som är lätta att läsa. Konversationsengelska för konsumenter",
    "Pages that are fairly difficult to read": "Sidor som är ganska svåra att läsa",
    "Pages that are fairly easy to read": "Sidor som är ganska lättlästa",
    "Pages that are in plain English. Easily understood by 13- to 15-year-old students": "Sidor som är skrivna på enkel engelska. Lätt att förstå för 13-15-åriga elever",
    "Pages that are very difficult to read. Best understood by university graduates": "Sidor som är mycket svåra att läsa. Förstår bäst av universitetsutbildade",
    "Pages that are very easy to read. Easily understood by an average 11-year-old student": "Sidor som är mycket lättlästa. Lätt att förstå för en genomsnittlig 11-årig elev",
    "Pages we could not determine Readability score": "Sidor som vi inte kunde fastställa Läsbarhetsbetyg",
    "Pages with Data Privacy issues": "Sidor med dataskyddsproblem",
    "Pages with Failing Checks": "Sidor med ej godkända kontroller",
    "Pages with Ignored Checks": "Sidor med ignorerade kontroller",
    "Pages with Misspellings": "Sidor med felstavningar",
    "Pages with Opportunities": "Sidor med förbättringsmöjligheter",
    "Pages with Policy Issues": "Sidor med policyfrågor",
    "Pages with QA Issues": "Sidor med QA-problem",
    "Pages with QA issues": "Sidor med kvalitetssäkringsproblem",
    "Pages with SEO Opportunities": "Sidor med SEO-Möjligheter",
    "Pages with SEO opportunities": "Sidor med SEO-möjligheter",
    "Pages with accessibility checks not in compliance": "Sidor med tillgänglighetskontroller som inte uppfyller kraven",
    "Pages with failing checks": "Sidor med ej godkända kontroller",
    "Pages with high, medium or low opportunities": "Sidor med höga, medelhöga eller låga möjligheter",
    "Pages with ignored checks": "Sidor med ignorerade kontroller  ",
    "Pages with issues": "Sidor med problem",
    "Pages with policy matches": "Sidor med matchningar av policyer",
    "Pages with score:": "Sidor med poäng:",
    "Pages with the \\\"noindex\\\" META tag will not be indexed by the search engines. This is not an \\\"error\\\" per se, but make sure that the page does not have this tag as a result of an error.": "Sidor med \\\"noindex\\\" META-taggen kommer inte att indexeras av sökmotorerna. Detta är inte ett \\\"fel\\\" i sig, men se till att sidan inte har den här taggen på grund av ett fel.",
    "Pages without H1 tags or with empty H1 tags that contain no value represent a failed SEO optimization opportunity.": "Sidor utan H1-taggar eller med tomma H1-taggar som inte innehåller något värde är en misslyckad SEO-optimering.",
    "Pages without Visits": "Sidor utan besök",
    "Pages without Visits in last 6 months": "Sidor utan besök under de senaste 6 månaderna",
    "Pageviews": "Sidvisningar",
    "Part of downtime calculation": "Del av beräkning av nedtid",
    "Part of heatmap Rules": "Del av Heatmap-Regler",
    "Part of success criteria [[checkIssueNumber]]": "Del av framgångskriterier [[checkIssueNumber]]",
    "Pass Example": "Exempel på godkännande",
    "Passed": "Godkänd",
    "Passed ([[audits]])": "Godkänd ([[audits]])",
    "Passed Checks": "Godkända kontroller",
    "Passed Policy checks": "Godkända policykontroller",
    "Passed checks": "Godkända kontroller",
    "Passed policy checks": "Godkänd policykontroll",
    "Password": "Lösenord",
    "Password Confirmation": "Bekräfta ditt lösenord",
    "Password confirmation": "Lösenordsbekräftelse",
    "Password to login": "Lösenord för att logga in",
    "Passwords does not match": "Lösenorden stämmer inte överens",
    "Path constraints": "Begränsningar av vägen",
    "Path template": "Mall för sökväg",
    "Pending": "Väntande",
    "Pending PDF review": "I väntan på PDF-granskning",
    "Pending PDF reviews": "Väntar på granskning av PDF-filer",
    "Percentage shows number of pages that are compliant with all Data Privacy checks": "Procentandel visar antalet sidor som uppfyller alla kontroller av dataskydd",
    "Percentage shows number of pages that are compliant with all SEO checks": "Procentandel visar antalet sidor som uppfyller alla SEO-kontroller",
    "Performance": "Prestanda",
    "Performance Errors": "Prestandafel   ",
    "Performance Pages": "Sidor för prestanda",
    "Performance Profiles": "Profiler för prestanda",
    "Performance Score": "Resultat",
    "Performance score": "Prestationsresultat",
    "Personal": "Personlig",
    "Personal information": "Din information",
    "Phone": "Telefon",
    "Pie": "Cirkel",
    "Pin domain": "Pin-domän",
    "Ping intervals": "Ping-intervall",
    "Play": "Spela",
    "Play misspelling": "Spela felstavning",
    "Please choose a trademark": "Välj ett varumärke",
    "Please insert correct URL:": "Vänligen ange rätt URL:",
    "Please insert the correct word:": "Sätt in det rätta ordet:",
    "Please insert the missing ALT text:": "Lägg in den saknade ALT-texten:",
    "Please select a module": "Välj en modul",
    "Please select the module that you want to create a Source Code Exclude for": "Välj den modul som du vill skapa ett undantag för källkod för",
    "Please specify word or phrase to search for": "Ange det ord eller den fras som du vill söka efter",
    "Please use CSS selectors to identify form fields and buttons": "Använd CSS-selektorer för att identifiera formulärfält och knappar",
    "Please wait": "Vänligen vänta",
    "Please wait - Adding word to dictionary": "Vänta - Lägg till ord i ordboken  ",
    "Please wait - Adding words to dictionary": "Vänta - Lägg till ord i ordboken",
    "Please wait - Confirming misspelling": "Vänta - Bekräftar felstavning",
    "Please wait - exporting audit log &nbsp;": "Vänta - export av granskningslogg",
    "Policies": "Policys",
    "Policies - required": "Policys - krävs",
    "Policies - violations": "Policys - överträdelser",
    "Policies marked as required or unwanted": "Policyer som markerats som nödvändiga eller oönskade",
    "Policies violations": "Överträdelser av policyer",
    "Policies with most matches": "Policyer med flest matchningar",
    "Policies with violations": "Policyer med överträdelser",
    "Policy": "Policy",
    "Policy Diagnostics": "Diagnostik av policys",
    "Policy Distribution": "Distribution av policys",
    "Policy Hits": "Policyträffar",
    "Policy Issues": "Policyproblem",
    "Policy List": "Förteckning över riktlinjer",
    "Policy Pages": "Policysidor",
    "Policy Running": "Policy Kör",
    "Policy errors": "Policyfel",
    "Policy hits per domain": "Policyträffar per domän",
    "Policy in queue": "Policy i kö",
    "Policy info": "Policyinfo",
    "Policy note": "Policyanteckning",
    "Policy rules": "Policyregler",
    "Policy scan in progress": "Policy scan pågår",
    "Policy setup": "Policyinställning",
    "Policy violations": "Överträdelser av policys",
    "Policy with matching terms": "Policy med matchande villkor",
    "Potential Misspelling": "Eventuell felstavning",
    "Potential Misspellings": "Möjliga felstavningar",
    "Potential Savings": "Potentiella besparingar",
    "Potential misspelling": "Eventuell felstavning",
    "Potential misspellings": "Möjliga felstavningar",
    "Potential misspellings found": "Eventuella felstavningar hittades",
    "Powered by Google Lighthouse": "Drivs av Google Lighthouse",
    "Prefix path": "Prefixets sökväg",
    "Presence": "Närvaro",
    "Previous": "Föregående",
    "Principle 1: Perceivable": "Princip 1: Möjlig att uppfatta",
    "Principle 2: Operable": "Princip 2: Hanterbar",
    "Principle 3: Understandable": "Princip 3: Begriplig",
    "Principle 4: Robust": "Princip 4: Robust",
    "Principle 5: Conformance": "Princip 5: Överensstämmelse",
    "Print view": "Utskriftsvy",
    "Priorities": "Prioriteter",
    "Prioritized Content": "Prioriterat innehåll",
    "Priority": "Prioritet",
    "Profile": "Profil",
    "Profile Description": "Profilbeskrivning",
    "Profile Dropdown": "Profil dropdown",
    "Profile Menu": "Profilmeny",
    "Profile Name": "Profilnamn",
    "Profile details": "Profil detaljer",
    "Profile updated": "Profilen är uppdaterad",
    "QA": "QA",
    "QA Issues": "Brister i kvalitetssäkring",
    "QA errors": "Fel i kvalitetssäkringen",
    "QUALITY ASSURANCE": "KVALITETSSÄKRING",
    "QUALITY ASSURANCE OVERVIEW": "ÖVERSIKT ÖVER KVALITETSSÄKRING",
    "Quality Assurance": "Kvalitetssäkring",
    "Quality Assurance Check": "Kontroll av kvalitetssäkring",
    "Quality Assurance Diagnostics": "Diagnos av kvalitetssäkring",
    "Quality Assurance Export summary": "Kvalitetssäkring Sammanfattning av export",
    "Quality Assurance errors": "Fel i kvalitetssäkringen",
    "Quality assurance": "Kvalitetssäkring",
    "Queued": "Köad",
    "Quick Guide": "Snabbguide",
    "Quick help": "Snabb hjälp",
    "Quick info:": "Snabb information:",
    "Re-scanning of issues for this page has started and will be finished in a few minutes.": "Omskanning av problem med den här sidan har börjat och kommer att vara klar om några minuter.",
    "Readability": "Läsbarhet",
    "Readability Score": "Läsbarhetsresultat",
    "Readability by score": "Läsbarhet efter poäng",
    "Readability levels": "Läsbarhetsnivåer",
    "Readability score": "Läsbarhetsresultat",
    "Readability scores across all web pages (based on": "Läsbarhetspoäng för alla webbsidor (baserat på",
    "Readability test": "Test av läsbarhet",
    "Receive report": "Ta emot en rapport",
    "Received reports": "Inkomna rapporter",
    "Referring Information": "Hänvisa information  ",
    "Referring visits": "Hänvisa besök",
    "Regex": "Regex",
    "Regulation": "Regulerad",
    "Remember me": "Kom ihåg mig",
    "Remove": "Ta bort",
    "Remove Custom Multistep Javascript": "Ta bort anpassat Javascript i flera steg",
    "Remove Extension Name": "Ta bort tilläggsnamn",
    "Remove Page": "Ta bort sidan",
    "Remove Profile": "Ta bort profil",
    "Remove Rule": "Ta bort regel",
    "Remove checkpoint": "Ta bort kontrollpunkten",
    "Remove domain": "Ta bort domän",
    "Remove domain group": "Ta bort domängrupp",
    "Remove from dictionary": "Ta bort från lexikonet",
    "Remove group": "Ta bort gruppen",
    "Remove rule": "Ta bort regeln",
    "Remove this IP address?": "Ta bort den här IP-adressen?",
    "Remove this pattern?": "Ta bort det här mönstret?",
    "Remove this word from dictionary": "Ta bort detta ord från ordboken",
    "Render pages and execute JS while crawling": "Justera sidor och utför JS under crawling",
    "Repeat": "Upprepa",
    "Replace Rule": "Ersätt regel",
    "Report": "Rapportera",
    "Report administration": "Administration av rapporter",
    "Report overview:": "Översikt över rapporten:",
    "Request PDF scan for all documents": "Begär PDF-skanning för alla dokument",
    "Requests": "Förfrågningar",
    "Required": "Obligatorisk",
    "Required content": "Obligatoriskt innehåll",
    "Required count": "Obligatorisk räkning",
    "Rescan": "Omskanna",
    "Rescanning": "Omskanning",
    "Reset": "Återställ",
    "Reset Preferences": "Återställ inställningar",
    "Resolution": "Upplösning",
    "Resource Type": "Typ av resurs",
    "Response Time": "Svarstid",
    "Response code": "Svarskod",
    "Response time": "Svarstid",
    "Response time (Milliseconds)": "Svarstid (millisekunder) ",
    "Response time notification": "Meddelande om svarstid",
    "Response time notification threshold": "Tröskelvärde för meddelande om svarstid",
    "Return to heartbeat overview": "Återgå till driftstidsöversikt",
    "Returning customer": "Återkommande kund",
    "Reverting state": "Återgång till ett annat tillstånd",
    "Review": "Granskas",
    "Reviewed": "Recenserad",
    "Reviewed/Ok": "Granskad/Ok",
    "Revoke token": "Återkalla token",
    "Robot Info": "Info om robotar",
    "Role": "Roll",
    "Rule": "Regel",
    "Rule name": "Regelns namn",
    "Rule operator": "Regeloperatör",
    "Rule to match": "Regel som ska matchas",
    "Rules": "Regler",
    "Run Policy": "Policy för körning",
    "Run policy": "Policy för körning",
    "Run policy again": "Kör policyn igen",
    "Running": "Kör",
    "SEO": "SEO",
    "SEO (Search Engine Optimization)": "SEO (sökmotoroptimering)",
    "SEO Checkpoints": "Kontrollpunkter för SEO",
    "SEO Diagnostics": "SEO-diagnostik",
    "SEO Issues": "SEO-frågor",
    "SEO OVERVIEW": "SEO ÖVERSIKT",
    "SEO Opportunities": "SEO-förbättringar",
    "SEO errors": "SEO-fel",
    "SEO impact": "Påverkan på SEO",
    "SEO opportunities": "SEO-möjligheter",
    "SEO opportunities - high priority": "SEO-möjligheter - hög prioritet",
    "SEO opportunities - low priority": "SEO-möjligheter - låg prioritet",
    "SEO opportunities - medium priority": "SEO-möjligheter - medelhög prioritet",
    "SEO opportunities - technical SEO issues": "SEO-möjligheter - tekniska SEO-frågor",
    "SEO opportunities found": "Hittade SEO-möjligheter",
    "SHOW LIST VIEW": "VISA LISTVYN",
    "STATISTICS OVERVIEW": "ÖVERSIKT ÖVER STATISTIKEN",
    "Saturday": "Lördag",
    "Save": "Spara",
    "Save Preferences": "Spara inställningar",
    "Save and close": "Spara och stäng",
    "Save policy": "Spara policy",
    "Scan": "Skanna",
    "Scan documents": "Skanna dokument",
    "Scan frequency": "Skanningsfrekvens",
    "Scan frequency:": "Skanningsfrekvens:",
    "Scan in progress": "Skanning pågår",
    "Scan in progress:": "Skanning pågår:",
    "Scan is done": "Skanningen är klar",
    "Scan subdomains": "Skanna underdomäner",
    "Scanned at": "Skannad på",
    "Scanned content": "Skannat innehåll",
    "Scanned links:": "Skannade länkar:",
    "Scanned pages": "Skannade sidor",
    "Scanned pages:": "Skannade sidor:",
    "Scanning URL:": "Skanning av URL:",
    "Scanning in progress": "Skanning pågår",
    "Schedule Report": "Rapport om schemaläggning",
    "Schedule supplemental reports to be delivered with each scan": "Planera kompletterande rapporter som ska levereras med varje skanning",
    "Scheduled": "Schemalagd",
    "Scheduled Reports": "Planerade rapporter  ",
    "Scopes": "Användningsområden",
    "Score": "Poäng",
    "Screen Resolutions": "Skärmupplösningar",
    "Screen Resolutions Overview": "Översikt över skärmupplösningar",
    "Script Evaluation": "Utvärdering av manuskriptet",
    "Script Parse": "Skriftanalysera",
    "Script installed": "Skript installerat",
    "Script installed on Domain": "Skript installerat på domänen",
    "Script setup guide": "Guide för inställning av skript",
    "Search Engine Optimization": "Sökmotoroptimering",
    "Search Engine Optimization (SEO)": "Sökmotoroptimering (SEO)",
    "Search Engines": "Sökmotorer",
    "Search engine": "Sökmotor",
    "Search engines": "Sökmotorer",
    "Search for Pages": "Sök efter sidor",
    "Search for file size that is": "Sök efter filstorlek som är",
    "Search for image size that is": "Sök efter en bildstorlek som är",
    "Search for links, that are associated with class names and contains below mentioned class names.": "Sök efter länkar som är associerade med klassnamn och som innehåller nedan nämnda klassnamn.",
    "Search for page titles or URLs across all domains": "Sök efter sidtitlar eller webbadresser på alla domäner",
    "Search for pages": "Sök efter sidor",
    "Search icon": "Sökikon",
    "Search in: Documents": "Sök i: Dokument   ",
    "Search in: Everything": "Sök i: Allt",
    "Search in: Links": "Sök i: Länkar",
    "Search in: Only HTML pages": "Sök i: Endast HTML-sidor",
    "Search pages across all domains": "Sök sidor på alla domäner",
    "Search...": "Sök…",
    "Searches": "Sökningar",
    "Seconds": "Sekunder",
    "See API Token": "Se API-symbol",
    "See Details": "Se detaljer",
    "See changes": "Se ändringar",
    "See details": "Se detaljer",
    "See pages": "Se sidorna",
    "Select Domain and Module to get the Insights": "Välj domän och modul för att få insikter",
    "Select Domain on domain picker": "Välj domän i domänväljaren",
    "Select Page to scan": "Välj sida som ska skannas",
    "Select a domain and recipients": "Välj en domän och mottagare",
    "Select a domain or group": "Välj en domän eller grupp",
    "Select a profile": "Välj en profil",
    "Select account": "Välj konto",
    "Select all items": "Välj alla objekt",
    "Select domain": "Välj domän",
    "Select domains and groups": "Välj domäner och grupper",
    "Select filters": "Välj filter",
    "Select import": "Välj import",
    "Select item": "Välj objekt",
    "Select login type*": "Välj inloggningstyp*",
    "Select timezone": "Välj tidszon",
    "Select users": "Välj användare",
    "Select what type of content the policy should search in": "Välj vilken typ av innehåll som policyn ska söka i",
    "Select whether the rule should search for case sensitive text or not": "Välj om regeln ska söka efter text som är skiftlägeskänslig eller inte",
    "Select your export file": "Välj din exportfil",
    "Send an email if the site is down": "Skicka ett e-postmeddelande om webbplatsen är nere",
    "Send an email if the site is slow to respond": "Skicka ett e-postmeddelande om webbplatsen är långsam att svara",
    "Send message": "Skicka meddelande",
    "Send report": "Skicka rapport",
    "Send welcome mail on creation": "Skicka ett välkomstbrev vid skapandet",
    "Set a default value for selector": "Ställ in ett standardvärde för väljaren",
    "Set as Default": "Sätt som standard",
    "Set to fixed": "Ställ in som fixad",
    "Settings": {
      "$$noContext": "Inställningar",
      "Topmenu": "Inställningar"
    },
    "Setup your domain": "Konfigurera din domän",
    "Severity": "Typ",
    "Severity level": "Svårighetsgrad",
    "Short": "Kort",
    "Short Description": "Kort beskrivning",
    "Should we check the page's current status?": "Ska vi kontrollera sidans aktuella status?",
    "Show Details": "Visa detaljer",
    "Show all": "Visa alla",
    "Show documents with this email": "Visa dokument med det här e-postmeddelandet    ",
    "Show history": "Visa historik",
    "Show label dropdown": "Visa rullgardinsmenyn med etikett",
    "Show less": "Visa mindre",
    "Show more": "Visa mer",
    "Show on global policy list": "Visa i den globala listan över principer",
    "Show pages": "Visa sidor",
    "Show pages with issues": "Visa sidor med problem",
    "Show pages with this SEO issue": "Visa sidor med detta SEO-problem",
    "Show pages with this email": "Visa sidor med det här e-postmeddelandet",
    "Show pages with this image": "Visa sidor med den här bilden",
    "Show pages with this link": "Visa sidor med den här länken",
    "Show pages with this misspelling": "Visa sidor med denna felstavning",
    "Show policy hits per domain": "Visa träffar på principer per domän",
    "Show policy info": "Visa information om policy",
    "Show the Domain Picker": "Visa val av domän",
    "Show/Hide filter selector": "Visa/dölj filterväljaren",
    "Show/Hide the Domain Picker": "Visa/dölj domänväljaren",
    "Shows the remaining number of Performance Profiles that can be created for this account": "Visar det återstående antalet prestandaprofiler som kan skapas för det här kontot",
    "Side Navigation": "Sidnavigering",
    "Single line": "Enkel linje",
    "Size": "Storlek",
    "Skip to content": "Fortsätt till innehållet",
    "Slide links": "Länkar för bildspel",
    "Slides": "Bildspel",
    "Slow": "Långsam",
    "Snippet": "Utklipp",
    "Social": "Socialt",
    "Social Networks": "Sociala nätverk",
    "Social visits": "Sociala besök",
    "Source Code Exclude": "Källkod utesluts   ",
    "Source Code Excludes": "Källkoden utesluter",
    "Source code": "Källkod",
    "Spellcheck": "Stavningskontroll",
    "Spellcheck Export Summary": "Sammanfattning av exporten av stavningskontrollen",
    "Spellcheck Summary": "Sammanfattning av stavningskontrollen",
    "Spelling": "Stavning",
    "Spelling Errors used": "Stavfel som används",
    "Spelling fixes": "Rättelser av stavningen",
    "Spelling ignore capitalized words": "Stavning ignorerar ord med stor bokstavsbeteckning",
    "Spreadsheet links": "Länkar till kalkylblad",
    "Spreadsheets": "Kalkylblad",
    "Start PDF accessibility scan": "Starta skanning av PDF-tillgänglighet",
    "Start at": "Börja",
    "Start compound export": "Börja exportera sammansättningar",
    "Start date": "Startdatum",
    "Start export": "Starta export",
    "Start export Pages With Specific Link": "Börja exportera sidor med en specifik länk   ",
    "Start new scan": "Starta en ny skanning",
    "Start on demand scan": "Start av skanning på begäran",
    "Start time": "Starttid",
    "Starts with": "Börjar med",
    "State": "Län",
    "Statistic": "Statistik",
    "Statistics": "Statistik",
    "Statistics excluded IP addresses": "Statistik över exkluderade IP-adresser",
    "Status": "Status",
    "Stop current crawl": "Stoppa pågående crawl",
    "Sub Navigation": "Undernavigering",
    "Submit selector*": "Skicka in väljare*",
    "Succeeds": "Lyckas",
    "Success criteria": "Kriterier för framgång",
    "Suggestions and ideas": "Förslag och idéer",
    "Summarized pages and documents count": "Antal sammanfattade sidor och dokument",
    "Summary": "Sammanfattning",
    "Sunday": "Söndag",
    "Switch account": "Växla konto",
    "Table View": "Tabellvisning",
    "Tags": "Taggar",
    "Target": "Mål",
    "Technical": "Teknisk",
    "Technical SEO Issues": "Tekniska SEO-frågor",
    "Text": "Text",
    "Text Documents": "Textdokument",
    "Text documents": "Textdokument",
    "Text to match": "Text som ska matchas",
    "Text:": "Text:",
    "The Checkpoint [[checkpoint]] will be updated with data after next crawl": "Kontrollpunkten [[checkpoint]] kommer att uppdateras med data efter nästa krypning",
    "The Document is not tagged": "Dokumentet är inte märkt",
    "The Path template for Umbraco CMS": "Path-mallen för Umbraco CMS",
    "The Requested Page is not a part of the Performance Module": "Den begärda sidan är inte en del av prestandamodulen",
    "The Scan will take effect within the next few hours": "Skanningen träder i kraft inom de närmaste timmarna",
    "The URL for this page is too long": "URL:en för denna sida är för lång",
    "The base url to the CMS page": "Den grundläggande webbadressen till CMS-sidan",
    "The bounce rate tells you the number of visits who only see the one page they started on": "Avvisningsfrekvensen visar hur många besökare som bara ser den sida de började på",
    "The following rules will be removed, are you sure you want to continue with this change?": "Följande regler kommer att tas bort, är du säker på att du vill fortsätta med den här ändringen?",
    "The header 1 (H1) tag is important as it helps search engines and users to understand what content they can expect to find on the page.": "Taggen Header 1 (H1) är viktig eftersom den hjälper sökmotorer och användare att förstå vilket innehåll de kan förvänta sig att hitta på sidan.",
    "The likelihood of this being a Data Privacy issue": "Sannolikheten för att detta är en fråga om dataskydd",
    "The lowest level of readability. Example: children's books": "Den lägsta nivån av läsbarhet. Exempel: barnböcker",
    "The meta description on this page is too long": "Metabeskrivningen på den här sidan är för lång",
    "The meta description on this page is too short": "Metabeskrivningen på den här sidan är för kort",
    "The misspelling will first show up after a new scan": "Felstavningen visas först efter en ny skanning",
    "The name of a meta entry (page metadata)": "Namnet på en metapost (sidmetadata)",
    "The optional base url to the CMS page": "Den valfria webbadressen till CMS-sidan",
    "The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.": "Sekretessen för dina personuppgifter är mycket viktig för oss. Därför har vi uppdaterat vår dataskydds- och integritetspolicy. För att du ska kunna fortsätta använda vår plattform ber vi dig vänligen att läsa och acceptera de nya villkoren för dataskydd och datapolicy.",
    "The scan can take a few hours/days to finalise, depending on the size of the website": "Skanningen kan ta några timmar/dagar att slutföra, beroende på webbplatsens storlek",
    "The scan can take a few hours/days to finalise, depending on the size of the website.<br><br>Are you sure you want to start on-demand scan?": "<br><br>Skanningen kan ta några timmar/dagar att slutföra, beroende på webbplatsens storlek.Är du säker på att du vill starta skanning på begäran?",
    "The scan can take a few minutes to finalise, depending on the size of the page": "Det kan ta några minuter att slutföra skanningen, beroende på sidans storlek",
    "There are no META descriptions on one or more pages": "Det finns inga META-beskrivningar på en eller flera sidor",
    "There are no domains assigned to this policy. Save policy anyway?": "Inga domäner har tilldelats den här principen. Spara ändå policyn?",
    "There are no more errors for this Snippet": "Det finns inga fler fel för detta utdrag",
    "There are no sub headlines on one or more pages": "Det finns inga underrubriker på en eller flera sidor",
    "There are zero META keywords on this page": "Det finns inga META-nyckelord på den här sidan",
    "There is no H1 on one or more pages": "Det finns ingen H1 på en eller flera sidor",
    "There is no H1 on this page": "Det finns ingen H1 på denna sida",
    "There is no META descriptions on this page": "Det finns inga META-beskrivningar på denna sida",
    "There is no historic data for domain groups": "Det finns inga historiska uppgifter för domängrupper",
    "There is no historic data for this domain": "Det finns inga historiska uppgifter för detta område",
    "There is no sub headlines on this page": "Det finns inga underrubriker på denna sida",
    "These are findings that cannot be automatically checked and must be reviewed manually": "Dessa resultat kan inte kontrolleras automatiskt utan måste granskas manuellt",
    "These are findings which are likely to be errors, requiring manual confirmation": "Dessa resultat är sannolikt felaktiga och kräver manuell bekräftelse",
    "These findings are confirmed errors": "Dessa resultat är bekräftade fel",
    "Third-Party": "Tredje part",
    "This field is required": "Detta fält är obligatoriskt",
    "This is the time between when an outage is first detected and when a notification is sent.": "Detta är tiden mellan när ett avbrott först upptäcks och när ett meddelande skickas.    ",
    "This is useful if you have defined timeslots for maintenance.": "Detta är användbart om du har definierat tidsperioder för underhåll.",
    "This issue is ignored": "Denna fråga ignoreras",
    "This link is marked as broken because it took more than 30 seconds to load": "Den här länken har markerats som trasig eftersom det tog mer än 30 sekunder att ladda den",
    "This page has been marked as no index": "Den här sidan har markerats som obefintlig",
    "This page has no meta description": "Den här sidan har ingen metabeskrivning",
    "This page has no meta keywords": "Den här sidan har inga meta-syckelord",
    "This page has not been assigned to the Performance Module": "Den här sidan har inte tilldelats prestandamodulen",
    "This page is missing a title": "Den här sidan saknar en titel",
    "This policy is scheduled": "Denna politik är planerad att",
    "This rule doesn't contain any matches": "Den här regeln innehåller inga matchningar",
    "This section lists requirements for <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformance</a> to WCAG 2.1. It also gives information about how to make conformance claims, which are optional.": "<a target=\"_blank\" href=\"https://www.w3.org/TR/WCAG21/#dfn-conform\"></a>I det här avsnittet förtecknas kraven för överensstämmelse med WCAG 2.1. Det ger också information om hur man gör krav på överensstämmelse, vilket är frivilligt.",
    "Thursday": "Torsdag",
    "Time": "Tid",
    "Time Spent": "Tidsåtgång",
    "Time To Interactive": "Tid för interaktivitet",
    "Time to Warning *": "Tid till varning *",
    "Timeframe:": "Tidsram:",
    "Timeline": "Tidslinje",
    "Timezone": "Tidszon",
    "Title": "Titel",
    "Title & description": "Titel och beskrivning",
    "Title and URL": "Titel och URL",
    "Title and url": "Titel och webbadress",
    "To setup this policy, you need to tell us how long your max word length is": "För att ställa in denna policy måste du ange hur lång din maximala ordlängd är",
    "To setup this policy, you need to tell us which brand name should end with TM or ™": "För att ställa in den här policyn måste du tala om för oss vilket varumärkesnamn som ska sluta på TM eller ™",
    "To toggle Quick Search:": "Växla Snabbsökning:    ",
    "Toggle Dropdown": "Växla Dropdown",
    "Toggle dropdown": "Växla rullgardinsmenyn",
    "Toggle notes": "Växla anteckningar",
    "Toggle show filters": "Växla visa filter",
    "Too few characters": "För få karaktärer",
    "Too many characters": "För många tecken",
    "Top keywords": "Viktigaste nyckelord",
    "Total": "Totalt",
    "Total CPU Time": "Total CPU-tid",
    "Total QA issues": "Totalt antal QA-problem",
    "Total Visitors": "Totalt antal besökare",
    "Total Visits": "Totalt antal besök",
    "Total amount of content": "Total mängd innehåll",
    "Total crawled": "Totalt antal sökningar",
    "Total number of issues": "Totalt antal frågor",
    "Total number of issues across all modules": "Totalt antal frågor i alla moduler",
    "Total page views over the last 30 days": "Totala sidvisningar under de senaste 30 dagarna",
    "Total pages:": "Antal sidor:",
    "Total visitors": "Totalt antal besökare",
    "Total visitors from Referrers": "Totala besökare från hänvisare",
    "Total visitors from Search Engines": "Antal besökare från sökmotorer",
    "Total visits": "Totala besök",
    "Total visits from Referrers": "Totalt antal besök från hänvisare",
    "Total visits from Search Engines": "Totalt antal besök från sökmotorer",
    "Total visits in the last 30 days:": "Totalt antal besök under de senaste 30 dagarna:   ",
    "Total words": "Totalt antal ord",
    "Track changes across domains and modules": "Spåra ändringar i olika domäner och moduler",
    "Traffic Sources": "Trafikkällor",
    "Traffic Sources Summary": "Sammanfattning av trafikkällor",
    "Traffic sources": "Trafikkällor",
    "Transfer Size": "Överföringsstorlek",
    "Tuesday": "Tisdag",
    "Twice a day": "Två gånger per dag",
    "Twitter": "Twitter",
    "Type": "Typ",
    "Type the key for the metadata": "Ange nyckeln för metadata",
    "Type the text to match rule": "Skriv den text som ska matcha regeln",
    "Type*": "Typ*",
    "URL": "URL",
    "URL must start with a protocol. Ex. http://....": "URL måste börja med ett protokoll. Exempel: http://....",
    "URL to redirect to if form is valid": "URL som ska omdirigeras till om formuläret är giltigt",
    "URL:": "URL:",
    "Unable to read link": "Kan inte läsa länken",
    "Unarchive": "Återställ från arkiv",
    "Undetermined": "Ej fastställd",
    "Undo": "Ångra",
    "Undo review": "Ångra översynen",
    "Unignore": "Avsluta",
    "Unignore check": "Avsluta kontrollen av ignorering",
    "Unignore misspelling": "Avignorera felstavning",
    "Unignore on this page": "Avignorera på den här sidan",
    "Unignore this SEO issue": "Avignorera detta SEO-problem ",
    "Unignore this check for this domain": "Avaktivera den här kontrollen för den här domänen",
    "Unique Visitors": "Unika besökare",
    "Unique downloads": "Unika nedladdningar",
    "Unknown": "Okänd",
    "Unknown Score": "Okänd poäng   ",
    "Unknown title": "Okänd titel",
    "Unpin domain": "Ta bort domänen från markeringen",
    "Unsaved changes": "Ändringar som inte sparats",
    "Unwanted": "Oönskad",
    "Unwanted content": "Oönskat innehåll",
    "Unwanted violations": "Oönskade överträdelser",
    "Update": "Uppdatera",
    "Update groups": "Uppdatera grupper",
    "Updated": "Uppdaterad",
    "Updated At": "Uppdaterad",
    "Updated at": "Uppdaterad den",
    "Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Uppdatering av grupper kan ta mer än 30 minuter. Under operationen kan du inte skapa eller uppdatera grupper.",
    "Upload CSV": "Ladda upp CSV",
    "Upload csv file": "Ladda upp CSV-fil",
    "Uptime": "Drifttid",
    "Uptime last 30 days": "Driftstid de senaste 30 dagarna",
    "Url*": "Url*",
    "Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors": "Använd * som jokertecken (t.ex. 192.168.1.*). Uteslutna IP-adresser kommer endast att påverka nya besökare",
    "Use language attribute": "Använd språkattributet",
    "Use or Apply custom PageCorrect": "Använd eller tillämpa anpassad PageCorrect",
    "User": "Användare",
    "User Export": "Exportera användare",
    "User List": "Användarlista",
    "User Loading Experience": "Upplevelse av användarens laddning",
    "User information": "Användarinformation",
    "User interface components and navigation must be operable.": "Komponenterna i användargränssnittet och navigeringen måste vara funktionsdugliga.   ",
    "User is account administrator": "Användaren är kontoadministratör",
    "Username": "Användarnamn",
    "Value": "Värde",
    "Value*": "Värde*",
    "Vat no": "Momsnr",
    "Verify URL*": "Kontrollera URL*",
    "Very easy": "Mycket lätt",
    "Very hard": "Mycket svårt",
    "View options": "Visa alternativ",
    "Viewing as Profile:": "Visar som profil:",
    "Views": "Visningar",
    "Violation": "Överträdelse",
    "Violation count": "Antal överträdelser",
    "Violation's info_type name not set": "Överträdelsens info_type-namn har inte angetts",
    "Violations": "Överträdelser",
    "Visible": "Synlig",
    "Visible modules": "Synliga moduler",
    "Visit the affected image": "Besök den drabbade bilden    ",
    "Visitor Overview": "Översikt över besökare",
    "Visitor Summary": "Sammanfattning av besökaren",
    "Visitor log": "Loggbok för besökare",
    "Visitor profile": "Besökarprofil",
    "Visitor profile:": "Besökarprofil:",
    "Visitors": "Besökare",
    "Visitors Summary": "Sammanfattning av besökarna",
    "Visits": "Besök",
    "Visual mode": "Visuellt läge",
    "WCAG 2.0 (Level A)": "WCAG 2.0 (nivå A)",
    "WCAG 2.0 (Level AA)": "WCAG 2.0 (nivå AA)",
    "WCAG 2.0 (Level AAA)": "WCAG 2.0 (nivå AAA)",
    "WCAG 2.0 Accessibility Compliance": "Överensstämmelse med WCAG 2.0 för tillgänglighet",
    "WCAG 2.1 (Level A)": "WCAG 2.1 (nivå A)",
    "WCAG 2.1 (Level AA)": "WCAG 2.1 (nivå AA)",
    "WCAG 2.1 (Level AAA)": "WCAG 2.1 (nivå AAA)",
    "WCAG 2.1 Accessibility Compliance": "Överensstämmelse med WCAG 2.1 om tillgänglighet",
    "Want to search for": "Vill du söka efter",
    "Warning": "Varning",
    "We recommend that all your pages has a number of relevant meta keywords.": "Vi rekommenderar att alla dina sidor har ett antal relevanta meta-nyckelord.",
    "We recommend that all your pages has a relevant and unique meta description.": "Vi rekommenderar att alla dina sidor har en relevant och unik metabeskrivning.",
    "We recommend that all your pages has an unique title.": "Vi rekommenderar att alla dina sidor har en unik titel.",
    "We recommend that the meta description consists of at least 50 characters.": "Vi rekommenderar att metabeskrivningen består av minst 50 tecken.",
    "We recommend that the meta description consists of no more than 160 characters.": "Vi rekommenderar att metabeskrivningen består av högst 160 tecken.",
    "We recommend that you give each page a unique title.": "Vi rekommenderar att du ger varje sida en unik titel.",
    "We recommend that you have a unique H1 tag on each page.": "Vi rekommenderar att du har en unik H1-tagg för varje sida.",
    "We recommend that you have at least one H2-H6": "Vi rekommenderar att du har minst en H2-H6",
    "We recommend that you have no more than 100 internal links on each page.": "Vi rekommenderar att du inte har mer än 100 interna länkar på varje sida.",
    "We recommend that you keep your URL below 200 characters.": "Vi rekommenderar att du håller din webbadress under 200 tecken.",
    "We recommend that you only have one H1 tag on each page.": "Vi rekommenderar att du bara har en H1-tagg på varje sida.",
    "Wednesday": "Onsdag",
    "Weekly": "Veckovis",
    "Well done - no accessibility issues found": "Bra jobbat - inga upptäckta tillgänglighetsproblem hittades      ",
    "We’ve Updated our Privacy Policy!": "Vi har uppdaterat vår sekretesspolicy!",
    "Why is this an issue": "Varför är detta ett problem? ",
    "With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go": "Med Fast Track kan du åtgärda, granska och ignorera HTML-snippets på berörda sidor på en gång",
    "Word": "Word",
    "Word Count": "Ordräknare",
    "Word count": "Antal ord",
    "Word count in PDF": "Antal ord i PDF",
    "Word is added to dictionary": "Ordet läggs till i ordboken",
    "Word is added to dictionary for all languages": "Ordet läggs till i ordboken för alla språk",
    "Word is confirmed as misspelling": "Ordet bekräftas som felstavat",
    "Word length": "Ordlängd",
    "Word links": "Länkar till ord",
    "Word or Phrase": "Ord eller fras",
    "Words": "Ord",
    "Would you like to update now? Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups": "Vill du uppdatera nu? Uppdatering av grupper kan ta mer än 30 minuter. Under operationen kan du inte skapa eller uppdatera grupper",
    "Written by: [[author]]": "Skrivet av: [[author]]",
    "Years": "År",
    "You are about to delete": "Du är på väg att radera   ",
    "You are about to delete the domain": "Du är på väg att ta bort domänen",
    "You are about to delete the domain group": "Du ska ta bort domängruppen",
    "You are currently using Demo Data, certain features will be unavailable": "Du använder för närvarande demodata, vissa funktioner är inte tillgängliga",
    "You are receiving this report": "Du tar emot den här rapporten",
    "You can create another [[customerProfilesLimit]] profiles for your account": "Du kan skapa ytterligare [[customerProfilesLimit]] profiler för ditt konto",
    "You can pin this domain. Pinned domains will be shown at the top of your domain list": "Du kan fästa den här domänen. Uppmärksammade domäner visas högst upp i din domänlista",
    "You have more than one H1 tag on this page": "Du har mer än en H1-tagg på den här sidan",
    "You have no H2-H6 tags on the page": "Du har inga H2-H6-taggar på sidan",
    "You have no available profiles": "Du har inga tillgängliga profiler",
    "You have not received any reports": "Du har inte fått några rapporter",
    "You have one or more pages with the \\\"noindex\\\" META tag": "Du har en eller flera sidor med \\\"noindex\\\" META-tag",
    "You have reached the maximum number of profiles for this account.": "Du har nått det maximala antalet profiler för det här kontot.",
    "You have too many internal links": "Du har för många interna länkar",
    "You will receive an email when the export is ready.": "Du får ett e-postmeddelande när exporten är klar.",
    "Your Users Technology": "Dina användares teknik",
    "Zero links were found": "Inga länkar hittades",
    "Zip code": "Postnummer",
    "achieved": "uppnått",
    "affected image": "påverkad bild",
    "and": "och",
    "and does not conform with": "och är inte förenlig med",
    "contact": "kontakt",
    "contains": "innehåller",
    "content": "innehåll",
    "diagnostics_errors.csv": "diagnostics_errors.csv",
    "diagnostics_passed.csv": "diagnostics_passed.csv",
    "disabling": "inaktivera",
    "document": "dokument",
    "documents": "dokument",
    "done": "klar",
    "enabling": "möjliggör",
    "ends_with": "slutar_med",
    "excluded": "exkluderad",
    "go to the matched link": "gå till den matchade länken",
    "image": "bild",
    "included": "inkluderad",
    "insert brand name": "ange varumärkesnamn    ",
    "insert context fx. us": "infoga kontext fx. oss",
    "insert max word length": "infoga maximal ordlängd",
    "insert word fx. contact": "infoga Word fx. kontakt",
    "is": "är",
    "is_exactly": "är_exakt",
    "language": "språk",
    "link": "länk",
    "match (regex)": "match (regex)",
    "metadata": "metadata",
    "milliseconds": "millisekunder",
    "minutes": "minuter",
    "n/a": "n/a",
    "not": "inte",
    "opportunities_errors.csv": "opportunities_errors.csv",
    "opportunities_passed.csv": "opportunities_passed.csv",
    "overall compliance": "Sammanlagd efterlevnad",
    "pages": "sidor",
    "path": "väg",
    "please type": "vänligen skriv in",
    "reviewed": "granskad",
    "rows - click to change": "rader - klicka för att ändra",
    "search engines overview": "översikt över sökmotorer",
    "should always be followed by": "ska alltid följas av",
    "social network overview": "översikt över sociala nätverk",
    "starts_with": "startar_med",
    "that": "som är",
    "title": "titel",
    "to confirm this action": "för att bekräfta denna åtgärd",
    "to fix": "för att åtgärda",
    "url": "url",
    "us": "oss",
    "visits": "besök",
    "you have one or more pages that contains links with rel=\\\"nofollow\\\"": "du har en eller flera sidor som innehåller länkar med rel=\\\"nofollow\\\"",
    "{{ pagesDone }} Pages ({{ compliancePercentage }}) in compliance": "{{ pagesDone }} Sidor ({{ compliancePercentage }}) som uppfyller kraven",
    "{{ totalPageIssues }} Pages ({{ compliancePercentage }}) to fix": "{{ totalPageIssues }} Sidor ({{ CompliancePercentage }}) att åtgärda",
    "[[label]]: [[value]] Pages": "[[label]]: [[value]] Sidor",
    "[[label]]: [[value]]ms": "[[label]]: [[value]]ms",
    "[[languageName]] ([[languageCount]])": "[[languageName]] ([[languageCount]])",
    "[[ms]] ms": "[[ms]] ms",
    "[[name]] have already been scanned for compliance. Are you sure you want to scan it again?": "[[name]] har redan skannats för överensstämmelse. Är du säker på att du vill skanna det igen?",
    "[[pageCount]] Pages": "[[pageCount]] Sidor",
    "[[pageCount]] pages found with this issue": "[[pageCount]] sidor hittades med detta problem",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nivå A)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nivå AA)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nivå AAA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nivå A)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nivå AA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nivå AAA)",
    "1 found": [
      "1 funnen",
      "[[$count | monNumber]] hittades"
    ],
    "1 issue found": [
      "1 problem hittades",
      "[[$count | monNumber]] problem hittades"
    ],
    "1 word found": [
      "1 ord hittades",
      "[[$count | monNumber]] ord hittades"
    ],
    "Total: 1 Performance Page": [
      "Totalt: 1 sida med prestanda    ",
      "Totalt: [[$count | monNumber]] Prestanda sidor"
    ],
    "You have 1 to do": [
      "Du har 1 att göra",
      "Du har [[issues]] att göra"
    ],
    "page": "sida",
    "Are you sure you want to remove Custom PageCorrect? <br> Please type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Är du säker på att du vill ta bort Custom PageCorrect? &lt;br&gt; Skriv [[deleteTag]]Ta bort[[deleteTagEnd]] för att bekräfta åtgärden&lt;/br&gt; ",
    "You are about to remove PageCorrect for this check <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du är på väg att ta bort PageCorrect för denna kontroll &lt;br&gt;Skriv [[deleteTag]]Delete[[deleteTagEnd]] för att bekräfta denna åtgärd&lt;/br&gt; ",
    "You are about to remove PageCorrect for this misspelling <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du är på väg att ta bort PageCorrect for this misspelling &lt;br&gt;Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action&lt;/br&gt; ",
    "You are about to remove PageCorrect for this [[type]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du är på väg att ta bort PageCorrect för denna [[type]] &lt;br&gt;Vänligen skriv [[deleteTag]]Ta bort[[deleteTagEnd]] för att bekräfta denna åtgärd&lt;/br&gt; ",
    "You are about to remove [[titleTag]][[title]][[titleTagEnd]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du är på väg att ta bort [[titleTag]][[title]][[titleTagEnd]] &lt;br&gt;Skriv [[deleteTag]]Ta bort[[deleteTagEnd]] för att bekräfta åtgärden&lt;/br&gt;",
    "Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it's place": "<br><strong></strong>Är du säker på att du vill återkalla tokenet för API-användaren [[apiUserId]]&lt;br&gt;&lt;strong&gt;Observera&lt;/strong&gt;&lt;/br&gt;Ett nytt token kommer att skapas i stället",
    "Maximum critical path latency: <strong>[[latency]] ms </strong>": "<strong></strong>Maximalt kritisk tidsåtgång: [[latency]] ms ",
    "Are you sure you want to remove <code>all</code> [[type]] PageCorrects? <br> Please type <code>Delete</code> to confirm this action": "<code></code><br><code></code>Är du säker på att du vill ta bort &lt;code&gt;alla&lt;/code&gt; [[type]] PageCorrects? &lt;br&gt; Skriv &lt;code&gt;Delete&lt;/code&gt;&lt;/br&gt; för att bekräfta denna åtgärd",
    "<strong>[[checkName]]</strong><br><br>Add reason (Optional)": "<strong></strong><br><br>[[checkName]]Lägg till skäl (valfritt)",
    "Are you sure you want to confirm the misspelling <strong>' + word.word + '</strong>?": "<strong></strong>Är du säker på att du vill bekräfta felstavningen ' + word.word + '?",
    "Are you sure you want to delete the policy <strong>[[policyName]]</strong>": "<strong></strong>Är du säker på att du vill ta bort policyn? [[policyName]]",
    "Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?": "<strong></strong>Är du säker på att du vill markera policyn? [[policyName]] som fastställd?",
    "Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>": "<strong></strong>Är du säker på att du vill ta bort Heatmap-Regeln från [[pageUrl]]",
    "Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?": "<strong></strong>Är du säker på att du vill ta bort regeln ' + rule.name + '?",
    "Are you sure you want to run the policy <strong>' + policy.name + '</strong>?": "<strong></strong>Är du säker på att du vill köra policyn ' + policy.name + '?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong> again?": "<strong></strong>Är du säker på att du vill köra policyn? [[policyName]] igen?",
    "Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?": "<strong></strong>Är du säker på att du vill avignorera policyn? [[policyName]]?",
    "You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.": "<strong></strong><strong></strong>Du har för närvarande [[spellingFixes]] Rättelser av stavfel, vi rekommenderar att du håller detta antal under [[spellingLimit]] för att säkerställa att sidan visas utan problem.",
    "You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.": "<strong></strong><strong></strong>Du har för närvarande [[totalFixes]] korrigeringar, rekommenderar vi att du begränsar antalet korrigeringar till [[pageFixLimit]] för att säkerställa optimal prestanda på sidan, men det är upp till dig själv att bestämma.",
    "[[users]]<strong>and [[userCountLeft]] more</strong>": "<strong></strong>[[users]]och [[userCountLeft]] mer",
    "Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?": "<strong></strong>Är du säker på att du vill ignorera policyn? [[policyName]]?",
    "Title:": "Titel:",
    "[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]": "<strong></strong>[[msg]][[regulationName]] kommer att leda till att de anpassade [[opposite]] -reglerna för följande problem skrivs över, vilket innebär att de kommer att [[negate]] flaggas vid framtida genomsökningar [[list]]",
    "Admin only": "Endast admin",
    "Apply fix": "Tillämpa fix",
    "Contains high, medium or low opportunities": "Innehåller höga, medelhöga eller låga möjligheter",
    "Design": "Design",
    "Enable Custom PageCorrect Settings": "Aktivera anpassade PageCorrect-inställningar",
    "Enable PageCorrect features below. Disabled features will not be shown on your dashboard.": "Aktivera PageCorrect-funktionerna nedan. Inaktiverade funktioner visas inte på instrumentpanelen.",
    "Enable PageCorrect for Accessibility Source Codes": "Aktivera PageCorrect för källkoder för tillgänglighet",
    "Enable PageCorrect for Broken Links": "Aktivera PageCorrect för Trasiga Länkar",
    "Enable PageCorrect for Misspellings": "Aktivera PageCorrect för felstavningar",
    "Enable PagedCorrect for Accessibility Checks": "Aktivera PagedCorrect för tillgänglighetskontroller",
    "Failing checks - A": "Underkända kontroller - A",
    "Failing checks - AA": "Ej godkända kontroller - AA",
    "Failing checks - AAA": "Underkända kontroller - AAA",
    "Good job! Your domain contains no Accessibility Issues for this section": "Bra jobbat! Din domän innehåller inga tillgänglighetsproblem för detta avsnitt",
    "Indicates the difficulty to apply this fix": "Anger hur svårt det är att tillämpa denna korrigering",
    "List of improvements that can be applied to your website to improve your Accessibility Compliance": "Förteckning över förbättringar som kan tillämpas på din webbplats för att förbättra tillgängligheten",
    "Manage": "Hantera",
    "Media": "Media",
    "Open PageCorrect Settings": "Öppna sidanKorrigera inställningar",
    "PageCorrect Settings Updated": "PageCorrect-inställningar uppdaterade",
    "PageCorrect settings": "Inställningar för PageCorrect",
    "Pages with Data Privacy violations": "Sidor med överträdelser av dataskyddet",
    "Should admin be the only one to set PageCorrect Settings": "Ska admin vara den enda som kan ställa in PageCorrect-inställningar",
    "Website Structure": "Webbplatsens struktur",
    "Data Privacy violations": "Brott mot dataskyddet",
    "Heartbeat check": "Driftstidskontroll",
    "Request PDF accessibility check from selection": "Begär PDF tillgänglighetskontroll från urvalet",
    "Total unique downloads": "Totalt antal unika nedladdningar",
    "[[succeededPdfs]] out of [[pdfs]] PDF accessibility request succeeded": "[[succeededPdfs]] av [[pdfs]] Förfrågan om PDF-tillgänglighet lyckades",
    "Accessibility Issues": "Tillgänglighetsfrågor",
    "Inspecting:": "Inspektion:",
    "Pages with Accessibility Issues": "Sidor med tillgänglighetsproblem",
    "Start advance export": "Börja förhandsutförandet av exporten",
    "Check whether your website is responding and measures the response times of the server": "Kontrollera om din webbplats svarar och mät serverns svarstider",
    "Search label": "Sök etikett",
    "Custom range": "Anpassat sortiment",
    "Last Half Year": "Förra halvåret",
    "Last Month": "Förra månaden",
    "Last Quarter": "Förra kvartalet",
    "Last Week": "Förra veckan",
    "Last Year": "Föregående år",
    "Character": [
      "Tecken",
      "Tecken"
    ],
    "Image missing alt attribute": "Bilden saknar alt-attribut",
    "Quick info here": "Snabb information här",
    "There is 1 META description on this page": "Det finns 1 META-beskrivning på denna sida",
    "There is 1 internal link on this page": [
      "Det finns 1 intern länk på denna sida",
      "Det finns [[$count | monNumber]] interna länkar på den här sidan"
    ],
    "There is one META description on this page": [
      "Det finns en META-beskrivning på denna sida",
      "META-beskrivningar på denna sida"
    ],
    "and 1 document": {
      "Documents with broken images": [
        "och 1 dokument",
        " och [[$count | monNumber]] dokument"
      ],
      "Documents with confirmed misspellings": [
        "och 1 dokument",
        "och [[$count | monNumber]] dokument"
      ],
      "Documents with potential misspellings": [
        "och 1 dokument",
        "och [[$count | monNumber]] dokument"
      ]
    },
    "and one document": {
      "Pages with broken links": [
        "och ett dokument",
        "och [[$count | monNumber]] dokument"
      ]
    },
    "Remediation": "Sanering",
    "Remediation quote": "Offert för sanering",
    "Remediation quote has been requested": "En offert för sanering har begärts",
    "Sort by": {
      "Exchange center filter option": "Sortera efter"
    },
    "#idname.class-name1.class-name2": "#idname.class-name1.class-name2",
    "&lt;i&gt; tags as icons": "&lt;i&gt; taggar som ikoner",
    ".class-name1": ".class-name1",
    "<strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)": "<strong></strong>CSS-stil för &lt;strong&gt;-tagg (gör all stark text röd)",
    "<strong>NOTE</strong>: Changing the text below, will override the text in all your included languages": "<strong></strong>OBS: Om du ändrar texten nedan kommer den att åsidosätta texten i alla dina inkluderade språk",
    "A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations": "Det finns en nyare version av PageAssist. Byt till version 2.0 för att få tillgång till nya anpassningar",
    "Accessibility Fixes": "Tillgänglighetsanpassningar",
    "Add Policy": "Lägg till policy",
    "Add a description of the widget to your users": "Lägg till en beskrivning av widgeten till dina användare",
    "Add comment (Optional)": "Lägg till en kommentar (valfritt)",
    "Add row": "Lägg till rad",
    "Add text for when the button is hovered": "Lägg till text för när knappen är svävande",
    "Add title": "Lägg till rubrik",
    "Africa": "Afrika",
    "All <code>img</code> elements have an <code>alt</code> attribute": "<code></code><code></code>Alla img-element har ett alt-attribut",
    "Alt text does not convey the same information as the image": "Alt-texten förmedlar inte samma information som bilden",
    "Alt text for all <code>img</code> elements contains all text in the image unless the image text is decorative or appears elsewhere in the document": "<code></code>Alt-texten för alla img-element innehåller all text i bilden om inte bildtexten är dekorativ eller förekommer någon annanstans i dokumentet",
    "Alt text for all <code>img</code> elements is not placeholder text unless author has confirmed it is correct": "<code></code>Alt-texten för alla img-element är inte platshållartext om inte författaren har bekräftat att den är korrekt",
    "Alt text for all <code>img</code> elements is the empty string (\\\"\\\") if the image is decorative.": "<code></code>Alt-texten för alla img-element är den tomma strängen (\\\"\\\") om bilden är dekorativ.",
    "Alt text for all <code>img</code> elements used as source anchors is not empty when there is no other text in the anchor": "<code></code>Alt-texten för alla img-element som används som källankare är inte tom när det inte finns någon annan text i ankaret",
    "Alt text is not the same as the filename unless author has confirmed it is correct": "Alt-texten är inte samma som filnamnet om inte författaren har bekräftat att den är korrekt",
    "And how are we going to fix it?": "Och hur ska vi åtgärda det?",
    "Applying fix": "Tillämpning av korrigering",
    "Are you sure you want to stop receiving this report?": "Är du säker på att du vill sluta få den här rapporten?",
    "Aria-label": "Aria-märket",
    "Asia": "Asien",
    "Blink sample image": "Blink exempelbild",
    "Blink testing sample image": "Exempelbild för testprovningen",
    "Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.": "Båda dessa problem kan i praktiken leda till flera visuella problem, från fel färger till obekväma utrymmen där det inte borde finnas några.",
    "Bottom center": "Nedtill, centrerat",
    "Bottom left": "Nedre vänster",
    "Bottom right": "Nedre höger",
    "Browse": "Bläddra",
    "Button hover message": "Meddelande om att en knapp är på väg att sväva över",
    "CSS selector": "CSS-selektor",
    "Change <b> tags to a custom element": "Ändra taggar till ett anpassat element",
    "Change <b> tags to a custom tag": "Ändra taggar till en egen tagg",
    "Change <blink> tags to a custom element": "Ändra taggar till ett anpassat element",
    "Change <blink> tags to a custom tag": "Ändra taggar till en egen tagg",
    "Change <marquee> tags to a custom element": "Ändra taggar till ett anpassat element",
    "Change <marquee> tags to a custom tag": "Ändra taggar till en egen tagg",
    "Change your &lt;blink&gt; tags into something else": "Ändra dina &lt;blink&gt; taggar till något annat",
    "Change your &lt;i&gt; elements into something else": "Ändra dina &lt;i&gt; element till något annat",
    "Change your &lt;marquee&gt; tags into something else": "Ändra dina &lt;marquee&gt; taggar till något annat",
    "Check for misspelling company name: [[company]]": "Kontrollera om företagsnamnet är felstavat: [[company]]",
    "Choose a tag to replace your b tags with": "Välj en tagg att ersätta dina b-taggar med",
    "Choose a tag to replace your blink tags with": "Välj en tagg att ersätta dina blink-taggar med",
    "Choose a tag to replace your italic tags with": "Välj en tagg att ersätta de kursiva taggarna med",
    "Choose a tag to replace your marquee tags with": "Välj en tagg att ersätta dina markeringsmärken med",
    "Choose an icon": "Välj en ikon",
    "Choose this option to customise the fix": "Välj det här alternativet för att anpassa fixningen",
    "Choose this option to customize the fix": "Välj det här alternativet för att anpassa fixningen",
    "Choose your own text for the warning pop-up": "Välj din egen text för varningsfönstret",
    "Circle": "Cirkel",
    "Class": "Klass",
    "Close PageCorrect form": "Stäng PageCorrect-formuläret",
    "Close [[groupName]]: [[labelName]]": "Stäng [[groupName]]: [[labelName]]",
    "Company name *": "Företagets namn *",
    "Constraint:": "Begränsning:",
    "Custom settings": "Anpassade inställningar",
    "Default fix": "Standardrättning",
    "Default language": "Standardspråk",
    "Dutch": "Nederländska",
    "Edit Report": "Redigera rapport",
    "Education": "Utbildning",
    "Element name is invalid": "Elementnamnet är ogiltigt",
    "Element name should not contain spaces": "Elementnamnet får inte innehålla mellanslag",
    "Enter aria-label name": "Ange namnet på aria-märket",
    "Enter class name": "Ange klassens namn",
    "Enter role name": "Ange rollnamn",
    "Europe": "Europa",
    "Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:": "Även om detta är en ganska enkel lösning finns det två sätt som kan orsaka designproblem på din webbplats:",
    "Example 1": "Exempel 1",
    "Example 2": "Exempel 2",
    "File must be below 1MB": "Filen måste vara mindre än 1 MB",
    "Filter dropdown": "Filter-dropdown",
    "Finance": "Finans",
    "Fix applied!": "Rättelsen har tillämpats!",
    "Fix options": "Rätta alternativ",
    "French": "Franska",
    "Give a title to your Skip to Content button": "Ge en titel till knappen Hoppa till innehåll",
    "Government": "Myndigheter",
    "Grid view": "Rutnätsvy",
    "Hide": "Dölj",
    "Hide text": "Dölj text",
    "Hitting the tab button will turn on Skip to PageAssist": "Genom att trycka på fliken aktiveras Hoppa till PageAssist",
    "How are we going to fix it?": "Hur ska vi åtgärda det?",
    "Icon shape": "Ikonform",
    "Image Alt text is short": "Bildens Alt-text är kort",
    "Important images should not have spacer Alt text": "Viktiga bilder bör inte ha en Alt-text med mellanslag",
    "Info": "Info",
    "Insert company name": "Ange företagets namn",
    "Instead of &lt;i&gt; choose a different element name to be used instead": "Istället för &lt;i&gt; välj ett annat elementnamn som ska användas i stället",
    "It will take some time before our system will register your changes to PageCorrect": "Det kommer att ta lite tid innan vårt system registrerar dina ändringar i PageCorrect",
    "Left middle": "Vänster mitten",
    "Letter case *": "Bokstavsformat *",
    "Light": "Ljus",
    "Link excludes:": "Länken utesluter:",
    "Loading PageFix": "Laddar PageFix",
    "Make sure you use correct formatting and add multiple selectors when your page design differs": "Se till att du använder korrekt formatering och lägger till flera valörer när sidans utformning skiljer sig åt",
    "Manage options": "Hantera alternativ",
    "Marquee sample image": "Exempel på en bild av en tältduk",
    "Marquee testing sample image": "Provbild för testning av markörer",
    "Menu theme": "Tema för menyer",
    "New Window Information": "Information om nya fönster",
    "New Window Test": "Test av nytt fönster",
    "Non-Decorative images must have Alt text": "Icke-dekorativa bilder måste ha Alt-text",
    "North America": "Nordamerika",
    "PageAssist Logo": "PageAssist logotyp",
    "PageAssist position on Page": "PageAssist-position på sidan",
    "Portuguese": "Portugisiska",
    "Potential problems that can arise": "Potentiella problem som kan uppstå",
    "Press 'Upload link' to save your URL settings": "Tryck på \"Ladda upp länk\" för att spara dina inställningar för URL-adressen",
    "Preview": "Förhandsgranska",
    "Proper Case": "Rätt fall",
    "Remove input selector": "Ta bort val av ingång",
    "Remove logo upload": "Ta bort uppladdning av logotyp",
    "Remove row": "Ta bort rad",
    "Repair Tip": "Tips för reparation",
    "Repair options": "Reparationsalternativ",
    "Replace Italic element with EM": "Ersätt kursivt element med EM",
    "Replace all &lt;b&gt; tags with": "Ersätt alla &lt;b&gt; taggar med",
    "Replace all &lt;blink&gt; tags with": "Ersätt alla &lt;blink&gt; taggar med",
    "Replace all &lt;i&gt; tags": "Ersätt alla &lt;i&gt; taggar",
    "Replace all &lt;marquee&gt; tags with": "Ersätt alla &lt;marquee&gt; taggar med",
    "Report Center Image": "Bild i rapportcentret",
    "Reset Input": "Återställningsingång",
    "Reset Skip to content text to its default": "Återställer texten Hoppa till innehåll till standardvärdet",
    "Reset design": "Återställning av konstruktionen",
    "Reset to default": "Återställ till standard",
    "Restore": "Återställ",
    "Restore profile?": "Återställa profilen?",
    "Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.": "<strong></strong>Om du återställer denna profil ([[profileName]]) blir den tillgänglig i dina moduler.",
    "Right middle": "Höger mitten",
    "Rounded Box": "Rundad Box",
    "Russian": "Ryska",
    "Show": "Visa",
    "Show details": "Visa detaljer",
    "Show text": "Visa text",
    "Simplified Chinese": "Förenklad kinesiska",
    "Skip to Content": "Hoppa till innehåll",
    "Snippet reset": "Återställning av utklipp",
    "Someone have created this PageCorrect before you, on another check.": "Någon har skapat denna PageCorrect före dig, vid en annan kontroll.",
    "Spanish Mexican": "Spanska mexikanska",
    "Start export inventory emails": "Börja exportera e-postmeddelanden för inventering",
    "Start export inventory emails extended": "Börja exportera e-postmeddelanden för inventering utökad",
    "Testing": "Testar",
    "The subpath/subfolder the WordPress installation is under": "Den underväg/undermapp som WordPress-installationen ligger under",
    "This fix requires development knowledge": "Den här korrigeringen kräver kunskap om utveckling",
    "This message will be displayed when the user hovers over the PageAssist button": "Det här meddelandet visas när användaren håller fingret över PageAssist-knappen",
    "This option might cause problems to your icons": "Det här alternativet kan orsaka problem med dina ikoner",
    "Title Text": "Titeltext",
    "To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check": "För att konfigurera den här policyn måste du ange företagets namn och den eventuella felstavade bokstavstyp som du vill kontrollera",
    "Top center": "Överst centrera",
    "Top left": "Överst vänster",
    "Top right": "Överst höger",
    "Trying out the pop-up": "Prova popup-fönstret",
    "UPPERCASE": "VERSAL",
    "Undo check review": "Ångra granskning av kontroll",
    "Upload link": "Länk för uppladdning",
    "Upload logo": "Ladda upp logga",
    "Use Datepicker": "Använd Datepicker",
    "Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>": "<code></code>Använd PageCorrect för att korrigera följande felstavning:[[misspelling]]",
    "Use PageCorrect to fix Broken Link": "Använd PageCorrect för att åtgärda Trasiga Länkar",
    "Use PageCorrect to fix these image sources": "Använd PageCorrect för att korrigera dessa bildkällor",
    "Value:": "Värde:",
    "View": "Visa",
    "What is wrong with the &lt;b&gt; (bold) element?": "Vad är det för fel på elementet &lt;b&gt; (fet)?",
    "What is wrong with the &lt;i&gt; (italic) element?": "Vad är det för fel på elementet &lt;i&gt; (kursiv)?",
    "What to do when the link doesn't work?": "Vad gör man när länken inte fungerar?",
    "What to do when things look wrong?": "Vad ska man göra när saker och ting ser fel ut?",
    "Why shouldn't I use the blink element?": "Varför ska jag inte använda blinkelementet?",
    "Widget Design and Text": "Widget Design och text",
    "Widget Icon Setup": "Inställning av widget-ikonen",
    "Without any assigned class": "Utan någon tilldelad klass",
    "Write a warning to your outbound link": "Skriv en varning till din utgående länk",
    "Write custom tag": "Skriv en egen tagg",
    "lowercase": "gemener",
    "with": "med",
    "with &lt;em&gt;": "med &lt;em&gt;",
    "Statistics is using sample data": "Statistiken använder sig av provuppgifter",
    "Statistics results are sample data for demo purposes - export is disabled": "Statistikresultaten är provdata för demoändamål - exporten är inaktiverad",
    "This section is using sample data": "I detta avsnitt används exempeluppgifter",
    "&lt;i&gt; tags with these attribute values will not be changed": "&lt;i&gt; taggar med dessa attributvärden kommer inte att ändras",
    "(Bad)": "(Dålig)",
    "(Good)": "(Bra)",
    "<span class=\\\"mr-2\\\">Pages</span>": "<span class=\\\"mr-2\\\">Sidor</span>",
    "Add API user": "Lägg till API-användare",
    "Add attributes to be excluded in this change": "Lägg till attribut som inte ska omfattas av denna ändring",
    "Add profile": "Lägg till en profil",
    "Add source code exclude": "Lägg till källkoden för att utesluta",
    "Are you sure?": "Är du säker?",
    "Button hover color": "Knappfärg vid mus över",
    "Calculated by no. and severity of issues, page views and links leading to this page..": "Beräknat utifrån antal och svårighetsgrad av problem, sidvisningar och länkar som leder till denna sida...",
    "Choose minimum word count for a page to be included in the readability test": "Välj minsta antal ord för att en sida ska ingå i läsbarhetstestet",
    "Color contrast ratio": "Färgkontrastförhållande",
    "Content id tag": "Innehållets id-tag",
    "Creation date": "Skapat  datum",
    "Custom text": "Egen text",
    "Customise the Information page": "Anpassa informationssidan",
    "Disable": "Inaktivera",
    "Docs without downloads": "Dokument utan nedladdningar",
    "Documents Without Downloads": "Dokument utan nedladdningar",
    "EPI Server Path": "EPI-serverns sökväg",
    "EPIServer": "EPIServer",
    "Editor": "Redigerare",
    "Ex: data-currentpage, or data-pageid, or CurrentPageLink": "Ex: data-currentpage, eller data-pageid, eller CurrentPageLink",
    "Ex: lang or CurrentPageLanguage": "Ex: lang eller CurrentPageLanguage",
    "Export both pages and documents": "Exportera både sidor och dokument",
    "Export only documents without downloads": "Exportera endast dokument utan nedladdningar",
    "Export only html pages without visits": "Exportera endast html-sidor utan besök",
    "Include Accessibility Statement": "Inkludera ett uttalande om tillgänglighet",
    "Include custom info text": "Inkludera anpassad informationstext",
    "Includes a button with a link to your accessibility statement": "Inkluderar en knapp med en länk till ditt uttalande om tillgänglighet",
    "Indicates which language this page will be scanned in. Click underneath to change": "Anger vilket språk sidan ska skannas på. Klicka under för att ändra",
    "Insert a valid URL": "Infoga en giltig URL",
    "Language tag": "Språklig tagg",
    "Last assigned profile on page. Page will be removed from Performance": "Senast tilldelad profil på sidan. Sidan kommer att tas bort från prestanda",
    "Link color": "Länkfärg",
    "Link opens in a new tab": "Länken öppnas i en ny flik",
    "Main color": "Primär färg",
    "Meta name": "Metanamn",
    "Mode": "Läge",
    "No default profile selected for this page, scoring not available.": "Ingen standardprofil har valts för den här sidan, poängsättning är inte tillgänglig.",
    "No documents found": "Inga dokument hittades",
    "No profiles selected for this page, scoring not available.": "Inga profiler har valts för den här sidan, poängsättning inte tillgänglig.",
    "Not a valid CSS selector": "Inte en giltig CSS-selektor",
    "Notification when the downtime ends": "Meddelande när driftstoppet upphör",
    "Number of external links": "Antal externa länkar",
    "Number of incoming links": "Antal inkommande länkar",
    "Open details": "Öppna detaljer",
    "PDF Accessibility": "Tillgänglighet till PDF-filer",
    "Passwords do not match": "Lösenorden stämmer inte överens",
    "Please add a Default Profile to your Page": "Lägg till en standardprofil på din sida",
    "Please add a Profile to your Page": "Lägg till en profil på din sida",
    "Please enter a valid color code": "Ange en giltig färgkod",
    "Please perform a PDF scan to see the results for the checks below": "Gör en PDF-skanning för att se resultaten av kontrollerna nedan",
    "Setup": "Konfigurera",
    "Show less of the code snippet": "Visa mindre av kodutdraget",
    "Show the full code snippet": "Visa hela kodutdraget",
    "Statistics not activated. Page Views not available.": "Statistiken är inte aktiverad. Sidvisningar är inte tillgängliga.",
    "Subdomain": "Underdomän",
    "Subdomain url": "URL till underdomän",
    "Superfast - Don't use unless you know what you're doing": "Superfast - Använd inte om du inte vet vad du gör",
    "Text color": "Textfärg",
    "The optional epi server path": "Den valfria sökvägen till epi-servern",
    "The subdomain url to the CMS page": "Underdomänens url till CMS-sidan",
    "This text must be under 1000 characters": "Texten måste vara mindre än 1000 tecken",
    "Two-Factor Authentication": "Tvåfaktorsautentisering",
    "Two-factor authentication is currently disabled": "Tvåfaktorsautentisering är för närvarande inaktiverad",
    "Two-factor authentication is currently enabled": "Tvåfaktorsautentisering är för närvarande aktiverad",
    "URL needs to be valid, include http:// or https:// and be under 100 characters": "URL-adressen måste vara giltig, innehålla http:// eller https:// och vara mindre än 100 tecken",
    "URL template": "URL-mall",
    "Unique broken links": "Unika trasiga länkar",
    "Very fast - Be Cautious": "Mycket snabbt - var försiktig",
    "WCAG 2.0": "WCAG 2.0",
    "WCAG 2.1": "WCAG 2.1",
    "Your color contrast is below the recommended score": "Din färgkontrast ligger under det rekommenderade värdet",
    "labels": "etiketter",
    "Acceptance Rate": "Acceptansfrekvens",
    "Acceptance Rate Over Time": "Acceptansfrekvens över tid",
    "Acceptance Rate by Category": "Acceptansfrekvens efter Kategori",
    "Accepted cookies": "Accepterade cookies",
    "Add callback functions boilerplate": "Lägg till callback-funktioner boilerplate",
    "Add cookie": "Lägg till cookie",
    "Add empty EventListeners": "Lägg till tomma EventListeners",
    "Add empty callbacks": "Lägg till tomma callbacks",
    "Add event listeners boilerplate": "Lägg till event listeners boilerplate",
    "Add web overlay lock": "Lägg till ett webböverlappningslås",
    "Alternative": "Alternativ",
    "An overview of your customer's behavior with cookies on your website": "En översikt över dina kunders beteende med cookies på din webbplats",
    "Are you sure you want to ignore all selected misspellings?": "Är du säker på att du vill ignorera alla valda felstavningar?",
    "Are you sure you want to mark this check as fixed on all pages?": "Är du säker på att du vill markera den här kontrollen som fast på alla sidor?",
    "Are you sure you want to mark this check as fixed?": "Är du säker på att du vill markera den här kontrollen som korrigerad?",
    "Are you sure you want to mark this misspelling as fixed?": "Är du säker på att du vill markera denna felstavning som korrigerad?",
    "Are you sure you want to mark this misspelling(s) as fixed?": "Är du säker på att du vill markera denna felstavning som korrigerad?",
    "Basic": "Grundläggande",
    "Button color": "Knappfärg",
    "Button text color": "Knapp textfärg",
    "Case sensitive URLs": "Skiftlägeskänsliga URL:er",
    "Changes wording from only essential cookies to explicit reject": "Ändrar ordalydelsen från endast nödvändiga cookies till uttryckligt avvisande",
    "Consent Log": "Samtyckeslogg",
    "Consent Overview": "Samtycke Översikt",
    "Consent results are sample data for demo purposes": "Samtyckesresultat är exempeldata för demosyften",
    "Cookie Acceptance Rate": "Cookie Acceptansfrekvens",
    "Cookie Overview": "Cookie Översikt",
    "Cookie description": "Cookie beskrivning",
    "Cookie duration": "Cookie varaktighet",
    "Cookie name": "Cookie-namn",
    "Enter a valid CSS selector": "Ange en giltig CSS-väljare",
    "Essential": "Nödvändiga",
    "Example 3": "Exempel 3",
    "Example 4": "Exempel 4",
    "Explicit reject option": "Uttryckligt avvisningsalternativ",
    "Give a short description of the purpose of the cookie": "Ge en kort beskrivning av syftet med cookien",
    "Give users more control over which categories of cookies to consent to": "Ge användarna större kontroll över vilka kategorier av cookies de vill godkänna",
    "How long is the cookie active": "Hur länge är cookien aktiv",
    "IP Address": "IP-Adress",
    "Ignore canonical URLs": "Ignorera kanoniska URL:er",
    "Ignored by": "Ignorerade av",
    "Ignored date": "Ignorerat datum",
    "Ignored misspellings on account": "Ignorerade felstavningar på konto",
    "Include cookies": "Inkludera cookies",
    "Insert CSS class or id selector": "Infoga CSS-klass eller id-väljare",
    "Insert a CSS selector": "Infoga en CSS-selektor",
    "Limit or exclude": "Begränsa eller utesluta",
    "Limit search": "Begränsa sökningen",
    "Link to your opt out page": "Länk till din sida för avregistrering",
    "Make sure you use the correct setting": "Se till att du använder rätt inställning",
    "Mark check as fixed": "Markera kontrollen som fixad",
    "Marketing": "Marknadsföring",
    "No cookies found": "Inga cookies funna",
    "No misspellings have been ignored": "Inga felstavningar har ignorerats",
    "Opt out link": "Länk för avregistrering",
    "Original": "Original",
    "Other": "Annat",
    "Overall Acceptance Rate": "Övergripande Acceptansfrekvens",
    "Overall acceptance rate": "Övergripande acceptansfrekvens",
    "Per category consent": "Samtycke per kategori",
    "Please wait - Marking as fixed": "Vänligen vänta - Markering som fixad",
    "Please wait - Marking word as fixed": "Vänta - Markerar ordet som rättat",
    "Preferences": "Preferenser",
    "Privacy regulation": "Integritetsreglering",
    "Remove cookie": "Ta bort cookie",
    "Remove from Ignored": "Ta bort från ignorerade",
    "Remove this word from Ignored Misspellings": "Ta bort detta ord från ignorerade felstavningar",
    "URL Structure": "URL-struktur",
    "Domain Overview": {
      "Topmenu": "Domänöversikt",
      "$$noContext": "Domänöversikt"
    },
    "Admin Settings": "Admin-inställningar",
    "Case sensitivity": "Skiftlägeskänslighet",
    "Close project search and domain picker": "Stäng projektsökning och domänväljare",
    "Domain Settings": "Domäninställningar",
    "In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.": "I slutändan ser både &lt;I&gt; och &lt;em&gt; taggarna visuellt sett likadana ut. De har dock olika semantisk innebörd. &lt;em&gt; används för att visa betoning, medan &lt;I&gt; taggen representerar ett ord eller en mening som användaren kan vilja sätta i kursiv stil (ett främmande ord, en definition av ett ord osv.). För det senare bör CSS användas i stället.",
    "Paste your image link (URL) here": "Klistra in din bildlänk (URL) här",
    "Set up your domain": "Sätt upp din domän",
    "The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.": "Det största problemet med denna lösning kan uppstå om taggen &lt;i&gt; används för ikoner i stället för till exempel &lt;span&gt; (exempel: Font Awesome). Om du märker att något ser fel ut med dina ikoner efter att du har tillämpat korrigeringen kan detta vara orsaken. Men &lt;i&gt;-taggar för ikoner tenderar att använda en klass, så se till att du har ställt in alternativen så att du bara ändrar taggarna utan att ändra klasserna. På så sätt bör dina ikoner lämnas orörda.",
    "The profile <strong>[[profileName]]</strong> is being used on the following pages below:": "<strong></strong>Profilen [[profileName]] används på följande sidor nedan:",
    "Add icon border": "Lägg till en ikongräns",
    "Adds a 3px wide border to the PageAssist widget icon": "Lägger till en 3px bred kant till PageAssist widget-ikonen",
    "Bottom": "Nederst",
    "Clear search": "Rensa sökningen",
    "Ensures that PageAssist is never overlapped by other elements on the page": "Säkerställer att PageAssist aldrig överlappas av andra element på sidan",
    "Estonian": "Estniska",
    "German": "Tyska",
    "Go to overlay with details": "Gå till överlappning med detaljer",
    "Guidelines for WCAG 2.2": "Riktlinjer för WCAG 2.2",
    "Heartbeat Overview": "Drifttidsöversikt",
    "How far the button is from the edge. Customization dependant on position.": "Hur långt knappen är från kanten. Anpassningen beror på positionen.",
    "Insert a valid host name": "Ange ett giltigt värdnamn",
    "Keep PageAssist on top": "Behåll PageAssist längst upp",
    "Left": "Vänster",
    "Margin from edge in pixels": "Marginal från kanten i pixlar",
    "Norwegian Bokmål": "Norska Bokmål",
    "Norwegian Nynorsk": "Norska Nynorska",
    "Right": "Höger",
    "Social Media visits": "Besök på Sociala Medier",
    "Social media visits": "Besök på sociala medier",
    "Sort column": "Sortera kolumn",
    "Sort column ascending": "Sortera kolumnen stigande",
    "Sort column descending": "Sortera kolumnen fallande",
    "Subgroup": "Undergrupp",
    "Swedish": "Svenska",
    "Toggle label text": "Växlingsetikett text",
    "Top": "Överst",
    "Unique misspellings": "Unika felstavningar",
    "Unique misspellings found": "Unika felstavningar hittades",
    "WCAG 2.2 Accessibility Compliance": "WCAG 2.2 Efterlevnad av Tillgänglighet",
    "Area dynamic page": "Områdesdynamiksida",
    "Employeepage": "Medarbetarsida",
    "Language id": "Språk-ID",
    "Newspage": "Nyhetssida",
    "Standard": "Standard",
    "Standard for http(s)://edit.domain.tld/inz/<path>. Alternative for http(s)://domain.tld/<path>/edit.": "Standard för http(s)://edit.domain.tld/inz/<path>. Alternativ till http(s)://domain.tld/<path>/edit.",
    "URL format": "URL-format",
    "Export both internal and external links": "Exportera både interna och externa länkar",
    "Export only external links": "Exportera endast externa länkar",
    "Export only internal links": "Exportera endast interna länkar",
    "Overview of all the enabled modules for this domain": "Översikt över alla aktiverade moduler för den här domänen",
    "Search for a predefined policy in the Policy Exchange Center": "Sök efter en fördefinierad policy i Policy Exchange Center",
    "A log of all the consents given by your website visitors": "En logg över alla samtycken som ges av dina besökare på webbplatsen",
    "Action required. Click to resolve issue.": "Åtgärd krävs. Klicka för att lösa problemet.",
    "Complete": "Slutförd",
    "Cookie Overview buttons": "Cookieöversiktsknappar",
    "Cookie Overview saved": "Cookieöversikt sparad",
    "Cookie added by user": "Cookie som lagts till av användaren",
    "Cookie domain": "Cookie-domän",
    "Cookie not found": "Cookie inte hittad",
    "Cookie not published. Missing:": "Cookie inte publicerad. Saknar:",
    "Could not save invalid form": "Kunde inte spara ogiltigt formulär",
    "Disables interactions on website until the visitor makes a consent choice. Be aware that locking interactions prior to consent may not be compliant with certain regional privacy regulations.": "Inaktiverar interaktioner på webbplatsen tills besökaren gör ett samtyckesval. Tänk på att det kan vara oförenligt med vissa regionala sekretessbestämmelser att låsa interaktioner före samtycke.",
    "Finish the setup by adding your cookies": "Slutför installationen genom att lägga till dina kakor",
    "For Cookie setup please go to your <b>Data Privacy</b> module.<br> Manual cookies can be set up or edited any time and are not related to script setup.": "<b></b><br>För att ställa in cookies går du till din modul för &lt;b&gt;dataskydd&lt;/b&gt;.&lt;br&gt;Manuella cookies kan ställas in eller redigeras när som helst och är inte relaterade till inställningen av skript.&lt;/br&gt; ",
    "GDPR requires that companies provide descriptions on their website for all cookies that are used.": "GDPR kräver att företag tillhandahåller beskrivningar på sin webbplats för alla cookies som används.",
    "Give an overview of the cookies used on your website. Finish a domain scan or add them manually.": "Ge en översikt över de cookies som används på din webbplats. Slutför en domänskanning eller lägg till dem manuellt.",
    "Id": "Id",
    "Include a link to your webpage's privacy policy": "Inkludera en länk till din webbsidas sekretesspolicy",
    "It looks like the previously set up cookie was not found in this scan. It might be that the cookie was removed or our scan just couldn’t detect it.": "Det ser ut som om den tidigare inställda cookien inte hittades i den här skanningen. Det kan vara så att cookien har tagits bort eller att vår skanning bara inte kunde upptäcka den.",
    "I’ll do it later": "Jag gör det senare",
    "Keep": "Behåll",
    "Leave without saving": "Lämna utan att spara",
    "Link to Privacy Policy": "Länk till sekretesspolicy",
    "Link to your Cookie Overview": "Länk till din översikt över cookies",
    "Link to your Privacy Policy": "Länk till din sekretesspolicy",
    "Link where customers can opt out of sale of personal data. Mandatory for websites under the CCPA regulation.": "Länk där kunderna kan avstå från att sälja personuppgifter. Obligatoriskt för webbplatser enligt CCPA-förordningen.",
    "List of checks with and without issues categorized by [[level]] guidelines": "Förteckning över kontroller med och utan problem som kategoriseras enligt [[level]] riktlinjer",
    "Manage Cookie": "Hantera cookie",
    "On-demand scan unavailable": "Skanning på begäran är inte tillgänglig",
    "Pages needing to be fixed": "Sidor som behöver åtgärdas",
    "Save cookies": "Spara cookies",
    "Save existing cookies": "Spara befintliga cookies",
    "Save this overview to publish completed cookies to the Cookie Overview.": "Spara den här översikten för att publicera färdiga cookies i Cookieöversikten.",
    "Save your page before leaving to keep your progress and publish the completed cookies.": "Spara din sida innan du går för att behålla dina framsteg och publicera färdiga cookies.",
    "Scan History": "Skanningshistorik",
    "Scan Information": "Skanningsinformation",
    "Scan info": "Skanningsinfo",
    "Source": "Källa",
    "This feature is not available on a demo account.": "Den här funktionen är inte tillgänglig på ett demokonto.",
    "This page has been rescanned since the latest full scan.": "Den här sidan har skannats på nytt sedan den senaste fullständiga skanningen.",
    "This scan feature is not available on a demo account": "Denna skanningsfunktion är inte tillgänglig på ett demokonto",
    "UUID": "UUID",
    "You need to include a name in order to save your cookies.": "Du måste ange ett namn för att spara dina cookies.",
    "[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.": "[[total]] sidor. Prioritera och åtgärda alla innehållsproblem på din webbplats från en konsoliderad vy.",
    "Distribution of policies with matches across priority levels": "Fördelning av policyområden med matchningar över olika prioriteringsnivåer",
    "Copied!": "Kopierad!",
    "Copy": "Kopiera",
    "Default language*": "Standardspråk*",
    "Don't forget to copy and update the script on your website!": "Glöm inte att kopiera och uppdatera skriptet på din webbplats!",
    "Included languages*": "Inkluderade språk*",
    "Loading Data": "Laddar information",
    "Loading...": "Laddar...",
    "No support": "Ingen support",
    "Open PageAssist script settings": "Öppna PageAssist-skriptinställningar",
    "PageAssist script settings": "Inställningar för PageAssist-skriptet",
    "Please add the script as close to the open HEAD-tag as possible": "Lägg till skriptet så nära den öppna HEAD-taggen som möjligt",
    "Please wait - loading": "Vänligen vänta - laddar",
    "Press Ctrl-C": "Tryck Ctrl-C",
    "Press ⌘-C": "Tryck ⌘-C",
    "This chart shows how many percent of visitors accepted the various categories of cookies on your website. Visitors who did not make a consent choice on the cookie banner are not counted": "Det här diagrammet visar hur många procent av besökarna som accepterade de olika kategorierna av cookies på din webbplats. Besökare som inte har valt att ge sitt samtycke på cookie-bannern räknas inte med",
    "Visitor percentage": "Procentuell andel av besökarna",
    "Consent Manager script settings": "Inställningar för skriptet för Consent Manager",
    "Open consent manager script settings": "Öppna inställningar för skriptet för samtyckeshanteraren",
    "Scan your website for any data privacy issues that could be present": "Skanna din webbplats för att se om det finns några problem med dataskydd",
    "Please enter a full UUID string. Empty or partial strings will not yield any results.": "Ange en fullständig UUID-sträng. Tomma eller partiella strängar ger inga resultat.",
    "UUID can only be searched by entering the full value": "UUID kan endast sökas genom att ange det fullständiga värdet",
    "Average Cumulative Layout Shift": "Genomsnittlig Cumulative Layout Shift",
    "Average Largest Contentful Paint": "Genomsnittlig Largest Contentful Paint",
    "Average Speed Index": "Genomsnittligt Speed Index",
    "Average Total Blocking Time": "Genomsnittlig Total Blocking Time",
    "CMS Path": "CMS-Path",
    "Click here or drag a rule to this area": "Klicka här eller dra en regel till det här området",
    "Cumulative Layout Shift": "Cumulative Layout Shift",
    "LCP": "LCP",
    "Relevant for": "Relevant för",
    "SI": "SI",
    "TBT": "TBT",
    "[[avg]]": "[[avg]]",
    "[[label]]: [[value]]": "[[label]]: [[value]]",
    "Content Authoring": "Content Authoring",
    "Responsibilities": "Ansvarsområden",
    "Responsibility": "Ansvar",
    "UX Design": "UX-design",
    "Visual Design": "Visuell design",
    "Version [[version]]": "Version [[version]]",
    "Accessibility score": "Tillgänglighetspoäng",
    "Comparison to average": "Jämförelse med genomsnittet",
    "Industry average": "Branschgenomsnitt",
    "No scores available for this domain": "Inga poäng tillgängliga för denna domän",
    "Professional services": "Professionella tjänster",
    "Quality Assurance score": "Kvalitetssäkringspoäng",
    "SEO score": "SEO-poäng",
    "Scores": "Poäng",
    "The average score for domains within your industry.": "Genomsnittliga poäng för domäner inom din bransch.",
    "Add language": "Lägg till språk",
    "Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.": "Är du säker på att du vill arkivera policyn <strong>[[policyName]]</strong>? Vi kommer inte längre att leta efter matchningar till denna policy. Du kan alltid avarkivera policyn igen senare.",
    "Are you sure you want to set these documents as reviewed?": "Är du säker på att du vill ställa in dessa dokument som granskade?",
    "Clear selection": "Rensa val",
    "Delete language -": "Ta bort språk -",
    "Delete the language tab - [[language]]": "Ta bort språkflik - [[language]]",
    "Discovered": "Upptäckt",
    "Doing this will result in removing the translations in the selected language from both your Cookie Overview and the actual banner itself.<br></br><strong>You will need to add the descriptions again when you re-add the selected language.</strong>": "Om du gör detta kommer översättningarna på det valda språket att tas bort från både din Cookie-översikt och själva bannern.<br></br><strong> Du måste lägga till beskrivningarna igen när du lägger till det valda språket igen.</strong>",
    "Don't forget to update your languages in Script Setup!": "Glöm inte att uppdatera dina språk i Script Setup!",
    "Edit this policy rule later under the “Add rule to policy” tab.": "Redigera denna policyregel senare under fliken \"Lägg till regel i policy\".",
    "Front-end Development": "Front-end utveckling",
    "How to setup this policy:": "Så här ställer du in denna policy:",
    "Insert word length": "Infoga ordlängd",
    "Inspect page with browser extension": "Inspektera sidan med webbläsartillägg",
    "Mark all as reviewed": "Markera alla som granskade",
    "Mobile only": "Endast mobil",
    "New policy": "Ny policy",
    "Please add at least one language": "Lägg till minst ett språk",
    "Please set the default language": "Ange standardspråk",
    "Please wait - Adding word to ignored list": "Vänta - Lägger till ord i listan ignorera",
    "Please wait - Adding words to ignored list": "Vänta - Lägger till ord i listan ignorera",
    "Remove rule from policy": "Ta bort regel från policy",
    "Request PDF accessibility check for all": "Begär PDF-tillgänglighetskontroll för alla",
    "Request Remedition quote for all": "Begär offert för åtgärd av alla",
    "Script": "Script",
    "Select a group": "Välj en grupp",
    "Select a shape": "Välj en form",
    "Select languages": "Välj språk",
    "Select the default language": "Välj standardspråk",
    "To finish setting up your manual Cookie Overview go to the selected domain’s": "Gå till den valda domänen för att avsluta inställningen av din manuella Cookie-översikt",
    "Unignore this check": "Avignorera denna kontroll",
    "WCAG 2.1 (Level AA) Mobile": "WCAG 2.1 (Nivå AA) Mobil",
    "WCAG 2.1 (Level AAA) Mobile": "WCAG 2.1 (Level AAA) Mobil",
    "Are you sure you want to delete label: [[label]] ?": "Är du säker på att du vill ta bort etikett: [[label]]?",
    "Business services": "Företagstjänster",
    "CMS template is configured for this domain": "CMS-mallen är konfigurerad för den här domänen",
    "Consent Manager configuration": "Konfiguration av samtyckeshanterare",
    "Consent Manager language*": "Samtyckeshanterare språk*",
    "Consent Manager pop-up position on Page": "Pop-up-position av samtyckeshanterare på Sida",
    "Consent Manager pop-up setup": "Popup-inställningar för Samtyckeshanterare",
    "Construction/industrial": "Byggnadsverksamhet/industriell verksamhet",
    "Consumer services": "Konsumenttjänster",
    "Entertainment/Leisure": "Underhållning/fritid",
    "Financial services": "Finansiella tjänster",
    "German (Germany)": "Tyska (Tyskland)",
    "Healthcare": "Hälso- och sjukvård",
    "Label used in the groups below. Please edit or delete the groups and try again.": "Etikett som används i grupperna nedan. Redigera eller radera grupperna och försök igen.",
    "Law enforcement": "Brottsbekämpning",
    "Legal": "Juridisk",
    "Non-profit": "Icke vinstdrivande",
    "Real-estate": "Fastigheter",
    "Retail/wholesale": "Detaljhandel/grosshandel",
    "Spanish (Spain)": "Spanska (Spanien)",
    "Technology": "Teknik",
    "Utilities/Natural resources": "Samhällsservice/Naturtillgångar",
    "Widget Design": "Widget-design",
    ":": ":",
    "Accessibility issue": "Tillgänglighetsproblem",
    "Add reason (optional)": "Lägg till orsak (valfritt)",
    "All pages with this accessibility issue": "Alla sidor med detta tillgänglighetsproblem",
    "All pages with this data privacy issue": "Alla sidor med detta dataintegritetsproblem",
    "Alternatively, click the button below.": "Alternativt, klicka på knappen nedan.",
    "Are you sure you want to mark this  as fixed?": "Är du säker på att du vill markera detta som fixat?",
    "Are you sure you want to mark this  as ignored?": "Är du säker på att du vill markera detta som ignorerat?",
    "Are you sure you want to mark this  as not fixed?": "Är du säker på att du vill markera detta som inte fixat?",
    "Are you sure you want to mark this check as ignored?": "Är du säker på att du vill markera den här kryssrutan som ignorerad?",
    "Are you sure you want to mark this issue as ignored?": "Är du säker på att du vill markera det här problemet som ignorerat?",
    "Are you sure you want to unignore this ?": "Är du säker på att du vill ta bort detta?",
    "Average time (comp.)": "Genomsnittlig tid (komp.)",
    "Bounce rate (comp.)": "Avvisningsfrekvens (komp.)",
    "Campaign visits": "Kampanjbesök",
    "Code": "Koda",
    "Confirmation required": "Bekräftelse krävs",
    "Current password": "Aktuellt lösenord",
    "Data privacy issue": "Datasekretessproblem",
    "Data violations": "Dataöverträdelser",
    "Date found": "Datum hittat",
    "Downloads (comp.)": "Nedladdningar (komp.)",
    "Entries (comp.)": "Inlägg (komp.)",
    "Events": "Händelser",
    "Exits (comp.)": "Utgångar (komp.)",
    "Export visitors browsers": "Exportera besökares webbläsare",
    "Export visitors devices": "Exportera besökares enheter",
    "Export visitors language": "Exportera besökarnas språk",
    "Export visitors locations": "Exportera besökarnas platser",
    "Export visitors operating systems": "Exportera besökares operativsystem",
    "Export visitors organization": "Exportera besökarorganisation",
    "Found on page": "Finns på sidan",
    "Group name": "Gruppnamn",
    "Image URL": "Bildens URL",
    "Issue details": "Ärendedetaljer",
    "Issue not found": "Problemet hittades inte",
    "Legacy Browser Service changed": "Äldre webbläsartjänst har ändrats",
    "Look up in Google": "Slå upp i Google",
    "Mark as reviewed": "Markera som granskad",
    "Maximum word length to search for": "Maximal ordlängd att söka efter",
    "Names": "Namn",
    "No pages were found. Try searching for the page URL instead of the page title.": "Inga sidor hittades. Försök att söka efter sidans URL istället för sidans titel.",
    "Open browser extension": "Öppna webbläsartillägget",
    "Open issue page": "Öppna ärendesidan",
    "Open misspelling page": "Öppna felstavningssidan",
    "Other checks for this snippet": "Andra kontroller för det här utdraget",
    "Pages with accessibility issues": "Sidor med tillgänglighetsproblem",
    "Pages with policy issues": "Sidor med policyfrågor",
    "Pageviews (comp.)": "Sidvisningar (komp.)",
    "Percentage shows number of pages that are compliant with all Policies": "Procentandelen visar antalet sidor som är kompatibla med alla policyer",
    "Percentage shows number of pages that are compliant with all QA checks": "Procentandelen visar antalet sidor som är kompatibla med alla kvalitetskontroller",
    "Please enter a valid date!": "Ange ett giltigt datum!",
    "Please wait - Adding word to all dictionaries": "Vänta - Lägger till ord i alla ordböcker",
    "Press to toggle additional rows.": "Tryck för att växla ytterligare rader.",
    "Puppeteer Browser Service changed": "Puppeteer Browser Service har ändrats",
    "Reason:&nbsp;": "Orsak:&nbsp;",
    "Remember to add this source code exclude to your domain(s) through the Edit Domain screen.": "Kom ihåg att lägga till denna exkludering av källkoden till din/dina domäner via skärmen Redigera domän.",
    "Remove review": "Ta bort recension",
    "Repeat new password": "Upprepa nytt lösenord",
    "Sorry, this page was not found. The issue must have been resolved.": "Tyvärr, den här sidan hittades inte. Problemet måste ha lösts.",
    "The date cannot be in the future": "Datumet kan inte ligga i framtiden",
    "The end date cannot be before the start date": "Slutdatumet kan inte infalla före startdatumet",
    "The settings form contains incorrect data. Close the form anyway?": "Inställningsformuläret innehåller felaktiga uppgifter. Stäng formuläret ändå?",
    "The start and end date cannot be in the future, please enter the compare dates again": "Start- och slutdatum kan inte ligga i framtiden, vänligen ange jämfördatumen igen",
    "This issue is marked as fixed.": "Det här problemet är markerat som löst.",
    "This issue is marked as ignored.": "Det här problemet är markerat som ignorerat.",
    "This issue is marked as reviewed.": "Det här problemet är markerat som granskat.",
    "This word has been added to your dictionary": "Detta ord har lagts till i din ordbok",
    "To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class=\\\"text-bold\\\">My Exports.</span>": "För att se den aktuella utvecklingen klickar du på användaravataren uppe till höger på huvudsidan och väljer <span class=\\\"text-bold\\\">Mina exporter.</span>",
    "Total unique downloads (comp.)": "Totalt antal unika nedladdningar (komp.)",
    "Unique downloads (comp.)": "Unika nedladdningar (komp.)",
    "Visitors browsers export": "Besökares webbläsare exporterar",
    "Visitors devices export": "Besökares enheter exporterar",
    "Visitors language export": "Besökares språkexport",
    "Visitors locations export": "Besöksplatser exporterar",
    "Visitors operating systems export": "Besökare exporterar operativsystem",
    "Visitors organization export": "Besöksorganisation export",
    "Visits (comp.)": "Besök (komp.)",
    "WCAG 2.1 (Level A) Mobile": "WCAG 2.1 (Nivå A) Mobil",
    "Your export is currently being generated.": "Din export genereras för närvarande.",
    "+ ' + (report.targets.length - maxTargets) + ' more": "+ ' + (report.targets.length - maxTargets) + ' mer",
    "Accessibility Checklist (WCAG 2.0)": "Tillgänglighetschecklista (WCAG 2.0)",
    "Accessibility Checklist (WCAG 2.1)": "Tillgänglighetschecklista (WCAG 2.1)",
    "Accessibility Checklist (WCAG 2.2)": "Tillgänglighetschecklista (WCAG 2.2)",
    "Average no. of results pages viewed": "Genomsnittligt antal. av visade resultatsidor",
    "Checklist": "Checklista",
    "Email *": "E-post *",
    "Event actions": "Händelseåtgärder",
    "Event categories": "Händelsekategorier",
    "Event names": "Namn på händelser",
    "First name *": "Förnamn *",
    "Last name *": "Efternamn *",
    "Search term": "Sökterm",
    "Search terms": "Söktermer",
    "Search terms with no results": "Söktermer utan resultat",
    "Site Search": "Webbplatssökning",
    "Site Search - Search Terms": "Webbplatssökning - Söktermer",
    "Site Search No Results Search Terms": "Webbplatssökning Inga resultat Söktermer",
    "Switch between chart and table": "Växla mellan diagram och tabell",
    "Table": "Tabell",
    "more": "mer",
    "Accessibility checks update": "Uppdatering av tillgänglighetskontroller",
    "Account is under maintenance": "Kontot är under underhåll",
    "Add internal URL": "Lägg till intern URL",
    "Add the name of the platform or company who provides this cookie.": "Lägg till namnet på plattformen eller företaget som tillhandahåller denna cookie.",
    "All PDFs": "Alla PDF-filer",
    "All scheduled reports": "Alla schemalagda rapporter",
    "An error has occurred - please try again": "Ett fel har uppstått - försök igen",
    "Are you sure you want mark as fixed": "Är du säker på att du vill markera som fast",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary for all languages?": "Är du säker på att du vill lägga till ordet <strong>[[word]]</strong> i ordboken för alla språk?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary?": "Är du säker på att du vill lägga till ordet <strong>[[word]]</strong> i ordboken?",
    "Are you sure you want to confirm the word <strong>[[word]]</strong> as misspelling?": "Är du säker på att du vill bekräfta ordet <strong>[[word]]</strong> som felstavning?",
    "Are you sure you want to ignore the misspelling <strong>[[word]]</strong> for all languages?": "Är du säker på att du vill ignorera felstavningen <strong>[[word]]</strong> för alla språk?",
    "Are you sure you want to mark the misspelling <strong>[[word]]</strong> as fixed?": "Är du säker på att du vill markera felstavningen <strong>[[word]]</strong> som åtgärdad?",
    "Are you sure you want to remove the Default label?": "Är du säker på att du vill ta bort standardetiketten?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong>?": "Är du säker på att du vill köra policyn <strong>[[policyName]]</strong>?",
    "Bar chart representing data": "Stapeldiagram som representerar data",
    "Bar line chart representing": "Stapellinjediagram som representerar",
    "Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.": "Tänk på att ett tomt alt-attribut kan vara tillräckligt och lämpligt för dekorativa bilder.",
    "Bubble chart representing data": "Bubbeldiagram som representerar data",
    "Clear the field": "Rensa fältet",
    "Close submenu": "Stäng undermenyn",
    "Contact Support": "Kontakta support",
    "Cookie platform": "Cookie-plattform",
    "Current password is incorrect please try again": "Det aktuella lösenordet är felaktigt, försök igen",
    "Doughnut chart representing data": "Munkdiagram som representerar data",
    "Enable Cookieless Tracking": "Aktivera spårning utan cookies",
    "Errors and": "Fel och",
    "Errors and Warnings": "Fel och varningar",
    "Events filter buttons": "Händelsefilterknappar",
    "Every 12 weeks": "Var 12:e vecka",
    "Every 2 weeks": "Varannan vecka",
    "Every 4 weeks": "Var 4:e vecka",
    "Every 8 weeks": "Var 8:e vecka",
    "Frequency": "Frekvens",
    "Image details": "Bilddetaljer",
    "Image metadata": "Bildmetadata",
    "Image preview": "Förhandsgranskning av bild",
    "Inventory image preview": "Förhandsgranskning av lagerbild",
    "It seems like we are experience some issues with the page you are looking at.": "Det verkar som om vi har några problem med sidan du tittar på.",
    "It seems like your computer is disconnected from the internet.": "Det verkar som om din dator är frånkopplad från internet.",
    "Line chart representing data": "Linjediagram som representerar data",
    "List of received reports": "Lista över mottagna rapporter",
    "Metadata and pages": "Metadata och sidor",
    "Metadata property": "Metadataegenskap",
    "My scheduled reports": "Mina schemalagda rapporter",
    "No date range selected": "Inget datumintervall valt",
    "Norwegian": "norska",
    "Only Errors": "Endast fel",
    "Only errors": "Bara fel",
    "Open dropdown with filters": "Öppna rullgardinsmenyn med filter",
    "Open metadata view": "Öppna metadatavy",
    "Open submenu with filters": "Öppna undermenyn med filter",
    "Pages that contain the Email": "Sidor som innehåller e-postmeddelandet",
    "Percentage shows the average compliance score across all pages on the domain": "Procentandelen visar den genomsnittliga efterlevnadspoängen på alla sidor på domänen",
    "Pie chart representing data": "Cirkeldiagram som representerar data",
    "Platform": "Plattform",
    "Please contact the support if this issue keeps happening": "Kontakta supporten om det här problemet fortsätter att hända",
    "Please refresh the browser when your computer is online again.": "Uppdatera webbläsaren när din dator är online igen.",
    "Please try again later": "Försök igen senare",
    "Press to remove the label.": "Tryck för att ta bort etiketten.",
    "Puppeteer 20": "Dockspelare 20",
    "Remove internal URL": "Ta bort intern URL",
    "Scan all pages for cookies": "Skanna alla sidor efter cookies",
    "Schedule this report": "Schemalägg denna rapport",
    "Search in options": "Sök i alternativ",
    "Show HTML snippet details": "Visa HTML-koddetaljer",
    "Show labels": "Visa etiketter",
    "Show less of the url snippet": "Visa mindre av webbadressavsnittet",
    "Show the full url snippet": "Visa hela webbadressavsnittet",
    "Showing": "Visande",
    "The average compliance score for this module for domains from other organizations within your industry:": "Den genomsnittliga efterlevnadspoängen för denna modul för domäner från andra organisationer inom din bransch:",
    "Unsubscribe from report": "Avsluta prenumeration på rapporten",
    "Warnings": "Varningar",
    "We export up to a maximum of 1000 rows": "Vi exporterar upp till maximalt 1000 rader",
    "We recommend that you have an alt attribute with relevant content on all image tags.": "Vi rekommenderar att du har ett alt-attribut med relevant innehåll på alla bildtaggar.",
    "You have images missing an alt attribute.": "Du har bilder som saknar ett alt-attribut.",
    "[[name]] Remove": "[[name]] Ta bort",
    "[[target]]": "[[mål]]",
    "default": "standard",
    "[[label]]": "[[märka]]",
    "% of visitors staying after a search": "% av besökarna stannar efter en sökning",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.": "Dokumentsanering för överensstämmelse med WCAG 2.1 AA, Section 508, HHS eller PDF/UA tillgänglighetsstandarder görs av vårt dotterbolag, NetCentric Technologies, Inc. På grund av regelverkskraven i ditt land kan vi inte samordna dokumentsanering direkt för du; du är dock inbjuden att kontakta NetCentric direkt för en offert och saneringstjänster på dherr@allyant.com. Observera att alla kontrakt för åtgärdande är mellan dig, kunden och NetCentric och omfattas av NetCentrics villkor och sekretesspolicy och kommer att resultera i en överföring av data till tredje part och tredje länder, inklusive men inte begränsat till USA , Kanada, Australien och Egypten.",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. Upon completion of the work, NetCentric will also provide a compliance report. NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy.": "Dokumentsanering för överensstämmelse med WCAG 2.1 AA, Section 508, HHS eller PDF/UA tillgänglighetsstandarder görs av vårt dotterbolag, NetCentric Technologies, Inc. För åtgärdande kommer vi att samordna med NetCentric för att granska dokumentet och ge dig ett fast pris för sanering. Efter avslutat arbete kommer NetCentric också att tillhandahålla en efterlevnadsrapport. NetCentric kommer att meddela dig om det finns någon alternativ text (Alt-Text) som krävs för bilder som inte är självbeskrivande eller någon relaterad ytterligare information som behövs för att åtgärda dokumentet. Observera att alla avtal för åtgärdande är mellan dig, kunden och NetCentric och är föremål för NetCentrics villkor och sekretesspolicy.",
    "Japanese": "japanska",
    "Report Administration": "Rapportadministration",
    "Submit": "Överlämna",
    "You have [[domains]] domain(s) on your account": "Du har [[domains]] domän(er) på ditt konto",
    "Find domains by searching for the title or URL": "Hitta domäner genom att söka efter titeln eller webbadressen",
    "Industry average score": "Branschgenomsnittliga poäng",
    "Proceed to add one more check": "Fortsätt för att lägga till ytterligare en kontroll",
    "Readability test (for English pages only)": "Läsbarhetstest (endast för engelska sidor)",
    "Request quote for more pages": "Begär offert för fler sidor",
    "Request quote for more profiles": "Begär offert för fler profiler",
    "Search for domain": "Sök efter domän",
    "The user does not have access to view this domain and any reports associated with it": "Användaren har inte åtkomst att se den här domänen och eventuella rapporter kopplade till den",
    "Update all domain groups": "Uppdatera alla domängrupper",
    "Update domain group": "Uppdatera domängrupp",
    "Updating a group can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Att uppdatera en grupp kan ta mer än 30 minuter. Under operationen kommer du inte att kunna skapa och uppdatera grupper.",
    "WCAG 2.2 (Level A)": "WCAG 2.2 (nivå A)",
    "WCAG 2.2 (Level A) Mobile": "WCAG 2.2 (Nivå A) Mobil",
    "WCAG 2.2 (Level AA)": "WCAG 2.2 (nivå AA)",
    "WCAG 2.2 (Level AA) Mobile": "WCAG 2.2 (Level AA) Mobil",
    "WCAG 2.2 (Level AAA)": "WCAG 2.2 (nivå AAA)",
    "WCAG 2.2 (Level AAA) Mobile": "WCAG 2.2 (Level AAA) Mobil",
    "You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button \\\"Request quote for more pages\\\" and someone on our team will be in touch.": "Du har nått det maximala antalet prestationssidor i din nuvarande plan.<br/><br/>För att fråga om prisalternativ för ytterligare sidor, tryck på knappen \\\"Begär offert för fler sidor\\\" så kommer någon i vårt team vara i kontakt.",
    "You must perform a manual review of the page to confirm if this issue is present": "Du måste utföra en manuell granskning av sidan för att bekräfta om det här problemet är närvarande",
    "Accessibility Checklist (QUALWEB)": "Tillgänglighetschecklista (QUALWEB)",
    "Accessibility checks cannot be ignored for domain groups. To ignore this check you must do it for the entire domain.": "Tillgänglighetskontroller kan inte ignoreras för domängrupper. För att ignorera denna kontroll måste du göra den för hela domänen.",
    "Accessibility checks cannot be unignored for domain groups. To unignore this check you must do it for the entire domain.": "Tillgänglighetskontroller kan inte ignoreras för domängrupper. För att ignorera denna kontroll måste du göra den för hela domänen.",
    "Check your spelling or try a shorter query.": "Kontrollera din stavning eller försök med en kortare fråga.",
    "Guidelines for QUALWEB": "Riktlinjer för QUALWEB",
    "Language not supported": "Språket stöds inte",
    "No domains found.": "Inga domäner hittades.",
    "QUALWEB Accessibility Compliance": "QUALWEB tillgänglighetsefterlevnad",
    "QualWeb (Level A)": "QualWeb (nivå A)",
    "QualWeb (Level AA)": "QualWeb (nivå AA)",
    "Score could not be generated": "Poäng kunde inte genereras",
    "Searching <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>": "Söker <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>",
    "The language of the page is not recognized as English. The Flesch-Kincaid test only works for English language. Change to the LIX test if you wish to generate scores for non-English pages.": "Språket på sidan känns inte igen som engelska. Flesch-Kincaid-testet fungerar bara för engelska. Byt till LIX-testet om du vill generera poäng för icke-engelska sidor.",
    "We could not generate an accurate score for these pages. This is typically either due to the text on a page being too short, too long, or our web crawler not picking up any text at all.": "Vi kunde inte generera ett korrekt resultat för dessa sidor. Detta beror vanligtvis antingen på att texten på en sida är för kort, för lång eller att vår sökrobot inte tar upp någon text alls.",
    "Are you sure you want to add word [[word]] to all dictionaries": "Är du säker på att du vill lägga till ordet [[ord]] i alla ordböcker",
    "Are you sure you want to add word [[word]] to dictionary?": "Är du säker på att du vill lägga till ordet [[ord]] i ordboken?",
    "Are you sure you want to confirm the word [[word]] as misspelling?": "Är du säker på att du vill bekräfta ordet [[ord]] som felstavning?",
    "Are you sure you want to ignore the misspelling [[word]] for all languages?": "Är du säker på att du vill ignorera felstavningen [[word]] för alla språk?",
    "Are you sure you want to mark the misspelling [[word]] as fixed?": "Är du säker på att du vill markera felstavningen [[ord]] som åtgärdad?",
    "Cannot forward more": "Kan inte vidarebefordra mer",
    "Choose Date": "Välj Datum",
    "Compare": "Jämföra",
    "Confirmed errors only": "Endast bekräftade fel",
    "Exclude checks that require manual review": "Uteslut kontroller som kräver manuell granskning",
    "If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.": "Om det här alternativet är aktiverat innehåller domänskanningen endast tillgänglighetskontroller som automatiskt kan identifieras som fel. Kontroller som kräver manuell granskning är undantagna.",
    "One month back": "En månad sedan",
    "One month forward": "En månad framåt",
    "Press to choose the end day": "Tryck för att välja slutdagen",
    "Press to choose the start day": "Tryck för att välja startdag",
    "Remove compare range dates": "Ta bort jämför intervalldatum",
    "The date cannot be in the future.": "Datumet kan inte ligga i framtiden.",
    "Toggle the datepicker": "Växla datumväljaren",
    "Add Policy with AI": "Lägg till policy med AI",
    "Consolidated Reports": "Konsoliderade rapporter",
    "Created with AI policy assistant": "Skapad med AI-policyassistent",
    "Policy Assistant": "Policyassistent",
    "Sparkle icon": "Glitter-ikonen",
    "The Policy Assistant runs on Google Vertex AI, which can make mistakes.": "Policy Assistant körs på Google Vertex AI, vilket kan göra misstag.",
    "You have reached the maximum number of Performance profiles in your current plan.<br/><br/>To inquire about pricing options for additional profiles, please press the button \\\"Request quote for more profiles\\\" and someone on our team will be in touch.": "Du har nått det maximala antalet prestandaprofiler i ditt nuvarande abonnemang.<br/><br/>För att fråga om prisalternativ för ytterligare profiler, vänligen tryck på knappen \"Begär offert för fler profiler\" så kommer någon i vårt team att kontakta dig.",
    "You are about to perform a scan of <span class='text-link'>[[pageTitle]]</span> using the profile <span class='text-link'>[[profileName]]</span>.<br>The scan can take a few minutes to finalise, depending on the size of the page.<br><br>Do you want to continue?": "Du ska nu utföra en skanning av <span class='text-link'>[[pageTitle]]</span> med profilen <span class='text-link'>[[profileName]]</span>.<br>Skanningen kan ta några minuter att slutföra, beroende på sidans storlek.<br><br>Vill du fortsätta?",
    "Doesn't scan automatically": "Skannar inte automatiskt",
    "Scans automatically": "Skannar automatiskt",
    "with this": "med detta",
    "with this PDF": "med denna PDF",
    "with this archive file": "med den här arkivfilen",
    "with this slide": "med den här bilden",
    "with this spreadsheet": "med detta kalkylblad",
    "with this text file": "med den här textfilen",
    "Errors must be fixed for compliance.": "Fel måste åtgärdas för att uppfylla kraven.",
    "Issues to Fix": "Problem att åtgärda",
    "Issues to Review": "Problem att granska",
    "Reviews require manual judgement.": "Recensioner kräver manuell bedömning.",
    "Warnings are likely to be issues, but they require manual investigation.": "Varningar är sannolikt problem, men de kräver manuell undersökning.",
    "1 content": [
      "1 innehåll",
      "{{$count}} innehåll"
    ],
    "1 misspelling ignored across all domains": [
      "1 felstavning ignorerad på alla domäner",
      "{{$count}} felstavninger ignorerad på alla domäner"
    ],
    "1 new cookie on": [
      "1 ny kaka på",
      "{{$count}} nya kaka på "
    ],
    "1 page": [
      "1 sida",
      "{{$count}} sidor"
    ],
    "1 page with one or more failing checks {{guideline}}": [
      "1 sida med en eller flera misslyckade kontroller {{guideline}}",
      "{{$count}} sidor med en eller flera misslyckade kontroller {{guideline}}"
    ],
    "1 page with one or more ignored checks {{guideline}}": [
      "1 sida med en eller flera ignorerade kontroller {{guideline}}",
      "{{$count}} sidor med en eller flera ignorerade kontroller {{guideline}}"
    ],
    "1 policy found": [
      "1 policy hittades",
      "{{$count}} policies hittades"
    ],
    "1 results": [
      "1 resultat",
      "{{$count}} resultater"
    ],
    "1 visit": [
      "1 besök",
      "{{$count}} besök"
    ],
    "1 word added across all domains": [
      "1 ord tillagt för alla domäner",
      "{{$count}} ord tillagt för alla domäner"
    ],
    "One word found": [
      "Ett ord hittades",
      "{{$count}} ord hittades"
    ],
    "You have 1 user on your account": [
      "Du har 1 användare på ditt konto",
      "Du har {{$count}} användare på ditt konto"
    ],
    "Accessibility Compliance Scan": "Skanning av tillgänglighetsefterlevnad",
    "Broken Links on Sitemap": "Trasiga länkar på webbplatskartan",
    "Broken links on sitemap": "Trasiga länkar på webbplatskartan",
    "Close Spotlight Search.": "Stäng Spotlight-sökning.",
    "Requested": "Begärde",
    "Toggle Spotlight Search.": "Aktivera Spotlight-sökning.",
    "WCAG 2.2": "WCAG 2.2",
    "Newest": {
      "Exchange Center Sort by option": "Nyaste"
    },
    "(<strong><i>[[issues]]</i></strong> unique problems)": "(<strong><i>[[issues]]</i></strong> unika problem)",
    "(<strong>[[issues]]</strong> unique problems)": "(<strong>[[issues]]</strong> unika problem)",
    "<div class=\\\\'pull-left\\\\'>' + ('Heatmaps": "<div class=\\\\'pull-left\\\\'>' + ('Värmekartor",
    "<div class=\\\\'pull-left\\\\'>' + ('History Center": "<div class=\\\\'pull-left\\\\'>' + ('Historiskt centrum",
    "<p class='warning'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached the limit of the amount of profiles allowed on your account ([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan or archive some profiles before restoring this one.</p>": "<p class='warning'>Acquia Web Governance kan inte återställa profilen.</p><p>Du har nått gränsen för antalet profiler som är tillåtna på ditt konto ([[maxProfiles]] profiler). Kontakta vårt säljteam för att lägga till fler profiler i din plan eller arkivera några profiler innan du återställer den här.</p>",
    "<strong>' + (links.total | monNumber) + '</strong> ' + ('link": "<strong>' + (länkar.totalt | månadsnummer) + '</strong> ' + ('länk",
    "<strong>' + (pages.total | monNumber) + '</strong> ' + ('page": "<strong>' + (sidor.totalt | månadsnummer) + '</strong> ' + ('sida",
    "A \\\"skip to content\\\" link at the start of the webpage allows screen reader and keyboard-only users to skip over potentially non-relevant links at the start of your webpage and immediately access the main content.": "En länk för att \"hoppa till innehåll\" i början av webbsidan gör det möjligt för skärmläsare och tangentbordsanvändare att hoppa över potentiellt irrelevanta länkar i början av webbsidan och omedelbart komma åt huvudinnehållet.",
    "A cozy room with sofa, table and laptops that have Acquia Web Governance text": "Ett mysigt rum med soffa, bord och bärbara datorer med text om Acquia Web Governance",
    "About Acquia Web Governance": "Om Acquia Web Governance",
    "Accept Acquia Web Governance Privacy Terms": "Godkänn Acquias sekretessvillkor för webbstyrning",
    "Acquia Web Governance": "Acquia Web Governance",
    "Acquia Web Governance - Accessibility": "Acquia Web Governance - Tillgänglighet",
    "Acquia Web Governance - Accessibility Check List": "Acquia Web Governance - Tillgänglighetschecklista",
    "Acquia Web Governance - Accessibility Guidelines": "Acquia Web Governance - Tillgänglighetsriktlinjer",
    "Acquia Web Governance - Account Dictionary": "Acquia Web Governance - Kontoordlista",
    "Acquia Web Governance - Admin Page Performance Profiles": "Acquia Web Governance - Prestandaprofiler för administratörssida",
    "Acquia Web Governance - Audit Log": "Acquia Web Governance - Granskningslogg",
    "Acquia Web Governance - Broken Images": "Acquia Web Governance - Trasiga bilder",
    "Acquia Web Governance - Broken Links": "Acquia Web Governance - Trasiga länkar",
    "Acquia Web Governance - Content With Broken Links": "Acquia Web Governance - Innehåll med trasiga länkar",
    "Acquia Web Governance - Content With QA Errors": "Acquia Web Governance - Innehåll med QA-fel",
    "Acquia Web Governance - Cookie Acceptance Rate": "Acquia Web Governance - Acceptansgrad för cookies",
    "Acquia Web Governance - Cookie Consent Log": "Acquia Web Governance - Samtyckeslogg för cookies",
    "Acquia Web Governance - Cookie Overview": "Acquia Web Governance - Översikt över cookies",
    "Acquia Web Governance - Dashboard": "Acquia Web Governance - Instrumentpanel",
    "Acquia Web Governance - Data Privacy": "Acquia Web Governance - Dataskydd",
    "Acquia Web Governance - Data Privacy Check List": "Acquia Web Governance - Checklista för dataskydd",
    "Acquia Web Governance - Data Privacy Content": "Acquia Web Governance - Innehåll om dataskydd",
    "Acquia Web Governance - Data Privacy Guidelines": "Acquia Web Governance - Riktlinjer för dataskydd",
    "Acquia Web Governance - Data Privacy Issues": "Acquia Web Governance - Dataskyddsfrågor",
    "Acquia Web Governance - Data Privacy Summary": "Acquia Web Governance - Sammanfattning av dataskydd",
    "Acquia Web Governance - External PDF Compliance": "Acquia Web Governance - Extern PDF-efterlevnad",
    "Acquia Web Governance - Fast Track": "Acquia Web Governance - Snabbspår",
    "Acquia Web Governance - Heatmaps": "Acquia Web Governance - Värmekartor",
    "Acquia Web Governance - History Center": "Acquia Web Governance - Historiskt center",
    "Acquia Web Governance - Ignored Misspellings": "Acquia Web Governance - Ignorerade felstavningar",
    "Acquia Web Governance - Internal PDF Compliance": "Acquia Web Governance - Intern PDF-efterlevnad",
    "Acquia Web Governance - Labels": "Acquia Web Governance - Etiketter",
    "Acquia Web Governance - Misspellings": "Acquia Web Governance - Stavfel",
    "Acquia Web Governance - Page Performance Pages": "Acquia Web Governance - Sidor om sidprestanda",
    "Acquia Web Governance - PageCorrect": "Acquia Web Governance - PageCorrect",
    "Acquia Web Governance - PageCorrect Accessibility Fixes": "Acquia Web Governance - PageCorrect tillgänglighetsåtgärder",
    "Acquia Web Governance - PageCorrect Content": "Acquia Web Governance - Sidkorrigering av innehåll",
    "Acquia Web Governance - Pages With Failing Checks": "Acquia Web Governance - Sidor med misslyckade kontroller",
    "Acquia Web Governance - Pages With Ignored Checks": "Acquia Web Governance - Sidor med ignorerade kontroller",
    "Acquia Web Governance - Pages With Misspellings": "Acquia Web Governance - Sidor med felstavningar",
    "Acquia Web Governance - Pages With Opportunity": "Acquia Web Governance - Sidor med möjligheter",
    "Acquia Web Governance - Potential Misspellings": "Acquia Web Governance - Potentiella felstavningar",
    "Acquia Web Governance - Prioritized Content": "Acquia Web Governance - Prioriterat innehåll",
    "Acquia Web Governance - Quality Assurance": "Acquia Web Governance - Kvalitetssäkring",
    "Acquia Web Governance - Readability Checker": "Acquia Web Governance - Läsbarhetskontroll",
    "Acquia Web Governance - Readability Summary": "Acquia Web Governance - Läsbarhetssammanfattning",
    "Acquia Web Governance - SEO Checkpoints": "Acquia Web Governance - SEO-kontrollpunkter",
    "Acquia Web Governance - Search Engine Optimization": "Acquia Web Governance - Sökmotoroptimering",
    "Acquia Web Governance - Spellcheck Summary": "Acquia Web Governance - Sammanfattning av stavningskontroll",
    "Acquia Web Governance - User List": "Acquia Web Governance - Användarlista",
    "Acquia Web Governance Consent Manager": "Acquia Web Governance Consent Manager",
    "Acquia Web Governance Extension": "Acquia Web Governance-tillägg",
    "Acquia Web Governance PageAssist": "Acquia Web Governance PageAssist",
    "Acquia Web Governance users receiving this report": "Acquia Web Governance-användare som får denna rapport",
    "Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )": "Acquia Web Governance kommer automatiskt att upptäcka en nedladdning som ett klick på en länk som slutar med ett av följande filtillägg (observera att tilläggen är skiftlägeskänsliga)",
    "Add Acquia Web Governance Consent Manager": "Lägg till Acquia Web Governance Consent Manager",
    "Affects [[pageCount]] pages": "Påverkar [[pageCount]] sidor",
    "An error has occurred - please try again. If the error continues, please contact Acquia Web Governance": "Ett fel har uppstått – försök igen. Om felet kvarstår, vänligen kontakta Acquia Web Governance.",
    "An unexpected error occurred. Please try again.": "Ett oväntat fel uppstod. Försök igen.",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary for all languages?": "Är du säker på att du vill lägga till ordet <strong>' + ord + '</strong> i ordboken för alla språk?",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary?": "Är du säker på att du vill lägga till ordet <strong>' + ord + '</strong> i ordboken?",
    "Are you sure you want to confirm the misspelling <strong>' + word + '</strong>?": "Är du säker på att du vill bekräfta felstavningen <strong>' + ord + '</strong>?",
    "Are you sure you want to remove the Profile <strong>[[profileName]]</strong>?": "Är du säker på att du vill ta bort profilen <strong>[[profileName]]</strong>?",
    "Are you sure you want to undo review this document as reviewed?": "Är du säker på att du vill ångra granskningen av det här dokumentet som granskat?",
    "Calculate Readability Score": "Beräkna läsbarhetspoäng",
    "Calculate score to see results": "Beräkna poäng för att se resultat",
    "Calculate the readability score of any text (based on [[testName]])": "Beräkna läsbarhetspoängen för valfri text (baserat på [[testName]])",
    "Can\\\\'t delete label": "Kan inte ta bort etiketten",
    "Change your &lt;b&gt; tags into something else": "Ändra dina &lt;b&gt;-taggar till något annat",
    "Choose your own text for the Skip to Content link button<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>": "Välj din egen text för länkknappen Hoppa till innehåll<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Ge en titel till din Hoppa till innehåll-knapp' | translate }}\\\"></span>",
    "Clear search in the domain picker": "Rensa sökningen i domänväljaren",
    "Click here to contact Acquia Web Governance sales department to increase your maximum page count.": "Klicka här för att kontakta Acquias försäljningsavdelning för Web Governance för att öka ert maximala antal sidor.",
    "Confirmed misspelling": "Bekräftad felstavning",
    "Copyright 2020 Acquia Web Governance. All rights reserved.": "Upphovsrätt 2020 Acquia Web Governance. Alla rättigheter förbehållna.",
    "Couldn't find any domains": "Kunde inte hitta några domäner",
    "Crawled Pages ([[pageCount]])": "Genomsökta sidor ([[pageCount]])",
    "Description*": "Beskrivning*",
    "Domain favicon for": "Domänfavicon för",
    "Domain groups": "Domängrupper",
    "Domains that have never been scanned": "Domäner som aldrig har skannats",
    "Domains that were not scanned in the selected date range": "Domäner som inte skannades inom det valda datumintervallet",
    "Edit this policy rule later under the \\\"Add rule to policy\\\" tab.": "Redigera denna policyregel senare under fliken \"Lägg till regel i policy\".",
    "Enable if you want to use Acquia Web Governance in Accessibility mode": "Aktivera om du vill använda Acquia Web Governance i tillgänglighetsläge",
    "Export visitors screen resolutions": "Exportera besökares skärmupplösningar",
    "For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.": "För närvarande kommer Acquia Web Governance Pagecorrect att lägga till en popup-varning till varje extern länk, så att dina besökare själva kan välja om de vill navigera bort från den ursprungliga sidan.",
    "Found 1 audit log on your account": "Hittade 1 granskningslogg på ditt konto",
    "Found [[count]] audit logs on your account": "Hittade [[count]] granskningsloggar på ditt konto",
    "From March 1, 2022, Acquia Web Governance will no longer be supporting any version of Internet Explorer or Edge browser version 78 or below. While you will still be able to log on and use Acquia Web Governance with Internet Explorer and older versions of Edge, we are no longer testing releases and fixing bugs specifically for those browsers. We encourage you to switch to another browser such as Chrome or newer version of Edge to be sure that Acquia Optimize continues to work optimally on your device.": "Från och med den 1 mars 2022 kommer Acquia Web Governance inte längre att stödja någon version av Internet Explorer eller Edge-webbläsare version 78 eller tidigare. Även om du fortfarande kommer att kunna logga in och använda Acquia Web Governance med Internet Explorer och äldre versioner av Edge, testar vi inte längre versioner och åtgärdar buggar specifikt för dessa webbläsare. Vi uppmuntrar dig att byta till en annan webbläsare som Chrome eller en nyare version av Edge för att vara säker på att Acquia Optimize fortsätter att fungera optimalt på din enhet.",
    "Get the Acquia Web Governance Extension": "Hämta Acquia Web Governance-tillägget",
    "Go to the policy dashboard of the domain [[title]]": "Gå till policyöversikten för domänen [[title]]",
    "Images missing alt attribute": "Bilder saknar alt-attribut",
    "Insert the CSS selector targets you want your visitors to land on<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>": "Infoga de CSS-selektormål som du vill att dina besökare ska landa på<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Se till att du använder korrekt formatering och lägg till flera selektorer när din siddesign skiljer sig åt' | translate }}\\\"></span>",
    "Internet Explorer &amp; Edge v.78 (or below) no longer supported": "Internet Explorer och Edge v.78 (eller tidigare) stöds inte längre",
    "Italics are often used in HTML to put emphasis on text. However, this is often achieved with the &lt;I&gt; tag, in which case the emphasis is not announced by screen readers. Using the &lt;I&gt; tag doesn't provide enough context and is becoming an outdated practice.": "Kursiv stil används ofta i HTML för att betona text. Detta uppnås dock ofta med taggen &lt;I&gt;, i vilket fall betoningen inte meddelas av skärmläsare. Att använda taggen &lt;I&gt; ger inte tillräckligt med sammanhang och håller på att bli en föråldrad praxis.",
    "Last 8 Performance Scans Scores": "Poäng från de senaste 8 prestationsskanningarna",
    "Latest manual scan finished on [[scannedAt]]": "Senaste manuella skanningen slutfördes den [[scannedAt]]",
    "Mark this issue as fixed": "Markera det här problemet som åtgärdat",
    "Monitor how visitors interact with your pages. Acquia Web Governance tracks up to a maximum of 1000 heatmaps sessions per page per month.": "Övervaka hur besökare interagerar med dina sidor. Acquia Web Governance spårar upp till maximalt 1000 värmekartsessioner per sida och månad.",
    "No downloads were found. Try searching for the document URL instead of the document title.": "Inga nedladdningar hittades. Försök att söka efter dokumentets URL istället för dokumentets titel.",
    "No more PDF accessibility scans are available for this account. Please contact a Acquia Web Governance sales department to add more.": "Inga fler PDF-tillgänglighetsskanningar finns tillgängliga för det här kontot. Kontakta en Acquia Web Governance-försäljningsavdelning för att lägga till fler.",
    "Not valid URL": "Ogiltig URL",
    "PageCorrect failed to save, the Acquia Web Governance team has been notified of the error": "PageCorrect kunde inte sparas. Acquia Web Governance-teamet har meddelats om felet.",
    "Pages Without Visits": "Sidor utan besök",
    "Part of success criteria [[issueNumber]]": "Del av framgångskriterierna [[issueNumber]]",
    "Pick any link on your website which you know opens in a new page (social media icons are usually a safe bet) and try to navigate away from the page you are on. If the pop-up doesn't appear it might be because the script has not been applied yet. Give it some time.": "Välj en länk på din webbplats som du vet öppnas på en ny sida (ikoner för sociala medier är oftast ett säkert kort) och försök att navigera bort från sidan du är på. Om popup-fönstret inte visas kan det bero på att skriptet inte har tillämpats än. Ge det lite tid.",
    "Policy Scan is no longer valid. Press Run Policy to update Policy Scan details": "Policysökning är inte längre giltig. Tryck på Kör policy för att uppdatera informationen om policysökning.",
    "Readability Checker": "Läsbarhetskontroll",
    "Readability Level": "Läsbarhetsnivå",
    "Readability Summary": "Läsbarhetssammanfattning",
    "Remove word from Ignored Misspellings": "Ta bort ord från Ignorerade felstavningar",
    "Remove word from dictionary": "Ta bort ord från ordlistan",
    "Request Remediation from selection": "Begär åtgärd från valet",
    "Request failed. Please ensure you have added only text in the input field.": "Begäran misslyckades. Se till att du bara har lagt till text i inmatningsfältet.",
    "Scan stopped successfully": "Skanningen har stoppats",
    "Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan": "Schemalägg rapporter för dig själv [[adminText]] via e-post efter varje Acquia Web Governance-skanning",
    "Search for content that*": "Sök efter innehåll som*",
    "Something went wrong. The Acquia Web Governance Team has been notified of this error and will get back to you, as soon as possible.": "Något gick fel. Acquias webbstyrningsteam har meddelats om detta fel och återkommer till dig så snart som möjligt.",
    "Start Cookie Scan": "Starta cookieskanning",
    "Start Scan": "Starta skanning",
    "Start a new scan to find cookies or add them manually": "Starta en ny skanning för att hitta cookies eller lägg till dem manuellt",
    "Stop scan": "Stoppa skanningen",
    "Switch to Acquia Web Governance classic": "Växla till Acquia Web Governance klassiska version",
    "Test your website's compliance levels ([[level]]) and fix issues that are making it difficult for people with disabilities to use your website": "Testa din webbplats efterlevnadsnivåer ([[level]]) och åtgärda problem som gör det svårt för personer med funktionsnedsättningar att använda din webbplats.",
    "The Acquia Web Governance team is notified and are working on the issue.": "Acquias webbstyrningsteam har informerats och arbetar med problemet.",
    "The Compound Export contains data from the first and last scans within the selected date range. The export does not include data from the following sources:": "Den sammansatta exporten innehåller data från den första och sista skanningen inom det valda datumintervallet. Exporten inkluderar inte data från följande källor:",
    "The profile has been archived.": "Profilen har arkiverats.",
    "The profile has been restored.": "Profilen har återställts.",
    "There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.": "Det finns bara ett sätt att göra detta. Acquia Web Governance kommer att ersätta alla <I>-taggar som den kan hitta på din webbplats med em-taggar istället.",
    "Type in or paste text to be analyzed": "Skriv in eller klistra in text som ska analyseras",
    "URL &amp; Title": "URL och titel",
    "Unignore Misspelling": "Avregistrera felstavningar",
    "Url &amp; Title": "URL och titel",
    "Visitors screen resolutions export": "Export av besökares skärmupplösningar",
    "Weight in score: [[weight]]": "Vikt i poäng: [[weight]]",
    "Why can't I open a new window without warning?": "Varför kan jag inte öppna ett nytt fönster utan förvarning?",
    "Why do I need a \\\"skip to content\\\" link?": "Varför behöver jag en länk för att \"hoppa till innehåll\"?",
    "Why shouldn't I use the marquee element?": "Varför ska jag inte använda marquee-elementet?",
    "You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here": "Du använder den nya versionen av Acquia Web Governance PageAssist. Om du vill återgå till v.1.0 klickar du här.",
    "You can only calculate a score for up to [[count]] characters.": "Du kan bara beräkna en poäng för upp till [[count]] tecken.",
    "You do not have sufficient permissions to use this feature.": "Du har inte tillräckliga behörigheter för att använda den här funktionen.",
    "Your current plan does not include on-demand scans. Please reach out to your Acquia Web Governance representative to learn more about this option": "Din nuvarande plan inkluderar inte skanningar på begäran. Kontakta din Acquia Web Governance-representant för att få veta mer om det här alternativet.",
    "[[$count]] found": "[[$count]] hittades",
    "[[count]] found": "[[count]] funna",
    "[[headerCount]] found": "[[headerCount]] hittades",
    "[[pageIssues]] Pages <span>([[errorPercentage]]%)</span> to fix": "[[pageIssues]] Sidor <span>([[errorPercentage]]%)</span> att åtgärda",
    "[[pageIssues]] Pages to fix": "[[pageIssues]] Sidor att åtgärda",
    "[[pagesDone]] Pages ([[compliancePercentage]]) in compliance": "[[pagesDone]] Sidor ([[compliancePercentage]]) i överensstämmelse",
    "[[totalPageIssues]] Pages ([[compliancePercentage]]) to fix": "[[totalPageIssues]] Sidor ([[compliancePercentage]]) att åtgärda",
    "failed when trying to ignore/review all. please try agin, or contact the Acquia Web Governance team": "Misslyckades vid försök att ignorera/granska alla. Försök igen eller kontakta Acquia Web Governance-teamet.",
    "policies": "policyer",
    "policy": "politik",
    "Start export PDF Accessibility Report": "Börja exportera PDF Accessibility Report",
    "No data showing? Add the Acquia Web Governance script to your website": "Visas ingen statistik? Lägg till Acquia Web Governance-skriptet på webbplatsen."
  },
  "pt": {
    "Search": {
      "Spotlight": "Procurar",
      "$$noContext": "Procurar"
    },
    "Global Policy Overview": {
      "Topmenu": "Visão geral da política global",
      "$$noContext": "Visão geral da política global"
    },
    "History Center": {
      "Topmenu": "Centro de História",
      "$$noContext": "Centro de História"
    },
    "Report Center": {
      "Topmenu": "Central de Relatórios",
      "$$noContext": "Central de Relatórios"
    },
    "Users": {
      "Topmenu": "Usuários",
      "$$noContext": "Usuários"
    },
    "No content was found": {
      "page-details -> Inventory -> links. No result message": "Nenhum conteúdo foi encontrado.",
      "$$noContext": "Nenhum conteúdo foi encontrado."
    },
    "&nbsp;&nbsp;&nbsp;Passwords does not match": "As senhas não coincidem.",
    "(HTML and documents)": "(HTML e documentos)",
    "(No title found)": "(Nenhum título encontrado)",
    "(The HTML snippet is now Marked as Reviewed/Ignored)": "(O trecho de HTML agora está marcado como revisado/ignorado)",
    "(This policy is marked as unwanted content)": "(Esta política foi marcada como conteúdo indesejado)",
    "+ Add new check": "+ Adicionar novo cheque",
    "+ Add new user": "+ Adicionar novo usuário",
    "1 min.": "1 min.",
    "1 minute": "1 minuto",
    "10 min.": "10 min.",
    "10th to 12th grade": "do 10º ao 12º ano",
    "120 min.": "120 min.",
    "15 min.": "15 min.",
    "1st": "1º",
    "2nd": "2º",
    "30 min.": "30 min.",
    "3rd": "3º",
    "5 min.": "5 min.",
    "5 minutes": "5 minutos",
    "5th grade": "5º ano",
    "60 min.": "60 min.",
    "6th grade": "6º ano",
    "7th grade": "7º ano",
    "8th to 9th grade": "8º para 9º ano",
    "A": "UM",
    "A list of all external PDF files already reviewed for accessibility issues": "Lista de todos os arquivos PDF externos já analisados ​​quanto a problemas de acessibilidade.",
    "A list of all external PDF files that you need to check for accessibility issues": "Uma lista de todos os arquivos PDF externos que você precisa verificar quanto a problemas de acessibilidade.",
    "A list of all internal PDF files already reviewed for accessibility issues": "Lista de todos os arquivos PDF internos já revisados ​​quanto a problemas de acessibilidade.",
    "A list of all internal PDF files that have been marked as failed for accessibility issues": "Uma lista de todos os arquivos PDF internos que foram marcados como falhos devido a problemas de acessibilidade.",
    "A list of all internal PDF files that have been marked as queued for accessibility issues": "Uma lista de todos os arquivos PDF internos que foram marcados como em fila para resolução de problemas de acessibilidade.",
    "A list of all internal PDF files that you need to check for accessibility issues": "Uma lista de todos os arquivos PDF internos que você precisa verificar quanto a problemas de acessibilidade.",
    "AA": "AA",
    "AAA": "AAA",
    "ACCESSIBILITY OVERVIEW": "VISÃO GERAL DE ACESSIBILIDADE",
    "API Token": "Token da API",
    "API URL": "URL da API",
    "API User": "Usuário da API",
    "API User Details": "Detalhes do usuário da API",
    "API Users": "Usuários da API",
    "About": "Sobre",
    "Accept": "Aceitar",
    "Accessibility": "Acessibilidade",
    "Accessibility Check": "Verificação de acessibilidade",
    "Accessibility Diagnostics": "Diagnóstico de Acessibilidade",
    "Accessibility Fast Track": "Via Rápida de Acessibilidade",
    "Accessibility Icon": "Ícone de acessibilidade",
    "Accessibility Snippet": "Trecho de acessibilidade",
    "Accessibility Source Code": "Código-fonte de acessibilidade",
    "Accessibility checks compliance by level": "Verificações de acessibilidade: conformidade por nível",
    "Accessibility checks not in compliance with domain": "Verificações de acessibilidade não estão em conformidade com o domínio.",
    "Accessibility error type": "Tipo de erro de acessibilidade",
    "Accessibility errors": "Erros de acessibilidade",
    "Accessibility fixes": "Correções de acessibilidade",
    "Accessibility help center": "Central de ajuda de acessibilidade",
    "Accessibility issues": "Problemas de acessibilidade",
    "Accessibility level": "Nível de acessibilidade",
    "Accessibility mode": "Modo de acessibilidade",
    "Accessibility review type": "Tipo de revisão de acessibilidade",
    "Account dictionary": "Dicionário de contas",
    "Action": "Ação",
    "Actions": "Ações",
    "Actions per visit": "Ações por visita",
    "Active": "Ativo",
    "Add": "Adicionar",
    "Add Custom Multistep Javascript": "Adicionar JavaScript personalizado de várias etapas",
    "Add Extension Name": "Adicionar nome de extensão",
    "Add Heatmap rule to a Page": "Adicionar regra de mapa de calor a uma página",
    "Add Heatmaps": "Adicionar mapas de calor",
    "Add PageAssist script": "Adicionar script PageAssist",
    "Add PageCorrect": "Adicionar páginaCorrigir",
    "Add Profile": "Adicionar perfil",
    "Add Rule": "Adicionar regra",
    "Add Skip to PageAssist": "Adicionar &quot;Pular&quot; ao PageAssist",
    "Add a new exemption to your heartbeat check": "Adicione uma nova exceção à sua verificação de batimentos cardíacos.",
    "Add a new page to start tracking individual pages' performance. Get an overview of load times and opportunities to speed up your site.": "Adicione uma nova página para começar a monitorar o desempenho de páginas individuais. Obtenha uma visão geral dos tempos de carregamento e oportunidades para acelerar seu site.",
    "Add a non-user email": "Adicionar um e-mail que não seja de usuário",
    "Add another rule": "Adicionar outra regra",
    "Add email": "Adicionar e-mail",
    "Add exemption": "Adicionar isenção",
    "Add new check": "Adicionar novo cheque",
    "Add new domain": "Adicionar novo domínio",
    "Add new exemption": "Adicionar nova isenção",
    "Add new label": "Adicionar novo rótulo",
    "Add new page": "Adicionar nova página",
    "Add new policy": "Adicionar nova política",
    "Add new user": "Adicionar novo usuário",
    "Add non users": "Adicionar usuários não autorizados",
    "Add reason (Optional)": "Adicionar motivo (Opcional)",
    "Add rule to policy": "Adicionar regra à política",
    "Add rule to the policy": "Adicionar regra à política",
    "Add task": "Adicionar tarefa",
    "Add timeslots where you won't receive notifications on downtime and slow responsetimes.": "Adicione períodos de tempo em que você não receberá notificações sobre indisponibilidade e lentidão no tempo de resposta.",
    "Add to all languages": "Adicionar a todos os idiomas",
    "Add to dictionary": "Adicionar ao dicionário",
    "Add to dictionary for all languages": "Adicionar ao dicionário para todos os idiomas",
    "Added": "Adicionado",
    "Added by": "Adicionado por",
    "Added date": "Data de adição",
    "Address": "Endereço",
    "Admin": "Administrador",
    "Advanced Domain Options": "Opções avançadas de domínio",
    "Affected image": "Imagem afetada",
    "Affected pages": "Páginas afetadas",
    "Affected pages by priority": "Páginas afetadas por prioridade",
    "Affected pages by severity": "Páginas afetadas por gravidade",
    "Affects": "Afeta",
    "After": "Depois",
    "All": "Todos",
    "All Failed Internal PDF files": "Todos os arquivos PDF internos com falha",
    "All Pending External PDF files": "Todos os arquivos PDF externos pendentes",
    "All Pending Internal PDF files": "Todos os arquivos PDF internos pendentes",
    "All Queued Internal PDF files": "Todos os arquivos PDF internos enfileirados",
    "All Reviewed External PDF files": "Todos os arquivos PDF externos analisados",
    "All Reviewed Internal PDF files": "Todos os arquivos PDF internos revisados",
    "All assets": "Todos os ativos",
    "All broken images": "Todas as imagens quebradas",
    "All broken links": "Todos os links quebrados",
    "All heartbeat checkpoints": "Todos os pontos de verificação de batimentos cardíacos",
    "All incident checkpoints in the selected time span": "Todos os pontos de verificação de incidentes no período de tempo selecionado",
    "All level A accessibility checks": "Todas as verificações de acessibilidade de nível A",
    "All level AA accessibility checks": "Todas as verificações de acessibilidade de nível AA",
    "All level AAA accessibility checks": "Todas as verificações de acessibilidade de nível AAA",
    "All levels": "Todos os níveis",
    "All modules": "Todos os módulos",
    "All modules - Content with Issues": "Todos os módulos - Conteúdo com problemas",
    "All notifications": "Todas as notificações",
    "All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.": "Basta inserir o script abaixo na tag BODY do seu site. É só copiar e colar exatamente como está.",
    "Analytics (Last 7 days)": "Análise (Últimos 7 dias)",
    "And": "E",
    "Appears on": "Aparece em",
    "Apply": "Aplicar",
    "Archive": "Arquivo",
    "Archive files": "Arquivos de arquivamento",
    "Archived": "Arquivado",
    "Are you sure you want to Mark this link as unignored?": "Tem certeza de que deseja marcar este link como não ignorado?",
    "Are you sure you want to Request All PDF Accessibility checks?": "Tem certeza de que deseja solicitar todas as verificações de acessibilidade de PDF?",
    "Are you sure you want to add to Request PDF Accessibility check from selection?": "Tem certeza de que deseja adicionar esta opção à lista &quot;Solicitar verificação de acessibilidade de PDF&quot;?",
    "Are you sure you want to add to all the dictionaries?": "Tem certeza de que deseja adicionar conteúdo a todos os dicionários?",
    "Are you sure you want to add to the dictionary?": "Tem certeza de que deseja adicionar algo ao dicionário?",
    "Are you sure you want to close this form without saving your changes?": "Tem certeza de que deseja fechar este formulário sem salvar as alterações?",
    "Are you sure you want to confirm this misspelling?": "Tem certeza de que deseja confirmar esse erro ortográfico?",
    "Are you sure you want to delete the API User [[apiUserId]]": "Tem certeza de que deseja excluir o usuário da API [[apiUserId]]?",
    "Are you sure you want to delete this exemption?": "Tem certeza de que deseja excluir essa isenção?",
    "Are you sure you want to delete this source exclude?": "Tem certeza de que deseja excluir esta origem?",
    "Are you sure you want to ignore all errors for this check?": "Tem certeza de que deseja ignorar todos os erros nesta verificação?",
    "Are you sure you want to ignore the selected issue on this page?": "Tem certeza de que deseja ignorar o problema selecionado nesta página?",
    "Are you sure you want to ignore this check for this domain?": "Tem certeza de que deseja ignorar esta verificação para este domínio?",
    "Are you sure you want to ignore this check for this page?": "Tem certeza de que deseja ignorar esta verificação para esta página?",
    "Are you sure you want to ignore this issue?": "Tem certeza de que deseja ignorar este problema?",
    "Are you sure you want to ignore this misspelling?": "Tem certeza de que deseja ignorar esse erro ortográfico?",
    "Are you sure you want to mark this issue as fixed?": "Tem certeza de que deseja marcar este problema como resolvido?",
    "Are you sure you want to mark this issue as not fixed?": "Tem certeza de que deseja marcar este problema como não resolvido?",
    "Are you sure you want to mark this link as fixed?": "Tem certeza de que deseja marcar este link como fixo?",
    "Are you sure you want to mark this link as ignored?": "Tem certeza de que deseja marcar este link como ignorado?",
    "Are you sure you want to mark this link as not fixed?": "Tem certeza de que deseja marcar este link como não corrigido?",
    "Are you sure you want to remove manually added user?": "Tem certeza de que deseja remover o usuário adicionado manualmente?",
    "Are you sure you want to remove review for this issue?": "Tem certeza de que deseja remover a avaliação deste problema?",
    "Are you sure you want to remove review on all errors for this check?": "Tem certeza de que deseja remover a revisão de todos os erros para esta verificação?",
    "Are you sure you want to remove this group?": "Tem certeza de que deseja remover este grupo?",
    "Are you sure you want to remove this host?": "Tem certeza de que deseja remover este host?",
    "Are you sure you want to remove this rule?": "Tem certeza de que deseja remover esta regra?",
    "Are you sure you want to remove this?": "Tem certeza de que deseja remover isso?",
    "Are you sure you want to review all errors for this check?": "Tem certeza de que deseja revisar todos os erros desta verificação?",
    "Are you sure you want to review this issue?": "Tem certeza de que deseja analisar este problema?",
    "Are you sure you want to set this document as reviewed?": "Tem certeza de que deseja marcar este documento como revisado?",
    "Are you sure you want to start on-demand scan?": "Tem certeza de que deseja iniciar a digitalização sob demanda?",
    "Are you sure you want to stop current crawl?": "Tem certeza de que deseja interromper a navegação atual?",
    "Are you sure you want to the request ADA clarification for [[name]]?": "Tem certeza de que deseja solicitar esclarecimentos sobre a ADA para [[name]]?",
    "Are you sure you want to undo review of this document?": "Tem certeza de que deseja desfazer a revisão deste documento?",
    "Are you sure you want to undo reviewing this document?": "Tem certeza de que deseja desfazer a revisão deste documento?",
    "Are you sure you want to unignore all errors for this check?": "Tem certeza de que deseja deixar de ignorar todos os erros para esta verificação?",
    "Are you sure you want to unignore the selected issue on this page?": "Tem certeza de que deseja deixar de ignorar o problema selecionado nesta página?",
    "Are you sure you want to unignore this check for this domain?": "Tem certeza de que deseja desativar essa verificação para este domínio?",
    "Are you sure you want to unignore this check for this page?": "Tem certeza de que deseja ativar novamente esta verificação para esta página?",
    "Are you sure you want to unignore this issue?": "Tem certeza de que deseja deixar de ignorar este problema?",
    "Are you sure you want to unignore this link?": "Tem certeza de que deseja deixar de ignorar este link?",
    "Are you sure you want to unignore this misspelling?": "Tem certeza de que deseja corrigir esse erro ortográfico?",
    "Are you sure you want to unpin this domain": "Tem certeza de que deseja desfixar este domínio?",
    "Are you sure you want unignore this link?": "Tem certeza de que deseja deixar de ignorar este link?",
    "Assign Heatmap Rule": "Atribuir regra de mapa de calor",
    "Assign to the Performance Module": "Atribuir ao Módulo de Desempenho",
    "Attribute": "Atributo",
    "Audit": "Auditoria",
    "Audit Log": "Registro de auditoria",
    "Autoselect": "Seleção automática",
    "Average First Contentful Paint": "Média Primeira Tinta Contentante",
    "Average First Meaningful Paint": "Média da primeira pintura significativa",
    "Average Performance Score": "Pontuação média de desempenho",
    "Average Performance score": "Pontuação de desempenho médio",
    "Average Time to Interactive": "Tempo médio até a interação",
    "Average response time": "Tempo médio de resposta",
    "Average time": "Tempo médio",
    "Average uptime": "Tempo médio de atividade",
    "Average visit time": "Tempo médio de visita",
    "Avg. Performance Score": "Pontuação média de desempenho",
    "Avg. Visit Time": "Tempo médio de visita",
    "Avg. response": "Resposta média",
    "BETA": "BETA",
    "Back": "Voltar",
    "Back to Heartbeat Overview": "Voltar à Visão Geral dos Batimentos Cardíacos",
    "Bar": "Bar",
    "Basic Auth": "Autenticação básica",
    "Before": "Antes",
    "Below 5th grade": "Abaixo do 5º ano",
    "Below you can see a list of all pages that contains the title": "Abaixo você pode ver uma lista de todas as páginas que contêm o título.",
    "Book online training": "Inscreva-se no treinamento online",
    "Bounce Rates": "Taxas de rejeição",
    "Bounce rate": "Taxa de rejeição",
    "Bounce rates": "Taxas de rejeição",
    "Brand name": "Nome da marca",
    "Broken Image": "Imagem quebrada",
    "Broken Image Links per page": "Links de imagens quebrados por página",
    "Broken Images": "Imagens quebradas",
    "Broken Links": "Links quebrados",
    "Broken Page Link": "Link da página quebrado",
    "Broken image affecting most content": "Imagem corrompida afetando a maior parte do conteúdo.",
    "Broken image affecting most pages": "Imagem corrompida afetando a maioria das páginas.",
    "Broken images": "Imagens quebradas",
    "Broken images with page count": "Imagens quebradas com contagem de páginas",
    "Broken link": "Link quebrado",
    "Broken link affecting most content": "Link quebrado afetando a maior parte do conteúdo.",
    "Broken link affecting most pages": "Link quebrado afetando a maioria das páginas",
    "Broken links": "Links quebrados",
    "Broken links per page": "Links quebrados por página",
    "Broken links with page count": "Links quebrados com contagem de páginas",
    "Browser": "Navegador",
    "Browser Extension": "Extensão do navegador",
    "Browsers": "Navegadores",
    "Browsers Overview": "Visão geral dos navegadores",
    "Bubble": "Bolha",
    "Build it from scratch": "Construa do zero.",
    "By deleting this domain all domain groups related to this domain, will also be deleted": "Ao excluir este domínio, todos os grupos de domínios relacionados a ele também serão excluídos.",
    "By user": "Por usuário",
    "CMS": "CMS",
    "CMS url": "URL do CMS",
    "CSS": "CSS",
    "CSS Target Selector": "Seletor de destino CSS",
    "CSS id or class selector to search for": "Seletor CSS de ID ou classe para pesquisar",
    "CSS selector to find submit button": "Seletor CSS para encontrar o botão de envio",
    "Cache TTL": "TTL do cache",
    "Cancel": "Cancelar",
    "Case sensitive": "Maiúsculas e minúsculas",
    "Categories": "Categorias",
    "Category": "Categoria",
    "Change password": "Alterar a senha",
    "Changed to": "Alterado para",
    "Changes": "Mudanças",
    "Changes added": "Alterações adicionadas",
    "Changes in selected time frame:": "Alterações no período de tempo selecionado:",
    "Changes since Previous Crawl": "Alterações desde a última verificação",
    "Changes since previous crawl": "Alterações desde a última verificação",
    "Characters": "Personagens",
    "Chart": "Gráfico",
    "Chart is now showing: [[name]]": "O gráfico agora exibe: [[name]]",
    "Check": "Verificar",
    "Check List Export": "Exportar lista de verificação",
    "Check all links in this section": "Confira todos os links nesta seção.",
    "Check all misspellings in this section": "Verifique todos os erros ortográficos nesta seção.",
    "Check all modules": "Verifique todos os módulos",
    "Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)": "Verifique e corrija problemas de conteúdo em todo o seu site (por exemplo, erros ortográficos, links quebrados, legibilidade e outros problemas).",
    "Check frequency": "Verifique a frequência",
    "Check frequency:": "Verificar a frequência:",
    "Check is ignored": "A verificação foi ignorada.",
    "Check is ignored for the entire domain": "A verificação é ignorada para todo o domínio.",
    "Check link": "Confira o link",
    "Check misspelling": "Verifique erros de ortografia",
    "Check name": "Verifique o nome",
    "Check off as Reviewed": "Marque como revisado.",
    "Check passed": "Verificação aprovada",
    "Check site status": "Verificar o status do site",
    "Checking": "Verificando",
    "Checkpoint exemptions": "Isenções de postos de controle",
    "Checkpoint has been updated.": "O ponto de verificação foi atualizado.",
    "Checkpoint information": "Informações do ponto de controle",
    "Checkpoint:": "Ponto de verificação:",
    "Checks": "Cheques",
    "Checks passed": "Verificações aprovadas",
    "Checks whether your website is responding and measures the response time of the server": "Verifica se o seu site está respondendo e mede o tempo de resposta do servidor.",
    "Choose Operator": "Selecione a operadora",
    "Choose What to Scan": "Escolha o que digitalizar",
    "Choose a response time": "Escolha um tempo de resposta",
    "Choose a response time notification": "Escolha um tempo de resposta para as notificações.",
    "Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned": "Escolha uma lei de dados existente para ser o modelo padrão da sua verificação de segurança. Edite as configurações abaixo para excluir determinadas tags da verificação.",
    "Choose checks": "Escolha cheques",
    "Choose domains": "Escolha domínios",
    "Choose how to view the Heatmaps Dashboard": "Escolha como visualizar o painel de mapas de calor.",
    "Choose notification time": "Escolha o horário da notificação",
    "Choose the minimum amount of words to scan for readability on a page": "Escolha a quantidade mínima de palavras a serem verificadas quanto à legibilidade em uma página.",
    "Choose where the policy should apply": "Escolha onde a política deve ser aplicada.",
    "Chrome extension": "Extensão do Chrome",
    "City": "Cidade",
    "Clear all labels": "Limpar todos os rótulos",
    "Clear and close filters": "Limpar e fechar filtros",
    "Click here to create your first policy": "Clique aqui para criar sua primeira apólice.",
    "Click here to edit": "Clique aqui para editar",
    "Click to create your first policy": "Clique para criar sua primeira apólice.",
    "Clone": "Clone",
    "Close": "Fechar",
    "Close filters": "Fechar filtros",
    "Collapse": "Colapso",
    "Collapse menu": "Recolher menu",
    "College": "Faculdade",
    "College graduate": "graduado universitário",
    "Coming soon": "Em breve",
    "Comment": "Comentário",
    "Common policy violations": "Violações comuns de políticas",
    "Company Info": "Informações da empresa",
    "Compliance": "Conformidade",
    "Compliance {{compliancePercentage}}": "Conformidade {{compliancePercentage}}",
    "Compound Export": "Exportação composta",
    "Compound Report": "Relatório Composto",
    "Confirm": "Confirmar",
    "Confirm as misspelling": "Confirmar erro de ortografia",
    "Confirm misspelling": "Confirmar erro de ortografia",
    "Confirm this word as a misspelling": "Confirme se esta palavra está escrita incorretamente.",
    "Confirmed": "Confirmado",
    "Confirmed misspellings": "Erros ortográficos confirmados",
    "Congratulations no violations were found": "Parabéns, nenhuma violação foi encontrada.",
    "Connection Profile": "Perfil de conexão",
    "Connections per minute": "Conexões por minuto",
    "Constraint": "Restrição",
    "Constraint pattern": "Padrão de restrição",
    "Contact me about more Performance Pages": "Entre em contato comigo para obter mais informações sobre Páginas de Desempenho.",
    "Contact me about more performance profiles": "Entre em contato comigo para obter mais informações sobre perfis de desempenho.",
    "Containing": "Contendo",
    "Contains": "Contém",
    "Contains confirmed misspellings, broken links & images": "Contém erros ortográficos confirmados, links quebrados e imagens.",
    "Contains confirmed misspellings, broken links or images": "Contém erros ortográficos confirmados, links quebrados ou imagens.",
    "Contains high, medium & low opportunities for all pages": "Contém oportunidades de alto, médio e baixo nível para todas as páginas.",
    "Contains high, medium & low severity issues for all pages": "Contém problemas de alta, média e baixa gravidade em todas as páginas.",
    "Contains issues with high, medium and low priority for all pages": "Contém problemas com prioridade alta, média e baixa para todas as páginas.",
    "Content": "Contente",
    "Content Links": "Links de conteúdo",
    "Content Policies": "Políticas de conteúdo",
    "Content Policy Violations": "Violações da Política de Conteúdo",
    "Content in compliance": "Conteúdo em conformidade",
    "Content must be robust enough that it can be interpreted reliably by a wide variety of user agents, including assistive technologies.": "O conteúdo deve ser suficientemente robusto para que possa ser interpretado de forma confiável por uma ampla variedade de agentes de usuário, incluindo tecnologias assistivas.",
    "Content policies": "Políticas de conteúdo",
    "Content with Broken Image": "Conteúdo com imagem quebrada",
    "Content with Broken Link": "Conteúdo com link quebrado",
    "Content with Broken Links": "Conteúdo com links quebrados",
    "Content with Data Issues": "Conteúdo com problemas de dados",
    "Content with Data Issues export": "Exportar conteúdo com problemas de dados",
    "Content with Policy Matches": "Conteúdo com correspondência de políticas",
    "Content with QA Errors": "Conteúdo com erros de controle de qualidade",
    "Content with broken links": "Conteúdo com links quebrados",
    "Content with issues": "Conteúdo com problemas",
    "Content with policy violations": "Conteúdo com violações de política",
    "Content with violations": "Conteúdo com violações",
    "Context": "Contexto",
    "Country": "País",
    "Crawl Automatically": "Rastejar automaticamente",
    "Crawl Options": "Opções de rastreamento",
    "Crawl done on": "Rastejar concluído em",
    "Crawl finalized on": "Crawl finalizado em",
    "Crawl info": "Informações sobre rastreamento",
    "Crawl runtime:": "Tempo de execução do Crawl:",
    "Crawl started:": "A rastejamento começou:",
    "Crawl status": "Status de rastreamento",
    "Crawl status:": "Estado do rastreamento:",
    "Crawled Documents ([[documentCount]])": "Documentos rastreados ([[documentCount]])",
    "Crawled at": "Rastejou em",
    "Crawled pages": "Páginas rastreadas",
    "Crawling": "Rastejando",
    "Create a policy to make an email as unwanted content": "Crie uma política para marcar um e-mail como conteúdo indesejado.",
    "Create as policy": "Criar como política",
    "Create label": "Criar etiqueta",
    "Create new domain group": "Criar novo grupo de domínio",
    "Create new group": "Criar novo grupo",
    "Create user": "Criar usuário",
    "Create your own policy": "Crie sua própria política",
    "Created": "Criado",
    "Created At": "Criado em",
    "Created at": "Criado em",
    "Created date": "Data de criação",
    "Created:": "Criado:",
    "Current domain status": "Estado atual do domínio",
    "Current status": "Situação atual",
    "Custom": "Personalizado",
    "Custom Multistep": "Personalizado em várias etapas",
    "Custom Profile": "Perfil personalizado",
    "Custom fixes": "Correções personalizadas",
    "Custom rule": "Regra personalizada",
    "Customer": "Cliente",
    "Customer Report": "Relatório do cliente",
    "DATA PRIVACY OVERVIEW": "VISÃO GERAL DA PRIVACIDADE DE DADOS",
    "DISCLAIMER": "ISENÇÃO DE RESPONSABILIDADE",
    "Daily": "Diário",
    "Danish": "dinamarquês",
    "Dark": "Escuro",
    "Dashboard": "Painel",
    "Data Issues": "Problemas com dados",
    "Data Privacy": "Privacidade de dados",
    "Data Privacy Diagnostics": "Diagnóstico de Privacidade de Dados",
    "Data Privacy Fast Track": "Via Rápida para a Privacidade de Dados",
    "Data Privacy Help Center": "Central de Ajuda sobre Privacidade de Dados",
    "Data Privacy Info Type Icon": "Ícone de tipo de informação sobre privacidade de dados",
    "Data Privacy Issues": "Questões de privacidade de dados",
    "Data Privacy Summary Export": "Exportar resumo da privacidade de dados",
    "Data Privacy issues found": "Foram identificados problemas de privacidade de dados.",
    "Data Regulations": "Regulamentos de dados",
    "Data Violations": "Violações de dados",
    "Data issues": "Problemas com dados",
    "Data issues export": "Exportação de dados com problemas",
    "Data privacy": "Privacidade de dados",
    "Data privacy violations": "Violações de privacidade de dados",
    "Data protection and privacy policy statement": "Declaração de política de proteção de dados e privacidade",
    "Date": "Data",
    "Day": "Dia",
    "Days": "Dias",
    "Dead": "Morto",
    "Default": "Padrão",
    "Default for CMS": "Padrão para CMS",
    "Default value*": "Valor padrão*",
    "Define meta headers to match": "Defina os cabeçalhos meta para corresponder",
    "Define size of files to look for": "Defina o tamanho dos arquivos a serem procurados.",
    "Define size of images to look for": "Defina o tamanho das imagens que deseja procurar.",
    "Delete": "Excluir",
    "Delete All": "Excluir tudo",
    "Delete user": "Excluir usuário",
    "Describe the exclude": "Descreva a exclusão.",
    "Description": "Descrição",
    "Desktop": "Área de trabalho",
    "Details": "Detalhes",
    "Device": "Dispositivo",
    "Device Overview": "Visão geral do dispositivo",
    "Device not found": "Dispositivo não encontrado",
    "Device:": "Dispositivo:",
    "Devices": "Dispositivos",
    "Diagnostics": "Diagnóstico",
    "Dictionary": "Dicionário",
    "Difficulty": "Dificuldade",
    "Direct visits": "Visitas diretas",
    "Disabling": "Desativar",
    "Display policy in other services": "Exibir política em outros serviços",
    "Display this policy as:": "Exibir esta política da seguinte forma:",
    "Distribution of Data Privacy levels": "Distribuição dos níveis de privacidade de dados",
    "Distribution of PageCorrects across all change types": "Distribuição de correções de página em todos os tipos de alteração",
    "Distribution of SEO levels": "Distribuição dos níveis de SEO",
    "Distribution of policies that match their corresponding setting": "Distribuição de políticas que correspondem ao seu respectivo contexto.",
    "Distribution of policies that matches their corresponding setting": "Distribuição de políticas que corresponda ao seu respectivo contexto.",
    "Do you want the policy to run every time your website is crawled?": "Deseja que a política seja executada sempre que seu site for rastreado?",
    "Do you want to find pages which match the query on one or multiple lines?": "Deseja encontrar páginas que correspondam à consulta em uma ou várias linhas?",
    "Do you want to find pages which match the query or pages which does not match the query": "Você deseja encontrar páginas que correspondam à consulta ou páginas que não correspondam à consulta?",
    "Do you want to update the Script Settings, for this Domain?": "Deseja atualizar as configurações de script para este domínio?",
    "Document": "Documento",
    "Document Class": "Classe de documento",
    "Document Dashboard": "Painel de Documentos",
    "Document Details": "Detalhes do documento",
    "Document Extension": "Extensão do documento",
    "Document Ignore Class": "Documento Ignorar Classe",
    "Document first detected": "Documento detectado pela primeira vez",
    "Document scan": "Digitalização de documentos",
    "Documents": "Documentos",
    "Documents Crawled": "Documentos rastreados",
    "Documents basic": "Documentos básicos",
    "Documents crawled": "Documentos rastreados",
    "Documents extended": "Documentos ampliados",
    "Documents with Broken Image": "Documentos com imagem corrompida",
    "Documents with Broken Link": "Documentos com links quebrados",
    "Domain": "Domínio",
    "Domain Compliance": "Conformidade de domínio",
    "Domain Data Privacy Settings": "Configurações de privacidade de dados de domínio",
    "Domain Detail": "Detalhes do domínio",
    "Domain Details": "Detalhes do domínio",
    "Domain Groups": "Grupos de Domínio",
    "Domain Picker Closed": "Seletor de domínio fechado",
    "Domain Picker Opened": "Seletor de domínio aberto",
    "Domain compliance": "Conformidade com o domínio",
    "Domain group": "Grupo de domínio",
    "Domain title and URL": "Título do domínio e URL",
    "Domain:": "Domínio:",
    "Domains": "Domínios",
    "Domains/groups selected": "Domínios/grupos selecionados",
    "Done": "Feito",
    "Download": "Download",
    "Download the Chrome extension": "Baixe a extensão do Chrome",
    "Download the Edge add-on": "Baixe o complemento Edge.",
    "Download the Firefox add-on": "Baixe o complemento para Firefox.",
    "Downloads": "Downloads",
    "Downtime": "Tempo de inatividade",
    "Downtime (Minutes)": "Tempo de inatividade (minutos)",
    "Downtime notification": "Notificação de tempo de inatividade",
    "Drag and drop the rule to add rules to the policy": "Arraste e solte a regra para adicionar regras à política.",
    "Dropdown": "Suspenso",
    "Duration": "Duração",
    "Easy": "Fácil",
    "Easy to read pages understood by most. Example: fiction literature for adults": "Páginas de fácil leitura, compreendidas pela maioria. Exemplo: literatura de ficção para adultos.",
    "Edge add-on": "Complemento Edge",
    "Edit": "Editar",
    "Edit Labels": "Editar rótulos",
    "Edit Performance Page": "Editar página de desempenho",
    "Edit customer information": "Editar informações do cliente",
    "Edit domain": "Editar domínio",
    "Edit domain group": "Editar grupo de domínio",
    "Edit exemption": "Isenção de edição",
    "Edit label": "Editar rótulo",
    "Edit labels": "Editar rótulos",
    "Edit my profile": "Editar meu perfil",
    "Edit or Delete PageCorrect": "Editar ou Excluir PáginaCorrigir",
    "Edit uptime": "Editar tempo de atividade",
    "Edit user": "Editar usuário",
    "Edit users": "Editar usuários",
    "Edit your exemption": "Edite sua isenção.",
    "Edit:": "Editar:",
    "Effect on compliance": "Efeito sobre a conformidade",
    "Effect on overall compliance level": "Efeito no nível geral de conformidade",
    "Element": "Elemento",
    "Element Tree Path": "Caminho da árvore de elementos",
    "Email": "E-mail",
    "Email Notifications": "Notificações por e-mail",
    "Email addresses": "Endereços de e-mail",
    "Email receiver *": "Destinatário de e-mail *",
    "Email to login": "E-mail para login",
    "Emails": "E-mails",
    "Empty": "Vazio",
    "Empty mailto": "Mailto vazio",
    "Enable / Disable Accessibility mode": "Ativar/Desativar o modo de acessibilidade",
    "Enable Document Tracking": "Ativar o rastreamento de documentos",
    "Enable Export Email Notification": "Ativar notificação de exportação por e-mail",
    "Enable Statistics": "Ativar estatísticas",
    "Enabled features": "Recursos ativados",
    "Enabling": "Habilitar",
    "End at": "Terminar em",
    "End date": "Data de término",
    "End time": "Hora final",
    "English": "Inglês",
    "Enter the full URL": "Insira o URL completo",
    "Entries": "Inscrições",
    "Entry": "Entrada",
    "Entry Pages": "Páginas de entrada",
    "Entry and Exit Pages": "Páginas de entrada e saída",
    "Error": "Erro",
    "Error Name": "Nome do erro",
    "Errors": "Erros",
    "Errors ([[audits]])": "Erros ([[auditorias]])",
    "Exact": "Exato",
    "Example: academic publications": "Exemplo: publicações acadêmicas",
    "Example: children's literature": "Exemplo: literatura infantil",
    "Example: daily newspapers": "Exemplo: jornais diários",
    "Example: fiction books": "Exemplo: livros de ficção",
    "Example: legal texts": "Exemplo: textos legais",
    "Examples": "Exemplos",
    "Excel Documents": "Documentos do Excel",
    "Exclude": "Excluir",
    "Exclude links that contains class name": "Excluir links que contenham o nome da turma.",
    "Exclude pattern": "Excluir padrão",
    "Excluded IP addresses from statistics": "Endereços IP excluídos das estatísticas",
    "Exemption": "Isenção",
    "Exemption options": "Opções de isenção",
    "Exemption time": "Período de isenção",
    "Exemptions": "Isenções",
    "Exit Pages": "Páginas de saída",
    "Exits": "Saídas",
    "Expand": "Expandir",
    "Explain the rationale behind the policy and which actions, editors should take to correct the violation": "Explique a lógica por trás da política e quais ações os editores devem tomar para corrigir a violação.",
    "Export": "Exportar",
    "Export CSV": "Exportar CSV",
    "Export Compound CSV": "Exportar composto CSV",
    "Export Logs": "Exportar registros",
    "Export list of broken images organized by page and document title": "Exportar lista de imagens corrompidas organizadas por página e título do documento.",
    "Export list of broken links organized by page and document title": "Exportar lista de links quebrados organizados por página e título do documento",
    "Export list of downtimes for the domain": "Exportar lista de períodos de inatividade para o domínio",
    "Export list of response times": "Exportar lista de tempos de resposta",
    "External": "Externo",
    "External Export": "Exportação externa",
    "External PDF Compliance": "Conformidade com PDFs externos",
    "External PDFs": "PDFs externos",
    "External Referring Domains": "Domínios de referência externos",
    "External Referring domains": "Domínios de referência externos",
    "External referees overview": "Visão geral dos árbitros externos",
    "External referring domains": "Domínios de referência externos",
    "FCP": "FCP",
    "FMP": "FMP",
    "Facebook": "Facebook",
    "Fail Example": "Exemplo de falha",
    "Failed": "Fracassado",
    "Failing accessibility checks": "Falha nas verificações de acessibilidade",
    "Failing accessibility checks gives you information about the current Accessibility status of the website/group. It may vary from the history if there have been changes in ignored and review of accessibility issues": "A falha nos testes de acessibilidade fornece informações sobre o status atual de acessibilidade do site/grupo. Esse status pode variar em relação ao histórico, caso tenham ocorrido alterações nos problemas de acessibilidade ignorados ou revisados.",
    "Failing check": "Verificação reprovada",
    "Failing check found": "Verificação com falha detectada",
    "Failing checks": "Verificações reprovadas",
    "Failing checks found": "Verificações com falha encontradas",
    "Fast Track": "Via Rápida",
    "Fast track html snippet": "trecho de HTML de acesso rápido",
    "Faster": "Mais rápido",
    "Features": "Características",
    "Feedback submitted": "Feedback enviado",
    "File size": "Tamanho do arquivo",
    "Filter": "Filtro",
    "Filter by": "Filtrar por",
    "Filter by:": "Filtrar por:",
    "Filter labels list": "Lista de rótulos de filtro",
    "Find and address violations relating to your content guides and regulatory compliance and find outdated content across your website.": "Identifique e corrija violações relacionadas aos seus guias de conteúdo e conformidade regulatória, e encontre conteúdo desatualizado em todo o seu site.",
    "Find word(s) without specific context": "Encontre a(s) palavra(s) sem contexto específico.",
    "Firefox add-on": "Complemento do Firefox",
    "First Contentful Paint": "Primeira Pintura Satisfeita",
    "First Meaningful Paint": "Primeira pintura significativa",
    "First name": "Primeiro nome",
    "Fixed": "Fixo",
    "Fixed or ignored violations": "violações corrigidas ou ignoradas",
    "Flesch Kincaid": "Flesch Kincaid",
    "For this domain": "Para este domínio",
    "Form": "Forma",
    "Form fields": "Campos do formulário",
    "Forms": "Formulários",
    "Found": "Encontrado",
    "Four times a day": "Quatro vezes ao dia",
    "Frames": "Molduras",
    "Friday": "Sexta-feira",
    "From 2 seconds to 8 seconds": "De 2 segundos a 8 segundos",
    "Generating report": "Gerando relatório",
    "Get advice on how to handle this check": "Obtenha aconselhamento sobre como lidar com este cheque.",
    "Getting {{ logs }} out of {{totalLogs}} logs": "Obtendo {{ logs }} de {{totalLogs}} logs",
    "Global - All Domains": "Global - Todos os Domínios",
    "Global Policies": "Políticas Globais",
    "Global Policy Dashboard": "Painel de Políticas Globais",
    "Global Policy List": "Lista de Políticas Globais",
    "Go to Global Policy List": "Acesse a Lista de Políticas Globais",
    "Go to My Exports": "Acesse Minhas Exportações",
    "Go to PDFs": "Acesse os PDFs",
    "Go to Policy List": "Acesse a lista de políticas.",
    "Go to broken Links": "Acesse os links quebrados",
    "Go to broken images": "Acesse as imagens quebradas",
    "Go to broken links": "Acesse os links quebrados",
    "Go to checkpoints": "Vá para os pontos de controle.",
    "Go to data issues": "Acesse a seção de problemas de dados.",
    "Go to domain": "Acesse o domínio",
    "Go to help center": "Acesse a central de ajuda.",
    "Go to mispellings": "Acesse a seção de erros ortográficos.",
    "Go to misspellings": "Acesse a seção de erros ortográficos.",
    "Go to most visits pages": "Acesse as páginas com mais visitas.",
    "Go to page": "Acesse a página",
    "Go to page details": "Acesse os detalhes da página.",
    "Go to potential misspellings": "Acesse possíveis erros ortográficos",
    "Go to predefined url": "Acesse o URL predefinido",
    "Go to the dashboard": "Acesse o painel de controle.",
    "Go to traffic sources overview": "Acesse a visão geral das fontes de tráfego.",
    "Go to uptime": "Acesse o tempo de atividade",
    "Go to visitor overview": "Acesse a visão geral do visitante.",
    "Good job! No incidents was registered": "Ótimo trabalho! Nenhum incidente foi registrado.",
    "Good job! No issues were found": "Ótimo trabalho! Nenhum problema foi encontrado.",
    "Good job! No violations were found": "Ótimo trabalho! Nenhuma violação foi encontrada.",
    "Google": "Google",
    "Greater than 8 seconds": "Mais de 8 segundos",
    "Grid View": "Visualização em grade",
    "Groups": "Grupos",
    "Guidelines": "Diretrizes",
    "Guidelines for WCAG 2.0": "Diretrizes para WCAG 2.0",
    "Guidelines for WCAG 2.1": "Diretrizes para WCAG 2.1",
    "H1 on this page": "H1 nesta página",
    "HTML": "HTML",
    "HTML Pages": "Páginas HTML",
    "HTML pages": "Páginas HTML",
    "HTML snippet": "trecho de HTML",
    "HTML snippet affecting compliance level": "Trecho de HTML que afeta o nível de conformidade",
    "HTML snippet failing check": "O trecho de HTML falhou na verificação.",
    "Hard": "Duro",
    "Hard to read text. Example: popular science magazines and easier academic publications": "Texto de difícil leitura. Exemplo: revistas de divulgação científica e publicações acadêmicas mais acessíveis.",
    "Harmony CMS": "Harmony CMS",
    "Header type": "Tipo de cabeçalho",
    "Headers": "Cabeçalhos",
    "Headlinks": "Links de cabeçalho",
    "Heartbeat": "Batimento cardíaco",
    "Heartbeat Downtime": "Tempo de inatividade dos batimentos cardíacos",
    "Heartbeat Response Time": "Tempo de resposta do batimento cardíaco",
    "Heartbeat status saved": "Status do batimento cardíaco salvo",
    "Heatmaps": {
      "$$noContext": "Mapas de calor",
      "Topmenu": "Mapas de calor"
    },
    "Help Center": "Central de Ajuda",
    "Help center": "Central de ajuda",
    "High": "Alto",
    "High impact": "Alto impacto",
    "High impact opportunities": "Oportunidades de alto impacto",
    "High priority": "Alta prioridade",
    "High severity": "Alta gravidade",
    "High severity issues": "problemas de alta gravidade",
    "Highest level of readability. Example: complex academic and legal texts": "Nível máximo de legibilidade. Exemplo: textos acadêmicos e jurídicos complexos.",
    "History": "História",
    "Hit": "Bater",
    "Hits": "Sucessos",
    "Hits across all domains and modules": "Acessos em todos os domínios e módulos",
    "Hits on domain": "Acessos ao domínio",
    "Home": "Lar",
    "Host": "Hospedar",
    "Hosts": "Anfitriões",
    "Hosts cannot be empty": "Os hosts não podem estar vazios.",
    "Hours": "Horas",
    "How often the page is checked": "Com que frequência a página é verificada?",
    "How to fix this problem": "Como resolver este problema",
    "How to prevent": "Como prevenir",
    "How to setup this policy": "Como configurar esta política",
    "IFrames": "IFrames",
    "IP address": "endereço IP",
    "Icon": "Ícone",
    "Icon status": "Status do ícone",
    "Identifier": "Identificador",
    "Ignore": "Ignorar",
    "Ignore check": "Ignorar verificação",
    "Ignore misspelling": "Ignore os erros de ortografia.",
    "Ignore on the page": "Ignorar na página",
    "Ignore on this page": "Ignorar esta página",
    "Ignore this SEO issue": "Ignore este problema de SEO",
    "Ignore this check": "Ignore esta verificação",
    "Ignore this check for this domain": "Ignore esta verificação para este domínio.",
    "Ignored": "Ignorado",
    "Ignored Misspellings": "Erros ortográficos ignorados",
    "Ignored Policies": "Políticas ignoradas",
    "Ignored checks": "Verificações ignoradas",
    "Ignored issue": "Problema ignorado",
    "Ignored policies": "Políticas ignoradas",
    "Ignoring broken link": "Ignorando link quebrado",
    "Image": "Imagem",
    "Image Links": "Links para imagens",
    "Image sources that will be fixed": "Fontes de imagem que serão corrigidas",
    "Images": "Imagens",
    "Import rules": "Regras de importação",
    "Import rules from CSV": "Importar regras de arquivo CSV",
    "Important Highlights": "Principais destaques",
    "Important Notifications": "Avisos importantes",
    "Important notification:": "Aviso importante:",
    "In compliance": "Em conformidade",
    "In progress of ignoring/reviewing all": "Em processo de ignorar/revisar tudo",
    "Inactive": "Inativo",
    "Incidents": "Incidentes",
    "Includes both documents and pages": "Inclui documentos e páginas.",
    "Incoming Links": "Links de entrada",
    "Incoming links": "Links de entrada",
    "Indicates the difficulty to fix an audit error": "Indica a dificuldade em corrigir um erro de auditoria.",
    "Indicates when some parts of the domain are not scanned due to Constraints / Exclusions being applied": "Indica quando algumas partes do domínio não são verificadas devido à aplicação de restrições/exclusões.",
    "Individual issues": "questões individuais",
    "Information": "Informação",
    "Information about this Check is not yet available": "As informações sobre esta verificação ainda não estão disponíveis.",
    "Information and the operation of user interface must be understandable.": "As informações e o funcionamento da interface do usuário devem ser compreensíveis.",
    "Information and user interface components must be presentable to users in ways they can perceive.": "As informações e os componentes da interface do usuário devem ser apresentados aos usuários de maneiras que eles possam perceber.",
    "Inline Images": "Imagens embutidas",
    "Inline images": "Imagens embutidas",
    "Input selector*": "Seletor de entrada*",
    "Input user data": "Dados de entrada do usuário",
    "Internal": "Interno",
    "Internal Export": "Exportação interna",
    "Internal PDF Compliance": "Conformidade interna com PDFs",
    "Internal PDFs": "PDFs internos",
    "Internal URLs": "URLs internas",
    "Inventory": "Inventário",
    "Inventory Documents Export": "Exportação de documentos de inventário",
    "Inventory History": "Histórico de inventário",
    "Invite to new project": "Convite para um novo projeto",
    "Is not a valid url": "Não é uma URL válida.",
    "Is not crawling automatically": "Não está rastreando automaticamente",
    "Is not tagged": "Não está etiquetado",
    "Issue": "Emitir",
    "Issue changes": "Alterações no problema",
    "Issue changes since previous crawl": "Alterações no problema desde a última verificação.",
    "Issue name": "Nome do problema",
    "Issue type": "Tipo de problema",
    "Issues": "Problemas",
    "Issues by Severities": "Problemas por Gravidade",
    "Issues changes since previous crawl": "Alterações nos problemas desde a última verificação.",
    "JS": "JS",
    "JavaScript": "JavaScript",
    "Javascript": "JavaScript",
    "Javascript crawl": "Rastreamento em Javascript",
    "KB": "KB",
    "Keyword": "Palavra-chave",
    "Knowledge Base": {
      "$$noContext": "Base de conhecimento",
      "Topmenu": "Base de conhecimento"
    },
    "LIX": "LIX",
    "Label": "Rótulo",
    "Label created": "Etiqueta criada",
    "Label name": "Nome da etiqueta",
    "Label overlay": "Sobreposição de rótulo",
    "Label preview": "Pré-visualização do rótulo",
    "Label updated": "Etiqueta atualizada",
    "Labels": "Etiquetas",
    "Language": "Linguagem",
    "Language Detected": "Idioma detectado",
    "Languages": "Línguas",
    "Languages found": "Idiomas encontrados",
    "Last Scan": "Última verificação",
    "Last check: [[lastCheckTime]]": "Última verificação: [[lastCheckTime]]",
    "Last check: [[performanceScannedAt]]": "Última verificação: [[performanceScannedAt]]",
    "Last downtime:": "Última inatividade:",
    "Last load time": "Última hora de carregamento",
    "Last name": "Sobrenome",
    "Last run": "Última corrida",
    "Last run [[date]]": "Última execução [[date]]",
    "Last run:": "Última execução:",
    "Last scan": "Última verificação",
    "Last scan never": "Última digitalização nunca",
    "Last scan: [[duration]] ago": "Última verificação: há [[duration]] anos",
    "Latest Updated PageCorrects": "Última atualização da páginaCorrige",
    "Latest login": "Último login",
    "Least Popular Pages": "Páginas menos populares",
    "Less than 10": "Menos de 10",
    "Less than 100": "Menos de 100",
    "Less than 2 seconds": "Menos de 2 segundos",
    "Less than 50": "Menos de 50",
    "Level": "Nível",
    "Level A": "Nível A",
    "Level A Issues": "Questões de nível A",
    "Level A accessibility checks": "Verificações de acessibilidade de nível A",
    "Level A compliance": "Conformidade de nível A",
    "Level A failing checks": "Verificações de nível A reprovadas",
    "Level AA": "Nível AA",
    "Level AA Issues": "Questões de nível AA",
    "Level AA accessibility checks": "Verificações de acessibilidade de nível AA",
    "Level AA compliance": "Conformidade de nível AA",
    "Level AA failing checks": "Nível AA reprovando nas verificações",
    "Level AAA": "Nível AAA",
    "Level AAA Issues": "Problemas de nível AAA",
    "Level AAA accessibility checks": "Verificações de acessibilidade de nível AAA",
    "Level AAA compliance": "Conformidade de nível AAA",
    "Level AAA failing checks": "Verificações de nível AAA reprovadas",
    "Level [[level]]": "Nível [[level]]",
    "Levels": "Níveis",
    "Likelihood": "Probabilidade",
    "Likelihood unspecified": "Probabilidade não especificada",
    "Link": "Link",
    "Link Type": "Tipo de link",
    "Link excludes": "O link exclui",
    "Link fixes": "Correções de links",
    "Link is broken": "O link está quebrado.",
    "Link of page": "Link da página",
    "Link to image": "Link para a imagem",
    "Linkedin": "LinkedIn",
    "Links": "Links",
    "Links To Documents Export": "Links para Exportar Documentos",
    "Links from other account domains": "Links de outros domínios de conta",
    "Links from own domain": "Links do próprio domínio",
    "Links with policy matches": "Ligações com correspondências de políticas",
    "Links with the rel=\\\"nofollow\\\" attribute will not pass link equity/SEO value to the linked page. This can be used for pages with user generated comments where you want to avoid that a competitor posts a comment with a link to their own website thus benefiting from your original content. This is not an \\\"error\\\" per se but make sure that the link does not have this attribute as a result of an error.": "Links com o atributo rel=&quot;nofollow&quot; não transferem autoridade de link/valor de SEO para a página vinculada. Isso pode ser útil em páginas com comentários gerados por usuários, onde você deseja evitar que um concorrente publique um comentário com um link para o próprio site, beneficiando-se assim do seu conteúdo original. Isso não é um &quot;erro&quot; em si, mas certifique-se de que o link não tenha esse atributo como resultado de um erro.",
    "List": "Lista",
    "List of accessibility issues": "Lista de problemas de acessibilidade",
    "List of all labels": "Lista de todos os rótulos",
    "List of checks with and without issues": "Lista de cheques com e sem problemas",
    "List of content containing links": "Lista de conteúdo contendo links",
    "List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)": "Lista de onde estão localizados todos os seus recursos no site (ex.: Documentação, links, endereços de e-mail, trechos de código, etc.)",
    "List view": "Visualização em lista",
    "Lists all profiles available for your account": "Lista todos os perfis disponíveis para sua conta.",
    "Load Times Trend": "Tendência dos tempos de carregamento",
    "Loading domains, please wait": "Carregando domínios, aguarde",
    "Loading new domain": "Carregando novo domínio",
    "Loading times": "Tempos de carregamento",
    "Locale": "Localidade",
    "Location": "Localização",
    "Location not found": "Localização não encontrada",
    "Locations": "Locais",
    "Log out": "Sair",
    "Login Type": "Tipo de login",
    "Long": "Longo",
    "Lookup in Google": "Pesquisar no Google",
    "Low": "Baixo",
    "Low impact": "Baixo impacto",
    "Low impact opportunities": "Oportunidades de baixo impacto",
    "Low priority": "Baixa prioridade",
    "Low severity": "Baixa gravidade",
    "Low severity issues": "Problemas de baixa gravidade",
    "MB": "MB",
    "META content": "Conteúdo META",
    "META name/property": "Nome/propriedade META",
    "Main-Thread Blocking Time": "Tempo de bloqueio da thread principal",
    "Mark 403 as broken link": "Marque 403 como link quebrado",
    "Mark all as reviewed/ignored": "Marcar tudo como revisado/ignorado",
    "Mark as fixed": "Marcar como resolvido",
    "Mark as ignored": "Marcar como ignorado",
    "Mark as not fixed": "Marcar como não corrigido",
    "Marked as fixed": "Marcado como resolvido",
    "Marked as reviewed": "Marcado como revisado",
    "Marking broken link as fixed": "Marcando o link quebrado como corrigido.",
    "Match": "Corresponder",
    "Match rule": "Regra de partida",
    "Matches": "Partidas",
    "Max": "Máximo",
    "Max scanned pages": "Páginas digitalizadas máximas",
    "Measure from": "Medida de",
    "Measure from:": "Meça a partir de:",
    "Measurement Settings": "Configurações de medição",
    "Measurements since [[date]]": "Medições desde [[date]]",
    "Medium": "Médio",
    "Medium complexity of text. Example: newspapers and magazines": "Complexidade média do texto. Exemplo: jornais e revistas.",
    "Medium impact": "Impacto médio",
    "Medium impact opportunities": "Oportunidades de impacto médio",
    "Medium priority": "Prioridade média",
    "Medium severity": "Gravidade média",
    "Medium severity issues": "problemas de gravidade média",
    "Meta Header Expr": "Expressão do cabeçalho Meta",
    "Meta Name": "Nome Meta",
    "Metadata": "Metadados",
    "Metadata key": "Chave de metadados",
    "Milliseconds": "Milissegundos",
    "Minimum words": "Palavras mínimas",
    "Minutes": "Minutos",
    "Minutes of slow response before you get an email": "Minutos de demora na resposta antes de você receber um e-mail.",
    "Mispelling": "Erro ortográfico",
    "Misspelling": "Erro ortográfico",
    "Misspelling affecting the most content": "Erros ortográficos que afetam a maior parte do conteúdo",
    "Misspellings": "Erros ortográficos",
    "Misspellings history": "Histórico de erros ortográficos",
    "Mobile": "Móvel",
    "Moderate": "Moderado",
    "Module": "Módulo",
    "Monday": "Segunda-feira",
    "Monitoring": "Monitoramento",
    "Monthly": "Mensal",
    "Months": "Meses",
    "More info": "Mais informações",
    "More than": "Mais do que",
    "More than [[count]]": "Mais de [[count]]",
    "Most Downloads": "Maior número de downloads",
    "Most Frequent": "Mais frequentes",
    "Most Popular Pages": "Páginas mais populares",
    "Most common SEO checkpoint needing review": "Pontos de verificação de SEO mais comuns que precisam de revisão",
    "Most common language": "Língua mais comum",
    "Most common misspellings": "Erros ortográficos mais comuns",
    "Most common opportunities found": "Oportunidades mais comuns encontradas",
    "Most common policy violation on this domain": "Violação de política mais comum neste domínio",
    "Most common potential misspellings": "Erros ortográficos mais comuns",
    "Most common readability level": "Nível de legibilidade mais comum",
    "Most of your pages have the readability level": "A maioria das suas páginas tem o nível de legibilidade adequado.",
    "Most pages have this readability level": "A maioria das páginas possui esse nível de legibilidade.",
    "Most prominent issues ranked by severity level": "Principais problemas classificados por nível de gravidade",
    "Most serious issues found": "Problemas mais graves encontrados",
    "Most visited pages": "Páginas mais visitadas",
    "Move focus down on domain picker": "Desloque o foco para baixo no seletor de domínio.",
    "Move focus up on domain picker": "Aumente o foco no seletor de domínio.",
    "Multiline": "Multilinhas",
    "My Exports": "Minhas exportações",
    "My profile": "Meu perfil",
    "N/A": "N / D",
    "NA": "N / D",
    "NB! Connection Settings cannot be edited after save": "Atenção! As configurações de conexão não podem ser editadas após serem salvas.",
    "NOTE: If you want to copy the Legacy Script. Click {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}here{{anchorEnd}}.": "NOTA: Se você quiser copiar o script legado, clique em {{anchorStart}} role=\\&quot;button\\&quot; ng-click=\\&quot;vm.openLegacy()\\&quot; {{gt}}aqui{{anchorEnd}}.",
    "Name": {
      "$$noContext": "Nome",
      "Exchange Center Sort by option": "Nome"
    },
    "Network not found": "Rede não encontrada",
    "Network speed": "Velocidade da rede",
    "Network speed:": "Velocidade da rede:",
    "Never": "Nunca",
    "Never scanned": "Nunca escaneado",
    "New": "Novo",
    "New Performance Page": "Nova página de desempenho",
    "New Policy": "Nova Política",
    "New password": "Nova Senha",
    "Next": "Próximo",
    "No Broken Links marked as Fixed": "Nenhum link quebrado marcado como corrigido.",
    "No CSS": "Sem CSS",
    "No Content links": "Links para nenhum conteúdo",
    "No Data available for selected time frame": "Não há dados disponíveis para o período de tempo selecionado.",
    "No Documents found": "Nenhum documento encontrado",
    "No Domains or Groups are yet selected for this report": "Nenhum domínio ou grupo foi selecionado para este relatório.",
    "No Frames": "Sem molduras",
    "No Frequency": "Sem frequência",
    "No HTML Pages found": "Nenhuma página HTML encontrada",
    "No Historic data available for Accessibility Level [[lvl]]": "Não há dados históricos disponíveis para o nível de acessibilidade [[lvl]].",
    "No IFrames": "Sem IFrames",
    "No Ignored Broken Links": "Nenhum link quebrado ignorado",
    "No Image Links found": "Não foram encontrados links para imagens.",
    "No PDF's failed": "Nenhum PDF falhou",
    "No PDF's pending": "Nenhum PDF pendente",
    "No PDF's queued": "Nenhum PDF na fila.",
    "No PDF's reviewed": "Nenhum PDF foi revisado.",
    "No PDFs are reviewed": "Nenhum PDF é revisado.",
    "No Policies detected": "Nenhuma política detectada",
    "No Profiles were found": "Nenhum perfil foi encontrado.",
    "No Spreadsheet links found": "Não foram encontrados links para planilhas.",
    "No Users are yet selected to receive this report": "Nenhum usuário foi selecionado ainda para receber este relatório.",
    "No Word links found": "Não foram encontrados links do Word",
    "No changes": "Sem alterações.",
    "No changes found": "Nenhuma alteração encontrada",
    "No checks found for this Accessibility category": "Nenhuma verificação encontrada para esta categoria de Acessibilidade.",
    "No content policies have been created yet": "Nenhuma política de conteúdo foi criada ainda.",
    "No corrections added to PageCorrect": "Nenhuma correção adicionada ao PageCorrect",
    "No data available": "Não há dados disponíveis.",
    "No data present": "Não há dados presentes.",
    "No diagnostics issues were found": "Não foram encontrados problemas de diagnóstico.",
    "No domains were found": "Nenhum domínio foi encontrado.",
    "No downloads found": "Nenhum download encontrado",
    "No errors found": "Nenhum erro encontrado",
    "No exemptions added to this checkpoint": "Nenhuma isenção foi adicionada a este posto de controle.",
    "No exports available": "Nenhuma exportação disponível",
    "No groups were found for this domain": "Não foram encontrados grupos para este domínio.",
    "No historic data available for this domain": "Não há dados históricos disponíveis para este domínio.",
    "No hits found": "Nenhum resultado encontrado",
    "No ignored checks in this accessibility category": "Nenhuma verificação ignorada nesta categoria de acessibilidade.",
    "No ignored misspellings found for this page": "Não foram encontrados erros ortográficos ignorados nesta página.",
    "No incidents occurred in the selected time frame": "Não ocorreram incidentes no período de tempo selecionado.",
    "No issues found": "Nenhum problema encontrado",
    "No javascript": "Sem JavaScript",
    "No name defined": "Nenhum nome definido",
    "No new notifications": "Nenhuma notificação nova",
    "No note has been added": "Nenhuma nota foi adicionada.",
    "No notifications available": "Nenhuma notificação disponível",
    "No opportunities were found": "Nenhuma oportunidade foi encontrada.",
    "No outages in this period": "Sem interrupções neste período.",
    "No pages found": "Nenhuma página encontrada",
    "No pages were found": "Nenhuma página foi encontrada.",
    "No passed checks in this accessibility category": "Nenhuma verificação aprovada nesta categoria de acessibilidade.",
    "No performance scan found": "Nenhuma análise de desempenho encontrada",
    "No performance scans were found": "Não foram encontradas análises de desempenho.",
    "No policies found": "Nenhuma política encontrada",
    "No readability score": "Sem pontuação de legibilidade",
    "No response received": "Nenhuma resposta recebida",
    "No run present": "Nenhuma execução presente",
    "No scan has yet been performed. Please check back later.": "Nenhuma verificação foi realizada ainda. Por favor, volte mais tarde.",
    "No slide links found": "Não foram encontrados links para os slides.",
    "No title found": "Nenhum título encontrado",
    "No title found on one or more pages": "Nenhum título encontrado em uma ou mais páginas.",
    "No title is found on this page": "Não foi encontrado nenhum título nesta página.",
    "No users available for this domain": "Não há usuários disponíveis para este domínio.",
    "No violations were found": "Nenhuma violação foi encontrada.",
    "No visitor profile selected": "Nenhum perfil de visitante selecionado",
    "No visits for this category in selected time frame": "Nenhuma visita para esta categoria no período selecionado.",
    "No words have been added to the default dictionary": "Nenhuma palavra foi adicionada ao dicionário padrão.",
    "No. Visits": "Não. Visitas",
    "Non-user list": "Lista de não usuários",
    "None": "Nenhum",
    "Normal - recommended": "Normal - recomendado",
    "Normal violations": "Violações normais",
    "Not case sensitive": "Não diferencia maiúsculas de minúsculas.",
    "Not containing": "Não contém",
    "Not scheduled": "Não agendado",
    "Not valid email": "E-mail inválido",
    "Note": "Observação",
    "Notes": "Notas",
    "Notifications": "Notificações",
    "Number of characters in Meta Header text": "Número de caracteres no texto do cabeçalho Meta",
    "Number of characters in header text": "Número de caracteres no texto do cabeçalho",
    "Number of characters in image text": "Número de caracteres no texto da imagem",
    "Number of characters in link text": "Número de caracteres no texto do link",
    "Number of characters in page title": "Número de caracteres no título da página",
    "Number of pages": "Número de páginas",
    "Number too high": "Número muito alto",
    "Number too low": "Número muito baixo",
    "OK": "OK",
    "Office 365 (BETA)": "Office 365 (BETA)",
    "Ok": "OK",
    "Once a day": "Uma vez por dia",
    "Once a week": "Uma vez por semana",
    "One or more documents have already been scanned for compliance. Are you sure you want to scan the selected documents again?": "Um ou mais documentos já foram digitalizados para fins de conformidade. Tem certeza de que deseja digitalizar os documentos selecionados novamente?",
    "One or more page on your website has the same H1 text.": "Uma ou mais páginas do seu site possuem o mesmo texto H1.",
    "One or more pages has been marked as no index": "Uma ou mais páginas foram marcadas como sem índice.",
    "One or more pages on your website has this title": "Uma ou mais páginas do seu site têm este título.",
    "Open": "Abrir",
    "Open Accessibility Decision Tree": "Árvore de decisão de acessibilidade aberta",
    "Open Data Privacy": "Privacidade de Dados Abertos",
    "Open Data Privacy Settings": "Configurações de privacidade de dados abertos",
    "Open Document Details": "Detalhes do documento aberto",
    "Open Document details": {
      "$$noContext": "Detalhes do documento aberto",
      "Aria label when clicking on open Document details": "Detalhes do documento aberto"
    },
    "Open Fast Track for this HTML snippet": "Abra o Acesso Rápido para este trecho de HTML",
    "Open New Help Center": "Abrir nova Central de Ajuda",
    "Open Page Details": "Abrir detalhes da página",
    "Open Schedule downtime": "Tempo de inatividade do Open Schedule",
    "Open document details": "Abrir detalhes do documento",
    "Open domain policy": "Política de domínio aberto",
    "Open example": "Abra o exemplo",
    "Open filters": "Abrir filtros",
    "Open group": "Grupo aberto",
    "Open help center": "Abra a central de ajuda",
    "Open keyboard shortcuts": "Abrir atalhos de teclado",
    "Open page details": {
      "$$noContext": "Abrir detalhes da página",
      "Aria label when clicking on open pagedetails": "Abrir detalhes da página"
    },
    "Open received reports": "Relatórios recebidos em aberto",
    "Open report": "Abrir relatório",
    "Operating System": "Sistema operacional",
    "Operating Systems": "Sistemas Operacionais",
    "Operating systems": "Sistemas operacionais",
    "Operating systems Overview": "Visão geral dos sistemas operacionais",
    "Operator*": "Operador*",
    "Opportunities": "Oportunidades",
    "Opportunities by Priority": "Oportunidades por Prioridade",
    "Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.": "Opcionalmente, você pode selecionar o idioma principal do domínio. Se escolher Inglês (Reino Unido), qualquer texto detectado como inglês será considerado inglês britânico.",
    "Options": "Opções",
    "Or": "Ou",
    "Organizations": "Organizações",
    "Original Data": "Dados originais",
    "Other Documents": "Outros documentos",
    "Other files": "Outros arquivos",
    "Others": "Outros",
    "Our suggestion": "Nossa sugestão",
    "Our team has been notified of your request. We will soon be in touch.": "Nossa equipe foi notificada sobre sua solicitação. Entraremos em contato em breve.",
    "Outages during the selected time-frame": "Interrupções durante o período selecionado",
    "Outages end": "Fim das interrupções",
    "Outages start": "As interrupções começam",
    "Outgoing Links": "Links de saída",
    "Outgoing links": "Links de saída",
    "Over 1000 ms.": "Mais de 1000 ms.",
    "Over 10000 ms.": "Mais de 10.000 ms.",
    "Over 200 ms.": "Mais de 200 ms.",
    "Over 2000 ms.": "Mais de 2000 ms.",
    "Over 3000 ms.": "Mais de 3000 ms.",
    "Over 4000 ms.": "Mais de 4000 ms.",
    "Over 500 ms.": "Mais de 500 ms.",
    "Over 5000 ms.": "Mais de 5000 ms.",
    "Over 6000 ms.": "Mais de 6000 ms.",
    "Over 7000 ms.": "Mais de 7000 ms.",
    "Over 8000 ms.": "Mais de 8000 ms.",
    "Over 9000 ms.": "Mais de 9000 ms.",
    "Overall Data Privacy compliance for this page": "Conformidade geral com a privacidade de dados para esta página.",
    "Overall PageCorrects": "Correções gerais da página",
    "Overall SEO compliance for this page": "Conformidade geral com SEO para esta página",
    "Overall accessibility compliance for this level": "Conformidade geral de acessibilidade para este nível",
    "Overall accessibility compliance level for this page": "Nível geral de conformidade com a acessibilidade desta página",
    "Overall compliance": "conformidade geral",
    "Overall policy compliance for this page": "Conformidade geral com as políticas desta página",
    "Owner": "Proprietário",
    "PAGE PERFORMANCE OVERVIEW": "VISÃO GERAL DO DESEMPENHO DA PÁGINA",
    "PDF": "PDF",
    "PDF Compliance Status": "Status de conformidade do PDF",
    "PDF Documents": "Documentos PDF",
    "PDF accessibility scan completed at [[date]]": "Verificação de acessibilidade do PDF concluída em [[date]]",
    "PDF accessibility scan requested": "Solicitação de verificação de acessibilidade do PDF",
    "PDF files": "Arquivos PDF",
    "PDF files pending": "Arquivos PDF pendentes",
    "PDF files reviewed": "Arquivos PDF revisados",
    "PDF files that are reviewed or pending for accessibility": "Arquivos PDF que estão sendo revisados ​​ou pendentes de verificação de acessibilidade.",
    "PDFs": "PDFs",
    "POLICIES OVERVIEW": "VISÃO GERAL DAS POLÍTICAS",
    "Page": "Página",
    "Page Dashboard": "Painel de controle da página",
    "Page Details": "Detalhes da página",
    "Page Performance": "Desempenho da página",
    "Page Statistics": "Estatísticas da página",
    "Page URL": "URL da página",
    "Page Views": "Visualizações de página",
    "Page compliance": "Conformidade da página",
    "Page count in PDF": "Número de páginas em PDF",
    "Page dashboard": "Painel de controle da página",
    "Page details": "Detalhes da página",
    "Page first detected": "Página detectada pela primeira vez",
    "Page links": "Links da página",
    "PageAssist Logo Position": "Posição do logotipo do PageAssist",
    "PageAssist Theme": "Tema PageAssist",
    "PageCorrect": "Página correta",
    "PageCorrect Content": "Conteúdo correto da página",
    "PageCorrect Custom Phrase or Word": "PageCorrect Frase ou palavra personalizada",
    "PageCorrect Details": "Detalhes corretos da página",
    "PageCorrect Diagnostics": "Diagnóstico PageCorrect",
    "PageCorrects categorized": "Correções de página categorizadas",
    "PageFixes": "Correções de página",
    "PageFixes Left": "PageFixes à esquerda",
    "Pages": "Páginas",
    "Pages & documents with confirmed misspellings, broken links or images": "Páginas e documentos com erros ortográficos confirmados, links quebrados ou imagens.",
    "Pages Crawled": "Páginas rastreadas",
    "Pages With Opportunities": "Páginas com Oportunidades",
    "Pages and documents with policies marked as unwanted or required": "Páginas e documentos com políticas marcadas como indesejadas ou obrigatórias.",
    "Pages crawled": "Páginas rastreadas",
    "Pages failing check": "Páginas que não passaram na verificação",
    "Pages in compliance": "Páginas em conformidade",
    "Pages related to policy link": "Páginas relacionadas ao link da política",
    "Pages that are difficult to read": "Páginas difíceis de ler",
    "Pages that are easily understood by children below 5'th grade": "Páginas de fácil compreensão para crianças abaixo do 5º ano.",
    "Pages that are easy to read. Conversational English for consumers": "Páginas de fácil leitura. Inglês coloquial para consumidores.",
    "Pages that are fairly difficult to read": "Páginas que são bastante difíceis de ler.",
    "Pages that are fairly easy to read": "Páginas que são relativamente fáceis de ler.",
    "Pages that are in plain English. Easily understood by 13- to 15-year-old students": "Páginas escritas em inglês simples. Facilmente compreendidas por alunos de 13 a 15 anos.",
    "Pages that are very difficult to read. Best understood by university graduates": "Páginas de leitura muito difícil. Mais adequadas para leitores com formação universitária.",
    "Pages that are very easy to read. Easily understood by an average 11-year-old student": "Páginas de leitura muito fácil. Facilmente compreendidas por um aluno médio de 11 anos.",
    "Pages we could not determine Readability score": "Páginas para as quais não foi possível determinar a pontuação de legibilidade.",
    "Pages with Data Privacy issues": "Páginas com problemas de privacidade de dados",
    "Pages with Failing Checks": "Páginas com verificações falhas",
    "Pages with Ignored Checks": "Páginas com verificações ignoradas",
    "Pages with Misspellings": "Páginas com erros ortográficos",
    "Pages with Opportunities": "Páginas com Oportunidades",
    "Pages with Policy Issues": "Páginas com questões políticas",
    "Pages with QA Issues": "Páginas com problemas de controle de qualidade",
    "Pages with QA issues": "Páginas com problemas de controle de qualidade",
    "Pages with SEO Opportunities": "Páginas com Oportunidades de SEO",
    "Pages with SEO opportunities": "Páginas com oportunidades de SEO",
    "Pages with accessibility checks not in compliance": "Páginas com verificações de acessibilidade que não estão em conformidade",
    "Pages with failing checks": "Páginas com verificações falhas",
    "Pages with high, medium or low opportunities": "Páginas com oportunidades altas, médias ou baixas",
    "Pages with ignored checks": "Páginas com verificações ignoradas",
    "Pages with issues": "Páginas com problemas",
    "Pages with policy matches": "Páginas com correspondências de políticas",
    "Pages with score:": "Páginas com pontuação:",
    "Pages with the \\\"noindex\\\" META tag will not be indexed by the search engines. This is not an \\\"error\\\" per se, but make sure that the page does not have this tag as a result of an error.": "Páginas com a meta tag &quot;noindex&quot; não serão indexadas pelos mecanismos de busca. Isso não é um &quot;erro&quot; em si, mas certifique-se de que a página não tenha essa tag como resultado de um erro.",
    "Pages without H1 tags or with empty H1 tags that contain no value represent a failed SEO optimization opportunity.": "Páginas sem tags H1 ou com tags H1 vazias, que não contêm nenhum valor, representam uma oportunidade de otimização de SEO perdida.",
    "Pages without Visits": "Páginas sem visitas",
    "Pages without Visits in last 6 months": "Páginas sem visitas nos últimos 6 meses",
    "Pageviews": "Visualizações de página",
    "Part of downtime calculation": "Parte do cálculo do tempo de inatividade",
    "Part of heatmap Rules": "Parte das regras do mapa de calor",
    "Part of success criteria [[checkIssueNumber]]": "Parte dos critérios de sucesso [[checkIssueNumber]]",
    "Pass Example": "Exemplo de aprovação",
    "Passed": "Aprovado",
    "Passed ([[audits]])": "Aprovado ([[audits]])",
    "Passed Checks": "Verificações aprovadas",
    "Passed Policy checks": "Aprovado nas verificações de política",
    "Passed checks": "Verificações aprovadas",
    "Passed policy checks": "Aprovado nas verificações de política",
    "Password": "Senha",
    "Password Confirmation": "Confirmação de senha",
    "Password confirmation": "Confirmação de senha",
    "Password to login": "Senha para fazer login",
    "Passwords does not match": "As senhas não coincidem.",
    "Path constraints": "restrições de caminho",
    "Path template": "Modelo de caminho",
    "Pending": "Pendente",
    "Pending PDF review": "Aguardando revisão do PDF.",
    "Pending PDF reviews": "Análises de PDF pendentes",
    "Percentage shows number of pages that are compliant with all Data Privacy checks": "A porcentagem mostra o número de páginas que estão em conformidade com todas as verificações de privacidade de dados.",
    "Percentage shows number of pages that are compliant with all SEO checks": "A porcentagem mostra o número de páginas que atendem a todos os requisitos de SEO.",
    "Performance": "Desempenho",
    "Performance Errors": "Erros de desempenho",
    "Performance Pages": "Páginas de desempenho",
    "Performance Profiles": "Perfis de desempenho",
    "Performance Score": "Pontuação de desempenho",
    "Performance score": "Pontuação de desempenho",
    "Personal": "Pessoal",
    "Personal information": "Informações pessoais",
    "Phone": "Telefone",
    "Pie": "Torta",
    "Pin domain": "Domínio Pin",
    "Ping intervals": "Intervalos de ping",
    "Play": "Jogar",
    "Play misspelling": "Erro de ortografia",
    "Please choose a trademark": "Por favor, selecione uma marca registrada.",
    "Please insert correct URL:": "Por favor, insira o URL correto:",
    "Please insert the correct word:": "Por favor, insira a palavra correta:",
    "Please insert the missing ALT text:": "Por favor, insira o texto ALT que está faltando:",
    "Please select a module": "Por favor, selecione um módulo.",
    "Please select the module that you want to create a Source Code Exclude for": "Selecione o módulo para o qual deseja criar uma exclusão de código-fonte.",
    "Please specify word or phrase to search for": "Por favor, especifique a palavra ou frase que deseja pesquisar.",
    "Please use CSS selectors to identify form fields and buttons": "Utilize seletores CSS para identificar os campos e botões do formulário.",
    "Please wait": "Por favor, aguarde",
    "Please wait - Adding word to dictionary": "Aguarde - Adicionando palavra ao dicionário",
    "Please wait - Adding words to dictionary": "Aguarde - Adicionando palavras ao dicionário",
    "Please wait - Confirming misspelling": "Aguarde - Confirmando erro de ortografia.",
    "Please wait - exporting audit log &nbsp;": "Aguarde - exportando o registro de auditoria",
    "Policies": "Políticas",
    "Policies - required": "Políticas - obrigatórias",
    "Policies - violations": "Políticas - violações",
    "Policies marked as required or unwanted": "Políticas marcadas como obrigatórias ou indesejadas.",
    "Policies violations": "violações de políticas",
    "Policies with most matches": "Políticas com mais correspondências",
    "Policies with violations": "Políticas com violações",
    "Policy": "Política",
    "Policy Diagnostics": "Diagnóstico de Políticas",
    "Policy Distribution": "Distribuição de Políticas",
    "Policy Hits": "Políticas de Impacto",
    "Policy Issues": "Questões políticas",
    "Policy List": "Lista de Políticas",
    "Policy Pages": "Páginas de Políticas",
    "Policy Running": "Política em execução",
    "Policy errors": "Erros de política",
    "Policy hits per domain": "Ações de política por domínio",
    "Policy in queue": "Política na fila",
    "Policy info": "Informações sobre a política",
    "Policy note": "Nota de política",
    "Policy rules": "Regras da política",
    "Policy scan in progress": "Análise de políticas em andamento",
    "Policy setup": "Configuração de políticas",
    "Policy violations": "violações de políticas",
    "Policy with matching terms": "Política com termos correspondentes",
    "Potential Misspelling": "Possível erro ortográfico",
    "Potential Misspellings": "Possíveis erros ortográficos",
    "Potential Savings": "Economia potencial",
    "Potential misspelling": "Possível erro de ortografia",
    "Potential misspellings": "Possíveis erros ortográficos",
    "Potential misspellings found": "Possíveis erros ortográficos encontrados",
    "Powered by Google Lighthouse": "Com tecnologia do Google Lighthouse",
    "Prefix path": "Caminho de prefixo",
    "Presence": "Presença",
    "Previous": "Anterior",
    "Principle 1: Perceivable": "Princípio 1: Perceptível",
    "Principle 2: Operable": "Princípio 2: Operacional",
    "Principle 3: Understandable": "Princípio 3: Compreensível",
    "Principle 4: Robust": "Princípio 4: Robusto",
    "Principle 5: Conformance": "Princípio 5: Conformidade",
    "Print view": "Visualização para impressão",
    "Priorities": "Prioridades",
    "Prioritized Content": "Conteúdo Priorizado",
    "Priority": "Prioridade",
    "Profile": "Perfil",
    "Profile Description": "Descrição do perfil",
    "Profile Dropdown": "Menu suspenso de perfil",
    "Profile Menu": "Menu de perfil",
    "Profile Name": "Nome do perfil",
    "Profile details": "Detalhes do perfil",
    "Profile updated": "Perfil atualizado",
    "QA": "QA",
    "QA Issues": "Questões de controle de qualidade",
    "QA errors": "erros de controle de qualidade",
    "QUALITY ASSURANCE": "GARANTIA DE QUALIDADE",
    "QUALITY ASSURANCE OVERVIEW": "VISÃO GERAL DA GARANTIA DA QUALIDADE",
    "Quality Assurance": "Garantia de Qualidade",
    "Quality Assurance Check": "Verificação de Garantia de Qualidade",
    "Quality Assurance Diagnostics": "Diagnóstico de Garantia de Qualidade",
    "Quality Assurance Export summary": "Resumo de Exportação de Garantia de Qualidade",
    "Quality Assurance errors": "Erros de garantia de qualidade",
    "Quality assurance": "Garantia de qualidade",
    "Queued": "Em fila",
    "Quick Guide": "Guia rápido",
    "Quick help": "Ajuda rápida",
    "Quick info:": "Informações rápidas:",
    "Re-scanning of issues for this page has started and will be finished in a few minutes.": "A nova verificação dos problemas desta página foi iniciada e será concluída em alguns minutos.",
    "Readability": "Legibilidade",
    "Readability Score": "Pontuação de legibilidade",
    "Readability by score": "Legibilidade por pontuação",
    "Readability levels": "Níveis de legibilidade",
    "Readability score": "Pontuação de legibilidade",
    "Readability scores across all web pages (based on": "Índices de legibilidade em todas as páginas da web (com base em",
    "Readability test": "Teste de legibilidade",
    "Receive report": "Receber relatório",
    "Received reports": "Relatórios recebidos",
    "Referring Information": "Informações de referência",
    "Referring visits": "Consultas de encaminhamento",
    "Regex": "Expressão regular",
    "Regulation": "Regulamento",
    "Remember me": "Lembre de mim",
    "Remove": "Remover",
    "Remove Custom Multistep Javascript": "Remover JavaScript personalizado de várias etapas",
    "Remove Extension Name": "Remover nome da extensão",
    "Remove Page": "Remover página",
    "Remove Profile": "Remover perfil",
    "Remove Rule": "Remover regra",
    "Remove checkpoint": "Remover ponto de verificação",
    "Remove domain": "Remover domínio",
    "Remove domain group": "Remover grupo de domínios",
    "Remove from dictionary": "Remover do dicionário",
    "Remove group": "Remover grupo",
    "Remove rule": "Remover regra",
    "Remove this IP address?": "Remover este endereço IP?",
    "Remove this pattern?": "Remover este padrão?",
    "Remove this word from dictionary": "Remova esta palavra do dicionário.",
    "Render pages and execute JS while crawling": "Renderizar páginas e executar JS durante a indexação.",
    "Repeat": "Repita",
    "Replace Rule": "Regra de substituição",
    "Report": "Relatório",
    "Report administration": "Administração de relatórios",
    "Report overview:": "Visão geral do relatório:",
    "Request PDF scan for all documents": "Solicitar digitalização em PDF de todos os documentos",
    "Requests": "Solicitações",
    "Required": "Obrigatório",
    "Required content": "Conteúdo obrigatório",
    "Required count": "Contagem necessária",
    "Rescan": "Nova verificação",
    "Rescanning": "Reescaneamento",
    "Reset": "Reiniciar",
    "Reset Preferences": "Redefinir preferências",
    "Resolution": "Resolução",
    "Resource Type": "Tipo de recurso",
    "Response Time": "Tempo de resposta",
    "Response code": "Código de resposta",
    "Response time": "Tempo de resposta",
    "Response time (Milliseconds)": "Tempo de resposta (milissegundos)",
    "Response time notification": "notificação do tempo de resposta",
    "Response time notification threshold": "Limite de notificação de tempo de resposta",
    "Return to heartbeat overview": "Voltar à visão geral dos batimentos cardíacos",
    "Returning customer": "Cliente recorrente",
    "Reverting state": "Estado de reversão",
    "Review": "Análise",
    "Reviewed": "Revisado",
    "Reviewed/Ok": "Revisado/OK",
    "Revoke token": "Revogar token",
    "Robot Info": "Informações sobre robôs",
    "Role": "Papel",
    "Rule": "Regra",
    "Rule name": "Nome da regra",
    "Rule operator": "Operador de regra",
    "Rule to match": "Regra para combinar",
    "Rules": "Regras",
    "Run Policy": "Política de execução",
    "Run policy": "Política de execução",
    "Run policy again": "Execute a política novamente",
    "Running": "Correndo",
    "SEO": "SEO",
    "SEO (Search Engine Optimization)": "SEO (Otimização para Mecanismos de Busca)",
    "SEO Checkpoints": "Pontos de verificação de SEO",
    "SEO Diagnostics": "Diagnóstico de SEO",
    "SEO Issues": "Problemas de SEO",
    "SEO OVERVIEW": "VISÃO GERAL DE SEO",
    "SEO Opportunities": "Oportunidades de SEO",
    "SEO errors": "erros de SEO",
    "SEO impact": "impacto do SEO",
    "SEO opportunities": "Oportunidades de SEO",
    "SEO opportunities - high priority": "Oportunidades de SEO - alta prioridade",
    "SEO opportunities - low priority": "Oportunidades de SEO - baixa prioridade",
    "SEO opportunities - medium priority": "Oportunidades de SEO - prioridade média",
    "SEO opportunities - technical SEO issues": "Oportunidades de SEO - questões técnicas de SEO",
    "SEO opportunities found": "Oportunidades de SEO encontradas",
    "SHOW LIST VIEW": "EXIBIR LISTA",
    "STATISTICS OVERVIEW": "VISÃO GERAL DAS ESTATÍSTICAS",
    "Saturday": "Sábado",
    "Save": "Salvar",
    "Save Preferences": "Salvar preferências",
    "Save and close": "Salvar e fechar",
    "Save policy": "Política de economia",
    "Scan": "Digitalizar",
    "Scan documents": "Digitalizar documentos",
    "Scan frequency": "Frequência de varredura",
    "Scan frequency:": "Frequência de varredura:",
    "Scan in progress": "Digitalização em andamento",
    "Scan in progress:": "Digitalização em andamento:",
    "Scan is done": "A digitalização foi concluída.",
    "Scan subdomains": "Analisar subdomínios",
    "Scanned at": "Escaneado em",
    "Scanned content": "Conteúdo digitalizado",
    "Scanned links:": "Links digitalizados:",
    "Scanned pages": "Páginas digitalizadas",
    "Scanned pages:": "Páginas digitalizadas:",
    "Scanning URL:": "Analisando URL:",
    "Scanning in progress": "Digitalização em andamento",
    "Schedule Report": "Relatório de Cronograma",
    "Schedule supplemental reports to be delivered with each scan": "Agende a entrega de relatórios complementares juntamente com cada digitalização.",
    "Scheduled": "Agendado",
    "Scheduled Reports": "Relatórios agendados",
    "Scopes": "Escopos",
    "Score": "Pontuação",
    "Screen Resolutions": "Resoluções de tela",
    "Screen Resolutions Overview": "Visão geral das resoluções de tela",
    "Script Evaluation": "Avaliação de roteiro",
    "Script Parse": "Análise de script",
    "Script installed": "Script instalado",
    "Script installed on Domain": "Script instalado no domínio",
    "Script setup guide": "Guia de configuração de scripts",
    "Search Engine Optimization": "Otimização para mecanismos de busca",
    "Search Engine Optimization (SEO)": "Otimização para mecanismos de busca (SEO)",
    "Search Engines": "Mecanismos de busca",
    "Search engine": "Mecanismo de busca",
    "Search engines": "Mecanismos de busca",
    "Search for Pages": "Pesquisar páginas",
    "Search for file size that is": "Pesquise por tamanho de arquivo que seja",
    "Search for image size that is": "Pesquise por tamanho de imagem que seja",
    "Search for links, that are associated with class names and contains below mentioned class names.": "Procure por links associados a nomes de classes e que contenham os nomes de classes mencionados abaixo.",
    "Search for page titles or URLs across all domains": "Pesquise títulos de páginas ou URLs em todos os domínios.",
    "Search for pages": "Pesquisar páginas",
    "Search icon": "Ícone de pesquisa",
    "Search in: Documents": "Pesquisar em: Documentos",
    "Search in: Everything": "Pesquisar em: Tudo",
    "Search in: Links": "Pesquisar em: Links",
    "Search in: Only HTML pages": "Pesquisar em: Somente páginas HTML",
    "Search pages across all domains": "Pesquisar páginas em todos os domínios",
    "Search...": "Procurar...",
    "Searches": "Pesquisas",
    "Seconds": "Segundos",
    "See API Token": "Consulte o token da API.",
    "See Details": "Veja os detalhes",
    "See changes": "Veja as alterações",
    "See details": "Veja os detalhes",
    "See pages": "Veja as páginas",
    "Select Domain and Module to get the Insights": "Selecione o domínio e o módulo para obter informações.",
    "Select Domain on domain picker": "Selecione o domínio no seletor de domínios.",
    "Select Page to scan": "Selecione a página a ser digitalizada.",
    "Select a domain and recipients": "Selecione um domínio e os destinatários.",
    "Select a domain or group": "Selecione um domínio ou grupo",
    "Select a profile": "Selecione um perfil",
    "Select account": "Selecione a conta",
    "Select all items": "Selecione todos os itens",
    "Select domain": "Selecione o domínio",
    "Select domains and groups": "Selecione domínios e grupos",
    "Select filters": "Selecione os filtros",
    "Select import": "Selecione importar",
    "Select item": "Selecione o item",
    "Select login type*": "Selecione o tipo de login*",
    "Select timezone": "Selecione o fuso horário",
    "Select users": "Selecionar usuários",
    "Select what type of content the policy should search in": "Selecione o tipo de conteúdo que a política deve pesquisar.",
    "Select whether the rule should search for case sensitive text or not": "Selecione se a regra deve procurar texto que diferencie maiúsculas de minúsculas ou não.",
    "Select your export file": "Selecione o arquivo de exportação",
    "Send an email if the site is down": "Envie um e-mail se o site estiver fora do ar.",
    "Send an email if the site is slow to respond": "Envie um e-mail se o site estiver lento para responder.",
    "Send message": "Enviar mensagem",
    "Send report": "Enviar relatório",
    "Send welcome mail on creation": "Enviar e-mail de boas-vindas após a criação do perfil.",
    "Set a default value for selector": "Defina um valor padrão para o seletor.",
    "Set as Default": "Definir como padrão",
    "Set to fixed": "Definir como fixo",
    "Settings": {
      "$$noContext": "Configurações",
      "Topmenu": "Configurações"
    },
    "Setup your domain": "Configure seu domínio",
    "Severity": "Gravidade",
    "Severity level": "Nível de gravidade",
    "Short": "Curto",
    "Short Description": "Descrição resumida",
    "Should we check the page's current status?": "Devemos verificar o estado atual da página?",
    "Show Details": "Mostrar detalhes",
    "Show all": "Mostrar tudo",
    "Show documents with this email": "Mostrar documentos com este e-mail",
    "Show history": "Mostrar histórico",
    "Show label dropdown": "Exibir menu suspenso de rótulos",
    "Show less": "Mostrar menos",
    "Show more": "Mostrar mais",
    "Show on global policy list": "Exibir na lista de políticas globais",
    "Show pages": "Mostrar páginas",
    "Show pages with issues": "Mostrar páginas com problemas",
    "Show pages with this SEO issue": "Exibir páginas com este problema de SEO",
    "Show pages with this email": "Exibir páginas com este e-mail",
    "Show pages with this image": "Exibir páginas com esta imagem",
    "Show pages with this link": "Mostrar páginas com este link",
    "Show pages with this misspelling": "Mostrar páginas com este erro ortográfico",
    "Show policy hits per domain": "Exibir ocorrências de políticas por domínio",
    "Show policy info": "Mostrar informações sobre a política",
    "Show the Domain Picker": "Exibir o Seletor de Domínio",
    "Show/Hide filter selector": "Mostrar/Ocultar seletor de filtro",
    "Show/Hide the Domain Picker": "Mostrar/Ocultar o Seletor de Domínio",
    "Shows the remaining number of Performance Profiles that can be created for this account": "Mostra o número restante de Perfis de Desempenho que podem ser criados para esta conta.",
    "Side Navigation": "Navegação lateral",
    "Single line": "Linha única",
    "Size": "Tamanho",
    "Skip to content": "Ir para o conteúdo",
    "Slide links": "Links para slides",
    "Slides": "Slides",
    "Slow": "Lento",
    "Snippet": "Trecho",
    "Social": "Social",
    "Social Networks": "Redes sociais",
    "Social visits": "visitas sociais",
    "Source Code Exclude": "Excluir código-fonte",
    "Source Code Excludes": "O código-fonte exclui",
    "Source code": "Código-fonte",
    "Spellcheck": "Correção ortográfica",
    "Spellcheck Export Summary": "Resumo da exportação da verificação ortográfica",
    "Spellcheck Summary": "Resumo da verificação ortográfica",
    "Spelling": "Ortografia",
    "Spelling Errors used": "Erros ortográficos usados",
    "Spelling fixes": "Correções ortográficas",
    "Spelling ignore capitalized words": "A ortografia ignora palavras em maiúsculas.",
    "Spreadsheet links": "Links para planilhas",
    "Spreadsheets": "Planilhas",
    "Start PDF accessibility scan": "Iniciar verificação de acessibilidade do PDF",
    "Start at": "Comece em",
    "Start compound export": "Iniciar exportação composta",
    "Start date": "Data de início",
    "Start export": "Iniciar exportação",
    "Start export Pages With Specific Link": "Iniciar exportação de páginas com link específico",
    "Start new scan": "Iniciar nova verificação",
    "Start on demand scan": "Iniciar verificação sob demanda",
    "Start time": "Hora de início",
    "Starts with": "Começa com",
    "State": "Estado",
    "Statistic": "Estatística",
    "Statistics": "Estatísticas",
    "Statistics excluded IP addresses": "As estatísticas excluíram endereços IP.",
    "Status": "Status",
    "Stop current crawl": "Interrompa o rastreamento atual",
    "Sub Navigation": "Subnavegação",
    "Submit selector*": "Enviar seletor*",
    "Succeeds": "Obtém sucesso",
    "Success criteria": "Critérios de sucesso",
    "Suggestions and ideas": "Sugestões e ideias",
    "Summarized pages and documents count": "Contagem resumida de páginas e documentos",
    "Summary": "Resumo",
    "Sunday": "Domingo",
    "Switch account": "Trocar de conta",
    "Table View": "Visualização em tabela",
    "Tags": "Etiquetas",
    "Target": "Alvo",
    "Technical": "Técnico",
    "Technical SEO Issues": "Questões técnicas de SEO",
    "Text": "Texto",
    "Text Documents": "Documentos de texto",
    "Text documents": "Documentos de texto",
    "Text to match": "Texto correspondente",
    "Text:": "Texto:",
    "The Checkpoint [[checkpoint]] will be updated with data after next crawl": "O ponto de verificação [[checkpoint]] será atualizado com dados após a próxima coleta de dados.",
    "The Document is not tagged": "O documento não está etiquetado.",
    "The Path template for Umbraco CMS": "Modelo de caminho para o CMS Umbraco",
    "The Requested Page is not a part of the Performance Module": "A página solicitada não faz parte do Módulo de Desempenho.",
    "The Scan will take effect within the next few hours": "O exame entrará em vigor nas próximas horas.",
    "The URL for this page is too long": "O URL desta página é muito longo.",
    "The base url to the CMS page": "O URL base para a página do CMS",
    "The bounce rate tells you the number of visits who only see the one page they started on": "A taxa de rejeição indica o número de visitantes que visualizam apenas a página em que iniciaram o processo.",
    "The following rules will be removed, are you sure you want to continue with this change?": "As seguintes regras serão removidas. Tem certeza de que deseja prosseguir com essa alteração?",
    "The header 1 (H1) tag is important as it helps search engines and users to understand what content they can expect to find on the page.": "A tag de cabeçalho 1 (H1) é importante, pois ajuda os mecanismos de busca e os usuários a entenderem que tipo de conteúdo podem esperar encontrar na página.",
    "The likelihood of this being a Data Privacy issue": "A probabilidade de isso ser um problema de privacidade de dados.",
    "The lowest level of readability. Example: children's books": "O nível mais baixo de legibilidade. Exemplo: livros infantis.",
    "The meta description on this page is too long": "A meta descrição desta página é muito longa.",
    "The meta description on this page is too short": "A meta descrição desta página é muito curta.",
    "The misspelling will first show up after a new scan": "O erro ortográfico só aparecerá após uma nova verificação.",
    "The name of a meta entry (page metadata)": "O nome de uma entrada meta (metadados da página)",
    "The optional base url to the CMS page": "O URL base opcional para a página do CMS.",
    "The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.": "A privacidade dos seus dados pessoais é muito importante para nós. Por isso, atualizamos nossa política de proteção de dados e privacidade. Para continuar usando nossa plataforma, pedimos que leia e aceite os novos termos da política de proteção de dados e privacidade.",
    "The scan can take a few hours/days to finalise, depending on the size of the website": "A digitalização pode levar algumas horas ou dias para ser concluída, dependendo do tamanho do site.",
    "The scan can take a few hours/days to finalise, depending on the size of the website.<br><br>Are you sure you want to start on-demand scan?": "A digitalização pode levar algumas horas ou dias para ser concluída, dependendo do tamanho do site.<br><br> Tem certeza de que deseja iniciar a digitalização sob demanda?",
    "The scan can take a few minutes to finalise, depending on the size of the page": "A digitalização pode demorar alguns minutos para ser concluída, dependendo do tamanho da página.",
    "There are no META descriptions on one or more pages": "Não existem meta descrições em uma ou mais páginas.",
    "There are no domains assigned to this policy. Save policy anyway?": "Não há domínios atribuídos a esta política. Deseja salvar a política mesmo assim?",
    "There are no more errors for this Snippet": "Não há mais erros para este trecho de código.",
    "There are no sub headlines on one or more pages": "Não há subtítulos em uma ou mais páginas.",
    "There are zero META keywords on this page": "Esta página não contém palavras-chave META.",
    "There is no H1 on one or more pages": "Não há H1 em uma ou mais páginas.",
    "There is no H1 on this page": "Não há H1 nesta página.",
    "There is no META descriptions on this page": "Não há meta descrições nesta página.",
    "There is no historic data for domain groups": "Não existem dados históricos para grupos de domínio.",
    "There is no historic data for this domain": "Não existem dados históricos para este domínio.",
    "There is no sub headlines on this page": "Não há subtítulos nesta página.",
    "These are findings that cannot be automatically checked and must be reviewed manually": "Essas são descobertas que não podem ser verificadas automaticamente e devem ser revisadas manualmente.",
    "These are findings which are likely to be errors, requiring manual confirmation": "Esses resultados provavelmente são erros e exigem confirmação manual.",
    "These findings are confirmed errors": "Essas conclusões são erros confirmados.",
    "Third-Party": "Terceiro",
    "This field is required": "Este campo é obrigatório",
    "This is the time between when an outage is first detected and when a notification is sent.": "Este é o período entre a detecção inicial de uma interrupção e o envio de uma notificação.",
    "This is useful if you have defined timeslots for maintenance.": "Isso é útil se você tiver definido horários para manutenção.",
    "This issue is ignored": "Este problema foi ignorado.",
    "This link is marked as broken because it took more than 30 seconds to load": "Este link está marcado como quebrado porque demorou mais de 30 segundos para carregar.",
    "This page has been marked as no index": "Esta página foi marcada como sem índice.",
    "This page has no meta description": "Esta página não possui meta descrição.",
    "This page has no meta keywords": "Esta página não possui meta palavras-chave.",
    "This page has not been assigned to the Performance Module": "Esta página não foi atribuída ao Módulo de Desempenho.",
    "This page is missing a title": "Esta página não tem título.",
    "This policy is scheduled": "Esta política está agendada",
    "This rule doesn't contain any matches": "Esta regra não contém nenhuma correspondência.",
    "This section lists requirements for <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformance</a> to WCAG 2.1. It also gives information about how to make conformance claims, which are optional.": "Esta seção lista os requisitos para <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformidade</a> com as WCAG 2.1. Também fornece informações sobre como fazer declarações de conformidade, que são opcionais.",
    "Thursday": "Quinta-feira",
    "Time": "Tempo",
    "Time Spent": "Tempo gasto",
    "Time To Interactive": "Hora de ser interativo",
    "Time to Warning *": "Tempo até o aviso *",
    "Timeframe:": "Cronograma:",
    "Timeline": "Linha do tempo",
    "Timezone": "Fuso horário",
    "Title": "Título",
    "Title & description": "Título e descrição",
    "Title and URL": "Título e URL",
    "Title and url": "Título e URL",
    "To setup this policy, you need to tell us how long your max word length is": "Para configurar essa política, você precisa nos informar qual é o comprimento máximo de suas palavras.",
    "To setup this policy, you need to tell us which brand name should end with TM or ™": "Para configurar essa política, você precisa nos informar qual nome de marca deve terminar com TM ou ™.",
    "To toggle Quick Search:": "Para ativar/desativar a Pesquisa Rápida:",
    "Toggle Dropdown": "Alternar menu suspenso",
    "Toggle dropdown": "Alternar menu suspenso",
    "Toggle notes": "Alternar notas",
    "Toggle show filters": "Alternar a exibição dos filtros",
    "Too few characters": "Poucos caracteres",
    "Too many characters": "Personagens demais",
    "Top keywords": "Principais palavras-chave",
    "Total": "Total",
    "Total CPU Time": "Tempo total de CPU",
    "Total QA issues": "Problemas totais de controle de qualidade",
    "Total Visitors": "Total de visitantes",
    "Total Visits": "Total de visitas",
    "Total amount of content": "Quantidade total de conteúdo",
    "Total crawled": "Total rastreado",
    "Total number of issues": "Número total de problemas",
    "Total number of issues across all modules": "Número total de problemas em todos os módulos",
    "Total page views over the last 30 days": "Total de visualizações de página nos últimos 30 dias",
    "Total pages:": "Total de páginas:",
    "Total visitors": "Total de visitantes",
    "Total visitors from Referrers": "Total de visitantes provenientes de fontes de referência",
    "Total visitors from Search Engines": "Total de visitantes provenientes de mecanismos de busca",
    "Total visits": "Total de visitas",
    "Total visits from Referrers": "Total de visitas provenientes de fontes de referência",
    "Total visits from Search Engines": "Total de visitas provenientes de mecanismos de busca",
    "Total visits in the last 30 days:": "Total de visitas nos últimos 30 dias:",
    "Total words": "Total de palavras",
    "Track changes across domains and modules": "Acompanhe as alterações em todos os domínios e módulos.",
    "Traffic Sources": "Fontes de tráfego",
    "Traffic Sources Summary": "Resumo das fontes de tráfego",
    "Traffic sources": "Fontes de tráfego",
    "Transfer Size": "Tamanho da transferência",
    "Tuesday": "Terça-feira",
    "Twice a day": "Duas vezes ao dia",
    "Twitter": "Twitter",
    "Type": "Tipo",
    "Type the key for the metadata": "Digite a chave para os metadados.",
    "Type the text to match rule": "Digite o texto que corresponde à regra.",
    "Type*": "Tipo*",
    "URL": "URL",
    "URL must start with a protocol. Ex. http://....": "A URL deve começar com um protocolo. Ex.: http://....",
    "URL to redirect to if form is valid": "URL para redirecionar se o formulário for válido",
    "URL:": "URL:",
    "Unable to read link": "Não foi possível ler o link.",
    "Unarchive": "Desarquivar",
    "Undetermined": "Indeterminado",
    "Undo": "Desfazer",
    "Undo review": "Desfazer revisão",
    "Unignore": "Ignorar",
    "Unignore check": "Designorar verificação",
    "Unignore misspelling": "Ignore erros de ortografia",
    "Unignore on this page": "Remover desta página",
    "Unignore this SEO issue": "Deixe de ignorar este problema de SEO",
    "Unignore this check for this domain": "Desfazer esta verificação para este domínio",
    "Unique Visitors": "Visitantes únicos",
    "Unique downloads": "Downloads únicos",
    "Unknown": "Desconhecido",
    "Unknown Score": "Pontuação desconhecida",
    "Unknown title": "Título desconhecido",
    "Unpin domain": "Desafixar domínio",
    "Unsaved changes": "Alterações não salvas",
    "Unwanted": "Indesejável",
    "Unwanted content": "Conteúdo indesejado",
    "Unwanted violations": "violações indesejadas",
    "Update": "Atualizar",
    "Update groups": "Grupos de atualização",
    "Updated": "Atualizado",
    "Updated At": "Atualizado em",
    "Updated at": "Atualizado em",
    "Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.": "A atualização de grupos pode demorar mais de 30 minutos. Durante essa operação, você não poderá criar nem atualizar grupos.",
    "Upload CSV": "Carregar arquivo CSV",
    "Upload csv file": "Carregar arquivo CSV",
    "Uptime": "Tempo de atividade",
    "Uptime last 30 days": "Tempo de atividade nos últimos 30 dias",
    "Url*": "URL*",
    "Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors": "Use * como um caractere curinga (ex.: 192.168.1.*). Os endereços IP excluídos afetarão apenas os novos visitantes.",
    "Use language attribute": "Usar atributo de idioma",
    "Use or Apply custom PageCorrect": "Use ou aplique PageCorrect personalizado",
    "User": "Usuário",
    "User Export": "Exportação do usuário",
    "User List": "Lista de usuários",
    "User Loading Experience": "Experiência de carregamento do usuário",
    "User information": "Informações do usuário",
    "User interface components and navigation must be operable.": "Os componentes da interface do usuário e a navegação devem estar operacionais.",
    "User is account administrator": "O usuário é administrador da conta.",
    "Username": "Nome de usuário",
    "Value": "Valor",
    "Value*": "Valor*",
    "Vat no": "Número de IVA",
    "Verify URL*": "Verificar URL*",
    "Very easy": "Muito fácil",
    "Very hard": "Muito difícil",
    "View options": "Opções de visualização",
    "Viewing as Profile:": "Visualizando como perfil:",
    "Views": "Vistas",
    "Violation": "Violação",
    "Violation count": "Contagem de violações",
    "Violation's info_type name not set": "O nome do tipo de informação da violação não foi definido.",
    "Violations": "Violações",
    "Visible": "Visível",
    "Visible modules": "Módulos visíveis",
    "Visit the affected image": "Visite a imagem afetada.",
    "Visitor Overview": "Visão geral do visitante",
    "Visitor Summary": "Resumo do visitante",
    "Visitor log": "Registro de visitantes",
    "Visitor profile": "Perfil do visitante",
    "Visitor profile:": "Perfil do visitante:",
    "Visitors": "Visitantes",
    "Visitors Summary": "Resumo dos visitantes",
    "Visits": "Visitas",
    "Visual mode": "Modo visual",
    "WCAG 2.0 (Level A)": "WCAG 2.0 (Nível A)",
    "WCAG 2.0 (Level AA)": "WCAG 2.0 (Nível AA)",
    "WCAG 2.0 (Level AAA)": "WCAG 2.0 (Nível AAA)",
    "WCAG 2.0 Accessibility Compliance": "Conformidade com as diretrizes de acessibilidade WCAG 2.0",
    "WCAG 2.1 (Level A)": "WCAG 2.1 (Nível A)",
    "WCAG 2.1 (Level AA)": "WCAG 2.1 (Nível AA)",
    "WCAG 2.1 (Level AAA)": "WCAG 2.1 (Nível AAA)",
    "WCAG 2.1 Accessibility Compliance": "Conformidade com as diretrizes de acessibilidade WCAG 2.1",
    "Want to search for": "Deseja pesquisar por",
    "Warning": "Aviso",
    "We recommend that all your pages has a number of relevant meta keywords.": "Recomendamos que todas as suas páginas contenham uma série de meta palavras-chave relevantes.",
    "We recommend that all your pages has a relevant and unique meta description.": "Recomendamos que todas as suas páginas tenham uma meta descrição relevante e exclusiva.",
    "We recommend that all your pages has an unique title.": "Recomendamos que todas as suas páginas tenham um título único.",
    "We recommend that the meta description consists of at least 50 characters.": "Recomendamos que a meta descrição tenha pelo menos 50 caracteres.",
    "We recommend that the meta description consists of no more than 160 characters.": "Recomendamos que a meta descrição não tenha mais de 160 caracteres.",
    "We recommend that you give each page a unique title.": "Recomendamos que você dê um título único a cada página.",
    "We recommend that you have a unique H1 tag on each page.": "Recomendamos que você utilize uma tag H1 exclusiva em cada página.",
    "We recommend that you have at least one H2-H6": "Recomendamos que você tenha pelo menos um H2-H6.",
    "We recommend that you have no more than 100 internal links on each page.": "Recomendamos que você não tenha mais de 100 links internos em cada página.",
    "We recommend that you keep your URL below 200 characters.": "Recomendamos que você mantenha seu URL com menos de 200 caracteres.",
    "We recommend that you only have one H1 tag on each page.": "Recomendamos que você tenha apenas uma tag H1 em cada página.",
    "Wednesday": "Quarta-feira",
    "Weekly": "Semanalmente",
    "Well done - no accessibility issues found": "Muito bem! Nenhum problema de acessibilidade foi encontrado.",
    "We’ve Updated our Privacy Policy!": "Atualizamos nossa Política de Privacidade!",
    "Why is this an issue": "Por que isso é um problema?",
    "With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go": "Com o Fast Track, você pode corrigir, revisar e ignorar trechos de HTML nas páginas afetadas, tudo de uma só vez.",
    "Word": "Palavra",
    "Word Count": "Contagem de palavras",
    "Word count": "Contagem de palavras",
    "Word count in PDF": "Contagem de palavras em PDF",
    "Word is added to dictionary": "A palavra foi adicionada ao dicionário.",
    "Word is added to dictionary for all languages": "A palavra foi adicionada ao dicionário para todos os idiomas.",
    "Word is confirmed as misspelling": "A palavra está confirmada como sendo um erro ortográfico.",
    "Word length": "Comprimento da palavra",
    "Word links": "Links de palavras",
    "Word or Phrase": "Palavra ou frase",
    "Words": "Palavras",
    "Would you like to update now? Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups": "Deseja atualizar agora? A atualização de grupos pode levar mais de 30 minutos. Durante essa operação, você não poderá criar nem atualizar grupos.",
    "Written by: [[author]]": "Escrito por: [[author]]",
    "Years": "Anos",
    "You are about to delete": "Você está prestes a excluir",
    "You are about to delete the domain": "Você está prestes a excluir o domínio.",
    "You are about to delete the domain group": "Você está prestes a excluir o grupo de domínio.",
    "You are currently using Demo Data, certain features will be unavailable": "Você está usando dados de demonstração; alguns recursos estarão indisponíveis.",
    "You are receiving this report": "Você está recebendo este relatório.",
    "You can create another [[customerProfilesLimit]] profiles for your account": "Você pode criar mais [[customerProfilesLimit]] perfis para sua conta.",
    "You can pin this domain. Pinned domains will be shown at the top of your domain list": "Você pode fixar este domínio. Os domínios fixados serão exibidos no topo da sua lista de domínios.",
    "You have more than one H1 tag on this page": "Você tem mais de uma tag H1 nesta página.",
    "You have no H2-H6 tags on the page": "Você não tem tags H2-H6 na página.",
    "You have no available profiles": "Você não possui perfis disponíveis.",
    "You have not received any reports": "Você não recebeu nenhum relatório.",
    "You have one or more pages with the \\\"noindex\\\" META tag": "Você tem uma ou mais páginas com a tag META &quot;noindex&quot;.",
    "You have reached the maximum number of profiles for this account.": "Você atingiu o número máximo de perfis para esta conta.",
    "You have too many internal links": "Você tem muitos links internos.",
    "You will receive an email when the export is ready.": "Você receberá um e-mail quando a exportação estiver pronta.",
    "Your Users Technology": "Tecnologia para seus usuários",
    "Zero links were found": "Não foram encontrados links.",
    "Zip code": "CEP",
    "achieved": "alcançou",
    "affected image": "imagem afetada",
    "and": "e",
    "and does not conform with": "e não está em conformidade com",
    "contact": "contato",
    "contains": "contém",
    "content": "contente",
    "diagnostics_errors.csv": "diagnósticos_erros.csv",
    "diagnostics_passed.csv": "diagnósticos_aprovados.csv",
    "disabling": "desativando",
    "document": "documento",
    "documents": "documentos",
    "done": "feito",
    "enabling": "permitindo",
    "ends_with": "termina_com",
    "excluded": "excluído",
    "go to the matched link": "Acesse o link correspondente.",
    "image": "imagem",
    "included": "incluído",
    "insert brand name": "inserir nome da marca",
    "insert context fx. us": "inserir contexto fx. nós",
    "insert max word length": "inserir comprimento máximo da palavra",
    "insert word fx. contact": "inserir palavra fx. contato",
    "is": "é",
    "is_exactly": "é_exatamente",
    "language": "linguagem",
    "link": "link",
    "match (regex)": "correspondência (regex)",
    "metadata": "metadados",
    "milliseconds": "milissegundos",
    "minutes": "minutos",
    "n/a": "n / D",
    "not": "não",
    "opportunities_errors.csv": "erros_de_oportunidades.csv",
    "opportunities_passed.csv": "oportunidades_passadas.csv",
    "overall compliance": "conformidade geral",
    "pages": "páginas",
    "path": "caminho",
    "please type": "Por favor, digite",
    "reviewed": "revisado",
    "rows - click to change": "linhas - clique para alterar",
    "search engines overview": "Visão geral dos mecanismos de busca",
    "should always be followed by": "deve sempre ser seguido por",
    "social network overview": "visão geral da rede social",
    "starts_with": "começa_com",
    "that": "que",
    "title": "título",
    "to confirm this action": "para confirmar esta ação",
    "to fix": "para consertar",
    "url": "URL",
    "us": "nós",
    "visits": "visitas",
    "you have one or more pages that contains links with rel=\\\"nofollow\\\"": "Você tem uma ou mais páginas que contêm links com rel=&quot;nofollow&quot;.",
    "{{ pagesDone }} Pages ({{ compliancePercentage }}) in compliance": "{{ pagesDone }} Páginas ({{ compliancePercentage }}) em conformidade",
    "{{ totalPageIssues }} Pages ({{ compliancePercentage }}) to fix": "{{ totalPageIssues }} Páginas ({{ compliancePercentage }}) a corrigir",
    "[[label]]: [[value]] Pages": "[[label]]: [[value]] Páginas",
    "[[label]]: [[value]]ms": "[[label]]: [[value]]ms",
    "[[languageName]] ([[languageCount]])": "[[languageName]] ([[languageCount]])",
    "[[ms]] ms": "[[ms]] ms",
    "[[name]] have already been scanned for compliance. Are you sure you want to scan it again?": "[[name]] já foi verificado quanto à conformidade. Tem certeza de que deseja verificá-lo novamente?",
    "[[pageCount]] Pages": "[[pageCount]] Páginas",
    "[[pageCount]] pages found with this issue": "[[pageCount]] páginas encontradas com este problema",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nível A)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nível AA)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nível AAA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nível A)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nível AA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nível AAA)",
    "1 found": [
      "1 encontrado",
      "[[$count]] encontrados",
      ""
    ],
    "1 issue found": [
      "1 problema encontrado",
      "[[$count]] problemas encontrados",
      ""
    ],
    "1 word found": [
      "1 palavra encontrada",
      "[[$count]] palavras encontradas",
      ""
    ],
    "Total: 1 Performance Page": [
      "Total: 1 Página de desempenho",
      "Totasl: [[$count]] Páginas de desempenho",
      ""
    ],
    "You have 1 to do": [
      "Você tem 1 para fazer",
      "Você tem [[issues]] para fazer",
      ""
    ],
    "page": "página",
    "Are you sure you want to remove Custom PageCorrect? <br> Please type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Tem certeza de que deseja remover o PageCorrect personalizado?<br> Digite [[deleteTag]]Excluir[[deleteTagEnd]] para confirmar esta ação.",
    "You are about to remove PageCorrect for this check <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Você está prestes a remover o PageCorrect para esta verificação.<br> Digite [[deleteTag]]Excluir[[deleteTagEnd]] para confirmar esta ação.",
    "You are about to remove PageCorrect for this misspelling <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Você está prestes a remover o PageCorrect devido a este erro ortográfico.<br> Digite [[deleteTag]]Excluir[[deleteTagEnd]] para confirmar esta ação.",
    "You are about to remove PageCorrect for this [[type]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Você está prestes a remover o PageCorrect para este [[type]]<br> Digite [[deleteTag]]Excluir[[deleteTagEnd]] para confirmar esta ação.",
    "You are about to remove [[titleTag]][[title]][[titleTagEnd]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Você está prestes a remover [[titleTag]][[title]][[titleTagEnd]]<br> Digite [[deleteTag]]Excluir[[deleteTagEnd]] para confirmar esta ação.",
    "Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it's place": "Tem certeza de que deseja revogar o token para o usuário da API [[apiUserId]]?<br> <strong>Observação:</strong> Um novo token será criado em seu lugar.",
    "Maximum critical path latency: <strong>[[latency]] ms </strong>": "Latência máxima do caminho crítico: <strong>[[latency]] ms</strong>",
    "Are you sure you want to remove <code>all</code> [[type]] PageCorrects? <br> Please type <code>Delete</code> to confirm this action": "Tem certeza de que deseja remover <code>all</code> os PageCorrects do tipo [[type]]?<br> Digite <code>Delete</code> para confirmar esta ação.",
    "<strong>[[checkName]]</strong><br><br>Add reason (Optional)": "<strong>[[checkName]]</strong><br><br> Adicionar motivo (Opcional)",
    "Are you sure you want to confirm the misspelling <strong>' + word.word + '</strong>?": "Tem certeza de que deseja confirmar o erro ortográfico <strong>&#39; + palavra.palavra + &#39;</strong> ?",
    "Are you sure you want to delete the policy <strong>[[policyName]]</strong>": "Tem certeza de que deseja excluir a política <strong>[[policyName]]?</strong>",
    "Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?": "Tem certeza de que deseja marcar a política <strong>[[policyName]]</strong> como fixa?",
    "Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>": "Tem certeza de que deseja remover a regra do mapa de calor de <strong>[[pageUrl]]?</strong>",
    "Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?": "Tem certeza de que deseja remover a regra <strong>&#39; + rule.name + &#39;</strong> ?",
    "Are you sure you want to run the policy <strong>' + policy.name + '</strong>?": "Tem certeza de que deseja executar a política <strong>&#39; + policy.name + &#39;</strong> ?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong> again?": "Tem certeza de que deseja executar a política <strong>[[policyName]]</strong> novamente?",
    "Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?": "Tem certeza de que deseja reverter a política ignorada <strong>[[policyName]]</strong> ?",
    "You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.": "Você tem atualmente <strong>[[spellingFixes]]</strong> correções de erros ortográficos. Recomendamos que você mantenha esse número abaixo de <strong>[[spellingLimit]]</strong> para garantir que a página seja exibida sem problemas.",
    "You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.": "Atualmente, você tem <strong>[[totalFixes]]</strong> correções. Recomendamos limitar o número de correções para <strong>[[pageFixLimit]]</strong> para garantir o melhor desempenho da página; no entanto, essa decisão é sua.",
    "[[users]]<strong>and [[userCountLeft]] more</strong>": "[[users]] <strong>e [[userCountLeft]] mais</strong>",
    "Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?": "Tem certeza de que deseja ignorar a política <strong>[[policyName]]</strong> ?",
    "Title:": "Título:",
    "[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]": "[[msg]] <strong>[[regulationName]]</strong> fará com que as regras personalizadas [[opposite]] para os seguintes problemas sejam sobrescritas, o que significa que elas serão [[negate]] sinalizadas por verificações futuras: [[list]]",
    "Admin only": "Somente para administradores",
    "Apply fix": "Aplicar correção",
    "Contains high, medium or low opportunities": "Contém oportunidades de alto, médio ou baixo nível.",
    "Design": "Projeto",
    "Enable Custom PageCorrect Settings": "Ativar configurações personalizadas do PageCorrect",
    "Enable PageCorrect features below. Disabled features will not be shown on your dashboard.": "Ative os recursos do PageCorrect abaixo. Os recursos desativados não serão exibidos no seu painel.",
    "Enable PageCorrect for Accessibility Source Codes": "Ative o PageCorrect para códigos-fonte de acessibilidade.",
    "Enable PageCorrect for Broken Links": "Ative o PageCorrect para links quebrados.",
    "Enable PageCorrect for Misspellings": "Ative a correção de erros ortográficos na página.",
    "Enable PagedCorrect for Accessibility Checks": "Ative o PagedCorrect para verificações de acessibilidade.",
    "Failing checks - A": "Verificações com falha - A",
    "Failing checks - AA": "Verificações reprovadas - AA",
    "Failing checks - AAA": "Verificações reprovadas - AAA",
    "Good job! Your domain contains no Accessibility Issues for this section": "Ótimo trabalho! Seu domínio não apresenta problemas de acessibilidade nesta seção.",
    "Indicates the difficulty to apply this fix": "Indica a dificuldade em aplicar esta correção.",
    "List of improvements that can be applied to your website to improve your Accessibility Compliance": "Lista de melhorias que podem ser aplicadas ao seu site para melhorar a sua conformidade com a acessibilidade.",
    "Manage": "Gerenciar",
    "Media": "Mídia",
    "Open PageCorrect Settings": "Abrir páginaCorrigir configurações",
    "PageCorrect Settings Updated": "Configurações do PageCorrect atualizadas",
    "PageCorrect settings": "Configurações corretas da página",
    "Pages with Data Privacy violations": "Páginas com violações de privacidade de dados",
    "Should admin be the only one to set PageCorrect Settings": "Somente o administrador deve definir as configurações do PageCorrect?",
    "Website Structure": "Estrutura do site",
    "Data Privacy violations": "Violações de privacidade de dados",
    "Heartbeat check": "Verificação dos batimentos cardíacos",
    "Request PDF accessibility check from selection": "Solicitar verificação de acessibilidade do PDF a partir da seleção",
    "Total unique downloads": "Total de downloads únicos",
    "[[succeededPdfs]] out of [[pdfs]] PDF accessibility request succeeded": "[[succeededPdfs]] de [[pdfs]] Solicitação de acessibilidade de PDF concluída com sucesso",
    "Accessibility Issues": "Problemas de acessibilidade",
    "Inspecting:": "Inspecionando:",
    "Pages with Accessibility Issues": "Páginas com problemas de acessibilidade",
    "Start advance export": "Iniciar exportação avançada",
    "Check whether your website is responding and measures the response times of the server": "Verifique se o seu site está respondendo e meça os tempos de resposta do servidor.",
    "Search label": "Etiqueta de pesquisa",
    "Custom range": "Gama personalizada",
    "Last Half Year": "Último semestre",
    "Last Month": "Mês passado",
    "Last Quarter": "Último trimestre",
    "Last Week": "Semana passada",
    "Last Year": "Ano passado",
    "Character": [
      "Caracter",
      "Caracteres",
      ""
    ],
    "Image missing alt attribute": "Imagem sem atributo alt",
    "Quick info here": "Informações rápidas aqui",
    "There is 1 META description on this page": "Esta página contém 1 descrição META.",
    "There is 1 internal link on this page": [
      "Esta página contém 1 link interno.",
      "Esta página contém [[$count]] links internos.",
      ""
    ],
    "There is one META description on this page": [
      "Há uma meta descrição nesta página.",
      "Descrições META nesta página",
      ""
    ],
    "and 1 document": {
      "Documents with broken images": [
        "e 1 documento",
        "e [[count]] documentos",
        ""
      ],
      "Documents with confirmed misspellings": [
        "e 1 documento",
        "e [[count]] documentos",
        ""
      ],
      "Documents with potential misspellings": [
        "e 1 documento",
        "e [[count]] documentos",
        ""
      ]
    },
    "and one document": {
      "Pages with broken links": [
        "e um documento",
        "e [[$count]] documentos",
        ""
      ]
    },
    "Remediation": "Remediação",
    "Remediation quote": "Orçamento de remediação",
    "Remediation quote has been requested": "Foi solicitado um orçamento para a remediação.",
    "Sort by": {
      "Exchange center filter option": "Ordenar por"
    },
    "#idname.class-name1.class-name2": "#idname.class-name1.class-name2",
    "&lt;i&gt; tags as icons": "&lt;i&gt; tags como ícones",
    ".class-name1": ".nome-da-classe1",
    "<strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)": "<strong>Estilo CSS para a tag &lt;strong&gt;</strong> (tornar todo o texto em negrito vermelho)",
    "<strong>NOTE</strong>: Changing the text below, will override the text in all your included languages": "<strong>NOTA</strong> : Alterar o texto abaixo substituirá o texto em todos os idiomas incluídos.",
    "A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations": "Uma versão mais recente do PageAssist está disponível. Alterne para a versão 2.0 para ter acesso às novas opções de personalização.",
    "Accessibility Fixes": "Correções de acessibilidade",
    "Add Policy": "Adicionar política",
    "Add a description of the widget to your users": "Adicione uma descrição do widget para seus usuários.",
    "Add comment (Optional)": "Adicionar comentário (Opcional)",
    "Add row": "Adicionar linha",
    "Add text for when the button is hovered": "Adicione um texto para ser exibido quando o cursor estiver sobre o botão.",
    "Add title": "Adicionar título",
    "Africa": "África",
    "All <code>img</code> elements have an <code>alt</code> attribute": "Todos os elementos <code>img</code> possuem um atributo <code>alt</code>",
    "Alt text does not convey the same information as the image": "O texto alternativo não transmite a mesma informação que a imagem.",
    "Alt text for all <code>img</code> elements contains all text in the image unless the image text is decorative or appears elsewhere in the document": "O texto alternativo (alt text) de todos os elementos <code>img</code> contém todo o texto da imagem, a menos que o texto da imagem seja decorativo ou apareça em outro lugar no documento.",
    "Alt text for all <code>img</code> elements is not placeholder text unless author has confirmed it is correct": "O texto alternativo para todos os elementos <code>img</code> não é um texto de espaço reservado, a menos que o autor tenha confirmado que está correto.",
    "Alt text for all <code>img</code> elements is the empty string (\\\"\\\") if the image is decorative.": "O texto alternativo para todos os elementos <code>img</code> é a string vazia (&quot;\\&quot;) se a imagem for decorativa.",
    "Alt text for all <code>img</code> elements used as source anchors is not empty when there is no other text in the anchor": "O texto alternativo para todos os elementos <code>img</code> usados ​​como âncoras de origem não fica vazio quando não há outro texto na âncora.",
    "Alt text is not the same as the filename unless author has confirmed it is correct": "O texto alternativo não é o mesmo que o nome do arquivo, a menos que o autor tenha confirmado que está correto.",
    "And how are we going to fix it?": "E como vamos resolver isso?",
    "Applying fix": "Aplicando correção",
    "Are you sure you want to stop receiving this report?": "Tem certeza de que deseja parar de receber este relatório?",
    "Aria-label": "Rótulo Aria",
    "Asia": "Ásia",
    "Blink sample image": "Imagem de exemplo do Blink",
    "Blink testing sample image": "Imagem de exemplo do teste Blink",
    "Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.": "Na prática, ambos os problemas podem causar diversos problemas visuais, desde cores incorretas até espaços estranhos onde não deveriam existir.",
    "Bottom center": "Centro inferior",
    "Bottom left": "Canto inferior esquerdo",
    "Bottom right": "Canto inferior direito",
    "Browse": "Navegar",
    "Button hover message": "mensagem ao passar o cursor sobre o botão",
    "CSS selector": "Seletor CSS",
    "Change <b> tags to a custom element": "Alterar <b>tags para um elemento personalizado</b>",
    "Change <b> tags to a custom tag": "Alterar <b>tags para uma tag personalizada</b>",
    "Change <blink> tags to a custom element": "Mudar<blink> tags para um elemento personalizado",
    "Change <blink> tags to a custom tag": "Mudar<blink> tags para uma tag personalizada",
    "Change <marquee> tags to a custom element": "Mudar<marquee> tags para um elemento personalizado",
    "Change <marquee> tags to a custom tag": "Mudar<marquee> tags para uma tag personalizada",
    "Change your &lt;blink&gt; tags into something else": "Altere suas tags &lt;blink&gt; para outra coisa.",
    "Change your &lt;i&gt; elements into something else": "Altere seus elementos &lt;i&gt; para outra coisa.",
    "Change your &lt;marquee&gt; tags into something else": "Altere suas tags &lt;marquee&gt; para outra coisa.",
    "Check for misspelling company name: [[company]]": "Verificar se o nome da empresa está escrito incorretamente: [[company]]",
    "Choose a tag to replace your b tags with": "Escolha uma etiqueta para substituir suas etiquetas b.",
    "Choose a tag to replace your blink tags with": "Escolha uma etiqueta para substituir suas etiquetas Blink.",
    "Choose a tag to replace your italic tags with": "Escolha uma etiqueta para substituir suas etiquetas em itálico.",
    "Choose a tag to replace your marquee tags with": "Escolha uma etiqueta para substituir as etiquetas da sua marquise.",
    "Choose an icon": "Escolha um ícone",
    "Choose this option to customise the fix": "Selecione esta opção para personalizar a correção.",
    "Choose this option to customize the fix": "Escolha esta opção para personalizar a correção.",
    "Choose your own text for the warning pop-up": "Escolha o seu próprio texto para a janela de aviso.",
    "Circle": "Círculo",
    "Class": "Aula",
    "Close PageCorrect form": "Fechar páginaFormulário correto",
    "Close [[groupName]]: [[labelName]]": "Fechar [[groupName]]: [[labelName]]",
    "Company name *": "Nome da empresa *",
    "Constraint:": "Restrição:",
    "Custom settings": "Configurações personalizadas",
    "Default fix": "Correção padrão",
    "Default language": "Idioma padrão",
    "Dutch": "Holandês",
    "Edit Report": "Editar relatório",
    "Education": "Educação",
    "Element name is invalid": "O nome do elemento é inválido.",
    "Element name should not contain spaces": "O nome do elemento não deve conter espaços.",
    "Enter aria-label name": "Insira o nome do rótulo ARIA",
    "Enter class name": "Digite o nome da turma",
    "Enter role name": "Digite o nome da função",
    "Europe": "Europa",
    "Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:": "Embora essa seja uma correção bastante simples, existem duas maneiras pelas quais isso pode causar problemas de design no seu site:",
    "Example 1": "Exemplo 1",
    "Example 2": "Exemplo 2",
    "File must be below 1MB": "O arquivo deve ter menos de 1 MB.",
    "Filter dropdown": "Menu suspenso de filtro",
    "Finance": "Financiar",
    "Fix applied!": "Correção aplicada!",
    "Fix options": "Opções de correção",
    "French": "Francês",
    "Give a title to your Skip to Content button": "Dê um título ao seu botão &quot;Pular para o conteúdo&quot;.",
    "Government": "Governo",
    "Grid view": "Visualização em grade",
    "Hide": "Esconder",
    "Hide text": "Ocultar texto",
    "Hitting the tab button will turn on Skip to PageAssist": "Ao pressionar a tecla Tab, o recurso &quot;Pular para o Assistente de Página&quot; será ativado.",
    "How are we going to fix it?": "Como vamos resolver isso?",
    "Icon shape": "Formato de ícone",
    "Image Alt text is short": "O texto alternativo da imagem é curto.",
    "Important images should not have spacer Alt text": "Imagens importantes não devem ter texto alternativo (Alt text) com espaçamento.",
    "Info": "Informações",
    "Insert company name": "Insira o nome da empresa",
    "Instead of &lt;i&gt; choose a different element name to be used instead": "Em vez de &lt;i&gt;, escolha um nome de elemento diferente para ser usado.",
    "It will take some time before our system will register your changes to PageCorrect": "Levará algum tempo até que nosso sistema registre suas alterações no PageCorrect.",
    "Left middle": "Meio à esquerda",
    "Letter case *": "Letras maiúsculas *",
    "Light": "Luz",
    "Link excludes:": "O link exclui:",
    "Loading PageFix": "Carregando PageFix",
    "Make sure you use correct formatting and add multiple selectors when your page design differs": "Certifique-se de usar a formatação correta e adicionar vários seletores quando o design da sua página for diferente.",
    "Manage options": "Gerenciar opções",
    "Marquee sample image": "Imagem de exemplo de letreiro",
    "Marquee testing sample image": "Imagem de exemplo para teste de marquee",
    "Menu theme": "Tema do menu",
    "New Window Information": "Informações da nova janela",
    "New Window Test": "Novo teste de janela",
    "Non-Decorative images must have Alt text": "Imagens não decorativas devem ter texto alternativo.",
    "North America": "América do Norte",
    "PageAssist Logo": "Logotipo do PageAssist",
    "PageAssist position on Page": "Posição do PageAssist na página",
    "Portuguese": "Português",
    "Potential problems that can arise": "Possíveis problemas que podem surgir",
    "Press 'Upload link' to save your URL settings": "Pressione &#39;Carregar link&#39; para salvar suas configurações de URL.",
    "Preview": "Pré-visualização",
    "Proper Case": "Caso apropriado",
    "Remove input selector": "Remover seletor de entrada",
    "Remove logo upload": "Remover upload de logotipo",
    "Remove row": "Remover linha",
    "Repair Tip": "Dica de reparo",
    "Repair options": "Opções de reparo",
    "Replace Italic element with EM": "Substitua o elemento em itálico por EM",
    "Replace all &lt;b&gt; tags with": "Substitua todas as tags &lt;b&gt; por",
    "Replace all &lt;blink&gt; tags with": "Substitua todas as tags &lt;blink&gt; por",
    "Replace all &lt;i&gt; tags": "Substitua todas as tags &lt;i&gt;",
    "Replace all &lt;marquee&gt; tags with": "Substitua todas as tags &lt;marquee&gt; por",
    "Report Center Image": "Imagem do Centro de Relatórios",
    "Reset Input": "Redefinir entrada",
    "Reset Skip to content text to its default": "Redefinir o texto &quot;Pular para o conteúdo&quot; para o valor padrão.",
    "Reset design": "Redefinir design",
    "Reset to default": "Restaurar para as configurações padrão",
    "Restore": "Restaurar",
    "Restore profile?": "Restaurar perfil?",
    "Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.": "Restaurar este perfil <strong>([[profileName]])</strong> o tornará disponível em seus módulos.",
    "Right middle": "Meio à direita",
    "Rounded Box": "Caixa arredondada",
    "Russian": "russo",
    "Show": "Mostrar",
    "Show details": "Mostrar detalhes",
    "Show text": "Mostrar texto",
    "Simplified Chinese": "Chinês simplificado",
    "Skip to Content": "Ir para o conteúdo",
    "Snippet reset": "Redefinição de trecho",
    "Someone have created this PageCorrect before you, on another check.": "Alguém já criou esta página PageCorrect antes de você, em outra verificação.",
    "Spanish Mexican": "Espanhol Mexicano",
    "Start export inventory emails": "Iniciar e-mails de exportação de inventário",
    "Start export inventory emails extended": "O início da exportação de e-mails de inventário foi estendido.",
    "Testing": "Testando",
    "The subpath/subfolder the WordPress installation is under": "O subdiretório/subpasta onde o WordPress está instalado.",
    "This fix requires development knowledge": "Essa correção requer conhecimento de desenvolvimento.",
    "This message will be displayed when the user hovers over the PageAssist button": "Esta mensagem será exibida quando o usuário passar o cursor sobre o botão PageAssist.",
    "This option might cause problems to your icons": "Essa opção pode causar problemas aos seus ícones.",
    "Title Text": "Texto do título",
    "To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check": "Para configurar esta política, você precisa nos informar o nome da empresa e o tipo de letra maiúscula ou minúscula que deseja verificar em caso de erro ortográfico.",
    "Top center": "Centro superior",
    "Top left": "Canto superior esquerdo",
    "Top right": "Canto superior direito",
    "Trying out the pop-up": "Testando o pop-up",
    "UPPERCASE": "MAIÚSCULAS",
    "Undo check review": "Desfazer verificação de revisão",
    "Upload link": "Link para upload",
    "Upload logo": "Carregar logotipo",
    "Use Datepicker": "Use o seletor de datas",
    "Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>": "Use o PageCorrect para corrigir o seguinte erro ortográfico: <code>[[misspelling]]</code>",
    "Use PageCorrect to fix Broken Link": "Use o PageCorrect para corrigir links quebrados.",
    "Use PageCorrect to fix these image sources": "Use o PageCorrect para corrigir essas fontes de imagem.",
    "Value:": "Valor:",
    "View": "Visualizar",
    "What is wrong with the &lt;b&gt; (bold) element?": "O que há de errado com o elemento &lt;b&gt; (negrito)?",
    "What is wrong with the &lt;i&gt; (italic) element?": "O que há de errado com o elemento &lt;i&gt; (itálico)?",
    "What to do when the link doesn't work?": "O que fazer quando o link não funciona?",
    "What to do when things look wrong?": "O que fazer quando as coisas parecem erradas?",
    "Why shouldn't I use the blink element?": "Por que eu não deveria usar o elemento blink?",
    "Widget Design and Text": "Design e texto do widget",
    "Widget Icon Setup": "Configuração do ícone do widget",
    "Without any assigned class": "Sem nenhuma classe atribuída",
    "Write a warning to your outbound link": "Escreva um aviso para o seu link de saída.",
    "Write custom tag": "Escreva uma etiqueta personalizada",
    "lowercase": "minúsculas",
    "with": "com",
    "with &lt;em&gt;": "com &lt;em&gt;",
    "Statistics is using sample data": "Estatística utiliza dados amostrais.",
    "Statistics results are sample data for demo purposes - export is disabled": "Os resultados estatísticos são dados de amostra para fins de demonstração - a exportação está desativada.",
    "This section is using sample data": "Esta seção utiliza dados de exemplo.",
    "&lt;i&gt; tags with these attribute values will not be changed": "As tags &lt;i&gt; com esses valores de atributo não serão alteradas.",
    "(Bad)": "(Ruim)",
    "(Good)": "(Bom)",
    "<span class=\\\"mr-2\\\">Pages</span>": "<span class=\\\"mr-2\\\">Páginas</span>",
    "Add API user": "Adicionar usuário da API",
    "Add attributes to be excluded in this change": "Adicione os atributos a serem excluídos nesta alteração.",
    "Add profile": "Adicionar perfil",
    "Add source code exclude": "Adicionar código-fonte excluir",
    "Are you sure?": "Tem certeza?",
    "Button hover color": "Cor do botão ao passar o cursor",
    "Calculated by no. and severity of issues, page views and links leading to this page..": "Calculado com base no número e na gravidade dos problemas, visualizações da página e links que levam a esta página.",
    "Choose minimum word count for a page to be included in the readability test": "Escolha o número mínimo de palavras para que uma página seja incluída no teste de legibilidade.",
    "Color contrast ratio": "relação de contraste de cores",
    "Content id tag": "Tag de identificação do conteúdo",
    "Creation date": "Data de criação",
    "Custom text": "Texto personalizado",
    "Customise the Information page": "Personalize a página de informações.",
    "Disable": "Desativar",
    "Docs without downloads": "Documentos sem necessidade de download",
    "Documents Without Downloads": "Documentos sem necessidade de download",
    "EPI Server Path": "Caminho do servidor EPI",
    "EPIServer": "Servidor EPI",
    "Editor": "Editor",
    "Ex: data-currentpage, or data-pageid, or CurrentPageLink": "Ex: data-currentpage, ou data-pageid, ou CurrentPageLink",
    "Ex: lang or CurrentPageLanguage": "Ex: lang ou CurrentPageLanguage",
    "Export both pages and documents": "Exporte tanto as páginas quanto os documentos.",
    "Export only documents without downloads": "Exportar somente documentos, sem fazer downloads.",
    "Export only html pages without visits": "Exportar apenas páginas HTML sem visitas",
    "Include Accessibility Statement": "Incluir declaração de acessibilidade",
    "Include custom info text": "Incluir texto informativo personalizado",
    "Includes a button with a link to your accessibility statement": "Inclui um botão com um link para a sua declaração de acessibilidade.",
    "Indicates which language this page will be scanned in. Click underneath to change": "Indica o idioma em que esta página será digitalizada. Clique abaixo para alterar.",
    "Insert a valid URL": "Insira um URL válido",
    "Language tag": "Etiqueta de idioma",
    "Last assigned profile on page. Page will be removed from Performance": "Último perfil atribuído na página. A página será removida do Desempenho.",
    "Link color": "Cor do link",
    "Link opens in a new tab": "O link abre em uma nova aba.",
    "Main color": "Cor principal",
    "Meta name": "Nome Meta",
    "Mode": "Modo",
    "No default profile selected for this page, scoring not available.": "Nenhum perfil padrão foi selecionado para esta página; a pontuação não está disponível.",
    "No documents found": "Nenhum documento encontrado",
    "No profiles selected for this page, scoring not available.": "Nenhum perfil selecionado para esta página, pontuação não disponível.",
    "Not a valid CSS selector": "Seletor CSS inválido",
    "Notification when the downtime ends": "Notificação quando o período de inatividade terminar",
    "Number of external links": "Número de links externos",
    "Number of incoming links": "Número de links de entrada",
    "Open details": "Abrir detalhes",
    "PDF Accessibility": "Acessibilidade do PDF",
    "Passwords do not match": "As senhas não coincidem.",
    "Please add a Default Profile to your Page": "Adicione um perfil padrão à sua página.",
    "Please add a Profile to your Page": "Adicione um perfil à sua página.",
    "Please enter a valid color code": "Por favor, insira um código de cor válido.",
    "Please perform a PDF scan to see the results for the checks below": "Por favor, faça uma digitalização em PDF para ver os resultados das verificações abaixo.",
    "Setup": "Configurar",
    "Show less of the code snippet": "Mostrar menos do trecho de código",
    "Show the full code snippet": "Mostrar o trecho de código completo",
    "Statistics not activated. Page Views not available.": "Estatísticas não ativadas. Visualizações de página não disponíveis.",
    "Subdomain": "Subdomínio",
    "Subdomain url": "URL do subdomínio",
    "Superfast - Don't use unless you know what you're doing": "Super-rápido - Não use a menos que saiba o que está fazendo.",
    "Text color": "Cor do texto",
    "The optional epi server path": "O caminho opcional do servidor epi",
    "The subdomain url to the CMS page": "O URL do subdomínio para a página do CMS",
    "This text must be under 1000 characters": "Este texto deve ter menos de 1000 caracteres.",
    "Two-Factor Authentication": "Autenticação de dois fatores",
    "Two-factor authentication is currently disabled": "A autenticação de dois fatores está desativada no momento.",
    "Two-factor authentication is currently enabled": "A autenticação de dois fatores está atualmente ativada.",
    "URL needs to be valid, include http:// or https:// and be under 100 characters": "O URL precisa ser válido, incluir http:// ou https:// e ter menos de 100 caracteres.",
    "URL template": "Modelo de URL",
    "Unique broken links": "Links quebrados únicos",
    "Very fast - Be Cautious": "Muito rápido - Tenha cuidado",
    "WCAG 2.0": "WCAG 2.0",
    "WCAG 2.1": "WCAG 2.1",
    "Your color contrast is below the recommended score": "Seu contraste de cores está abaixo da pontuação recomendada.",
    "labels": "rótulos",
    "Acceptance Rate": "Taxa de aceitação",
    "Acceptance Rate Over Time": "Taxa de aceitação ao longo do tempo",
    "Acceptance Rate by Category": "Taxa de aceitação por categoria",
    "Accepted cookies": "Cookies aceitos",
    "Add callback functions boilerplate": "Adicionar modelo de funções de retorno de chamada",
    "Add cookie": "Adicionar cookie",
    "Add empty EventListeners": "Adicionar ouvintes de eventos vazios",
    "Add empty callbacks": "Adicionar callbacks vazios",
    "Add event listeners boilerplate": "Adicionar modelo de ouvintes de eventos",
    "Add web overlay lock": "Adicionar bloqueio de sobreposição da web",
    "Alternative": "Alternativa",
    "An overview of your customer's behavior with cookies on your website": "Uma visão geral do comportamento dos seus clientes em relação aos cookies no seu site.",
    "Are you sure you want to ignore all selected misspellings?": "Tem certeza de que deseja ignorar todos os erros ortográficos selecionados?",
    "Are you sure you want to mark this check as fixed on all pages?": "Tem certeza de que deseja marcar esta opção como fixa em todas as páginas?",
    "Are you sure you want to mark this check as fixed?": "Tem certeza de que deseja marcar esta verificação como resolvida?",
    "Are you sure you want to mark this misspelling as fixed?": "Tem certeza de que deseja marcar este erro ortográfico como corrigido?",
    "Are you sure you want to mark this misspelling(s) as fixed?": "Tem certeza de que deseja marcar este(s) erro(s) ortográfico(s) como corrigido(s)?",
    "Basic": "Básico",
    "Button color": "Cor do botão",
    "Button text color": "Cor do texto do botão",
    "Case sensitive URLs": "URLs que diferenciam maiúsculas de minúsculas",
    "Changes wording from only essential cookies to explicit reject": "Altera a redação de &quot;apenas cookies essenciais&quot; para &quot;rejeitar explicitamente&quot; os cookies.",
    "Consent Log": "Registro de consentimento",
    "Consent Overview": "Visão geral do consentimento",
    "Consent results are sample data for demo purposes": "Os resultados de consentimento são dados de amostra para fins de demonstração.",
    "Cookie Acceptance Rate": "Taxa de aceitação de cookies",
    "Cookie Overview": "Visão geral dos cookies",
    "Cookie description": "Descrição do cookie",
    "Cookie duration": "Duração do cookie",
    "Cookie name": "Nome do biscoito",
    "Enter a valid CSS selector": "Insira um seletor CSS válido",
    "Essential": "Essencial",
    "Example 3": "Exemplo 3",
    "Example 4": "Exemplo 4",
    "Explicit reject option": "Opção de rejeição explícita",
    "Give a short description of the purpose of the cookie": "Descreva brevemente a finalidade do cookie.",
    "Give users more control over which categories of cookies to consent to": "Dê aos usuários mais controle sobre quais categorias de cookies eles podem aceitar.",
    "How long is the cookie active": "Por quanto tempo o cookie fica ativo?",
    "IP Address": "Endereço IP",
    "Ignore canonical URLs": "Ignorar URLs canônicas",
    "Ignored by": "Ignorado por",
    "Ignored date": "Data ignorada",
    "Ignored misspellings on account": "Erros ortográficos ignorados por conta",
    "Include cookies": "Incluir cookies",
    "Insert CSS class or id selector": "Inserir seletor de classe ou ID CSS",
    "Insert a CSS selector": "Insira um seletor CSS",
    "Limit or exclude": "Limitar ou excluir",
    "Limit search": "Limitar a pesquisa",
    "Link to your opt out page": "Link para a sua página de cancelamento de inscrição.",
    "Make sure you use the correct setting": "Certifique-se de usar a configuração correta.",
    "Mark check as fixed": "Marque a caixa de seleção como corrigida.",
    "Marketing": "Marketing",
    "No cookies found": "Nenhum cookie encontrado",
    "No misspellings have been ignored": "Nenhum erro ortográfico foi ignorado.",
    "Opt out link": "Link para cancelar a inscrição",
    "Original": "Original",
    "Other": "Outro",
    "Overall Acceptance Rate": "Taxa de aceitação geral",
    "Overall acceptance rate": "Taxa de aceitação geral",
    "Per category consent": "consentimento por categoria",
    "Please wait - Marking as fixed": "Aguarde - Marcando como resolvido",
    "Please wait - Marking word as fixed": "Aguarde - Marcando a palavra como corrigida.",
    "Preferences": "Preferências",
    "Privacy regulation": "Regulamento de privacidade",
    "Remove cookie": "Remover cookie",
    "Remove from Ignored": "Remover da lista de ignorados",
    "Remove this word from Ignored Misspellings": "Remova esta palavra da lista de erros ortográficos ignorados.",
    "URL Structure": "Estrutura da URL",
    "Domain Overview": {
      "Topmenu": "Visão geral do domínio",
      "$$noContext": "Visão geral do domínio"
    },
    "Admin Settings": "Configurações do administrador",
    "Case sensitivity": "Sensibilidade a maiúsculas e minúsculas",
    "Close project search and domain picker": "Fechar pesquisa de projetos e seletor de domínios",
    "Domain Settings": "Configurações de domínio",
    "In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.": "No final das contas, as tags &lt;i&gt; e &lt;em&gt; são visualmente iguais. No entanto, cada uma possui um significado semântico diferente. &lt;em&gt; é usada para representar ênfase, enquanto a tag &lt;i&gt; representa uma palavra ou frase que o usuário pode querer destacar em itálico (uma palavra estrangeira, a definição de uma palavra, etc.). Para esta última, deve-se usar CSS em vez de itálico.",
    "Paste your image link (URL) here": "Cole aqui o link (URL) da sua imagem.",
    "Set up your domain": "Configure seu domínio",
    "The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.": "O maior problema com essa correção pode surgir se a tag &lt;i&gt; for usada para ícones em vez de, por exemplo, &lt;span&gt; (exemplo: Font Awesome). Se você notar que algo está errado com seus ícones após aplicar a correção, esse pode ser o motivo. No entanto, as tags &lt;i&gt; para ícones geralmente usam uma classe, então certifique-se de ter configurado as opções para alterar apenas as tags, sem alterar as classes. Dessa forma, seus ícones permanecerão intactos.",
    "The profile <strong>[[profileName]]</strong> is being used on the following pages below:": "O perfil <strong>[[profileName]]</strong> está sendo usado nas seguintes páginas abaixo:",
    "Add icon border": "Adicionar borda de ícone",
    "Adds a 3px wide border to the PageAssist widget icon": "Adiciona uma borda de 3px de largura ao ícone do widget PageAssist.",
    "Bottom": "Fundo",
    "Clear search": "Limpar pesquisa",
    "Ensures that PageAssist is never overlapped by other elements on the page": "Garante que o PageAssist nunca seja sobreposto por outros elementos na página.",
    "Estonian": "estoniano",
    "German": "Alemão",
    "Go to overlay with details": "Acesse a sobreposição com detalhes.",
    "Guidelines for WCAG 2.2": "Diretrizes para WCAG 2.2",
    "Heartbeat Overview": "Visão geral dos batimentos cardíacos",
    "How far the button is from the edge. Customization dependant on position.": "Distância do botão até a borda. A personalização depende da posição.",
    "Insert a valid host name": "Insira um nome de host válido.",
    "Keep PageAssist on top": "Mantenha o PageAssist em primeiro plano",
    "Left": "Esquerda",
    "Margin from edge in pixels": "Margem da borda em pixels",
    "Norwegian Bokmål": "Bokmål norueguês",
    "Norwegian Nynorsk": "Nynorsk norueguês",
    "Right": "Certo",
    "Social Media visits": "Visitas às redes sociais",
    "Social media visits": "visitas de mídias sociais",
    "Sort column": "Coluna de classificação",
    "Sort column ascending": "Ordenar coluna em ordem crescente",
    "Sort column descending": "Ordenar coluna em ordem decrescente",
    "Subgroup": "Subgrupo",
    "Swedish": "sueco",
    "Toggle label text": "Alternar texto do rótulo",
    "Top": "Principal",
    "Unique misspellings": "erros ortográficos únicos",
    "Unique misspellings found": "Foram encontradas grafias incorretas únicas.",
    "WCAG 2.2 Accessibility Compliance": "Conformidade com as diretrizes de acessibilidade WCAG 2.2",
    "Area dynamic page": "Página dinâmica da área",
    "Employeepage": "Página do funcionário",
    "Language id": "ID do idioma",
    "Newspage": "Página de notícias",
    "Standard": "Padrão",
    "Standard for http(s)://edit.domain.tld/inz/<path>. Alternative for http(s)://domain.tld/<path>/edit.": "Padrão para http(s)://edit.domain.tld/inz/<path> . Alternativa para http(s)://domain.tld/<path> /editar.",
    "URL format": "Formato de URL",
    "Export both internal and external links": "Exportar links internos e externos",
    "Export only external links": "Exportar apenas links externos",
    "Export only internal links": "Exportar apenas links internos",
    "Overview of all the enabled modules for this domain": "Visão geral de todos os módulos habilitados para este domínio.",
    "Search for a predefined policy in the Policy Exchange Center": "Procure uma política predefinida no Centro de Intercâmbio de Políticas.",
    "A log of all the consents given by your website visitors": "Um registro de todos os consentimentos concedidos pelos visitantes do seu site.",
    "Action required. Click to resolve issue.": "Ação necessária. Clique para resolver o problema.",
    "Complete": "Completo",
    "Cookie Overview buttons": "Botões de visão geral dos cookies",
    "Cookie Overview saved": "Visão geral dos cookies salvos",
    "Cookie added by user": "Cookie adicionado pelo usuário",
    "Cookie domain": "Domínio de cookies",
    "Cookie not found": "Cookie não encontrado",
    "Cookie not published. Missing:": "Cookie não publicado. Ausente:",
    "Could not save invalid form": "Não foi possível salvar o formulário inválido.",
    "Disables interactions on website until the visitor makes a consent choice. Be aware that locking interactions prior to consent may not be compliant with certain regional privacy regulations.": "Desativa as interações no site até que o visitante faça uma escolha de consentimento. Esteja ciente de que bloquear as interações antes do consentimento pode não estar em conformidade com certas regulamentações regionais de privacidade.",
    "Finish the setup by adding your cookies": "Finalize a configuração adicionando seus cookies.",
    "For Cookie setup please go to your <b>Data Privacy</b> module.<br> Manual cookies can be set up or edited any time and are not related to script setup.": "Para configurar os cookies, acesse o módulo <b>de Privacidade de Dados</b> .<br> Os cookies manuais podem ser configurados ou editados a qualquer momento e não estão relacionados à configuração do script.",
    "GDPR requires that companies provide descriptions on their website for all cookies that are used.": "O RGPD exige que as empresas forneçam descrições em seus sites para todos os cookies que utilizam.",
    "Give an overview of the cookies used on your website. Finish a domain scan or add them manually.": "Apresente uma visão geral dos cookies utilizados no seu site. Conclua uma verificação de domínio ou adicione-os manualmente.",
    "Id": "Eu ia",
    "Include a link to your webpage's privacy policy": "Inclua um link para a política de privacidade da sua página web.",
    "It looks like the previously set up cookie was not found in this scan. It might be that the cookie was removed or our scan just couldn’t detect it.": "Parece que o cookie configurado anteriormente não foi encontrado nesta verificação. Pode ser que o cookie tenha sido removido ou que nossa verificação simplesmente não tenha conseguido detectá-lo.",
    "I’ll do it later": "Farei isso mais tarde.",
    "Keep": "Manter",
    "Leave without saving": "Sair sem salvar",
    "Link to Privacy Policy": "Link para a Política de Privacidade",
    "Link to your Cookie Overview": "Link para a sua Visão Geral dos Cookies",
    "Link to your Privacy Policy": "Link para sua Política de Privacidade",
    "Link where customers can opt out of sale of personal data. Mandatory for websites under the CCPA regulation.": "Link onde os clientes podem optar por não permitir a venda de seus dados pessoais. Obrigatório para sites sujeitos à regulamentação CCPA.",
    "List of checks with and without issues categorized by [[level]] guidelines": "Lista de verificações com e sem problemas categorizadas por diretrizes de [[level]]",
    "Manage Cookie": "Gerenciar cookies",
    "On-demand scan unavailable": "A digitalização sob demanda não está disponível.",
    "Pages needing to be fixed": "Páginas que precisam ser corrigidas",
    "Save cookies": "Salvar cookies",
    "Save existing cookies": "Salvar cookies existentes",
    "Save this overview to publish completed cookies to the Cookie Overview.": "Salve esta visão geral para publicar os cookies concluídos na Visão geral dos cookies.",
    "Save your page before leaving to keep your progress and publish the completed cookies.": "Salve a página antes de sair para manter seu progresso e publicar os cookies concluídos.",
    "Scan History": "Histórico de digitalização",
    "Scan Information": "Informações de digitalização",
    "Scan info": "Informações de digitalização",
    "Source": "Fonte",
    "This feature is not available on a demo account.": "Este recurso não está disponível em uma conta de demonstração.",
    "This page has been rescanned since the latest full scan.": "Esta página foi digitalizada novamente desde a última digitalização completa.",
    "This scan feature is not available on a demo account": "Este recurso de digitalização não está disponível em uma conta de demonstração.",
    "UUID": "UUID",
    "You need to include a name in order to save your cookies.": "Você precisa incluir um nome para salvar seus cookies.",
    "[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.": "[[total]] páginas. Priorize e corrija todos os problemas de conteúdo em seu site a partir de uma visão consolidada.",
    "Distribution of policies with matches across priority levels": "Distribuição de políticas com correspondências em todos os níveis de prioridade",
    "Copied!": "Copiado!",
    "Copy": "Cópia",
    "Default language*": "Idioma padrão*",
    "Don't forget to copy and update the script on your website!": "Não se esqueça de copiar e atualizar o script no seu site!",
    "Included languages*": "Idiomas incluídos*",
    "Loading Data": "Carregando dados",
    "Loading...": "Carregando...",
    "No support": "Sem suporte",
    "Open PageAssist script settings": "Abra as configurações do script PageAssist",
    "PageAssist script settings": "Configurações do script PageAssist",
    "Please add the script as close to the open HEAD-tag as possible": "Por favor, adicione o script o mais próximo possível da tag HEAD aberta.",
    "Please wait - loading": "Aguarde - carregando",
    "Press Ctrl-C": "Pressione Ctrl+C",
    "Press ⌘-C": "Pressione ⌘-C",
    "This chart shows how many percent of visitors accepted the various categories of cookies on your website. Visitors who did not make a consent choice on the cookie banner are not counted": "Este gráfico mostra a porcentagem de visitantes que aceitaram as diferentes categorias de cookies no seu site. Visitantes que não optaram por aceitar os cookies no banner não são contabilizados.",
    "Visitor percentage": "Percentagem de visitantes",
    "Consent Manager script settings": "Configurações do script do Gerenciador de Consentimento",
    "Open consent manager script settings": "Abra as configurações do script do gerenciador de consentimento.",
    "Scan your website for any data privacy issues that could be present": "Analise seu site em busca de possíveis problemas de privacidade de dados.",
    "Please enter a full UUID string. Empty or partial strings will not yield any results.": "Por favor, insira uma string UUID completa. Strings vazias ou parciais não produzirão resultados.",
    "UUID can only be searched by entering the full value": "O UUID só pode ser pesquisado inserindo o valor completo.",
    "Average Cumulative Layout Shift": "Mudança média cumulativa de layout",
    "Average Largest Contentful Paint": "Média Maior Conteúdo Pintura",
    "Average Speed Index": "Índice de velocidade média",
    "Average Total Blocking Time": "Tempo médio total de bloqueio",
    "CMS Path": "Caminho CMS",
    "Click here or drag a rule to this area": "Clique aqui ou arraste uma regra para esta área.",
    "Cumulative Layout Shift": "Mudança cumulativa de layout",
    "LCP": "LCP",
    "Relevant for": "Relevante para",
    "SI": "SI",
    "TBT": "#TBT",
    "[[avg]]": "[[avg]]",
    "[[label]]: [[value]]": "[[label]]: [[value]]",
    "Content Authoring": "Criação de conteúdo",
    "Responsibilities": "Responsabilidades",
    "Responsibility": "Responsabilidade",
    "UX Design": "Design de UX",
    "Visual Design": "Design visual",
    "Version [[version]]": "Versão [[version]]",
    "Accessibility score": "Pontuação de acessibilidade",
    "Comparison to average": "Comparação com a média",
    "Industry average": "Média do setor",
    "No scores available for this domain": "Não há pontuações disponíveis para este domínio.",
    "Professional services": "Serviços profissionais",
    "Quality Assurance score": "Pontuação de Garantia de Qualidade",
    "SEO score": "Pontuação de SEO",
    "Scores": "Pontuações",
    "The average score for domains within your industry.": "A pontuação média para domínios dentro do seu setor.",
    "Add language": "Adicionar idioma",
    "Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.": "Tem certeza de que deseja arquivar a política <strong>[[policyName]]</strong> ? Não buscaremos mais correspondências para esta política. Você sempre poderá desarquivar a política posteriormente.",
    "Are you sure you want to set these documents as reviewed?": "Tem certeza de que deseja marcar esses documentos como revisados?",
    "Clear selection": "Limpar seleção",
    "Delete language -": "Apagar idioma -",
    "Delete the language tab - [[language]]": "Exclua a guia de idioma - [[language]]",
    "Discovered": "Descoberto",
    "Doing this will result in removing the translations in the selected language from both your Cookie Overview and the actual banner itself.<br></br><strong>You will need to add the descriptions again when you re-add the selected language.</strong>": "Ao fazer isso, as traduções no idioma selecionado serão removidas tanto da sua Visão Geral de Cookies quanto do próprio banner.<br></br> <strong>Você precisará adicionar as descrições novamente ao adicionar o idioma selecionado mais uma vez.</strong>",
    "Don't forget to update your languages in Script Setup!": "Não se esqueça de atualizar seus idiomas na Configuração de Scripts!",
    "Edit this policy rule later under the “Add rule to policy” tab.": "Edite esta regra de política posteriormente na guia &quot;Adicionar regra à política&quot;.",
    "Front-end Development": "Desenvolvimento Front-end",
    "How to setup this policy:": "Como configurar esta política:",
    "Insert word length": "Insira o comprimento da palavra",
    "Inspect page with browser extension": "Inspecionar página com extensão do navegador",
    "Mark all as reviewed": "Marcar tudo como revisado",
    "Mobile only": "Somente para dispositivos móveis",
    "New policy": "Nova política",
    "Please add at least one language": "Por favor, adicione pelo menos um idioma.",
    "Please set the default language": "Por favor, defina o idioma padrão.",
    "Please wait - Adding word to ignored list": "Aguarde - Adicionando palavra à lista de ignorados",
    "Please wait - Adding words to ignored list": "Aguarde - Adicionando palavras à lista de ignorados",
    "Remove rule from policy": "Remover regra da política",
    "Request PDF accessibility check for all": "Solicitar verificação de acessibilidade de PDF para todos",
    "Request Remedition quote for all": "Solicite um orçamento de remediação para todos os casos.",
    "Script": "Roteiro",
    "Select a group": "Selecione um grupo",
    "Select a shape": "Selecione uma forma",
    "Select languages": "Selecione o idioma",
    "Select the default language": "Selecione o idioma padrão",
    "To finish setting up your manual Cookie Overview go to the selected domain’s": "Para concluir a configuração da sua Visão Geral de Cookies manual, acesse o domínio selecionado.",
    "Unignore this check": "Desfazer verificação",
    "WCAG 2.1 (Level AA) Mobile": "WCAG 2.1 (Nível AA) Dispositivos Móveis",
    "WCAG 2.1 (Level AAA) Mobile": "WCAG 2.1 (Nível AAA) para dispositivos móveis",
    "Are you sure you want to delete label: [[label]] ?": "Tem certeza de que deseja excluir o rótulo: [[label]] ?",
    "Business services": "Serviços empresariais",
    "CMS template is configured for this domain": "O modelo CMS está configurado para este domínio.",
    "Consent Manager configuration": "Configuração do Gerenciador de Consentimento",
    "Consent Manager language*": "Idioma do Gerenciador de Consentimento*",
    "Consent Manager pop-up position on Page": "Posição do pop-up do Gerenciador de Consentimento na página",
    "Consent Manager pop-up setup": "Configuração do pop-up do Gerenciador de Consentimento",
    "Construction/industrial": "Construção/industrial",
    "Consumer services": "Serviços ao consumidor",
    "Entertainment/Leisure": "Entretenimento/Lazer",
    "Financial services": "Serviços financeiros",
    "German (Germany)": "Alemão (Alemanha)",
    "Healthcare": "Assistência médica",
    "Label used in the groups below. Please edit or delete the groups and try again.": "Rótulo usado nos grupos abaixo. Edite ou exclua os grupos e tente novamente.",
    "Law enforcement": "aplicação da lei",
    "Legal": "Jurídico",
    "Non-profit": "Organização sem fins lucrativos",
    "Real-estate": "Imobiliária",
    "Retail/wholesale": "Varejo/atacado",
    "Spanish (Spain)": "Espanhol (Espanha)",
    "Technology": "Tecnologia",
    "Utilities/Natural resources": "Serviços públicos/Recursos naturais",
    "Widget Design": "Design de widget",
    ":": ":",
    "Accessibility issue": "Problema de acessibilidade",
    "Add reason (optional)": "Adicionar motivo (opcional)",
    "All pages with this accessibility issue": "Todas as páginas com este problema de acessibilidade",
    "All pages with this data privacy issue": "Todas as páginas com este problema de privacidade de dados",
    "Alternatively, click the button below.": "Alternativamente, clique no botão abaixo.",
    "Are you sure you want to mark this  as fixed?": "Tem certeza de que deseja marcar isso como resolvido?",
    "Are you sure you want to mark this  as ignored?": "Tem certeza de que deseja marcar isso como ignorado?",
    "Are you sure you want to mark this  as not fixed?": "Tem certeza de que deseja marcar isso como não resolvido?",
    "Are you sure you want to mark this check as ignored?": "Tem certeza de que deseja marcar esta verificação como ignorada?",
    "Are you sure you want to mark this issue as ignored?": "Tem certeza de que deseja marcar este problema como ignorado?",
    "Are you sure you want to unignore this ?": "Tem certeza de que deseja deixar de ignorar isso?",
    "Average time (comp.)": "Tempo médio (comp.)",
    "Bounce rate (comp.)": "Taxa de rejeição (comp.)",
    "Campaign visits": "Visitas de campanha",
    "Code": "Código",
    "Confirmation required": "Confirmação necessária",
    "Current password": "Senha atual",
    "Data privacy issue": "Questão de privacidade de dados",
    "Data violations": "Violações de dados",
    "Date found": "Data encontrada",
    "Downloads (comp.)": "Downloads (comp.)",
    "Entries (comp.)": "Entradas (comp.)",
    "Events": "Eventos",
    "Exits (comp.)": "Saídas (comp.)",
    "Export visitors browsers": "Exportar navegadores de visitantes",
    "Export visitors devices": "Exportar dispositivos para visitantes",
    "Export visitors language": "Idioma dos visitantes de exportação",
    "Export visitors locations": "Exportar locais de visitantes",
    "Export visitors operating systems": "Sistemas operacionais para visitantes de exportação",
    "Export visitors organization": "Organização de visitantes de exportação",
    "Found on page": "Encontrado na página",
    "Group name": "Nome do grupo",
    "Image URL": "URL da imagem",
    "Issue details": "Detalhes do problema",
    "Issue not found": "Problema não encontrado",
    "Legacy Browser Service changed": "O serviço de navegador legado foi alterado.",
    "Look up in Google": "Pesquise no Google",
    "Mark as reviewed": "Marcar como revisado",
    "Maximum word length to search for": "Comprimento máximo da palavra a pesquisar",
    "Names": "Nomes",
    "No pages were found. Try searching for the page URL instead of the page title.": "Nenhuma página foi encontrada. Tente pesquisar pelo URL da página em vez do título.",
    "Open browser extension": "Abrir extensão do navegador",
    "Open issue page": "Página de problema aberto",
    "Open misspelling page": "Abra a página com erros de ortografia",
    "Other checks for this snippet": "Outras verificações para este trecho",
    "Pages with accessibility issues": "Páginas com problemas de acessibilidade",
    "Pages with policy issues": "Páginas com questões políticas",
    "Pageviews (comp.)": "Visualizações de página (comp.)",
    "Percentage shows number of pages that are compliant with all Policies": "A porcentagem mostra o número de páginas que estão em conformidade com todas as políticas.",
    "Percentage shows number of pages that are compliant with all QA checks": "A porcentagem indica o número de páginas que atendem a todos os requisitos de controle de qualidade.",
    "Please enter a valid date!": "Por favor, insira uma data válida!",
    "Please wait - Adding word to all dictionaries": "Aguarde - Adicionando a palavra a todos os dicionários.",
    "Press to toggle additional rows.": "Pressione para ativar/desativar linhas adicionais.",
    "Puppeteer Browser Service changed": "O serviço de navegador Puppeteer foi alterado.",
    "Reason:&nbsp;": "Razão:",
    "Remember to add this source code exclude to your domain(s) through the Edit Domain screen.": "Lembre-se de adicionar essa exclusão de código-fonte ao(s) seu(s) domínio(s) através da tela Editar Domínio.",
    "Remove review": "Remover avaliação",
    "Repeat new password": "Repita a nova senha",
    "Sorry, this page was not found. The issue must have been resolved.": "Desculpe, esta página não foi encontrada. O problema deve ter sido resolvido.",
    "The date cannot be in the future": "A data não pode ser no futuro.",
    "The end date cannot be before the start date": "A data de término não pode ser anterior à data de início.",
    "The settings form contains incorrect data. Close the form anyway?": "O formulário de configurações contém dados incorretos. Deseja fechar o formulário mesmo assim?",
    "The start and end date cannot be in the future, please enter the compare dates again": "As datas de início e término não podem ser futuras. Por favor, insira as datas de comparação novamente.",
    "This issue is marked as fixed.": "Este problema foi marcado como resolvido.",
    "This issue is marked as ignored.": "Este problema foi marcado como ignorado.",
    "This issue is marked as reviewed.": "Este problema foi marcado como analisado.",
    "This word has been added to your dictionary": "Esta palavra foi adicionada ao seu dicionário.",
    "To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class=\\\"text-bold\\\">My Exports.</span>": "Para ver o progresso atual, clique no avatar do usuário no canto superior direito da página principal e selecione <span class=\\\"text-bold\\\">&quot;Minhas Exportações&quot;.</span>",
    "Total unique downloads (comp.)": "Total de downloads únicos (comp.)",
    "Unique downloads (comp.)": "Downloads únicos (comp.)",
    "Visitors browsers export": "Exportação de navegadores de visitantes",
    "Visitors devices export": "Exportação de dispositivos de visitantes",
    "Visitors language export": "Exportação de idioma para visitantes",
    "Visitors locations export": "Exportar locais de visitantes",
    "Visitors operating systems export": "Exportação de sistemas operacionais para visitantes",
    "Visitors organization export": "Exportação da organização de visitantes",
    "Visits (comp.)": "Visitas (comp.)",
    "WCAG 2.1 (Level A) Mobile": "WCAG 2.1 (Nível A) Dispositivos Móveis",
    "Your export is currently being generated.": "Seu pedido de exportação está sendo gerado.",
    "+ ' + (report.targets.length - maxTargets) + ' more": "+ &#39; + (report.targets.length - maxTargets) + &#39; mais",
    "Accessibility Checklist (WCAG 2.0)": "Lista de verificação de acessibilidade (WCAG 2.0)",
    "Accessibility Checklist (WCAG 2.1)": "Lista de verificação de acessibilidade (WCAG 2.1)",
    "Accessibility Checklist (WCAG 2.2)": "Lista de verificação de acessibilidade (WCAG 2.2)",
    "Average no. of results pages viewed": "Número médio de páginas de resultados visualizadas",
    "Checklist": "Lista de verificação",
    "Email *": "E-mail *",
    "Event actions": "Ações do evento",
    "Event categories": "Categorias de eventos",
    "Event names": "Nomes dos eventos",
    "First name *": "Primeiro nome *",
    "Last name *": "Sobrenome *",
    "Search term": "Termo de pesquisa",
    "Search terms": "Termos de pesquisa",
    "Search terms with no results": "Termos de pesquisa sem resultados",
    "Site Search": "Pesquisa no site",
    "Site Search - Search Terms": "Pesquisa no site - Termos de pesquisa",
    "Site Search No Results Search Terms": "Pesquisa no site: Nenhum resultado encontrado. Termos de pesquisa.",
    "Switch between chart and table": "Alternar entre gráfico e tabela",
    "Table": "Mesa",
    "more": "mais",
    "Accessibility checks update": "Atualização das verificações de acessibilidade",
    "Account is under maintenance": "A conta está em manutenção.",
    "Add internal URL": "Adicionar URL interna",
    "Add the name of the platform or company who provides this cookie.": "Adicione o nome da plataforma ou empresa que fornece esse cookie.",
    "All PDFs": "Todos os PDFs",
    "All scheduled reports": "Todos os relatórios programados",
    "An error has occurred - please try again": "Ocorreu um erro. Tente novamente.",
    "Are you sure you want mark as fixed": "Tem certeza de que deseja marcar como corrigido?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary for all languages?": "Tem certeza de que deseja adicionar a palavra <strong>[[word]]</strong> ao dicionário para todos os idiomas?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary?": "Tem certeza de que deseja adicionar a palavra <strong>[[word]]</strong> ao dicionário?",
    "Are you sure you want to confirm the word <strong>[[word]]</strong> as misspelling?": "Tem certeza de que deseja confirmar a palavra <strong>[[word]]</strong> como um erro ortográfico?",
    "Are you sure you want to ignore the misspelling <strong>[[word]]</strong> for all languages?": "Tem certeza de que deseja ignorar o erro ortográfico <strong>[[word]]</strong> em todos os idiomas?",
    "Are you sure you want to mark the misspelling <strong>[[word]]</strong> as fixed?": "Tem certeza de que deseja marcar o erro ortográfico <strong>[[word]]</strong> como corrigido?",
    "Are you sure you want to remove the Default label?": "Tem certeza de que deseja remover o rótulo &quot;Padrão&quot;?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong>?": "Tem certeza de que deseja executar a política <strong>[[policyName]]</strong> ?",
    "Bar chart representing data": "Gráfico de barras representando dados",
    "Bar line chart representing": "Gráfico de barras representando",
    "Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.": "Tenha em mente que um atributo alt vazio pode ser suficiente e apropriado para imagens decorativas.",
    "Bubble chart representing data": "Gráfico de bolhas representando dados",
    "Clear the field": "Limpe o campo",
    "Close submenu": "Fechar submenu",
    "Contact Support": "Contate o suporte",
    "Cookie platform": "Plataforma de cookies",
    "Current password is incorrect please try again": "A senha atual está incorreta. Tente novamente.",
    "Doughnut chart representing data": "Gráfico de rosca representando dados",
    "Enable Cookieless Tracking": "Ativar rastreamento sem cookies",
    "Errors and": "Erros e",
    "Errors and Warnings": "Erros e avisos",
    "Events filter buttons": "botões de filtro de eventos",
    "Every 12 weeks": "A cada 12 semanas",
    "Every 2 weeks": "A cada 2 semanas",
    "Every 4 weeks": "A cada 4 semanas",
    "Every 8 weeks": "A cada 8 semanas",
    "Frequency": "Freqüência",
    "Image details": "Detalhes da imagem",
    "Image metadata": "Metadados da imagem",
    "Image preview": "Pré-visualização da imagem",
    "Inventory image preview": "Pré-visualização da imagem do inventário",
    "It seems like we are experience some issues with the page you are looking at.": "Parece que estamos enfrentando alguns problemas com a página que você está visualizando.",
    "It seems like your computer is disconnected from the internet.": "Parece que seu computador está desconectado da internet.",
    "Line chart representing data": "Gráfico de linhas representando dados",
    "List of received reports": "Lista de relatórios recebidos",
    "Metadata and pages": "Metadados e páginas",
    "Metadata property": "Propriedade de metadados",
    "My scheduled reports": "Meus relatórios agendados",
    "No date range selected": "Nenhum intervalo de datas selecionado",
    "Norwegian": "norueguês",
    "Only Errors": "Apenas erros",
    "Only errors": "Apenas erros",
    "Open dropdown with filters": "Abra o menu suspenso com filtros",
    "Open metadata view": "Abrir visualização de metadados",
    "Open submenu with filters": "Abrir submenu com filtros",
    "Pages that contain the Email": "Páginas que contêm o e-mail",
    "Percentage shows the average compliance score across all pages on the domain": "A porcentagem mostra a pontuação média de conformidade em todas as páginas do domínio.",
    "Pie chart representing data": "Gráfico de pizza representando dados",
    "Platform": "Plataforma",
    "Please contact the support if this issue keeps happening": "Se o problema persistir, entre em contato com o suporte.",
    "Please refresh the browser when your computer is online again.": "Por favor, atualize o navegador quando seu computador estiver online novamente.",
    "Please try again later": "Por favor, tente novamente mais tarde.",
    "Press to remove the label.": "Pressione para remover a etiqueta.",
    "Puppeteer 20": "Marionetista 20",
    "Remove internal URL": "Remover URL interna",
    "Scan all pages for cookies": "Analise todas as páginas em busca de cookies.",
    "Schedule this report": "Agende este relatório",
    "Search in options": "Pesquisar nas opções",
    "Show HTML snippet details": "Mostrar detalhes do trecho de HTML",
    "Show labels": "Mostrar rótulos",
    "Show less of the url snippet": "Mostrar menos do trecho da URL",
    "Show the full url snippet": "Exibir o trecho completo da URL",
    "Showing": "Exibindo",
    "The average compliance score for this module for domains from other organizations within your industry:": "A pontuação média de conformidade para este módulo em domínios de outras organizações do seu setor é:",
    "Unsubscribe from report": "Cancelar inscrição no relatório",
    "Warnings": "Avisos",
    "We export up to a maximum of 1000 rows": "Exportamos até um máximo de 1000 linhas.",
    "We recommend that you have an alt attribute with relevant content on all image tags.": "Recomendamos que você inclua um atributo alt com conteúdo relevante em todas as tags de imagem.",
    "You have images missing an alt attribute.": "Você tem imagens sem o atributo alt.",
    "[[name]] Remove": "[[name]] Remove",
    "[[target]]": "[[alvo]]",
    "default": "padrão",
    "[[label]]": "[[rótulo]]",
    "% of visitors staying after a search": "% de visitantes que permanecem após uma pesquisa",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.": "A correção de documentos para conformidade com os padrões de acessibilidade WCAG 2.1 AA, Seção 508, HHS ou PDF/UA é realizada por nossa afiliada, NetCentric Technologies, Inc. Devido aos requisitos regulatórios do seu país, não podemos coordenar a correção de documentos diretamente para você; no entanto, convidamos você a entrar em contato diretamente com a NetCentric para solicitar um orçamento e serviços de correção pelo e-mail dherr@allyant.com. Observe que todos os contratos de correção são firmados entre você, o Cliente, e a NetCentric, estando sujeitos aos Termos e Condições e à Política de Privacidade da NetCentric, e resultarão na transferência de dados para terceiros e países terceiros, incluindo, entre outros, os Estados Unidos, Canadá, Austrália e Egito.",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. Upon completion of the work, NetCentric will also provide a compliance report. NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy.": "A correção de documentos para conformidade com os padrões de acessibilidade WCAG 2.1 AA, Seção 508, HHS ou PDF/UA é realizada por nossa afiliada, NetCentric Technologies, Inc. Para a correção, coordenaremos com a NetCentric para revisar o documento e fornecer um preço fixo para o serviço. Após a conclusão do trabalho, a NetCentric também fornecerá um relatório de conformidade. A NetCentric informará se há necessidade de Texto Alternativo (Alt-Text) para imagens que não sejam autodescritivas ou qualquer informação adicional relacionada necessária para corrigir o documento. Observe que todos os contratos de correção são firmados entre você, o Cliente, e a NetCentric, e estão sujeitos aos Termos e Condições e à Política de Privacidade da NetCentric.",
    "Japanese": "japonês",
    "Report Administration": "Administração de relatórios",
    "Submit": "Enviar",
    "You have [[domains]] domain(s) on your account": "Você possui [[domains]] domínio(s) em sua conta.",
    "Find domains by searching for the title or URL": "Encontre domínios pesquisando pelo título ou URL.",
    "Industry average score": "Pontuação média do setor",
    "Proceed to add one more check": "Prossiga para adicionar mais um cheque.",
    "Readability test (for English pages only)": "Teste de legibilidade (apenas para páginas em inglês)",
    "Request quote for more pages": "Solicite um orçamento para mais páginas.",
    "Request quote for more profiles": "Solicite um orçamento para mais perfis.",
    "Search for domain": "Pesquisar domínio",
    "The user does not have access to view this domain and any reports associated with it": "O usuário não tem permissão para visualizar este domínio e quaisquer relatórios associados a ele.",
    "Update all domain groups": "Atualizar todos os grupos de domínio",
    "Update domain group": "Atualizar grupo de domínio",
    "Updating a group can take more than 30 minutes. During the operation you will not be able to create and update groups.": "A atualização de um grupo pode levar mais de 30 minutos. Durante essa operação, você não poderá criar nem atualizar grupos.",
    "WCAG 2.2 (Level A)": "WCAG 2.2 (Nível A)",
    "WCAG 2.2 (Level A) Mobile": "WCAG 2.2 (Nível A) Dispositivos Móveis",
    "WCAG 2.2 (Level AA)": "WCAG 2.2 (Nível AA)",
    "WCAG 2.2 (Level AA) Mobile": "WCAG 2.2 (Nível AA) Dispositivos Móveis",
    "WCAG 2.2 (Level AAA)": "WCAG 2.2 (Nível AAA)",
    "WCAG 2.2 (Level AAA) Mobile": "WCAG 2.2 (Nível AAA) para dispositivos móveis",
    "You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button \\\"Request quote for more pages\\\" and someone on our team will be in touch.": "Você atingiu o número máximo de páginas de desempenho no seu plano atual.<br/><br/> Para consultar os preços de páginas adicionais, clique no botão &quot;Solicitar orçamento para mais páginas&quot; e um membro da nossa equipe entrará em contato.",
    "You must perform a manual review of the page to confirm if this issue is present": "Você deve realizar uma revisão manual da página para confirmar se esse problema está presente.",
    "Accessibility Checklist (QUALWEB)": "Lista de verificação de acessibilidade (QUALWEB)",
    "Accessibility checks cannot be ignored for domain groups. To ignore this check you must do it for the entire domain.": "As verificações de acessibilidade não podem ser ignoradas para grupos de domínio. Para ignorar essa verificação, você deve fazê-lo para todo o domínio.",
    "Accessibility checks cannot be unignored for domain groups. To unignore this check you must do it for the entire domain.": "As verificações de acessibilidade não podem ser reativadas para grupos de domínio. Para reativar essa verificação, você deve fazê-lo para todo o domínio.",
    "Check your spelling or try a shorter query.": "Verifique sua ortografia ou tente uma consulta mais curta.",
    "Guidelines for QUALWEB": "Diretrizes para QUALWEB",
    "Language not supported": "Idioma não suportado",
    "No domains found.": "Nenhum domínio encontrado.",
    "QUALWEB Accessibility Compliance": "Conformidade com a acessibilidade QUALWEB",
    "QualWeb (Level A)": "QualWeb (Nível A)",
    "QualWeb (Level AA)": "QualWeb (Nível AA)",
    "Score could not be generated": "Não foi possível gerar pontuação.",
    "Searching <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>": "Pesquisando<span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>",
    "The language of the page is not recognized as English. The Flesch-Kincaid test only works for English language. Change to the LIX test if you wish to generate scores for non-English pages.": "O idioma da página não foi reconhecido como inglês. O teste Flesch-Kincaid só funciona para o idioma inglês. Alterne para o teste LIX se desejar gerar pontuações para páginas em outros idiomas.",
    "We could not generate an accurate score for these pages. This is typically either due to the text on a page being too short, too long, or our web crawler not picking up any text at all.": "Não foi possível gerar uma pontuação precisa para essas páginas. Isso geralmente ocorre porque o texto da página é muito curto, muito longo ou porque nosso rastreador da web não detectou nenhum texto.",
    "Are you sure you want to add word [[word]] to all dictionaries": "Tem certeza de que deseja adicionar a palavra [[word]] a todos os dicionários?",
    "Are you sure you want to add word [[word]] to dictionary?": "Tem certeza de que deseja adicionar a palavra [[word]] ao dicionário?",
    "Are you sure you want to confirm the word [[word]] as misspelling?": "Tem certeza de que deseja confirmar a palavra [[word]] como um erro ortográfico?",
    "Are you sure you want to ignore the misspelling [[word]] for all languages?": "Tem certeza de que deseja ignorar o erro ortográfico [[word]] em todos os idiomas?",
    "Are you sure you want to mark the misspelling [[word]] as fixed?": "Tem certeza de que deseja marcar o erro ortográfico [[word]] como corrigido?",
    "Cannot forward more": "Não é possível encaminhar mais",
    "Choose Date": "Escolha a data",
    "Compare": "Comparar",
    "Confirmed errors only": "Apenas erros confirmados",
    "Exclude checks that require manual review": "Excluir verificações que exigem revisão manual",
    "If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.": "Se esta opção estiver ativada, a verificação do domínio incluirá apenas as verificações de acessibilidade que podem ser identificadas automaticamente como erros. As verificações que exigem revisão manual serão excluídas.",
    "One month back": "Há um mês",
    "One month forward": "Um mês à frente",
    "Press to choose the end day": "Pressione para escolher o dia de término",
    "Press to choose the start day": "Pressione para escolher o dia de início.",
    "Remove compare range dates": "Remover datas de intervalo de comparação",
    "The date cannot be in the future.": "A data não pode ser no futuro.",
    "Toggle the datepicker": "Alternar o seletor de datas",
    "Add Policy with AI": "Adicionar política com IA",
    "Consolidated Reports": "Relatórios Consolidados",
    "Created with AI policy assistant": "Criado com o assistente de políticas de IA",
    "Policy Assistant": "Assistente de Políticas",
    "Sparkle icon": "Ícone de brilho",
    "The Policy Assistant runs on Google Vertex AI, which can make mistakes.": "O Assistente de Políticas utiliza a IA Vertex do Google, que pode cometer erros.",
    "You have reached the maximum number of Performance profiles in your current plan.<br/><br/>To inquire about pricing options for additional profiles, please press the button \\\"Request quote for more profiles\\\" and someone on our team will be in touch.": "Você atingiu o número máximo de perfis de desempenho no seu plano atual.<br/><br/> Para consultar os preços de perfis adicionais, clique no botão &quot;Solicitar orçamento para mais perfis&quot; e um membro da nossa equipe entrará em contato.",
    "You are about to perform a scan of <span class='text-link'>[[pageTitle]]</span> using the profile <span class='text-link'>[[profileName]]</span>.<br>The scan can take a few minutes to finalise, depending on the size of the page.<br><br>Do you want to continue?": "Você está prestes a realizar uma varredura de <span class='text-link'>[[pageTitle]]</span> usando o perfil <span class='text-link'>[[profileName]]</span> .<br> A digitalização pode levar alguns minutos para ser concluída, dependendo do tamanho da página.<br><br> Deseja continuar?",
    "Doesn't scan automatically": "Não realiza a digitalização automaticamente.",
    "Scans automatically": "Digitaliza automaticamente",
    "with this": "com isso",
    "with this PDF": "com este PDF",
    "with this archive file": "com este arquivo compactado",
    "with this slide": "com este slide",
    "with this spreadsheet": "com esta planilha",
    "with this text file": "com este arquivo de texto",
    "Errors must be fixed for compliance.": "Os erros devem ser corrigidos para que haja conformidade.",
    "Issues to Fix": "Problemas a resolver",
    "Issues to Review": "Questões a serem analisadas",
    "Reviews require manual judgement.": "As avaliações exigem julgamento manual.",
    "Warnings are likely to be issues, but they require manual investigation.": "É provável que existam avisos sobre problemas, mas eles exigem investigação manual.",
    "1 content": [
      "1 conteúdo",
      "{{$count}} conteúdos",
      ""
    ],
    "1 misspelling ignored across all domains": [
      "1 erro ortográfico ignorado em todos os domínios",
      "{{$count}} erros ortográficos ignorados em todos os domínios",
      ""
    ],
    "1 new cookie on": [
      "1 nova cookie em",
      "{{$count}} novas cookies em",
      ""
    ],
    "1 page": [
      "1 página",
      "{{$count}} páginas",
      ""
    ],
    "1 page with one or more failing checks {{guideline}}": [
      "1 página com uma ou mais verificações falhas {{guideline}}",
      "1 página com uma ou mais verificações falhas {{guideline}}",
      ""
    ],
    "1 page with one or more ignored checks {{guideline}}": [
      "1 página com uma ou mais verificações ignoradas {{guideline}}",
      "{{$count}} páginas com uma ou mais verificações ignoradas {{guideline}}",
      ""
    ],
    "1 policy found": [
      "1 política encontrada",
      "{{$count}} políticas encontradas",
      ""
    ],
    "1 results": [
      "1 resultado",
      "{{$count}} resultados",
      ""
    ],
    "1 visit": [
      "1 visita",
      "{{$count}} visitas",
      ""
    ],
    "1 word added across all domains": [
      "1 palavra adicionada em todos os domínios",
      "{{$count}} palavras adicionadas em todos os domínios",
      ""
    ],
    "One word found": [
      "Uma palavra encontrada",
      "{{$count}} palavras encontradas",
      ""
    ],
    "You have 1 user on your account": [
      "Você tem 1 usuário em sua conta.",
      "Você tem {{$count}} usuários em sua conta.",
      ""
    ],
    "Accessibility Compliance Scan": "Verificação de Conformidade de Acessibilidade",
    "Broken Links on Sitemap": "Links quebrados no mapa do site",
    "Broken links on sitemap": "Links quebrados no mapa do site",
    "Close Spotlight Search.": "Fechar Busca em Destaque.",
    "Requested": "Solicitado",
    "Toggle Spotlight Search.": "Alternar busca em destaque.",
    "WCAG 2.2": "WCAG 2.2",
    "Newest": {
      "Exchange Center Sort by option": "Mais recentes"
    },
    "(<strong><i>[[issues]]</i></strong> unique problems)": "( <strong><i>[[problemas]]</i></strong> problemas únicos)",
    "(<strong>[[issues]]</strong> unique problems)": "( <strong>[[problemas]]</strong> problemas únicos)",
    "<div class=\\\\'pull-left\\\\'>' + ('Heatmaps": "<div class=\\\\'pull-left\\\\'>&#39; + (&#39;Mapas de calor",
    "<div class=\\\\'pull-left\\\\'>' + ('History Center": "<div class=\\\\'pull-left\\\\'>&#39; + (&#39;Centro de História",
    "<p class='warning'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached the limit of the amount of profiles allowed on your account ([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan or archive some profiles before restoring this one.</p>": "<p class='warning'>O Acquia Web Governance não consegue restaurar o perfil.</p><p> Você atingiu o limite de perfis permitidos em sua conta ([[maxProfiles]] perfis). Entre em contato com nossa equipe de vendas para adicionar mais perfis ao seu plano ou arquivar alguns perfis antes de restaurar este.</p>",
    "<strong>' + (links.total | monNumber) + '</strong> ' + ('link": "<strong>&#39; + (links.total | monNumber) + &#39;</strong> &#39; + (&#39;link",
    "<strong>' + (pages.total | monNumber) + '</strong> ' + ('page": "<strong>&#39; + (pages.total | monNumber) + &#39;</strong> &#39; + (&#39;página",
    "A \\\"skip to content\\\" link at the start of the webpage allows screen reader and keyboard-only users to skip over potentially non-relevant links at the start of your webpage and immediately access the main content.": "Um link &quot;pular para o conteúdo&quot; no início da página permite que usuários de leitores de tela e aqueles que acessam a página somente pelo teclado ignorem links potencialmente irrelevantes no início da página e acessem imediatamente o conteúdo principal.",
    "A cozy room with sofa, table and laptops that have Acquia Web Governance text": "Uma sala aconchegante com sofá, mesa e laptops com o texto &quot;Acquia Web Governance&quot; instalado.",
    "About Acquia Web Governance": "Sobre a Acquia Web Governance",
    "Accept Acquia Web Governance Privacy Terms": "Aceitar os Termos de Privacidade do Acquia Web Governance",
    "Acquia Web Governance": "Governança Web da Acquia",
    "Acquia Web Governance - Accessibility": "Governança Web da Acquia - Acessibilidade",
    "Acquia Web Governance - Accessibility Check List": "Lista de verificação de acessibilidade do Acquia Web Governance",
    "Acquia Web Governance - Accessibility Guidelines": "Governança Web da Acquia - Diretrizes de Acessibilidade",
    "Acquia Web Governance - Account Dictionary": "Acquia Web Governance - Dicionário de Contas",
    "Acquia Web Governance - Admin Page Performance Profiles": "Acquia Web Governance - Perfis de desempenho da página de administração",
    "Acquia Web Governance - Audit Log": "Acquia Web Governance - Registro de Auditoria",
    "Acquia Web Governance - Broken Images": "Acquia Web Governance - Imagens Quebradas",
    "Acquia Web Governance - Broken Links": "Acquia Web Governance - Links Quebrados",
    "Acquia Web Governance - Content With Broken Links": "Acquia Web Governance - Conteúdo com links quebrados",
    "Acquia Web Governance - Content With QA Errors": "Acquia Web Governance - Conteúdo com erros de controle de qualidade",
    "Acquia Web Governance - Cookie Acceptance Rate": "Acquia Web Governance - Taxa de aceitação de cookies",
    "Acquia Web Governance - Cookie Consent Log": "Acquia Web Governance - Registro de consentimento de cookies",
    "Acquia Web Governance - Cookie Overview": "Visão geral dos cookies do Acquia Web Governance",
    "Acquia Web Governance - Dashboard": "Acquia Web Governance - Painel de Controle",
    "Acquia Web Governance - Data Privacy": "Acquia Web Governance - Privacidade de Dados",
    "Acquia Web Governance - Data Privacy Check List": "Acquia Web Governance - Lista de Verificação de Privacidade de Dados",
    "Acquia Web Governance - Data Privacy Content": "Acquia Web Governance - Conteúdo sobre Privacidade de Dados",
    "Acquia Web Governance - Data Privacy Guidelines": "Acquia Web Governance - Diretrizes de Privacidade de Dados",
    "Acquia Web Governance - Data Privacy Issues": "Governança Web da Acquia - Questões de Privacidade de Dados",
    "Acquia Web Governance - Data Privacy Summary": "Acquia Web Governance - Resumo de Privacidade de Dados",
    "Acquia Web Governance - External PDF Compliance": "Acquia Web Governance - Conformidade com PDFs externos",
    "Acquia Web Governance - Fast Track": "Acquia Web Governance - Via Rápida",
    "Acquia Web Governance - Heatmaps": "Governança Web da Acquia - Mapas de Calor",
    "Acquia Web Governance - History Center": "Centro de Histórico do Acquia Web Governance",
    "Acquia Web Governance - Ignored Misspellings": "Governança Web da Acquia - Erros ortográficos ignorados",
    "Acquia Web Governance - Internal PDF Compliance": "Acquia Web Governance - Conformidade com PDFs internos",
    "Acquia Web Governance - Labels": "Governança Web da Acquia - Etiquetas",
    "Acquia Web Governance - Misspellings": "Governança Web da Acquia - Erros de ortografia",
    "Acquia Web Governance - Page Performance Pages": "Acquia Web Governance - Páginas de desempenho",
    "Acquia Web Governance - PageCorrect": "Acquia Web Governance - PageCorrect",
    "Acquia Web Governance - PageCorrect Accessibility Fixes": "Acquia Web Governance - Correções de acessibilidade do PageCorrect",
    "Acquia Web Governance - PageCorrect Content": "Acquia Web Governance - Conteúdo PageCorrect",
    "Acquia Web Governance - Pages With Failing Checks": "Acquia Web Governance - Páginas com verificações falhas",
    "Acquia Web Governance - Pages With Ignored Checks": "Acquia Web Governance - Páginas com verificações ignoradas",
    "Acquia Web Governance - Pages With Misspellings": "Governança Web da Acquia - Páginas com erros ortográficos",
    "Acquia Web Governance - Pages With Opportunity": "Acquia Web Governance - Páginas com Oportunidades",
    "Acquia Web Governance - Potential Misspellings": "Governança Web da Acquia - Possíveis erros ortográficos",
    "Acquia Web Governance - Prioritized Content": "Governança Web da Acquia - Conteúdo Priorizado",
    "Acquia Web Governance - Quality Assurance": "Governança Web da Acquia - Garantia de Qualidade",
    "Acquia Web Governance - Readability Checker": "Acquia Web Governance - Verificador de Legibilidade",
    "Acquia Web Governance - Readability Summary": "Acquia Web Governance - Resumo de Legibilidade",
    "Acquia Web Governance - SEO Checkpoints": "Acquia Web Governance - Pontos de verificação de SEO",
    "Acquia Web Governance - Search Engine Optimization": "Acquia Web Governance - Otimização para Mecanismos de Busca",
    "Acquia Web Governance - Spellcheck Summary": "Acquia Web Governance - Resumo da verificação ortográfica",
    "Acquia Web Governance - User List": "Lista de usuários do Acquia Web Governance",
    "Acquia Web Governance Consent Manager": "Gerenciador de consentimento de governança web da Acquia",
    "Acquia Web Governance Extension": "Extensão de Governança Web da Acquia",
    "Acquia Web Governance PageAssist": "Assistente de página de governança web da Acquia",
    "Acquia Web Governance users receiving this report": "Usuários do Acquia Web Governance que receberam este relatório",
    "Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )": "O Acquia Web Governance detectará automaticamente um download como um clique em um link que termina com uma das seguintes extensões de arquivo (observe que as extensões diferenciam maiúsculas de minúsculas):",
    "Add Acquia Web Governance Consent Manager": "Adicione o Acquia Web Governance Consent Manager",
    "Affects [[pageCount]] pages": "Afeta [[pageCount]] páginas",
    "An error has occurred - please try again. If the error continues, please contact Acquia Web Governance": "Ocorreu um erro. Tente novamente. Se o erro persistir, entre em contato com a Acquia Web Governance.",
    "An unexpected error occurred. Please try again.": "Ocorreu um erro inesperado. Tente novamente.",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary for all languages?": "Tem certeza de que deseja adicionar a palavra <strong>&#39; + palavra + &#39;</strong> ao dicionário para todos os idiomas?",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary?": "Tem certeza de que deseja adicionar a palavra <strong>&#39; + palavra + &#39;</strong> ao dicionário?",
    "Are you sure you want to confirm the misspelling <strong>' + word + '</strong>?": "Tem certeza de que deseja confirmar o erro ortográfico <strong>&#39; + palavra + &#39;</strong> ?",
    "Are you sure you want to remove the Profile <strong>[[profileName]]</strong>?": "Tem certeza de que deseja remover o perfil <strong>[[profileName]]</strong> ?",
    "Are you sure you want to undo review this document as reviewed?": "Tem certeza de que deseja desfazer a revisão deste documento?",
    "Calculate Readability Score": "Calcular o Índice de Legibilidade",
    "Calculate score to see results": "Calcule a pontuação para ver os resultados.",
    "Calculate the readability score of any text (based on [[testName]])": "Calcule a pontuação de legibilidade de qualquer texto (com base em [[testName]])",
    "Can\\\\'t delete label": "Não é possível excluir o rótulo",
    "Change your &lt;b&gt; tags into something else": "Altere suas tags &lt;b&gt; para outra coisa.",
    "Choose your own text for the Skip to Content link button<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>": "Escolha o texto que deseja para o botão &quot;Pular para o conteúdo&quot;. <span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>",
    "Clear search in the domain picker": "Limpar pesquisa no seletor de domínios",
    "Click here to contact Acquia Web Governance sales department to increase your maximum page count.": "Clique aqui para entrar em contato com o departamento de vendas da Acquia Web Governance e aumentar o número máximo de páginas permitidas.",
    "Confirmed misspelling": "Erro ortográfico confirmado",
    "Copyright 2020 Acquia Web Governance. All rights reserved.": "Copyright 2020 Acquia Web Governance. Todos os direitos reservados.",
    "Couldn't find any domains": "Não foi possível encontrar nenhum domínio.",
    "Crawled Pages ([[pageCount]])": "Páginas rastreadas ([[pageCount]])",
    "Description*": "Descrição*",
    "Domain favicon for": "Favicon de domínio para",
    "Domain groups": "Grupos de domínio",
    "Domains that have never been scanned": "Domínios que nunca foram verificados",
    "Domains that were not scanned in the selected date range": "Domínios que não foram verificados no intervalo de datas selecionado",
    "Edit this policy rule later under the \\\"Add rule to policy\\\" tab.": "Edite esta regra de política posteriormente na guia &quot;Adicionar regra à política&quot;.",
    "Enable if you want to use Acquia Web Governance in Accessibility mode": "Ative esta opção se desejar usar o Acquia Web Governance no modo de acessibilidade.",
    "Export visitors screen resolutions": "Exportar resoluções de tela dos visitantes",
    "For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.": "Por enquanto, o Acquia Web Governance Pagecorrect adicionará um aviso pop-up a cada link externo, permitindo que seus visitantes escolham se desejam sair da página original.",
    "Found 1 audit log on your account": "Encontramos 1 registro de auditoria em sua conta.",
    "Found [[count]] audit logs on your account": "Foram encontrados [[count]] registros de auditoria em sua conta.",
    "From March 1, 2022, Acquia Web Governance will no longer be supporting any version of Internet Explorer or Edge browser version 78 or below. While you will still be able to log on and use Acquia Web Governance with Internet Explorer and older versions of Edge, we are no longer testing releases and fixing bugs specifically for those browsers. We encourage you to switch to another browser such as Chrome or newer version of Edge to be sure that Acquia Optimize continues to work optimally on your device.": "A partir de 1º de março de 2022, o Acquia Web Governance deixará de oferecer suporte a qualquer versão do Internet Explorer ou do Edge anterior à versão 78. Embora você ainda possa acessar e usar o Acquia Web Governance com o Internet Explorer e versões antigas do Edge, não testaremos mais versões nem corrigiremos bugs especificamente para esses navegadores. Recomendamos que você utilize outro navegador, como o Chrome ou uma versão mais recente do Edge, para garantir que o Acquia Optimize continue funcionando da melhor forma possível em seu dispositivo.",
    "Get the Acquia Web Governance Extension": "Obtenha a extensão Acquia Web Governance.",
    "Go to the policy dashboard of the domain [[title]]": "Acesse o painel de políticas do domínio [[title]]",
    "Images missing alt attribute": "Imagens sem atributo alt",
    "Insert the CSS selector targets you want your visitors to land on<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>": "Insira os seletores CSS que você deseja que direcionem seus visitantes para as páginas onde deseja publicar a página. <span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>",
    "Internet Explorer &amp; Edge v.78 (or below) no longer supported": "O Internet Explorer e o Edge versão 78 (ou anterior) não são mais suportados.",
    "Italics are often used in HTML to put emphasis on text. However, this is often achieved with the &lt;I&gt; tag, in which case the emphasis is not announced by screen readers. Using the &lt;I&gt; tag doesn't provide enough context and is becoming an outdated practice.": "O uso de itálico em HTML é comum para enfatizar textos. No entanto, isso geralmente é feito com a tag &lt;i&gt;, que não é indicada pelos leitores de tela. O uso da tag &lt;i&gt; não fornece contexto suficiente e está se tornando uma prática obsoleta.",
    "Last 8 Performance Scans Scores": "Últimas 8 pontuações de análises de desempenho",
    "Latest manual scan finished on [[scannedAt]]": "Última verificação manual concluída em [[scannedAt]]",
    "Mark this issue as fixed": "Marque este problema como resolvido.",
    "Monitor how visitors interact with your pages. Acquia Web Governance tracks up to a maximum of 1000 heatmaps sessions per page per month.": "Monitore como os visitantes interagem com suas páginas. O Acquia Web Governance rastreia até um máximo de 1000 sessões de mapas de calor por página por mês.",
    "No downloads were found. Try searching for the document URL instead of the document title.": "Nenhum download foi encontrado. Tente pesquisar pelo URL do documento em vez do título.",
    "No more PDF accessibility scans are available for this account. Please contact a Acquia Web Governance sales department to add more.": "Não há mais digitalizações de acessibilidade em PDF disponíveis para esta conta. Entre em contato com o departamento de vendas da Acquia Web Governance para adicionar mais.",
    "Not valid URL": "URL inválida",
    "PageCorrect failed to save, the Acquia Web Governance team has been notified of the error": "A correção de página falhou ao salvar; a equipe de Governança Web da Acquia foi notificada do erro.",
    "Pages Without Visits": "Páginas sem visitas",
    "Part of success criteria [[issueNumber]]": "Parte dos critérios de sucesso [[issueNumber]]",
    "Pick any link on your website which you know opens in a new page (social media icons are usually a safe bet) and try to navigate away from the page you are on. If the pop-up doesn't appear it might be because the script has not been applied yet. Give it some time.": "Escolha qualquer link no seu site que você saiba que abre em uma nova página (ícones de redes sociais costumam ser uma boa opção) e tente navegar para outra página. Se o pop-up não aparecer, pode ser porque o script ainda não foi aplicado. Aguarde um pouco.",
    "Policy Scan is no longer valid. Press Run Policy to update Policy Scan details": "A verificação de políticas não é mais válida. Clique em &quot;Executar Política&quot; para atualizar os detalhes da verificação.",
    "Readability Checker": "Verificador de legibilidade",
    "Readability Level": "Nível de legibilidade",
    "Readability Summary": "Resumo de legibilidade",
    "Remove word from Ignored Misspellings": "Remover palavra da lista de erros ortográficos ignorados",
    "Remove word from dictionary": "Remover palavra do dicionário",
    "Request Remediation from selection": "Solicitar correção a partir da seleção",
    "Request failed. Please ensure you have added only text in the input field.": "A solicitação falhou. Certifique-se de ter inserido apenas texto no campo de entrada.",
    "Scan stopped successfully": "A digitalização foi concluída com sucesso.",
    "Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan": "Agende relatórios para você mesmo [[adminText]] por e-mail após cada verificação do Acquia Web Governance.",
    "Search for content that*": "Procure conteúdo que*",
    "Something went wrong. The Acquia Web Governance Team has been notified of this error and will get back to you, as soon as possible.": "Ocorreu um problema. A equipe de Governança Web da Acquia foi notificada do erro e entrará em contato com você o mais breve possível.",
    "Start Cookie Scan": "Iniciar verificação de cookies",
    "Start Scan": "Iniciar digitalização",
    "Start a new scan to find cookies or add them manually": "Inicie uma nova verificação para encontrar cookies ou adicione-os manualmente.",
    "Stop scan": "Interrompa a digitalização",
    "Switch to Acquia Web Governance classic": "Mude para o Acquia Web Governance clássico.",
    "Test your website's compliance levels ([[level]]) and fix issues that are making it difficult for people with disabilities to use your website": "Teste os níveis de conformidade do seu site ([[level]]) e corrija os problemas que dificultam o uso do seu site por pessoas com deficiência.",
    "The Acquia Web Governance team is notified and are working on the issue.": "A equipe de Governança Web da Acquia foi notificada e está trabalhando na resolução do problema.",
    "The Compound Export contains data from the first and last scans within the selected date range. The export does not include data from the following sources:": "A Exportação de Compostos contém dados da primeira e da última varredura dentro do intervalo de datas selecionado. A exportação não inclui dados das seguintes fontes:",
    "The profile has been archived.": "O perfil foi arquivado.",
    "The profile has been restored.": "O perfil foi restaurado.",
    "There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.": "Só existe uma maneira de fazer isso. O Acquia Web Governance substituirá todas as tags &lt;i&gt; encontradas no seu site por tags em.",
    "Type in or paste text to be analyzed": "Digite ou cole o texto a ser analisado.",
    "URL &amp; Title": "URL e título",
    "Unignore Misspelling": "Ignorar erros de ortografia",
    "Url &amp; Title": "URL e título",
    "Visitors screen resolutions export": "Exportar resoluções de tela para visitantes",
    "Weight in score: [[weight]]": "Peso na pontuação: [[weight]]",
    "Why can't I open a new window without warning?": "Por que não consigo abrir uma nova janela sem aviso prévio?",
    "Why do I need a \\\"skip to content\\\" link?": "Por que preciso de um link &quot;pular para o conteúdo&quot;?",
    "Why shouldn't I use the marquee element?": "Por que eu não deveria usar o elemento de seleção retangular?",
    "You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here": "Você está usando a nova versão do Acquia Web Governance PageAssist. Se desejar retornar à versão 1.0, clique aqui.",
    "You can only calculate a score for up to [[count]] characters.": "Você só pode calcular uma pontuação para até [[count]] caracteres.",
    "You do not have sufficient permissions to use this feature.": "Você não possui permissões suficientes para usar este recurso.",
    "Your current plan does not include on-demand scans. Please reach out to your Acquia Web Governance representative to learn more about this option": "Seu plano atual não inclui verificações sob demanda. Entre em contato com seu representante da Acquia Web Governance para saber mais sobre essa opção.",
    "[[$count]] found": "[[$count]] encontrado",
    "[[count]] found": "[[count]] encontrado",
    "[[headerCount]] found": "[[headerCount]] encontrado",
    "[[pageIssues]] Pages <span>([[errorPercentage]]%)</span> to fix": "[[pageIssues]] Páginas <span>([[errorPercentage]]%)</span> para corrigir",
    "[[pageIssues]] Pages to fix": "[[pageIssues]] Páginas a corrigir",
    "[[pagesDone]] Pages ([[compliancePercentage]]) in compliance": "[[pagesDone]] Páginas ([[compliancePercentage]]) em conformidade",
    "[[totalPageIssues]] Pages ([[compliancePercentage]]) to fix": "[[totalPageIssues]] Páginas ([[compliancePercentage]]) para corrigir",
    "failed when trying to ignore/review all. please try agin, or contact the Acquia Web Governance team": "Falha ao tentar ignorar/revisar tudo. Tente novamente ou entre em contato com a equipe de Governança Web da Acquia.",
    "policies": "políticas",
    "policy": "política",
    "<strong>' + linksTotal + '</strong> ' + ('link": "<strong>&#39; + linksTotal + &#39;</strong> &#39; + (&#39;link",
    "Add domain": "Adicionar domínio",
    "There are [[seoContentCount]] META descriptions on this page": "Existem [[seoContentCount]] descrições META nesta página.",
    "Total documents scanned": "Total de documentos digitalizados",
    "Total pages scanned": "Total de páginas digitalizadas",
    "admin.apiTokens.table.breadcrumbLabel": "admin.apiTokens.table.breadcrumbLabel",
    "admin.auditLog.table.breadcrumbLabel": "admin.auditLog.table.breadcrumbLabel",
    "admin.dashboard.breadcrumbLabel": "admin.dashboard.breadcrumbLabel",
    "admin.labels.actions.deleteButtonLabel": "admin.labels.actions.deleteButtonLabel",
    "admin.labels.actions.editButtonLabel": "admin.labels.actions.editButtonLabel",
    "admin.labels.deleteDialog.cancelBtnLabel": "admin.labels.deleteDialog.cancelBtnLabel",
    "admin.labels.deleteDialog.deleteBtnLabel": "admin.labels.deleteDialog.deleteBtnLabel",
    "admin.labels.deleteDialog.header": "admin.labels.deleteDialog.header",
    "admin.labels.deleteDialog.message{{labelName}}": "admin.labels.deleteDialog.message{{labelName}}",
    "admin.labels.dialogHeader.add": "admin.labels.dialogHeader.add",
    "admin.labels.dialogHeader.edit": "admin.labels.dialogHeader.edit",
    "admin.labels.labelInUseDialog.header": "admin.labels.labelInUseDialog.header",
    "admin.labels.table.breadcrumbLabel": "admin.labels.table.breadcrumbLabel",
    "admin.labels.toastDetail.labelCreated": "admin.labels.toastDetail.labelCreated",
    "admin.labels.toastDetail.labelDeleteError{{labelName}}": "admin.labels.toastDetail.labelDeleteError{{labelName}}",
    "admin.labels.toastDetail.labelDeleted{{labelName}}": "admin.labels.toastDetail.labelDeleted{{labelName}}",
    "admin.labels.toastDetail.labelUpdated": "admin.labels.toastDetail.labelUpdated",
    "admin.leftnav.api_tokens": "admin.leftnav.api_tokens",
    "admin.leftnav.audit_log": "admin.leftnav.audit_log",
    "admin.leftnav.configuration": "admin.leftnav.configuration",
    "admin.leftnav.dashboard": "admin.leftnav.dashboard",
    "admin.leftnav.integrations": "admin.leftnav.integrações",
    "admin.leftnav.labels": "admin.leftnav.labels",
    "admin.leftnav.performance_profiles": "admin.leftnav.performance_profiles",
    "admin.leftnav.scan_exclusions": "admin.leftnav.scan_exclusions",
    "admin.leftnav.user_management": "admin.leftnav.user_management",
    "admin.leftnav.users": "admin.leftnav.users",
    "admin.performanceProfiles.form.add.breadcrumbLabel": "admin.performanceProfiles.form.add.breadcrumbLabel",
    "admin.performanceProfiles.form.edit.breadcrumbLabel": "admin.performanceProfiles.form.edit.breadcrumbLabel",
    "admin.performanceProfiles.table.breadcrumbLabel": "admin.performanceProfiles.table.breadcrumbLabel",
    "admin.user.form.add.breadcrumbLabel": "admin.user.form.add.breadcrumbLabel",
    "admin.user.form.edit.breadcrumbLabel": "admin.user.form.edit.breadcrumbLabel",
    "admin.user.form.error.loadDomainsMessage": "admin.user.form.error.loadDomainsMessage",
    "admin.user.form.error.loadMessage": "admin.user.form.error.loadMessage",
    "admin.user.form.invalidInputToast": "admin.user.form.invalidInputToast",
    "admin.user.form.toast.createSuccessMessage{{firstName}}": "admin.user.form.toast.createSuccessMessage{{firstName}}",
    "admin.user.form.toast.domainIdsErrorDetail": "admin.user.form.toast.domainIdsErrorDetail",
    "admin.user.form.toast.updateSuccessMessage{{firstName}}": "admin.user.form.toast.updateSuccessMessage{{firstName}}",
    "admin.user.permissions.accessibility": "admin.user.permissions.accessibility",
    "admin.user.permissions.content_pages": "admin.user.permissions.content_pages",
    "admin.user.permissions.cookie_banner": "admin.user.permissions.cookie_banner",
    "admin.user.permissions.data_privacy": "admin.user.permissions.data_privacy",
    "admin.user.permissions.inventory": "admin.user.permissions.inventory",
    "admin.user.permissions.page_fix": "admin.user.permissions.page_fix",
    "admin.user.permissions.pagecorrect": "admin.user.permissions.pagecorrect",
    "admin.user.permissions.performance": "admin.user.permissions.performance",
    "admin.user.permissions.policies": "admin.user.permissions.policies",
    "admin.user.permissions.qa": "admin.user.permissions.qa",
    "admin.user.permissions.seo": "admin.user.permissions.seo",
    "admin.user.permissions.statistics": "admin.user.permissions.statistics",
    "admin.user.permissions.uptime": "admin.user.permissions.uptime",
    "admin.users.actions.deleteButtonLabel": "admin.users.actions.deleteButtonLabel",
    "admin.users.actions.editButtonLabel": "admin.users.actions.editButtonLabel",
    "admin.users.addLabelToUserSuccess.details{{userEmail}}{{labelName}}": "admin.users.addLabelToUserSuccess.details{{userEmail}}{{labelName}}",
    "admin.users.deleteDialog.header": "admin.users.deleteDialog.header",
    "admin.users.deleteDialog.message": "admin.users.deleteDialog.message",
    "admin.users.deleteSuccessToast.message{{userName}}": "admin.users.deleteSuccessToast.message{{userName}}",
    "admin.users.deleteUserDialog.acceptButtonLabel": "admin.users.deleteUserDialog.acceptButtonLabel",
    "admin.users.deleteUserDialog.rejectButtonLabel": "admin.users.deleteUserDialog.rejectButtonLabel",
    "admin.users.last_login.never": "admin.users.last_login.never",
    "admin.users.role.filterLabel.admin": "admin.users.role.filterLabel.admin",
    "admin.users.role.filterLabel.regular": "admin.users.role.filterLabel.regular",
    "admin.users.table.breadcrumbLabel": "admin.users.table.breadcrumbLabel",
    "admin.users.updateLabelErrorToast.summary{{userEmail}}": "admin.users.updateLabelErrorToast.summary{{userEmail}}",
    "admin.users.updateLabelSuccessToast.summary{{userEmail}}": "admin.users.updateLabelSuccessToast.summary{{userEmail}}",
    "adminApiTokens.addApiTokenDialog.header": "adminApiTokens.addApiTokenDialog.header",
    "adminApiTokens.addApiTokenToast.success": "adminApiTokens.addApiTokenToast.success",
    "adminApiTokens.deleteApiTokenDialog.acceptButtonLabel": "adminApiTokens.deleteApiTokenDialog.acceptButtonLabel",
    "adminApiTokens.deleteApiTokenDialog.description": "adminApiTokens.deleteApiTokenDialog.description",
    "adminApiTokens.deleteApiTokenDialog.header": "adminApiTokens.deleteApiTokenDialog.header",
    "adminApiTokens.deleteApiTokenDialog.rejectButtonLabel": "adminApiTokens.deleteApiTokenDialog.rejectButtonLabel",
    "adminApiTokens.deleteApiTokenToast.success": "adminApiTokens.deleteApiTokenToast.success",
    "adminApiTokens.revokeApiTokenDialog.acceptButtonLabel": "adminApiTokens.revokeApiTokenDialog.acceptButtonLabel",
    "adminApiTokens.revokeApiTokenDialog.description": "adminApiTokens.revokeApiTokenDialog.descrição",
    "adminApiTokens.revokeApiTokenDialog.header": "adminApiTokens.revokeApiTokenDialog.header",
    "adminApiTokens.revokeApiTokenDialog.rejectButtonLabel": "adminApiTokens.revokeApiTokenDialog.rejectButtonLabel",
    "adminApiTokens.revokeApiTokenDialog.subDescription": "adminApiTokens.revokeApiTokenDialog.subDescrição",
    "adminApiTokens.revokeApiTokenToast.success": "adminApiTokens.revokeApiTokenToast.success",
    "adminApiTokens.scope.cms": "adminApiTokens.scope.cms",
    "adminApiTokens.scope.customer": "adminApiTokens.scope.customer",
    "adminApiTokens.scope.customerAdmin": "adminApiTokens.scope.customerAdmin",
    "adminApiTokens.table.deleteApiTokenButton.ariaLabel": "adminApiTokens.table.deleteApiTokenButton.ariaLabel",
    "adminApiTokens.table.revokeApiTokenButton.ariaLabel": "adminApiTokens.table.revokeApiTokenButton.ariaLabel",
    "adminAuditLog.createExportDialog.buttonLabel": "adminAuditLog.createExportDialog.buttonLabel",
    "adminAuditLog.dialog.showDetails.title": "adminAuditLog.dialog.showDetails.title",
    "adminAuditLog.dialog.undoCheckReview.title": "adminAuditLog.dialog.undoCheckReview.title",
    "adminAuditLog.dialog.viewChanges.title": "adminAuditLog.dialog.viewChanges.title",
    "adminAuditLog.table.action.showDetails": "adminAuditLog.table.action.showDetails",
    "adminAuditLog.table.action.undoCheckReview": "adminAuditLog.table.action.undoCheckReview",
    "adminAuditLog.table.action.viewChanges": "adminAuditLog.table.action.viewChanges",
    "adminDashboard.card.label.description": "adminDashboard.card.label.description",
    "adminDashboard.card.label.title": "adminDashboard.card.label.title",
    "adminDashboard.card.scanExclusion.description": "adminDashboard.card.scanExclusion.description",
    "adminDashboard.card.scanExclusion.title": "adminDashboard.card.scanExclusion.title",
    "adminDashboard.card.user.description": "adminDashboard.card.user.description",
    "adminDashboard.card.user.title": "Painel de administração.cartão.usuário.título",
    "adminPerformanceProfiles.addEdit.addLabel": "adminPerformanceProfiles.addEdit.addLabel",
    "adminPerformanceProfiles.addEdit.editLabel": "adminPerformanceProfiles.addEdit.editLabel",
    "adminPerformanceProfiles.addEdit.form.createSuccess{{profileName}}": "adminPerformanceProfiles.addEdit.form.createSuccess{{profileName}}",
    "adminPerformanceProfiles.addEdit.form.deviceOptions.desktop": "adminPerformanceProfiles.addEdit.form.deviceOptions.desktop",
    "adminPerformanceProfiles.addEdit.form.deviceOptions.mobile": "adminPerformanceProfiles.addEdit.form.deviceOptions.mobile",
    "adminPerformanceProfiles.addEdit.form.editSuccess{{profileName}}": "adminPerformanceProfiles.addEdit.form.editSuccess{{profileName}}",
    "adminPerformanceProfiles.addEdit.form.saveError{{profileName}}": "adminPerformanceProfiles.addEdit.form.saveError{{profileName}}",
    "adminPerformanceProfiles.addEdit.pageHeaderCommon": "adminPerformanceProfiles.addEdit.pageHeaderCommon",
    "adminPerformanceProfiles.archiveDialog.archiveFailedToast{{profileName}}": "adminPerformanceProfiles.archiveDialog.archiveFailedToast{{profileName}}",
    "adminPerformanceProfiles.archiveDialog.archiveSuccessToast{{profileName}}": "adminPerformanceProfiles.archiveDialog.archiveSuccessToast{{profileName}}",
    "adminPerformanceProfiles.archiveDialog.header": "adminPerformanceProfiles.archiveDialog.header",
    "adminPerformanceProfiles.profileLimitDialog.header": "adminPerformanceProfiles.profileLimitDialog.header",
    "adminPerformanceProfiles.profileLimitDialog.requestProfileMessage": "adminPerformanceProfiles.profileLimitDialog.requestProfileMessage",
    "adminPerformanceProfiles.profileLimitDialog.requestProfileSuccessToast": "adminPerformanceProfiles.profileLimitDialog.requestProfileSuccessToast",
    "adminPerformanceProfiles.restoreDialog.header": "adminPerformanceProfiles.restoreDialog.header",
    "adminPerformanceProfiles.restoreDialog.restoreFailedToast{{profileName}}": "adminPerformanceProfiles.restoreDialog.restoreFailedToast{{profileName}}",
    "adminPerformanceProfiles.restoreDialog.restoreSuccessToast{{profileName}}": "adminPerformanceProfiles.restoreDialog.restoreSuccessToast{{profileName}}",
    "adminPerformanceProfiles.table.actions.archiveProfile": "adminPerformanceProfiles.table.actions.archiveProfile",
    "adminPerformanceProfiles.table.actions.editProfile": "adminPerformanceProfiles.table.actions.editProfile",
    "adminPerformanceProfiles.table.actions.restoreProfile": "adminPerformanceProfiles.table.actions.restoreProfile",
    "adminScanExclusions.accessibility.module": "adminScanExclusions.accessibility.module",
    "adminScanExclusions.actions.deleteButtonLabel": "adminScanExclusions.actions.deleteButtonLabel",
    "adminScanExclusions.actions.editButtonLabel": "adminScanExclusions.actions.editButtonLabel",
    "adminScanExclusions.deleteDialog.cancelBtnLabel": "adminScanExclusions.deleteDialog.cancelBtnLabel",
    "adminScanExclusions.deleteDialog.confirmMessage{{scanExclusionName}}": "adminScanExclusions.deleteDialog.confirmMessage{{scanExclusionName}}",
    "adminScanExclusions.deleteDialog.deleteBtnLabel": "adminScanExclusions.deleteDialog.deleteBtnLabel",
    "adminScanExclusions.deleteDialog.deleteSuccess{{scanExclusionName}}": "adminScanExclusions.deleteDialog.deleteSuccess{{scanExclusionName}}",
    "adminScanExclusions.deleteDialog.header": "adminScanExclusions.deleteDialog.header",
    "adminScanExclusions.form.cmsOptions.noneOptionLabel": "adminScanExclusions.form.cmsOptions.noneOptionLabel",
    "adminScanExclusions.form.create.errorToast": "adminScanExclusions.form.create.errorToast",
    "adminScanExclusions.form.create.successToast": "adminScanExclusions.form.create.successToast",
    "adminScanExclusions.form.invalidInputToast": "adminScanExclusions.form.invalidInputToast",
    "adminScanExclusions.form.scanExclusion.failedToast": "adminScanExclusions.form.scanExclusion.failedToast",
    "adminScanExclusions.form.scanExclusion.notFoundToast": "adminScanExclusions.form.scanExclusion.notFoundToast",
    "adminScanExclusions.form.update.errorToast": "adminScanExclusions.form.update.errorToast",
    "adminScanExclusions.form.update.successToast": "adminScanExclusions.form.update.successToast",
    "adminScanExclusions.getScanExclusions.failedToast": "adminScanExclusions.getScanExclusions.failedToast",
    "adminScanExclusions.misspellings.module": "adminScanExclusions.misspellings.module",
    "adminScanExclusions.readability.module": "adminScanExclusions.readability.module",
    "createExport.dialog.exportInProgress.header": "criarExportação.dialog.exportInProgress.header",
    "createExport.dialog.header": "criarExportação.dialog.header",
    "export.pipe.brokenPageLink": "export.pipe.brokenPageLink",
    "export.pipe.documentsBasic": "export.pipe.documentsBasic",
    "export.pipe.pagesDocuments": "export.pipe.pagesDocumentos",
    "export.pipe.scanHistoryOverview": "export.pipe.scanHistoryOverview",
    "export.pipe.siteSearch.keywords": "export.pipe.siteSearch.keywords",
    "export.pipe.siteSearch.noResultKeywords": "export.pipe.siteSearch.noResultKeywords",
    "label.addDialog.header": "label.addDialog.header",
    "label.select.add": "rótulo.selecionar.adicionar",
    "label.select.edit": "label.select.edit",
    "label.select.emptyMessage": "label.select.emptyMessage",
    "label.select.emptySearchMessage": "label.select.emptySearchMessage",
    "locale.danish": "local.danish",
    "locale.dutch": "local.holandês",
    "locale.english": "local.inglês",
    "locale.french": "local.francês",
    "locale.japanese": "local.japonês",
    "locale.norwegian": "local.norueguês",
    "locale.swedish": "local.sueco",
    "myExports.dialog.header": "myExports.dialog.header",
    "page added since last scan": "Página adicionada desde a última verificação.",
    "primeng.accept": "primeng.aceitar",
    "primeng.addRule": "primeng.adicionarRegra",
    "primeng.after": "primeng.após",
    "primeng.am": "primeng.am",
    "primeng.apply": "primeng.apply",
    "primeng.aria.browseFiles": "primeng.aria.browseFiles",
    "primeng.aria.cancelEdit": "primeng.aria.cancelarEditar",
    "primeng.aria.close": "primeng.aria.close",
    "primeng.aria.collapseRow": "primeng.aria.collapseRow",
    "primeng.aria.editRow": "primeng.aria.editRow",
    "primeng.aria.expandRow": "primeng.aria.expandRow",
    "primeng.aria.falseLabel": "primeng.aria.falseLabel",
    "primeng.aria.filterConstraint": "primeng.aria.filterConstraint",
    "primeng.aria.filterOperator": "primeng.aria.filterOperador",
    "primeng.aria.firstPageLabel": "primeng.aria.firstPageLabel",
    "primeng.aria.gridView": "primeng.aria.gridView",
    "primeng.aria.hideFilterMenu": "primeng.aria.hideFilterMenu",
    "primeng.aria.jumpToPageDropdownLabel": "primeng.aria.jumpToPageDropdownLabel",
    "primeng.aria.jumpToPageInputLabel": "primeng.aria.jumpToPageInputLabel",
    "primeng.aria.lastPageLabel": "primeng.aria.lastPageLabel",
    "primeng.aria.listLabel": "primeng.aria.listLabel",
    "primeng.aria.listView": "primeng.aria.listView",
    "primeng.aria.maximizeLabel": "primeng.aria.maximizeLabel",
    "primeng.aria.moveAllToSource": "primeng.aria.moveAllToSource",
    "primeng.aria.moveAllToTarget": "primeng.aria.moverTudoParaAlvo",
    "primeng.aria.moveBottom": "primeng.aria.movemBottom",
    "primeng.aria.moveDown": "primeng.aria.movedDown",
    "primeng.aria.moveToSource": "primeng.aria.movedToSource",
    "primeng.aria.moveToTarget": "primeng.aria.movingToTarget",
    "primeng.aria.moveTop": "primeng.aria.movedTop",
    "primeng.aria.moveUp": "primeng.aria.movedUp",
    "primeng.aria.navigation": "primeng.aria.navegação",
    "primeng.aria.next": "primeng.aria.next",
    "primeng.aria.nextPageLabel": "primeng.aria.nextPageLabel",
    "primeng.aria.nullLabel": "primeng.aria.nullLabel",
    "primeng.aria.pageLabel": "primeng.aria.pageLabel",
    "primeng.aria.prevPageLabel": "primeng.aria.prevPageLabel",
    "primeng.aria.previous": "primeng.aria.anterior",
    "primeng.aria.previousPageLabel": "primeng.aria.previousPageLabel",
    "primeng.aria.removeLabel": "primeng.aria.removeLabel",
    "primeng.aria.rotateLeft": "primeng.aria.rotateLeft",
    "primeng.aria.rotateRight": "primeng.aria.rotateRight",
    "primeng.aria.rowsPerPageLabel": "primeng.aria.rowsPerPageLabel",
    "primeng.aria.saveEdit": "primeng.aria.saveEdit",
    "primeng.aria.scrollTop": "primeng.aria.scrollTop",
    "primeng.aria.selectAll": "primeng.aria.selectAll",
    "primeng.aria.selectColor": "primeng.aria.selectColor",
    "primeng.aria.selectRow": "primeng.aria.selectRow",
    "primeng.aria.showFilterMenu": "primeng.aria.showFilterMenu",
    "primeng.aria.slide": "primeng.aria.slide",
    "primeng.aria.slideNumber": "primeng.aria.slideNumber",
    "primeng.aria.star": "primeng.aria.star",
    "primeng.aria.stars": "primeng.aria.estrelas",
    "primeng.aria.trueLabel": "primeng.aria.trueLabel",
    "primeng.aria.unselectAll": "primeng.aria.unselectAll",
    "primeng.aria.unselectRow": "primeng.aria.unselectRow",
    "primeng.aria.zoomImage": "primeng.aria.zoomImage",
    "primeng.aria.zoomIn": "primeng.aria.zoomIn",
    "primeng.aria.zoomOut": "primeng.aria.zoomOut",
    "primeng.before": "primeng.antes",
    "primeng.cancel": "primeng.cancelar",
    "primeng.choose": "primeng.escolha",
    "primeng.chooseDate": "primeng.escolhaData",
    "primeng.chooseMonth": "primeng.escolhaMês",
    "primeng.chooseYear": "primeng.escolhaAno",
    "primeng.clear": "primeng.limpar",
    "primeng.contains": "primeng.contém",
    "primeng.dateAfter": "primeng.dateAfter",
    "primeng.dateBefore": "primeng.dateBefore",
    "primeng.dateFormat": "primeng.dateFormat",
    "primeng.dateIs": "primeng.dateIs",
    "primeng.dateIsNot": "primeng.dateIsNot",
    "primeng.dayNames.0": "primeng.dayNames.0",
    "primeng.dayNames.1": "primeng.dayNames.1",
    "primeng.dayNames.2": "primeng.dayNames.2",
    "primeng.dayNames.3": "primeng.dayNames.3",
    "primeng.dayNames.4": "primeng.dayNames.4",
    "primeng.dayNames.5": "primeng.dayNames.5",
    "primeng.dayNames.6": "primeng.dayNames.6",
    "primeng.dayNamesMin.0": "primeng.dayNamesMin.0",
    "primeng.dayNamesMin.1": "primeng.dayNamesMin.1",
    "primeng.dayNamesMin.2": "primeng.dayNamesMin.2",
    "primeng.dayNamesMin.3": "primeng.dayNamesMin.3",
    "primeng.dayNamesMin.4": "primeng.dayNamesMin.4",
    "primeng.dayNamesMin.5": "primeng.dayNamesMin.5",
    "primeng.dayNamesMin.6": "primeng.dayNamesMin.6",
    "primeng.dayNamesShort.0": "primeng.dayNamesShort.0",
    "primeng.dayNamesShort.1": "primeng.dayNamesShort.1",
    "primeng.dayNamesShort.2": "primeng.dayNamesShort.2",
    "primeng.dayNamesShort.3": "primeng.dayNamesShort.3",
    "primeng.dayNamesShort.4": "primeng.dayNamesShort.4",
    "primeng.dayNamesShort.5": "primeng.dayNamesShort.5",
    "primeng.dayNamesShort.6": "primeng.dayNamesShort.6",
    "primeng.emptyFilterMessage": "primeng.mensagemFiltroEmpty",
    "primeng.emptyMessage": "primeng.mensagemvazia",
    "primeng.emptySearchMessage": "primeng.mensagemDeBuscaEmpty",
    "primeng.emptySelectionMessage": "primeng.mensagem de seleção vazia",
    "primeng.endsWith": "primeng.terminaCom",
    "primeng.equals": "primeng.igual",
    "primeng.fileChosenMessage": "primeng.fileMensagemEscolhida",
    "primeng.fileSizeTypes.0": "primeng.fileSizeTypes.0",
    "primeng.fileSizeTypes.1": "primeng.fileSizeTypes.1",
    "primeng.fileSizeTypes.2": "primeng.fileSizeTypes.2",
    "primeng.fileSizeTypes.3": "primeng.fileSizeTypes.3",
    "primeng.fileSizeTypes.4": "primeng.fileSizeTypes.4",
    "primeng.fileSizeTypes.5": "primeng.fileSizeTypes.5",
    "primeng.fileSizeTypes.6": "primeng.fileSizeTypes.6",
    "primeng.fileSizeTypes.7": "primeng.fileSizeTypes.7",
    "primeng.fileSizeTypes.8": "primeng.fileSizeTypes.8",
    "primeng.firstDayOfWeek": "primeng.primeiroDiaDaSemana",
    "primeng.gt": "primeng.gt",
    "primeng.gte": "primeng.gte",
    "primeng.is": "primeng.is",
    "primeng.isNot": "primeng.não é",
    "primeng.lt": "primeng.lt",
    "primeng.lte": "primeng.lte",
    "primeng.matchAll": "primeng.matchAll",
    "primeng.matchAny": "primeng.matchAny",
    "primeng.medium": "primeng.médio",
    "primeng.monthNames.0": "primeng.monthNames.0",
    "primeng.monthNames.1": "primeng.monthNames.1",
    "primeng.monthNames.10": "primeng.monthNames.10",
    "primeng.monthNames.11": "primeng.monthNames.11",
    "primeng.monthNames.2": "primeng.monthNames.2",
    "primeng.monthNames.3": "primeng.monthNames.3",
    "primeng.monthNames.4": "primeng.monthNames.4",
    "primeng.monthNames.5": "primeng.monthNames.5",
    "primeng.monthNames.6": "primeng.monthNames.6",
    "primeng.monthNames.7": "primeng.monthNames.7",
    "primeng.monthNames.8": "primeng.monthNames.8",
    "primeng.monthNames.9": "primeng.monthNames.9",
    "primeng.monthNamesShort.0": "primeng.monthNamesShort.0",
    "primeng.monthNamesShort.1": "primeng.monthNamesShort.1",
    "primeng.monthNamesShort.10": "primeng.monthNamesShort.10",
    "primeng.monthNamesShort.11": "primeng.monthNamesShort.11",
    "primeng.monthNamesShort.2": "primeng.monthNamesShort.2",
    "primeng.monthNamesShort.3": "primeng.monthNamesShort.3",
    "primeng.monthNamesShort.4": "primeng.monthNamesShort.4",
    "primeng.monthNamesShort.5": "primeng.monthNamesShort.5",
    "primeng.monthNamesShort.6": "primeng.monthNamesShort.6",
    "primeng.monthNamesShort.7": "primeng.monthNamesShort.7",
    "primeng.monthNamesShort.8": "primeng.monthNamesShort.8",
    "primeng.monthNamesShort.9": "primeng.monthNamesShort.9",
    "primeng.nextDecade": "primeng.próximadécada",
    "primeng.nextHour": "primeng.próximaHora",
    "primeng.nextMinute": "primeng.nextMinuto",
    "primeng.nextMonth": "primeng.próximo mês",
    "primeng.nextSecond": "primeng.nextSecond",
    "primeng.nextYear": "primeng.nextYear",
    "primeng.noFileChosenMessage": "primeng.noFileChosenMessage",
    "primeng.noFilter": "primeng.semFiltro",
    "primeng.notContains": "primeng.nãoContém",
    "primeng.notEquals": "primeng.não é igual a",
    "primeng.passwordPrompt": "primeng.passwordPrompt",
    "primeng.pending": "primeng.pendente",
    "primeng.pm": "primeng.pm",
    "primeng.prevDecade": "primeng.década anterior",
    "primeng.prevHour": "primeng.prevHour",
    "primeng.prevMinute": "primeng.prevMinuto",
    "primeng.prevMonth": "primeng.mês anterior",
    "primeng.prevSecond": "primeng.prevSegundo",
    "primeng.prevYear": "primeng.ano anterior",
    "primeng.reject": "primeng.rejeitar",
    "primeng.removeRule": "primeng.removeRule",
    "primeng.searchMessage": "primeng.searchMessage",
    "primeng.selectionMessage": "primeng.selectionMessage",
    "primeng.startsWith": "primeng.começaCom",
    "primeng.strong": "primeng.forte",
    "primeng.today": "primeng.hoje",
    "primeng.upload": "primeng.upload",
    "primeng.weak": "primeng.fraco",
    "primeng.weekHeader": "primeng.weekHeader",
    "toast.summary.error": "toast.summary.error",
    "toast.summary.info": "toast.summary.info",
    "toast.summary.notice": "aviso de resumo",
    "toast.summary.success": "brinde.resumo.sucesso",
    "toast.summary.warning": "toast.summary.warning",
    "unsavedFormCheck.dialog.acceptButtonLabel": "unsavedFormCheck.dialog.acceptButtonLabel",
    "unsavedFormCheck.dialog.header": "unsavedFormCheck.dialog.header",
    "unsavedFormCheck.dialog.message": "mensagem de diálogo de verificação de formulário não salvo",
    "unsavedFormCheck.dialog.rejectButtonLabel": "unsavedFormCheck.dialog.rejectButtonLabel",
    "Create issue": "Criar problema",
    "Create issue in Jira": "Criar solicitação no Jira",
    "Declared language": "Língua declarada",
    "Detected Languages": "Idiomas detectados",
    "Detected language": "Idioma detectado",
    "Export documents without downloads": "Exportar documentos sem fazer downloads",
    "Good job! No language issues were found": "Ótimo trabalho! Não foram encontrados problemas com o idioma.",
    "Identify pages with incorrect or missing language tags.": "Identificar páginas com etiquetas de idioma incorretas ou ausentes.",
    "Issues by page": "Edições por página",
    "Language Validation": "Validação de idioma",
    "Language Validation summary": "Resumo da Validação de Idioma",
    "Language distribution": "Distribuição de idiomas",
    "Language mismatch": "Incompatibilidade de idiomas",
    "Language tag analysis": "Análise de etiquetas de idioma",
    "Languages match": "Os idiomas correspondem",
    "Loading language validation data...": "Carregando dados de validação de idioma...",
    "Mismatch detected": "Incompatibilidade detectada",
    "Multi-language": "Multilíngue",
    "Multi-language tag": "Etiqueta multilíngue",
    "No language match data available for this page": "Não há dados de correspondência de idioma disponíveis para esta página.",
    "No language tag analysis data available.": "Não há dados disponíveis para análise de etiquetas de idioma.",
    "No languages detected": "Nenhum idioma detectado",
    "Not declared": "Não declarado",
    "Not detected": "Não detectado",
    "Pages missing language": "Páginas sem idioma",
    "Pages with incorrect language": "Páginas com linguagem incorreta",
    "Pages with incorrect language tag": "Páginas com etiqueta de idioma incorreta",
    "Pages with insufficient text for language detection": "Páginas com texto insuficiente para detecção de idioma",
    "Pages with language issues": "Páginas com problemas de idioma",
    "Pages with multiple languages detected": "Páginas com vários idiomas detectadas",
    "Pages without issues": "Páginas sem problemas",
    "The setting \\\"Use language attribute\\\" is disabled for this domain. Please edit the domain and activate the setting to use this feature.\\\"": "A configuração &quot;Usar atributo de idioma&quot; está desativada para este domínio. Edite o domínio e ative a configuração para usar esse recurso.",
    "Use language attribute is disabled for this domain, please activate it to use this module": "O atributo &quot;Usar idioma&quot; está desativado para este domínio. Ative-o para usar este módulo.",
    "View issue": "Ver problema",
    "View issue in Jira": "Visualizar problema no Jira",
    "admin.jiraConnector.deleteDialog.cancelButtonLabel": "admin.jiraConnector.deleteDialog.cancelButtonLabel",
    "admin.jiraConnector.deleteDialog.deleteButtonLabel": "admin.jiraConnector.deleteDialog.deleteButtonLabel",
    "admin.jiraConnector.deleteDialog.header": "admin.jiraConnector.deleteDialog.header",
    "admin.jiraConnector.deleteDialog.message": "admin.jiraConnector.deleteDialog.message",
    "admin.jiraConnector.toast.authenticationError": "admin.jiraConnector.toast.authenticationError",
    "admin.jiraConnector.toast.deleteSuccess": "admin.jiraConnector.toast.deleteSuccess",
    "admin.jiraConnector.toast.genericError": "admin.jiraConnector.toast.genericError",
    "admin.jiraConnector.toast.invalidIssueTypeError": "admin.jiraConnector.toast.invalidIssueTypeError",
    "admin.jiraConnector.toast.invalidProjectKeyError": "admin.jiraConnector.toast.invalidProjectKeyError",
    "admin.jiraConnector.toast.loadError": "admin.jiraConnector.toast.loadError",
    "admin.jiraConnector.toast.saveError": "admin.jiraConnector.toast.saveError",
    "admin.jiraConnector.toast.saveSuccess": "admin.jiraConnector.toast.saveSucesso",
    "admin.jiraConnector.toast.testError": "admin.jiraConnector.toast.testError",
    "admin.jiraConnector.toast.testSuccess": "admin.jiraConnector.toast.testSuccess",
    "admin.labels.table.actions": "admin.rótulos.tabela.ações",
    "admin.labels.table.label": "admin.rótulos.tabela.rótulo",
    "admin.leftnav.jira_connector": "admin.leftnav.jira_connector",
    "admin.user.form.toast.createErrorEmailInUseDetail": "admin.user.form.toast.createErrorEmailInUseDetail",
    "admin.users.label.filterLabelPlaceholder": "admin.users.label.filterLabelPlaceholder",
    "admin.users.role.filterLabelPlaceholder": "admin.users.role.filterLabelPlaceholder",
    "admin.users.table.actions": "admin.users.table.actions",
    "admin.users.table.email": "admin.users.table.email",
    "admin.users.table.labels": "admin.users.table.labels",
    "admin.users.table.lastLogin": "admin.users.table.lastLogin",
    "admin.users.table.role": "admin.users.table.role",
    "admin.users.table.user": "admin.users.table.user",
    "adminApiTokens.table.header.actions": "adminApiTokens.table.header.actions",
    "adminApiTokens.table.header.apiUrl": "adminApiTokens.table.header.apiUrl",
    "adminApiTokens.table.header.description": "adminApiTokens.table.header.description",
    "adminApiTokens.table.header.scope": "adminApiTokens.table.header.scope",
    "adminApiTokens.table.header.token": "adminApiTokens.table.header.token",
    "adminAuditLog.table.header.action": "adminAuditLog.table.header.action",
    "adminAuditLog.table.header.date": "adminAuditLog.table.header.date",
    "adminAuditLog.table.header.domain": "adminAuditLog.table.header.domain",
    "adminAuditLog.table.header.identifier": "adminAuditLog.table.header.identifier",
    "adminAuditLog.table.header.module": "adminAuditLog.table.header.module",
    "adminAuditLog.table.header.target": "adminAuditLog.table.header.target",
    "adminAuditLog.table.header.user": "adminAuditLog.table.header.user",
    "adminPerformanceProfiles.table.actions": "adminPerfilsDeDesempenho.tabela.ações",
    "adminPerformanceProfiles.table.description": "adminPerfisDeDesempenho.tabela.descrição",
    "adminPerformanceProfiles.table.name": "adminPerfilsDeDesempenho.tabela.nome",
    "adminPerformanceProfiles.table.status": "adminPerfilsDeDesempenho.tabela.status",
    "adminScanExclusions.languageMatch.module": "adminScanExclusions.languageMatch.module",
    "adminScanExclusions.table.header.actions": "adminScanExclusions.table.header.actions",
    "adminScanExclusions.table.header.title": "adminScanExclusions.table.header.title",
    "global.error.generalErrorTitle": "global.error.generalErrorTitle",
    "Start export PDF Accessibility Report": "Iniciar exportação do relatório de clareza da página",
    "No data showing? Add the Acquia Web Governance script to your website": "Não há estatísticas sendo exibidas? Adicione o script Acquia Web Governance ao site."
  },
  "nl": {
    "Search": {
      "Spotlight": "Zoeken",
      "$$noContext": "Zoeken"
    },
    "Global Policy Overview": {
      "Topmenu": "Globale Policy Overzicht",
      "$$noContext": "Globale Policies Overzicht"
    },
    "History Center": {
      "Topmenu": "History Center",
      "$$noContext": "History Center"
    },
    "Report Center": {
      "Topmenu": "Rapportcentrum",
      "$$noContext": "Rapportcentrum"
    },
    "Users": {
      "Topmenu": "Gebruikers",
      "$$noContext": "Gebruikers"
    },
    "No content was found": {
      "page-details -> Inventory -> links. No result message": "Geen content gevonden",
      "$$noContext": "Er is geen content gevonden"
    },
    "&nbsp;&nbsp;&nbsp;Passwords does not match": "&nbsp;&nbsp;&nbsp;Wachtwoorden komen niet overeen",
    "(HTML and documents)": "(HTML en documenten)",
    "(No title found)": "(Geen titel gevonden)",
    "(The HTML snippet is now Marked as Reviewed/Ignored)": "(Het HTML-fragment is nu gemarkeerd als gecontroleerd/genegeerd)",
    "(This policy is marked as unwanted content)": "(Deze Policies zijn gemarkeerd als ongewenste content)",
    "+ Add new check": "+ Nieuwe controle toevoegen",
    "+ Add new user": "+ Nieuwe gebruiker toevoegen",
    "1 min.": "1 min.",
    "1 minute": "1 minuut",
    "10 min.": "10 min.",
    "10th to 12th grade": "10de tot 12de leerjaar",
    "120 min.": "120 min.",
    "15 min.": "15 min.",
    "1st": "1ste",
    "2nd": "2de",
    "30 min.": "30 min.",
    "3rd": "3de",
    "5 min.": "5 min.",
    "5 minutes": "5 minuten",
    "5th grade": "5de leerjaar",
    "60 min.": "60 min.",
    "6th grade": "6de leerjaar",
    "7th grade": "7de leerjaar",
    "8th to 9th grade": "8ste tot 9de leerjaar",
    "A": "A",
    "A list of all external PDF files already reviewed for accessibility issues": "Een lijst met alle externe pdf-bestanden die al zijn gecontroleerd op toegankelijkheidsproblemen",
    "A list of all external PDF files that you need to check for accessibility issues": "Een lijst met alle externe pdf-bestanden die je moet controleren op toegankelijkheidsproblemen",
    "A list of all internal PDF files already reviewed for accessibility issues": "Een lijst met alle interne PDF-bestanden die al zijn gecontroleerd op toegankelijkheidsproblemen",
    "A list of all internal PDF files that have been marked as failed for accessibility issues": "Een lijst met alle interne PDF-bestanden die zijn gemarkeerd als mislukt vanwege toegankelijkheidsproblemen",
    "A list of all internal PDF files that have been marked as queued for accessibility issues": "Een lijst met alle interne PDF-bestanden die zijn gemarkeerd als in de wachtrij vanwege toegankelijkheidsproblemen",
    "A list of all internal PDF files that you need to check for accessibility issues": "Een lijst met alle interne PDF-bestanden die je moet controleren op toegankelijkheidsproblemen",
    "AA": "AA",
    "AAA": "AAA",
    "ACCESSIBILITY OVERVIEW": "TOEGANKELIJKHEIDSOVERZICHT",
    "API Token": "API-token",
    "API URL": "API-URL",
    "API User": "API-gebruiker",
    "API User Details": "API-gebruikersgegevens",
    "API Users": "API-gebruikers",
    "About": "Over",
    "Accept": "Accepteer",
    "Accessibility": "Toegankelijkheid",
    "Accessibility Check": "Toegankelijkheidscontrole",
    "Accessibility Diagnostics": "Toegankelijkheidsscore",
    "Accessibility Fast Track": "Toegankelijkheid Fast Track",
    "Accessibility Icon": "Toegankelijkheid Icoon",
    "Accessibility Snippet": "Toegankelijkheid HTML Snippet",
    "Accessibility Source Code": "Toegankelijkheid Broncode",
    "Accessibility checks compliance by level": "Naleving toegankelijkheidscriteria per conformiteitsniveau",
    "Accessibility checks not in compliance with domain": "Toegankelijkheidscontroles niet in naleving van domein",
    "Accessibility error type": "Toegankelijkheidsfouttype",
    "Accessibility errors": "Toegankelijkheidsfouten",
    "Accessibility fixes": "Toegankelijkheidsoplossingen",
    "Accessibility help center": "Helpcentrum voor toegankelijkheid",
    "Accessibility issues": "Toegankelijkheidsproblemen",
    "Accessibility level": "Toegankelijkheidsniveau",
    "Accessibility mode": "Toegankelijkheidsmodus",
    "Accessibility review type": "Toegankelijkheidsbeoordelingstype",
    "Account dictionary": "Account woordenboek",
    "Action": "Actie",
    "Actions": "Acties",
    "Actions per visit": "Acties per bezoek",
    "Active": "Actief",
    "Add": "Toevoegen",
    "Add Custom Multistep Javascript": "Aangepaste meerstaps Javascript toevoegen",
    "Add Extension Name": "Extensienaam toevoegen",
    "Add Heatmap rule to a Page": "Voeg Heatmap toe aan een pagina",
    "Add Heatmaps": "Heatmaps toevoegen",
    "Add PageAssist script": "PageAssist-script toevoegen",
    "Add PageCorrect": "PageCorrect toevoegen",
    "Add Profile": "Profiel toevoegen",
    "Add Rule": "Regel toevoegen",
    "Add Skip to PageAssist": "Skip to PageAssist toevoegen",
    "Add a new exemption to your heartbeat check": "Een nieuwe uitzondering aan je Heartbeat toevoegen",
    "Add a new page to start tracking individual pages' performance. Get an overview of load times and opportunities to speed up your site.": "Voeg een nieuwe pagina toe om de performance van individuele pagina's bij te houden.",
    "Add a non-user email": "Voeg een e-mailadres van een niet-gebruiker toe",
    "Add another rule": "Nog een regel toevoegen",
    "Add email": "E-mailadres toevoegen",
    "Add exemption": "Uitzondering toevoegen",
    "Add new check": "Nieuwe check toevoegen",
    "Add new domain": "Nieuw domein toevoegen",
    "Add new exemption": "Nieuwe uitzondering toevoegen",
    "Add new label": "Nieuw label toevoegen",
    "Add new page": "Nieuwe pagina toevoegen",
    "Add new policy": "Nieuwe policy toevoegen",
    "Add new user": "Nieuwe gebruiker toevoegen",
    "Add non users": "Niet-gebruikers toevoegen",
    "Add reason (Optional)": "Reden toevoegen (optioneel)",
    "Add rule to policy": "Regel toevoegen aan policy",
    "Add rule to the policy": "Regel toevoegen aan de policy",
    "Add task": "Taak toevoegen",
    "Add timeslots where you won't receive notifications on downtime and slow responsetimes.": "Voeg tijdstippen toe waar je geen meldingen ontvangt over downtime en trage responstijden.",
    "Add to all languages": "Toevoegen aan alle talen",
    "Add to dictionary": "Toevoegen aan woordenboek",
    "Add to dictionary for all languages": "Toevoegen aan woordenboek voor alle talen",
    "Added": "Toegevoegd",
    "Added by": "Toegevoegd door",
    "Added date": "Toegevoegde datum",
    "Address": "Adres",
    "Admin": "Admin",
    "Advanced Domain Options": "Geavanceerde domeinopties",
    "Affected image": "Betrokken afbeelding",
    "Affected pages": "Betrokken pagina's",
    "Affected pages by priority": "Aantal pagina’s per prioriteitsniveau",
    "Affected pages by severity": "Aantal pagina’s per type probleem",
    "Affects": "Beïnvloedt",
    "After": "Na",
    "All": "Alle",
    "All Failed Internal PDF files": "Alle falende interne PDF-bestanden",
    "All Pending External PDF files": "Alle in afwachting van externe PDF-bestanden",
    "All Pending Internal PDF files": "Alle in afwachting van interne PDF-bestanden",
    "All Queued Internal PDF files": "Alle in de wachtrij geplaatste interne PDF-bestanden",
    "All Reviewed External PDF files": "Alle beoordeelde externe PDF-bestanden",
    "All Reviewed Internal PDF files": "Alle beoordeelde interne PDF-bestanden",
    "All assets": "Alles",
    "All broken images": "Alle gebroken afbeeldingen",
    "All broken links": "Alle gebroken links",
    "All heartbeat checkpoints": "Alle Heartbeat checkpoints",
    "All incident checkpoints in the selected time span": "Alle checkpoints in de geselecteerde tijdspanne",
    "All level A accessibility checks": "Alle toegankelijkheidscontroles op niveau A",
    "All level AA accessibility checks": "Alle toegankelijkheidscontroles op niveau AA",
    "All level AAA accessibility checks": "Alle toegankelijkheidscontroles op niveau AAA",
    "All levels": "Alle niveaus",
    "All modules": "Alle modules",
    "All modules - Content with Issues": "Alle modules - content met problemen",
    "All notifications": "Alle notificaties",
    "All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.": "Het enige wat je hoeft te doen is het onderstaande script in de BODY-tag van je website te plaatsen. Kopieer en plak het zoals het is.",
    "Analytics (Last 7 days)": "Analytics (afgelopen 7 dagen)",
    "And": "En",
    "Appears on": "Verschijnt op",
    "Apply": "Toepassen",
    "Archive": "Archief",
    "Archive files": "Archiveer bestanden",
    "Archived": "Gearchiveerd",
    "Are you sure you want to Mark this link as unignored?": "Weet je zeker dat je deze link als niet-genegeerd wilt markeren?",
    "Are you sure you want to Request All PDF Accessibility checks?": "Weet je zeker dat je alle PDF-toegankelijkheidscontroles wilt aanvragen?",
    "Are you sure you want to add to Request PDF Accessibility check from selection?": "Weet je zeker dat je wilt toevoegen aan PDF-toegankelijkheidscontrole aanvragen bij selectie?",
    "Are you sure you want to add to all the dictionaries?": "Weet je zeker dat je aan alle woordenboeken wilt toevoegen?",
    "Are you sure you want to add to the dictionary?": "Weet je zeker dat je dit aan het woordenboek wilt toevoegen?",
    "Are you sure you want to close this form without saving your changes?": "Weet je zeker dat je dit formulier wilt sluiten zonder je wijzigingen op te slaan?",
    "Are you sure you want to confirm this misspelling?": "Weet je zeker dat je deze spelfout wilt bevestigen?",
    "Are you sure you want to delete the API User [[apiUserId]]": "Weet je zeker dat je de API-gebruiker [[apiUserId]] wilt verwijderen?",
    "Are you sure you want to delete this exemption?": "Weet je zeker dat je deze uitzondering wilt verwijderen?",
    "Are you sure you want to delete this source exclude?": "Weet je zeker dat je deze bronuitsluiting wilt verwijderen?",
    "Are you sure you want to ignore all errors for this check?": "Weet je zeker dat je alle fouten bij deze controle wilt negeren?",
    "Are you sure you want to ignore the selected issue on this page?": "Weet je zeker dat je het geselecteerde probleem op deze pagina wilt negeren?",
    "Are you sure you want to ignore this check for this domain?": "Weet je zeker dat je deze controle voor dit domein wilt negeren?",
    "Are you sure you want to ignore this check for this page?": "Weet je zeker dat je deze controle voor deze pagina wilt negeren?",
    "Are you sure you want to ignore this issue?": "Weet je zeker dat je dit probleem wilt negeren?",
    "Are you sure you want to ignore this misspelling?": "Weet je zeker dat je deze spelfout wilt negeren?",
    "Are you sure you want to mark this issue as fixed?": "Weet je zeker dat je dit probleem als opgelost wilt markeren?",
    "Are you sure you want to mark this issue as not fixed?": "Weet je zeker dat je dit probleem als niet opgelost wilt markeren?",
    "Are you sure you want to mark this link as fixed?": "Weet je zeker dat je deze link als opgelost wilt markeren?",
    "Are you sure you want to mark this link as ignored?": "Weet je zeker dat je deze link als genegeerd wilt markeren?",
    "Are you sure you want to mark this link as not fixed?": "Weet je zeker dat je deze link als niet opgelost wilt markeren?",
    "Are you sure you want to remove manually added user?": "Weet je zeker dat je handmatig toegevoegde gebruiker wilt verwijderen?",
    "Are you sure you want to remove review for this issue?": "Weet je zeker dat je de beoordeling voor dit probleem wilt verwijderen?",
    "Are you sure you want to remove review on all errors for this check?": "Weet je zeker dat je de beoordeling voor alle fouten voor deze controle wilt verwijderen?",
    "Are you sure you want to remove this group?": "Weet je zeker dat je deze groep wilt verwijderen?",
    "Are you sure you want to remove this host?": "Weet je zeker dat je deze host wilt verwijderen?",
    "Are you sure you want to remove this rule?": "Weet je zeker dat je deze regel wilt verwijderen?",
    "Are you sure you want to remove this?": "Weet je zeker dat je dit wilt verwijderen?",
    "Are you sure you want to review all errors for this check?": "Weet je zeker dat je alle fouten voor deze controle wilt beoordelen?",
    "Are you sure you want to review this issue?": "Weet je zeker dat je dit probleem wilt beoordelen?",
    "Are you sure you want to set this document as reviewed?": "Weet je zeker dat je dit document als beoordeeld wilt instellen?",
    "Are you sure you want to start on-demand scan?": "Weet je zeker dat je de handmatige scan wilt starten?",
    "Are you sure you want to stop current crawl?": "Weet je zeker dat je de huidige crawl wilt stoppen?",
    "Are you sure you want to the request ADA clarification for [[name]]?": "Weet je zeker dat je het verzoek om ADA-verduidelijking voor [[name]] wilt indienen?",
    "Are you sure you want to undo review of this document?": "Weet je zeker dat je de beoordeling van dit document ongedaan wilt maken?",
    "Are you sure you want to undo reviewing this document?": "Weet je zeker dat je het beoordelen van dit document ongedaan wilt maken?",
    "Are you sure you want to unignore all errors for this check?": "Weet je zeker dat je alle fouten voor deze controle ongedaan wilt maken?",
    "Are you sure you want to unignore the selected issue on this page?": "Weet je zeker dat je het geselecteerde probleem op deze pagina ongedaan wilt maken?",
    "Are you sure you want to unignore this check for this domain?": "Weet je zeker dat je deze controle voor dit domein ongedaan wilt maken?",
    "Are you sure you want to unignore this check for this page?": "Weet je zeker dat je deze controle voor deze pagina ongedaan wilt maken?",
    "Are you sure you want to unignore this issue?": "Weet je zeker dat je dit probleem ongedaan wilt maken?",
    "Are you sure you want to unignore this link?": "Weet je zeker dat je deze link ongedaan wilt maken?",
    "Are you sure you want to unignore this misspelling?": "Weet je zeker dat je deze spelfout ongedaan wilt maken?",
    "Are you sure you want to unpin this domain": "Weet je zeker dat je dit domein niet meer wilt vastpinnen?",
    "Are you sure you want unignore this link?": "Weet je zeker dat je deze link ongedaan wilt maken?",
    "Assign Heatmap Rule": "Wijs Heatmap-regel toe",
    "Assign to the Performance Module": "Wijs toe aan de Performance Module",
    "Attribute": "Attribuut",
    "Audit": "Audit",
    "Audit Log": "Audit Log",
    "Autoselect": "Automatische selectie",
    "Average First Contentful Paint": "Gemiddelde First Contentful Paint",
    "Average First Meaningful Paint": "Gemiddelde First Meaningful Paint",
    "Average Performance Score": "Gemiddelde Performance Score",
    "Average Performance score": "Gemiddelde Performance Score",
    "Average Time to Interactive": "Gemiddelde tijd tot interactief",
    "Average response time": "Gemiddelde responstijd",
    "Average time": "Gemiddelde tijd",
    "Average uptime": "Gemiddelde uptime",
    "Average visit time": "Gemiddelde bezoektijd",
    "Avg. Performance Score": "Gem. Performance Score",
    "Avg. Visit Time": "Gem. Bezoektijd",
    "Avg. response": "Gem. respons",
    "BETA": "BETA",
    "Back": "Terug",
    "Back to Heartbeat Overview": "Terug naar Heartbeat",
    "Bar": "Bar",
    "Basic Auth": "Basis Auth",
    "Before": "Voordat",
    "Below 5th grade": "Onder het 5e leerjaar",
    "Below you can see a list of all pages that contains the title": "Hieronder zie je een lijst met alle pagina's die de titel bevatten",
    "Book online training": "Boek online training",
    "Bounce Rates": "Bouncepercentages",
    "Bounce rate": "Bouncepercentage",
    "Bounce rates": "Bouncepercentages",
    "Brand name": "Merknaam",
    "Broken Image": "Gebroken afbeelding",
    "Broken Image Links per page": "Gebroken afbeelding links per pagina",
    "Broken Images": "Gebroken afbeeldingen",
    "Broken Links": "Gebroken links",
    "Broken Page Link": "Gebroken paginalink",
    "Broken image affecting most content": "Gebroken afbeelding met grootste impact",
    "Broken image affecting most pages": "Gebroken afbeelding die de meeste pagina’s beïnvloedt",
    "Broken images": "Gebroken afbeeldingen",
    "Broken images with page count": "Gebroken afbeeldingen met paginatelling",
    "Broken link": "Gebroken link",
    "Broken link affecting most content": "Gebroken link met grootste impact",
    "Broken link affecting most pages": "Gebroken link die de meeste pagina’s beïnvloedt",
    "Broken links": "Gebroken links",
    "Broken links per page": "Gebroken links per pagina",
    "Broken links with page count": "Gebroken links met het aantal pagina's",
    "Browser": "Browser",
    "Browser Extension": "Browser-extensie",
    "Browsers": "Browsers",
    "Browsers Overview": "Browsers Overzicht",
    "Bubble": "Bubbel",
    "Build it from scratch": "Maak een policy",
    "By deleting this domain all domain groups related to this domain, will also be deleted": "Door dit domein te verwijderen, worden ook alle domeingroepen die aan dit domein gerelateerd zijn, verwijderd",
    "By user": "Door gebruiker",
    "CMS": "CMS",
    "CMS url": "CMS-URL",
    "CSS": "CSS",
    "CSS Target Selector": "CSS Target Selector",
    "CSS id or class selector to search for": "CSS-id of class selector om naar te zoeken",
    "CSS selector to find submit button": "CSS-selector om de verzendknop te vinden",
    "Cache TTL": "TTL in cache opslaan",
    "Cancel": "Annuleer",
    "Case sensitive": "Hoofdlettergevoelig",
    "Categories": "Categorieën",
    "Category": "Categorie",
    "Change password": "Wachtwoord wijzigen",
    "Changed to": "Gewijzigd in",
    "Changes": "Wijzigingen",
    "Changes added": "Wijzigingen toegevoegd",
    "Changes in selected time frame:": "Wijzigingen in het geselecteerde tijdvak:",
    "Changes since Previous Crawl": "Wijzigingen sinds vorige crawl",
    "Changes since previous crawl": "Wijzigingen sinds vorige crawl",
    "Characters": "Tekens",
    "Chart": "Grafiek",
    "Chart is now showing: [[name]]": "Grafiek wordt nu weergegeven: [[name]]",
    "Check": "Check",
    "Check List Export": "Check List exporteren",
    "Check all links in this section": "Check alle links in dit gedeelte",
    "Check all misspellings in this section": "Check alle spelfouten in dit gedeelte",
    "Check all modules": "Check alle modules",
    "Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)": "Bekijk problemen op je website na en los ze op (bijv. spelfouten, gebroken links, leesbaarheid en andere kwesties)",
    "Check frequency": "Check frequentie",
    "Check frequency:": "Check frequentie:",
    "Check is ignored": "Check wordt genegeerd",
    "Check is ignored for the entire domain": "Check wordt genegeerd voor het hele domein",
    "Check link": "Check link",
    "Check misspelling": "Check spelfout",
    "Check name": "Check naam",
    "Check off as Reviewed": "Vink af als Beoordeeld",
    "Check passed": "Check geslaagd",
    "Check site status": "Check de sitestatus",
    "Checking": "Checking",
    "Checkpoint exemptions": "Uitzonderingen voor check points",
    "Checkpoint has been updated.": "Checkpoint is bijgewerkt.",
    "Checkpoint information": "Checkpoint informatie",
    "Checkpoint:": "Checkpoint:",
    "Checks": "Checks",
    "Checks passed": "Geslaagde checks",
    "Checks whether your website is responding and measures the response time of the server": "Check of je website reageert en meet de responstijd van de server",
    "Choose Operator": "Kies Operator",
    "Choose What to Scan": "Kies wat je wilt scannen",
    "Choose a response time": "Kies een responstijd",
    "Choose a response time notification": "Kies een responsmelding",
    "Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned": "Kies een bestaande gegevenswet als standaardsjabloon voor je beveiligingsscan. Bewerk de onderstaande problemen om te voorkomen dat bepaalde tags worden gescand",
    "Choose checks": "Kies controles",
    "Choose domains": "Kies domeinen",
    "Choose how to view the Heatmaps Dashboard": "Kies hoe je het Heatmaps-dashboard wilt bekijken",
    "Choose notification time": "Kies meldingstijd",
    "Choose the minimum amount of words to scan for readability on a page": "Kies het minimumaantal woorden dat moet worden gescand op leesbaarheid op een pagina",
    "Choose where the policy should apply": "Kies waar de policy van toepassing moet zijn",
    "Chrome extension": "Chrome-extensie",
    "City": "Stad",
    "Clear all labels": "Wis alle labels",
    "Clear and close filters": "Filters wissen en sluiten",
    "Click here to create your first policy": "Klik hier om je eerste policy te maken",
    "Click here to edit": "Klik hier om te bewerken",
    "Click to create your first policy": "Klik om je eerste policy te maken",
    "Clone": "Kloon",
    "Close": "Sluiten",
    "Close filters": "Sluit filters",
    "Collapse": "Samenvouwen",
    "Collapse menu": "Menu samenvouwen",
    "College": "College",
    "College graduate": "Afgestudeerde",
    "Coming soon": "Komt binnenkort",
    "Comment": "Opmerking",
    "Common policy violations": "Veelvoorkomende schendingen van policies",
    "Company Info": "Bedrijfsinfo",
    "Compliance": "Naleving",
    "Compliance {{compliancePercentage}}": "Naleving {{compliancePercentage}}",
    "Compound Export": "Samengestelde export",
    "Compound Report": "Samengestelde rapport",
    "Confirm": "Bevestigen",
    "Confirm as misspelling": "Bevestig als spelfout",
    "Confirm misspelling": "Bevestig spelfout",
    "Confirm this word as a misspelling": "Bevestig dit woord als een spelfout",
    "Confirmed": "Bevestigd",
    "Confirmed misspellings": "Bevestigde spelfouten",
    "Congratulations no violations were found": "Gefeliciteerd, er zijn geen overtredingen geconstateerd",
    "Connection Profile": "Verbindingsprofiel",
    "Connections per minute": "Verbindingen per minuut",
    "Constraint": "Beperking",
    "Constraint pattern": "Beperkingspatroon",
    "Contact me about more Performance Pages": "Contacteer mij voor meer performance pagina's",
    "Contact me about more performance profiles": "Contacteer mij voor meer performance profielen",
    "Containing": "Bevat",
    "Contains": "Bevat",
    "Contains confirmed misspellings, broken links & images": "Bevat bevestigde spelfouten, gebroken links en afbeeldingen",
    "Contains confirmed misspellings, broken links or images": "Bevat bevestigde spelfouten, gebroken links of afbeeldingen",
    "Contains high, medium & low opportunities for all pages": "Bevat grote, gemiddelde en kleine verbeterpunten voor alle pagina's",
    "Contains high, medium & low severity issues for all pages": "Bevat grote, gemiddelde en kleine problemen voor alle pagina's",
    "Contains issues with high, medium and low priority for all pages": "Bevat problemen met hoge, gemiddelde en lage prioriteit voor alle pagina's",
    "Content": "Content",
    "Content Links": "Content links",
    "Content Policies": "Content Policies",
    "Content Policy Violations": "Content policy schendingen",
    "Content in compliance": "Content in naleving",
    "Content must be robust enough that it can be interpreted reliably by a wide variety of user agents, including assistive technologies.": "Content moet robuust genoeg zijn om betrouwbaar te kunnen worden geïnterpreteerd door een grote verscheidenheid aan gebruikers, waaronder ondersteunende technologieën.",
    "Content policies": "Content policies",
    "Content with Broken Image": "Content met een gebroken afbeelding",
    "Content with Broken Link": "Content met gebroken link",
    "Content with Broken Links": "Content met gebroken links",
    "Content with Data Issues": "Content met dataproblemen",
    "Content with Data Issues export": "Export van content met dataproblemen",
    "Content with Policy Matches": "Content met policy overeenkomsten",
    "Content with QA Errors": "Content met QA fouten",
    "Content with broken links": "Content met gebroken links",
    "Content with issues": "Content met problemen",
    "Content with policy violations": "Content met schendingen van de policy",
    "Content with violations": "Content met overtredingen",
    "Context": "Context",
    "Country": "Land",
    "Crawl Automatically": "Automatisch crawlen",
    "Crawl Options": "Crawl opties",
    "Crawl done on": "Crawl gedaan op",
    "Crawl finalized on": "Crawl afgerond op",
    "Crawl info": "Crawl informatie",
    "Crawl runtime:": "Crawl runtime:",
    "Crawl started:": "Crawl gestart:",
    "Crawl status": "Crawlstatus",
    "Crawl status:": "Crawlstatus:",
    "Crawled Documents ([[documentCount]])": "Gecrawlde documenten ([[documentCount]])",
    "Crawled at": "Gecrawld op",
    "Crawled pages": "Gecrawlde pagina's",
    "Crawling": "Crawlen",
    "Create a policy to make an email as unwanted content": "Maak een policy om een e-mail als ongewenste content te markeren",
    "Create as policy": "Maak als policy",
    "Create label": "Maak een label",
    "Create new domain group": "Maak een nieuwe domeingroep aan",
    "Create new group": "Maak een nieuwe groep",
    "Create user": "Maak een gebruiker",
    "Create your own policy": "Maak je eigen policy",
    "Created": "Gemaakt",
    "Created At": "Gemaakt op",
    "Created at": "Gemaakt op",
    "Created date": "Gemaakt op datum",
    "Created:": "Aangemaakt:",
    "Current domain status": "Huidige domeinstatus",
    "Current status": "Huidige status",
    "Custom": "Op maat",
    "Custom Multistep": "Aangepaste meerstappen",
    "Custom Profile": "Aangepast profiel",
    "Custom fixes": "Aangepaste oplossingen",
    "Custom rule": "Aangepaste regel",
    "Customer": "Klant",
    "Customer Report": "Klantrapport",
    "DATA PRIVACY OVERVIEW": "DATA PRIVACY OVERZICHT",
    "DISCLAIMER": "DISCLAIMER",
    "Daily": "Dagelijks",
    "Danish": "Deens",
    "Dark": "Donker",
    "Dashboard": "Dashboard",
    "Data Issues": "Data problemen",
    "Data Privacy": "Data Privacy",
    "Data Privacy Diagnostics": "Data Privacy diagnostiek",
    "Data Privacy Fast Track": "Data Privacy Fast Track",
    "Data Privacy Help Center": "Helpcentrum voor Data Privacy",
    "Data Privacy Info Type Icon": "Data Privacy info type icoon",
    "Data Privacy Issues": "Data Privacy problemen",
    "Data Privacy Summary Export": "Data Privacy samenvatting export",
    "Data Privacy issues found": "Data Privacy problemen gevonden",
    "Data Regulations": "Data regelgeving",
    "Data Violations": "Data overtredingen",
    "Data issues": "Data problemen",
    "Data issues export": "Data problemen exporteren",
    "Data privacy": "Data Privacy",
    "Data privacy violations": "Schendingen van privacygegevens",
    "Data protection and privacy policy statement": "Verklaring inzake data bescherming en privacybeleid",
    "Date": "Datum",
    "Day": "Dag",
    "Days": "Dagen",
    "Dead": "Dood",
    "Default": "Standaard",
    "Default for CMS": "Standaard voor CMS",
    "Default value*": "Standaardwaarde*",
    "Define meta headers to match": "Definieer meta headers die overeen moeten komen",
    "Define size of files to look for": "Definieer de grootte van de bestanden waarnaar je wilt zoeken",
    "Define size of images to look for": "Definieer de grootte van de afbeeldingen waarnaar je wilt zoeken",
    "Delete": "Verwijderen",
    "Delete All": "Verwijder alles",
    "Delete user": "Gebruiker verwijderen",
    "Describe the exclude": "Beschrijf de uitsluiting",
    "Description": "Beschrijving",
    "Desktop": "Bureaublad",
    "Details": "Details",
    "Device": "Apparaat",
    "Device Overview": "Apparaatoverzicht",
    "Device not found": "Apparaat niet gevonden",
    "Device:": "Apparaat:",
    "Devices": "Apparaten",
    "Diagnostics": "Diagnostiek",
    "Dictionary": "Woordenboek",
    "Difficulty": "Moeilijkheidsgraad",
    "Direct visits": "Directe bezoeken",
    "Disabling": "Uitschakelen",
    "Display policy in other services": "Policy weergeven in andere services",
    "Display this policy as:": "Geef deze policy weer als:",
    "Distribution of Data Privacy levels": "Verdeling volgens omvang",
    "Distribution of PageCorrects across all change types": "PageCorrects volgens type aanpassing",
    "Distribution of SEO levels": "Verdeling van SEO niveaus",
    "Distribution of policies that match their corresponding setting": "Verdeling van policies die overeenkomen met de bijbehorende instelling",
    "Distribution of policies that matches their corresponding setting": "Verdeling van policies die overeenkomen met de bijbehorende instelling",
    "Do you want the policy to run every time your website is crawled?": "Wil je dat de policy telkens wordt uitgevoerd wanneer je website wordt gecrawld?",
    "Do you want to find pages which match the query on one or multiple lines?": "Wil je pagina's vinden die overeenkomen met de zoekopdracht op één of meerdere regels?",
    "Do you want to find pages which match the query or pages which does not match the query": "Wil je pagina's vinden die overeenkomen met de zoekopdracht of pagina's die niet overeenkomen met de zoekopdracht?",
    "Do you want to update the Script Settings, for this Domain?": "Wil je de scriptinstellingen voor dit domein bijwerken?",
    "Document": "Document",
    "Document Class": "Documentklasse",
    "Document Dashboard": "Document Dashboard",
    "Document Details": "Documentdetails",
    "Document Extension": "Documentextensie",
    "Document Ignore Class": "Document negeer klasse",
    "Document first detected": "Document voor het eerst gedetecteerd",
    "Document scan": "Document scannen",
    "Documents": "Documenten",
    "Documents Crawled": "Documenten gecrawld",
    "Documents basic": "Documenten basis",
    "Documents crawled": "Documenten gecrawld",
    "Documents extended": "Documenten verlengd",
    "Documents with Broken Image": "Documenten met een gebroken afbeelding",
    "Documents with Broken Link": "Documenten met een gebroken link",
    "Domain": "Domein",
    "Domain Compliance": "Domein naleving",
    "Domain Data Privacy Settings": "Privacyinstellingen voor domeingegevens",
    "Domain Detail": "Domeindetail",
    "Domain Details": "Domeindetails",
    "Domain Groups": "Domeingroepen",
    "Domain Picker Closed": "Domeinkiezer gesloten",
    "Domain Picker Opened": "Domeinkiezer geopend",
    "Domain compliance": "Domein naleving",
    "Domain group": "Domeingroep",
    "Domain title and URL": "Domeinnaam en URL",
    "Domain:": "Domein:",
    "Domains": "Domeinen",
    "Domains/groups selected": "Domeinen / groepen geselecteerd",
    "Done": "Gedaan",
    "Download": "Downloaden",
    "Download the Chrome extension": "Download de Chrome extensie",
    "Download the Edge add-on": "Download de Edge add-on",
    "Download the Firefox add-on": "Download de Firefox add-on",
    "Downloads": "Downloads",
    "Downtime": "Downtime",
    "Downtime (Minutes)": "Downtime (minuten)",
    "Downtime notification": "Downtime melding",
    "Drag and drop the rule to add rules to the policy": "Versleep de regel om regels aan de policy toe te voegen",
    "Dropdown": "Dropdown",
    "Duration": "Looptijd",
    "Easy": "Gemakkelijk",
    "Easy to read pages understood by most. Example: fiction literature for adults": "Gemakkelijk te lezen pagina's die door de meesten worden begrepen. Voorbeeld: fictieliteratuur voor volwassenen",
    "Edge add-on": "Edge add-on",
    "Edit": "Bewerk",
    "Edit Labels": "Bewerk Labels",
    "Edit Performance Page": "Bewerk de performance pagina",
    "Edit customer information": "Bewerk klantgegevens",
    "Edit domain": "Bewerk domein",
    "Edit domain group": "Bewerk domeingroep",
    "Edit exemption": "Bewerk uitzondering",
    "Edit label": "Bewerk label",
    "Edit labels": "Bewerk labels",
    "Edit my profile": "Bewerk mijn profiel",
    "Edit or Delete PageCorrect": "Bewerk of verwijder PageCorrect",
    "Edit uptime": "Bewerk uptime",
    "Edit user": "Bewerk gebruiker",
    "Edit users": "Bewerk gebruikers",
    "Edit your exemption": "Bewerk je uitzondering",
    "Edit:": "Bewerk:",
    "Effect on compliance": "Effect op naleving",
    "Effect on overall compliance level": "Effect op het algemene nalevingsniveau",
    "Element": "Element",
    "Element Tree Path": "Element Tree Path",
    "Email": "E-mail",
    "Email Notifications": "E-mailnotificaties",
    "Email addresses": "E-mailadressen",
    "Email receiver *": "E-mail ontvanger *",
    "Email to login": "E-mail om in te loggen",
    "Emails": "E-mails",
    "Empty": "Leeg",
    "Empty mailto": "Mailto leegmaken",
    "Enable / Disable Accessibility mode": "Toegankelijkheidsmodus in- / uitschakelen",
    "Enable Document Tracking": "Schakel het bijhouden van documenten in",
    "Enable Export Email Notification": "Schakel e-mailmelding exporteren in",
    "Enable Statistics": "Statistieken inschakelen",
    "Enabled features": "Ingeschakelde functies",
    "Enabling": "Inschakelen",
    "End at": "Eindig op",
    "End date": "Einddatum",
    "End time": "Eindtijd",
    "English": "Engels",
    "Enter the full URL": "Voer de volledige URL in",
    "Entries": "Binnenkomsten",
    "Entry": "Binnenkomst",
    "Entry Pages": "Binnenkomstpagina’s",
    "Entry and Exit Pages": "Binnenkomst- en Verlaatpagina’s",
    "Error": "Fout",
    "Error Name": "Foutnaam",
    "Errors": "Fouten",
    "Errors ([[audits]])": "Fouten ([[audits]])",
    "Exact": "Precies",
    "Example: academic publications": "Voorbeeld: wetenschappelijke publicaties",
    "Example: children's literature": "Voorbeeld: kinderliteratuur",
    "Example: daily newspapers": "Voorbeeld: dagbladen",
    "Example: fiction books": "Voorbeeld: fictieboeken",
    "Example: legal texts": "Voorbeeld: juridische teksten",
    "Examples": "Voorbeelden",
    "Excel Documents": "Excel-documenten",
    "Exclude": "Uitsluiten",
    "Exclude links that contains class name": "Sluit links uit die de klassenaam bevatten",
    "Exclude pattern": "Uitsluitpatroon",
    "Excluded IP addresses from statistics": "IP-adressen uitgesloten van statistieken",
    "Exemption": "Uitzondering",
    "Exemption options": "Uitzonderingsmogelijkheden",
    "Exemption time": "Uitzonderingstijd",
    "Exemptions": "Uitzonderingen",
    "Exit Pages": "Verlaatpagina’s",
    "Exits": "Verlaten",
    "Expand": "Uitbreiden",
    "Explain the rationale behind the policy and which actions, editors should take to correct the violation": "Leg de gedachte achter de policy uit en leg uit welke acties de redacteuren moeten ondernemen om deze te corrigeren",
    "Export": "Exporteren",
    "Export CSV": "CSV exporteren",
    "Export Compound CSV": "Export samengestelde CSV",
    "Export Logs": "Logboeken exporteren",
    "Export list of broken images organized by page and document title": "Exporteer een lijst met gebroken afbeeldingen, geordend op pagina en documenttitel",
    "Export list of broken links organized by page and document title": "Exporteer een lijst met gebroken links, geordend op pagina en documenttitel",
    "Export list of downtimes for the domain": "Exporteer een lijst met downtime voor het domein",
    "Export list of response times": "Exporteer lijst met responstijden",
    "External": "Extern",
    "External Export": "Externe export",
    "External PDF Compliance": "Externe PDF-naleving",
    "External PDFs": "Externe PDF’s",
    "External Referring Domains": "Externe verwijzende domeinen",
    "External Referring domains": "Externe verwijzende domeinen",
    "External referees overview": "Overzicht externe verwijzers",
    "External referring domains": "Externe verwijzende domeinen",
    "FCP": "FCP",
    "FMP": "FMP",
    "Facebook": "Facebook",
    "Fail Example": "Mislukt voorbeeld",
    "Failed": "Mislukt",
    "Failing accessibility checks": "Openstaande toegankelijkheidscontroles",
    "Failing accessibility checks gives you information about the current Accessibility status of the website/group. It may vary from the history if there have been changes in ignored and review of accessibility issues": "Onopgeloste toegankelijkeheidscontroles geven je informatie over de huidige toegankelijkheidsstatus van de website/groep. Dit kan afwijken van de voorgaande crawl(s) als er wijzigingen zijn aangebracht in de beoordeelde en genegeerde toegankelijkheidsproblemen",
    "Failing check": "Openstaande controle",
    "Failing check found": "Openstaande controle gevonden",
    "Failing checks": "Openstaande controles",
    "Failing checks found": "Openstaande controles gevonden",
    "Fast Track": "Fast Track",
    "Fast track html snippet": "Fast Track html snippet",
    "Faster": "Sneller",
    "Features": "Kenmerken",
    "Feedback submitted": "Feedback verzonden",
    "File size": "Bestandsgrootte",
    "Filter": "Filter",
    "Filter by": "Filteren op",
    "Filter by:": "Filteren op:",
    "Filter labels list": "Lijst met filterlabels",
    "Find and address violations relating to your content guides and regulatory compliance and find outdated content across your website.": "Vind content regels die niet voldoen aan het content beleid en spoor gedateerde content op.",
    "Find word(s) without specific context": "Vind woord(en) zonder specifieke context",
    "Firefox add-on": "Firefox add-on",
    "First Contentful Paint": "First Contentful Paint",
    "First Meaningful Paint": "First Meaningful Paint",
    "First name": "Voornaam",
    "Fixed": "Hersteld",
    "Fixed or ignored violations": "Herstelde of genegeerde schendingen",
    "Flesch Kincaid": "Flesch Kincaid",
    "For this domain": "Voor dit domein",
    "Form": "Formulier",
    "Form fields": "Formuliervelden",
    "Forms": "Formulieren",
    "Found": "Gevonden",
    "Four times a day": "Vier keer per dag",
    "Frames": "Frames",
    "Friday": "Vrijdag",
    "From 2 seconds to 8 seconds": "Van 2- tot 8-seconden",
    "Generating report": "Rapport genereren",
    "Get advice on how to handle this check": "Krijg advies over het afhandelen van deze controle",
    "Getting {{ logs }} out of {{totalLogs}} logs": "{{ logs }} ophalen uit {{totalLogs}} logboeken",
    "Global - All Domains": "Globaal - alle domeinen",
    "Global Policies": "Globale Policies",
    "Global Policy Dashboard": "Globale Policies Dashboard",
    "Global Policy List": "Globale Policies Lijst",
    "Go to Global Policy List": "Ga naar Globale Policies Lijst",
    "Go to My Exports": "Ga naar Mijn export",
    "Go to PDFs": "Ga naar PDF’s",
    "Go to Policy List": "Ga naar Lijst Policies",
    "Go to broken Links": "Ga naar gebroken links",
    "Go to broken images": "Ga naar gebroken afbeeldingen",
    "Go to broken links": "Ga naar gebroken links",
    "Go to checkpoints": "Ga naar checkpoints",
    "Go to data issues": "Ga naar data problemen",
    "Go to domain": "Ga naar domein",
    "Go to help center": "Ga naar het helpcentrum",
    "Go to mispellings": "Ga naar spelfouten",
    "Go to misspellings": "Ga naar spelfouten",
    "Go to most visits pages": "Ga naar de meest bezochte pagina’s",
    "Go to page": "Ga naar pagina",
    "Go to page details": "Ga naar paginadetails",
    "Go to potential misspellings": "Ga naar mogelijke spelfouten",
    "Go to predefined url": "Ga naar voorgedefinieerde url",
    "Go to the dashboard": "Ga naar het dashboard",
    "Go to traffic sources overview": "Ga naar het overzicht van verkeersbronnen",
    "Go to uptime": "Ga naar uptime",
    "Go to visitor overview": "Ga naar bezoekersoverzicht",
    "Good job! No incidents was registered": "Goed gedaan! Er werden geen incidenten geregistreerd",
    "Good job! No issues were found": "Goed gedaan! Er zijn geen problemen gevonden",
    "Good job! No violations were found": "Goed gedaan! Er zijn geen overtredingen geconstateerd",
    "Google": "Google",
    "Greater than 8 seconds": "Meer dan 8 seconden",
    "Grid View": "Rasterweergave",
    "Groups": "Groepen",
    "Guidelines": "Richtlijnen",
    "Guidelines for WCAG 2.0": "WCAG 2.0 richtlijnen",
    "Guidelines for WCAG 2.1": "WCAG 2.1 richtlijnen",
    "H1 on this page": "H1 op deze pagina",
    "HTML": "HTML",
    "HTML Pages": "HTML-pagina's",
    "HTML pages": "HTML-pagina's",
    "HTML snippet": "HTML-snippet",
    "HTML snippet affecting compliance level": "HTML-snippet dat het nalevingsniveau beïnvloedt",
    "HTML snippet failing check": "Controle van HTML-snippet mislukt",
    "Hard": "Moeilijk",
    "Hard to read text. Example: popular science magazines and easier academic publications": "Moeilijk leesbare tekst. Voorbeeld: populair-wetenschappelijke tijdschriften en gemakkelijkere wetenschappelijke publicaties",
    "Harmony CMS": "Harmony CMS",
    "Header type": "Type Header",
    "Headers": "Headers",
    "Headlinks": "Headlinks",
    "Heartbeat": "Heartbeat",
    "Heartbeat Downtime": "Heartbeat downtime",
    "Heartbeat Response Time": "Heartbeat responstijd",
    "Heartbeat status saved": "Heartbeat status opgeslagen",
    "Heatmaps": {
      "$$noContext": "Heatmaps",
      "Topmenu": "Warmtekaarten"
    },
    "Help Center": "Helpcentrum",
    "Help center": "Helpcentrum",
    "High": "Hoog",
    "High impact": "Hoge impact",
    "High impact opportunities": "Verbeterpunten met hoge impact",
    "High priority": "Hoge prioriteit",
    "High severity": "Groot",
    "High severity issues": "Zeer ernstige problemen",
    "Highest level of readability. Example: complex academic and legal texts": "Hoogste leesbaarheid. Voorbeeld: complexe academische en juridische teksten",
    "History": "Historie",
    "Hit": "Hit",
    "Hits": "Hits",
    "Hits across all domains and modules": "Hits over alle domeinen en modules",
    "Hits on domain": "Hits op domein",
    "Home": "Home",
    "Host": "Host",
    "Hosts": "Hosts",
    "Hosts cannot be empty": "Hosts mogen niet leeg zijn",
    "Hours": "Uren",
    "How often the page is checked": "Hoe vaak de pagina wordt gecontroleerd",
    "How to fix this problem": "Hoe dit probleem op te lossen",
    "How to prevent": "Hoe te voorkomen",
    "How to setup this policy": "Hoe je deze policy instelt",
    "IFrames": "IFrames",
    "IP address": "IP-adres",
    "Icon": "Icoon",
    "Icon status": "Icoonstatus",
    "Identifier": "ID",
    "Ignore": "Negeren",
    "Ignore check": "Negeer de controle",
    "Ignore misspelling": "Negeer spelfout",
    "Ignore on the page": "Negeer op de pagina",
    "Ignore on this page": "Negeer op deze pagina",
    "Ignore this SEO issue": "Negeer dit SEO-probleem",
    "Ignore this check": "Negeer deze controle",
    "Ignore this check for this domain": "Negeer deze controle voor dit domein",
    "Ignored": "Genegeerd",
    "Ignored Misspellings": "Genegeerde spelfouten",
    "Ignored Policies": "Genegeerde policies",
    "Ignored checks": "Genegeerde controles",
    "Ignored issue": "Genegeerd probleem",
    "Ignored policies": "Genegeerde policies",
    "Ignoring broken link": "Gebroken link negeren",
    "Image": "Afbeelding",
    "Image Links": "Afbeeldingslinks",
    "Image sources that will be fixed": "Afbeeldingsbronnen die worden opgelost",
    "Images": "Afbeeldingen",
    "Import rules": "Regels importeren",
    "Import rules from CSV": "Regels importeren uit CSV",
    "Important Highlights": "Belangrijke aandachtspunten",
    "Important Notifications": "Belangrijke meldingen",
    "Important notification:": "Belangrijke melding:",
    "In compliance": "In naleving",
    "In progress of ignoring/reviewing all": "Bezig met het negeren/beoordelen van alles",
    "Inactive": "Inactief",
    "Incidents": "Incidenten",
    "Includes both documents and pages": "Omvat zowel documenten als pagina's",
    "Incoming Links": "Inkomende links",
    "Incoming links": "Inkomende links",
    "Indicates the difficulty to fix an audit error": "Geeft de moeilijkheid aan om een auditfout te herstellen",
    "Indicates when some parts of the domain are not scanned due to Constraints / Exclusions being applied": "Geeft aan wanneer sommige delen van het domein niet worden gescand omdat beperkingen / uitsluitingen worden toegepast",
    "Individual issues": "Individuele problemen",
    "Information": "Informatie",
    "Information about this Check is not yet available": "Informatie over deze controle is nog niet beschikbaar",
    "Information and the operation of user interface must be understandable.": "Informatie en de werking van de gebruikersinterface moeten begrijpelijk zijn.",
    "Information and user interface components must be presentable to users in ways they can perceive.": "Informatie en componenten van de gebruikersinterface moeten voor gebruikers presenteerbaar zijn op een manier die zij kunnen begrijpen.",
    "Inline Images": "Inline afbeeldingen",
    "Inline images": "Inline afbeeldingen",
    "Input selector*": "Input selector*",
    "Input user data": "Voer gebruikersgegevens in",
    "Internal": "Intern",
    "Internal Export": "Interne export",
    "Internal PDF Compliance": "Interne PDF-naleving",
    "Internal PDFs": "Interne PDF’s",
    "Internal URLs": "Interne URL's",
    "Inventory": "Inventaris",
    "Inventory Documents Export": "Inventarisdocumenten exporteren",
    "Inventory History": "Inventaris historie",
    "Invite to new project": "Nodig uit voor nieuw project",
    "Is not a valid url": "Is geen geldige url",
    "Is not crawling automatically": "Crawlt niet automatisch",
    "Is not tagged": "Is niet getagd",
    "Issue": "Probleem",
    "Issue changes": "Wijzigingen aan probleem",
    "Issue changes since previous crawl": "Wijzigingen aan probleem sinds vorige crawl",
    "Issue name": "Naam probleem",
    "Issue type": "Soort probleem",
    "Issues": "Problemen",
    "Issues by Severities": "Problemen per type",
    "Issues changes since previous crawl": "Wijzigingen aan probleem sinds vorige crawl",
    "JS": "JS",
    "JavaScript": "JavaScript",
    "Javascript": "Javascript",
    "Javascript crawl": "Javascript crawl",
    "KB": "KB",
    "Keyword": "Trefwoord",
    "Knowledge Base": {
      "$$noContext": "Helpcentrum",
      "Topmenu": "Kennisbank"
    },
    "LIX": "LIX",
    "Label": "Label",
    "Label created": "Label gemaakt",
    "Label name": "Labelnaam",
    "Label overlay": "Label-overlay",
    "Label preview": "Labelvoorbeeld",
    "Label updated": "Label geüpdate",
    "Labels": "Labels",
    "Language": "Taal",
    "Language Detected": "Taal gedetecteerd",
    "Languages": "Talen",
    "Languages found": "Gevonden talen",
    "Last Scan": "Laatste Scan",
    "Last check: [[lastCheckTime]]": "Laatste controle: [[lastCheckTime]]",
    "Last check: [[performanceScannedAt]]": "Laatste controle: [[performanceScannedAt]]",
    "Last downtime:": "Laatste downtime:",
    "Last load time": "Laatste laadtijd",
    "Last name": "Achternaam",
    "Last run": "Laatste uitvoering",
    "Last run [[date]]": "Laatste uitvoering [[date]]",
    "Last run:": "Laatste uitvoering:",
    "Last scan": "Laatste scan",
    "Last scan never": "Laatste scan nooit",
    "Last scan: [[duration]] ago": "Laatste scan: [[duration]] geleden",
    "Latest Updated PageCorrects": "Laatst bijgewerkte PageCorrects",
    "Latest login": "Laatste login",
    "Least Popular Pages": "Minst populaire pagina's",
    "Less than 10": "Minder dan 10",
    "Less than 100": "Minder dan 100",
    "Less than 2 seconds": "Minder dan 2 seconden",
    "Less than 50": "Minder dan 50",
    "Level": "Niveau",
    "Level A": "Niveau A",
    "Level A Issues": "Niveau A-problemen",
    "Level A accessibility checks": "Niveau A toegankelijkheidscontroles",
    "Level A compliance": "Naleving van niveau A",
    "Level A failing checks": "Niveau A onopgeloste controles",
    "Level AA": "Niveau AA",
    "Level AA Issues": "Niveau AA-problemen",
    "Level AA accessibility checks": "Niveau AA toegankelijkheidscontroles",
    "Level AA compliance": "Naleving van niveau AA",
    "Level AA failing checks": "Niveau AA onopgeloste controles",
    "Level AAA": "Niveau AAA",
    "Level AAA Issues": "Niveau AAA-problemen",
    "Level AAA accessibility checks": "Niveau AAA toegankelijkheidscontroles",
    "Level AAA compliance": "Naleving van niveau AAA",
    "Level AAA failing checks": "Niveau AAA onopgeloste controles",
    "Level [[level]]": "Niveau [[level]]",
    "Levels": "Niveaus",
    "Likelihood": "Waarschijnlijkheid",
    "Likelihood unspecified": "Waarschijnlijkheid niet gespecificeerd",
    "Link": "Link",
    "Link Type": "Soort Link",
    "Link excludes": "Sluit links uit",
    "Link fixes": "Link fixes",
    "Link is broken": "Link is gebroken",
    "Link of page": "Link van pagina",
    "Link to image": "Link naar afbeelding",
    "Linkedin": "Linkedin",
    "Links": "Links",
    "Links To Documents Export": "Links naar documenten exporteren",
    "Links from other account domains": "Links van andere accountdomeinen",
    "Links from own domain": "Links van eigen domein",
    "Links with policy matches": "Links met overeenkomsten van de policy",
    "Links with the rel=\\\"nofollow\\\" attribute will not pass link equity/SEO value to the linked page. This can be used for pages with user generated comments where you want to avoid that a competitor posts a comment with a link to their own website thus benefiting from your original content. This is not an \\\"error\\\" per se but make sure that the link does not have this attribute as a result of an error.": "Links met het rel=\\”nofollow\\” attribuut geven geen link-waarde / SEO-waarde door aan de gelinkte pagina. Dit kan worden gebruikt voor pagina's met door gebruikers gegenereerde opmerkingen waarbij je wilt voorkomen dat een concurrent een opmerking plaatst met een link naar zijn eigen website en zo profiteert van jouw originele content. Dit is niet per se een \\”error\\” maar zorg ervoor dat de link dit attribuut niet heeft als gevolg van een fout.",
    "List": "Lijst",
    "List of accessibility issues": "Lijst met toegankelijkheidsproblemen",
    "List of all labels": "Lijst met alle labels",
    "List of checks with and without issues": "Lijst met controles met en zonder problemen",
    "List of content containing links": "Lijst met content welke links bevatten",
    "List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)": "Lijst die aangeeft waar al je items zich op de website bevinden (d.w.z. documenten, links, e-mailadressen, codefragmenten enz.)",
    "List view": "Lijstweergave",
    "Lists all profiles available for your account": "Toont alle profielen die beschikbaar zijn voor je account",
    "Load Times Trend": "Laadtijden trends",
    "Loading domains, please wait": "Domeinen laden, even geduld",
    "Loading new domain": "Nieuw domein laden",
    "Loading times": "Laadtijden",
    "Locale": "Landinstelling",
    "Location": "Locatie",
    "Location not found": "Locatie niet gevonden",
    "Locations": "Locaties",
    "Log out": "Log out",
    "Login Type": "Type Login",
    "Long": "Lang",
    "Lookup in Google": "Opzoeken in Google",
    "Low": "Laag",
    "Low impact": "Lage impact",
    "Low impact opportunities": "Verbeterpunten met lage impact",
    "Low priority": "Lage prioriteit",
    "Low severity": "Klein",
    "Low severity issues": "Kleine problemen",
    "MB": "MB",
    "META content": "META-content",
    "META name/property": "META naam/eigenschap",
    "Main-Thread Blocking Time": "Main-Thread Blocking Time",
    "Mark 403 as broken link": "Markeer 403 als gebroken link",
    "Mark all as reviewed/ignored": "Markeer alles als beoordeeld/genegeerd",
    "Mark as fixed": "Markeer als opgelost",
    "Mark as ignored": "Markeer als genegeerd",
    "Mark as not fixed": "Markeer als niet opgelost",
    "Marked as fixed": "Gemarkeerd als opgelost",
    "Marked as reviewed": "Gemarkeerd als beoordeeld",
    "Marking broken link as fixed": "Gebroken link markeren als opgelost",
    "Match": "Overeenkomst",
    "Match rule": "Overeenkomst regel",
    "Matches": "Overeenkomsten",
    "Max": "Max",
    "Max scanned pages": "Max. Gescande pagina's",
    "Measure from": "Meet vanaf",
    "Measure from:": "Meet vanaf:",
    "Measurement Settings": "Metingsinstellingen",
    "Measurements since [[date]]": "Metingen sinds [[date]]",
    "Medium": "Gemiddeld",
    "Medium complexity of text. Example: newspapers and magazines": "Gemiddelde complexiteit van tekst. Voorbeeld: kranten en tijdschriften",
    "Medium impact": "Gemiddelde impact",
    "Medium impact opportunities": "Verbeterpunten met gemiddelde impact",
    "Medium priority": "Gemiddelde prioriteit",
    "Medium severity": "Gemiddeld",
    "Medium severity issues": "Gemiddelde problemen",
    "Meta Header Expr": "Meta Header Expr",
    "Meta Name": "Meta naam",
    "Metadata": "Metadata",
    "Metadata key": "Metadatasleutel",
    "Milliseconds": "Milliseconden",
    "Minimum words": "Minimum aantal woorden",
    "Minutes": "Minuten",
    "Minutes of slow response before you get an email": "Minuten langzame respons voordat je een e-mail ontvangt",
    "Mispelling": "Spelfout",
    "Misspelling": "Spelfout",
    "Misspelling affecting the most content": "Spelfout met grootste impact",
    "Misspellings": "Spelfouten",
    "Misspellings history": "Spelfouten historie",
    "Mobile": "Mobiel",
    "Moderate": "Matig",
    "Module": "Module",
    "Monday": "Maandag",
    "Monitoring": "Monitoren",
    "Monthly": "Maandelijks",
    "Months": "Maanden",
    "More info": "Meer informatie",
    "More than": "Meer dan",
    "More than [[count]]": "Meer dan [[count]]",
    "Most Downloads": "Meeste downloads",
    "Most Frequent": "Meest voorkomend",
    "Most Popular Pages": "Meest populaire pagina's",
    "Most common SEO checkpoint needing review": "Meest voorkomende SEO checkpoint voor beoordeling",
    "Most common language": "Meest voorkomende taal",
    "Most common misspellings": "Meest voorkomende spelfouten",
    "Most common opportunities found": "Meest voorkomende verbeterpunten",
    "Most common policy violation on this domain": "Meest voorkomende schending van policies op dit domein",
    "Most common potential misspellings": "Meest voorkomende mogelijke spelfouten",
    "Most common readability level": "Meest voorkomende leesbaarheidsniveau",
    "Most of your pages have the readability level": "De meeste van je pagina's hebben het leesbaarheidsniveau",
    "Most pages have this readability level": "De meeste pagina's hebben dit leesbaarheidsniveau",
    "Most prominent issues ranked by severity level": "Rangschikking van belangrijkste problemen",
    "Most serious issues found": "Meest ernstige problemen gevonden",
    "Most visited pages": "Meest bezochte pagina's",
    "Move focus down on domain picker": "Verplaats de focus naar beneden op de domeinkiezer",
    "Move focus up on domain picker": "Verplaats de focus naar boven op de domeinkiezer",
    "Multiline": "Multiline",
    "My Exports": "Mijn Exports",
    "My profile": "Mijn profiel",
    "N/A": "Nvt",
    "NA": "Nvt",
    "NB! Connection Settings cannot be edited after save": "Let op! Verbindingsinstellingen kunnen na het opslaan niet worden bewerkt",
    "NOTE: If you want to copy the Legacy Script. Click {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}here{{anchorEnd}}.": "OPMERKING: als je het oude script wilt kopiëren. Klik {{anchorStart}} role=\\”button\\” ng-click=\\”vm.openLegacy()\\” {{gt}}hier{{anchorEnd}}.",
    "Name": {
      "$$noContext": "Naam",
      "Exchange Center Sort by option": "Naam"
    },
    "Network not found": "Netwerk niet gevonden",
    "Network speed": "Netwerksnelheid",
    "Network speed:": "Netwerksnelheid:",
    "Never": "Nooit",
    "Never scanned": "Nooit gescand",
    "New": "Nieuw",
    "New Performance Page": "Nieuwe Performance pagina",
    "New Policy": "Nieuwe Policy",
    "New password": "Nieuw wachtwoord",
    "Next": "Volgende",
    "No Broken Links marked as Fixed": "Geen gebroken links gemarkeerd als opgelost",
    "No CSS": "Geen CSS",
    "No Content links": "Geen content links",
    "No Data available for selected time frame": "Geen gegevens beschikbaar voor het geselecteerde tijdvak",
    "No Documents found": "Geen documenten gevonden",
    "No Domains or Groups are yet selected for this report": "Er zijn nog geen domeinen of groepen geselecteerd voor dit rapport",
    "No Frames": "Geen frames",
    "No Frequency": "Geen frequentie",
    "No HTML Pages found": "Geen HTML-pagina's gevonden",
    "No Historic data available for Accessibility Level [[lvl]]": "Geen historie beschikbaar voor toegankelijkheidsniveau [[lvl]]",
    "No IFrames": "Geen IFrames",
    "No Ignored Broken Links": "Geen genegeerde gebroken links",
    "No Image Links found": "Geen afbeeldingslinks gevonden",
    "No PDF's failed": "Geen enkele PDF is gefaald",
    "No PDF's pending": "Geen PDF in behandeling",
    "No PDF's queued": "Geen PDF’s in de wachtrij",
    "No PDF's reviewed": "Geen PDF’s beoordeeld",
    "No PDFs are reviewed": "Er worden geen PDF’s beoordeeld",
    "No Policies detected": "Geen policies gedetecteerd",
    "No Profiles were found": "Er zijn geen profielen gevonden",
    "No Spreadsheet links found": "Geen spreadsheet-links gevonden",
    "No Users are yet selected to receive this report": "Er zijn nog geen gebruikers geselecteerd om dit rapport te ontvangen",
    "No Word links found": "Geen Word-links gevonden",
    "No changes": "Geen wijzigingen",
    "No changes found": "Geen wijzigingen gevonden",
    "No checks found for this Accessibility category": "Geen controles gevonden voor deze toegankelijkheidscategorie",
    "No content policies have been created yet": "Er zijn nog geen policies voor content gemaakt",
    "No corrections added to PageCorrect": "Geen correcties toegevoegd aan PageCorrect",
    "No data available": "Geen gegevens beschikbaar",
    "No data present": "Geen gegevens aanwezig",
    "No diagnostics issues were found": "Er zijn geen diagnostische problemen gevonden",
    "No domains were found": "Er zijn geen domeinen gevonden",
    "No downloads found": "Geen downloads gevonden",
    "No errors found": "Geen fouten gevonden",
    "No exemptions added to this checkpoint": "Er zijn geen uitzonderingen toegevoegd aan dit checkpoint",
    "No exports available": "Geen export beschikbaar",
    "No groups were found for this domain": "Er zijn geen groepen gevonden voor dit domein",
    "No historic data available for this domain": "Geen historie beschikbaar voor dit domein",
    "No hits found": "Geen hits gevonden",
    "No ignored checks in this accessibility category": "Geen genegeerde controles in deze toegankelijkheidscategorie",
    "No ignored misspellings found for this page": "Geen genegeerde spelfouten gevonden voor deze pagina",
    "No incidents occurred in the selected time frame": "Er hebben zich geen incidenten voorgedaan in het geselecteerde tijdvak",
    "No issues found": "Geen problemen gevonden",
    "No javascript": "Geen javascript",
    "No name defined": "Geen naam gedefinieerd",
    "No new notifications": "Geen nieuwe meldingen",
    "No note has been added": "Er is geen notitie toegevoegd",
    "No notifications available": "Geen meldingen beschikbaar",
    "No opportunities were found": "Er zijn geen verbeterpunten gevonden",
    "No outages in this period": "Geen downtime in deze periode",
    "No pages found": "Geen pagina's gevonden",
    "No pages were found": "Er zijn geen pagina's gevonden",
    "No passed checks in this accessibility category": "Geen geslaagde controles in deze toegankelijkheidscategorie",
    "No performance scan found": "Geen performance scan gevonden",
    "No performance scans were found": "Er zijn geen performance scans gevonden",
    "No policies found": "Geen policies gevonden",
    "No readability score": "Geen leesbaarheidsscore",
    "No response received": "Geen antwoord ontvangen",
    "No run present": "Geen uitvoering aanwezig",
    "No scan has yet been performed. Please check back later.": "Er is nog geen scan uitgevoerd. Kijk later nog eens.",
    "No slide links found": "Geen dia-links gevonden",
    "No title found": "Geen titel gevonden",
    "No title found on one or more pages": "Geen titel gevonden op een of meer pagina's",
    "No title is found on this page": "Er is geen titel gevonden op deze pagina",
    "No users available for this domain": "Geen gebruikers beschikbaar voor dit domein",
    "No violations were found": "Er zijn geen overtredingen geconstateerd",
    "No visitor profile selected": "Geen bezoekersprofiel geselecteerd",
    "No visits for this category in selected time frame": "Geen bezoeken voor deze categorie in het geselecteerde tijdvak",
    "No words have been added to the default dictionary": "Er zijn geen woorden toegevoegd aan het standaardwoordenboek",
    "No. Visits": "Aantal bezoeken",
    "Non-user list": "Lijst met niet-gebruikers",
    "None": "Geen",
    "Normal - recommended": "Normaal - aanbevolen",
    "Normal violations": "Normale overtredingen",
    "Not case sensitive": "Niet hoofdlettergevoelig",
    "Not containing": "Bevat niet",
    "Not scheduled": "Niet gepland",
    "Not valid email": "Geen geldig e-mailadres",
    "Note": "Opmerking",
    "Notes": "Opmerkingen",
    "Notifications": "Meldingen",
    "Number of characters in Meta Header text": "Aantal tekens in Meta Header tekst",
    "Number of characters in header text": "Aantal tekens in header tekst",
    "Number of characters in image text": "Aantal tekens in afbeeldingstekst",
    "Number of characters in link text": "Aantal tekens in linktekst",
    "Number of characters in page title": "Aantal tekens in paginatitel",
    "Number of pages": "Aantal pagina's",
    "Number too high": "Aantal te hoog",
    "Number too low": "Aantal te laag",
    "OK": "OK",
    "Office 365 (BETA)": "Office 365 (BETA)",
    "Ok": "OK",
    "Once a day": "Een keer per dag",
    "Once a week": "Een keer per week",
    "One or more documents have already been scanned for compliance. Are you sure you want to scan the selected documents again?": "Een of meer documenten zijn al gescand op naleving. Weet je zeker dat je de geselecteerde documenten opnieuw wilt scannen?",
    "One or more page on your website has the same H1 text.": "Een of meer pagina's op je website hebben dezelfde H1-tekst.",
    "One or more pages has been marked as no index": "Een of meer pagina's zijn gemarkeerd als noindex.",
    "One or more pages on your website has this title": "Een of meer pagina's op je website hebben deze titel.",
    "Open": "Open",
    "Open Accessibility Decision Tree": "Beslisboom voor toegankelijkheid openen",
    "Open Data Privacy": "Open Data Privacy",
    "Open Data Privacy Settings": "Open instellingen voor Data Privacy",
    "Open Document Details": "Open documentdetails",
    "Open Document details": {
      "$$noContext": "Open documentdetails",
      "Aria label when clicking on open Document details": "Open documentdetails"
    },
    "Open Fast Track for this HTML snippet": "Open Fast Track voor deze HTML-snippet",
    "Open New Help Center": "Open een nieuw helpcentrum",
    "Open Page Details": "Open paginadetails",
    "Open Schedule downtime": "Open downtime schema",
    "Open document details": "Open documentdetails",
    "Open domain policy": "Open policies voor het domein",
    "Open example": "Open voorbeeld",
    "Open filters": "Open filters",
    "Open group": "Open groep",
    "Open help center": "Open helpcentrum",
    "Open keyboard shortcuts": "Open sneltoetsen",
    "Open page details": {
      "$$noContext": "Open paginadetails",
      "Aria label when clicking on open pagedetails": "Open paginadetails"
    },
    "Open received reports": "Open ontvangen rapporten",
    "Open report": "Open rapport",
    "Operating System": "Besturingssysteem",
    "Operating Systems": "Besturingssystemen",
    "Operating systems": "Besturingssystemen",
    "Operating systems Overview": "Besturingssystemen overzicht",
    "Operator*": "Operator*",
    "Opportunities": "Verbeterpunten",
    "Opportunities by Priority": "Verbeterpunten gesorteerd op prioriteit",
    "Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.": "Optioneel kun je de primaire taal voor het domein selecteren. Als je Engels (UK) kiest, wordt elke tekst die als Engels wordt gedetecteerd, beschouwd als Brits-Engels.",
    "Options": "Opties",
    "Or": "Of",
    "Organizations": "Organisaties",
    "Original Data": "Originele gegevens",
    "Other Documents": "Andere documenten",
    "Other files": "Andere bestanden",
    "Others": "Anderen",
    "Our suggestion": "Onze suggestie",
    "Our team has been notified of your request. We will soon be in touch.": "Ons team is op de hoogte gebracht van je verzoek. We nemen binnenkort contact met je op.",
    "Outages during the selected time-frame": "Uitval tijdens het geselecteerde tijdsbestek",
    "Outages end": "Uitval eindigt",
    "Outages start": "Uitval begint",
    "Outgoing Links": "Uitgaande links",
    "Outgoing links": "Uitgaande links",
    "Over 1000 ms.": "Meer dan 1000 ms.",
    "Over 10000 ms.": "Meer dan 10000 ms.",
    "Over 200 ms.": "Meer dan 200 ms.",
    "Over 2000 ms.": "Meer dan 2000 ms.",
    "Over 3000 ms.": "Meer dan 3000 ms.",
    "Over 4000 ms.": "Meer dan 4000 ms.",
    "Over 500 ms.": "Meer dan 500 ms.",
    "Over 5000 ms.": "Meer dan 5000 ms.",
    "Over 6000 ms.": "Meer dan 6000 ms.",
    "Over 7000 ms.": "Meer dan 7000 ms.",
    "Over 8000 ms.": "Meer dan 8000 ms.",
    "Over 9000 ms.": "Meer dan 9000 ms.",
    "Overall Data Privacy compliance for this page": "Algemene naleving van Data Privacy voor deze pagina",
    "Overall PageCorrects": "Algemene PageCorrects",
    "Overall SEO compliance for this page": "Algemene SEO-naleving voor deze pagina",
    "Overall accessibility compliance for this level": "Algemene naleving van toegankelijkheid voor dit niveau",
    "Overall accessibility compliance level for this page": "Algemeen nalevingsniveau voor toegankelijkheid voor deze pagina",
    "Overall compliance": "Algemene naleving",
    "Overall policy compliance for this page": "Algemene naleving van policies voor deze pagina",
    "Owner": "Eigenaar",
    "PAGE PERFORMANCE OVERVIEW": "OVERZICHT PAGINA PERFORMANCE",
    "PDF": "PDF",
    "PDF Compliance Status": "PDF-nalevingsstatus",
    "PDF Documents": "PDF-documenten",
    "PDF accessibility scan completed at [[date]]": "PDF-toegankelijkheidsscan voltooid op [[date]]",
    "PDF accessibility scan requested": "PDF-toegankelijkheidsscan aangevraagd",
    "PDF files": "PDF-bestanden",
    "PDF files pending": "PDF-bestanden in behandeling",
    "PDF files reviewed": "PDF-bestanden beoordeeld",
    "PDF files that are reviewed or pending for accessibility": "PDF-bestanden die gecontroleerd zijn op toegankelijkheid of dat nog moeten worden",
    "PDFs": "PDF’s",
    "POLICIES OVERVIEW": "OVERZICHT VAN POLICIES",
    "Page": "Pagina",
    "Page Dashboard": "Paginadashboard",
    "Page Details": "Paginadetails",
    "Page Performance": "Pagina Performance",
    "Page Statistics": "Paginastatistieken",
    "Page URL": "Pagina URL",
    "Page Views": "Paginaweergaven",
    "Page compliance": "Pagina-naleving",
    "Page count in PDF": "Aantal pagina's in PDF",
    "Page dashboard": "Paginadashboard",
    "Page details": "Paginadetails",
    "Page first detected": "Pagina voor het eerst gedetecteerd",
    "Page links": "Paginalinks",
    "PageAssist Logo Position": "Positie van het PageAssist-logo",
    "PageAssist Theme": "PageAssist-thema",
    "PageCorrect": "PageCorrect",
    "PageCorrect Content": "PageCorrect content",
    "PageCorrect Custom Phrase or Word": "PageCorrect aangepaste zin of woord",
    "PageCorrect Details": "PageCorrect details",
    "PageCorrect Diagnostics": "PageCorrect-score",
    "PageCorrects categorized": "PageCorrects gecategoriseerd",
    "PageFixes": "PageFixes",
    "PageFixes Left": "PageFixes Over",
    "Pages": "Pagina's",
    "Pages & documents with confirmed misspellings, broken links or images": "Pagina's en documenten met bevestigde spelfouten, gebroken links of afbeeldingen",
    "Pages Crawled": "Pagina's gecrawld",
    "Pages With Opportunities": "Pagina's met verbeterpunten",
    "Pages and documents with policies marked as unwanted or required": "Pagina's en documenten met policies die zijn gemarkeerd als ongewenst of vereist",
    "Pages crawled": "Pagina's gecrawld",
    "Pages failing check": "Pagina's die niet worden gecontroleerd",
    "Pages in compliance": "Pagina's in naleving",
    "Pages related to policy link": "Pagina's gerelateerd aan policy link",
    "Pages that are difficult to read": "Pagina's die moeilijk te lezen zijn",
    "Pages that are easily understood by children below 5'th grade": "Pagina's die gemakkelijk te begrijpen zijn voor kinderen onder de 5e klas",
    "Pages that are easy to read. Conversational English for consumers": "Pagina's die gemakkelijk te lezen zijn.",
    "Pages that are fairly difficult to read": "Pagina's die vrij moeilijk te lezen zijn.",
    "Pages that are fairly easy to read": "Pagina's die redelijk gemakkelijk te lezen zijn.",
    "Pages that are in plain English. Easily understood by 13- to 15-year-old students": "Pagina's die in simpel Nederlands zijn. Gemakkelijk te begrijpen voor 13- tot 15-jarige studenten.",
    "Pages that are very difficult to read. Best understood by university graduates": "Pagina's die erg moeilijk te lezen zijn. Het best begrepen door universitair afgestudeerden.",
    "Pages that are very easy to read. Easily understood by an average 11-year-old student": "Pagina's die heel gemakkelijk te lezen zijn. Gemakkelijk te begrijpen voor een gemiddelde 11-jarige student.",
    "Pages we could not determine Readability score": "Pagina's waarvan we de leesbaarheidsscore niet konden bepalen",
    "Pages with Data Privacy issues": "Pagina's met problemen met Data Privacy",
    "Pages with Failing Checks": "Pagina's met openstaande controles",
    "Pages with Ignored Checks": "Pagina's met genegeerde controles",
    "Pages with Misspellings": "Pagina's met spelfouten",
    "Pages with Opportunities": "Pagina's met verbeterpunten",
    "Pages with Policy Issues": "Pagina's met policy problemen",
    "Pages with QA Issues": "Pagina's met QA-problemen",
    "Pages with QA issues": "Pagina's met QA-problemen",
    "Pages with SEO Opportunities": "Pagina's met SEO verbeterpunten",
    "Pages with SEO opportunities": "Pagina's met SEO verbeterpunten",
    "Pages with accessibility checks not in compliance": "Pagina's met toegankelijkheidscontroles die niet voldoen aan naleving",
    "Pages with failing checks": "Pagina's met openstaande controles",
    "Pages with high, medium or low opportunities": "Pagina's met hoge, gemiddelde of lage verbeterpunten",
    "Pages with ignored checks": "Pagina's met genegeerde controles",
    "Pages with issues": "Pagina's met problemen",
    "Pages with policy matches": "Pagina's met policy overeenkomsten",
    "Pages with score:": "Pagina's met score:",
    "Pages with the \\\"noindex\\\" META tag will not be indexed by the search engines. This is not an \\\"error\\\" per se, but make sure that the page does not have this tag as a result of an error.": "Pagina's met de \\\"noindex\\\" META-tag worden niet geïndexeerd door de zoekmachines. Dit is niet per se een \\”error\\\", maar zorg ervoor dat de pagina deze tag niet heeft als gevolg van een fout.",
    "Pages without H1 tags or with empty H1 tags that contain no value represent a failed SEO optimization opportunity.": "Het is belangrijk dat je bij al je content, indien voorzien van een kop, de H1 tag toevoegt.",
    "Pages without Visits": "Pagina's zonder bezoeken",
    "Pages without Visits in last 6 months": "Pagina's zonder bezoeken in de afgelopen 6 maanden",
    "Pageviews": "Paginaweergaven",
    "Part of downtime calculation": "Onderdeel van berekening van downtime",
    "Part of heatmap Rules": "Onderdeel van heatmapregels",
    "Part of success criteria [[checkIssueNumber]]": "Onderdeel van succescriteria [[checkIssueNumber]]",
    "Pass Example": "Geslaagd voorbeeld",
    "Passed": "Geslaagd",
    "Passed ([[audits]])": "Geslaagd ([[audits]])",
    "Passed Checks": "Geslaagde controles",
    "Passed Policy checks": "Geslaagde policy controles",
    "Passed checks": "Geslaagde controles",
    "Passed policy checks": "Geslaagde policy controles",
    "Password": "Wachtwoord",
    "Password Confirmation": "Wachtwoordbevestiging",
    "Password confirmation": "Wachtwoordbevestiging",
    "Password to login": "Wachtwoord om in te loggen",
    "Passwords does not match": "Wachtwoorden komen niet overeen",
    "Path constraints": "Padbeperkingen",
    "Path template": "Pad sjabloon",
    "Pending": "In afwachting",
    "Pending PDF review": "In afwachting van PDF-beoordeling",
    "Pending PDF reviews": "In afwachting van PDF-beoordelingen",
    "Percentage shows number of pages that are compliant with all Data Privacy checks": "Percentage toont het aantal pagina's dat voldoet aan alle Data Privacy controles",
    "Percentage shows number of pages that are compliant with all SEO checks": "Percentage toont aantal pagina’s dat voldoet aan alle SEO checks",
    "Performance": "Performance",
    "Performance Errors": "Performance fouten",
    "Performance Pages": "Performance pagina's",
    "Performance Profiles": "Performance profielen",
    "Performance Score": "Performance score",
    "Performance score": "Performance score",
    "Personal": "Persoonlijk",
    "Personal information": "Persoonsgegevens",
    "Phone": "Telefoon",
    "Pie": "Taart",
    "Pin domain": "Domein vastzetten",
    "Ping intervals": "Ping-intervallen",
    "Play": "Start",
    "Play misspelling": "Speel spelfout",
    "Please choose a trademark": "Kies een handelsmerk",
    "Please insert correct URL:": "Voer de juiste URL in:",
    "Please insert the correct word:": "Voer het juiste woord in:",
    "Please insert the missing ALT text:": "Voer de ontbrekende ALT-tekst in:",
    "Please select a module": "Selecteer een module",
    "Please select the module that you want to create a Source Code Exclude for": "Selecteer de module waarvoor je een broncode wilt uitsluiten",
    "Please specify word or phrase to search for": "Geef een woord of zin op om naar te zoeken",
    "Please use CSS selectors to identify form fields and buttons": "Gebruik CSS-selectors om formuliervelden en knoppen te identificeren",
    "Please wait": "Een ogenblik geduld",
    "Please wait - Adding word to dictionary": "Een ogenblik geduld - woord wordt toegevoegd aan woordenboek",
    "Please wait - Adding words to dictionary": "Een ogenblik geduld - woorden worden toegevoegd aan woordenboek",
    "Please wait - Confirming misspelling": "Een ogenblik geduld - spelfout wordt bevestigd",
    "Please wait - exporting audit log &nbsp;": "Een ogenblik geduld - auditlogboek exporteren &nbsp;",
    "Policies": "Policies",
    "Policies - required": "Policies - vereist",
    "Policies - violations": "Policies - schendingen",
    "Policies marked as required or unwanted": "Policies gemarkeerd als vereist of ongewenst",
    "Policies violations": "Policies schendingen",
    "Policies with most matches": "Policies met de meeste overeenkomsten",
    "Policies with violations": "Policies met schendingen",
    "Policy": "Policy",
    "Policy Diagnostics": "Policy score",
    "Policy Distribution": "Verdeling van policy",
    "Policy Hits": "Policy overeenkomsten",
    "Policy Issues": "Problemen met policy",
    "Policy List": "Lijst Policies",
    "Policy Pages": "Policy pagina's",
    "Policy Running": "Policy word momenteel uitgevoerd",
    "Policy errors": "Policy fouten",
    "Policy hits per domain": "Policy overeenkomsten per domein",
    "Policy in queue": "Policy in wachtrij",
    "Policy info": "Informatie over policy",
    "Policy note": "Policy notitie",
    "Policy rules": "Policy regels",
    "Policy scan in progress": "Scan van policy wordt uitgevoerd",
    "Policy setup": "Policy instellingen",
    "Policy violations": "Policy schendingen",
    "Policy with matching terms": "Policy met bijpassende termen",
    "Potential Misspelling": "Mogelijke spelfout",
    "Potential Misspellings": "Mogelijke spelfouten",
    "Potential Savings": "Mogelijke besparingen",
    "Potential misspelling": "Mogelijke spelfout",
    "Potential misspellings": "Mogelijke spelfouten",
    "Potential misspellings found": "Mogelijke spelfouten gevonden",
    "Powered by Google Lighthouse": "Mogelijk gemaakt door Google Lighthouse",
    "Prefix path": "Prefix pad",
    "Presence": "Aanwezigheid",
    "Previous": "Vorige",
    "Principle 1: Perceivable": "Principe 1: Waarneembaar",
    "Principle 2: Operable": "Principe 2: Bedienbaar",
    "Principle 3: Understandable": "Principe 3: Begrijpelijk",
    "Principle 4: Robust": "Principe 4: Robuust",
    "Principle 5: Conformance": "Principe 5: Conformiteit",
    "Print view": "Afdrukweergave",
    "Priorities": "Prioriteiten",
    "Prioritized Content": "Prioritized Content",
    "Priority": "Prioriteit",
    "Profile": "Profiel",
    "Profile Description": "Profielomschrijving",
    "Profile Dropdown": "Profiel dropdown",
    "Profile Menu": "Profielmenu",
    "Profile Name": "Profielnaam",
    "Profile details": "Profieldetails",
    "Profile updated": "Profiel geüpdate",
    "QA": "QA",
    "QA Issues": "QA-problemen",
    "QA errors": "QA-fouten",
    "QUALITY ASSURANCE": "QUALITY ASSURANCE",
    "QUALITY ASSURANCE OVERVIEW": "QUALITY ASSURANCE OVERZICHT",
    "Quality Assurance": "Quality Assurance",
    "Quality Assurance Check": "Quality Assurance controle",
    "Quality Assurance Diagnostics": "Quality Assurance score",
    "Quality Assurance Export summary": "Quality Assurance export samenvatting",
    "Quality Assurance errors": "Quality Assurance fouten",
    "Quality assurance": "Quality assurance",
    "Queued": "In de wachtrij",
    "Quick Guide": "Snelgids",
    "Quick help": "Snelle hulp",
    "Quick info:": "Snelle info:",
    "Re-scanning of issues for this page has started and will be finished in a few minutes.": "Het opnieuw scannen van problemen voor deze pagina is begonnen en zal binnen enkele minuten voltooid zijn.",
    "Readability": "Leesbaarheid",
    "Readability Score": "Leesbaarheidsscore",
    "Readability by score": "Leesbaarheid per score",
    "Readability levels": "Leesbaarheidsniveaus",
    "Readability score": "Leesbaarheidsscore",
    "Readability scores across all web pages (based on": "Leesbaarheidsscores op alle webpagina's (gebaseerd op",
    "Readability test": "Leesbaarheidstest",
    "Receive report": "Ontvang rapport",
    "Received reports": "Ontvangen rapporten",
    "Referring Information": "Verwijzende informatie",
    "Referring visits": "Verwijzende bezoeken",
    "Regex": "Regex",
    "Regulation": "Regulatie",
    "Remember me": "Onthoud mij",
    "Remove": "Verwijderen",
    "Remove Custom Multistep Javascript": "Custom Multistep Javascript verwijderen",
    "Remove Extension Name": "Extensienaam verwijderen",
    "Remove Page": "Pagina verwijderen",
    "Remove Profile": "Profiel verwijderen",
    "Remove Rule": "Regel verwijderen",
    "Remove checkpoint": "Checkpoint verwijderen",
    "Remove domain": "Domein verwijderen",
    "Remove domain group": "Domeingroep verwijderen",
    "Remove from dictionary": "Uit woordenboek verwijderen",
    "Remove group": "Groep verwijderen",
    "Remove rule": "Regel verwijderen",
    "Remove this IP address?": "Dit IP-adres verwijderen?",
    "Remove this pattern?": "Dit patroon verwijderen?",
    "Remove this word from dictionary": "Verwijder dit woord uit woordenboek",
    "Render pages and execute JS while crawling": "Render pagina's en voer JS uit tijdens het crawlen",
    "Repeat": "Herhaling",
    "Replace Rule": "Regel vervangen",
    "Report": "Rapport",
    "Report administration": "Rapportadministratie",
    "Report overview:": "Rapportoverzicht:",
    "Request PDF scan for all documents": "Vraag PDF-scan aan voor alle documenten",
    "Requests": "Verzoeken",
    "Required": "Verplicht",
    "Required content": "Vereiste content",
    "Required count": "Vereist aantal",
    "Rescan": "Opnieuw scannen",
    "Rescanning": "Opnieuw scannen",
    "Reset": "Reset",
    "Reset Preferences": "Reset voorkeuren",
    "Resolution": "Resolutie",
    "Resource Type": "Brontype",
    "Response Time": "Responstijd",
    "Response code": "Responscode",
    "Response time": "Responstijd",
    "Response time (Milliseconds)": "Responstijd (milliseconden)",
    "Response time notification": "Responstijd melding",
    "Response time notification threshold": "Responstijd melding drempel",
    "Return to heartbeat overview": "Terug naar het Heartbeat overzicht",
    "Returning customer": "Terugkomende klant",
    "Reverting state": "Staat terugzetten",
    "Review": "Beoordelen",
    "Reviewed": "Beoordeeld",
    "Reviewed/Ok": "Beoordeeld/Ok",
    "Revoke token": "Token intrekken",
    "Robot Info": "Robot Info",
    "Role": "Rol",
    "Rule": "Regel",
    "Rule name": "Regel naam",
    "Rule operator": "Regel operator",
    "Rule to match": "Regel die overeenkomt",
    "Rules": "Regels",
    "Run Policy": "Policy uitvoeren",
    "Run policy": "Policy uitvoeren",
    "Run policy again": "Policy opnieuw uitvoeren",
    "Running": "Word momenteel uitgevoerd",
    "SEO": "SEO",
    "SEO (Search Engine Optimization)": "SEO (Search Engine Optimization)",
    "SEO Checkpoints": "SEO Checkpoints",
    "SEO Diagnostics": "SEO-score",
    "SEO Issues": "SEO Problemen",
    "SEO OVERVIEW": "SEO OVERZICHT",
    "SEO Opportunities": "SEO Verbeterpunten",
    "SEO errors": "SEO fouten",
    "SEO impact": "SEO impact",
    "SEO opportunities": "SEO verbeterpunten",
    "SEO opportunities - high priority": "SEO verbeterpunten - hoge prioriteit",
    "SEO opportunities - low priority": "SEO verbeterpunten - lage prioriteit",
    "SEO opportunities - medium priority": "SEO verbeterpunten - gemiddelde prioriteit",
    "SEO opportunities - technical SEO issues": "SEO verbeterpunten - technische SEO problemen",
    "SEO opportunities found": "SEO verbeterpunten gevonden",
    "SHOW LIST VIEW": "TOON LIJSTWEERGAVE",
    "STATISTICS OVERVIEW": "STATISTIEKEN OVERZICHT",
    "Saturday": "Zaterdag",
    "Save": "Opslaan",
    "Save Preferences": "Bewaar voorkeuren",
    "Save and close": "Opslaan en sluiten",
    "Save policy": "Save policy",
    "Scan": "Scannen",
    "Scan documents": "Scan documenten",
    "Scan frequency": "Scan frequentie",
    "Scan frequency:": "Scan frequentie:",
    "Scan in progress": "Bezig met scannen",
    "Scan in progress:": "Bezig met scannen:",
    "Scan is done": "Scan is voltooid",
    "Scan subdomains": "Scan subdomeinen",
    "Scanned at": "Gescand op",
    "Scanned content": "Gescande content",
    "Scanned links:": "Gescande links:",
    "Scanned pages": "Gescande pagina's",
    "Scanned pages:": "Gescande pagina's:",
    "Scanning URL:": "URL scannen:",
    "Scanning in progress": "Bezig met scannen",
    "Schedule Report": "Plan rapport",
    "Schedule supplemental reports to be delivered with each scan": "Plan extra rapporten die na elke scan moeten worden verzonden",
    "Scheduled": "Gepland",
    "Scheduled Reports": "Geplande rapporten",
    "Scopes": "Bereik",
    "Score": "Score",
    "Screen Resolutions": "Schermresoluties",
    "Screen Resolutions Overview": "Schermresoluties overzicht",
    "Script Evaluation": "Scriptevaluatie",
    "Script Parse": "Script plakken",
    "Script installed": "Script geïnstalleerd",
    "Script installed on Domain": "Script geïnstalleerd op domein",
    "Script setup guide": "Handleiding voor het instellen van scripts",
    "Search Engine Optimization": "Search Engine Optimization",
    "Search Engine Optimization (SEO)": "Search Engine Optimization (SEO)",
    "Search Engines": "Zoekmachines",
    "Search engine": "Zoekmachine",
    "Search engines": "Zoekmachines",
    "Search for Pages": "Zoek naar pagina's",
    "Search for file size that is": "Zoek naar bestandsgrootte welke",
    "Search for image size that is": "Zoek naar het afbeeldingsformaat welke",
    "Search for links, that are associated with class names and contains below mentioned class names.": "Zoek naar links die zijn gekoppeld aan klassenamen en die onderstaande klassenamen bevatten.",
    "Search for page titles or URLs across all domains": "Zoek naar paginatitels of URL's in alle domeinen",
    "Search for pages": "Zoek naar pagina's",
    "Search icon": "Zoek icoon",
    "Search in: Documents": "Zoeken in: Documenten",
    "Search in: Everything": "Zoeken in: Alles",
    "Search in: Links": "Zoeken in: Links",
    "Search in: Only HTML pages": "Zoeken in: alleen HTML-pagina's",
    "Search pages across all domains": "Zoek pagina's in alle domeinen",
    "Search...": "Zoeken...",
    "Searches": "Zoekopdrachten",
    "Seconds": "Seconden",
    "See API Token": "Zie API-token",
    "See Details": "Zie details",
    "See changes": "Zie wijzigingen",
    "See details": "Zie details",
    "See pages": "Zie pagina's",
    "Select Domain and Module to get the Insights": "Selecteer domein en module om de inzichten op te halen",
    "Select Domain on domain picker": "Selecteer domein met domeinkiezer",
    "Select Page to scan": "Selecteer pagina om te scannen",
    "Select a domain and recipients": "Selecteer een domein en ontvangers",
    "Select a domain or group": "Selecteer een domein of groep",
    "Select a profile": "Selecteer een profiel",
    "Select account": "Selecteer account",
    "Select all items": "Selecteer alle items",
    "Select domain": "Selecteer domein",
    "Select domains and groups": "Selecteer domeinen en groepen",
    "Select filters": "Selecteer filters",
    "Select import": "Selecteer importeren",
    "Select item": "Selecteer item",
    "Select login type*": "Selecteer logintype*",
    "Select timezone": "Selecteer tijdzone",
    "Select users": "Selecteer gebruikers",
    "Select what type of content the policy should search in": "Selecteer in welk type content de policy moet zoeken",
    "Select whether the rule should search for case sensitive text or not": "Selecteer of de regel moet zoeken naar hoofdlettergevoelige tekst of niet",
    "Select your export file": "Selecteer je exportbestand",
    "Send an email if the site is down": "Stuur een e-mail bij downtime",
    "Send an email if the site is slow to respond": "Stuur een e-mail bij trage response time",
    "Send message": "Verstuur bericht",
    "Send report": "Verstuur rapport",
    "Send welcome mail on creation": "Stuur een welkomstmail bij het maken",
    "Set a default value for selector": "Stel een standaardwaarde in voor selector",
    "Set as Default": "Stel in als standaard",
    "Set to fixed": "Stel in als opgelost",
    "Settings": {
      "$$noContext": "Instellingen",
      "Topmenu": "Instellingen"
    },
    "Setup your domain": "Stel je domein in",
    "Severity": "Omvang",
    "Severity level": "Omvangniveau",
    "Short": "Kort",
    "Short Description": "Korte omschrijving",
    "Should we check the page's current status?": "Moeten we de huidige status van de pagina controleren?",
    "Show Details": "Toon details",
    "Show all": "Toon alles",
    "Show documents with this email": "Toon documenten met deze e-mail",
    "Show history": "Toon historie",
    "Show label dropdown": "Dropdownmenu voor labels weergeven",
    "Show less": "Laat minder zien",
    "Show more": "Laat meer zien",
    "Show on global policy list": "Weergeven op globale policy lijst",
    "Show pages": "Toon pagina's",
    "Show pages with issues": "Toon pagina's met problemen",
    "Show pages with this SEO issue": "Toon pagina's met dit SEO-probleem",
    "Show pages with this email": "Toon pagina's met deze e-mail",
    "Show pages with this image": "Toon pagina's met deze afbeelding",
    "Show pages with this link": "Toon pagina's met deze link",
    "Show pages with this misspelling": "Toon pagina's met deze spelfout",
    "Show policy hits per domain": "Toon policy hits per domein",
    "Show policy info": "Toon informatie over policy",
    "Show the Domain Picker": "Toon de domeinkiezer",
    "Show/Hide filter selector": "Filterkiezer weergeven/verbergen",
    "Show/Hide the Domain Picker": "Domeinkiezer weergeven/verbergen",
    "Shows the remaining number of Performance Profiles that can be created for this account": "Geeft het resterende aantal performance profielen weer dat voor dit account kan worden gemaakt",
    "Side Navigation": "Zij-navigatie",
    "Single line": "Enkele lijn",
    "Size": "Grootte",
    "Skip to content": "Doorgaan naar content",
    "Slide links": "Dia links",
    "Slides": "Dia's",
    "Slow": "Langzaam",
    "Snippet": "Snippet",
    "Social": "Sociaal",
    "Social Networks": "Sociale netwerken",
    "Social visits": "Sociale bezoeken",
    "Source Code Exclude": "Broncode uitsluiten",
    "Source Code Excludes": "Broncode is uitgesloten",
    "Source code": "Broncode",
    "Spellcheck": "Spellingscontrole",
    "Spellcheck Export Summary": "Spellingscontrole exportoverzicht",
    "Spellcheck Summary": "Spellingscontrole overzicht",
    "Spelling": "Spelling",
    "Spelling Errors used": "Gebruikte spelfouten",
    "Spelling fixes": "Spel verbeteringen",
    "Spelling ignore capitalized words": "Bij de spelling worden woorden met een hoofdletter genegeerd",
    "Spreadsheet links": "Spreadsheet-koppelingen",
    "Spreadsheets": "Spreadsheets",
    "Start PDF accessibility scan": "Start PDF-toegankelijkheidsscan",
    "Start at": "Begin om",
    "Start compound export": "Start samengestelde export",
    "Start date": "Startdatum",
    "Start export": "Start de export",
    "Start export Pages With Specific Link": "Start het exporteren van pagina's met een specifieke link",
    "Start new scan": "Start een nieuwe scan",
    "Start on demand scan": "Start de handmatige scan",
    "Start time": "Starttijd",
    "Starts with": "Begint met",
    "State": "Staat",
    "Statistic": "Statistiek",
    "Statistics": "Statistieken",
    "Statistics excluded IP addresses": "Statistieken uitgesloten IP-adressen",
    "Status": "Status",
    "Stop current crawl": "Stop de huidige crawl",
    "Sub Navigation": "Subnavigatie",
    "Submit selector*": "Selector verzenden*",
    "Succeeds": "Slaagt",
    "Success criteria": "Succescriteria",
    "Suggestions and ideas": "Suggesties en ideeën",
    "Summarized pages and documents count": "Aantal samengevatte pagina's en documenten",
    "Summary": "Overzicht",
    "Sunday": "Zondag",
    "Switch account": "Wissel account",
    "Table View": "Tabelweergave",
    "Tags": "Tags",
    "Target": "Doel",
    "Technical": "Technisch",
    "Technical SEO Issues": "Technische SEO-problemen",
    "Text": "Tekst",
    "Text Documents": "Tekstdocumenten",
    "Text documents": "Tekstdocumenten",
    "Text to match": "Tekst om overeenkomsten voor te zoeken",
    "Text:": "Tekst:",
    "The Checkpoint [[checkpoint]] will be updated with data after next crawl": "Het Checkpoint [[checkpoint]] wordt na de volgende crawl bijgewerkt met gegevens",
    "The Document is not tagged": "Het document is niet gelabeld",
    "The Path template for Umbraco CMS": "Het Path-sjabloon voor Umbraco CMS",
    "The Requested Page is not a part of the Performance Module": "De opgevraagde pagina maakt geen deel uit van de Performance Module",
    "The Scan will take effect within the next few hours": "De scan wordt binnen enkele uren voltooid",
    "The URL for this page is too long": "De URL voor deze pagina is te lang",
    "The base url to the CMS page": "De basis-URL naar de CMS-pagina",
    "The bounce rate tells you the number of visits who only see the one page they started on": "Het bounce percentage geeft het aantal bezoekers aan dat alleen de pagina bekijkt waarop ze zijn begonnen.",
    "The following rules will be removed, are you sure you want to continue with this change?": "De volgende regels worden verwijderd. Weet je zeker dat je door wilt gaan met deze wijziging?",
    "The header 1 (H1) tag is important as it helps search engines and users to understand what content they can expect to find on the page.": "De header 1 (H1) tag is belangrijk omdat het zoekmachines en gebruikers helpt te begrijpen welke content ze op de pagina kunnen verwachten.",
    "The likelihood of this being a Data Privacy issue": "De kans dat dit een Data Privacy probleem is",
    "The lowest level of readability. Example: children's books": "Het laagste leesbaarheidsniveau. Voorbeeld: kinderboeken",
    "The meta description on this page is too long": "De meta-beschrijving op deze pagina is te lang",
    "The meta description on this page is too short": "De meta-beschrijving op deze pagina is te kort",
    "The misspelling will first show up after a new scan": "De spelfout wordt voor het eerst weergegeven na een nieuwe scan",
    "The name of a meta entry (page metadata)": "De naam van een meta-invoer (metadata van de pagina)",
    "The optional base url to the CMS page": "De optionele basis-URL naar de CMS-pagina",
    "The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.": "De beveiliging van je persoonlijke gegevens is erg belangrijk voor ons. Daarom hebben we ons gegevensbeschermings- en privacybeleid bijgewerkt. Om ons platform te blijven gebruiken, vragen we je vriendelijk de nieuwe voorwaarden voor gegevensbescherming en gegevensbeleid te lezen en te accepteren.",
    "The scan can take a few hours/days to finalise, depending on the size of the website": "Afhankelijk van de grootte van de website, kan het enkele uren/dagen duren voordat de scan is voltooid.",
    "The scan can take a few hours/days to finalise, depending on the size of the website.<br><br>Are you sure you want to start on-demand scan?": "<br><br> Afhankelijk van de grootte van de website, kan het enkele uren/dagen duren voordat de scan is voltooid. Weet je zeker dat je de scan nu wilt starten?",
    "The scan can take a few minutes to finalise, depending on the size of the page": "Afhankelijk van de grootte van de pagina, kan het enkele minuten duren voordat de scan is voltooid.",
    "There are no META descriptions on one or more pages": "Er zijn geen META-beschrijvingen op een of meer pagina's",
    "There are no domains assigned to this policy. Save policy anyway?": "Er zijn geen domeinen toegewezen aan deze policy. Policy toch opslaan?",
    "There are no more errors for this Snippet": "Er zijn geen fouten meer voor deze snippet",
    "There are no sub headlines on one or more pages": "Er zijn geen tussenkoppen op een of meer pagina's",
    "There are zero META keywords on this page": "Er zijn geen META-trefwoorden op deze pagina",
    "There is no H1 on one or more pages": "Er is geen H1 op een of meer pagina's",
    "There is no H1 on this page": "Er is geen H1 op deze pagina",
    "There is no META descriptions on this page": "Er zijn geen META-beschrijvingen op deze pagina",
    "There is no historic data for domain groups": "Geen historische data beschikbaar voor domeingroepen",
    "There is no historic data for this domain": "Geen historie beschikbaar voor dit domein",
    "There is no sub headlines on this page": "Er zijn geen tussenkoppen op deze pagina",
    "These are findings that cannot be automatically checked and must be reviewed manually": "Dit zijn bevindingen die niet automatisch kunnen worden gecontroleerd en die handmatig moeten worden beoordeeld",
    "These are findings which are likely to be errors, requiring manual confirmation": "Dit zijn bevindingen die waarschijnlijk fouten zijn en die handmatige bevestiging vereisen",
    "These findings are confirmed errors": "Deze bevindingen zijn bevestigde fouten",
    "Third-Party": "Derde partij",
    "This field is required": "Dit veld is verplicht",
    "This is the time between when an outage is first detected and when a notification is sent.": "Dit is de tijd tussen het moment waarop een storing voor het eerst wordt gedetecteerd en het moment waarop een melding wordt verzonden.",
    "This is useful if you have defined timeslots for maintenance.": "Dit is handig als je tijdvakken voor onderhoud hebt gedefinieerd.",
    "This issue is ignored": "Dit probleem wordt genegeerd",
    "This link is marked as broken because it took more than 30 seconds to load": "Deze link is gemarkeerd als gebroken omdat het meer dan 30 seconden duurde om te laden",
    "This page has been marked as no index": "Deze pagina is gemarkeerd als noindex",
    "This page has no meta description": "Deze pagina heeft geen metabeschrijving",
    "This page has no meta keywords": "Deze pagina heeft geen meta-keywords",
    "This page has not been assigned to the Performance Module": "Deze pagina is niet toegewezen aan de Performance Module",
    "This page is missing a title": "Deze pagina heeft geen titel",
    "This policy is scheduled": "Deze policy staat gepland",
    "This rule doesn't contain any matches": "Deze regel bevat geen overeenkomsten",
    "This section lists requirements for <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformance</a> to WCAG 2.1. It also gives information about how to make conformance claims, which are optional.": "<a target=\"_blank\" href=\"https://www.w3.org/TR/WCAG21/#dfn-conform\"></a>Deze sectie bevat vereisten voor conformiteit aan WCAG 2.1. Het geeft ook informatie over hoe je conformiteit kunt aantonen, die optioneel zijn.",
    "Thursday": "Donderdag",
    "Time": "Tijd",
    "Time Spent": "Tijd besteed",
    "Time To Interactive": "Tijd voor interactief",
    "Time to Warning *": "Tijd tot waarschuwing*",
    "Timeframe:": "Tijdsspanne:",
    "Timeline": "Tijdlijn",
    "Timezone": "Tijdzone",
    "Title": "Titel",
    "Title & description": "Titel & beschrijving",
    "Title and URL": "Titel en URL",
    "Title and url": "Titel en url",
    "To setup this policy, you need to tell us how long your max word length is": "Om deze policy in te stellen, voer je de maximale woordlengte in",
    "To setup this policy, you need to tell us which brand name should end with TM or ™": "Om deze richtlijnen in te stellen, geef je aan welke merknaam moet eindigen op TM of ™",
    "To toggle Quick Search:": "Om snel zoeken in te schakelen:",
    "Toggle Dropdown": "Toggle Dropdown",
    "Toggle dropdown": "Toggle dropdown",
    "Toggle notes": "Toggle notities",
    "Toggle show filters": "Toggle het weergeven van filters",
    "Too few characters": "Te weinig tekens",
    "Too many characters": "Te veel tekens",
    "Top keywords": "Top keywords",
    "Total": "Totaal",
    "Total CPU Time": "Totale CPU-tijd",
    "Total QA issues": "Totaal aantal QA-problemen",
    "Total Visitors": "Totaal bezoekers",
    "Total Visits": "Totaal aantal bezoeken",
    "Total amount of content": "Totale hoeveelheid content",
    "Total crawled": "Totaal gecrawld",
    "Total number of issues": "Totaal aantal problemen",
    "Total number of issues across all modules": "Totaal aantal problemen voor alle modules",
    "Total page views over the last 30 days": "Totaal aantal paginaweergaven in de afgelopen 30 dagen",
    "Total pages:": "Totaal aantal pagina's:",
    "Total visitors": "Totaal bezoekers",
    "Total visitors from Referrers": "Totaal aantal bezoekers van verwijzende bronnen",
    "Total visitors from Search Engines": "Totaal aantal bezoekers van zoekmachines",
    "Total visits": "Totaal aantal bezoeken",
    "Total visits from Referrers": "Totaal aantal bezoeken van verwijzende bronnen",
    "Total visits from Search Engines": "Totaal aantal bezoeken van zoekmachines",
    "Total visits in the last 30 days:": "Totaal aantal bezoeken in de afgelopen 30 dagen:",
    "Total words": "Totaal aantal woorden",
    "Track changes across domains and modules": "Houd wijzigingen bij tussen domeinen en modules",
    "Traffic Sources": "Verkeersbronnen",
    "Traffic Sources Summary": "Overzicht verkeersbronnen",
    "Traffic sources": "Verkeersbronnen",
    "Transfer Size": "Overdrachtsgrootte",
    "Tuesday": "Dinsdag",
    "Twice a day": "Twee keer per dag",
    "Twitter": "Twitter",
    "Type": "Type",
    "Type the key for the metadata": "Typ de sleutel voor de metadata",
    "Type the text to match rule": "Typ de tekst die overeenkomt met de regel",
    "Type*": "Type*",
    "URL": "URL",
    "URL must start with a protocol. Ex. http://....": "URL moet beginnen met een protocol. Bijv. http://....",
    "URL to redirect to if form is valid": "URL waarnaar moet worden doorverwezen als het formulier geldig is",
    "URL:": "URL:",
    "Unable to read link": "Kan link niet lezen",
    "Unarchive": "De-archiveren",
    "Undetermined": "Onbepaald",
    "Undo": "Ongedaan maken",
    "Undo review": "Beoordeling ongedaan maken",
    "Unignore": "Niet negeren",
    "Unignore check": "Controle niet meer negeren",
    "Unignore misspelling": "Spelfout niet meer negeren",
    "Unignore on this page": "Niet meer negeren op deze pagina",
    "Unignore this SEO issue": "Dit SEO-probleem niet meer negeren",
    "Unignore this check for this domain": "Deze controle voor dit domein niet meer negeren",
    "Unique Visitors": "Unieke Bezoekers",
    "Unique downloads": "Unieke downloads",
    "Unknown": "Onbekend",
    "Unknown Score": "Onbekende score",
    "Unknown title": "Onbekende titel",
    "Unpin domain": "Maak domein los",
    "Unsaved changes": "Niet-opgeslagen wijzigingen",
    "Unwanted": "Ongewenst",
    "Unwanted content": "Ongewenste content",
    "Unwanted violations": "Ongewenste overtredingen",
    "Update": "Bijwerken",
    "Update groups": "Groepen bijwerken",
    "Updated": "Bijgewerkt",
    "Updated At": "Bijgewerkt op",
    "Updated at": "Bijgewerkt op",
    "Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Het bijwerken van groepen kan meer dan 30 minuten duren. Tijdens het bijwerken kan je geen groepen maken en bijwerken.",
    "Upload CSV": "Upload CSV",
    "Upload csv file": "Upload csv-bestand",
    "Uptime": "Uptime",
    "Uptime last 30 days": "Uptime afgelopen 30 dagen",
    "Url*": "Url*",
    "Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors": "Gebruik * als een wildcard (bijv. 192.168.1.*). Uitgesloten IP-adressen zijn alleen van invloed op nieuwe bezoekers",
    "Use language attribute": "Gebruik taalkenmerk",
    "Use or Apply custom PageCorrect": "Gebruik of pas aangepaste PageCorrect toe",
    "User": "Gebruiker",
    "User Export": "Gebruiker exporteren",
    "User List": "Gebruikerslijst",
    "User Loading Experience": "Gebruikerservaring met laden",
    "User information": "Gebruikersinformatie",
    "User interface components and navigation must be operable.": "Gebruikersinterface componenten en navigatie moeten bedienbaar zijn.",
    "User is account administrator": "Gebruiker is accountbeheerder",
    "Username": "Gebruikersnaam",
    "Value": "Waarde",
    "Value*": "Waarde*",
    "Vat no": "Btw nr",
    "Verify URL*": "Verificatie-URL*",
    "Very easy": "Erg makkelijk",
    "Very hard": "Heel moeilijk",
    "View options": "Bekijk opties",
    "Viewing as Profile:": "Weergeven als profiel:",
    "Views": "Weergaven",
    "Violation": "Overtreding",
    "Violation count": "Aantal overtredingen",
    "Violation's info_type name not set": "Info_type naam van overtreding niet ingesteld",
    "Violations": "Overtredingen",
    "Visible": "Zichtbaar",
    "Visible modules": "Zichtbare modules",
    "Visit the affected image": "Bezoek de betreffende afbeelding",
    "Visitor Overview": "Bezoekersoverzicht",
    "Visitor Summary": "Bezoekersoverzicht",
    "Visitor log": "Bezoekerslogboek",
    "Visitor profile": "Bezoekersprofiel",
    "Visitor profile:": "Bezoekersprofiel:",
    "Visitors": "Bezoekers",
    "Visitors Summary": "Bezoekersoverzicht",
    "Visits": "Bezoeken",
    "Visual mode": "Visuele modus",
    "WCAG 2.0 (Level A)": "WCAG 2.0 (niveau A)",
    "WCAG 2.0 (Level AA)": "WCAG 2.0 (niveau AA)",
    "WCAG 2.0 (Level AAA)": "WCAG 2.0 (niveau AAA)",
    "WCAG 2.0 Accessibility Compliance": "WCAG 2.0 naleving van toegankelijkheid",
    "WCAG 2.1 (Level A)": "WCAG 2.1 (niveau A)",
    "WCAG 2.1 (Level AA)": "WCAG 2.1 (niveau AA)",
    "WCAG 2.1 (Level AAA)": "WCAG 2.1 (niveau AAA)",
    "WCAG 2.1 Accessibility Compliance": "WCAG 2.1 naleving van toegankelijkheid",
    "Want to search for": "Wil je zoeken naar",
    "Warning": "Waarschuwing",
    "We recommend that all your pages has a number of relevant meta keywords.": "We raden aan dat al je pagina's een aantal relevante meta-keywords hebben.",
    "We recommend that all your pages has a relevant and unique meta description.": "We raden aan dat al je pagina's een relevante en unieke metabeschrijving hebben.",
    "We recommend that all your pages has an unique title.": "We raden aan dat al je pagina's een unieke titel hebben.",
    "We recommend that the meta description consists of at least 50 characters.": "We raden aan dat de metabeschrijving uit minimaal 50 tekens bestaat.",
    "We recommend that the meta description consists of no more than 160 characters.": "We raden aan dat de metabeschrijving uit niet meer dan 160 tekens bestaat.",
    "We recommend that you give each page a unique title.": "We raden je aan om elke pagina een unieke titel te geven.",
    "We recommend that you have a unique H1 tag on each page.": "We raden je aan om op elke pagina een unieke H1-tag te gebruiken.",
    "We recommend that you have at least one H2-H6": "We raden je aan om per pagina ten minste één H2-H6 te gebruiken",
    "We recommend that you have no more than 100 internal links on each page.": "We raden je aan om niet meer dan 100 interne links op elke pagina te gebruiken.",
    "We recommend that you keep your URL below 200 characters.": "We raden je aan om je URL onder de 200 tekens te houden.",
    "We recommend that you only have one H1 tag on each page.": "We raden je aan slechts één H1-tag op elke pagina te hebben.",
    "Wednesday": "Woensdag",
    "Weekly": "Wekelijks",
    "Well done - no accessibility issues found": "Goed gedaan - geen toegankelijkheidsproblemen gevonden",
    "We’ve Updated our Privacy Policy!": "We hebben ons privacybeleid bijgewerkt!",
    "Why is this an issue": "Waarom is dit een probleem?",
    "With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go": "Met Fast Track kun je HTML-snippets op betrokken pagina's in één keer corrigeren, bekijken en negeren",
    "Word": "Woord",
    "Word Count": "Aantal woorden",
    "Word count": "Aantal woorden",
    "Word count in PDF": "Aantal woorden in PDF",
    "Word is added to dictionary": "Woord wordt aan woordenboek toegevoegd",
    "Word is added to dictionary for all languages": "Woord wordt voor alle talen aan woordenboek toegevoegd",
    "Word is confirmed as misspelling": "Woord wordt als spelfout bevestigd",
    "Word length": "Woordlengte",
    "Word links": "Woordlinks",
    "Word or Phrase": "Woord of zin",
    "Words": "Woorden",
    "Would you like to update now? Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups": "Wil je nu bijwerken? Het bijwerken van groepen kan meer dan 30 minuten duren. Tijdens het bijwerken kan je geen groepen maken en bijwerken",
    "Written by: [[author]]": "Geschreven door: [[author]]",
    "Years": "Jaren",
    "You are about to delete": "Je staat op het punt om te verwijderen",
    "You are about to delete the domain": "Je staat op het punt het domein te verwijderen",
    "You are about to delete the domain group": "Je staat op het punt de domeingroep te verwijderen",
    "You are currently using Demo Data, certain features will be unavailable": "Je gebruikt momenteel demogegevens. Bepaalde functies zijn niet beschikbaar",
    "You are receiving this report": "Je ontvangt dit rapport",
    "You can create another [[customerProfilesLimit]] profiles for your account": "Je kunt nog een [[customerProfilesLimit]] - profiel voor je account maken",
    "You can pin this domain. Pinned domains will be shown at the top of your domain list": "Je kunt dit domein vastzetten. Vastgezette domeinen worden bovenaan je domeinlijst weergegeven",
    "You have more than one H1 tag on this page": "Je hebt meer dan één H1-tag op deze pagina",
    "You have no H2-H6 tags on the page": "Je hebt geen H2-H6-tags op deze pagina",
    "You have no available profiles": "Je hebt geen beschikbare profielen",
    "You have not received any reports": "Je hebt geen rapporten ontvangen",
    "You have one or more pages with the \\\"noindex\\\" META tag": "Je hebt een of meer pagina's met de \\\"noindex\\\" META-tag",
    "You have reached the maximum number of profiles for this account.": "Je hebt het maximale aantal profielen voor dit account bereikt.",
    "You have too many internal links": "Je hebt te veel interne links",
    "You will receive an email when the export is ready.": "Je ontvangt een e-mail wanneer de export klaar is.",
    "Your Users Technology": "De technologie van je gebruikers",
    "Zero links were found": "Er zijn geen links gevonden",
    "Zip code": "Postcode",
    "achieved": "bereikt",
    "affected image": "getroffen afbeelding",
    "and": "en",
    "and does not conform with": "en voldoet niet aan",
    "contact": "contact",
    "contains": "bevat",
    "content": "content",
    "diagnostics_errors.csv": "diagnostics_errors.csv",
    "diagnostics_passed.csv": "diagnostics_passed.csv",
    "disabling": "uitschakelen",
    "document": "document",
    "documents": "documenten",
    "done": "gedaan",
    "enabling": "inschakelen",
    "ends_with": "eindigt met",
    "excluded": "uitgesloten",
    "go to the matched link": "ga naar de overeenkomende link",
    "image": "afbeelding",
    "included": "inbegrepen",
    "insert brand name": "merknaam invoegen",
    "insert context fx. us": "insert context fx. us",
    "insert max word length": "maximale woordlengte invoegen",
    "insert word fx. contact": "insert word fx. contact",
    "is": "is",
    "is_exactly": "is_exactly",
    "language": "taal",
    "link": "link",
    "match (regex)": "match (regex)",
    "metadata": "metadata",
    "milliseconds": "milliseconden",
    "minutes": "minuten",
    "n/a": "nvt",
    "not": "niet",
    "opportunities_errors.csv": "opportunities_errors.csv",
    "opportunities_passed.csv": "opportunities_passed.csv",
    "overall compliance": "algemene naleving",
    "pages": "pagina's",
    "path": "pad",
    "please type": "typ alstublieft",
    "reviewed": "beoordeeld",
    "rows - click to change": "rijen - klik om te wijzigen",
    "search engines overview": "zoekmachines overzicht",
    "should always be followed by": "moet altijd worden gevolgd door",
    "social network overview": "sociaal netwerk overzicht",
    "starts_with": "starts_with",
    "that": "dat",
    "title": "titel",
    "to confirm this action": "om deze actie te bevestigen",
    "to fix": "om te repareren",
    "url": "url",
    "us": "ons",
    "visits": "bezoeken",
    "you have one or more pages that contains links with rel=\\\"nofollow\\\"": "je hebt een of meer pagina's die links bevatten met rel =\\\"nofollow\\\"",
    "{{ pagesDone }} Pages ({{ compliancePercentage }}) in compliance": "{{pagesDone}} Pagina's ({{ compliancePercentage }}) in naleving",
    "{{ totalPageIssues }} Pages ({{ compliancePercentage }}) to fix": "{{ totalPageIssues }} Pagina's ({{ compliancePercentage }}) om te corrigeren",
    "[[label]]: [[value]] Pages": "[[label]]: [[value]] Pagina's",
    "[[label]]: [[value]]ms": "[[label]]: [[value]]ms",
    "[[languageName]] ([[languageCount]])": "[[languageName]] ([[languageCount]])",
    "[[ms]] ms": "[[ms]] ms",
    "[[name]] have already been scanned for compliance. Are you sure you want to scan it again?": "[[name]] zijn al gescand op naleving. Weet je zeker dat je het opnieuw wilt scannen?",
    "[[pageCount]] Pages": "[[pageCount]] Pagina's",
    "[[pageCount]] pages found with this issue": "[[pageCount]] pagina's gevonden met dit probleem",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Niveau A)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Niveau AA)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Niveau AAA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Niveau A)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Niveau AA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Niveau AAA)",
    "1 found": [
      "1 gevonden",
      "[[$count | monNumber]] gevonden"
    ],
    "1 issue found": [
      "1 probleem gevonden",
      "[[$count | monNumber]] problemen gevonden"
    ],
    "1 word found": [
      "1 woord gevonden",
      "[[$count | monNumber]] gevonden woorden"
    ],
    "Total: 1 Performance Page": [
      "Totaal: 1 performance pagina",
      "Totaal: [[$count | monNumber]] Prestatiepagina's"
    ],
    "You have 1 to do": [
      "Je hebt 1 te doen",
      "Je hebt [[issues]] te doen."
    ],
    "page": "pagina",
    "Are you sure you want to remove Custom PageCorrect? <br> Please type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Weet je zeker dat je een aangepaste PageCorrect wilt verwijderen? Typ [[deleteTag]]Verwijderen[[deleteTagEnd]] om de actie te bevestigen",
    "You are about to remove PageCorrect for this check <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Je staat op het punt PageCorrect te verwijderen voor deze controle  Typ [[deleteTag]]Verwijderen[[deleteTagEnd]] om deze actie te bevestigen",
    "You are about to remove PageCorrect for this misspelling <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Je bent bezig met het verwijderen van een PageCorrect correctie voor deze spelfout  Typ [[deleteTag]]Verwijderen[[deleteTagEnd]] om de actie te bevestigen",
    "You are about to remove PageCorrect for this [[type]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Je bent bezig met het verwijderen van PageCorrect voor het type [[type]]  Typ [[deleteTag]]Verwijderen[[deleteTagEnd]] om de actie te bevestigen",
    "You are about to remove [[titleTag]][[title]][[titleTagEnd]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Je bent bezig met het verwijderen [[titleTag]][[title]][[titleTagEnd]] van  Typ [[deleteTag]]Verwijderen[[deleteTagEnd]] om de actie te bevestigen",
    "Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it's place": "<br><strong></strong>Weet je zeker dat je het token voor API-gebruiker [[apiUserId]] wilt intrekkenOpmerking Er wordt in plaats daarvan een nieuw token gemaakt",
    "Maximum critical path latency: <strong>[[latency]] ms </strong>": "<strong></strong>Maximale wachttijd voor kritieke paden: [[latency]] ms ",
    "Are you sure you want to remove <code>all</code> [[type]] PageCorrects? <br> Please type <code>Delete</code> to confirm this action": "<code></code><br><code></code>Weet je zeker dat je alle [[type]] PageCorrects wilt verwijderen?  Typ Verwijderen om deze actie te bevestigen",
    "<strong>[[checkName]]</strong><br><br>Add reason (Optional)": "<strong></strong><br><br>[[checkName]]Reden toevoegen (optioneel)",
    "Are you sure you want to confirm the misspelling <strong>' + word.word + '</strong>?": "<strong></strong>Weet je zeker dat je de spelfout ’ + word.word + ‘wilt bevestigen?",
    "Are you sure you want to delete the policy <strong>[[policyName]]</strong>": "Weet je zeker dat je de policy wilt verwijderen? <strong>[[policyName]]</strong>",
    "Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?": "Weet je zeker dat je de policy als opgelost wilt markeren? <strong>[[policyName]]</strong>",
    "Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>": "<strong></strong>Weet je zeker dat je de Heatmap-regel wilt verwijderen uit [[pageUrl]]",
    "Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?": "<strong></strong>Weet je zeker dat je de regel ’ + rule.name + ‘wilt verwijderen?",
    "Are you sure you want to run the policy <strong>' + policy.name + '</strong>?": "Weet je zeker dat je de policy wilt uitvoeren? <strong>' + policy.name + '</strong>",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong> again?": "Weet je zeker dat je de policy opnieuw wilt uitvoeren? <strong>[[policyName]]</strong>",
    "Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?": "Weet je zeker dat je de policy niet meer wilt negeren? <strong>[[policyName]]</strong>",
    "You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.": "<strong></strong><strong></strong>Je hebt momenteel [[spellingFixes]] spelfoutencorrecties, we raden je aan dit aantal onder [[spellingLimit]] te houden om ervoor te zorgen dat de pagina probleemloos wordt weergegeven.",
    "You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.": "<strong></strong><strong></strong>Je hebt momenteel [[totalFixes]] correcties, we raden je aan om het aantal correcties te beperken tot [[pageFixLimit]] om optimale pagina performance te garanderen, maar dat bepaal je zelf.",
    "[[users]]<strong>and [[userCountLeft]] more</strong>": "<strong></strong>[[users]]en [[userCountLeft]] meer",
    "Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?": "Weet je zeker dat je de policy wilt negeren? <strong>[[policyName]]</strong>",
    "Title:": "Titel:",
    "[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]": "<strong></strong>[[msg]] [[regulationName]] zal ertoe leiden dat de aangepaste [[opposite]] regels voor de volgende problemen worden overschreven, wat betekent dat ze [[negate]] zullen worden gemarkeerd door toekomstige scans: [[list]]",
    "Admin only": "Enkel beheerder",
    "Apply fix": "Fix aanbrengen",
    "Contains high, medium or low opportunities": "Bevat hoge, gemiddelde of lage verbeterpunten",
    "Design": "Ontwerp",
    "Enable Custom PageCorrect Settings": "Schakel custom PageCorrect-instellingen in",
    "Enable PageCorrect features below. Disabled features will not be shown on your dashboard.": "Schakel de PageCorrect-functies hieronder in. Uitgeschakelde functies worden niet op je dashboard weergegeven.",
    "Enable PageCorrect for Accessibility Source Codes": "Schakel PageCorrect in voor toegankelijkheidsbroncodes",
    "Enable PageCorrect for Broken Links": "Schakel PageCorrect in voor gebroken links",
    "Enable PageCorrect for Misspellings": "Schakel PageCorrect in voor spelfouten",
    "Enable PagedCorrect for Accessibility Checks": "Schakel PageCorrect in voor toegankelijkheidscontroles",
    "Failing checks - A": "Onopgeloste controles - A",
    "Failing checks - AA": "Onopgeloste controles - AA",
    "Failing checks - AAA": "Onopgeloste controles - AAA",
    "Good job! Your domain contains no Accessibility Issues for this section": "Goed gedaan! Je domein bevat geen toegankelijkheidsproblemen voor deze sectie",
    "Indicates the difficulty to apply this fix": "Geeft de moeilijkheid aan om deze oplossing toe te passen",
    "List of improvements that can be applied to your website to improve your Accessibility Compliance": "Lijst met verbeterpunten die kunnen worden verwerkt om je naleving van de toegankelijkheid te verbeteren",
    "Manage": "Beheer",
    "Media": "Media",
    "Open PageCorrect Settings": "Open PageCorrect-instellingen",
    "PageCorrect Settings Updated": "PageCorrect-instellingen bijgewerkt",
    "PageCorrect settings": "PageCorrect-instellingen",
    "Pages with Data Privacy violations": "Pagina's met schendingen van de Data Privacy",
    "Should admin be the only one to set PageCorrect Settings": "Moet de beheerder de enige zijn die PageCorrect-instellingen instelt",
    "Website Structure": "Websitestructuur",
    "Data Privacy violations": "Data Privacy overtredingen",
    "Heartbeat check": "Heartbeat check",
    "Request PDF accessibility check from selection": "Vraag PDF-toegankelijkheidscontrole aan bij selectie",
    "Total unique downloads": "Totaal aantal unieke downloads",
    "[[succeededPdfs]] out of [[pdfs]] PDF accessibility request succeeded": "[[successedPdfs]] van [[pdfs]] PDF-toegankelijkheidsverzoek is geslaagd",
    "Accessibility Issues": "Toegankelijkheidsproblemen",
    "Inspecting:": "Inspectie:",
    "Pages with Accessibility Issues": "Pagina's met toegankelijkheidsproblemen",
    "Start advance export": "Begin met exporteren",
    "Check whether your website is responding and measures the response times of the server": "Check of je website reageert en meet de responstijden van de server",
    "Search label": "Zoeklabel",
    "Custom range": "Aangepast bereik",
    "Last Half Year": "Afgelopen half jaar",
    "Last Month": "Afgelopen maand",
    "Last Quarter": "Afgelopen kwartaal",
    "Last Week": "Afgelopen week",
    "Last Year": "Afgelopen jaar",
    "Character": [
      "Teken",
      "Tekens"
    ],
    "Image missing alt attribute": "Alt-attribuut afbeelding ontbreekt",
    "Quick info here": "Snelle info hier",
    "There is 1 META description on this page": "Er is 1 META beschrijving op deze pagina",
    "There is 1 internal link on this page": [
      "Er is 1 interne link op deze pagina",
      "Er zijn [[$count | monNumber]] interne links op deze pagina"
    ],
    "There is one META description on this page": [
      "Er is één META beschrijving op deze pagina",
      "META beschrijvingen op deze pagina"
    ],
    "and 1 document": {
      "Documents with broken images": [
        "en 1 document",
        " en [[$count | monNumber]] documenten"
      ],
      "Documents with confirmed misspellings": [
        "en 1 document",
        "en [[$count | monNumber]] documenten"
      ],
      "Documents with potential misspellings": [
        "en 1 document",
        "en [[$count | monNumber]] documenten"
      ]
    },
    "and one document": {
      "Pages with broken links": [
        "en één document",
        "en [[$count | monNumber]] documenten"
      ]
    },
    "Remediation": "Herstel",
    "Remediation quote": "Herstelofferte",
    "Remediation quote has been requested": "Herstelofferte is aangevraagd",
    "Sort by": {
      "Exchange center filter option": "Sorteer op"
    },
    "#idname.class-name1.class-name2": "#idname.class-name1.class-name2",
    "&lt;i&gt; tags as icons": "&lt;i&gt; tags als pictogrammen",
    ".class-name1": ".class-name1",
    "<strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)": "<strong></strong>CSS-styling voor &lt;strong&gt; tag (zet alle sterke tekst rood)",
    "<strong>NOTE</strong>: Changing the text below, will override the text in all your included languages": "<strong></strong>OPMERKING: als je de onderstaande tekst wijzigt, wordt de tekst in al je opgenomen talen overschreven",
    "A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations": "Er is een nieuwere versie van PageAssist beschikbaar. Schakel over naar versie 2.0 om toegang te krijgen tot nieuwe aanpassingen",
    "Accessibility Fixes": "Toegankelijkheidsoplossingen",
    "Add Policy": "Policy toevoegen",
    "Add a description of the widget to your users": "Voeg een beschrijving van de widget toe aan je gebruikers",
    "Add comment (Optional)": "Comment toevoegen (optioneel)",
    "Add row": "Rij toevoegen",
    "Add text for when the button is hovered": "Voeg tekst toe voor wanneer over de knop wordt bewogen",
    "Add title": "Voeg titel toe",
    "Africa": "Afrika",
    "All <code>img</code> elements have an <code>alt</code> attribute": "<code></code><code></code>Alle img elementen hebben een alt attribuut",
    "Alt text does not convey the same information as the image": "Alt-tekst geeft niet dezelfde informatie als de afbeelding",
    "Alt text for all <code>img</code> elements contains all text in the image unless the image text is decorative or appears elsewhere in the document": "<code></code>Alt-tekst voor alle img elementen bevat alle tekst in de afbeelding, tenzij de afbeeldingstekst decoratief is of elders in het document voorkomt",
    "Alt text for all <code>img</code> elements is not placeholder text unless author has confirmed it is correct": "<code></code>Alt-tekst voor alle img elementen is geen tijdelijke aanduiding voor tekst, tenzij de auteur heeft bevestigd dat deze correct is",
    "Alt text for all <code>img</code> elements is the empty string (\\\"\\\") if the image is decorative.": "<code></code>Alt-tekst voor alle img elementen is de lege tekenreeks (\\\"\\\") als de afbeelding decoratief is.",
    "Alt text for all <code>img</code> elements used as source anchors is not empty when there is no other text in the anchor": "<code></code>Alt-tekst voor alle img elementen die als bronankers worden gebruikt, is niet leeg als er geen andere tekst in het anker staat",
    "Alt text is not the same as the filename unless author has confirmed it is correct": "Alt-tekst is niet hetzelfde als de bestandsnaam, tenzij de auteur heeft bevestigd dat deze correct is",
    "And how are we going to fix it?": "En hoe gaan we het repareren?",
    "Applying fix": "Fix aanbrengen",
    "Are you sure you want to stop receiving this report?": "Weet je zeker dat je dit rapport niet meer wilt ontvangen?",
    "Aria-label": "Aria-label",
    "Asia": "Azië",
    "Blink sample image": "Knipperende voorbeeldafbeelding",
    "Blink testing sample image": "Knipperende testvoorbeeldafbeelding",
    "Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.": "Beide problemen kunnen in de praktijk leiden tot meerdere visuele problemen, van verkeerde kleuren tot lastige ruimtes waar er geen zou mogen bestaan.",
    "Bottom center": "Middenonder",
    "Bottom left": "Linksonder",
    "Bottom right": "Rechtsonder",
    "Browse": "Bladeren",
    "Button hover message": "Knop zweefbericht",
    "CSS selector": "CSS-kiezer",
    "Change <b> tags to a custom element": "Wijzig <b> tags naar een custom element",
    "Change <b> tags to a custom tag": "Wijzig <b> tags naar een custom tag",
    "Change <blink> tags to a custom element": "Wijzig <blink> tags naar een custom element",
    "Change <blink> tags to a custom tag": "Wijzig <blink> tags naar een custom tag",
    "Change <marquee> tags to a custom element": "Wijzig <marquee> tags naar een custom element",
    "Change <marquee> tags to a custom tag": "Wijzig <marquee> tags naar een custom tag",
    "Change your &lt;blink&gt; tags into something else": "Wijzig je &lt;blink&gt; tags naar iets anders",
    "Change your &lt;i&gt; elements into something else": "Wijzig je &lt;i&gt; elementen naar iets anders",
    "Change your &lt;marquee&gt; tags into something else": "Wijzig je &lt;marquee&gt; tags naar iets anders",
    "Check for misspelling company name: [[company]]": "Check op verkeerd gespelde bedrijfsnaam: [[company]]",
    "Choose a tag to replace your b tags with": "Kies een tag om je b-tags mee te vervangen",
    "Choose a tag to replace your blink tags with": "Kies een tag om je blink-tags mee te vervangen",
    "Choose a tag to replace your italic tags with": "Kies een tag om je cursieve tags mee te vervangen",
    "Choose a tag to replace your marquee tags with": "Kies een tag om je marquee-tags mee te vervangen",
    "Choose an icon": "Kies een icoon",
    "Choose this option to customise the fix": "Kies deze optie om de fix aan te passen",
    "Choose this option to customize the fix": "Kies deze optie om de fix aan te passen",
    "Choose your own text for the warning pop-up": "Kies je eigen tekst voor de waarschuwingspop-up",
    "Circle": "Cirkel",
    "Class": "Klasse",
    "Close PageCorrect form": "Sluit het PageCorrect-formulier",
    "Close [[groupName]]: [[labelName]]": "Sluit [[groupName]]: [[labelName]]",
    "Company name *": "Bedrijfsnaam *",
    "Constraint:": "Beperking:",
    "Custom settings": "Aangepaste instellingen",
    "Default fix": "Standaard fix",
    "Default language": "Standaardtaal",
    "Dutch": "Nederlands",
    "Edit Report": "Rapport bewerken",
    "Education": "Onderwijs",
    "Element name is invalid": "Elementnaam is ongeldig",
    "Element name should not contain spaces": "Elementnaam mag geen spaties bevatten",
    "Enter aria-label name": "Voer de naam van het aria-label in",
    "Enter class name": "Voer de naam van de klasse in",
    "Enter role name": "Voer de rolnaam in",
    "Europe": "Europa",
    "Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:": "Hoewel dit een vrij eenvoudige oplossing is, zijn er twee manieren waarop dit design-problemen op je website kan veroorzaken:",
    "Example 1": "Voorbeeld 1",
    "Example 2": "Voorbeeld 2",
    "File must be below 1MB": "Het bestand moet kleiner zijn dan 1 MB",
    "Filter dropdown": "Filter vervolgkeuzelijst",
    "Finance": "Financiën",
    "Fix applied!": "Fix toegepast!",
    "Fix options": "Fix opties",
    "French": "Frans",
    "Give a title to your Skip to Content button": "Geef een titel aan je knop skip to content",
    "Government": "Regering",
    "Grid view": "Rasterweergave",
    "Hide": "Verbergen",
    "Hide text": "Verberg tekst",
    "Hitting the tab button will turn on Skip to PageAssist": "Als je op de tab-knop drukt, wordt skip to PageAssist ingeschakeld",
    "How are we going to fix it?": "Hoe gaan we het repareren?",
    "Icon shape": "Icoon vorm",
    "Image Alt text is short": "Alt-tekst van afbeelding is kort",
    "Important images should not have spacer Alt text": "Belangrijke afbeeldingen mogen geen lege Alt-tekst hebben",
    "Info": "Info",
    "Insert company name": "Voer de bedrijfsnaam in",
    "Instead of &lt;i&gt; choose a different element name to be used instead": "Kies in plaats van &lt;i&gt; een andere elementnaam om in plaats daarvan te gebruiken",
    "It will take some time before our system will register your changes to PageCorrect": "Het zal enige tijd duren voordat ons systeem je wijzigingen in PageCorrect registreert",
    "Left middle": "Links midden",
    "Letter case *": "Hoofdletter of kleine letter *",
    "Light": "Licht",
    "Link excludes:": "Link is exclusief:",
    "Loading PageFix": "PageFix laden",
    "Make sure you use correct formatting and add multiple selectors when your page design differs": "Zorg ervoor dat je de juiste opmaak gebruikt en voeg meerdere selectors toe wanneer je pagina-ontwerp verschilt",
    "Manage options": "Beheer opties",
    "Marquee sample image": "Marquee voorbeeldafbeelding",
    "Marquee testing sample image": "Marquee testen voorbeeldafbeelding",
    "Menu theme": "Menu thema",
    "New Window Information": "Nieuw venster informatie",
    "New Window Test": "Nieuwe venster test",
    "Non-Decorative images must have Alt text": "Niet-decoratieve afbeeldingen moeten alt-tekst bevatten",
    "North America": "Noord-Amerika",
    "PageAssist Logo": "PageAssist logo",
    "PageAssist position on Page": "Positie PageAssist op pagina",
    "Portuguese": "Portugees",
    "Potential problems that can arise": "Mogelijke problemen die kunnen optreden",
    "Press 'Upload link' to save your URL settings": "Druk op 'Upload link' om je URL-instellingen op te slaan",
    "Preview": "Voorbeeld",
    "Proper Case": "Elk Woord Hoofletter",
    "Remove input selector": "Verwijder input selecteer",
    "Remove logo upload": "Logo-upload verwijderen",
    "Remove row": "Rij verwijderen",
    "Repair Tip": "Reparatie Tip",
    "Repair options": "Reparatie-opties",
    "Replace Italic element with EM": "Vervang cursief element door EM",
    "Replace all &lt;b&gt; tags with": "Vervang alle &lt;b&gt; tags met",
    "Replace all &lt;blink&gt; tags with": "Vervang alle &lt;blink&gt; tags met",
    "Replace all &lt;i&gt; tags": "Vervang alle &lt;i&gt; tags",
    "Replace all &lt;marquee&gt; tags with": "Vervang alle &lt;marquee&gt; tags met",
    "Report Center Image": "Rapportcentrum afbeelding",
    "Reset Input": "Reset Input",
    "Reset Skip to content text to its default": "Reset skip to content tekst naar de standaard",
    "Reset design": "Reset ontwerp",
    "Reset to default": "Reset naar standaard",
    "Restore": "Herstellen",
    "Restore profile?": "Profiel herstellen?",
    "Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.": "<strong></strong>Als je dit profiel ([[profileName]]) herstelt, wordt het beschikbaar in je modules.",
    "Right middle": "Rechts midden",
    "Rounded Box": "Ronde Box",
    "Russian": "Russisch",
    "Show": "Tonen",
    "Show details": "Toon details",
    "Show text": "Toon tekst",
    "Simplified Chinese": "Vereenvoudigd Chinees",
    "Skip to Content": "Skip to Content",
    "Snippet reset": "Snippet reset",
    "Someone have created this PageCorrect before you, on another check.": "Iemand heeft deze PageCorrect eerder gemaakt dan jij, bij een andere controle.",
    "Spanish Mexican": "Spaans Mexicaans",
    "Start export inventory emails": "Begin met het exporteren van inventaris e-mails",
    "Start export inventory emails extended": "Begin met het exporteren van inventaris e-mails uitgebreid",
    "Testing": "Testen",
    "The subpath/subfolder the WordPress installation is under": "Het subpad/submap waar de WordPress-installatie zich onder bevindt",
    "This fix requires development knowledge": "Deze oplossing vereist programmeerkennis",
    "This message will be displayed when the user hovers over the PageAssist button": "Dit bericht wordt weergegeven wanneer de gebruiker met de muis over de PageAssist-knop beweegt",
    "This option might cause problems to your icons": "Deze optie kan problemen met je pictogrammen veroorzaken",
    "Title Text": "Titel tekst",
    "To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check": "Om deze policy in te stellen, moet je ons de bedrijfsnaam en het mogelijk verkeerd gespelde hoofdlettertype dat je wilt controleren, doorgeven",
    "Top center": "Midden boven",
    "Top left": "Linksboven",
    "Top right": "Rechtsboven",
    "Trying out the pop-up": "Probeer de pop-up uit",
    "UPPERCASE": "HOOFDLETTERS",
    "Undo check review": "Controle beoordelen ongedaan maken",
    "Upload link": "Upload link",
    "Upload logo": "Upload logo",
    "Use Datepicker": "Gebruik datumkiezer",
    "Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>": "<code></code>Gebruik PageCorrect om de volgende spelfout te corrigeren:[[misspelling]]",
    "Use PageCorrect to fix Broken Link": "Gebruik PageCorrect om gebroken link te herstellen",
    "Use PageCorrect to fix these image sources": "Gebruik PageCorrect om deze afbeeldingsbronnen te corrigeren",
    "Value:": "Waarde:",
    "View": "Weergave",
    "What is wrong with the &lt;b&gt; (bold) element?": "Wat is er mis met het &lt;b&gt; (vetgedrukt) element?",
    "What is wrong with the &lt;i&gt; (italic) element?": "Wat is er mis met het &lt;i&gt; (cursief) element?",
    "What to do when the link doesn't work?": "Wat te doen als de link niet werkt?",
    "What to do when things look wrong?": "Wat te doen als dingen er niet goed uitzien?",
    "Why shouldn't I use the blink element?": "Waarom zou ik het blink-element niet gebruiken?",
    "Widget Design and Text": "Widgetontwerp en tekst",
    "Widget Icon Setup": "Widget-pictogram instellen",
    "Without any assigned class": "Zonder enige toegewezen klasse",
    "Write a warning to your outbound link": "Schrijf een waarschuwing naar je uitgaande link",
    "Write custom tag": "Schrijf een eigen tag",
    "lowercase": "kleine letters",
    "with": "met",
    "with &lt;em&gt;": "met &lt;em&gt;",
    "Statistics is using sample data": "Statistieken gebruiken voorbeeldgegevens",
    "Statistics results are sample data for demo purposes - export is disabled": "Resultaat van statistieken bestaat uit voorbeeldgegevens voor demonstratiedoeleinden - exporteren is uitgeschakeld",
    "This section is using sample data": "Dit gedeelte gebruikt voorbeeldgegevens",
    "&lt;i&gt; tags with these attribute values will not be changed": "&lt;i&gt; tags met deze attribuutwaardes worden niet gewijzigd",
    "(Bad)": "(Slecht)",
    "(Good)": "(Goed)",
    "<span class=\\\"mr-2\\\">Pages</span>": "Pagina’s",
    "Add API user": "API-gebruiker toevoegen",
    "Add attributes to be excluded in this change": "Voeg attributen toe die in deze wijziging moeten worden uitgesloten",
    "Add profile": "Profiel toevoegen",
    "Add source code exclude": "Broncode uitsluiten toevoegen",
    "Are you sure?": "Weet je het zeker?",
    "Button hover color": "Kleur van knop bij bewegen muisaanwijzer",
    "Calculated by no. and severity of issues, page views and links leading to this page..": "Berekend op aantal en ernst van problemen, paginaweergaven en links die naar deze pagina verwijzen..",
    "Choose minimum word count for a page to be included in the readability test": "Kies een minimaal aantal woorden per pagina voor deze wordt opgenomen in de leesbaarheidstest",
    "Color contrast ratio": "Kleurcontrastverhouding",
    "Content id tag": "Content id tag",
    "Creation date": "Aanmaakdatum",
    "Custom text": "Aangepaste tekst",
    "Customise the Information page": "Pas de Informatiepagina aan",
    "Disable": "Uitschakelen",
    "Docs without downloads": "Documenten zonder downloads",
    "Documents Without Downloads": "Documenten Zonder Downloads",
    "EPI Server Path": "EPI Serverpad",
    "EPIServer": "EPIServer",
    "Editor": "Editor",
    "Ex: data-currentpage, or data-pageid, or CurrentPageLink": "Bijv: data-currentpage of data-pageid of CurrentPageLink",
    "Ex: lang or CurrentPageLanguage": "Bijv: lang of CurrentPageLanguage",
    "Export both pages and documents": "Exporteer pagina’s en documenten",
    "Export only documents without downloads": "Exporteer alleen documenten zonder downloads",
    "Export only html pages without visits": "Exporteer alleen html-pagina’s zonder bezoeken",
    "Include Accessibility Statement": "Verklaring Toegankelijkheid invoegen",
    "Include custom info text": "Aangepaste infotekst invoegen",
    "Includes a button with a link to your accessibility statement": "Bevat een knop met een link naar je toegankelijkheidsverklaring",
    "Indicates which language this page will be scanned in. Click underneath to change": "Geeft aan in welke taal deze pagina gescand wordt. Klik hieronder om te wijzigen",
    "Insert a valid URL": "Voer een geldige URL in",
    "Language tag": "Taal-tag",
    "Last assigned profile on page. Page will be removed from Performance": "Laatst toegewezen profiel op pagina. Pagina wordt verwijderd uit Performance",
    "Link color": "Kleur link",
    "Link opens in a new tab": "Link opent in een nieuw tabblad",
    "Main color": "Hoofdkleur",
    "Meta name": "Meta naam",
    "Mode": "Mode",
    "No default profile selected for this page, scoring not available.": "Geen standaardprofiel geselecteerd voor deze pagina, scores niet beschikbaar.",
    "No documents found": "Geen documenten gevonden",
    "No profiles selected for this page, scoring not available.": "Geen profielen geselecteerd voor deze pagina, scores niet beschikbaar.",
    "Not a valid CSS selector": "Geen geldige CSS selector",
    "Notification when the downtime ends": "Notificatie wanneer de downtime beëindigt",
    "Number of external links": "Aantal externe links",
    "Number of incoming links": "Aantal inkomende links",
    "Open details": "Open details",
    "PDF Accessibility": "PDF Toegankelijkheid",
    "Passwords do not match": "Wachtwoorden komen niet overeen",
    "Please add a Default Profile to your Page": "Voeg een standaardprofiel toe aan je Pagina",
    "Please add a Profile to your Page": "Voeg een profiel toe aan je Pagina",
    "Please enter a valid color code": "Voer een geldige kleurcode in",
    "Please perform a PDF scan to see the results for the checks below": "Voer een PDF-scan uit om de resultaten van onderstaande controles te zien",
    "Setup": "Instellingen",
    "Show less of the code snippet": "Toon minder van het code snippet",
    "Show the full code snippet": "Toon het volledige code snippet",
    "Statistics not activated. Page Views not available.": "Statistieken niet geactiveerd. Paginaweergaven niet beschikbaar.",
    "Subdomain": "Subdomein",
    "Subdomain url": "Subdomein url",
    "Superfast - Don't use unless you know what you're doing": "Supersnel - Gebruik dit enkel als je zeker weet hoe het werkt",
    "Text color": "Kleur tekst",
    "The optional epi server path": "Het optionele epi serverpad",
    "The subdomain url to the CMS page": "De subdomein url naar de CMS-pagina",
    "This text must be under 1000 characters": "Deze tekst moet uit minder dan 1000 tekens bestaan",
    "Two-Factor Authentication": "Two-Factor Authentication",
    "Two-factor authentication is currently disabled": "Two-Factor Authentication is momenteel uitgeschakeld",
    "Two-factor authentication is currently enabled": "Two-Factor Authentication is momenteel ingeschakeld",
    "URL needs to be valid, include http:// or https:// and be under 100 characters": "URL moet geldig zijn, inclusief http:// of https:// en uit minder dan 100 tekens bestaan",
    "URL template": "URL-sjabloon",
    "Unique broken links": "Unieke gebroken links",
    "Very fast - Be Cautious": "Zeer snel - Wees voorzichtig",
    "WCAG 2.0": "WCAG 2.0",
    "WCAG 2.1": "WCAG 2.1",
    "Your color contrast is below the recommended score": "Je kleurcontrast is lager dan de aanbevolen score",
    "labels": "Labels",
    "Acceptance Rate": "Acceptatiegraad",
    "Acceptance Rate Over Time": "Acceptatiegraad in de loop van de tijd",
    "Acceptance Rate by Category": "Acceptatiegraad per categorie",
    "Accepted cookies": "Geaccepteerde cookies",
    "Add callback functions boilerplate": "Standaard callback-functies toevoegen",
    "Add cookie": "Cookie toevoegen",
    "Add empty EventListeners": "Lege EventListeners toevoegen",
    "Add empty callbacks": "Lege callbacks toevoegen",
    "Add event listeners boilerplate": "Standaard event listeners toevoegen",
    "Add web overlay lock": "Web overlay lock toevoegen",
    "Alternative": "Alternatief",
    "An overview of your customer's behavior with cookies on your website": "Een overzicht van het gedrag van je klanten met geaccepteerde cookies op je website",
    "Are you sure you want to ignore all selected misspellings?": "Weet je zeker dat je alle geselecteerde spelfouten wilt negeren?",
    "Are you sure you want to mark this check as fixed on all pages?": "Weet je zeker dat je deze controle als opgelost wilt markeren op alle pagina’s?",
    "Are you sure you want to mark this check as fixed?": "Weet je zeker dat je deze controle als opgelost wilt markeren?",
    "Are you sure you want to mark this misspelling as fixed?": "Weet je zeker dat je deze spelfout als opgelost wilt markeren?",
    "Are you sure you want to mark this misspelling(s) as fixed?": "Weet je zeker dat je deze spelfout(en) als opgelost wilt markeren?",
    "Basic": "Basis",
    "Button color": "Kleur knop",
    "Button text color": "Kleur knoptekst",
    "Case sensitive URLs": "Hoofdlettergevoelige url’s",
    "Changes wording from only essential cookies to explicit reject": "Wijzigt de bewoording van enkel acceptatie van essentiële cookies naar concrete weigering van cookies",
    "Consent Log": "Consent Log",
    "Consent Overview": "Consent Overzicht",
    "Consent results are sample data for demo purposes": "Resultaten van acceptatiegraad bestaan vanwege demonstratiedoeleinden uit voorbeeldgegevens",
    "Cookie Acceptance Rate": "Cookie Acceptatiegraad",
    "Cookie Overview": "Overzicht Cookies",
    "Cookie description": "Cookie omschrijving",
    "Cookie duration": "Cookie duur",
    "Cookie name": "Cookie naam",
    "Enter a valid CSS selector": "Voer een geldige CSS-selector in",
    "Essential": "Essentieel",
    "Example 3": "Voorbeeld 3",
    "Example 4": "Voorbeeld 4",
    "Explicit reject option": "Optie om concreet te weigeren",
    "Give a short description of the purpose of the cookie": "Geef een korte omschrijving over het doel van de cookie",
    "Give users more control over which categories of cookies to consent to": "Geef gebruikers meer controle over welke categorieën van cookies ze toestemming kunnen geven",
    "How long is the cookie active": "Hoe lang is de cookie actief",
    "IP Address": "IP-adres",
    "Ignore canonical URLs": "Negeer canonical url’s",
    "Ignored by": "Genegeerd door",
    "Ignored date": "Datum genegeerd",
    "Ignored misspellings on account": "Genegeerde spelfouten op account",
    "Include cookies": "Inclusief cookies",
    "Insert CSS class or id selector": "Voer CSS-class of id selector in",
    "Insert a CSS selector": "Voer een CSS-selector in",
    "Limit or exclude": "Beperken of uitsluiten",
    "Limit search": "Beperk zoeken",
    "Link to your opt out page": "Link naar je opt-out pagina",
    "Make sure you use the correct setting": "Zorg dat je de juiste instelling gebruikt",
    "Mark check as fixed": "Controle markeren als opgelost",
    "Marketing": "Marketing",
    "No cookies found": "Geen cookies gevonden",
    "No misspellings have been ignored": "Er zijn geen spelfouten genegeerd",
    "Opt out link": "Opt-out link",
    "Original": "Origineel",
    "Other": "Andere",
    "Overall Acceptance Rate": "Algehele Acceptatiegraad",
    "Overall acceptance rate": "Algehele acceptatiegraad",
    "Per category consent": "Consent per categorie",
    "Please wait - Marking as fixed": "Even wachten - Bezig met markeren als opgelost",
    "Please wait - Marking word as fixed": "Even wachten - Bezig met woord markeren als opgelost",
    "Preferences": "Voorkeuren",
    "Privacy regulation": "Privacyregelgeving",
    "Remove cookie": "Cookie verwijderen",
    "Remove from Ignored": "Verwijderen uit genegeerd",
    "Remove this word from Ignored Misspellings": "Verwijder dit woord uit de genegeerde spelfouten",
    "URL Structure": "URL-structuur",
    "Domain Overview": {
      "Topmenu": "Domeinoverzicht",
      "$$noContext": "Domeinoverzicht"
    },
    "Admin Settings": "Beheerinstellingen",
    "Case sensitivity": "Hoofdlettergevoeligheid",
    "Close project search and domain picker": "Sluit projectzoeker en domeinkiezer",
    "Domain Settings": "Domeininstellingen",
    "In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.": "Uiteindelijk zien beide &lt;i&gt; en &lt;em&gt; tags er visueel hetzelfde uit. Ze hebben echter elk een andere semantische betekenis. &lt;em&gt; wordt gebruikt om nadruk te leggen, terwijl &lt;i&gt; tag staat voor een woord of een zin die de gebruiker mogelijk cursief wil zetten (een buitenlands woord, definitie van een woord enz.). In dat laatste gevoel moet in plaats daarvan CSS worden gebruikt.",
    "Paste your image link (URL) here": "Plak hier je afbeeldingslink (URL)",
    "Set up your domain": "Stel je domein in",
    "The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.": "Het grootste probleem met deze oplossing kan optreden als de &lt;i&gt; tag wordt gebruikt voor pictogrammen in plaats van bijvoorbeeld &lt;span&gt; (voorbeeld: Font Awesome). Als je merkt dat er iets mis is met je pictogrammen nadat je de correctie hebt toegepast, kan dit de reden zijn. Echter, &lt;i&gt; tags voor pictogrammen gebruiken meestal een klasse, dus zorg ervoor dat je de opties hebt ingesteld om alleen de tags te wijzigen zonder de klassen te wijzigen. Op die manier zouden je pictogrammen onveranderd moeten blijven.",
    "The profile <strong>[[profileName]]</strong> is being used on the following pages below:": "<strong></strong>Het profiel [[profileName]] wordt gebruikt op de volgende pagina's hieronder:",
    "Add icon border": "Pictogram rand toevoegen",
    "Adds a 3px wide border to the PageAssist widget icon": "Voegt een rand van 3px breed toe aan het PageAssist widget-pictogram",
    "Bottom": "Onder",
    "Clear search": "Zoekopdracht wissen",
    "Ensures that PageAssist is never overlapped by other elements on the page": "Zorgt dat PageAssist nooit overlapt wordt door andere elementen op de pagina",
    "Estonian": "Ests",
    "German": "Duits",
    "Go to overlay with details": "Ga naar overlay met details",
    "Guidelines for WCAG 2.2": "WCAG 2.2 richtlijnen",
    "Heartbeat Overview": "Heartbeat overzicht",
    "How far the button is from the edge. Customization dependant on position.": "Hoe ver de knop van de rand is. Aanpasbaarheid afhankelijk van positie.",
    "Insert a valid host name": "Voer een geldige hostnaam in",
    "Keep PageAssist on top": "Houd PageAssist bovenaan",
    "Left": "Links",
    "Margin from edge in pixels": "Marge van rand in pixels",
    "Norwegian Bokmål": "Noorse Bokmål",
    "Norwegian Nynorsk": "Noorse Nynorsk",
    "Right": "Rechts",
    "Social Media visits": "Sociale Media bezoeken",
    "Social media visits": "Sociale media bezoeken",
    "Sort column": "Kolom sorteren",
    "Sort column ascending": "Kolom oplopend sorteren",
    "Sort column descending": "Kolom aflopend sorteren",
    "Subgroup": "Subgroep",
    "Swedish": "Zweeds",
    "Toggle label text": "Toggle kabeltekst",
    "Top": "Boven",
    "Unique misspellings": "Unieke spelfouten",
    "Unique misspellings found": "Unieke spelfouten gevonden",
    "WCAG 2.2 Accessibility Compliance": "WCAG 2.2 Naleving Toegankelijkheid",
    "Area dynamic page": "Area dynamic page",
    "Employeepage": "Werknemerspagina",
    "Language id": "Taal-id",
    "Newspage": "Nieuwspagina",
    "Standard": "Standaard",
    "Standard for http(s)://edit.domain.tld/inz/<path>. Alternative for http(s)://domain.tld/<path>/edit.": "Standaard voor http(s)://edit.domain.tld/inz/<path>. Alternatief voor http(s)://domain.tld/<path>/edit.",
    "URL format": "URL-formaat",
    "Export both internal and external links": "Exporteer zowel interne als externe links",
    "Export only external links": "Exporteer alleen externe links",
    "Export only internal links": "Exporteer alleen interne links",
    "Overview of all the enabled modules for this domain": "Overzicht van alle ingeschakelde modules voor dit domein",
    "Search for a predefined policy in the Policy Exchange Center": "Zoek naar vooraf gedefinieerde policy in het policy centrum",
    "A log of all the consents given by your website visitors": "Een logbestand van website bezoekers die cookie toestemmingen hebben gegeven",
    "Action required. Click to resolve issue.": "Actie nodig. Klik om het probleem op te lossen.",
    "Complete": "Compleet",
    "Cookie Overview buttons": "Cookie Overzicht knoppen",
    "Cookie Overview saved": "Cookie Overzicht opgeslagen",
    "Cookie added by user": "Cookie toegevoegd door gebruiker",
    "Cookie domain": "Cookie domein",
    "Cookie not found": "Cookie niet gevonden",
    "Cookie not published. Missing:": "Cookie niet gepubliceerd. Ontbreekt:",
    "Could not save invalid form": "Kon ongeldig formulier niet opslaan",
    "Disables interactions on website until the visitor makes a consent choice. Be aware that locking interactions prior to consent may not be compliant with certain regional privacy regulations.": "Schakelt interacties op de website uit tot de bezoeker een besluit maak van toestemming voor cookies. Let op dat het vastleggen van interacties vóór toestemming misschien niet voldoen aan bepaalde regionale privacy regels.",
    "Finish the setup by adding your cookies": "Rond de installatie af door je cookies toe te voegen",
    "For Cookie setup please go to your <b>Data Privacy</b> module.<br> Manual cookies can be set up or edited any time and are not related to script setup.": "<b></b><br>Voor het instellen van Cookies ga je naar de module Data Privacy. Handmatige cookies kunnen op elk moment ingesteld of bewerkt worden en staan niet in verband met het installatiescript.",
    "GDPR requires that companies provide descriptions on their website for all cookies that are used.": "GDPR vereist dat bedrijven op hun website omschrijvingen hebben van alle cookies die worden gebruikt.",
    "Give an overview of the cookies used on your website. Finish a domain scan or add them manually.": "Geef een overzicht van de cookies die op je website worden gebruikt. Rond een domeinscan af of voeg ze handmatig toe.",
    "Id": "Id",
    "Include a link to your webpage's privacy policy": "Voeg een link toe naar het privacybeleid van je website",
    "It looks like the previously set up cookie was not found in this scan. It might be that the cookie was removed or our scan just couldn’t detect it.": "Het lijkt erop dat de eerder ingestelde cookie niet is gevonden in deze scan. Het kan zijn dat de cookie is verwijderd of dat onze scan het niet kon detecteren.",
    "I’ll do it later": "Ik doe het later",
    "Keep": "Behouden",
    "Leave without saving": "Doorgaan zonder op te slaan",
    "Link to Privacy Policy": "Link naar Privacybeleid",
    "Link to your Cookie Overview": "Link naar je cookie overzicht",
    "Link to your Privacy Policy": "Link naar je Privacybeleid",
    "Link where customers can opt out of sale of personal data. Mandatory for websites under the CCPA regulation.": "Link waar klanten zich kunnen afmelden van het verkopen van persoonlijke gegevens. Verplicht voor websites om te voldoen aan de CCPA-policy.",
    "List of checks with and without issues categorized by [[level]] guidelines": "Lijst met controles met en zonder problemen gecategoriseerd volgens [[level]] richtlijnen",
    "Manage Cookie": "Beheer Cookie",
    "On-demand scan unavailable": "Handmatige scan niet beschikbaar",
    "Pages needing to be fixed": "Pagina’s die moeten worden gerepareerd",
    "Save cookies": "Cookies opslaan",
    "Save existing cookies": "Bestaande cookies opslaan",
    "Save this overview to publish completed cookies to the Cookie Overview.": "Sla dit overzicht op om voltooide cookies te publiceren naar het cookie overzicht.",
    "Save your page before leaving to keep your progress and publish the completed cookies.": "Sla je pagina op voordat je deze verlaat om je voorgang te bewaren en de voltooide cookies te publiceren.",
    "Scan History": "Scan historie",
    "Scan Information": "Scan informatie",
    "Scan info": "Scan info",
    "Source": "Bron",
    "This feature is not available on a demo account.": "Op een demo-account is deze functie niet beschikbaar.",
    "This page has been rescanned since the latest full scan.": "Sinds de laatste volledige scan is deze pagina opnieuw gescand.",
    "This scan feature is not available on a demo account": "Op een demo-account is deze scanfunctie niet beschikbaar",
    "UUID": "UUID",
    "You need to include a name in order to save your cookies.": "Je moet een naam toevoegen om cookies op te slaan.",
    "[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.": "[[total]] pagina’s. Prioriteer en fix alle problemen met content op je website vanuit een samengevoegde weergave.",
    "Distribution of policies with matches across priority levels": "Verdeling van policies met overeenkomsten over prioriteitsniveaus",
    "Copied!": "Gekopieerd!",
    "Copy": "Kopiëren",
    "Default language*": "Standaardtaal*",
    "Don't forget to copy and update the script on your website!": "Vergeet niet het script op je website te kopiëren en bij te werken!",
    "Included languages*": "Inbegrepen talen*",
    "Loading Data": "Gegevens laden",
    "Loading...": "Laden…",
    "No support": "Geen support",
    "Open PageAssist script settings": "Open PageAssist script instellingen",
    "PageAssist script settings": "PageAssist script instellingen",
    "Please add the script as close to the open HEAD-tag as possible": "Voeg het script zo dicht mogelijk bij de open HEAD-tag toe",
    "Please wait - loading": "Even geduld - laden",
    "Press Ctrl-C": "Druk op Ctrl-C",
    "Press ⌘-C": "Druk op ⌘-C",
    "This chart shows how many percent of visitors accepted the various categories of cookies on your website. Visitors who did not make a consent choice on the cookie banner are not counted": "Deze grafiek toont hoeveel procent van de bezoekers de verschillende categorieën cookies op je website accepteerden. Bezoekers die geen toestemmingskeuze maakten op de cookie banner worden niet meegeteld",
    "Visitor percentage": "Bezoekerspercentage",
    "Consent Manager script settings": "Instellingen voor het Consent Manager script",
    "Open consent manager script settings": "Open Consent Manager script instellingen",
    "Scan your website for any data privacy issues that could be present": "Scan je website op mogelijke problemen met Data Privacy",
    "Please enter a full UUID string. Empty or partial strings will not yield any results.": "Voer een volledige UUID string in. Lege of gedeeltelijke strings leveren geen resultaten op.",
    "UUID can only be searched by entering the full value": "UUID kan alleen gezocht worden door de volledige waarde in te voeren",
    "Average Cumulative Layout Shift": "Gemiddelde Cumulative Layout Shift",
    "Average Largest Contentful Paint": "Gemiddelde Largest Contentful Paint",
    "Average Speed Index": "Gemiddelde Speed Index",
    "Average Total Blocking Time": "Gemiddelde Total Blocking Time",
    "CMS Path": "CMS Path",
    "Click here or drag a rule to this area": "Klik hier of sleep een regel naar dit gebied",
    "Cumulative Layout Shift": "Cumulative Layout Shift",
    "LCP": "LCP",
    "Relevant for": "Relevant voor",
    "SI": "SI",
    "TBT": "TBT",
    "[[avg]]": "[[avg]]",
    "[[label]]: [[value]]": "[[label]]: [[value]]",
    "Content Authoring": "Content redactie",
    "Responsibilities": "Verantwoordelijkheden",
    "Responsibility": "Verantwoordelijkheid",
    "UX Design": "UX Design",
    "Visual Design": "Visueel Ontwerp",
    "Version [[version]]": "Versie [[version]]",
    "Accessibility score": "Toegankelijkheidsscore",
    "Comparison to average": "In vergelijking met het gemiddelde",
    "Industry average": "Gemiddelde van deze sector",
    "No scores available for this domain": "Geen scores beschikbaar voor dit domein",
    "Professional services": "Professionele dienstverlening",
    "Quality Assurance score": "Quality Assurance score",
    "SEO score": "SEO score",
    "Scores": "Scores",
    "The average score for domains within your industry.": "De vergelijkende score ten opzichte van websites binnen je sector.",
    "Add language": "Taal toevoegen",
    "Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.": "Weet je zeker dat je de policy <strong>[[policyName]]</strong> wilt archiveren? Wij zullen dan niet meer zoeken naar overeenkomsten met deze policy. Je kunt de policy later altijd weer uit het archief halen.",
    "Are you sure you want to set these documents as reviewed?": "Weet je zeker dat je deze documenten als beoordeeld wilt zetten?",
    "Clear selection": "Selectie wissen",
    "Delete language -": "Taal verwijderen -",
    "Delete the language tab - [[language]]": "Verwijder de taal tab - [[language]]",
    "Discovered": "Ontdekt",
    "Doing this will result in removing the translations in the selected language from both your Cookie Overview and the actual banner itself.<br></br><strong>You will need to add the descriptions again when you re-add the selected language.</strong>": "Dit zorgt ervoor dat de vertalingen in de geselecteerde taal verwijderd worden uit zowel jouw Cookie Overzicht als de daadwerkelijke banner.<br></br><strong>Je zult de beschrijvingen opnieuw moeten toevoegen wanneer je de geselecteerde taal opnieuw toevoegt.</strong>",
    "Don't forget to update your languages in Script Setup!": "Vergeet niet jouw talen bij te werken in Script Setup!",
    "Edit this policy rule later under the “Add rule to policy” tab.": "Bewerk deze policy regel later onder het tabblad \"Regel aan policy toevoegen\".",
    "Front-end Development": "Front-end Development",
    "How to setup this policy:": "Hoe je deze policy kunt instellen:",
    "Insert word length": "Woordlengte invoegen",
    "Inspect page with browser extension": "Bekijk pagina met browserextensie",
    "Mark all as reviewed": "Alles als beoordeeld markeren",
    "Mobile only": "Mobile only",
    "New policy": "Nieuwe policy",
    "Please add at least one language": "Voeg tenminste één taal toe",
    "Please set the default language": "Stel de standaardtaal in",
    "Please wait - Adding word to ignored list": "Een ogenblik geduld - Woord wordt toegevoegd aan lijst met genegeerde woorden",
    "Please wait - Adding words to ignored list": "Een ogenblik geduld - Woorden worden toegevoegd aan lijst met genegeerde woorden",
    "Remove rule from policy": "Regel uit policy verwijderen",
    "Request PDF accessibility check for all": "Vraag een PDF-toegankelijkheidscontrole aan voor alle PDFs",
    "Request Remedition quote for all": "Herstel offerte aanvragen voor alles",
    "Script": "Script",
    "Select a group": "Selecteer een groep",
    "Select a shape": "Selecteer een vorm",
    "Select languages": "Selecteer talen",
    "Select the default language": "Selecteer de standaardtaal",
    "To finish setting up your manual Cookie Overview go to the selected domain’s": "Om het instellen van het handmatige Cookie-overzicht te voltooien ga je naar het geselecteerde domein",
    "Unignore this check": "Deze controle niet meer negeren",
    "WCAG 2.1 (Level AA) Mobile": "WCAG 2.1 (niveau AA) Smartphone",
    "WCAG 2.1 (Level AAA) Mobile": "WCAG 2.1 (niveau AAA) Smartphone",
    "Are you sure you want to delete label: [[label]] ?": "Weet je zeker dat je het label: [[label]] wilt verwijderen?",
    "Business services": "Bedrijfsdiensten",
    "CMS template is configured for this domain": "CMS sjabloon is voor dit domein geconfigureerd",
    "Consent Manager configuration": "Consent Manager configuratie",
    "Consent Manager language*": "Consent Manager taal*",
    "Consent Manager pop-up position on Page": "Consent Manager pop-up positie op Pagina",
    "Consent Manager pop-up setup": "Consent Manager pop-up instellen",
    "Construction/industrial": "Bouw/industrie",
    "Consumer services": "Consumentendiensten",
    "Entertainment/Leisure": "Amusement/Vrijetijdsbesteding",
    "Financial services": "Financiële diensten",
    "German (Germany)": "Duits (Duitsland)",
    "Healthcare": "Gezondheidszorg",
    "Label used in the groups below. Please edit or delete the groups and try again.": "Label gebruikt in de onderstaande groepen. Bewerk of verwijder de groepen en probeer opnieuw.",
    "Law enforcement": "Rechtshandhaving",
    "Legal": "Juridisch",
    "Non-profit": "Non-profit",
    "Real-estate": "Onroerend goed",
    "Retail/wholesale": "Detailhandel/groothandel",
    "Spanish (Spain)": "Spaans (Spanje)",
    "Technology": "Technologie",
    "Utilities/Natural resources": "Nutsvoorzieningen/Natuurlijke grondstoffen",
    "Widget Design": "Widget Ontwerp",
    ":": ":",
    "Accessibility issue": "Toegankelijkheidsprobleem",
    "Add reason (optional)": "Reden toevoegen (optioneel)",
    "All pages with this accessibility issue": "Alle pagina's met dit toegankelijkheidsprobleem",
    "All pages with this data privacy issue": "Alle pagina's met dit probleem met gegevensbescherming",
    "Alternatively, click the button below.": "U kunt ook op onderstaande knop klikken.",
    "Are you sure you want to mark this  as fixed?": "Weet u zeker dat u dit als opgelost wilt markeren?",
    "Are you sure you want to mark this  as ignored?": "Weet u zeker dat u dit wilt markeren als genegeerd?",
    "Are you sure you want to mark this  as not fixed?": "Weet u zeker dat u dit wilt markeren als 'niet opgelost'?",
    "Are you sure you want to mark this check as ignored?": "Weet u zeker dat u deze controle als genegeerd wilt markeren?",
    "Are you sure you want to mark this issue as ignored?": "Weet u zeker dat u dit probleem als genegeerd wilt markeren?",
    "Are you sure you want to unignore this ?": "Weet u zeker dat u dit wilt negeren?",
    "Average time (comp.)": "Gemiddelde tijd (vergelijkbaar)",
    "Bounce rate (comp.)": "Bouncepercentage (vergelijkbaar)",
    "Campaign visits": "Campagnebezoeken",
    "Code": "Code",
    "Confirmation required": "Bevestiging vereist",
    "Current password": "Huidig wachtwoord",
    "Data privacy issue": "Probleem met gegevensprivacy",
    "Data violations": "Gegevensinbreuken",
    "Date found": "Datum gevonden",
    "Downloads (comp.)": "Downloaden (comp.)",
    "Entries (comp.)": "Inzendingen (comp.)",
    "Events": "Evenementen",
    "Exits (comp.)": "Uitgangen (comp.)",
    "Export visitors browsers": "Bezoekersbrowsers exporteren",
    "Export visitors devices": "Exporteer bezoekersapparaten",
    "Export visitors language": "Exporteer bezoekers taal",
    "Export visitors locations": "Exporteer bezoekerslocaties",
    "Export visitors operating systems": "Exporteer bezoekersbesturingssystemen",
    "Export visitors organization": "Exporteer bezoekersorganisatie",
    "Found on page": "Gevonden op pagina",
    "Group name": "Groepsnaam",
    "Image URL": "Afbeelding-URL",
    "Issue details": "Probleemdetails",
    "Issue not found": "Probleem niet gevonden",
    "Legacy Browser Service changed": "Legacy Browser Service gewijzigd",
    "Look up in Google": "Zoek op in Google",
    "Mark as reviewed": "Markeren als beoordeeld",
    "Maximum word length to search for": "Maximale woordlengte om naar te zoeken",
    "Names": "Namen",
    "No pages were found. Try searching for the page URL instead of the page title.": "Er zijn geen pagina's gevonden. Probeer te zoeken naar de pagina-URL in plaats van de paginatitel.",
    "Open browser extension": "Browserextensie openen",
    "Open issue page": "Open probleempagina",
    "Open misspelling page": "Open pagina met spelfouten",
    "Other checks for this snippet": "Andere controles voor dit fragment",
    "Pages with accessibility issues": "Pagina's met toegankelijkheidsproblemen",
    "Pages with policy issues": "Pagina's met beleidsvraagstukken",
    "Pageviews (comp.)": "Paginaweergaven (comp.)",
    "Percentage shows number of pages that are compliant with all Policies": "Percentage geeft het aantal pagina's weer dat voldoet aan alle beleidsregels",
    "Percentage shows number of pages that are compliant with all QA checks": "Percentage geeft het aantal pagina's weer dat voldoet aan alle QA-controles",
    "Please enter a valid date!": "Voer een geldige datum in!",
    "Please wait - Adding word to all dictionaries": "Even geduld a.u.b. - Woord toevoegen aan alle woordenboeken",
    "Press to toggle additional rows.": "Druk om naar andere rijen te gaan.",
    "Puppeteer Browser Service changed": "Puppeteer Browser Service gewijzigd",
    "Reason:&nbsp;": "Reden:&nbsp;",
    "Remember to add this source code exclude to your domain(s) through the Edit Domain screen.": "Vergeet niet om deze broncode-uitsluiting toe te voegen aan uw domein(en) via het scherm Domein bewerken.",
    "Remove review": "Beoordeling verwijderen",
    "Repeat new password": "Herhaal nieuw wachtwoord",
    "Sorry, this page was not found. The issue must have been resolved.": "Sorry, deze pagina is niet gevonden. Het probleem moet zijn opgelost.",
    "The date cannot be in the future": "De datum kan niet in de toekomst liggen",
    "The end date cannot be before the start date": "De einddatum kan niet vóór de startdatum liggen",
    "The settings form contains incorrect data. Close the form anyway?": "Het instellingenformulier bevat onjuiste gegevens. Formulier toch sluiten?",
    "The start and end date cannot be in the future, please enter the compare dates again": "De begin- en einddatum kunnen niet in de toekomst liggen, voer de vergelijkingsdata opnieuw in",
    "This issue is marked as fixed.": "Dit probleem is gemarkeerd als opgelost.",
    "This issue is marked as ignored.": "Dit probleem is gemarkeerd als genegeerd.",
    "This issue is marked as reviewed.": "Dit probleem is gemarkeerd als beoordeeld.",
    "This word has been added to your dictionary": "Dit woord is toegevoegd aan uw woordenboek",
    "To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class=\\\"text-bold\\\">My Exports.</span>": "Om de huidige voortgang te bekijken, klikt u op de gebruikersavatar in de rechterbovenhoek van de hoofdpagina en selecteert u <span class=\\\"text-bold\\\">Mijn exporten.</span>",
    "Total unique downloads (comp.)": "Totaal aantal unieke downloads (comp.)",
    "Unique downloads (comp.)": "Unieke downloads (comp.)",
    "Visitors browsers export": "Bezoekersbrowsers exporteren",
    "Visitors devices export": "Bezoekersapparaten exporteren",
    "Visitors language export": "Bezoekers taal exporteren",
    "Visitors locations export": "Bezoekerslocaties exporteren",
    "Visitors operating systems export": "Bezoekersbesturingssystemen exporteren",
    "Visitors organization export": "Bezoekersorganisatie exporteren",
    "Visits (comp.)": "Bezoeken (vergelijkbaar)",
    "WCAG 2.1 (Level A) Mobile": "WCAG 2.1 (niveau A) Mobiel",
    "Your export is currently being generated.": "Uw export wordt momenteel gegenereerd.",
    "+ ' + (report.targets.length - maxTargets) + ' more": "+ ' + (report.targets.length - maxTargets) + ' meer",
    "Accessibility Checklist (WCAG 2.0)": "Checklist Toegankelijkheid (WCAG 2.0)",
    "Accessibility Checklist (WCAG 2.1)": "Checklist Toegankelijkheid (WCAG 2.1)",
    "Accessibility Checklist (WCAG 2.2)": "Checklist Toegankelijkheid (WCAG 2.2)",
    "Average no. of results pages viewed": "Gemiddeld aantal bekeken resultatenpagina's",
    "Checklist": "Controlelijst",
    "Email *": "E-mailadres *",
    "Event actions": "Gebeurtenisacties",
    "Event categories": "Evenementcategorieën",
    "Event names": "Namen van evenementen",
    "First name *": "Voornaam *",
    "Last name *": "Achternaam *",
    "Search term": "Zoekterm",
    "Search terms": "Zoektermen",
    "Search terms with no results": "Zoektermen zonder resultaten",
    "Site Search": "Site zoeken",
    "Site Search - Search Terms": "Site zoeken - Zoektermen",
    "Site Search No Results Search Terms": "Site zoeken Geen resultaten Zoektermen",
    "Switch between chart and table": "Schakelen tussen grafiek en tabel",
    "Table": "Tafel",
    "more": "meer",
    "Accessibility checks update": "Update toegankelijkheidscontroles",
    "Account is under maintenance": "Account is in onderhoud",
    "Add internal URL": "Interne URL toevoegen",
    "Add the name of the platform or company who provides this cookie.": "Voeg de naam toe van het platform of bedrijf dat deze cookie aanbiedt.",
    "All PDFs": "Alle PDF's",
    "All scheduled reports": "Alle geplande rapporten",
    "An error has occurred - please try again": "Er is een fout opgetreden - probeer het opnieuw",
    "Are you sure you want mark as fixed": "Weet u zeker dat u het als opgelost wilt markeren?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary for all languages?": "Weet u zeker dat u het woord <strong>[[word]]</strong> wilt toevoegen aan het woordenboek voor alle talen?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary?": "Weet u zeker dat u het woord <strong>[[word]]</strong> aan het woordenboek wilt toevoegen?",
    "Are you sure you want to confirm the word <strong>[[word]]</strong> as misspelling?": "Weet u zeker dat u wilt bevestigen dat het woord <strong>[[word]]</strong> verkeerd gespeld is?",
    "Are you sure you want to ignore the misspelling <strong>[[word]]</strong> for all languages?": "Weet u zeker dat u de spelfout <strong>[[word]]</strong> voor alle talen wilt negeren?",
    "Are you sure you want to mark the misspelling <strong>[[word]]</strong> as fixed?": "Weet u zeker dat u de spelfout <strong>[[word]]</strong> als gecorrigeerd wilt markeren?",
    "Are you sure you want to remove the Default label?": "Weet u zeker dat u het label Standaard wilt verwijderen?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong>?": "Weet u zeker dat u het beleid <strong>[[policyName]]</strong> wilt uitvoeren?",
    "Bar chart representing data": "Staafdiagram met gegevens",
    "Bar line chart representing": "Staafdiagram dat weergeeft",
    "Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.": "Houd er rekening mee dat een leeg alt-kenmerk voldoende en geschikt kan zijn voor decoratieve afbeeldingen.",
    "Bubble chart representing data": "Bubbeldiagram met gegevens",
    "Clear the field": "Maak het veld leeg",
    "Close submenu": "Sluit submenu",
    "Contact Support": "Neem contact op met de ondersteuning",
    "Cookie platform": "Cookieplatform",
    "Current password is incorrect please try again": "Het huidige wachtwoord is onjuist. Probeer het opnieuw.",
    "Doughnut chart representing data": "Donutdiagram met gegevens",
    "Enable Cookieless Tracking": "Cookieloze tracking inschakelen",
    "Errors and": "Fouten en",
    "Errors and Warnings": "Fouten en waarschuwingen",
    "Events filter buttons": "Filterknoppen voor evenementen",
    "Every 12 weeks": "Elke 12 weken",
    "Every 2 weeks": "Elke 2 weken",
    "Every 4 weeks": "Elke 4 weken",
    "Every 8 weeks": "Elke 8 weken",
    "Frequency": "Frequentie",
    "Image details": "Afbeeldingdetails",
    "Image metadata": "Afbeeldingsmetagegevens",
    "Image preview": "Afbeeldingvoorbeeld",
    "Inventory image preview": "Voorbeeld van inventarisafbeelding",
    "It seems like we are experience some issues with the page you are looking at.": "Het lijkt erop dat er problemen zijn met de pagina die u bekijkt.",
    "It seems like your computer is disconnected from the internet.": "Het lijkt erop dat uw computer geen verbinding heeft met het internet.",
    "Line chart representing data": "Lijndiagram met gegevens",
    "List of received reports": "Lijst met ontvangen rapporten",
    "Metadata and pages": "Metagegevens en pagina's",
    "Metadata property": "Metadata-eigenschap",
    "My scheduled reports": "Mijn geplande rapporten",
    "No date range selected": "Geen datumbereik geselecteerd",
    "Norwegian": "Noors",
    "Only Errors": "Alleen fouten",
    "Only errors": "Alleen fouten",
    "Open dropdown with filters": "Open dropdown met filters",
    "Open metadata view": "Metadataweergave openen",
    "Open submenu with filters": "Open submenu met filters",
    "Pages that contain the Email": "Pagina's die het e-mailadres bevatten",
    "Percentage shows the average compliance score across all pages on the domain": "Percentage geeft de gemiddelde nalevingsscore weer op alle pagina's op het domein",
    "Pie chart representing data": "Cirkeldiagram met gegevens",
    "Platform": "Platform",
    "Please contact the support if this issue keeps happening": "Neem contact op met de ondersteuning als dit probleem zich blijft voordoen",
    "Please refresh the browser when your computer is online again.": "Vernieuw de browser zodra uw computer weer online is.",
    "Please try again later": "Probeer het later opnieuw",
    "Press to remove the label.": "Druk om het label te verwijderen.",
    "Puppeteer 20": "Poppenspeler 20",
    "Remove internal URL": "Interne URL verwijderen",
    "Scan all pages for cookies": "Scan alle pagina's op cookies",
    "Schedule this report": "Plan dit rapport",
    "Search in options": "Zoeken in opties",
    "Show HTML snippet details": "Toon HTML-fragmentdetails",
    "Show labels": "Labels weergeven",
    "Show less of the url snippet": "Minder van het url-fragment weergeven",
    "Show the full url snippet": "Toon het volledige url-fragment",
    "Showing": "Tonen",
    "The average compliance score for this module for domains from other organizations within your industry:": "De gemiddelde nalevingsscore voor deze module voor domeinen van andere organisaties binnen uw branche:",
    "Unsubscribe from report": "Afmelden voor rapport",
    "Warnings": "Waarschuwingen",
    "We export up to a maximum of 1000 rows": "Wij exporteren maximaal 1000 rijen",
    "We recommend that you have an alt attribute with relevant content on all image tags.": "Wij adviseren u om bij alle afbeeldingstags een alt-attribuut met relevante inhoud te gebruiken.",
    "You have images missing an alt attribute.": "Er ontbreken alt-attributen bij uw afbeeldingen.",
    "[[name]] Remove": "[[name]] Verwijderen",
    "[[target]]": "[[doel]]",
    "default": "standaard",
    "[[label]]": "[[label]]",
    "% of visitors staying after a search": "% van de bezoekers die na een zoekopdracht blijven",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.": "Documentherstel voor naleving van WCAG 2.1 AA, Sectie 508, HHS of PDF/UA-toegankelijkheidsnormen wordt uitgevoerd door onze dochteronderneming, NetCentric Technologies, Inc. Vanwege de vereisten van het regelgevingskader in uw land, kunnen we documentherstel niet rechtstreeks voor u coördineren; u wordt echter uitgenodigd om rechtstreeks contact op te nemen met NetCentric voor een offerte en hersteldiensten op dherr@allyant.com. Houd er rekening mee dat alle contracten voor herstel tussen u, de klant, en NetCentric zijn en onderworpen zijn aan de Algemene voorwaarden en het Privacybeleid van NetCentric en zullen resulteren in een overdracht van gegevens aan derden en derde landen, inclusief maar niet beperkt tot de Verenigde Staten, Canada, Australië en Egypte.",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. Upon completion of the work, NetCentric will also provide a compliance report. NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy.": "Documentherstel voor naleving van WCAG 2.1 AA, Sectie 508, HHS of PDF/UA-toegankelijkheidsnormen wordt uitgevoerd door onze dochteronderneming, NetCentric Technologies, Inc. Voor herstel zullen we samenwerken met NetCentric om het document te beoordelen en u een vaste prijs voor het herstel te bieden. Na voltooiing van het werk zal NetCentric ook een nalevingsrapport verstrekken. NetCentric zal u laten weten of er alternatieve tekst (Alt-tekst) vereist is voor afbeeldingen die niet zelfbeschrijvend zijn of gerelateerde aanvullende informatie die nodig is om het document te herstellen. Houd er rekening mee dat alle contracten voor herstel tussen u, de klant, en NetCentric zijn en onderworpen zijn aan de algemene voorwaarden en het privacybeleid van NetCentric.",
    "Japanese": "Japanse",
    "Report Administration": "Rapportbeheer",
    "Submit": "Indienen",
    "You have [[domains]] domain(s) on your account": "U hebt [[domains]] domein(en) op uw account",
    "Find domains by searching for the title or URL": "Zoek domeinen door te zoeken naar de titel of URL",
    "Industry average score": "Gemiddelde score van de sector",
    "Proceed to add one more check": "Ga door met het toevoegen van nog een controle",
    "Readability test (for English pages only)": "Leesbaarheidstest (alleen voor Engelse pagina's)",
    "Request quote for more pages": "Vraag offerte aan voor meer pagina's",
    "Request quote for more profiles": "Vraag offerte aan voor meer profielen",
    "Search for domain": "Zoeken naar domein",
    "The user does not have access to view this domain and any reports associated with it": "De gebruiker heeft geen toegang om dit domein en de bijbehorende rapporten te bekijken",
    "Update all domain groups": "Alle domeingroepen bijwerken",
    "Update domain group": "Domeingroep bijwerken",
    "Updating a group can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Het updaten van een groep kan meer dan 30 minuten duren. Tijdens de bewerking kunt u geen groepen maken en updaten.",
    "WCAG 2.2 (Level A)": "WCAG 2.2 (niveau A)",
    "WCAG 2.2 (Level A) Mobile": "WCAG 2.2 (niveau A) Mobiel",
    "WCAG 2.2 (Level AA)": "WCAG 2.2 (niveau AA)",
    "WCAG 2.2 (Level AA) Mobile": "WCAG 2.2 (niveau AA) Mobiel",
    "WCAG 2.2 (Level AAA)": "WCAG 2.2 (niveau AAA)",
    "WCAG 2.2 (Level AAA) Mobile": "WCAG 2.2 (niveau AAA) Mobiel",
    "You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button \\\"Request quote for more pages\\\" and someone on our team will be in touch.": "U hebt het maximum aantal prestatiepagina's in uw huidige abonnement bereikt.<br/><br/>Als u informatie wilt opvragen over de prijsopties voor extra pagina's, klikt u op de knop 'Vraag een offerte aan voor meer pagina's'. Iemand van ons team neemt dan contact met u op.",
    "You must perform a manual review of the page to confirm if this issue is present": "U moet de pagina handmatig controleren om te bevestigen of dit probleem zich voordoet",
    "Accessibility Checklist (QUALWEB)": "Controlelijst toegankelijkheid (QUALWEB)",
    "Accessibility checks cannot be ignored for domain groups. To ignore this check you must do it for the entire domain.": "Toegankelijkheidscontroles kunnen niet worden genegeerd voor domeingroepen. Om deze controle te negeren, moet u deze voor het hele domein uitvoeren.",
    "Accessibility checks cannot be unignored for domain groups. To unignore this check you must do it for the entire domain.": "Toegankelijkheidscontroles kunnen niet worden genegeerd voor domeingroepen. Om deze controle te negeren, moet u dit voor het hele domein doen.",
    "Check your spelling or try a shorter query.": "Controleer uw spelling of probeer een kortere zoekopdracht.",
    "Guidelines for QUALWEB": "Richtlijnen voor QUALWEB",
    "Language not supported": "Taal niet ondersteund",
    "No domains found.": "Geen domeinen gevonden.",
    "QUALWEB Accessibility Compliance": "QUALWEB Toegankelijkheidsnaleving",
    "QualWeb (Level A)": "QualWeb (niveau A)",
    "QualWeb (Level AA)": "QualWeb (niveau AA)",
    "Score could not be generated": "Score kon niet worden gegenereerd",
    "Searching <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>": "Zoeken <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>",
    "The language of the page is not recognized as English. The Flesch-Kincaid test only works for English language. Change to the LIX test if you wish to generate scores for non-English pages.": "De taal van de pagina wordt niet herkend als Engels. De Flesch-Kincaid-test werkt alleen voor de Engelse taal. Ga naar de LIX-test als u scores wilt genereren voor niet-Engelstalige pagina's.",
    "We could not generate an accurate score for these pages. This is typically either due to the text on a page being too short, too long, or our web crawler not picking up any text at all.": "We konden geen nauwkeurige score voor deze pagina's genereren. Dit komt meestal doordat de tekst op een pagina te kort of te lang is, of doordat onze webcrawler helemaal geen tekst oppikt.",
    "Are you sure you want to add word [[word]] to all dictionaries": "Weet u zeker dat u het woord [[word]] aan alle woordenboeken wilt toevoegen?",
    "Are you sure you want to add word [[word]] to dictionary?": "Weet u zeker dat u het woord [[word]] aan het woordenboek wilt toevoegen?",
    "Are you sure you want to confirm the word [[word]] as misspelling?": "Weet u zeker dat u wilt bevestigen dat het woord [[word]] verkeerd gespeld is?",
    "Are you sure you want to ignore the misspelling [[word]] for all languages?": "Weet u zeker dat u de spelfout [[word]] voor alle talen wilt negeren?",
    "Are you sure you want to mark the misspelling [[word]] as fixed?": "Weet u zeker dat u de spelfout [[word]] als gecorrigeerd wilt markeren?",
    "Cannot forward more": "Kan niet verder doorsturen",
    "Choose Date": "Kies datum",
    "Compare": "Vergelijken",
    "Confirmed errors only": "Alleen bevestigde fouten",
    "Exclude checks that require manual review": "Controles uitsluiten die handmatige controle vereisen",
    "If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.": "Als deze optie is ingeschakeld, omvat de domeinscan alleen toegankelijkheidscontroles die automatisch als fouten kunnen worden geïdentificeerd. Controles die handmatige beoordeling vereisen, worden uitgesloten.",
    "One month back": "Een maand terug",
    "One month forward": "Een maand vooruit",
    "Press to choose the end day": "Druk om de einddag te kiezen",
    "Press to choose the start day": "Druk om de startdag te kiezen",
    "Remove compare range dates": "Verwijder vergelijkingsbereikdatums",
    "The date cannot be in the future.": "De datum kan niet in de toekomst liggen.",
    "Toggle the datepicker": "Schakel de datumkiezer in",
    "Add Policy with AI": "Beleid toevoegen met AI",
    "Consolidated Reports": "Geconsolideerde rapporten",
    "Created with AI policy assistant": "Gemaakt met AI-beleidsassistent",
    "Policy Assistant": "Beleidsassistent",
    "Sparkle icon": "Sparkle-pictogram",
    "The Policy Assistant runs on Google Vertex AI, which can make mistakes.": "De beleidsassistent draait op Google Vertex AI, dat fouten kan maken.",
    "You have reached the maximum number of Performance profiles in your current plan.<br/><br/>To inquire about pricing options for additional profiles, please press the button \\\"Request quote for more profiles\\\" and someone on our team will be in touch.": "U hebt het maximale aantal Prestatie-profielen in uw huidige abonnement bereikt.<br/><br/>Als u informatie wilt opvragen over prijsopties voor extra profielen, klikt u op de knop \"Offerte aanvragen voor meer profielen\". Iemand van ons team neemt dan contact met u op.",
    "You are about to perform a scan of <span class='text-link'>[[pageTitle]]</span> using the profile <span class='text-link'>[[profileName]]</span>.<br>The scan can take a few minutes to finalise, depending on the size of the page.<br><br>Do you want to continue?": "U staat op het punt een scan uit te voeren van <span class='text-link'>[[pageTitle]]</span> met behulp van het profiel <span class='text-link'>[[profileName]]</span>.<br>Het kan enkele minuten duren voordat de scan is voltooid, afhankelijk van de grootte van de pagina.<br><br>Wilt u doorgaan?",
    "Doesn't scan automatically": "Scant niet automatisch",
    "Scans automatically": "Scant automatisch",
    "with this": "met dit",
    "with this PDF": "met deze PDF",
    "with this archive file": "met dit archiefbestand",
    "with this slide": "met deze dia",
    "with this spreadsheet": "met dit spreadsheet",
    "with this text file": "met dit tekstbestand",
    "Errors must be fixed for compliance.": "Om aan de regelgeving te voldoen, moeten fouten worden hersteld.",
    "Issues to Fix": "Problemen die opgelost moeten worden",
    "Issues to Review": "Te beoordelen kwesties",
    "Reviews require manual judgement.": "Beoordelingen vereisen handmatige beoordeling.",
    "Warnings are likely to be issues, but they require manual investigation.": "Waarschuwingen kunnen een probleem zijn, maar vereisen handmatig onderzoek.",
    "1 content": [
      "1 inhoud",
      "{{$count}} inhoud"
    ],
    "1 misspelling ignored across all domains": [
      "1 spelfout genegeerd in alle domeinen",
      "{{$count}} spelfout genegeerd in alle domeinen"
    ],
    "1 new cookie on": [
      "1 nieuw koekje op",
      "{{$count}} nieuw koekje op "
    ],
    "1 page": [
      "1 pagina",
      "{{$count}} paginas"
    ],
    "1 page with one or more failing checks {{guideline}}": [
      "1 pagina met één of meer mislukte controles {{guideline}}",
      "{{$count}} paginas met één of meer mislukte controles {{guideline}}"
    ],
    "1 page with one or more ignored checks {{guideline}}": [
      "1 pagina met een of meer genegeerde controles {{guideline}}",
      "{{$count}} paginas met een of meer genegeerde controles {{guideline}}"
    ],
    "1 policy found": [
      "1 beleid gevonden",
      "{{$count}} beleide gevonden"
    ],
    "1 results": [
      "1 resultaat",
      "{{$count}} resultaat"
    ],
    "1 visit": [
      "1 bezoek",
      "{{$count}} bezoek"
    ],
    "1 word added across all domains": [
      "1 woord toegevoegd in alle domeinen",
      "{{$count}} woord toegevoegd in alle domeinen"
    ],
    "One word found": [
      "Eén woord gevonden",
      "{{$count}} woord gevonden"
    ],
    "You have 1 user on your account": [
      "U heeft 1 gebruiker op uw account",
      "U heeft {{$count}} gebruikers op uw account"
    ],
    "Accessibility Compliance Scan": "Scan voor toegankelijkheidsnaleving",
    "Broken Links on Sitemap": "Gebroken links op de sitemap",
    "Broken links on sitemap": "Gebroken links op de sitemap",
    "Close Spotlight Search.": "Sluit Spotlight-zoeken.",
    "Requested": "Gevraagd",
    "Toggle Spotlight Search.": "Spotlight-zoeken in-/uitschakelen.",
    "WCAG 2.2": "WCAG 2.2",
    "Newest": {
      "Exchange Center Sort by option": "Nieuwste"
    },
    "(<strong><i>[[issues]]</i></strong> unique problems)": "(<strong><i>[[issues]]</i></strong> unieke problemen)",
    "(<strong>[[issues]]</strong> unique problems)": "(<strong>[[issues]]</strong> unieke problemen)",
    "<div class=\\\\'pull-left\\\\'>' + ('Heatmaps": "<div class=\\\\'pull-left\\\\'>' + ('Heatmaps",
    "<div class=\\\\'pull-left\\\\'>' + ('History Center": "<div class=\\\\'pull-left\\\\'>' + ('Geschiedeniscentrum",
    "<p class='warning'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached the limit of the amount of profiles allowed on your account ([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan or archive some profiles before restoring this one.</p>": "<p class='warning'>Acquia Web Governance kan het profiel niet herstellen.</p><p>U hebt de limiet bereikt van het aantal toegestane profielen voor uw account ([[maxProfiles]] profielen). Neem contact op met ons salesteam om meer profielen aan uw abonnement toe te voegen of een aantal profielen te archiveren voordat u dit profiel herstelt.</p>",
    "<strong>' + (links.total | monNumber) + '</strong> ' + ('link": "<strong>' + (links.total | monNumber) + '</strong> ' + ('link",
    "<strong>' + (pages.total | monNumber) + '</strong> ' + ('page": "<strong>' + (pagina's.totaal | monNumber) + '</strong> ' + ('pagina",
    "A \\\"skip to content\\\" link at the start of the webpage allows screen reader and keyboard-only users to skip over potentially non-relevant links at the start of your webpage and immediately access the main content.": "Met een link 'ga naar inhoud' aan het begin van de webpagina kunnen gebruikers van een schermlezer of een toetsenbord mogelijk niet-relevante links aan het begin van de webpagina overslaan en meteen toegang krijgen tot de hoofdinhoud.",
    "A cozy room with sofa, table and laptops that have Acquia Web Governance text": "Een gezellige kamer met een bank, een tafel en laptops met Acquia Web Governance-tekst",
    "About Acquia Web Governance": "Over Acquia Web Governance",
    "Accept Acquia Web Governance Privacy Terms": "Accepteer de privacyvoorwaarden van Acquia Web Governance",
    "Acquia Web Governance": "Acquia Web Governance",
    "Acquia Web Governance - Accessibility": "Acquia Web Governance - Toegankelijkheid",
    "Acquia Web Governance - Accessibility Check List": "Acquia Web Governance - Checklist voor toegankelijkheid",
    "Acquia Web Governance - Accessibility Guidelines": "Acquia Web Governance - Richtlijnen voor toegankelijkheid",
    "Acquia Web Governance - Account Dictionary": "Acquia Web Governance - Accountwoordenboek",
    "Acquia Web Governance - Admin Page Performance Profiles": "Acquia Web Governance - Prestatieprofielen van de beheerpagina",
    "Acquia Web Governance - Audit Log": "Acquia Web Governance - Auditlogboek",
    "Acquia Web Governance - Broken Images": "Acquia Web Governance - Gebroken afbeeldingen",
    "Acquia Web Governance - Broken Links": "Acquia Web Governance - Gebroken links",
    "Acquia Web Governance - Content With Broken Links": "Acquia Web Governance - Inhoud met verbroken links",
    "Acquia Web Governance - Content With QA Errors": "Acquia Web Governance - Inhoud met QA-fouten",
    "Acquia Web Governance - Cookie Acceptance Rate": "Acquia Web Governance - Cookie-acceptatiepercentage",
    "Acquia Web Governance - Cookie Consent Log": "Acquia Web Governance - Cookietoestemmingslogboek",
    "Acquia Web Governance - Cookie Overview": "Acquia Web Governance - Cookieoverzicht",
    "Acquia Web Governance - Dashboard": "Acquia Web Governance - Dashboard",
    "Acquia Web Governance - Data Privacy": "Acquia Web Governance - Gegevensbescherming",
    "Acquia Web Governance - Data Privacy Check List": "Acquia Web Governance - Checklist voor gegevensbescherming",
    "Acquia Web Governance - Data Privacy Content": "Acquia Web Governance - Gegevensbeschermingsinhoud",
    "Acquia Web Governance - Data Privacy Guidelines": "Acquia Web Governance - Richtlijnen voor gegevensbescherming",
    "Acquia Web Governance - Data Privacy Issues": "Acquia Web Governance - Problemen met gegevensprivacy",
    "Acquia Web Governance - Data Privacy Summary": "Acquia Web Governance - Samenvatting gegevensbescherming",
    "Acquia Web Governance - External PDF Compliance": "Acquia Web Governance - Externe PDF-naleving",
    "Acquia Web Governance - Fast Track": "Acquia Web Governance - Fast Track",
    "Acquia Web Governance - Heatmaps": "Acquia Web Governance - Heatmaps",
    "Acquia Web Governance - History Center": "Acquia Web Governance - Geschiedeniscentrum",
    "Acquia Web Governance - Ignored Misspellings": "Acquia Web Governance - Genegeerde spelfouten",
    "Acquia Web Governance - Internal PDF Compliance": "Acquia Web Governance - Interne PDF-naleving",
    "Acquia Web Governance - Labels": "Acquia Web Governance - Labels",
    "Acquia Web Governance - Misspellings": "Acquia Web Governance - Spelfouten",
    "Acquia Web Governance - Page Performance Pages": "Acquia Web Governance - Paginaprestaties Pagina's",
    "Acquia Web Governance - PageCorrect": "Acquia Web Governance - PageCorrect",
    "Acquia Web Governance - PageCorrect Accessibility Fixes": "Acquia Web Governance - PageCorrect Toegankelijkheidsoplossingen",
    "Acquia Web Governance - PageCorrect Content": "Acquia Web Governance - PageCorrect Content",
    "Acquia Web Governance - Pages With Failing Checks": "Acquia Web Governance - Pagina's met mislukte controles",
    "Acquia Web Governance - Pages With Ignored Checks": "Acquia Web Governance - Pagina's met genegeerde controles",
    "Acquia Web Governance - Pages With Misspellings": "Acquia Web Governance - Pagina's met spelfouten",
    "Acquia Web Governance - Pages With Opportunity": "Acquia Web Governance - Pagina's met kansen",
    "Acquia Web Governance - Potential Misspellings": "Acquia Web Governance - Mogelijke spelfouten",
    "Acquia Web Governance - Prioritized Content": "Acquia Web Governance - Geprioriteerde inhoud",
    "Acquia Web Governance - Quality Assurance": "Acquia Web Governance - Kwaliteitsborging",
    "Acquia Web Governance - Readability Checker": "Acquia Web Governance - Leesbaarheidscontrole",
    "Acquia Web Governance - Readability Summary": "Acquia Web Governance - Leesbaarheidssamenvatting",
    "Acquia Web Governance - SEO Checkpoints": "Acquia Web Governance - SEO-controlepunten",
    "Acquia Web Governance - Search Engine Optimization": "Acquia Web Governance - Zoekmachineoptimalisatie",
    "Acquia Web Governance - Spellcheck Summary": "Acquia Web Governance - Samenvatting spellingscontrole",
    "Acquia Web Governance - User List": "Acquia Web Governance - Gebruikerslijst",
    "Acquia Web Governance Consent Manager": "Acquia Web Governance Consent Manager",
    "Acquia Web Governance Extension": "Acquia Web Governance-extensie",
    "Acquia Web Governance PageAssist": "Acquia Web Governance PageAssist",
    "Acquia Web Governance users receiving this report": "Acquia Web Governance-gebruikers die dit rapport ontvangen",
    "Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )": "Acquia Web Governance detecteert automatisch een download als een klik op een link die eindigt met een van de volgende bestandsextensies (let op: de extensies zijn hoofdlettergevoelig):",
    "Add Acquia Web Governance Consent Manager": "Acquia Web Governance Consent Manager toevoegen",
    "Affects [[pageCount]] pages": "Beïnvloedt [[pageCount]] pagina's",
    "An error has occurred - please try again. If the error continues, please contact Acquia Web Governance": "Er is een fout opgetreden. Probeer het opnieuw. Als de fout blijft optreden, neem dan contact op met Acquia Web Governance.",
    "An unexpected error occurred. Please try again.": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary for all languages?": "Weet u zeker dat u het woord <strong>' + word + '</strong> wilt toevoegen aan het woordenboek voor alle talen?",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary?": "Weet u zeker dat u het woord <strong>' + word + '</strong> aan het woordenboek wilt toevoegen?",
    "Are you sure you want to confirm the misspelling <strong>' + word + '</strong>?": "Weet u zeker dat u de spelfout <strong>' + woord + '</strong> wilt bevestigen?",
    "Are you sure you want to remove the Profile <strong>[[profileName]]</strong>?": "Weet u zeker dat u het profiel <strong>[[profileName]]</strong> wilt verwijderen?",
    "Are you sure you want to undo review this document as reviewed?": "Weet u zeker dat u de beoordeling van dit document ongedaan wilt maken?",
    "Calculate Readability Score": "Leesbaarheidsscore berekenen",
    "Calculate score to see results": "Bereken de score om de resultaten te zien",
    "Calculate the readability score of any text (based on [[testName]])": "Bereken de leesbaarheidsscore van een willekeurige tekst (gebaseerd op [[testName]])",
    "Can\\\\'t delete label": "Kan label niet verwijderen",
    "Change your &lt;b&gt; tags into something else": "Verander je <b>tags in iets anders",
    "Choose your own text for the Skip to Content link button<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>": "Kies uw eigen tekst voor de knop 'Ga naar inhoud'<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Geef een titel aan uw knop 'Ga naar inhoud' | vertalen }}\\\"></span>",
    "Clear search in the domain picker": "Zoekopdracht wissen in de domeinkiezer",
    "Click here to contact Acquia Web Governance sales department to increase your maximum page count.": "Klik hier om contact op te nemen met de verkoopafdeling van Acquia Web Governance om uw maximale paginaaantal te verhogen.",
    "Confirmed misspelling": "Bevestigde spelfout",
    "Copyright 2020 Acquia Web Governance. All rights reserved.": "Copyright 2020 Acquia Web Governance. Alle rechten voorbehouden.",
    "Couldn't find any domains": "Kon geen domeinen vinden",
    "Crawled Pages ([[pageCount]])": "Gecrawlde pagina's ([[pageCount]])",
    "Description*": "Beschrijving*",
    "Domain favicon for": "Domein favicon voor",
    "Domain groups": "Domeingroepen",
    "Domains that have never been scanned": "Domeinen die nog nooit zijn gescand",
    "Domains that were not scanned in the selected date range": "Domeinen die niet zijn gescand in de geselecteerde datumbereik",
    "Edit this policy rule later under the \\\"Add rule to policy\\\" tab.": "U kunt deze beleidsregel later bewerken via het tabblad 'Regel toevoegen aan beleid'.",
    "Enable if you want to use Acquia Web Governance in Accessibility mode": "Inschakelen als u Acquia Web Governance in de toegankelijkheidsmodus wilt gebruiken",
    "Export visitors screen resolutions": "Schermresoluties van bezoekers exporteren",
    "For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.": "Acquia Web Governance Pagecorrect zal voorlopig een pop-upwaarschuwing toevoegen aan elke externe link, zodat uw bezoekers zelf kunnen kiezen of ze de oorspronkelijke pagina willen verlaten.",
    "Found 1 audit log on your account": "Er is 1 auditlogboek gevonden op uw account",
    "Found [[count]] audit logs on your account": "Er zijn [[count]] auditlogs gevonden in uw account",
    "From March 1, 2022, Acquia Web Governance will no longer be supporting any version of Internet Explorer or Edge browser version 78 or below. While you will still be able to log on and use Acquia Web Governance with Internet Explorer and older versions of Edge, we are no longer testing releases and fixing bugs specifically for those browsers. We encourage you to switch to another browser such as Chrome or newer version of Edge to be sure that Acquia Optimize continues to work optimally on your device.": "Vanaf 1 maart 2022 ondersteunt Acquia Web Governance geen versies van Internet Explorer of Edge-browserversie 78 of lager meer. U kunt nog steeds inloggen en Acquia Web Governance gebruiken met Internet Explorer en oudere versies van Edge, maar we testen geen releases meer en lossen geen bugs meer op voor die browsers. We raden u aan over te stappen op een andere browser, zoals Chrome of een nieuwere versie van Edge, om er zeker van te zijn dat Acquia Optimize optimaal blijft werken op uw apparaat.",
    "Get the Acquia Web Governance Extension": "Download de Acquia Web Governance-extensie",
    "Go to the policy dashboard of the domain [[title]]": "Ga naar het beleidsdashboard van het domein [[title]]",
    "Images missing alt attribute": "Afbeeldingen waarvan het alt-attribuut ontbreekt",
    "Insert the CSS selector targets you want your visitors to land on<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>": "Voeg de CSS-selectordoelen in waar je bezoekers naartoe moeten komen<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Zorg ervoor dat je de juiste opmaak gebruikt en voeg meerdere selectoren toe als je pagina-ontwerp afwijkt' | vertalen }}\\\"></span>",
    "Internet Explorer &amp; Edge v.78 (or below) no longer supported": "Internet Explorer en Edge v.78 (of lager) worden niet langer ondersteund",
    "Italics are often used in HTML to put emphasis on text. However, this is often achieved with the &lt;I&gt; tag, in which case the emphasis is not announced by screen readers. Using the &lt;I&gt; tag doesn't provide enough context and is becoming an outdated practice.": "Cursief wordt in HTML vaak gebruikt om tekst te benadrukken. Dit wordt echter vaak bereikt met de <I>-tag, waarbij de nadruk niet door schermlezers wordt aangegeven. Het gebruik van de <I>-tag biedt onvoldoende context en raakt steeds meer achterhaald.",
    "Last 8 Performance Scans Scores": "Scores van de laatste 8 prestatiescans",
    "Latest manual scan finished on [[scannedAt]]": "Laatste handmatige scan voltooid op [[scannedAt]]",
    "Mark this issue as fixed": "Markeer dit probleem als opgelost",
    "Monitor how visitors interact with your pages. Acquia Web Governance tracks up to a maximum of 1000 heatmaps sessions per page per month.": "Volg hoe bezoekers met uw pagina's omgaan. Acquia Web Governance registreert maximaal 1000 heatmapsessies per pagina per maand.",
    "No downloads were found. Try searching for the document URL instead of the document title.": "Er zijn geen downloads gevonden. Probeer te zoeken naar de document-URL in plaats van de documenttitel.",
    "No more PDF accessibility scans are available for this account. Please contact a Acquia Web Governance sales department to add more.": "Er zijn geen PDF-toegankelijkheidsscans meer beschikbaar voor dit account. Neem contact op met een verkoopafdeling van Acquia Web Governance om er meer toe te voegen.",
    "Not valid URL": "Ongeldige URL",
    "PageCorrect failed to save, the Acquia Web Governance team has been notified of the error": "PageCorrect kon niet worden opgeslagen. Het Acquia Web Governance-team is op de hoogte gebracht van de fout.",
    "Pages Without Visits": "Pagina's zonder bezoeken",
    "Part of success criteria [[issueNumber]]": "Onderdeel van succescriteria [[issueNumber]]",
    "Pick any link on your website which you know opens in a new page (social media icons are usually a safe bet) and try to navigate away from the page you are on. If the pop-up doesn't appear it might be because the script has not been applied yet. Give it some time.": "Kies een link op je website waarvan je weet dat die naar een nieuwe pagina opent (social media-iconen zijn meestal een veilige optie) en probeer weg te navigeren van de pagina waarop je je bevindt. Als de pop-up niet verschijnt, kan dit komen doordat het script nog niet is toegepast. Geef het even de tijd.",
    "Policy Scan is no longer valid. Press Run Policy to update Policy Scan details": "Beleidsscan is niet langer geldig. Klik op Beleid uitvoeren om de details van de beleidsscan bij te werken.",
    "Readability Checker": "Leesbaarheidscontrole",
    "Readability Level": "Leesbaarheidsniveau",
    "Readability Summary": "Leesbaarheidssamenvatting",
    "Remove word from Ignored Misspellings": "Verwijder een woord uit de genegeerde spelfouten",
    "Remove word from dictionary": "Woord uit woordenboek verwijderen",
    "Request Remediation from selection": "Verzoek om herstel van selectie",
    "Request failed. Please ensure you have added only text in the input field.": "Aanvraag mislukt. Zorg ervoor dat u alleen tekst in het invoerveld heeft ingevoerd.",
    "Scan stopped successfully": "Scan succesvol gestopt",
    "Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan": "Plan rapporten voor uzelf [[adminText]] per e-mail na elke Acquia Web Governance-scan",
    "Search for content that*": "Zoek naar inhoud die*",
    "Something went wrong. The Acquia Web Governance Team has been notified of this error and will get back to you, as soon as possible.": "Er is iets misgegaan. Het Acquia Web Governance Team is op de hoogte gesteld van deze fout en neemt zo snel mogelijk contact met u op.",
    "Start Cookie Scan": "Cookiescan starten",
    "Start Scan": "Scan starten",
    "Start a new scan to find cookies or add them manually": "Start een nieuwe scan om cookies te vinden of voeg ze handmatig toe",
    "Stop scan": "Scannen stoppen",
    "Switch to Acquia Web Governance classic": "Overstappen naar Acquia Web Governance classic",
    "Test your website's compliance levels ([[level]]) and fix issues that are making it difficult for people with disabilities to use your website": "Test de nalevingsniveaus van uw website ([[level]]) en los problemen op die het voor mensen met een beperking moeilijk maken om uw website te gebruiken",
    "The Acquia Web Governance team is notified and are working on the issue.": "Het Acquia Web Governance-team is op de hoogte gesteld en werkt aan een oplossing voor het probleem.",
    "The Compound Export contains data from the first and last scans within the selected date range. The export does not include data from the following sources:": "De samengestelde export bevat gegevens van de eerste en laatste scans binnen het geselecteerde datumbereik. De export bevat geen gegevens van de volgende bronnen:",
    "The profile has been archived.": "Het profiel is gearchiveerd.",
    "The profile has been restored.": "Het profiel is hersteld.",
    "There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.": "Er is maar één manier om dit te doen. Acquia Web Governance vervangt alle <I>-tags die het op uw website kan vinden door em-tags.",
    "Type in or paste text to be analyzed": "Typ of plak de tekst die geanalyseerd moet worden",
    "URL &amp; Title": "URL en titel",
    "Unignore Misspelling": "Negeer spelfouten niet",
    "Url &amp; Title": "Url en titel",
    "Visitors screen resolutions export": "Schermresoluties van bezoekers exporteren",
    "Weight in score: [[weight]]": "Gewicht in score: [[gewicht]]",
    "Why can't I open a new window without warning?": "Waarom kan ik zonder waarschuwing geen nieuw venster openen?",
    "Why do I need a \\\"skip to content\\\" link?": "Waarom heb ik een 'ga naar inhoud'-link nodig?",
    "Why shouldn't I use the marquee element?": "Waarom zou ik het marquee-element niet gebruiken?",
    "You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here": "U gebruikt de nieuwe versie van Acquia Web Governance PageAssist. Wilt u terug naar versie 1.0? Klik dan hier.",
    "You can only calculate a score for up to [[count]] characters.": "U kunt een score berekenen voor maximaal [[count]] tekens.",
    "You do not have sufficient permissions to use this feature.": "U beschikt niet over voldoende rechten om deze functie te gebruiken.",
    "Your current plan does not include on-demand scans. Please reach out to your Acquia Web Governance representative to learn more about this option": "Uw huidige abonnement omvat geen scans op aanvraag. Neem contact op met uw Acquia Web Governance-vertegenwoordiger voor meer informatie over deze optie.",
    "[[$count]] found": "[[$count]] gevonden",
    "[[count]] found": "[[count]] gevonden",
    "[[headerCount]] found": "[[headerCount]] gevonden",
    "[[pageIssues]] Pages <span>([[errorPercentage]]%)</span> to fix": "[[pageIssues]] Pagina's <span>([[errorPercentage]]%)</span> om te repareren",
    "[[pageIssues]] Pages to fix": "[[pageIssues]] Pagina's om te repareren",
    "[[pagesDone]] Pages ([[compliancePercentage]]) in compliance": "[[pagesDone]] Pagina's ([[compliancePercentage]]) in overeenstemming",
    "[[totalPageIssues]] Pages ([[compliancePercentage]]) to fix": "[[totalPageIssues]] pagina's ([[compliancePercentage]]) om te repareren",
    "failed when trying to ignore/review all. please try agin, or contact the Acquia Web Governance team": "mislukt bij poging om alles te negeren/beoordelen. Probeer het opnieuw of neem contact op met het Acquia Web Governance-team.",
    "policies": "beleid",
    "policy": "beleid",
    "Start export PDF Accessibility Report": "Begin export PDF Accessibility Report",
    "No data showing? Add the Acquia Web Governance script to your website": "Geen statistieken zichtbaar? Voeg het Acquia Web Governance-script toe aan de website."
  },
  "nb": {
    "Search": {
      "Spotlight": "Søk",
      "$$noContext": "Søk"
    },
    "Global Policy Overview": {
      "Topmenu": "Global Policy Oversikt",
      "$$noContext": "Oversikt over globale policies"
    },
    "History Center": {
      "Topmenu": "Historisk Oversikt",
      "$$noContext": "Historisk overblikk"
    },
    "Report Center": {
      "Topmenu": "Rapportsenter",
      "$$noContext": "Rapportsenter"
    },
    "Users": {
      "Topmenu": "Brukere",
      "$$noContext": "Brukere"
    },
    "No content was found": {
      "page-details -> Inventory -> links. No result message": "Ingen innhold ble funnet",
      "$$noContext": "Ingen innhold ble funnet"
    },
    "&nbsp;&nbsp;&nbsp;Passwords does not match": "Passordene stemmer ikke overens",
    "(HTML and documents)": "(HTML og dokumenter)",
    "(No title found)": "(Ingen tittel funnet)",
    "(The HTML snippet is now Marked as Reviewed/Ignored)": "(HTML-utdraget er nå markert som gjennomgått/ignorert)",
    "(This policy is marked as unwanted content)": "(Denne policy er markert som uønsket innhold)",
    "+ Add new check": "+ Legg til ny sjekk",
    "+ Add new user": "+ Legg til ny bruker",
    "1 min.": "1 min.",
    "1 minute": "1 minutt",
    "10 min.": "10 min.",
    "10th to 12th grade": "10. til 12. klasse",
    "120 min.": "120 min.",
    "15 min.": "15 min.",
    "1st": "1.",
    "2nd": "2.",
    "30 min.": "30 min.",
    "3rd": "3.",
    "5 min.": "5 min.",
    "5 minutes": "5 minutter",
    "5th grade": "5.klasse",
    "60 min.": "60 min.",
    "6th grade": "6. klasse",
    "7th grade": "7. klasse",
    "8th to 9th grade": "8. til 9. klasse",
    "A": "A",
    "A list of all external PDF files already reviewed for accessibility issues": "En liste over alle eksterne PDF-filer som allerede er gjennomgått for tilgjengelighetsproblemer",
    "A list of all external PDF files that you need to check for accessibility issues": "En liste over alle eksterne PDF-filer som du skal kontrollere for tilgjengelighetsproblemer",
    "A list of all internal PDF files already reviewed for accessibility issues": "En liste over alle interne PDF-filer som allerede er gjennomgått for tilgjengelighetsproblemer",
    "A list of all internal PDF files that have been marked as failed for accessibility issues": "En liste over alle interne PDF-filer som ikke har bestått en sjekk for tilgjengelighetsproblemer",
    "A list of all internal PDF files that have been marked as queued for accessibility issues": "En liste over alle interne PDF-filer som er satt i kø grunnet tilgjengelighetsproblemer",
    "A list of all internal PDF files that you need to check for accessibility issues": "En liste over alle interne PDF-filer som du skal kontrollere for tilgjengelighetsproblemer",
    "AA": "AA",
    "AAA": "AAA",
    "ACCESSIBILITY OVERVIEW": "TILGJENGELIGHETS OVERSIKT",
    "API Token": "API-token",
    "API URL": "API-URL",
    "API User": "API-bruker",
    "API User Details": "API-brukeropplysninger",
    "API Users": "API-brukere",
    "About": "Om",
    "Accept": "Aksepter",
    "Accessibility": "Tilgjengelighet",
    "Accessibility Check": "Tilgjengelighets sjekk",
    "Accessibility Diagnostics": "Tilgjengelighets diagnostikk",
    "Accessibility Fast Track": "Fast Track for tilgjengelighet",
    "Accessibility Icon": "Tilgjengelighetsikon",
    "Accessibility Snippet": "Berørt kodestykke",
    "Accessibility Source Code": "Kildekode for tilgjengelighets sjekk",
    "Accessibility checks compliance by level": "Overholdelse av tilgjengelighet etter nivå",
    "Accessibility checks not in compliance with domain": "Tilgjengelighets sjekker som ikke er i samsvar med domenet",
    "Accessibility error type": "Tilgjengelighets-feil type",
    "Accessibility errors": "Tilgjengelighets feil",
    "Accessibility fixes": "Rettelser for tilgjengelighet",
    "Accessibility help center": "Hjelp til tilgjengelighet",
    "Accessibility issues": "Problemer med tilgjengelighet",
    "Accessibility level": "Tilgjengelighetsnivå",
    "Accessibility mode": "Tilgjengelighetsmodus",
    "Accessibility review type": "Tilgjengelighetstype",
    "Account dictionary": "Konto ordbok",
    "Action": "Handling",
    "Actions": "Handlinger",
    "Actions per visit": "Handlinger pr. besøk",
    "Active": "Aktiv",
    "Add": "Legg til",
    "Add Custom Multistep Javascript": "Legg til tilpasset flertrinns-Javascript",
    "Add Extension Name": "Legg til utvidelsesnavn",
    "Add Heatmap rule to a Page": "Legg til varmekart-regel på en side",
    "Add Heatmaps": "Legg til varmekart",
    "Add PageAssist script": "Legg til PageAssist-script",
    "Add PageCorrect": "Legg til PageCorrect",
    "Add Profile": "Legg til profil",
    "Add Rule": "Legg til regel",
    "Add Skip to PageAssist": "Legg til Gå til PageAssist",
    "Add a new exemption to your heartbeat check": "Legg til et nytt unntak til din Heartbeat sjekk",
    "Add a new page to start tracking individual pages' performance. Get an overview of load times and opportunities to speed up your site.": "Legg til en ny side for å begynne å spore individuelle siders ytelse. Få en oversikt over lastetider og muligheter for å optimere hastigheten på nettstedet ditt.",
    "Add a non-user email": "Legg til e-post uten Acquia Optimize-konto",
    "Add another rule": "Legg til en annen regel",
    "Add email": "Legg til e-post",
    "Add exemption": "Legg til unntak",
    "Add new check": "Legg til ny sjekk",
    "Add new domain": "Legg til nytt domene",
    "Add new exemption": "Legg til nytt unntak",
    "Add new label": "Legg til ny etikett",
    "Add new page": "Legg til ny side",
    "Add new policy": "Legg til ny policy",
    "Add new user": "Legg til ny bruker",
    "Add non users": "Legg til ikke-brukere",
    "Add reason (Optional)": "Legg til begrunnelse (valgfritt)",
    "Add rule to policy": "Tilføy regel til policy",
    "Add rule to the policy": "Tilføy regel til policy",
    "Add task": "Legg til oppgave",
    "Add timeslots where you won't receive notifications on downtime and slow responsetimes.": "Legg til tidsintervaller der du ikke vil motta varsler om nedetid og treg responstid.",
    "Add to all languages": "Legg til for alle språk",
    "Add to dictionary": "Legg til i ordboken",
    "Add to dictionary for all languages": "Legg til i ordboken for alle språk",
    "Added": "Lagt til",
    "Added by": "Lagt til av",
    "Added date": "Dato lagt til",
    "Address": "Adresse",
    "Admin": "Administrator",
    "Advanced Domain Options": "Avanserte domeneinnstillinger",
    "Affected image": "Berørt bilde",
    "Affected pages": "Berørte sider",
    "Affected pages by priority": "Berørte sider etter prioritet",
    "Affected pages by severity": "Berørte sider etter alvorlighetsgrad",
    "Affects": "Påvirker",
    "After": "Etter",
    "All": "Alle",
    "All Failed Internal PDF files": "Alle interne PDF-filer med feil",
    "All Pending External PDF files": "Alle eksterne PDF-filer på vent",
    "All Pending Internal PDF files": "Alle interne PDF-filer på vent",
    "All Queued Internal PDF files": "Alle interne PDF-filer i kø",
    "All Reviewed External PDF files": "Alle gjennomgåtte eksterne PDF-filer",
    "All Reviewed Internal PDF files": "Alle gjennomgåtte interne PDF-filer",
    "All assets": "Alle ressurser",
    "All broken images": "Alle brutte bilder",
    "All broken links": "Alle brutte lenker",
    "All heartbeat checkpoints": "Alle Heartbeat-sjekker",
    "All incident checkpoints in the selected time span": "Alle hendelseskontrollpunkter i det valgte tidsrom",
    "All level A accessibility checks": "Alle sjekker for tilgjengelighet på nivå A",
    "All level AA accessibility checks": "Alle sjekker for tilgjengelighet på nivå AA",
    "All level AAA accessibility checks": "Alle sjekker for tilgjengelighet på nivå AAA",
    "All levels": "Alle nivåer",
    "All modules": "Alle moduler",
    "All modules - Content with Issues": "Alle moduler - Innhold med problemer",
    "All notifications": "Alle varsler",
    "All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.": "Alt du trenger å gjøre er å sette inn skriptet nedenfor i nettsidens BODY-tag. Bare kopier og lim det inn som det er.",
    "Analytics (Last 7 days)": "Analyse (Siste 7 dager)",
    "And": "Og",
    "Appears on": "Vises på",
    "Apply": "Søk",
    "Archive": "Arkiv",
    "Archive files": "Arkivér filer",
    "Archived": "Arkivert",
    "Are you sure you want to Mark this link as unignored?": "Er du sikker på at du ikke lengre vil markere lenken som ignorert?",
    "Are you sure you want to Request All PDF Accessibility checks?": "Er du sikker på at du vil forespørre alle PDF-tilgjengelighetssjekker?",
    "Are you sure you want to add to Request PDF Accessibility check from selection?": "Er du sikker på at du vil legge til forespørsel om PDF-tilgjengelighetssjekk fra de valgte?",
    "Are you sure you want to add to all the dictionaries?": "Er du sikker på at du vil legge til i alle ordbøker?",
    "Are you sure you want to add to the dictionary?": "Er du sikker på at du vil legge til i ordboken?",
    "Are you sure you want to close this form without saving your changes?": "Er du sikker på at du vil avslutte uten å lagre endringene?",
    "Are you sure you want to confirm this misspelling?": "Er du sikker på at du vil bekrefte denne stavefeilen?",
    "Are you sure you want to delete the API User [[apiUserId]]": "Er du sikker på at du vil slette API-brukeren [[apiUserId]]",
    "Are you sure you want to delete this exemption?": "Er du sikker på at du vil slette dette unntaket?",
    "Are you sure you want to delete this source exclude?": "Er du sikker på at du vil slette denne kildeekskluderingen?",
    "Are you sure you want to ignore all errors for this check?": "Er du sikker på at du vil ignorere alle feil på denne sjekken?",
    "Are you sure you want to ignore the selected issue on this page?": "Er du sikker på at du vil ignorere det valgte problem på denne siden?",
    "Are you sure you want to ignore this check for this domain?": "Er du sikker på at du vil ignorere denne sjekken for dette domenet?",
    "Are you sure you want to ignore this check for this page?": "Er du sikker på at du vil ignorere denne sjekken for denne siden?",
    "Are you sure you want to ignore this issue?": "Er du sikker på at du vil ignorere dette problemet?",
    "Are you sure you want to ignore this misspelling?": "Er du sikker på at du vil ignorere denne stavefeilen?",
    "Are you sure you want to mark this issue as fixed?": "Er du sikker på at du vil markere dette problemet som rettet?",
    "Are you sure you want to mark this issue as not fixed?": "Er du sikker på at du vil markere dette problemet som ikke rettet?",
    "Are you sure you want to mark this link as fixed?": "Er du sikker på at du vil markere denne lenken som rettet?",
    "Are you sure you want to mark this link as ignored?": "Er du sikker på at du vil markere denne lenken som ignorert?",
    "Are you sure you want to mark this link as not fixed?": "Er du sikker på at du vil markere denne lenken som ikke rettet?",
    "Are you sure you want to remove manually added user?": "Er du sikker på at du vil fjerne en bruker som er manuelt lagt til?",
    "Are you sure you want to remove review for this issue?": "Er du sikker på at du vil fjerne gjennomgangen av dette problemet?",
    "Are you sure you want to remove review on all errors for this check?": "Er du sikker på at du vil fjerne gjennomgangen av alle feil for denne sjekken?",
    "Are you sure you want to remove this group?": "Er du sikker på at du vil fjerne denne gruppen?",
    "Are you sure you want to remove this host?": "Er du sikker på at du vil fjerne denne verten?",
    "Are you sure you want to remove this rule?": "Er du sikker på at du vil fjerne denne regelen?",
    "Are you sure you want to remove this?": "Er du sikker på at du vil fjerne dette?",
    "Are you sure you want to review all errors for this check?": "Er du sikker på at du vil gjennomgå alle feil for denne sjekken?",
    "Are you sure you want to review this issue?": "Er du sikker på at du vil gjennomgå dette problemet?",
    "Are you sure you want to set this document as reviewed?": "Er du sikker på at du vil markere dette dokumentet som gjennomgått?",
    "Are you sure you want to start on-demand scan?": "Er du sikker på at du vil starte en on-demand skanning?",
    "Are you sure you want to stop current crawl?": "Er du sikker på at du vil stoppe det aktuelle crawl?",
    "Are you sure you want to the request ADA clarification for [[name]]?": "Er du sikker på at du vil forespørre en ADA-avklaring for [[name]]?",
    "Are you sure you want to undo review of this document?": "Er du sikker på at du vil angre gjennomgangen av dette dokumentet?",
    "Are you sure you want to undo reviewing this document?": "Er du sikker på at du vil angre gjennomgangen av dette dokumentet?",
    "Are you sure you want to unignore all errors for this check?": "Er du sikker på at du vil fjerne ignorering av alle feil for denne sjekken?",
    "Are you sure you want to unignore the selected issue on this page?": "Er du sikker på at du vil fjerne ignoreringen av det valgte emnet på denne siden?",
    "Are you sure you want to unignore this check for this domain?": "Er du sikker på at du vil fjerne ignoreringen av denne sjekken for dette domenet?",
    "Are you sure you want to unignore this check for this page?": "Er du sikker på at du vil fjerne ignoreringen av denne sjekken for denne siden?",
    "Are you sure you want to unignore this issue?": "Er du sikker på at du vil fjerne ignoreringen av dette problemet?",
    "Are you sure you want to unignore this link?": "Er du sikker på at du vil fjerne ignoreringen av denne lenken?",
    "Are you sure you want to unignore this misspelling?": "Er du sikker på at du vil fjerne ignoreringen av denne stavefeilen?",
    "Are you sure you want to unpin this domain": "Er du sikker på at du vil frigjøre dette domenet?",
    "Are you sure you want unignore this link?": "Er du sikker på at du vil fjerne ignoreringen av denne lenken?",
    "Assign Heatmap Rule": "Tildel Varmekart-regel",
    "Assign to the Performance Module": "Tildel til Performance modulen",
    "Attribute": "Egenskap",
    "Audit": "Revidere",
    "Audit Log": "Endringshistorikk",
    "Autoselect": "Velg automatisk",
    "Average First Contentful Paint": "Gjennomsnittlig First Contentful Paint",
    "Average First Meaningful Paint": "Gjennomsnittlig First Meaningful Paint",
    "Average Performance Score": "Gjennomsnittlig Performance score",
    "Average Performance score": "Gjennomsnittlig Performance score",
    "Average Time to Interactive": "Gjennomsnittlig tid til interaktivitet",
    "Average response time": "Gjennomsnittlig svartid",
    "Average time": "Gjennomsnittlig tid",
    "Average uptime": "Gjennomsnittlig oppetid",
    "Average visit time": "Gjennomsnittlig besøkstid",
    "Avg. Performance Score": "Gj.snitt Performance Score",
    "Avg. Visit Time": "Gj.snitt Besøkstid",
    "Avg. response": "Gj.snitt respons",
    "BETA": "BETA",
    "Back": "Tilbake",
    "Back to Heartbeat Overview": "Tilbake til Heartbeat Oversikt",
    "Bar": "Bar",
    "Basic Auth": "Basic Auth",
    "Before": "Før",
    "Below 5th grade": "Under 5. klasse",
    "Below you can see a list of all pages that contains the title": "Nedenfor kan du se en liste over alle sider som inneholder tittelen",
    "Book online training": "Book online trening",
    "Bounce Rates": "Bounce Rates",
    "Bounce rate": "Bounce rate",
    "Bounce rates": "Bounce rates",
    "Brand name": "Merkenavn",
    "Broken Image": "Brutt bilde",
    "Broken Image Links per page": "Brutte bildelenker pr. side",
    "Broken Images": "Brutte bilder",
    "Broken Links": "Brutte lenker",
    "Broken Page Link": "Brutte sidelenker",
    "Broken image affecting most content": "Brutt bilde som påvirker mest innhold",
    "Broken image affecting most pages": "Brutt bilde som påvirker flest sider",
    "Broken images": "Brutte bilder",
    "Broken images with page count": "Brutte bilder med sideantall",
    "Broken link": "Brutt lenke",
    "Broken link affecting most content": "Brutt lenke som påvirker mest innhold",
    "Broken link affecting most pages": "Brutt lenke som påvirker flest sider",
    "Broken links": "Brutte lenker",
    "Broken links per page": "Brutte lenker pr. side",
    "Broken links with page count": "Brutte lenker med sideantall",
    "Browser": "Nettleser",
    "Browser Extension": "Nettleser-utvidelse",
    "Browsers": "Nettlesere",
    "Browsers Overview": "Nettleser oversikt",
    "Bubble": "Bobler",
    "Build it from scratch": "Bygg det fra bunnen av",
    "By deleting this domain all domain groups related to this domain, will also be deleted": "Ved å slette dette domenet, slettes også alle domenegrupper tilhørende dette domenet",
    "By user": "Etter bruker",
    "CMS": "CMS",
    "CMS url": "CMS url",
    "CSS": "CSS",
    "CSS Target Selector": "CSS Target Selector",
    "CSS id or class selector to search for": "CSS id eller klasse-velger, som skal søkes etter",
    "CSS selector to find submit button": "CSS-selector, som skal finne send-knappen",
    "Cache TTL": "Cache TTL",
    "Cancel": "Avbryt",
    "Case sensitive": "Sensitiv for store/små bokstaver",
    "Categories": "Kategorier",
    "Category": "Kategori",
    "Change password": "Endre passord",
    "Changed to": "Endret til",
    "Changes": "Endringer",
    "Changes added": "Endringer lagt til",
    "Changes in selected time frame:": "Endringer i valgt tidsramme:",
    "Changes since Previous Crawl": "Endringer siden forrige crawl",
    "Changes since previous crawl": "Endringer siden forrige crawl",
    "Characters": "Tegn",
    "Chart": "Diagram",
    "Chart is now showing: [[name]]": "Diagrammet viser nå: [[name]]",
    "Check": "Sjekk",
    "Check List Export": "Sjekkliste eksport",
    "Check all links in this section": "Sjekk alle lenker i dette avsnittet",
    "Check all misspellings in this section": "Sjekk alle stavefeil i dette avsnittet",
    "Check all modules": "Sjekk alle moduler",
    "Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)": "Sjekk og rett innholds problemer på tvers av nettstedet ditt (dvs. stavefeil, brutte lenker, lesbarhet og andre problemer)",
    "Check frequency": "Frekvens for sjekk",
    "Check frequency:": "Frekvens for sjekk:",
    "Check is ignored": "Sjekken ignoreres",
    "Check is ignored for the entire domain": "Sjekken ignoreres for hele domenet",
    "Check link": "Sjekk lenke",
    "Check misspelling": "Sjekk stavefeil",
    "Check name": "Sjekk navn",
    "Check off as Reviewed": "Kryss av som gjennomgått",
    "Check passed": "Bestått sjekk",
    "Check site status": "Sjekk status på siden",
    "Checking": "Sjekker",
    "Checkpoint exemptions": "Unntak for sjekkpunkt",
    "Checkpoint has been updated.": "Sjekkpunktet er oppdatert.",
    "Checkpoint information": "Informasjon om sjekkpunktet",
    "Checkpoint:": "Sjekkpunkt:",
    "Checks": "Sjekker",
    "Checks passed": "Beståtte sjekker",
    "Checks whether your website is responding and measures the response time of the server": "Sjekker om nettstedet ditt reagerer, og måler serverens responstid",
    "Choose Operator": "Velg operatør",
    "Choose What to Scan": "Velg hva som skal skannes",
    "Choose a response time": "Velg en svartid",
    "Choose a response time notification": "Velg et svartid varsel",
    "Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned": "Velg en eksisterende personvernbestemmelse (for eksempel GDPR) som standardmal for sikkerhetsskanningen. Rediger problemene nedenfor for å ekskludere visse koder fra skanningen.",
    "Choose checks": "Velg sjekker",
    "Choose domains": "Velg domener",
    "Choose how to view the Heatmaps Dashboard": "Velg hvordan du får vist Varmekarts Dashbord",
    "Choose notification time": "Velg tidspunkt for varsel",
    "Choose the minimum amount of words to scan for readability on a page": "Velg det minste antallet ord som skal skannes for lesbarhet på en side",
    "Choose where the policy should apply": "Velg hvor policien skal gjelde",
    "Chrome extension": "Chrome extention",
    "City": "By",
    "Clear all labels": "Fjern alle etiketter",
    "Clear and close filters": "Tøm og lukk filtre",
    "Click here to create your first policy": "Klikk her for å opprette din første policy",
    "Click here to edit": "Klikk her for å redigere",
    "Click to create your first policy": "Klikk for å opprette din første policy",
    "Clone": "Klone",
    "Close": "Lukk",
    "Close filters": "Lukk filtre",
    "Collapse": "Skjul",
    "Collapse menu": "Skjul meny",
    "College": "Universitet",
    "College graduate": "Universitetsutdannet",
    "Coming soon": "Kommer snart",
    "Comment": "Kommentar",
    "Common policy violations": "Typiske brudd på policy",
    "Company Info": "Firmainformasjon",
    "Compliance": "Compliance",
    "Compliance {{compliancePercentage}}": "Compliance {{compliancePercentage}}",
    "Compound Export": "Sammensatt eksport",
    "Compound Report": "Sammensatt rapport",
    "Confirm": "Bekreft",
    "Confirm as misspelling": "Bekreft som stavefeil",
    "Confirm misspelling": "Bekreft stavefeil",
    "Confirm this word as a misspelling": "Bekreft dette ordet som stavefeil",
    "Confirmed": "Bekreftet",
    "Confirmed misspellings": "Bekreftede stavefeil",
    "Congratulations no violations were found": "Gratulerer, ingen brudd funnet",
    "Connection Profile": "Forbindelsesprofil",
    "Connections per minute": "Forbindelser pr. minutt",
    "Constraint": "Begrensning",
    "Constraint pattern": "Begrensningsmønster",
    "Contact me about more Performance Pages": "Kontakt meg for flere Performance-sider",
    "Contact me about more performance profiles": "Kontakt meg for flere Performance-profiler",
    "Containing": "Inneholder",
    "Contains": "Inneholder",
    "Contains confirmed misspellings, broken links & images": "Inneholder bekreftede stavefeil, brutte lenker og bilder",
    "Contains confirmed misspellings, broken links or images": "Inneholder bekreftede stavefeil, brutte lenker og bilder",
    "Contains high, medium & low opportunities for all pages": "Inneholder høye, middels og lave muligheter for alle sider",
    "Contains high, medium & low severity issues for all pages": "Inneholder problemer med høy, middels og lav alvorlighetsgrad for alle sider",
    "Contains issues with high, medium and low priority for all pages": "Inneholder problemer med høy, middels og lav prioritet for alle sider",
    "Content": "Innhold",
    "Content Links": "Lenker til innhold",
    "Content Policies": "Policies for innhold",
    "Content Policy Violations": "Innholds-policy brudd",
    "Content in compliance": "Innhold i compliance",
    "Content must be robust enough that it can be interpreted reliably by a wide variety of user agents, including assistive technologies.": "Innholdet må være robust nok til å kunne tolkes pålitelig av et bredt spekter av brukerteknologier, inkludert tekniske hjelpemidler som skjermlesere.",
    "Content policies": "Innholds-policy",
    "Content with Broken Image": "Innhold med brutt bilde",
    "Content with Broken Link": "Innhold med brutt lenke",
    "Content with Broken Links": "Innhold med brutte lenker",
    "Content with Data Issues": "Innhold med dataproblemer",
    "Content with Data Issues export": "Eksport for innhold med dataproblemer",
    "Content with Policy Matches": "Innhold med Policy-overensstemmelser",
    "Content with QA Errors": "Innhold med kvalitetssikringsfeil",
    "Content with broken links": "Innhold med brutte lenker",
    "Content with issues": "Innhold med problemer",
    "Content with policy violations": "Innhold med policy-brudd",
    "Content with violations": "Innhold med brudd",
    "Context": "Sammenheng",
    "Country": "Land",
    "Crawl Automatically": "Crawl automatisk",
    "Crawl Options": "Innstillinger for crawl",
    "Crawl done on": "Crawl gjennomført den",
    "Crawl finalized on": "Crawl avsluttet den",
    "Crawl info": "Crawl info",
    "Crawl runtime:": "Crawl tid:",
    "Crawl started:": "Crawl startet:",
    "Crawl status": "Crawl status",
    "Crawl status:": "Crawl status:",
    "Crawled Documents ([[documentCount]])": "Crawlede dokumenter ([[documentCount]])",
    "Crawled at": "Crawled på",
    "Crawled pages": "Crawlede sider",
    "Crawling": "Crawling",
    "Create a policy to make an email as unwanted content": "Opprett en policy for å markere en e-post som uønsket innhold",
    "Create as policy": "Opprett som policy",
    "Create label": "Opprett etikett",
    "Create new domain group": "Opprett ny domenegruppe",
    "Create new group": "Opprett ny gruppe",
    "Create user": "Opprett bruker",
    "Create your own policy": "Opprett din egen policy",
    "Created": "Opprettet",
    "Created At": "Opprettet den",
    "Created at": "Opprettet den",
    "Created date": "Opprettet dato",
    "Created:": "Opprettet:",
    "Current domain status": "Nåværende domenestatus",
    "Current status": "Nåværende status",
    "Custom": "Egendefinert",
    "Custom Multistep": "Egendefinert i flere trinn",
    "Custom Profile": "Egendefinert profil",
    "Custom fixes": "Egendefinerte rettelser",
    "Custom rule": "Egendefinert regel",
    "Customer": "Kunde",
    "Customer Report": "Kunderapport",
    "DATA PRIVACY OVERVIEW": "OVERSIKT OVER PERSONVERN",
    "DISCLAIMER": "ANSVARSFRASKRIVELSE",
    "Daily": "Daglige",
    "Danish": "Dansk",
    "Dark": "Mørk",
    "Dashboard": "Dashbord",
    "Data Issues": "Personvern problemer",
    "Data Privacy": "Personvern",
    "Data Privacy Diagnostics": "Diagnostisering av personvern",
    "Data Privacy Fast Track": "Fast Track for personvern",
    "Data Privacy Help Center": "Hjelp til personvern",
    "Data Privacy Info Type Icon": "Ikon for infotypen",
    "Data Privacy Issues": "Personvern problemer",
    "Data Privacy Summary Export": "Eksport personvern sammendrag",
    "Data Privacy issues found": "Oppdagede personvern problemer",
    "Data Regulations": "Dataregler",
    "Data Violations": "Databrudd",
    "Data issues": "Personvern problemer",
    "Data issues export": "Eksport av personvern problemer",
    "Data privacy": "Personvern",
    "Data privacy violations": "Personvernbrudd",
    "Data protection and privacy policy statement": "Personvernerklæring og personvernspolicy",
    "Date": "Dato",
    "Day": "Dag",
    "Days": "Dager",
    "Dead": "Død",
    "Default": "Standard",
    "Default for CMS": "Standard for CMS",
    "Default value*": "Standard verdi*",
    "Define meta headers to match": "Definer meta-overskrifter som skal matche",
    "Define size of files to look for": "Definer størrelsen på filer som skal søkes etter",
    "Define size of images to look for": "Definer størrelsen på bilder som skal søkes etter",
    "Delete": "Slett",
    "Delete All": "Slett alt",
    "Delete user": "Slett bruker",
    "Describe the exclude": "Beskriv ekskluderingen",
    "Description": "Beskrivelse",
    "Desktop": "Skrivebord",
    "Details": "Detaljer",
    "Device": "Enhet",
    "Device Overview": "Enhets oversikt",
    "Device not found": "Enhet ikke funnet",
    "Device:": "Enhet:",
    "Devices": "Enheter",
    "Diagnostics": "Diagnostikk",
    "Dictionary": "Ordbok",
    "Difficulty": "Vanskelighet",
    "Direct visits": "Direkte besøk",
    "Disabling": "Deaktivering",
    "Display policy in other services": "Vis policy i andre tjenester",
    "Display this policy as:": "Vis denne policy som:",
    "Distribution of Data Privacy levels": "Fordeling av personvern nivåer",
    "Distribution of PageCorrects across all change types": "Fordeling av PageCorrects på tvers av alle endringstyper",
    "Distribution of SEO levels": "Fordeling av SEO-nivåer",
    "Distribution of policies that match their corresponding setting": "Fordeling av policies som matcher deres tilsvarende innstilling",
    "Distribution of policies that matches their corresponding setting": "Fordeling av policies som matcher deres tilsvarende innstilling",
    "Do you want the policy to run every time your website is crawled?": "Ønsker du at denne policy skal kjøres hver gang nettstedet ditt blir crawlet?",
    "Do you want to find pages which match the query on one or multiple lines?": "Ønsker du å finne sider som matcher forespørselen på en eller flere linjer?",
    "Do you want to find pages which match the query or pages which does not match the query": "Ønsker du å finne sider som matcher forespørselen, eller sider som ikke matcher forespørselen?",
    "Do you want to update the Script Settings, for this Domain?": "Ønsker du å oppdatere innstillinger til Scripts for dette domenet?",
    "Document": "Dokument",
    "Document Class": "Dokumentklasse",
    "Document Dashboard": "Dokument dashbord",
    "Document Details": "Dokumentopplysninger",
    "Document Extension": "Dokument Extension",
    "Document Ignore Class": "Ignorerer dokumentklasse",
    "Document first detected": "Dokumentet ble først registrert",
    "Document scan": "Dokumentskanning",
    "Documents": "Dokumenter",
    "Documents Crawled": "Crawlede dokumenter",
    "Documents basic": "Grunnleggende dokumenter",
    "Documents crawled": "Crawlede dokumenter",
    "Documents extended": "Dokumenter - utvidet",
    "Documents with Broken Image": "Dokumenter med brutt bilde",
    "Documents with Broken Link": "Dokumenter med brutt lenke",
    "Domain": "Domene",
    "Domain Compliance": "Domenets compliance",
    "Domain Data Privacy Settings": "Innstillinger for personvern på domenet",
    "Domain Detail": "Domene detaljer",
    "Domain Details": "Domene opplysninger",
    "Domain Groups": "Domene grupper",
    "Domain Picker Closed": "Domenevelger lukket",
    "Domain Picker Opened": "Domenevelger åpnet",
    "Domain compliance": "Domenets compliance",
    "Domain group": "Domene gruppe",
    "Domain title and URL": "Domenetittel og URL",
    "Domain:": "Domene:",
    "Domains": "Domener",
    "Domains/groups selected": "Domener/grupper valgt",
    "Done": "Ferdig",
    "Download": "Last ned",
    "Download the Chrome extension": "Last ned Chrome-extension",
    "Download the Edge add-on": "Last ned Edge add-on",
    "Download the Firefox add-on": "Last ned Firefox add-on",
    "Downloads": "Nedlastninger",
    "Downtime": "Nedetid",
    "Downtime (Minutes)": "Nedetid (minutter)",
    "Downtime notification": "Varsel om nedetid",
    "Drag and drop the rule to add rules to the policy": "Dra og slipp regelen for å legge til regler til policyen",
    "Dropdown": "Dropdown",
    "Duration": "Varighet",
    "Easy": "Lett",
    "Easy to read pages understood by most. Example: fiction literature for adults": "Lett å lese sider forstått av de fleste. Eksempel: Fiksjonslitteratur for voksne",
    "Edge add-on": "Edge add-on",
    "Edit": "Rediger",
    "Edit Labels": "Rediger etiketter",
    "Edit Performance Page": "Rediger Performance-side",
    "Edit customer information": "Rediger kundeopplysninger",
    "Edit domain": "Rediger domene",
    "Edit domain group": "Rediger domenegruppe",
    "Edit exemption": "Rediger unntak",
    "Edit label": "Rediger etikett",
    "Edit labels": "Rediger etiketter",
    "Edit my profile": "Rediger min profil",
    "Edit or Delete PageCorrect": "Rediger eller slett PageCorrect",
    "Edit uptime": "Rediger oppetid",
    "Edit user": "Rediger bruker",
    "Edit users": "Rediger brukere",
    "Edit your exemption": "Rediger unntaket ditt",
    "Edit:": "Rediger:",
    "Effect on compliance": "Effekt på compliance",
    "Effect on overall compliance level": "Effekt på det samlede compliance-nivå",
    "Element": "Element",
    "Element Tree Path": "Forgrening av elementer",
    "Email": "E-post",
    "Email Notifications": "E-post varsler",
    "Email addresses": "E-postadresse",
    "Email receiver *": "E-post mottaker*",
    "Email to login": "E-post for å logge inn",
    "Emails": "E-poster",
    "Empty": "Tom",
    "Empty mailto": "Tom mailto",
    "Enable / Disable Accessibility mode": "Aktivér / deaktiver Tilgjengelighets modus",
    "Enable Document Tracking": "Aktivér dokumentsporing",
    "Enable Export Email Notification": "Aktivér Eksport E-post varsler",
    "Enable Statistics": "Aktivér statistikk",
    "Enabled features": "Aktiverte funksjoner",
    "Enabling": "Muliggjør",
    "End at": "Slutt",
    "End date": "Sluttdato",
    "End time": "Sluttid",
    "English": "Engelsk",
    "Enter the full URL": "Inntast den fulle URL",
    "Entries": "Innganger",
    "Entry": "Inngang",
    "Entry Pages": "Startsider",
    "Entry and Exit Pages": "Startsider og utgangssider",
    "Error": "Feil",
    "Error Name": "Navn på feil",
    "Errors": "Feil",
    "Errors ([[audits]])": "Feil ([[audits]])",
    "Exact": "Nøyaktig",
    "Example: academic publications": "Eksempel: akademiske publikasjoner",
    "Example: children's literature": "Eksempel: barnelitteratur",
    "Example: daily newspapers": "Eksempel: daglige aviser",
    "Example: fiction books": "Eksempel: fiksjonsbøker",
    "Example: legal texts": "Eksempel: juridiske tekster",
    "Examples": "Eksempler",
    "Excel Documents": "Excel dokumenter",
    "Exclude": "Ekskluder",
    "Exclude links that contains class name": "Ekskluder lenker som inneholder klassenavnet",
    "Exclude pattern": "Ekskluderingsmønster",
    "Excluded IP addresses from statistics": "Ekskludert IP-adresse fra statistikk",
    "Exemption": "Unntak",
    "Exemption options": "Muligheter for unntak",
    "Exemption time": "Tidspunkt for unntak",
    "Exemptions": "Unntak",
    "Exit Pages": "Utgangssider",
    "Exits": "Utganger",
    "Expand": "Utvid",
    "Explain the rationale behind the policy and which actions, editors should take to correct the violation": "Forklar begrunnelsen bak denne policien samt hva som skal gjøres for å rette bruddet",
    "Export": "Eksport",
    "Export CSV": "Eksporter CSV",
    "Export Compound CSV": "Eksporter kombinert CSV",
    "Export Logs": "Eksporter logger",
    "Export list of broken images organized by page and document title": "Eksporter liste over brutte bilder organisert etter side og dokumenttittel",
    "Export list of broken links organized by page and document title": "Eksporter liste over brutte lenker organisert etter side og dokumenttittel",
    "Export list of downtimes for the domain": "Eksporter liste med nedetid for domenet",
    "Export list of response times": "Eksporter liste over svartid",
    "External": "Ekstern",
    "External Export": "Ekstern eksport",
    "External PDF Compliance": "Ekstern PDF-compliance",
    "External PDFs": "Eksterne PDF-filer",
    "External Referring Domains": "Eksterne henvisende domener",
    "External Referring domains": "Eksterne henvisende domener",
    "External referees overview": "Oversikt over ekstern henvisning",
    "External referring domains": "Eksterne domene-henvisninger",
    "FCP": "FCP",
    "FMP": "FMP",
    "Facebook": "Facebook",
    "Fail Example": "Feileksempel",
    "Failed": "Feilet",
    "Failing accessibility checks": "Feilede tilgjengelighetssjekker",
    "Failing accessibility checks gives you information about the current Accessibility status of the website/group. It may vary from the history if there have been changes in ignored and review of accessibility issues": "Feilede tilgjengelighetssjekker gir deg informasjon om gjeldende tilgjengelighetsstatus for nettsiden / gruppen. Den kan variere fra historikken hvis det har vært endringer i de gjennomgåtte og ignorerte tilgjengelighetsproblemene.",
    "Failing check": "Feilende sjekk",
    "Failing check found": "Feilende sjekker funnet",
    "Failing checks": "Feilende sjekker",
    "Failing checks found": "Feilende sjekker funnet",
    "Fast Track": "Fast Track",
    "Fast track html snippet": "Fast track HTML-snippet",
    "Faster": "Fortere",
    "Features": "Funksjoner",
    "Feedback submitted": "Tilbakemelding innsendt",
    "File size": "Filstørrelse",
    "Filter": "Filter",
    "Filter by": "Sorter etter",
    "Filter by:": "Sorter etter:",
    "Filter labels list": "Filtrer etikettliste",
    "Find and address violations relating to your content guides and regulatory compliance and find outdated content across your website.": "Finn og adressér brudd knyttet til dine innholdsretningslinjer og lovgivningsoverholdelse, og identifiser utdatert innhold på tvers av nettstedet ditt.",
    "Find word(s) without specific context": "Finn ord uten spesifikk kontekst",
    "Firefox add-on": "Firefox add-on",
    "First Contentful Paint": "First Contentful Paint",
    "First Meaningful Paint": "First Meaningful Paint",
    "First name": "Fornavn",
    "Fixed": "Rettet",
    "Fixed or ignored violations": "Rettede eller ignorerte brudd",
    "Flesch Kincaid": "Flesch Kincaid",
    "For this domain": "For dette domenet",
    "Form": "Skjema",
    "Form fields": "Skjemafelt",
    "Forms": "Skjemaer",
    "Found": "Funnet",
    "Four times a day": "Fire ganger om dagen",
    "Frames": "Rammer",
    "Friday": "Fredag",
    "From 2 seconds to 8 seconds": "Fra 2 sekunder til 8 sekunder",
    "Generating report": "Genererer rapport",
    "Get advice on how to handle this check": "Få råd om hvordan du håndterer denne sjekken",
    "Getting {{ logs }} out of {{totalLogs}} logs": "Finner {{logs}} ut av i alt {{totalLogs}} logger",
    "Global - All Domains": "Global - Alle domener",
    "Global Policies": "Globale policies",
    "Global Policy Dashboard": "Dashbord over globale policies",
    "Global Policy List": "Liste over globale policies",
    "Go to Global Policy List": "Gå til liste med globale policies",
    "Go to My Exports": "Gå til Mine Eksporter",
    "Go to PDFs": "Gå til PDF-filer",
    "Go to Policy List": "Gå til Liste over policies",
    "Go to broken Links": "Gå til brutte lenker",
    "Go to broken images": "Gå til brutte bilder",
    "Go to broken links": "Gå til brutte lenker",
    "Go to checkpoints": "Gå til checkpoints",
    "Go to data issues": "Gå til personvern-problemer",
    "Go to domain": "Gå til domene",
    "Go to help center": "Gå til hjelp",
    "Go to mispellings": "Gå til stavefeil",
    "Go to misspellings": "Gå til stavefeil",
    "Go to most visits pages": "Gå til mest besøkte sider",
    "Go to page": "Gå til side",
    "Go to page details": "Gå til sidedetaljer",
    "Go to potential misspellings": "Gå til potensielle stavefeil",
    "Go to predefined url": "Gå til forhåndsdefinert url",
    "Go to the dashboard": "Gå til dashbord",
    "Go to traffic sources overview": "Gå til oversikt over trafikkilder",
    "Go to uptime": "Gå til oppetid",
    "Go to visitor overview": "Gå til oversikt over besøkende",
    "Good job! No incidents was registered": "Godt jobbet! Ingen hendelser ble registrert",
    "Good job! No issues were found": "Godt jobbet! Ingen problemer ble funnet",
    "Good job! No violations were found": "Godt jobbet! Ingen brudd ble funnet",
    "Google": "Google",
    "Greater than 8 seconds": "Mer enn 8 sekunder",
    "Grid View": "Rutenett visning",
    "Groups": "Grupper",
    "Guidelines": "Retningslinjer",
    "Guidelines for WCAG 2.0": "Retningslinjer for WCAG 2.0",
    "Guidelines for WCAG 2.1": "Retningslinjer for WCAG 2.1",
    "H1 on this page": "H1 på denne siden",
    "HTML": "HTML",
    "HTML Pages": "HTML-sider",
    "HTML pages": "HTML-sider",
    "HTML snippet": "HTML-kodestykke",
    "HTML snippet affecting compliance level": "HTML-kodestykke som påvirker compliance nivå",
    "HTML snippet failing check": "HTML-kodestykke med feilende sjekk",
    "Hard": "Vanskelig",
    "Hard to read text. Example: popular science magazines and easier academic publications": "Teksten er vanskelig å lese. Eksempel: Populære vitenskapelige magasiner og lettere akademiske publikasjoner",
    "Harmony CMS": "Harmony CMS",
    "Header type": "Header-type",
    "Headers": "Overskrifter",
    "Headlinks": "Hovedlenker",
    "Heartbeat": "Heartbeat",
    "Heartbeat Downtime": "Heartbeat nedetid",
    "Heartbeat Response Time": "Heartbeat-svartid",
    "Heartbeat status saved": "Heartbeat-status lagret",
    "Heatmaps": {
      "$$noContext": "Varmekart",
      "Topmenu": "Varmekart"
    },
    "Help Center": "Hjelpesenter",
    "Help center": "Hjelpesenter",
    "High": "Høy",
    "High impact": "Høy påvirkning",
    "High impact opportunities": "Muligheter med stor påvirkning",
    "High priority": "Høy prioritet",
    "High severity": "Høy alvorlighetsgrad",
    "High severity issues": "Problemer med høy alvorlighetsgrad",
    "Highest level of readability. Example: complex academic and legal texts": "Høyeste nivå av lesbarhet. Eksempel: komplekse akademiske og juridiske tekster",
    "History": "Historie",
    "Hit": "Treff",
    "Hits": "Treff",
    "Hits across all domains and modules": "Treff på tvers av alle domener og moduler",
    "Hits on domain": "Treff på domene",
    "Home": "Hjem",
    "Host": "Host",
    "Hosts": "Hosts",
    "Hosts cannot be empty": "Hosts kan ikke være tomme",
    "Hours": "Timer",
    "How often the page is checked": "Hvor ofte siden gjennomgås",
    "How to fix this problem": "Slik løses dette problemet",
    "How to prevent": "Slik forhindres",
    "How to setup this policy": "Slik setter du opp denne policy",
    "IFrames": "IFrammes",
    "IP address": "IP-adresse",
    "Icon": "Ikon",
    "Icon status": "Ikonstatus",
    "Identifier": "Identifikator",
    "Ignore": "Ignorer",
    "Ignore check": "Ignorer sjekk",
    "Ignore misspelling": "Ignorer stavefeil",
    "Ignore on the page": "Ignorer på siden",
    "Ignore on this page": "Ignorer på denne siden",
    "Ignore this SEO issue": "Ignorer dette SEO-problemet",
    "Ignore this check": "Ignorer denne sjekken",
    "Ignore this check for this domain": "Ignorer denne sjekken for dette domenet",
    "Ignored": "Ignorert",
    "Ignored Misspellings": "Ignorerte stavefeil",
    "Ignored Policies": "Ignorerte policies",
    "Ignored checks": "Ignorerte sjekker",
    "Ignored issue": "Ignorerte problem",
    "Ignored policies": "Ignorerte policies",
    "Ignoring broken link": "Ignorerer brutt lenke",
    "Image": "Bilde",
    "Image Links": "Bildelenke",
    "Image sources that will be fixed": "Bildekilder som vil bli rettet",
    "Images": "Bilder",
    "Import rules": "Import regler",
    "Import rules from CSV": "Importer regler fra CSV",
    "Important Highlights": "Viktige høydepunkter",
    "Important Notifications": "Viktige varsler",
    "Important notification:": "Viktig varsel:",
    "In compliance": "I compliance",
    "In progress of ignoring/reviewing all": "I gang med å ignorere/gjennomgå alle",
    "Inactive": "Inaktiv",
    "Incidents": "Hendelser",
    "Includes both documents and pages": "Inkluderer både dokumenter og sider",
    "Incoming Links": "Inngående lenker",
    "Incoming links": "Inngående lenker",
    "Indicates the difficulty to fix an audit error": "Angir vanskeligheten ved å rette en audit feil",
    "Indicates when some parts of the domain are not scanned due to Constraints / Exclusions being applied": "Angir når noen deler av domenet ikke skannes på grunn av begrensninger/ekskluderinger som benyttes",
    "Individual issues": "Enkeltstående problemer",
    "Information": "Informasjon",
    "Information about this Check is not yet available": "Informasjon om denne sjekken er ikke tilgjengelig enda",
    "Information and the operation of user interface must be understandable.": "Informasjon og brukergrensesnittets funksjon må være forståelig.",
    "Information and user interface components must be presentable to users in ways they can perceive.": "Informasjon og brukergrensesnitts komponenter må presenteres for brukerne på en måte de kan oppfatte.",
    "Inline Images": "Inline-bilder",
    "Inline images": "Integrerte bilder",
    "Input selector*": "Innsett selector*",
    "Input user data": "Inntast brukerdata",
    "Internal": "Intern",
    "Internal Export": "Intern eksport",
    "Internal PDF Compliance": "Intern PDF-compliance",
    "Internal PDFs": "Interne PDF-filer",
    "Internal URLs": "Interne URL'er",
    "Inventory": "Innholdsoversikt",
    "Inventory Documents Export": "Eksport av innholdsoversikt",
    "Inventory History": "Historisk oversikt over innhold",
    "Invite to new project": "Inviter til nytt prosjekt",
    "Is not a valid url": "Er ikke en gyldig url",
    "Is not crawling automatically": "Crawler ikke automatisk",
    "Is not tagged": "Er ikke merket",
    "Issue": "Problem",
    "Issue changes": "Problem endringer",
    "Issue changes since previous crawl": "Problemer med endringer siden forrige crawl",
    "Issue name": "Problem navn",
    "Issue type": "Problem type",
    "Issues": "Problemer",
    "Issues by Severities": "Problemer sortert etter alvorlighet",
    "Issues changes since previous crawl": "Problemer med endringer siden forrige gjennomgang",
    "JS": "JS",
    "JavaScript": "JavaScript",
    "Javascript": "JavaScript",
    "Javascript crawl": "Javascript-crawl",
    "KB": "KB",
    "Keyword": "Nøkkelord",
    "Knowledge Base": {
      "$$noContext": "Kunnskaps database",
      "Topmenu": "Kunnskapsbase"
    },
    "LIX": "LIX",
    "Label": "Etikett",
    "Label created": "Etikett opprettet",
    "Label name": "Etikettnavn",
    "Label overlay": "Etikett-overlay",
    "Label preview": "Eksempelvisning av etikett",
    "Label updated": "Etikett oppdatert",
    "Labels": "Etiketter",
    "Language": "Språk",
    "Language Detected": "Språk funnet",
    "Languages": "Språk",
    "Languages found": "Språk funnet",
    "Last Scan": "Sist skanning",
    "Last check: [[lastCheckTime]]": "Siste sjekk: [[lastCheckTime]]",
    "Last check: [[performanceScannedAt]]": "Siste sjekk: [[performanceScannedAt]]",
    "Last downtime:": "Siste nedetid:",
    "Last load time": "Siste lastetid",
    "Last name": "Etternavn",
    "Last run": "Siste kjøring",
    "Last run [[date]]": "Siste kjøring [[date]]",
    "Last run:": "Sist kjørt:",
    "Last scan": "Siste skanning",
    "Last scan never": "Siste skanning aldri",
    "Last scan: [[duration]] ago": "Siste skanning: [[duration]] siden",
    "Latest Updated PageCorrects": "Siste oppdaterte PageCorrects",
    "Latest login": "Siste innlogg",
    "Least Popular Pages": "Minst populære sider",
    "Less than 10": "Mindre enn 10",
    "Less than 100": "Mindre enn 100",
    "Less than 2 seconds": "Mindre enn 2 sekunder",
    "Less than 50": "Mindre enn 50",
    "Level": "Nivå",
    "Level A": "Nivå A",
    "Level A Issues": "Nivå A-problemer",
    "Level A accessibility checks": "Nivå A tilgjengelighetssjekker",
    "Level A compliance": "Compliance for nivå A",
    "Level A failing checks": "Feil for nivå A",
    "Level AA": "Nivå AA",
    "Level AA Issues": "Nivå AA-problemer",
    "Level AA accessibility checks": "Nivå AA tilgjengelighets sjekker",
    "Level AA compliance": "Compliance for nivå AA",
    "Level AA failing checks": "Feil på nivå AA",
    "Level AAA": "Nivå AAA",
    "Level AAA Issues": "Nivå AAA-problemer",
    "Level AAA accessibility checks": "Nivå AAA tilgjengelighets sjekker",
    "Level AAA compliance": "Compliance for nivå AAA",
    "Level AAA failing checks": "Feil på nivå AAA",
    "Level [[level]]": "Nivå [[level]]",
    "Levels": "Nivåer",
    "Likelihood": "Sannsynlighet",
    "Likelihood unspecified": "Uspesifisert sannsynlighet",
    "Link": "Lenke",
    "Link Type": "Lenke type",
    "Link excludes": "Lenke inneholder ikke",
    "Link fixes": "Lenke rettelser",
    "Link is broken": "Lenke er brutt",
    "Link of page": "Sidens lenke",
    "Link to image": "Lenke til bildet",
    "Linkedin": "Linkedin",
    "Links": "Lenker",
    "Links To Documents Export": "Lenker til eksport av dokumenter",
    "Links from other account domains": "Lenker fra andre kontodomener",
    "Links from own domain": "Lenker fra eget domene",
    "Links with policy matches": "Lenker med policy matcher",
    "Links with the rel=\\\"nofollow\\\" attribute will not pass link equity/SEO value to the linked page. This can be used for pages with user generated comments where you want to avoid that a competitor posts a comment with a link to their own website thus benefiting from your original content. This is not an \\\"error\\\" per se but make sure that the link does not have this attribute as a result of an error.": "Lenker med attributtet rel=\\\"nofollow\\\" bidrar ikke med SEO-verdi til den siden som det linkes til. Det brukes for eksempel på sider med brukergenererte kommentarer, hvor du ønsker å unngå at en konkurrent får fordel av å linke til sin egen side og dermed dra nytte av ditt originale innhold. Dette er ikke en feil, men du bør sørge for at lenken din ikke ved en feil inneholder attributtet rel=\\\"nofollow\\\".",
    "List": "Liste",
    "List of accessibility issues": "Liste over problemer med tilgjengelighet",
    "List of all labels": "Liste over alle etiketter",
    "List of checks with and without issues": "Liste over sjekker med og uten problemer",
    "List of content containing links": "Liste over innhold som inneholder lenker",
    "List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)": "Liste over plassering for alle dine ressurser på nettstedet (dvs. dokumenter, lenker, e-postadresser, kodestykker osv.)",
    "List view": "Listevisning",
    "Lists all profiles available for your account": "Liste over alle profiler tilgjengelig på din konto",
    "Load Times Trend": "Trend for lastetider",
    "Loading domains, please wait": "Laster inn domener, vennligst vent",
    "Loading new domain": "Laster inn nytt domene",
    "Loading times": "Lastetider",
    "Locale": "Landsversjon",
    "Location": "Beliggenhet",
    "Location not found": "Plassering ikke funnet",
    "Locations": "Plasseringer",
    "Log out": "Logg ut",
    "Login Type": "Innloggingstype",
    "Long": "Lang",
    "Lookup in Google": "Slå opp i Google",
    "Low": "Lav",
    "Low impact": "Lav påvirkning",
    "Low impact opportunities": "Muligheter med lav påvirkning",
    "Low priority": "Lav prioritet",
    "Low severity": "Lav alvorlighetsgrad",
    "Low severity issues": "Problemer med lav alvorlighetsgrad",
    "MB": "MB",
    "META content": "META-innhold",
    "META name/property": "META-navn/egenskap",
    "Main-Thread Blocking Time": "Blokkeringstid på hovedtråd",
    "Mark 403 as broken link": "Marker 403 som brutt lenke",
    "Mark all as reviewed/ignored": "Marker alle som gjennomgått/ignorert",
    "Mark as fixed": "Marker som rettet",
    "Mark as ignored": "Marker som ignorert",
    "Mark as not fixed": "Marker som ikke rettet",
    "Marked as fixed": "Markert som rettet",
    "Marked as reviewed": "Markert som gjennomgått",
    "Marking broken link as fixed": "Markert brutt lenke som fikset",
    "Match": "Match",
    "Match rule": "Match-regel",
    "Matches": "Matcher",
    "Max": "Maks",
    "Max scanned pages": "Maks. skannede sider",
    "Measure from": "Mål fra",
    "Measure from:": "Mål fra:",
    "Measurement Settings": "Måleinnstillinger",
    "Measurements since [[date]]": "Målinger siden [[date]]",
    "Medium": "Medium",
    "Medium complexity of text. Example: newspapers and magazines": "Middels tekstkompleksitet. Eksempel: aviser og magasiner",
    "Medium impact": "Middels påvirkning",
    "Medium impact opportunities": "Mellomstore muligheter for påvirkning",
    "Medium priority": "Middels-prioritet",
    "Medium severity": "Middels alvorlighetsgrad",
    "Medium severity issues": "Problemer med middels alvorlighetsgrad",
    "Meta Header Expr": "Meta overskrift-uttrykk",
    "Meta Name": "Meta Navn",
    "Metadata": "Metadata",
    "Metadata key": "Metadata-nøkkel",
    "Milliseconds": "Millisekunder",
    "Minimum words": "Minimum ord",
    "Minutes": "Minutter",
    "Minutes of slow response before you get an email": "Minutter med langsom responstid før du mottar en e-mail",
    "Mispelling": "Stavefeil",
    "Misspelling": "Stavefeil",
    "Misspelling affecting the most content": "Stavefeil som påvirker mest innhold",
    "Misspellings": "Stavefeil",
    "Misspellings history": "Stavefeils historikk",
    "Mobile": "Mobil",
    "Moderate": "Moderat",
    "Module": "Modul",
    "Monday": "Mandag",
    "Monitoring": "Overvåkning",
    "Monthly": "Månedlig",
    "Months": "Måneder",
    "More info": "Mer info",
    "More than": "Mer enn",
    "More than [[count]]": "Mer enn [[count]]",
    "Most Downloads": "Flest nedlastninger",
    "Most Frequent": "Mest hyppige",
    "Most Popular Pages": "Mest populære sider",
    "Most common SEO checkpoint needing review": "Vanligste SEO-kontrollpunkt som trenger gjennomgang",
    "Most common language": "Vanligste språk",
    "Most common misspellings": "Vanligste stavefeil",
    "Most common opportunities found": "Vanligste muligheter funnet",
    "Most common policy violation on this domain": "Vanligste policy-brudd på dette domenet",
    "Most common potential misspellings": "Vanligste potensielle stavefeil",
    "Most common readability level": "Vanligste lesbarhetsnivå",
    "Most of your pages have the readability level": "De fleste av sidene dine har lesbarhetsnivået",
    "Most pages have this readability level": "De fleste sidene har dette lesbarhetsnivået",
    "Most prominent issues ranked by severity level": "De mest fremtredende problemene rangert etter alvorlighetsgrad",
    "Most serious issues found": "Mest alvorlige problemer funnet",
    "Most visited pages": "Mest besøkte sider",
    "Move focus down on domain picker": "Flytt fokus ned på domenevelgeren",
    "Move focus up on domain picker": "Flytt fokus opp på domenevelgeren",
    "Multiline": "Multiline",
    "My Exports": "Mine eksporter",
    "My profile": "Min profil",
    "N/A": "Ikke relevant",
    "NA": "Ikke relevant",
    "NB! Connection Settings cannot be edited after save": "NB! Innstillinger for tilkobling kan ikke redigeres etter lagring",
    "NOTE: If you want to copy the Legacy Script. Click {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}here{{anchorEnd}}.": "OBS: Ønsker du å benytte deg av den tidligere versjonen av skriptet? Klikk {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}her{{anchorEnd}}.",
    "Name": {
      "$$noContext": "Navn",
      "Exchange Center Sort by option": "Navn"
    },
    "Network not found": "Nettverk ikke funnet",
    "Network speed": "Nettverkshastighet",
    "Network speed:": "Nettverkshastighet:",
    "Never": "Aldri",
    "Never scanned": "Aldri skannet",
    "New": "Ny",
    "New Performance Page": "Ny Performance-side",
    "New Policy": "Ny Policy",
    "New password": "Nytt passord",
    "Next": "Neste",
    "No Broken Links marked as Fixed": "Ingen brutte lenker er markert som rettet",
    "No CSS": "Ingen CSS",
    "No Content links": "Ingen innholdslenker",
    "No Data available for selected time frame": "Ingen data tilgjengelig for den valgte tidsramme",
    "No Documents found": "Ingen dokumenter funnet",
    "No Domains or Groups are yet selected for this report": "Det er ikke valgt noen domener eller grupper til denne rapporten enda",
    "No Frames": "Ingen rammer",
    "No Frequency": "Ingen frekvens",
    "No HTML Pages found": "Ingen HTML-sider funnet",
    "No Historic data available for Accessibility Level [[lvl]]": "Ingen historiske data for tilgjengelighetsnivå [[lvl]]",
    "No IFrames": "Ingen IFrames",
    "No Ignored Broken Links": "Ingen ignorerte brutte lenker",
    "No Image Links found": "Ingen bildelenke funnet",
    "No PDF's failed": "Ingen PDF'er feilet",
    "No PDF's pending": "Ingen PDF'er avventer",
    "No PDF's queued": "Ingen PDF er i kø",
    "No PDF's reviewed": "Ingen PDF'er er gjennomgått",
    "No PDFs are reviewed": "Ingen PDF-filer gjennomgås",
    "No Policies detected": "Ingen policies funnet",
    "No Profiles were found": "Ingen profiler ble funnet",
    "No Spreadsheet links found": "Ingen lenker til regneark funnet",
    "No Users are yet selected to receive this report": "Ingen brukere er valgt til å motta denne rapporten enda",
    "No Word links found": "Ingen Word-lenker funnet",
    "No changes": "Ingen endringer",
    "No changes found": "Fant ingen endringer",
    "No checks found for this Accessibility category": "Ingen sjekker funnet for denne tilgjengelighets kategori",
    "No content policies have been created yet": "Ingen policies for innhold er opprettet enda",
    "No corrections added to PageCorrect": "Ingen endringer lagt til PageCorrect",
    "No data available": "Ingen data tilgjengelig",
    "No data present": "Ingen data tilstede",
    "No diagnostics issues were found": "Ingen diagnostiske problemer ble funnet",
    "No domains were found": "Ingen domener ble funnet",
    "No downloads found": "Ingen nedlastninger funnet",
    "No errors found": "Ingen feil funnet",
    "No exemptions added to this checkpoint": "Ingen unntakelser lagt til dette sjekkpunktet",
    "No exports available": "Ingen eksporter tilgjengelig",
    "No groups were found for this domain": "Ingen grupper ble funnet for dette domenet",
    "No historic data available for this domain": "Ingen historiske data er tilgjengelig for dette domenet",
    "No hits found": "Ingen hits funnet",
    "No ignored checks in this accessibility category": "Ingen ignorerte sjekker i denne tilgjengelighetskategorien",
    "No ignored misspellings found for this page": "Ingen ignorerte stavefeil funnet på denne siden",
    "No incidents occurred in the selected time frame": "Ingen hendelser oppstod i det valgte tidsrommet",
    "No issues found": "Ingen problemer funnet",
    "No javascript": "Ingen JavaScript",
    "No name defined": "Ingen navn definert",
    "No new notifications": "Ingen nye varsler",
    "No note has been added": "Ingen notat er lagt til",
    "No notifications available": "Ingen varsler tilgjengelige",
    "No opportunities were found": "Ingen muligheter ble funnet",
    "No outages in this period": "Ingen nedetid i denne perioden",
    "No pages found": "Ingen sider funnet",
    "No pages were found": "Ingen sider ble funnet",
    "No passed checks in this accessibility category": "Ingen beståtte sjekker i denne tilgjengelighetskategorien",
    "No performance scan found": "Ingen performance skanning funnet",
    "No performance scans were found": "Ingen performance skanning ble funnet",
    "No policies found": "Ingen policies funnet",
    "No readability score": "Ingen lesbarhetsscore",
    "No response received": "Ingen svar mottatt",
    "No run present": "Ingen kjøring tilstede",
    "No scan has yet been performed. Please check back later.": "Det er enda ikke utført noen skanning. Kom tilbake senere.",
    "No slide links found": "Ingen lenker til slideshow funnet",
    "No title found": "Ingen tittel funnet",
    "No title found on one or more pages": "Ingen tittel funnet på en eller flere sider",
    "No title is found on this page": "Ingen tittel funnet på denne siden",
    "No users available for this domain": "Ingen tilgjengelige brukere for dette domenet",
    "No violations were found": "Ingen brudd ble funnet",
    "No visitor profile selected": "Ingen besøksprofil valgt",
    "No visits for this category in selected time frame": "Ingen besøk for denne kategori i den valgte tidsramme",
    "No words have been added to the default dictionary": "Ingen ord er lagt til i standardordboken",
    "No. Visits": "Antall besøk",
    "Non-user list": "Ikke-bruker liste",
    "None": "Ingen",
    "Normal - recommended": "Normal - anbefales",
    "Normal violations": "Normale brudd",
    "Not case sensitive": "Ikke følsom for store og små bokstaver",
    "Not containing": "Inneholder ikke",
    "Not scheduled": "Ikke planlagt",
    "Not valid email": "Ikke gyldig e-post",
    "Note": "Bemerk",
    "Notes": "Bemerkninger",
    "Notifications": "Varsler",
    "Number of characters in Meta Header text": "Antall tegn i Meta Header-tekst",
    "Number of characters in header text": "Antall tegn i overskriftstekst",
    "Number of characters in image text": "Antall tegn i bildetekst",
    "Number of characters in link text": "Antall tegn i lenketekst",
    "Number of characters in page title": "Antall tegn i sidetittel",
    "Number of pages": "Antall sider",
    "Number too high": "Nummeret er for høyt",
    "Number too low": "Nummeret er for lavt",
    "OK": "OK",
    "Office 365 (BETA)": "Office 365 (BETA)",
    "Ok": "Ok",
    "Once a day": "En gang om dagen",
    "Once a week": "En gang i uken",
    "One or more documents have already been scanned for compliance. Are you sure you want to scan the selected documents again?": "Et eller flere dokumenter er allerede blitt skannet for overholdelse av kravene. Er du sikker på at du vil skanne de valgte dokumenter igjen?",
    "One or more page on your website has the same H1 text.": "En eller flere sider på nettsiden din har den samme H1-tekst.",
    "One or more pages has been marked as no index": "En eller flere sider er markert med ingen indeks",
    "One or more pages on your website has this title": "En eller flere sider på nettsiden din har denne tittelen",
    "Open": "Åpen",
    "Open Accessibility Decision Tree": "Åpne beslutningstre for tilgjengelighet",
    "Open Data Privacy": "Åpne personvern",
    "Open Data Privacy Settings": "Åpne innstillinger for personvern",
    "Open Document Details": "Åpne dokumentopplysninger",
    "Open Document details": {
      "$$noContext": "Åpne dokumentopplysninger",
      "Aria label when clicking on open Document details": "Åpne dokumentdetaljer"
    },
    "Open Fast Track for this HTML snippet": "Åpne Fast Track for dette HTML-utdrag",
    "Open New Help Center": "Åpne nytt hjelpesenter",
    "Open Page Details": "Åpne sideopplysninger",
    "Open Schedule downtime": "Åpne planlegging av nedetid",
    "Open document details": "Åpne dokumentopplysninger",
    "Open domain policy": "Åpne policy for domene",
    "Open example": "Åpne eksempel",
    "Open filters": "Åpne filtre",
    "Open group": "Åpne gruppe",
    "Open help center": "Åpne hjelpesenter",
    "Open keyboard shortcuts": "Åpne tastatur snarveier",
    "Open page details": {
      "$$noContext": "Åpne sideopplysninger",
      "Aria label when clicking on open pagedetails": "Åpne sidedetaljer"
    },
    "Open received reports": "Åpne mottatte rapporter",
    "Open report": "Åpen rapport",
    "Operating System": "Operativ system",
    "Operating Systems": "Operativsystemer",
    "Operating systems": "Operativsystemer",
    "Operating systems Overview": "Operativsystemer Oversikt",
    "Operator*": "Operatør*",
    "Opportunities": "Muligheter",
    "Opportunities by Priority": "Muligheter etter prioritet",
    "Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.": "Du kan eventuelt velge det primære språket for domenet. Hvis du velger engelsk (UK), vil all tekst som registreres som engelsk, bli betraktet som britisk engelsk.",
    "Options": "Muligheter",
    "Or": "Eller",
    "Organizations": "Organisasjoner",
    "Original Data": "Original data",
    "Other Documents": "Andre dokumenter",
    "Other files": "Andre filer",
    "Others": "Andre",
    "Our suggestion": "Vårt forslag",
    "Our team has been notified of your request. We will soon be in touch.": "Teamet vårt har blitt varslet om din henvendelse. Vi kontakter deg snarest.",
    "Outages during the selected time-frame": "Nedetid i løpet av det valgte tidsrommet",
    "Outages end": "Nedetid slutter",
    "Outages start": "Nedetid starter",
    "Outgoing Links": "Utgående lenker",
    "Outgoing links": "Utgående lenker",
    "Over 1000 ms.": "Over 1000 ms.",
    "Over 10000 ms.": "Over 10000 ms.",
    "Over 200 ms.": "Over 200 ms.",
    "Over 2000 ms.": "Over 2000 ms.",
    "Over 3000 ms.": "Over 3000 ms.",
    "Over 4000 ms.": "Over 4000 ms.",
    "Over 500 ms.": "Over 500 ms.",
    "Over 5000 ms.": "Over 5000 ms.",
    "Over 6000 ms.": "Over 6000 ms.",
    "Over 7000 ms.": "Over 7000 ms.",
    "Over 8000 ms.": "Over 8000 ms.",
    "Over 9000 ms.": "Over 9000 ms.",
    "Overall Data Privacy compliance for this page": "Overordnet compliance for personvern på siden",
    "Overall PageCorrects": "Samlede PageCorrects",
    "Overall SEO compliance for this page": "Overordnet SEO-compliance for denne siden",
    "Overall accessibility compliance for this level": "Overordnet compliance for tilgjengelighet på dette nivået",
    "Overall accessibility compliance level for this page": "Overordnet compliance for tilgjengelighet på denne siden",
    "Overall compliance": "Overordnet compliance",
    "Overall policy compliance for this page": "Overordnet compliance for policies på denne siden",
    "Owner": "Eier",
    "PAGE PERFORMANCE OVERVIEW": "OVERSIKT OVER PAGE PERFORMANCE",
    "PDF": "PDF",
    "PDF Compliance Status": "PDF-Compliance Status",
    "PDF Documents": "PDF-dokumenter",
    "PDF accessibility scan completed at [[date]]": "Skanning av PDF-tilgjengelighet avsluttet [[date]]",
    "PDF accessibility scan requested": "Forespørsel om skanning av PDF-tilgjengelighet sendt",
    "PDF files": "PDF-filer",
    "PDF files pending": "Avventende PDF-filer",
    "PDF files reviewed": "Gjennomgåtte PDF-filer",
    "PDF files that are reviewed or pending for accessibility": "Tilgjengelighets PDF-filer som er gjennomgått eller avventer",
    "PDFs": "PDF-filer",
    "POLICIES OVERVIEW": "POLICYOVERSIKT",
    "Page": "Side",
    "Page Dashboard": "Side Dashbord",
    "Page Details": "Sideopplysninger",
    "Page Performance": "Page Performance",
    "Page Statistics": "Sidestatistikk",
    "Page URL": "Side URL",
    "Page Views": "Sidevisninger",
    "Page compliance": "Sidens compliance",
    "Page count in PDF": "Sidetelling i PDF",
    "Page dashboard": "Overblikk over siden",
    "Page details": "Sideopplysninger",
    "Page first detected": "Siden ble først registrert",
    "Page links": "Sidelenker",
    "PageAssist Logo Position": "PageAssist-logo posisjon",
    "PageAssist Theme": "PageAssist-tema",
    "PageCorrect": "PageCorrect",
    "PageCorrect Content": "PageCorrect-innhold",
    "PageCorrect Custom Phrase or Word": "PageCorrect egendefinert setning eller ord",
    "PageCorrect Details": "PageCorrect detaljer",
    "PageCorrect Diagnostics": "PageCorrect diagnostisering",
    "PageCorrects categorized": "Kategoriserte PageCorrect-rettelser",
    "PageFixes": "PageFixes",
    "PageFixes Left": "Resterende PageFixes",
    "Pages": "Sider",
    "Pages & documents with confirmed misspellings, broken links or images": "Sider og dokumenter med bekreftede stavefeil, brutte lenker eller bilder",
    "Pages Crawled": "Sider Crawlet",
    "Pages With Opportunities": "Sider med muligheter",
    "Pages and documents with policies marked as unwanted or required": "Sider og dokumenter med policies markert som uønsket eller påkrevde",
    "Pages crawled": "Sider Crawlet",
    "Pages failing check": "Sider som ikke består sjekk",
    "Pages in compliance": "Sider i compliance",
    "Pages related to policy link": "Sider relatert til policy link",
    "Pages that are difficult to read": "Sider som er vanskelige å lese",
    "Pages that are easily understood by children below 5'th grade": "Sider som er lett å forstå for barn under 5.klasse",
    "Pages that are easy to read. Conversational English for consumers": "Sider som er lett å lese. Engelsk på samtalenivå.",
    "Pages that are fairly difficult to read": "Sider som er vanskelig å lese",
    "Pages that are fairly easy to read": "Relativt lettleselige sider",
    "Pages that are in plain English. Easily understood by 13- to 15-year-old students": "Sider som er på alminnelig engelsk. Lett forstått av skoleelever fra 13 til 15 år",
    "Pages that are very difficult to read. Best understood by university graduates": "Sider som er veldig vanskelig å lese. Best forstått av universitetsutdannede",
    "Pages that are very easy to read. Easily understood by an average 11-year-old student": "Sider som er veldig lett å lese. Kan forstås av en gjennomsnittlig 11-årig skoleelev",
    "Pages we could not determine Readability score": "Sider der vi ikke kunne fastslå lesbarhetsscore",
    "Pages with Data Privacy issues": "Sider med personvern-problemer",
    "Pages with Failing Checks": "Sider med feilede sjekker",
    "Pages with Ignored Checks": "Sider med ignorerede sjekker",
    "Pages with Misspellings": "Sider med stavefeil",
    "Pages with Opportunities": "Sider med muligheter",
    "Pages with Policy Issues": "Sider med policy problemer",
    "Pages with QA Issues": "Sider med kvalitetssikrings problemer",
    "Pages with QA issues": "Sider med kvalitetssikrings problemer",
    "Pages with SEO Opportunities": "Sider med SEO-muligheter",
    "Pages with SEO opportunities": "Sider med SEO-muligheter",
    "Pages with accessibility checks not in compliance": "Sider med tilgjengelighetskontroller som ikke overholder kravene",
    "Pages with failing checks": "Sider med feilede sjekker",
    "Pages with high, medium or low opportunities": "Sider med høye, middels eller lave muligheter",
    "Pages with ignored checks": "Sider med ignorerte sjekker",
    "Pages with issues": "Sider med problemer",
    "Pages with policy matches": "Sider med policy matches",
    "Pages with score:": "Sider med score:",
    "Pages with the \\\"noindex\\\" META tag will not be indexed by the search engines. This is not an \\\"error\\\" per se, but make sure that the page does not have this tag as a result of an error.": "Sider med meta-taggen \\\"noindex\\\" blir ikke indeksert av søkemotorene. Dette er ikke en feil i seg selv, men sørg for at taggen ikke er til stede på siden ved en feil.",
    "Pages without H1 tags or with empty H1 tags that contain no value represent a failed SEO optimization opportunity.": "Sider uten H1-tags eller med tomme H1-tags som ikke inneholder noe verdi, representerer en mislykket SEO-optimeringsmulighet.",
    "Pages without Visits": "Sider uten besøk",
    "Pages without Visits in last 6 months": "Sider uten besøk de siste 6 måneder",
    "Pageviews": "Sidevisninger",
    "Part of downtime calculation": "Del av beregningen for nedetid",
    "Part of heatmap Rules": "Del av varmekart reglene",
    "Part of success criteria [[checkIssueNumber]]": "Del av suksesskriteriet [[checkIssueNumber]]",
    "Pass Example": "Godkjent Eksempel",
    "Passed": "Godkjent",
    "Passed ([[audits]])": "Bestått ([[audits]])",
    "Passed Checks": "Beståtte sjekker",
    "Passed Policy checks": "Beståtte policy sjekker",
    "Passed checks": "Beståtte sjekker",
    "Passed policy checks": "Beståtte policy sjekker",
    "Password": "Passord",
    "Password Confirmation": "Bekreftelse av passord",
    "Password confirmation": "Bekreftelse av passord",
    "Password to login": "Innloggingspassord",
    "Passwords does not match": "Passord stemmer ikke overens",
    "Path constraints": "Sti-begrensninger",
    "Path template": "Mal til sti",
    "Pending": "Avventer",
    "Pending PDF review": "Avventer PDF-gjennomgang",
    "Pending PDF reviews": "Avventende PDF-gjennomganger",
    "Percentage shows number of pages that are compliant with all Data Privacy checks": "Prosentandelen viser antallet av sider som er i samsvar med alle personvern sjekker",
    "Percentage shows number of pages that are compliant with all SEO checks": "Prosentandelen viser antallet av sider som overholder alle SEO-sjekker",
    "Performance": "Performance",
    "Performance Errors": "Performance Feil",
    "Performance Pages": "Performance Sider",
    "Performance Profiles": "Performance Profiler",
    "Performance Score": "Performance Score",
    "Performance score": "Performance score",
    "Personal": "Personlig",
    "Personal information": "Personlig informasjon",
    "Phone": "Telefon",
    "Pie": "Pai",
    "Pin domain": "Pin domene",
    "Ping intervals": "Ping-intervaller",
    "Play": "Spill av",
    "Play misspelling": "Spill av stavefeil",
    "Please choose a trademark": "Velg et varemerke",
    "Please insert correct URL:": "Sett inn korrekt URL:",
    "Please insert the correct word:": "Sett inn det riktige ordet:",
    "Please insert the missing ALT text:": "Sett inn den manglende ALT-tekst:",
    "Please select a module": "Velg en modul",
    "Please select the module that you want to create a Source Code Exclude for": "Velg modulen som du ønsker å opprette en kildekode ekskludering for",
    "Please specify word or phrase to search for": "Vennligst spesifiser ord eller uttrykk å søke etter",
    "Please use CSS selectors to identify form fields and buttons": "Vennligst bruk CSS-selectors til å identifisere skjemafelter og knapper",
    "Please wait": "Vennligst vent",
    "Please wait - Adding word to dictionary": "Vennligst vent - Legger til ord i ordboken",
    "Please wait - Adding words to dictionary": "Vennligst vent - Legger til ord i ordboken",
    "Please wait - Confirming misspelling": "Vennligst vent - Bekrefter stavefeil",
    "Please wait - exporting audit log &nbsp;": "Vennligst vent - eksporterer endringshistorikk & nbsp;",
    "Policies": "Policies",
    "Policies - required": "Policies - påkrevde",
    "Policies - violations": "Policies - brudd",
    "Policies marked as required or unwanted": "Policies markert som påkrevd eller uønsket",
    "Policies violations": "Brudd på policies",
    "Policies with most matches": "Policies med flest matcher",
    "Policies with violations": "Policies med brudd",
    "Policy": "Policy",
    "Policy Diagnostics": "Diagnostisering av policies",
    "Policy Distribution": "Fordeling av policies",
    "Policy Hits": "Policy Hits",
    "Policy Issues": "Problemer med policies",
    "Policy List": "Policy liste",
    "Policy Pages": "Policy-sider",
    "Policy Running": "Policy kjører",
    "Policy errors": "Policyfeil",
    "Policy hits per domain": "Policy-hits per domene",
    "Policy in queue": "Policy i kø",
    "Policy info": "Policy-info",
    "Policy note": "Policy-notat",
    "Policy rules": "Policy-regler",
    "Policy scan in progress": "Policy-skanning er i gang",
    "Policy setup": "Policy-oppsett",
    "Policy violations": "Typiske policy-brudd",
    "Policy with matching terms": "Policy med matchende vilkår",
    "Potential Misspelling": "Potensiell stavefeil",
    "Potential Misspellings": "Potensielle stavefeil",
    "Potential Savings": "Potensielle besparelser",
    "Potential misspelling": "Potensiell stavefeil",
    "Potential misspellings": "Potensielle stavefeil",
    "Potential misspellings found": "Potensielle stavefeil funnet",
    "Powered by Google Lighthouse": "Kjører på Google Lighthouse",
    "Prefix path": "Prefix-sti",
    "Presence": "Tilstedeværelse",
    "Previous": "Tidligere",
    "Principle 1: Perceivable": "Prinsipp 1: Oppfattbart",
    "Principle 2: Operable": "Prinsipp 2: Betjenes",
    "Principle 3: Understandable": "Prinsipp 3: Forståelig",
    "Principle 4: Robust": "Prinsipp 4: Robust",
    "Principle 5: Conformance": "Prinsipp 5: Overensstemmelse",
    "Print view": "Utskriftsvisning",
    "Priorities": "Prioriteter",
    "Prioritized Content": "Prioritert innhold",
    "Priority": "Prioritet",
    "Profile": "Profil",
    "Profile Description": "Profilbeskrivelse",
    "Profile Dropdown": "Profil dropdown",
    "Profile Menu": "Profil meny",
    "Profile Name": "Profil navn",
    "Profile details": "Profilopplysninger",
    "Profile updated": "Profil oppdatert",
    "QA": "Kvalitetssikring",
    "QA Issues": "Kvalitetssikrings-problemer",
    "QA errors": "Kvalitetssikrings-feil",
    "QUALITY ASSURANCE": "KVALITETSSIKRING",
    "QUALITY ASSURANCE OVERVIEW": "OVERSIKT OVER KVALITETSSIKRING",
    "Quality Assurance": "Kvalitetssikring",
    "Quality Assurance Check": "Kvalitetssikringssjekk",
    "Quality Assurance Diagnostics": "Diagnostisering av kvalitetssikring",
    "Quality Assurance Export summary": "Eksport med overblikk over kvalitetssikring",
    "Quality Assurance errors": "Kvalitetssikringsfeil",
    "Quality assurance": "Kvalitetssikring",
    "Queued": "I kø",
    "Quick Guide": "Hurtig guide",
    "Quick help": "Hurtig hjelp",
    "Quick info:": "Hurtig info:",
    "Re-scanning of issues for this page has started and will be finished in a few minutes.": "Omskanning av problemer for denne siden har startet og vil bli ferdig om noen få minutter.",
    "Readability": "Lesbarhet",
    "Readability Score": "Lesbarhetsscore",
    "Readability by score": "Lesbarhet etter score",
    "Readability levels": "Lesbarhetsnivåer",
    "Readability score": "Lesbarhetsscore",
    "Readability scores across all web pages (based on": "Lesbarhetsscore på tvers av alle websider (basert på",
    "Readability test": "Test av lesbarhet",
    "Receive report": "Motta rapport",
    "Received reports": "Mottatte rapporter",
    "Referring Information": "Informasjon om henvisning",
    "Referring visits": "Henvisningsbesøk",
    "Regex": "Regex",
    "Regulation": "Lovgivning",
    "Remember me": "Husk meg",
    "Remove": "Fjern",
    "Remove Custom Multistep Javascript": "Fjern Custom Multistep Javascript",
    "Remove Extension Name": "Fjern fil-typer",
    "Remove Page": "Fjern side",
    "Remove Profile": "Fjern profil",
    "Remove Rule": "Fjern regel",
    "Remove checkpoint": "Fjern kontrollpunktet",
    "Remove domain": "Fjern domene",
    "Remove domain group": "Fjern domenegruppe",
    "Remove from dictionary": "Fjern fra ordboken",
    "Remove group": "Fjern gruppe",
    "Remove rule": "Fjern regel",
    "Remove this IP address?": "Fjern denne IP-adressen?",
    "Remove this pattern?": "Fjern dette mønster?",
    "Remove this word from dictionary": "Fjern dette ordet fra ordboken",
    "Render pages and execute JS while crawling": "Vis sider og kjør JS mens crawling pågår",
    "Repeat": "Gjenta",
    "Replace Rule": "Erstatt regel",
    "Report": "Rapport",
    "Report administration": "Administrer rapporter",
    "Report overview:": "Rapport oversikt:",
    "Request PDF scan for all documents": "Be om PDF-skanning for alle dokumenter",
    "Requests": "Forespørsler",
    "Required": "Påkrevd",
    "Required content": "Påkrevd innhold",
    "Required count": "Antall påkrevde",
    "Rescan": "Skann igjen",
    "Rescanning": "Re-skanning",
    "Reset": "Nullstill",
    "Reset Preferences": "Nullstill preferanser",
    "Resolution": "Oppløsning",
    "Resource Type": "Ressurs type",
    "Response Time": "Responstid",
    "Response code": "Responskode",
    "Response time": "Responstid",
    "Response time (Milliseconds)": "Svartid (millisekunder)",
    "Response time notification": "Svartids-varsel",
    "Response time notification threshold": "Grenseverdi for svartidsvarsel",
    "Return to heartbeat overview": "Gå tilbake til Heartbeat-oversikt",
    "Returning customer": "Tilbakevendende kunde",
    "Reverting state": "Gjenoppretter tilstanden",
    "Review": "Gjennomgå",
    "Reviewed": "Gjennomgått",
    "Reviewed/Ok": "Gjennomgått/Ok",
    "Revoke token": "Tilbakekall token",
    "Robot Info": "Robotinfo",
    "Role": "Rolle",
    "Rule": "Regel",
    "Rule name": "Regelnavn",
    "Rule operator": "Regeloperatør",
    "Rule to match": "Regel å matche",
    "Rules": "Regler",
    "Run Policy": "Kjør policy",
    "Run policy": "Kjør policy",
    "Run policy again": "Kjør policy igjen",
    "Running": "Kjører",
    "SEO": "SEO",
    "SEO (Search Engine Optimization)": "SEO (søkemotoroptimering)",
    "SEO Checkpoints": "SEO kontrollpunkter",
    "SEO Diagnostics": "SEO diagnostikk",
    "SEO Issues": "SEO problemer",
    "SEO OVERVIEW": "SEO OVERSIKT",
    "SEO Opportunities": "SEO muligheter",
    "SEO errors": "SEO-feil",
    "SEO impact": "SEO-påvirkning",
    "SEO opportunities": "SEO-muligheter",
    "SEO opportunities - high priority": "SEO-muligheter - høy prioritet",
    "SEO opportunities - low priority": "SEO-muligheter - lav prioritet",
    "SEO opportunities - medium priority": "SEO-muligheter - mellomstor prioritet",
    "SEO opportunities - technical SEO issues": "SEO-muligheter - tekniske SEO spørsmål",
    "SEO opportunities found": "SEO-muligheter funnet",
    "SHOW LIST VIEW": "VIS LISTEVISNING",
    "STATISTICS OVERVIEW": "STATISTIKK OVERSIKT",
    "Saturday": "Lørdag",
    "Save": "Lagre",
    "Save Preferences": "Lagre innstillinger",
    "Save and close": "Lagre og lukk",
    "Save policy": "Lagre policy",
    "Scan": "Skann",
    "Scan documents": "Skann dokumenter",
    "Scan frequency": "Skanningsfrekvens",
    "Scan frequency:": "Skanningsfrekvens:",
    "Scan in progress": "Skanning er i gang",
    "Scan in progress:": "Skanning er i gang:",
    "Scan is done": "Skanningen er utført",
    "Scan subdomains": "Skann underdomener",
    "Scanned at": "Skannet",
    "Scanned content": "Skannet innhold",
    "Scanned links:": "Skannede lenker:",
    "Scanned pages": "Skannede sider",
    "Scanned pages:": "Skannede sider:",
    "Scanning URL:": "Skanner URL:",
    "Scanning in progress": "Skanning er i gang",
    "Schedule Report": "Planlegg rapport",
    "Schedule supplemental reports to be delivered with each scan": "Planlegg supplerende rapporter som skal leveres med hver skanning",
    "Scheduled": "Planlagt",
    "Scheduled Reports": "Planlagte rapporter",
    "Scopes": "Omfang",
    "Score": "Score",
    "Screen Resolutions": "Skjermoppløsning",
    "Screen Resolutions Overview": "Oversikt over skjermoppløsninger",
    "Script Evaluation": "Evaluering av script",
    "Script Parse": "Tolkning av script",
    "Script installed": "Script installert",
    "Script installed on Domain": "Script installert på domene",
    "Script setup guide": "Veiledning til oppsetting av script",
    "Search Engine Optimization": "Søkemotor optimering",
    "Search Engine Optimization (SEO)": "Søkemotoroptimering (SEO)",
    "Search Engines": "Søkemotorer",
    "Search engine": "Sølemotor",
    "Search engines": "Søkemotorer",
    "Search for Pages": "Søk etter sider",
    "Search for file size that is": "Søk etter filstørrelse",
    "Search for image size that is": "Søk etter bildestørrelse",
    "Search for links, that are associated with class names and contains below mentioned class names.": "Søk etter lenker som er assosiert med klasse-navn og inneholder klasse-navnene nevnt nedenfor.",
    "Search for page titles or URLs across all domains": "Søk etter sidetitler eller URL'er på tvers av alle domener",
    "Search for pages": "Søk etter sider",
    "Search icon": "Søke ikon",
    "Search in: Documents": "Søk i: Dokumenter",
    "Search in: Everything": "Søk i: Alt",
    "Search in: Links": "Søk i: Lenker",
    "Search in: Only HTML pages": "Søk i: Kun HTML-sider",
    "Search pages across all domains": "Søk på sider på alle domener",
    "Search...": "Søk...",
    "Searches": "Søkninger",
    "Seconds": "Sekunder",
    "See API Token": "Se API-token",
    "See Details": "Se detaljer",
    "See changes": "Se endringer",
    "See details": "Se endringer",
    "See pages": "Se sider",
    "Select Domain and Module to get the Insights": "Velg Domene og Modul for å få innsikt",
    "Select Domain on domain picker": "Velg Domene på domenevelger",
    "Select Page to scan": "Velg side som skal skannes",
    "Select a domain and recipients": "Velg et domene og mottakere",
    "Select a domain or group": "Velg et domene eller gruppe",
    "Select a profile": "Velg en profil",
    "Select account": "Velg konto",
    "Select all items": "Velg alle",
    "Select domain": "Velg domene",
    "Select domains and groups": "Velg domener og grupper",
    "Select filters": "Velg filtre",
    "Select import": "Velg import",
    "Select item": "Velg element",
    "Select login type*": "Velg innloggingstype*",
    "Select timezone": "Velg tidssone",
    "Select users": "Velg brukere",
    "Select what type of content the policy should search in": "Velg hvilken type innhold policien skal søke i",
    "Select whether the rule should search for case sensitive text or not": "Velg om regelen skal søke etter store og små bokstaver eller ikke",
    "Select your export file": "Velg din eksportfil",
    "Send an email if the site is down": "Send en e-post dersom siden er nede",
    "Send an email if the site is slow to respond": "Send en e-post dersom nettstedet responderer sakte",
    "Send message": "Send melding",
    "Send report": "Send rapport",
    "Send welcome mail on creation": "Send velkomstmail ved opprettelse",
    "Set a default value for selector": "Sett en standardverdi for selectoren",
    "Set as Default": "Sett som standard",
    "Set to fixed": "Marker som rettet",
    "Settings": {
      "$$noContext": "Innstillinger",
      "Topmenu": "Innstillinger"
    },
    "Setup your domain": "Sett opp ditt domene",
    "Severity": "Alvorlighet",
    "Severity level": "Alvorlighetsnivå",
    "Short": "Kort",
    "Short Description": "Kort beskrivelse",
    "Should we check the page's current status?": "Skal vi kontrollere sidens aktuelle status?",
    "Show Details": "Vis detaljer",
    "Show all": "Vis alt",
    "Show documents with this email": "Vis dokumenter med denne e-posten",
    "Show history": "Vis historie",
    "Show label dropdown": "Vis etikett dropdown",
    "Show less": "Vis mindre",
    "Show more": "Vis mer",
    "Show on global policy list": "Vis på den globale policy-liste",
    "Show pages": "Vis sider",
    "Show pages with issues": "Vis sider med problemer",
    "Show pages with this SEO issue": "Vis sider med dette SEO-problemet",
    "Show pages with this email": "Vis sider med denne e-posten",
    "Show pages with this image": "Vis sider med dette bildet",
    "Show pages with this link": "Vis sider med denne lenken",
    "Show pages with this misspelling": "Vis sider med denne stavefeilen",
    "Show policy hits per domain": "Vis policy hits per domene",
    "Show policy info": "Vis info om denne policy",
    "Show the Domain Picker": "Vis domenevelgeren",
    "Show/Hide filter selector": "Vis/skjul filtervelger",
    "Show/Hide the Domain Picker": "Vis/skjul domenevelgeren",
    "Shows the remaining number of Performance Profiles that can be created for this account": "Viser det resterende antall Performance Profiler som kan opprettes for denne kontoen",
    "Side Navigation": "Side navigasjon",
    "Single line": "Enkel linje",
    "Size": "Størrelse",
    "Skip to content": "Gå til innhold",
    "Slide links": "Slide lenker",
    "Slides": "Slides",
    "Slow": "Treg",
    "Snippet": "Kodevisning",
    "Social": "Sosial",
    "Social Networks": "Sosiale nettverk",
    "Social visits": "Sosiale nettverks besøk",
    "Source Code Exclude": "Ekskludert kildekode",
    "Source Code Excludes": "Ekskluderte kildekoder",
    "Source code": "Kildekode",
    "Spellcheck": "Stavekontroll",
    "Spellcheck Export Summary": "Stavekontroll Eksportoversikt",
    "Spellcheck Summary": "Oversikt over stavekontroll",
    "Spelling": "Staving",
    "Spelling Errors used": "Stavefeil brukt",
    "Spelling fixes": "Stavefeil rettelser",
    "Spelling ignore capitalized words": "Stavekontroll ignorerer store bokstaver",
    "Spreadsheet links": "Regneark-lenker",
    "Spreadsheets": "Regneark",
    "Start PDF accessibility scan": "Start PDF-tilgjengelighetsskanning",
    "Start at": "Start ved",
    "Start compound export": "Start samlet eksport",
    "Start date": "Start dato",
    "Start export": "Start eksport",
    "Start export Pages With Specific Link": "Start eksport av Sider med spesifikk lenke",
    "Start new scan": "Start ny skanning",
    "Start on demand scan": "Start on demand-skanning",
    "Start time": "Starttidspunkt",
    "Starts with": "Starter med",
    "State": "Stat",
    "Statistic": "Statistikk",
    "Statistics": "Statistikk",
    "Statistics excluded IP addresses": "IP-adresser ekskludert i statistikk",
    "Status": "Status",
    "Stop current crawl": "Stopp den aktuelle skanningen",
    "Sub Navigation": "Undermeny",
    "Submit selector*": "Send inn selector*",
    "Succeeds": "Lykkes",
    "Success criteria": "Suksesskriterier",
    "Suggestions and ideas": "Forslag og ideer",
    "Summarized pages and documents count": "Oppsummering av antall sider og dokumenter",
    "Summary": "Sammendrag",
    "Sunday": "Søndag",
    "Switch account": "Bytt konto",
    "Table View": "Tabellvisning",
    "Tags": "Tags",
    "Target": "Target",
    "Technical": "Tekniske",
    "Technical SEO Issues": "Tekniske SEO-problemer",
    "Text": "Tekst",
    "Text Documents": "Tekstdokumenter",
    "Text documents": "Tekstdokumenter",
    "Text to match": "Tekst som skal matches",
    "Text:": "Tekst:",
    "The Checkpoint [[checkpoint]] will be updated with data after next crawl": "Sjekkpunktet [[checkpoint]] oppdateres med data etter neste skanning",
    "The Document is not tagged": "Dokumentet er ikke tagget",
    "The Path template for Umbraco CMS": "Sti-malen til Umbraco CMS",
    "The Requested Page is not a part of the Performance Module": "Den forespurte siden er ikke en del av Performance-modulen",
    "The Scan will take effect within the next few hours": "Skanningen trer i kraft i løpet av de neste timene",
    "The URL for this page is too long": "URL'en til denne siden er for lang",
    "The base url to the CMS page": "Basis url til CMS-siden",
    "The bounce rate tells you the number of visits who only see the one page they started on": "Bounce frekvensen forteller deg antallet besøkende som kun ser den ene siden de startet på",
    "The following rules will be removed, are you sure you want to continue with this change?": "Følgende regler vil bli fjernet, er du sikker på at du ønsker å fortsette med denne endringen?",
    "The header 1 (H1) tag is important as it helps search engines and users to understand what content they can expect to find on the page.": "Overskrift 1 (H1-tagget) er viktig, da det hjelper søkemotorer og brukere med å forstå hvilket innhold de kan forvente å finne på siden.",
    "The likelihood of this being a Data Privacy issue": "Sannsynligheten for at dette er et personvern problem",
    "The lowest level of readability. Example: children's books": "Det laveste nivå av lesbarhet. Eksempel: barnebøker",
    "The meta description on this page is too long": "Metabeskrivelsen på denne siden er for lang",
    "The meta description on this page is too short": "Metabeskrivelsen på denne siden er for kort",
    "The misspelling will first show up after a new scan": "Stavefeilen registreres først etter en ny skanning",
    "The name of a meta entry (page metadata)": "Navnet på en meta entry (sidens metadata)",
    "The optional base url to the CMS page": "Den valgfri basis-URL til CMS-siden",
    "The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.": "Sikkerheten til dine personlige data er svært viktig for oss. Derfor har vi oppdatert våre retningslinjer for databeskyttelse og personvern. For å fortsette å bruke plattformen vår ber vi deg vennligst om å lese og akseptere de nye vilkårene for databeskyttelse og personvern.",
    "The scan can take a few hours/days to finalise, depending on the size of the website": "Skanningen kan ta noen timer/dager å fullføre, avhengig av størrelsen på nettstedet",
    "The scan can take a few hours/days to finalise, depending on the size of the website.<br><br>Are you sure you want to start on-demand scan?": "<br><br>Skanningen kan ta noen timer/dager å fullføre, avhengig av størrelsen på nettstedet. Er du sikker på at du vil starte on-demand skanning?",
    "The scan can take a few minutes to finalise, depending on the size of the page": "Skanningen kan ta noen minutter å fullføre, avhengig av størrelsen på siden",
    "There are no META descriptions on one or more pages": "Det er ingen META-beskrivelser på en eller flere sider",
    "There are no domains assigned to this policy. Save policy anyway?": "Policyen er ikke tildelt noen domener. Lagre policy likevel?",
    "There are no more errors for this Snippet": "Det er ingen flere feil for dette utdraget",
    "There are no sub headlines on one or more pages": "Det er ingen underoverskrifter på en eller flere sider",
    "There are zero META keywords on this page": "Det er null META-nøkkelord på denne siden",
    "There is no H1 on one or more pages": "Det er ingen H1 på en eller flere sider",
    "There is no H1 on this page": "Det er ingen H1 på denne siden",
    "There is no META descriptions on this page": "Det er ingen META-beskrivelser på denne siden",
    "There is no historic data for domain groups": "Det er ingen historiske data for domenegrupper",
    "There is no historic data for this domain": "Det er ingen historiske data for dette domenet",
    "There is no sub headlines on this page": "Det er ingen underoverskrifter på denne siden",
    "These are findings that cannot be automatically checked and must be reviewed manually": "Dette er funn som ikke kan kontrolleres automatisk og må gjennomgås manuelt",
    "These are findings which are likely to be errors, requiring manual confirmation": "Dette er funn som sannsynligvis er feil, men som krever manuell bekreftelse",
    "These findings are confirmed errors": "Disse funnene er bekreftede feil",
    "Third-Party": "Tredje part",
    "This field is required": "Dette feltet er påkrevd",
    "This is the time between when an outage is first detected and when a notification is sent.": "Dette er tiden mellom når en nedetid først oppdages og når et varsel er sendt.",
    "This is useful if you have defined timeslots for maintenance.": "Dette er nyttig hvis du har definert tidsperioder for nedetid pga. vedlikehold.",
    "This issue is ignored": "Dette problemet er ignorert",
    "This link is marked as broken because it took more than 30 seconds to load": "Denne lenken er markert som brutt fordi den tok mer enn 30 sekunder å laste inn",
    "This page has been marked as no index": "Denne siden er markert som no index",
    "This page has no meta description": "Denne siden har ingen metabeskrivelse",
    "This page has no meta keywords": "Denne siden har ingen meta-nøkkelord",
    "This page has not been assigned to the Performance Module": "Denne siden er ikke tilknyttet Performance modulen",
    "This page is missing a title": "Denne siden mangler en tittel",
    "This policy is scheduled": "Denne policy er planlagt",
    "This rule doesn't contain any matches": "Denne regelen inneholder ingen matcher",
    "This section lists requirements for <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformance</a> to WCAG 2.1. It also gives information about how to make conformance claims, which are optional.": "<a target=\"_blank\" href=\"https://www.w3.org/TR/WCAG21/#dfn-conform\"></a>Dette avsnittet inneholder krav til overholdelse av WCAG 2.1. Det inneholder også informasjon om hvordan man fremsetter frivillige krav om overholdelse.",
    "Thursday": "Torsdag",
    "Time": "Tid",
    "Time Spent": "Tid brukt",
    "Time To Interactive": "Time to Interactive",
    "Time to Warning *": "Tid til advarsel *",
    "Timeframe:": "Tidsramme:",
    "Timeline": "Tidslinje",
    "Timezone": "Tidssone",
    "Title": "Tittel",
    "Title & description": "Tittel og beskrivelse",
    "Title and URL": "Tittel og URL",
    "Title and url": "Tittel og URL",
    "To setup this policy, you need to tell us how long your max word length is": "For å sette opp denne policyen må du fortelle oss hvor lang din maksimale ordlengde er",
    "To setup this policy, you need to tell us which brand name should end with TM or ™": "For å sette opp denne policyen må du fortelle oss hvilket merkenavn som skal ende med TM eller ™",
    "To toggle Quick Search:": "Slik skifter du til Hurtig Søk:",
    "Toggle Dropdown": "Dropdown til endringer",
    "Toggle dropdown": "Skift rullemeny",
    "Toggle notes": "Skift noter",
    "Toggle show filters": "Skift viste filtre",
    "Too few characters": "For få tegn",
    "Too many characters": "For mange tegn",
    "Top keywords": "Topp nøkkelord",
    "Total": "Total",
    "Total CPU Time": "Samlet CPU-tid",
    "Total QA issues": "Samlet kvalitetssikringsproblemer",
    "Total Visitors": "Samlet antall besøkende",
    "Total Visits": "Samlet antall besøk",
    "Total amount of content": "Samlet mengde innhold",
    "Total crawled": "Total crawlet",
    "Total number of issues": "Samlet antall problemer",
    "Total number of issues across all modules": "Samlet antall problemer på tvers av alle moduler",
    "Total page views over the last 30 days": "Samlet sidevisning i løpet av de siste 30 dager",
    "Total pages:": "Antall sider i alt:",
    "Total visitors": "Antall besøkende",
    "Total visitors from Referrers": "Samlet antall besøkende fra henvisere",
    "Total visitors from Search Engines": "Samlet antall besøkende fra søkemotorer",
    "Total visits": "Antall besøk",
    "Total visits from Referrers": "Antall besøk fra henvisere",
    "Total visits from Search Engines": "Antall besøk fra søkemotorer",
    "Total visits in the last 30 days:": "Antall besøk de siste 30 dager:",
    "Total words": "Antall ord",
    "Track changes across domains and modules": "Spor endringer på tvers av domener og moduler",
    "Traffic Sources": "Trafikkilder",
    "Traffic Sources Summary": "Oversikt over trafikkilder",
    "Traffic sources": "Trafikkilder",
    "Transfer Size": "Overførselsstørrelse",
    "Tuesday": "Tirsdag",
    "Twice a day": "To ganger om dagen",
    "Twitter": "Twitter",
    "Type": "Type",
    "Type the key for the metadata": "Tast inn nøkkelen til metadataene",
    "Type the text to match rule": "Skriv teksten som skal matche regel",
    "Type*": "Type*",
    "URL": "URL",
    "URL must start with a protocol. Ex. http://....": "URL skal starte med en protokoll. Eks. http: // ....",
    "URL to redirect to if form is valid": "URL som skal omdirigeres til dersom skjemaet er gyldig",
    "URL:": "URL:",
    "Unable to read link": "Ikke i stand til å lese lenken",
    "Unarchive": "Fjern arkivering",
    "Undetermined": "Ubestemt",
    "Undo": "Angre",
    "Undo review": "Angre review",
    "Unignore": "Fjern ignorering",
    "Unignore check": "Fjern ignorering av denne sjekken",
    "Unignore misspelling": "Fjern ignorering av stavefeilen",
    "Unignore on this page": "Fjern ignorering av denne siden",
    "Unignore this SEO issue": "Fjern ignorering av dette SEO-problemet",
    "Unignore this check for this domain": "Fjern ignorering av denne sjekken for dette domenet",
    "Unique Visitors": "Unike besøkende",
    "Unique downloads": "Unike nedlastninger",
    "Unknown": "Ukjent",
    "Unknown Score": "Ukjent score",
    "Unknown title": "Ukjent tittel",
    "Unpin domain": "Unpin domene",
    "Unsaved changes": "Ikke-lagrede endringer",
    "Unwanted": "Uønsket",
    "Unwanted content": "Uønsket innhold",
    "Unwanted violations": "Uønskede brudd",
    "Update": "Oppdatering",
    "Update groups": "Oppdater grupper",
    "Updated": "Oppdatert",
    "Updated At": "Oppdatert kl",
    "Updated at": "Oppdatert kl",
    "Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Oppdatering av grupper kan ta mer enn 30 minutter. Under oppdateringen vil du ikke kunne opprette eller oppdatere grupper.",
    "Upload CSV": "Last opp CSV",
    "Upload csv file": "Last opp csv-fil",
    "Uptime": "Oppetid",
    "Uptime last 30 days": "Oppetid siste 30 dager",
    "Url*": "URL *",
    "Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors": "Bruk * som et jokertegn (f.eks. 192.168.1. *). Ekskluderte IP-adresser påvirker kun nye besøkende",
    "Use language attribute": "Bruk språkattributt",
    "Use or Apply custom PageCorrect": "Bruk eller implementer tilpasset PageCorrect",
    "User": "Bruker",
    "User Export": "Brukereksport",
    "User List": "Brukerliste",
    "User Loading Experience": "Brukeropplevelse ved lasting",
    "User information": "Brukeropplysninger",
    "User interface components and navigation must be operable.": "Brukergrensesnittkomponenter og navigasjon skal kunne betjenes.",
    "User is account administrator": "Bruker er kontoadministrator",
    "Username": "Brukernavn",
    "Value": "Verdi",
    "Value*": "Verdi*",
    "Vat no": "VAT nr",
    "Verify URL*": "Bekreft URL*",
    "Very easy": "Veldig lett",
    "Very hard": "Veldig vanskelig",
    "View options": "Innstillinger for visning",
    "Viewing as Profile:": "Viser som profil:",
    "Views": "Visninger",
    "Violation": "Brudd",
    "Violation count": "Antall brudd",
    "Violation's info_type name not set": "Bruddets info_type navn ikke satt",
    "Violations": "Brudd",
    "Visible": "Synlig",
    "Visible modules": "Synlige moduler",
    "Visit the affected image": "Se det berørte bildet",
    "Visitor Overview": "Oversikt over besøkende",
    "Visitor Summary": "Sammendrag av besøkende",
    "Visitor log": "Besøkslogg",
    "Visitor profile": "Besøksprofil",
    "Visitor profile:": "Besøksprofil:",
    "Visitors": "Besøkende",
    "Visitors Summary": "Sammendrag av besøkende",
    "Visits": "Besøk",
    "Visual mode": "Visuell modus",
    "WCAG 2.0 (Level A)": "WCAG 2.0 (nivå A)",
    "WCAG 2.0 (Level AA)": "WCAG 2.0 (nivå AA)",
    "WCAG 2.0 (Level AAA)": "WCAG 2.0 (nivå AAA)",
    "WCAG 2.0 Accessibility Compliance": "Overholdelse av WCAG 2.0 tilgjengelighet",
    "WCAG 2.1 (Level A)": "WCAG 2.1 (nivå A)",
    "WCAG 2.1 (Level AA)": "WCAG 2.1 (nivå AA)",
    "WCAG 2.1 (Level AAA)": "WCAG 2.1 (nivå AAA)",
    "WCAG 2.1 Accessibility Compliance": "Overholdelse av WCAG 2.1 tilgjengelighet",
    "Want to search for": "Søk etter",
    "Warning": "Advarsel",
    "We recommend that all your pages has a number of relevant meta keywords.": "Vi anbefaler at alle dine sider har et antall relevante meta nøkkelord.",
    "We recommend that all your pages has a relevant and unique meta description.": "Vi anbefaler at alle dine sider har en relevant og unik metabeskrivelse.",
    "We recommend that all your pages has an unique title.": "Vi anbefaler at alle dine sider har en unik tittel.",
    "We recommend that the meta description consists of at least 50 characters.": "Vi anbefaler at metabeskrivelsen består av minst 50 tegn.",
    "We recommend that the meta description consists of no more than 160 characters.": "Vi anbefaler at metabeskrivelsen ikke består av mer enn 160 tegn.",
    "We recommend that you give each page a unique title.": "Vi anbefaler at du gir hver side en unik tittel.",
    "We recommend that you have a unique H1 tag on each page.": "Vi anbefaler at du har et unikt H1-tag på hver side.",
    "We recommend that you have at least one H2-H6": "Vi anbefaler at du har minst en H2-H6",
    "We recommend that you have no more than 100 internal links on each page.": "Vi anbefaler at du ikke har mer enn 100 interne lenker på hver side.",
    "We recommend that you keep your URL below 200 characters.": "Vi anbefaler at du holder din URL under 200 tegn.",
    "We recommend that you only have one H1 tag on each page.": "Vi anbefaler at du kun har en H1-tag på hver side.",
    "Wednesday": "Onsdag",
    "Weekly": "Ukentlig",
    "Well done - no accessibility issues found": "Bra jobbet - ingen tilgjengelighetsproblemer funnet",
    "We’ve Updated our Privacy Policy!": "Vi har oppdatert vår personvernpolicy!",
    "Why is this an issue": "Hvorfor er dette et problem?",
    "With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go": "Med Fast Track kan du fikse, gjennomgå og ignorere HTML-snutter på berørte sider samtidig",
    "Word": "Ord",
    "Word Count": "Antall ord",
    "Word count": "Antall ord",
    "Word count in PDF": "Antall ord i PDF",
    "Word is added to dictionary": "Ordet er lagt til i ordboken",
    "Word is added to dictionary for all languages": "Ordet er lagt til i ordboken for alle språk",
    "Word is confirmed as misspelling": "Ordet er bekreftet som stavefeil",
    "Word length": "Ordlengde",
    "Word links": "Ordlenker",
    "Word or Phrase": "Ord eller setning",
    "Words": "Ord",
    "Would you like to update now? Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups": "Vil du oppdatere nå? Oppdatering av grupper kan ta mer enn 30 minutter. Under oppdateringen vil du ikke kunne opprette og oppdatere grupper",
    "Written by: [[author]]": "Skrevet av: [[author]]",
    "Years": "År",
    "You are about to delete": "Du er i ferd med å slette",
    "You are about to delete the domain": "Du er i ferd med å slette domenet",
    "You are about to delete the domain group": "Du er i ferd med å slette domenegruppen",
    "You are currently using Demo Data, certain features will be unavailable": "Siden du i øyeblikket bruker demo-data vil ikke visse funksjoner være tilgjengelig",
    "You are receiving this report": "Du mottar denne rapporten",
    "You can create another [[customerProfilesLimit]] profiles for your account": "Du kan opprette en annen [[customerProfilesLimit]]-profil til din konto",
    "You can pin this domain. Pinned domains will be shown at the top of your domain list": "Du kan feste dette domenet. Festede domener vil vises øverst på domenelisten din",
    "You have more than one H1 tag on this page": "Du har mer enn én H1-overskrift på denne siden",
    "You have no H2-H6 tags on the page": "Du har ingen H2-H6-tagger på siden",
    "You have no available profiles": "Du har ingen tilgjengelige profiler",
    "You have not received any reports": "Du har ikke mottatt noen rapporter",
    "You have one or more pages with the \\\"noindex\\\" META tag": "Du har en eller flere sider med meta-taggen \\\"noindex\\\"",
    "You have reached the maximum number of profiles for this account.": "Du har nådd det maksimale antall profiler for denne kontoen.",
    "You have too many internal links": "Du har for mange interne lenker",
    "You will receive an email when the export is ready.": "Du vil motta en e-post når eksporten er klar.",
    "Your Users Technology": "Din brukers teknologi",
    "Zero links were found": "Det ble ikke funnet noen lenker",
    "Zip code": "Postnummer",
    "achieved": "Oppnådd",
    "affected image": "Berørt bilde",
    "and": "og",
    "and does not conform with": "og er ikke i overensstemmelse med",
    "contact": "kontakt",
    "contains": "Inneholder",
    "content": "Innhold",
    "diagnostics_errors.csv": "diagnostics_errors.csv",
    "diagnostics_passed.csv": "diagnostics_passed.csv",
    "disabling": "deaktivering",
    "document": "dokument",
    "documents": "dokumenter",
    "done": "ferdig",
    "enabling": "muliggjør",
    "ends_with": "slutter_med",
    "excluded": "ekskludert",
    "go to the matched link": "gå til den matchende lenken",
    "image": "bilde",
    "included": "inkludert",
    "insert brand name": "Sett inn merkenavn",
    "insert context fx. us": "Sett inn kontekst fx. oss",
    "insert max word length": "Innsett maksimal ordlengde",
    "insert word fx. contact": "Innsett ord fx. kontakt",
    "is": "er",
    "is_exactly": "is_exactly",
    "language": "språk",
    "link": "lenke",
    "match (regex)": "Match (regex)",
    "metadata": "Metadata",
    "milliseconds": "Millisekunder",
    "minutes": "Minutter",
    "n/a": "Ikke relevant",
    "not": "ikke",
    "opportunities_errors.csv": "opportunities_errors.csv",
    "opportunities_passed.csv": "opportunities_passed.csv",
    "overall compliance": "Generell compliance",
    "pages": "Sider",
    "path": "Sti",
    "please type": "Vennligst skriv",
    "reviewed": "gjennomgått",
    "rows - click to change": "rader - klikk for å endre",
    "search engines overview": "søkemotorer oversikt",
    "should always be followed by": "skal alltid etterfølges av",
    "social network overview": "sosiale nettverk oversikt",
    "starts_with": "starter_med",
    "that": "som",
    "title": "tittel",
    "to confirm this action": "for å bekrefte denne handlingen",
    "to fix": "å fikse",
    "url": "url",
    "us": "oss",
    "visits": "besøk",
    "you have one or more pages that contains links with rel=\\\"nofollow\\\"": "Du har en eller flere sider med lenker som inneholder attributten rel=\\\"nofollow\\\"",
    "{{ pagesDone }} Pages ({{ compliancePercentage }}) in compliance": "{{pagesDone}} sider ({{compliancePercentage}}) i compliance",
    "{{ totalPageIssues }} Pages ({{ compliancePercentage }}) to fix": "{{totalPageIssues}} sider ({{compliancePercentage}}) som skal rettes",
    "[[label]]: [[value]] Pages": "[[label]]: [[value]] Sider",
    "[[label]]: [[value]]ms": "[[label]]: [[value]] ms",
    "[[languageName]] ([[languageCount]])": "[[languageName]] ([[languageCount]])",
    "[[ms]] ms": "[[ms]] ms",
    "[[name]] have already been scanned for compliance. Are you sure you want to scan it again?": "[[name]] er allerede skannet for compliance. Er du sikker på at du vil skanne den igjen?",
    "[[pageCount]] Pages": "[[pageCount]] sider",
    "[[pageCount]] pages found with this issue": "[[pageCount]] sider funnet med dette problemet",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.0[[spanEnd]] (nivå A)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (nivå AA)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (nivå AAA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.1[[spanEnd]] (nivå A)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (nivå AA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (nivå AAA)",
    "1 found": [
      "[[$count | monNumber]] funnet",
      "[[$count | monNumber]] funnet"
    ],
    "1 issue found": [
      "Fant [[$count | monNumber]] problem",
      "Fant [[$count | monNumber]] problemer"
    ],
    "1 word found": [
      "1 ord funnet",
      "[[$count | monNumber]] ord funnet"
    ],
    "Total: 1 Performance Page": [
      "I alt: 1 Performance side",
      "I alt: [[$count | monNumber]] Performance-sider"
    ],
    "You have 1 to do": [
      "Du har 1 problem å rette opp",
      "Du har [[issues]] problemer å rette"
    ],
    "page": "side",
    "Are you sure you want to remove Custom PageCorrect? <br> Please type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Er du sikker på at du ønsker å slette en egendefinert PageCorrect?  Skriv vennligst [[deleteTag]]Delete[[deleteTagEnd]] i feltet for å bekrefte handlingen.",
    "You are about to remove PageCorrect for this check <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du er i ferd med å slette en PageCorrect-rettelse for denne sjekken. Skriv [[deleteTag]]Delete[[deleteTagEnd]] i feltet for å bekrefte handlingen.",
    "You are about to remove PageCorrect for this misspelling <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du er i ferd med å slette en PageCorrect-rettelse for denne stavefeilen. Skriv [[deleteTag]]Delete[[deleteTagEnd]] i feltet for å bekrefte handlingen.",
    "You are about to remove PageCorrect for this [[type]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du er i ferd med å slette PageCorrect for typen [[type]] Skriv [[deleteTag]]Delete[[deleteTagEnd]] i feltet for å bekrefte handlingen.",
    "You are about to remove [[titleTag]][[title]][[titleTagEnd]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du er i ferd med å slette [[titleTag]][[title]][[titleTagEnd]]  Skriv [[deleteTag]]Delete[[deleteTagEnd]] i feltet for å bekrefte handlingen.",
    "Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it's place": "<br><strong></strong>Er du sikker på at du vil tilbagetrekke token for API-brukeren [[apiUserId]]OBS Et nytt token vil bli generert i stedet for",
    "Maximum critical path latency: <strong>[[latency]] ms </strong>": "<strong></strong>Maksimal ventetid for den kritiske stien: [[latency]] ms␣",
    "Are you sure you want to remove <code>all</code> [[type]] PageCorrects? <br> Please type <code>Delete</code> to confirm this action": "<code></code><br><code></code>Er du sikker på at du ønsker å fjerne all [[type]] PageCorrect-rettelser?  Skriv vennligst Delete i feltet for å bekrefte handlingen",
    "<strong>[[checkName]]</strong><br><br>Add reason (Optional)": "<strong></strong><br><br>[[checkName]]Legg til begrunnelse (valgfritt)",
    "Are you sure you want to confirm the misspelling <strong>' + word.word + '</strong>?": "<strong></strong>Er du sikker på at du ønsker å bekrefte ordet ' + word.word + ' som stavefeil?",
    "Are you sure you want to delete the policy <strong>[[policyName]]</strong>": "<strong></strong>Er du sikker på at du ønsker å slette policy'en [[policyName]]?",
    "Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?": "<strong></strong>Er du sikker på at du vil markere denne policy [[policyName]] som rettet?",
    "Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>": "<strong></strong>Er du sikker på at du ønsker å fjerne denne Varmekart-regelen fra [[pageUrl]]?",
    "Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?": "<strong></strong>Er du sikker på at du ønsker å fjerne regelen ' + rule.name + '?",
    "Are you sure you want to run the policy <strong>' + policy.name + '</strong>?": "<strong></strong>Er du sikker på at du ønsker å kjøre denne policyen ' + policy.name + '?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong> again?": "<strong></strong>Er du sikker på at du ønsker å kjøre denne policy [[policyName]] igjen?",
    "Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?": "<strong></strong>Er du sikker på at du ikke lengre ønsker å ignorere policyen [[policyName]]?",
    "You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.": "<strong></strong><strong></strong>I øyeblikket har du [[spellingFixes]] stavefeil som bør rettes. Vi anbefaler at du holder antallet under [[spellingLimit]], så du sikrer at siden blir vist uten feil.",
    "You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.": "<strong></strong><strong></strong>I øyeblikket har du [[totalFixes]] rettelser. Vi anbefaler at du holder antallet rettelser under [[pageFixLimit]], så du sikrer optimal yteevne på siden. Det er imidlertid på eget skjønn.",
    "[[users]]<strong>and [[userCountLeft]] more</strong>": "<strong></strong>[[users]]og [[userCountLeft]] ytterligere",
    "Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?": "<strong></strong>Er du sikker på at du ønsker å ignorere policyen [[policyName]]?",
    "Title:": "Tittel:",
    "[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]": "<strong></strong>[[msg]] [[regulationName]] resulterer i at [[opposite]] regler for de følgende problemer overskrives. Det betyr at de [[negate]] vil bli markert ved fremtidige skanninger: [[list]]",
    "Admin only": "Kun admin",
    "Apply fix": "Implementer rettelse",
    "Contains high, medium or low opportunities": "Inneholder høye, middels og lave muligheter",
    "Design": "Design",
    "Enable Custom PageCorrect Settings": "Aktiver tilpassede PageCorrect-innstillinger",
    "Enable PageCorrect features below. Disabled features will not be shown on your dashboard.": "Aktiver PageCorrect-funksjoner nedenfor. Deaktiverte funksjoner vil ikke vises på dashbordet ditt.",
    "Enable PageCorrect for Accessibility Source Codes": "Aktiver PageCorrect for tilgjengelighets-kildekoder",
    "Enable PageCorrect for Broken Links": "Aktiver PageCorrect for brutte lenker",
    "Enable PageCorrect for Misspellings": "Aktiver PageCorrect for stavefeil",
    "Enable PagedCorrect for Accessibility Checks": "Aktiver PagedCorrect for tilgjengelighetskontroller",
    "Failing checks - A": "Feilende sjekker - A",
    "Failing checks - AA": "Feilende sjekker - AA",
    "Failing checks - AAA": "Feilende sjekker - AAA",
    "Good job! Your domain contains no Accessibility Issues for this section": "Bra jobbet! Domenet ditt har ikke flere tilgjengelighetsproblemer for denne seksjonen",
    "Indicates the difficulty to apply this fix": "Indikerer vanskelighetsgraden med å implementere denne rettingen",
    "List of improvements that can be applied to your website to improve your Accessibility Compliance": "Liste over forbedringer som kan gjøres på nettstedet ditt for å forbedre din compliance ift. tilgjengelighet",
    "Manage": "Administrer",
    "Media": "Medier",
    "Open PageCorrect Settings": "Åpne PageCorrect innstillinger",
    "PageCorrect Settings Updated": "PageCorrect innstillinger oppdatert",
    "PageCorrect settings": "PageCorrect innstillinger",
    "Pages with Data Privacy violations": "Sider med personvernbrudd",
    "Should admin be the only one to set PageCorrect Settings": "Skal admin være den eneste som kan sette opp PageCorrect-innstillinger",
    "Website Structure": "Nettside struktur",
    "Data Privacy violations": "Personvernbrudd",
    "Heartbeat check": "Heartbeat-sjekk",
    "Request PDF accessibility check from selection": "Be om PDF-tilgjengelighetskontroll for valgte dokumenter",
    "Total unique downloads": "Totale unike nedlastninger",
    "[[succeededPdfs]] out of [[pdfs]] PDF accessibility request succeeded": "[[successedPdfs]] ut av [[pdfs]] forespørsler om tilgjengelighets-skanning av PDF lykkes",
    "Accessibility Issues": "Tilgjengelighetsproblemer",
    "Inspecting:": "Inspiserer:",
    "Pages with Accessibility Issues": "Sider med tilgjengelighetsproblemer",
    "Start advance export": "Start avansert eksport",
    "Check whether your website is responding and measures the response times of the server": "Sjekk om nettstedet ditt responderer og måler serverens responstider",
    "Search label": "Søkemerke",
    "Custom range": "Egendefinert",
    "Last Half Year": "Forrige halvår",
    "Last Month": "Forrige måned",
    "Last Quarter": "Forrige kvartal",
    "Last Week": "Forrige uke",
    "Last Year": "I fjor",
    "Character": [
      "Tegn",
      "Tegn"
    ],
    "Image missing alt attribute": "Bilde mangler alt-attributt",
    "Quick info here": "Hurtig forklaring",
    "There is 1 META description on this page": "Det er 1 META-beskrivelse på denne siden",
    "There is 1 internal link on this page": [
      "Det er 1 intern lenke på denne siden",
      "Det er [[$count | monNumber]] interne lenker på denne siden"
    ],
    "There is one META description on this page": [
      "Det er én META-beskrivelse på denne siden",
      "META beskrivelsen på denne siden"
    ],
    "and 1 document": {
      "Documents with broken images": [
        "og 1 dokument",
        "␣og [[$count | monNumber]] dokumenter"
      ],
      "Documents with confirmed misspellings": [
        "og 1 dokument",
        "og [[$count | monNumber]] dokumenter"
      ],
      "Documents with potential misspellings": [
        "og 1 dokument",
        "og [[$count | monNumber]] dokumenter"
      ]
    },
    "and one document": {
      "Pages with broken links": [
        "og ett dokument",
        "og [[$count | monNumber]] dokumenter"
      ]
    },
    "Remediation": "Utbedring",
    "Remediation quote": "Tilbud på utbedring",
    "Remediation quote has been requested": "Forespørsel om prisoverslag for utbedring er sendt inn",
    "Sort by": {
      "Exchange center filter option": "Sorter etter"
    },
    "#idname.class-name1.class-name2": "# idname.class-name1.class-name2",
    "&lt;i&gt; tags as icons": "& lt; i & gt; tags som ikoner",
    ".class-name1": ".class-name1",
    "<strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)": "<strong></strong> CSS-styling til strong-tag  (gjør all fet tekst rødt)",
    "<strong>NOTE</strong>: Changing the text below, will override the text in all your included languages": "<strong></strong>OBS: Å endre teksten nedenfor vil overstyre teksten i alle dine inkluderte språk",
    "A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations": "En nyere versjon av PageAssist er tilgjengelig. Bytt til versjon 2.0 for å få adgang til nye tilpasninger",
    "Accessibility Fixes": "Tilgjengelighets rettelser",
    "Add Policy": "Legg til Policy",
    "Add a description of the widget to your users": "Legg til en beskrivelse av widgeten til brukerne dine",
    "Add comment (Optional)": "Legg til kommentar (valgfritt)",
    "Add row": "Legg til rad",
    "Add text for when the button is hovered": "Legg til tekst for når knappen blir svevet over",
    "Add title": "Legg til tittel",
    "Africa": "Afrika",
    "All <code>img</code> elements have an <code>alt</code> attribute": "<code></code><code></code>Alle  img  -elementer har en  alt  -attributt",
    "Alt text does not convey the same information as the image": "Alt-tekst overfører ikke de samme opplysningene som bildet",
    "Alt text for all <code>img</code> elements contains all text in the image unless the image text is decorative or appears elsewhere in the document": "<code></code>Alt-tekst for alle  img  -elementer inneholder all tekst i bildet, med mindre bildeteksten er dekorativ eller vises et annet sted i dokumentet",
    "Alt text for all <code>img</code> elements is not placeholder text unless author has confirmed it is correct": "<code></code>Alt-tekst for alle  img  -elementer er ikke plassholdertekst, med mindre forfatteren har bekreftet at den er korrekt",
    "Alt text for all <code>img</code> elements is the empty string (\\\"\\\") if the image is decorative.": "<code></code>Alt-tekst for alle  img  -elementer er den tomme strengen (\\ \"\\\"), hvis bildet er dekorativt.",
    "Alt text for all <code>img</code> elements used as source anchors is not empty when there is no other text in the anchor": "<code></code>Alt-tekst for alle  img  -elementer som brukes som kildeanker er ikke tom når det ikke er noen annen tekst i ankeret",
    "Alt text is not the same as the filename unless author has confirmed it is correct": "Alt-teksten er ikke den samme som filnavnet, med mindre forfatteren har bekreftet at den er korrekt",
    "And how are we going to fix it?": "Og hvordan skal vi fikse det?",
    "Applying fix": "Implementerer rettelse",
    "Are you sure you want to stop receiving this report?": "Er du sikker på at du ikke lengre ønsker å motta denne rapporten?",
    "Aria-label": "Aria-label",
    "Asia": "Asia",
    "Blink sample image": "Blink-testbilde",
    "Blink testing sample image": "Test av blink-testbilde",
    "Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.": "Begge disse problemene kan i praksis forårsake flere visuelle problemer, fra feil farger til upassende rom der ingen burde eksistere.",
    "Bottom center": "Nederst i midten",
    "Bottom left": "Nederst til venstre",
    "Bottom right": "Nederst til høyre",
    "Browse": "Se igjennom",
    "Button hover message": "Beskjed ved knapp-hover",
    "CSS selector": "CSS-selektor",
    "Change <b> tags to a custom element": "Endre <b> tags til et egendefinert element",
    "Change <b> tags to a custom tag": "Endre <b> tags til en egendefinert tag",
    "Change <blink> tags to a custom element": "Endre <blink> tags til et egendefinert element",
    "Change <blink> tags to a custom tag": "Endre <blink> tags til en egendefinert tag",
    "Change <marquee> tags to a custom element": "Endre <marquee> -tags til et egendefinert element",
    "Change <marquee> tags to a custom tag": "Endre <marquee> -tags til en egendefinert tag",
    "Change your &lt;blink&gt; tags into something else": "Endre din & lt; blink & gt; tags til noe annet",
    "Change your &lt;i&gt; elements into something else": "Endre dine & lt; i & gt; elementer til noe annet",
    "Change your &lt;marquee&gt; tags into something else": "Endre dine & lt; telt & gt; tags til noe annet",
    "Check for misspelling company name: [[company]]": "Kontroller om firmanavn er stavet feil: [[company]]",
    "Choose a tag to replace your b tags with": "Velg en tag som du vil erstatte dine b-tags med",
    "Choose a tag to replace your blink tags with": "Velg en tag som du vil erstatte dine blink-tags med",
    "Choose a tag to replace your italic tags with": "Velg en tag som du vil erstatte dine kursive tags med",
    "Choose a tag to replace your marquee tags with": "Velg en tag som du vil erstatte dine marquee-tags med",
    "Choose an icon": "Velg et ikon",
    "Choose this option to customise the fix": "Velg dette alternativet for å tilpasse rettelsen",
    "Choose this option to customize the fix": "Velg dette alternativet for å tilpasse rettelsen",
    "Choose your own text for the warning pop-up": "Velg din egen tekst til pop-up advarselen",
    "Circle": "Sirkel",
    "Class": "Klasse",
    "Close PageCorrect form": "Lukk PageCorrect skjema",
    "Close [[groupName]]: [[labelName]]": "Lukk [[groupName]]: [[labelName]]",
    "Company name *": "Firmanavn *",
    "Constraint:": "Begrensning:",
    "Custom settings": "Tilpassede innstillinger",
    "Default fix": "Standard fix",
    "Default language": "Standard språk",
    "Dutch": "Nederlandsk",
    "Edit Report": "Rediger rapport",
    "Education": "Utdannelse",
    "Element name is invalid": "Navn på element er ugyldig",
    "Element name should not contain spaces": "Navn på element bør ikke inneholde mellomrom",
    "Enter aria-label name": "Inntast navn på aria-label",
    "Enter class name": "Inntast klasse navn",
    "Enter role name": "Inntast navn på rolle",
    "Europe": "Europa",
    "Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:": "Selv om dette er en ganske enkel retting, er det to måter hvor dette kan forårsake designproblemer på nettstedet ditt:",
    "Example 1": "Eksempel 1",
    "Example 2": "Eksempel 2",
    "File must be below 1MB": "Filen skal være under 1 MB",
    "Filter dropdown": "Dropdown-filter",
    "Finance": "Finans",
    "Fix applied!": "Retting anvendt!",
    "Fix options": "Alternativer for retting",
    "French": "Fransk",
    "Give a title to your Skip to Content button": "Gi en tittel til din Gå til innhold-knapp",
    "Government": "Myndighet",
    "Grid view": "Rutenettvisning",
    "Hide": "Skjul",
    "Hide text": "Skjul tekst",
    "Hitting the tab button will turn on Skip to PageAssist": "Dersom du trykker på faneknappen aktiveres Gå til PageAssist",
    "How are we going to fix it?": "Hvordan skal vi fikse det?",
    "Icon shape": "Ikonform",
    "Image Alt text is short": "Bilde Alt-tekst er kort",
    "Important images should not have spacer Alt text": "Viktige bilder bør ikke ha mellomroms Alt-tekst",
    "Info": "Info",
    "Insert company name": "Innsett firmanavn",
    "Instead of &lt;i&gt; choose a different element name to be used instead": "I stedet for & lt; i & gt; velg et annet elementnavn som skal brukes i stedet",
    "It will take some time before our system will register your changes to PageCorrect": "Det vil ta litt tid før systemet vårt registrerer endringene dine for PageCorrect",
    "Left middle": "Venstre midtre",
    "Letter case *": "Bokstav-følsomhet *",
    "Light": "Lys",
    "Link excludes:": "Lenke-ekskluderinger:",
    "Loading PageFix": "Laster PageFix",
    "Make sure you use correct formatting and add multiple selectors when your page design differs": "Sørg for at du bruker korrekt formatering og legger til flere selektorer når sideutformingen er forskjellig",
    "Manage options": "Administrer muligheter",
    "Marquee sample image": "Marquee-eksempelbilde",
    "Marquee testing sample image": "Marquee-test eksempelbilde",
    "Menu theme": "Menytema",
    "New Window Information": "Opplysninger om nytt vindu",
    "New Window Test": "Nytt vindu test",
    "Non-Decorative images must have Alt text": "Ikke-dekorative bilder skal ha Alt-tekst",
    "North America": "Nord-Amerika",
    "PageAssist Logo": "PageAssist-logo",
    "PageAssist position on Page": "PageAssists posisjon på siden",
    "Portuguese": "Portugisisk",
    "Potential problems that can arise": "Potensielle problemer som kan oppstå",
    "Press 'Upload link' to save your URL settings": "Trykk på 'Last opp lenke' for å lagre dine URL-innstillinger",
    "Preview": "Forhåndsvisning",
    "Proper Case": "Riktig størrelse på skrift",
    "Remove input selector": "Fjern input-velgeren",
    "Remove logo upload": "Fjern opplastning av logo",
    "Remove row": "Fjern rad",
    "Repair Tip": "Reparasjonstips",
    "Repair options": "Reparasjonsalternativer",
    "Replace Italic element with EM": "Erstatt kursiv element med EM",
    "Replace all &lt;b&gt; tags with": "Erstatt alle & lt; b & gt; tags med",
    "Replace all &lt;blink&gt; tags with": "Erstatt alle & lt; blink & gt; tags med",
    "Replace all &lt;i&gt; tags": "Erstatt alle & lt; i & gt; tags",
    "Replace all &lt;marquee&gt; tags with": "Erstatt alle &lt;marquee&gt; tags med",
    "Report Center Image": "Senterbildet i rapporten",
    "Reset Input": "Nullstill input",
    "Reset Skip to content text to its default": "Tilbakestill Gå til innhold til standard",
    "Reset design": "Nullstill design",
    "Reset to default": "Nullstill til standard",
    "Restore": "Gjenopprett",
    "Restore profile?": "Gjenopprett profil?",
    "Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.": "<strong></strong>Gjenopprettelse av denne profilen ([[profileName]]) gjør den tilgjengelig i dine moduler.",
    "Right middle": "Høyre midtre",
    "Rounded Box": "Avrundet boks",
    "Russian": "Russisk",
    "Show": "Vis",
    "Show details": "Vis detaljer",
    "Show text": "Vis tekst",
    "Simplified Chinese": "Forenklet kinesisk",
    "Skip to Content": "Gå til innhold",
    "Snippet reset": "Nullstilling av Snippet",
    "Someone have created this PageCorrect before you, on another check.": "Noen har opprettet denne PageCorrect før deg, i en annen sjekk.",
    "Spanish Mexican": "Spansk Mexikansk",
    "Start export inventory emails": "Start eksport av e-postadresser for lager",
    "Start export inventory emails extended": "Start utvidet eksport av e-postadresser for lager",
    "Testing": "Testing",
    "The subpath/subfolder the WordPress installation is under": "Understien/undermappen WordPress-installasjonen er under",
    "This fix requires development knowledge": "Denne løsningen krever kunnskap om utvikling",
    "This message will be displayed when the user hovers over the PageAssist button": "Denne meldingen vil bli vist når brukeren holder datamusen over PageAssist-knappen",
    "This option might cause problems to your icons": "Dette valget kan forårsake problemer med dine ikoner",
    "Title Text": "Titteltekst",
    "To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check": "For å sette opp denne policyen må du oppgi bedriftsnavnet og den mulige feilstavede bokstavtypen du ønsker å kontrollere",
    "Top center": "Topp senter",
    "Top left": "Øverst til venstre",
    "Top right": "Øverst til høyre",
    "Trying out the pop-up": "Tester ut pop-up vinduet",
    "UPPERCASE": "STORE BOKSTAVER",
    "Undo check review": "Angre sjekkgjennomgang",
    "Upload link": "Last opp lenke",
    "Upload logo": "Last opp logo",
    "Use Datepicker": "Bruk datovelger",
    "Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>": "<code></code>Bruk PageCorrect til å rette følgende stavefeil: [[stavefejl]]",
    "Use PageCorrect to fix Broken Link": "Bruk PageCorrect til å rette brutt lenke",
    "Use PageCorrect to fix these image sources": "Bruk PageCorrect til å rette disse bildekildene",
    "Value:": "Verdi:",
    "View": "Se",
    "What is wrong with the &lt;b&gt; (bold) element?": "Hva er galt med &lt;b&gt; (fet) element?",
    "What is wrong with the &lt;i&gt; (italic) element?": "Hva er galt med &lt;i&gt; (kursiv) element?",
    "What to do when the link doesn't work?": "Hva skal jeg gjøre når lenken ikke fungerer?",
    "What to do when things look wrong?": "Hva skal jeg gjøre når ting ser feil ut?",
    "Why shouldn't I use the blink element?": "Hvorfor bør jeg ikke bruke blinkelementet?",
    "Widget Design and Text": "Widget-design og tekst",
    "Widget Icon Setup": "Oppsett av widget ikon",
    "Without any assigned class": "Uten noen tildelt klasse",
    "Write a warning to your outbound link": "Skriv en advarsel til din utgående lenke",
    "Write custom tag": "Skriv egendefinert tag",
    "lowercase": "små bokstaver",
    "with": "med",
    "with &lt;em&gt;": "med & lt; em & gt;",
    "Statistics is using sample data": "Statistikk baseres på prøvedata",
    "Statistics results are sample data for demo purposes - export is disabled": "Statistikk resultater baseres på prøvedata til demoformål - eksport er deaktivert",
    "This section is using sample data": "Denne seksjonen anvender prøvedata",
    "&lt;i&gt; tags with these attribute values will not be changed": "&lt;i&gt; tags med disse attributverdier vil ikke bli endret",
    "(Bad)": "(Dårlig)",
    "(Good)": "(God)",
    "<span class=\\\"mr-2\\\">Pages</span>": "<span class=\\\"mr-2\\\">Sider</span>",
    "Add API user": "Legg til API-bruker",
    "Add attributes to be excluded in this change": "Legg til attributter som skal ekskluderes i denne endringen",
    "Add profile": "Legg til profil",
    "Add source code exclude": "Legg til kildekode som skal ekskluderes",
    "Are you sure?": "Er du sikker?",
    "Button hover color": "Farge på hover-knappen",
    "Calculated by no. and severity of issues, page views and links leading to this page..": "Beregnet ut fra antall og alvorlighetsgrad av problemer, sidevisninger og lenker som fører til denne siden..",
    "Choose minimum word count for a page to be included in the readability test": "Angi minimum antall ord for at en side skal inkluderes i lesbarhetstesten",
    "Color contrast ratio": "Fargekontrastforhold",
    "Content id tag": "Id-tag for innhold",
    "Creation date": "Dato for opprettelse",
    "Custom text": "Egendefinert tekst",
    "Customise the Information page": "Tilpasning av informasjonssiden",
    "Disable": "Deaktiver",
    "Docs without downloads": "Dokumenter uten nedlastninger",
    "Documents Without Downloads": "Dokumenter Uten Nedlastninger",
    "EPI Server Path": "EPI-serversti",
    "EPIServer": "EPIServer",
    "Editor": "Editor",
    "Ex: data-currentpage, or data-pageid, or CurrentPageLink": "Ex: data-currentpage, eller data-pageid, eller CurrentPageLink",
    "Ex: lang or CurrentPageLanguage": "Ex: lang eller CurrentPageLanguage",
    "Export both pages and documents": "Eksporter både sider og dokumenter",
    "Export only documents without downloads": "Eksporter kun dokumenter uten nedlastninger",
    "Export only html pages without visits": "Eksporter kun html-sider uten besøk",
    "Include Accessibility Statement": "Inkluder tilgjengelighetserklæring",
    "Include custom info text": "Inkluder egendefinert informasjonstekst",
    "Includes a button with a link to your accessibility statement": "Inkluderer en knapp med en lenke til din tilgjengelighetserklæring",
    "Indicates which language this page will be scanned in. Click underneath to change": "Indikerer hvilket språk denne siden vil skannes i. Klikk under for å endre",
    "Insert a valid URL": "Sett inn en gyldig URL",
    "Language tag": "Språk-tag",
    "Last assigned profile on page. Page will be removed from Performance": "Siste tildelte profil på siden. Siden vil bli fjernet fra Performance",
    "Link color": "Lenkefarge",
    "Link opens in a new tab": "Lenken åpner i ny fane",
    "Main color": "Primær farge",
    "Meta name": "Metanavn",
    "Mode": "Modus",
    "No default profile selected for this page, scoring not available.": "Det er ikke valgt noe standardprofil for denne siden, scoring ikke tilgjengelig.",
    "No documents found": "Ingen dokumenter funnet",
    "No profiles selected for this page, scoring not available.": "Ingen profiler valgt for denne siden, scoring ikke tilgjengelig.",
    "Not a valid CSS selector": "Ikke en gyldig CSS-selektor",
    "Notification when the downtime ends": "Varsel når nedetiden er over",
    "Number of external links": "Antall eksterne lenker",
    "Number of incoming links": "Antall innkommende lenker",
    "Open details": "Åpne detaljer",
    "PDF Accessibility": "Tilgjengelighet av PDF-filer",
    "Passwords do not match": "Passord matcher ikke",
    "Please add a Default Profile to your Page": "Vennligst legg til en standardprofil til din side",
    "Please add a Profile to your Page": "Vennligst legg til en profil til din side",
    "Please enter a valid color code": "Vennligst inntast en gyldig fargekode",
    "Please perform a PDF scan to see the results for the checks below": "Vennligst utfør en PDF-skanning for å se resultatene for kontrollene nedenfor",
    "Setup": "Oppsett",
    "Show less of the code snippet": "Vis mindre av kodeutdraget",
    "Show the full code snippet": "Vis hele kodeutdraget",
    "Statistics not activated. Page Views not available.": "Statistikker er ikke aktivert. Sidevisninger ikke tilgjengelig.",
    "Subdomain": "Subdomene",
    "Subdomain url": "URL til subdomene",
    "Superfast - Don't use unless you know what you're doing": "Superfast - Ikke bruk den med mindre du vet hva du gjør",
    "Text color": "Tekstfarge",
    "The optional epi server path": "Den valgfrie epi-server-sti",
    "The subdomain url to the CMS page": "Subdomenets url til CMS-siden",
    "This text must be under 1000 characters": "Denne teksten må være under 1000 tegn",
    "Two-Factor Authentication": "To-faktor autentisering",
    "Two-factor authentication is currently disabled": "To-faktor autentisering er i øyeblikket deaktivert",
    "Two-factor authentication is currently enabled": "To-faktor autentisering er i øyeblikket aktivert",
    "URL needs to be valid, include http:// or https:// and be under 100 characters": "URL'en må være gyldig og inneholde http:// eller https:// samt være under 100 tegn",
    "URL template": "URL-mal",
    "Unique broken links": "Unike brutte lenker",
    "Very fast - Be Cautious": "Veldig raskt - Vær forsiktig",
    "WCAG 2.0": "WCAG 2.0",
    "WCAG 2.1": "WCAG 2.1",
    "Your color contrast is below the recommended score": "Fargekontrasten din er under den anbefalte score",
    "labels": "etiketter",
    "Acceptance Rate": "Godkjennelsesrate",
    "Acceptance Rate Over Time": "Godkjennelsesrate over tid",
    "Acceptance Rate by Category": "Godkjennelsesrate etter kategori",
    "Accepted cookies": "Godkjent cookies",
    "Add callback functions boilerplate": "Legg til callback-funksjoner som standard",
    "Add cookie": "Legg til cookie",
    "Add empty EventListeners": "Legg til tomme EventListeners",
    "Add empty callbacks": "Legg til tomme callbacks",
    "Add event listeners boilerplate": "Legg til event listeners boilerplate",
    "Add web overlay lock": "Legg til web-overlays-lås",
    "Alternative": "Alternativ",
    "An overview of your customer's behavior with cookies on your website": "Et overblikk over dine kunders adferd med cookies på nettsiden din",
    "Are you sure you want to ignore all selected misspellings?": "Er du sikker på at du vil ignorere alle valgte skrivefeil?",
    "Are you sure you want to mark this check as fixed on all pages?": "Er du sikker på at du vil markere denne sjekken som rettet på alle sider?",
    "Are you sure you want to mark this check as fixed?": "Er du sikker på at du vil markere denne sjekken som rettet?",
    "Are you sure you want to mark this misspelling as fixed?": "Er du sikker på at du vil markere denne stavefeil som rettet?",
    "Are you sure you want to mark this misspelling(s) as fixed?": "Er du sikker på at du vil markere denne stavefeil (disse stavefeilene) som rettet?",
    "Basic": "Basic",
    "Button color": "Farge på knapp",
    "Button text color": "Tekstfarge på knapp",
    "Case sensitive URLs": "URL'er med hensyn til store og små bokstaver",
    "Changes wording from only essential cookies to explicit reject": "Endrer formuleringen fra kun nødvendige cookies til tydelig avslag",
    "Consent Log": "Samtykkelogg",
    "Consent Overview": "Oversikt over samtykke",
    "Consent results are sample data for demo purposes": "Samtykkeresultater er prøvedata til demonstrasjonsformål",
    "Cookie Acceptance Rate": "Godkjennelsesrate av cookies",
    "Cookie Overview": "Oversikt over cookies",
    "Cookie description": "Cookie beskrivelse",
    "Cookie duration": "Cookie varighet",
    "Cookie name": "Cookie navn",
    "Enter a valid CSS selector": "Tast inn en gyldig CSS-selektor",
    "Essential": "Nødvendig",
    "Example 3": "Eksempel 3",
    "Example 4": "Eksempel 4",
    "Explicit reject option": "Alternativet for tydelig avslag",
    "Give a short description of the purpose of the cookie": "Gi en kort beskrivelse av formålet med cookien",
    "Give users more control over which categories of cookies to consent to": "Gi brukerne mer kontroll over hvilke kategorier av cookies de vil gi sitt samtykke til",
    "How long is the cookie active": "Hvor lenge er cookien aktiv",
    "IP Address": "IP-adresse",
    "Ignore canonical URLs": "Ignorer kanoniske URL'er",
    "Ignored by": "Ignorert av",
    "Ignored date": "Ignorert dato",
    "Ignored misspellings on account": "Ignorerte stavefeil på konto",
    "Include cookies": "Inkluder cookies",
    "Insert CSS class or id selector": "Sett inn CSS-klasse eller id-selektor",
    "Insert a CSS selector": "Sett inn en CSS-selektor",
    "Limit or exclude": "Begrens eller ekskluder",
    "Limit search": "Begrens søkning",
    "Link to your opt out page": "Lenke til din opt ut-side",
    "Make sure you use the correct setting": "Sørg for at du bruker den riktige innstilling",
    "Mark check as fixed": "Markér sjekk som rettet",
    "Marketing": "Marketing",
    "No cookies found": "Ingen cookies funnet",
    "No misspellings have been ignored": "Ingen stavefeil har blitt ignorert",
    "Opt out link": "Opt out lenke",
    "Original": "Original",
    "Other": "Annet",
    "Overall Acceptance Rate": "Samlet godkjennelsesrate",
    "Overall acceptance rate": "Samlet godkjennelsesrate",
    "Per category consent": "Samtykke per kategori",
    "Please wait - Marking as fixed": "Vennligst vent - Markerer som rettet",
    "Please wait - Marking word as fixed": "Vennligst vent - Markerer ord som rettet",
    "Preferences": "Innstillinger",
    "Privacy regulation": "Personvernregulering",
    "Remove cookie": "Fjern cookie",
    "Remove from Ignored": "Fjern fra Ignorert",
    "Remove this word from Ignored Misspellings": "Fjern dette ordet fra Ignorerte stavefeil",
    "URL Structure": "URL struktur",
    "Domain Overview": {
      "Topmenu": "Oversikt over domener",
      "$$noContext": "Oversikt over domener"
    },
    "Admin Settings": "Admin-innstillinger",
    "Case sensitivity": "Følsomhet for store og små bokstaver",
    "Close project search and domain picker": "Lukk prosjektsøkning og domenevelger",
    "Domain Settings": "Domeneinnstillinger",
    "In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.": "I siste ende ser både & lt; I & gt; og & lt; em & gt; taggene visuelt like ut. De har imidlertid hver sin forskjellige semantiske betydning. & lt; em & gt; taggen brukes for å representere vekt, mens & lt; I & gt; taggen representerer et ord eller en setning som brukeren kanskje ønsker å kursivere (et fremmed ord, definisjon av et ord, osv.). For sistnevnte skal CSS brukes i stedet.",
    "Paste your image link (URL) here": "Sett inn din bildelenke (URL) her",
    "Set up your domain": "Sett opp ditt domene",
    "The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.": "Det største problemet med denne rettingen kan oppstå hvis &lt;i&gt; taggen brukes til ikoner i stedet for for eksempel &lt;span&gt; (eksempel: Font Awesome). Hvis du legger merke til at noe ser feil ut med ikonene dine etter å ha anvendt rettingen, kan dette være årsaken. Imidlertid pleier &lt;i&gt; tagger for ikoner å bruke en klasse, så sørg for at du har innstillingene satt til kun å endre taggene uten å endre klassene. På den måten skal ikonene dine forbli uendret.",
    "The profile <strong>[[profileName]]</strong> is being used on the following pages below:": "<strong></strong>Profilen  [[profileName]]  brukes på de følgende sidene nedenfor",
    "Add icon border": "Legg til ikonramme",
    "Adds a 3px wide border to the PageAssist widget icon": "Legg til en 3px bred kant til ikonet for PageAssist widget'en",
    "Bottom": "Bund",
    "Clear search": "Tøm søk",
    "Ensures that PageAssist is never overlapped by other elements on the page": "Sikrer at PageAssist aldri overlappes av andre elementer på siden",
    "Estonian": "Estisk",
    "German": "Tysk",
    "Go to overlay with details": "Gå til overlay med detaljer",
    "Guidelines for WCAG 2.2": "Retningslinjer for WCAG 2.2",
    "Heartbeat Overview": "Heartbeat Oversikt",
    "How far the button is from the edge. Customization dependant on position.": "Hvor langt knappen er fra kanten. Tilpasning avhenger av posisjon.",
    "Insert a valid host name": "Sett inn et gyldig vertsnavn",
    "Keep PageAssist on top": "Behold PageAssist på toppen",
    "Left": "Venstre",
    "Margin from edge in pixels": "Avstand fra kanten i piksler",
    "Norwegian Bokmål": "Norsk Bokmål",
    "Norwegian Nynorsk": "Nynorsk",
    "Right": "Høyre",
    "Social Media visits": "Besøk på sosiale medier",
    "Social media visits": "Besøk på sosiale medier",
    "Sort column": "Sorter kolonne",
    "Sort column ascending": "Sorter kolonnen stigende",
    "Sort column descending": "Sorter kolonnen synkende",
    "Subgroup": "Undergruppe",
    "Swedish": "Svensk",
    "Toggle label text": "Veksle etikettekst",
    "Top": "Topp",
    "Unique misspellings": "Unike stavefeil",
    "Unique misspellings found": "Unike stavefeil funnet",
    "WCAG 2.2 Accessibility Compliance": "Overholdelse av WCAG 2.2 tilgjengelighet",
    "Area dynamic page": "Område dynamisk side",
    "Employeepage": "Medarbeiderside",
    "Language id": "Språk id",
    "Newspage": "Nyhetsside",
    "Standard": "Standard",
    "Standard for http(s)://edit.domain.tld/inz/<path>. Alternative for http(s)://domain.tld/<path>/edit.": "Standard for http(s)://edit.domain.tld/inz/. Alternativ til http(s)://domain.tld//edit.",
    "URL format": "URL format",
    "Export both internal and external links": "Eksportér både interne og eksterne lenker",
    "Export only external links": "Eksportér kun eksterne lenker",
    "Export only internal links": "Eksportér kun interne lenker",
    "Overview of all the enabled modules for this domain": "Oversikt over alle aktiverte moduler for dette domenet",
    "Search for a predefined policy in the Policy Exchange Center": "Søk etter en forhåndsdefinert policy i Policy Exchange Center.",
    "A log of all the consents given by your website visitors": "En logg over alle samtykker gitt av besøkende på nettstedet ditt",
    "Action required. Click to resolve issue.": "Handling påkrevd. Klikk for å løse problemet.",
    "Complete": "Fullført",
    "Cookie Overview buttons": "Knapper til oversikt over cookies",
    "Cookie Overview saved": "Oversikt over lagrede cookies",
    "Cookie added by user": "Cookie lagt til av brukeren",
    "Cookie domain": "Cookie domene",
    "Cookie not found": "Cookie ikke funnet",
    "Cookie not published. Missing:": "Cookie ikke publisert. Mangler:",
    "Could not save invalid form": "Kunne ikke lagre ugyldig skjema",
    "Disables interactions on website until the visitor makes a consent choice. Be aware that locking interactions prior to consent may not be compliant with certain regional privacy regulations.": "Deaktiverer interaksjoner på nettstedet frem til den besøkende velger å gi samtykke. Vær oppmerksom på at å låse interaksjoner før samtykke kan være i strid med visse regionale personvernregler.",
    "Finish the setup by adding your cookies": "Fullfør oppsettet ved å legge til dine cookies",
    "For Cookie setup please go to your <b>Data Privacy</b> module.<br> Manual cookies can be set up or edited any time and are not related to script setup.": "<b></b><br>For å sette opp cookies skal du gå til din modul om &lt;b&gt;personvern&lt;/b&gt;.&lt;br&gt;Manuelle cookies kan settes opp eller redigeres når som helst og er ikke relatert til scriptoppsetting.&lt;/br&gt;␣",
    "GDPR requires that companies provide descriptions on their website for all cookies that are used.": "GDPR krever at selskaper gir beskrivelser på nettsiden sin for alle cookies som brukes.",
    "Give an overview of the cookies used on your website. Finish a domain scan or add them manually.": "Gi en oversikt over alle cookies som brukes på ditt nettsted. Fullfør en domeneskanning eller legg dem til manuelt.",
    "Id": "Id",
    "Include a link to your webpage's privacy policy": "Inkluder en lenke til nettsidens personvernpolicy",
    "It looks like the previously set up cookie was not found in this scan. It might be that the cookie was removed or our scan just couldn’t detect it.": "Det ser ut som om den tidligere konfigurerte cookie ikke ble funnet i denne skanningen. Det kan være at cookien ble fjernet, eller at skanningen vår rett og slett ikke kunne oppdage den.",
    "I’ll do it later": "Jeg gjør det senere",
    "Keep": "Behold",
    "Leave without saving": "Forlat uten å lagre",
    "Link to Privacy Policy": "Lenke til personvernpolicy",
    "Link to your Cookie Overview": "Lenke til din cookieoversikt",
    "Link to your Privacy Policy": "Lenke til din personvernpolicy",
    "Link where customers can opt out of sale of personal data. Mandatory for websites under the CCPA regulation.": "Lenke hvor kundene kan velge bort salg av personopplysninger. Obligatorisk for nettsteder under CCPA-reguleringen.",
    "List of checks with and without issues categorized by [[level]] guidelines": "Liste over kontroller med og uten problemer kategoriseret etter [[level]] retningslinjer",
    "Manage Cookie": "Administrér cookie",
    "On-demand scan unavailable": "On-demand skanning er ikke tilgjengelig",
    "Pages needing to be fixed": "Sider som må rettes",
    "Save cookies": "Lagre cookies",
    "Save existing cookies": "Lagre eksisterende cookies",
    "Save this overview to publish completed cookies to the Cookie Overview.": "Lagre denne oversikten for å publisere ferdige cookies i Cookieoversikten.",
    "Save your page before leaving to keep your progress and publish the completed cookies.": "Lagre siden før du forlater for å beholde fremgangen din og publisere de fullførte cookies.",
    "Scan History": "Skanningshistorikk",
    "Scan Information": "Skanningsinformasjon",
    "Scan info": "Skannings info",
    "Source": "Kilde",
    "This feature is not available on a demo account.": "Denne funksjonen er ikke tilgjengelig på en demokonto.",
    "This page has been rescanned since the latest full scan.": "Denne siden har blitt skannet på nytt siden forrige fulle skanning.",
    "This scan feature is not available on a demo account": "Denne skanningsfunksjonen er ikke tilgjengelig på demokonto",
    "UUID": "UUID",
    "You need to include a name in order to save your cookies.": "Du må inkludere et navn for å kunne lagre cookies.",
    "[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.": "[[total]] sider. Prioritér og løs alle innholdsproblemer på hele nettstedet ditt fra én samlet visning.",
    "Distribution of policies with matches across priority levels": "Distribusjon av policies med match på tvers av prioriteringsnivåer",
    "Copied!": "Kopiert!",
    "Copy": "Kopier",
    "Default language*": "Standardspråk*",
    "Don't forget to copy and update the script on your website!": "Husk å kopiere og oppdatere scriptet på nettsiden din!",
    "Included languages*": "Inkluderte språk*",
    "Loading Data": "Laster inn data",
    "Loading...": "Laster inn...",
    "No support": "Ingen support",
    "Open PageAssist script settings": "Åpne innstillingene for PageAssist-scriptet",
    "PageAssist script settings": "Innstillinger for PageAssist-scriptet",
    "Please add the script as close to the open HEAD-tag as possible": "Legg til skriptet så nær den åpne HEAD-taggen som mulig",
    "Please wait - loading": "Vennligst vent - laster inn",
    "Press Ctrl-C": "Trykk på Ctrl-C",
    "Press ⌘-C": "Trykk på ⌘-C",
    "This chart shows how many percent of visitors accepted the various categories of cookies on your website. Visitors who did not make a consent choice on the cookie banner are not counted": "Dette diagrammet viser hvor mange prosent av de besøkende som aksepterer de forskjellige kategoriene av cookies på nettstedet ditt. Besøkende som ikke har tatt et valg angående cookies er ikke inkludert",
    "Visitor percentage": "Prosentdel av besøkende",
    "Consent Manager script settings": "Script-innstillinger i Consent Manager",
    "Open consent manager script settings": "Åpne script-innstillinger i Consent Manager",
    "Scan your website for any data privacy issues that could be present": "Skann nettstedet ditt for eventuelle personvernsproblemer som kan være tilstede",
    "Please enter a full UUID string. Empty or partial strings will not yield any results.": "Vennligst inntast en full UUID-streng. Tomme eller delvise strenger vil ikke gi noen resultater.",
    "UUID can only be searched by entering the full value": "UUID kan kun søkes ved å inntaste den fulle verdien",
    "Average Cumulative Layout Shift": "Gjennomsnittlig Cumulative Layout Shift",
    "Average Largest Contentful Paint": "Gjennomsnittlig Largest Contentful Paint",
    "Average Speed Index": "Gjennomsnittlig Speed Index",
    "Average Total Blocking Time": "Gjennomsnittlig Total Blocking Time",
    "CMS Path": "CMS Path",
    "Click here or drag a rule to this area": "Klikk her eller dra en regel til dette området",
    "Cumulative Layout Shift": "Cumulative Layout Shift",
    "LCP": "LCP",
    "Relevant for": "Relevant for",
    "SI": "SI",
    "TBT": "TBT",
    "[[avg]]": "[[avg]]",
    "[[label]]: [[value]]": "[[label]]: [[value]]",
    "Content Authoring": "Content Authoring",
    "Responsibilities": "Ansvarsområder",
    "Responsibility": "Ansvarsområde",
    "UX Design": "UX-design",
    "Visual Design": "Visuelt design",
    "Version [[version]]": "Versjon [[version]]",
    "Accessibility score": "Tilgjengelighetsscore",
    "Comparison to average": "Sammenligning med gjennomsnittet",
    "Industry average": "Industri gjennomsnitt",
    "No scores available for this domain": "Ingen score tilgjengelig for dette domenet",
    "Professional services": "Profesjonelle tjenester",
    "Quality Assurance score": "Kvalitetssikringsscore",
    "SEO score": "SEO-score",
    "Scores": "Resultater",
    "The average score for domains within your industry.": "Den gjennomsnittlige score for domener innenfor din industri",
    "Add language": "Legg til språk",
    "Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.": "Er du sikker på at du vil arkivere policyen <strong>[[policyName]]</strong>? Vi vil ikke fortsette å se etter matcher for denne policyen. Du kan alltids hente ut policyen fra arkivet på et senere tidspunkt.",
    "Are you sure you want to set these documents as reviewed?": "Er du sikker på at du ønsker å merke disse dokumentene som gjennomgått?",
    "Clear selection": "Fjern valg",
    "Delete language -": "Slett språk -",
    "Delete the language tab - [[language]]": "Slett språkfanen - [[language]]",
    "Discovered": "Oppdaget",
    "Doing this will result in removing the translations in the selected language from both your Cookie Overview and the actual banner itself.<br></br><strong>You will need to add the descriptions again when you re-add the selected language.</strong>": "Hvis du gjør dette fjernes oversettelsene på det valgte språket både fra Cookie-oversikt og selve banneret.<br></br><strong>Du må legge til beskrivelsene på nytt når du legger til det valgte språket igjen.</strong>",
    "Don't forget to update your languages in Script Setup!": "Husk å oppdatere språkene dine i Script Setup!",
    "Edit this policy rule later under the “Add rule to policy” tab.": "Rediger denne policy-regelen senere under fanen \"Legg til regel for policy\".",
    "Front-end Development": "Front-end utvikling",
    "How to setup this policy:": "Hvordan sette opp denne policyen:",
    "Insert word length": "Sett inn ordlengde",
    "Inspect page with browser extension": "Inspiser siden med browserutvidelsen",
    "Mark all as reviewed": "Marker alle som gjennomgått",
    "Mobile only": "Kun mobil",
    "New policy": "Ny policy",
    "Please add at least one language": "Legg til minst ett språk",
    "Please set the default language": "Vennligst sett standardspråk",
    "Please wait - Adding word to ignored list": "Vennligst vent - Legger til ord i listen over ignorerte ord",
    "Please wait - Adding words to ignored list": "Vennligst vent - Legger til ord i listen over ignorerte ord",
    "Remove rule from policy": "Fjern regel fra policy",
    "Request PDF accessibility check for all": "Be om sjekk av PDF-tilgjengelighet for alle",
    "Request Remedition quote for all": "Be om et tilbud på utbedring for alle",
    "Script": "Script",
    "Select a group": "Velg en gruppe",
    "Select a shape": "Velg en form",
    "Select languages": "Velg språk",
    "Select the default language": "Velg standardspråk",
    "To finish setting up your manual Cookie Overview go to the selected domain’s": "For å fullføre oppsettingen av din manuelle cookieoversikt må du gå til det valgte domenet",
    "Unignore this check": "Fjern ignoreringen av denne sjekken",
    "WCAG 2.1 (Level AA) Mobile": "WCAG 2.1 (nivå AA) Mobil",
    "WCAG 2.1 (Level AAA) Mobile": "WCAG 2.1 (nivå AAA) Mobil",
    "Are you sure you want to delete label: [[label]] ?": "Er du sikker på at du ønsker å slette etiketten: [[label]]?",
    "Business services": "Forretningstjenester",
    "CMS template is configured for this domain": "CMS-malen er konfigurert for dette domenet",
    "Consent Manager configuration": "Konfigurasjon av Consent Manager",
    "Consent Manager language*": "Språk for Consent Manager*",
    "Consent Manager pop-up position on Page": "Consent Manager pop-up posisjon på siden",
    "Consent Manager pop-up setup": "Oppsett av pop-up til Consent Manager",
    "Construction/industrial": "Bygg&anlegg",
    "Consumer services": "Forbrukertjenester",
    "Entertainment/Leisure": "Underholdning/fritid",
    "Financial services": "Finansielle tjenester",
    "German (Germany)": "Tysk (Tyskland)",
    "Healthcare": "Helse&omsorg",
    "Label used in the groups below. Please edit or delete the groups and try again.": "Etikett brukt i gruppene nedenfor. Rediger eller slett gruppene og prøv igjen.",
    "Law enforcement": "Politimyndighet",
    "Legal": "Juridisk",
    "Non-profit": "Non-profit",
    "Real-estate": "Eiendom",
    "Retail/wholesale": "Detaljhandel/grossist",
    "Spanish (Spain)": "Spansk (Spanien)",
    "Technology": "Teknologi",
    "Utilities/Natural resources": "Infrastruktur/Naturlige ressurser",
    "Widget Design": "Design av widget",
    ":": ":",
    "Accessibility issue": "Tilgjengelighetsproblem",
    "Add reason (optional)": "Legg til begrunnelse (valgfritt)",
    "All pages with this accessibility issue": "Alle sider med dette tilgjengelighetsproblemet",
    "All pages with this data privacy issue": "Alle sider med dette personvernsproblemet",
    "Alternatively, click the button below.": "Alternativt, klikk på knappen nedenfor.",
    "Are you sure you want to mark this  as fixed?": "Er du sikker på at du vil markere dette som rettet?",
    "Are you sure you want to mark this  as ignored?": "Er du sikker på at du vil markere dette som ignorert?",
    "Are you sure you want to mark this  as not fixed?": "Er du sikker på at du vil markere dette som ikke rettet?",
    "Are you sure you want to mark this check as ignored?": "Er du sikker på at du vil markere denne sjekken som ignorert?",
    "Are you sure you want to mark this issue as ignored?": "Er du sikker på at du vil markere dette problemet som ignorert?",
    "Are you sure you want to unignore this ?": "Er du sikker på at du vil fjerne ignoreringen av dette?",
    "Average time (comp.)": "Gjennomsnittlig tid (comp.)",
    "Bounce rate (comp.)": "Bounce rate (comp.)",
    "Campaign visits": "Kampanje besøk",
    "Code": "Kode",
    "Confirmation required": "Bekreftelse påkrevd",
    "Current password": "Nåværende passord",
    "Data privacy issue": "Personvernproblem",
    "Data violations": "Data brudd",
    "Date found": "Dato funnet",
    "Downloads (comp.)": "Nedlastninger (comp.)",
    "Entries (comp.)": "Entires (comp.)",
    "Events": "Arrangementer",
    "Exits (comp.)": "Utganger (comp.)",
    "Export visitors browsers": "Eksporter besøkendes browsers",
    "Export visitors devices": "Eksporter besøkendes enheter",
    "Export visitors language": "Eksporter besøkendes språk",
    "Export visitors locations": "Eksporter besøkendes lokasjoner",
    "Export visitors operating systems": "Eksporter besøkendes operativsystemer",
    "Export visitors organization": "Eksporter besøkendes organisasjon",
    "Found on page": "Funnet på side",
    "Group name": "Gruppenavn",
    "Image URL": "Bilde URL",
    "Issue details": "Problemdetaljer",
    "Issue not found": "Problem ikke funnet",
    "Legacy Browser Service changed": "Legacy Browser Service endret",
    "Look up in Google": "Søk i Google",
    "Mark as reviewed": "Marker som gjennomgått",
    "Maximum word length to search for": "Maksimum ordlengde å søke etter",
    "Names": "Navn",
    "No pages were found. Try searching for the page URL instead of the page title.": "Ingen sider funnet. Prøv å søke etter sidens URL i stedet for sidetittelen.",
    "Open browser extension": "Åpne browserutvidelse",
    "Open issue page": "Åpne side for problem",
    "Open misspelling page": "Åpne side for feilstavelser",
    "Other checks for this snippet": "Angre sjekker for dette snippet",
    "Pages with accessibility issues": "Sider med tilgjengelighetsproblem",
    "Pages with policy issues": "Sider med policy problem",
    "Pageviews (comp.)": "Sidevisninger (comp.)",
    "Percentage shows number of pages that are compliant with all Policies": "Prosentandel viser antallet sider som er i samsvar med alle Policies",
    "Percentage shows number of pages that are compliant with all QA checks": "Prosentandel viser antallet sider som er i samsvar med alle kvalitetssikringskontroller",
    "Please enter a valid date!": "Vennligst tast inn gyldig dato!",
    "Please wait - Adding word to all dictionaries": "Vennligst vent - Legger til ord i alle ordbøker",
    "Press to toggle additional rows.": "Klikk for å veksle ekstra rader",
    "Puppeteer Browser Service changed": "Puppeteer Browser Service endret",
    "Reason:&nbsp;": "Reason:&nbsp;",
    "Remember to add this source code exclude to your domain(s) through the Edit Domain screen.": "Husk å legge til denne kildekodeutelukkelsen på domenet/domenene dine via redigeringsskjermen for domenet.",
    "Remove review": "Fjern gjennomgang",
    "Repeat new password": "Gjenta nytt passord",
    "Sorry, this page was not found. The issue must have been resolved.": "Beklager, denne siden ble ikke funnet. Dette problemet må ha blitt løst.",
    "The date cannot be in the future": "Datoen kan ikke være frem i tid",
    "The end date cannot be before the start date": "Sluttdato kan ikke være før startdato",
    "The settings form contains incorrect data. Close the form anyway?": "Skjemainnstillingene inneholder feilaktige data. Vil du lukke skjemaet likevel?",
    "The start and end date cannot be in the future, please enter the compare dates again": "Start- og sluttdato kan ikke være i fremtiden, vennligst skriv inn datoene for sammenligning på nytt",
    "This issue is marked as fixed.": "Dette problemet er markert som løst",
    "This issue is marked as ignored.": "Dette problemet er markert som ignorert",
    "This issue is marked as reviewed.": "Dette problemet er markert som gjennomgått",
    "This word has been added to your dictionary": "Dette ordet har blitt lagt til i ordboken",
    "To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class=\\\"text-bold\\\">My Exports.</span>": "For å se nåværende fremgang, klikk på brukeravatar på øvre høyre side av hovedsiden og velg <span class=\"text-bold\">Mine eksporter.</span>",
    "Total unique downloads (comp.)": "Totale unike nedlastninger (comp.)",
    "Unique downloads (comp.)": "Unike nedlastninger (comp.)",
    "Visitors browsers export": "Besøkendes nettleser eksport",
    "Visitors devices export": "Besøkendes enhetseksport",
    "Visitors language export": "Besøkendes språk eksport",
    "Visitors locations export": "Besøkendes lokasjoner eksport",
    "Visitors operating systems export": "Besøkendes operativsystemer eksport",
    "Visitors organization export": "Besøkendes organisasjon eksport",
    "Visits (comp.)": "Besøk (comp.)",
    "WCAG 2.1 (Level A) Mobile": "WCAG 2.1 (Level A) Mobil",
    "Your export is currently being generated.": "Din eksport genereres for øyeblikket.",
    "+ ' + (report.targets.length - maxTargets) + ' more": "+ ' + (report.targets.length - maxTargets) + ' more",
    "Accessibility Checklist (WCAG 2.0)": "Tilgjengelighets Sjekkliste (WCAG 2.0)",
    "Accessibility Checklist (WCAG 2.1)": "Tilgjengelighets Sjekkliste (WCAG 2.1)",
    "Accessibility Checklist (WCAG 2.2)": "Tilgjengelighets Sjekkliste (WCAG 2.2)",
    "Average no. of results pages viewed": "Gjennomsnittlig antall resultatsider sett",
    "Checklist": "Sjekkliste",
    "Email *": "E-post*",
    "Event actions": "Arrangement handlinger",
    "Event categories": "Arrangement kategorier",
    "Event names": "Arrangement navn",
    "First name *": "Fornavn*",
    "Last name *": "Etternavn*",
    "Search term": "Søkeuttrykk",
    "Search terms": "Søkeuttrykk",
    "Search terms with no results": "Søkeuttrykk med ingen resultater",
    "Site Search": "Site Search",
    "Site Search - Search Terms": "Site Search - Søkeuttrykk",
    "Site Search No Results Search Terms": "Site Search Ingen Resultater Søkeuttrykk",
    "Switch between chart and table": "Bytt mellom diagram og tabell",
    "Table": "Tabell",
    "more": "mer",
    "Accessibility checks update": "Oppdatering av tilgjengelighetssjekker",
    "Account is under maintenance": "Kontoen er under vedlikehold",
    "Add internal URL": "Legg til intern URL",
    "Add the name of the platform or company who provides this cookie.": "Legg til navnet på plattformen eller selskapet som tilbyr denne informasjonskapselen.",
    "All PDFs": "Alle PDF-er",
    "All scheduled reports": "Alle planlagte rapporter",
    "An error has occurred - please try again": "Det har oppstått en feil - prøv igjen",
    "Are you sure you want mark as fixed": "Er du sikker på at du vil merke som fast",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary for all languages?": "Er du sikker på at du vil legge til ordet <strong>[[word]]</strong> i ordboken for alle språk?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary?": "Er du sikker på at du vil legge til ordet <strong>[[word]]</strong> i ordboken?",
    "Are you sure you want to confirm the word <strong>[[word]]</strong> as misspelling?": "Er du sikker på at du vil bekrefte ordet <strong>[[word]]</strong> som feilstaving?",
    "Are you sure you want to ignore the misspelling <strong>[[word]]</strong> for all languages?": "Er du sikker på at du vil ignorere stavefeilen <strong>[[word]]</strong> for alle språk?",
    "Are you sure you want to mark the misspelling <strong>[[word]]</strong> as fixed?": "Er du sikker på at du vil merke feilstavingen <strong>[[word]]</strong> som løst?",
    "Are you sure you want to remove the Default label?": "Er du sikker på at du vil fjerne standardetiketten?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong>?": "Er du sikker på at du vil kjøre policyen <strong>[[policyName]]</strong>?",
    "Bar chart representing data": "Stolpediagram som representerer data",
    "Bar line chart representing": "Stolpelinjediagram som representerer",
    "Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.": "Vær oppmerksom på at et tomt alt-attributt kan være tilstrekkelig og passende for dekorative bilder.",
    "Bubble chart representing data": "Boblediagram som representerer data",
    "Clear the field": "Rydd feltet",
    "Close submenu": "Lukk undermenyen",
    "Contact Support": "Kontakt kundestøtte",
    "Cookie platform": "Cookie-plattform",
    "Current password is incorrect please try again": "Gjeldende passord er feil, prøv igjen",
    "Doughnut chart representing data": "Smultringdiagram som representerer data",
    "Enable Cookieless Tracking": "Aktiver sporing uten informasjonskapsler",
    "Errors and": "Feil og",
    "Errors and Warnings": "Feil og advarsler",
    "Events filter buttons": "Hendelsesfilterknapper",
    "Every 12 weeks": "Hver 12. uke",
    "Every 2 weeks": "Hver 2. uke",
    "Every 4 weeks": "Hver 4. uke",
    "Every 8 weeks": "Hver 8. uke",
    "Frequency": "Hyppighet",
    "Image details": "Bildedetaljer",
    "Image metadata": "Bilde metadata",
    "Image preview": "Forhåndsvisning av bilde",
    "Inventory image preview": "Forhåndsvisning av inventarbilde",
    "It seems like we are experience some issues with the page you are looking at.": "Det virker som om vi opplever noen problemer med siden du ser på.",
    "It seems like your computer is disconnected from the internet.": "Det virker som om datamaskinen din er koblet fra internett.",
    "Line chart representing data": "Linjediagram som representerer data",
    "List of received reports": "Liste over mottatte rapporter",
    "Metadata and pages": "Metadata og sider",
    "Metadata property": "Metadata-egenskap",
    "My scheduled reports": "Mine planlagte rapporter",
    "No date range selected": "Ingen datoperiode er valgt",
    "Norwegian": "norsk",
    "Only Errors": "Kun feil",
    "Only errors": "Kun feil",
    "Open dropdown with filters": "Åpne rullegardinmenyen med filtre",
    "Open metadata view": "Åpne metadatavisning",
    "Open submenu with filters": "Åpne undermenyen med filtre",
    "Pages that contain the Email": "Sider som inneholder e-posten",
    "Percentage shows the average compliance score across all pages on the domain": "Prosent viser gjennomsnittlig samsvarspoeng på alle sidene på domenet",
    "Pie chart representing data": "Sektordiagram som representerer data",
    "Platform": "Plattform",
    "Please contact the support if this issue keeps happening": "Kontakt brukerstøtten hvis dette problemet vedvarer",
    "Please refresh the browser when your computer is online again.": "Oppdater nettleseren når datamaskinen din er tilkoblet igjen.",
    "Please try again later": "Prøv igjen senere",
    "Press to remove the label.": "Trykk for å fjerne etiketten.",
    "Puppeteer 20": "Dukkespiller 20",
    "Remove internal URL": "Fjern intern URL",
    "Scan all pages for cookies": "Skann alle sider for informasjonskapsler",
    "Schedule this report": "Planlegg denne rapporten",
    "Search in options": "Søk i alternativer",
    "Show HTML snippet details": "Vis detaljer om HTML-snutt",
    "Show labels": "Vis etiketter",
    "Show less of the url snippet": "Vis mindre av nettadressekodebiten",
    "Show the full url snippet": "Vis hele nettadressekodebiten",
    "Showing": "Viser",
    "The average compliance score for this module for domains from other organizations within your industry:": "Gjennomsnittlig samsvarspoeng for denne modulen for domener fra andre organisasjoner i din bransje:",
    "Unsubscribe from report": "Avmeld rapport",
    "Warnings": "Advarsler",
    "We export up to a maximum of 1000 rows": "Vi eksporterer opptil maks 1000 rader",
    "We recommend that you have an alt attribute with relevant content on all image tags.": "Vi anbefaler at du har et alt-attributt med relevant innhold på alle bildekoder.",
    "You have images missing an alt attribute.": "Du har bilder som mangler et alt-attributt.",
    "[[name]] Remove": "[[name]] Fjern",
    "[[target]]": "[[mål]]",
    "default": "misligholde",
    "[[label]]": "[[merkelapp]]",
    "% of visitors staying after a search": "% av besøkende som blir etter et søk",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.": "Dokumentutbedring for overholdelse av WCAG 2.1 AA, Section 508, HHS eller PDF/UA-tilgjengelighetsstandarder utføres av vårt tilknyttede selskap, NetCentric Technologies, Inc. På grunn av regelverkets rammebetingelser i ditt land, er vi ikke i stand til å koordinere dokumentutbedring direkte for du; Du er imidlertid invitert til å kontakte NetCentric direkte for et tilbud og utbedringstjenester på dherr@allyant.com. Vær oppmerksom på at alle kontrakter for utbedring er mellom deg, kunden og NetCentric, og underlagt NetCentrics vilkår og betingelser og retningslinjer for personvern og vil resultere i en overføring av data til tredjeparter og tredjeland, inkludert men ikke begrenset til USA , Canada, Australia og Egypt.",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. Upon completion of the work, NetCentric will also provide a compliance report. NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy.": "Dokumentutbedring for overholdelse av WCAG 2.1 AA, Section 508, HHS eller PDF/UA tilgjengelighetsstandarder gjøres av vårt tilknyttede selskap, NetCentric Technologies, Inc. For utbedring vil vi koordinere med NetCentric for å gjennomgå dokumentet og gi deg en fast pris for utbedring. Etter fullføring av arbeidet vil NetCentric også levere en samsvarsrapport. NetCentric vil gi deg beskjed om det er nødvendig med alternativ tekst (Alt-Text) for bilder som ikke er selvbeskrivende eller relatert tilleggsinformasjon som er nødvendig for å utbedre dokumentet. Vær oppmerksom på at alle kontrakter for utbedring er mellom deg, kunden og NetCentric, og underlagt NetCentrics vilkår og betingelser og retningslinjer for personvern.",
    "Japanese": "japansk",
    "Report Administration": "Rapportadministrasjon",
    "Submit": "Send inn",
    "You have [[domains]] domain(s) on your account": "Du har [[domains]] domene(r) på kontoen din",
    "Find domains by searching for the title or URL": "Finn domener ved å søke etter tittelen eller nettadressen",
    "Industry average score": "Gjennomsnittlig poengsum for bransjen",
    "Proceed to add one more check": "Fortsett for å legge til en sjekk til",
    "Readability test (for English pages only)": "Lesbarhetstest (kun for engelske sider)",
    "Request quote for more pages": "Be om tilbud for flere sider",
    "Request quote for more profiles": "Be om tilbud for flere profiler",
    "Search for domain": "Søk etter domene",
    "The user does not have access to view this domain and any reports associated with it": "Brukeren har ikke tilgang til å se dette domenet og eventuelle rapporter knyttet til det",
    "Update all domain groups": "Oppdater alle domenegrupper",
    "Update domain group": "Oppdater domenegruppe",
    "Updating a group can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Å oppdatere en gruppe kan ta mer enn 30 minutter. Under operasjonen vil du ikke kunne opprette og oppdatere grupper.",
    "WCAG 2.2 (Level A)": "WCAG 2.2 (nivå A)",
    "WCAG 2.2 (Level A) Mobile": "WCAG 2.2 (Nivå A) Mobil",
    "WCAG 2.2 (Level AA)": "WCAG 2.2 (nivå AA)",
    "WCAG 2.2 (Level AA) Mobile": "WCAG 2.2 (Nivå AA) Mobil",
    "WCAG 2.2 (Level AAA)": "WCAG 2.2 (nivå AAA)",
    "WCAG 2.2 (Level AAA) Mobile": "WCAG 2.2 (Nivå AAA) Mobil",
    "You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button \\\"Request quote for more pages\\\" and someone on our team will be in touch.": "Du har nådd det maksimale antallet ytelsessider i din nåværende plan.<br/><br/>For å spørre om prisalternativer for flere sider, trykk på knappen \\\"Be om tilbud for flere sider\\\" og noen i teamet vårt vil være i kontakt.",
    "You must perform a manual review of the page to confirm if this issue is present": "Du må utføre en manuell gjennomgang av siden for å bekrefte om dette problemet er tilstede",
    "Accessibility Checklist (QUALWEB)": "Sjekkliste for tilgjengelighet (QUALWEB)",
    "Accessibility checks cannot be ignored for domain groups. To ignore this check you must do it for the entire domain.": "Tilgjengelighetskontroller kan ikke ignoreres for domenegrupper. For å ignorere denne kontrollen må du gjøre det for hele domenet.",
    "Accessibility checks cannot be unignored for domain groups. To unignore this check you must do it for the entire domain.": "Tilgjengelighetssjekker kan ikke ignoreres for domenegrupper. For å ignorere denne sjekken må du gjøre det for hele domenet.",
    "Check your spelling or try a shorter query.": "Sjekk stavemåten eller prøv et kortere søk.",
    "Guidelines for QUALWEB": "Retningslinjer for QUALWEB",
    "Language not supported": "Språk støttes ikke",
    "No domains found.": "Ingen domener funnet.",
    "QUALWEB Accessibility Compliance": "Overholdelse av QUALWEB tilgjengelighet",
    "QualWeb (Level A)": "QualWeb (nivå A)",
    "QualWeb (Level AA)": "QualWeb (nivå AA)",
    "Score could not be generated": "Poengsummen kunne ikke genereres",
    "Searching <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>": "Søker <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>",
    "The language of the page is not recognized as English. The Flesch-Kincaid test only works for English language. Change to the LIX test if you wish to generate scores for non-English pages.": "Språket på siden gjenkjennes ikke som engelsk. Flesch-Kincaid-testen fungerer kun for engelsk språk. Bytt til LIX-testen hvis du ønsker å generere poengsum for ikke-engelske sider.",
    "We could not generate an accurate score for these pages. This is typically either due to the text on a page being too short, too long, or our web crawler not picking up any text at all.": "Vi kunne ikke generere en nøyaktig poengsum for disse sidene. Dette skyldes vanligvis enten at teksten på en side er for kort, for lang, eller at søkeroboten vår ikke fanger opp noen tekst i det hele tatt.",
    "Are you sure you want to add word [[word]] to all dictionaries": "Er du sikker på at du vil legge til ordet [[ord]] i alle ordbøkene",
    "Are you sure you want to add word [[word]] to dictionary?": "Er du sikker på at du vil legge til ordet [[word]] i ordboken?",
    "Are you sure you want to confirm the word [[word]] as misspelling?": "Er du sikker på at du vil bekrefte ordet [[ord]] som feilstaving?",
    "Are you sure you want to ignore the misspelling [[word]] for all languages?": "Er du sikker på at du vil ignorere feilstavingen [[word]] for alle språk?",
    "Are you sure you want to mark the misspelling [[word]] as fixed?": "Er du sikker på at du vil merke feilstavingen [[ord]] som rettet?",
    "Cannot forward more": "Kan ikke videresende flere",
    "Choose Date": "Velg Dato",
    "Compare": "Sammenligne",
    "Confirmed errors only": "Kun bekreftede feil",
    "Exclude checks that require manual review": "Ekskluder sjekker som krever manuell gjennomgang",
    "If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.": "Hvis dette alternativet er slått på, inkluderer domeneskanningen bare tilgjengelighetssjekker som automatisk kan identifiseres som feil. Sjekker som krever manuell gjennomgang er ekskludert.",
    "One month back": "En måned tilbake",
    "One month forward": "En måned frem",
    "Press to choose the end day": "Trykk for å velge sluttdagen",
    "Press to choose the start day": "Trykk for å velge startdagen",
    "Remove compare range dates": "Fjern datoer for sammenligningsintervaller",
    "The date cannot be in the future.": "Datoen kan ikke være i fremtiden.",
    "Toggle the datepicker": "Slå på datovelgeren",
    "Add Policy with AI": "Legg til policy med AI",
    "Consolidated Reports": "Konsoliderte rapporter",
    "Created with AI policy assistant": "Laget med AI-policyassistent",
    "Policy Assistant": "Policyassistent",
    "Sparkle icon": "Glitrende ikon",
    "The Policy Assistant runs on Google Vertex AI, which can make mistakes.": "Policy Assistant kjører på Google Vertex AI, som kan gjøre feil.",
    "You have reached the maximum number of Performance profiles in your current plan.<br/><br/>To inquire about pricing options for additional profiles, please press the button \\\"Request quote for more profiles\\\" and someone on our team will be in touch.": "Du har nådd det maksimale antallet ytelsesprofiler i din nåværende plan.<br/><br/>For å spørre om prisalternativer for flere profiler, vennligst trykk på knappen «Be om tilbud for flere profiler», så vil noen i teamet vårt ta kontakt med deg.",
    "You are about to perform a scan of <span class='text-link'>[[pageTitle]]</span> using the profile <span class='text-link'>[[profileName]]</span>.<br>The scan can take a few minutes to finalise, depending on the size of the page.<br><br>Do you want to continue?": "Du er i ferd med å utføre en skanning av <span class='text-link'>[[pageTitle]]</span> ved hjelp av profilen <span class='text-link'>[[profileName]]</span>.<br>Det kan ta noen minutter å fullføre skanningen, avhengig av størrelsen på siden.<br><br>Vil du fortsette?",
    "Doesn't scan automatically": "Skanner ikke automatisk",
    "Scans automatically": "Skanner automatisk",
    "with this": "med dette",
    "with this PDF": "med denne PDF-filen",
    "with this archive file": "med denne arkivfilen",
    "with this slide": "med dette lysbildet",
    "with this spreadsheet": "med dette regnearket",
    "with this text file": "med denne tekstfilen",
    "Errors must be fixed for compliance.": "Feil må rettes for å være i samsvar med regelverket.",
    "Issues to Fix": "Problemer som må fikses",
    "Issues to Review": "Problemer som skal gjennomgås",
    "Reviews require manual judgement.": "Anmeldelser krever manuell vurdering.",
    "Warnings are likely to be issues, but they require manual investigation.": "Advarsler vil sannsynligvis være problemer, men de krever manuell undersøkelse.",
    "1 content": [
      "1 innhold",
      "{{$count}} innhold"
    ],
    "1 misspelling ignored across all domains": [
      "1 stavefeil ignorert på tvers av alle domener",
      "{{$count}} stavefeil ignorert på tvers av alle domener"
    ],
    "1 new cookie on": [
      "1 ny informasjonskapsel på",
      "{{$count}} nye informasjonskapsler på "
    ],
    "1 page": [
      "1 side",
      "{{$count}} sider"
    ],
    "1 page with one or more failing checks {{guideline}}": [
      "1 side med én eller flere feilende kontroller {{guideline}}",
      "{{$count}} sider med én eller flere feilende kontroller {{guideline}}"
    ],
    "1 page with one or more ignored checks {{guideline}}": [
      "1 side med én eller flere ignorerte sjekker {{guideline}}",
      "{{$count}} sider med én eller flere ignorerte sjekker {{guideline}}"
    ],
    "1 policy found": [
      "1 policy funnet",
      "{{$count}} policies funnet"
    ],
    "1 results": [
      "1 resultater",
      "{{$count}} resultater"
    ],
    "1 visit": [
      "1 besøk",
      "{{$count}} besøk"
    ],
    "1 word added across all domains": [
      "1 ord lagt til på tvers av alle domener",
      "{{$count}} ord lagt til på tvers av alle domener"
    ],
    "One word found": [
      "Ett ord funnet",
      "{{$count}} ord funnet"
    ],
    "You have 1 user on your account": [
      "Du har én bruker på kontoen din",
      "Du har {{$count}} brukere på kontoen din"
    ],
    "Accessibility Compliance Scan": "Skanning av tilgjengelighetssamsvar",
    "Broken Links on Sitemap": "Ødelagte lenker på nettstedskartet",
    "Broken links on sitemap": "Ødelagte lenker på nettstedskartet",
    "Close Spotlight Search.": "Lukk Spotlight-søk.",
    "Requested": "Forespurt",
    "Toggle Spotlight Search.": "Slå av/på Spotlight-søk.",
    "WCAG 2.2": "WCAG 2.2",
    "Newest": {
      "Exchange Center Sort by option": "Nyeste"
    },
    "(<strong><i>[[issues]]</i></strong> unique problems)": "(<strong><i>[[issues]]</i></strong> unike problemer)",
    "(<strong>[[issues]]</strong> unique problems)": "(<strong>[[issues]]</strong> unike problemer)",
    "<div class=\\\\'pull-left\\\\'>' + ('Heatmaps": "<div class=\\\\'pull-left\\\\'>' + ('Varmekart",
    "<div class=\\\\'pull-left\\\\'>' + ('History Center": "<div class=\\\\'pull-left\\\\'>' + ('Historiesenter",
    "<p class='warning'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached the limit of the amount of profiles allowed on your account ([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan or archive some profiles before restoring this one.</p>": "<p class='warning'>Acquia Web Governance kan ikke gjenopprette profilen.</p><p>Du har nådd grensen for antall profiler som er tillatt på kontoen din ([[maxProfiles]] profiler). Ta kontakt med salgsteamet vårt for å legge til flere profiler i planen din eller arkiver noen profiler før du gjenoppretter denne.</p>",
    "<strong>' + (links.total | monNumber) + '</strong> ' + ('link": "<strong>' + (lenker.totalt | monNumber) + '</strong> ' + ('lenke",
    "<strong>' + (pages.total | monNumber) + '</strong> ' + ('page": "<strong>' + (sider.totalt | monNumber) + '</strong> ' + ('side",
    "A \\\"skip to content\\\" link at the start of the webpage allows screen reader and keyboard-only users to skip over potentially non-relevant links at the start of your webpage and immediately access the main content.": "En «hopp til innhold»-lenke i starten av nettsiden lar skjermlesere og brukere av tastatur hoppe over potensielt irrelevante lenker i starten av nettsiden din og umiddelbart få tilgang til hovedinnholdet.",
    "A cozy room with sofa, table and laptops that have Acquia Web Governance text": "Et koselig rom med sofa, bord og bærbare datamaskiner med Acquia Web Governance-tekst",
    "About Acquia Web Governance": "Om Acquia Web Governance",
    "Accept Acquia Web Governance Privacy Terms": "Godta Acquias personvernvilkår for nettstyring",
    "Acquia Web Governance": "Acquia nettstyring",
    "Acquia Web Governance - Accessibility": "Acquia Web Governance – Tilgjengelighet",
    "Acquia Web Governance - Accessibility Check List": "Acquia Web Governance – Sjekkliste for tilgjengelighet",
    "Acquia Web Governance - Accessibility Guidelines": "Acquia Web Governance – Retningslinjer for tilgjengelighet",
    "Acquia Web Governance - Account Dictionary": "Acquia Web Governance – Kontoordbok",
    "Acquia Web Governance - Admin Page Performance Profiles": "Acquia Web Governance – Ytelsesprofiler for administrasjonssider",
    "Acquia Web Governance - Audit Log": "Acquia Web Governance – Revisjonslogg",
    "Acquia Web Governance - Broken Images": "Acquia Web Governance – Ødelagte bilder",
    "Acquia Web Governance - Broken Links": "Acquia Web Governance – Ødelagte lenker",
    "Acquia Web Governance - Content With Broken Links": "Acquia Web Governance – Innhold med ødelagte lenker",
    "Acquia Web Governance - Content With QA Errors": "Acquia Web Governance – Innhold med QA-feil",
    "Acquia Web Governance - Cookie Acceptance Rate": "Acquia Web Governance – akseptgrad for informasjonskapsler",
    "Acquia Web Governance - Cookie Consent Log": "Acquia Web Governance – Samtykkelogg for informasjonskapsler",
    "Acquia Web Governance - Cookie Overview": "Acquia Web Governance – Oversikt over informasjonskapsler",
    "Acquia Web Governance - Dashboard": "Acquia Web Governance – Dashbord",
    "Acquia Web Governance - Data Privacy": "Acquia Web Governance – Personvern",
    "Acquia Web Governance - Data Privacy Check List": "Acquia Web Governance – Sjekkliste for personvern",
    "Acquia Web Governance - Data Privacy Content": "Acquia Web Governance – Innhold om personvern",
    "Acquia Web Governance - Data Privacy Guidelines": "Acquia Web Governance – Retningslinjer for personvern",
    "Acquia Web Governance - Data Privacy Issues": "Acquia Web Governance – Personvernspørsmål",
    "Acquia Web Governance - Data Privacy Summary": "Acquia Web Governance – Sammendrag av personvern",
    "Acquia Web Governance - External PDF Compliance": "Acquia Web Governance – Ekstern PDF-samsvar",
    "Acquia Web Governance - Fast Track": "Acquia nettstyring – hurtigspor",
    "Acquia Web Governance - Heatmaps": "Acquia Web Governance – Varmekart",
    "Acquia Web Governance - History Center": "Acquia Web Governance – Historisk senter",
    "Acquia Web Governance - Ignored Misspellings": "Acquia Web Governance – Ignorerte stavefeil",
    "Acquia Web Governance - Internal PDF Compliance": "Acquia Web Governance – Intern PDF-samsvar",
    "Acquia Web Governance - Labels": "Acquia Web Governance – Etiketter",
    "Acquia Web Governance - Misspellings": "Acquia Web Governance – stavefeil",
    "Acquia Web Governance - Page Performance Pages": "Acquia Web Governance – Sideytelsessider",
    "Acquia Web Governance - PageCorrect": "Acquia Web Governance – PageCorrect",
    "Acquia Web Governance - PageCorrect Accessibility Fixes": "Acquia Web Governance – PageCorrect tilgjengelighetsrettelser",
    "Acquia Web Governance - PageCorrect Content": "Acquia Web Governance – Sidekorrekt innhold",
    "Acquia Web Governance - Pages With Failing Checks": "Acquia Web Governance – Sider med mislykkede kontroller",
    "Acquia Web Governance - Pages With Ignored Checks": "Acquia Web Governance – Sider med ignorerte sjekker",
    "Acquia Web Governance - Pages With Misspellings": "Acquia Web Governance – Sider med stavefeil",
    "Acquia Web Governance - Pages With Opportunity": "Acquia Web Governance – Sider med muligheter",
    "Acquia Web Governance - Potential Misspellings": "Acquia Web Governance – Mulige stavefeil",
    "Acquia Web Governance - Prioritized Content": "Acquia Web Governance – Prioritert innhold",
    "Acquia Web Governance - Quality Assurance": "Acquia Web Governance – Kvalitetssikring",
    "Acquia Web Governance - Readability Checker": "Acquia Web Governance – Lesbarhetskontroll",
    "Acquia Web Governance - Readability Summary": "Acquia Web Governance – Lesbarhetssammendrag",
    "Acquia Web Governance - SEO Checkpoints": "Acquia Web Governance – SEO-sjekkpunkter",
    "Acquia Web Governance - Search Engine Optimization": "Acquia Web Governance - Søkemotoroptimalisering",
    "Acquia Web Governance - Spellcheck Summary": "Acquia Web Governance – Sammendrag av stavekontroll",
    "Acquia Web Governance - User List": "Acquia Web Governance – Brukerliste",
    "Acquia Web Governance Consent Manager": "Acquia Web Governance Samtykkeansvarlig",
    "Acquia Web Governance Extension": "Acquia Web Governance-utvidelse",
    "Acquia Web Governance PageAssist": "Acquia Web Governance PageAssist",
    "Acquia Web Governance users receiving this report": "Acquia Web Governance-brukere som mottar denne rapporten",
    "Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )": "Acquia Web Governance vil automatisk oppdage en nedlasting som et klikk på en lenke som slutter med en av følgende filtyper (vær oppmerksom på at filtypene skiller mellom store og små bokstaver)",
    "Add Acquia Web Governance Consent Manager": "Legg til Acquia Web Governance Consent Manager",
    "Affects [[pageCount]] pages": "Påvirker [[pageCount]] sider",
    "An error has occurred - please try again. If the error continues, please contact Acquia Web Governance": "Det har oppstått en feil – prøv på nytt. Hvis feilen vedvarer, ta kontakt med Acquia Web Governance.",
    "An unexpected error occurred. Please try again.": "Det oppsto en uventet feil. Prøv på nytt.",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary for all languages?": "Er du sikker på at du vil legge til ordet <strong>' + ord + '</strong> i ordboken for alle språk?",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary?": "Er du sikker på at du vil legge til ordet <strong>' + ord + '</strong> i ordboken?",
    "Are you sure you want to confirm the misspelling <strong>' + word + '</strong>?": "Er du sikker på at du vil bekrefte feilstavingen <strong>' + ord + '</strong>?",
    "Are you sure you want to remove the Profile <strong>[[profileName]]</strong>?": "Er du sikker på at du vil fjerne profilen <strong>[[profileName]]</strong>?",
    "Are you sure you want to undo review this document as reviewed?": "Er du sikker på at du vil angre gjennomgangen av dette dokumentet som gjennomgått?",
    "Calculate Readability Score": "Beregn lesbarhetspoengsum",
    "Calculate score to see results": "Beregn poengsum for å se resultater",
    "Calculate the readability score of any text (based on [[testName]])": "Beregn lesbarhetspoengsummen til en hvilken som helst tekst (basert på [[testName]])",
    "Can\\\\'t delete label": "Kan ikke slette etiketten",
    "Change your &lt;b&gt; tags into something else": "Endre &lt;b&gt;-taggene dine til noe annet",
    "Choose your own text for the Skip to Content link button<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>": "Velg din egen tekst for Hopp til innhold-lenkeknappen<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Gi en tittel til Hopp til innhold-knappen' | translate }}\\\"></span>",
    "Clear search in the domain picker": "Fjern søket i domenevelgeren",
    "Click here to contact Acquia Web Governance sales department to increase your maximum page count.": "Klikk her for å kontakte salgsavdelingen til Acquia Web Governance for å øke det maksimale sideantallet.",
    "Confirmed misspelling": "Bekreftet stavefeil",
    "Copyright 2020 Acquia Web Governance. All rights reserved.": "Opphavsrett 2020 Acquia Web Governance. Alle rettigheter forbeholdt.",
    "Couldn't find any domains": "Fant ingen domener",
    "Crawled Pages ([[pageCount]])": "Gjennomsøkte sider ([[pageCount]])",
    "Description*": "Beskrivelse*",
    "Domain favicon for": "Domenefavicon for",
    "Domain groups": "Domenegrupper",
    "Domains that have never been scanned": "Domener som aldri har blitt skannet",
    "Domains that were not scanned in the selected date range": "Domener som ikke ble skannet i det valgte datoområdet",
    "Edit this policy rule later under the \\\"Add rule to policy\\\" tab.": "Rediger denne policyregelen senere under fanen «Legg til regel i policy».",
    "Enable if you want to use Acquia Web Governance in Accessibility mode": "Aktiver hvis du vil bruke Acquia Web Governance i tilgjengelighetsmodus",
    "Export visitors screen resolutions": "Eksporter skjermoppløsninger for besøkende",
    "For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.": "Foreløpig vil Acquia Web Governance Pagecorrect legge til en popup-advarsel til alle eksterne lenker, slik at besøkende selv kan velge om de ønsker å navigere bort fra den opprinnelige siden.",
    "Found 1 audit log on your account": "Fant 1 revisjonslogg på kontoen din",
    "Found [[count]] audit logs on your account": "Fant [[count]] revisjonslogger på kontoen din",
    "From March 1, 2022, Acquia Web Governance will no longer be supporting any version of Internet Explorer or Edge browser version 78 or below. While you will still be able to log on and use Acquia Web Governance with Internet Explorer and older versions of Edge, we are no longer testing releases and fixing bugs specifically for those browsers. We encourage you to switch to another browser such as Chrome or newer version of Edge to be sure that Acquia Optimize continues to work optimally on your device.": "Fra 1. mars 2022 vil ikke Acquia Web Governance lenger støtte noen versjon av Internet Explorer eller Edge nettleserversjon 78 eller eldre. Selv om du fortsatt vil kunne logge på og bruke Acquia Web Governance med Internet Explorer og eldre versjoner av Edge, tester vi ikke lenger utgivelser og fikser feil spesifikt for disse nettleserne. Vi oppfordrer deg til å bytte til en annen nettleser, for eksempel Chrome eller en nyere versjon av Edge, for å være sikker på at Acquia Optimize fortsetter å fungere optimalt på enheten din.",
    "Get the Acquia Web Governance Extension": "Skaff deg Acquia Web Governance-utvidelsen",
    "Go to the policy dashboard of the domain [[title]]": "Gå til policydashbordet for domenet [[title]]",
    "Images missing alt attribute": "Bilder mangler alt-attributt",
    "Insert the CSS selector targets you want your visitors to land on<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>": "Sett inn CSS-selektormålene du vil at de besøkende skal lande på<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Sørg for at du bruker riktig formatering og legg til flere selektorer når sidedesignet ditt er annerledes' | translate }}\\\"></span>",
    "Internet Explorer &amp; Edge v.78 (or below) no longer supported": "Internet Explorer og Edge v.78 (eller eldre) støttes ikke lenger",
    "Italics are often used in HTML to put emphasis on text. However, this is often achieved with the &lt;I&gt; tag, in which case the emphasis is not announced by screen readers. Using the &lt;I&gt; tag doesn't provide enough context and is becoming an outdated practice.": "Kursiv brukes ofte i HTML for å legge vekt på tekst. Dette oppnås imidlertid ofte med <I>-taggen, og i så fall leses ikke vekten av skjermlesere. Bruk av <I>-taggen gir ikke nok kontekst og er i ferd med å bli en utdatert praksis.",
    "Last 8 Performance Scans Scores": "Poengsummer for de siste 8 ytelsesskanningene",
    "Latest manual scan finished on [[scannedAt]]": "Siste manuelle skanning fullført [[scannedAt]]",
    "Mark this issue as fixed": "Merk dette problemet som løst",
    "Monitor how visitors interact with your pages. Acquia Web Governance tracks up to a maximum of 1000 heatmaps sessions per page per month.": "Overvåk hvordan besøkende samhandler med sidene dine. Acquia Web Governance sporer opptil maksimalt 1000 varmekart-økter per side per måned.",
    "No downloads were found. Try searching for the document URL instead of the document title.": "Ingen nedlastinger ble funnet. Prøv å søke etter dokument-URL-en i stedet for dokumenttittelen.",
    "No more PDF accessibility scans are available for this account. Please contact a Acquia Web Governance sales department to add more.": "Ingen flere PDF-tilgjengelighetsskanninger er tilgjengelige for denne kontoen. Ta kontakt med en salgsavdeling for Acquia Web Governance for å legge til flere.",
    "Not valid URL": "Ikke gyldig nettadresse",
    "PageCorrect failed to save, the Acquia Web Governance team has been notified of the error": "PageCorrect kunne ikke lagres. Acquia Web Governance-teamet har blitt varslet om feilen.",
    "Pages Without Visits": "Sider uten besøk",
    "Part of success criteria [[issueNumber]]": "Del av suksesskriteriene [[issueNumber]]",
    "Pick any link on your website which you know opens in a new page (social media icons are usually a safe bet) and try to navigate away from the page you are on. If the pop-up doesn't appear it might be because the script has not been applied yet. Give it some time.": "Velg en lenke på nettstedet ditt som du vet åpnes på en ny side (ikoner for sosiale medier er vanligvis et trygt valg), og prøv å navigere bort fra siden du er på. Hvis popup-vinduet ikke vises, kan det være fordi skriptet ikke er implementert ennå. Gi det litt tid.",
    "Policy Scan is no longer valid. Press Run Policy to update Policy Scan details": "Policy-skanning er ikke lenger gyldig. Trykk Kjør policy for å oppdatere policy-skanningsdetaljene",
    "Readability Checker": "Lesbarhetskontroll",
    "Readability Level": "Lesbarhetsnivå",
    "Readability Summary": "Lesbarhetssammendrag",
    "Remove word from Ignored Misspellings": "Fjern ord fra Ignorerte feilstavinger",
    "Remove word from dictionary": "Fjern ord fra ordboken",
    "Request Remediation from selection": "Be om utbedring fra utvalget",
    "Request failed. Please ensure you have added only text in the input field.": "Forespørselen mislyktes. Sørg for at du bare har lagt til tekst i inndatafeltet.",
    "Scan stopped successfully": "Skanningen ble stoppet",
    "Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan": "Planlegg rapporter for deg selv [[adminText]] via e-post etter hver Acquia Web Governance-skanning",
    "Search for content that*": "Søk etter innhold som*",
    "Something went wrong. The Acquia Web Governance Team has been notified of this error and will get back to you, as soon as possible.": "Noe gikk galt. Acquia Web Governance-teamet har blitt varslet om denne feilen og vil ta kontakt med deg så snart som mulig.",
    "Start Cookie Scan": "Start skanning av informasjonskapsler",
    "Start Scan": "Start skanning",
    "Start a new scan to find cookies or add them manually": "Start en ny skanning for å finne informasjonskapsler, eller legg dem til manuelt",
    "Stop scan": "Stopp skanningen",
    "Switch to Acquia Web Governance classic": "Bytt til Acquia Web Governance klassisk",
    "Test your website's compliance levels ([[level]]) and fix issues that are making it difficult for people with disabilities to use your website": "Test nettstedets samsvarsnivåer ([[level]]) og fiks problemer som gjør det vanskelig for funksjonshemmede å bruke nettstedet ditt.",
    "The Acquia Web Governance team is notified and are working on the issue.": "Acquia Web Governance-teamet er varslet og jobber med problemet.",
    "The Compound Export contains data from the first and last scans within the selected date range. The export does not include data from the following sources:": "Den sammensatte eksporten inneholder data fra den første og siste skanningen innenfor det valgte datointervallet. Eksporten inkluderer ikke data fra følgende kilder:",
    "The profile has been archived.": "Profilen er arkivert.",
    "The profile has been restored.": "Profilen er gjenopprettet.",
    "There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.": "Det finnes bare én måte å gjøre dette på. Acquia Web Governance vil erstatte alle <I>-taggene den finner på nettstedet ditt med em-tagger i stedet.",
    "Type in or paste text to be analyzed": "Skriv inn eller lim inn tekst som skal analyseres",
    "URL &amp; Title": "URL og tittel",
    "Unignore Misspelling": "Fjern ignorering av stavefeil",
    "Url &amp; Title": "URL og tittel",
    "Visitors screen resolutions export": "Eksport av skjermoppløsninger for besøkende",
    "Weight in score: [[weight]]": "Vekt i poengsum: [[weight]]",
    "Why can't I open a new window without warning?": "Hvorfor kan jeg ikke åpne et nytt vindu uten forvarsel?",
    "Why do I need a \\\"skip to content\\\" link?": "Hvorfor trenger jeg en «hopp til innhold»-lenke?",
    "Why shouldn't I use the marquee element?": "Hvorfor skal jeg ikke bruke marquee-elementet?",
    "You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here": "Du bruker den nye versjonen av Acquia Web Governance PageAssist. Hvis du ønsker å gå tilbake til v.1.0, klikk her.",
    "You can only calculate a score for up to [[count]] characters.": "Du kan bare beregne en poengsum for opptil [[count]] tegn.",
    "You do not have sufficient permissions to use this feature.": "Du har ikke tilstrekkelige tillatelser til å bruke denne funksjonen.",
    "Your current plan does not include on-demand scans. Please reach out to your Acquia Web Governance representative to learn more about this option": "Din nåværende plan inkluderer ikke skanninger på forespørsel. Ta kontakt med din Acquia Web Governance-representant for å finne ut mer om dette alternativet.",
    "[[$count]] found": "[[$count]] funnet",
    "[[count]] found": "[[count]] funnet",
    "[[headerCount]] found": "[[headerCount]] funnet",
    "[[pageIssues]] Pages <span>([[errorPercentage]]%)</span> to fix": "[[pageIssues]] Sider <span>([[errorPercentage]]%)</span> å fikse",
    "[[pageIssues]] Pages to fix": "[[pageIssues]] Sider som skal fikses",
    "[[pagesDone]] Pages ([[compliancePercentage]]) in compliance": "[[pagesDone]] Sider ([[compliancePercentage]]) i samsvar",
    "[[totalPageIssues]] Pages ([[compliancePercentage]]) to fix": "[[totalPageIssues]] Sider ([[compliancePercentage]]) å fikse",
    "failed when trying to ignore/review all. please try agin, or contact the Acquia Web Governance team": "Mislyktes ved forsøk på å ignorere/gjennomgå alle. Prøv igjen, eller kontakt Acquia Web Governance-teamet.",
    "policies": "retningslinjer",
    "policy": "politikk",
    "Start export PDF Accessibility Report": "Start eksport av PDF Accessibility Report",
    "No data showing? Add the Acquia Web Governance script to your website": "Ingen statistikk som vises? Legg til Acquia Web Governance-skriptet på nettstedet."
  },
  "ja": {
    "Search": {
      "Spotlight": "検索",
      "$$noContext": "検索"
    },
    "Global Policy Overview": {
      "Topmenu": "グローバルポリシーの概要",
      "$$noContext": "グローバルポリシーの概要"
    },
    "History Center": {
      "Topmenu": "ヒストリーセンター",
      "$$noContext": "ヒストリーセンター"
    },
    "Report Center": {
      "Topmenu": "レポートセンター",
      "$$noContext": "レポートセンター"
    },
    "Users": {
      "Topmenu": "ユーザー",
      "$$noContext": "ユーザー"
    },
    "No content was found": {
      "page-details -> Inventory -> links. No result message": "コンテンツが見つかりませんでした",
      "$$noContext": "コンテンツが見つかりませんでした"
    },
    "&nbsp;&nbsp;&nbsp;Passwords does not match": "&nbsp;&nbsp;&nbsp;パスワードが一致しません",
    "(HTML and documents)": "(HTMLとドキュメント)",
    "(No title found)": "(タイトルが見つかりません)",
    "(The HTML snippet is now Marked as Reviewed/Ignored)": "(HTML スニペットはレビュー済み/無視済みとしてマークされました)",
    "(This policy is marked as unwanted content)": "(このポリシーは不要なコンテンツとしてマークされています)",
    "+ Add new check": "+ 新しいチェックを追加",
    "+ Add new user": "+ 新規ユーザーを追加",
    "1 min.": "1分",
    "1 minute": "1分",
    "10 min.": "10分",
    "10th to 12th grade": "高校1年から3年生",
    "120 min.": "120分",
    "15 min.": "15分",
    "1st": "1番目",
    "2nd": "2番目",
    "30 min.": "30分",
    "3rd": "3番目",
    "5 min.": "5分",
    "5 minutes": "5分",
    "5th grade": "小学5年生",
    "60 min.": "60分",
    "6th grade": "小学6年生",
    "7th grade": "中学1年生",
    "8th to 9th grade": "中学2年から3年生",
    "A": "A",
    "A list of all external PDF files already reviewed for accessibility issues": "アクセシビリティの問題がすでに確認されているすべての外部 PDF ファイルの一覧",
    "A list of all external PDF files that you need to check for accessibility issues": "アクセシビリティの問題を確認する必要があるすべての外部PDFファイルの一覧",
    "A list of all internal PDF files already reviewed for accessibility issues": "アクセシビリティの問題がすでに確認されているすべての内部 PDF ファイルの一覧",
    "A list of all internal PDF files that have been marked as failed for accessibility issues": "アクセシビリティの問題で不合格とマークされたすべての内部 PDF ファイルのリスト",
    "A list of all internal PDF files that have been marked as queued for accessibility issues": "アクセシビリティの問題のためキューに入れられたすべての内部 PDF ファイルのリスト",
    "A list of all internal PDF files that you need to check for accessibility issues": "アクセシビリティの問題を確認する必要があるすべての内部 PDF ファイルの一覧",
    "AA": "AA",
    "AAA": "AAA",
    "ACCESSIBILITY OVERVIEW": "アクセシビリティの概要",
    "API Token": "APIトークン",
    "API URL": "API URL",
    "API User": "API ユーザー",
    "API User Details": "API ユーザーの詳細",
    "API Users": "API ユーザー",
    "About": "Acquiaについて",
    "Accept": "承諾する",
    "Accessibility": "アクセシビリティ",
    "Accessibility Check": "アクセシビリティチェック",
    "Accessibility Diagnostics": "アクセシビリティ診断",
    "Accessibility Fast Track": "アクセシビリティ ファスト トラック",
    "Accessibility Icon": "アクセシビリティアイコン",
    "Accessibility Snippet": "アクセシビリティ スニペット",
    "Accessibility Source Code": "アクセシビリティ ソースコード",
    "Accessibility checks compliance by level": "アクセシビリティはレベルごとにコンプライアンスをチェックします",
    "Accessibility checks not in compliance with domain": "アクセシビリティチェックがドメインに準拠していません",
    "Accessibility error type": "アクセシビリティエラーの種類",
    "Accessibility errors": "アクセシビリティエラー",
    "Accessibility fixes": "アクセシビリティの修正",
    "Accessibility help center": "アクセシビリティ ヘルプセンター",
    "Accessibility issues": "アクセシビリティの問題",
    "Accessibility level": "アクセシビリティレベル",
    "Accessibility mode": "アクセシビリティモード",
    "Accessibility review type": "アクセシビリティレビュータイプ",
    "Account dictionary": "アカウント辞書",
    "Action": "アクション",
    "Actions": "アクション",
    "Actions per visit": "訪問ごとのアクション",
    "Active": "アクティブ",
    "Add": "追加",
    "Add Custom Multistep Javascript": "カスタムのマルチステップJavascriptを追加する",
    "Add Extension Name": "拡張機能名を追加",
    "Add Heatmap rule to a Page": "ページにヒートマップルールを追加する",
    "Add Heatmaps": "ヒートマップを追加する",
    "Add PageAssist script": "PageAssist スクリプトを追加",
    "Add PageCorrect": "PageCorrectを修正",
    "Add Profile": "プロフィールを追加",
    "Add Rule": "ルールを追加",
    "Add Skip to PageAssist": "PageAssistにスキップを追加",
    "Add a new exemption to your heartbeat check": "Heartbeatに新たな除外項目を追加する",
    "Add a new page to start tracking individual pages' performance. Get an overview of load times and opportunities to speed up your site.": "新しいページを追加して、個々のページのパフォーマンスの追跡を開始します。読み込み時間の概要と、サイトを高速化する機会を把握します。",
    "Add a non-user email": "非ユーザーメールを追加する",
    "Add another rule": "別のルールを追加する",
    "Add email": "メールを追加",
    "Add exemption": "除外項目を追加",
    "Add new check": "新しいチェックを追加",
    "Add new domain": "新しいドメインを追加",
    "Add new exemption": "新しい免除を追加",
    "Add new label": "新しいラベルを追加",
    "Add new page": "新しいページを追加",
    "Add new policy": "新しいポリシーを追加",
    "Add new user": "新しいユーザーを追加",
    "Add non users": "非ユーザーを追加",
    "Add reason (Optional)": "理由を追加（任意）",
    "Add rule to policy": "ポリシーにルールを追加する",
    "Add rule to the policy": "ポリシーにルールを追加する",
    "Add task": "タスクを追加",
    "Add timeslots where you won't receive notifications on downtime and slow responsetimes.": "ダウンタイムや応答時間の遅延に関する通知を受信しないタイムスロットを追加します。",
    "Add to all languages": "すべての言語に追加",
    "Add to dictionary": "辞書に追加",
    "Add to dictionary for all languages": "すべての言語の辞書に追加",
    "Added": "追加しました",
    "Added by": "追加者",
    "Added date": "追加日",
    "Address": "住所",
    "Admin": "管理者",
    "Advanced Domain Options": "高度なドメインオプション",
    "Affected image": "影響を受ける画像",
    "Affected pages": "影響を受けるページ",
    "Affected pages by priority": "優先度ごとの影響を受けるページ",
    "Affected pages by severity": "深刻度別の影響を受けるページ",
    "Affects": "影響",
    "After": "変更後",
    "All": "全て",
    "All Failed Internal PDF files": "すべての不合格の内部PDFファイル",
    "All Pending External PDF files": "保留中のすべての外部 PDF ファイル",
    "All Pending Internal PDF files": "保留中のすべての内部 PDF ファイル",
    "All Queued Internal PDF files": "キューに入れられたすべての内部 PDF ファイル",
    "All Reviewed External PDF files": "すべてのレビュー済み外部 PDF ファイル",
    "All Reviewed Internal PDF files": "すべてのレビュー済み内部 PDF ファイル",
    "All assets": "すべてのアセット",
    "All broken images": "すべての壊れた画像",
    "All broken links": "すべてのリンク切れ",
    "All heartbeat checkpoints": "すべてのHeartbeatチェックポイント",
    "All incident checkpoints in the selected time span": "選択した期間内のすべてのインシデントチェックポイント",
    "All level A accessibility checks": "すべてのレベルAアクセシビリティチェック",
    "All level AA accessibility checks": "すべてのレベルAAアクセシビリティチェック",
    "All level AAA accessibility checks": "すべてのレベルAAAアクセシビリティチェック",
    "All levels": "すべてのレベル",
    "All modules": "すべてのモジュール",
    "All modules - Content with Issues": "すべてのモジュール - 問題のあるコンテンツ",
    "All notifications": "すべての通知",
    "All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.": "以下のスクリプトをウェブサイトの BODY タグに挿入するだけです。そのままコピーして貼り付けるだけです。",
    "Analytics (Last 7 days)": "分析（過去 7 日間）",
    "And": "And",
    "Appears on": "表示場所",
    "Apply": "適用する",
    "Archive": "アーカイブ",
    "Archive files": "アーカイブファイル",
    "Archived": "アーカイブ済み",
    "Are you sure you want to Mark this link as unignored?": "このリンクを無視しないものとしてマークしてもよろしいですか?",
    "Are you sure you want to Request All PDF Accessibility checks?": "すべての PDF アクセシビリティ チェックをリクエストしてもよろしいですか?",
    "Are you sure you want to add to Request PDF Accessibility check from selection?": "選択内容をPDF アクセシビリティチェックのリクエストに追加しますか?",
    "Are you sure you want to add to all the dictionaries?": "すべての辞書に追加してもよろしいですか?",
    "Are you sure you want to add to the dictionary?": "辞書に追加してもよろしいですか?",
    "Are you sure you want to close this form without saving your changes?": "変更を保存せずにこのフォームを閉じてもよろしいですか?",
    "Are you sure you want to confirm this misspelling?": "このスペルミスを確定しますか?",
    "Are you sure you want to delete the API User [[apiUserId]]": "API ユーザー [[apiUserId]] を削除しますか?",
    "Are you sure you want to delete this exemption?": "この除外項目を削除しますか?",
    "Are you sure you want to delete this source exclude?": "この除外ソースを削除しますか?",
    "Are you sure you want to ignore all errors for this check?": "このチェックのすべてのエラーを無視してもよろしいですか?",
    "Are you sure you want to ignore the selected issue on this page?": "このページで選択した問題を無視してもよろしいですか?",
    "Are you sure you want to ignore this check for this domain?": "このドメインのこのチェックを無視してもよろしいですか?",
    "Are you sure you want to ignore this check for this page?": "このページのこのチェックを無視してもよろしいですか?",
    "Are you sure you want to ignore this issue?": "この問題を無視してもよろしいですか?",
    "Are you sure you want to ignore this misspelling?": "このスペルミスを無視してもよろしいですか?",
    "Are you sure you want to mark this issue as fixed?": "この問題を解決済みとしてマークしますか?",
    "Are you sure you want to mark this issue as not fixed?": "この問題を未解決としてマークしますか?",
    "Are you sure you want to mark this link as fixed?": "このリンクを修正済みとしてマークしてもよろしいですか?",
    "Are you sure you want to mark this link as ignored?": "このリンクを無視としてマークしてもよろしいですか?",
    "Are you sure you want to mark this link as not fixed?": "このリンクを修正されていないものとしてマークしてもよろしいですか?",
    "Are you sure you want to remove manually added user?": "手動で追加されたユーザーを削除してもよろしいですか?",
    "Are you sure you want to remove review for this issue?": "この問題のレビューを削除してもよろしいですか?",
    "Are you sure you want to remove review on all errors for this check?": "このチェックのすべてのエラーのレビューを削除してもよろしいですか?",
    "Are you sure you want to remove this group?": "このグループを削除してもよろしいですか?",
    "Are you sure you want to remove this host?": "このホストを削除してもよろしいですか?",
    "Are you sure you want to remove this rule?": "このルールを削除してもよろしいですか?",
    "Are you sure you want to remove this?": "これを削除してもよろしいですか?",
    "Are you sure you want to review all errors for this check?": "このチェックのすべてのエラーをレビューしますか?",
    "Are you sure you want to review this issue?": "この問題をレビューしますか?",
    "Are you sure you want to set this document as reviewed?": "このドキュメントをレビュー済みとして設定してもよろしいですか?",
    "Are you sure you want to start on-demand scan?": "オンデマンドスキャンを開始してもよろしいですか?",
    "Are you sure you want to stop current crawl?": "現在のクロールを停止しますか?",
    "Are you sure you want to the request ADA clarification for [[name]]?": "[[name]] の ADA の説明をリクエストしますか?",
    "Are you sure you want to undo review of this document?": "このドキュメントのレビューを取り消してもよろしいですか?",
    "Are you sure you want to undo reviewing this document?": "このドキュメントのレビューを元に戻しますか?",
    "Are you sure you want to unignore all errors for this check?": "このチェックのすべてのエラーを無視解除しますか?",
    "Are you sure you want to unignore the selected issue on this page?": "このページで選択した問題の無視を解除しますか?",
    "Are you sure you want to unignore this check for this domain?": "このドメインのこのチェックを無視解除しますか?",
    "Are you sure you want to unignore this check for this page?": "このページのこのチェックを無視解除しますか?",
    "Are you sure you want to unignore this issue?": "この問題を無視解除しますか?",
    "Are you sure you want to unignore this link?": "このリンクを無視解除しますか?",
    "Are you sure you want to unignore this misspelling?": "このスペルミスを無視解除しますか?",
    "Are you sure you want to unpin this domain": "このドメインのピン留めを解除してもよろしいですか?",
    "Are you sure you want unignore this link?": "このリンクを無視解除しますか?",
    "Assign Heatmap Rule": "ヒートマップルールを割り当てる",
    "Assign to the Performance Module": "パフォーマンスモジュールに割り当てる",
    "Attribute": "属性",
    "Audit": "監査",
    "Audit Log": "監査ログ",
    "Autoselect": "自動選択",
    "Average First Contentful Paint": "平均的なFirst Contentful Paint",
    "Average First Meaningful Paint": "平均的なFirst Meaningful Paint",
    "Average Performance Score": "平均パフォーマンススコア",
    "Average Performance score": "平均パフォーマンススコア",
    "Average Time to Interactive": "平均的なTime to Interactive",
    "Average response time": "平均応答時間",
    "Average time": "平均時間",
    "Average uptime": "平均稼働時間",
    "Average visit time": "平均訪問時間",
    "Avg. Performance Score": "平均パフォーマンススコア",
    "Avg. Visit Time": "平均訪問時間",
    "Avg. response": "平均応答",
    "BETA": "ベータ",
    "Back": "戻る",
    "Back to Heartbeat Overview": "Heartbeatの概要に戻る",
    "Bar": "バー",
    "Basic Auth": "Basic認証",
    "Before": "変更前",
    "Below 5th grade": "小学5年生以下",
    "Below you can see a list of all pages that contains the title": "以下にタイトルを含むすべてのページのリストが表示されます",
    "Book online training": "オンライントレーニングを予約する",
    "Bounce Rates": "直帰率",
    "Bounce rate": "直帰率",
    "Bounce rates": "直帰率",
    "Brand name": "ブランド名",
    "Broken Image": "壊れた画像",
    "Broken Image Links per page": "ページあたりの壊れた画像リンク数",
    "Broken Images": "壊れた画像",
    "Broken Links": "リンク切れ",
    "Broken Page Link": "壊れたページリンク",
    "Broken image affecting most content": "ほとんどのコンテンツに影響を与える壊れた画像",
    "Broken image affecting most pages": "ほとんどのページに影響する壊れた画像",
    "Broken images": "壊れた画像",
    "Broken images with page count": "画像が壊れているページ数",
    "Broken link": "リンク切れ",
    "Broken link affecting most content": "ほとんどのコンテンツに影響するリンク切れ",
    "Broken link affecting most pages": "ほとんどのページに影響するリンク切れ",
    "Broken links": "リンク切れ",
    "Broken links per page": "ページごとのリンク切れ",
    "Broken links with page count": "リンク切れのあるページ数",
    "Browser": "ブラウザ",
    "Browser Extension": "ブラウザ拡張機能",
    "Browsers": "ブラウザ",
    "Browsers Overview": "ブラウザの概要",
    "Bubble": "バブル",
    "Build it from scratch": "ゼロから構築する",
    "By deleting this domain all domain groups related to this domain, will also be deleted": "このドメインを削除すると、このドメインに関連するすべてのドメイングループも削除されます。",
    "By user": "ユーザー別",
    "CMS": "CMS",
    "CMS url": "CMS URL",
    "CSS": "CSS",
    "CSS Target Selector": "CSS ターゲットセレクタ",
    "CSS id or class selector to search for": "検索対象とするCSSのIDかclassセレクタ",
    "CSS selector to find submit button": "送信ボタンを見つけるための CSS セレクタ",
    "Cache TTL": "キャッシュTTL",
    "Cancel": "キャンセル",
    "Case sensitive": "大文字と小文字を区別",
    "Categories": "カテゴリー",
    "Category": "カテゴリー",
    "Change password": "パスワードを変更する",
    "Changed to": "変更内容",
    "Changes": "変更点",
    "Changes added": "変更が追加されました",
    "Changes in selected time frame:": "選択した期間内の変更:",
    "Changes since Previous Crawl": "前回のクロール以降の変更",
    "Changes since previous crawl": "前回のクロール以降の変更",
    "Characters": "文字数",
    "Chart": "チャート",
    "Chart is now showing: [[name]]": "現在表示されているチャート: [[name]]",
    "Check": "チェック",
    "Check List Export": "チェックリストのエクスポート",
    "Check all links in this section": "このセクションのすべてのリンクを確認してください",
    "Check all misspellings in this section": "このセクションのすべての誤字をチェックしてください",
    "Check all modules": "すべてのモジュールをチェック",
    "Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)": "ウェブサイト全体のコンテンツの問題（スペルミス、リンク切れ、読みやすさなどの問題）をチェックして修正します",
    "Check frequency": "チェック頻度",
    "Check frequency:": "チェック頻度:",
    "Check is ignored": "チェックは無視されます",
    "Check is ignored for the entire domain": "ドメイン全体のチェックは無視されます",
    "Check link": "リンクをチェックする",
    "Check misspelling": "スペルミスをチェック",
    "Check name": "名前を確認",
    "Check off as Reviewed": "レビュー済みとしてチェックする",
    "Check passed": "チェックに合格",
    "Check site status": "サイトの状態を確認する",
    "Checking": "チェック中",
    "Checkpoint exemptions": "チェックポイントの除外",
    "Checkpoint has been updated.": "チェックポイントが更新されました。",
    "Checkpoint information": "チェックポイント情報",
    "Checkpoint:": "チェックポイント:",
    "Checks": "チェック",
    "Checks passed": "チェックに合格",
    "Checks whether your website is responding and measures the response time of the server": "ウェブサイトが応答しているかどうかを確認し、サーバーの応答時間を測定します",
    "Choose Operator": "オペレーターを選択",
    "Choose What to Scan": "スキャン対象を選択",
    "Choose a response time": "応答時間を選択してください",
    "Choose a response time notification": "応答時間通知を選択する",
    "Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned": "セキュリティスキャンのデフォルトテンプレートとして既存のデータ法を選択します。以下の問題を編集して、特定のタグをスキャンから除外します。",
    "Choose checks": "チェックを選択",
    "Choose domains": "ドメインを選択",
    "Choose how to view the Heatmaps Dashboard": "ヒートマップダッシュボードの表示方法を選択する",
    "Choose notification time": "通知時間を選択",
    "Choose the minimum amount of words to scan for readability on a page": "読みやすさを考慮して、ページをスキャンする最小限の単語数を選択します",
    "Choose where the policy should apply": "ポリシーを適用する場所を選択する",
    "Chrome extension": "Chrome拡張機能",
    "City": "市",
    "Clear all labels": "すべてのラベルをクリア",
    "Clear and close filters": "フィルターをクリアして閉じる",
    "Click here to create your first policy": "最初のポリシーを作成するにはここをクリックしてください",
    "Click here to edit": "編集するにはここをクリック",
    "Click to create your first policy": "クリックして最初のポリシーを作成",
    "Clone": "複製する",
    "Close": "閉じる",
    "Close filters": "フィルターを閉じる",
    "Collapse": "閉じる",
    "Collapse menu": "メニューを折りたたむ",
    "College": "大学",
    "College graduate": "大学卒業生",
    "Coming soon": "近日リリース",
    "Comment": "コメント",
    "Common policy violations": "よくあるポリシー違反",
    "Company Info": "会社情報",
    "Compliance": "コンプライアンス",
    "Compliance {{compliancePercentage}}": "コンプライアンス {{compliancePercentage}}",
    "Compound Export": "複合エクスポート",
    "Compound Report": "複合レポート",
    "Confirm": "確認する",
    "Confirm as misspelling": "スペルミスとして確認",
    "Confirm misspelling": "スペルミスを確認",
    "Confirm this word as a misspelling": "この単語がスペルミスであることを確認する",
    "Confirmed": "確認済み",
    "Confirmed misspellings": "確認済みのスペルミス",
    "Congratulations no violations were found": "おめでとうございます。違反は見つかりませんでした",
    "Connection Profile": "接続プロファイル",
    "Connections per minute": "1分あたりの接続数",
    "Constraint": "制約",
    "Constraint pattern": "制約パターン",
    "Contact me about more Performance Pages": "パフォーマンスページの詳細についてはお問い合わせください",
    "Contact me about more performance profiles": "パフォーマンスプロファイルの詳細についてはお問い合わせください",
    "Containing": "含んでいる",
    "Contains": "含む",
    "Contains confirmed misspellings, broken links & images": "確認済みの誤字、リンク切れ、壊れた画像が含まれています",
    "Contains confirmed misspellings, broken links or images": "誤字、リンク切れ、壊れた画像が含まれていることが確認されています",
    "Contains high, medium & low opportunities for all pages": "すべてのページの高、中、低の機会が含まれています",
    "Contains high, medium & low severity issues for all pages": "すべてのページに重大度の高い、中程度の、低い問題が含まれています",
    "Contains issues with high, medium and low priority for all pages": "すべてのページの優先度が高い、中程度、低い問題が含まれています",
    "Content": "コンテンツ",
    "Content Links": "コンテンツリンク",
    "Content Policies": "コンテンツポリシー",
    "Content Policy Violations": "コンテンツポリシー違反",
    "Content in compliance": "準拠したコンテンツ",
    "Content must be robust enough that it can be interpreted reliably by a wide variety of user agents, including assistive technologies.": "コンテンツは、支援技術を含むさまざまなユーザー エージェントによって確実に解釈できるほど堅牢である必要があります。",
    "Content policies": "コンテンツポリシー",
    "Content with Broken Image": "壊れた画像を含むコンテンツ",
    "Content with Broken Link": "リンク切れのあるコンテンツ",
    "Content with Broken Links": "リンク切れのあるコンテンツ",
    "Content with Data Issues": "データに関する問題のあるコンテンツ",
    "Content with Data Issues export": "データの問題のあるコンテンツのエクスポート",
    "Content with Policy Matches": "ポリシーに一致するコンテンツ",
    "Content with QA Errors": "QAエラーのあるコンテンツ",
    "Content with broken links": "リンク切れのあるコンテンツ",
    "Content with issues": "問題のあるコンテンツ",
    "Content with policy violations": "ポリシー違反のあるコンテンツ",
    "Content with violations": "違反のあるコンテンツ",
    "Context": "コンテクスト",
    "Country": "国",
    "Crawl Automatically": "自動的にクロールする",
    "Crawl Options": "クロールオプション",
    "Crawl done on": "クロール完了",
    "Crawl finalized on": "クロール終了",
    "Crawl info": "クロール情報",
    "Crawl runtime:": "クロール実行時間:",
    "Crawl started:": "クロールを開始しました:",
    "Crawl status": "クロールステータス",
    "Crawl status:": "クロールステータス:",
    "Crawled Documents ([[documentCount]])": "クロールされたドキュメント ([[documentCount]])",
    "Crawled at": "クロールされました:",
    "Crawled pages": "クロールされたページ",
    "Crawling": "クローリング",
    "Create a policy to make an email as unwanted content": "メールアドレスを不適切なコンテンツとして扱うポリシーを作成する",
    "Create as policy": "ポリシーとして作成",
    "Create label": "ラベルを作成",
    "Create new domain group": "新しいドメイングループを作成する",
    "Create new group": "新しいグループを作成",
    "Create user": "ユーザーを作成",
    "Create your own policy": "独自のポリシーを作成する",
    "Created": "作成日時",
    "Created At": "作成日",
    "Created at": "作成日",
    "Created date": "作成日",
    "Created:": "作成した：",
    "Current domain status": "現在のドメインステータス",
    "Current status": "現在のステータス",
    "Custom": "カスタム",
    "Custom Multistep": "カスタムマルチステップ",
    "Custom Profile": "カスタムプロファイル",
    "Custom fixes": "カスタム修正",
    "Custom rule": "カスタムルール",
    "Customer": "顧客",
    "Customer Report": "顧客レポート",
    "DATA PRIVACY OVERVIEW": "データプライバシーの概要",
    "DISCLAIMER": "免責事項",
    "Daily": "毎日",
    "Danish": "デンマーク語",
    "Dark": "暗く",
    "Dashboard": "ダッシュボード",
    "Data Issues": "データの問題",
    "Data Privacy": "データのプライバシー",
    "Data Privacy Diagnostics": "データプライバシー診断",
    "Data Privacy Fast Track": "データプライバシーファストトラック",
    "Data Privacy Help Center": "データプライバシーヘルプセンター",
    "Data Privacy Info Type Icon": "データプライバシー情報タイプアイコン",
    "Data Privacy Issues": "データプライバシーの問題",
    "Data Privacy Summary Export": "データプライバシー概要のエクスポート",
    "Data Privacy issues found": "データプライバシーの問題が見つかりました",
    "Data Regulations": "データ規制",
    "Data Violations": "データ違反",
    "Data issues": "データの問題",
    "Data issues export": "データの問題のエクスポート",
    "Data privacy": "データのプライバシー",
    "Data privacy violations": "データプライバシーの侵害",
    "Data protection and privacy policy statement": "データ保護およびプライバシーポリシー声明",
    "Date": "日付",
    "Day": "日",
    "Days": "日",
    "Dead": "停止",
    "Default": "デフォルト",
    "Default for CMS": "CMSのデフォルト",
    "Default value*": "デフォルト値*",
    "Define meta headers to match": "一致するメタヘッダーを定義する",
    "Define size of files to look for": "検索するファイルのサイズを定義する",
    "Define size of images to look for": "検索する画像のサイズを定義する",
    "Delete": "削除",
    "Delete All": "すべて削除",
    "Delete user": "ユーザーを削除",
    "Describe the exclude": "除外項目を説明説明する",
    "Description": "説明",
    "Desktop": "デスクトップ",
    "Details": "詳細",
    "Device": "デバイス",
    "Device Overview": "デバイスの概要",
    "Device not found": "デバイスが見つかりません",
    "Device:": "デバイス：",
    "Devices": "デバイス",
    "Diagnostics": "診断",
    "Dictionary": "辞書",
    "Difficulty": "難易度",
    "Direct visits": "直接訪問",
    "Disabling": "無効化中",
    "Display policy in other services": "他のサービスのポリシーを表示します",
    "Display this policy as:": "このポリシーを次のように表示します:",
    "Distribution of Data Privacy levels": "データプライバシーレベルの分布",
    "Distribution of PageCorrects across all change types": "すべての変更タイプにおける PageCorrect の分布",
    "Distribution of SEO levels": "SEOレベルの分布",
    "Distribution of policies that match their corresponding setting": "対応する設定に一致するポリシーの配布",
    "Distribution of policies that matches their corresponding setting": "対応する設定に一致するポリシーの配布",
    "Do you want the policy to run every time your website is crawled?": "ウェブサイトがクロールされるたびにポリシーを実行しますか?",
    "Do you want to find pages which match the query on one or multiple lines?": "1 行または複数行のクエリに一致するページを検索しますか?",
    "Do you want to find pages which match the query or pages which does not match the query": "クエリに一致するページを検索しますか、それともクエリに一致しないページを検索しますか",
    "Do you want to update the Script Settings, for this Domain?": "このドメインのスクリプト設定を更新しますか?",
    "Document": "ドキュメント",
    "Document Class": "ドキュメントクラス",
    "Document Dashboard": "ドキュメントダッシュボード",
    "Document Details": "ドキュメントの詳細",
    "Document Extension": "ドキュメント拡張子",
    "Document Ignore Class": "無視するドキュメントのclass",
    "Document first detected": "最初に検出された文書",
    "Document scan": "文書スキャン",
    "Documents": "ドキュメント",
    "Documents Crawled": "クロールされたドキュメント",
    "Documents basic": "ドキュメントの基本",
    "Documents crawled": "クロールされたドキュメント",
    "Documents extended": "ドキュメントの拡張",
    "Documents with Broken Image": "画像が破損した文書",
    "Documents with Broken Link": "リンク切れがある文書",
    "Domain": "ドメイン",
    "Domain Compliance": "ドメインコンプライアンス",
    "Domain Data Privacy Settings": "ドメインデータプライバシー設定",
    "Domain Detail": "ドメインの詳細",
    "Domain Details": "ドメインの詳細",
    "Domain Groups": "ドメイングループ",
    "Domain Picker Closed": "ドメインピッカー閉鎖",
    "Domain Picker Opened": "ドメインピッカー開始",
    "Domain compliance": "ドメインコンプライアンス",
    "Domain group": "ドメイングループ",
    "Domain title and URL": "ドメインタイトルとURL",
    "Domain:": "ドメイン：",
    "Domains": "ドメイン",
    "Domains/groups selected": "選択されたドメイン/グループ",
    "Done": "終了",
    "Download": "ダウンロード",
    "Download the Chrome extension": "Chrome拡張機能をダウンロードする",
    "Download the Edge add-on": "Edgeアドオンをダウンロードする",
    "Download the Firefox add-on": "Firefoxアドオンをダウンロードする",
    "Downloads": "ダウンロード",
    "Downtime": "ダウンタイム",
    "Downtime (Minutes)": "ダウンタイム（分）",
    "Downtime notification": "ダウンタイム通知",
    "Drag and drop the rule to add rules to the policy": "ルールをドラッグアンドドロップしてポリシーにルールを追加します",
    "Dropdown": "ドロップダウン",
    "Duration": "間隔",
    "Easy": "簡単",
    "Easy to read pages understood by most. Example: fiction literature for adults": "ほとんどの人が理解できる読みやすいページ。例: 大人向けのフィクション文学",
    "Edge add-on": "エッジアドオン",
    "Edit": "編集",
    "Edit Labels": "ラベルを編集",
    "Edit Performance Page": "パフォーマンスページの編集",
    "Edit customer information": "顧客情報を編集する",
    "Edit domain": "ドメインを編集",
    "Edit domain group": "ドメイングループを編集",
    "Edit exemption": "編集除外",
    "Edit label": "ラベルを編集",
    "Edit labels": "ラベルを編集する",
    "Edit my profile": "プロフィールの編集",
    "Edit or Delete PageCorrect": "ページの編集または削除修正",
    "Edit uptime": "稼働時間を編集",
    "Edit user": "ユーザーを編集",
    "Edit users": "ユーザーを編集",
    "Edit your exemption": "除外項目の編集",
    "Edit:": "編集：",
    "Effect on compliance": "コンプライアンスへの影響",
    "Effect on overall compliance level": "全体的なコンプライアンスレベルへの影響",
    "Element": "要素",
    "Element Tree Path": "要素ツリーパス",
    "Email": "Eメール",
    "Email Notifications": "メール通知",
    "Email addresses": "メールアドレス",
    "Email receiver *": "メール受信者 *",
    "Email to login": "ログイン用メールアドレス",
    "Emails": "メール",
    "Empty": "空",
    "Empty mailto": "空のメール送信先",
    "Enable / Disable Accessibility mode": "アクセシビリティモードを有効/無効にする",
    "Enable Document Tracking": "ドキュメント追跡を有効にする",
    "Enable Export Email Notification": "エクスポートメール通知を有効にする",
    "Enable Statistics": "統計を有効にする",
    "Enabled features": "有効な機能",
    "Enabling": "有効化",
    "End at": "終了",
    "End date": "終了日",
    "End time": "終了時間",
    "English": "英語",
    "Enter the full URL": "完全なURLを入力してください",
    "Entries": "エントリー",
    "Entry": "エントリ",
    "Entry Pages": "エントリーページ",
    "Entry and Exit Pages": "ページへのエントリーと離脱",
    "Error": "エラー",
    "Error Name": "エラー名",
    "Errors": "エラー",
    "Errors ([[audits]])": "エラー ([[audits]])",
    "Exact": "正確",
    "Example: academic publications": "例: 学術出版物",
    "Example: children's literature": "例: 児童文学",
    "Example: daily newspapers": "例: 日刊新聞",
    "Example: fiction books": "例: フィクション本",
    "Example: legal texts": "例: 法律文書",
    "Examples": "例",
    "Excel Documents": "Excel ドキュメント",
    "Exclude": "除外",
    "Exclude links that contains class name": "クラス名を含むリンクを除外",
    "Exclude pattern": "パターンを除外",
    "Excluded IP addresses from statistics": "統計から除外された IP アドレス",
    "Exemption": "免除",
    "Exemption options": "免除オプション",
    "Exemption time": "免除期間",
    "Exemptions": "免除",
    "Exit Pages": "終了ページ",
    "Exits": "出口",
    "Expand": "拡大",
    "Explain the rationale behind the policy and which actions, editors should take to correct the violation": "ポリシーの根拠と、違反を是正するために編集者が取るべき行動を説明する",
    "Export": "エクスポート",
    "Export CSV": "CSVエクスポート",
    "Export Compound CSV": "複合CSVをエクスポート",
    "Export Logs": "ログのエクスポート",
    "Export list of broken images organized by page and document title": "ページとドキュメントのタイトル別に整理された壊れた画像のリストをエクスポートします",
    "Export list of broken links organized by page and document title": "ページとドキュメントのタイトル別に整理されたリンク切れのリストをエクスポートする",
    "Export list of downtimes for the domain": "ドメインのダウンタイムのリストをエクスポートする",
    "Export list of response times": "応答時間のリストをエクスポートする",
    "External": "外部の",
    "External Export": "外部エクスポート",
    "External PDF Compliance": "外部PDFコンプライアンス",
    "External PDFs": "外部PDF",
    "External Referring Domains": "外部参照ドメイン",
    "External Referring domains": "外部参照ドメイン",
    "External referees overview": "外部審査員の概要",
    "External referring domains": "外部参照ドメイン",
    "FCP": "FCP",
    "FMP": "FMP",
    "Facebook": "フェイスブック",
    "Fail Example": "失敗例",
    "Failed": "失敗した",
    "Failing accessibility checks": "アクセシビリティチェックに失敗する",
    "Failing accessibility checks gives you information about the current Accessibility status of the website/group. It may vary from the history if there have been changes in ignored and review of accessibility issues": "アクセシビリティチェックに失敗すると、ウェブサイト/グループの現在のアクセシビリティステータスに関する情報が提供されます。無視されたり、アクセシビリティの問題のレビューが変更されたりした場合は、履歴と異なる場合があります。",
    "Failing check": "チェックに失敗",
    "Failing check found": "失敗したチェックが見つかりました",
    "Failing checks": "チェックに失敗する",
    "Failing checks found": "不合格のチェックが見つかりました",
    "Fast Track": "ファストトラック",
    "Fast track html snippet": "ファストトラック HTML スニペット",
    "Faster": "もっと早く",
    "Features": "特徴",
    "Feedback submitted": "フィードバックを送信しました",
    "File size": "ファイルサイズ",
    "Filter": "フィルター",
    "Filter by": "フィルター",
    "Filter by:": "フィルター:",
    "Filter labels list": "フィルターラベルリスト",
    "Find and address violations relating to your content guides and regulatory compliance and find outdated content across your website.": "コンテンツ ガイドや規制コンプライアンスに関連する違反を見つけて対処し、Web サイト全体で古くなったコンテンツを見つけます。",
    "Find word(s) without specific context": "特定の文脈なしで単語を検索する",
    "Firefox add-on": "Firefoxアドオン",
    "First Contentful Paint": "First Contentful Paint",
    "First Meaningful Paint": "First Meaningful Paint",
    "First name": "名前",
    "Fixed": "修理済み",
    "Fixed or ignored violations": "修正または無視された違反",
    "Flesch Kincaid": "Flesch Kincaid",
    "For this domain": "このドメインの場合",
    "Form": "フォーム",
    "Form fields": "フォームフィールド",
    "Forms": "フォーム",
    "Found": "見つかりました",
    "Four times a day": "１日に４回",
    "Frames": "フレーム",
    "Friday": "金曜日",
    "From 2 seconds to 8 seconds": "2秒から8秒",
    "Generating report": "レポートを生成しています",
    "Get advice on how to handle this check": "このチェックの対処方法についてアドバイスを受ける",
    "Getting {{ logs }} out of {{totalLogs}} logs": "{{totalLogs}} ログのうち {{ logs }} を取得しています",
    "Global - All Domains": "グローバル - すべてのドメイン",
    "Global Policies": "グローバルポリシー",
    "Global Policy Dashboard": "グローバルポリシーダッシュボード",
    "Global Policy List": "グローバルポリシーリスト",
    "Go to Global Policy List": "グローバルポリシーリストへ移動",
    "Go to My Exports": "マイエクスポートへ移動",
    "Go to PDFs": "PDFへ移動",
    "Go to Policy List": "ポリシーリストへ移動",
    "Go to broken Links": "リンク切れへ移動",
    "Go to broken images": "壊れた画像へ移動",
    "Go to broken links": "リンク切れへ移動",
    "Go to checkpoints": "チェックポイントへ移動",
    "Go to data issues": "データの問題へ移動",
    "Go to domain": "ドメインへ移動",
    "Go to help center": "ヘルプセンターへ",
    "Go to mispellings": "誤字へ移動",
    "Go to misspellings": "誤字へ移動",
    "Go to most visits pages": "最も多く訪問されたページへ移動",
    "Go to page": "ページに移動",
    "Go to page details": "ページの詳細へ移動",
    "Go to potential misspellings": "誤字の可能性へ移動",
    "Go to predefined url": "定義済みのURLに移動",
    "Go to the dashboard": "ダッシュボードに移動",
    "Go to traffic sources overview": "トラフィックソースの概要へ",
    "Go to uptime": "稼働時間へ進む",
    "Go to visitor overview": "訪問者概要へ",
    "Good job! No incidents was registered": "よくできました！インシデントは記録されませんでした",
    "Good job! No issues were found": "よくできました！問題は見つかりませんでした",
    "Good job! No violations were found": "よくできました！違反は見つかりませんでした",
    "Google": "グーグル",
    "Greater than 8 seconds": "8秒以上",
    "Grid View": "グリッドビュー",
    "Groups": "グループ",
    "Guidelines": "ガイドライン",
    "Guidelines for WCAG 2.0": "WCAG 2.0 ガイドライン",
    "Guidelines for WCAG 2.1": "WCAG 2.1 ガイドライン",
    "H1 on this page": "このページのH1",
    "HTML": "HTML",
    "HTML Pages": "HTML ページ",
    "HTML pages": "HTML ページ",
    "HTML snippet": "HTML スニペット",
    "HTML snippet affecting compliance level": "コンプライアンス レベルに影響する HTML スニペット",
    "HTML snippet failing check": "HTML スニペットのチェックに失敗",
    "Hard": "難しい",
    "Hard to read text. Example: popular science magazines and easier academic publications": "読みにくいテキスト。例: 科学雑誌や簡単な学術出版物",
    "Harmony CMS": "Harmony CMS",
    "Header type": "ヘッダータイプ",
    "Headers": "ヘッダー",
    "Headlinks": "ヘッドリンク",
    "Heartbeat": "Heartbeat",
    "Heartbeat Downtime": "Heartbeat ダウンタイム",
    "Heartbeat Response Time": "Heartbeat 応答時間",
    "Heartbeat status saved": "Heartbeat ステータスが保存されました",
    "Heatmaps": {
      "$$noContext": "ヒートマップ",
      "Topmenu": "ヒートマップ"
    },
    "Help Center": "ヘルプセンター",
    "Help center": "ヘルプセンター",
    "High": "高い",
    "High impact": "大きな影響",
    "High impact opportunities": "大きな影響を与える機会",
    "High priority": "優先度が高い",
    "High severity": "重大度が高い",
    "High severity issues": "重大度の高い問題",
    "Highest level of readability. Example: complex academic and legal texts": "最高レベルの難しさ。例: 複雑な学術文書や法律文書",
    "History": "歴史",
    "Hit": "ヒット",
    "Hits": "ヒット",
    "Hits across all domains and modules": "すべてのドメインとモジュールにわたるヒット",
    "Hits on domain": "ドメインのヒット数",
    "Home": "トップ",
    "Host": "ホスト",
    "Hosts": "ホスト",
    "Hosts cannot be empty": "ホストは空白にできません",
    "Hours": "時間",
    "How often the page is checked": "ページがチェックされる頻度",
    "How to fix this problem": "この問題を解決する方法",
    "How to prevent": "予防方法",
    "How to setup this policy": "このポリシーの設定方法",
    "IFrames": "iframe",
    "IP address": "IPアドレス",
    "Icon": "アイコン",
    "Icon status": "アイコンのステータス",
    "Identifier": "識別子",
    "Ignore": "無視する",
    "Ignore check": "チェックを無視する",
    "Ignore misspelling": "スペルミスを無視",
    "Ignore on the page": "ページ上で無視する",
    "Ignore on this page": "このページを無視する",
    "Ignore this SEO issue": "このSEOの問題は無視してください",
    "Ignore this check": "このチェックを無視",
    "Ignore this check for this domain": "このドメインのこのチェックを無視する",
    "Ignored": "無視済み",
    "Ignored Misspellings": "無視された誤字",
    "Ignored Policies": "無視されたポリシー",
    "Ignored checks": "無視されたチェック",
    "Ignored issue": "無視された問題",
    "Ignored policies": "無視されたポリシー",
    "Ignoring broken link": "リンク切れを無視する",
    "Image": "画像",
    "Image Links": "画像リンク",
    "Image sources that will be fixed": "修正される画像ソース",
    "Images": "画像",
    "Import rules": "ルールをインポート",
    "Import rules from CSV": "CSVからルールをインポートする",
    "Important Highlights": "重要なハイライト",
    "Important Notifications": "重要なお知らせ",
    "Important notification:": "重要なお知らせ:",
    "In compliance": "順守している",
    "In progress of ignoring/reviewing all": "すべてを無視/レビュー中",
    "Inactive": "非アクティブ",
    "Incidents": "インシデント",
    "Includes both documents and pages": "ドキュメントとページの両方を含む",
    "Incoming Links": "インバウンドリンク",
    "Incoming links": "インバウンドリンク",
    "Indicates the difficulty to fix an audit error": "監査エラーを修正する難しさを示します",
    "Indicates when some parts of the domain are not scanned due to Constraints / Exclusions being applied": "制約/除外が適用されているためにドメインの一部がスキャンされていないことを示します",
    "Individual issues": "個別の問題",
    "Information": "情報",
    "Information about this Check is not yet available": "このチェックに関する情報はまだ入手できません",
    "Information and the operation of user interface must be understandable.": "情報とユーザー インターフェイスの操作はわかりやすくなければなりません。",
    "Information and user interface components must be presentable to users in ways they can perceive.": "情報とユーザー インターフェイス コンポーネントは、ユーザーが認識できる方法で提示できる必要があります。",
    "Inline Images": "インライン画像",
    "Inline images": "インライン画像",
    "Input selector*": "Inputセレクタ*",
    "Input user data": "ユーザーデータを入力する",
    "Internal": "内部",
    "Internal Export": "内部エクスポート",
    "Internal PDF Compliance": "内部PDFコンプライアンス",
    "Internal PDFs": "内部PDF",
    "Internal URLs": "内部URL",
    "Inventory": "インベントリ",
    "Inventory Documents Export": "インベントリ文書のエクスポート",
    "Inventory History": "インベントリ履歴",
    "Invite to new project": "新しいプロジェクトに招待",
    "Is not a valid url": "有効なURLではありません",
    "Is not crawling automatically": "自動的にクロールされません",
    "Is not tagged": "タグ付けされていません",
    "Issue": "問題",
    "Issue changes": "問題の変更",
    "Issue changes since previous crawl": "前回のクロール以降の問題の変更",
    "Issue name": "問題名",
    "Issue type": "問題の種類",
    "Issues": "問題",
    "Issues by Severities": "重大度別の問題",
    "Issues changes since previous crawl": "前回のクロール以降の問題の変更",
    "JS": "JS",
    "JavaScript": "JavaScript",
    "Javascript": "Javascript",
    "Javascript crawl": "Javascript クロール",
    "KB": "KB",
    "Keyword": "キーワード",
    "Knowledge Base": {
      "$$noContext": "ナレッジベース",
      "Topmenu": "ナレッジベース"
    },
    "LIX": "LIX",
    "Label": "ラベル",
    "Label created": "ラベルを作成しました",
    "Label name": "ラベル名",
    "Label overlay": "ラベルオーバーレイ",
    "Label preview": "ラベルプレビュー",
    "Label updated": "ラベルが更新されました",
    "Labels": "ラベル",
    "Language": "言語",
    "Language Detected": "言語が検出されました",
    "Languages": "言語",
    "Languages found": "見つかった言語",
    "Last Scan": "最終スキャン",
    "Last check: [[lastCheckTime]]": "最終チェック: [[lastCheckTime]]",
    "Last check: [[performanceScannedAt]]": "最終チェック: [[performanceScannedAt]]",
    "Last downtime:": "最終ダウンタイム:",
    "Last load time": "最終読み込み時間",
    "Last name": "苗字",
    "Last run": "最終実行",
    "Last run [[date]]": "最終実行 [[date]]",
    "Last run:": "最終実行:",
    "Last scan": "最終スキャン",
    "Last scan never": "未スキャン",
    "Last scan: [[duration]] ago": "最終スキャン: [[duration]] 前",
    "Latest Updated PageCorrects": "最新のPageCorrect修正",
    "Latest login": "最新のログイン",
    "Least Popular Pages": "最も人気のないページ",
    "Less than 10": "10未満",
    "Less than 100": "100未満",
    "Less than 2 seconds": "2秒未満",
    "Less than 50": "50未満",
    "Level": "レベル",
    "Level A": "レベルA",
    "Level A Issues": "レベル A の問題",
    "Level A accessibility checks": "レベルAアクセシビリティチェック",
    "Level A compliance": "レベルA準拠",
    "Level A failing checks": "レベルA不合格チェック",
    "Level AA": "レベルAA",
    "Level AA Issues": "レベルAAの問題",
    "Level AA accessibility checks": "レベルAAアクセシビリティチェック",
    "Level AA compliance": "レベルAA準拠",
    "Level AA failing checks": "レベルAA不合格チェック",
    "Level AAA": "レベルAAA",
    "Level AAA Issues": "レベル AAAの問題",
    "Level AAA accessibility checks": "レベルAAAのアクセシビリティチェック",
    "Level AAA compliance": "レベルAAA準拠",
    "Level AAA failing checks": "レベルAAA不合格チェック",
    "Level [[level]]": "レベル [[level]]",
    "Levels": "レベル",
    "Likelihood": "可能性",
    "Likelihood unspecified": "可能性は不明",
    "Link": "リンク",
    "Link Type": "リンクタイプ",
    "Link excludes": "除外するリンク",
    "Link fixes": "修正するリンク",
    "Link is broken": "リンクが切れています",
    "Link of page": "ページのリンク",
    "Link to image": "画像へのリンク",
    "Linkedin": "Linkedin",
    "Links": "リンク",
    "Links To Documents Export": "ドキュメントのエクスポートへのリンク",
    "Links from other account domains": "他のアカウントドメインからのリンク",
    "Links from own domain": "独自ドメインからのリンク",
    "Links with policy matches": "ポリシーに一致するリンク",
    "Links with the rel=\\\"nofollow\\\" attribute will not pass link equity/SEO value to the linked page. This can be used for pages with user generated comments where you want to avoid that a competitor posts a comment with a link to their own website thus benefiting from your original content. This is not an \\\"error\\\" per se but make sure that the link does not have this attribute as a result of an error.": "rel=\\\"nofollow\\\" 属性を持つリンクは、リンク先のページにリンク エクイティ/SEO 値を渡しません。これは、ユーザーが作成したコメントがあるページで、競合他社が自分の Web サイトへのリンクを含むコメントを投稿して、元のコンテンツから利益を得ることを回避したい場合に使用できます。これはそれ自体が \\\"error\\\"  ではありませんが、エラーの結果としてリンクにこの属性が付いていないことを確認してください。",
    "List": "リスト",
    "List of accessibility issues": "アクセシビリティの問題のリスト",
    "List of all labels": "すべてのラベルのリスト",
    "List of checks with and without issues": "問題のあるチェックと問題のないチェックのリスト",
    "List of content containing links": "リンクを含むコンテンツのリスト",
    "List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)": "ウェブサイト上のすべてのアセットの所在のリスト（ドキュメント、リンク、メールアドレス、コードスニペットなど）",
    "List view": "リストビュー",
    "Lists all profiles available for your account": "アカウントで利用可能なすべてのプロファイルを一覧表示します",
    "Load Times Trend": "読み込み時間の傾向",
    "Loading domains, please wait": "ドメインを読み込んでいます。お待ちください",
    "Loading new domain": "新しいドメインを読み込んでいます",
    "Loading times": "読み込み時間",
    "Locale": "ロケール",
    "Location": "位置",
    "Location not found": "位置が見つかりません",
    "Locations": "位置",
    "Log out": "ログアウト",
    "Login Type": "ログインタイプ",
    "Long": "長さ",
    "Lookup in Google": "Googleで検索",
    "Low": "低い",
    "Low impact": "少規模の影響",
    "Low impact opportunities": "小規模の影響の機会",
    "Low priority": "優先度が低い",
    "Low severity": "重大度が低い",
    "Low severity issues": "重大度の低い問題",
    "MB": "MB",
    "META content": "META content",
    "META name/property": "META name/property",
    "Main-Thread Blocking Time": "メインスレッドのブロッキング時間",
    "Mark 403 as broken link": "403 をリンク切れとしてマークする",
    "Mark all as reviewed/ignored": "すべてを確認済み/無視済みとしてマークする",
    "Mark as fixed": "修正済みとしてマーク",
    "Mark as ignored": "無視としてマーク",
    "Mark as not fixed": "未修正としてマーク",
    "Marked as fixed": "修正済みとしてマーク",
    "Marked as reviewed": "レビュー済みとしてマーク",
    "Marking broken link as fixed": "リンク切れを修正済みとしてマークする",
    "Match": "一致",
    "Match rule": "一致ルール",
    "Matches": "一致",
    "Max": "最大",
    "Max scanned pages": "スキャンした最大ページ数",
    "Measure from": "測定開始",
    "Measure from:": "測定開始:",
    "Measurement Settings": "測定設定",
    "Measurements since [[date]]": "[[date]] 以降の測定",
    "Medium": "中度",
    "Medium complexity of text. Example: newspapers and magazines": "テキストの複雑さは中度。例: 新聞や雑誌",
    "Medium impact": "中程度の影響",
    "Medium impact opportunities": "中程度のインパクトの機会",
    "Medium priority": "中程度の優先度",
    "Medium severity": "中程度の重症度",
    "Medium severity issues": "中程度の重大度の問題",
    "Meta Header Expr": "Meta Header 制限",
    "Meta Name": "Meta Name",
    "Metadata": "メタデータ",
    "Metadata key": "メタデータキー",
    "Milliseconds": "ミリ秒",
    "Minimum words": "最小文字数",
    "Minutes": "分",
    "Minutes of slow response before you get an email": "メールが届くまで数分かかります",
    "Mispelling": "スペルミス",
    "Misspelling": "スペルミス",
    "Misspelling affecting the most content": "ほとんどのコンテンツに影響する誤字",
    "Misspellings": "スペルミス",
    "Misspellings history": "スペルミスの履歴",
    "Mobile": "モバイル",
    "Moderate": "適度",
    "Module": "モジュール",
    "Monday": "月曜日",
    "Monitoring": "監視",
    "Monthly": "月次",
    "Months": "月",
    "More info": "より詳しい情報",
    "More than": "少なくとも",
    "More than [[count]]": "[[count]]以上",
    "Most Downloads": "最もダウンロードされたファイル",
    "Most Frequent": "最も頻繁",
    "Most Popular Pages": "最も人気のあるページ",
    "Most common SEO checkpoint needing review": "確認が必要な最も一般的な SEO チェックポイント",
    "Most common language": "最も一般的な言語",
    "Most common misspellings": "最も一般的なスペルミス",
    "Most common opportunities found": "最もよく見られる機会",
    "Most common policy violation on this domain": "このドメインで最も一般的なポリシー違反",
    "Most common potential misspellings": "最も一般的なスペルミス",
    "Most common readability level": "最も一般的な読みやすさレベル",
    "Most of your pages have the readability level": "ほとんどのページの読みやすさレベルは",
    "Most pages have this readability level": "ほとんどのページはこの読みやすさレベルです",
    "Most prominent issues ranked by severity level": "最も顕著な問題を重大度順にランク付け",
    "Most serious issues found": "最も深刻な問題が見つかりました",
    "Most visited pages": "最も訪問されたページ",
    "Move focus down on domain picker": "ドメインピッカーでフォーカスを下に移動",
    "Move focus up on domain picker": "ドメインピッカーでフォーカスを上に移動",
    "Multiline": "複数行",
    "My Exports": "マイエクスポート",
    "My profile": "マイプロフィール",
    "N/A": "該当なし",
    "NA": "該当なし",
    "NB! Connection Settings cannot be edited after save": "注意！接続設定は保存後に編集することはできません",
    "NOTE: If you want to copy the Legacy Script. Click {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}here{{anchorEnd}}.": "注意: レガシー スクリプトをコピーする場合は、{{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}ここ{{anchorEnd}}をクリックしてください。",
    "Name": {
      "$$noContext": "名前",
      "Exchange Center Sort by option": "名前"
    },
    "Network not found": "ネットワークが見つかりません",
    "Network speed": "ネットワーク速度",
    "Network speed:": "ネットワーク速度:",
    "Never": "一度もない",
    "Never scanned": "一度もスキャンされていない",
    "New": "New",
    "New Performance Page": "新しいパフォーマンスページ",
    "New Policy": "新しいポリシー",
    "New password": "新しいパスワード",
    "Next": "次",
    "No Broken Links marked as Fixed": "壊れたリンクは修正済みとしてマークされていません",
    "No CSS": "CSSなし",
    "No Content links": "コンテンツリンクなし",
    "No Data available for selected time frame": "選択した期間のデータはありません",
    "No Documents found": "文書が見つかりません",
    "No Domains or Groups are yet selected for this report": "このレポートにはまだドメインまたはグループが選択されていません",
    "No Frames": "フレームなし",
    "No Frequency": "頻度なし",
    "No HTML Pages found": "HTML ページが見つかりません",
    "No Historic data available for Accessibility Level [[lvl]]": "アクセシビリティ レベル [[lvl]] の履歴データはありません",
    "No IFrames": "iframeなし",
    "No Ignored Broken Links": "無視されたリンク切れはありません",
    "No Image Links found": "画像リンクが見つかりません",
    "No PDF's failed": "不合格のPDFはありません",
    "No PDF's pending": "保留中のPDFはありません",
    "No PDF's queued": "PDFがキューにありません",
    "No PDF's reviewed": "PDFはレビューされていません",
    "No PDFs are reviewed": "PDFはレビューされません",
    "No Policies detected": "ポリシーが検出されませんでした",
    "No Profiles were found": "プロフィールが見つかりませんでした",
    "No Spreadsheet links found": "スプレッドシートのリンクが見つかりません",
    "No Users are yet selected to receive this report": "このレポートを受信するユーザーはまだ選択されていません",
    "No Word links found": "単語リンクが見つかりません",
    "No changes": "変更なし",
    "No changes found": "変更は見つかりませんでした",
    "No checks found for this Accessibility category": "このアクセシビリティ カテゴリのチェックは見つかりませんでした",
    "No content policies have been created yet": "コンテンツポリシーはまだ作成されていません",
    "No corrections added to PageCorrect": "PageCorrect に修正は追加されていません",
    "No data available": "データなし",
    "No data present": "データなし",
    "No diagnostics issues were found": "診断上の問題は見つかりませんでした",
    "No domains were found": "ドメインが見つかりませんでした",
    "No downloads found": "ダウンロードが見つかりません",
    "No errors found": "エラーは見つかりませんでした",
    "No exemptions added to this checkpoint": "このチェックポイントには除外項目は追加されていません",
    "No exports available": "エクスポートできるものがありません",
    "No groups were found for this domain": "このドメインのグループは見つかりませんでした",
    "No historic data available for this domain": "このドメインの履歴データはありません",
    "No hits found": "ヒットが見つかりませんでした",
    "No ignored checks in this accessibility category": "このアクセシビリティ カテゴリでは無視されたチェックはありません",
    "No ignored misspellings found for this page": "このページには無視されたスペルミスは見つかりませんでした",
    "No incidents occurred in the selected time frame": "選択した期間内にインシデントは発生しませんでした",
    "No issues found": "問題は見つかりませんでした",
    "No javascript": "javascriptなし",
    "No name defined": "名前が定義されていません",
    "No new notifications": "新しい通知はありません",
    "No note has been added": "メモは追加されていません",
    "No notifications available": "通知はありません",
    "No opportunities were found": "機会が見つかりませんでした",
    "No outages in this period": "この期間に停止は発生していません",
    "No pages found": "ページが見つかりません",
    "No pages were found": "ページが見つかりませんでした",
    "No passed checks in this accessibility category": "このアクセシビリティ カテゴリでチェックに合格したものはありません",
    "No performance scan found": "パフォーマンススキャンが見つかりません",
    "No performance scans were found": "パフォーマンススキャンは見つかりませんでした",
    "No policies found": "ポリシーが見つかりません",
    "No readability score": "読みやすさスコアなし",
    "No response received": "応答がありません",
    "No run present": "実行中のものはありません",
    "No scan has yet been performed. Please check back later.": "まだスキャンは実行されていません。後でもう一度確認してください。",
    "No slide links found": "スライドリンクが見つかりません",
    "No title found": "タイトルが見つかりません",
    "No title found on one or more pages": "1 つ以上のページにタイトルが見つかりません",
    "No title is found on this page": "このページにタイトルが見つかりません",
    "No users available for this domain": "このドメインにはユーザーがいません",
    "No violations were found": "違反は見つかりませんでした",
    "No visitor profile selected": "訪問者プロフィールが選択されていません",
    "No visits for this category in selected time frame": "選択した期間内にこのカテゴリの訪問はありませんでした",
    "No words have been added to the default dictionary": "デフォルトの辞書に単語が追加されていません",
    "No. Visits": "訪問回数",
    "Non-user list": "非ユーザーリスト",
    "None": "なし",
    "Normal - recommended": "通常 - 推奨",
    "Normal violations": "通常の違反",
    "Not case sensitive": "大文字と小文字を区別しません",
    "Not containing": "含まない",
    "Not scheduled": "予定なし",
    "Not valid email": "有効なメールアドレスではありません",
    "Note": "注記",
    "Notes": "ノート",
    "Notifications": "通知",
    "Number of characters in Meta Header text": "メタヘッダーテキストの文字数",
    "Number of characters in header text": "ヘッダーテキストの文字数",
    "Number of characters in image text": "画像テキストの文字数",
    "Number of characters in link text": "リンクテキストの文字数",
    "Number of characters in page title": "ページタイトルの文字数",
    "Number of pages": "ページ数",
    "Number too high": "数値が高すぎます",
    "Number too low": "数が少なすぎます",
    "OK": "OK",
    "Office 365 (BETA)": "Office 365 (ベータ版)",
    "Ok": "OK",
    "Once a day": "一日一回",
    "Once a week": "週に一度",
    "One or more documents have already been scanned for compliance. Are you sure you want to scan the selected documents again?": "1 つ以上のドキュメントがコンプライアンスのためにすでにスキャンされています。選択したドキュメントを再度スキャンしてもよろしいですか?",
    "One or more page on your website has the same H1 text.": "ウェブサイト上の 1 つ以上のページに同じ H1 テキストがあります。",
    "One or more pages has been marked as no index": "1 つ以上のページがインデックスなしとしてマークされています",
    "One or more pages on your website has this title": "ウェブサイトの 1 つ以上のページにこのタイトルが付いています",
    "Open": "開く",
    "Open Accessibility Decision Tree": "オープンアクセシビリティ決定ツリー",
    "Open Data Privacy": "オープンデータプライバシー",
    "Open Data Privacy Settings": "データのプライバシー設定を開く",
    "Open Document Details": "ドキュメントの詳細を開く",
    "Open Document details": {
      "$$noContext": "ドキュメントの詳細を開く",
      "Aria label when clicking on open Document details": "ドキュメントの詳細を開く"
    },
    "Open Fast Track for this HTML snippet": "この HTML スニペットのファウトトラックを開く",
    "Open New Help Center": "新しいヘルプセンターを開く",
    "Open Page Details": "ページの詳細を開く",
    "Open Schedule downtime": "スケジュールのダウンタイムを開く",
    "Open document details": "ドキュメントの詳細を開く",
    "Open domain policy": "オープンドメインポリシー",
    "Open example": "例を開く",
    "Open filters": "フィルターを開く",
    "Open group": "グループを開く",
    "Open help center": "ヘルプセンターを開く",
    "Open keyboard shortcuts": "キーボードショートカットを開く",
    "Open page details": {
      "$$noContext": "ページの詳細を開く",
      "Aria label when clicking on open pagedetails": "ページの詳細を開く"
    },
    "Open received reports": "受信したレポートを開く",
    "Open report": "レポートを開く",
    "Operating System": "オペレーティング·システム",
    "Operating Systems": "オペレーティングシステム",
    "Operating systems": "オペレーティングシステム",
    "Operating systems Overview": "オペレーティングシステムの概要",
    "Operator*": "オペレーター*",
    "Opportunities": "機会",
    "Opportunities by Priority": "優先度別の機会",
    "Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.": "オプションで、ドメインの主要言語を選択できます。英語 (英国) を選択した場合、英語として検出されたテキストはすべて英国英語とみなされます。",
    "Options": "オプション",
    "Or": "または",
    "Organizations": "組織",
    "Original Data": "元データ",
    "Other Documents": "その他の文書",
    "Other files": "その他のファイル",
    "Others": "その他",
    "Our suggestion": "私たちの提案",
    "Our team has been notified of your request. We will soon be in touch.": "弊社のチームにお客様のリクエストが通知されました。すぐにご連絡いたします。",
    "Outages during the selected time-frame": "選択した期間中の停止",
    "Outages end": "停止終了",
    "Outages start": "停止開始",
    "Outgoing Links": "外部リンク",
    "Outgoing links": "外部リンク",
    "Over 1000 ms.": "1000ミリ秒以上",
    "Over 10000 ms.": "10000ミリ秒以上",
    "Over 200 ms.": "200ミリ秒以上",
    "Over 2000 ms.": "2000ミリ秒以上",
    "Over 3000 ms.": "3000ミリ秒以上",
    "Over 4000 ms.": "4000ミリ秒以上",
    "Over 500 ms.": "500ミリ秒以上",
    "Over 5000 ms.": "5000ミリ秒以上",
    "Over 6000 ms.": "6000ミリ秒以上",
    "Over 7000 ms.": "7000ミリ秒以上",
    "Over 8000 ms.": "8000ミリ秒以上",
    "Over 9000 ms.": "9000ミリ秒以上",
    "Overall Data Privacy compliance for this page": "このページの全体的なデータプライバシーコンプライアンス",
    "Overall PageCorrects": "全体的なPageCorrect",
    "Overall SEO compliance for this page": "このページの全体的な SEO コンプライアンス",
    "Overall accessibility compliance for this level": "このレベルの全体的なアクセシビリティ準拠",
    "Overall accessibility compliance level for this page": "このページの全体的なアクセシビリティ準拠レベル",
    "Overall compliance": "全体的なコンプライアンス",
    "Overall policy compliance for this page": "このページの全体的なポリシー準拠",
    "Owner": "所有者",
    "PAGE PERFORMANCE OVERVIEW": "ページパフォーマンスの概要",
    "PDF": "PDF",
    "PDF Compliance Status": "PDF コンプライアンス ステータス",
    "PDF Documents": "PDFドキュメント",
    "PDF accessibility scan completed at [[date]]": "PDF アクセシビリティ スキャンが [[date]] に完了しました",
    "PDF accessibility scan requested": "PDF アクセシビリティ スキャンを要求しました",
    "PDF files": "PDFファイル",
    "PDF files pending": "PDFファイルが保留中",
    "PDF files reviewed": "PDFファイルのレビュー",
    "PDF files that are reviewed or pending for accessibility": "アクセシビリティの確認が済んでいるか保留中の PDF ファイル",
    "PDFs": "PDFファイル",
    "POLICIES OVERVIEW": "ポリシーの概要",
    "Page": "ページ",
    "Page Dashboard": "ページダッシュボード",
    "Page Details": "ページの詳細",
    "Page Performance": "ページパフォーマンス",
    "Page Statistics": "ページ統計",
    "Page URL": "ページURL",
    "Page Views": "ページビュー",
    "Page compliance": "ページコンプライアンス",
    "Page count in PDF": "PDFのページ数",
    "Page dashboard": "ページダッシュボード",
    "Page details": "ページの詳細",
    "Page first detected": "最初に検出されたページ",
    "Page links": "ページリンク",
    "PageAssist Logo Position": "PageAssist ロゴの位置",
    "PageAssist Theme": "PageAssist テーマ",
    "PageCorrect": "PageCorrect",
    "PageCorrect Content": "PageCorrectコンテンツ",
    "PageCorrect Custom Phrase or Word": "PageCorrect カスタムフレーズまたは単語",
    "PageCorrect Details": "PageCorrectの詳細",
    "PageCorrect Diagnostics": "PageCorrect診断",
    "PageCorrects categorized": "PageCorrects 分類",
    "PageFixes": "ページ修正",
    "PageFixes Left": "残りのページ修正",
    "Pages": "ページ",
    "Pages & documents with confirmed misspellings, broken links or images": "誤字、リンク切れ、壊れた画像が確認されたページと文書",
    "Pages Crawled": "クロールされたページ",
    "Pages With Opportunities": "機会のあるページ",
    "Pages and documents with policies marked as unwanted or required": "不要または必須としてマークされたポリシーを含むページとドキュメント",
    "Pages crawled": "クロールされたページ",
    "Pages failing check": "チェックに失敗したページ",
    "Pages in compliance": "準拠しているページ",
    "Pages related to policy link": "ポリシーリンクに関連するページ",
    "Pages that are difficult to read": "読みにくいページ",
    "Pages that are easily understood by children below 5'th grade": "小学5年生以下の子どもでも理解しやすいページ",
    "Pages that are easy to read. Conversational English for consumers": "読みやすいページ。消費者向けの会話的言語",
    "Pages that are fairly difficult to read": "かなり読みにくいページ",
    "Pages that are fairly easy to read": "かなり読みやすいページ",
    "Pages that are in plain English. Easily understood by 13- to 15-year-old students": "平易な言語で書かれたページ。中学1年〜3年生が簡単に理解できる",
    "Pages that are very difficult to read. Best understood by university graduates": "非常に読みにくいページ。大学卒業生に最もよく理解される",
    "Pages that are very easy to read. Easily understood by an average 11-year-old student": "とても読みやすいページです。平均的な11歳の生徒でも簡単に理解できます。",
    "Pages we could not determine Readability score": "読みやすさスコアを判定できなかったページ",
    "Pages with Data Privacy issues": "データプライバシーの問題があるページ",
    "Pages with Failing Checks": "チェックに失敗したページ",
    "Pages with Ignored Checks": "チェックが無視されたページ",
    "Pages with Misspellings": "誤字のあるページ",
    "Pages with Opportunities": "機会のあるページ",
    "Pages with Policy Issues": "ポリシーに関する問題のあるページ",
    "Pages with QA Issues": "QA の問題があるページ",
    "Pages with QA issues": "QA の問題があるページ",
    "Pages with SEO Opportunities": "SEOの機会があるページ",
    "Pages with SEO opportunities": "SEO の機会があるページ",
    "Pages with accessibility checks not in compliance": "アクセシビリティチェックに準拠していないページ",
    "Pages with failing checks": "チェックに失敗したページ",
    "Pages with high, medium or low opportunities": "機会が高い、中程度、または低いページ",
    "Pages with ignored checks": "チェックが無視されたページ",
    "Pages with issues": "問題のあるページ",
    "Pages with policy matches": "ポリシーに一致するページ",
    "Pages with score:": "スコアのあるページ:",
    "Pages with the \\\"noindex\\\" META tag will not be indexed by the search engines. This is not an \\\"error\\\" per se, but make sure that the page does not have this tag as a result of an error.": "\\\"noindex\\\" META タグが付いたページは、検索エンジンによってインデックスされません。これは厳密には \\\"エラー\\\" ではありませんが、エラーの結果としてページにこのタグが付いていないことを確認してください。",
    "Pages without H1 tags or with empty H1 tags that contain no value represent a failed SEO optimization opportunity.": "H1 タグのないページ、または値を含まない空の H1 タグがあるページは、SEO 最適化の機会が失敗したことを表します。",
    "Pages without Visits": "訪問のないページ",
    "Pages without Visits in last 6 months": "過去 6 か月間に訪問がなかったページ",
    "Pageviews": "ページビュー",
    "Part of downtime calculation": "ダウンタイム計算の一部",
    "Part of heatmap Rules": "ヒートマップルールの一部",
    "Part of success criteria [[checkIssueNumber]]": "成功基準の一部 [[checkIssueNumber]]",
    "Pass Example": "合格例",
    "Passed": "合格した",
    "Passed ([[audits]])": "([[audits]])に合格",
    "Passed Checks": "合格したチェック",
    "Passed Policy checks": "ポリシーチェックに合格",
    "Passed checks": "チェックに合格",
    "Passed policy checks": "ポリシーチェックに合格",
    "Password": "パスワード",
    "Password Confirmation": "パスワードの確認",
    "Password confirmation": "パスワードの確認",
    "Password to login": "ログインパスワード",
    "Passwords does not match": "パスワードが一致しません",
    "Path constraints": "パス制約",
    "Path template": "パステンプレート",
    "Pending": "保留中",
    "Pending PDF review": "PDFレビュー保留中",
    "Pending PDF reviews": "PDFレビュー保留中",
    "Percentage shows number of pages that are compliant with all Data Privacy checks": "パーセンテージは、すべてのデータプライバシーチェックに準拠しているページの数を示します。",
    "Percentage shows number of pages that are compliant with all SEO checks": "パーセンテージは、すべての SEO チェックに準拠しているページの数を示します。",
    "Performance": "パフォーマンス",
    "Performance Errors": "パフォーマンスエラー",
    "Performance Pages": "パフォーマンスページ",
    "Performance Profiles": "パフォーマンスプロファイル",
    "Performance Score": "パフォーマンススコア",
    "Performance score": "パフォーマンススコア",
    "Personal": "個人的",
    "Personal information": "個人情報",
    "Phone": "電話",
    "Pie": "パイ",
    "Pin domain": "ドメインをピンする",
    "Ping intervals": "Ping間隔",
    "Play": "Play",
    "Play misspelling": "誤字を順に表示する",
    "Please choose a trademark": "商標を選択してください",
    "Please insert correct URL:": "正しいURLを入力してください:",
    "Please insert the correct word:": "正しい単語を入力してください:",
    "Please insert the missing ALT text:": "不足している ALT テキストを挿入してください:",
    "Please select a module": "モジュールを選択してください",
    "Please select the module that you want to create a Source Code Exclude for": "ソースコード除外部分を作成するモジュールを選択してください",
    "Please specify word or phrase to search for": "検索する単語またはフレーズを指定してください",
    "Please use CSS selectors to identify form fields and buttons": "フォームフィールドとボタンを識別するには、CSSセレクタを使用してください。",
    "Please wait": "お待ちください",
    "Please wait - Adding word to dictionary": "お待ちください - 辞書に単語を追加しています",
    "Please wait - Adding words to dictionary": "お待ちください - 辞書に単語を追加しています",
    "Please wait - Confirming misspelling": "しばらくお待ちください - スペルミスを確認しています",
    "Please wait - exporting audit log &nbsp;": "お待ちください - 監査ログをエクスポートしています &nbsp;",
    "Policies": "ポリシー",
    "Policies - required": "ポリシー - 必須",
    "Policies - violations": "ポリシー - 違反",
    "Policies marked as required or unwanted": "必須または不要としてマークされたポリシー",
    "Policies violations": "ポリシー違反",
    "Policies with most matches": "最も一致するポリシー",
    "Policies with violations": "違反のあるポリシー",
    "Policy": "ポリシー",
    "Policy Diagnostics": "ポリシー診断",
    "Policy Distribution": "ポリシー分布",
    "Policy Hits": "ポリシーヒット",
    "Policy Issues": "ポリシーの問題",
    "Policy List": "ポリシーリスト",
    "Policy Pages": "ポリシーページ",
    "Policy Running": "ポリシー実行中",
    "Policy errors": "ポリシーエラー",
    "Policy hits per domain": "ドメインあたりのポリシーヒット数",
    "Policy in queue": "キュー内のポリシー",
    "Policy info": "ポリシー情報",
    "Policy note": "ポリシーノート",
    "Policy rules": "ポリシールール",
    "Policy scan in progress": "ポリシースキャンが進行中",
    "Policy setup": "ポリシーの設定",
    "Policy violations": "ポリシー違反",
    "Policy with matching terms": "一致する用語を含むポリシー",
    "Potential Misspelling": "誤字の可能性",
    "Potential Misspellings": "誤字の可能性",
    "Potential Savings": "潜在的な節約",
    "Potential misspelling": "誤字の可能性あり",
    "Potential misspellings": "誤字の可能性",
    "Potential misspellings found": "誤字の可能性あり",
    "Powered by Google Lighthouse": "Google Lighthouse を搭載",
    "Prefix path": "プレフィックスパス",
    "Presence": "プレゼンス",
    "Previous": "前",
    "Principle 1: Perceivable": "原則1: 知覚可能",
    "Principle 2: Operable": "原則2: 操作可能",
    "Principle 3: Understandable": "原則3: 理解可能",
    "Principle 4: Robust": "原則4: 堅牢",
    "Principle 5: Conformance": "原則5: 適合",
    "Print view": "印刷表示",
    "Priorities": "優先事項",
    "Prioritized Content": "優先コンテンツ",
    "Priority": "優先度",
    "Profile": "プロフィール",
    "Profile Description": "プロフィールの説明",
    "Profile Dropdown": "プロフィールドロップダウン",
    "Profile Menu": "プロフィールメニュー",
    "Profile Name": "プロファイル名",
    "Profile details": "プロフィール詳細",
    "Profile updated": "プロフィール更新",
    "QA": "品質保証",
    "QA Issues": "QAの問題",
    "QA errors": "QAエラー",
    "QUALITY ASSURANCE": "品質保証",
    "QUALITY ASSURANCE OVERVIEW": "品質保証の概要",
    "Quality Assurance": "品質保証",
    "Quality Assurance Check": "品質保証チェック",
    "Quality Assurance Diagnostics": "品質保証診断",
    "Quality Assurance Export summary": "品質保証エクスポート概要",
    "Quality Assurance errors": "品質保証エラー",
    "Quality assurance": "品質保証",
    "Queued": "キューに登録",
    "Quick Guide": "クイックガイド",
    "Quick help": "クイックヘルプ",
    "Quick info:": "クイック情報:",
    "Re-scanning of issues for this page has started and will be finished in a few minutes.": "このページの問題の再スキャンが開始され、数分以内に完了します。",
    "Readability": "読みやすさ",
    "Readability Score": "読みやすさスコア",
    "Readability by score": "スコアによる読みやすさ",
    "Readability levels": "読みやすさのレベル",
    "Readability score": "読みやすさスコア",
    "Readability scores across all web pages (based on": "すべてのウェブページの読みやすさスコア（",
    "Readability test": "読みやすさテスト",
    "Receive report": "レポートを受け取る",
    "Received reports": "受け取ったレポート",
    "Referring Information": "参照情報",
    "Referring visits": "リファラル訪問",
    "Regex": "正規表現",
    "Regulation": "規制",
    "Remember me": "ログイン情報を保存する",
    "Remove": "削除",
    "Remove Custom Multistep Javascript": "カスタムマルチステップJavascriptを削除する",
    "Remove Extension Name": "拡張機能名を削除する",
    "Remove Page": "ページを削除する",
    "Remove Profile": "プロファイルを削除する",
    "Remove Rule": "ルールを削除する",
    "Remove checkpoint": "チェックポイントを削除",
    "Remove domain": "ドメインを削除する",
    "Remove domain group": "ドメイングループを削除する",
    "Remove from dictionary": "辞書から削除する",
    "Remove group": "グループを削除する",
    "Remove rule": "ルールを削除する",
    "Remove this IP address?": "この IP アドレスを削除しますか?",
    "Remove this pattern?": "このパターンを削除しますか?",
    "Remove this word from dictionary": "この単語を辞書から削除する",
    "Render pages and execute JS while crawling": "クロール中にページをレンダリングし、JSを実行する",
    "Repeat": "繰り返す",
    "Replace Rule": "ルールを置き換える",
    "Report": "レポート",
    "Report administration": "レポート管理",
    "Report overview:": "レポートの概要:",
    "Request PDF scan for all documents": "すべての文書のPDFスキャンをリクエストする",
    "Requests": "リクエスト",
    "Required": "必須",
    "Required content": "必須コンテンツ",
    "Required count": "必要な数",
    "Rescan": "再スキャン",
    "Rescanning": "再スキャン中",
    "Reset": "リセット",
    "Reset Preferences": "設定をリセット",
    "Resolution": "解決",
    "Resource Type": "リソースタイプ",
    "Response Time": "レスポンスタイム",
    "Response code": "応答コード",
    "Response time": "レスポンスタイム",
    "Response time (Milliseconds)": "応答時間（ミリ秒）",
    "Response time notification": "応答時間通知",
    "Response time notification threshold": "レスポンスタイム通知しきい値",
    "Return to heartbeat overview": "Heartbeatの概要に戻る",
    "Returning customer": "再訪問顧客",
    "Reverting state": "状態を元に戻しています",
    "Review": "レビュー",
    "Reviewed": "レビュー済",
    "Reviewed/Ok": "レビュー済/OK",
    "Revoke token": "トークンを取り消す",
    "Robot Info": "Robot情報",
    "Role": "役割",
    "Rule": "ルール",
    "Rule name": "ルール名",
    "Rule operator": "ルール演算子",
    "Rule to match": "一致するルール",
    "Rules": "ルール",
    "Run Policy": "ポリシーを実行する",
    "Run policy": "ポリシーを実行する",
    "Run policy again": "ポリシーを再度実行する",
    "Running": "実行中",
    "SEO": "SEO",
    "SEO (Search Engine Optimization)": "SEO（検索エンジン最適化）",
    "SEO Checkpoints": "SEO チェックポイント",
    "SEO Diagnostics": "SEO診断",
    "SEO Issues": "SEOの問題",
    "SEO OVERVIEW": "SEOの概要",
    "SEO Opportunities": "SEOの機会",
    "SEO errors": "SEOエラー",
    "SEO impact": "SEOへの影響",
    "SEO opportunities": "SEOの機会",
    "SEO opportunities - high priority": "SEO の機会 - 優先度が高い",
    "SEO opportunities - low priority": "SEO の機会 - 優先度が低い",
    "SEO opportunities - medium priority": "SEO の機会 - 中程度の優先度",
    "SEO opportunities - technical SEO issues": "SEO の機会 - 技術的な SEO の問題",
    "SEO opportunities found": "SEOの機会が見つかりました",
    "SHOW LIST VIEW": "リストビューを表示",
    "STATISTICS OVERVIEW": "統計概要",
    "Saturday": "土曜日",
    "Save": "保存",
    "Save Preferences": "設定を保存",
    "Save and close": "保存して閉じる",
    "Save policy": "ポリシーを保存",
    "Scan": "スキャン",
    "Scan documents": "ドキュメントをスキャンする",
    "Scan frequency": "スキャン頻度",
    "Scan frequency:": "スキャン頻度:",
    "Scan in progress": "スキャン中",
    "Scan in progress:": "スキャン中:",
    "Scan is done": "スキャンが完了しました",
    "Scan subdomains": "サブドメインをスキャンする",
    "Scanned at": "スキャン日時",
    "Scanned content": "スキャンされたコンテンツ",
    "Scanned links:": "スキャンされたリンク:",
    "Scanned pages": "スキャンされたページ",
    "Scanned pages:": "スキャンされたページ:",
    "Scanning URL:": "スキャン中のURL:",
    "Scanning in progress": "スキャン中",
    "Schedule Report": "スケジュールレポート",
    "Schedule supplemental reports to be delivered with each scan": "スキャンごとに補足レポートを配信するスケジュールを設定します",
    "Scheduled": "スケジュール済",
    "Scheduled Reports": "スケジュールされたレポート",
    "Scopes": "スコープ",
    "Score": "スコア",
    "Screen Resolutions": "画面解像度",
    "Screen Resolutions Overview": "画面解像度の概要",
    "Script Evaluation": "スクリプト評価",
    "Script Parse": "スクリプト解析",
    "Script installed": "スクリプトがインストールされました",
    "Script installed on Domain": "ドメインにスクリプトがインストールされました",
    "Script setup guide": "スクリプト設定ガイド",
    "Search Engine Optimization": "検索エンジン最適化",
    "Search Engine Optimization (SEO)": "検索エンジン最適化 (SEO)",
    "Search Engines": "サーチエンジン",
    "Search engine": "検索エンジン",
    "Search engines": "サーチエンジン",
    "Search for Pages": "ページを検索",
    "Search for file size that is": "ファイルサイズを検索する",
    "Search for image size that is": "画像サイズを検索する",
    "Search for links, that are associated with class names and contains below mentioned class names.": "クラス名に関連付けられており、下記のクラス名を含むリンクを検索します。",
    "Search for page titles or URLs across all domains": "すべてのドメインのページタイトルまたはURLを検索",
    "Search for pages": "ページを検索",
    "Search icon": "検索アイコン",
    "Search in: Documents": "検索: ドキュメント",
    "Search in: Everything": "検索: すべて",
    "Search in: Links": "検索: リンク",
    "Search in: Only HTML pages": "検索対象: HTML ページのみ",
    "Search pages across all domains": "すべてのドメインのページを検索",
    "Search...": "検索...",
    "Searches": "検索",
    "Seconds": "秒",
    "See API Token": "APIトークンを見る",
    "See Details": "詳細を見る",
    "See changes": "変更内容を見る",
    "See details": "詳細を見る",
    "See pages": "ページを参照",
    "Select Domain and Module to get the Insights": "ドメインとモジュールを選択してインサイトを取得",
    "Select Domain on domain picker": "ドメインピッカーでドメインを選択",
    "Select Page to scan": "スキャンするページを選択",
    "Select a domain and recipients": "ドメインと受信者を選択",
    "Select a domain or group": "ドメインまたはグループを選択",
    "Select a profile": "プロフィールを選択",
    "Select account": "アカウントを選択",
    "Select all items": "すべての項目を選択",
    "Select domain": "ドメインを選択",
    "Select domains and groups": "ドメインとグループを選択",
    "Select filters": "フィルターを選択",
    "Select import": "インポートを選択",
    "Select item": "アイテムを選択",
    "Select login type*": "ログインタイプを選択*",
    "Select timezone": "タイムゾーンを選択",
    "Select users": "ユーザーを選択",
    "Select what type of content the policy should search in": "ポリシーで検索するコンテンツの種類を選択します",
    "Select whether the rule should search for case sensitive text or not": "ルールで大文字と小文字を区別してテキストを検索するかどうかを選択します",
    "Select your export file": "エクスポートファイルを選択",
    "Send an email if the site is down": "サイトがダウンしている場合はメールを送信する",
    "Send an email if the site is slow to respond": "サイトの応答が遅い場合はメールを送信してください",
    "Send message": "メッセージを送る",
    "Send report": "レポートを送信",
    "Send welcome mail on creation": "作成時にウェルカムメールを送信",
    "Set a default value for selector": "セレクタのデフォルト値を設定する",
    "Set as Default": "デフォルトとして設定",
    "Set to fixed": "固定に設定",
    "Settings": {
      "$$noContext": "設定",
      "Topmenu": "設定"
    },
    "Setup your domain": "ドメインを設定する",
    "Severity": "重大度",
    "Severity level": "重大度レベル",
    "Short": "短い",
    "Short Description": "簡単な説明",
    "Should we check the page's current status?": "ページの現在のステータスを確認する必要がありますか?",
    "Show Details": "詳細を表示",
    "Show all": "すべて表示する",
    "Show documents with this email": "このメールのドキュメントを表示",
    "Show history": "履歴を表示",
    "Show label dropdown": "ラベルドロップダウンを表示",
    "Show less": "表示を減らす",
    "Show more": "もっと表示する",
    "Show on global policy list": "グローバルポリシーリストに表示",
    "Show pages": "ページを表示",
    "Show pages with issues": "問題のあるページを表示",
    "Show pages with this SEO issue": "この SEO の問題があるページを表示",
    "Show pages with this email": "このメールを含むページを表示",
    "Show pages with this image": "この画像を含むページを表示",
    "Show pages with this link": "このリンクを含むページを表示",
    "Show pages with this misspelling": "このスペルミスのあるページを表示",
    "Show policy hits per domain": "ドメインごとのポリシーヒットを表示",
    "Show policy info": "ポリシー情報を表示",
    "Show the Domain Picker": "ドメインピッカーを表示する",
    "Show/Hide filter selector": "フィルターセレクターの表示/非表示",
    "Show/Hide the Domain Picker": "ドメインピッカーの表示/非表示",
    "Shows the remaining number of Performance Profiles that can be created for this account": "このアカウントに作成できるパフォーマンス プロファイルの残り数を表示します",
    "Side Navigation": "サイドナビゲーション",
    "Single line": "一行",
    "Size": "サイズ",
    "Skip to content": "コンテンツにスキップ",
    "Slide links": "スライドリンク",
    "Slides": "スライド",
    "Slow": "遅い",
    "Snippet": "スニペット",
    "Social": "ソーシャル",
    "Social Networks": "ソーシャルネットワーク",
    "Social visits": "ソーシャルネットワーク訪問",
    "Source Code Exclude": "ソースコード除外",
    "Source Code Excludes": "ソースコード除外",
    "Source code": "ソースコード",
    "Spellcheck": "スペルチェック",
    "Spellcheck Export Summary": "スペルチェックエクスポートの概要",
    "Spellcheck Summary": "スペルチェックの概要",
    "Spelling": "記述",
    "Spelling Errors used": "誤字を使用",
    "Spelling fixes": "スペルの修正",
    "Spelling ignore capitalized words": "スペルチェックでは大文字の単語は無視されます",
    "Spreadsheet links": "スプレッドシートのリンク",
    "Spreadsheets": "スプレッドシート",
    "Start PDF accessibility scan": "PDFアクセシビリティスキャンを開始",
    "Start at": "開始",
    "Start compound export": "複合エクスポートを開始",
    "Start date": "開始日",
    "Start export": "エクスポートを開始",
    "Start export Pages With Specific Link": "特定のリンクを含むページのエクスポートを開始",
    "Start new scan": "新しいスキャンを開始",
    "Start on demand scan": "オンデマンドスキャンを開始",
    "Start time": "開始時間",
    "Starts with": "始まり",
    "State": "州",
    "Statistic": "統計",
    "Statistics": "統計",
    "Statistics excluded IP addresses": "統計から除外されたIPアドレス",
    "Status": "状態",
    "Stop current crawl": "現在のクロールを停止",
    "Sub Navigation": "サブナビゲーション",
    "Submit selector*": "セレクターを送信*",
    "Succeeds": "成功",
    "Success criteria": "成功基準",
    "Suggestions and ideas": "提案とアイデア",
    "Summarized pages and documents count": "要約されたページと文書の数",
    "Summary": "まとめ",
    "Sunday": "日曜日",
    "Switch account": "アカウントを切り替える",
    "Table View": "テーブルビュー",
    "Tags": "タグ",
    "Target": "目標",
    "Technical": "テクニカル",
    "Technical SEO Issues": "技術的な SEO の問題",
    "Text": "文章",
    "Text Documents": "テキスト文書",
    "Text documents": "テキスト文書",
    "Text to match": "一致するテキスト",
    "Text:": "文章：",
    "The Checkpoint [[checkpoint]] will be updated with data after next crawl": "チェックポイント [[checkpoint]] は次回のクロール後にデータで更新されます",
    "The Document is not tagged": "ドキュメントにタグが付いていません",
    "The Path template for Umbraco CMS": "Umbraco CMS のパス テンプレート",
    "The Requested Page is not a part of the Performance Module": "要求されたページはPerformanceモジュールの一部ではありません",
    "The Scan will take effect within the next few hours": "スキャンは数時間以内に有効になります",
    "The URL for this page is too long": "このページのURLは長すぎます",
    "The base url to the CMS page": "CMS ページへのベース URL",
    "The bounce rate tells you the number of visits who only see the one page they started on": "直帰率は、最初に訪問したページのみを閲覧した訪問者の数を示します。",
    "The following rules will be removed, are you sure you want to continue with this change?": "次のルールは削除されます。この変更を続行してもよろしいですか?",
    "The header 1 (H1) tag is important as it helps search engines and users to understand what content they can expect to find on the page.": "ヘッダー 1 (H1) タグは、検索エンジンとユーザーがページ上でどのようなコンテンツを見つけることができるかを理解するのに役立つため重要です。",
    "The likelihood of this being a Data Privacy issue": "これがデータプライバシーの問題となる可能性",
    "The lowest level of readability. Example: children's books": "読みやすさの最低レベル。例: 児童書",
    "The meta description on this page is too long": "このページのメタディスクリプションが長すぎます",
    "The meta description on this page is too short": "このページのメタディスクリプションは短すぎます",
    "The misspelling will first show up after a new scan": "誤字は、新しいスキャン後に初めて表示されます",
    "The name of a meta entry (page metadata)": "メタエントリの名前（ページメタデータ）",
    "The optional base url to the CMS page": "CMS ページへのオプションのベース URL",
    "The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.": "お客様の個人情報のプライバシーは当社にとって非常に重要です。このため、当社はデータ保護およびプライバシー ポリシーを更新しました。当社のプラットフォームを引き続きご利用いただくには、新しいデータ保護およびデータ ポリシーの条件をお読みいただき、同意していただきますようお願いいたします。",
    "The scan can take a few hours/days to finalise, depending on the size of the website": "ウェブサイトのサイズに応じて、スキャンが完了するまでに数時間から数日かかる場合があります。",
    "The scan can take a few hours/days to finalise, depending on the size of the website.<br><br>Are you sure you want to start on-demand scan?": "ウェブサイトのサイズによっては、スキャンが完了するまでに数時間/数日かかる場合があります。<br><br>オンデマンド スキャンを開始してもよろしいですか?",
    "The scan can take a few minutes to finalise, depending on the size of the page": "ページのサイズによっては、スキャンが完了するまでに数分かかる場合があります。",
    "There are no META descriptions on one or more pages": "1 つ以上のページに META 記述がありません",
    "There are no domains assigned to this policy. Save policy anyway?": "このポリシーにはドメインが割り当てられていません。ポリシーを保存しますか?",
    "There are no more errors for this Snippet": "このスニペットにはこれ以上のエラーはありません",
    "There are no sub headlines on one or more pages": "1 つ以上のページにサブ見出しがありません",
    "There are zero META keywords on this page": "このページにはMETAキーワードがありません",
    "There is no H1 on one or more pages": "1 つ以上のページに H1 がありません",
    "There is no H1 on this page": "このページにはH1がありません",
    "There is no META descriptions on this page": "このページにはMETA説明がありません",
    "There is no historic data for domain groups": "ドメイングループの履歴データはありません",
    "There is no historic data for this domain": "このドメインには履歴データがありません",
    "There is no sub headlines on this page": "このページにはサブ見出しはありません",
    "These are findings that cannot be automatically checked and must be reviewed manually": "これらは自動的にチェックすることができず、手動で確認する必要がある発見事項です。",
    "These are findings which are likely to be errors, requiring manual confirmation": "これらはエラーである可能性が高いため、手動での確認が必要です。",
    "These findings are confirmed errors": "これらの調査結果はエラーであることが確認されました",
    "Third-Party": "第三者",
    "This field is required": "この項目は必須です",
    "This is the time between when an outage is first detected and when a notification is sent.": "これは、停止が最初に検出されてから通知が送信されるまでの時間です。",
    "This is useful if you have defined timeslots for maintenance.": "これは、メンテナンスの時間枠を定義している場合に便利です。",
    "This issue is ignored": "この問題は無視されます",
    "This link is marked as broken because it took more than 30 seconds to load": "このリンクは読み込みに30秒以上かかったため、リンク切れとマークされています",
    "This page has been marked as no index": "このページはインデックスなしとしてマークされています",
    "This page has no meta description": "このページにはメタディスクリプションがありません",
    "This page has no meta keywords": "このページにはメタキーワードがありません",
    "This page has not been assigned to the Performance Module": "このページはパフォーマンスモジュールに割り当てられていません",
    "This page is missing a title": "このページのタイトルがありません",
    "This policy is scheduled": "このポリシーは予定されています",
    "This rule doesn't contain any matches": "このルールには一致するものがありません",
    "This section lists requirements for <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformance</a> to WCAG 2.1. It also gives information about how to make conformance claims, which are optional.": "このセクションでは、WCAG 2.1 への <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>適合</a>の要件を一覧表示します。また、オプションである適合宣言を行う方法についても説明します。",
    "Thursday": "木曜日",
    "Time": "時間",
    "Time Spent": "使った時間",
    "Time To Interactive": "インタラクティブな時間",
    "Time to Warning *": "警告までの時間 *",
    "Timeframe:": "時間枠：",
    "Timeline": "タイムライン",
    "Timezone": "タイムゾーン",
    "Title": "タイトル",
    "Title & description": "タイトル説明",
    "Title and URL": "タイトルとURL",
    "Title and url": "タイトルとURL",
    "To setup this policy, you need to tell us how long your max word length is": "このポリシーを設定するには、最大単語長を設定してください",
    "To setup this policy, you need to tell us which brand name should end with TM or ™": "このポリシーを設定するには、どのブランド名がTMまたは™で終わるかを指定する必要があります。",
    "To toggle Quick Search:": "クイック検索を切り替えるには:",
    "Toggle Dropdown": "ドロップダウンを切り替える",
    "Toggle dropdown": "ドロップダウンを切り替える",
    "Toggle notes": "ノートを切り替える",
    "Toggle show filters": "表示フィルターを切り替える",
    "Too few characters": "文字数が少なすぎます",
    "Too many characters": "文字数が多すぎます",
    "Top keywords": "上位のキーワード",
    "Total": "合計",
    "Total CPU Time": "合計CPU時間",
    "Total QA issues": "QA問題の総数",
    "Total Visitors": "総訪問者数",
    "Total Visits": "総訪問数",
    "Total amount of content": "コンテンツの総量",
    "Total crawled": "クロールされた合計",
    "Total number of issues": "問題の総数",
    "Total number of issues across all modules": "すべてのモジュールにおける問題の総数",
    "Total page views over the last 30 days": "過去 30 日間の合計ページビュー",
    "Total pages:": "総ページ数:",
    "Total visitors": "総訪問者数",
    "Total visitors from Referrers": "リファラーからの合計訪問者数",
    "Total visitors from Search Engines": "検索エンジンからの合計訪問者数",
    "Total visits": "総訪問数",
    "Total visits from Referrers": "リファラーからの合計訪問数",
    "Total visits from Search Engines": "検索エンジンからの合計訪問数",
    "Total visits in the last 30 days:": "過去 30 日間の合計訪問数:",
    "Total words": "総単語数",
    "Track changes across domains and modules": "ドメインとモジュール全体の変更を追跡する",
    "Traffic Sources": "トラフィックソース",
    "Traffic Sources Summary": "トラフィックソースの概要",
    "Traffic sources": "トラフィックソース",
    "Transfer Size": "転送サイズ",
    "Tuesday": "火曜日",
    "Twice a day": "1日2回",
    "Twitter": "Twitter",
    "Type": "タイプ",
    "Type the key for the metadata": "メタデータのキーを入力してください",
    "Type the text to match rule": "ルールに一致するテキストを入力してください",
    "Type*": "タイプ*",
    "URL": "URL",
    "URL must start with a protocol. Ex. http://....": "URL はプロトコルで始まる必要があります。例: http://....",
    "URL to redirect to if form is valid": "フォームが有効な場合にリダイレクトする URL",
    "URL:": "URL:",
    "Unable to read link": "リンクを読み取れません",
    "Unarchive": "アーカイブ解除",
    "Undetermined": "未定",
    "Undo": "元に戻す",
    "Undo review": "レビューを元に戻す",
    "Unignore": "無視しない",
    "Unignore check": "無視しないチェック",
    "Unignore misspelling": "誤字を無視しない",
    "Unignore on this page": "このページの無視を解除",
    "Unignore this SEO issue": "このSEOの問題を無視しない",
    "Unignore this check for this domain": "このドメインのこのチェックを無視しない",
    "Unique Visitors": "ユニークビジター数",
    "Unique downloads": "ユニークダウンロード数",
    "Unknown": "未知",
    "Unknown Score": "スコア不明",
    "Unknown title": "タイトル不明",
    "Unpin domain": "ドメインの固定を解除",
    "Unsaved changes": "保存されていない変更",
    "Unwanted": "不要",
    "Unwanted content": "不要なコンテンツ",
    "Unwanted violations": "望ましくない違反",
    "Update": "アップデート",
    "Update groups": "グループを更新する",
    "Updated": "更新しました",
    "Updated At": "更新日時",
    "Updated at": "更新日時",
    "Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.": "グループの更新には 30 分以上かかる場合があります。操作中はグループの作成や更新はできません。",
    "Upload CSV": "CSVをアップロード",
    "Upload csv file": "csvファイルをアップロード",
    "Uptime": "稼働時間",
    "Uptime last 30 days": "過去30日間の稼働時間",
    "Url*": "URL*",
    "Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors": "* をワイルドカードとして使用します (例: 192.168.1.*)。除外された IP アドレスは新しい訪問者にのみ影響します。",
    "Use language attribute": "言語属性を使用する",
    "Use or Apply custom PageCorrect": "カスタムPageCorrectの使用または適用",
    "User": "ユーザー",
    "User Export": "ユーザーのエクスポート",
    "User List": "ユーザーリスト",
    "User Loading Experience": "ユーザーの読み込みエクスペリエンス",
    "User information": "ユーザー情報",
    "User interface components and navigation must be operable.": "ユーザー インターフェイス コンポーネントとナビゲーションは操作可能である必要があります。",
    "User is account administrator": "ユーザーはアカウント管理者です",
    "Username": "ユーザー名",
    "Value": "値",
    "Value*": "値*",
    "Vat no": "付加価値税登録番号",
    "Verify URL*": "URLを確認する*",
    "Very easy": "非常に簡単",
    "Very hard": "とても難しい",
    "View options": "表示オプション",
    "Viewing as Profile:": "プロフィールとして表示:",
    "Views": "ビュー",
    "Violation": "違反",
    "Violation count": "違反回数",
    "Violation's info_type name not set": "違反の info_type 名が設定されていません",
    "Violations": "違反行為",
    "Visible": "見える",
    "Visible modules": "表示モジュール",
    "Visit the affected image": "影響を受けた画像にアクセスする",
    "Visitor Overview": "訪問者の概要",
    "Visitor Summary": "訪問者の概要",
    "Visitor log": "訪問者ログ",
    "Visitor profile": "訪問者プロフィール",
    "Visitor profile:": "訪問者プロフィール:",
    "Visitors": "訪問者",
    "Visitors Summary": "訪問者の概要",
    "Visits": "訪問",
    "Visual mode": "ビジュアルモード",
    "WCAG 2.0 (Level A)": "WCAG 2.0 (レベル A)",
    "WCAG 2.0 (Level AA)": "WCAG 2.0 (レベル AA)",
    "WCAG 2.0 (Level AAA)": "WCAG 2.0 (レベル AAA)",
    "WCAG 2.0 Accessibility Compliance": "WCAG 2.0 アクセシビリティ準拠",
    "WCAG 2.1 (Level A)": "WCAG 2.1 (レベル A)",
    "WCAG 2.1 (Level AA)": "WCAG 2.1 (レベル AA)",
    "WCAG 2.1 (Level AAA)": "WCAG 2.1 (レベル AAA)",
    "WCAG 2.1 Accessibility Compliance": "WCAG 2.1 アクセシビリティ準拠",
    "Want to search for": "検索対象",
    "Warning": "警告",
    "We recommend that all your pages has a number of relevant meta keywords.": "すべてのページにいくつかの関連するメタキーワードを含めることをお勧めします。",
    "We recommend that all your pages has a relevant and unique meta description.": "すべてのページに関連性のある固有のメタディスクリプションを付けることをお勧めします。",
    "We recommend that all your pages has an unique title.": "すべてのページに一意のタイトルを付けることをお勧めします。",
    "We recommend that the meta description consists of at least 50 characters.": "メタディスクリプションは少なくとも 50字で構成することをお勧めします。",
    "We recommend that the meta description consists of no more than 160 characters.": "メタディスクリプションは 160字以内にすることをお勧めします。",
    "We recommend that you give each page a unique title.": "各ページに固有のタイトルを付けることをお勧めします。",
    "We recommend that you have a unique H1 tag on each page.": "各ページに固有の H1 タグを設定することをお勧めします。",
    "We recommend that you have at least one H2-H6": "少なくとも1つのH2-H6をお勧めします",
    "We recommend that you have no more than 100 internal links on each page.": "各ページの内部リンクは 100 個以下にすることをお勧めします。",
    "We recommend that you keep your URL below 200 characters.": "URL は 200 文字未満にすることをお勧めします。",
    "We recommend that you only have one H1 tag on each page.": "各ページには H1 タグを 1 つだけ使用することをお勧めします。",
    "Wednesday": "水曜日",
    "Weekly": "毎週",
    "Well done - no accessibility issues found": "よくできました。アクセシビリティの問題は見つかりませんでした。",
    "We’ve Updated our Privacy Policy!": "プライバシーポリシーを更新しました。",
    "Why is this an issue": "これが問題となる理由",
    "With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go": "Fast Trackを使用すると、影響を受けるページのHTMLスニペットを一度に修正、確認、無視することができます。",
    "Word": "単語",
    "Word Count": "単語数",
    "Word count": "単語数",
    "Word count in PDF": "PDF の単語数",
    "Word is added to dictionary": "単語が辞書に追加されました",
    "Word is added to dictionary for all languages": "すべての言語の辞書に単語が追加されました",
    "Word is confirmed as misspelling": "単語の誤字が確認されました",
    "Word length": "単語の長さ",
    "Word links": "単語リンク",
    "Word or Phrase": "単語またはフレーズ",
    "Words": "単語",
    "Would you like to update now? Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups": "今すぐ更新しますか? グループの更新には 30 分以上かかる場合があります。操作中はグループの作成と更新はできません。",
    "Written by: [[author]]": "著者: [[author]]",
    "Years": "年",
    "You are about to delete": "削除しようとしています",
    "You are about to delete the domain": "ドメインを削除しようとしています",
    "You are about to delete the domain group": "ドメイングループを削除しようとしています",
    "You are currently using Demo Data, certain features will be unavailable": "現在デモデータを使用しているため、一部の機能はご利用いただけません",
    "You are receiving this report": "このレポートを受け取っています",
    "You can create another [[customerProfilesLimit]] profiles for your account": "アカウントにさらに [[customerProfilesLimit]] 個のプロファイルを作成できます",
    "You can pin this domain. Pinned domains will be shown at the top of your domain list": "このドメインをピン留めすることができます。ピン留めされたドメインはドメインリストの上部に表示されます。",
    "You have more than one H1 tag on this page": "このページには複数の H1 タグがあります",
    "You have no H2-H6 tags on the page": "ページにH2-H6タグがありません",
    "You have no available profiles": "利用可能なプロフィールはありません",
    "You have not received any reports": "レポートを受け取っていません",
    "You have one or more pages with the \\\"noindex\\\" META tag": "\\\"noindex\\\" META タグが設定されたページが 1 つ以上あります",
    "You have reached the maximum number of profiles for this account.": "このアカウントのプロファイルの最大数に達しました。",
    "You have too many internal links": "内部リンクが多すぎます",
    "You will receive an email when the export is ready.": "エクスポートの準備ができたらメールが届きます。",
    "Your Users Technology": "ユーザーのテクノロジー",
    "Zero links were found": "リンクは見つかりませんでした",
    "Zip code": "郵便番号",
    "achieved": "達成",
    "affected image": "影響を受けた画像",
    "and": "and",
    "and does not conform with": "そして次に適合しない",
    "contact": "連絡先",
    "contains": "含む",
    "content": "コンテンツ",
    "diagnostics_errors.csv": "diagnostics_errors.csv",
    "diagnostics_passed.csv": "diagnostics_passed.csv",
    "disabling": "無効化中",
    "document": "ドキュメント",
    "documents": "ドキュメント",
    "done": "終了",
    "enabling": "有効化",
    "ends_with": "終了",
    "excluded": "除外",
    "go to the matched link": "一致したリンクに移動",
    "image": "画像",
    "included": "含まれる",
    "insert brand name": "ブランド名を挿入",
    "insert context fx. us": "コンテキストを挿入 fx. us",
    "insert max word length": "最大単語長を挿入",
    "insert word fx. contact": "単語を挿入 fx. 連絡先",
    "is": "は",
    "is_exactly": "完全一致する",
    "language": "言語",
    "link": "リンク",
    "match (regex)": "一致（正規表現）",
    "metadata": "メタデータ",
    "milliseconds": "ミリ秒",
    "minutes": "分",
    "n/a": "該当なし",
    "not": "でない",
    "opportunities_errors.csv": "opportunities_errors.csv",
    "opportunities_passed.csv": "opportunities_passed.csv",
    "overall compliance": "全体的なコンプライアンス",
    "pages": "ページ",
    "path": "パス",
    "please type": "入力してください",
    "reviewed": "レビュー済",
    "rows - click to change": "行 - クリックして変更",
    "search engines overview": "検索エンジンの概要",
    "should always be followed by": "常に続くべき",
    "social network overview": "ソーシャルネットワークの概要",
    "starts_with": "始まり",
    "that": "条件",
    "title": "タイトル",
    "to confirm this action": "このアクションを確認する",
    "to fix": "修正する",
    "url": "URL",
    "us": "us",
    "visits": "訪問",
    "you have one or more pages that contains links with rel=\\\"nofollow\\\"": "rel=\\\"nofollow\\\" のリンクを含むページが 1 つ以上あります",
    "{{ pagesDone }} Pages ({{ compliancePercentage }}) in compliance": "{{ pagesDone }} 件のページ ({{ CompliancePercentage }}) が準拠しています",
    "{{ totalPageIssues }} Pages ({{ compliancePercentage }}) to fix": "修正すべきページ数: {{ totalPageIssues }} ページ ({{ CompliancePercentage }})",
    "[[label]]: [[value]] Pages": "[[label]]: [[value]] ページ",
    "[[label]]: [[value]]ms": "[[label]]: [[value]] ミリ秒",
    "[[languageName]] ([[languageCount]])": "[[languageName]] ([[languageCount]])",
    "[[ms]] ms": "[[ms]] ミリ秒",
    "[[name]] have already been scanned for compliance. Are you sure you want to scan it again?": "[[name]] はすでにコンプライアンスのスキャンを受けています。もう一度スキャンしてもよろしいですか?",
    "[[pageCount]] Pages": "[[pageCount]] ページ",
    "[[pageCount]] pages found with this issue": "この問題のあるページが [[pageCount]] 件見つかりました",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.0[[spanEnd]] (レベル A)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (レベル AA)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (レベル AAA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.1[[spanEnd]] (レベル A)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (レベル AA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (レベル AAA)",
    "1 found": "1 件見つかりました",
    "1 issue found": "1 件の問題が見つかりました",
    "1 word found": "1 単語が見つかりました",
    "Total: 1 Performance Page": "合計: 1 パフォーマンス ページ",
    "You have 1 to do": "やるべきことが1つあります",
    "page": "ページ",
    "Are you sure you want to remove Custom PageCorrect? <br> Please type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "カスタムPageCorrect を削除してもよろしいですか? <br> この操作を確定するには、[[deleteTag]]Delete[[deleteTagEnd]] と入力してください。",
    "You are about to remove PageCorrect for this check <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "このチェックの PageCorrect を削除しようとしています <br> この操作を確認するには [[deleteTag]]Delete[[deleteTagEnd]] と入力してください",
    "You are about to remove PageCorrect for this misspelling <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "この誤字の PageCorrect を削除しようとしています <br> この操作を確認するには [[deleteTag]]Delete[[deleteTagEnd]] と入力してください",
    "You are about to remove PageCorrect for this [[type]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "この [[type]] の PageCorrect を削除しようとしています <br> この操作を確認するには [[deleteTag]]Delete[[deleteTagEnd]] と入力してください",
    "You are about to remove [[titleTag]][[title]][[titleTagEnd]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "[[titleTag]][[title]][[titleTagEnd]] を削除しようとしています <br> この操作を確認するには、「[[deleteTag]]Delete[[deleteTagEnd]]」と入力してください",
    "Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it's place": "API ユーザー [[apiUserId]] のトークンを取り消しますか? <br><strong>注</strong> 代わりに新しいトークンが作成されます",
    "Maximum critical path latency: <strong>[[latency]] ms </strong>": "最大クリティカルパス遅延: <strong>[[latency]] ミリ秒 </strong>",
    "Are you sure you want to remove <code>all</code> [[type]] PageCorrects? <br> Please type <code>Delete</code> to confirm this action": "<code>すべての</code> [[type]] PageCorrects を削除しますか?  <br> この操作を確定するには、<code>Delete</code>と入力してください。",
    "<strong>[[checkName]]</strong><br><br>Add reason (Optional)": "<strong>[[checkName]]</strong><br><br>理由を追加（任意）",
    "Are you sure you want to confirm the misspelling <strong>' + word.word + '</strong>?": "本当に誤字を <strong>' + word.word + '</strong> を確定しますか?",
    "Are you sure you want to delete the policy <strong>[[policyName]]</strong>": "ポリシー <strong>[[policyName]]</strong> を削除しますか?",
    "Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?": "ポリシー <strong>[[policyName]]</strong> を修正済みとしてマークしますか?",
    "Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>": "<strong>[[pageUrl]]</strong> からヒートマップ ルールを削除しますか?",
    "Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?": "ルール <strong>' + rule.name + '</strong> を削除しますか?",
    "Are you sure you want to run the policy <strong>' + policy.name + '</strong>?": "ポリシー <strong>' + policy.name + '</strong> を実行しますか?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong> again?": "ポリシー <strong>[[policyName]]</strong> を再度実行しますか?",
    "Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?": "ポリシー <strong>[[policyName]]</strong> の無視を解除しますか?",
    "You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.": "現在、誤字の修正が <strong>[[spellingFixes]]</strong> 件あります。ページが問題なく表示されるようにするには、この数を <strong>[[spellingLimit]]</strong> 未満に抑えることをお勧めします。",
    "You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.": "現在、修正は <strong>[[totalFixes]]</strong> 件あります。最適なページ パフォーマンスを確保するには、修正数を <strong>[[pageFixLimit]]</strong> に制限することをお勧めしますが、これはご自身の判断で行ってください。",
    "[[users]]<strong>and [[userCountLeft]] more</strong>": "[[users]] さん: <strong>と [[userCountLeft]] 人</strong>",
    "Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?": "ポリシー <strong>[[policyName]]</strong> を無視しますか?",
    "Title:": "タイトル：",
    "[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]": "[[msg]] <strong>[[regulationName]]</strong> により、次の問題に対するカスタム [[opposite]] ルールが上書きされ、将来のスキャンで [[negate]] フラグが付けられることになります: [[list]]",
    "Admin only": "管理者のみ",
    "Apply fix": "修正を適用",
    "Contains high, medium or low opportunities": "高、中、低程度の機会が含まれています",
    "Design": "デザイン",
    "Enable Custom PageCorrect Settings": "カスタムページ修正設定を有効にする",
    "Enable PageCorrect features below. Disabled features will not be shown on your dashboard.": "以下の PageCorrect 機能を有効にします。無効になっている機能はダッシュボードに表示されません。",
    "Enable PageCorrect for Accessibility Source Codes": "アクセシビリティ ソース コードで PageCorrect を有効にする",
    "Enable PageCorrect for Broken Links": "リンク切れに対して PageCorrect を有効にする",
    "Enable PageCorrect for Misspellings": "誤字に対してPageCorrectを有効にする",
    "Enable PagedCorrect for Accessibility Checks": "アクセシビリティチェックにPagedCorrectを有効にする",
    "Failing checks - A": "不合格チェック - A",
    "Failing checks - AA": "不合格チェック - AA",
    "Failing checks - AAA": "不合格チェック - AAA",
    "Good job! Your domain contains no Accessibility Issues for this section": "よくできました！あなたのドメインにはこのセクションのアクセシビリティの問題はありません",
    "Indicates the difficulty to apply this fix": "この修正を適用する難しさを示します",
    "List of improvements that can be applied to your website to improve your Accessibility Compliance": "アクセシビリティコンプライアンスを向上させるためにウェブサイトに適用できる改善点のリスト",
    "Manage": "管理",
    "Media": "メディア",
    "Open PageCorrect Settings": "PageCorrect設定を開く",
    "PageCorrect Settings Updated": "PageCorrect設定が更新されました",
    "PageCorrect settings": "PageCorrect設定",
    "Pages with Data Privacy violations": "データプライバシー違反のあるページ",
    "Should admin be the only one to set PageCorrect Settings": "PageCorrect設定を設定できるのは管理者のみか",
    "Website Structure": "ウェブサイトの構造",
    "Data Privacy violations": "データプライバシー違反",
    "Heartbeat check": "Heartbeat チェック",
    "Request PDF accessibility check from selection": "選択項目からPDFアクセシビリティチェックをリクエストする",
    "Total unique downloads": "合計ユニークダウンロード数",
    "[[succeededPdfs]] out of [[pdfs]] PDF accessibility request succeeded": "[[succeededPdfs]] 件中 [[pdfs]] 件の PDF アクセシビリティ リクエストが成功しました",
    "Accessibility Issues": "アクセシビリティの問題",
    "Inspecting:": "検査中:",
    "Pages with Accessibility Issues": "アクセシビリティの問題があるページ",
    "Start advance export": "高度なエクスポートを開始",
    "Check whether your website is responding and measures the response times of the server": "ウェブサイトが応答しているかどうかを確認し、サーバーの応答時間を測定します。",
    "Search label": "検索ラベル",
    "Custom range": "カスタム範囲",
    "Last Half Year": "過去半年",
    "Last Month": "先月",
    "Last Quarter": "前四半期",
    "Last Week": "先週",
    "Last Year": "去年",
    "Character": "文字数",
    "Image missing alt attribute": "画像に alt 属性がありません",
    "Quick info here": "簡単な情報はこちら",
    "There is 1 META description on this page": "このページには 1 つの META 記述があります",
    "There is 1 internal link on this page": "このページには内部リンクが 1 つあります",
    "There is one META description on this page": "このページにはMETA説明が1つあります",
    "and 1 document": {
      "Documents with broken images": "および 1 件のドキュメント",
      "Documents with confirmed misspellings": "および 1 件のドキュメント",
      "Documents with potential misspellings": "および 1 件のドキュメント"
    },
    "and one document": {
      "Pages with broken links": "および1件のドキュメント"
    },
    "Remediation": "修正",
    "Remediation quote": "修正見積り",
    "Remediation quote has been requested": "修正見積りを依頼しました",
    "Sort by": {
      "Exchange center filter option": "並べ替え"
    },
    "#idname.class-name1.class-name2": "#idname.class-name1.class-name2",
    "&lt;i&gt; tags as icons": "&lt;i&gt; タグをアイコンとして",
    ".class-name1": ".class-name1",
    "<strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)": "<strong>&lt;strong&gt; タグの CSS スタイル</strong> (すべての強いテキストを赤にする)",
    "<strong>NOTE</strong>: Changing the text below, will override the text in all your included languages": "<strong>注意</strong>: 以下のテキストを変更すると、含まれているすべての言語のテキストが上書きされます。",
    "A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations": "PageAssist の新しいバージョンが利用可能です。新しいカスタマイズにアクセスするには、バージョン 2.0 に切り替えてください。",
    "Accessibility Fixes": "アクセシビリティの修正",
    "Add Policy": "ポリシーを追加",
    "Add a description of the widget to your users": "ユーザー向けにウィジェットの説明を追加する",
    "Add comment (Optional)": "コメントを追加（任意）",
    "Add row": "行を追加する",
    "Add text for when the button is hovered": "ボタンにマウスを置いたときに表示されるテキストを追加する",
    "Add title": "タイトルを加える",
    "Africa": "アフリカ",
    "All <code>img</code> elements have an <code>alt</code> attribute": "すべての <code>img</code> 要素には <code>alt</code> 属性があります",
    "Alt text does not convey the same information as the image": "代替テキストが画像と同じ情報を伝えていません",
    "Alt text for all <code>img</code> elements contains all text in the image unless the image text is decorative or appears elsewhere in the document": "すべての <code>img</code> 要素の代替テキストには、画像テキストが装飾的なものであったり、ドキュメント内の他の場所に表示されていない限り、画像内のすべてのテキストが含まれます。",
    "Alt text for all <code>img</code> elements is not placeholder text unless author has confirmed it is correct": "すべての <code>img</code> 要素の代替テキストは、作成者が正しいことを確認しない限り、プレースホルダーテキストではありません。",
    "Alt text for all <code>img</code> elements is the empty string (\\\"\\\") if the image is decorative.": "画像が装飾的なものである場合、すべての <code>img</code> 要素の代替テキストは空の文字列 (\\\"\\\") になります。",
    "Alt text for all <code>img</code> elements used as source anchors is not empty when there is no other text in the anchor": "ソース アンカーとして使用されるすべての <code>img</code> 要素の代替テキストは、アンカーに他のテキストがない場合でも空ではありません。",
    "Alt text is not the same as the filename unless author has confirmed it is correct": "著者が正しいことを確認しない限り、代替テキストはファイル名と同じではありません",
    "And how are we going to fix it?": "そして、どうやってそれを修正するのでしょうか?",
    "Applying fix": "修正を適用中",
    "Are you sure you want to stop receiving this report?": "このレポートの受信を停止してもよろしいですか?",
    "Aria-label": "Aria-label",
    "Asia": "アジア",
    "Blink sample image": "点滅サンプル画像",
    "Blink testing sample image": "瞬きテストのサンプル画像",
    "Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.": "実際には、これらの問題は両方とも、間違った色から、存在すべきでない不自然なスペースまで、さまざまな視覚的な問題を引き起こす可能性があります。",
    "Bottom center": "下中央",
    "Bottom left": "左下",
    "Bottom right": "右下",
    "Browse": "見る",
    "Button hover message": "ボタンホバーメッセージ",
    "CSS selector": "CSSセレクター",
    "Change <b> tags to a custom element": "<b> タグをカスタム要素に変更する",
    "Change <b> tags to a custom tag": "<b> タグをカスタムタグに変更する",
    "Change <blink> tags to a custom element": "<blink> タグをカスタム要素に変更する",
    "Change <blink> tags to a custom tag": "<blink> タグをカスタムタグに変更する",
    "Change <marquee> tags to a custom element": "<marquee> タグをカスタム要素に変更する",
    "Change <marquee> tags to a custom tag": "<marquee> タグをカスタムタグに変更する",
    "Change your &lt;blink&gt; tags into something else": "&lt;blink&gt; タグを他のものに変更する",
    "Change your &lt;i&gt; elements into something else": "&lt;i&gt; 要素を他のものに変更する",
    "Change your &lt;marquee&gt; tags into something else": "&lt;marquee&gt; タグを他のものに変更する",
    "Check for misspelling company name: [[company]]": "会社名の誤字を確認してください: [[company]]",
    "Choose a tag to replace your b tags with": "bタグを置き換えるタグを選択してください",
    "Choose a tag to replace your blink tags with": "blinkタグを置き換えるタグを選択してください",
    "Choose a tag to replace your italic tags with": "italicタグを置き換えるタグを選択してください",
    "Choose a tag to replace your marquee tags with": "marqueeタグを置き換えるタグを選択してください",
    "Choose an icon": "アイコンを選択",
    "Choose this option to customise the fix": "修正をカスタマイズするにはこのオプションを選択してください",
    "Choose this option to customize the fix": "修正をカスタマイズするにはこのオプションを選択してください",
    "Choose your own text for the warning pop-up": "警告ポップアップ用の独自テキストを選択します",
    "Circle": "丸",
    "Class": "クラス",
    "Close PageCorrect form": "PageCorrectフォームを閉じる",
    "Close [[groupName]]: [[labelName]]": "[[groupName]] : [[labelName]]を閉じる",
    "Company name *": "会社名 *",
    "Constraint:": "制約:",
    "Custom settings": "カスタム設定",
    "Default fix": "デフォルトの修正",
    "Default language": "デフォルト言語",
    "Dutch": "オランダ人",
    "Edit Report": "レポートを編集",
    "Education": "教育",
    "Element name is invalid": "要素名が無効です",
    "Element name should not contain spaces": "要素名にはスペースを含めることはできません",
    "Enter aria-label name": "aria-label名を入力してください",
    "Enter class name": "クラス名を入力してください",
    "Enter role name": "役割名を入力",
    "Europe": "ヨーロッパ",
    "Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:": "これは非常に簡単な修正ですが、Web サイトのデザインに問題を引き起こす可能性がある方法が 2 つあります。",
    "Example 1": "例1",
    "Example 2": "例2",
    "File must be below 1MB": "ファイルは1MB未満である必要があります",
    "Filter dropdown": "フィルタードロップダウン",
    "Finance": "ファイナンス",
    "Fix applied!": "修正を適用しました!",
    "Fix options": "オプションを修正",
    "French": "フランス語",
    "Give a title to your Skip to Content button": "「コンテンツへスキップ」ボタンにタイトルを付ける",
    "Government": "政府",
    "Grid view": "グリッドビュー",
    "Hide": "隠れる",
    "Hide text": "テキストを非表示",
    "Hitting the tab button will turn on Skip to PageAssist": "タブボタンを押すと、PageAssistにスキップがオンになります",
    "How are we going to fix it?": "どうやって解決するのでしょうか?",
    "Icon shape": "アイコンの形状",
    "Image Alt text is short": "画像の代替テキストが短い",
    "Important images should not have spacer Alt text": "重要な画像にはスペーサーの代替テキストは不要です",
    "Info": "情報",
    "Insert company name": "会社名を入力",
    "Instead of &lt;i&gt; choose a different element name to be used instead": "&lt;i&gt;の代わりに使用する別の要素名を選択してください",
    "It will take some time before our system will register your changes to PageCorrect": "PageCorrectへの変更がシステムに反映されるまでには、しばらく時間がかかります。",
    "Left middle": "左中央",
    "Letter case *": "大文字小文字 *",
    "Light": "ライト",
    "Link excludes:": "リンクには以下は含まれません:",
    "Loading PageFix": "PageFix を読み込んでいます",
    "Make sure you use correct formatting and add multiple selectors when your page design differs": "ページデザインが異なる場合は、正しい書式を使用し、複数のセレクターを追加してください。",
    "Manage options": "オプションの管理",
    "Marquee sample image": "マーキーサンプル画像",
    "Marquee testing sample image": "マーキーテストのサンプル画像",
    "Menu theme": "メニューテーマ",
    "New Window Information": "新しいウィンドウの情報",
    "New Window Test": "新しいウィンドウのテスト",
    "Non-Decorative images must have Alt text": "装飾のない画像には代替テキストが必要です",
    "North America": "北米",
    "PageAssist Logo": "PageAssist ロゴ",
    "PageAssist position on Page": "ページ上のPageAssistの位置",
    "Portuguese": "ポルトガル語",
    "Potential problems that can arise": "発生する可能性のある潜在的な問題",
    "Press 'Upload link' to save your URL settings": "「リンクをアップロード」を押してURL設定を保存します",
    "Preview": "プレビュー",
    "Proper Case": "適切なケース",
    "Remove input selector": "入力セレクターを削除",
    "Remove logo upload": "ロゴアップロードを削除",
    "Remove row": "行を削除",
    "Repair Tip": "修理のヒント",
    "Repair options": "修理オプション",
    "Replace Italic element with EM": "斜体要素をEMに置き換える",
    "Replace all &lt;b&gt; tags with": "すべての&lt;b&gt;タグを次と置き換える",
    "Replace all &lt;blink&gt; tags with": "すべての&lt;blink&gt;タグを次と置き換える",
    "Replace all &lt;i&gt; tags": "すべての &lt;i&gt; タグを置き換えます",
    "Replace all &lt;marquee&gt; tags with": "すべての&lt;marquee&gt;タグを次と置き換える",
    "Report Center Image": "レポートセンター画像",
    "Reset Input": "入力をリセット",
    "Reset Skip to content text to its default": "コンテンツにスキップするテキストをデフォルトにリセット",
    "Reset design": "デザインをリセット",
    "Reset to default": "デフォルトにリセット",
    "Restore": "復元する",
    "Restore profile?": "プロフィールを復元しますか?",
    "Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.": "このプロファイル <strong>([[profileName]])</strong> を復元すると、モジュールで使用できるようになります。",
    "Right middle": "右真ん中",
    "Rounded Box": "丸いボックス",
    "Russian": "ロシア語",
    "Show": "表示する",
    "Show details": "詳細を表示",
    "Show text": "テキストを表示",
    "Simplified Chinese": "中国語（簡体字）",
    "Skip to Content": "コンテンツにスキップ",
    "Snippet reset": "スニペットのリセット",
    "Someone have created this PageCorrect before you, on another check.": "別のチェックで、あなたより前に誰かがこのページを作成しました。",
    "Spanish Mexican": "スペイン語 メキシコ語",
    "Start export inventory emails": "インベントリメールのエクスポートを開始する",
    "Start export inventory emails extended": "インベントリエクスポートメールの延長を開始",
    "Testing": "テスト",
    "The subpath/subfolder the WordPress installation is under": "WordPress がインストールされているサブパス/サブフォルダ",
    "This fix requires development knowledge": "この修正には開発知識が必要です",
    "This message will be displayed when the user hovers over the PageAssist button": "このメッセージは、ユーザーがPageAssistボタンの上にマウスを置いたときに表示されます。",
    "This option might cause problems to your icons": "このオプションはアイコンに問題を引き起こす可能性があります",
    "Title Text": "タイトルテキスト",
    "To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check": "このポリシーを設定するには、会社名と、チェックしたい誤字の可能性のある大文字と小文字の種類をお知らせください",
    "Top center": "上中央",
    "Top left": "左上",
    "Top right": "右上",
    "Trying out the pop-up": "ポップアップを試してみる",
    "UPPERCASE": "大文字",
    "Undo check review": "チェックレビューを元に戻す",
    "Upload link": "アップロードリンク",
    "Upload logo": "ロゴをアップロード",
    "Use Datepicker": "日付ピッカーを使用する",
    "Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>": "PageCorrect を使用して次のスペルミスを修正します:<code>[[misspelling]]</code>",
    "Use PageCorrect to fix Broken Link": "PageCorrectを使用してリンク切れを修正する",
    "Use PageCorrect to fix these image sources": "PageCorrectを使用してこれらの画像ソースを修正します",
    "Value:": "値：",
    "View": "ビュー",
    "What is wrong with the &lt;b&gt; (bold) element?": "&lt;b&gt; (太字) 要素の何が問題なのでしょうか?",
    "What is wrong with the &lt;i&gt; (italic) element?": "&lt;i&gt; (斜体) 要素の何が問題なのでしょうか?",
    "What to do when the link doesn't work?": "リンクが機能しない場合はどうすればよいですか?",
    "What to do when things look wrong?": "何かおかしいと思ったらどうすればいいでしょうか?",
    "Why shouldn't I use the blink element?": "なぜ点滅要素を使用しない方が良いのでしょうか?",
    "Widget Design and Text": "ウィジェットのデザインとテキスト",
    "Widget Icon Setup": "ウィジェットアイコンの設定",
    "Without any assigned class": "指定クラスなし",
    "Write a warning to your outbound link": "アウトバウンドリンクに警告を記載する",
    "Write custom tag": "カスタムタグを書く",
    "lowercase": "小文字",
    "with": "一緒に",
    "with &lt;em&gt;": "&lt;em&gt; 付き",
    "Statistics is using sample data": "Statisticsはサンプルデータを使用しています",
    "Statistics results are sample data for demo purposes - export is disabled": "統計結果はデモ用のサンプルデータです - エクスポートは無効です",
    "This section is using sample data": "このセクションではサンプルデータを使用しています",
    "&lt;i&gt; tags with these attribute values will not be changed": "これらの属性値を持つ &lt;i&gt; タグは変更されません",
    "(Bad)": "（悪い）",
    "(Good)": "（良い）",
    "<span class=\\\"mr-2\\\">Pages</span>": "<span class=\\\"mr-2\\\">ページ</span>",
    "Add API user": "APIユーザーを追加",
    "Add attributes to be excluded in this change": "この変更で除外する属性を追加する",
    "Add profile": "プロフィールを追加",
    "Add source code exclude": "ソースコード除外を追加",
    "Are you sure?": "確定しますか？",
    "Button hover color": "ボタンのホバーカラー",
    "Calculated by no. and severity of issues, page views and links leading to this page..": "問題の数と重大度、ページビュー、このページにつながるリンクによって計算されます。",
    "Choose minimum word count for a page to be included in the readability test": "読みやすさテストに含めるページの最小単語数を選択します",
    "Color contrast ratio": "色のコントラスト比",
    "Content id tag": "コンテンツIDタグ",
    "Creation date": "作成日",
    "Custom text": "カスタムテキスト",
    "Customise the Information page": "情報ページをカスタマイズする",
    "Disable": "無効にする",
    "Docs without downloads": "ダウンロード不要のドキュメント",
    "Documents Without Downloads": "ダウンロード不要のドキュメント",
    "EPI Server Path": "EPI サーバー パス",
    "EPIServer": "EPIサーバー",
    "Editor": "編集者",
    "Ex: data-currentpage, or data-pageid, or CurrentPageLink": "例: data-currentpage、data-pageid、CurrentPageLink",
    "Ex: lang or CurrentPageLanguage": "例: lang または CurrentPageLanguage",
    "Export both pages and documents": "ページとドキュメントの両方をエクスポートする",
    "Export only documents without downloads": "ダウンロードせずにドキュメントのみをエクスポートする",
    "Export only html pages without visits": "訪問のないHTMLページのみをエクスポートする",
    "Include Accessibility Statement": "アクセシビリティに関する声明を含める",
    "Include custom info text": "カスタム情報テキストを含める",
    "Includes a button with a link to your accessibility statement": "アクセシビリティステートメントへのリンクを含むボタンが含まれています",
    "Indicates which language this page will be scanned in. Click underneath to change": "このページをスキャンする言語を示します。変更するには下をクリックしてください",
    "Insert a valid URL": "有効なURLを入力してください",
    "Language tag": "言語タグ",
    "Last assigned profile on page. Page will be removed from Performance": "ページに最後に割り当てられたプロファイル。ページはパフォーマンスから削除されます",
    "Link color": "リンクの色",
    "Link opens in a new tab": "リンクは新しいタブで開きます",
    "Main color": "メインカラー",
    "Meta name": "メタ名",
    "Mode": "モード",
    "No default profile selected for this page, scoring not available.": "このページにはデフォルトのプロファイルが選択されていないため、スコアは利用できません。",
    "No documents found": "文書が見つかりません",
    "No profiles selected for this page, scoring not available.": "このページにはプロファイルが選択されていないため、スコアは利用できません。",
    "Not a valid CSS selector": "有効な CSS セレクタではありません",
    "Notification when the downtime ends": "ダウンタイム終了時の通知",
    "Number of external links": "外部リンクの数",
    "Number of incoming links": "リンクされている数",
    "Open details": "詳細を開く",
    "PDF Accessibility": "PDF アクセシビリティ",
    "Passwords do not match": "パスワードが一致していません",
    "Please add a Default Profile to your Page": "ページにデフォルトプロファイルを追加してください",
    "Please add a Profile to your Page": "ページにプロフィールを追加してください",
    "Please enter a valid color code": "有効なカラーコードを入力してください",
    "Please perform a PDF scan to see the results for the checks below": "以下のチェックの結果を確認するには、PDFスキャンを実行してください。",
    "Setup": "設定",
    "Show less of the code snippet": "コードスニペットを少なく表示する",
    "Show the full code snippet": "完全なコードスニペットを表示",
    "Statistics not activated. Page Views not available.": "Statisticsは有効になっていません。ページビューは利用できません。",
    "Subdomain": "サブドメイン",
    "Subdomain url": "サブドメイン URL",
    "Superfast - Don't use unless you know what you're doing": "超高速 - 何をしているのか分かっていない限り使用しないでください",
    "Text color": "テキストの色",
    "The optional epi server path": "オプションのepiサーバーパス",
    "The subdomain url to the CMS page": "CMS ページのサブドメイン URL",
    "This text must be under 1000 characters": "このテキストは1000文字未満である必要があります",
    "Two-Factor Authentication": "2要素認証",
    "Two-factor authentication is currently disabled": "2要素認証は現在無効になっています",
    "Two-factor authentication is currently enabled": "2要素認証は現在有効になっています",
    "URL needs to be valid, include http:// or https:// and be under 100 characters": "URL は有効で、http:// または https:// を含み、100 文字未満である必要があります。",
    "URL template": "URL テンプレート",
    "Unique broken links": "ユニークなリンク切れ",
    "Very fast - Be Cautious": "非常に速い - 注意してください",
    "WCAG 2.0": "WCAG 2.0",
    "WCAG 2.1": "WCAG 2.1",
    "Your color contrast is below the recommended score": "色のコントラストが推奨スコアを下回っています",
    "labels": "ラベル",
    "Acceptance Rate": "合格率",
    "Acceptance Rate Over Time": "時間の経過に伴う受け入れ率",
    "Acceptance Rate by Category": "カテゴリー別合格率",
    "Accepted cookies": "承認されたクッキー",
    "Add callback functions boilerplate": "コールバック関数の定型文を追加する",
    "Add cookie": "クッキーを追加",
    "Add empty EventListeners": "空のEventListenersを追加する",
    "Add empty callbacks": "空のコールバックを追加する",
    "Add event listeners boilerplate": "イベントリスナーの定型文を追加する",
    "Add web overlay lock": "ウェブオーバーレイロックを追加",
    "Alternative": "代替",
    "An overview of your customer's behavior with cookies on your website": "ウェブサイト上のCookieを使用した顧客の行動の概要",
    "Are you sure you want to ignore all selected misspellings?": "選択したスペルミスをすべて無視してもよろしいですか?",
    "Are you sure you want to mark this check as fixed on all pages?": "このチェックをすべてのページで修正済みとしてマークしてもよろしいですか?",
    "Are you sure you want to mark this check as fixed?": "このチェックを修正済みとしてマークしてもよろしいですか?",
    "Are you sure you want to mark this misspelling as fixed?": "このスペルミスを修正済みとしてマークしてもよろしいですか?",
    "Are you sure you want to mark this misspelling(s) as fixed?": "このスペルミスを修正済みとしてマークしてもよろしいですか?",
    "Basic": "基本",
    "Button color": "ボタンの色",
    "Button text color": "ボタンのテキストの色",
    "Case sensitive URLs": "大文字と小文字を区別するURL",
    "Changes wording from only essential cookies to explicit reject": "必須クッキーのみの文言から明示的に拒否する文言に変更",
    "Consent Log": "同意ログ",
    "Consent Overview": "同意の概要",
    "Consent results are sample data for demo purposes": "同意結果はデモ用のサンプルデータです",
    "Cookie Acceptance Rate": "クッキー受け入れ率",
    "Cookie Overview": "クッキーの概要",
    "Cookie description": "クッキーの説明",
    "Cookie duration": "クッキーの有効期間",
    "Cookie name": "クッキー名",
    "Enter a valid CSS selector": "有効なCSSセレクタを入力してください",
    "Essential": "不可欠",
    "Example 3": "例3",
    "Example 4": "例4",
    "Explicit reject option": "明示的な拒否オプション",
    "Give a short description of the purpose of the cookie": "クッキーの目的について簡単に説明します",
    "Give users more control over which categories of cookies to consent to": "ユーザーがどのカテゴリーのCookieに同意するかをより細かく制御できるようにする",
    "How long is the cookie active": "クッキーはどのくらいの期間有効ですか",
    "IP Address": "IPアドレス",
    "Ignore canonical URLs": "正規 URL を無視する",
    "Ignored by": "無視済み:",
    "Ignored date": "無視された日付",
    "Ignored misspellings on account": "アカウントのスペルミスを無視",
    "Include cookies": "クッキーを含める",
    "Insert CSS class or id selector": "CSSクラスまたはIDセレクタを挿入する",
    "Insert a CSS selector": "CSSセレクターを挿入する",
    "Limit or exclude": "制限または除外",
    "Limit search": "検索を制限する",
    "Link to your opt out page": "オプトアウトページへのリンク",
    "Make sure you use the correct setting": "正しい設定を使用していることを確認してください",
    "Mark check as fixed": "チェックを修正済みとしてマークする",
    "Marketing": "マーケティング",
    "No cookies found": "クッキーが見つかりません",
    "No misspellings have been ignored": "スペルミスは無視されません",
    "Opt out link": "オプトアウトリンク",
    "Original": "オリジナル",
    "Other": "他の",
    "Overall Acceptance Rate": "全体の合格率",
    "Overall acceptance rate": "全体の合格率",
    "Per category consent": "カテゴリごとの同意",
    "Please wait - Marking as fixed": "お待ちください - 修正済みとしてマーク",
    "Please wait - Marking word as fixed": "お待ちください - 単語を修正済みとしてマークしています",
    "Preferences": "環境設定",
    "Privacy regulation": "プライバシー規制",
    "Remove cookie": "クッキーを削除する",
    "Remove from Ignored": "無視から削除",
    "Remove this word from Ignored Misspellings": "この単語を無視されたスペルミスから削除する",
    "URL Structure": "URL構造",
    "Domain Overview": {
      "Topmenu": "ドメインの概要",
      "$$noContext": "ドメインの概要"
    },
    "Admin Settings": "管理者設定",
    "Case sensitivity": "大文字と小文字の区別",
    "Close project search and domain picker": "プロジェクト検索とドメインピッカーを閉じる",
    "Domain Settings": "ドメイン設定",
    "In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.": "最終的に、&lt;i&gt; タグと &lt;em&gt; タグは見た目は同じに見えます。ただし、意味はそれぞれ異なります。&lt;em&gt; は強調を表すために使用され、&lt;i&gt; タグはユーザーが斜体で設定したい単語や文 (外国語、単語の定義など) を表します。後者の場合は、代わりに CSS を使用する必要があります。",
    "Paste your image link (URL) here": "ここに画像リンク（URL）を貼り付けます",
    "Set up your domain": "ドメインを設定する",
    "The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.": "この修正で最も問題となるのは、&lt;i&gt; タグが、たとえば &lt;span&gt; (例: Font Awesome) ではなくアイコンに使用されている場合です。修正を適用した後にアイコンの見た目がおかしいことに気付いた場合は、これが原因である可能性があります。ただし、アイコンの &lt;i&gt; タグはクラスを使用する傾向があるため、クラスを変更せずにタグのみを変更するオプションを設定していることを確認してください。そうすれば、アイコンはそのまま残ります。",
    "The profile <strong>[[profileName]]</strong> is being used on the following pages below:": "プロファイル <strong>[[profileName]]</strong> は以下のページで使用されています:",
    "Add icon border": "アイコンの枠線を追加",
    "Adds a 3px wide border to the PageAssist widget icon": "PageAssistウィジェットアイコンに3ピクセル幅の境界線を追加します",
    "Bottom": "下部",
    "Clear search": "検索をクリア",
    "Ensures that PageAssist is never overlapped by other elements on the page": "PageAssistがページ上の他の要素と重ならないようにする",
    "Estonian": "エストニア語",
    "German": "ドイツ人",
    "Go to overlay with details": "詳細を含むオーバーレイに移動",
    "Guidelines for WCAG 2.2": "WCAG 2.2 のガイドライン",
    "Heartbeat Overview": "Heartbeatの概要",
    "How far the button is from the edge. Customization dependant on position.": "ボタンが端からどのくらい離れているか。位置に応じてカスタマイズします。",
    "Insert a valid host name": "有効なホスト名を入力してください",
    "Keep PageAssist on top": "PageAssistを常にトップに",
    "Left": "左",
    "Margin from edge in pixels": "端からの余白（ピクセル単位）",
    "Norwegian Bokmål": "ノルウェー語（ブークモール）",
    "Norwegian Nynorsk": "ノルウェー語（ニーノシュク）",
    "Right": "右",
    "Social Media visits": "ソーシャルメディア訪問",
    "Social media visits": "ソーシャルメディア訪問",
    "Sort column": "列を並べ替える",
    "Sort column ascending": "列を昇順に並べ替える",
    "Sort column descending": "列を降順に並べ替える",
    "Subgroup": "サブグループ",
    "Swedish": "スウェーデン語",
    "Toggle label text": "ラベルテキストを切り替える",
    "Top": "トップ",
    "Unique misspellings": "ユニークな誤字",
    "Unique misspellings found": "ユニークな誤字が見つかりました",
    "WCAG 2.2 Accessibility Compliance": "WCAG 2.2 アクセシビリティ準拠",
    "Area dynamic page": "エリアダイナミックページ",
    "Employeepage": "従業員ページ",
    "Language id": "言語ID",
    "Newspage": "ニュースページ",
    "Standard": "標準",
    "Standard for http(s)://edit.domain.tld/inz/<path>. Alternative for http(s)://domain.tld/<path>/edit.": "http(s)://edit.domain.tld/inz/<path> の標準。http(s)://domain.tld/<path>/edit の代替。",
    "URL format": "URL 形式",
    "Export both internal and external links": "内部リンクと外部リンクの両方をエクスポートする",
    "Export only external links": "外部リンクのみをエクスポートする",
    "Export only internal links": "内部リンクのみをエクスポートする",
    "Overview of all the enabled modules for this domain": "このドメインで有効なすべてのモジュールの概要",
    "Search for a predefined policy in the Policy Exchange Center": "Policy Exchange Centerで定義済みのポリシーを検索する",
    "A log of all the consents given by your website visitors": "ウェブサイト訪問者が与えたすべての同意のログ",
    "Action required. Click to resolve issue.": "アクションが必要です。クリックして問題を解決してください。",
    "Complete": "完了",
    "Cookie Overview buttons": "Cookieの概要ボタン",
    "Cookie Overview saved": "Cookieの概要を保存しました",
    "Cookie added by user": "ユーザーがCookieを追加しました",
    "Cookie domain": "クッキードメイン",
    "Cookie not found": "クッキーが見つかりません",
    "Cookie not published. Missing:": "Cookie は公開されていません。不足しています:",
    "Could not save invalid form": "無効なフォームを保存できませんでした",
    "Disables interactions on website until the visitor makes a consent choice. Be aware that locking interactions prior to consent may not be compliant with certain regional privacy regulations.": "訪問者が同意の選択をするまで、Web サイトでのインタラクションを無効にします。同意前にインタラクションをロックすると、特定の地域のプライバシー規制に準拠しない可能性があることに注意してください。",
    "Finish the setup by adding your cookies": "クッキーを追加してセットアップを完了します",
    "For Cookie setup please go to your <b>Data Privacy</b> module.<br> Manual cookies can be set up or edited any time and are not related to script setup.": "Cookie の設定については、<b>データ プライバシー</b> モジュールに移動してください。<br> 手動 Cookie はいつでも設定または編集でき、スクリプトの設定とは関係ありません。",
    "GDPR requires that companies provide descriptions on their website for all cookies that are used.": "GDPR では、企業は使用するすべての Cookie について自社の Web サイトで説明を提供することが義務付けられています。",
    "Give an overview of the cookies used on your website. Finish a domain scan or add them manually.": "ウェブサイトで使用されている Cookie の概要を示します。ドメイン スキャンを完了するか、手動で追加します。",
    "Id": "ID",
    "Include a link to your webpage's privacy policy": "ウェブページのプライバシーポリシーへのリンクを含める",
    "It looks like the previously set up cookie was not found in this scan. It might be that the cookie was removed or our scan just couldn’t detect it.": "以前設定された Cookie がこのスキャンでは見つからなかったようです。Cookie が削除されたか、スキャンで検出できなかった可能性があります。",
    "I’ll do it later": "後で行う",
    "Keep": "保持する",
    "Leave without saving": "保存せずに終了",
    "Link to Privacy Policy": "プライバシーポリシーへのリンク",
    "Link to your Cookie Overview": "Cookieの概要へのリンク",
    "Link to your Privacy Policy": "プライバシーポリシーへのリンク",
    "Link where customers can opt out of sale of personal data. Mandatory for websites under the CCPA regulation.": "顧客が個人データの販売をオプトアウトできるリンク。CCPA 規制の対象となる Web サイトでは必須です。",
    "List of checks with and without issues categorized by [[level]] guidelines": "[[level]] ガイドライン別に分類された問題ありと問題なしのチェックのリスト",
    "Manage Cookie": "Cookieの管理",
    "On-demand scan unavailable": "オンデマンドスキャンは利用できません",
    "Pages needing to be fixed": "修正が必要なページ",
    "Save cookies": "クッキーを保存する",
    "Save existing cookies": "既存のクッキーを保存する",
    "Save this overview to publish completed cookies to the Cookie Overview.": "この概要を保存すると、完了した Cookie が Cookie の概要に公開されます。",
    "Save your page before leaving to keep your progress and publish the completed cookies.": "進行状況を保存し、完了したクッキーを公開するには、終了する前にページを保存してください。",
    "Scan History": "スキャン履歴",
    "Scan Information": "スキャン情報",
    "Scan info": "スキャン情報",
    "Source": "ソース",
    "This feature is not available on a demo account.": "この機能はデモアカウントでは利用できません。",
    "This page has been rescanned since the latest full scan.": "このページは最新の完全スキャン以降に再スキャンされました。",
    "This scan feature is not available on a demo account": "このスキャン機能はデモアカウントではご利用いただけません",
    "UUID": "UUID",
    "You need to include a name in order to save your cookies.": "クッキーを保存するには名前を入力する必要があります。",
    "[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.": "[[total]] ページ。1 つの統合ビューから、Web サイト全体のすべてのコンテンツの問題を優先順位付けして修正します。",
    "Distribution of policies with matches across priority levels": "優先度レベルに一致するポリシーの配布",
    "Copied!": "コピーしました！",
    "Copy": "コピー",
    "Default language*": "デフォルト言語*",
    "Don't forget to copy and update the script on your website!": "ウェブサイトのスクリプトをコピーして更新することを忘れないでください。",
    "Included languages*": "含まれる言語*",
    "Loading Data": "データのロード中",
    "Loading...": "読み込み中...",
    "No support": "サポートなし",
    "Open PageAssist script settings": "PageAssistスクリプト設定を開く",
    "PageAssist script settings": "PageAssist スクリプト設定",
    "Please add the script as close to the open HEAD-tag as possible": "スクリプトはできるだけHEADタグのはじめ近くに追加してください",
    "Please wait - loading": "お待ちください - 読み込み中",
    "Press Ctrl-C": "Ctrl+Cを押します",
    "Press ⌘-C": "⌘-Cを押します",
    "This chart shows how many percent of visitors accepted the various categories of cookies on your website. Visitors who did not make a consent choice on the cookie banner are not counted": "このグラフは、ウェブサイト上のさまざまなカテゴリのCookieを承認した訪問者の割合を示しています。Cookieバナーで同意を選択しなかった訪問者はカウントされません。",
    "Visitor percentage": "訪問者の割合",
    "Consent Manager script settings": "同意マネージャのスクリプト設定",
    "Open consent manager script settings": "同意マネージャーのスクリプト設定を開く",
    "Scan your website for any data privacy issues that could be present": "ウェブサイトをスキャンして、データプライバシーの問題がないか確認します",
    "Please enter a full UUID string. Empty or partial strings will not yield any results.": "完全な UUID 文字列を入力してください。空または部分的な文字列では結果は生成されません。",
    "UUID can only be searched by entering the full value": "UUIDは完全な値を入力してのみ検索できます",
    "Average Cumulative Layout Shift": "平均累積レイアウトシフト",
    "Average Largest Contentful Paint": "平均的なLargest Contentful Paint",
    "Average Speed Index": "平均的なSpeed Index",
    "Average Total Blocking Time": "平均的なTotal Blocking Time",
    "CMS Path": "CMS パス",
    "Click here or drag a rule to this area": "ここをクリックするか、ルールをこの領域にドラッグします",
    "Cumulative Layout Shift": "累積レイアウトシフト",
    "LCP": "LCP",
    "Relevant for": "関連分野",
    "SI": "SI",
    "TBT": "TBT",
    "[[avg]]": "[[avg]]",
    "[[label]]: [[value]]": "[[label]]: [[value]]",
    "Content Authoring": "コンテンツ作成",
    "Responsibilities": "責任",
    "Responsibility": "責任",
    "UX Design": "UXデザイン",
    "Visual Design": "ビジュアルデザイン",
    "Version [[version]]": "バージョン [[version]]",
    "Accessibility score": "アクセシビリティスコア",
    "Comparison to average": "平均との比較",
    "Industry average": "業界平均",
    "No scores available for this domain": "このドメインのスコアはありません",
    "Professional services": "プロフェッショナルサービス",
    "Quality Assurance score": "品質保証スコア",
    "SEO score": "SEOスコア",
    "Scores": "スコア",
    "The average score for domains within your industry.": "業界内のドメインの平均スコア。",
    "Add language": "言語を追加",
    "Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.": "ポリシー <strong>[[policyName]]</strong> をアーカイブしてもよろしいですか? このポリシーに一致するものは検索されなくなります。 後でいつでもポリシーをアーカイブ解除できます。",
    "Are you sure you want to set these documents as reviewed?": "これらのドキュメントをレビュー済みとして設定してもよろしいですか?",
    "Clear selection": "選択をクリアする",
    "Delete language -": "言語を削除 -",
    "Delete the language tab - [[language]]": "言語タブを削除します - [[language]]",
    "Discovered": "発見された",
    "Doing this will result in removing the translations in the selected language from both your Cookie Overview and the actual banner itself.<br></br><strong>You will need to add the descriptions again when you re-add the selected language.</strong>": "これを行うと、Cookie の概要と実際のバナー自体の両方から、選択した言語の翻訳が削除されます。<br></br><strong>選択した言語を再度追加するときに、説明を再度追加する必要があります。</strong>",
    "Don't forget to update your languages in Script Setup!": "スクリプト設定で言語を更新することを忘れないでください。",
    "Edit this policy rule later under the “Add rule to policy” tab.": "このポリシー ルールは、後で「ポリシーにルールを追加」タブで編集します。",
    "Front-end Development": "フロントエンド開発",
    "How to setup this policy:": "このポリシーを設定する方法:",
    "Insert word length": "単語の長さを挿入",
    "Inspect page with browser extension": "ブラウザ拡張機能でページを検査する",
    "Mark all as reviewed": "すべてレビュー済みとしてマーク",
    "Mobile only": "モバイルのみ",
    "New policy": "新しいポリシー",
    "Please add at least one language": "少なくとも1つの言語を追加してください",
    "Please set the default language": "デフォルトの言語を設定してください",
    "Please wait - Adding word to ignored list": "お待ちください - 無視リストに単語を追加しています",
    "Please wait - Adding words to ignored list": "お待ちください - 無視リストに単語を追加しています",
    "Remove rule from policy": "ポリシーからルールを削除する",
    "Request PDF accessibility check for all": "すべてのPDFアクセシビリティチェックをリクエスト",
    "Request Remedition quote for all": "すべての修復見積りをリクエストする",
    "Script": "スクリプト",
    "Select a group": "グループを選択",
    "Select a shape": "図形を選択",
    "Select languages": "言語を選択",
    "Select the default language": "デフォルトの言語を選択",
    "To finish setting up your manual Cookie Overview go to the selected domain’s": "マニュアルでのCookie概要の設定を完了するには、選択したドメインの",
    "Unignore this check": "このチェックを無視しない",
    "WCAG 2.1 (Level AA) Mobile": "WCAG 2.1 (レベル AA) モバイル",
    "WCAG 2.1 (Level AAA) Mobile": "WCAG 2.1 (レベル AAA) モバイル",
    "Are you sure you want to delete label: [[label]] ?": "ラベル [[label]] を削除してもよろしいですか?",
    "Business services": "ビジネスサービス",
    "CMS template is configured for this domain": "このドメインにはCMSテンプレートが設定されています",
    "Consent Manager configuration": "同意マネージャの設定",
    "Consent Manager language*": "同意マネージャーの言語*",
    "Consent Manager pop-up position on Page": "ページ上の同意マネージャのポップアップの位置",
    "Consent Manager pop-up setup": "同意マネージャのポップアップ設定",
    "Construction/industrial": "建設・工業",
    "Consumer services": "消費者サービス",
    "Entertainment/Leisure": "エンターテイメント/レジャー",
    "Financial services": "金融業務",
    "German (Germany)": "ドイツ語（ドイツ）",
    "Healthcare": "ヘルスケア",
    "Label used in the groups below. Please edit or delete the groups and try again.": "以下のグループで使用されているラベルです。グループを編集または削除して、もう一度お試しください。",
    "Law enforcement": "法執行",
    "Legal": "法律上",
    "Non-profit": "非営利",
    "Real-estate": "不動産",
    "Retail/wholesale": "小売卸売",
    "Spanish (Spain)": "スペイン語（スペイン）",
    "Technology": "テクノロジー",
    "Utilities/Natural resources": "公共事業/天然資源",
    "Widget Design": "ウィジェットデザイン",
    ":": ":",
    "Accessibility issue": "アクセシビリティの問題",
    "Add reason (optional)": "理由を追加（オプション）",
    "All pages with this accessibility issue": "このアクセシビリティの問題があるすべてのページ",
    "All pages with this data privacy issue": "このデータプライバシー問題のあるすべてのページ",
    "Alternatively, click the button below.": "または、下のボタンをクリックしてください。",
    "Are you sure you want to mark this  as fixed?": "これを修正済みとしてマークしますか?",
    "Are you sure you want to mark this  as ignored?": "これを無視としてマークしますか?",
    "Are you sure you want to mark this  as not fixed?": "これを未修正としてマークしますか?",
    "Are you sure you want to mark this check as ignored?": "このチェックを無視としてマークしますか?",
    "Are you sure you want to mark this issue as ignored?": "この問題を無視としてマークしますか?",
    "Are you sure you want to unignore this ?": "これを無視解除しますか?",
    "Average time (comp.)": "平均時間（比較）",
    "Bounce rate (comp.)": "直帰率（比較）",
    "Campaign visits": "キャンペーン訪問",
    "Code": "コード",
    "Confirmation required": "確認が必要です",
    "Current password": "現在のパスワード",
    "Data privacy issue": "データプライバシーの問題",
    "Data violations": "データ違反",
    "Date found": "発見日",
    "Downloads (comp.)": "ダウンロード（まとめ）",
    "Entries (comp.)": "エントリー (比較)",
    "Events": "イベント",
    "Exits (comp.)": "離脱 (比較)",
    "Export visitors browsers": "訪問者のブラウザをエクスポート",
    "Export visitors devices": "訪問者のデバイスをエクスポート",
    "Export visitors language": "訪問者の言語をエクスポート",
    "Export visitors locations": "訪問者の所在地をエクスポート",
    "Export visitors operating systems": "訪問者のオペレーティング システムをエクスポートする",
    "Export visitors organization": "訪問者の組織をエクスポート",
    "Found on page": "ページで見つかりました",
    "Group name": "グループ名",
    "Image URL": "画像URL",
    "Issue details": "問題の詳細",
    "Issue not found": "問題が見つかりません",
    "Legacy Browser Service changed": "レガシーブラウザサービスが変更されました",
    "Look up in Google": "Googleで調べる",
    "Mark as reviewed": "レビュー済みとしてマーク",
    "Maximum word length to search for": "検索する単語の最大長",
    "Names": "名前",
    "No pages were found. Try searching for the page URL instead of the page title.": "ページが見つかりませんでした。ページタイトルの代わりにページ URL を検索してみてください。",
    "Open browser extension": "ブラウザ拡張機能を開く",
    "Open issue page": "問題ページを開く",
    "Open misspelling page": "誤字ページを開く",
    "Other checks for this snippet": "このスニペットのその他のチェック",
    "Pages with accessibility issues": "アクセシビリティの問題があるページ",
    "Pages with policy issues": "ポリシーに問題があるページ",
    "Pageviews (comp.)": "ページビュー（比較）",
    "Percentage shows number of pages that are compliant with all Policies": "パーセンテージは、すべてのポリシーに準拠しているページの数を示します。",
    "Percentage shows number of pages that are compliant with all QA checks": "パーセンテージは、すべてのQAチェックに準拠しているページの数を示します。",
    "Please enter a valid date!": "有効な日付を入力してください！",
    "Please wait - Adding word to all dictionaries": "お待ちください - すべての辞書に単語を追加しています",
    "Press to toggle additional rows.": "押すと追加の行が切り替わります。",
    "Puppeteer Browser Service changed": "Puppeteer ブラウザ サービスが変更されました",
    "Reason:&nbsp;": "理由:",
    "Remember to add this source code exclude to your domain(s) through the Edit Domain screen.": "このソース コード除外項目をドメイン編集画面からドメインに追加することを忘れないでください。",
    "Remove review": "レビューを削除",
    "Repeat new password": "新しいパスワードを繰り返し入力してください",
    "Sorry, this page was not found. The issue must have been resolved.": "申し訳ありませんが、このページは見つかりませんでした。問題は解決されているはずです。",
    "The date cannot be in the future": "日付は未来にはできません",
    "The end date cannot be before the start date": "終了日は開始日より前に設定できません",
    "The settings form contains incorrect data. Close the form anyway?": "設定フォームに誤ったデータが含まれています。それでもフォームを閉じますか?",
    "The start and end date cannot be in the future, please enter the compare dates again": "開始日と終了日は将来の日付にできません。比較日を再度入力してください。",
    "This issue is marked as fixed.": "この問題は修正済みとしてマークされています。",
    "This issue is marked as ignored.": "この問題は無視としてマークされています。",
    "This issue is marked as reviewed.": "この問題はレビュー済みとしてマークされています。",
    "This word has been added to your dictionary": "この単語は辞書に追加されました",
    "To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class=\\\"text-bold\\\">My Exports.</span>": "現在の進行状況を確認するには、メイン ページの右上にあるユーザー アバターをクリックし、<span class=\\\"text-bold\\\">[マイ エクスポート]</span> を選択します。",
    "Total unique downloads (comp.)": "合計ユニークダウンロード数（比較）",
    "Unique downloads (comp.)": "ユニークダウンロード数（比較）",
    "Visitors browsers export": "訪問者のブラウザのエクスポート",
    "Visitors devices export": "訪問者のデバイスのエクスポート",
    "Visitors language export": "訪問者の言語エクスポート",
    "Visitors locations export": "訪問者の所在地のエクスポート",
    "Visitors operating systems export": "訪問者のオペレーティングシステムのエクスポート",
    "Visitors organization export": "訪問者組織のエクスポート",
    "Visits (comp.)": "訪問数（比較）",
    "WCAG 2.1 (Level A) Mobile": "WCAG 2.1 (レベル A) モバイル",
    "Your export is currently being generated.": "エクスポートは現在生成中です。",
    "+ ' + (report.targets.length - maxTargets) + ' more": "+ さらに ' + (report.targets.length - maxTargets) + ' 件",
    "Accessibility Checklist (WCAG 2.0)": "アクセシビリティ チェックリスト (WCAG 2.0)",
    "Accessibility Checklist (WCAG 2.1)": "アクセシビリティ チェックリスト (WCAG 2.1)",
    "Accessibility Checklist (WCAG 2.2)": "アクセシビリティ チェックリスト (WCAG 2.2)",
    "Average no. of results pages viewed": "閲覧された結果ページの平均数",
    "Checklist": "チェックリスト",
    "Email *": "Eメール *",
    "Event actions": "イベントアクション",
    "Event categories": "イベントカテゴリー",
    "Event names": "イベント名",
    "First name *": "名前 *",
    "Last name *": "姓 *",
    "Search term": "検索ワード",
    "Search terms": "検索ワード",
    "Search terms with no results": "結果がない検索語",
    "Site Search": "サイト内検索",
    "Site Search - Search Terms": "サイト検索 - 検索用語",
    "Site Search No Results Search Terms": "サイト内検索 結果なし 検索用語",
    "Switch between chart and table": "グラフと表を切り替える",
    "Table": "テーブル",
    "more": "さらに",
    "Accessibility checks update": "アクセシビリティチェックの更新",
    "Account is under maintenance": "アカウントはメンテナンス中です",
    "Add internal URL": "内部URLを追加",
    "Add the name of the platform or company who provides this cookie.": "このクッキーを提供するプラットフォームまたは会社の名前を追加します。",
    "All PDFs": "すべてのPDF",
    "All scheduled reports": "すべてのスケジュールされたレポート",
    "An error has occurred - please try again": "エラーが発生しました。もう一度お試しください",
    "Are you sure you want mark as fixed": "本当に修正済みとしてマークしますか?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary for all languages?": "単語 <strong>[[word]]</strong> をすべての言語の辞書に追加してもよろしいですか?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary?": "単語 <strong>[[word]]</strong> を辞書に追加してもよろしいですか?",
    "Are you sure you want to confirm the word <strong>[[word]]</strong> as misspelling?": "単語 <strong>[[word]]</strong> の記載が間違っていることを確定しますか?",
    "Are you sure you want to ignore the misspelling <strong>[[word]]</strong> for all languages?": "すべての言語で誤字 <strong>[[word]]</strong> を無視しますか?",
    "Are you sure you want to mark the misspelling <strong>[[word]]</strong> as fixed?": "誤字 <strong>[[word]]</strong> を修正済みとしてマークしますか?",
    "Are you sure you want to remove the Default label?": "デフォルト ラベルを削除しますか?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong>?": "ポリシー <strong>[[policyName]]</strong> を実行しますか?",
    "Bar chart representing data": "データを表す棒グラフ",
    "Bar line chart representing": "棒グラフを表示",
    "Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.": "装飾的な画像の場合、空の alt 属性で十分かつ適切な場合があることに注意してください。",
    "Bubble chart representing data": "データを表すバブルチャート",
    "Clear the field": "フィールドをクリア",
    "Close submenu": "サブメニューを閉じる",
    "Contact Support": "サポート問い合わせ先",
    "Cookie platform": "クッキープラットフォーム",
    "Current password is incorrect please try again": "現在のパスワードが間違っています。もう一度お試しください。",
    "Doughnut chart representing data": "データを表すドーナツグラフ",
    "Enable Cookieless Tracking": "Cookieなしのトラッキングを有効にする",
    "Errors and": "エラーと",
    "Errors and Warnings": "エラーと警告",
    "Events filter buttons": "イベントフィルターボタン",
    "Every 12 weeks": "12週間ごと",
    "Every 2 weeks": "2週間ごと",
    "Every 4 weeks": "4週間ごと",
    "Every 8 weeks": "8週間ごと",
    "Frequency": "頻度",
    "Image details": "画像の詳細",
    "Image metadata": "画像のメタデータ",
    "Image preview": "画像プレビュー",
    "Inventory image preview": "インベントリ画像プレビュー",
    "It seems like we are experience some issues with the page you are looking at.": "閲覧中のページで問題が発生しているようです。",
    "It seems like your computer is disconnected from the internet.": "コンピュータがインターネットから切断されているようです。",
    "Line chart representing data": "データを表す折れ線グラフ",
    "List of received reports": "受信したレポートのリスト",
    "Metadata and pages": "メタデータとページ",
    "Metadata property": "メタデータプロパティ",
    "My scheduled reports": "スケジュールされたレポート",
    "No date range selected": "日付範囲が選択されていません",
    "Norwegian": "ノルウェー語",
    "Only Errors": "エラーのみ",
    "Only errors": "エラーのみ",
    "Open dropdown with filters": "フィルター付きのドロップダウンを開く",
    "Open metadata view": "メタデータビューを開く",
    "Open submenu with filters": "フィルター付きのサブメニューを開く",
    "Pages that contain the Email": "メールを含むページ",
    "Percentage shows the average compliance score across all pages on the domain": "パーセンテージはドメイン上のすべてのページの平均コンプライアンススコアを示します",
    "Pie chart representing data": "データを表す円グラフ",
    "Platform": "プラットホーム",
    "Please contact the support if this issue keeps happening": "この問題が引き続き発生する場合はサポートにお問い合わせください",
    "Please refresh the browser when your computer is online again.": "コンピュータが再びオンラインになったら、ブラウザを更新してください。",
    "Please try again later": "後でもう一度お試しください",
    "Press to remove the label.": "ラベルを外す",
    "Puppeteer 20": "Puppeteer 20",
    "Remove internal URL": "内部URLを削除する",
    "Scan all pages for cookies": "すべてのページでCookieをスキャンする",
    "Schedule this report": "このレポートをスケジュールする",
    "Search in options": "オプションで検索",
    "Show HTML snippet details": "HTMLスニペットの詳細を表示",
    "Show labels": "ラベルを表示",
    "Show less of the url snippet": "URLスニペットを少なく表示する",
    "Show the full url snippet": "完全なURLスニペットを表示",
    "Showing": "表示中",
    "The average compliance score for this module for domains from other organizations within your industry:": "業界内の他の組織のドメインと比較したこのモジュールの平均コンプライアンス スコア:",
    "Unsubscribe from report": "レポートの購読を解除する",
    "Warnings": "警告",
    "We export up to a maximum of 1000 rows": "最大1000行までエクスポートできます",
    "We recommend that you have an alt attribute with relevant content on all image tags.": "すべての画像タグに、関連するコンテンツを含む alt 属性を設定することをお勧めします。",
    "You have images missing an alt attribute.": "alt 属性が欠落している画像があります。",
    "[[name]] Remove": "[[name]] を削除",
    "[[target]]": "[[目標]]",
    "default": "デフォルト",
    "[[label]]": "[[ラベル]]",
    "% of visitors staying after a search": "検索後に滞在する訪問者の割合",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.": "WCAG 2.1 AA、Section 508、HHS、または PDF/UA アクセシビリティ標準に準拠するためのドキュメント修復は、当社の関連会社である NetCentric Technologies, Inc. によって行われます。お客様の国の規制フレームワーク要件により、当社が直接お客様のためにドキュメント修復を調整することはできませんが、お見積りと修復サービスについては、dherr@allyant.com まで直接 NetCentric にお問い合わせください。修復に関するすべての契約は、お客様と NetCentric の間で締結され、NetCentric の利用規約とプライバシー ポリシーの対象となり、米国、カナダ、オーストラリア、エジプトを含むがこれらに限定されない第三者および第三国へのデータ転送が発生することにご注意ください。",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. Upon completion of the work, NetCentric will also provide a compliance report. NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy.": "WCAG 2.1 AA、Section 508、HHS、または PDF/UA アクセシビリティ標準に準拠するためのドキュメントの修正は、当社の関連会社である NetCentric Technologies, Inc. によって行われます。修正については、NetCentric と連携してドキュメントを確認し、修正の固定価格を提示します。作業が完了すると、NetCentric はコンプライアンス レポートも提供します。NetCentric は、自己説明的ではない画像に必要な代替テキスト (Alt-Text) があるか、ドキュメントを修正するために必要な関連追加情報があるかどうかをお知らせします。修正に関するすべての契約は、お客様と NetCentric の間で締結され、NetCentric の利用規約とプライバシー ポリシーに従うことにご注意ください。",
    "Japanese": "日本語",
    "Report Administration": "レポート管理",
    "Submit": "提出する",
    "You have [[domains]] domain(s) on your account": "アカウントには [[domains]] 個のドメインがあります",
    "Find domains by searching for the title or URL": "タイトルまたは URL を検索してドメインを見つける",
    "Industry average score": "業界平均スコア",
    "Proceed to add one more check": "チェックをもう 1 つ追加してください",
    "Readability test (for English pages only)": "可読性テスト（英語ページのみ）",
    "Request quote for more pages": "さらに多くのページの見積もりをリクエストする",
    "Request quote for more profiles": "詳しいプロフィールについては見積もりをリクエストしてください",
    "Search for domain": "ドメインを検索する",
    "The user does not have access to view this domain and any reports associated with it": "ユーザーには、このドメインとそれに関連付けられたレポートを表示するアクセス権がありません。",
    "Update all domain groups": "すべてのドメイン グループを更新する",
    "Update domain group": "ドメイングループを更新する",
    "Updating a group can take more than 30 minutes. During the operation you will not be able to create and update groups.": "グループの更新には 30 分以上かかる場合があります。操作中はグループの作成と更新はできません。",
    "WCAG 2.2 (Level A)": "WCAG 2.2 (レベル A)",
    "WCAG 2.2 (Level A) Mobile": "WCAG 2.2 (レベル A) モバイル",
    "WCAG 2.2 (Level AA)": "WCAG 2.2 (レベル AA)",
    "WCAG 2.2 (Level AA) Mobile": "WCAG 2.2 (レベル AA) モバイル",
    "WCAG 2.2 (Level AAA)": "WCAG 2.2 (レベル AAA)",
    "WCAG 2.2 (Level AAA) Mobile": "WCAG 2.2 (レベル AAA) モバイル",
    "You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button \\\"Request quote for more pages\\\" and someone on our team will be in touch.": "現在のプランのパフォーマンス ページの最大数に達しました。<br/><br/>追加ページの料金オプションについて問い合わせるには、「追加ページの見積もりをリクエスト」ボタンを押してください。チームの担当者が対応します。連絡する。",
    "You must perform a manual review of the page to confirm if this issue is present": "この問題が存在するかどうかを確認するには、ページを手動でレビューする必要があります。",
    "Accessibility Checklist (QUALWEB)": "アクセシビリティ チェックリスト (QUALWEB)",
    "Accessibility checks cannot be ignored for domain groups. To ignore this check you must do it for the entire domain.": "ドメイン グループではアクセシビリティ チェックを無視できません。このチェックを無視するには、ドメイン全体に対してチェックを実行する必要があります。",
    "Accessibility checks cannot be unignored for domain groups. To unignore this check you must do it for the entire domain.": "ドメイン グループではアクセシビリティ チェックを無視解除できません。このチェックを無視解除するには、ドメイン全体に対して実行する必要があります。",
    "Check your spelling or try a shorter query.": "スペルを確認するか、クエリを短くしてください。",
    "Guidelines for QUALWEB": "QUALWEBのガイドライン",
    "Language not supported": "言語はサポートされていません",
    "No domains found.": "ドメインが見つかりません。",
    "QUALWEB Accessibility Compliance": "QUALWEB アクセシビリティコンプライアンス",
    "QualWeb (Level A)": "QualWeb (レベル A)",
    "QualWeb (Level AA)": "QualWeb (レベル AA)",
    "Score could not be generated": "スコアを生成できませんでした",
    "Searching <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>": "<span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span> を検索しています",
    "The language of the page is not recognized as English. The Flesch-Kincaid test only works for English language. Change to the LIX test if you wish to generate scores for non-English pages.": "ページの言語は英語として認識されません。Flesch-Kincaid テストは英語でのみ機能します。英語以外のページのスコアを生成する場合は、LIX テストに変更してください。",
    "We could not generate an accurate score for these pages. This is typically either due to the text on a page being too short, too long, or our web crawler not picking up any text at all.": "これらのページについては正確なスコアを生成できませんでした。これは通常、ページ上のテキストが短すぎるか長すぎるか、または Web クローラーがテキストをまったく取得していないことが原因です。",
    "Are you sure you want to add word [[word]] to all dictionaries": "単語 [[word]] をすべての辞書に追加してもよろしいですか?",
    "Are you sure you want to add word [[word]] to dictionary?": "単語 [[word]] を辞書に追加してもよろしいですか?",
    "Are you sure you want to confirm the word [[word]] as misspelling?": "単語 [[word]] のスペルが間違っていることを確認してもよろしいですか?",
    "Are you sure you want to ignore the misspelling [[word]] for all languages?": "すべての言語でスペルミス [[word]] を無視してもよろしいですか?",
    "Are you sure you want to mark the misspelling [[word]] as fixed?": "スペルミス [[word]] を修正済みとしてマークしてもよろしいですか?",
    "Cannot forward more": "これ以上転送できません",
    "Choose Date": "日付を選択",
    "Compare": "比較する",
    "Confirmed errors only": "確認されたエラーのみ",
    "Exclude checks that require manual review": "手動レビューが必要なチェックを除外する",
    "If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.": "このオプションをオンにすると、ドメイン スキャンには、エラーとして自動的に識別できるアクセシビリティ チェックのみが含まれます。手動によるレビューが必要なチェックは除外されます。",
    "One month back": "1か月前",
    "One month forward": "1か月後",
    "Press to choose the end day": "終了日を選択するには押してください",
    "Press to choose the start day": "開始日を選択するには押してください",
    "Remove compare range dates": "比較範囲の日付を削除する",
    "The date cannot be in the future.": "日付は将来の日付にはできません。",
    "Toggle the datepicker": "日付ピッカーを切り替える",
    "Add Policy with AI": "AIでポリシーを追加",
    "Consolidated Reports": "連結レポート",
    "Created with AI policy assistant": "AIポリシーアシスタントで作成",
    "Policy Assistant": "政策アシスタント",
    "Sparkle icon": "スパークルアイコン",
    "The Policy Assistant runs on Google Vertex AI, which can make mistakes.": "ポリシー アシスタントは Google Vertex AI 上で実行されますが、間違いが発生する可能性があります。",
    "You have reached the maximum number of Performance profiles in your current plan.<br/><br/>To inquire about pricing options for additional profiles, please press the button \\\"Request quote for more profiles\\\" and someone on our team will be in touch.": "現在のプランのパフォーマンス プロファイルの最大数に達しました。<br/><br/>追加のプロファイルの価格オプションについて問い合わせるには、[追加のプロファイルの見積もりを依頼] ボタンを押してください。弊社のチーム担当者からご連絡いたします。",
    "You are about to perform a scan of <span class='text-link'>[[pageTitle]]</span> using the profile <span class='text-link'>[[profileName]]</span>.<br>The scan can take a few minutes to finalise, depending on the size of the page.<br><br>Do you want to continue?": "プロファイル <span class='text-link'>[[profileName]]</span> を使用して、<span class='text-link'>[[pageTitle]]> のスキャンを実行しようとしています。<br>ページのサイズによっては、スキャンが完了するまでに数分かかることがあります。<br><br>続行しますか?",
    "Doesn't scan automatically": "自動的にスキャンされない",
    "Scans automatically": "自動的にスキャン",
    "with this": "これで",
    "with this PDF": "このPDFで",
    "with this archive file": "このアーカイブファイル",
    "with this slide": "このスライドで",
    "with this spreadsheet": "このスプレッドシートで",
    "with this text file": "このテキストファイルで",
    "Errors must be fixed for compliance.": "コンプライアンスのためにエラーを修正する必要があります。",
    "Issues to Fix": "修正すべき問題",
    "Issues to Review": "検討すべき問題",
    "Reviews require manual judgement.": "レビューには手動の判断が必要です。",
    "Warnings are likely to be issues, but they require manual investigation.": "警告は問題となる可能性が高いですが、手動での調査が必要です。",
    "1 content": "1 コンテンツ",
    "1 misspelling ignored across all domains": "1 件のスペルミスがすべてのドメインで無視されました",
    "1 new cookie on": "新しいクッキー1個",
    "1 page": "1ページ",
    "1 page with one or more failing checks {{guideline}}": "1 つ以上のチェックに失敗したページが 1 つあります {{guideline}}",
    "1 page with one or more ignored checks {{guideline}}": "1 つ以上のチェックが無視されたページ {{guideline}}",
    "1 policy found": "1 件のポリシーが見つかりました",
    "1 results": "1件の結果",
    "1 visit": "1回の訪問",
    "1 word added across all domains": "すべてのドメインに1語追加されました",
    "One word found": "1つの単語が見つかりました",
    "You have 1 user on your account": "あなたのアカウントには1人のユーザーがいます",
    "Accessibility Compliance Scan": "アクセシビリティコンプライアンススキャン",
    "Broken Links on Sitemap": "サイトマップ上のリンク切れ",
    "Broken links on sitemap": "サイトマップ上のリンク切れ",
    "Close Spotlight Search.": "Spotlight 検索を閉じます。",
    "Requested": "リクエスト",
    "Toggle Spotlight Search.": "Spotlight 検索を切り替えます。",
    "WCAG 2.2": "WCAG 2.2",
    "Newest": {
      "Exchange Center Sort by option": "最新"
    },
    "(<strong><i>[[issues]]</i></strong> unique problems)": "（<strong><i>[[issues]]></i></strong> 個の固有の問題）",
    "(<strong>[[issues]]</strong> unique problems)": "（<strong>[[issues]]></strong> 個の固有の問題）",
    "<div class=\\\\'pull-left\\\\'>' + ('Heatmaps": "<div class=\\\\'pull-left\\\\'>' + ('ヒートマップ",
    "<div class=\\\\'pull-left\\\\'>' + ('History Center": "<div class=\\\\'pull-left\\\\'>' + ('歴史センター",
    "<p class='warning'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached the limit of the amount of profiles allowed on your account ([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan or archive some profiles before restoring this one.</p>": "<p class='warning'>Acquia Web Governance はプロファイルを復元できません。</p><p>アカウントで許可されているプロファイル数の上限（[[maxProfiles]] 個）に達しました。このプロファイルを復元する前に、プランにプロファイルを追加するか、一部のプロファイルをアーカイブするよう、弊社の営業チームにお問い合わせください。</p>",
    "<strong>' + (links.total | monNumber) + '</strong> ' + ('link": "<strong>' + (links.total | monNumber) + '</strong> ' + ('link",
    "<strong>' + (pages.total | monNumber) + '</strong> ' + ('page": "<strong>' + (pages.total | monNumber) + '</strong> ' + ('ページ",
    "A \\\"skip to content\\\" link at the start of the webpage allows screen reader and keyboard-only users to skip over potentially non-relevant links at the start of your webpage and immediately access the main content.": "ウェブページの先頭にある「コンテンツにスキップ」リンクを使用すると、スクリーン リーダーやキーボードのみを使用するユーザーは、ウェブページの先頭にある関連性の低い可能性のあるリンクをスキップして、すぐにメイン コンテンツにアクセスできます。",
    "A cozy room with sofa, table and laptops that have Acquia Web Governance text": "ソファ、テーブル、Acquia Web Governanceテキストを備えたラップトップを備えた居心地の良い部屋",
    "About Acquia Web Governance": "Acquia Web Governanceについて",
    "Accept Acquia Web Governance Privacy Terms": "Acquia Web Governanceのプライバシー規約に同意する",
    "Acquia Web Governance": "Acquia ウェブガバナンス",
    "Acquia Web Governance - Accessibility": "Acquia Webガバナンス - アクセシビリティ",
    "Acquia Web Governance - Accessibility Check List": "Acquia Web Governance - アクセシビリティチェックリスト",
    "Acquia Web Governance - Accessibility Guidelines": "Acquia Web Governance - アクセシビリティガイドライン",
    "Acquia Web Governance - Account Dictionary": "Acquia Web Governance - アカウント辞書",
    "Acquia Web Governance - Admin Page Performance Profiles": "Acquia Web Governance - 管理ページのパフォーマンスプロファイル",
    "Acquia Web Governance - Audit Log": "Acquia Web Governance - 監査ログ",
    "Acquia Web Governance - Broken Images": "Acquia Web Governance - 壊れた画像",
    "Acquia Web Governance - Broken Links": "Acquia Web Governance - 壊れたリンク",
    "Acquia Web Governance - Content With Broken Links": "Acquia Web Governance - リンク切れのあるコンテンツ",
    "Acquia Web Governance - Content With QA Errors": "Acquia Web Governance - QAエラーのあるコンテンツ",
    "Acquia Web Governance - Cookie Acceptance Rate": "Acquia Web Governance - Cookie 受け入れ率",
    "Acquia Web Governance - Cookie Consent Log": "Acquia Web Governance - Cookie 同意ログ",
    "Acquia Web Governance - Cookie Overview": "Acquia Web Governance - Cookie の概要",
    "Acquia Web Governance - Dashboard": "Acquia Web ガバナンス - ダッシュボード",
    "Acquia Web Governance - Data Privacy": "Acquia Webガバナンス - データプライバシー",
    "Acquia Web Governance - Data Privacy Check List": "Acquia Web Governance - データプライバシーチェックリスト",
    "Acquia Web Governance - Data Privacy Content": "Acquia Web Governance - データプライバシーコンテンツ",
    "Acquia Web Governance - Data Privacy Guidelines": "Acquia Web Governance - データプライバシーガイドライン",
    "Acquia Web Governance - Data Privacy Issues": "Acquia Web Governance - データプライバシーの問題",
    "Acquia Web Governance - Data Privacy Summary": "Acquia Web Governance - データプライバシー概要",
    "Acquia Web Governance - External PDF Compliance": "Acquia Web Governance - 外部 PDF コンプライアンス",
    "Acquia Web Governance - Fast Track": "Acquia Web ガバナンス - ファスト トラック",
    "Acquia Web Governance - Heatmaps": "Acquia Web Governance - ヒートマップ",
    "Acquia Web Governance - History Center": "Acquia Web ガバナンス - 履歴センター",
    "Acquia Web Governance - Ignored Misspellings": "Acquia Web Governance - 無視されたスペルミス",
    "Acquia Web Governance - Internal PDF Compliance": "Acquia Web Governance - 内部 PDF コンプライアンス",
    "Acquia Web Governance - Labels": "Acquia Webガバナンス - ラベル",
    "Acquia Web Governance - Misspellings": "Acquia Web Governance - スペルミス",
    "Acquia Web Governance - Page Performance Pages": "Acquia Web Governance - ページパフォーマンスページ",
    "Acquia Web Governance - PageCorrect": "Acquia Webガバナンス - PageCorrect",
    "Acquia Web Governance - PageCorrect Accessibility Fixes": "Acquia Web Governance - PageCorrect アクセシビリティ修正",
    "Acquia Web Governance - PageCorrect Content": "Acquia Webガバナンス - PageCorrectコンテンツ",
    "Acquia Web Governance - Pages With Failing Checks": "Acquia Web Governance - チェックに失敗したページ",
    "Acquia Web Governance - Pages With Ignored Checks": "Acquia Web Governance - チェックが無視されたページ",
    "Acquia Web Governance - Pages With Misspellings": "Acquia Web Governance - スペルミスのあるページ",
    "Acquia Web Governance - Pages With Opportunity": "Acquia Web Governance - 機会のあるページ",
    "Acquia Web Governance - Potential Misspellings": "Acquia Web Governance - スペルミスの可能性",
    "Acquia Web Governance - Prioritized Content": "Acquia Web Governance - 優先コンテンツ",
    "Acquia Web Governance - Quality Assurance": "Acquia Webガバナンス - 品質保証",
    "Acquia Web Governance - Readability Checker": "Acquia Web Governance - 読みやすさチェッカー",
    "Acquia Web Governance - Readability Summary": "Acquia Web Governance - 読みやすさの要約",
    "Acquia Web Governance - SEO Checkpoints": "Acquia Web Governance - SEO チェックポイント",
    "Acquia Web Governance - Search Engine Optimization": "Acquia Web Governance - 検索エンジン最適化",
    "Acquia Web Governance - Spellcheck Summary": "Acquia Web Governance - スペルチェックの概要",
    "Acquia Web Governance - User List": "Acquia Web Governance - ユーザーリスト",
    "Acquia Web Governance Consent Manager": "Acquia Webガバナンス同意マネージャー",
    "Acquia Web Governance Extension": "Acquia Web ガバナンス拡張機能",
    "Acquia Web Governance PageAssist": "Acquia WebガバナンスPageAssist",
    "Acquia Web Governance users receiving this report": "このレポートを受け取ったAcquia Web Governanceユーザー",
    "Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )": "Acquia Web Governance は、以下のいずれかのファイル拡張子で終わるリンクをクリックすると、ダウンロードを自動的に検出します (拡張子は大文字と小文字が区別されることに注意してください)。",
    "Add Acquia Web Governance Consent Manager": "Acquia Web Governance Consent Manager を追加する",
    "Affects [[pageCount]] pages": "[[pageCount]] ページに影響します",
    "An error has occurred - please try again. If the error continues, please contact Acquia Web Governance": "エラーが発生しました。もう一度お試しください。エラーが続く場合は、Acquia Web Governance にお問い合わせください。",
    "An unexpected error occurred. Please try again.": "予期しないエラーが発生しました。もう一度お試しください。",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary for all languages?": "すべての言語の辞書に単語 <strong>' + word + '</strong> を追加してもよろしいですか?",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary?": "単語 <strong>' + word + '</strong> を辞書に追加してもよろしいですか?",
    "Are you sure you want to confirm the misspelling <strong>' + word + '</strong>?": "本当にスペルミス <strong>' + 単語 + '</strong> を確認しますか?",
    "Are you sure you want to remove the Profile <strong>[[profileName]]</strong>?": "プロフィール <strong>[[profileName]]></strong> を削除してもよろしいですか?",
    "Are you sure you want to undo review this document as reviewed?": "このドキュメントのレビューをレビュー済みとして取り消してもよろしいですか?",
    "Calculate Readability Score": "読みやすさスコアを計算する",
    "Calculate score to see results": "スコアを計算して結果を確認する",
    "Calculate the readability score of any text (based on [[testName]])": "任意のテキストの読みやすさスコアを計算します（[[testName]] に基づく）",
    "Can\\\\'t delete label": "ラベルを削除できません",
    "Change your &lt;b&gt; tags into something else": "&lt;b&gt; タグを別のものに変更する",
    "Choose your own text for the Skip to Content link button<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>": "「コンテンツへスキップ」リンクボタンに独自のテキストを選択してください<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'コンテンツへスキップボタンにタイトルを付けます' | translate }}\\\"></span>",
    "Clear search in the domain picker": "ドメインピッカーで検索をクリアする",
    "Click here to contact Acquia Web Governance sales department to increase your maximum page count.": "最大ページ数を増やすには、ここをクリックして Acquia Web Governance 営業部門にお問い合わせください。",
    "Confirmed misspelling": "スペルミスを確認しました",
    "Copyright 2020 Acquia Web Governance. All rights reserved.": "Copyright 2020 Acquia Web Governance. All rights reserved.",
    "Couldn't find any domains": "ドメインが見つかりませんでした",
    "Crawled Pages ([[pageCount]])": "クロールされたページ ([[pageCount]])",
    "Description*": "説明*",
    "Domain favicon for": "ドメインファビコン",
    "Domain groups": "ドメイングループ",
    "Domains that have never been scanned": "一度もスキャンされていないドメイン",
    "Domains that were not scanned in the selected date range": "選択した期間内にスキャンされなかったドメイン",
    "Edit this policy rule later under the \\\"Add rule to policy\\\" tab.": "このポリシー ルールは、後で [ポリシーにルールを追加] タブで編集します。",
    "Enable if you want to use Acquia Web Governance in Accessibility mode": "Acquia Web Governanceをアクセシビリティモードで使用する場合は有効にします",
    "Export visitors screen resolutions": "訪問者の画面解像度をエクスポート",
    "For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.": "現時点では、Acquia Web Governance Pagecorrect はすべての外部リンクにポップアップ警告を追加し、訪問者が元のページから移動するかどうかを自分で選択できるようにします。",
    "Found 1 audit log on your account": "アカウントに監査ログが 1 件見つかりました",
    "Found [[count]] audit logs on your account": "アカウントに [[count]] 件の監査ログが見つかりました",
    "From March 1, 2022, Acquia Web Governance will no longer be supporting any version of Internet Explorer or Edge browser version 78 or below. While you will still be able to log on and use Acquia Web Governance with Internet Explorer and older versions of Edge, we are no longer testing releases and fixing bugs specifically for those browsers. We encourage you to switch to another browser such as Chrome or newer version of Edge to be sure that Acquia Optimize continues to work optimally on your device.": "2022年3月1日以降、Acquia Web GovernanceはInternet ExplorerおよびEdgeブラウザ（バージョン78以下）のサポートを終了します。Internet ExplorerおよびEdgeの旧バージョンでもAcquia Web Governanceにログインしてご利用いただくことは可能ですが、これらのブラウザを対象としたリリースのテストやバグ修正は行っておりません。Acquia Optimizeが引き続きデバイス上で最適に動作するよう、ChromeやEdgeの最新バージョンなど、他のブラウザへの切り替えをお勧めします。",
    "Get the Acquia Web Governance Extension": "Acquia Web Governance拡張機能を入手する",
    "Go to the policy dashboard of the domain [[title]]": "ドメイン [[title]] のポリシーダッシュボードに移動します",
    "Images missing alt attribute": "alt属性のない画像",
    "Insert the CSS selector targets you want your visitors to land on<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>": "訪問者に訪れてほしい CSS セレクターターゲットを挿入します <span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'ページデザインが異なる場合は、正しいフォーマットを使用し、複数のセレクターを追加してください' | translate }}\\\"></span>",
    "Internet Explorer &amp; Edge v.78 (or below) no longer supported": "Internet Explorer および Edge v.78 (またはそれ以下) はサポートされなくなりました",
    "Italics are often used in HTML to put emphasis on text. However, this is often achieved with the &lt;I&gt; tag, in which case the emphasis is not announced by screen readers. Using the &lt;I&gt; tag doesn't provide enough context and is becoming an outdated practice.": "HTMLでは、テキストを強調するためにイタリック体がよく使用されます。しかし、これは多くの場合&lt;I&gt;タグで実現されますが、その場合、スクリーンリーダーは強調を通知しません。&lt;I&gt;タグの使用は十分な文脈を提供しないため、時代遅れの手法になりつつあります。",
    "Last 8 Performance Scans Scores": "過去8回のパフォーマンススキャンスコア",
    "Latest manual scan finished on [[scannedAt]]": "最新の手動スキャンは [[scannedAt]] に完了しました",
    "Mark this issue as fixed": "この問題を解決済みとしてマークする",
    "Monitor how visitors interact with your pages. Acquia Web Governance tracks up to a maximum of 1000 heatmaps sessions per page per month.": "訪問者がページ上でどのようにインタラクションしているかを監視します。Acquia Web Governance は、1 ページあたり月間最大 1,000 件のヒートマップセッションを追跡します。",
    "No downloads were found. Try searching for the document URL instead of the document title.": "ダウンロードは見つかりませんでした。ドキュメントのタイトルではなく、ドキュメントのURLで検索してみてください。",
    "No more PDF accessibility scans are available for this account. Please contact a Acquia Web Governance sales department to add more.": "このアカウントでは利用可能なPDFアクセシビリティスキャンがもうありません。スキャンを追加するには、Acquia Web Governance営業部までお問い合わせください。",
    "Not valid URL": "無効なURL",
    "PageCorrect failed to save, the Acquia Web Governance team has been notified of the error": "PageCorrect は保存に失敗しました。Acquia Web Governance チームにエラーが通知されました。",
    "Pages Without Visits": "訪問のないページ",
    "Part of success criteria [[issueNumber]]": "成功基準の一部 [[issueNumber]]",
    "Pick any link on your website which you know opens in a new page (social media icons are usually a safe bet) and try to navigate away from the page you are on. If the pop-up doesn't appear it might be because the script has not been applied yet. Give it some time.": "ウェブサイト上の、新しいページで開くことが分かっているリンク（ソーシャルメディアのアイコンは一般的に安全です）を選択し、現在開いているページから別のページに移動してみてください。ポップアップが表示されない場合は、スクリプトがまだ適用されていない可能性があります。しばらくお待ちください。",
    "Policy Scan is no longer valid. Press Run Policy to update Policy Scan details": "ポリシースキャンは無効です。ポリシースキャンの詳細を更新するには、「ポリシーを実行」を押してください。",
    "Readability Checker": "読みやすさチェッカー",
    "Readability Level": "読みやすさレベル",
    "Readability Summary": "読みやすさの要約",
    "Remove word from Ignored Misspellings": "無視されたスペルミスから単語を削除する",
    "Remove word from dictionary": "辞書から単語を削除する",
    "Request Remediation from selection": "選択から修復を要求する",
    "Request failed. Please ensure you have added only text in the input field.": "リクエストが失敗しました。入力フィールドにテキストのみを追加したことを確認してください。",
    "Scan stopped successfully": "スキャンが正常に停止しました",
    "Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan": "Acquia Web Governance スキャンのたびに、[[adminText]] 宛てにレポートをメールでスケジュール設定します。",
    "Search for content that*": "次のコンテンツを検索する*",
    "Something went wrong. The Acquia Web Governance Team has been notified of this error and will get back to you, as soon as possible.": "問題が発生しました。Acquia Web Governance チームにこのエラーが通知され、できるだけ早くご連絡いたします。",
    "Start Cookie Scan": "Cookieスキャンを開始",
    "Start Scan": "スキャンを開始",
    "Start a new scan to find cookies or add them manually": "新しいスキャンを開始してCookieを検索するか、手動で追加します",
    "Stop scan": "スキャンを停止",
    "Switch to Acquia Web Governance classic": "Acquia Web Governanceクラシックに切り替える",
    "Test your website's compliance levels ([[level]]) and fix issues that are making it difficult for people with disabilities to use your website": "ウェブサイトのコンプライアンスレベル（[[level]]）をテストし、障害のあるユーザーがウェブサイトを使いにくくしている問題を修正します。",
    "The Acquia Web Governance team is notified and are working on the issue.": "Acquia Web Governance チームに通知され、問題解決に取り組んでいます。",
    "The Compound Export contains data from the first and last scans within the selected date range. The export does not include data from the following sources:": "化合物エクスポートには、選択した日付範囲内の最初と最後のスキャンのデータが含まれます。エクスポートには、以下のソースからのデータは含まれません。",
    "The profile has been archived.": "プロフィールはアーカイブされました。",
    "The profile has been restored.": "プロフィールが復元されました。",
    "There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.": "これを実行する方法は1つだけです。Acquia Web Governanceは、Webサイト上で検出されたすべての&lt;I&gt;タグをemタグに置き換えます。",
    "Type in or paste text to be analyzed": "分析するテキストを入力または貼り付けます",
    "URL &amp; Title": "URLとタイトル",
    "Unignore Misspelling": "スペルミスを無視しない",
    "Url &amp; Title": "URLとタイトル",
    "Visitors screen resolutions export": "訪問者の画面解像度のエクスポート",
    "Weight in score: [[weight]]": "スコアの重み: [[weight]]",
    "Why can't I open a new window without warning?": "警告なしに新しいウィンドウを開くことができないのはなぜですか?",
    "Why do I need a \\\"skip to content\\\" link?": "「コンテンツへスキップ」リンクがなぜ必要なのですか?",
    "Why shouldn't I use the marquee element?": "マーキー要素を使用しないほうがよいのはなぜですか?",
    "You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here": "Acquia Web Governance PageAssistの新しいバージョンをご利用いただいています。バージョン1.0に戻す場合は、こちらをクリックしてください。",
    "You can only calculate a score for up to [[count]] characters.": "スコアを計算できるのは最大 [[count]] 文字までです。",
    "You do not have sufficient permissions to use this feature.": "この機能を使用するための十分な権限がありません。",
    "Your current plan does not include on-demand scans. Please reach out to your Acquia Web Governance representative to learn more about this option": "現在のプランにはオンデマンドスキャンは含まれていません。このオプションの詳細については、Acquia Web Governanceの担当者にお問い合わせください。",
    "[[$count]] found": "[[$count]]件見つかりました",
    "[[count]] found": "[[count]]件見つかりました",
    "[[headerCount]] found": "[[headerCount]] 個見つかりました",
    "[[pageIssues]] Pages <span>([[errorPercentage]]%)</span> to fix": "修正すべきページが [[pageIssues]] ページあります <span>([[errorPercentage]]%)</span>",
    "[[pageIssues]] Pages to fix": "[[pageIssues]] 修正すべきページ",
    "[[pagesDone]] Pages ([[compliancePercentage]]) in compliance": "[[pagesDone]] ページ ([[compliancePercentage]]) がコンプライアンスに準拠しています",
    "[[totalPageIssues]] Pages ([[compliancePercentage]]) to fix": "修正すべきページ数: [[totalPageIssues]] ページ ([[compliancePercentage]])",
    "failed when trying to ignore/review all. please try agin, or contact the Acquia Web Governance team": "すべてを無視/確認しようとして失敗しました。もう一度お試しいただくか、Acquia Web Governance チームにお問い合わせください。",
    "policies": "政策",
    "policy": "ポリシー",
    "Start export PDF Accessibility Report": "ページ明瞭度レポートのエクスポートを開始",
    "No data showing? Add the Acquia Web Governance script to your website": "統計情報が表示されませんか？Acquia Web Governanceスクリプトをウェブサイトに追加してください。"
  },
  "fr": {
    "Search": {
      "Spotlight": "Recherche",
      "$$noContext": "Recherche"
    },
    "Global Policy Overview": {
      "Topmenu": "Aperçu de la politique globale",
      "$$noContext": "Aperçu de la politique globale"
    },
    "History Center": {
      "Topmenu": "Centre d'historique",
      "$$noContext": "Centre d'historique"
    },
    "Report Center": {
      "Topmenu": "Centre de rapport",
      "$$noContext": "Centre de rapport"
    },
    "Users": {
      "Topmenu": "Utilisateurs",
      "$$noContext": "Utilisateurs"
    },
    "No content was found": {
      "page-details -> Inventory -> links. No result message": "Aucun contenu trouvé",
      "$$noContext": "Aucun contenu trouvé"
    },
    "&nbsp;&nbsp;&nbsp;Passwords does not match": "&nbsp;&nbsp;&nbsp;Le mot de passe ne correspond pas",
    "(HTML and documents)": "(HTML et documents)",
    "(No title found)": "(Aucun titre trouvé)",
    "(The HTML snippet is now Marked as Reviewed/Ignored)": "(L'extrait HTML est maintenant marqué comme Examiné/Ignoré)",
    "(This policy is marked as unwanted content)": "(Cette politique est marquée comme contenu indésirable)",
    "+ Add new check": "+ Ajouter une nouvelle vérification",
    "+ Add new user": "+ Ajouter un nouvel utilisateur",
    "1 min.": "1 min.",
    "1 minute": "1 minute",
    "10 min.": "10 min.",
    "10th to 12th grade": "10ème à la 12ème année",
    "120 min.": "120 min.",
    "15 min.": "15 min.",
    "1st": "1er",
    "2nd": "2ème",
    "30 min.": "30 min.",
    "3rd": "3ème",
    "5 min.": "5 min.",
    "5 minutes": "5 minutes",
    "5th grade": "5ème année",
    "60 min.": "60 min.",
    "6th grade": "6ème année",
    "7th grade": "7ème année",
    "8th to 9th grade": "8ème à la 9ème année",
    "A": "A",
    "A list of all external PDF files already reviewed for accessibility issues": "Une liste de tous les fichiers PDF externes déjà examinés pour les questions d'accessibilité",
    "A list of all external PDF files that you need to check for accessibility issues": "Une liste de tous les fichiers PDF externes dont vous devez vérifier les problèmes d'accessibilité.",
    "A list of all internal PDF files already reviewed for accessibility issues": "Une liste de tous les fichiers PDF internes déjà examinés pour les questions d'accessibilité",
    "A list of all internal PDF files that have been marked as failed for accessibility issues": "Une liste de tous les fichiers PDF internes marqués comme ayant échoué pour des raisons d'accessibilité.",
    "A list of all internal PDF files that have been marked as queued for accessibility issues": "Une liste de tous les fichiers PDF internes marqués comme étant en attente pour des questions d'accessibilité.",
    "A list of all internal PDF files that you need to check for accessibility issues": "Une liste de tous les fichiers PDF internes dont vous devez vérifier les problèmes d'accessibilité.",
    "AA": "AA",
    "AAA": "AAA",
    "ACCESSIBILITY OVERVIEW": "APERÇU DE L'ACCESSIBILITÉ",
    "API Token": "Jeton API",
    "API URL": "URL DE L'API",
    "API User": "Utilisateur de l'API",
    "API User Details": "Détails de l'utilisateur de l'API",
    "API Users": "Utilisateurs de l'API",
    "About": "A propos de",
    "Accept": "Accepter",
    "Accessibility": "Accessibilité",
    "Accessibility Check": "Vérification d'accessibilité",
    "Accessibility Diagnostics": "Diagnostics d'accessibilité",
    "Accessibility Fast Track": "Fast Track pour l'accessibilité",
    "Accessibility Icon": "Icône d'accessibilité",
    "Accessibility Snippet": "Extrait de l'accessibilité",
    "Accessibility Source Code": "Code source de l'accessibilité",
    "Accessibility checks compliance by level": "Vérifications d'accessibilité conformité par niveau",
    "Accessibility checks not in compliance with domain": "Les vérifications d'accessibilité ne sont pas conformes au domaine",
    "Accessibility error type": "Type d'erreur d'accessibilité",
    "Accessibility errors": "Erreurs d'accessibilité",
    "Accessibility fixes": "Corrections d'accessibilité",
    "Accessibility help center": "Centre d'aide sur l'accessibilité",
    "Accessibility issues": "Problèmes d'accessibilité",
    "Accessibility level": "Niveau d'accessibilité",
    "Accessibility mode": "Mode d'accessibilité",
    "Accessibility review type": "Type d'examen de l'accessibilité",
    "Account dictionary": "Dictionnaire du compte",
    "Action": "Action",
    "Actions": "Actions",
    "Actions per visit": "Actions par visite",
    "Active": "Actif",
    "Add": "Ajouter",
    "Add Custom Multistep Javascript": "Ajouter un Javascript multi-étapes personnalisé",
    "Add Extension Name": "Ajouter un nom d'extension",
    "Add Heatmap rule to a Page": "Ajouter une règle de carte thermique à une page",
    "Add Heatmaps": "Ajouter des cartes thermiques",
    "Add PageAssist script": "Ajouter le script PageAssist",
    "Add PageCorrect": "Ajouter PageCorrect",
    "Add Profile": "Ajouter un profil",
    "Add Rule": "Ajouter une règle",
    "Add Skip to PageAssist": "Ajouter Passer à PageAssist",
    "Add a new exemption to your heartbeat check": "Ajouter une nouvelle exemption à votre vérification heartbeat",
    "Add a new page to start tracking individual pages' performance. Get an overview of load times and opportunities to speed up your site.": "Ajouter une nouvelle page pour suivre les performances des pages individuelles. Obtenir une vue d'ensemble des temps de chargement et des possibilités d'accélérer votre site.",
    "Add a non-user email": "Ajouter un e-mail de non-utilisateur",
    "Add another rule": "Ajouter une autre règle",
    "Add email": "Ajouter un e-mail",
    "Add exemption": "Ajouter une exemption",
    "Add new check": "Ajouter une nouvelle vérification",
    "Add new domain": "Ajouter un nouveau domaine",
    "Add new exemption": "Ajouter une nouvelle exemption",
    "Add new label": "Ajouter une nouvelle étiquette",
    "Add new page": "Ajouter une nouvelle page",
    "Add new policy": "Ajouter une nouvelle politique",
    "Add new user": "Ajouter un nouvel utilisateur",
    "Add non users": "Ajouter des non-utilisateurs",
    "Add reason (Optional)": "Ajouter un motif (facultatif)",
    "Add rule to policy": "Ajouter une règle à la politique",
    "Add rule to the policy": "Ajouter une règle à la politique",
    "Add task": "Ajouter une tâche",
    "Add timeslots where you won't receive notifications on downtime and slow responsetimes.": "Ajouter des plages horaires pendant lesquelles vous ne recevrez pas de notifications sur les temps d'arrêt et les temps de réponse lents.",
    "Add to all languages": "Ajouter à toutes les langues",
    "Add to dictionary": "Ajouter au dictionnaire",
    "Add to dictionary for all languages": "Ajouter au dictionnaire pour toutes les langues",
    "Added": "Ajouté",
    "Added by": "Ajouté par",
    "Added date": "Date d'ajout",
    "Address": "Adresse",
    "Admin": "Administrateur",
    "Advanced Domain Options": "Options de domaine avancées",
    "Affected image": "Image affectée",
    "Affected pages": "Pages affectées",
    "Affected pages by priority": "Pages affectées par priorité",
    "Affected pages by severity": "Pages affectées par gravité",
    "Affects": "Affecte",
    "After": "Après",
    "All": "Tous",
    "All Failed Internal PDF files": "Tous les fichiers PDF internes qui ont échoué",
    "All Pending External PDF files": "Tous les fichiers PDF externes en attente",
    "All Pending Internal PDF files": "Tous les fichiers PDF internes en attente",
    "All Queued Internal PDF files": "Tous les fichiers PDF internes en attente",
    "All Reviewed External PDF files": "Tous les fichiers PDF externes examinés",
    "All Reviewed Internal PDF files": "Tous les fichiers PDF internes examinés",
    "All assets": "Tous les actifs",
    "All broken images": "Toutes les images défectueuses",
    "All broken links": "Tous les liens défectueux",
    "All heartbeat checkpoints": "Tous les points de contrôle heartbeat",
    "All incident checkpoints in the selected time span": "Tous les points de contrôle des incidents dans la période sélectionnée",
    "All level A accessibility checks": "Toutes les vérifications d'accessibilité de niveau A",
    "All level AA accessibility checks": "Toutes les vérifications d'accessibilité de niveau AA",
    "All level AAA accessibility checks": "Toutes les vérifications d'accessibilité de niveau AAA",
    "All levels": "Tous les niveaux",
    "All modules": "Tous les modules",
    "All modules - Content with Issues": "Tous les modules - Contenu avec des questions",
    "All notifications": "Toutes les notifications",
    "All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.": "Tout ce que vous avez à faire est d'insérer le script ci-dessous dans la balise BODY de votre site web. Il suffit de le copier et de le coller tel quel.",
    "Analytics (Last 7 days)": "Analyse de données (7 derniers jours)",
    "And": "Et",
    "Appears on": "Apparaît sur",
    "Apply": "Appliquer",
    "Archive": "Archives",
    "Archive files": "Fichiers d'archives",
    "Archived": "Archivé",
    "Are you sure you want to Mark this link as unignored?": "Êtes-vous sûr de vouloir marquer ce lien comme non ignoré ?",
    "Are you sure you want to Request All PDF Accessibility checks?": "Êtes-vous sûr de vouloir demander les vérifications d'accessibilité de tous les PDF ?",
    "Are you sure you want to add to Request PDF Accessibility check from selection?": "Êtes-vous sûr de vouloir ajouter la vérification de l'accessibilité des PDF sélectionnés ?",
    "Are you sure you want to add to all the dictionaries?": "Êtes-vous sûr de vouloir ajouter à tous les dictionnaires ?",
    "Are you sure you want to add to the dictionary?": "Êtes-vous sûr de vouloir ajouter au dictionnaire ?",
    "Are you sure you want to close this form without saving your changes?": "Êtes-vous sûr de vouloir fermer ce formulaire sans enregistrer vos modifications ?",
    "Are you sure you want to confirm this misspelling?": "Êtes-vous sûr de vouloir confirmer cette faute d'orthographe ?",
    "Are you sure you want to delete the API User [[apiUserId]]": "Êtes-vous sûr de vouloir supprimer l'utilisateur de l'API [[apiUserId]] ?",
    "Are you sure you want to delete this exemption?": "Êtes-vous sûr de vouloir supprimer cette exemption ?",
    "Are you sure you want to delete this source exclude?": "Êtes-vous sûr de vouloir supprimer cette exclusion de source ?",
    "Are you sure you want to ignore all errors for this check?": "Êtes-vous sûr de vouloir ignorer toutes les erreurs pour cette vérification ?",
    "Are you sure you want to ignore the selected issue on this page?": "Êtes-vous sûr de vouloir ignorer la question sélectionnée sur cette page ?",
    "Are you sure you want to ignore this check for this domain?": "Êtes-vous sûr de vouloir ignorer cette vérification pour ce domaine ?",
    "Are you sure you want to ignore this check for this page?": "Êtes-vous sûr de vouloir ignorer cette vérification pour cette page ?",
    "Are you sure you want to ignore this issue?": "Êtes-vous sûr de vouloir ignorer cette question ?",
    "Are you sure you want to ignore this misspelling?": "Êtes-vous sûr de vouloir ignorer cette faute d'orthographe ?",
    "Are you sure you want to mark this issue as fixed?": "Êtes-vous sûr de vouloir marquer cette question comme résolue ?",
    "Are you sure you want to mark this issue as not fixed?": "Êtes-vous sûr de vouloir marquer cette question comme non résolue ?",
    "Are you sure you want to mark this link as fixed?": "Êtes-vous sûr de vouloir marquer ce lien comme rétabli ?",
    "Are you sure you want to mark this link as ignored?": "Êtes-vous sûr de vouloir marquer ce lien comme ignoré ?",
    "Are you sure you want to mark this link as not fixed?": "Êtes-vous sûr de vouloir marquer ce lien comme non rétabli ?",
    "Are you sure you want to remove manually added user?": "Êtes-vous sûr de vouloir supprimer l'utilisateur ajouté manuellement ?",
    "Are you sure you want to remove review for this issue?": "Êtes-vous sûr de vouloir supprimer l'examen de cette question ?",
    "Are you sure you want to remove review on all errors for this check?": "Êtes-vous sûr de vouloir supprimer l'examen de toutes les erreurs pour cette vérification ?",
    "Are you sure you want to remove this group?": "Êtes-vous sûr de vouloir supprimer ce groupe ?",
    "Are you sure you want to remove this host?": "Êtes-vous sûr de vouloir supprimer cet hôte ?",
    "Are you sure you want to remove this rule?": "Êtes-vous sûr de vouloir supprimer cette règle ?",
    "Are you sure you want to remove this?": "Êtes-vous sûr de vouloir supprimer cela ?",
    "Are you sure you want to review all errors for this check?": "Êtes-vous sûr de vouloir examiner toutes les erreurs pour cette vérification ?",
    "Are you sure you want to review this issue?": "Êtes-vous sûr de vouloir examiner cette question ?",
    "Are you sure you want to set this document as reviewed?": "Êtes-vous sûr de vouloir considérer ce document comme examiné ?",
    "Are you sure you want to start on-demand scan?": "Êtes-vous sûr de vouloir lancer l'analyse à la demande ?",
    "Are you sure you want to stop current crawl?": "Êtes-vous sûr de vouloir mettre fin à l'exploration en cours ?",
    "Are you sure you want to the request ADA clarification for [[name]]?": "Êtes-vous sûr de vouloir demander une clarification concernant l'ADA pour[[name]] ?",
    "Are you sure you want to undo review of this document?": "Êtes-vous sûr de vouloir annuler l'examen de ce document ?",
    "Are you sure you want to undo reviewing this document?": "Êtes-vous sûr de vouloir annuler l'examen de ce document ?",
    "Are you sure you want to unignore all errors for this check?": "Êtes-vous sûr de vouloir ne pas ignorer toutes les erreurs pour cette vérification ?",
    "Are you sure you want to unignore the selected issue on this page?": "Êtes-vous sûr de vouloir ne pas ignorer la question sélectionnée sur cette page ?",
    "Are you sure you want to unignore this check for this domain?": "Êtes-vous sûr de vouloir ne pas ignorer cette vérification pour ce domaine ?",
    "Are you sure you want to unignore this check for this page?": "Êtes-vous sûr de vouloir ne pas ignorer cette vérification pour cette page ?",
    "Are you sure you want to unignore this issue?": "Êtes-vous sûr de vouloir ne pas ignorer cette question ?",
    "Are you sure you want to unignore this link?": "Êtes-vous sûr de vouloir ne pas ignorer ce lien ?",
    "Are you sure you want to unignore this misspelling?": "Êtes-vous sûr de vouloir ne pas ignorer cette faute d'orthographe ?",
    "Are you sure you want to unpin this domain": "Êtes-vous sûr de vouloir désépingler ce domaine ?",
    "Are you sure you want unignore this link?": "Êtes-vous sûr de vouloir ne pas ignorer ce lien ?",
    "Assign Heatmap Rule": "Attribuer une règle de carte thermique",
    "Assign to the Performance Module": "Affecter au module de performance",
    "Attribute": "Attribut",
    "Audit": "Audit",
    "Audit Log": "Journal d'audit",
    "Autoselect": "Autosélection",
    "Average First Contentful Paint": "FCP moyen",
    "Average First Meaningful Paint": "FMP moyen",
    "Average Performance Score": "Score de performance moyen",
    "Average Performance score": "Score de performance moyen",
    "Average Time to Interactive": "TTI moyen",
    "Average response time": "Temps de réponse moyen",
    "Average time": "Durée moyenne",
    "Average uptime": "Temps de fonctionnement moyen",
    "Average visit time": "Durée moyenne de la visite",
    "Avg. Performance Score": "Moy. Score de performance",
    "Avg. Visit Time": "Moy. Temps de visite",
    "Avg. response": "Réponse moy.",
    "BETA": "BETA",
    "Back": "Retour",
    "Back to Heartbeat Overview": "Retour à l'aperçu Heartbeat",
    "Bar": "Barre",
    "Basic Auth": "Auth de base",
    "Before": "Avant",
    "Below 5th grade": "En dessous de la 5ème année",
    "Below you can see a list of all pages that contains the title": "Ci-dessous vous pouvez voir une liste de toutes les pages qui contiennent le titre",
    "Book online training": "Réserver une formation en ligne",
    "Bounce Rates": "Taux de rebond",
    "Bounce rate": "Taux de rebond",
    "Bounce rates": "Taux de rebond",
    "Brand name": "Nom de marque",
    "Broken Image": "Image défectueuse",
    "Broken Image Links per page": "Liens d'images défectueuses par page",
    "Broken Images": "Images défectueuses",
    "Broken Links": "Liens défectueux",
    "Broken Page Link": "Lien de page défectueux",
    "Broken image affecting most content": "Image défectueuse affectant la plupart du contenu",
    "Broken image affecting most pages": "Image défectueuse affectant la plupart des pages",
    "Broken images": "Images défectueuses",
    "Broken images with page count": "Images défectueuses avec nombre de pages",
    "Broken link": "Lien défectueux",
    "Broken link affecting most content": "Lien défectueux affectant la plupart du contenu",
    "Broken link affecting most pages": "Lien défectueux affectant la plupart des pages",
    "Broken links": "Liens défectueux",
    "Broken links per page": "Liens défectueux par page",
    "Broken links with page count": "Liens défectueux avec nombre de pages",
    "Browser": "Navigateur",
    "Browser Extension": "Extension du navigateur",
    "Browsers": "Navigateurs",
    "Browsers Overview": "Aperçu des navigateurs",
    "Bubble": "Bulle",
    "Build it from scratch": "Élaborer à partir de rien",
    "By deleting this domain all domain groups related to this domain, will also be deleted": "En supprimant ce domaine, tous les groupes de domaines liés à ce domaine seront également supprimés.",
    "By user": "Par utilisateur",
    "CMS": "CMS",
    "CMS url": "URL du CMS",
    "CSS": "CSS",
    "CSS Target Selector": "Sélecteur de cible CSS",
    "CSS id or class selector to search for": "Identifiant CSS ou sélecteur de classe à rechercher",
    "CSS selector to find submit button": "Sélecteur CSS pour trouver le bouton Soumettre",
    "Cache TTL": "TTL du cache",
    "Cancel": "Annuler",
    "Case sensitive": "Sensible à la casse",
    "Categories": "Catégories",
    "Category": "Catégorie",
    "Change password": "Modifier le mot de passe",
    "Changed to": "Modifié en",
    "Changes": "Modifications",
    "Changes added": "Modifications ajoutées",
    "Changes in selected time frame:": "Modifications au cours de la période sélectionnée :",
    "Changes since Previous Crawl": "Modifications depuis l'exploration précédente",
    "Changes since previous crawl": "Modifications depuis l'exploration précédente",
    "Characters": "Caractères",
    "Chart": "Graphique",
    "Chart is now showing: [[name]]": "Le graphique affiche maintenant :[[name]]",
    "Check": "Vérifier",
    "Check List Export": "Vérifier l'exportation de la liste",
    "Check all links in this section": "Vérifier tous les liens dans cette section",
    "Check all misspellings in this section": "Vérifier toutes les fautes d'orthographe dans cette section",
    "Check all modules": "Vérifier tous les modules",
    "Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)": "Vérifier et corriger les problèmes de contenu sur votre site web (fautes d'orthographe, liens défectieux, lisibilité et autres problèmes).",
    "Check frequency": "Vérifier la fréquence",
    "Check frequency:": "Vérifier la fréquence :",
    "Check is ignored": "la vérification est ignorée",
    "Check is ignored for the entire domain": "la vérification est ignorée pour l'ensemble du domaine",
    "Check link": "Vérifier le lien",
    "Check misspelling": "Vérifier les fautes d'orthographe",
    "Check name": "Vérifier le nom",
    "Check off as Reviewed": "Cocher comme Examiné",
    "Check passed": "Vérification réussie",
    "Check site status": "Vérifier l'état du site",
    "Checking": "Vérification",
    "Checkpoint exemptions": "Exemptions au point de contrôle",
    "Checkpoint has been updated.": "Le point de contrôle a été mis à jour.",
    "Checkpoint information": "Informations sur le point de contrôle",
    "Checkpoint:": "Point de contrôle :",
    "Checks": "Vérifications",
    "Checks passed": "Vérifications réussies",
    "Checks whether your website is responding and measures the response time of the server": "Vérifie si votre site web répond et mesure le temps de réponse du serveur.",
    "Choose Operator": "Choisir l'opérateur",
    "Choose What to Scan": "Choisir ce qui doit être analysé",
    "Choose a response time": "Choisir un délai de réponse",
    "Choose a response time notification": "Choisir une notification de délai de réponse",
    "Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned": "Choisir une loi sur les données existante comme modèle par défaut pour votre analyse de sécurité. Modifier les questions ci-dessous pour exclure certaines balises de l'analyse.",
    "Choose checks": "Choisir les vérifications",
    "Choose domains": "Choisir les domaines",
    "Choose how to view the Heatmaps Dashboard": "Choisir comment afficher le tableau de bord des cartes thermiques",
    "Choose notification time": "Choisir le temps de notification",
    "Choose the minimum amount of words to scan for readability on a page": "Choisir le nombre minimum de mots à analyser pour la lisibilité sur une page",
    "Choose where the policy should apply": "Choisir où la politique doit s'appliquer",
    "Chrome extension": "Extension Chrome",
    "City": "Ville",
    "Clear all labels": "Effacer toutes les étiquettes",
    "Clear and close filters": "Effacer et fermer les filtres",
    "Click here to create your first policy": "Cliquer ici pour créer votre première politique",
    "Click here to edit": "Cliquer ici pour modifier",
    "Click to create your first policy": "Cliquer ici pour créer votre première politique",
    "Clone": "Clone",
    "Close": "Fermer",
    "Close filters": "Fermer les filtres",
    "Collapse": "Réduire",
    "Collapse menu": "Réduire le menu",
    "College": "Lycée",
    "College graduate": "Diplômé du lycée",
    "Coming soon": "Prochainement",
    "Comment": "Commentaire",
    "Common policy violations": "Infractions courantes à la politique",
    "Company Info": "Infos sur l'entreprise",
    "Compliance": "Conformité",
    "Compliance {{compliancePercentage}}": "{{compliancePercentage}} de conformité",
    "Compound Export": "Exportation groupée",
    "Compound Report": "Rapport groupé",
    "Confirm": "Confirmer",
    "Confirm as misspelling": "Confirmer en tant que faute d'orthographe",
    "Confirm misspelling": "Confirmer la faute d'orthographe",
    "Confirm this word as a misspelling": "Confirmer ce mot comme mal orthographié",
    "Confirmed": "Confirmé",
    "Confirmed misspellings": "Fautes d'orthographe confirmées",
    "Congratulations no violations were found": "Félicitations aucune infraction n'a été constatée",
    "Connection Profile": "Profil de connexion",
    "Connections per minute": "Connexions par minute",
    "Constraint": "Contrainte",
    "Constraint pattern": "Modèle de contrainte",
    "Contact me about more Performance Pages": "Me contacter pour plus de pages de performance",
    "Contact me about more performance profiles": "Me contacter pour plus de profils de performance",
    "Containing": "Contient",
    "Contains": "Contient",
    "Contains confirmed misspellings, broken links & images": "Contient des fautes d'orthographe, des liens et des images défectueux confirmés.",
    "Contains confirmed misspellings, broken links or images": "Contient des fautes d'orthographe, des liens ou des images défectueux confirmés.",
    "Contains high, medium & low opportunities for all pages": "Contient des opportunités importantes, moyennes et faibles pour toutes les pages.",
    "Contains high, medium & low severity issues for all pages": "Contient des problèmes de gravité élevée, moyenne et faible pour toutes les pages.",
    "Contains issues with high, medium and low priority for all pages": "Contient des questions ayant une priorité élevée, moyenne et faible pour toutes les pages.",
    "Content": "Contenu",
    "Content Links": "Liens de contenu",
    "Content Policies": "Politiques de contenu",
    "Content Policy Violations": "Infractions à la politique de contenu",
    "Content in compliance": "Contenu conforme",
    "Content must be robust enough that it can be interpreted reliably by a wide variety of user agents, including assistive technologies.": "Le contenu doit être suffisamment robuste pour pouvoir être interprété de manière fiable par une grande variété d'agents utilisateurs, y compris les technologies d'assistance.",
    "Content policies": "Politiques de contenu",
    "Content with Broken Image": "Contenu avec image défectueuse",
    "Content with Broken Link": "Contenu avec lien défectueux",
    "Content with Broken Links": "Contenu avec des liens défectueux",
    "Content with Data Issues": "Contenu avec des problèmes de données",
    "Content with Data Issues export": "Contenu avec exportation de problèmes de données",
    "Content with Policy Matches": "Contenu avec correspondances à la politique",
    "Content with QA Errors": "Contenu avec des erreurs d'assurance qualité",
    "Content with broken links": "Contenu avec des liens défectueux",
    "Content with issues": "Contenu avec des problèmes",
    "Content with policy violations": "Contenu avec infractions à la politique",
    "Content with violations": "Contenu avec infractions",
    "Context": "Contexte",
    "Country": "Pays",
    "Crawl Automatically": "Explorer automatiquement",
    "Crawl Options": "Options d'exploration",
    "Crawl done on": "Exploration effectuée le",
    "Crawl finalized on": "Exploration terminée le ",
    "Crawl info": "Infos sur l'exploration",
    "Crawl runtime:": "Durée d'exécution de l'exploration :",
    "Crawl started:": "L'exploration a commencé :",
    "Crawl status": "État de l'exploration",
    "Crawl status:": "État de l'exploration :",
    "Crawled Documents ([[documentCount]])": "([[documentCount]]) documents explorés",
    "Crawled at": "Exploré à",
    "Crawled pages": "Pages explorées",
    "Crawling": "Exploration en cours",
    "Create a policy to make an email as unwanted content": "Créer une politique pour faire d'un e-mail un contenu indésirable",
    "Create as policy": "Créer en tant que politique",
    "Create label": "Créer une étiquette",
    "Create new domain group": "Créer un nouveau groupe de domaines",
    "Create new group": "Créer un nouveau groupe",
    "Create user": "Créer un utilisateur",
    "Create your own policy": "Créer votre propre politique",
    "Created": "Créée",
    "Created At": "Créée À",
    "Created at": "Créée à",
    "Created date": "Date de création",
    "Created:": "Créée :",
    "Current domain status": "Statut actuel du domaine",
    "Current status": "Statut actuel",
    "Custom": "Personnaliser",
    "Custom Multistep": "Personnaliser le multi-étapes",
    "Custom Profile": "Personnaliser le profil",
    "Custom fixes": "Personnaliser les corrections",
    "Custom rule": "Personnaliser la règle",
    "Customer": "Client",
    "Customer Report": "Rapport client",
    "DATA PRIVACY OVERVIEW": "APERÇU DE LA CONFIDENTIALITÉ DES DONNÉES",
    "DISCLAIMER": "AVIS DE NON-RESPONSABILITÉ",
    "Daily": "Quotidiennement",
    "Danish": "Danois",
    "Dark": "Sombre",
    "Dashboard": "Tableau de bord",
    "Data Issues": "Problèmes de données",
    "Data Privacy": "Confidentialité des données",
    "Data Privacy Diagnostics": "Diagnostics sur la confidentialité des données",
    "Data Privacy Fast Track": "Fast Track pour la confidentialité des données",
    "Data Privacy Help Center": "Centre d'aide sur la confidentialité des données",
    "Data Privacy Info Type Icon": "Icône de type d'informations sur la confidentialité des données",
    "Data Privacy Issues": "Problèmes de Confidentialité des Données",
    "Data Privacy Summary Export": "Exportation du résumé sur la confidentialité des données",
    "Data Privacy issues found": "Problèmes de confidentialité des données trouvés",
    "Data Regulations": "Règlement sur les données",
    "Data Violations": "Violations de données",
    "Data issues": "Problèmes de données",
    "Data issues export": "Exportation des problèmes de données",
    "Data privacy": "Confidentialité des données",
    "Data privacy violations": "Infractions à la confidentialité des données",
    "Data protection and privacy policy statement": "Déclaration concernant la politique de protection des données et de la vie privée",
    "Date": "Date",
    "Day": "Jour",
    "Days": "Jours",
    "Dead": "Mort",
    "Default": "Défaut",
    "Default for CMS": "Par défaut pour le CMS",
    "Default value*": "Valeur par défaut*",
    "Define meta headers to match": "Définir les en-têtes méta à faire correspondre",
    "Define size of files to look for": "Définir la taille des fichiers à rechercher",
    "Define size of images to look for": "Définir la taille des images à rechercher",
    "Delete": "Supprimer",
    "Delete All": "Supprimer tout",
    "Delete user": "Supprimer l'utilisateur",
    "Describe the exclude": "Décrire l'exclusion",
    "Description": "Description",
    "Desktop": "Bureau",
    "Details": "Détails",
    "Device": "Appareil",
    "Device Overview": "Aperçu de l'appareil",
    "Device not found": "Appareil non trouvé",
    "Device:": "Appareil :",
    "Devices": "Appareils",
    "Diagnostics": "Diagnostics",
    "Dictionary": "Dictionnaire",
    "Difficulty": "Difficulté",
    "Direct visits": "Visites directes",
    "Disabling": "Désactivation",
    "Display policy in other services": "Afficher la politique dans d'autres services",
    "Display this policy as:": "Afficher cette politique comme :",
    "Distribution of Data Privacy levels": "Distribution des niveaux de confidentialité des données",
    "Distribution of PageCorrects across all change types": "Distribution des PageCorrects pour tous les types de changements",
    "Distribution of SEO levels": "Distribution des niveaux de SEO",
    "Distribution of policies that match their corresponding setting": "Distribution des politiques qui correspondent à leurs propres paramètres",
    "Distribution of policies that matches their corresponding setting": "Distribution des politiques qui correspondent à leurs propres paramètres",
    "Do you want the policy to run every time your website is crawled?": "Voulez-vous que la politique soit exécutée à chaque fois que votre site web est exploré ?",
    "Do you want to find pages which match the query on one or multiple lines?": "Voulez-vous trouver des pages qui correspondent à la requête sur une ou plusieurs lignes ?",
    "Do you want to find pages which match the query or pages which does not match the query": "Voulez-vous trouver des pages qui correspondent à la requête ou des pages qui ne correspondent pas à la requête ?",
    "Do you want to update the Script Settings, for this Domain?": "Souhaitez-vous mettre à jour les paramètres de script pour ce domaine ?",
    "Document": "Document",
    "Document Class": "Classe du document",
    "Document Dashboard": "Tableau de bord du document",
    "Document Details": "Détails du document",
    "Document Extension": "Extension du document",
    "Document Ignore Class": "Ignorer la classe du document",
    "Document first detected": "Document détecté pour la première fois",
    "Document scan": "Analyse du document",
    "Documents": "Documents",
    "Documents Crawled": "Documents explorés",
    "Documents basic": "Infos de base du document",
    "Documents crawled": "Documents explorés",
    "Documents extended": "Documents étendus",
    "Documents with Broken Image": "Documents avec image défectueuse",
    "Documents with Broken Link": "Documents avec lien défectueux",
    "Domain": "Domaine",
    "Domain Compliance": "Conformité du domaine",
    "Domain Data Privacy Settings": "Paramètres de confidentialité des données du domaine",
    "Domain Detail": "Détail du domaine",
    "Domain Details": "Détails du domaine",
    "Domain Groups": "Groupes de domaines",
    "Domain Picker Closed": "Fermeture du sélecteur du domaine",
    "Domain Picker Opened": "Ouverture du sélecteur du domaine",
    "Domain compliance": "Conformité du domaine",
    "Domain group": "Groupe de domaines",
    "Domain title and URL": "Titre et URL du domaine",
    "Domain:": "Domaine :",
    "Domains": "Domaines",
    "Domains/groups selected": "Domaines/groupes sélectionnés",
    "Done": "Terminé",
    "Download": "Télécharger",
    "Download the Chrome extension": "Télécharger l'extension Chrome",
    "Download the Edge add-on": "Télécharger le module complémentaire Edge",
    "Download the Firefox add-on": "Télécharger le module complémentaire Firefox",
    "Downloads": "Téléchargements",
    "Downtime": "Temps d'arrêt",
    "Downtime (Minutes)": "Temps d'arrêt (minutes)",
    "Downtime notification": "Notification de temps d'arrêt",
    "Drag and drop the rule to add rules to the policy": "Glisser-déposer la règle pour ajouter des règles à la politique",
    "Dropdown": "Liste déroulante",
    "Duration": "Durée",
    "Easy": "Facile",
    "Easy to read pages understood by most. Example: fiction literature for adults": "Pages faciles à lire et comprises par la plupart. Exemple : littérature de fiction pour adultes",
    "Edge add-on": "Module complémentaire Edge",
    "Edit": "Modifier",
    "Edit Labels": "Modifier les étiquettes",
    "Edit Performance Page": "Modifier la page des performances",
    "Edit customer information": "Modifier les informations clients",
    "Edit domain": "Modifier le domaine",
    "Edit domain group": "Modifier le groupe du domaine",
    "Edit exemption": "Modifier l'exemption",
    "Edit label": "Modifier l'étiquette",
    "Edit labels": "Modifier les étiquettes",
    "Edit my profile": "Modifier mon profil",
    "Edit or Delete PageCorrect": "Modifier ou supprimer PageCorrect",
    "Edit uptime": "Modifier le temps de fonctionnement",
    "Edit user": "Modifier l'utilisateur",
    "Edit users": "Modifier les utilisateurs",
    "Edit your exemption": "Modifier votre exemption",
    "Edit:": "Modifier :",
    "Effect on compliance": "Effet sur la conformité",
    "Effect on overall compliance level": "Effet sur le niveau global de conformité",
    "Element": "Élément",
    "Element Tree Path": "Chemin d'accès à ElementTree",
    "Email": "E-mail",
    "Email Notifications": "Notifications par e-mail",
    "Email addresses": "Adresses e-mail",
    "Email receiver *": "Destinataire de l'e-mail *",
    "Email to login": "E-mail pour se connecter",
    "Emails": "E-mails",
    "Empty": "Vide",
    "Empty mailto": "Mailto vide",
    "Enable / Disable Accessibility mode": "Activer / désactiver le mode Accessibilité",
    "Enable Document Tracking": "Activer le suivi des documents",
    "Enable Export Email Notification": "Activer la notification par e-mail des exportations",
    "Enable Statistics": "Activer les statistiques",
    "Enabled features": "Fonctionnalités activées",
    "Enabling": "Activation",
    "End at": "Fin à",
    "End date": "Date de fin",
    "End time": "Heure de fin",
    "English": "Anglais",
    "Enter the full URL": "Saisir l'URL complète",
    "Entries": "Entrées",
    "Entry": "Entrée",
    "Entry Pages": "Pages d'entrée",
    "Entry and Exit Pages": "Pages d'entrée et de sortie",
    "Error": "Erreur",
    "Error Name": "Nom de l'erreur",
    "Errors": "Erreurs",
    "Errors ([[audits]])": "([[audits]]) erreurs",
    "Exact": "Exact",
    "Example: academic publications": "Exemple : publications universitaires",
    "Example: children's literature": "Exemple : littérature pour enfants",
    "Example: daily newspapers": "Exemple : journaux quotidiens",
    "Example: fiction books": "Exemple : livres de fiction",
    "Example: legal texts": "Exemple : textes juridiques",
    "Examples": "Exemples",
    "Excel Documents": "Documents Excel",
    "Exclude": "Exclure",
    "Exclude links that contains class name": "Exclure les liens qui contiennent un nom de classe",
    "Exclude pattern": "Exclure le modèle",
    "Excluded IP addresses from statistics": "Adresses IP exclues des statistiques",
    "Exemption": "Exemption",
    "Exemption options": "Options d'exemption",
    "Exemption time": "Durée d'exemption",
    "Exemptions": "Exemptions",
    "Exit Pages": "Pages de sortie",
    "Exits": "Sorties",
    "Expand": "Élargir",
    "Explain the rationale behind the policy and which actions, editors should take to correct the violation": "Expliquer la raison d'être de la politique et les mesures que les éditeurs doivent prendre pour corriger l'infraction.",
    "Export": "Exporter",
    "Export CSV": "Exporter le CSV",
    "Export Compound CSV": "Exporter le CSV groupé",
    "Export Logs": "Exporter les journaux",
    "Export list of broken images organized by page and document title": "Exporter la liste des images défectueuses triées par page et par titre de document",
    "Export list of broken links organized by page and document title": "Exporter la liste des liens défectueux triés par page et par titre de document",
    "Export list of downtimes for the domain": "Exporter la liste des temps d'arrêt pour le domaine",
    "Export list of response times": "Exporter la liste des temps de réponse",
    "External": "Externe",
    "External Export": "Exportation externe",
    "External PDF Compliance": "Conformité PDF externe",
    "External PDFs": "PDF externes",
    "External Referring Domains": "Domaines de référence externes",
    "External Referring domains": "Domaines de référence externes",
    "External referees overview": "Aperçu des référents externes",
    "External referring domains": "Domaines de référence externes",
    "FCP": "FCP",
    "FMP": "FMP",
    "Facebook": "Facebook",
    "Fail Example": "Exemple d'échec",
    "Failed": "Échec",
    "Failing accessibility checks": "Échec des vérifications d'accessibilité",
    "Failing accessibility checks gives you information about the current Accessibility status of the website/group. It may vary from the history if there have been changes in ignored and review of accessibility issues": "L'échec des vérifications d'accessibilité vous donne des informations sur l'état actuel de l'accessibilité du site web/groupe. Cela peut différer de l'historique si des modifications ont été ignorées et examinées dans les problèmes d'accessibilité. ",
    "Failing check": "Échec de la vérification",
    "Failing check found": "Échec de la vérification trouvé",
    "Failing checks": "Échec des vérifications",
    "Failing checks found": "Échec des vérifications trouvé",
    "Fast Track": "Fast Track",
    "Fast track html snippet": "Extrait html Fast Track",
    "Faster": "Plus rapidement",
    "Features": "Caractéristiques",
    "Feedback submitted": "Feedback envoyé",
    "File size": "Taille de fichier",
    "Filter": "Filtrer",
    "Filter by": "Filtrer par",
    "Filter by:": "Filtrer par :",
    "Filter labels list": "Filtrer la liste des étiquettes",
    "Find and address violations relating to your content guides and regulatory compliance and find outdated content across your website.": "Trouver et traiter les infractions relatives à vos guides de contenu et à la conformité réglementaire, et trouver les contenus obsolètes sur votre site web.",
    "Find word(s) without specific context": "Trouver un ou des mots sans contexte spécifique",
    "Firefox add-on": "Module complémentaire Firefox",
    "First Contentful Paint": "First Contentful Paint",
    "First Meaningful Paint": "First Meaningful Paint",
    "First name": "Prénom",
    "Fixed": "Résolu",
    "Fixed or ignored violations": "Infractions résolues ou ignorées",
    "Flesch Kincaid": "Flesch Kincaid",
    "For this domain": "Pour ce domaine",
    "Form": "Formulaire",
    "Form fields": "Champs du formulaire",
    "Forms": "Formulaires",
    "Found": "Trouvé",
    "Four times a day": "Quatre fois par jour",
    "Frames": "Cadres",
    "Friday": "Vendredi",
    "From 2 seconds to 8 seconds": "De 2 secondes à 8 secondes",
    "Generating report": "Génération du rapport",
    "Get advice on how to handle this check": "Obtenir des conseils sur la manière de traiter cette vérification",
    "Getting {{ logs }} out of {{totalLogs}} logs": "Obtenir {{ logs }} sur {{totalLogs}} journaux",
    "Global - All Domains": "Global - Tous les domaines",
    "Global Policies": "Politiques Globales",
    "Global Policy Dashboard": "Tableau de bord de la politique globale",
    "Global Policy List": "Liste des politiques globales",
    "Go to Global Policy List": "Aller à la liste des politiques globales",
    "Go to My Exports": "Aller à Mes exportations",
    "Go to PDFs": "Aller aux PDF",
    "Go to Policy List": "Aller à la liste des politiques",
    "Go to broken Links": "Aller aux liens défectueux",
    "Go to broken images": "Aller aux images défectueuses",
    "Go to broken links": "Aller aux liens défectueux",
    "Go to checkpoints": "Aller aux points de contrôle",
    "Go to data issues": "Aller aux problèmes de données",
    "Go to domain": "Aller au domaine",
    "Go to help center": "Aller au centre d'aide",
    "Go to mispellings": "Aller aux fautes d'orthographe",
    "Go to misspellings": "Aller aux fautes d'orthographe",
    "Go to most visits pages": "Aller aux pages les plus visitées",
    "Go to page": "Aller à la page",
    "Go to page details": "Aller aux détails de la page",
    "Go to potential misspellings": "Aller aux fautes d'orthographe potentielles",
    "Go to predefined url": "Aller à l'url prédéfinie",
    "Go to the dashboard": "Aller au tableau de bord",
    "Go to traffic sources overview": "Aller à l'aperçu des sources de trafic",
    "Go to uptime": "Aller au temps de fonctionnement",
    "Go to visitor overview": "Aller à l'aperçu des visiteurs",
    "Good job! No incidents was registered": "Bravo ! Aucun incident n'a été enregistré",
    "Good job! No issues were found": "Bravo ! Aucun problème n'a été trouvé",
    "Good job! No violations were found": "Bravo ! Aucune infraction n'a été trouvée",
    "Google": "Google",
    "Greater than 8 seconds": "Plus de 8 secondes",
    "Grid View": "Vue en grille",
    "Groups": "Groupes",
    "Guidelines": "Directives",
    "Guidelines for WCAG 2.0": "Directives pour WCAG 2.0",
    "Guidelines for WCAG 2.1": "Directives pour WCAG 2.1",
    "H1 on this page": "H1 sur cette page",
    "HTML": "HTML",
    "HTML Pages": "Pages HTML",
    "HTML pages": "Pages HTML",
    "HTML snippet": "Extrait HTML",
    "HTML snippet affecting compliance level": "Extrait HTML affectant le niveau de conformité",
    "HTML snippet failing check": "Échec de la vérification de l'extrait HTML",
    "Hard": "Difficile",
    "Hard to read text. Example: popular science magazines and easier academic publications": "Texte difficile à lire. Exemple : magazines de vulgarisation scientifique et publications universitaires plus accessibles",
    "Harmony CMS": "CMS Harmony",
    "Header type": "Type d'en-tête",
    "Headers": "En-têtes",
    "Headlinks": "Liens de tête",
    "Heartbeat": "Heartbeat",
    "Heartbeat Downtime": "Temps d'arrêt de Heartbeat",
    "Heartbeat Response Time": "Temps de réponse du Heartbeat",
    "Heartbeat status saved": "État du Heartbeat sauvegardé",
    "Heatmaps": {
      "$$noContext": "Cartes thermiques",
      "Topmenu": "Cartes thermiques"
    },
    "Help Center": "Centre d'aide",
    "Help center": "Centre d'aide",
    "High": "Fort",
    "High impact": "Fort impact",
    "High impact opportunities": "Opportunités à fort impact",
    "High priority": "Haute priorité ",
    "High severity": "Haute gravité",
    "High severity issues": "Problèmes de haute gravité",
    "Highest level of readability. Example: complex academic and legal texts": "Niveau de lisibilité le plus élevé. Exemple : textes académiques et juridiques complexes",
    "History": "Historique",
    "Hit": "Résultat",
    "Hits": "Résultats",
    "Hits across all domains and modules": "Résultats dans l'ensemble des domaines et modules",
    "Hits on domain": "Résultats sur le domaine",
    "Home": "Accueil",
    "Host": "Hôte",
    "Hosts": "Hôtes",
    "Hosts cannot be empty": "Les hôtes ne peuvent pas être vides",
    "Hours": "Heures",
    "How often the page is checked": "Fréquence de vérification de la page",
    "How to fix this problem": "Comment résoudre ce problème",
    "How to prevent": "Comment éviter",
    "How to setup this policy": "Comment mettre en place cette politique",
    "IFrames": "IFrames",
    "IP address": "Adresse IP",
    "Icon": "Icône",
    "Icon status": "Statut de l'icône",
    "Identifier": "Identifiant",
    "Ignore": "Ignorer",
    "Ignore check": "Ignorer la vérification",
    "Ignore misspelling": "Ignorer les fautes d'orthographe",
    "Ignore on the page": "Ignorer sur la page",
    "Ignore on this page": "Ignorer sur cette page",
    "Ignore this SEO issue": "Ignorer cette question de SEO",
    "Ignore this check": "Ignorer cette vérification",
    "Ignore this check for this domain": "Ignorer cette vérification pour ce domaine",
    "Ignored": "Ignorée",
    "Ignored Misspellings": "Fautes d'orthographe ignorées",
    "Ignored Policies": "Politiques ignorées",
    "Ignored checks": "Vérifications ignorées",
    "Ignored issue": "Problème ignoré",
    "Ignored policies": "Politiques ignorées",
    "Ignoring broken link": "Ignorer le lien défectueux",
    "Image": "Image",
    "Image Links": "Liens des images",
    "Image sources that will be fixed": "Sources d'images qui seront corrigées",
    "Images": "Images",
    "Import rules": "Règles d'importation",
    "Import rules from CSV": "Importer des règles à partir d'un fichier CSV",
    "Important Highlights": "Faits marquants importants",
    "Important Notifications": "Notifications importantes",
    "Important notification:": "Notification importante :",
    "In compliance": "En conformité",
    "In progress of ignoring/reviewing all": "Ignorance/Examen en cours de tous les",
    "Inactive": "Inactif",
    "Incidents": "Incidents",
    "Includes both documents and pages": "Inclut à la fois les documents et les pages",
    "Incoming Links": "Liens entrants",
    "Incoming links": "Liens entrants",
    "Indicates the difficulty to fix an audit error": "Indique la difficulté de corriger une erreur d'audit",
    "Indicates when some parts of the domain are not scanned due to Constraints / Exclusions being applied": "Indique que certaines parties du domaine ne sont pas analysées en raison des Contraintes / Exclusions qui sont appliquées",
    "Individual issues": "Problèmes individuels",
    "Information": "Informations",
    "Information about this Check is not yet available": "Les informations sur cette vérification ne sont pas encore disponibles",
    "Information and the operation of user interface must be understandable.": "Les informations et le fonctionnement de l'interface utilisateur doivent être compréhensibles.",
    "Information and user interface components must be presentable to users in ways they can perceive.": "Les informations et les composants de l'interface utilisateur doivent être présentés aux utilisateurs de manière perceptible.",
    "Inline Images": "Images en ligne",
    "Inline images": "Images en ligne",
    "Input selector*": "Sélecteur d'entrée*",
    "Input user data": "Saisir les données utilisateur",
    "Internal": "Interne",
    "Internal Export": "Exportation interne",
    "Internal PDF Compliance": "Conformité PDF interne",
    "Internal PDFs": "PDF internes",
    "Internal URLs": "URL internes",
    "Inventory": "Inventaire",
    "Inventory Documents Export": "Exportation de documents d'inventaire",
    "Inventory History": "Historique de l'inventaire",
    "Invite to new project": "Inviter à un nouveau projet",
    "Is not a valid url": "N'est pas une url valide",
    "Is not crawling automatically": "N'explore pas automatiquement",
    "Is not tagged": "N'est pas étiqueté",
    "Issue": "Problème",
    "Issue changes": "Changements de problème.",
    "Issue changes since previous crawl": "Changements de problème depuis la dernière exploration. ",
    "Issue name": "Nom du problème",
    "Issue type": "Type de problème",
    "Issues": "Problèmes",
    "Issues by Severities": "Problèmes par gravité",
    "Issues changes since previous crawl": "Changements de problème depuis la dernière exploration",
    "JS": "JS",
    "JavaScript": "JavaScript",
    "Javascript": "Javascript",
    "Javascript crawl": "Exploration Javascript",
    "KB": "KB",
    "Keyword": "Mot-clé",
    "Knowledge Base": {
      "$$noContext": "Base de connaissances",
      "Topmenu": "Base de connaissances"
    },
    "LIX": "LIX",
    "Label": "Étiquette",
    "Label created": "Étiquette créée",
    "Label name": "Nom de l'étiquette",
    "Label overlay": "Superposition d'étiquettes",
    "Label preview": "Aperçu de l'étiquette",
    "Label updated": "Étiquette actualisée",
    "Labels": "Étiquettes",
    "Language": "Langue",
    "Language Detected": "Langue détectée",
    "Languages": "Langues",
    "Languages found": "Langues trouvées",
    "Last Scan": "Dernière analyse",
    "Last check: [[lastCheckTime]]": "Dernière vérification : [[lastCheckTime]]",
    "Last check: [[performanceScannedAt]]": "Dernière vérification : [[performanceScannedAt]]",
    "Last downtime:": "Dernier temps d'arrêt :",
    "Last load time": "Dernier temps de chargement",
    "Last name": "Nom de famille",
    "Last run": "Dernière exécution",
    "Last run [[date]]": "Dernière exécution [[date]]",
    "Last run:": "Dernière analyse :",
    "Last scan": "Dernière analyse",
    "Last scan never": "Dernière exécution jamais",
    "Last scan: [[duration]] ago": "Dernière analyse : il y a [[duration]]",
    "Latest Updated PageCorrects": "Dernière mise à jour de PageCorrects",
    "Latest login": "Dernière connexion",
    "Least Popular Pages": "Pages les moins populaires",
    "Less than 10": "Moins de 10",
    "Less than 100": "Moins de 100",
    "Less than 2 seconds": "Moins de 2 secondes",
    "Less than 50": "Moins de 50",
    "Level": "Niveau",
    "Level A": "Niveau A",
    "Level A Issues": "Problèmes de niveau A",
    "Level A accessibility checks": "Vérifications d'accessibilité de niveau A",
    "Level A compliance": "Conformité de niveau A",
    "Level A failing checks": "Échec des vérifications de niveau A",
    "Level AA": "Niveau AA",
    "Level AA Issues": "Problèmes de niveau AA",
    "Level AA accessibility checks": "Vérifications d'accessibilité de niveau AA",
    "Level AA compliance": "Conformité de niveau AA",
    "Level AA failing checks": "Échec des vérifications de niveau AA",
    "Level AAA": "Niveau AAA",
    "Level AAA Issues": "Problèmes de niveau AAA",
    "Level AAA accessibility checks": "Vérifications d'accessibilité de niveau AAA",
    "Level AAA compliance": "Conformité de niveau AAA",
    "Level AAA failing checks": "Échec des vérifications de niveau AAA",
    "Level [[level]]": "Niveau[[level]]",
    "Levels": "Niveaux",
    "Likelihood": "Probabilité",
    "Likelihood unspecified": "Probabilité non spécifiée",
    "Link": "Lien",
    "Link Type": "Type de lien",
    "Link excludes": "Le lien exclut",
    "Link fixes": "Corrections du lien",
    "Link is broken": "Le lien est défectueux",
    "Link of page": "Lien de la page",
    "Link to image": "Lien vers l'image",
    "Linkedin": "Linkedin",
    "Links": "Liens",
    "Links To Documents Export": "Exportation des liens vers les documents ",
    "Links from other account domains": "Liens provenant d'autres domaines du compte",
    "Links from own domain": "Liens du propre domaine",
    "Links with policy matches": "Liens avec des correspondances aux politiques",
    "Links with the rel=\\\"nofollow\\\" attribute will not pass link equity/SEO value to the linked page. This can be used for pages with user generated comments where you want to avoid that a competitor posts a comment with a link to their own website thus benefiting from your original content. This is not an \\\"error\\\" per se but make sure that the link does not have this attribute as a result of an error.": "Les liens avec l'attribut rel=\"nofollow\" ne transmettront pas la valeur du lien équité/SEO à la page liée. Cette fonction peut être utilisée pour les pages contenant des commentaires générés par les utilisateurs, afin d'éviter qu'un concurrent ne publie un commentaire contenant un lien vers son propre site web, ce qui lui permettrait de profiter de votre contenu original. Il ne s'agit pas d'une \\\"erreur\\\" en soi, mais il faut s'assurer que le lien n'a pas cet attribut à la suite d'une erreur.",
    "List": "Liste",
    "List of accessibility issues": "Liste des problèmes d'accessibilité",
    "List of all labels": "Liste de toutes les étiquettes",
    "List of checks with and without issues": "Liste des vérifications avec et sans problèmes",
    "List of content containing links": "Liste des contenus contenant des liens",
    "List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)": "Liste de l'emplacement de tous vos actifs sur le site web (ex : documents, liens, adresses e-mail, extraits de code, etc.)",
    "List view": "Vue de la liste",
    "Lists all profiles available for your account": "Liste de tous les profils disponibles pour votre compte",
    "Load Times Trend": "Tendance des temps de chargement",
    "Loading domains, please wait": "Domaines en cours de chargement, veuillez patienter",
    "Loading new domain": "Chargement d'un nouveau domaine",
    "Loading times": "Temps de chargement",
    "Locale": "Locale",
    "Location": "Emplacement",
    "Location not found": "Emplacement non trouvé",
    "Locations": "Emplacements",
    "Log out": "Déconnexion",
    "Login Type": "Type de connexion",
    "Long": "Longue",
    "Lookup in Google": "Recherche dans Google",
    "Low": "Faible",
    "Low impact": "Faible impact",
    "Low impact opportunities": "Opportunités à faible impact",
    "Low priority": "Faible priorité",
    "Low severity": "Faible gravité",
    "Low severity issues": "Problèmes de faible gravité",
    "MB": "MB",
    "META content": "Contenu META",
    "META name/property": "Nom/propriété META",
    "Main-Thread Blocking Time": "Temps de blocage du fil principal",
    "Mark 403 as broken link": "Marquer 403 comme lien défectueux",
    "Mark all as reviewed/ignored": "Marquer tous les documents comme examinés/ignorés",
    "Mark as fixed": "Marquer comme résolu",
    "Mark as ignored": "Marquer comme ignoré",
    "Mark as not fixed": "Marquer comme non résolu",
    "Marked as fixed": "Marqué comme résolu",
    "Marked as reviewed": "Marqué comme examiné",
    "Marking broken link as fixed": "Marquer un lien défectueux comme réparé",
    "Match": "Correspondance",
    "Match rule": "Règle de correspondance",
    "Matches": "Correspondances",
    "Max": "Max",
    "Max scanned pages": "Nombre maximal de pages analysées",
    "Measure from": "Mesurer à partir de",
    "Measure from:": "Mesurer à partir de :",
    "Measurement Settings": "Paramètres de mesure",
    "Measurements since [[date]]": "Mesures depuis [[date]]",
    "Medium": "Moyen",
    "Medium complexity of text. Example: newspapers and magazines": "Texte de complexité moyenne. Exemple : journaux et magazines",
    "Medium impact": "Impact moyen",
    "Medium impact opportunities": "Opportunités à impact moyen",
    "Medium priority": "Priorité moyenne",
    "Medium severity": "Gravité moyenne",
    "Medium severity issues": "Problèmes de gravité moyenne",
    "Meta Header Expr": "Meta Header Expr",
    "Meta Name": "Nom Méta",
    "Metadata": "Métadonnées",
    "Metadata key": "Clé de métadonnées",
    "Milliseconds": "Millisecondes",
    "Minimum words": "Nombre de mots minimum",
    "Minutes": "Minutes",
    "Minutes of slow response before you get an email": "Quelques minutes de lenteur avant de recevoir un e-mail",
    "Mispelling": "Faute d'orthographe",
    "Misspelling": "Faute d'orthographe",
    "Misspelling affecting the most content": "Faute d'orthographe affectant le plus de contenu",
    "Misspellings": "Fautes d'orthographe",
    "Misspellings history": "Historique des fautes d'orthographe",
    "Mobile": "Mobile",
    "Moderate": "Modéré",
    "Module": "Module",
    "Monday": "Lundi",
    "Monitoring": "Surveillance",
    "Monthly": "Mensuellement",
    "Months": "Mois",
    "More info": "Plus d'informations",
    "More than": "Plus de ",
    "More than [[count]]": "Plus de [[count]]",
    "Most Downloads": "Le plus grand nombre de téléchargements",
    "Most Frequent": "Les plus fréquents",
    "Most Popular Pages": "Pages les plus populaires",
    "Most common SEO checkpoint needing review": "Les points de contrôle les plus courants en matière de SEO doivent être examinés",
    "Most common language": "Langue la plus courante",
    "Most common misspellings": "Fautes d'orthographe les plus courantes",
    "Most common opportunities found": "Opportunités les plus courantes trouvées",
    "Most common policy violation on this domain": "Infraction à la politique la plus fréquente pour ce domaine",
    "Most common potential misspellings": "Fautes d'orthographe potentielles les plus courantes",
    "Most common readability level": "Niveau de lisibilité le plus courant",
    "Most of your pages have the readability level": "La plupart de vos pages ont le niveau de lisibilité",
    "Most pages have this readability level": "La plupart des pages ont ce niveau de lisibilité",
    "Most prominent issues ranked by severity level": "Les problèmes les plus importants classés par niveau de gravité",
    "Most serious issues found": "Problèmes les plus graves trouvés",
    "Most visited pages": "Pages les plus visitées",
    "Move focus down on domain picker": "Déplacer l'attention vers le bas sur le sélecteur de domaine",
    "Move focus up on domain picker": "Déplacer l'attention vers le haut sur le sélecteur de domaine",
    "Multiline": "Multiligne",
    "My Exports": "Mes exportations",
    "My profile": "Mon profil",
    "N/A": "S/O",
    "NA": "SO",
    "NB! Connection Settings cannot be edited after save": "NB ! Les paramètres de connexion ne peuvent pas être modifiés après avoir la sauvegarde",
    "NOTE: If you want to copy the Legacy Script. Click {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}here{{anchorEnd}}.": "REMARQUE : si vous souhaitez copier le script hérité. Cliquez sur {{anchorStart}} role=\\\"button\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}ici{{anchorEnd}}.",
    "Name": {
      "$$noContext": "Nom",
      "Exchange Center Sort by option": "Nom"
    },
    "Network not found": "Réseau non trouvé",
    "Network speed": "Vitesse du réseau",
    "Network speed:": "Vitesse du réseau :",
    "Never": "Jamais",
    "Never scanned": "Jamais analysé(e)",
    "New": "Nouveau",
    "New Performance Page": "Nouvelle page de performance",
    "New Policy": "Nouvelle politique",
    "New password": "Nouveau mot de passe",
    "Next": "Suivant",
    "No Broken Links marked as Fixed": "Aucun lien défectueux marqué comme rétabli",
    "No CSS": "Pas de CSS",
    "No Content links": "Pas de liens de contenu",
    "No Data available for selected time frame": "Pas de données disponibles pour la période sélectionnée",
    "No Documents found": "Aucun document trouvé",
    "No Domains or Groups are yet selected for this report": "Aucun domaine ou groupe n'est encore sélectionné pour ce rapport.",
    "No Frames": "Pas de cadre",
    "No Frequency": "Pas de fréquence",
    "No HTML Pages found": "Aucune page HTML trouvée",
    "No Historic data available for Accessibility Level [[lvl]]": "Aucune donnée historique n'est disponible pour le niveau d'accessibilité [[lvl]]",
    "No IFrames": "Pas d'IFrames",
    "No Ignored Broken Links": "Pas de liens défectueux ignorés",
    "No Image Links found": "Aucun lien d'image n'a été trouvé",
    "No PDF's failed": "Pas de PDF défaillant",
    "No PDF's pending": "Pas de PDF en attente",
    "No PDF's queued": "Pas de PDF en attente",
    "No PDF's reviewed": "Pas de PDF examiné",
    "No PDFs are reviewed": "Aucun PDF n'est examiné",
    "No Policies detected": "Aucune politique détectée",
    "No Profiles were found": "Aucun profil n'a été trouvé",
    "No Spreadsheet links found": "Aucun lien vers une feuille de calcul n'a été trouvé",
    "No Users are yet selected to receive this report": "Aucun utilisateur n'a encore été sélectionné pour recevoir ce rapport",
    "No Word links found": "Aucun lien de mots n'a été trouvé",
    "No changes": "Pas de modifications",
    "No changes found": "Aucune modification trouvée",
    "No checks found for this Accessibility category": "Aucune vérification trouvée pour cette catégorie d'accessibilité",
    "No content policies have been created yet": "Aucune politique de contenu n'a encore été créée",
    "No corrections added to PageCorrect": "Aucune correction ajoutée à PageCorrect",
    "No data available": "Pas de données disponibles",
    "No data present": "Aucune donnée présente",
    "No diagnostics issues were found": "Aucun problème de diagnostic n'a été trouvé",
    "No domains were found": "Aucun domaine n'a été trouvé",
    "No downloads found": "Aucun téléchargement trouvé",
    "No errors found": "Aucune erreur trouvée",
    "No exemptions added to this checkpoint": "Aucune exemption ajoutée à ce point de contrôle",
    "No exports available": "Pas d'exportations disponibles",
    "No groups were found for this domain": "Aucun groupe n'a été trouvé pour ce domaine",
    "No historic data available for this domain": "Aucune donnée historique disponible pour ce domaine",
    "No hits found": "Aucun résultat trouvé",
    "No ignored checks in this accessibility category": "Aucune vérification ignorée dans cette catégorie d'accessibilité",
    "No ignored misspellings found for this page": "Aucune faute d'orthographe ignorée trouvée pour cette page.",
    "No incidents occurred in the selected time frame": "Aucun incident survenu au cours de la période sélectionnée",
    "No issues found": "Aucun problème trouvé",
    "No javascript": "Pas de javascript",
    "No name defined": "Pas de nom défini",
    "No new notifications": "Pas de nouvelles notifications",
    "No note has been added": "Aucune note n'a été ajoutée",
    "No notifications available": "Aucune notification disponible",
    "No opportunities were found": "Aucune opportunité n'a été trouvée",
    "No outages in this period": "Pas de pannes pendant cette période",
    "No pages found": "Aucune page trouvée",
    "No pages were found": "Aucune page n'a été trouvée",
    "No passed checks in this accessibility category": "Aucune vérification réussie dans cette catégorie d'accessibilité",
    "No performance scan found": "Aucune analyse de performance trouvée",
    "No performance scans were found": "Aucune analyse de performance n'a été trouvée",
    "No policies found": "Aucune politique trouvée",
    "No readability score": "Pas de score de lisibilité",
    "No response received": "Pas de réponse reçue",
    "No run present": "Pas d'exécution présente",
    "No scan has yet been performed. Please check back later.": "Aucune analyse n'a encore été effectuée. Veuillez révérifier plus tard.",
    "No slide links found": "Aucun lien de diapositive trouvé",
    "No title found": "Aucun titre trouvé",
    "No title found on one or more pages": "Aucun titre trouvé sur une ou plusieurs pages",
    "No title is found on this page": "Aucun titre trouvé sur cette page",
    "No users available for this domain": "Aucun utilisateur disponible pour ce domaine",
    "No violations were found": "Aucune infraction n'a été trouvée",
    "No visitor profile selected": "Aucun profil de visiteur sélectionné",
    "No visits for this category in selected time frame": "Aucune visite pour cette catégorie dans la période sélectionnée",
    "No words have been added to the default dictionary": "Aucun mot n'a été ajouté au dictionnaire par défaut",
    "No. Visits": "Nb de visites",
    "Non-user list": "Liste des non-utilisateurs",
    "None": "Aucun",
    "Normal - recommended": "Normal - recommandé",
    "Normal violations": "Infractions normales",
    "Not case sensitive": "Non sensible à la casse",
    "Not containing": "Ne contenant pas",
    "Not scheduled": "Non programmé",
    "Not valid email": "E-mail non valide",
    "Note": "Note",
    "Notes": "Notes",
    "Notifications": "Notifications",
    "Number of characters in Meta Header text": "Nombre de caractères dans le texte de l'en-tête Meta",
    "Number of characters in header text": "Nombre de caractères dans le texte de l'en-tête",
    "Number of characters in image text": "Nombre de caractères dans le texte de l'image",
    "Number of characters in link text": "Nombre de caractères dans le texte du lien",
    "Number of characters in page title": "Nombre de caractères dans le titre de la page",
    "Number of pages": "Nombre de pages",
    "Number too high": "Nombre trop élevé",
    "Number too low": "Nombre trop faible",
    "OK": "OK",
    "Office 365 (BETA)": "Office 365 (BETA)",
    "Ok": "Ok",
    "Once a day": "Une fois par jour",
    "Once a week": "Une fois par semaine",
    "One or more documents have already been scanned for compliance. Are you sure you want to scan the selected documents again?": "Un ou plusieurs documents ont déjà été analysé(s) pour la conformité. Êtes-vous sûr de vouloir analyser à nouveau les documents sélectionnés ?",
    "One or more page on your website has the same H1 text.": "Une ou plusieurs pages de votre site web ont le même texte H1.",
    "One or more pages has been marked as no index": "Une ou plusieurs pages ont été marquées comme n'ayant pas d'index",
    "One or more pages on your website has this title": "Une ou plusieurs pages de votre site web portent ce titre",
    "Open": "Ouvrir",
    "Open Accessibility Decision Tree": "Ouvrir l'arbre de décision sur l'accessibilité",
    "Open Data Privacy": "Ouvrir la Confidentialité des données",
    "Open Data Privacy Settings": "Ouvrir les paramètres de confidentialité des données ",
    "Open Document Details": "Ouvrir les détails du document",
    "Open Document details": {
      "$$noContext": "Ouvrir les détails du document",
      "Aria label when clicking on open Document details": "Ouvrir les détails du document"
    },
    "Open Fast Track for this HTML snippet": "Ouvrir Fast Track pour cet extrait HTML",
    "Open New Help Center": "Ouvrir le nouveau centre d'aide",
    "Open Page Details": "Ouvrir les détails de la page",
    "Open Schedule downtime": "Ouvrir le temps d'arrêt du Calendrier",
    "Open document details": "Ouvrir les détails du document",
    "Open domain policy": "Ouvrir la politique du domaine",
    "Open example": "Ouvrir un exemple",
    "Open filters": "Ouvrir les filtres",
    "Open group": "Ouvrir un groupe",
    "Open help center": "Ouvrir le centre d'aide",
    "Open keyboard shortcuts": "Ouvrir les raccourcis clavier",
    "Open page details": {
      "$$noContext": "Ouvrir les détails de la page",
      "Aria label when clicking on open pagedetails": "Ouvrir les détails de la page"
    },
    "Open received reports": "Ouvrir les rapports reçus",
    "Open report": "Ouvrir le rapport",
    "Operating System": "Système d'exploitation",
    "Operating Systems": "Systèmes d'exploitation",
    "Operating systems": "Systèmes d'exploitation",
    "Operating systems Overview": "Aperçu des systèmes d'exploitation",
    "Operator*": "Opérateur*",
    "Opportunities": "Opportunités",
    "Opportunities by Priority": "Opportunités par priorité",
    "Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.": "En option, vous pouvez sélectionner la langue principale du domaine. Si vous choisissez l'anglais (UK), tout texte détecté en anglais sera considéré comme de l'anglais britannique.",
    "Options": "Options",
    "Or": "Ou",
    "Organizations": "Organisations",
    "Original Data": "Données originales",
    "Other Documents": "Autres documents",
    "Other files": "Autres fichiers",
    "Others": "Autres",
    "Our suggestion": "Notre proposition",
    "Our team has been notified of your request. We will soon be in touch.": "Notre équipe a été informée de votre demande. Nous vous contacterons prochainement. ",
    "Outages during the selected time-frame": "Pannes pendant la période sélectionnée",
    "Outages end": "Fin des pannes",
    "Outages start": "Début des pannes",
    "Outgoing Links": "Liens Sortants",
    "Outgoing links": "Liens sortants",
    "Over 1000 ms.": "Plus de 1000 ms.",
    "Over 10000 ms.": "Plus de 10000 ms.",
    "Over 200 ms.": "Plus de 200 ms.",
    "Over 2000 ms.": "Plus de 2000 ms.",
    "Over 3000 ms.": "Plus de 3000 ms.",
    "Over 4000 ms.": "Plus de 4000 ms.",
    "Over 500 ms.": "Plus de 500 ms.",
    "Over 5000 ms.": "Plus de 5000 ms.",
    "Over 6000 ms.": "Plus de 6000 ms.",
    "Over 7000 ms.": "Plus de 7000 ms.",
    "Over 8000 ms.": "Plus de 8000 ms.",
    "Over 9000 ms.": "Plus de 9000 ms.",
    "Overall Data Privacy compliance for this page": "Conformité globale sur la confidentialité des données pour cette page",
    "Overall PageCorrects": "PageCorrects Global",
    "Overall SEO compliance for this page": "Conformité globale du SEO pour cette page",
    "Overall accessibility compliance for this level": "Conformité globale de l'accessibilité à ce niveau",
    "Overall accessibility compliance level for this page": "Niveau de conformité globale de l'accessibilité pour cette page",
    "Overall compliance": "Conformité globale",
    "Overall policy compliance for this page": "Conformité globale de la politique pour cette page",
    "Owner": "Propriétaire",
    "PAGE PERFORMANCE OVERVIEW": "APERÇU DE LA PERFORMANCE DE LA PAGE",
    "PDF": "PDF",
    "PDF Compliance Status": "État de conformité des PDF ",
    "PDF Documents": "Documents PDF",
    "PDF accessibility scan completed at [[date]]": "Analyse d'accessibilité des PDF réalisée à [[date]]",
    "PDF accessibility scan requested": "Analyse d'accessibilité des PDF demandée",
    "PDF files": "Fichiers PDF",
    "PDF files pending": "Fichiers PDF en attente",
    "PDF files reviewed": "Fichiers PDF examinés",
    "PDF files that are reviewed or pending for accessibility": "Fichiers PDF dont l'accessibilité est examinée ou en cours d'examen",
    "PDFs": "PDFs",
    "POLICIES OVERVIEW": "APERÇU DES POLITIQUES",
    "Page": "Page",
    "Page Dashboard": "Tableau de bord de la page",
    "Page Details": "Détails de la page",
    "Page Performance": "Performance de la page",
    "Page Statistics": "Statistiques de la page",
    "Page URL": "URL de la page",
    "Page Views": "Pages vues",
    "Page compliance": "Conformité des pages",
    "Page count in PDF": "Nombre de pages en PDF",
    "Page dashboard": "Tableau de bord de la page",
    "Page details": "Détails de la page",
    "Page first detected": "Page détectée pour la première fois",
    "Page links": "Liens de page",
    "PageAssist Logo Position": "Position du logo PageAssist",
    "PageAssist Theme": "Thème PageAssist",
    "PageCorrect": "PageCorrect",
    "PageCorrect Content": "Contenu PageCorrect",
    "PageCorrect Custom Phrase or Word": "Phrase ou mot personnalisé PageCorrect",
    "PageCorrect Details": "Détails PageCorrect",
    "PageCorrect Diagnostics": "Diagnostics PageCorrect",
    "PageCorrects categorized": "PageCorrects catégorisé",
    "PageFixes": "PageFixes",
    "PageFixes Left": "PageFixes Gauche",
    "Pages": "Pages",
    "Pages & documents with confirmed misspellings, broken links or images": "Pages et documents contenant des fautes d'orthographe confirmées, des liens ou des images défectueux",
    "Pages Crawled": "Pages explorées",
    "Pages With Opportunities": "Pages avec des opportunités",
    "Pages and documents with policies marked as unwanted or required": "Pages et documents avec politiques marquées comme indésirables ou obligatoires",
    "Pages crawled": "Pages explorées",
    "Pages failing check": "Pages ayant échoué aux vérifications",
    "Pages in compliance": "Pages en conformité",
    "Pages related to policy link": "Pages liées au lien de la politique",
    "Pages that are difficult to read": "Pages qui sont difficiles à lire",
    "Pages that are easily understood by children below 5'th grade": "Pages facilement compréhensibles par des enfants en dessous de la 5ème année",
    "Pages that are easy to read. Conversational English for consumers": "Pages qui sont faciles à lire. Anglais conversationnel pour les consommateurs",
    "Pages that are fairly difficult to read": "Pages qui sont assez difficiles à lire",
    "Pages that are fairly easy to read": "Pages qui sont assez faciles à lire",
    "Pages that are in plain English. Easily understood by 13- to 15-year-old students": "Pages qui sont en Anglais simple.  Facilement compréhensible par des élèves de 13 à 15 ans",
    "Pages that are very difficult to read. Best understood by university graduates": "Pages qui sont très difficiles à lire. Mieux compris par des diplômés de l'université",
    "Pages that are very easy to read. Easily understood by an average 11-year-old student": "Pages qui sont très faciles à lire. Facilement compréhensible par un élève moyen de 11 ans",
    "Pages we could not determine Readability score": "Pages pour lesquelles nous n'avons pas pu déterminer le score de lisibilité",
    "Pages with Data Privacy issues": "Pages avec des problèmes de confidentialité des données",
    "Pages with Failing Checks": "Pages avec des vérifications ayant échoué",
    "Pages with Ignored Checks": "Pages avec des vérifications ignorées",
    "Pages with Misspellings": "Pages avec des fautes d'orthographe",
    "Pages with Opportunities": "Pages avec des opportunités",
    "Pages with Policy Issues": "Pages avec des problèmes de politique",
    "Pages with QA Issues": "Pages avec des problèmes d'assurance qualité",
    "Pages with QA issues": "Pages avec des problèmes d'assurance qualité",
    "Pages with SEO Opportunities": "Pages avec des opportunités de SEO",
    "Pages with SEO opportunities": "Pages avec des opportunités de SEO",
    "Pages with accessibility checks not in compliance": "Pages avec des vérifications d'accessibilité non conformes",
    "Pages with failing checks": "Pages avec des vérifications ayant échoué",
    "Pages with high, medium or low opportunities": "Pages avec des opportunités élevées, moyennes ou faibles",
    "Pages with ignored checks": "Pages avec des vérifications ignorées",
    "Pages with issues": "Pages avec des problèmes",
    "Pages with policy matches": "Pages avec des correspondances de politiques",
    "Pages with score:": "Pages avec score :",
    "Pages with the \\\"noindex\\\" META tag will not be indexed by the search engines. This is not an \\\"error\\\" per se, but make sure that the page does not have this tag as a result of an error.": "Les pages comportant la balise META \\\"noindex \\\" ne seront pas indexées par les moteurs de recherche. Il ne s'agit pas d'une  \\\"erreur \\\" en soi, mais il faut s'assurer que la page ne comporte pas cette balise à la suite d'une erreur.",
    "Pages without H1 tags or with empty H1 tags that contain no value represent a failed SEO optimization opportunity.": "Les pages sans balises H1 ou avec des balises H1 vides qui ne contiennent aucune valeur représentent une opportunité d'optimisation SEO ratée.",
    "Pages without Visits": "Pages sans visites",
    "Pages without Visits in last 6 months": "Pages sans visites au cours des 6 derniers mois",
    "Pageviews": "Nombre de pages vues",
    "Part of downtime calculation": "Partie du calcul du temps d'arrêt",
    "Part of heatmap Rules": "Partie des règles de la carte thermique",
    "Part of success criteria [[checkIssueNumber]]": "Partie des critères de réussite [[checkIssueNumber]]",
    "Pass Example": "Exemple de réussite",
    "Passed": "Réussi",
    "Passed ([[audits]])": "Réussi ([[audits]])",
    "Passed Checks": "Vérifications réussies",
    "Passed Policy checks": "Vérifications de politique réussies",
    "Passed checks": "Vérifications réussies",
    "Passed policy checks": "Vérifications de politique réussies",
    "Password": "Mot de passe",
    "Password Confirmation": "Confirmation du mot de passe",
    "Password confirmation": "Confirmation du mot de passe",
    "Password to login": "Mot de passe pour se connecter",
    "Passwords does not match": "Le mot de passe ne correspond pas",
    "Path constraints": "Contraintes de chemin",
    "Path template": "Modèle de chemin",
    "Pending": "En attente",
    "Pending PDF review": "Examen PDF en attente",
    "Pending PDF reviews": "Examen PDF en attente",
    "Percentage shows number of pages that are compliant with all Data Privacy checks": "Le pourcentage indique le nombre de pages qui sont conformes à toutes les vérifications de confidentialité des données.",
    "Percentage shows number of pages that are compliant with all SEO checks": "Le pourcentage indique le nombre de pages qui sont conformes à toutes les vérifications SEO.",
    "Performance": "Performance",
    "Performance Errors": "Erreurs de performance",
    "Performance Pages": "Pages de performance",
    "Performance Profiles": "Profils de performance",
    "Performance Score": "Score de performance",
    "Performance score": "Score de performance",
    "Personal": "Personnel",
    "Personal information": "Informations personnelles",
    "Phone": "Téléphone",
    "Pie": "Pie",
    "Pin domain": "Domaine Pin",
    "Ping intervals": "Intervalles de ping",
    "Play": "Jouer",
    "Play misspelling": "Jouer mal orthographié",
    "Please choose a trademark": "Veuillez choisir une marque",
    "Please insert correct URL:": "Veuillez insérer une URL correcte :",
    "Please insert the correct word:": "Veuillez insérer le mot correct :",
    "Please insert the missing ALT text:": "Veuillez insérer le texte ALT manquant :",
    "Please select a module": "Veuillez sélectionner un module",
    "Please select the module that you want to create a Source Code Exclude for": "Veuillez sélectionner le module pour lequel vous souhaitez créer une exclusion du code source.",
    "Please specify word or phrase to search for": "Veuillez spécifier le mot ou la phrase à rechercher",
    "Please use CSS selectors to identify form fields and buttons": "Veuillez utiliser des sélecteurs CSS pour identifier les champs et les boutons du formulaire.",
    "Please wait": "Veuillez patienter",
    "Please wait - Adding word to dictionary": "Veuillez patienter - Ajouter un mot au dictionnaire",
    "Please wait - Adding words to dictionary": "Veuillez patienter - Ajouter des mots au dictionnaire",
    "Please wait - Confirming misspelling": "Veuillez patienter - Confirmation de la faute d'orthographe",
    "Please wait - exporting audit log &nbsp;": "Veuillez patienter - exportation du journal d'audit & de l'espace insécable;",
    "Policies": "Politiques",
    "Policies - required": "Politiques - obligatoires",
    "Policies - violations": "Politiques - infractions",
    "Policies marked as required or unwanted": "Politiques marquées comme obligatoires ou indésirables",
    "Policies violations": "Infractions aux politiques",
    "Policies with most matches": "Politiques avec le plus grand nombre de correspondances",
    "Policies with violations": "Politiques avec infractions",
    "Policy": "Politique",
    "Policy Diagnostics": "Diagnostic de la politique",
    "Policy Distribution": "Distribution de la politique",
    "Policy Hits": "Résultats de la politique",
    "Policy Issues": "Problèmes de politique",
    "Policy List": "Liste des politiques",
    "Policy Pages": "Pages de la politique",
    "Policy Running": "Politique en train d'être exécutée",
    "Policy errors": "Erreurs de politique",
    "Policy hits per domain": "Résultats de la politique par domaine",
    "Policy in queue": "Politique en attente",
    "Policy info": "Infor sur la politique",
    "Policy note": "Note sur la politique",
    "Policy rules": "Règles de la politique",
    "Policy scan in progress": "Analyse de la politique en cours",
    "Policy setup": "Configuration de la politique",
    "Policy violations": "infractions à la politique",
    "Policy with matching terms": "Police avec des termes correspondants",
    "Potential Misspelling": "Faute d'orthographe potentielle",
    "Potential Misspellings": "Fautes d'orthographe potentielles",
    "Potential Savings": "Économies potentielles",
    "Potential misspelling": "Faute d'orthographe potentielle",
    "Potential misspellings": "Fautes d'orthographe potentielles",
    "Potential misspellings found": "Fautes d'orthographe potentielles trouvées",
    "Powered by Google Lighthouse": "Généré par Google Lighthouse",
    "Prefix path": "Chemin du préfixe",
    "Presence": "Présence",
    "Previous": "Précédent",
    "Principle 1: Perceivable": "Principe 1 : Perceptible",
    "Principle 2: Operable": "Principe 2 : Exploitable",
    "Principle 3: Understandable": "Principe 3 : Compréhensible",
    "Principle 4: Robust": "Principe 4 : Robuste",
    "Principle 5: Conformance": "Principe 5 : Conformité",
    "Print view": "Imprimer la vue",
    "Priorities": "Priorités",
    "Prioritized Content": "Contenu priorisé",
    "Priority": "Priorité",
    "Profile": "Profil",
    "Profile Description": "Description du profil",
    "Profile Dropdown": "Liste déroulante du profil",
    "Profile Menu": "Menu du profil",
    "Profile Name": "Nom du profil",
    "Profile details": "Détails du profil",
    "Profile updated": "Profil mis à jour",
    "QA": "AQ",
    "QA Issues": "Problèmes d'assurance qualité",
    "QA errors": "Erreurs d'assurance qualité",
    "QUALITY ASSURANCE": "ASSURANCE QUALITÉ",
    "QUALITY ASSURANCE OVERVIEW": "APERÇU DE L'ASSURANCE QUALITÉ",
    "Quality Assurance": "Assurance Qualité",
    "Quality Assurance Check": "Vérification d'assurance qualité",
    "Quality Assurance Diagnostics": "Diagnostics d'assurance qualité",
    "Quality Assurance Export summary": "Résumé de l'exportation d'assurance qualité ",
    "Quality Assurance errors": "Erreurs d'assurance qualité",
    "Quality assurance": "Assurance qualité",
    "Queued": "En attente",
    "Quick Guide": "Guide rapide",
    "Quick help": "Aide rapide",
    "Quick info:": "Info rapide :",
    "Re-scanning of issues for this page has started and will be finished in a few minutes.": "La ré-analyse des problèmes de cette page a débuté et sera terminée dans quelques minutes.",
    "Readability": "Lisibilité",
    "Readability Score": "Score de lisibilité",
    "Readability by score": "Lisibilité par score",
    "Readability levels": "Niveaux de lisibilité",
    "Readability score": "Score de lisibilité",
    "Readability scores across all web pages (based on": "Scores de lisibilité de toutes les pages web (sur la base du",
    "Readability test": "Test de lisibilité",
    "Receive report": "Recevoir le rapport",
    "Received reports": "Rapports reçus",
    "Referring Information": "Informations de référence",
    "Referring visits": "Visites de référence",
    "Regex": "Regex",
    "Regulation": "Règlement",
    "Remember me": "Se rappeler de moi",
    "Remove": "Supprimer",
    "Remove Custom Multistep Javascript": "Supprimer le Javascript multi-étapes personnalisé",
    "Remove Extension Name": "Supprimer le nom de l'extension",
    "Remove Page": "Supprimer la page",
    "Remove Profile": "Supprimer le profil",
    "Remove Rule": "Supprimer la règle",
    "Remove checkpoint": "Supprimer le point de contrôle",
    "Remove domain": "Supprimer le domaine",
    "Remove domain group": "Supprimer le groupe du domaine",
    "Remove from dictionary": "Supprimer du dictionnaire",
    "Remove group": "Supprimer le groupe",
    "Remove rule": "Supprimer la règle",
    "Remove this IP address?": "Supprimer cette adresse IP ?",
    "Remove this pattern?": "Supprimer ce modèle ?",
    "Remove this word from dictionary": "Supprimer ce mot du dictionnaire",
    "Render pages and execute JS while crawling": "Rendu des pages et exécution de JS pendant l'exploration",
    "Repeat": "Répéter",
    "Replace Rule": "Remplacer la règle",
    "Report": "Rapport",
    "Report administration": "Administration du rapport",
    "Report overview:": "Aperçu du rapport :",
    "Request PDF scan for all documents": "Demander une analyse PDF pour tous les documents",
    "Requests": "Demandes",
    "Required": "Requis",
    "Required content": "Contenu requis",
    "Required count": "Nombre requis",
    "Rescan": "Ré-analyser",
    "Rescanning": "Ré-analyse",
    "Reset": "Réinitialiser",
    "Reset Preferences": "Réinitialiser les préférences",
    "Resolution": "Résolution",
    "Resource Type": "Type de ressource",
    "Response Time": "Temps de réponse",
    "Response code": "Code de réponse",
    "Response time": "Temps de réponse",
    "Response time (Milliseconds)": "Temps de réponse (Millisecondes)",
    "Response time notification": "Notification du temps de réponse",
    "Response time notification threshold": "Seuil de notification du temps de réponse",
    "Return to heartbeat overview": "Retour à l'aperçu heartbeat",
    "Returning customer": "Client fidèle",
    "Reverting state": "Retour à l'état antérieur",
    "Review": "Revoir",
    "Reviewed": "Examiné",
    "Reviewed/Ok": "Examiné/Ok",
    "Revoke token": "Révoquer le jeton",
    "Robot Info": "Info robot",
    "Role": "Rôle",
    "Rule": "Règle",
    "Rule name": "Nom de la règle",
    "Rule operator": "Opérateur de la règle",
    "Rule to match": "Règle à faire correspondre",
    "Rules": "Règles",
    "Run Policy": "Exécuter la politique",
    "Run policy": "Exécuter la politique",
    "Run policy again": "Réexécuter la politique",
    "Running": "En cours d'exécution",
    "SEO": "SEO",
    "SEO (Search Engine Optimization)": "SEO (optimisation des moteurs de recherche)",
    "SEO Checkpoints": "Points de contrôle SEO",
    "SEO Diagnostics": "Diagnostics SEO",
    "SEO Issues": "Problèmes de SEO",
    "SEO OVERVIEW": "APERÇU SEO",
    "SEO Opportunities": "Opportunités SEO",
    "SEO errors": "Erreurs SEO",
    "SEO impact": "Impact SEO",
    "SEO opportunities": "Opportunités SEO",
    "SEO opportunities - high priority": "Opportunités SEO - priorité élevée",
    "SEO opportunities - low priority": "Opportunités SEO - faible priorité",
    "SEO opportunities - medium priority": "Opportunités SEO - priorité moyenne",
    "SEO opportunities - technical SEO issues": "Opportunités SEO - problèmes techniques de SEO",
    "SEO opportunities found": "Opportunités SEO trouvées",
    "SHOW LIST VIEW": "AFFICHER LA VUE DE LA LISTE",
    "STATISTICS OVERVIEW": "APERÇU DES STATISTIQUES",
    "Saturday": "Samedi",
    "Save": "Enregistrer",
    "Save Preferences": "Enregistrer les préférences",
    "Save and close": "Enregistrer et fermer",
    "Save policy": "Enregistrer la politique",
    "Scan": "Analyser",
    "Scan documents": "Analyser des documents",
    "Scan frequency": "Fréquence d'analyse",
    "Scan frequency:": "Fréquence d'analyse :",
    "Scan in progress": "Analyse en cours",
    "Scan in progress:": "Analyse en cours :",
    "Scan is done": "L'analyse est terminée",
    "Scan subdomains": "Analyser les sous-domaines",
    "Scanned at": "Analysé à",
    "Scanned content": "Contenu analysé",
    "Scanned links:": "Liens analysés :",
    "Scanned pages": "Pages analysées",
    "Scanned pages:": "Pages analysées :",
    "Scanning URL:": "URL en cours d'analyse :",
    "Scanning in progress": "Analyse en cours",
    "Schedule Report": "Programmer le rapport",
    "Schedule supplemental reports to be delivered with each scan": "Programmer les rapports complémentaires à fournir avec chaque analyse",
    "Scheduled": "Programmé",
    "Scheduled Reports": "Rapports programmés",
    "Scopes": "Périmètres",
    "Score": "Score",
    "Screen Resolutions": "Résolutions d'écran",
    "Screen Resolutions Overview": "Aperçu des résolutions d'écran",
    "Script Evaluation": "Évaluation du script",
    "Script Parse": "Analyse du script",
    "Script installed": "Script installé",
    "Script installed on Domain": "Script installé sur le domaine",
    "Script setup guide": "Guide de configuration des scripts",
    "Search Engine Optimization": "Optimisation des moteurs de recherche",
    "Search Engine Optimization (SEO)": "Optimisation des moteurs de recherche (SEO)",
    "Search Engines": "Moteurs de recherche",
    "Search engine": "Moteur de recherche",
    "Search engines": "Moteurs de recherche",
    "Search for Pages": "Rechercher des pages",
    "Search for file size that is": "Rechercher une taille de fichier qui soit ",
    "Search for image size that is": "Recherche une taille d'image qui soit",
    "Search for links, that are associated with class names and contains below mentioned class names.": "Rechercher les liens qui sont associés aux noms de classe et qui contiennent les noms de classe mentionnés ci-dessous.",
    "Search for page titles or URLs across all domains": "Rechercher des titres de pages ou des URL dans tous les domaines",
    "Search for pages": "Rechercher des pages",
    "Search icon": "Rechercher l'icône",
    "Search in: Documents": "Rechercher dans : Documents",
    "Search in: Everything": "Rechercher dans : Tout",
    "Search in: Links": "Rechercher dans : Liens",
    "Search in: Only HTML pages": "Rechercher dans : pages HTML uniquement",
    "Search pages across all domains": "Rechercher des pages dans tous les domaines",
    "Search...": "Recherche...",
    "Searches": "Recherches",
    "Seconds": "Secondes",
    "See API Token": "Voir jeton API",
    "See Details": "Voir les détails",
    "See changes": "Voir les modifications",
    "See details": "Voir les détails",
    "See pages": "Voir les pages",
    "Select Domain and Module to get the Insights": "Sélectionner le domaine et le module pour obtenir les informations",
    "Select Domain on domain picker": "Sélectionner le Domaine dans le sélecteur de domaine",
    "Select Page to scan": "Sélectionner la page à analyser",
    "Select a domain and recipients": "Sélectionner un domaine et des destinataires",
    "Select a domain or group": "Sélectionner un domaine ou un groupe",
    "Select a profile": "Sélectionner un profil",
    "Select account": "Sélectionner un compte",
    "Select all items": "Sélectionner tous les éléments",
    "Select domain": "Sélectionner un domaine",
    "Select domains and groups": "Sélectionner des domaines et des groupes",
    "Select filters": "Sélectionner les filtres",
    "Select import": "Sélectionner l'importation",
    "Select item": "Sélectionner l'élément",
    "Select login type*": "Sélectionner le type d'authentification*",
    "Select timezone": "Sélectionner le fuseau horaire",
    "Select users": "Sélectionner les utilisateurs",
    "Select what type of content the policy should search in": "Sélectionner le type de contenu dans lequel la politique doit rechercher",
    "Select whether the rule should search for case sensitive text or not": "Sélectionner si la règle doit rechercher du texte sensible à la casse ou non.",
    "Select your export file": "Sélectionnez votre fichier d'exportation",
    "Send an email if the site is down": "Envoyer un e-mail si le site est indisponible",
    "Send an email if the site is slow to respond": "Envoyer un e-mail si le site est lent à répondre",
    "Send message": "Envoyer un message",
    "Send report": "Envoyer le rapport",
    "Send welcome mail on creation": "Envoyer un message de bienvenue lors de la création",
    "Set a default value for selector": "Définir une valeur par défaut pour le sélecteur",
    "Set as Default": "Définir par défaut",
    "Set to fixed": "Définir comme résolu",
    "Settings": {
      "$$noContext": "Paramètres",
      "Topmenu": "Paramètres"
    },
    "Setup your domain": "Configurer votre domaine",
    "Severity": "Gravité",
    "Severity level": "Niveau de gravité",
    "Short": "Court",
    "Short Description": "Brève description",
    "Should we check the page's current status?": "Devons-nous vérifier l'état actuel de la page ?",
    "Show Details": "Afficher les détails",
    "Show all": "Afficher tout",
    "Show documents with this email": "Afficher les documents avec cet e-mail",
    "Show history": "Afficher l'historique",
    "Show label dropdown": "Afficher le menu déroulant de l'étiquette",
    "Show less": "Afficher moins",
    "Show more": "Afficher plus",
    "Show on global policy list": "Afficher dans la liste des politiques globales",
    "Show pages": "Afficher les pages",
    "Show pages with issues": "Afficher les pages avec des problèmes",
    "Show pages with this SEO issue": "Afficher les pages avec ce problème SEO",
    "Show pages with this email": "Afficher les pages avec cet e-mail",
    "Show pages with this image": "Afficher les pages avec cette image",
    "Show pages with this link": "Afficher les pages avec ce lien",
    "Show pages with this misspelling": "Afficher les pages avec cette faute d'orthographe",
    "Show policy hits per domain": "Afficher les résultats de la politique par domaine",
    "Show policy info": "Afficher les infos de la politique",
    "Show the Domain Picker": "Afficher le sélecteur de domaine",
    "Show/Hide filter selector": "Afficher/masquer le sélecteur de filtre",
    "Show/Hide the Domain Picker": "Afficher/masquer le sélecteur de domaine",
    "Shows the remaining number of Performance Profiles that can be created for this account": "Indique le nombre restant de profils de performance pouvant être créés pour ce compte.",
    "Side Navigation": "Navigation latérale",
    "Single line": "Ligne unique",
    "Size": "Taille",
    "Skip to content": "Passer au contenu",
    "Slide links": "Liens de diapositives",
    "Slides": "Diapositives",
    "Slow": "Lent",
    "Snippet": "Extrait",
    "Social": "Social",
    "Social Networks": "Réseaux sociaux",
    "Social visits": "Visites réseaux sociaux",
    "Source Code Exclude": "Exclusion du code source",
    "Source Code Excludes": "Le code source exclut",
    "Source code": "Code source",
    "Spellcheck": "Vérification de l'orthographe",
    "Spellcheck Export Summary": "Résumé de l'exportation de la vérification d'orthographe",
    "Spellcheck Summary": "Résumé de la vérification d'orthographe",
    "Spelling": "Orthographe",
    "Spelling Errors used": "Erreurs d'orthographe utilisées",
    "Spelling fixes": "Corrections orthographiques",
    "Spelling ignore capitalized words": "L'orthographe ignore les mots en majuscules",
    "Spreadsheet links": "Liens des feuilles de calcul",
    "Spreadsheets": "Feuilles de calcul",
    "Start PDF accessibility scan": "Lancer l'analyse d'accessibilité des PDF",
    "Start at": "Commencer à",
    "Start compound export": "Lancer l'exportation groupée",
    "Start date": "Commencer à",
    "Start export": "Démarrer l'exportation",
    "Start export Pages With Specific Link": "Commencer à exporter des pages avec un lien spécifique",
    "Start new scan": "Démarrer une nouvelle analyse",
    "Start on demand scan": "Démarrer une analyse à la demande",
    "Start time": "Heure de début",
    "Starts with": "Commence par",
    "State": "État",
    "Statistic": "Statistiques",
    "Statistics": "Statistiques",
    "Statistics excluded IP addresses": "Les statistiques ont exclu les adresses IP",
    "Status": "Statut",
    "Stop current crawl": "Arrêter l'exploration en cours",
    "Sub Navigation": "Sous-navigation",
    "Submit selector*": "Soumettre le sélecteur*",
    "Succeeds": "A réussi",
    "Success criteria": "Critères de réussite",
    "Suggestions and ideas": "Suggestions et idées",
    "Summarized pages and documents count": "Nombre de pages et de documents résumés",
    "Summary": "Résumé",
    "Sunday": "Dimanche",
    "Switch account": "Changer de compte",
    "Table View": "Vue du tableau",
    "Tags": "Étiquettes",
    "Target": "Cible",
    "Technical": "Technique",
    "Technical SEO Issues": "Problèmes techniques de SEO",
    "Text": "Texte",
    "Text Documents": "Documents textuels",
    "Text documents": "Documents textuels",
    "Text to match": "Texte à faire correspondre",
    "Text:": "Texte :",
    "The Checkpoint [[checkpoint]] will be updated with data after next crawl": "Le point de contrôle [[checkpoint]] sera mis à jour avec les données après la prochaine exploration.",
    "The Document is not tagged": "Le document n'est pas étiqueté",
    "The Path template for Umbraco CMS": "Le modèle Path pour le CMS Umbraco",
    "The Requested Page is not a part of the Performance Module": "La page demandée ne fait pas partie du module de performance",
    "The Scan will take effect within the next few hours": "L'analyse prendra effet dans les prochaines heures.",
    "The URL for this page is too long": "L'URL de cette page est trop longue",
    "The base url to the CMS page": "L'url de base de la page du CMS",
    "The bounce rate tells you the number of visits who only see the one page they started on": "Le taux de rebond vous indique le nombre de visiteurs qui ne voient que la page sur laquelle ils ont commencé.",
    "The following rules will be removed, are you sure you want to continue with this change?": "Les règles suivantes seront supprimées. Êtes-vous sûr de vouloir poursuivre cette modification ?",
    "The header 1 (H1) tag is important as it helps search engines and users to understand what content they can expect to find on the page.": "La balise d'en-tête 1 (H1) est importante car elle aide les moteurs de recherche et les utilisateurs à comprendre le contenu qu'ils peuvent s'attendre à trouver sur la page.",
    "The likelihood of this being a Data Privacy issue": "La probabilité qu'il s'agisse d'un problème de confidentialité des données",
    "The lowest level of readability. Example: children's books": "Le niveau de lisibilité le plus bas. Exemple : livres pour enfants",
    "The meta description on this page is too long": "La méta description de cette page est trop longue",
    "The meta description on this page is too short": "La méta description de cette page est trop courte",
    "The misspelling will first show up after a new scan": "La faute d'orthographe apparaîtra pour la première fois après une nouvelle analyse",
    "The name of a meta entry (page metadata)": "Le nom d'une entrée méta (métadonnées de la page)",
    "The optional base url to the CMS page": "L'url de base optionnelle de la page du CMS",
    "The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.": "La confidentialité de vos données personnelles est très importante pour nous. C'est pourquoi nous avons mis à jour notre politique de protection des données et de la vie privée. Pour continuer à utiliser notre plateforme, nous vous demandons de lire et d'accepter les nouvelles conditions relatives à la protection des données et notre politique en matière de données.",
    "The scan can take a few hours/days to finalise, depending on the size of the website": "L'analyse peut prendre quelques heures/jours pour être finalisée, selon la taille du site web.",
    "The scan can take a few hours/days to finalise, depending on the size of the website.<br><br>Are you sure you want to start on-demand scan?": "La finalisation de l'analyse peut prendre quelques heures/jours, selon la taille du site web.<br><br>Êtes-vous sûr de vouloir lancer l'analyse à la demande ?",
    "The scan can take a few minutes to finalise, depending on the size of the page": "L'analyse peut prendre quelques minutes, selon la taille de la page.",
    "There are no META descriptions on one or more pages": "Il n'y a pas de descriptions META sur une ou plusieurs pages",
    "There are no domains assigned to this policy. Save policy anyway?": "Aucun domaine n'est affecté à cette politique. Poursuivre l'enregistrement de la politique ?",
    "There are no more errors for this Snippet": "Il n'y a plus d'erreurs pour cet extrait",
    "There are no sub headlines on one or more pages": "Il n'y a pas de sous-titres sur une ou plusieurs pages.",
    "There are zero META keywords on this page": "Il n'y a pas de mots-clés META sur cette page",
    "There is no H1 on one or more pages": "Il n'y a pas de H1 sur une ou plusieurs pages",
    "There is no H1 on this page": "Il n'y a pas de H1 sur cette page",
    "There is no META descriptions on this page": "Il n'y a pas de descriptions META sur cette page",
    "There is no historic data for domain groups": "Il n'y a pas de données historiques pour les groupes de domaines",
    "There is no historic data for this domain": "Il n'y a pas de données historiques pour ce domaine",
    "There is no sub headlines on this page": "Il n'y a pas de sous-titres sur cette page",
    "These are findings that cannot be automatically checked and must be reviewed manually": "Il s'agit de résultats qui ne peuvent pas être vérifiés automatiquement et qui doivent être examinés manuellement.",
    "These are findings which are likely to be errors, requiring manual confirmation": "Il s'agit de résultats susceptibles d'être des erreurs, nécessitant une confirmation manuelle.",
    "These findings are confirmed errors": "Ces résultats sont des erreurs confirmées",
    "Third-Party": "Tiers",
    "This field is required": "Ce champ est obligatoire",
    "This is the time between when an outage is first detected and when a notification is sent.": "Il s'agit du temps qui s'écoule entre le moment où une panne est détectée et celui où une notification est envoyée.",
    "This is useful if you have defined timeslots for maintenance.": "Cette fonction est utile si vous avez défini des plages horaires pour la maintenance.",
    "This issue is ignored": "Ce problème est ignoré",
    "This link is marked as broken because it took more than 30 seconds to load": "Ce lien est marqué comme défectueux car il a mis plus de 30 secondes à se charger.",
    "This page has been marked as no index": "Cette page a été marquée comme n'ayant pas d'index",
    "This page has no meta description": "Cette page n'a pas de méta description",
    "This page has no meta keywords": "Cette page n'a pas de mots-clés meta",
    "This page has not been assigned to the Performance Module": "Cette page n'a pas été attribuée au module Performance",
    "This page is missing a title": "Il manque un titre à cette page",
    "This policy is scheduled": "Cette politique est programmée",
    "This rule doesn't contain any matches": "Cette règle ne contient aucune correspondance",
    "This section lists requirements for <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformance</a> to WCAG 2.1. It also gives information about how to make conformance claims, which are optional.": "Cette section énumère les exigences de <a target=\"_blank\" href=\"https://www.w3.org/TR/WCAG21/#dfn-conform\">conformité</a> aux WCAG 2.1. Elle donne également des informations sur la manière de faire des déclarations de conformité, qui sont facultatives.",
    "Thursday": "Jeudi",
    "Time": "Temps",
    "Time Spent": "Temps passé",
    "Time To Interactive": "Time To Interactive",
    "Time to Warning *": "Délai d'alerte *",
    "Timeframe:": "Période de temps :",
    "Timeline": "Délai",
    "Timezone": "Fuseau horaire",
    "Title": "Titre",
    "Title & description": "Titre et description",
    "Title and URL": "Titre et URL",
    "Title and url": "Titre et url",
    "To setup this policy, you need to tell us how long your max word length is": "Pour mettre en place cette politique, vous devez nous indiquer la longueur maximale des mots.",
    "To setup this policy, you need to tell us which brand name should end with TM or ™": "Pour mettre en place cette politique, vous devez nous indiquer quel nom de marque doit se terminer par TM ou ™.",
    "To toggle Quick Search:": "Pour basculer vers la recherche rapide :",
    "Toggle Dropdown": "Basculer vers le bas",
    "Toggle dropdown": "Basculer vers le bas",
    "Toggle notes": "Basculer vers les notes",
    "Toggle show filters": "Le basculement affiche les filtres",
    "Too few characters": "Trop peu de caractères",
    "Too many characters": "Trop de caractères",
    "Top keywords": "Principaux mots-clés",
    "Total": "Total",
    "Total CPU Time": "Temps CPU total",
    "Total QA issues": "Total des problèmes d'assurance qualité",
    "Total Visitors": "Total des visiteurs",
    "Total Visits": "Nombre total de visites",
    "Total amount of content": "Quantité totale de contenu",
    "Total crawled": "Total exploré",
    "Total number of issues": "Nombre total de problèmes",
    "Total number of issues across all modules": "Nombre total de problèmes sur l'ensemble des modules",
    "Total page views over the last 30 days": "Nombre total de pages vues au cours des 30 derniers jours",
    "Total pages:": "Nombre total de pages :",
    "Total visitors": "Total des visiteurs",
    "Total visitors from Referrers": "Total des visiteurs provenant de référants",
    "Total visitors from Search Engines": "Total des visiteurs provenant des moteurs de recherche",
    "Total visits": "Nombre total de visites",
    "Total visits from Referrers": "Total des visites provenant de référents",
    "Total visits from Search Engines": "Total des visites provenant des moteurs de recherche",
    "Total visits in the last 30 days:": "Nombre total de visites au cours des 30 derniers jours :",
    "Total words": "Total des mots",
    "Track changes across domains and modules": "Suivre les modifications dans l'ensemble des domaines et modules",
    "Traffic Sources": "Sources de trafic",
    "Traffic Sources Summary": "Résumé des sources de trafic",
    "Traffic sources": "Sources de trafic",
    "Transfer Size": "Taille du transfert",
    "Tuesday": "Mardi",
    "Twice a day": "Deux fois par jour",
    "Twitter": "Twitter",
    "Type": "Type",
    "Type the key for the metadata": "Saisir la clé des métadonnées",
    "Type the text to match rule": "Saisir le texte à faire correspondre à la règle",
    "Type*": "Type*",
    "URL": "URL",
    "URL must start with a protocol. Ex. http://....": "L'URL doit commencer par un protocole. Ex. http://....",
    "URL to redirect to if form is valid": "URL vers laquelle rediriger si le formulaire est valide",
    "URL:": "URL :",
    "Unable to read link": "Impossible de lire le lien",
    "Unarchive": "Désarchiver",
    "Undetermined": "Indéterminé",
    "Undo": "Annuler",
    "Undo review": "Annuler l'examen",
    "Unignore": "Ne pas ignorer",
    "Unignore check": "Ne pas ignorer la vérification",
    "Unignore misspelling": "Ne pas ignorer la faute d'orthographe",
    "Unignore on this page": "Ne pas ignorer sur cette page",
    "Unignore this SEO issue": "Ne pas ignorer ce problème de SEO",
    "Unignore this check for this domain": "Ne pas ignorer cette vérification pour ce domaine",
    "Unique Visitors": "Visiteurs uniques",
    "Unique downloads": "Téléchargements uniques",
    "Unknown": "Inconnu",
    "Unknown Score": "Score inconnu",
    "Unknown title": "Titre inconnu",
    "Unpin domain": "Désépingler le domaine",
    "Unsaved changes": "Modifications non enregistrées",
    "Unwanted": "Indésirable",
    "Unwanted content": "Contenu indésirable",
    "Unwanted violations": "Infractions indésirables",
    "Update": "Actualiser",
    "Update groups": "Actualiser les groupes",
    "Updated": "Actualisé",
    "Updated At": "Actualisé À",
    "Updated at": "Actualisé à",
    "Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.": "L'actualisation des groupes peut prendre plus de 30 minutes. Pendant l'opération, il ne sera pas possible de créer et d'actualiser des groupes.",
    "Upload CSV": "Téléverser le CSV",
    "Upload csv file": "Téléverser le fichier csv",
    "Uptime": "Temps de fonctionnement",
    "Uptime last 30 days": "Temps de fonctionnement des 30 derniers jours",
    "Url*": "Url*",
    "Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors": "Utilisez * comme caractère de remplacement (ex. 192.168.1.*). Les adresses IP exclues n'affecteront que les nouveaux visiteurs.",
    "Use language attribute": "Utiliser l'attribut linguistique",
    "Use or Apply custom PageCorrect": "Utiliser ou appliquer un PageCorrect personnalisé",
    "User": "Utilisateur",
    "User Export": "Exportation de l'utilisateur",
    "User List": "Liste des utilisateurs",
    "User Loading Experience": "Expérience de chargement de l'utilisateur",
    "User information": "Informations sur l'utilisateur",
    "User interface components and navigation must be operable.": "Les composants de l'interface utilisateur et la navigation doivent être opérationnels.",
    "User is account administrator": "L'utilisateur est l'administrateur du compte",
    "Username": "Nom d'utilisateur",
    "Value": "Valeur",
    "Value*": "Valeur*",
    "Vat no": "N° de TVA",
    "Verify URL*": "Vérifier l'URL*",
    "Very easy": "Très facile",
    "Very hard": "Très difficile",
    "View options": "Voir les options",
    "Viewing as Profile:": "Voir comme Profil :",
    "Views": "Vues",
    "Violation": "Infraction",
    "Violation count": "Nombre d'infractions",
    "Violation's info_type name not set": "Nom du type_info de l'infraction pas défini",
    "Violations": "Infractions",
    "Visible": "Visible",
    "Visible modules": "Modules visibles",
    "Visit the affected image": "Visiter l'image affectée",
    "Visitor Overview": "Aperçu des visiteurs",
    "Visitor Summary": "Résumé des visiteurs",
    "Visitor log": "Journaux des visiteurs",
    "Visitor profile": "Profil des visiteurs",
    "Visitor profile:": "Profil des visiteurs :",
    "Visitors": "Visiteurs",
    "Visitors Summary": "Résumé des visiteurs",
    "Visits": "Visites",
    "Visual mode": "Mode visuel",
    "WCAG 2.0 (Level A)": "WCAG 2.0 (niveau A)",
    "WCAG 2.0 (Level AA)": "WCAG 2.0 (niveau AA)",
    "WCAG 2.0 (Level AAA)": "WCAG 2.0 (niveau AAA)",
    "WCAG 2.0 Accessibility Compliance": "Conformité d'accessibilité WCAG 2.0",
    "WCAG 2.1 (Level A)": "WCAG 2.1 (niveau A)",
    "WCAG 2.1 (Level AA)": "WCAG 2.1 (niveau AA)",
    "WCAG 2.1 (Level AAA)": "WCAG 2.1 (niveau AAA)",
    "WCAG 2.1 Accessibility Compliance": "Conformité d'accessibilité WCAG 2.1",
    "Want to search for": "Vous souhaitez rechercher",
    "Warning": "Avertissement",
    "We recommend that all your pages has a number of relevant meta keywords.": "Nous recommandons que toutes vos pages contiennent un certain nombre de méta-mots-clés pertinents.",
    "We recommend that all your pages has a relevant and unique meta description.": "Nous recommandons que toutes vos pages aient une méta description pertinente et unique.",
    "We recommend that all your pages has an unique title.": "Nous recommandons que toutes vos pages aient un titre unique.",
    "We recommend that the meta description consists of at least 50 characters.": "Nous recommandons que la méta-description comporte au moins 50 caractères.",
    "We recommend that the meta description consists of no more than 160 characters.": "Nous recommandons que la méta-description ne comporte pas plus de 160 caractères.",
    "We recommend that you give each page a unique title.": "Nous vous recommandons de donner un titre unique à chaque page.",
    "We recommend that you have a unique H1 tag on each page.": "Nous vous recommandons d'avoir une balise H1 unique sur chaque page.",
    "We recommend that you have at least one H2-H6": "Nous vous recommandons d'avoir au moins un H2-H6",
    "We recommend that you have no more than 100 internal links on each page.": "Nous vous recommandons de ne pas avoir plus de 100 liens internes par page.",
    "We recommend that you keep your URL below 200 characters.": "Nous vous recommandons de ne pas dépasser 200 caractères pour votre URL.",
    "We recommend that you only have one H1 tag on each page.": "Nous vous recommandons de n'avoir qu'une seule balise H1 par page.",
    "Wednesday": "Mercredi",
    "Weekly": "Hebdomadaire",
    "Well done - no accessibility issues found": "Bravo - aucun problème d'accessibilité n'a été trouvé",
    "We’ve Updated our Privacy Policy!": "Nous avons mis à jour notre politique de confidentialité !",
    "Why is this an issue": "Pourquoi est-ce un problème ?",
    "With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go": "Avec Fast Track, vous pouvez corriger, revoir et ignorer les extraits HTML sur les pages concernées en une seule fois.",
    "Word": "Mot",
    "Word Count": "Nombre de Mots",
    "Word count": "Nombre de mots",
    "Word count in PDF": "Nombre de mots dans le PDF",
    "Word is added to dictionary": "Le mot est ajouté au dictionnaire",
    "Word is added to dictionary for all languages": "Le mot est ajouté au dictionnaire pour toutes les langues",
    "Word is confirmed as misspelling": "Le mot est confirmé comme étant une faute d'orthographe",
    "Word length": "Longueur du mot",
    "Word links": "Liens des mots",
    "Word or Phrase": "Mot ou phrase",
    "Words": "Mots",
    "Would you like to update now? Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups": "Souhaitez-vous actualiser maintenant ? L'actualisation des groupes peut prendre plus de 30 minutes. Pendant l'opération, il ne sera pas possible de créer et d'actualiser des groupes.",
    "Written by: [[author]]": "Écrit par:[[author]]",
    "Years": "Années",
    "You are about to delete": "Vous êtes sur le point de supprimer",
    "You are about to delete the domain": "Vous êtes sur le point de supprimer le domaine",
    "You are about to delete the domain group": "Vous êtes sur le point de supprimer le groupe du domaine",
    "You are currently using Demo Data, certain features will be unavailable": "Vous utilisez actuellement des données de démonstration, certaines fonctions ne sont pas disponibles.",
    "You are receiving this report": "Vous recevez ce rapport",
    "You can create another [[customerProfilesLimit]] profiles for your account": "Vous pouvez encore créer [[customerProfilesLimit]] profils pour votre compte.",
    "You can pin this domain. Pinned domains will be shown at the top of your domain list": "Vous pouvez épingler ce domaine. Les domaines épinglés seront affichés en haut de votre liste de domaines",
    "You have more than one H1 tag on this page": "Vous avez plus d'une balise H1 sur cette page",
    "You have no H2-H6 tags on the page": "Vous n'avez pas de balises H2-H6 sur la page",
    "You have no available profiles": "Vous n'avez pas de profils disponibles",
    "You have not received any reports": "Vous n'avez reçu aucun rapport",
    "You have one or more pages with the \\\"noindex\\\" META tag": "Vous avez une ou plusieurs pages avec la balise META \"noindex\\\".",
    "You have reached the maximum number of profiles for this account.": "Vous avez atteint le nombre maximum de profils pour ce compte.",
    "You have too many internal links": "Vous avez trop de liens internes",
    "You will receive an email when the export is ready.": "Vous recevrez un e-mail lorsque l'exportation sera prête.",
    "Your Users Technology": "Technologie de vos utilisateurs",
    "Zero links were found": "Aucun lien n'a été trouvé",
    "Zip code": "Code postal",
    "achieved": "réalisé",
    "affected image": "image affectée",
    "and": "et",
    "and does not conform with": "et n'est pas conforme à",
    "contact": "contact",
    "contains": "contient",
    "content": "contenu",
    "diagnostics_errors.csv": "erreurs_diagnostics.csv",
    "diagnostics_passed.csv": "diagnostics_réussis.csv",
    "disabling": "désactivation",
    "document": "document",
    "documents": "documents",
    "done": "terminé",
    "enabling": "activation",
    "ends_with": "se termine_par",
    "excluded": "exclu",
    "go to the matched link": "aller sur le lien correspondant",
    "image": "image",
    "included": "inclus",
    "insert brand name": "insérer le nom de la marque",
    "insert context fx. us": "Insérer l'image contextuelle",
    "insert max word length": "insérer la longueur maximale des mots",
    "insert word fx. contact": "insérer le mot fx. contact",
    "is": "est",
    "is_exactly": "est_exactement",
    "language": "langue",
    "link": "lien",
    "match (regex)": "correspondance (regex)",
    "metadata": "métadonnées",
    "milliseconds": "millisecondes",
    "minutes": "minutes",
    "n/a": "s/o",
    "not": "pas",
    "opportunities_errors.csv": "erreurs_opportunités.csv",
    "opportunities_passed.csv": "opportunités_réussies.csv",
    "overall compliance": "conformité globale",
    "pages": "pages",
    "path": "chemin",
    "please type": "veuillez taper",
    "reviewed": "examiné",
    "rows - click to change": "rangées - cliquer pour modifier",
    "search engines overview": "aperçu des moteurs de recherche",
    "should always be followed by": "doit toujours être suivi de",
    "social network overview": "aperçu des réseaux sociaux",
    "starts_with": "commence_avec",
    "that": "que",
    "title": "titre",
    "to confirm this action": "pour confirmer cette action",
    "to fix": "à résoudre",
    "url": "url",
    "us": "nous",
    "visits": "visites",
    "you have one or more pages that contains links with rel=\\\"nofollow\\\"": "vous avez une ou plusieurs pages qui contiennent des liens avec rel=\"nofollow\"",
    "{{ pagesDone }} Pages ({{ compliancePercentage }}) in compliance": "{{ pagesDone }} Pages ({{ compliancePercentage }}) en conformité",
    "{{ totalPageIssues }} Pages ({{ compliancePercentage }}) to fix": "{{ totalPageIssues }} Pages ({{ compliancePercentage }} ) à réparer",
    "[[label]]: [[value]] Pages": "[[label]] : [[value]] Pages",
    "[[label]]: [[value]]ms": "[[label]] : [[value]]ms",
    "[[languageName]] ([[languageCount]])": "[[languageName]] ([[languageCount]])",
    "[[ms]] ms": "[[ms]] ms",
    "[[name]] have already been scanned for compliance. Are you sure you want to scan it again?": "[[name]] a déjà été analysé pour vérifier sa conformité. Êtes-vous sûr de vouloir l'analyser à nouveau ?",
    "[[pageCount]] Pages": "[[pageCount]] Pages",
    "[[pageCount]] pages found with this issue": "[[pageCount]] pages trouvées avec ce problème",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Niveau A)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Niveau AA)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Niveau AAA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Niveau A)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Niveau AA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Niveau AAA)",
    "1 found": [
      "1 trouvé",
      "",
      ""
    ],
    "1 issue found": [
      "1 problème trouvé",
      "",
      ""
    ],
    "1 word found": [
      "1 mot trouvé",
      "",
      ""
    ],
    "Total: 1 Performance Page": [
      "Total : 1 page de performance",
      "",
      ""
    ],
    "You have 1 to do": [
      "Vous en avez 1 à faire",
      "",
      ""
    ],
    "page": "page",
    "Are you sure you want to remove Custom PageCorrect? <br> Please type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Êtes-vous sûr de vouloir supprimer Custom PageCorrect ? <br> Veuillez taper [[deleteTag]]Supprimer[[deleteTagEnd]] pour confirmer cette action.",
    "You are about to remove PageCorrect for this check <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Vous êtes sur le point de supprimer PageCorrect pour cette vérification <br> Veuillez taper [[deleteTag]]Supprimer[[deleteTagEnd]] pour confirmer cette action.",
    "You are about to remove PageCorrect for this misspelling <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Vous êtes sur le point de supprimer PageCorrect pour cette faute d'orthographe <br> Veuillez taper [[deleteTag]]Supprimer[[deleteTagEnd]] pour confirmer cette action.",
    "You are about to remove PageCorrect for this [[type]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Vous êtes sur le point de supprimer PageCorrect pour ce [[type]] <br> Veuillez taper [[deleteTag]]Supprimer[[deleteTagEnd]] pour confirmer cette action.",
    "You are about to remove [[titleTag]][[title]][[titleTagEnd]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Vous êtes sur le point de supprimer[[titleTag]][[title]][[titleTagEnd]] <br> Veuillez taper[[deleteTag]] Supprimer[[deleteTagEnd]] pour confirmer cette action",
    "Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it's place": "Êtes-vous sûr de vouloir révoquer le jeton pour l'utilisateur de l'API [[apiUserId]]<br><strong>Note</strong> Un nouveau jeton sera créé à la place.",
    "Maximum critical path latency: <strong>[[latency]] ms </strong>": "Latence maximale du chemin critique&nbsp;:<strong>[[latency]] ms </strong>",
    "Are you sure you want to remove <code>all</code> [[type]] PageCorrects? <br> Please type <code>Delete</code> to confirm this action": "Êtes-vous sûr de vouloir supprimer <code>tous les</code> [[type]] PageCorrects ? <br> Veuillez taper <code>Supprimer</code> pour confirmer cette action",
    "<strong>[[checkName]]</strong><br><br>Add reason (Optional)": "<strong>[[checkName]]</strong><br><br>Ajouter un motif (facultatif)",
    "Are you sure you want to confirm the misspelling <strong>' + word.word + '</strong>?": "Êtes-vous sûr de vouloir confirmer la faute d'orthographe <strong>' + word.word + ' ?</strong>",
    "Are you sure you want to delete the policy <strong>[[policyName]]</strong>": "Êtes-vous sûr de vouloir supprimer la politique <strong>[[policyName]] ?</strong>",
    "Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?": "Etes-vous sûr de vouloir marquer la politique<strong>[[policyName]]</strong> comme résolue ?",
    "Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>": "Êtes-vous sûr de vouloir supprimer la règle de la carte thermique de <strong>[[pageUrl]] ?</strong>",
    "Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?": "Êtes-vous sûr de vouloir supprimer la règle <strong>' + rule.name + ' ?</strong>",
    "Are you sure you want to run the policy <strong>' + policy.name + '</strong>?": "Êtes-vous sûr de vouloir exécuter la politique <strong>' + policy.name + ' ?</strong>",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong> again?": "Êtes-vous sûr de vouloir exécuter la politique<strong>[[policyName]]</strong> encore?",
    "Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?": "Êtes-vous sûr de vouloir ne pas ignorer la politique&nbsp;?<strong>[[policyName]]</strong> ?",
    "You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.": "Vous avez actuellement<strong>[[spellingFixes]]</strong> corrections de fautes d'orthographe, nous vous recommandons de conserver ce numéro en dessous<strong>[[spellingLimit]]</strong> pour garantir que la page s'affiche sans problème.",
    "You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.": "Vous avez actuellement <strong>[[totalFixes]]</strong> corrections, nous vous recommandons de limiter votre nombre de corrections à <strong>[[pageFixLimit]]</strong> pour assurer une performance optimale de la page, mais cela reste à votre discrétion.",
    "[[users]]<strong>and [[userCountLeft]] more</strong>": "[[users]] et<strong>[[userCountLeft]] plus</strong>",
    "Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?": "Êtes-vous sûr de vouloir ignorer la politique&nbsp;?<strong>[[policyName]]</strong> ?",
    "Title:": "Titre :",
    "[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]": "[[msg]] <strong>[[regulationName]]</strong> entraînera l'écrasement des règles personnalisées [[opposite]] pour les questions suivantes, ce qui signifie qu'elles seront [[negate]] signalées par les analyses futures : [[list]]",
    "Admin only": "Admin uniquement",
    "Apply fix": "Appliquer la correction",
    "Contains high, medium or low opportunities": "Contient des opportunités élevées, moyennes ou faibles",
    "Design": "Conception",
    "Enable Custom PageCorrect Settings": "Activer les paramètres personnalisés de PageCorrect",
    "Enable PageCorrect features below. Disabled features will not be shown on your dashboard.": "Activez les fonctions PageCorrect ci-dessous. Les fonctions désactivées ne seront pas affichées sur votre tableau de bord.",
    "Enable PageCorrect for Accessibility Source Codes": "Activer PageCorrect pour les codes source d'Accessibilité",
    "Enable PageCorrect for Broken Links": "Activer PageCorrect pour les liens défectueux",
    "Enable PageCorrect for Misspellings": "Activer PageCorrect pour les fautes d'orthographe",
    "Enable PagedCorrect for Accessibility Checks": "Activer PageCorrect pour les vérifications d'accessibilité",
    "Failing checks - A": "Échec des vérifications - A",
    "Failing checks - AA": "Échec des vérifications - AA",
    "Failing checks - AAA": "Échec des vérifications - AAA",
    "Good job! Your domain contains no Accessibility Issues for this section": "Bravo ! Votre domaine ne contient aucun problème d'accessibilité pour cette section",
    "Indicates the difficulty to apply this fix": "Indique la difficulté d'appliquer cette correction",
    "List of improvements that can be applied to your website to improve your Accessibility Compliance": "Liste des améliorations pouvant être apportées à votre site web afin d'en améliorer la conformité en matière d'accessibilité",
    "Manage": "Gérer",
    "Media": "Médias",
    "Open PageCorrect Settings": "Ouvrir les paramètres de PageCorrect",
    "PageCorrect Settings Updated": "Paramètres de PageCorrect mis à jour",
    "PageCorrect settings": "Paramètres de PageCorrect",
    "Pages with Data Privacy violations": "Pages avec des infractions à la confidentialité des données",
    "Should admin be the only one to set PageCorrect Settings": "L'administrateur doit-il être le seul à pouvoir définir les paramètres de PageCorrect ?",
    "Website Structure": "Structure du site web",
    "Data Privacy violations": "Infractions à la confidentialité des données",
    "Heartbeat check": "Vérification heartbeat",
    "Request PDF accessibility check from selection": "Demander une vérification d'accessibilité PDF à partir de la sélection",
    "Total unique downloads": "Total des téléchargements uniques",
    "[[succeededPdfs]] out of [[pdfs]] PDF accessibility request succeeded": "[[succeededPdfs]] sur [[pdfs]] demandes d'accessibilité PDF a/ont abouti",
    "Accessibility Issues": "Problèmes d'accessibilité",
    "Inspecting:": "Inspection de :",
    "Pages with Accessibility Issues": "Pages avec des problèmes d'accessibilité",
    "Start advance export": "Démarrer l'exportation avancée",
    "Check whether your website is responding and measures the response times of the server": "Vérifie si votre site web répond et mesure les temps de réponse du serveur",
    "Search label": "Chercher étiquette",
    "Custom range": "Personnaliser la gamme",
    "Last Half Year": "Dernier semestre",
    "Last Month": "Dernier mois",
    "Last Quarter": "Dernier trimestre",
    "Last Week": "Dernière semaine",
    "Last Year": "Dernière année",
    "Character": [
      "Caractère",
      "",
      ""
    ],
    "Image missing alt attribute": "Image sans attribut alt",
    "Quick info here": "Info rapide ici",
    "There is 1 META description on this page": "Il y a 1 description META sur cette page",
    "There is 1 internal link on this page": [
      "Il y a 1 lien interne sur cette page",
      "",
      ""
    ],
    "There is one META description on this page": [
      "Il y a une description META sur cette page",
      "",
      ""
    ],
    "and 1 document": {
      "Documents with broken images": [
        "et 1 document",
        "",
        ""
      ],
      "Documents with confirmed misspellings": [
        "et 1 document",
        "",
        ""
      ],
      "Documents with potential misspellings": [
        "et 1 document",
        "",
        ""
      ]
    },
    "and one document": {
      "Pages with broken links": [
        "et un document",
        "",
        ""
      ]
    },
    "Remediation": "Remédiation",
    "Remediation quote": "Devis de remédiation",
    "Remediation quote has been requested": "Un devis de remédiation a été demandé",
    "Sort by": {
      "Exchange center filter option": "Trier par"
    },
    "#idname.class-name1.class-name2": "#idname.class-name1.class-name2",
    "&lt;i&gt; tags as icons": "&lt;i&gt ; tags as icons",
    ".class-name1": ".class-name1",
    "<strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)": "<strong>Style CSS pour la balise &lt;strong&gt;</strong> (rendre tout le texte plein)",
    "<strong>NOTE</strong>: Changing the text below, will override the text in all your included languages": "<strong>REMARQUE</strong>: la modification du texte ci-dessous aura pour effet de remplacer le texte dans toutes les langues incluses.",
    "A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations": "Une version plus récente de PageAssist est disponible. Passer à la version 2.0 pour accéder aux nouvelles personnalisations",
    "Accessibility Fixes": "Corrections d'accessibilité",
    "Add Policy": "Ajouter une politique",
    "Add a description of the widget to your users": "Ajouter une description du widget à vos utilisateurs",
    "Add comment (Optional)": "Ajouter un commentaire (facultatif)",
    "Add row": "Ajouter une ligne",
    "Add text for when the button is hovered": "Ajouter du texte lorsque le bouton est survolé",
    "Add title": "Ajouter un titre",
    "Africa": "Afrique",
    "All <code>img</code> elements have an <code>alt</code> attribute": "Tous les éléments <code>img</code> ont un attribut <code>alt</code> ",
    "Alt text does not convey the same information as the image": "Le texte Alt ne véhicule pas la même information que l'image",
    "Alt text for all <code>img</code> elements contains all text in the image unless the image text is decorative or appears elsewhere in the document": "Le texte Alt de tous les éléments <code>img</code> contient tout le texte de l'image, sauf si le texte de l'image est décoratif ou apparaît ailleurs dans le document.",
    "Alt text for all <code>img</code> elements is not placeholder text unless author has confirmed it is correct": "Le texte Alt de tous les éléments <code>img</code> n'est pas un texte générique, sauf si l'auteur a confirmé qu'il est correct.",
    "Alt text for all <code>img</code> elements is the empty string (\\\"\\\") if the image is decorative.": "Le texte Alt pour tous les éléments <code>img</code> est la chaîne vide (\\\"\\\") si l'image est décorative.",
    "Alt text for all <code>img</code> elements used as source anchors is not empty when there is no other text in the anchor": "Le texte Alt de tous les éléments <code>img</code> utilisés comme ancres sources n'est pas vide lorsqu'il n'y a pas d'autre texte dans l'ancre.",
    "Alt text is not the same as the filename unless author has confirmed it is correct": "Le texte Alt n'est pas identique au nom du fichier, sauf si l'auteur a confirmé qu'il est correct.",
    "And how are we going to fix it?": "Et comment allons-nous corriger cela ?",
    "Applying fix": "Application de la correction",
    "Are you sure you want to stop receiving this report?": "Êtes-vous sûr de vouloir cesser de recevoir ce rapport ?",
    "Aria-label": "Label Aria",
    "Asia": "Asie",
    "Blink sample image": "Exemple d'image de clignement ",
    "Blink testing sample image": "Exemple d'image pour le test du clignement",
    "Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.": "Dans la pratique, ces deux problèmes peuvent entraîner de multiples problèmes visuels, allant de couleurs erronées à des espaces gênants là où il n'y en a pas.",
    "Bottom center": "En bas au milieu",
    "Bottom left": "En bas à gauche",
    "Bottom right": "En bas à droite",
    "Browse": "Parcourir",
    "Button hover message": "Message au survol du bouton",
    "CSS selector": "Sélecteur CSS",
    "Change <b> tags to a custom element": "Remplacer les balises <b> par un élément personnalisé",
    "Change <b> tags to a custom tag": "Remplacer les balises <b> par une balise personnalisée",
    "Change <blink> tags to a custom element": "Remplacer les balises <blink> par un élément personnalisé",
    "Change <blink> tags to a custom tag": "Remplacer les balises <blink> par une balise personnalisée",
    "Change <marquee> tags to a custom element": "Remplacer les balises <marquee> par un élément personnalisé",
    "Change <marquee> tags to a custom tag": "Remplacer les balises <marquee> par une balise personnalisée",
    "Change your &lt;blink&gt; tags into something else": "Changer vos balises &lt;blink&gt ; en quelque chose d'autre",
    "Change your &lt;i&gt; elements into something else": "Transformer vos éléments &lt;i&gt ; en quelque chose d'autre",
    "Change your &lt;marquee&gt; tags into something else": "Changer vos balises &lt;marquee&gt ; en quelque chose d'autre",
    "Check for misspelling company name: [[company]]": "Vérifier les fautes d'orthographe dans le nom de l'entreprise :[[company]]",
    "Choose a tag to replace your b tags with": "Choisir une balise pour remplacer vos balises b par",
    "Choose a tag to replace your blink tags with": "Choisir une balise pour remplacer vos balises clignotantes par",
    "Choose a tag to replace your italic tags with": "Choisir une balise pour remplacer vos balises italiques par",
    "Choose a tag to replace your marquee tags with": "Choisissez une balise pour remplacer vos balises de marquage par",
    "Choose an icon": "Choisir une icône",
    "Choose this option to customise the fix": "Choisir cette option pour personnaliser la correction",
    "Choose this option to customize the fix": "Choisir cette option pour personnaliser la correction",
    "Choose your own text for the warning pop-up": "Choisir votre propre texte pour la fenêtre d'avertissement",
    "Circle": "Cercle",
    "Class": "Classe",
    "Close PageCorrect form": "Fermer le formulaire PageCorrect",
    "Close [[groupName]]: [[labelName]]": "Fermer [[groupName]] : [[labelName]]",
    "Company name *": "Nom de l'entreprise *",
    "Constraint:": "Contrainte :",
    "Custom settings": "Personnaliser les paramètres",
    "Default fix": "Correction par défaut",
    "Default language": "Langue par défaut",
    "Dutch": "Néerlandais",
    "Edit Report": "Modifier le rapport",
    "Education": "Éducation",
    "Element name is invalid": "Le nom de l'élément n'est pas valide",
    "Element name should not contain spaces": "Le nom de l'élément ne doit pas contenir d'espaces",
    "Enter aria-label name": "Saisir le nom de l'étiquette aria",
    "Enter class name": "Saisir le nom de la classe",
    "Enter role name": "Saisir le nom du rôle",
    "Europe": "Europe",
    "Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:": "Même s'il s'agit d'une solution assez simple, cela peut poser des problèmes de conception sur votre site web de deux manières :",
    "Example 1": "Exemple 1",
    "Example 2": "Exemple 2",
    "File must be below 1MB": "Le fichier doit être inférieur à 1MB",
    "Filter dropdown": "Filtre déroulant",
    "Finance": "Finances",
    "Fix applied!": "Correction appliquée !",
    "Fix options": "Options de correction",
    "French": "Français",
    "Give a title to your Skip to Content button": "Donner un titre à votre bouton Passer au contenu",
    "Government": "Gouvernement",
    "Grid view": "Vue en grille",
    "Hide": "Masquer",
    "Hide text": "Masquer le texte",
    "Hitting the tab button will turn on Skip to PageAssist": "Le bouton de tabulation activera le passage à PageAssist",
    "How are we going to fix it?": "Comment allons-nous corriger cela ?",
    "Icon shape": "Forme de l'icône",
    "Image Alt text is short": "Le texte Alt de l'image est court",
    "Important images should not have spacer Alt text": "Les images importantes ne doivent pas être accompagnées d'un texte Alt intercalaire",
    "Info": "Info",
    "Insert company name": "Insérer le nom de l'entreprise",
    "Instead of &lt;i&gt; choose a different element name to be used instead": "Au lieu de &lt;i&gt ; choisissez un nom d'élément différent à utiliser à la place",
    "It will take some time before our system will register your changes to PageCorrect": "Il faudra un certain temps avant que notre système n'enregistre vos modifications dans PageCorrect.",
    "Left middle": "Milieu à gauche",
    "Letter case *": "Écriture bicamérale *",
    "Light": "Lumière",
    "Link excludes:": "Le lien exclut :",
    "Loading PageFix": "Chargement de PageFix",
    "Make sure you use correct formatting and add multiple selectors when your page design differs": "Veillez à utiliser une mise en forme correcte et à ajouter des sélecteurs multiples lorsque la conception de votre page diffère.",
    "Manage options": "Gérer les options",
    "Marquee sample image": "Exemple d'image de marquage",
    "Marquee testing sample image": "Exemple d'image de test de marquage",
    "Menu theme": "Thème du menu",
    "New Window Information": "Informations sur la nouvelle fenêtre",
    "New Window Test": "Test de la nouvelle fenêtre",
    "Non-Decorative images must have Alt text": "Les images non décoratives doivent être accompagnées d'un texte Alt.",
    "North America": "Amérique du Nord",
    "PageAssist Logo": "Logo PageAssist",
    "PageAssist position on Page": "Position de PageAssist sur la Page",
    "Portuguese": "Portugais",
    "Potential problems that can arise": "Problèmes potentiels qui peuvent survenir",
    "Press 'Upload link' to save your URL settings": "Cliquez sur \"Télécharger le lien\" pour enregistrer vos paramètres d'URL.",
    "Preview": "Aperçu",
    "Proper Case": "Cas particulier",
    "Remove input selector": "Retirer le sélecteur d'entrée",
    "Remove logo upload": "Supprimer le téléchargement du logo",
    "Remove row": "Supprimer la ligne",
    "Repair Tip": "Conseil de réparation",
    "Repair options": "Options de réparation",
    "Replace Italic element with EM": "Remplacer l'élément italique par EM",
    "Replace all &lt;b&gt; tags with": "Remplacer toutes les balises &lt;b&gt ; par",
    "Replace all &lt;blink&gt; tags with": "Remplacer toutes les balises &lt;blink&gt ; par",
    "Replace all &lt;i&gt; tags": "Remplacer toutes les balises &lt;i&gt ;.",
    "Replace all &lt;marquee&gt; tags with": "Remplacer toutes les balises &lt;marquee&gt ; par",
    "Report Center Image": "Image du centre de rapport",
    "Reset Input": "Réinitialiser l'entrée",
    "Reset Skip to content text to its default": "Rétablir la valeur par défaut du texte Passer au contenu",
    "Reset design": "Réinitialiser la conception",
    "Reset to default": "Rétablir la valeur par défaut",
    "Restore": "Restaurer",
    "Restore profile?": "Rétablir le profil ?",
    "Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.": "La restauration de ce profil <strong>([[profileName]] )</strong> le rendra disponible dans vos modules.",
    "Right middle": "Au milieu à droite",
    "Rounded Box": "Case arrondie",
    "Russian": "Russe",
    "Show": "Afficher",
    "Show details": "Afficher les détails",
    "Show text": "Afficher le texte",
    "Simplified Chinese": "Chinois simplifié",
    "Skip to Content": "Passer au contenu",
    "Snippet reset": "Réinitialisation de l'extrait",
    "Someone have created this PageCorrect before you, on another check.": "Quelqu'un a créé ce PageCorrect avant vous, sur une autre vérification.",
    "Spanish Mexican": "Espagnol mexicain",
    "Start export inventory emails": "Commencer à exporter les e-mails d'inventaire",
    "Start export inventory emails extended": "Commencer à exporter les e-mails d'inventaire étendus",
    "Testing": "Test",
    "The subpath/subfolder the WordPress installation is under": "Le sous-chemin/sous-dossier dans lequel se trouve l'installation de WordPress",
    "This fix requires development knowledge": "Cette correction nécessite des connaissances en matière de développement",
    "This message will be displayed when the user hovers over the PageAssist button": "Ce message s'affiche lorsque l'utilisateur survole le bouton PageAssist.",
    "This option might cause problems to your icons": "Cette option peut causer des problèmes à vos icônes",
    "Title Text": "Texte du titre",
    "To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check": "Pour mettre en place cette politique, vous devez nous indiquer le nom de l'entreprise et le type d'écriture bicamérale éventuellement mal orthographiée que vous souhaitez vérifier.",
    "Top center": "En haut au milieu",
    "Top left": "En haut à gauche",
    "Top right": "En haut à droite",
    "Trying out the pop-up": "Essai du pop-up",
    "UPPERCASE": "MAJUSCULE",
    "Undo check review": "Annuler l'examen de la vérification",
    "Upload link": "Téléverser le lien",
    "Upload logo": "Téléverser le logo",
    "Use Datepicker": "Utiliser un sélecteur de date",
    "Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>": "Utilisez PageCorrect pour corriger la faute de frappe suivante<code>:[[misspelling]]</code>",
    "Use PageCorrect to fix Broken Link": "Utiliser PageCorrect pour réparer un lien défectueux",
    "Use PageCorrect to fix these image sources": "Utilisez PageCorrect pour corriger ces sources d'images",
    "Value:": "Valeur :",
    "View": "Voir",
    "What is wrong with the &lt;b&gt; (bold) element?": "Qu'est-ce qui ne va pas avec l'élément &lt;b&gt ; (gras) ?",
    "What is wrong with the &lt;i&gt; (italic) element?": "Qu'est-ce qui ne va pas avec l'élément &lt;i&gt ; (italique) ?",
    "What to do when the link doesn't work?": "Que faire lorsque le lien ne fonctionne pas ?",
    "What to do when things look wrong?": "Que faire en cas de problème ?",
    "Why shouldn't I use the blink element?": "Pourquoi ne puis-je pas utiliser l'élément \"clignement\" ?",
    "Widget Design and Text": "Conception et texte des widgets",
    "Widget Icon Setup": "Configuration de l'icône du widget",
    "Without any assigned class": "Sans classe assignée",
    "Write a warning to your outbound link": "Ajouter un avertissement à votre lien sortant",
    "Write custom tag": "Rédiger une balise personnalisée",
    "lowercase": "minuscule",
    "with": "avec",
    "with &lt;em&gt;": "avec &lt;em&gt ;",
    "Statistics is using sample data": "Les statistiques utilisent des échantillons de données",
    "Statistics results are sample data for demo purposes - export is disabled": "Les résultats statistiques sont des échantillons de données à des fins de démonstration - l'exportation est désactivée.",
    "This section is using sample data": "Cette section utilise des échantillons de données",
    "&lt;i&gt; tags with these attribute values will not be changed": "les balises &lt;i&gt; avec ces valeurs d'attribut ne seront pas modifiées",
    "(Bad)": "(Mauvais)",
    "(Good)": "(Bon)",
    "<span class=\\\"mr-2\\\">Pages</span>": "<span class=\"\\&quot;mr-2\\&quot;\">Pages</span>",
    "Add API user": "Ajouter un utilisateur API",
    "Add attributes to be excluded in this change": "Ajouter les attributs à exclure de cette modification",
    "Add profile": "Ajouter un profil",
    "Add source code exclude": "Ajouter l'exclusion du code source",
    "Are you sure?": "Êtes-vous sûr ?",
    "Button hover color": "Couleur du bouton au survol",
    "Calculated by no. and severity of issues, page views and links leading to this page..": "Calculé en fonction du nombre et de la gravité des problèmes, des pages consultées et des liens menant à cette page.",
    "Choose minimum word count for a page to be included in the readability test": "Choisir le nombre de mots minimum pour qu'une page soit incluse dans le test de lisibilité.",
    "Color contrast ratio": "Rapport de contraste des couleurs",
    "Content id tag": "Balise d'identification du contenu",
    "Creation date": "Date de création",
    "Custom text": "Personnaliser le texte",
    "Customise the Information page": "Personnaliser la page d'information",
    "Disable": "Désactiver",
    "Docs without downloads": "Docs sans téléchargement",
    "Documents Without Downloads": "Documents sans téléchargement",
    "EPI Server Path": "Chemin d'accès au serveur EPI",
    "EPIServer": "Serveur EPI",
    "Editor": "Éditeur",
    "Ex: data-currentpage, or data-pageid, or CurrentPageLink": "Ex : data-currentpage, ou data-pageid, ou CurrentPageLink",
    "Ex: lang or CurrentPageLanguage": "Ex : lang ou CurrentPageLanguage",
    "Export both pages and documents": "Exporter à la fois des pages et des documents",
    "Export only documents without downloads": "Exporter uniquement les documents sans téléchargements",
    "Export only html pages without visits": "Exporter uniquement les pages html sans visites",
    "Include Accessibility Statement": "Inclure une déclaration d'accessibilité",
    "Include custom info text": "Inclure un texte d'information personnalisé",
    "Includes a button with a link to your accessibility statement": "Inclut un bouton avec un lien vers votre déclaration d'accessibilité",
    "Indicates which language this page will be scanned in. Click underneath to change": "Indique la langue dans laquelle cette page sera analysée. Cliquer en dessous pour modifier",
    "Insert a valid URL": "Insérer une URL valide",
    "Language tag": "Étiquette de la langue",
    "Last assigned profile on page. Page will be removed from Performance": "Dernier profil attribué sur la page. La page sera supprimée de Performance",
    "Link color": "Couleur du lien",
    "Link opens in a new tab": "Le lien s'ouvre dans un nouvel onglet",
    "Main color": "Couleur principale",
    "Meta name": "Nom méta",
    "Mode": "Mode",
    "No default profile selected for this page, scoring not available.": "Aucun profil par défaut sélectionné pour cette page, notation non disponible.",
    "No documents found": "Aucun document trouvé",
    "No profiles selected for this page, scoring not available.": "Aucun profil sélectionné pour cette page, notation non disponible.",
    "Not a valid CSS selector": "Sélecteur CSS non valide",
    "Notification when the downtime ends": "Notification de la fin du temps d'arrêt",
    "Number of external links": "Nombre de liens externes",
    "Number of incoming links": "Nombre de liens entrants",
    "Open details": "Ouvrir les détails",
    "PDF Accessibility": "Accessibilité des PDF",
    "Passwords do not match": "Les mots de passe ne correspondent pas",
    "Please add a Default Profile to your Page": "Veuillez ajouter un profil par défaut à votre page",
    "Please add a Profile to your Page": "Veuillez ajouter un profil à votre page",
    "Please enter a valid color code": "Veuillez saisir un code couleur valide",
    "Please perform a PDF scan to see the results for the checks below": "Veuillez effectuer une analyse PDF pour voir les résultats des vérifications ci-dessous",
    "Setup": "Configuration",
    "Show less of the code snippet": "Afficher moins d'extrait de code",
    "Show the full code snippet": "Afficher l'extrait de code complet",
    "Statistics not activated. Page Views not available.": "Statistiques non activées. Nombre de pages vues non disponible.",
    "Subdomain": "Sous-domaine",
    "Subdomain url": "URL du sous-domaine",
    "Superfast - Don't use unless you know what you're doing": "Ultra rapide - ne pas utiliser à moins de savoir ce que vous faites",
    "Text color": "Couleur du texte",
    "The optional epi server path": "Chemin d'accès facultatif au serveur epi",
    "The subdomain url to the CMS page": "L'url du sous-domaine vers la page du CMS",
    "This text must be under 1000 characters": "Ce texte doit être inférieur à 1000 caractères",
    "Two-Factor Authentication": "Authentification à deux facteurs",
    "Two-factor authentication is currently disabled": "L'authentification à deux facteurs est actuellement désactivée",
    "Two-factor authentication is currently enabled": "L'authentification à deux facteurs est actuellement activée",
    "URL needs to be valid, include http:// or https:// and be under 100 characters": "L'URL doit être valide, inclure http:// ou https:// et ne pas dépasser 100 caractères.",
    "URL template": "Modèle d'URL",
    "Unique broken links": "Liens défectueux uniques",
    "Very fast - Be Cautious": "Très rapide - Soyez prudent",
    "WCAG 2.0": "WCAG 2.0",
    "WCAG 2.1": "WCAG 2.1",
    "Your color contrast is below the recommended score": "Le contraste des couleurs est inférieur à la valeur recommandée",
    "labels": "étiquettes",
    "Acceptance Rate": "Taux d'acceptation",
    "Acceptance Rate Over Time": "Taux d'acceptation au fil du temps",
    "Acceptance Rate by Category": "Taux d'acceptation par catégorie",
    "Accepted cookies": "Cookies acceptés",
    "Add callback functions boilerplate": "Ajouter un modèle de fonctions de rappel",
    "Add cookie": "Ajouter un cookie",
    "Add empty EventListeners": "Ajouter les écouteurs d'événements vides",
    "Add empty callbacks": "Ajouter les rappels vides",
    "Add event listeners boilerplate": "Ajouter un modèle d'écouteurs d'événements",
    "Add web overlay lock": "Ajouter un verrou superposé",
    "Alternative": "Alternative",
    "An overview of your customer's behavior with cookies on your website": "Un aperçu du comportement de vos clients avec les cookies sur votre site web",
    "Are you sure you want to ignore all selected misspellings?": "Êtes-vous sûr de vouloir ignorer toutes les fautes d'orthographe sélectionnées ?",
    "Are you sure you want to mark this check as fixed on all pages?": "Êtes-vous sûr de vouloir marquer cette vérification comme résolue sur toutes les pages ?",
    "Are you sure you want to mark this check as fixed?": "Êtes-vous sûr de vouloir marquer cette vérification comme résolue ?",
    "Are you sure you want to mark this misspelling as fixed?": "Êtes-vous sûr de vouloir marquer cette faute d'orthographe comme corrigée ?",
    "Are you sure you want to mark this misspelling(s) as fixed?": "Êtes-vous sûr de vouloir marquer cette (ces) faute(s) d'orthographe comme corrigée(s) ?",
    "Basic": "Basique",
    "Button color": "Couleur du bouton",
    "Button text color": "Couleur du texte du bouton",
    "Case sensitive URLs": "URL sensibles à la casse",
    "Changes wording from only essential cookies to explicit reject": "Modifie la formulation en remplaçant « cookies essentiels » par « rejet explicite ». ",
    "Consent Log": "Registre de consentement",
    "Consent Overview": "Aperçu du consentement",
    "Consent results are sample data for demo purposes": "Les résultats du consentement sont des échantillons de données à des fins de démonstration.",
    "Cookie Acceptance Rate": "Taux d'acceptation du cookie",
    "Cookie Overview": "Aperçu du cookie",
    "Cookie description": "Description du cookie",
    "Cookie duration": "Durée du cookie",
    "Cookie name": "Nom du cookie",
    "Enter a valid CSS selector": "Entrez un sélecteur CSS valide",
    "Essential": "Essentiel",
    "Example 3": "Exemple 3",
    "Example 4": "Exemple 4",
    "Explicit reject option": "Option de rejet explicite",
    "Give a short description of the purpose of the cookie": "Décrire brièvement l'objectif du cookie.",
    "Give users more control over which categories of cookies to consent to": "Donner aux utilisateurs plus de contrôle sur les catégories de cookies auxquelles ils consentent",
    "How long is the cookie active": "La durée pendant laquelle le cookie est actif",
    "IP Address": "Adresse IP",
    "Ignore canonical URLs": "Ignorer les URL canoniques",
    "Ignored by": "Ignoré par",
    "Ignored date": "Date ignorée",
    "Ignored misspellings on account": "Fautes d'orthographe ignorées sur le compte",
    "Include cookies": "Inclure les cookies",
    "Insert CSS class or id selector": "Insérer un sélecteur de classe ou d'identifiant CSS",
    "Insert a CSS selector": "Insérer un sélecteur CSS",
    "Limit or exclude": "Limiter ou exclure",
    "Limit search": "Limiter la recherche",
    "Link to your opt out page": "Lier à votre page d'exclusion",
    "Make sure you use the correct setting": "Assurez-vous d'utiliser le bon paramètre",
    "Mark check as fixed": "Marquer la vérification comme résolue",
    "Marketing": "Marketing",
    "No cookies found": "Aucun cookie trouvé",
    "No misspellings have been ignored": "Aucune faute d'orthographe n'a été ignorée",
    "Opt out link": "Lien d'exclusion",
    "Original": "Original",
    "Other": "Autres",
    "Overall Acceptance Rate": "Taux d'acceptation global",
    "Overall acceptance rate": "Taux d'acceptation global",
    "Per category consent": "Par catégorie de consentement",
    "Please wait - Marking as fixed": "Veuillez patienter - marquage comme résolu",
    "Please wait - Marking word as fixed": "Veuillez patienter - marquage du mot comme corrigé",
    "Preferences": "Préférences",
    "Privacy regulation": "Règlement sur la protection de la vie privée",
    "Remove cookie": "Supprimer le cookie",
    "Remove from Ignored": "Enlever d'Ignoré",
    "Remove this word from Ignored Misspellings": "Retirer ce mot des fautes d'orthographe ignorées",
    "URL Structure": "Structure de l'URL",
    "Domain Overview": {
      "Topmenu": "Aperçu du domaine",
      "$$noContext": "Aperçu du domaine"
    },
    "Admin Settings": "Paramètres Admin",
    "Case sensitivity": "Sensibilité à la casse",
    "Close project search and domain picker": "Fermer la recherche de projet et le sélecteur de domaine",
    "Domain Settings": "Paramètres du domaine",
    "In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.": "Au final, les balises &lt;i&gt ; et &lt;em&gt ; ont toutes deux la même apparence visuelle. Cependant, elles ont chacune une signification sémantique différente. La balise &lt;em&gt; est utilisée pour représenter l'emphase, tandis que la balise &lt;i&gt; représente un mot ou une phrase que l'utilisateur pourrait vouloir mettre en italique (un mot étranger, la définition d'un mot, etc.). Dans ce dernier cas, il convient d'utiliser le CSS.",
    "Paste your image link (URL) here": "Coller le lien de votre image (URL) ici",
    "Set up your domain": "Configurer votre domaine",
    "The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.": "Le plus gros problème de cette correction peut survenir si la balise &lt;i&gt; est utilisée pour les icônes au lieu de, par exemple, &lt;span&gt; (exemple : police Awesome). Si vous remarquez que quelque chose ne va pas avec vos icônes après avoir appliqué le correctif, c'est peut-être la raison. Cependant, les balises &lt;i&gt; pour les icônes ont tendance à utiliser une classe, assurez-vous donc que vous avez défini les options de manière à ne modifier que les balises sans modifier les classes. De cette manière, vos icônes ne devraient pas être touchées.",
    "The profile <strong>[[profileName]]</strong> is being used on the following pages below:": "Le profil <strong>[[profileName]]</strong> est utilisé sur les pages suivantes :",
    "Add icon border": "Ajouter une bordure d'icône",
    "Adds a 3px wide border to the PageAssist widget icon": "Ajoute une bordure de 3px de large à l'icône du widget PageAssist",
    "Bottom": "En bas",
    "Clear search": "Effacer la recherche",
    "Ensures that PageAssist is never overlapped by other elements on the page": "Veille à ce que PageAssist n'interfère jamais avec d'autres éléments de la page.",
    "Estonian": "Estonien",
    "German": "Allemand",
    "Go to overlay with details": "Aller à la superposition avec les détails",
    "Guidelines for WCAG 2.2": "Directives pour WCAG 2.2",
    "Heartbeat Overview": "Aperçu Heartbeat",
    "How far the button is from the edge. Customization dependant on position.": "Distance entre le bouton et le bord. Personnalisation en fonction de la position.",
    "Insert a valid host name": "Insérer un nom d'hôte valide",
    "Keep PageAssist on top": "Garder PageAssist en haut",
    "Left": "Gauche",
    "Margin from edge in pixels": "Marge par rapport au bord en pixels",
    "Norwegian Bokmål": "Norvégien Bokmål",
    "Norwegian Nynorsk": "Norvégien Nynorsk",
    "Right": "À droite",
    "Social Media visits": "Visites de réseaux sociaux",
    "Social media visits": "Visites de réseaux sociaux",
    "Sort column": "Trier la colonne",
    "Sort column ascending": "Trier les colonnes par ordre croissant",
    "Sort column descending": "Trier les colonnes par ordre décroissant",
    "Subgroup": "Sous-groupe",
    "Swedish": "Suédois",
    "Toggle label text": "Bascule vers le texte de l'étiquette",
    "Top": "En haut",
    "Unique misspellings": "Fautes d'orthographe uniques",
    "Unique misspellings found": "Fautes d'orthographe uniques trouvées",
    "WCAG 2.2 Accessibility Compliance": "Conformité à l'accessibilité WCAG 2.2",
    "Area dynamic page": "Page dynamique de la zone",
    "Employeepage": "Page employé",
    "Language id": "Identité linguistique",
    "Newspage": "Page d'actualité",
    "Standard": "Standard",
    "Standard for http(s)://edit.domain.tld/inz/<path>. Alternative for http(s)://domain.tld/<path>/edit.": "Standard pour http(s)://edit.domain.tld/inz/<path>. Alternative à http(s)://domain.tld/<path>/edit.",
    "URL format": "Format de l'URL",
    "Export both internal and external links": "Exporter les liens internes et externes",
    "Export only external links": "Exporter uniquement les liens externes",
    "Export only internal links": "Exporter uniquement les liens internes",
    "Overview of all the enabled modules for this domain": "Aperçu de tous les modules activés pour ce domaine",
    "Search for a predefined policy in the Policy Exchange Center": "Recherche d'une politique prédéfinie dans le Centre d'échange de politiques",
    "A log of all the consents given by your website visitors": "Un registre de tous les consentements donnés par les visiteurs de votre site web",
    "Action required. Click to resolve issue.": "Action requise. Cliquer dessus pour résoudre le problème.",
    "Complete": "Terminé",
    "Cookie Overview buttons": "Boutons d'aperçu des cookies",
    "Cookie Overview saved": "Aperçu des cookies enregistré",
    "Cookie added by user": "Cookie ajouté par l'utilisateur",
    "Cookie domain": "Domaine des cookies",
    "Cookie not found": "Cookie non trouvé",
    "Cookie not published. Missing:": "Cookie non publié. Manquant :",
    "Could not save invalid form": "Impossible d'enregistrer un formulaire invalide",
    "Disables interactions on website until the visitor makes a consent choice. Be aware that locking interactions prior to consent may not be compliant with certain regional privacy regulations.": "Désactive les interactions sur le site web jusqu'à ce que le visiteur choisisse de donner son consentement. Sachez que le verrouillage des interactions avant le consentement peut ne pas être conforme à certaines réglementations régionales en matière de protection de la vie privée.",
    "Finish the setup by adding your cookies": "Terminez la configuration en ajoutant vos cookies",
    "For Cookie setup please go to your <b>Data Privacy</b> module.<br> Manual cookies can be set up or edited any time and are not related to script setup.": "Pour la configuration des cookies, veuillez consulter votre module de <b>confidentialité des données</b>.<br> Les cookies manuels peuvent être configurés ou modifiés à tout moment et ne sont pas liés à la configuration du script.",
    "GDPR requires that companies provide descriptions on their website for all cookies that are used.": "Le rgpd exige que les entreprises fournissent des descriptions sur leur site web pour tous les cookies utilisés.",
    "Give an overview of the cookies used on your website. Finish a domain scan or add them manually.": "Donne un aperçu des cookies utilisés sur votre site web. Terminez l'analyse d'un domaine ou ajoutez-les manuellement.",
    "Id": "Id",
    "Include a link to your webpage's privacy policy": "Incluez un lien vers la politique de confidentialité de votre page web",
    "It looks like the previously set up cookie was not found in this scan. It might be that the cookie was removed or our scan just couldn’t detect it.": "Il semble que le cookie précédemment défini n'ait pas été trouvé lors de cette analyse. Il se peut que le cookie ait été supprimé ou que notre analyse n'ait pas pu le détecter.",
    "I’ll do it later": "Je le ferai plus tard",
    "Keep": "Garder",
    "Leave without saving": "Quitter sans enregistrer",
    "Link to Privacy Policy": "Lien vers la politique de confidentialité",
    "Link to your Cookie Overview": "Lien vers votre aperçu des cookies",
    "Link to your Privacy Policy": "Lien vers votre politique de confidentialité",
    "Link where customers can opt out of sale of personal data. Mandatory for websites under the CCPA regulation.": "Lien permettant aux clients de refuser la vente de leurs données personnelles. Obligatoire pour les sites relevant du CCPA.",
    "List of checks with and without issues categorized by [[level]] guidelines": "Liste des vérifications avec et sans problèmes classés par les directives [[level]]",
    "Manage Cookie": "Gérer les cookies",
    "On-demand scan unavailable": "L'analyse à la demande n'est pas disponible",
    "Pages needing to be fixed": "Pages à corriger",
    "Save cookies": "Enregistrer les cookies",
    "Save existing cookies": "Enregistrer les cookies existants",
    "Save this overview to publish completed cookies to the Cookie Overview.": "Enregistrer cet aperçu pour publier les cookies terminés dans l'aperçu des cookies.",
    "Save your page before leaving to keep your progress and publish the completed cookies.": "Enregistrer votre page avant de quitter pour conserver votre progression et publier les cookies terminés.",
    "Scan History": "Historique d'analyse",
    "Scan Information": "Informations sur l'analyse",
    "Scan info": "Info sur l'analyse",
    "Source": "Source",
    "This feature is not available on a demo account.": "Cette fonction n'est pas disponible sur un compte de démo.",
    "This page has been rescanned since the latest full scan.": "Cette page a été réanalysée depuis la dernière analyse complète.",
    "This scan feature is not available on a demo account": "Cette fonction d'analyse n'est pas disponible sur un compte de démo.",
    "UUID": "UUID",
    "You need to include a name in order to save your cookies.": "Vous devez indiquer un nom pour que vos cookies soient enregistrés.",
    "[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.": "[[total]] pages. Prioriser et corriger tous les problèmes de contenu de votre site web à partir d'une vue consolidée.",
    "Distribution of policies with matches across priority levels": "Distribution des politiques avec des correspondances sur l'ensemble des niveaux de priorité",
    "Copied!": "Copié !",
    "Copy": "Copier",
    "Default language*": "Langue par défaut*",
    "Don't forget to copy and update the script on your website!": "N'oubliez pas de copier et de mettre à jour le script sur votre site web !",
    "Included languages*": "Langues incluses*",
    "Loading Data": "Chargement des données",
    "Loading...": "Chargement...",
    "No support": "Pas d'assistance",
    "Open PageAssist script settings": "Ouvrir les paramètres du script PageAssist",
    "PageAssist script settings": "Paramètres du script PageAssist",
    "Please add the script as close to the open HEAD-tag as possible": "Veuillez ajouter le script aussi près que possible de la balise HEAD ouverte.",
    "Please wait - loading": "Veuillez patienter - chargement en cours",
    "Press Ctrl-C": "Appuyer sur Ctrl-C",
    "Press ⌘-C": "Appuyer sur ⌘-C",
    "This chart shows how many percent of visitors accepted the various categories of cookies on your website. Visitors who did not make a consent choice on the cookie banner are not counted": "Ce graphique indique le pourcentage de visiteurs qui ont accepté les différentes catégories de cookies sur votre site web. Les visiteurs qui n'ont pas choisi de donner leur consentement sur la bannière des cookies ne sont pas comptabilisés.",
    "Visitor percentage": "Pourcentage de visiteurs",
    "Consent Manager script settings": "Paramètres du script du gestionnaire de consentement",
    "Open consent manager script settings": "Ouvrir les paramètres du script du gestionnaire de consentement",
    "Scan your website for any data privacy issues that could be present": "Analysez votre site web pour détecter d'éventuels problèmes de confidentialité des données.",
    "Please enter a full UUID string. Empty or partial strings will not yield any results.": "Veuillez saisir une chaîne UUID complète. Les chaînes vides ou partielles ne donneront aucun résultat.",
    "UUID can only be searched by entering the full value": "L'UUID ne peut être recherché qu'en entrant la valeur complète.",
    "Average Cumulative Layout Shift": "Cumulative Layout Shift moyen",
    "Average Largest Contentful Paint": "Largest Contentful Paint moyen",
    "Average Speed Index": "Speed index moyen",
    "Average Total Blocking Time": "Total Blocking Time moyen",
    "CMS Path": "Chemin d'accès du CMS",
    "Click here or drag a rule to this area": "Cliquez ici ou faites glisser une règle dans cette zone",
    "Cumulative Layout Shift": "Cumulative Layout Shift",
    "LCP": "LCP",
    "Relevant for": "Pertinent pour",
    "SI": "SI",
    "TBT": "TBT",
    "[[avg]]": "[[avg]]",
    "[[label]]: [[value]]": "[[label]] : [[value]]",
    "Content Authoring": "Création de contenu",
    "Responsibilities": "Responsabilités",
    "Responsibility": "Responsabilité",
    "UX Design": "Conception UX",
    "Visual Design": "Conception visuelle",
    "Version [[version]]": "Version [[version]]",
    "Accessibility score": "Score d'accessibilité",
    "Comparison to average": "Comparaison avec la moyenne",
    "Industry average": "Moyenne du secteur",
    "No scores available for this domain": "Aucun score disponible pour ce domaine",
    "Professional services": "Services professionnels",
    "Quality Assurance score": "Score d'assurance qualité",
    "SEO score": "Score SEO",
    "Scores": "Scores",
    "The average score for domains within your industry.": "Le score moyen des domaines au sein de votre secteur d'activité.",
    "Add language": "Ajouter une langue",
    "Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.": "Êtes-vous sûr de vouloir archiver la politique<strong>[[policyName]]</strong> ? Nous ne rechercherons plus de correspondance avec cette politique. Vous pouvez toujours désarchiver la politique ultérieurement.",
    "Are you sure you want to set these documents as reviewed?": "Êtes-vous sûr de vouloir définir ces documents comme étant examinés ?",
    "Clear selection": "Effacer la sélection",
    "Delete language -": "Supprimer la langue -",
    "Delete the language tab - [[language]]": "Supprimer l'onglet langue - [[language]]",
    "Discovered": "Découvert",
    "Doing this will result in removing the translations in the selected language from both your Cookie Overview and the actual banner itself.<br></br><strong>You will need to add the descriptions again when you re-add the selected language.</strong>": "Cette opération aura pour effet de supprimer les traductions dans la langue sélectionnée, tant dans l'aperçu des cookies que dans la bannière elle-même.<br><br><strong>Vous devrez ajouter à nouveau les descriptions lorsque vous réintroduirez la langue sélectionnée</strong>.",
    "Don't forget to update your languages in Script Setup!": "N'oubliez pas de mettre à jour vos langues dans la configuration du Script !",
    "Edit this policy rule later under the “Add rule to policy” tab.": "Modifier cette règle de politique ultérieurement sous l'onglet \"Ajouter une règle à la politique\".",
    "Front-end Development": "Développement Front-end",
    "How to setup this policy:": "Comment mettre en place cette politique :",
    "Insert word length": "Insérer la longueur du mot",
    "Inspect page with browser extension": "Inspecter la page avec une extension de navigateur",
    "Mark all as reviewed": "Marquer tous les documents comme examinés",
    "Mobile only": "Mobile uniquement",
    "New policy": "Nouvelle politique",
    "Please add at least one language": "Veuillez ajouter au moins une langue",
    "Please set the default language": "Veuillez définir la langue par défaut",
    "Please wait - Adding word to ignored list": "Veuillez patienter - mot en train d'être ajouté à la liste des mots ignorés",
    "Please wait - Adding words to ignored list": "Veuillez patienter - mots en train d'être ajoutés à la liste des mots ignorés",
    "Remove rule from policy": "Supprimer une règle de la politique",
    "Request PDF accessibility check for all": "Demander une vérification d'accessibilité PDF pour tous",
    "Request Remedition quote for all": "Demander un devis de remédiation pour tous",
    "Script": "Script",
    "Select a group": "Sélectionner un groupe",
    "Select a shape": "Sélectionner une forme",
    "Select languages": "Sélectionner les langues",
    "Select the default language": "Sélectionner la langue par défaut",
    "To finish setting up your manual Cookie Overview go to the selected domain’s": "Pour terminer la configuration de votre aperçu manuel des cookies, allez dans celle du domaine sélectionné",
    "Unignore this check": "Ne pas ignorer cette vérification",
    "WCAG 2.1 (Level AA) Mobile": "WCAG 2.1 (niveau AA) Mobile",
    "WCAG 2.1 (Level AAA) Mobile": "WCAG 2.1 (niveau AAA) Mobile",
    "Are you sure you want to delete label: [[label]] ?": "Êtes-vous sûr de vouloir supprimer l'étiquette : [[label]] ?",
    "Business services": "Services aux entreprises",
    "CMS template is configured for this domain": "Le modèle CMS est configuré pour ce domaine",
    "Consent Manager configuration": "Configuration du gestionnaire de consentement",
    "Consent Manager language*": "Langue du gestionnaire de consentement*",
    "Consent Manager pop-up position on Page": "Position de la fenêtre contextuelle du gestionnaire de consentement sur la page",
    "Consent Manager pop-up setup": "Configuration de la fenêtre contextuelle du gestionnaire de consentement",
    "Construction/industrial": "Construction/industrie",
    "Consumer services": "Services aux consommateurs",
    "Entertainment/Leisure": "Divertissement/loisirs",
    "Financial services": "Services financiers",
    "German (Germany)": "Allemand (Allemagne)",
    "Healthcare": "Santé",
    "Label used in the groups below. Please edit or delete the groups and try again.": "Étiquette utilisée dans les groupes ci-dessous. Veuillez modifier ou supprimer les groupes et réessayer.",
    "Law enforcement": "Application de la loi",
    "Legal": "Juridique",
    "Non-profit": "Sans but lucratif",
    "Real-estate": "Immobilier",
    "Retail/wholesale": "Commerce de détail/de gros",
    "Spanish (Spain)": "Espagnol (Espagne)",
    "Technology": "Technologie",
    "Utilities/Natural resources": "Services publics/Ressources naturelles",
    "Widget Design": "Conception de widgets",
    ":": ":",
    "Accessibility issue": "Problème d'accessibilité",
    "Add reason (optional)": "Ajouter un motif (facultatif)",
    "All pages with this accessibility issue": "Toutes les pages avec ce problème d'accessibilité",
    "All pages with this data privacy issue": "Toutes les pages avec ce problème de confidentialité des données",
    "Alternatively, click the button below.": "Vous pouvez également cliquer sur le bouton ci-dessous.",
    "Are you sure you want to mark this  as fixed?": "Êtes-vous sûr de vouloir marquer ce point comme résolu ?",
    "Are you sure you want to mark this  as ignored?": "Êtes-vous sûr de vouloir marquer ce point comme ignoré ?",
    "Are you sure you want to mark this  as not fixed?": "Êtes-vous sûr de vouloir marquer ce point comme non corrigé ?",
    "Are you sure you want to mark this check as ignored?": "Êtes-vous sûr de vouloir marquer cette vérification comme ignorée ?",
    "Are you sure you want to mark this issue as ignored?": "Êtes-vous sûr de vouloir marquer ce problème comme ignoré ?",
    "Are you sure you want to unignore this ?": "Êtes-vous sûr de vouloir ne pas ignorer ce point ?",
    "Average time (comp.)": "Temps moyen (comp.)",
    "Bounce rate (comp.)": "Taux de rebond (comp.)",
    "Campaign visits": "Visites de la campagne",
    "Code": "Code",
    "Confirmation required": "Confirmation requise",
    "Current password": "Mot de passe actuel",
    "Data privacy issue": "Problème de confidentialité des données",
    "Data violations": "Violations de données",
    "Date found": "Date trouvée",
    "Downloads (comp.)": "Téléchargements (comp.)",
    "Entries (comp.)": "Entrées (comp.)",
    "Events": "Evénements",
    "Exits (comp.)": "Sorties (comp.)",
    "Export visitors browsers": "Exporter les navigateurs des visiteurs",
    "Export visitors devices": "Exporter les appareils des visiteurs",
    "Export visitors language": "Exporter les langues des visiteurs",
    "Export visitors locations": "Exporter l'emplacement des visiteurs",
    "Export visitors operating systems": "Exporter les systèmes d'exploitation des visiteurs",
    "Export visitors organization": "Exporter l'organisation des visiteurs",
    "Found on page": "Trouvé sur la page",
    "Group name": "Nom du groupe",
    "Image URL": "URL de l'image",
    "Issue details": "Détails du problème",
    "Issue not found": "Problème non trouvé",
    "Legacy Browser Service changed": "Le service du navigateur antérieur a été modifié",
    "Look up in Google": "Rechercher dans Google",
    "Mark as reviewed": "Marquer comme examiné",
    "Maximum word length to search for": "Longueur maximale du mot à rechercher",
    "Names": "Noms",
    "No pages were found. Try searching for the page URL instead of the page title.": "Aucune page n'a été trouvée. Essayez de rechercher l'URL de la page au lieu du titre de la page.",
    "Open browser extension": "Ouvrir l'extension du navigateur",
    "Open issue page": "Ouvrir la page de problèmes",
    "Open misspelling page": "Ouvrir la page des fautes d'orthographe",
    "Other checks for this snippet": "Autres vérifications pour cet extrait",
    "Pages with accessibility issues": "Pages avec des problèmes d'accessibilité",
    "Pages with policy issues": "Pages avec des problèmes de politique",
    "Pageviews (comp.)": "Pages vues (comp.)",
    "Percentage shows number of pages that are compliant with all Policies": "Le pourcentage indique le nombre de pages conformes à toutes les politiques.",
    "Percentage shows number of pages that are compliant with all QA checks": "Le pourcentage indique le nombre de pages conformes à toutes les vérifications d'assurance qualité.",
    "Please enter a valid date!": "Veuillez saisir une date valide !",
    "Please wait - Adding word to all dictionaries": "Veuillez patienter - mot en cours d'ajout dans tous les dictionnaires",
    "Press to toggle additional rows.": "Appuyer pour faire basculer les lignes supplémentaires.",
    "Puppeteer Browser Service changed": "Le service de navigation de Puppeteer a été modifié",
    "Reason:&nbsp;": "Raison:&nbsp ;",
    "Remember to add this source code exclude to your domain(s) through the Edit Domain screen.": "N'oubliez pas d'ajouter cette exclusion de code source à votre/vos domaine(s) via l'écran Modifier le domaine.",
    "Remove review": "Supprimer l'avis",
    "Repeat new password": "Répéter le nouveau mot de passe",
    "Sorry, this page was not found. The issue must have been resolved.": "Désolé, cette page n'a pas été trouvée. Le problème doit avoir été résolu.",
    "The date cannot be in the future": "La date ne peut pas être dans le futur",
    "The end date cannot be before the start date": "La date de fin ne peut être antérieure à la date de début",
    "The settings form contains incorrect data. Close the form anyway?": "Le formulaire de paramétrage contient des données incorrectes. Fermer quand même le formulaire ?",
    "The start and end date cannot be in the future, please enter the compare dates again": "Les dates de début et de fin ne peuvent pas se situer dans le futur, veuillez saisir à nouveau les dates de comparaison.",
    "This issue is marked as fixed.": "Ce problème est marqué comme résolu.",
    "This issue is marked as ignored.": "Ce problème est marqué comme ignoré.",
    "This issue is marked as reviewed.": "Ce problème est marqué comme consulté.",
    "This word has been added to your dictionary": "Ce mot a été ajouté à votre dictionnaire",
    "To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class=\\\"text-bold\\\">My Exports.</span>": "Pour voir l'état d'avancement, cliquez sur l'avatar de l'utilisateur en haut à droite de la page d'accueil et sélectionnez <span class=\"\\&quot;text-bold\\&quot;\">Mes exportations</span>.",
    "Total unique downloads (comp.)": "Total des téléchargements uniques (comp.)",
    "Unique downloads (comp.)": "Téléchargements uniques (comp.)",
    "Visitors browsers export": "Exportation des navigateurs des visiteurs",
    "Visitors devices export": "Exportation des appareils des visiteurs",
    "Visitors language export": "Exportation de la langue des visiteurs",
    "Visitors locations export": "Exportation des emplacements des visiteurs",
    "Visitors operating systems export": "Exportation des systèmes d'exploitation des visiteurs",
    "Visitors organization export": "Exportation de l'organisation des visiteurs",
    "Visits (comp.)": "Visites (comp.)",
    "WCAG 2.1 (Level A) Mobile": "WCAG 2.1 (niveau A) Mobile",
    "Your export is currently being generated.": "Votre exportation est en cours de génération.",
    "+ ' + (report.targets.length - maxTargets) + ' more": "+ ' + (report.targets.length - maxTargets) + ' plus",
    "Accessibility Checklist (WCAG 2.0)": "Liste de contrôle de l'accessibilité (WCAG 2.0)",
    "Accessibility Checklist (WCAG 2.1)": "Liste de contrôle de l'accessibilité (WCAG 2.1)",
    "Accessibility Checklist (WCAG 2.2)": "Liste de contrôle de l'accessibilité (WCAG 2.2)",
    "Average no. of results pages viewed": "Nb moyen de pages de résultats consultées",
    "Checklist": "Liste de contrôle",
    "Email *": "E-mail *",
    "Event actions": "Actions événementielles",
    "Event categories": "Catégories d'événements",
    "Event names": "Noms des événements",
    "First name *": "Prénom *",
    "Last name *": "Nom de famille *",
    "Search term": "Terme de recherche",
    "Search terms": "Termes de recherche",
    "Search terms with no results": "Termes de recherche sans résultats",
    "Site Search": "Recherche sur le site",
    "Site Search - Search Terms": "Recherche sur le site - Termes de recherche",
    "Site Search No Results Search Terms": "Recherche sur le site Termes de recherche sans résultats",
    "Switch between chart and table": "Passer d'un graphique à un tableau",
    "Table": "Tableau",
    "more": "plus",
    "Accessibility checks update": "Mise à jour des vérifications d'accessibilité",
    "Account is under maintenance": "Le compte est en cours de maintenance",
    "Add internal URL": "Ajouter une URL interne",
    "Add the name of the platform or company who provides this cookie.": "Ajouter le nom de la plateforme ou de l'entreprise qui fournit ce cookie.",
    "All PDFs": "Tous les PDF",
    "All scheduled reports": "Tous les rapports programmés",
    "An error has occurred - please try again": "Une erreur s'est produite - veuillez réessayer",
    "Are you sure you want mark as fixed": "Êtes-vous sûr de vouloir marquer cela comme résolu",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary for all languages?": "Êtes-vous sûr de vouloir ajouter le mot<strong>[[word]]</strong> au dictionnaire pour toutes les langues ?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary?": "Êtes-vous sûr de vouloir ajouter le mot<strong>[[word]]</strong> au dictionnaire ?",
    "Are you sure you want to confirm the word <strong>[[word]]</strong> as misspelling?": "Êtes-vous sûr de vouloir confirmer que le mot <strong>[[word]]</strong> est mal orthographié ?",
    "Are you sure you want to ignore the misspelling <strong>[[word]]</strong> for all languages?": "Êtes-vous sûr de vouloir ignorer la faute d'orthographe<strong>[[word]]</strong> pour toutes les langues ?",
    "Are you sure you want to mark the misspelling <strong>[[word]]</strong> as fixed?": "Êtes-vous sûr de vouloir marquer la faute d'orthographe<strong>[[word]]</strong> comme corrigée ?",
    "Are you sure you want to remove the Default label?": "Êtes-vous sûr de vouloir supprimer l'étiquette \"Défaut\" ?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong>?": "Êtes-vous sûr de vouloir exécuter la politique<strong>[[policyName]]</strong> ?",
    "Bar chart representing data": "Diagramme à barres représentant des données",
    "Bar line chart representing": "Diagramme à barres représentant",
    "Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.": "Sachez qu'un attribut alt vide peut être suffisant et approprié pour les images décoratives.",
    "Bubble chart representing data": "Graphique à bulles représentant des données",
    "Clear the field": "Effacer le champ",
    "Close submenu": "Fermer le sous-menu",
    "Contact Support": "Contacter l'assistance",
    "Cookie platform": "Plateforme de cookies",
    "Current password is incorrect please try again": "Le mot de passe actuel est incorrect, veuillez réessayer",
    "Doughnut chart representing data": "Diagramme en forme de donut représentant des données",
    "Enable Cookieless Tracking": "Activer le suivi sans cookie",
    "Errors and": "Erreurs et",
    "Errors and Warnings": "Erreurs et avertissements",
    "Events filter buttons": "Boutons de filtrage des événements",
    "Every 12 weeks": "Toutes les 12 semaines",
    "Every 2 weeks": "Toutes les 2 semaines",
    "Every 4 weeks": "Toutes les 4 semaines",
    "Every 8 weeks": "Toutes les 8 semaines",
    "Frequency": "Fréquence",
    "Image details": "Détails de l'image",
    "Image metadata": "Métadonnées de l'image",
    "Image preview": "Aperçu de l'image",
    "Inventory image preview": "Aperçu de l'image d'inventaire",
    "It seems like we are experience some issues with the page you are looking at.": "Il semble que nous ayons des problèmes avec la page que vous consultez.",
    "It seems like your computer is disconnected from the internet.": "Il semble que votre ordinateur soit déconnecté d'Internet.",
    "Line chart representing data": "Graphique linéaire représentant des données",
    "List of received reports": "Liste des rapports reçus",
    "Metadata and pages": "Métadonnées et pages",
    "Metadata property": "Propriété des métadonnées",
    "My scheduled reports": "Mes rapports programmés",
    "No date range selected": "Aucune plage de dates n'a été sélectionnée",
    "Norwegian": "Norvégien",
    "Only Errors": "Seulement les erreurs",
    "Only errors": "Seulement les erreurs",
    "Open dropdown with filters": "Ouvrir une liste déroulante avec filtres",
    "Open metadata view": "Ouvrir la vue des métadonnées",
    "Open submenu with filters": "Ouvrir le sous-menu avec filtres",
    "Pages that contain the Email": "Pages qui contiennent l'e-mail",
    "Percentage shows the average compliance score across all pages on the domain": "Le pourcentage indique le score de conformité moyen de toutes les pages du domaine.",
    "Pie chart representing data": "Diagramme circulaire représentant les données",
    "Platform": "Plate-forme",
    "Please contact the support if this issue keeps happening": "Veuillez contacter le service d'assistance si ce problème persiste",
    "Please refresh the browser when your computer is online again.": "Veuillez actualiser le navigateur lorsque votre ordinateur sera de nouveau en ligne.",
    "Please try again later": "Veuillez réessayer plus tard",
    "Press to remove the label.": "Appuyez sur cette touche pour supprimer l'étiquette.",
    "Puppeteer 20": "Puppeteer 20",
    "Remove internal URL": "Supprimer l'URL interne",
    "Scan all pages for cookies": "Analyser les cookies de toutes les pages ",
    "Schedule this report": "Programmer ce rapport",
    "Search in options": "Options de recherche",
    "Show HTML snippet details": "Afficher les détails de l'extrait HTML",
    "Show labels": "Afficher les étiquettes",
    "Show less of the url snippet": "Afficher moins de l'extrait d'url",
    "Show the full url snippet": "Afficher l'extrait d'url complet",
    "Showing": "Affichage de",
    "The average compliance score for this module for domains from other organizations within your industry:": "Le score moyen de conformité pour ce module pour les domaines d'autres organisations de votre secteur :",
    "Unsubscribe from report": "Se désabonner du rapport",
    "Warnings": "Avertissements",
    "We export up to a maximum of 1000 rows": "Nous exportons jusqu'à un maximum de 1000 lignes",
    "We recommend that you have an alt attribute with relevant content on all image tags.": "Nous vous recommandons d'ajouter un attribut alt avec un contenu pertinent sur toutes les balises d'image.",
    "You have images missing an alt attribute.": "Vous avez des images qui n'ont pas d'attribut alt.",
    "[[name]] Remove": "[[name]] Supprimer",
    "[[target]]": "[[target]]",
    "default": "défaut",
    "[[label]]": "[[label]]",
    "% of visitors staying after a search": "% de visiteurs restant après une recherche",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.": "La remédiation des documents en vue de leur mise en conformité avec les normes d'accessibilité WCAG 2.1 AA, Section 508, HHS ou PDF/UA est effectuée par notre filiale, NetCentric Technologies, Inc. En raison des exigences réglementaires en vigueur dans votre pays, nous ne sommes pas en mesure de coordonner la remédiation des documents directement pour vous. Nous vous invitons toutefois à contacter directement NetCentric pour obtenir un devis et des services de remédiation à l'adresse suivante : dherr@allyant.com. Veuillez noter que tous les contrats de remédiation sont conclus entre vous, le client, et NetCentric, et soumis aux conditions générales et à la politique de confidentialité de NetCentric, et qu'ils entraîneront un transfert de données à des tiers et à des pays tiers, y compris, mais sans s'y limiter, les États-Unis, le Canada, l'Australie et l'Égypte.",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. Upon completion of the work, NetCentric will also provide a compliance report. NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy.": "La remédiation des documents en vue de leur mise en conformité avec les normes d'accessibilité WCAG 2.1 AA, Section 508, HHS ou PDF/UA est effectuée par notre société affiliée, NetCentric Technologies, Inc. Pour la remédiation, nous nous coordonnerons avec NetCentric pour examiner le document et vous fournir un prix fixe pour la remédiation. À l'issue des travaux, NetCentric fournira également un rapport de conformité. NetCentric vous indiquera si un texte alternatif (Alt-Text) est nécessaire pour les images qui ne sont pas auto-descriptives ou si des informations supplémentaires sont nécessaires pour finaliser la remédiation du document. Veuillez noter que tous les contrats de remédiation sont conclus entre vous, le client, et NetCentric, et qu'ils sont soumis aux conditions générales et à la politique de confidentialité de NetCentric.",
    "Japanese": "Japonais",
    "Report Administration": "Administration du rapport",
    "Submit": "Soumettre",
    "You have [[domains]] domain(s) on your account": "Vous avez [[domains]] domaine(s) sur votre compte",
    "Find domains by searching for the title or URL": "Trouver des domaines en recherchant le titre ou l'URL",
    "Industry average score": "Score moyen du secteur",
    "Proceed to add one more check": "Procéder à l'ajout d'une vérification supplémentaire",
    "Readability test (for English pages only)": "Test de lisibilité (pour les pages en anglais uniquement)",
    "Request quote for more pages": "Demander un devis pour plus de pages",
    "Request quote for more profiles": "Demander un devis pour plus de profils",
    "Search for domain": "Rechercher un domaine",
    "The user does not have access to view this domain and any reports associated with it": "L'utilisateur n'a pas accès à la visualisation de ce domaine et des rapports qui y sont associés.",
    "Update all domain groups": "Actualiser tous les groupes de domaine",
    "Update domain group": "Actualiser le groupe de domaine",
    "Updating a group can take more than 30 minutes. During the operation you will not be able to create and update groups.": "L'actualisation d'un groupe peut prendre plus de 30 minutes. Pendant l'opération, il ne sera pas possible de créer et d'actualiser des groupes.",
    "WCAG 2.2 (Level A)": "WCAG 2.2 (niveau A)",
    "WCAG 2.2 (Level A) Mobile": "WCAG 2.2 (niveau A) Mobile",
    "WCAG 2.2 (Level AA)": "WCAG 2.2 (niveau AA)",
    "WCAG 2.2 (Level AA) Mobile": "WCAG 2.2 (niveau AA) Mobile",
    "WCAG 2.2 (Level AAA)": "WCAG 2.2 (niveau AAA)",
    "WCAG 2.2 (Level AAA) Mobile": "WCAG 2.2 (niveau AAA) Mobile",
    "You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button \\\"Request quote for more pages\\\" and someone on our team will be in touch.": "Vous avez atteint le nombre maximum de pages de Performance dans votre forfait actuel.<br><br>Pour vous renseigner sur les options tarifaires pour des pages supplémentaires, veuillez cliquer sur le bouton \"Demander un devis pour plus de pages\" et un membre de notre équipe vous contactera.",
    "You must perform a manual review of the page to confirm if this issue is present": "Vous devez procéder à un examen manuel de la page pour confirmer la présence de ce problème.",
    "Accessibility Checklist (QUALWEB)": "Liste de contrôle d'accessibilité (QUALWEB)",
    "Accessibility checks cannot be ignored for domain groups. To ignore this check you must do it for the entire domain.": "Les contrôles d'accessibilité ne peuvent pas être ignorés pour les groupes de domaines. Pour ignorer ce contrôle, vous devez l'effectuer pour l'ensemble du domaine.",
    "Accessibility checks cannot be unignored for domain groups. To unignore this check you must do it for the entire domain.": "Les contrôles d'accessibilité ne peuvent pas être ignorés pour les groupes de domaines. Pour ignorer ce contrôle, vous devez l'effectuer pour l'ensemble du domaine.",
    "Check your spelling or try a shorter query.": "Vérifiez votre orthographe ou essayez une requête plus courte.",
    "Guidelines for QUALWEB": "Lignes directrices pour QUALWEB",
    "Language not supported": "Langue non prise en charge",
    "No domains found.": "Aucun domaine trouvé.",
    "QUALWEB Accessibility Compliance": "Conformité d'accessibilité QUALWEB",
    "QualWeb (Level A)": "QualWeb (Niveau A)",
    "QualWeb (Level AA)": "QualWeb (Niveau AA)",
    "Score could not be generated": "Le score n'a pas pu être généré",
    "Searching <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>": "Recherche <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>",
    "The language of the page is not recognized as English. The Flesch-Kincaid test only works for English language. Change to the LIX test if you wish to generate scores for non-English pages.": "La langue de la page n'est pas reconnue comme étant l'anglais. Le test Flesch-Kincaid ne fonctionne que pour la langue anglaise. Passez au test LIX si vous souhaitez générer des scores pour des pages non anglaises.",
    "We could not generate an accurate score for these pages. This is typically either due to the text on a page being too short, too long, or our web crawler not picking up any text at all.": "Nous n'avons pas pu générer un score précis pour ces pages. Cela est généralement dû au fait que le texte d'une page est trop court, trop long ou que notre robot d'exploration Web ne détecte aucun texte.",
    "Are you sure you want to add word [[word]] to all dictionaries": "Etes-vous sûr de vouloir ajouter le mot [[word]] à tous les dictionnaires",
    "Are you sure you want to add word [[word]] to dictionary?": "Êtes-vous sûr de vouloir ajouter le mot [[word]] au dictionnaire ?",
    "Are you sure you want to confirm the word [[word]] as misspelling?": "Êtes-vous sûr de vouloir confirmer que le mot [[word]] est mal orthographié ?",
    "Are you sure you want to ignore the misspelling [[word]] for all languages?": "Êtes-vous sûr de vouloir ignorer l’orthographe erronée [[word]] pour toutes les langues ?",
    "Are you sure you want to mark the misspelling [[word]] as fixed?": "Êtes-vous sûr de vouloir marquer le mot mal orthographié [[word]] comme corrigé ?",
    "Cannot forward more": "Impossible de transmettre plus",
    "Choose Date": "Choisissez la date",
    "Compare": "Comparer",
    "Confirmed errors only": "Erreurs confirmées uniquement",
    "Exclude checks that require manual review": "Exclure les contrôles qui nécessitent une vérification manuelle",
    "If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.": "Si cette option est activée, l'analyse du domaine inclut uniquement les contrôles d'accessibilité qui peuvent être automatiquement identifiés comme des erreurs. Les contrôles nécessitant une vérification manuelle sont exclus.",
    "One month back": "Il y a un mois",
    "One month forward": "Un mois en avant",
    "Press to choose the end day": "Appuyez pour choisir le jour de fin",
    "Press to choose the start day": "Appuyez pour choisir le jour de début",
    "Remove compare range dates": "Supprimer les dates de comparaison de plage",
    "The date cannot be in the future.": "La date ne peut pas être dans le futur.",
    "Toggle the datepicker": "Activer/désactiver le sélecteur de date",
    "Add Policy with AI": "Ajouter une politique avec l'IA",
    "Consolidated Reports": "Rapports consolidés",
    "Created with AI policy assistant": "Créé avec l'assistant politique AI",
    "Policy Assistant": "Assistant politique",
    "Sparkle icon": "Icône Sparkle",
    "The Policy Assistant runs on Google Vertex AI, which can make mistakes.": "L'assistant politique fonctionne sur Google Vertex AI, qui peut faire des erreurs.",
    "You have reached the maximum number of Performance profiles in your current plan.<br/><br/>To inquire about pricing options for additional profiles, please press the button \\\"Request quote for more profiles\\\" and someone on our team will be in touch.": "Vous avez atteint le nombre maximum de profils de performance dans votre forfait actuel.<br/><br/>Pour vous renseigner sur les options de tarification pour des profils supplémentaires, veuillez appuyer sur le bouton « Demander un devis pour plus de profils » et un membre de notre équipe vous contactera.",
    "You are about to perform a scan of <span class='text-link'>[[pageTitle]]</span> using the profile <span class='text-link'>[[profileName]]</span>.<br>The scan can take a few minutes to finalise, depending on the size of the page.<br><br>Do you want to continue?": "Vous êtes sur le point d'effectuer une analyse de <span class='text-link'>[[pageTitle]]</span> à l'aide du profil <span class='text-link'>[[profileName]]</span>.<br>L'analyse peut prendre quelques minutes, selon la taille de la page.<br><br>Voulez-vous continuer ?",
    "Doesn't scan automatically": "Ne scanne pas automatiquement",
    "Scans automatically": "Numérise automatiquement",
    "with this": "avec ça",
    "with this PDF": "avec ce PDF",
    "with this archive file": "avec ce fichier d'archive",
    "with this slide": "avec cette diapositive",
    "with this spreadsheet": "avec cette feuille de calcul",
    "with this text file": "avec ce fichier texte",
    "Errors must be fixed for compliance.": "Les erreurs doivent être corrigées pour assurer la conformité.",
    "Issues to Fix": "Problèmes à résoudre",
    "Issues to Review": "Questions à examiner",
    "Reviews require manual judgement.": "Les évaluations nécessitent un jugement manuel.",
    "Warnings are likely to be issues, but they require manual investigation.": "Les avertissements sont susceptibles d’être problématiques, mais ils nécessitent une enquête manuelle.",
    "1 content": [
      "1 contenu",
      "",
      ""
    ],
    "1 misspelling ignored across all domains": [
      "1 faute d'orthographe ignorée dans tous les domaines",
      "",
      ""
    ],
    "1 new cookie on": [
      "1 nouveau cookie sur",
      "",
      ""
    ],
    "1 page": [
      "1 page",
      "",
      ""
    ],
    "1 page with one or more failing checks {{guideline}}": [
      "1 page avec un ou plusieurs contrôles échoués {{guideline}}",
      "",
      ""
    ],
    "1 page with one or more ignored checks {{guideline}}": [
      "1 page avec un ou plusieurs contrôles ignorés {{guideline}}",
      "",
      ""
    ],
    "1 policy found": [
      "1 politique trouvée",
      "",
      ""
    ],
    "1 results": [
      "1 résultat",
      "",
      ""
    ],
    "1 visit": [
      "1 visite",
      "",
      ""
    ],
    "1 word added across all domains": [
      "1 mot ajouté dans tous les domaines",
      "",
      ""
    ],
    "One word found": [
      "Un mot trouvé",
      "",
      ""
    ],
    "You have 1 user on your account": [
      "Vous avez 1 utilisateur sur votre compte",
      "",
      ""
    ],
    "Accessibility Compliance Scan": "Analyse de conformité en matière d'accessibilité",
    "Broken Links on Sitemap": "Liens brisés sur le plan du site",
    "Broken links on sitemap": "Liens brisés sur le plan du site",
    "Close Spotlight Search.": "Fermer la recherche Spotlight.",
    "Requested": "Demandé",
    "Toggle Spotlight Search.": "Activer/désactiver la recherche Spotlight.",
    "WCAG 2.2": "WCAG 2.2",
    "Newest": {
      "Exchange Center Sort by option": "Le plus récent"
    },
    "(<strong><i>[[issues]]</i></strong> unique problems)": "(<strong><i>[[issues]]</i></strong> problèmes uniques)",
    "(<strong>[[issues]]</strong> unique problems)": "(<strong>[[issues]]</strong> problèmes uniques)",
    "<div class=\\\\'pull-left\\\\'>' + ('Heatmaps": "<div class=\\\\'pull-left\\\\'>' + ('Cartes thermiques",
    "<div class=\\\\'pull-left\\\\'>' + ('History Center": "<div class=\\\\'pull-left\\\\'>' + ('Centre historique",
    "<p class='warning'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached the limit of the amount of profiles allowed on your account ([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan or archive some profiles before restoring this one.</p>": "<p class='warning'>Acquia Web Governance ne peut pas restaurer le profil.</p><p>Vous avez atteint la limite de profils autorisés sur votre compte ([[maxProfiles]] profils). Veuillez contacter notre équipe commerciale pour ajouter d'autres profils à votre forfait ou en archiver certains avant de restaurer celui-ci.</p>",
    "<strong>' + (links.total | monNumber) + '</strong> ' + ('link": "<strong>' + (links.total | monNumber) + '</strong> ' + ('lien",
    "<strong>' + (pages.total | monNumber) + '</strong> ' + ('page": "<strong>' + (pages.total | monNumber) + '</strong> ' + ('page",
    "A \\\"skip to content\\\" link at the start of the webpage allows screen reader and keyboard-only users to skip over potentially non-relevant links at the start of your webpage and immediately access the main content.": "Un lien « Accéder au contenu » au début de la page Web permet aux utilisateurs de lecteurs d'écran et de clavier uniquement d'ignorer les liens potentiellement non pertinents au début de votre page Web et d'accéder immédiatement au contenu principal.",
    "A cozy room with sofa, table and laptops that have Acquia Web Governance text": "Une pièce confortable avec canapé, table et ordinateurs portables dotés du texte Acquia Web Governance",
    "About Acquia Web Governance": "À propos d'Acquia Web Governance",
    "Accept Acquia Web Governance Privacy Terms": "Accepter les conditions de confidentialité d'Acquia Web Governance",
    "Acquia Web Governance": "Gouvernance Web Acquia",
    "Acquia Web Governance - Accessibility": "Acquia Web Governance - Accessibilité",
    "Acquia Web Governance - Accessibility Check List": "Acquia Web Governance - Liste de contrôle d'accessibilité",
    "Acquia Web Governance - Accessibility Guidelines": "Acquia Web Governance - Directives d'accessibilité",
    "Acquia Web Governance - Account Dictionary": "Acquia Web Governance - Dictionnaire des comptes",
    "Acquia Web Governance - Admin Page Performance Profiles": "Acquia Web Governance - Profils de performance de la page d'administration",
    "Acquia Web Governance - Audit Log": "Acquia Web Governance - Journal d'audit",
    "Acquia Web Governance - Broken Images": "Acquia Web Governance - Images brisées",
    "Acquia Web Governance - Broken Links": "Acquia Web Governance - Liens brisés",
    "Acquia Web Governance - Content With Broken Links": "Acquia Web Governance – Contenu avec liens brisés",
    "Acquia Web Governance - Content With QA Errors": "Acquia Web Governance - Contenu avec erreurs d'assurance qualité",
    "Acquia Web Governance - Cookie Acceptance Rate": "Acquia Web Governance - Taux d'acceptation des cookies",
    "Acquia Web Governance - Cookie Consent Log": "Acquia Web Governance - Journal de consentement aux cookies",
    "Acquia Web Governance - Cookie Overview": "Acquia Web Governance - Présentation des cookies",
    "Acquia Web Governance - Dashboard": "Acquia Web Governance - Tableau de bord",
    "Acquia Web Governance - Data Privacy": "Acquia Web Governance - Confidentialité des données",
    "Acquia Web Governance - Data Privacy Check List": "Acquia Web Governance - Liste de contrôle de la confidentialité des données",
    "Acquia Web Governance - Data Privacy Content": "Acquia Web Governance - Contenu relatif à la confidentialité des données",
    "Acquia Web Governance - Data Privacy Guidelines": "Acquia Web Governance - Directives sur la confidentialité des données",
    "Acquia Web Governance - Data Privacy Issues": "Acquia Web Governance – Problèmes de confidentialité des données",
    "Acquia Web Governance - Data Privacy Summary": "Acquia Web Governance - Résumé de la confidentialité des données",
    "Acquia Web Governance - External PDF Compliance": "Acquia Web Governance - Conformité PDF externe",
    "Acquia Web Governance - Fast Track": "Acquia Web Governance - Voie rapide",
    "Acquia Web Governance - Heatmaps": "Acquia Web Governance - Cartes thermiques",
    "Acquia Web Governance - History Center": "Acquia Web Governance - Centre d'histoire",
    "Acquia Web Governance - Ignored Misspellings": "Acquia Web Governance - Fautes d'orthographe ignorées",
    "Acquia Web Governance - Internal PDF Compliance": "Acquia Web Governance - Conformité interne aux PDF",
    "Acquia Web Governance - Labels": "Acquia Web Governance - Étiquettes",
    "Acquia Web Governance - Misspellings": "Acquia Web Governance - Fautes d'orthographe",
    "Acquia Web Governance - Page Performance Pages": "Acquia Web Governance - Performances des pages",
    "Acquia Web Governance - PageCorrect": "Gouvernance Web Acquia - PageCorrect",
    "Acquia Web Governance - PageCorrect Accessibility Fixes": "Acquia Web Governance - Corrections d'accessibilité PageCorrect",
    "Acquia Web Governance - PageCorrect Content": "Acquia Web Governance - Contenu PageCorrect",
    "Acquia Web Governance - Pages With Failing Checks": "Acquia Web Governance - Pages avec vérifications défaillantes",
    "Acquia Web Governance - Pages With Ignored Checks": "Acquia Web Governance - Pages avec vérifications ignorées",
    "Acquia Web Governance - Pages With Misspellings": "Acquia Web Governance - Pages avec fautes d'orthographe",
    "Acquia Web Governance - Pages With Opportunity": "Acquia Web Governance : des pages d'opportunités",
    "Acquia Web Governance - Potential Misspellings": "Acquia Web Governance - Erreurs d'orthographe potentielles",
    "Acquia Web Governance - Prioritized Content": "Acquia Web Governance - Contenu prioritaire",
    "Acquia Web Governance - Quality Assurance": "Acquia Web Governance - Assurance qualité",
    "Acquia Web Governance - Readability Checker": "Acquia Web Governance - Vérificateur de lisibilité",
    "Acquia Web Governance - Readability Summary": "Acquia Web Governance - Résumé de lisibilité",
    "Acquia Web Governance - SEO Checkpoints": "Acquia Web Governance - Points de contrôle SEO",
    "Acquia Web Governance - Search Engine Optimization": "Acquia Web Governance - Optimisation des moteurs de recherche",
    "Acquia Web Governance - Spellcheck Summary": "Acquia Web Governance - Résumé de la vérification orthographique",
    "Acquia Web Governance - User List": "Acquia Web Governance - Liste des utilisateurs",
    "Acquia Web Governance Consent Manager": "Gestionnaire de consentement de gouvernance Web Acquia",
    "Acquia Web Governance Extension": "Extension de gouvernance Web Acquia",
    "Acquia Web Governance PageAssist": "Acquia Web Governance PageAssist",
    "Acquia Web Governance users receiving this report": "Utilisateurs d'Acquia Web Governance recevant ce rapport",
    "Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )": "Acquia Web Governance détectera automatiquement un téléchargement comme un clic sur un lien qui se termine par l'une des extensions de fichier suivantes (veuillez noter que les extensions sont sensibles à la casse)",
    "Add Acquia Web Governance Consent Manager": "Ajouter Acquia Web Governance Consent Manager",
    "Affects [[pageCount]] pages": "Affecte [[pageCount]] pages",
    "An error has occurred - please try again. If the error continues, please contact Acquia Web Governance": "Une erreur s'est produite ; veuillez réessayer. Si l'erreur persiste, veuillez contacter Acquia Web Governance.",
    "An unexpected error occurred. Please try again.": "Une erreur inattendue s'est produite. Veuillez réessayer.",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary for all languages?": "Êtes-vous sûr de vouloir ajouter le mot <strong>' + mot + '</strong> au dictionnaire pour toutes les langues ?",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary?": "Êtes-vous sûr de vouloir ajouter le mot <strong>' + mot + '</strong> au dictionnaire ?",
    "Are you sure you want to confirm the misspelling <strong>' + word + '</strong>?": "Êtes-vous sûr de vouloir confirmer l'orthographe erronée <strong>' + mot + '</strong> ?",
    "Are you sure you want to remove the Profile <strong>[[profileName]]</strong>?": "Êtes-vous sûr de vouloir supprimer le profil <strong>[[profileName]]</strong> ?",
    "Are you sure you want to undo review this document as reviewed?": "Êtes-vous sûr de vouloir annuler la révision de ce document comme révisé ?",
    "Calculate Readability Score": "Calculer le score de lisibilité",
    "Calculate score to see results": "Calculez le score pour voir les résultats",
    "Calculate the readability score of any text (based on [[testName]])": "Calculer le score de lisibilité de n'importe quel texte (basé sur [[testName]])",
    "Can\\\\'t delete label": "Impossible de supprimer l'étiquette",
    "Change your &lt;b&gt; tags into something else": "Changez vos balises &lt;b&gt; en quelque chose d'autre",
    "Choose your own text for the Skip to Content link button<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>": "Choisissez votre propre texte pour le bouton de lien « Passer au contenu »<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Donnez un titre à votre bouton « Passer au contenu » | translate }}\\\"></span>",
    "Clear search in the domain picker": "Effacer la recherche dans le sélecteur de domaine",
    "Click here to contact Acquia Web Governance sales department to increase your maximum page count.": "Cliquez ici pour contacter le service commercial d'Acquia Web Governance afin d'augmenter votre nombre maximum de pages.",
    "Confirmed misspelling": "Faute d'orthographe confirmée",
    "Copyright 2020 Acquia Web Governance. All rights reserved.": "Copyright 2020 Acquia Web Governance. Tous droits réservés.",
    "Couldn't find any domains": "Aucun domaine n'a été trouvé",
    "Crawled Pages ([[pageCount]])": "Pages parcourues ([[pageCount]])",
    "Description*": "Description*",
    "Domain favicon for": "Favicon de domaine pour",
    "Domain groups": "Groupes de domaines",
    "Domains that have never been scanned": "Domaines qui n'ont jamais été scannés",
    "Domains that were not scanned in the selected date range": "Domaines qui n'ont pas été scannés dans la plage de dates sélectionnée",
    "Edit this policy rule later under the \\\"Add rule to policy\\\" tab.": "Modifiez cette règle de politique ultérieurement sous l'onglet « Ajouter une règle à la politique ».",
    "Enable if you want to use Acquia Web Governance in Accessibility mode": "Activez cette option si vous souhaitez utiliser Acquia Web Governance en mode Accessibilité.",
    "Export visitors screen resolutions": "Exporter les résolutions d'écran des visiteurs",
    "For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.": "Pour l'instant, Acquia Web Governance Pagecorrect ajoutera un avertissement contextuel à chaque lien externe, permettant à vos visiteurs de choisir eux-mêmes s'ils souhaitent quitter la page d'origine.",
    "Found 1 audit log on your account": "1 journal d'audit trouvé sur votre compte",
    "Found [[count]] audit logs on your account": "[[count]] journaux d'audit trouvés sur votre compte",
    "From March 1, 2022, Acquia Web Governance will no longer be supporting any version of Internet Explorer or Edge browser version 78 or below. While you will still be able to log on and use Acquia Web Governance with Internet Explorer and older versions of Edge, we are no longer testing releases and fixing bugs specifically for those browsers. We encourage you to switch to another browser such as Chrome or newer version of Edge to be sure that Acquia Optimize continues to work optimally on your device.": "À compter du 1er mars 2022, Acquia Web Governance ne sera plus compatible avec les versions d'Internet Explorer et du navigateur Edge (version 78 ou antérieure). Vous pourrez toujours vous connecter et utiliser Acquia Web Governance avec Internet Explorer et les anciennes versions d'Edge, mais nous ne testons plus les versions ni ne corrigeons les bugs spécifiques à ces navigateurs. Nous vous encourageons à utiliser un autre navigateur, comme Chrome ou une version plus récente d'Edge, pour garantir le bon fonctionnement d'Acquia Optimize sur votre appareil.",
    "Get the Acquia Web Governance Extension": "Obtenez l'extension Acquia Web Governance",
    "Go to the policy dashboard of the domain [[title]]": "Accédez au tableau de bord des politiques du domaine [[title]]",
    "Images missing alt attribute": "Images sans attribut alt",
    "Insert the CSS selector targets you want your visitors to land on<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>": "Insérez les cibles de sélecteur CSS sur lesquelles vous souhaitez que vos visiteurs atterrissent<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Assurez-vous d'utiliser une mise en forme correcte et d'ajouter plusieurs sélecteurs lorsque la conception de votre page diffère' | translate }}\\\"></span>",
    "Internet Explorer &amp; Edge v.78 (or below) no longer supported": "Internet Explorer et Edge v.78 (ou inférieur) ne sont plus pris en charge",
    "Italics are often used in HTML to put emphasis on text. However, this is often achieved with the &lt;I&gt; tag, in which case the emphasis is not announced by screen readers. Using the &lt;I&gt; tag doesn't provide enough context and is becoming an outdated practice.": "L'italique est souvent utilisé en HTML pour mettre en valeur du texte. Cependant, ce résultat est souvent obtenu grâce à la balise &lt;I&gt;, qui ne signale alors pas l'accentuation par les lecteurs d'écran. L'utilisation de la balise &lt;I&gt; ne fournit pas suffisamment de contexte et devient une pratique obsolète.",
    "Last 8 Performance Scans Scores": "Résultats des 8 derniers scans de performance",
    "Latest manual scan finished on [[scannedAt]]": "Dernière analyse manuelle terminée le [[scannedAt]]",
    "Mark this issue as fixed": "Marquer ce problème comme résolu",
    "Monitor how visitors interact with your pages. Acquia Web Governance tracks up to a maximum of 1000 heatmaps sessions per page per month.": "Surveillez l'interaction des visiteurs avec vos pages. Acquia Web Governance suit jusqu'à 1 000 sessions de cartes thermiques par page et par mois.",
    "No downloads were found. Try searching for the document URL instead of the document title.": "Aucun téléchargement n'a été trouvé. Essayez de rechercher l'URL du document plutôt que son titre.",
    "No more PDF accessibility scans are available for this account. Please contact a Acquia Web Governance sales department to add more.": "Il n'y a plus d'analyses d'accessibilité PDF disponibles pour ce compte. Veuillez contacter le service commercial d'Acquia Web Governance pour en ajouter d'autres.",
    "Not valid URL": "URL non valide",
    "PageCorrect failed to save, the Acquia Web Governance team has been notified of the error": "PageCorrect n'a pas pu être enregistré, l'équipe Acquia Web Governance a été informée de l'erreur",
    "Pages Without Visits": "Pages sans visites",
    "Part of success criteria [[issueNumber]]": "Une partie des critères de réussite [[issueNumber]]",
    "Pick any link on your website which you know opens in a new page (social media icons are usually a safe bet) and try to navigate away from the page you are on. If the pop-up doesn't appear it might be because the script has not been applied yet. Give it some time.": "Choisissez un lien sur votre site web qui ouvre une nouvelle page (les icônes de réseaux sociaux sont généralement une option sûre) et essayez de quitter la page consultée. Si la fenêtre contextuelle n'apparaît pas, c'est peut-être parce que le script n'a pas encore été appliqué. Attendez un peu.",
    "Policy Scan is no longer valid. Press Run Policy to update Policy Scan details": "L'analyse des politiques n'est plus valide. Cliquez sur « Exécuter la politique » pour mettre à jour les détails de l'analyse.",
    "Readability Checker": "Vérificateur de lisibilité",
    "Readability Level": "Niveau de lisibilité",
    "Readability Summary": "Résumé de lisibilité",
    "Remove word from Ignored Misspellings": "Supprimer le mot des fautes d'orthographe ignorées",
    "Remove word from dictionary": "Supprimer le mot du dictionnaire",
    "Request Remediation from selection": "Demande de correction à partir de la sélection",
    "Request failed. Please ensure you have added only text in the input field.": "La demande a échoué. Veuillez vous assurer d'avoir saisi uniquement du texte dans le champ de saisie.",
    "Scan stopped successfully": "L'analyse s'est arrêtée avec succès",
    "Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan": "Planifiez des rapports pour vous-même [[adminText]] par e-mail après chaque analyse Acquia Web Governance",
    "Search for content that*": "Rechercher du contenu qui*",
    "Something went wrong. The Acquia Web Governance Team has been notified of this error and will get back to you, as soon as possible.": "Une erreur s'est produite. L'équipe de gouvernance Web d'Acquia a été informée de cette erreur et vous répondra dans les plus brefs délais.",
    "Start Cookie Scan": "Démarrer l'analyse des cookies",
    "Start Scan": "Démarrer l'analyse",
    "Start a new scan to find cookies or add them manually": "Démarrer une nouvelle analyse pour trouver les cookies ou les ajouter manuellement",
    "Stop scan": "Arrêter l'analyse",
    "Switch to Acquia Web Governance classic": "Passer à Acquia Web Governance classique",
    "Test your website's compliance levels ([[level]]) and fix issues that are making it difficult for people with disabilities to use your website": "Testez les niveaux de conformité de votre site Web ([[level]]) et corrigez les problèmes qui rendent difficile l'utilisation de votre site Web par les personnes handicapées.",
    "The Acquia Web Governance team is notified and are working on the issue.": "L'équipe Acquia Web Governance est informée et travaille sur le problème.",
    "The Compound Export contains data from the first and last scans within the selected date range. The export does not include data from the following sources:": "L'exportation composée contient les données des première et dernière analyses effectuées dans la période sélectionnée. Elle n'inclut pas les données des sources suivantes :",
    "The profile has been archived.": "Le profil a été archivé.",
    "The profile has been restored.": "Le profil a été restauré.",
    "There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.": "Il n'y a qu'une seule façon de procéder : Acquia Web Governance remplacera toutes les balises &lt;I&gt; présentes sur votre site web par des balises em.",
    "Type in or paste text to be analyzed": "Saisissez ou collez le texte à analyser",
    "URL &amp; Title": "URL et titre",
    "Unignore Misspelling": "Ne plus ignorer les fautes d'orthographe",
    "Url &amp; Title": "URL et titre",
    "Visitors screen resolutions export": "Exportation des résolutions d'écran des visiteurs",
    "Weight in score: [[weight]]": "Poids dans le score : [[weight]]",
    "Why can't I open a new window without warning?": "Pourquoi ne puis-je pas ouvrir une nouvelle fenêtre sans avertissement ?",
    "Why do I need a \\\"skip to content\\\" link?": "Pourquoi ai-je besoin d'un lien « passer au contenu » ?",
    "Why shouldn't I use the marquee element?": "Pourquoi ne devrais-je pas utiliser l'élément chapiteau ?",
    "You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here": "Vous utilisez la nouvelle version d'Acquia Web Governance PageAssist. Pour revenir à la version 1.0, cliquez ici.",
    "You can only calculate a score for up to [[count]] characters.": "Vous ne pouvez calculer un score que pour un maximum de [[count]] caractères.",
    "You do not have sufficient permissions to use this feature.": "Vous ne disposez pas des autorisations suffisantes pour utiliser cette fonctionnalité.",
    "Your current plan does not include on-demand scans. Please reach out to your Acquia Web Governance representative to learn more about this option": "Votre forfait actuel n'inclut pas les analyses à la demande. Veuillez contacter votre représentant Acquia Web Governance pour en savoir plus sur cette option.",
    "[[$count]] found": "[[$count]] trouvé",
    "[[count]] found": "[[count]] trouvé",
    "[[headerCount]] found": "[[headerCount]] trouvé",
    "[[pageIssues]] Pages <span>([[errorPercentage]]%)</span> to fix": "[[pageIssues]] Pages <span>([[errorPercentage]]%)</span> à corriger",
    "[[pageIssues]] Pages to fix": "[[pageIssues]] Pages à corriger",
    "[[pagesDone]] Pages ([[compliancePercentage]]) in compliance": "[[pagesDone]] Pages ([[compliancePercentage]]) en conformité",
    "[[totalPageIssues]] Pages ([[compliancePercentage]]) to fix": "[[totalPageIssues]] Pages ([[compliancePercentage]]) à corriger",
    "failed when trying to ignore/review all. please try agin, or contact the Acquia Web Governance team": "Échec lors de la tentative d'ignorer/réviser tout. Veuillez réessayer ou contacter l'équipe Acquia Web Governance.",
    "policies": "politiques",
    "policy": "politique",
    "Start export PDF Accessibility Report": "Démarrer l'exportation du rapport sur la clarté des pages",
    "No data showing? Add the Acquia Web Governance script to your website": "Aucune statistique affichée ? Ajoutez le script Acquia Web Governance au site web."
  },
  "es": {
    "Search": {
      "Spotlight": "Buscar",
      "$$noContext": "Buscar"
    },
    "Global Policy Overview": {
      "Topmenu": "Sumario de la Política Global",
      "$$noContext": "Sumario de la política global"
    },
    "History Center": {
      "Topmenu": "Centro de Historial",
      "$$noContext": "Centro de Historia"
    },
    "Report Center": {
      "Topmenu": "Centro de Reportes",
      "$$noContext": "Centro de informes"
    },
    "Users": {
      "Topmenu": "Usuarios",
      "$$noContext": "Usuarios"
    },
    "No content was found": {
      "page-details -> Inventory -> links. No result message": "No se encontró ningún contenido",
      "$$noContext": "No se encontró ningún contenido"
    },
    "&nbsp;&nbsp;&nbsp;Passwords does not match": "Las contraseñas no coinciden",
    "(HTML and documents)": "(HTML y documentos)",
    "(No title found)": "(No se encontró ningún título)",
    "(The HTML snippet is now Marked as Reviewed/Ignored)": "(El fragmento HTML ahora está marcado como revisado/ignorado)",
    "(This policy is marked as unwanted content)": "(Esta política está marcada como contenido no deseado)",
    "+ Add new check": "+ Agregar nuevo control",
    "+ Add new user": "+ Agregar nuevo usuario",
    "1 min.": "1 min.",
    "1 minute": "1 minuto",
    "10 min.": "10 min.",
    "10th to 12th grade": "10º a 12º grado",
    "120 min.": "120 min.",
    "15 min.": "15 min.",
    "1st": "1º",
    "2nd": "2º",
    "30 min.": "30 min.",
    "3rd": "3º",
    "5 min.": "5 min.",
    "5 minutes": "5 minutos",
    "5th grade": "5to grado",
    "60 min.": "60 min.",
    "6th grade": "6to grado",
    "7th grade": "7mo grado",
    "8th to 9th grade": "8º a 9º grado",
    "A": "A",
    "A list of all external PDF files already reviewed for accessibility issues": "Una lista de todos los archivos PDF externos ya revisados ​​para detectar problemas de accesibilidad",
    "A list of all external PDF files that you need to check for accessibility issues": "Una lista de todos los archivos PDF externos que necesita verificar para detectar problemas de accesibilidad",
    "A list of all internal PDF files already reviewed for accessibility issues": "Una lista de todos los archivos PDF internos ya revisados ​​para detectar problemas de accesibilidad",
    "A list of all internal PDF files that have been marked as failed for accessibility issues": "Una lista de todos los archivos PDF internos que se han marcado como fallidos debido a problemas de accesibilidad",
    "A list of all internal PDF files that have been marked as queued for accessibility issues": "Una lista de todos los archivos PDF internos que se han marcado como en cola por problemas de accesibilidad",
    "A list of all internal PDF files that you need to check for accessibility issues": "Una lista de todos los archivos PDF internos que necesita verificar para detectar problemas de accesibilidad",
    "AA": "AA",
    "AAA": "AAA",
    "ACCESSIBILITY OVERVIEW": "SUMARIO DE ACCESIBILIDAD",
    "API Token": "API Token",
    "API URL": "API URL",
    "API User": "API User",
    "API User Details": "Detalles del usuario de la API",
    "API Users": "Usuarios API",
    "About": "Acerca de",
    "Accept": "Aceptar",
    "Accessibility": "Accesibilidad",
    "Accessibility Check": "Control de Accesibilidad",
    "Accessibility Diagnostics": "Diagnóstico de Accesibilidad",
    "Accessibility Fast Track": "Fast Track de Accesibilidad",
    "Accessibility Icon": "Icono de Accesibilidad",
    "Accessibility Snippet": "Fragmento de Accesibilidad",
    "Accessibility Source Code": "Código fuente de Accesibilidad",
    "Accessibility checks compliance by level": "Conformidad de controles de accesibilidad por nivel",
    "Accessibility checks not in compliance with domain": "Controles de accesibilidad fallados en el dominio",
    "Accessibility error type": "Tipo de error de accesibilidad",
    "Accessibility errors": "Errores de accesibilidad",
    "Accessibility fixes": "Correcciones de accesibilidad",
    "Accessibility help center": "Centro de ayuda de accesibilidad",
    "Accessibility issues": "Problemas de accesibilidad",
    "Accessibility level": "Nivel de accesibilidad",
    "Accessibility mode": "Modo accesible",
    "Accessibility review type": "Tipo de revisión de accesibilidad",
    "Account dictionary": "Diccionario de cuentas",
    "Action": "Acción",
    "Actions": "Comportamiento",
    "Actions per visit": "Acciones por visita",
    "Active": "Activo",
    "Add": "Agregar",
    "Add Custom Multistep Javascript": "Agregar Javascript Multipaso personalizado",
    "Add Extension Name": "Agregar Nombre de Extensión",
    "Add Heatmap rule to a Page": "Agregar una regla de Mapa de Calor a una Página",
    "Add Heatmaps": "Agregar Mapas de Calor",
    "Add PageAssist script": "Agregar script de PageAssist",
    "Add PageCorrect": "Agregar PageCorrect",
    "Add Profile": "Agregar perfil",
    "Add Rule": "Agregar regla",
    "Add Skip to PageAssist": "Agregar Saltar a PageAssist",
    "Add a new exemption to your heartbeat check": "Agregar una nueva exención a tu control de Heartbeat",
    "Add a new page to start tracking individual pages' performance. Get an overview of load times and opportunities to speed up your site.": "Agrega una nueva página para empezar a monitorizar el rendimiento de cada página. Obtén una visión general de los tiempos de carga y las oportunidades para acelerar tu sitio.",
    "Add a non-user email": "Agregar un correo electrónico que no sea de usuario",
    "Add another rule": "Agregar otra regla",
    "Add email": "Agregar correo electrónico",
    "Add exemption": "Agregar excepción",
    "Add new check": "Agregar nuevo control",
    "Add new domain": "Agregar nuevo dominio",
    "Add new exemption": "Agregar nueva exención",
    "Add new label": "Agregar nueva etiqueta",
    "Add new page": "Agregar nueva página",
    "Add new policy": "Agregar nueva política",
    "Add new user": "Agregar nuevo usuario",
    "Add non users": "Agregar usuarios no registrados",
    "Add reason (Optional)": "Agregar motivo (opcional)",
    "Add rule to policy": "Agregar regla a la política",
    "Add rule to the policy": "Agregar regla a la política",
    "Add task": "Agregar tarea",
    "Add timeslots where you won't receive notifications on downtime and slow responsetimes.": "Agregue franjas horarias en las que no recibirá notificaciones sobre tiempos de inactividad y tiempos de respuesta lentos.",
    "Add to all languages": "Agregar a todos los idiomas",
    "Add to dictionary": "Agregar al diccionario",
    "Add to dictionary for all languages": "Agregar al diccionario para todos los idiomas",
    "Added": "Agregado",
    "Added by": "Agregado por",
    "Added date": "Fecha agregada/o",
    "Address": "Dirección",
    "Admin": "Administrador",
    "Advanced Domain Options": "Opciones Avanzadas de Dominio",
    "Affected image": "Imagen afectada",
    "Affected pages": "Páginas afectadas",
    "Affected pages by priority": "Páginas afectadas por prioridad",
    "Affected pages by severity": "Páginas afectadas por gravedad",
    "Affects": "Afecta",
    "After": "Después",
    "All": "Todo",
    "All Failed Internal PDF files": "Todos los archivos PDF Internos Fallidos",
    "All Pending External PDF files": "Todos los archivos PDF Externos Pendientes",
    "All Pending Internal PDF files": "Todos los archivos PDF Internos Pendientes",
    "All Queued Internal PDF files": "Todos los archivos PDF Internos en Cola",
    "All Reviewed External PDF files": "Todos los archivos PDF Externos Revisados",
    "All Reviewed Internal PDF files": "Todos los archivos PDF Internos Revisados",
    "All assets": "Todos los \"Assets\"",
    "All broken images": "Todas las imágenes rotas",
    "All broken links": "Todos los enlaces rotos",
    "All heartbeat checkpoints": "Todos los puntos de control del Heartbeat",
    "All incident checkpoints in the selected time span": "Todos los puntos de control de incidentes en el lapso de tiempo seleccionado",
    "All level A accessibility checks": "Todos los controles de accesibilidad de nivel A",
    "All level AA accessibility checks": "Todos los controles de accesibilidad de nivel AA",
    "All level AAA accessibility checks": "Todos los controles de accesibilidad de nivel AAA",
    "All levels": "Todos los niveles",
    "All modules": "Todos los módulos",
    "All modules - Content with Issues": "Todos los módulos - Contenido con Problemas",
    "All notifications": "Todas las notificaciones",
    "All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.": "Solo tienes que insertar el siguiente script en la etiqueta BODY de tu sitio web. Cópialo y pégalo tal cual.",
    "Analytics (Last 7 days)": "Análisis (últimos 7 días)",
    "And": "Y",
    "Appears on": "Aparece en",
    "Apply": "Aplicar",
    "Archive": "Archivo",
    "Archive files": "Archivos de archivo",
    "Archived": "Archivado",
    "Are you sure you want to Mark this link as unignored?": "¿Estás seguro que deseas Marcar este enlace como no ignorado?",
    "Are you sure you want to Request All PDF Accessibility checks?": "¿Está seguro de que desea Solicitar Todos los Controles de Accesibilidad de PDF?",
    "Are you sure you want to add to Request PDF Accessibility check from selection?": "¿Está seguro de que desea agregar a la Solicitud de control de Accesibilidad de PDF de la selección?",
    "Are you sure you want to add to all the dictionaries?": "¿Está seguro que deseas agregar a todos los diccionarios?",
    "Are you sure you want to add to the dictionary?": "¿Está seguro que deseas agregarlo al diccionario?",
    "Are you sure you want to close this form without saving your changes?": "¿Está seguro de que desea cerrar este formulario sin guardar los cambios?",
    "Are you sure you want to confirm this misspelling?": "¿Está seguro que deseas confirmar este error de escritura?",
    "Are you sure you want to delete the API User [[apiUserId]]": "¿Está seguro de que desea eliminar el usuario API [[apiUserId]]?",
    "Are you sure you want to delete this exemption?": "¿Está seguro de que desea eliminar esta exención?",
    "Are you sure you want to delete this source exclude?": "¿Está seguro de que desea eliminar esta exclusión de código de fuente?",
    "Are you sure you want to ignore all errors for this check?": "¿Está seguro de que desea ignorar todos los errores para este control?",
    "Are you sure you want to ignore the selected issue on this page?": "¿Está seguro de que desea ignorar el problema seleccionado en esta página?",
    "Are you sure you want to ignore this check for this domain?": "¿Está seguro de que desea ignorar este control para este dominio?",
    "Are you sure you want to ignore this check for this page?": "¿Está seguro de que desea ignorar este control para esta página?",
    "Are you sure you want to ignore this issue?": "¿Estás seguro de que deseas ignorar este problema?",
    "Are you sure you want to ignore this misspelling?": "¿Estás seguro de que deseas ignorar este error de escritura?",
    "Are you sure you want to mark this issue as fixed?": "¿Está seguro de que desea marcar este problema como solucionado?",
    "Are you sure you want to mark this issue as not fixed?": "¿Está seguro de que desea marcar este problema como no solucionado?",
    "Are you sure you want to mark this link as fixed?": "¿Estás seguro de que deseas marcar este enlace como reparado?",
    "Are you sure you want to mark this link as ignored?": "¿Estás seguro de que deseas marcar este enlace como ignorado?",
    "Are you sure you want to mark this link as not fixed?": "¿Estás seguro de que deseas marcar este enlace como no arreglado?",
    "Are you sure you want to remove manually added user?": "¿Está seguro de que desea eliminar el usuario agregado manualmente?",
    "Are you sure you want to remove review for this issue?": "¿Está seguro de que desea eliminar la reseña de este problema?",
    "Are you sure you want to remove review on all errors for this check?": "¿Está seguro de que desea eliminar la revisión de todos los errores de este control?",
    "Are you sure you want to remove this group?": "¿Estás seguro que deseas eliminar este grupo?",
    "Are you sure you want to remove this host?": "¿Estás seguro que deseas eliminar este host?",
    "Are you sure you want to remove this rule?": "¿Estás seguro de que deseas eliminar esta regla?",
    "Are you sure you want to remove this?": "¿Estás seguro que deseas eliminar esto?",
    "Are you sure you want to review all errors for this check?": "¿Está seguro de que desea revisar todos los errores de este control?",
    "Are you sure you want to review this issue?": "¿Está seguro que desea revisar este problema?",
    "Are you sure you want to set this document as reviewed?": "¿Está seguro de que desea establecer este documento como revisado?",
    "Are you sure you want to start on-demand scan?": "¿Está seguro de que desea iniciar el escaneo a pedido?",
    "Are you sure you want to stop current crawl?": "¿Estás seguro de que deseas detener el rastreo actual?",
    "Are you sure you want to the request ADA clarification for [[name]]?": "¿Está seguro de que desea solicitar una aclaración sobre la ADA para [[name]]?",
    "Are you sure you want to undo review of this document?": "¿Está seguro de que desea deshacer la revisión de este documento?",
    "Are you sure you want to undo reviewing this document?": "¿Está seguro de que desea deshacer la revisión de este documento?",
    "Are you sure you want to unignore all errors for this check?": "¿Está seguro de que desea dejar de ignorar todos los errores de este control?",
    "Are you sure you want to unignore the selected issue on this page?": "¿Está seguro de que desea dejar de ignorar el problema seleccionado en esta página?",
    "Are you sure you want to unignore this check for this domain?": "¿Está seguro de que desea dejar de ignorar este control para este dominio?",
    "Are you sure you want to unignore this check for this page?": "¿Está seguro de que desea dejar de ignorar este control para esta página?",
    "Are you sure you want to unignore this issue?": "¿Estás seguro de que deseas dejar de ignorar este problema?",
    "Are you sure you want to unignore this link?": "¿Estás seguro que deseas dejar de ignorar este enlace?",
    "Are you sure you want to unignore this misspelling?": "¿Estás seguro que deseas dejar de ignorar este error de escritura?",
    "Are you sure you want to unpin this domain": "¿Estás seguro de que deseas desanclar este dominio?",
    "Are you sure you want unignore this link?": "¿Estás seguro que deseas dejar de ignorar este enlace?",
    "Assign Heatmap Rule": "Asignar Regla de Mapa de Calor",
    "Assign to the Performance Module": "Asignar al módulo de rendimiento",
    "Attribute": "Atributo",
    "Audit": "Auditoría",
    "Audit Log": "Registro de auditoría",
    "Autoselect": "Selección automática",
    "Average First Contentful Paint": "Primera pintura con contenido promedio",
    "Average First Meaningful Paint": "Primera pintura significativa promedio",
    "Average Performance Score": "Puntuación media de rendimiento",
    "Average Performance score": "Puntuación media de rendimiento",
    "Average Time to Interactive": "Tiempo promedio para la interacción",
    "Average response time": "Tiempo promedio de respuesta",
    "Average time": "Tiempo promedio",
    "Average uptime": "Tiempo de actividad promedio",
    "Average visit time": "Tiempo promedio de visita",
    "Avg. Performance Score": "Puntuación media de rendimiento",
    "Avg. Visit Time": "Tiempo promedio de visita",
    "Avg. response": "Respuesta promedio",
    "BETA": "BETA",
    "Back": "Atrás",
    "Back to Heartbeat Overview": "Volver al Sumario de Heartbeat",
    "Bar": "Bar",
    "Basic Auth": "Autorización básica",
    "Before": "Antes",
    "Below 5th grade": "Por debajo del quinto grado",
    "Below you can see a list of all pages that contains the title": "A continuación puede ver una lista de todas las páginas que contienen el título",
    "Book online training": "Reserva formación online",
    "Bounce Rates": "Tasas de rebote",
    "Bounce rate": "Tasa de rebote",
    "Bounce rates": "Tasas de rebote",
    "Brand name": "Nombre de marca",
    "Broken Image": "Imagen rota",
    "Broken Image Links per page": "Enlaces de imágenes rotas por página",
    "Broken Images": "Imágenes rotas",
    "Broken Links": "Enlaces rotos",
    "Broken Page Link": "Enlace de página roto",
    "Broken image affecting most content": "Imagen rota que afecta la mayor parte del contenido.",
    "Broken image affecting most pages": "Imagen rota que afecta a la mayoría de las páginas.",
    "Broken images": "Imágenes rotas",
    "Broken images with page count": "Imágenes rotas con recuento de páginas",
    "Broken link": "Enlace roto",
    "Broken link affecting most content": "Enlace roto que afecta a la mayoría del contenido",
    "Broken link affecting most pages": "Enlace roto que afecta a la mayoría de las páginas",
    "Broken links": "Enlaces rotos",
    "Broken links per page": "Enlaces rotos por página",
    "Broken links with page count": "Enlaces rotos con recuento de páginas",
    "Browser": "Navegador",
    "Browser Extension": "Extensión del navegador",
    "Browsers": "Navegadores",
    "Browsers Overview": "Sumario de Navegadores",
    "Bubble": "Burbuja",
    "Build it from scratch": "Construirlo desde cero",
    "By deleting this domain all domain groups related to this domain, will also be deleted": "Al eliminar este dominio, todos los grupos de dominios relacionados con este dominio también se eliminarán.",
    "By user": "Por el usuario",
    "CMS": "CMS",
    "CMS url": "URL del CMS",
    "CSS": "CSS",
    "CSS Target Selector": "Selector de destino CSS",
    "CSS id or class selector to search for": "ID de CSS o selector de clase para buscar",
    "CSS selector to find submit button": "Selector CSS para encontrar el botón de envío",
    "Cache TTL": "TTL de caché",
    "Cancel": "Cancelar",
    "Case sensitive": "Distingue mayúsculas y minúsculas",
    "Categories": "Categorías",
    "Category": "Categoría",
    "Change password": "Cambiar la contraseña",
    "Changed to": "Cambiado a",
    "Changes": "Cambios",
    "Changes added": "Cambios agregados",
    "Changes in selected time frame:": "Cambios en el período de tiempo seleccionado:",
    "Changes since Previous Crawl": "Cambios desde el rastreo anterior",
    "Changes since previous crawl": "Cambios desde el rastreo anterior",
    "Characters": "Personajes",
    "Chart": "Cuadro",
    "Chart is now showing: [[name]]": "El gráfico ahora muestra: [[name]]",
    "Check": "Controlar",
    "Check List Export": "Exportación de Lista de Controles",
    "Check all links in this section": "Consulta todos los enlaces de esta sección",
    "Check all misspellings in this section": "Revisa todos los errores de escritura en esta sección",
    "Check all modules": "Ver todos los módulos",
    "Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)": "Verifique y corrija problemas de contenido en su sitio web (es decir, errores de escritura, enlaces rotos, problemas de legibilidad y otros)",
    "Check frequency": "Frecuencia de chequeo",
    "Check frequency:": "Frecuencia de chequeo:",
    "Check is ignored": "El control se ignora",
    "Check is ignored for the entire domain": "El control se ignora para todo el dominio",
    "Check link": "Comprobar enlace",
    "Check misspelling": "Revisar errores de escritura",
    "Check name": "Comprobar nombre",
    "Check off as Reviewed": "Marcar como Revisado",
    "Check passed": "Control aprobado",
    "Check site status": "Comprobar el estado del sitio",
    "Checking": "Comprobando",
    "Checkpoint exemptions": "Exenciones de Puntos de Control",
    "Checkpoint has been updated.": "Se ha actualizado el Punto de Control.",
    "Checkpoint information": "Información del Punto de Control",
    "Checkpoint:": "Control:",
    "Checks": "Controles",
    "Checks passed": "Controles aprobados",
    "Checks whether your website is responding and measures the response time of the server": "Comprueba si su sitio web está respondiendo y mide el tiempo de respuesta del servidor",
    "Choose Operator": "Elija Operador",
    "Choose What to Scan": "Elija qué escanear",
    "Choose a response time": "Elija un tiempo de respuesta",
    "Choose a response time notification": "Elija una notificación de tiempo de respuesta",
    "Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned": "Elija una ley de datos existente como plantilla predeterminada para su análisis de seguridad. Edite los problemas a continuación para excluir ciertas etiquetas del análisis.",
    "Choose checks": "Elija controles",
    "Choose domains": "Elegir dominios",
    "Choose how to view the Heatmaps Dashboard": "Elija cómo ver el panel de Mapas de Calor",
    "Choose notification time": "Elija la hora de notificación",
    "Choose the minimum amount of words to scan for readability on a page": "Elija la cantidad mínima de palabras que se deben escanear para facilitar la lectura en una página",
    "Choose where the policy should apply": "Elija dónde debe aplicarse la política",
    "Chrome extension": "Extensión de Chrome",
    "City": "Ciudad",
    "Clear all labels": "Borrar todas las etiquetas",
    "Clear and close filters": "Borrar y cerrar filtros",
    "Click here to create your first policy": "Haga clic aquí para crear su primera póliza",
    "Click here to edit": "Haga clic aquí para editar",
    "Click to create your first policy": "Haga clic para crear su primera póliza",
    "Clone": "Clon",
    "Close": "Cerca",
    "Close filters": "Cerrar filtros",
    "Collapse": "Colapsar",
    "Collapse menu": "Contraer menú",
    "College": "Colega",
    "College graduate": "Graduado universitario",
    "Coming soon": "Muy pronto",
    "Comment": "Comentario",
    "Common policy violations": "Violaciones comunes de políticas",
    "Company Info": "Información de la empresa",
    "Compliance": "Conformidad",
    "Compliance {{compliancePercentage}}": "Conformidad {{compliancePercentage}}",
    "Compound Export": "Exportación de compuestos",
    "Compound Report": "Informe compuesto",
    "Confirm": "Confirmar",
    "Confirm as misspelling": "Confirmar como error de escritura",
    "Confirm misspelling": "Confirmar error de escritura",
    "Confirm this word as a misspelling": "Confirme que esta palabra es un error de escritura",
    "Confirmed": "Confirmado",
    "Confirmed misspellings": "Errores de escritura confirmados",
    "Congratulations no violations were found": "Felicitaciones, no se encontraron violaciones.",
    "Connection Profile": "Perfil de conexión",
    "Connections per minute": "Conexiones por minuto",
    "Constraint": "Restricción",
    "Constraint pattern": "Patrón de restricción",
    "Contact me about more Performance Pages": "Contáctame sobre más Páginas de Rendimiento",
    "Contact me about more performance profiles": "Contáctame para más perfiles de rendimiento.",
    "Containing": "Contiene",
    "Contains": "Contiene",
    "Contains confirmed misspellings, broken links & images": "Contiene errores de escritura confirmados, enlaces rotos e imágenes.",
    "Contains confirmed misspellings, broken links or images": "Contiene errores de escritura confirmados, enlaces o imágenes rotos.",
    "Contains high, medium & low opportunities for all pages": "Contiene oportunidades altas, medias y bajas para todas las páginas.",
    "Contains high, medium & low severity issues for all pages": "Contiene problemas de gravedad alta, media y baja para todas las páginas.",
    "Contains issues with high, medium and low priority for all pages": "Contiene problemas con prioridad alta, media y baja para todas las páginas.",
    "Content": "Contenido",
    "Content Links": "Enlaces de contenido",
    "Content Policies": "Políticas de contenido",
    "Content Policy Violations": "Violaciones de la política de contenido",
    "Content in compliance": "Contenido en conformidad",
    "Content must be robust enough that it can be interpreted reliably by a wide variety of user agents, including assistive technologies.": "El contenido debe ser lo suficientemente sólido para que pueda ser interpretado de manera confiable por una amplia variedad de agentes de usuario, incluidas las tecnologías de asistencia.",
    "Content policies": "Políticas de contenido",
    "Content with Broken Image": "Contenido con imagen rota",
    "Content with Broken Link": "Contenido con enlace roto",
    "Content with Broken Links": "Contenido con enlaces rotos",
    "Content with Data Issues": "Contenido con problemas de datos",
    "Content with Data Issues export": "Exportación de contenido con problemas de datos",
    "Content with Policy Matches": "Contenido con coincidencias de políticas",
    "Content with QA Errors": "Contenido con errores de control de calidad",
    "Content with broken links": "Contenido con enlaces rotos",
    "Content with issues": "Contenido con problemas",
    "Content with policy violations": "Contenido con violaciones de políticas",
    "Content with violations": "Contenido con infracciones",
    "Context": "Contexto",
    "Country": "País",
    "Crawl Automatically": "Rastrear automáticamente",
    "Crawl Options": "Opciones de rastreo",
    "Crawl done on": "Rastreo realizado en",
    "Crawl finalized on": "Rastreo finalizado el",
    "Crawl info": "Información de rastreo",
    "Crawl runtime:": "Tiempo de ejecución del rastreo:",
    "Crawl started:": "El rastreo comenzó:",
    "Crawl status": "Estado de rastreo",
    "Crawl status:": "Estado de rastreo:",
    "Crawled Documents ([[documentCount]])": "Documentos rastreados ([[documentCount]])",
    "Crawled at": "Se arrastró a",
    "Crawled pages": "Páginas rastreadas",
    "Crawling": "Arrastrándose",
    "Create a policy to make an email as unwanted content": "Crear una política para marcar un correo electrónico como contenido no deseado",
    "Create as policy": "Crear como política",
    "Create label": "Crear etiqueta",
    "Create new domain group": "Crear nuevo grupo de dominios",
    "Create new group": "Crear nuevo grupo",
    "Create user": "Crear usuario",
    "Create your own policy": "Crea tu propia política",
    "Created": "Creado",
    "Created At": "Creado en",
    "Created at": "Creado en",
    "Created date": "Fecha de creación",
    "Created:": "Creado:",
    "Current domain status": "Estado actual del dominio",
    "Current status": "Estado actual",
    "Custom": "Costumbre",
    "Custom Multistep": "Multipaso personalizado",
    "Custom Profile": "Perfil personalizado",
    "Custom fixes": "Correcciones personalizadas",
    "Custom rule": "Regla personalizada",
    "Customer": "Cliente",
    "Customer Report": "Informe del cliente",
    "DATA PRIVACY OVERVIEW": "SUMARIO DE PRIVACIDAD DE DATOS",
    "DISCLAIMER": "DESCARGO DE RESPONSABILIDAD",
    "Daily": "A diario",
    "Danish": "danés",
    "Dark": "Oscuro",
    "Dashboard": "Panel",
    "Data Issues": "Problemas de datos",
    "Data Privacy": "Privacidad de datos",
    "Data Privacy Diagnostics": "Diagnóstico de privacidad de datos",
    "Data Privacy Fast Track": "Fast Track de Privacidad de Datos",
    "Data Privacy Help Center": "Centro de ayuda sobre privacidad de datos",
    "Data Privacy Info Type Icon": "Icono de tipo de información de privacidad de datos",
    "Data Privacy Issues": "Problemas de privacidad de datos",
    "Data Privacy Summary Export": "Exportación del resumen de privacidad de datos",
    "Data Privacy issues found": "Se encontraron problemas de privacidad de datos",
    "Data Regulations": "Reglamento de datos",
    "Data Violations": "Violaciones de datos",
    "Data issues": "Problemas de datos",
    "Data issues export": "Exportación de problemas de datos",
    "Data privacy": "Privacidad de datos",
    "Data privacy violations": "Violaciones de la privacidad de datos",
    "Data protection and privacy policy statement": "Declaración de política de protección de datos y privacidad",
    "Date": "Fecha",
    "Day": "Día",
    "Days": "Días",
    "Dead": "Muerto",
    "Default": "Por defecto",
    "Default for CMS": "Predeterminado para CMS",
    "Default value*": "Valor predeterminado*",
    "Define meta headers to match": "Definir encabezados meta para que coincidan",
    "Define size of files to look for": "Definir el tamaño de los archivos a buscar",
    "Define size of images to look for": "Define el tamaño de las imágenes a buscar",
    "Delete": "Borrar",
    "Delete All": "Eliminar todo",
    "Delete user": "Eliminar usuario",
    "Describe the exclude": "Describe la exclusión",
    "Description": "Descripción",
    "Desktop": "De oficina",
    "Details": "Detalles",
    "Device": "Dispositivo",
    "Device Overview": "Sumario de Dispositivos",
    "Device not found": "Dispositivo no encontrado",
    "Device:": "Dispositivo:",
    "Devices": "Dispositivos",
    "Diagnostics": "Diagnóstico",
    "Dictionary": "Diccionario",
    "Difficulty": "Dificultad",
    "Direct visits": "Visitas directas",
    "Disabling": "Desactivación",
    "Display policy in other services": "Mostrar la política en otros servicios",
    "Display this policy as:": "Mostrar esta política como:",
    "Distribution of Data Privacy levels": "Distribución de los niveles de privacidad de datos",
    "Distribution of PageCorrects across all change types": "Distribución de PageCorrects en todos los tipos de cambios",
    "Distribution of SEO levels": "Distribución de los niveles de SEO",
    "Distribution of policies that match their corresponding setting": "Distribución de políticas que coinciden con su configuración correspondiente",
    "Distribution of policies that matches their corresponding setting": "Distribución de políticas que coincidan con su configuración correspondiente",
    "Do you want the policy to run every time your website is crawled?": "¿Quieres que la política se ejecute cada vez que se rastree tu sitio web?",
    "Do you want to find pages which match the query on one or multiple lines?": "¿Quieres encontrar páginas que coincidan con la consulta en una o varias líneas?",
    "Do you want to find pages which match the query or pages which does not match the query": "¿Quieres encontrar páginas que coincidan con la consulta o páginas que no coincidan con la consulta?",
    "Do you want to update the Script Settings, for this Domain?": "¿Quieres actualizar la configuración del script para este dominio?",
    "Document": "Documento",
    "Document Class": "Clase de documento",
    "Document Dashboard": "Panel de documentos",
    "Document Details": "Detalles del documento",
    "Document Extension": "Extensión del documento",
    "Document Ignore Class": "Clase de documento ignorado",
    "Document first detected": "Documento detectado por primera vez",
    "Document scan": "Escaneo de documentos",
    "Documents": "Documentos",
    "Documents Crawled": "Documentos rastreados",
    "Documents basic": "Documentos básicos",
    "Documents crawled": "Documentos rastreados",
    "Documents extended": "Documentos ampliados",
    "Documents with Broken Image": "Documentos con imagen rota",
    "Documents with Broken Link": "Documentos con enlaces rotos",
    "Domain": "Dominio",
    "Domain Compliance": "Conformidad del dominio",
    "Domain Data Privacy Settings": "Configuración de privacidad de datos de dominio",
    "Domain Detail": "Detalle del dominio",
    "Domain Details": "Detalles del dominio",
    "Domain Groups": "Grupos de dominios",
    "Domain Picker Closed": "Selector de dominio cerrado",
    "Domain Picker Opened": "Selector de dominio abierto",
    "Domain compliance": "Conformidad del dominio",
    "Domain group": "Grupo de dominios",
    "Domain title and URL": "Título del dominio y URL",
    "Domain:": "Dominio:",
    "Domains": "Dominios",
    "Domains/groups selected": "Dominios/grupos seleccionados",
    "Done": "Hecho",
    "Download": "Descargar",
    "Download the Chrome extension": "Descargar la extensión de Chrome",
    "Download the Edge add-on": "Descargar el complemento Edge",
    "Download the Firefox add-on": "Descargar el complemento de Firefox",
    "Downloads": "Descargas",
    "Downtime": "Falta del tiempo",
    "Downtime (Minutes)": "Tiempo de inactividad (minutos)",
    "Downtime notification": "Notificación de tiempo de inactividad",
    "Drag and drop the rule to add rules to the policy": "Arrastre y suelte la regla para agregar reglas a la política",
    "Dropdown": "Menú desplegable",
    "Duration": "Duración",
    "Easy": "Fácil",
    "Easy to read pages understood by most. Example: fiction literature for adults": "Páginas fáciles de leer y comprensibles para la mayoría. Ejemplo: literatura de ficción para adultos.",
    "Edge add-on": "Complemento de borde",
    "Edit": "Editar",
    "Edit Labels": "Editar etiquetas",
    "Edit Performance Page": "Página de edición de rendimiento",
    "Edit customer information": "Editar la información del cliente",
    "Edit domain": "Editar dominio",
    "Edit domain group": "Editar grupo de dominio",
    "Edit exemption": "Exención de edición",
    "Edit label": "Editar etiqueta",
    "Edit labels": "Editar etiquetas",
    "Edit my profile": "Editar mi perfil",
    "Edit or Delete PageCorrect": "Editar o eliminar PageCorrect",
    "Edit uptime": "Editar el tiempo de actividad",
    "Edit user": "Editar usuario",
    "Edit users": "Editar usuarios",
    "Edit your exemption": "Editar su exención",
    "Edit:": "Editar:",
    "Effect on compliance": "Efecto sobre la conformidad general",
    "Effect on overall compliance level": "Efecto sobre el nivel general de conformidad",
    "Element": "Elemento",
    "Element Tree Path": "Ruta del árbol de elementos",
    "Email": "Correo electrónico",
    "Email Notifications": "Notificaciones por correo electrónico",
    "Email addresses": "Direcciones de correo electrónico",
    "Email receiver *": "Destinatario del correo electrónico *",
    "Email to login": "Correo electrónico para iniciar sesión",
    "Emails": "Correos electrónicos",
    "Empty": "Vacío",
    "Empty mailto": "Correo vacío",
    "Enable / Disable Accessibility mode": "Habilitar/Deshabilitar el modo de accesibilidad",
    "Enable Document Tracking": "Habilitar el seguimiento de documentos",
    "Enable Export Email Notification": "Habilitar la notificación de exportación por correo electrónico",
    "Enable Statistics": "Habilitar estadísticas",
    "Enabled features": "Funciones habilitadas",
    "Enabling": "Habilitación",
    "End at": "Fin en",
    "End date": "Fecha de finalización",
    "End time": "Fin del tiempo",
    "English": "Inglés",
    "Enter the full URL": "Introduzca la URL completa",
    "Entries": "Entradas",
    "Entry": "Entrada",
    "Entry Pages": "Páginas de entrada",
    "Entry and Exit Pages": "Páginas de entrada y salida",
    "Error": "Error",
    "Error Name": "Nombre del error",
    "Errors": "Errores",
    "Errors ([[audits]])": "Errores ([[auditorías]])",
    "Exact": "Exacto",
    "Example: academic publications": "Ejemplo: publicaciones académicas",
    "Example: children's literature": "Ejemplo: literatura infantil",
    "Example: daily newspapers": "Ejemplo: periódicos diarios",
    "Example: fiction books": "Ejemplo: libros de ficción",
    "Example: legal texts": "Ejemplo: textos legales",
    "Examples": "Ejemplos",
    "Excel Documents": "Documentos de Excel",
    "Exclude": "Excluir",
    "Exclude links that contains class name": "Excluir enlaces que contengan el nombre de la clase",
    "Exclude pattern": "Patrón de exclusión",
    "Excluded IP addresses from statistics": "Direcciones IP excluidas de las estadísticas",
    "Exemption": "Exención",
    "Exemption options": "Opciones de exención",
    "Exemption time": "Tiempo de exención",
    "Exemptions": "Exenciones",
    "Exit Pages": "Páginas de salida",
    "Exits": "Salidas",
    "Expand": "Expandir",
    "Explain the rationale behind the policy and which actions, editors should take to correct the violation": "Explique la lógica detrás de la política y qué acciones deben tomar los editores para corregir la infracción.",
    "Export": "Exportar",
    "Export CSV": "Exportar CSV",
    "Export Compound CSV": "Exportar CSV compuesto",
    "Export Logs": "Exportar registros",
    "Export list of broken images organized by page and document title": "Exportar lista de imágenes rotas organizadas por página y título del documento",
    "Export list of broken links organized by page and document title": "Exportar lista de enlaces rotos organizados por página y título del documento",
    "Export list of downtimes for the domain": "Exportar lista de tiempos de inactividad del dominio",
    "Export list of response times": "Exportar lista de tiempos de respuesta",
    "External": "Externo",
    "External Export": "Exportación externa",
    "External PDF Compliance": "Conformidad de PDF Externos",
    "External PDFs": "PDF externos",
    "External Referring Domains": "Dominios de referencia externos",
    "External Referring domains": "Dominios de referencia externos",
    "External referees overview": "Sumario de arbitrajes externos",
    "External referring domains": "Dominios de referencia externos",
    "FCP": "FCP",
    "FMP": "FMP",
    "Facebook": "Facebook",
    "Fail Example": "Ejemplo de fallo",
    "Failed": "Fallido",
    "Failing accessibility checks": "Controles de accesibilidad fallados",
    "Failing accessibility checks gives you information about the current Accessibility status of the website/group. It may vary from the history if there have been changes in ignored and review of accessibility issues": "Los controles de accesibilidad fallidos le brindan información sobre el estado actual de accesibilidad del sitio web/grupo. Puede variar con respecto al historial si se han producido cambios en los problemas de accesibilidad ignorados y revisados.",
    "Failing check": "Control fallido",
    "Failing check found": "Se encontró un control fallido",
    "Failing checks": "Controles fallidos",
    "Failing checks found": "Se encontraron controles fallidos",
    "Fast Track": "Fast Track",
    "Fast track html snippet": "Fast Track para fragmento de HTML",
    "Faster": "Más rápido",
    "Features": "Características",
    "Feedback submitted": "Comentarios enviados",
    "File size": "Tamaño del archivo",
    "Filter": "Filtrar",
    "Filter by": "Filtrar por",
    "Filter by:": "Filtrar por:",
    "Filter labels list": "Lista de etiquetas de filtro",
    "Find and address violations relating to your content guides and regulatory compliance and find outdated content across your website.": "Encuentre y aborde las violaciones relacionadas con sus guías de contenido y el cumplimiento normativo, y encuentre contenido desactualizado en todo su sitio web.",
    "Find word(s) without specific context": "Buscar palabra(s) sin contexto específico",
    "Firefox add-on": "Complemento de Firefox",
    "First Contentful Paint": "Primera pintura con contenido",
    "First Meaningful Paint": "Primera pintura significativa",
    "First name": "Nombre de pila",
    "Fixed": "Fijado",
    "Fixed or ignored violations": "Violaciones corregidas o ignoradas",
    "Flesch Kincaid": "Flesch Kincaid",
    "For this domain": "Para este dominio",
    "Form": "Forma",
    "Form fields": "Campos de formulario",
    "Forms": "Formularios",
    "Found": "Encontró",
    "Four times a day": "Cuatro veces al día",
    "Frames": "Marcos",
    "Friday": "Viernes",
    "From 2 seconds to 8 seconds": "De 2 segundos a 8 segundos",
    "Generating report": "Generando informe",
    "Get advice on how to handle this check": "Obtenga asesoramiento sobre cómo gestionar este control",
    "Getting {{ logs }} out of {{totalLogs}} logs": "Obtener {{ logs }} de {{totalLogs}} registros",
    "Global - All Domains": "Global - Todos los dominios",
    "Global Policies": "Políticas globales",
    "Global Policy Dashboard": "Panel de políticas globales",
    "Global Policy List": "Lista de políticas globales",
    "Go to Global Policy List": "Ir a la lista de políticas globales",
    "Go to My Exports": "Ir a Mis Exportaciones",
    "Go to PDFs": "Ir a los PDF",
    "Go to Policy List": "Ir a la lista de políticas",
    "Go to broken Links": "Ir a enlaces rotos",
    "Go to broken images": "Ir a imágenes rotas",
    "Go to broken links": "Ir a enlaces rotos",
    "Go to checkpoints": "Ir a los puntos de control",
    "Go to data issues": "Ir a problemas de datos",
    "Go to domain": "Ir al dominio",
    "Go to help center": "Ir al centro de ayuda",
    "Go to mispellings": "Ir a errores de escritura",
    "Go to misspellings": "Ir a errores de escritura",
    "Go to most visits pages": "Ir a las páginas más visitadas",
    "Go to page": "Ir a la página",
    "Go to page details": "Ir a los detalles de la página",
    "Go to potential misspellings": "Ir a posibles errores de escritura",
    "Go to predefined url": "Ir a la URL predefinida",
    "Go to the dashboard": "Ir al panel de control",
    "Go to traffic sources overview": "Ir a la descripción general de las fuentes de tráfico",
    "Go to uptime": "Ir al tiempo de actividad",
    "Go to visitor overview": "Ir a la descripción general de los visitantes",
    "Good job! No incidents was registered": "¡Buen trabajo! No se registró ningún incidente.",
    "Good job! No issues were found": "¡Buen trabajo! No se encontraron problemas.",
    "Good job! No violations were found": "¡Buen trabajo! No se encontraron infracciones.",
    "Google": "Google",
    "Greater than 8 seconds": "Más de 8 segundos",
    "Grid View": "Vista de Cuadrícula",
    "Groups": "Grupos",
    "Guidelines": "Pautas",
    "Guidelines for WCAG 2.0": "Directrices para WCAG 2.0",
    "Guidelines for WCAG 2.1": "Directrices para WCAG 2.1",
    "H1 on this page": "H1 en esta página",
    "HTML": "HTML",
    "HTML Pages": "Páginas HTML",
    "HTML pages": "Páginas HTML",
    "HTML snippet": "Fragmento de HTML",
    "HTML snippet affecting compliance level": "Fragmento de HTML que afecta el nivel de conformidad",
    "HTML snippet failing check": "Fragmento HTML que no pasa el control",
    "Hard": "Duro",
    "Hard to read text. Example: popular science magazines and easier academic publications": "Texto difícil de leer. Ejemplo: revistas de divulgación científica y publicaciones académicas más sencillas.",
    "Harmony CMS": "Sistema de gestión de contenidos Harmony",
    "Header type": "Tipo de encabezado",
    "Headers": "Encabezados",
    "Headlinks": "Enlaces principales",
    "Heartbeat": "Heartbeat",
    "Heartbeat Downtime": "Tiempo de inactividad de Heartbeat",
    "Heartbeat Response Time": "Tiempo de respuesta de Heartbeat",
    "Heartbeat status saved": "Estado de Heartbeat",
    "Heatmaps": {
      "$$noContext": "Mapas de Calor",
      "Topmenu": "Mapas de Calor"
    },
    "Help Center": "Centro de ayuda",
    "Help center": "Centro de ayuda",
    "High": "Alto",
    "High impact": "Alto impacto",
    "High impact opportunities": "Oportunidades de alto impacto",
    "High priority": "Alta prioridad",
    "High severity": "Alta gravedad",
    "High severity issues": "Problemas de alta gravedad",
    "Highest level of readability. Example: complex academic and legal texts": "Máximo nivel de legibilidad. Ejemplo: textos académicos y jurídicos complejos.",
    "History": "Historia",
    "Hit": "Golpear",
    "Hits": "Éxitos",
    "Hits across all domains and modules": "Impactos en todos los dominios y módulos",
    "Hits on domain": "Visitas al dominio",
    "Home": "Hogar",
    "Host": "Anfitrión",
    "Hosts": "Anfitriones",
    "Hosts cannot be empty": "Los hosts no pueden estar vacíos",
    "Hours": "Horas",
    "How often the page is checked": "Con qué frecuencia se revisa la página",
    "How to fix this problem": "Cómo solucionar este problema",
    "How to prevent": "Cómo prevenir",
    "How to setup this policy": "Cómo configurar esta política",
    "IFrames": "Marcos IFrames",
    "IP address": "Dirección IP",
    "Icon": "Icono",
    "Icon status": "Estado del icono",
    "Identifier": "Identificador",
    "Ignore": "Ignorar",
    "Ignore check": "Ignorar control",
    "Ignore misspelling": "Ignorar errores de escritura",
    "Ignore on the page": "Ignorar en la página",
    "Ignore on this page": "Ignorar en esta página",
    "Ignore this SEO issue": "Ignore este problema de SEO",
    "Ignore this check": "Ignorar este control",
    "Ignore this check for this domain": "Ignorar este control para este dominio",
    "Ignored": "Ignorado",
    "Ignored Misspellings": "Errores de escritura ignorados",
    "Ignored Policies": "Políticas ignoradas",
    "Ignored checks": "Controles ignorados",
    "Ignored issue": "Problema ignorado",
    "Ignored policies": "Políticas ignoradas",
    "Ignoring broken link": "Ignorar el enlace roto",
    "Image": "Imagen",
    "Image Links": "Enlaces de imágenes",
    "Image sources that will be fixed": "Fuentes de imágenes que se arreglarán",
    "Images": "Imágenes",
    "Import rules": "Reglas de importación",
    "Import rules from CSV": "Importar reglas desde CSV",
    "Important Highlights": "Aspectos destacados importantes",
    "Important Notifications": "Notificaciones importantes",
    "Important notification:": "Notificación importante:",
    "In compliance": "En conformidad",
    "In progress of ignoring/reviewing all": "En proceso de ignorar/revisar todo",
    "Inactive": "Inactivo",
    "Incidents": "Incidentes",
    "Includes both documents and pages": "Incluye tanto documentos como páginas.",
    "Incoming Links": "Enlaces entrantes",
    "Incoming links": "Enlaces entrantes",
    "Indicates the difficulty to fix an audit error": "Indica la dificultad para corregir un error de auditoría.",
    "Indicates when some parts of the domain are not scanned due to Constraints / Exclusions being applied": "Indica cuando algunas partes del dominio no se escanean debido a que se aplican restricciones o exclusiones.",
    "Individual issues": "Cuestiones individuales",
    "Information": "Información",
    "Information about this Check is not yet available": "La información sobre este control aún no está disponible",
    "Information and the operation of user interface must be understandable.": "La información y el funcionamiento de la interfaz de usuario deben ser comprensibles.",
    "Information and user interface components must be presentable to users in ways they can perceive.": "Los componentes de información y de interfaz de usuario deben ser presentables a los usuarios de manera que puedan percibirlos.",
    "Inline Images": "Imágenes en línea",
    "Inline images": "Imágenes en línea",
    "Input selector*": "Selector de entrada*",
    "Input user data": "Introducir datos del usuario",
    "Internal": "Interno",
    "Internal Export": "Exportación interna",
    "Internal PDF Compliance": "Conformidad de PDF Internos",
    "Internal PDFs": "PDF internos",
    "Internal URLs": "URL internas",
    "Inventory": "Inventario",
    "Inventory Documents Export": "Exportación de documentos de inventario",
    "Inventory History": "Historial de inventario",
    "Invite to new project": "Invitar a nuevo proyecto",
    "Is not a valid url": "No es una URL válida",
    "Is not crawling automatically": "No se rastrea automáticamente",
    "Is not tagged": "No está etiquetado",
    "Issue": "Asunto",
    "Issue changes": "Cambios en los problemas",
    "Issue changes since previous crawl": "Cambios en el problema desde el rastreo anterior",
    "Issue name": "Nombre del problema",
    "Issue type": "Tipo de problema",
    "Issues": "Asuntos",
    "Issues by Severities": "Problemas por gravedad",
    "Issues changes since previous crawl": "Los problemas cambian desde el rastreo anterior",
    "JS": "JS",
    "JavaScript": "JavaScript",
    "Javascript": "Javascript",
    "Javascript crawl": "Rastreo de Javascript",
    "KB": "KB",
    "Keyword": "Palabra clave",
    "Knowledge Base": {
      "$$noContext": "Base de conocimientos",
      "Topmenu": "Base de conocimientos"
    },
    "LIX": "LIX",
    "Label": "Etiqueta",
    "Label created": "Etiqueta creada",
    "Label name": "Nombre de la etiqueta",
    "Label overlay": "Superposición de etiquetas",
    "Label preview": "Vista previa de la etiqueta",
    "Label updated": "Etiqueta actualizada",
    "Labels": "Etiquetas",
    "Language": "Idioma",
    "Language Detected": "Idioma detectado",
    "Languages": "Idiomas",
    "Languages found": "Idiomas encontrados",
    "Last Scan": "Último escaneo",
    "Last check: [[lastCheckTime]]": "Última comprobación: [[lastCheckTime]]",
    "Last check: [[performanceScannedAt]]": "Última comprobación: [[performanceScannedAt]]",
    "Last downtime:": "Último tiempo de inactividad:",
    "Last load time": "Hora de la última carga",
    "Last name": "Apellido",
    "Last run": "Última ejecución",
    "Last run [[date]]": "Última ejecución [[date]]",
    "Last run:": "Última ejecución:",
    "Last scan": "Último escaneo",
    "Last scan never": "Último escaneo nunca",
    "Last scan: [[duration]] ago": "Último escaneo: hace [[duration]]",
    "Latest Updated PageCorrects": "Última actualización de PageCorrects",
    "Latest login": "Último inicio de sesión",
    "Least Popular Pages": "Páginas menos populares",
    "Less than 10": "Menos de 10",
    "Less than 100": "Menos de 100",
    "Less than 2 seconds": "Menos de 2 segundos",
    "Less than 50": "Menos de 50",
    "Level": "Nivel",
    "Level A": "Nivel A",
    "Level A Issues": "Problemas de nivel A",
    "Level A accessibility checks": "Controles de accesibilidad de nivel A",
    "Level A compliance": "Conformidad de nivel A",
    "Level A failing checks": "Controles de nivel A fallidos",
    "Level AA": "Nivel AA",
    "Level AA Issues": "Problemas de nivel AA",
    "Level AA accessibility checks": "Controles de accesibilidad de nivel AA",
    "Level AA compliance": "Conformidad de nivel AA",
    "Level AA failing checks": "Controles de accesibilidad de nivel AA fallidos",
    "Level AAA": "Nivel AAA",
    "Level AAA Issues": "Problemas de nivel AAA",
    "Level AAA accessibility checks": "Controles de accesibilidad de nivel AAA",
    "Level AAA compliance": "Conformidad de nivel AAA",
    "Level AAA failing checks": "Controles de accesibilidad de nivel AAA fallidos",
    "Level [[level]]": "Nivel [[level]]",
    "Levels": "Niveles",
    "Likelihood": "Probabilidad",
    "Likelihood unspecified": "Probabilidad no especificada",
    "Link": "Enlace",
    "Link Type": "Tipo de enlace",
    "Link excludes": "Enlace excluido",
    "Link fixes": "Correcciones de enlaces",
    "Link is broken": "El enlace está roto",
    "Link of page": "Enlace de la página",
    "Link to image": "Enlace a la imagen",
    "Linkedin": "Linkedin",
    "Links": "Campo de golf",
    "Links To Documents Export": "Enlaces a la exportación de documentos",
    "Links from other account domains": "Enlaces de otros dominios de cuenta",
    "Links from own domain": "Enlaces de dominio propio",
    "Links with policy matches": "Enlaces con coincidencias de políticas",
    "Links with the rel=\\\"nofollow\\\" attribute will not pass link equity/SEO value to the linked page. This can be used for pages with user generated comments where you want to avoid that a competitor posts a comment with a link to their own website thus benefiting from your original content. This is not an \\\"error\\\" per se but make sure that the link does not have this attribute as a result of an error.": "Los enlaces con el atributo rel=\\&quot;nofollow\\&quot; no transferirán valor de enlace/SEO a la página enlazada. Esto se puede usar para páginas con comentarios generados por el usuario donde se desea evitar que un competidor publique un comentario con un enlace a su propio sitio web, beneficiándose así de su contenido original. Esto no es un error en sí mismo, pero asegúrese de que el enlace no tenga este atributo como resultado de un error.",
    "List": "Lista",
    "List of accessibility issues": "Lista de problemas de accesibilidad",
    "List of all labels": "Lista de todas las etiquetas",
    "List of checks with and without issues": "Lista de controles con y sin problemas",
    "List of content containing links": "Lista de contenidos que contienen enlaces",
    "List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)": "Lista de dónde se encuentran todos sus activos en el sitio web (es decir, documentos, enlaces, direcciones de correo electrónico, fragmentos de código, etc.)",
    "List view": "Vista de lista",
    "Lists all profiles available for your account": "Enumera todos los perfiles disponibles para su cuenta",
    "Load Times Trend": "Tendencia de los tiempos de carga",
    "Loading domains, please wait": "Cargando dominios, por favor espere",
    "Loading new domain": "Cargando nuevo dominio",
    "Loading times": "Tiempos de carga",
    "Locale": "Lugar",
    "Location": "Ubicación",
    "Location not found": "Ubicación no encontrada",
    "Locations": "Ubicaciones",
    "Log out": "Finalizar la sesión",
    "Login Type": "Tipo de inicio de sesión",
    "Long": "Largo",
    "Lookup in Google": "Buscar en Google",
    "Low": "Bajo",
    "Low impact": "Bajo impacto",
    "Low impact opportunities": "Oportunidades de bajo impacto",
    "Low priority": "Baja prioridad",
    "Low severity": "Baja gravedad",
    "Low severity issues": "Problemas de baja gravedad",
    "MB": "MEGABYTE",
    "META content": "Contenido META",
    "META name/property": "Nombre/propiedad META",
    "Main-Thread Blocking Time": "Tiempo de bloqueo del hilo principal",
    "Mark 403 as broken link": "Marcar 403 como enlace roto",
    "Mark all as reviewed/ignored": "Marcar todo como revisado/ignorado",
    "Mark as fixed": "Marcar como arreglado",
    "Mark as ignored": "Marcar como ignorado",
    "Mark as not fixed": "Marcar como no arreglado",
    "Marked as fixed": "Marcado como arreglado",
    "Marked as reviewed": "Marcado como revisado",
    "Marking broken link as fixed": "Marcar el enlace roto como reparado",
    "Match": "Fósforo",
    "Match rule": "Regla de coincidencia",
    "Matches": "Partidos",
    "Max": "Máximo",
    "Max scanned pages": "Máximo de páginas escaneadas",
    "Measure from": "Medir desde",
    "Measure from:": "Medir desde:",
    "Measurement Settings": "Configuración de medición",
    "Measurements since [[date]]": "Mediciones desde [[date]]",
    "Medium": "Medio",
    "Medium complexity of text. Example: newspapers and magazines": "Complejidad de texto media. Ejemplo: periódicos y revistas.",
    "Medium impact": "Impacto medio",
    "Medium impact opportunities": "Oportunidades de impacto medio",
    "Medium priority": "Prioridad media",
    "Medium severity": "Gravedad media",
    "Medium severity issues": "Problemas de gravedad media",
    "Meta Header Expr": "Expr. de encabezado meta",
    "Meta Name": "Nombre meta",
    "Metadata": "Metadatos",
    "Metadata key": "Clave de metadatos",
    "Milliseconds": "Milisegundos",
    "Minimum words": "Mínimo de palabras",
    "Minutes": "Minutos",
    "Minutes of slow response before you get an email": "Minutos de respuesta lenta antes de recibir un correo electrónico",
    "Mispelling": "Error de escritura",
    "Misspelling": "Error de ortografía",
    "Misspelling affecting the most content": "Errores de escritura que afectan a la mayor parte del contenido",
    "Misspellings": "Errores de escritura",
    "Misspellings history": "Historial de errores de escritura",
    "Mobile": "Móvil",
    "Moderate": "Moderado",
    "Module": "Módulo",
    "Monday": "Lunes",
    "Monitoring": "Escucha",
    "Monthly": "Mensual",
    "Months": "Meses",
    "More info": "Más información",
    "More than": "Más que",
    "More than [[count]]": "Más de [[count]]",
    "Most Downloads": "Más descargas",
    "Most Frequent": "Más frecuentes",
    "Most Popular Pages": "Páginas más populares",
    "Most common SEO checkpoint needing review": "Los puntos de control SEO más comunes que necesitan revisión",
    "Most common language": "Idioma más común",
    "Most common misspellings": "Errores de escritura más comunes",
    "Most common opportunities found": "Oportunidades más comunes encontradas",
    "Most common policy violation on this domain": "Violación de política más común en este dominio",
    "Most common potential misspellings": "Los errores de escritura potenciales más comunes",
    "Most common readability level": "Nivel de legibilidad más común",
    "Most of your pages have the readability level": "La mayoría de sus páginas tienen el nivel de legibilidad",
    "Most pages have this readability level": "La mayoría de las páginas tienen este nivel de legibilidad.",
    "Most prominent issues ranked by severity level": "Problemas más destacados clasificados por nivel de gravedad",
    "Most serious issues found": "Problemas más graves encontrados",
    "Most visited pages": "Páginas más visitadas",
    "Move focus down on domain picker": "Mueva el foco hacia abajo en el selector de dominio",
    "Move focus up on domain picker": "Mover el foco hacia arriba en el selector de dominio",
    "Multiline": "Multilínea",
    "My Exports": "Mis exportaciones",
    "My profile": "Mi perfil",
    "N/A": "N / A",
    "NA": "N / A",
    "NB! Connection Settings cannot be edited after save": "¡ATENCIÓN! La configuración de conexión no se puede editar después de guardarla.",
    "NOTE: If you want to copy the Legacy Script. Click {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}here{{anchorEnd}}.": "NOTA: Si desea copiar el script heredado, haga clic en {{anchorStart}} role=\\&quot;button\\&quot; ng-click=\\&quot;vm.openLegacy()\\&quot; {{gt}}aquí{{anchorEnd}}.",
    "Name": {
      "$$noContext": "Nombre",
      "Exchange Center Sort by option": "Nombre"
    },
    "Network not found": "Red no encontrada",
    "Network speed": "Velocidad de la red",
    "Network speed:": "Velocidad de la red:",
    "Never": "Nunca",
    "Never scanned": "Nunca escaneado",
    "New": "Nuevo",
    "New Performance Page": "Nueva página de rendimiento",
    "New Policy": "Nueva política",
    "New password": "Nueva contraseña",
    "Next": "Próximo",
    "No Broken Links marked as Fixed": "No hay enlaces rotos marcados como reparados",
    "No CSS": "Sin CSS",
    "No Content links": "Sin enlaces de contenido",
    "No Data available for selected time frame": "No hay datos disponibles para el período de tiempo seleccionado",
    "No Documents found": "No se encontraron documentos",
    "No Domains or Groups are yet selected for this report": "Aún no se han seleccionado dominios ni grupos para este informe",
    "No Frames": "Sin marcos",
    "No Frequency": "Sin frecuencia",
    "No HTML Pages found": "No se encontraron páginas HTML",
    "No Historic data available for Accessibility Level [[lvl]]": "No hay datos históricos disponibles para el nivel de accesibilidad [[lvl]]",
    "No IFrames": "Sin IFrames",
    "No Ignored Broken Links": "No se ignoran los enlaces rotos",
    "No Image Links found": "No se encontraron enlaces de imágenes",
    "No PDF's failed": "No hay PDF fallidos",
    "No PDF's pending": "No hay PDF pendientes",
    "No PDF's queued": "No hay PDF en cola",
    "No PDF's reviewed": "No hay PDF revisados",
    "No PDFs are reviewed": "No se revisan archivos PDF",
    "No Policies detected": "No se detectaron políticas",
    "No Profiles were found": "No se encontraron perfiles",
    "No Spreadsheet links found": "No se encontraron enlaces de hojas de cálculo",
    "No Users are yet selected to receive this report": "Aún no hay usuarios seleccionados para recibir este informe",
    "No Word links found": "No se encontraron enlaces de Word",
    "No changes": "Sin cambios",
    "No changes found": "No se encontraron cambios",
    "No checks found for this Accessibility category": "No se encontraron comprobaciones para esta categoría de accesibilidad",
    "No content policies have been created yet": "Aún no se han creado políticas de contenido",
    "No corrections added to PageCorrect": "No se han agregado correcciones a PageCorrect",
    "No data available": "No hay datos disponibles",
    "No data present": "No hay datos presentes",
    "No diagnostics issues were found": "No se encontraron problemas de diagnóstico",
    "No domains were found": "No se encontraron dominios",
    "No downloads found": "No se encontraron descargas",
    "No errors found": "No se encontraron errores",
    "No exemptions added to this checkpoint": "No se agregaron exenciones a este punto de control",
    "No exports available": "No hay exportaciones disponibles",
    "No groups were found for this domain": "No se encontraron grupos para este dominio",
    "No historic data available for this domain": "No hay datos históricos disponibles para este dominio",
    "No hits found": "No se encontraron resultados",
    "No ignored checks in this accessibility category": "No hay comprobaciones ignoradas en esta categoría de accesibilidad",
    "No ignored misspellings found for this page": "No se encontraron errores de escritura ignorados para esta página",
    "No incidents occurred in the selected time frame": "No se produjeron incidentes en el período de tiempo seleccionado",
    "No issues found": "No se encontraron problemas",
    "No javascript": "Sin javascript",
    "No name defined": "No hay nombre definido",
    "No new notifications": "No hay nuevas notificaciones",
    "No note has been added": "No se ha agregado ninguna nota",
    "No notifications available": "No hay notificaciones disponibles",
    "No opportunities were found": "No se encontraron oportunidades",
    "No outages in this period": "No hay cortes en este período",
    "No pages found": "No se encontraron páginas",
    "No pages were found": "No se encontraron páginas",
    "No passed checks in this accessibility category": "No se han superado los controles en esta categoría de accesibilidad",
    "No performance scan found": "No se encontró ningún análisis de rendimiento",
    "No performance scans were found": "No se encontraron análisis de rendimiento",
    "No policies found": "No se encontraron políticas",
    "No readability score": "Sin puntuación de legibilidad",
    "No response received": "No se recibió respuesta",
    "No run present": "No hay ejecución presente",
    "No scan has yet been performed. Please check back later.": "Aún no se ha realizado ningún análisis. Vuelva a consultarlo más tarde.",
    "No slide links found": "No se encontraron enlaces de diapositivas",
    "No title found": "No se encontró ningún título",
    "No title found on one or more pages": "No se encontró ningún título en una o más páginas",
    "No title is found on this page": "No se encuentra ningún título en esta página",
    "No users available for this domain": "No hay usuarios disponibles para este dominio",
    "No violations were found": "No se encontraron violaciones",
    "No visitor profile selected": "No se ha seleccionado ningún perfil de visitante",
    "No visits for this category in selected time frame": "No hay visitas para esta categoría en el período de tiempo seleccionado",
    "No words have been added to the default dictionary": "No se han agregado palabras al diccionario predeterminado",
    "No. Visits": "Número de visitas",
    "Non-user list": "Lista de no usuarios",
    "None": "Ninguno",
    "Normal - recommended": "Normal - recomendado",
    "Normal violations": "Violaciones normales",
    "Not case sensitive": "No distingue entre mayúsculas y minúsculas",
    "Not containing": "No contiene",
    "Not scheduled": "No programado",
    "Not valid email": "Correo electrónico no válido",
    "Note": "Nota",
    "Notes": "Notas",
    "Notifications": "Notificaciones",
    "Number of characters in Meta Header text": "Número de caracteres en el texto del metaencabezado",
    "Number of characters in header text": "Número de caracteres en el texto del encabezado",
    "Number of characters in image text": "Número de caracteres en el texto de la imagen",
    "Number of characters in link text": "Número de caracteres en el texto del enlace",
    "Number of characters in page title": "Número de caracteres en el título de la página",
    "Number of pages": "Número de páginas",
    "Number too high": "Número demasiado alto",
    "Number too low": "Número demasiado bajo",
    "OK": "DE ACUERDO",
    "Office 365 (BETA)": "Office 365 (BETA)",
    "Ok": "De acuerdo",
    "Once a day": "Una vez al día",
    "Once a week": "Una vez a la semana",
    "One or more documents have already been scanned for compliance. Are you sure you want to scan the selected documents again?": "Ya se han escaneado uno o más documentos para comprobar su conformidad. ¿Está seguro de que desea volver a escanearlos?",
    "One or more page on your website has the same H1 text.": "Una o más páginas de su sitio web tienen el mismo texto H1.",
    "One or more pages has been marked as no index": "Una o más páginas han sido marcadas como sin índice",
    "One or more pages on your website has this title": "Una o más páginas de su sitio web tienen este título",
    "Open": "Abierto",
    "Open Accessibility Decision Tree": "Árbol de decisiones de accesibilidad abierta",
    "Open Data Privacy": "Privacidad de datos abiertos",
    "Open Data Privacy Settings": "Abrir configuración de privacidad de datos",
    "Open Document Details": "Abrir detalles del documento",
    "Open Document details": {
      "$$noContext": "Abrir detalles del documento",
      "Aria label when clicking on open Document details": "Abrir detalles del documento"
    },
    "Open Fast Track for this HTML snippet": "Abrir Fast Track para este fragmento HTML",
    "Open New Help Center": "Abrir nuevo Centro de ayuda",
    "Open Page Details": "Abrir detalles de la página",
    "Open Schedule downtime": "Horario de inactividad abierto",
    "Open document details": "Abrir detalles del documento",
    "Open domain policy": "Política de dominio abierto",
    "Open example": "Ejemplo abierto",
    "Open filters": "Filtros abiertos",
    "Open group": "Grupo abierto",
    "Open help center": "Abrir el centro de ayuda",
    "Open keyboard shortcuts": "Abrir atajos de teclado",
    "Open page details": {
      "$$noContext": "Abrir detalles de la página",
      "Aria label when clicking on open pagedetails": "Abrir detalles de la página"
    },
    "Open received reports": "Abrir informes recibidos",
    "Open report": "Informe abierto",
    "Operating System": "Sistema operativo",
    "Operating Systems": "Sistemas operativos",
    "Operating systems": "Sistemas operativos",
    "Operating systems Overview": "Descripción general de los sistemas operativos",
    "Operator*": "Operador*",
    "Opportunities": "Oportunidades",
    "Opportunities by Priority": "Oportunidades por Prioridad",
    "Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.": "Opcionalmente, puede seleccionar el idioma principal del dominio. Si elige Inglés (Reino Unido), cualquier texto que se detecte como inglés se considerará inglés británico.",
    "Options": "Opciones",
    "Or": "O",
    "Organizations": "Organizaciones",
    "Original Data": "Datos originales",
    "Other Documents": "Otros documentos",
    "Other files": "Otros archivos",
    "Others": "Otros",
    "Our suggestion": "Nuestra sugerencia",
    "Our team has been notified of your request. We will soon be in touch.": "Nuestro equipo ha sido notificado de su solicitud. Nos pondremos en contacto con usted en breve.",
    "Outages during the selected time-frame": "Interrupciones durante el período de tiempo seleccionado",
    "Outages end": "Fin de los cortes",
    "Outages start": "Comienzan los cortes",
    "Outgoing Links": "Enlaces salientes",
    "Outgoing links": "Enlaces salientes",
    "Over 1000 ms.": "Más de 1000 ms.",
    "Over 10000 ms.": "Más de 10000 ms.",
    "Over 200 ms.": "Más de 200 ms.",
    "Over 2000 ms.": "Más de 2000 ms.",
    "Over 3000 ms.": "Más de 3000 ms.",
    "Over 4000 ms.": "Más de 4000 ms.",
    "Over 500 ms.": "Más de 500 ms.",
    "Over 5000 ms.": "Más de 5000 ms.",
    "Over 6000 ms.": "Más de 6000 ms.",
    "Over 7000 ms.": "Más de 7000 ms.",
    "Over 8000 ms.": "Más de 8000 ms.",
    "Over 9000 ms.": "Más de 9000 ms.",
    "Overall Data Privacy compliance for this page": "Conformidad general de la privacidad de datos para esta página",
    "Overall PageCorrects": "PageCorrect Generales",
    "Overall SEO compliance for this page": "Conformidad general de SEO para esta página",
    "Overall accessibility compliance for this level": "Conformidad general de accesibilidad para este nivel",
    "Overall accessibility compliance level for this page": "Nivel general de conformidad de accesibilidad para esta página",
    "Overall compliance": "Conformidad general",
    "Overall policy compliance for this page": "Conformidad general de la política para esta página",
    "Owner": "Dueño",
    "PAGE PERFORMANCE OVERVIEW": "SUMARIO DEL RENDIMIENTO DE LA PÁGINA",
    "PDF": "PDF",
    "PDF Compliance Status": "Estado de conformidad de PDF",
    "PDF Documents": "Documentos PDF",
    "PDF accessibility scan completed at [[date]]": "Escaneo de accesibilidad de PDF completado el [[date]]",
    "PDF accessibility scan requested": "Se solicitó escaneo de accesibilidad de PDF",
    "PDF files": "Archivos PDF",
    "PDF files pending": "Archivos PDF pendientes",
    "PDF files reviewed": "Archivos PDF revisados",
    "PDF files that are reviewed or pending for accessibility": "Archivos PDF que están revisados ​​o pendientes de accesibilidad",
    "PDFs": "PDF",
    "POLICIES OVERVIEW": "SUMARIO DE POLÍTICAS",
    "Page": "Página",
    "Page Dashboard": "Panel de control de la página",
    "Page Details": "Detalles de la página",
    "Page Performance": "Rendimiento de la página",
    "Page Statistics": "Estadísticas de la página",
    "Page URL": "URL de la página",
    "Page Views": "Páginas vistas",
    "Page compliance": "Conformidad de la página",
    "Page count in PDF": "Recuento de páginas en PDF",
    "Page dashboard": "Panel de control de la página",
    "Page details": "Detalles de la página",
    "Page first detected": "Página detectada por primera vez",
    "Page links": "Enlaces de página",
    "PageAssist Logo Position": "Posición del logotipo de PageAssist",
    "PageAssist Theme": "Tema de PageAssist",
    "PageCorrect": "PageCorrect",
    "PageCorrect Content": "Contenido de PageCorrect",
    "PageCorrect Custom Phrase or Word": "Frase o palabra personalizada de PageCorrect",
    "PageCorrect Details": "Detalles de PageCorrect",
    "PageCorrect Diagnostics": "Diagnóstico de PageCorrect",
    "PageCorrects categorized": "PageCorrects categorizado",
    "PageFixes": "Correcciones de página",
    "PageFixes Left": "PageFixes Left",
    "Pages": "Páginas",
    "Pages & documents with confirmed misspellings, broken links or images": "Páginas y documentos con errores de escritura confirmados, enlaces rotos o imágenes",
    "Pages Crawled": "Páginas rastreadas",
    "Pages With Opportunities": "Páginas con oportunidades",
    "Pages and documents with policies marked as unwanted or required": "Páginas y documentos con políticas marcadas como no deseadas o requeridas",
    "Pages crawled": "Páginas rastreadas",
    "Pages failing check": "Páginas que no pasan el control",
    "Pages in compliance": "Páginas en conformidad",
    "Pages related to policy link": "Páginas relacionadas con el enlace de políticas",
    "Pages that are difficult to read": "Páginas difíciles de leer",
    "Pages that are easily understood by children below 5'th grade": "Páginas que son fácilmente entendidas por niños menores de 5º grado.",
    "Pages that are easy to read. Conversational English for consumers": "Páginas fáciles de leer. Inglés conversacional para consumidores.",
    "Pages that are fairly difficult to read": "Páginas que son bastante difíciles de leer.",
    "Pages that are fairly easy to read": "Páginas que son bastante fáciles de leer.",
    "Pages that are in plain English. Easily understood by 13- to 15-year-old students": "Páginas en inglés sencillo. Fácilmente comprensibles para estudiantes de 13 a 15 años.",
    "Pages that are very difficult to read. Best understood by university graduates": "Páginas muy difíciles de leer. Mejor entendidas por graduados universitarios.",
    "Pages that are very easy to read. Easily understood by an average 11-year-old student": "Páginas muy fáciles de leer. Fácilmente comprensibles para un estudiante promedio de 11 años.",
    "Pages we could not determine Readability score": "Páginas en las que no pudimos determinar la puntuación de legibilidad",
    "Pages with Data Privacy issues": "Páginas con problemas de privacidad de datos",
    "Pages with Failing Checks": "Páginas con Controles Fallidos",
    "Pages with Ignored Checks": "Páginas con Controles Ignorados",
    "Pages with Misspellings": "Páginas con Errores de Escritura",
    "Pages with Opportunities": "Páginas con oportunidades",
    "Pages with Policy Issues": "Páginas con temas de política",
    "Pages with QA Issues": "Páginas con problemas de control de calidad",
    "Pages with QA issues": "Páginas con problemas de control de calidad",
    "Pages with SEO Opportunities": "Páginas con oportunidades de SEO",
    "Pages with SEO opportunities": "Páginas con oportunidades de SEO",
    "Pages with accessibility checks not in compliance": "Páginas con controles de accesibilidad que no cumplen con los requisitos",
    "Pages with failing checks": "Páginas con controles fallidos",
    "Pages with high, medium or low opportunities": "Páginas con oportunidades altas, medias o bajas",
    "Pages with ignored checks": "Páginas con controles ignorados",
    "Pages with issues": "Páginas con problemas",
    "Pages with policy matches": "Páginas con coincidencias de políticas",
    "Pages with score:": "Páginas con puntuación:",
    "Pages with the \\\"noindex\\\" META tag will not be indexed by the search engines. This is not an \\\"error\\\" per se, but make sure that the page does not have this tag as a result of an error.": "Las páginas con la etiqueta META &quot;noindex&quot; no serán indexadas por los motores de búsqueda. Esto no es un error en sí, pero asegúrese de que la página no tenga esta etiqueta como resultado de un error.",
    "Pages without H1 tags or with empty H1 tags that contain no value represent a failed SEO optimization opportunity.": "Las páginas sin etiquetas H1 o con etiquetas H1 vacías que no contienen ningún valor representan una oportunidad de optimización SEO fallida.",
    "Pages without Visits": "Páginas sin visitas",
    "Pages without Visits in last 6 months": "Páginas sin visitas en los últimos 6 meses",
    "Pageviews": "Páginas vistas",
    "Part of downtime calculation": "Parte del cálculo del tiempo de inactividad",
    "Part of heatmap Rules": "Parte de las reglas del Mapa de Calor",
    "Part of success criteria [[checkIssueNumber]]": "Parte de los criterios de éxito [[checkIssueNumber]]",
    "Pass Example": "Ejemplo de pase",
    "Passed": "Aprobado",
    "Passed ([[audits]])": "Aprobado ([[audits]])",
    "Passed Checks": "Controles aprobados",
    "Passed Policy checks": "Controles de Política aprobados",
    "Passed checks": "Controles aprobados",
    "Passed policy checks": "Controles de política aprobados",
    "Password": "Contraseña",
    "Password Confirmation": "Confirmación de contraseña",
    "Password confirmation": "Confirmación de contraseña",
    "Password to login": "Contraseña para iniciar sesión",
    "Passwords does not match": "Las contraseñas no coinciden",
    "Path constraints": "Restricciones de ruta",
    "Path template": "Plantilla de ruta",
    "Pending": "Pendiente",
    "Pending PDF review": "Pendiente de revisión del PDF",
    "Pending PDF reviews": "Revisiones de PDF pendientes",
    "Percentage shows number of pages that are compliant with all Data Privacy checks": "El porcentaje muestra el número de páginas que cumplen con todos los controles de privacidad de datos",
    "Percentage shows number of pages that are compliant with all SEO checks": "El porcentaje muestra el número de páginas que cumplen con todos los controles de SEO",
    "Performance": "Actuación",
    "Performance Errors": "Errores de rendimiento",
    "Performance Pages": "Páginas de Rendimiento",
    "Performance Profiles": "Perfiles de rendimiento",
    "Performance Score": "Puntuación de rendimiento",
    "Performance score": "Puntuación de rendimiento",
    "Personal": "Personal",
    "Personal information": "Información personal",
    "Phone": "Teléfono",
    "Pie": "Pastel",
    "Pin domain": "Dominio PIN",
    "Ping intervals": "Intervalos de ping",
    "Play": "Jugar",
    "Play misspelling": "Reproducir errores de escritura",
    "Please choose a trademark": "Por favor seleccione una marca comercial",
    "Please insert correct URL:": "Por favor, inserte la URL correcta:",
    "Please insert the correct word:": "Por favor inserte la palabra correcta:",
    "Please insert the missing ALT text:": "Por favor inserte el texto ALT que falta:",
    "Please select a module": "Por favor seleccione un módulo",
    "Please select the module that you want to create a Source Code Exclude for": "Seleccione el módulo para el cual desea crear una exclusión de código fuente",
    "Please specify word or phrase to search for": "Por favor especifique la palabra o frase a buscar",
    "Please use CSS selectors to identify form fields and buttons": "Utilice selectores CSS para identificar campos y botones de formulario",
    "Please wait": "Espere por favor",
    "Please wait - Adding word to dictionary": "Por favor espere - Agregando palabra al diccionario",
    "Please wait - Adding words to dictionary": "Por favor espere - Agregando palabras al diccionario",
    "Please wait - Confirming misspelling": "Por favor espere - Confirmando error de escritura",
    "Please wait - exporting audit log &nbsp;": "Por favor espere - exportando registro de auditoría",
    "Policies": "Políticas",
    "Policies - required": "Políticas - requeridas",
    "Policies - violations": "Políticas - violaciones",
    "Policies marked as required or unwanted": "Políticas marcadas como obligatorias o no deseadas",
    "Policies violations": "Violaciones de políticas",
    "Policies with most matches": "Políticas con más coincidencias",
    "Policies with violations": "Políticas con infracciones",
    "Policy": "Política",
    "Policy Diagnostics": "Diagnóstico de políticas",
    "Policy Distribution": "Distribución de políticas",
    "Policy Hits": "Impactos políticos",
    "Policy Issues": "Cuestiones de política",
    "Policy List": "Lista de políticas",
    "Policy Pages": "Páginas de políticas",
    "Policy Running": "Política en ejecución",
    "Policy errors": "Errores de política",
    "Policy hits per domain": "Impactos de políticas por dominio",
    "Policy in queue": "Política en cola",
    "Policy info": "Información de la política",
    "Policy note": "Nota de política",
    "Policy rules": "Reglas de política",
    "Policy scan in progress": "Análisis de políticas en curso",
    "Policy setup": "Configuración de políticas",
    "Policy violations": "Violaciones de políticas",
    "Policy with matching terms": "Póliza con términos coincidentes",
    "Potential Misspelling": "Posible Error de Escritura",
    "Potential Misspellings": "Posibles Errores de Escritura",
    "Potential Savings": "Ahorros potenciales",
    "Potential misspelling": "Posible error de escritura",
    "Potential misspellings": "Posibles errores de escritura",
    "Potential misspellings found": "Posibles errores de escritura encontrados",
    "Powered by Google Lighthouse": "Desarrollado por Google Lighthouse",
    "Prefix path": "Ruta del prefijo",
    "Presence": "Presencia",
    "Previous": "Anterior",
    "Principle 1: Perceivable": "Principio 1: Perceptible",
    "Principle 2: Operable": "Principio 2: Operable",
    "Principle 3: Understandable": "Principio 3: Comprensible",
    "Principle 4: Robust": "Principio 4: Robusto",
    "Principle 5: Conformance": "Principio 5: Conformidad",
    "Print view": "Vista de impresión",
    "Priorities": "Prioridades",
    "Prioritized Content": "Contenido priorizado",
    "Priority": "Prioridad",
    "Profile": "Perfil",
    "Profile Description": "Descripción del perfil",
    "Profile Dropdown": "Menú desplegable de perfil",
    "Profile Menu": "Menú de perfil",
    "Profile Name": "Nombre del perfil",
    "Profile details": "Detalles del perfil",
    "Profile updated": "Perfil actualizado",
    "QA": "Control de calidad",
    "QA Issues": "Problemas de control de calidad",
    "QA errors": "Errores de control de calidad",
    "QUALITY ASSURANCE": "CONTROL DE CALIDAD",
    "QUALITY ASSURANCE OVERVIEW": "SUMARIO DE CONTROL DE CALIDAD",
    "Quality Assurance": "Control de Calidad",
    "Quality Assurance Check": "Control de Control de Calidad",
    "Quality Assurance Diagnostics": "Diagnóstico de Control de Calidad",
    "Quality Assurance Export summary": "Resumen de exportado de Control de Calidad",
    "Quality Assurance errors": "Errores de Control de Calidad",
    "Quality assurance": "Control de calidad",
    "Queued": "En cola",
    "Quick Guide": "Guía rápida",
    "Quick help": "Ayuda rápida",
    "Quick info:": "Información rápida:",
    "Re-scanning of issues for this page has started and will be finished in a few minutes.": "El nuevo escaneo de los problemas de esta página ha comenzado y finalizará en unos minutos.",
    "Readability": "Legibilidad",
    "Readability Score": "Puntuación de legibilidad",
    "Readability by score": "Legibilidad por puntuación",
    "Readability levels": "Niveles de legibilidad",
    "Readability score": "Puntuación de legibilidad",
    "Readability scores across all web pages (based on": "Puntuaciones de legibilidad en todas las páginas web (según",
    "Readability test": "Prueba de legibilidad",
    "Receive report": "Recibir informe",
    "Received reports": "Informes recibidos",
    "Referring Information": "Información de referencia",
    "Referring visits": "Visitas de referencia",
    "Regex": "Expresión regular",
    "Regulation": "Regulación",
    "Remember me": "Acuérdate de mí",
    "Remove": "Eliminar",
    "Remove Custom Multistep Javascript": "Eliminar Javascript multipaso personalizado",
    "Remove Extension Name": "Eliminar el nombre de la extensión",
    "Remove Page": "Eliminar página",
    "Remove Profile": "Eliminar perfil",
    "Remove Rule": "Eliminar regla",
    "Remove checkpoint": "Eliminar punto de control",
    "Remove domain": "Eliminar dominio",
    "Remove domain group": "Eliminar grupo de dominio",
    "Remove from dictionary": "Eliminar del diccionario",
    "Remove group": "Eliminar grupo",
    "Remove rule": "Eliminar regla",
    "Remove this IP address?": "¿Eliminar esta dirección IP?",
    "Remove this pattern?": "¿Eliminar este patrón?",
    "Remove this word from dictionary": "Eliminar esta palabra del diccionario",
    "Render pages and execute JS while crawling": "Renderizar páginas y ejecutar JS mientras se rastrea",
    "Repeat": "Repetir",
    "Replace Rule": "Reemplazar regla",
    "Report": "Informe",
    "Report administration": "Administración de informes",
    "Report overview:": "Descripción general del informe:",
    "Request PDF scan for all documents": "Solicitar escaneo PDF para todos los documentos",
    "Requests": "Solicitudes",
    "Required": "Requerido",
    "Required content": "Contenido obligatorio",
    "Required count": "Recuento requerido",
    "Rescan": "Volver a escanear",
    "Rescanning": "Reescaneo",
    "Reset": "Reiniciar",
    "Reset Preferences": "Restablecer preferencias",
    "Resolution": "Resolución",
    "Resource Type": "Tipo de recurso",
    "Response Time": "Tiempo de respuesta",
    "Response code": "Código de respuesta",
    "Response time": "Tiempo de respuesta",
    "Response time (Milliseconds)": "Tiempo de respuesta (milisegundos)",
    "Response time notification": "Notificación de tiempo de respuesta",
    "Response time notification threshold": "Umbral de notificación del tiempo de respuesta",
    "Return to heartbeat overview": "Regresar a el sumario de Heartbeat",
    "Returning customer": "Cliente recurrente",
    "Reverting state": "Revirtiendo el estado",
    "Review": "Revisar",
    "Reviewed": "Revisado",
    "Reviewed/Ok": "Revisado/Aceptable",
    "Revoke token": "Revocar token",
    "Robot Info": "Información del robot",
    "Role": "Role",
    "Rule": "Regla",
    "Rule name": "Nombre de la regla",
    "Rule operator": "Operador de regla",
    "Rule to match": "Regla para hacer coincidir",
    "Rules": "Normas",
    "Run Policy": "Política de ejecución",
    "Run policy": "Ejecutar política",
    "Run policy again": "Ejecutar la política nuevamente",
    "Running": "Correr",
    "SEO": "SEO",
    "SEO (Search Engine Optimization)": "SEO (optimización de motores de búsqueda)",
    "SEO Checkpoints": "Puntos de control de SEO",
    "SEO Diagnostics": "Diagnóstico SEO",
    "SEO Issues": "Problemas de SEO",
    "SEO OVERVIEW": "SUMARIO DE SEO",
    "SEO Opportunities": "Oportunidades de SEO",
    "SEO errors": "Errores de SEO",
    "SEO impact": "Impacto SEO",
    "SEO opportunities": "Oportunidades de SEO",
    "SEO opportunities - high priority": "Oportunidades de SEO: alta prioridad",
    "SEO opportunities - low priority": "Oportunidades de SEO: prioridad baja",
    "SEO opportunities - medium priority": "Oportunidades de SEO: prioridad media",
    "SEO opportunities - technical SEO issues": "Oportunidades de SEO: problemas técnicos de SEO",
    "SEO opportunities found": "Oportunidades de SEO encontradas",
    "SHOW LIST VIEW": "MOSTRAR VISTA DE LISTA",
    "STATISTICS OVERVIEW": "SUMARIO DE ESTADÍSTICAS",
    "Saturday": "Sábado",
    "Save": "Ahorrar",
    "Save Preferences": "Guardar preferencias",
    "Save and close": "Guardar y cerrar",
    "Save policy": "Política de ahorro",
    "Scan": "Escanear",
    "Scan documents": "Escanear documentos",
    "Scan frequency": "Frecuencia de escaneo",
    "Scan frequency:": "Frecuencia de escaneo:",
    "Scan in progress": "Escaneo en progreso",
    "Scan in progress:": "Escaneo en progreso:",
    "Scan is done": "El escaneo está hecho",
    "Scan subdomains": "Escanear subdominios",
    "Scanned at": "Escaneado en",
    "Scanned content": "Contenido escaneado",
    "Scanned links:": "Enlaces escaneados:",
    "Scanned pages": "Páginas escaneadas",
    "Scanned pages:": "Páginas escaneadas:",
    "Scanning URL:": "URL de escaneo:",
    "Scanning in progress": "Escaneo en progreso",
    "Schedule Report": "Informe de programación",
    "Schedule supplemental reports to be delivered with each scan": "Programe informes complementarios que se entregarán con cada escaneo",
    "Scheduled": "Programado",
    "Scheduled Reports": "Informes programados",
    "Scopes": "Ámbitos",
    "Score": "Puntaje",
    "Screen Resolutions": "Resoluciones de pantalla",
    "Screen Resolutions Overview": "Sumario de Resoluciones de Pantalla",
    "Script Evaluation": "Evaluación del guión",
    "Script Parse": "Análisis de scripts",
    "Script installed": "Script instalado",
    "Script installed on Domain": "Script instalado en el dominio",
    "Script setup guide": "Guía de configuración de scripts",
    "Search Engine Optimization": "Optimización de motores de búsqueda",
    "Search Engine Optimization (SEO)": "Optimización de motores de búsqueda (SEO)",
    "Search Engines": "Motores de búsqueda",
    "Search engine": "Motor de búsqueda",
    "Search engines": "Motores de búsqueda",
    "Search for Pages": "Buscar páginas",
    "Search for file size that is": "Busque el tamaño del archivo que sea",
    "Search for image size that is": "Busque el tamaño de imagen que sea",
    "Search for links, that are associated with class names and contains below mentioned class names.": "Busque enlaces que estén asociados con nombres de clases y que contengan los nombres de clases mencionados a continuación.",
    "Search for page titles or URLs across all domains": "Busque títulos de páginas o URL en todos los dominios",
    "Search for pages": "Buscar páginas",
    "Search icon": "Icono de búsqueda",
    "Search in: Documents": "Buscar en: Documentos",
    "Search in: Everything": "Buscar en: Todo",
    "Search in: Links": "Buscar en: Enlaces",
    "Search in: Only HTML pages": "Buscar en: Sólo páginas HTML",
    "Search pages across all domains": "Buscar páginas en todos los dominios",
    "Search...": "Buscar...",
    "Searches": "Búsquedas",
    "Seconds": "Artículos de segunda clase",
    "See API Token": "Ver token API",
    "See Details": "Ver detalles",
    "See changes": "Ver cambios",
    "See details": "Ver detalles",
    "See pages": "Ver páginas",
    "Select Domain and Module to get the Insights": "Seleccione el dominio y el módulo para obtener la información",
    "Select Domain on domain picker": "Seleccionar dominio en el selector de dominios",
    "Select Page to scan": "Seleccionar página para escanear",
    "Select a domain and recipients": "Seleccione un dominio y destinatarios",
    "Select a domain or group": "Seleccione un dominio o grupo",
    "Select a profile": "Seleccione un perfil",
    "Select account": "Seleccionar cuenta",
    "Select all items": "Seleccionar todos los elementos",
    "Select domain": "Seleccionar dominio",
    "Select domains and groups": "Seleccionar dominios y grupos",
    "Select filters": "Seleccionar filtros",
    "Select import": "Seleccionar importación",
    "Select item": "Seleccionar artículo",
    "Select login type*": "Seleccione el tipo de inicio de sesión*",
    "Select timezone": "Seleccionar zona horaria",
    "Select users": "Seleccionar usuarios",
    "Select what type of content the policy should search in": "Seleccione en qué tipo de contenido debe buscar la política",
    "Select whether the rule should search for case sensitive text or not": "Seleccione si la regla debe buscar texto que distinga entre mayúsculas y minúsculas o no",
    "Select your export file": "Seleccione su archivo de exportación",
    "Send an email if the site is down": "Enviar un correo electrónico si el sitio no funciona",
    "Send an email if the site is slow to respond": "Envíe un correo electrónico si el sitio tarda en responder",
    "Send message": "Enviar mensaje",
    "Send report": "Enviar informe",
    "Send welcome mail on creation": "Enviar correo de bienvenida al crear",
    "Set a default value for selector": "Establecer un valor predeterminado para el selector",
    "Set as Default": "Establecer como predeterminado",
    "Set to fixed": "Establecer como fijo",
    "Settings": {
      "$$noContext": "Ajustes",
      "Topmenu": "Ajustes"
    },
    "Setup your domain": "Configura tu dominio",
    "Severity": "Gravedad",
    "Severity level": "Nivel de gravedad",
    "Short": "Corto",
    "Short Description": "Descripción breve",
    "Should we check the page's current status?": "¿Debemos comprobar el estado actual de la página?",
    "Show Details": "Mostrar detalles",
    "Show all": "Mostrar todo",
    "Show documents with this email": "Mostrar documentos con este correo electrónico",
    "Show history": "Mostrar historial",
    "Show label dropdown": "Mostrar el menú desplegable de etiquetas",
    "Show less": "Mostrar menos",
    "Show more": "Mostrar más",
    "Show on global policy list": "Mostrar en la lista de políticas globales",
    "Show pages": "Mostrar páginas",
    "Show pages with issues": "Mostrar páginas con problemas",
    "Show pages with this SEO issue": "Mostrar páginas con este problema de SEO",
    "Show pages with this email": "Mostrar páginas con este correo electrónico",
    "Show pages with this image": "Mostrar páginas con esta imagen",
    "Show pages with this link": "Mostrar páginas con este enlace",
    "Show pages with this misspelling": "Mostrar páginas con este error de escritura",
    "Show policy hits per domain": "Mostrar los impactos de la política por dominio",
    "Show policy info": "Mostrar información de la política",
    "Show the Domain Picker": "Mostrar el selector de dominio",
    "Show/Hide filter selector": "Mostrar/Ocultar selector de filtros",
    "Show/Hide the Domain Picker": "Mostrar/ocultar el selector de dominio",
    "Shows the remaining number of Performance Profiles that can be created for this account": "Muestra el número restante de perfiles de rendimiento que se pueden crear para esta cuenta",
    "Side Navigation": "Navegación lateral",
    "Single line": "Línea única",
    "Size": "Tamaño",
    "Skip to content": "Saltar al contenido",
    "Slide links": "Enlaces de diapositivas",
    "Slides": "Diapositivas",
    "Slow": "Lento",
    "Snippet": "Retazo",
    "Social": "Social",
    "Social Networks": "Redes sociales",
    "Social visits": "Visitas sociales",
    "Source Code Exclude": "Exclusión de código fuente",
    "Source Code Excludes": "Código fuente excluido",
    "Source code": "Código fuente",
    "Spellcheck": "Corrector de escritura",
    "Spellcheck Export Summary": "Resumen de Exportación del Corrector de escritura",
    "Spellcheck Summary": "Resumen del Corrector de escritura",
    "Spelling": "Ortografía",
    "Spelling Errors used": "Errores de escritura utilizados",
    "Spelling fixes": "Correcciones ortográficas",
    "Spelling ignore capitalized words": "La ortografía ignora las palabras en mayúscula",
    "Spreadsheet links": "Enlaces de hojas de cálculo",
    "Spreadsheets": "Hojas de cálculo",
    "Start PDF accessibility scan": "Iniciar escaneo de accesibilidad de PDF",
    "Start at": "Empezar en",
    "Start compound export": "Iniciar exportación de compuestos",
    "Start date": "Fecha de inicio",
    "Start export": "Iniciar exportación",
    "Start export Pages With Specific Link": "Iniciar exportación de páginas con un enlace específico",
    "Start new scan": "Iniciar nuevo escaneo",
    "Start on demand scan": "Iniciar escaneo a pedido",
    "Start time": "Hora de inicio",
    "Starts with": "Comienza con",
    "State": "Estado",
    "Statistic": "Estadística",
    "Statistics": "Estadística",
    "Statistics excluded IP addresses": "Las estadísticas excluyeron direcciones IP",
    "Status": "Estado",
    "Stop current crawl": "Detener el rastreo actual",
    "Sub Navigation": "Subnavegación",
    "Submit selector*": "Enviar selector*",
    "Succeeds": "Tiene éxito",
    "Success criteria": "Criterios de éxito",
    "Suggestions and ideas": "Sugerencias e ideas",
    "Summarized pages and documents count": "Recuento de páginas y documentos resumidos",
    "Summary": "Resumen",
    "Sunday": "Domingo",
    "Switch account": "Cambiar de cuenta",
    "Table View": "Vista de tabla",
    "Tags": "Etiquetas",
    "Target": "Objetivo",
    "Technical": "Técnico",
    "Technical SEO Issues": "Problemas técnicos de SEO",
    "Text": "Texto",
    "Text Documents": "Documentos de texto",
    "Text documents": "Documentos de texto",
    "Text to match": "Texto a combinar",
    "Text:": "Texto:",
    "The Checkpoint [[checkpoint]] will be updated with data after next crawl": "El punto de control [[checkpoint]] se actualizará con datos después del próximo rastreo",
    "The Document is not tagged": "El documento no está etiquetado",
    "The Path template for Umbraco CMS": "La plantilla Path para Umbraco CMS",
    "The Requested Page is not a part of the Performance Module": "La página solicitada no es parte del módulo de rendimiento",
    "The Scan will take effect within the next few hours": "El escaneo entrará en vigor en las próximas horas.",
    "The URL for this page is too long": "La URL de esta página es demasiado larga",
    "The base url to the CMS page": "La URL base de la página CMS",
    "The bounce rate tells you the number of visits who only see the one page they started on": "La tasa de rebote te indica la cantidad de visitas que solo ven la página en la que comenzaron.",
    "The following rules will be removed, are you sure you want to continue with this change?": "Se eliminarán las siguientes reglas, ¿está seguro de que desea continuar con este cambio?",
    "The header 1 (H1) tag is important as it helps search engines and users to understand what content they can expect to find on the page.": "La etiqueta de encabezado 1 (H1) es importante porque ayuda a los motores de búsqueda y a los usuarios a comprender qué contenido pueden esperar encontrar en la página.",
    "The likelihood of this being a Data Privacy issue": "La probabilidad de que se trate de un problema de privacidad de datos",
    "The lowest level of readability. Example: children's books": "El nivel más bajo de legibilidad. Ejemplo: libros infantiles.",
    "The meta description on this page is too long": "La meta descripción de esta página es demasiado larga.",
    "The meta description on this page is too short": "La meta descripción de esta página es demasiado corta.",
    "The misspelling will first show up after a new scan": "El error de escritura aparecerá por primera vez después de un nuevo escaneo.",
    "The name of a meta entry (page metadata)": "El nombre de una meta entrada (metadatos de la página)",
    "The optional base url to the CMS page": "La URL base opcional a la página CMS",
    "The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.": "La privacidad de sus datos personales es muy importante para nosotros. Por ello, hemos actualizado nuestra política de protección de datos y privacidad. Para seguir utilizando nuestra plataforma, le rogamos que lea y acepte los nuevos términos de la política de protección de datos y privacidad.",
    "The scan can take a few hours/days to finalise, depending on the size of the website": "El escaneo puede tardar algunas horas o días en finalizar, dependiendo del tamaño del sitio web.",
    "The scan can take a few hours/days to finalise, depending on the size of the website.<br><br>Are you sure you want to start on-demand scan?": "El escaneo puede tardar algunas horas o días en finalizar, dependiendo del tamaño del sitio web.<br><br> ¿Está seguro de que desea iniciar el escaneo a pedido?",
    "The scan can take a few minutes to finalise, depending on the size of the page": "El escaneo puede tardar unos minutos en finalizar, dependiendo del tamaño de la página.",
    "There are no META descriptions on one or more pages": "No hay descripciones META en una o más páginas",
    "There are no domains assigned to this policy. Save policy anyway?": "No hay dominios asignados a esta política. ¿Guardar la política de todos modos?",
    "There are no more errors for this Snippet": "No hay más errores para este fragmento.",
    "There are no sub headlines on one or more pages": "No hay subtítulos en una o más páginas",
    "There are zero META keywords on this page": "No hay ninguna palabra clave META en esta página",
    "There is no H1 on one or more pages": "No hay H1 en una o más páginas",
    "There is no H1 on this page": "No hay H1 en esta página",
    "There is no META descriptions on this page": "No hay descripciones META en esta página",
    "There is no historic data for domain groups": "No hay datos históricos para los grupos de dominios",
    "There is no historic data for this domain": "No hay datos históricos para este dominio",
    "There is no sub headlines on this page": "No hay subtítulos en esta página.",
    "These are findings that cannot be automatically checked and must be reviewed manually": "Se trata de hallazgos que no se pueden comprobar automáticamente y deben revisarse manualmente.",
    "These are findings which are likely to be errors, requiring manual confirmation": "Se trata de hallazgos que probablemente sean errores y requieran confirmación manual.",
    "These findings are confirmed errors": "Estos hallazgos son errores confirmados.",
    "Third-Party": "Tercero",
    "This field is required": "Este campo es obligatorio",
    "This is the time between when an outage is first detected and when a notification is sent.": "Este es el tiempo transcurrido entre cuando se detecta por primera vez una interrupción y cuando se envía una notificación.",
    "This is useful if you have defined timeslots for maintenance.": "Esto es útil si ha definido franjas horarias para el mantenimiento.",
    "This issue is ignored": "Este problema se ignora",
    "This link is marked as broken because it took more than 30 seconds to load": "Este enlace está marcado como roto porque tardó más de 30 segundos en cargarse.",
    "This page has been marked as no index": "Esta página ha sido marcada como sin índice",
    "This page has no meta description": "Esta página no tiene meta descripción",
    "This page has no meta keywords": "Esta página no tiene palabras clave meta",
    "This page has not been assigned to the Performance Module": "Esta página no ha sido asignada al Módulo de Rendimiento",
    "This page is missing a title": "A esta página le falta un título.",
    "This policy is scheduled": "Esta política está programada",
    "This rule doesn't contain any matches": "Esta regla no contiene ninguna coincidencia",
    "This section lists requirements for <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformance</a> to WCAG 2.1. It also gives information about how to make conformance claims, which are optional.": "Esta sección enumera los requisitos para <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>la conformidad</a> con las WCAG 2.1. También proporciona información sobre cómo realizar declaraciones de conformidad, las cuales son opcionales.",
    "Thursday": "Jueves",
    "Time": "Tiempo",
    "Time Spent": "Tiempo dedicado",
    "Time To Interactive": "Es hora de interactuar",
    "Time to Warning *": "Hora de alerta*",
    "Timeframe:": "Periodo de tiempo:",
    "Timeline": "Cronología",
    "Timezone": "Zona horaria",
    "Title": "Título",
    "Title & description": "Título y descripción",
    "Title and URL": "Título y URL",
    "Title and url": "Título y URL",
    "To setup this policy, you need to tell us how long your max word length is": "Para configurar esta política, debe indicarnos cuál es la longitud máxima de su palabra.",
    "To setup this policy, you need to tell us which brand name should end with TM or ™": "Para configurar esta política, debe indicarnos qué marca debe terminar con TM o ™",
    "To toggle Quick Search:": "Para alternar la búsqueda rápida:",
    "Toggle Dropdown": "Alternar menú desplegable",
    "Toggle dropdown": "Alternar menú desplegable",
    "Toggle notes": "Cambiar notas",
    "Toggle show filters": "Activar o desactivar los filtros de visualización",
    "Too few characters": "Muy pocos caracteres",
    "Too many characters": "Demasiados personajes",
    "Top keywords": "Palabras clave principales",
    "Total": "Total",
    "Total CPU Time": "Tiempo total de CPU",
    "Total QA issues": "Problemas totales de control de calidad",
    "Total Visitors": "Total de visitantes",
    "Total Visits": "Visitas totales",
    "Total amount of content": "Cantidad total de contenido",
    "Total crawled": "Total rastreado",
    "Total number of issues": "Número total de problemas",
    "Total number of issues across all modules": "Número total de problemas en todos los módulos",
    "Total page views over the last 30 days": "Total de páginas vistas en los últimos 30 días",
    "Total pages:": "Páginas totales:",
    "Total visitors": "Total de visitantes",
    "Total visitors from Referrers": "Visitantes totales de referentes",
    "Total visitors from Search Engines": "Visitantes totales de motores de búsqueda",
    "Total visits": "Total de visitas",
    "Total visits from Referrers": "Visitas totales de referentes",
    "Total visits from Search Engines": "Visitas totales desde motores de búsqueda",
    "Total visits in the last 30 days:": "Total de visitas en los últimos 30 días:",
    "Total words": "Total de palabras",
    "Track changes across domains and modules": "Seguimiento de cambios en dominios y módulos",
    "Traffic Sources": "Fuentes de tráfico",
    "Traffic Sources Summary": "Resumen de fuentes de tráfico",
    "Traffic sources": "Fuentes de tráfico",
    "Transfer Size": "Tamaño de transferencia",
    "Tuesday": "Martes",
    "Twice a day": "Dos veces al día",
    "Twitter": "Gorjeo",
    "Type": "Tipo",
    "Type the key for the metadata": "Escriba la clave para los metadatos",
    "Type the text to match rule": "Escriba el texto que debe coincidir con la regla",
    "Type*": "Tipo*",
    "URL": "URL",
    "URL must start with a protocol. Ex. http://....": "La URL debe comenzar con un protocolo. Ej. http://....",
    "URL to redirect to if form is valid": "URL a la que redirigir si el formulario es válido",
    "URL:": "URL:",
    "Unable to read link": "No se puede leer el enlace",
    "Unarchive": "Desarchivar",
    "Undetermined": "Indeterminado",
    "Undo": "Deshacer",
    "Undo review": "Deshacer revisión",
    "Unignore": "Dejar de ignorar",
    "Unignore check": "Marcar control como no ignorado",
    "Unignore misspelling": "Deshacer la omisión de errores de escritura",
    "Unignore on this page": "Dejar de ignorar en esta página",
    "Unignore this SEO issue": "No ignore este problema de SEO",
    "Unignore this check for this domain": "Desactivar este control para este dominio",
    "Unique Visitors": "Visitantes únicos",
    "Unique downloads": "Descargas únicas",
    "Unknown": "Desconocido",
    "Unknown Score": "Puntuación desconocida",
    "Unknown title": "Título desconocido",
    "Unpin domain": "Desanclar dominio",
    "Unsaved changes": "Cambios no guardados",
    "Unwanted": "No deseado",
    "Unwanted content": "Contenido no deseado",
    "Unwanted violations": "Violaciones no deseadas",
    "Update": "Actualizar",
    "Update groups": "Actualizar grupos",
    "Updated": "Actualizado",
    "Updated At": "Actualizado en",
    "Updated at": "Actualizado en",
    "Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.": "La actualización de grupos puede tardar más de 30 minutos. Durante el proceso, no podrá crear ni actualizar grupos.",
    "Upload CSV": "Subir CSV",
    "Upload csv file": "Subir archivo csv",
    "Uptime": "Tiempo de actividad",
    "Uptime last 30 days": "Tiempo de actividad últimos 30 días",
    "Url*": "URL*",
    "Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors": "Utilice * como comodín (p. ej., 192.168.1.*). Las direcciones IP excluidas solo afectarán a los nuevos visitantes.",
    "Use language attribute": "Usar atributo de idioma",
    "Use or Apply custom PageCorrect": "Utilice o aplique PageCorrect personalizado",
    "User": "Usuario",
    "User Export": "Exportación de usuarios",
    "User List": "Lista de usuarios",
    "User Loading Experience": "Experiencia de carga del usuario",
    "User information": "Información del usuario",
    "User interface components and navigation must be operable.": "Los componentes de la interfaz de usuario y la navegación deben ser operativos.",
    "User is account administrator": "El usuario es administrador de la cuenta",
    "Username": "Nombre de usuario",
    "Value": "Valor",
    "Value*": "Valor*",
    "Vat no": "N.º de IVA",
    "Verify URL*": "Verificar URL*",
    "Very easy": "Muy fácil",
    "Very hard": "Muy duro",
    "View options": "Ver opciones",
    "Viewing as Profile:": "Viendo como perfil:",
    "Views": "Vistas",
    "Violation": "Violación",
    "Violation count": "Recuento de infracciones",
    "Violation's info_type name not set": "El nombre del tipo de información de la infracción no está establecido",
    "Violations": "Violaciones",
    "Visible": "Visible",
    "Visible modules": "Módulos visibles",
    "Visit the affected image": "Visita la imagen afectada",
    "Visitor Overview": "Sumario de Visitantes",
    "Visitor Summary": "Resumen del visitante",
    "Visitor log": "Registro de visitantes",
    "Visitor profile": "Perfil del visitante",
    "Visitor profile:": "Perfil del visitante:",
    "Visitors": "Visitantes",
    "Visitors Summary": "Resumen de visitantes",
    "Visits": "Visitas",
    "Visual mode": "Modo visual",
    "WCAG 2.0 (Level A)": "WCAG 2.0 (Nivel A)",
    "WCAG 2.0 (Level AA)": "WCAG 2.0 (Nivel AA)",
    "WCAG 2.0 (Level AAA)": "WCAG 2.0 (Nivel AAA)",
    "WCAG 2.0 Accessibility Compliance": "Conformidad de Accesibilidad WCAG 2.0",
    "WCAG 2.1 (Level A)": "WCAG 2.1 (Nivel A)",
    "WCAG 2.1 (Level AA)": "WCAG 2.1 (Nivel AA)",
    "WCAG 2.1 (Level AAA)": "WCAG 2.1 (Nivel AAA)",
    "WCAG 2.1 Accessibility Compliance": "Conformidad de accesibilidad WCAG 2.1",
    "Want to search for": "Quiere buscar",
    "Warning": "Advertencia",
    "We recommend that all your pages has a number of relevant meta keywords.": "Le recomendamos que todas sus páginas tengan una serie de palabras clave meta relevantes.",
    "We recommend that all your pages has a relevant and unique meta description.": "Recomendamos que todas sus páginas tengan una meta descripción relevante y única.",
    "We recommend that all your pages has an unique title.": "Le recomendamos que todas sus páginas tengan un título único.",
    "We recommend that the meta description consists of at least 50 characters.": "Recomendamos que la meta descripción conste de al menos 50 caracteres.",
    "We recommend that the meta description consists of no more than 160 characters.": "Recomendamos que la meta descripción no tenga más de 160 caracteres.",
    "We recommend that you give each page a unique title.": "Le recomendamos que le dé a cada página un título único.",
    "We recommend that you have a unique H1 tag on each page.": "Le recomendamos que tenga una etiqueta H1 única en cada página.",
    "We recommend that you have at least one H2-H6": "Le recomendamos que tenga al menos un H2-H6",
    "We recommend that you have no more than 100 internal links on each page.": "Recomendamos que no tenga más de 100 enlaces internos en cada página.",
    "We recommend that you keep your URL below 200 characters.": "Le recomendamos que mantenga su URL por debajo de 200 caracteres.",
    "We recommend that you only have one H1 tag on each page.": "Le recomendamos que solo tenga una etiqueta H1 en cada página.",
    "Wednesday": "Miércoles",
    "Weekly": "Semanalmente",
    "Well done - no accessibility issues found": "Bien hecho, no se encontraron problemas de accesibilidad.",
    "We’ve Updated our Privacy Policy!": "¡Hemos actualizado nuestra Política de Privacidad!",
    "Why is this an issue": "¿Por qué es esto un problema?",
    "With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go": "Con Fast Track puedes corregir, revisar e ignorar fragmentos de HTML en las páginas afectadas, todo de una sola vez.",
    "Word": "Palabra",
    "Word Count": "Recuento de palabras",
    "Word count": "Recuento de palabras",
    "Word count in PDF": "Recuento de palabras en PDF",
    "Word is added to dictionary": "Se agrega la palabra al diccionario",
    "Word is added to dictionary for all languages": "Word se agrega al diccionario para todos los idiomas",
    "Word is confirmed as misspelling": "Se confirma que la palabra está mal escrita",
    "Word length": "Longitud de la palabra",
    "Word links": "Enlaces de palabras",
    "Word or Phrase": "Palabra o frase",
    "Words": "Palabras",
    "Would you like to update now? Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups": "¿Quieres actualizar ahora? Actualizar grupos puede tardar más de 30 minutos. Durante la operación, no podrás crear ni actualizar grupos.",
    "Written by: [[author]]": "Escrito por: [[author]]",
    "Years": "Años",
    "You are about to delete": "Estás a punto de eliminar",
    "You are about to delete the domain": "Estás a punto de eliminar el dominio",
    "You are about to delete the domain group": "Estás a punto de eliminar el grupo de dominios",
    "You are currently using Demo Data, certain features will be unavailable": "Actualmente estás utilizando datos de demostración, ciertas funciones no estarán disponibles",
    "You are receiving this report": "Estás recibiendo este informe",
    "You can create another [[customerProfilesLimit]] profiles for your account": "Puedes crear otros [[customerProfilesLimit]] perfiles para tu cuenta",
    "You can pin this domain. Pinned domains will be shown at the top of your domain list": "Puedes anclar este dominio. Los dominios anclados se mostrarán en la parte superior de tu lista de dominios.",
    "You have more than one H1 tag on this page": "Tienes más de una etiqueta H1 en esta página",
    "You have no H2-H6 tags on the page": "No tienes etiquetas H2-H6 en la página",
    "You have no available profiles": "No tienes perfiles disponibles",
    "You have not received any reports": "No has recibido ningún informe",
    "You have one or more pages with the \\\"noindex\\\" META tag": "Tienes una o más páginas con la etiqueta META \\&quot;noindex\\&quot;",
    "You have reached the maximum number of profiles for this account.": "Ha alcanzado el número máximo de perfiles para esta cuenta.",
    "You have too many internal links": "Tienes demasiados enlaces internos",
    "You will receive an email when the export is ready.": "Recibirás un correo electrónico cuando la exportación esté lista.",
    "Your Users Technology": "La tecnología de sus usuarios",
    "Zero links were found": "No se encontraron enlaces",
    "Zip code": "Código postal",
    "achieved": "logrado",
    "affected image": "imagen afectada",
    "and": "y",
    "and does not conform with": "y no se ajusta a",
    "contact": "contacto",
    "contains": "contiene",
    "content": "contenido",
    "diagnostics_errors.csv": "diagnósticos_errores.csv",
    "diagnostics_passed.csv": "diagnósticos_aprobados.csv",
    "disabling": "deshabilitando",
    "document": "documento",
    "documents": "documentos",
    "done": "hecho",
    "enabling": "habilitante",
    "ends_with": "termina_con",
    "excluded": "excluidos",
    "go to the matched link": "ir al enlace coincidente",
    "image": "imagen",
    "included": "incluido",
    "insert brand name": "Insertar nombre de marca",
    "insert context fx. us": "insertar contexto fx.us",
    "insert max word length": "Insertar longitud máxima de palabra",
    "insert word fx. contact": "Insertar palabra fx. contacto",
    "is": "es",
    "is_exactly": "es_exactamente",
    "language": "idioma",
    "link": "enlace",
    "match (regex)": "coincidencia (expresión regular)",
    "metadata": "metadatos",
    "milliseconds": "milisegundos",
    "minutes": "minutos",
    "n/a": "n / A",
    "not": "no",
    "opportunities_errors.csv": "oportunidades_errores.csv",
    "opportunities_passed.csv": "oportunidades_pasadas.csv",
    "overall compliance": "conformidad general",
    "pages": "páginas",
    "path": "camino",
    "please type": "Por favor escribe",
    "reviewed": "revisado",
    "rows - click to change": "filas - haga clic para cambiar",
    "search engines overview": "Sumario de Motores de Búsqueda",
    "should always be followed by": "Siempre debe ir seguido de",
    "social network overview": "Sumario de Redes Sociales",
    "starts_with": "comienza_con",
    "that": "eso",
    "title": "título",
    "to confirm this action": "para confirmar esta acción",
    "to fix": "Para arreglar",
    "url": "URL",
    "us": "a nosotros",
    "visits": "visitas",
    "you have one or more pages that contains links with rel=\\\"nofollow\\\"": "Tienes una o más páginas que contienen enlaces con rel=\\&quot;nofollow\\&quot;",
    "{{ pagesDone }} Pages ({{ compliancePercentage }}) in compliance": "{{ pagesDone }} Páginas ({{ compliancePercentage }}) en conformidad",
    "{{ totalPageIssues }} Pages ({{ compliancePercentage }}) to fix": "{{ totalPageIssues }} Páginas ({{ compliancePercentage }}) para corregir",
    "[[label]]: [[value]] Pages": "[[label]]: [[value]] Páginas",
    "[[label]]: [[value]]ms": "[[etiqueta]]: [[valor]]ms",
    "[[languageName]] ([[languageCount]])": "[[nombreDeIdioma]] ([[númeroDeIdiomas]])",
    "[[ms]] ms": "[[ms]] ms",
    "[[name]] have already been scanned for compliance. Are you sure you want to scan it again?": "[[name]] ya ha sido escaneado para verificar su conformidad. ¿Seguro que desea volver a escanearlo?",
    "[[pageCount]] Pages": "[[pageCount]] páginas",
    "[[pageCount]] pages found with this issue": "Se encontraron [[pageCount]] páginas con este problema",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nivel A)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nivel AA)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (Nivel AAA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nivel A)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nivel AA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (Nivel AAA)",
    "1 found": [
      "1 encontrado",
      "[[$count]] encontrados",
      "[[$count]] encontrados"
    ],
    "1 issue found": [
      "1 problema encontrado",
      "[[$count]] errores encontrados",
      "[[$count]] errores encontrados"
    ],
    "1 word found": [
      "1 palabra encontrada",
      "[[$count]] palabras encontradas",
      "[[$count]] palabras encontradas"
    ],
    "Total: 1 Performance Page": [
      "Total: 1 Página de Rendimiento",
      "Total: [[$count]] Páginas de Rendimiento",
      "Total: [[$count]] Páginas de Rendimiento"
    ],
    "You have 1 to do": [
      "Tienes 1 cosa que hacer",
      "Tienes [[issues]] por hacer",
      "Tienes [[issues]] por hacer"
    ],
    "page": "página",
    "Are you sure you want to remove Custom PageCorrect? <br> Please type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "¿Está seguro de que desea eliminar Custom PageCorrect?<br> Escriba [[deleteTag]]Eliminar[[deleteTagEnd]] para confirmar esta acción",
    "You are about to remove PageCorrect for this check <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Estás a punto de eliminar PageCorrect para esta comprobación<br> Escriba [[deleteTag]]Eliminar[[deleteTagEnd]] para confirmar esta acción",
    "You are about to remove PageCorrect for this misspelling <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Estás a punto de eliminar PageCorrect para este error de escritura.<br> Escriba [[deleteTag]]Delete[[deleteTagEnd]] para confirmar esta acción",
    "You are about to remove PageCorrect for this [[type]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Estás a punto de eliminar PageCorrect para este [[type]]<br> Escriba [[deleteTag]]Eliminar[[deleteTagEnd]] para confirmar esta acción",
    "You are about to remove [[titleTag]][[title]][[titleTagEnd]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "Estás a punto de eliminar [[titleTag]][[title]][[titleTagEnd]]<br> Escriba [[deleteTag]]Eliminar[[deleteTagEnd]] para confirmar esta acción",
    "Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it's place": "¿Está seguro de que desea revocar el token para el usuario API [[apiUserId]]?<br> <strong>Nota:</strong> Se creará un nuevo token en su lugar.",
    "Maximum critical path latency: <strong>[[latency]] ms </strong>": "Latencia máxima de ruta crítica: <strong>[[latency]] ms</strong>",
    "Are you sure you want to remove <code>all</code> [[type]] PageCorrects? <br> Please type <code>Delete</code> to confirm this action": "¿Está seguro de que desea eliminar <code>all</code> [[type]] PageCorrects?<br> Por favor escriba <code>Delete</code> para confirmar esta acción",
    "<strong>[[checkName]]</strong><br><br>Add reason (Optional)": "<strong>[[checkName]]</strong><br><br> Agregar motivo (opcional)",
    "Are you sure you want to confirm the misspelling <strong>' + word.word + '</strong>?": "¿Estás seguro de que deseas confirmar el error de escritura <strong>&#39;+ word.word + &#39;</strong> ?",
    "Are you sure you want to delete the policy <strong>[[policyName]]</strong>": "¿Está seguro de que desea eliminar la política <strong>[[policyName]]?</strong>",
    "Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?": "¿Está seguro de que desea marcar la política <strong>[[policyName]]</strong> como corregida?",
    "Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>": "¿Estás seguro de que deseas eliminar la regla de Mapa de Calor de <strong>[[pageUrl]]?</strong>",
    "Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?": "¿Estás seguro de que deseas eliminar la regla <strong>&#39; + rule.name + &#39;</strong> ?",
    "Are you sure you want to run the policy <strong>' + policy.name + '</strong>?": "¿Está seguro de que desea ejecutar la política <strong>&#39; + policy.name + &#39;</strong> ?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong> again?": "¿Está seguro de que desea ejecutar la política <strong>[[policyName]]</strong> nuevamente?",
    "Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?": "¿Está seguro de que desea dejar de ignorar la política <strong>[[policyName]]</strong> ?",
    "You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.": "Actualmente tiene <strong>[[spellingFixes]]</strong> correcciones de errores de escritura, le recomendamos que mantenga este número por debajo de <strong>[[spellingLimit]]</strong> para garantizar que la página se muestre sin problemas.",
    "You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.": "Actualmente tiene <strong>[[totalFixes]]</strong> correcciones, le recomendamos limitar su número de correcciones a <strong>[[pageFixLimit]]</strong> para garantizar un rendimiento óptimo de la página, sin embargo, esto queda a su propia discreción.",
    "[[users]]<strong>and [[userCountLeft]] more</strong>": "[[users]] <strong>y [[userCountLeft]] más</strong>",
    "Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?": "¿Está seguro de que desea ignorar la política <strong>[[policyName]]</strong> ?",
    "Title:": "Título:",
    "[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]": "[[msg]] <strong>[[regulationName]]</strong> provocará que se sobrescriban las reglas personalizadas [[opposite]] para los siguientes problemas, lo que significa que se marcarán [[negate]] en futuros análisis: [[list]]",
    "Admin only": "Solo administrador",
    "Apply fix": "Aplicar corrección",
    "Contains high, medium or low opportunities": "Contiene oportunidades altas, medias o bajas",
    "Design": "Diseño",
    "Enable Custom PageCorrect Settings": "Habilitar configuraciones personalizadas de PageCorrect",
    "Enable PageCorrect features below. Disabled features will not be shown on your dashboard.": "Habilite las funciones de PageCorrect a continuación. Las funciones deshabilitadas no se mostrarán en su panel.",
    "Enable PageCorrect for Accessibility Source Codes": "Habilitar PageCorrect para códigos fuente de accesibilidad",
    "Enable PageCorrect for Broken Links": "Habilitar PageCorrect para enlaces rotos",
    "Enable PageCorrect for Misspellings": "Habilitar PageCorrect para errores de escritura",
    "Enable PagedCorrect for Accessibility Checks": "Habilitar PagedCorrect para comprobaciones de accesibilidad",
    "Failing checks - A": "Controles fallidos - A",
    "Failing checks - AA": "Controles fallidos - AA",
    "Failing checks - AAA": "Cheques fallidos - AAA",
    "Good job! Your domain contains no Accessibility Issues for this section": "¡Buen trabajo! Tu dominio no tiene problemas de accesibilidad en esta sección.",
    "Indicates the difficulty to apply this fix": "Indica la dificultad de aplicar esta corrección.",
    "List of improvements that can be applied to your website to improve your Accessibility Compliance": "Lista de mejoras que se pueden aplicar a su sitio web para mejorar su conformidad de accesibilidad",
    "Manage": "Administrar",
    "Media": "Medios de comunicación",
    "Open PageCorrect Settings": "Abrir la configuración de PageCorrect",
    "PageCorrect Settings Updated": "Configuración de PageCorrect actualizada",
    "PageCorrect settings": "Configuración de PageCorrect",
    "Pages with Data Privacy violations": "Páginas con violaciones de privacidad de datos",
    "Should admin be the only one to set PageCorrect Settings": "¿Debería ser el administrador el único que configure la configuración de PageCorrect?",
    "Website Structure": "Estructura del sitio web",
    "Data Privacy violations": "Violaciones de la privacidad de datos",
    "Heartbeat check": "Comprobación de Heartbeat",
    "Request PDF accessibility check from selection": "Solicitar comprobación de accesibilidad de PDF de la selección",
    "Total unique downloads": "Descargas únicas totales",
    "[[succeededPdfs]] out of [[pdfs]] PDF accessibility request succeeded": "[[succeededPdfs]] de [[pdfs]] solicitud de accesibilidad de PDF exitosa",
    "Accessibility Issues": "Problemas de accesibilidad",
    "Inspecting:": "Inspeccionando:",
    "Pages with Accessibility Issues": "Páginas con problemas de accesibilidad",
    "Start advance export": "Iniciar exportación avanzada",
    "Check whether your website is responding and measures the response times of the server": "Comprueba si tu sitio web está respondiendo y mide los tiempos de respuesta del servidor",
    "Search label": "Etiqueta de búsqueda",
    "Custom range": "Gama personalizada",
    "Last Half Year": "Último medio año",
    "Last Month": "Mes pasado",
    "Last Quarter": "Último trimestre",
    "Last Week": "La semana pasada",
    "Last Year": "El año pasado",
    "Character": [
      "Personaje",
      "Personajes",
      "Personajes"
    ],
    "Image missing alt attribute": "Atributo alt faltante en la imagen",
    "Quick info here": "Información rápida aquí",
    "There is 1 META description on this page": "Hay 1 descripción META en esta página",
    "There is 1 internal link on this page": [
      "Hay 1 enlace interno en esta página",
      "Hay [[$count]] links internos en esta página",
      "Hay [[$count]] links internos en esta página"
    ],
    "There is one META description on this page": [
      "Hay una descripción META en esta página",
      "Descripciones META en esta página",
      "Descripciones META en esta página"
    ],
    "and 1 document": {
      "Documents with broken images": [
        "y 1 documento",
        " y [[count]] documentos",
        " y [[count]] documentos"
      ],
      "Documents with confirmed misspellings": [
        "y 1 documento",
        "y [[count]] documentos",
        "y [[count]] documentos"
      ],
      "Documents with potential misspellings": [
        "y 1 documento",
        "y [[count]] documentos",
        "y [[count]] documentos"
      ]
    },
    "and one document": {
      "Pages with broken links": [
        "y un documento",
        "y [[$count]] documentos",
        "y [[$count]] documentos"
      ]
    },
    "Remediation": "Remediación",
    "Remediation quote": "Cotización de remediación",
    "Remediation quote has been requested": "Se ha solicitado cotización de remediación",
    "Sort by": {
      "Exchange center filter option": "Ordenar por"
    },
    "#idname.class-name1.class-name2": "#idname.nombre-de-clase1.nombre-de-clase2",
    "&lt;i&gt; tags as icons": "etiquetas &lt;i&gt; como iconos",
    ".class-name1": ".nombre-de-clase1",
    "<strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)": "<strong>Estilo CSS para la etiqueta &lt;strong&gt;</strong> (poner todo el texto fuerte en rojo)",
    "<strong>NOTE</strong>: Changing the text below, will override the text in all your included languages": "<strong>NOTA</strong> : Si cambia el texto a continuación, se anulará el texto en todos los idiomas incluidos.",
    "A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations": "Hay una versión más reciente de PageAssist disponible. Cambie a la versión 2.0 para acceder a nuevas personalizaciones.",
    "Accessibility Fixes": "Correcciones de accesibilidad",
    "Add Policy": "Agregar política",
    "Add a description of the widget to your users": "Agrega una descripción del widget a tus usuarios",
    "Add comment (Optional)": "Agregar comentario (opcional)",
    "Add row": "Agregar fila",
    "Add text for when the button is hovered": "Agregar texto para cuando se pasa el cursor sobre el botón",
    "Add title": "Agregar título",
    "Africa": "África",
    "All <code>img</code> elements have an <code>alt</code> attribute": "Todos los elementos <code>img</code> tienen un atributo <code>alt</code>",
    "Alt text does not convey the same information as the image": "El texto alternativo no transmite la misma información que la imagen.",
    "Alt text for all <code>img</code> elements contains all text in the image unless the image text is decorative or appears elsewhere in the document": "El texto alternativo de todos los elementos <code>img</code> contiene todo el texto de la imagen a menos que el texto de la imagen sea decorativo o aparezca en otra parte del documento.",
    "Alt text for all <code>img</code> elements is not placeholder text unless author has confirmed it is correct": "El texto alternativo de todos los elementos <code>img</code> no es texto de marcador de posición a menos que el autor haya confirmado que es correcto",
    "Alt text for all <code>img</code> elements is the empty string (\\\"\\\") if the image is decorative.": "El texto alternativo para todos los elementos <code>img</code> es la cadena vacía (&quot;\\&quot;) si la imagen es decorativa.",
    "Alt text for all <code>img</code> elements used as source anchors is not empty when there is no other text in the anchor": "El texto alternativo de todos los elementos <code>img</code> utilizados como anclas de origen no está vacío cuando no hay otro texto en el ancla",
    "Alt text is not the same as the filename unless author has confirmed it is correct": "El texto alternativo no es lo mismo que el nombre del archivo a menos que el autor haya confirmado que es correcto",
    "And how are we going to fix it?": "¿Y cómo vamos a solucionarlo?",
    "Applying fix": "Aplicando corrección",
    "Are you sure you want to stop receiving this report?": "¿Está seguro de que desea dejar de recibir este informe?",
    "Aria-label": "Etiqueta Aria",
    "Asia": "Asia",
    "Blink sample image": "Imagen de muestra de parpadeo",
    "Blink testing sample image": "Imagen de muestra de prueba de parpadeo",
    "Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.": "Ambos problemas pueden, en la práctica, provocar múltiples inconvenientes visuales, desde colores incorrectos hasta espacios incómodos donde no deberían existir.",
    "Bottom center": "Abajo en el centro",
    "Bottom left": "Abajo a la izquierda",
    "Bottom right": "Abajo a la derecha",
    "Browse": "Navegar",
    "Button hover message": "Mensaje al pasar el cursor sobre el botón",
    "CSS selector": "Selector CSS",
    "Change <b> tags to a custom element": "Cambiar <b>las etiquetas a un elemento personalizado</b>",
    "Change <b> tags to a custom tag": "Cambiar <b>las etiquetas a una etiqueta personalizada</b>",
    "Change <blink> tags to a custom element": "Cambiar<blink> etiquetas a un elemento personalizado",
    "Change <blink> tags to a custom tag": "Cambiar<blink> etiquetas a una etiqueta personalizada",
    "Change <marquee> tags to a custom element": "Cambiar<marquee> etiquetas a un elemento personalizado",
    "Change <marquee> tags to a custom tag": "Cambiar<marquee> etiquetas a una etiqueta personalizada",
    "Change your &lt;blink&gt; tags into something else": "Cambia tus etiquetas &lt;blink&gt; por algo más",
    "Change your &lt;i&gt; elements into something else": "Cambia tus elementos &lt;i&gt; por algo más",
    "Change your &lt;marquee&gt; tags into something else": "Cambie sus etiquetas &lt;marquee&gt; por algo más",
    "Check for misspelling company name: [[company]]": "Compruebe si el nombre de la empresa está mal escrito: [[company]]",
    "Choose a tag to replace your b tags with": "Elige una etiqueta para reemplazar tus etiquetas b",
    "Choose a tag to replace your blink tags with": "Elige una etiqueta para reemplazar tus etiquetas blink",
    "Choose a tag to replace your italic tags with": "Elija una etiqueta para reemplazar sus etiquetas en cursiva",
    "Choose a tag to replace your marquee tags with": "Elija una etiqueta para reemplazar sus etiquetas de marquesina",
    "Choose an icon": "Elige un icono",
    "Choose this option to customise the fix": "Elija esta opción para personalizar la solución.",
    "Choose this option to customize the fix": "Elija esta opción para personalizar la corrección.",
    "Choose your own text for the warning pop-up": "Elija su propio texto para la ventana emergente de advertencia",
    "Circle": "Círculo",
    "Class": "Clase",
    "Close PageCorrect form": "Cerrar formulario de PageCorrect",
    "Close [[groupName]]: [[labelName]]": "Cerrar [[groupName]]: [[labelName]]",
    "Company name *": "Nombre de empresa *",
    "Constraint:": "Restricción:",
    "Custom settings": "Configuraciones personalizadas",
    "Default fix": "Solución predeterminada",
    "Default language": "Idioma predeterminado",
    "Dutch": "Holandés",
    "Edit Report": "Editar informe",
    "Education": "Educación",
    "Element name is invalid": "El nombre del elemento no es válido",
    "Element name should not contain spaces": "El nombre del elemento no debe contener espacios",
    "Enter aria-label name": "Ingrese el nombre de la etiqueta aria",
    "Enter class name": "Introduzca el nombre de la clase",
    "Enter role name": "Introduzca el nombre del rol",
    "Europe": "Europa",
    "Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:": "Si bien esta es una solución bastante sencilla, hay dos formas en que esto puede causar algunos problemas de diseño en su sitio web:",
    "Example 1": "Ejemplo 1",
    "Example 2": "Ejemplo 2",
    "File must be below 1MB": "El archivo debe tener menos de 1 MB",
    "Filter dropdown": "Filtro desplegable",
    "Finance": "Finanzas",
    "Fix applied!": "¡Corrección aplicada!",
    "Fix options": "Opciones de reparación",
    "French": "Francés",
    "Give a title to your Skip to Content button": "Dale un título a tu botón Saltar al contenido",
    "Government": "Gobierno",
    "Grid view": "Vista de cuadrícula",
    "Hide": "Esconder",
    "Hide text": "Ocultar texto",
    "Hitting the tab button will turn on Skip to PageAssist": "Al presionar el botón de tabulación se activará Saltar a PageAssist",
    "How are we going to fix it?": "¿Cómo vamos a solucionarlo?",
    "Icon shape": "Forma del icono",
    "Image Alt text is short": "El texto alternativo de la imagen es corto",
    "Important images should not have spacer Alt text": "Las imágenes importantes no deben tener espaciador en el texto Alt",
    "Info": "Información",
    "Insert company name": "Insertar nombre de la empresa",
    "Instead of &lt;i&gt; choose a different element name to be used instead": "En lugar de &lt;i&gt; elija un nombre de elemento diferente para utilizar en su lugar",
    "It will take some time before our system will register your changes to PageCorrect": "Tomará algún tiempo antes de que nuestro sistema registre sus cambios en PageCorrect",
    "Left middle": "Izquierda central",
    "Letter case *": "Mayúsculas y minúsculas *",
    "Light": "Luz",
    "Link excludes:": "El enlace excluye:",
    "Loading PageFix": "Cargando PageFix",
    "Make sure you use correct formatting and add multiple selectors when your page design differs": "Asegúrese de utilizar el formato correcto y agregar varios selectores cuando el diseño de su página sea diferente.",
    "Manage options": "Administrar opciones",
    "Marquee sample image": "Imagen de muestra de marquesina",
    "Marquee testing sample image": "Imagen de muestra de prueba de marquesina",
    "Menu theme": "Tema del menú",
    "New Window Information": "Información de la nueva ventana",
    "New Window Test": "Prueba de nueva ventana",
    "Non-Decorative images must have Alt text": "Las imágenes no decorativas deben tener texto alternativo",
    "North America": "América del norte",
    "PageAssist Logo": "Logotipo de PageAssist",
    "PageAssist position on Page": "Posición de PageAssist en la página",
    "Portuguese": "portugués",
    "Potential problems that can arise": "Posibles problemas que pueden surgir",
    "Press 'Upload link' to save your URL settings": "Presione &#39;Subir enlace&#39; para guardar la configuración de URL",
    "Preview": "Avance",
    "Proper Case": "Caso apropiado",
    "Remove input selector": "Quitar el selector de entrada",
    "Remove logo upload": "Eliminar la carga del logotipo",
    "Remove row": "Eliminar fila",
    "Repair Tip": "Consejo de reparación",
    "Repair options": "Opciones de reparación",
    "Replace Italic element with EM": "Reemplazar elemento cursiva con EM",
    "Replace all &lt;b&gt; tags with": "Reemplace todas las etiquetas &lt;b&gt; con",
    "Replace all &lt;blink&gt; tags with": "Reemplace todas las etiquetas &lt;blink&gt; con",
    "Replace all &lt;i&gt; tags": "Reemplazar todas las etiquetas &lt;i&gt;",
    "Replace all &lt;marquee&gt; tags with": "Reemplace todas las etiquetas &lt;marquee&gt; con",
    "Report Center Image": "Imagen del centro de informes",
    "Reset Input": "Restablecer entrada",
    "Reset Skip to content text to its default": "Restablecer el texto de Saltar al contenido a su valor predeterminado",
    "Reset design": "Restablecer diseño",
    "Reset to default": "Restablecer a valores predeterminados",
    "Restore": "Restaurar",
    "Restore profile?": "¿Restaurar perfil?",
    "Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.": "Restaurar este perfil <strong>([[profileName]])</strong> lo hará disponible en sus módulos.",
    "Right middle": "Medio derecho",
    "Rounded Box": "Caja redondeada",
    "Russian": "ruso",
    "Show": "Espectáculo",
    "Show details": "Mostrar detalles",
    "Show text": "Mostrar texto",
    "Simplified Chinese": "Chino simplificado",
    "Skip to Content": "Saltar al contenido",
    "Snippet reset": "Restablecimiento de fragmento",
    "Someone have created this PageCorrect before you, on another check.": "Alguien ha creado esta PageCorrect antes que usted, en otra comprobación.",
    "Spanish Mexican": "Español mexicano",
    "Start export inventory emails": "Comenzar a exportar correos electrónicos de inventario",
    "Start export inventory emails extended": "Iniciar la exportación de correos electrónicos de inventario ampliados",
    "Testing": "Pruebas",
    "The subpath/subfolder the WordPress installation is under": "La subruta/subcarpeta en la que se encuentra la instalación de WordPress",
    "This fix requires development knowledge": "Esta solución requiere conocimientos de desarrollo.",
    "This message will be displayed when the user hovers over the PageAssist button": "Este mensaje se mostrará cuando el usuario pase el cursor sobre el botón PageAssist",
    "This option might cause problems to your icons": "Esta opción podría causar problemas con tus íconos.",
    "Title Text": "Texto del título",
    "To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check": "Para configurar esta política, debe indicarnos el nombre de la empresa y el tipo de letra posiblemente mal escrita que desea verificar.",
    "Top center": "Centro superior",
    "Top left": "Arriba a la izquierda",
    "Top right": "Arriba a la derecha",
    "Trying out the pop-up": "Probando la ventana emergente",
    "UPPERCASE": "MAYÚSCULAS",
    "Undo check review": "Deshacer revisión de verificación",
    "Upload link": "Subir enlace",
    "Upload logo": "Subir logotipo",
    "Use Datepicker": "Usar el selector de fechas",
    "Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>": "Utilice PageCorrect para corregir el siguiente error de escritura: <code>[[misspelling]]</code>",
    "Use PageCorrect to fix Broken Link": "Utilice PageCorrect para reparar un enlace roto",
    "Use PageCorrect to fix these image sources": "Utilice PageCorrect para corregir estas fuentes de imágenes",
    "Value:": "Valor:",
    "View": "Vista",
    "What is wrong with the &lt;b&gt; (bold) element?": "¿Qué problema hay con el elemento &lt;b&gt; (negrita)?",
    "What is wrong with the &lt;i&gt; (italic) element?": "¿Qué problema hay con el elemento &lt;i&gt; (cursiva)?",
    "What to do when the link doesn't work?": "¿Qué hacer cuando el enlace no funciona?",
    "What to do when things look wrong?": "¿Qué hacer cuando las cosas parecen mal?",
    "Why shouldn't I use the blink element?": "¿Por qué no debería utilizar el elemento parpadeante?",
    "Widget Design and Text": "Diseño y texto del widget",
    "Widget Icon Setup": "Configuración del icono del widget",
    "Without any assigned class": "Sin ninguna clase asignada",
    "Write a warning to your outbound link": "Escribe una advertencia en tu enlace saliente",
    "Write custom tag": "Escribir etiqueta personalizada",
    "lowercase": "minúsculas",
    "with": "con",
    "with &lt;em&gt;": "con &lt;em&gt;",
    "Statistics is using sample data": "La estadística utiliza datos de muestra",
    "Statistics results are sample data for demo purposes - export is disabled": "Los resultados de las estadísticas son datos de muestra para fines de demostración; la exportación está deshabilitada.",
    "This section is using sample data": "Esta sección utiliza datos de muestra.",
    "&lt;i&gt; tags with these attribute values will not be changed": "Las etiquetas &lt;i&gt; con estos valores de atributo no se cambiarán",
    "(Bad)": "(Malo)",
    "(Good)": "(Bien)",
    "<span class=\\\"mr-2\\\">Pages</span>": "<span class=\\\"mr-2\\\">Páginas</span>",
    "Add API user": "Agregar usuario API",
    "Add attributes to be excluded in this change": "Agregar atributos que se excluirán en este cambio",
    "Add profile": "Agregar perfil",
    "Add source code exclude": "Agregar exclusión de código fuente",
    "Are you sure?": "¿Está seguro?",
    "Button hover color": "Color del botón al pasar el mouse",
    "Calculated by no. and severity of issues, page views and links leading to this page..": "Calculado por número y gravedad de problemas, páginas vistas y enlaces que conducen a esta página.",
    "Choose minimum word count for a page to be included in the readability test": "Elija el recuento mínimo de palabras para que una página se incluya en la prueba de legibilidad",
    "Color contrast ratio": "Relación de contraste de color",
    "Content id tag": "Etiqueta de identificación de contenido",
    "Creation date": "Fecha de creación",
    "Custom text": "Texto personalizado",
    "Customise the Information page": "Personalizar la página de información",
    "Disable": "Desactivar",
    "Docs without downloads": "Documentos sin descargas",
    "Documents Without Downloads": "Documentos sin descargas",
    "EPI Server Path": "Ruta del servidor EPI",
    "EPIServer": "Servidor EPI",
    "Editor": "Editor",
    "Ex: data-currentpage, or data-pageid, or CurrentPageLink": "Ej: data-currentpage, o data-pageid, o CurrentPageLink",
    "Ex: lang or CurrentPageLanguage": "Ej: lang o CurrentPageLanguage",
    "Export both pages and documents": "Exportar tanto páginas como documentos",
    "Export only documents without downloads": "Exportar solo documentos sin descargas",
    "Export only html pages without visits": "Exportar solo páginas html sin visitas",
    "Include Accessibility Statement": "Incluir declaración de accesibilidad",
    "Include custom info text": "Incluir texto de información personalizado",
    "Includes a button with a link to your accessibility statement": "Incluye un botón con un enlace a su declaración de accesibilidad",
    "Indicates which language this page will be scanned in. Click underneath to change": "Indica en qué idioma se escaneará esta página. Haga clic debajo para cambiar",
    "Insert a valid URL": "Insertar una URL válida",
    "Language tag": "Etiqueta de idioma",
    "Last assigned profile on page. Page will be removed from Performance": "Último perfil asignado en la página. La página se eliminará de Rendimiento.",
    "Link color": "Color del enlace",
    "Link opens in a new tab": "El enlace se abre en una nueva pestaña",
    "Main color": "Color principal",
    "Meta name": "Nombre meta",
    "Mode": "Modo",
    "No default profile selected for this page, scoring not available.": "No hay ningún perfil predeterminado seleccionado para esta página, puntuación no disponible.",
    "No documents found": "No se encontraron documentos",
    "No profiles selected for this page, scoring not available.": "No hay perfiles seleccionados para esta página, puntuación no disponible.",
    "Not a valid CSS selector": "No es un selector CSS válido",
    "Notification when the downtime ends": "Notificación cuando finaliza el tiempo de inactividad",
    "Number of external links": "Número de enlaces externos",
    "Number of incoming links": "Número de enlaces entrantes",
    "Open details": "Abrir detalles",
    "PDF Accessibility": "Accesibilidad de PDF",
    "Passwords do not match": "Las contraseñas no coinciden",
    "Please add a Default Profile to your Page": "Agrega un perfil predeterminado a tu página",
    "Please add a Profile to your Page": "Por favor, agrega un perfil a tu página",
    "Please enter a valid color code": "Por favor, introduzca un código de color válido",
    "Please perform a PDF scan to see the results for the checks below": "Realice un escaneo en PDF para ver los resultados de las comprobaciones a continuación.",
    "Setup": "Configuración",
    "Show less of the code snippet": "Mostrar menos del fragmento de código",
    "Show the full code snippet": "Mostrar el fragmento de código completo",
    "Statistics not activated. Page Views not available.": "Estadísticas no activadas. Páginas vistas no disponibles.",
    "Subdomain": "Subdominio",
    "Subdomain url": "URL del subdominio",
    "Superfast - Don't use unless you know what you're doing": "Superrápido: no lo uses a menos que sepas lo que estás haciendo",
    "Text color": "Color del texto",
    "The optional epi server path": "La ruta del servidor epi opcional",
    "The subdomain url to the CMS page": "La URL del subdominio a la página CMS",
    "This text must be under 1000 characters": "Este texto debe tener menos de 1000 caracteres.",
    "Two-Factor Authentication": "Autenticación de dos factores",
    "Two-factor authentication is currently disabled": "La autenticación de dos factores está actualmente deshabilitada",
    "Two-factor authentication is currently enabled": "La autenticación de dos factores está actualmente habilitada",
    "URL needs to be valid, include http:// or https:// and be under 100 characters": "La URL debe ser válida, incluir http:// o https:// y tener menos de 100 caracteres.",
    "URL template": "Plantilla de URL",
    "Unique broken links": "Enlaces rotos únicos",
    "Very fast - Be Cautious": "Muy rápido - Tenga cuidado",
    "WCAG 2.0": "WCAG 2.0",
    "WCAG 2.1": "WCAG 2.1",
    "Your color contrast is below the recommended score": "Su contraste de color está por debajo del puntaje recomendado",
    "labels": "etiquetas",
    "Acceptance Rate": "Tasa de aceptación",
    "Acceptance Rate Over Time": "Tasa de aceptación a lo largo del tiempo",
    "Acceptance Rate by Category": "Tasa de aceptación por categoría",
    "Accepted cookies": "Cookies aceptadas",
    "Add callback functions boilerplate": "Agregar funciones de devolución de llamada repetitivas",
    "Add cookie": "Agregar galleta",
    "Add empty EventListeners": "Agregar EventListeners vacíos",
    "Add empty callbacks": "Agregar devoluciones de llamadas vacías",
    "Add event listeners boilerplate": "Agregar escuchas de eventos repetitivo",
    "Add web overlay lock": "Agregar bloqueo de superposición web",
    "Alternative": "Alternativa",
    "An overview of your customer's behavior with cookies on your website": "Una descripción general del comportamiento de sus clientes con las cookies en su sitio web",
    "Are you sure you want to ignore all selected misspellings?": "¿Está seguro de que desea ignorar todos los errores de escritura seleccionados?",
    "Are you sure you want to mark this check as fixed on all pages?": "¿Está seguro de que desea marcar esta comprobación como fija en todas las páginas?",
    "Are you sure you want to mark this check as fixed?": "¿Está seguro de que desea marcar esta comprobación como corregida?",
    "Are you sure you want to mark this misspelling as fixed?": "¿Está seguro de que desea marcar este error de escritura como corregido?",
    "Are you sure you want to mark this misspelling(s) as fixed?": "¿Está seguro de que desea marcar este(os) error(es) de escritura como corregido?",
    "Basic": "Básico",
    "Button color": "Color del botón",
    "Button text color": "Color del texto del botón",
    "Case sensitive URLs": "URL que distinguen entre mayúsculas y minúsculas",
    "Changes wording from only essential cookies to explicit reject": "Cambia la redacción de solo cookies esenciales a rechazar explícitamente",
    "Consent Log": "Registro de consentimiento",
    "Consent Overview": "Sumario de Consentimiento",
    "Consent results are sample data for demo purposes": "Los resultados del consentimiento son datos de muestra para fines de demostración.",
    "Cookie Acceptance Rate": "Tasa de aceptación de cookies",
    "Cookie Overview": "Sumario de Cookies",
    "Cookie description": "Descripción de la cookie",
    "Cookie duration": "Duración de las cookies",
    "Cookie name": "Nombre de la cookie",
    "Enter a valid CSS selector": "Introduzca un selector CSS válido",
    "Essential": "Básico",
    "Example 3": "Ejemplo 3",
    "Example 4": "Ejemplo 4",
    "Explicit reject option": "Opción de rechazo explícito",
    "Give a short description of the purpose of the cookie": "Proporcione una breve descripción del propósito de la cookie.",
    "Give users more control over which categories of cookies to consent to": "Dar a los usuarios más control sobre qué categorías de cookies aceptar",
    "How long is the cookie active": "¿Cuánto tiempo está activa la cookie?",
    "IP Address": "Dirección IP",
    "Ignore canonical URLs": "Ignorar URL canónicas",
    "Ignored by": "Ignorado por",
    "Ignored date": "Fecha ignorada",
    "Ignored misspellings on account": "Se ignoraron los errores de escritura en la cuenta",
    "Include cookies": "Incluir cookies",
    "Insert CSS class or id selector": "Insertar selector de clase o id CSS",
    "Insert a CSS selector": "Insertar un selector CSS",
    "Limit or exclude": "Limitar o excluir",
    "Limit search": "Limitar la búsqueda",
    "Link to your opt out page": "Enlace a su página de cancelación de suscripción",
    "Make sure you use the correct setting": "Asegúrese de utilizar la configuración correcta",
    "Mark check as fixed": "Marcar la verificación como corregida",
    "Marketing": "Marketing",
    "No cookies found": "No se encontraron cookies",
    "No misspellings have been ignored": "No se han ignorado errores de escritura.",
    "Opt out link": "Enlace de exclusión voluntaria",
    "Original": "Original",
    "Other": "Otro",
    "Overall Acceptance Rate": "Tasa de aceptación general",
    "Overall acceptance rate": "Tasa de aceptación general",
    "Per category consent": "Consentimiento por categoría",
    "Please wait - Marking as fixed": "Por favor espere - Marcando como arreglado",
    "Please wait - Marking word as fixed": "Por favor espere - Marcando palabra como corregida",
    "Preferences": "Preferencias",
    "Privacy regulation": "Reglamento de privacidad",
    "Remove cookie": "Eliminar cookies",
    "Remove from Ignored": "Eliminar de Ignorados",
    "Remove this word from Ignored Misspellings": "Eliminar esta palabra de Errores de escritura ignorados",
    "URL Structure": "Estructura de URL",
    "Domain Overview": {
      "Topmenu": "Sumario del Dominio",
      "$$noContext": "Sumario del Dominio"
    },
    "Admin Settings": "Configuración de administrador",
    "Case sensitivity": "Sensibilidad a mayúsculas y minúsculas",
    "Close project search and domain picker": "Cerrar la búsqueda de proyectos y el selector de dominios",
    "Domain Settings": "Configuración del dominio",
    "In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.": "En definitiva, las etiquetas &lt;i&gt; y &lt;em&gt; tienen un aspecto visual similar. Sin embargo, cada una tiene un significado semántico diferente. &lt;em&gt; se usa para representar énfasis, mientras que la etiqueta &lt;i&gt; representa una palabra o frase que el usuario podría querer poner en cursiva (una palabra extranjera, la definición de una palabra, etc.). Para esta última, se recomienda usar CSS.",
    "Paste your image link (URL) here": "Pegue el enlace de su imagen (URL) aquí",
    "Set up your domain": "Configura tu dominio",
    "The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.": "El mayor problema con esta corrección puede surgir si se usa la etiqueta &lt;i&gt; para los íconos en lugar de, por ejemplo, &lt;span&gt; (ejemplo: Font Awesome). Si observa que algo no se ve bien en sus íconos después de aplicar la corrección, esta podría ser la razón. Sin embargo, las etiquetas &lt;i&gt; para íconos suelen usar una clase, así que asegúrese de configurar las opciones para que solo se modifiquen las etiquetas, sin modificar las clases. De esta manera, sus íconos no se verán afectados.",
    "The profile <strong>[[profileName]]</strong> is being used on the following pages below:": "El perfil <strong>[[profileName]]</strong> se está utilizando en las siguientes páginas:",
    "Add icon border": "Agregar borde de icono",
    "Adds a 3px wide border to the PageAssist widget icon": "Agrega un borde de 3 px de ancho al ícono del widget PageAssist",
    "Bottom": "Abajo",
    "Clear search": "Borrar búsqueda",
    "Ensures that PageAssist is never overlapped by other elements on the page": "Asegura que PageAssist nunca se superponga con otros elementos de la página",
    "Estonian": "estonio",
    "German": "Alemán",
    "Go to overlay with details": "Ir a la superposición con detalles",
    "Guidelines for WCAG 2.2": "Directrices para WCAG 2.2",
    "Heartbeat Overview": "Sumario de Heartbeat",
    "How far the button is from the edge. Customization dependant on position.": "A qué distancia está el botón del borde. Personalización según la posición.",
    "Insert a valid host name": "Insertar un nombre de host válido",
    "Keep PageAssist on top": "Mantener PageAssist encima",
    "Left": "Izquierda",
    "Margin from edge in pixels": "Margen desde el borde en píxeles",
    "Norwegian Bokmål": "Bokmål noruego",
    "Norwegian Nynorsk": "Nynorsk noruego",
    "Right": "Bien",
    "Social Media visits": "Visitas a las redes sociales",
    "Social media visits": "Visitas a las redes sociales",
    "Sort column": "Ordenar columna",
    "Sort column ascending": "Ordenar columna ascendente",
    "Sort column descending": "Ordenar columna descendente",
    "Subgroup": "Subgrupo",
    "Swedish": "sueco",
    "Toggle label text": "Alternar texto de etiqueta",
    "Top": "Arriba",
    "Unique misspellings": "Errores de escritura únicos",
    "Unique misspellings found": "Se encontraron errores de escritura únicos",
    "WCAG 2.2 Accessibility Compliance": "Conformidad de accesibilidad WCAG 2.2",
    "Area dynamic page": "Página dinámica del área",
    "Employeepage": "Página del empleado",
    "Language id": "Identificación del idioma",
    "Newspage": "Página de noticias",
    "Standard": "Estándar",
    "Standard for http(s)://edit.domain.tld/inz/<path>. Alternative for http(s)://domain.tld/<path>/edit.": "Estándar para http(s)://edit.domain.tld/inz/<path> Alternativa para http(s)://dominio.tld/<path> /editar.",
    "URL format": "Formato de URL",
    "Export both internal and external links": "Exportar enlaces internos y externos",
    "Export only external links": "Exportar solo enlaces externos",
    "Export only internal links": "Exportar solo enlaces internos",
    "Overview of all the enabled modules for this domain": "Sumario de todos los módulos habilitados para este dominio",
    "Search for a predefined policy in the Policy Exchange Center": "Busque una política predefinida en el Centro de intercambio de políticas",
    "A log of all the consents given by your website visitors": "Un registro de todos los consentimientos otorgados por los visitantes de su sitio web",
    "Action required. Click to resolve issue.": "Acción requerida. Haga clic para resolver el problema.",
    "Complete": "Completo",
    "Cookie Overview buttons": "Botones de Resumen de Cookies",
    "Cookie Overview saved": "Resumen de Cookies guardado",
    "Cookie added by user": "Cookie agregada por el usuario",
    "Cookie domain": "Dominio de cookies",
    "Cookie not found": "Cookie no encontrada",
    "Cookie not published. Missing:": "Cookie no publicada. Falta:",
    "Could not save invalid form": "No se pudo guardar el formulario no válido",
    "Disables interactions on website until the visitor makes a consent choice. Be aware that locking interactions prior to consent may not be compliant with certain regional privacy regulations.": "Desactiva las interacciones en el sitio web hasta que el visitante dé su consentimiento. Tenga en cuenta que bloquear las interacciones antes del consentimiento podría no cumplir con ciertas normativas regionales de privacidad.",
    "Finish the setup by adding your cookies": "Finaliza la configuración agregando tus cookies",
    "For Cookie setup please go to your <b>Data Privacy</b> module.<br> Manual cookies can be set up or edited any time and are not related to script setup.": "Para configurar las cookies, vaya a su módulo <b>de Privacidad de datos</b> .<br> Las cookies manuales se pueden configurar o editar en cualquier momento y no están relacionadas con la configuración del script.",
    "GDPR requires that companies provide descriptions on their website for all cookies that are used.": "El RGPD exige que las empresas proporcionen descripciones en su sitio web de todas las cookies que se utilizan.",
    "Give an overview of the cookies used on your website. Finish a domain scan or add them manually.": "Proporciona un resumen de las cookies utilizadas en tu sitio web. Realiza un análisis del dominio o agregalas manualmente.",
    "Id": "ID",
    "Include a link to your webpage's privacy policy": "Incluya un enlace a la política de privacidad de su página web",
    "It looks like the previously set up cookie was not found in this scan. It might be that the cookie was removed or our scan just couldn’t detect it.": "Parece que la cookie configurada previamente no se encontró en este análisis. Es posible que se haya eliminado o que nuestro análisis no la haya detectado.",
    "I’ll do it later": "Lo haré más tarde",
    "Keep": "Mantener",
    "Leave without saving": "Salir sin guardar",
    "Link to Privacy Policy": "Enlace a la Política de Privacidad",
    "Link to your Cookie Overview": "Enlace a su Resumen de Cookies",
    "Link to your Privacy Policy": "Enlace a su Política de Privacidad",
    "Link where customers can opt out of sale of personal data. Mandatory for websites under the CCPA regulation.": "Enlace donde los clientes pueden optar por no vender sus datos personales. Obligatorio para sitios web según la normativa CCPA.",
    "List of checks with and without issues categorized by [[level]] guidelines": "Lista de controles con y sin problemas categorizados según las pautas de [[level]]",
    "Manage Cookie": "Administrar cookies",
    "On-demand scan unavailable": "Escaneo a pedido no disponible",
    "Pages needing to be fixed": "Páginas que necesitan reparación",
    "Save cookies": "Guardar cookies",
    "Save existing cookies": "Guardar cookies existentes",
    "Save this overview to publish completed cookies to the Cookie Overview.": "Guarde este resumen para publicar las cookies completadas en la Resumen de Cookies.",
    "Save your page before leaving to keep your progress and publish the completed cookies.": "Guarda tu página antes de salir para conservar tu progreso y publicar las cookies completadas.",
    "Scan History": "Historial de escaneo",
    "Scan Information": "Información de escaneo",
    "Scan info": "Información del escaneo",
    "Source": "Fuente",
    "This feature is not available on a demo account.": "Esta función no está disponible en una cuenta de demostración.",
    "This page has been rescanned since the latest full scan.": "Esta página ha sido escaneada nuevamente desde el último escaneo completo.",
    "This scan feature is not available on a demo account": "Esta función de escaneo no está disponible en una cuenta de demostración",
    "UUID": "UUID",
    "You need to include a name in order to save your cookies.": "Debes incluir un nombre para poder guardar tus cookies.",
    "[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.": "[[total]] páginas. Prioriza y soluciona todos los problemas de contenido de tu sitio web desde una vista consolidada.",
    "Distribution of policies with matches across priority levels": "Distribución de políticas con coincidencias en todos los niveles de prioridad",
    "Copied!": "Copiado!",
    "Copy": "Copiar",
    "Default language*": "Idioma predeterminado*",
    "Don't forget to copy and update the script on your website!": "¡No olvides copiar y actualizar el script en tu sitio web!",
    "Included languages*": "Idiomas incluidos*",
    "Loading Data": "Cargando datos",
    "Loading...": "Cargando...",
    "No support": "Sin soporte",
    "Open PageAssist script settings": "Abrir la configuración del script de PageAssist",
    "PageAssist script settings": "Configuración del script de PageAssist",
    "Please add the script as close to the open HEAD-tag as possible": "Agregue el script lo más cerca posible de la etiqueta HEAD abierta",
    "Please wait - loading": "Por favor espere - cargando",
    "Press Ctrl-C": "Presione Ctrl-C",
    "Press ⌘-C": "Presione ⌘-C",
    "This chart shows how many percent of visitors accepted the various categories of cookies on your website. Visitors who did not make a consent choice on the cookie banner are not counted": "Este gráfico muestra el porcentaje de visitantes que aceptaron las distintas categorías de cookies en su sitio web. Los visitantes que no dieron su consentimiento en el banner de cookies no se contabilizan.",
    "Visitor percentage": "Porcentaje de visitantes",
    "Consent Manager script settings": "Configuración del script de Consent Manager",
    "Open consent manager script settings": "Abrir la configuración del script del administrador de consentimiento",
    "Scan your website for any data privacy issues that could be present": "Escanee su sitio web para detectar cualquier problema de privacidad de datos que pueda estar presente",
    "Please enter a full UUID string. Empty or partial strings will not yield any results.": "Introduzca una cadena UUID completa. Las cadenas vacías o incompletas no generarán resultados.",
    "UUID can only be searched by entering the full value": "El UUID solo se puede buscar ingresando el valor completo",
    "Average Cumulative Layout Shift": "Cambio de diseño acumulado promedio",
    "Average Largest Contentful Paint": "Pintura con contenido más grande promedio",
    "Average Speed Index": "Índice de velocidad promedio",
    "Average Total Blocking Time": "Tiempo total promedio de bloqueo",
    "CMS Path": "Ruta del CMS",
    "Click here or drag a rule to this area": "Haga clic aquí o arrastre una regla a esta área",
    "Cumulative Layout Shift": "Cambio de diseño acumulativo",
    "LCP": "LCP",
    "Relevant for": "Relevante para",
    "SI": "SI",
    "TBT": "OTC",
    "[[avg]]": "[[promedio]]",
    "[[label]]: [[value]]": "[[etiqueta]]: [[valor]]",
    "Content Authoring": "Creación de contenido",
    "Responsibilities": "Responsabilidades",
    "Responsibility": "Responsabilidad",
    "UX Design": "Diseño UX",
    "Visual Design": "Diseño visual",
    "Version [[version]]": "Versión [[version]]",
    "Accessibility score": "Puntuación de accesibilidad",
    "Comparison to average": "Comparación con el promedio",
    "Industry average": "Promedio de la industria",
    "No scores available for this domain": "No hay puntuaciones disponibles para este dominio",
    "Professional services": "Servicios profesionales",
    "Quality Assurance score": "Puntuación de Control de Calidad",
    "SEO score": "Puntuación SEO",
    "Scores": "Montones",
    "The average score for domains within your industry.": "La puntuación media de los dominios de su industria.",
    "Add language": "Agregar idioma",
    "Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.": "¿Seguro que desea archivar la política <strong>[[policyName]]</strong> ? Ya no buscaremos coincidencias con esta política. Puede desarchivarla más adelante.",
    "Are you sure you want to set these documents as reviewed?": "¿Está seguro de que desea establecer estos documentos como revisados?",
    "Clear selection": "Borrar selección",
    "Delete language -": "Eliminar idioma -",
    "Delete the language tab - [[language]]": "Eliminar la pestaña de idioma - [[language]]",
    "Discovered": "Descubierto",
    "Doing this will result in removing the translations in the selected language from both your Cookie Overview and the actual banner itself.<br></br><strong>You will need to add the descriptions again when you re-add the selected language.</strong>": "Al hacer esto, se eliminarán las traducciones en el idioma seleccionado tanto de la Resumen de Cookies como del banner en sí.<br></br> <strong>Necesitarás agregar las descripciones nuevamente cuando vuelvas a agregar el idioma seleccionado.</strong>",
    "Don't forget to update your languages in Script Setup!": "¡No olvides actualizar tus idiomas en Configuración de script!",
    "Edit this policy rule later under the “Add rule to policy” tab.": "Edite esta regla de política más tarde en la pestaña “Agregar regla a la política”.",
    "Front-end Development": "Desarrollo front-end",
    "How to setup this policy:": "Cómo configurar esta política:",
    "Insert word length": "Insertar longitud de palabra",
    "Inspect page with browser extension": "Inspeccionar página con la extensión del navegador",
    "Mark all as reviewed": "Marcar todo como revisado",
    "Mobile only": "Solo móvil",
    "New policy": "Nueva política",
    "Please add at least one language": "Por favor, agrega al menos un idioma",
    "Please set the default language": "Por favor, configure el idioma predeterminado",
    "Please wait - Adding word to ignored list": "Por favor espere - Agregando palabra a la lista de ignoradas",
    "Please wait - Adding words to ignored list": "Por favor espere - Agregando palabras a la lista de ignoradas",
    "Remove rule from policy": "Eliminar regla de la política",
    "Request PDF accessibility check for all": "Solicitar verificación de accesibilidad de PDF para todos",
    "Request Remedition quote for all": "Solicitar cotización de remediación para todos",
    "Script": "Guion",
    "Select a group": "Seleccione un grupo",
    "Select a shape": "Seleccione una forma",
    "Select languages": "Seleccionar idiomas",
    "Select the default language": "Seleccione el idioma predeterminado",
    "To finish setting up your manual Cookie Overview go to the selected domain’s": "Para finalizar la configuración manual de la Resumen de Cookies, vaya al dominio seleccionado",
    "Unignore this check": "Desactivar esta comprobación",
    "WCAG 2.1 (Level AA) Mobile": "WCAG 2.1 (Nivel AA) Móvil",
    "WCAG 2.1 (Level AAA) Mobile": "WCAG 2.1 (Nivel AAA) Móvil",
    "Are you sure you want to delete label: [[label]] ?": "¿Estás seguro de que deseas eliminar la etiqueta: [[label]]?",
    "Business services": "Servicios empresariales",
    "CMS template is configured for this domain": "La plantilla CMS está configurada para este dominio",
    "Consent Manager configuration": "Configuración del administrador de consentimiento",
    "Consent Manager language*": "Idioma del administrador de consentimiento*",
    "Consent Manager pop-up position on Page": "Posición de la ventana emergente del Administrador de consentimiento en la página",
    "Consent Manager pop-up setup": "Configuración de la ventana emergente del Administrador de consentimiento",
    "Construction/industrial": "Construcción/industrial",
    "Consumer services": "Servicios al consumidor",
    "Entertainment/Leisure": "Entretenimiento/Ocio",
    "Financial services": "Servicios financieros",
    "German (Germany)": "Alemán (Alemania)",
    "Healthcare": "Cuidado de la salud",
    "Label used in the groups below. Please edit or delete the groups and try again.": "Etiqueta usada en los grupos a continuación. Edita o elimina los grupos y vuelve a intentarlo.",
    "Law enforcement": "Aplicación de la ley",
    "Legal": "Legal",
    "Non-profit": "No lucrativo",
    "Real-estate": "Bienes raíces",
    "Retail/wholesale": "Venta al por menor/al por mayor",
    "Spanish (Spain)": "Español (España)",
    "Technology": "Tecnología",
    "Utilities/Natural resources": "Servicios públicos/Recursos naturales",
    "Widget Design": "Diseño de widgets",
    ":": ":",
    "Accessibility issue": "Problema de accesibilidad",
    "Add reason (optional)": "Agregar motivo (opcional)",
    "All pages with this accessibility issue": "Todas las páginas con este problema de accesibilidad",
    "All pages with this data privacy issue": "Todas las páginas con este problema de privacidad de datos",
    "Alternatively, click the button below.": "Alternativamente, haga clic en el botón a continuación.",
    "Are you sure you want to mark this  as fixed?": "¿Estás seguro que deseas marcar esto como arreglado?",
    "Are you sure you want to mark this  as ignored?": "¿Estás seguro de que deseas marcar esto como ignorado?",
    "Are you sure you want to mark this  as not fixed?": "¿Estás seguro que deseas marcar esto como no arreglado?",
    "Are you sure you want to mark this check as ignored?": "¿Está seguro de que desea marcar esta comprobación como ignorada?",
    "Are you sure you want to mark this issue as ignored?": "¿Está seguro de que desea marcar este problema como ignorado?",
    "Are you sure you want to unignore this ?": "¿Estás seguro que deseas dejar de ignorar esto?",
    "Average time (comp.)": "Tiempo promedio (comp.)",
    "Bounce rate (comp.)": "Tasa de rebote (comp.)",
    "Campaign visits": "Visitas de campaña",
    "Code": "Código",
    "Confirmation required": "Se requiere confirmación",
    "Current password": "Contraseña actual",
    "Data privacy issue": "Problema de privacidad de datos",
    "Data violations": "Violaciones de datos",
    "Date found": "Fecha de hallazgo",
    "Downloads (comp.)": "Descargas (comp.)",
    "Entries (comp.)": "Entradas (comp.)",
    "Events": "Eventos",
    "Exits (comp.)": "Salidas (comp.)",
    "Export visitors browsers": "Exportar navegadores de visitantes",
    "Export visitors devices": "Exportar dispositivos de visitantes",
    "Export visitors language": "Exportar idioma de los visitantes",
    "Export visitors locations": "Exportar ubicaciones de visitantes",
    "Export visitors operating systems": "Exportar sistemas operativos de visitantes",
    "Export visitors organization": "Organización de visitantes de exportación",
    "Found on page": "Encontrado en la página",
    "Group name": "Nombre del grupo",
    "Image URL": "URL de la imagen",
    "Issue details": "Detalles del problema",
    "Issue not found": "Problema no encontrado",
    "Legacy Browser Service changed": "El servicio de navegador heredado ha cambiado",
    "Look up in Google": "Busque en Google",
    "Mark as reviewed": "Marcar como revisado",
    "Maximum word length to search for": "Longitud máxima de palabra a buscar",
    "Names": "Nombres",
    "No pages were found. Try searching for the page URL instead of the page title.": "No se encontraron páginas. Intenta buscar la URL de la página en lugar del título.",
    "Open browser extension": "Abrir la extensión del navegador",
    "Open issue page": "Página de problemas abiertos",
    "Open misspelling page": "Abrir página de errores de escritura",
    "Other checks for this snippet": "Otras comprobaciones para este fragmento",
    "Pages with accessibility issues": "Páginas con problemas de accesibilidad",
    "Pages with policy issues": "Páginas con temas de política",
    "Pageviews (comp.)": "Páginas vistas (comp.)",
    "Percentage shows number of pages that are compliant with all Policies": "El porcentaje muestra el número de páginas que cumplen con todas las políticas",
    "Percentage shows number of pages that are compliant with all QA checks": "El porcentaje muestra la cantidad de páginas que cumplen con todos los controles de calidad",
    "Please enter a valid date!": "¡Por favor introduzca una fecha válida!",
    "Please wait - Adding word to all dictionaries": "Por favor espere - Agregando palabra a todos los diccionarios",
    "Press to toggle additional rows.": "Presione para alternar filas adicionales.",
    "Puppeteer Browser Service changed": "El servicio de navegación Puppeteer ha cambiado",
    "Reason:&nbsp;": "Razón:",
    "Remember to add this source code exclude to your domain(s) through the Edit Domain screen.": "Recuerde agregar esta exclusión de código fuente a su(s) dominio(s) a través de la pantalla Editar dominio.",
    "Remove review": "Eliminar reseña",
    "Repeat new password": "Repetir nueva contraseña",
    "Sorry, this page was not found. The issue must have been resolved.": "Lo sentimos, no se encontró esta página. El problema debe haberse resuelto.",
    "The date cannot be in the future": "La fecha no puede ser futura",
    "The end date cannot be before the start date": "La fecha de finalización no puede ser anterior a la fecha de inicio.",
    "The settings form contains incorrect data. Close the form anyway?": "El formulario de configuración contiene datos incorrectos. ¿Quieres cerrarlo de todas formas?",
    "The start and end date cannot be in the future, please enter the compare dates again": "La fecha de inicio y finalización no puede ser futura, ingrese nuevamente las fechas de comparación",
    "This issue is marked as fixed.": "Este problema está marcado como solucionado.",
    "This issue is marked as ignored.": "Este problema está marcado como ignorado.",
    "This issue is marked as reviewed.": "Este problema está marcado como revisado.",
    "This word has been added to your dictionary": "Esta palabra ha sido agregada a tu diccionario",
    "To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class=\\\"text-bold\\\">My Exports.</span>": "Para ver el progreso actual, haga clic en el avatar del usuario en la parte superior derecha de la página principal y seleccione <span class=\\\"text-bold\\\">Mis exportaciones.</span>",
    "Total unique downloads (comp.)": "Descargas únicas totales (comp.)",
    "Unique downloads (comp.)": "Descargas únicas (comp.)",
    "Visitors browsers export": "Exportación de navegadores de visitantes",
    "Visitors devices export": "Exportación de dispositivos de los visitantes",
    "Visitors language export": "Exportación de idioma de los visitantes",
    "Visitors locations export": "Exportación de ubicaciones de visitantes",
    "Visitors operating systems export": "Exportación de sistemas operativos de visitantes",
    "Visitors organization export": "Organización de visitantes para exportar",
    "Visits (comp.)": "Visitas (comp.)",
    "WCAG 2.1 (Level A) Mobile": "WCAG 2.1 (Nivel A) Móvil",
    "Your export is currently being generated.": "Su exportación se está generando actualmente.",
    "+ ' + (report.targets.length - maxTargets) + ' more": "+ &#39; + (report.targets.length - maxTargets) + &#39; más",
    "Accessibility Checklist (WCAG 2.0)": "Lista de verificación de accesibilidad (WCAG 2.0)",
    "Accessibility Checklist (WCAG 2.1)": "Lista de verificación de accesibilidad (WCAG 2.1)",
    "Accessibility Checklist (WCAG 2.2)": "Lista de verificación de accesibilidad (WCAG 2.2)",
    "Average no. of results pages viewed": "Número promedio de páginas de resultados vistas",
    "Checklist": "Lista de verificación",
    "Email *": "Correo electrónico *",
    "Event actions": "Acciones de eventos",
    "Event categories": "Categorías de eventos",
    "Event names": "Nombres de eventos",
    "First name *": "Nombre de pila *",
    "Last name *": "Apellido *",
    "Search term": "Término de búsqueda",
    "Search terms": "Términos de búsqueda",
    "Search terms with no results": "Términos de búsqueda sin resultados",
    "Site Search": "Búsqueda en el sitio",
    "Site Search - Search Terms": "Búsqueda en el sitio - Términos de búsqueda",
    "Site Search No Results Search Terms": "Búsqueda en el sitio No hay resultados Términos de búsqueda",
    "Switch between chart and table": "Cambiar entre gráfico y tabla",
    "Table": "Mesa",
    "more": "más",
    "Accessibility checks update": "Actualización de las comprobaciones de accesibilidad",
    "Account is under maintenance": "La cuenta está en mantenimiento",
    "Add internal URL": "Agregar URL interna",
    "Add the name of the platform or company who provides this cookie.": "Agrega el nombre de la plataforma o empresa que proporciona esta cookie.",
    "All PDFs": "Todos los PDF",
    "All scheduled reports": "Todos los informes programados",
    "An error has occurred - please try again": "Se ha producido un error. Inténtelo de nuevo.",
    "Are you sure you want mark as fixed": "¿Estás seguro que deseas marcar como corregido?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary for all languages?": "¿Estás seguro de que deseas agregar la palabra <strong>[[word]]</strong> al diccionario para todos los idiomas?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary?": "¿Estás seguro de que deseas agregar la palabra <strong>[[word]]</strong> al diccionario?",
    "Are you sure you want to confirm the word <strong>[[word]]</strong> as misspelling?": "¿Está seguro de que desea confirmar que la palabra <strong>[[word]]</strong> está mal escrita?",
    "Are you sure you want to ignore the misspelling <strong>[[word]]</strong> for all languages?": "¿Está seguro de que desea ignorar el error de escritura <strong>[[word]]</strong> para todos los idiomas?",
    "Are you sure you want to mark the misspelling <strong>[[word]]</strong> as fixed?": "¿Estás seguro de que deseas marcar el error de escritura <strong>[[word]]</strong> como corregido?",
    "Are you sure you want to remove the Default label?": "¿Está seguro de que desea eliminar la etiqueta predeterminada?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong>?": "¿Está seguro de que desea ejecutar la política <strong>[[policyName]]</strong> ?",
    "Bar chart representing data": "Gráfico de barras que representa datos",
    "Bar line chart representing": "Gráfico de líneas de barras que representa",
    "Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.": "Tenga en cuenta que un atributo alt vacío puede ser suficiente y apropiado para imágenes decorativas.",
    "Bubble chart representing data": "Gráfico de burbujas que representa datos",
    "Clear the field": "Limpiar el campo",
    "Close submenu": "Cerrar submenú",
    "Contact Support": "Contactar con soporte técnico",
    "Cookie platform": "Plataforma de cookies",
    "Current password is incorrect please try again": "La contraseña actual es incorrecta, inténtelo de nuevo.",
    "Doughnut chart representing data": "Gráfico de anillos que representa datos",
    "Enable Cookieless Tracking": "Habilitar el seguimiento sin cookies",
    "Errors and": "Errores y",
    "Errors and Warnings": "Errores y advertencias",
    "Events filter buttons": "Botones de filtro de eventos",
    "Every 12 weeks": "Cada 12 semanas",
    "Every 2 weeks": "Cada 2 semanas",
    "Every 4 weeks": "Cada 4 semanas",
    "Every 8 weeks": "Cada 8 semanas",
    "Frequency": "Frecuencia",
    "Image details": "Detalles de la imagen",
    "Image metadata": "Metadatos de la imagen",
    "Image preview": "Vista previa de la imagen",
    "Inventory image preview": "Vista previa de la imagen de inventario",
    "It seems like we are experience some issues with the page you are looking at.": "Parece que estamos experimentando algunos problemas con la página que estás viendo.",
    "It seems like your computer is disconnected from the internet.": "Parece que tu computadora está desconectada de Internet.",
    "Line chart representing data": "Gráfico de líneas que representa datos",
    "List of received reports": "Lista de informes recibidos",
    "Metadata and pages": "Metadatos y páginas",
    "Metadata property": "Propiedad de metadatos",
    "My scheduled reports": "Mis informes programados",
    "No date range selected": "No se ha seleccionado ningún rango de fechas",
    "Norwegian": "noruego",
    "Only Errors": "Solo errores",
    "Only errors": "Solo errores",
    "Open dropdown with filters": "Abrir menú desplegable con filtros",
    "Open metadata view": "Abrir vista de metadatos",
    "Open submenu with filters": "Abrir submenú con filtros",
    "Pages that contain the Email": "Páginas que contienen el correo electrónico",
    "Percentage shows the average compliance score across all pages on the domain": "El porcentaje muestra el puntaje de conformidad promedio en todas las páginas del dominio",
    "Pie chart representing data": "Gráfico circular que representa datos",
    "Platform": "Plataforma",
    "Please contact the support if this issue keeps happening": "Comuníquese con el soporte si este problema persiste.",
    "Please refresh the browser when your computer is online again.": "Actualice el navegador cuando su computadora vuelva a estar en línea.",
    "Please try again later": "Por favor, inténtelo de nuevo más tarde",
    "Press to remove the label.": "Presione para quitar la etiqueta.",
    "Puppeteer 20": "Titiritero 20",
    "Remove internal URL": "Eliminar URL interna",
    "Scan all pages for cookies": "Escanear todas las páginas en busca de cookies",
    "Schedule this report": "Programe este informe",
    "Search in options": "Buscar en opciones",
    "Show HTML snippet details": "Mostrar detalles del fragmento HTML",
    "Show labels": "Mostrar etiquetas",
    "Show less of the url snippet": "Mostrar menos del fragmento de URL",
    "Show the full url snippet": "Mostrar el fragmento de URL completo",
    "Showing": "Demostración",
    "The average compliance score for this module for domains from other organizations within your industry:": "El puntaje de conformidad promedio de este módulo para dominios de otras organizaciones dentro de su industria:",
    "Unsubscribe from report": "Darse de baja del informe",
    "Warnings": "Advertencias",
    "We export up to a maximum of 1000 rows": "Exportamos hasta un máximo de 1000 filas",
    "We recommend that you have an alt attribute with relevant content on all image tags.": "Le recomendamos que tenga un atributo alt con contenido relevante en todas las etiquetas de imagen.",
    "You have images missing an alt attribute.": "Tienes imágenes a las que les falta un atributo alt.",
    "[[name]] Remove": "[[name]] Eliminar",
    "[[target]]": "[[objetivo]]",
    "default": "por defecto",
    "[[label]]": "[[etiqueta]]",
    "% of visitors staying after a search": "% de visitantes que se quedan después de una búsqueda",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.": "La corrección de documentos para la conformidad con las normas de accesibilidad WCAG 2.1 AA, Sección 508, HHS o PDF/UA la realiza nuestra filial, NetCentric Technologies, Inc. Debido a los requisitos del marco regulatorio de su país, no podemos coordinar la corrección de documentos directamente; sin embargo, le invitamos a contactar directamente con NetCentric para obtener un presupuesto y servicios de corrección en dherr@allyant.com. Tenga en cuenta que todos los contratos de corrección se celebran entre usted, el Cliente, y NetCentric, y están sujetos a los Términos y Condiciones y la Política de Privacidad de NetCentric, lo que implicará la transferencia de datos a terceros y países, incluyendo, entre otros, Estados Unidos, Canadá, Australia y Egipto.",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. Upon completion of the work, NetCentric will also provide a compliance report. NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy.": "La corrección de documentos para la conformidad con las normas de accesibilidad WCAG 2.1 AA, Sección 508, HHS o PDF/UA la realiza nuestra filial, NetCentric Technologies, Inc. Para la corrección, nos coordinaremos con NetCentric para revisar el documento y ofrecerle un precio fijo. Una vez finalizado el trabajo, NetCentric también le proporcionará un informe de cumplimiento. NetCentric le informará si se requiere texto alternativo (Alt-Text) para imágenes que no sean autodescriptivas o si se necesita información adicional para la corrección del documento. Tenga en cuenta que todos los contratos de corrección se celebran entre usted, el cliente, y NetCentric, y están sujetos a los Términos y Condiciones y la Política de Privacidad de NetCentric.",
    "Japanese": "japonés",
    "Report Administration": "Administración de informes",
    "Submit": "Entregar",
    "You have [[domains]] domain(s) on your account": "Tienes [[domains]] dominio(s) en tu cuenta",
    "Find domains by searching for the title or URL": "Encuentre dominios buscando por título o URL",
    "Industry average score": "Puntuación media de la industria",
    "Proceed to add one more check": "Proceda a agregar un cheque más",
    "Readability test (for English pages only)": "Prueba de legibilidad (solo para páginas en inglés)",
    "Request quote for more pages": "Solicitar cotización para más páginas",
    "Request quote for more profiles": "Solicitar cotización para más perfiles",
    "Search for domain": "Buscar dominio",
    "The user does not have access to view this domain and any reports associated with it": "El usuario no tiene acceso para ver este dominio ni ningún informe asociado a él.",
    "Update all domain groups": "Actualizar todos los grupos de dominios",
    "Update domain group": "Actualizar el grupo de dominio",
    "Updating a group can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Actualizar un grupo puede tardar más de 30 minutos. Durante la operación, no podrá crear ni actualizar grupos.",
    "WCAG 2.2 (Level A)": "WCAG 2.2 (Nivel A)",
    "WCAG 2.2 (Level A) Mobile": "WCAG 2.2 (Nivel A) Móvil",
    "WCAG 2.2 (Level AA)": "WCAG 2.2 (Nivel AA)",
    "WCAG 2.2 (Level AA) Mobile": "WCAG 2.2 (Nivel AA) Móvil",
    "WCAG 2.2 (Level AAA)": "WCAG 2.2 (Nivel AAA)",
    "WCAG 2.2 (Level AAA) Mobile": "WCAG 2.2 (Nivel AAA) Móvil",
    "You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button \\\"Request quote for more pages\\\" and someone on our team will be in touch.": "Has alcanzado el número máximo de Páginas de Rendimiento en tu plan actual.<br/><br/>Para consultar sobre opciones de precios para páginas adicionales, presione el botón \\\"Solicitar cotización para más páginas\\\" y alguien de nuestro equipo se pondrá en contacto con usted.",
    "You must perform a manual review of the page to confirm if this issue is present": "Debe realizar una revisión manual de la página para confirmar si este problema está presente.",
    "Accessibility Checklist (QUALWEB)": "Lista de verificación de accesibilidad (QUALWEB)",
    "Accessibility checks cannot be ignored for domain groups. To ignore this check you must do it for the entire domain.": "Las comprobaciones de accesibilidad no se pueden ignorar en los grupos de dominios. Para ignorar esta comprobación, debe realizarla en todo el dominio.",
    "Accessibility checks cannot be unignored for domain groups. To unignore this check you must do it for the entire domain.": "Las comprobaciones de accesibilidad no se pueden deshacer en grupos de dominios. Para deshacer esta comprobación, debe realizarla en todo el dominio.",
    "Check your spelling or try a shorter query.": "Verifique su ortografía o intente una consulta más corta.",
    "Guidelines for QUALWEB": "Directrices para QUALWEB",
    "Language not supported": "Idioma no compatible",
    "No domains found.": "No se encontraron dominios.",
    "QUALWEB Accessibility Compliance": "Conformidad de accesibilidad de QUALWEB",
    "QualWeb (Level A)": "QualWeb (Nivel A)",
    "QualWeb (Level AA)": "QualWeb (Nivel AA)",
    "Score could not be generated": "No se pudo generar la puntuación",
    "Searching <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>": "Búsqueda<span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>",
    "The language of the page is not recognized as English. The Flesch-Kincaid test only works for English language. Change to the LIX test if you wish to generate scores for non-English pages.": "El idioma de la página no se reconoce como inglés. La prueba Flesch-Kincaid solo funciona en inglés. Cambie a la prueba LIX si desea generar puntuaciones para páginas en otros idiomas.",
    "We could not generate an accurate score for these pages. This is typically either due to the text on a page being too short, too long, or our web crawler not picking up any text at all.": "No pudimos generar una puntuación precisa para estas páginas. Esto suele deberse a que el texto de una página es demasiado corto, demasiado largo o a que nuestro rastreador web no detecta ningún texto.",
    "Are you sure you want to add word [[word]] to all dictionaries": "¿Estás seguro de que deseas agregar la palabra [[word]] a todos los diccionarios?",
    "Are you sure you want to add word [[word]] to dictionary?": "¿Estás seguro de que deseas agregar la palabra [[word]] al diccionario?",
    "Are you sure you want to confirm the word [[word]] as misspelling?": "¿Está seguro de que desea confirmar que la palabra [[word]] está mal escrita?",
    "Are you sure you want to ignore the misspelling [[word]] for all languages?": "¿Está seguro de que desea ignorar el error de escritura [[word]] para todos los idiomas?",
    "Are you sure you want to mark the misspelling [[word]] as fixed?": "¿Estás seguro de que deseas marcar el error de escritura [[word]] como corregido?",
    "Cannot forward more": "No se puede reenviar más",
    "Choose Date": "Elija fecha",
    "Compare": "Comparar",
    "Confirmed errors only": "Solo errores confirmados",
    "Exclude checks that require manual review": "Excluir cheques que requieren revisión manual",
    "If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.": "Si esta opción está activada, el análisis del dominio solo incluye las comprobaciones de accesibilidad que se pueden identificar automáticamente como errores. Se excluyen las comprobaciones que requieren revisión manual.",
    "One month back": "Hace un mes",
    "One month forward": "Un mes adelante",
    "Press to choose the end day": "Presione para elegir el día de finalización",
    "Press to choose the start day": "Pulse para elegir el día de inicio",
    "Remove compare range dates": "Eliminar fechas de rango de comparación",
    "The date cannot be in the future.": "La fecha no puede estar en el futuro.",
    "Toggle the datepicker": "Activar o desactivar el selector de fechas",
    "Add Policy with AI": "Agregar política con IA",
    "Consolidated Reports": "Informes consolidados",
    "Created with AI policy assistant": "Creado con asistente de políticas de IA",
    "Policy Assistant": "Asistente de políticas",
    "Sparkle icon": "Icono de brillo",
    "The Policy Assistant runs on Google Vertex AI, which can make mistakes.": "El Asistente de políticas se ejecuta en Google Vertex AI, que puede cometer errores.",
    "You have reached the maximum number of Performance profiles in your current plan.<br/><br/>To inquire about pricing options for additional profiles, please press the button \\\"Request quote for more profiles\\\" and someone on our team will be in touch.": "Has alcanzado el número máximo de perfiles de rendimiento en tu plan actual.<br/><br/> Para consultar sobre opciones de precios para perfiles adicionales, presione el botón &quot;Solicitar cotización para más perfiles&quot; y alguien de nuestro equipo se pondrá en contacto con usted.",
    "You are about to perform a scan of <span class='text-link'>[[pageTitle]]</span> using the profile <span class='text-link'>[[profileName]]</span>.<br>The scan can take a few minutes to finalise, depending on the size of the page.<br><br>Do you want to continue?": "Está a punto de realizar un escaneo de <span class='text-link'>[[pageTitle]]</span> utilizando el perfil <span class='text-link'>[[profileName]]</span> .<br> El escaneo puede tardar unos minutos en finalizar, dependiendo del tamaño de la página.<br><br> ¿Quieres continuar?",
    "Doesn't scan automatically": "No escanea automáticamente",
    "Scans automatically": "Escanea automáticamente",
    "with this": "con esto",
    "with this PDF": "con este PDF",
    "with this archive file": "con este archivo",
    "with this slide": "con esta diapositiva",
    "with this spreadsheet": "con esta hoja de cálculo",
    "with this text file": "con este archivo de texto",
    "Errors must be fixed for compliance.": "Los errores deben corregirse para garantizar la conformidad.",
    "Issues to Fix": "Problemas a solucionar",
    "Issues to Review": "Cuestiones a revisar",
    "Reviews require manual judgement.": "Las revisiones requieren un juicio manual.",
    "Warnings are likely to be issues, but they require manual investigation.": "Es probable que las advertencias sean problemas, pero requieren una investigación manual.",
    "1 content": [
      "1 contenido",
      "{{$count}} contenidos",
      "{{$count}} contenidos"
    ],
    "1 misspelling ignored across all domains": [
      "1 error de escritura ignorado en todos los dominios",
      "{{$count}} errores de escritura ignorados agregados en todos los dominios",
      "{{$count}} errores de escritura ignorados agregados en todos los dominios"
    ],
    "1 new cookie on": [
      "1 nueva galleta en",
      "{{$count}} nuevas cookies en ",
      "{{$count}} nuevas cookies en "
    ],
    "1 page": [
      "1 página",
      "{{$count}} páginas",
      "{{$count}} páginas"
    ],
    "1 page with one or more failing checks {{guideline}}": [
      "1 página con uno o más controles fallidos {{guideline}}",
      "{{$count}} páginas con controles fallidos {{guideline}}",
      "{{$count}} páginas con controles fallidos {{guideline}}"
    ],
    "1 page with one or more ignored checks {{guideline}}": [
      "1 página con una o más comprobaciones ignoradas {{guideline}}",
      "{{$count}} páginas con controles ignorados {{guideline}}",
      "{{$count}} páginas con controles ignorados {{guideline}}"
    ],
    "1 policy found": [
      "1 política encontrada",
      "{{$count}} políticas encontradas",
      "{{$count}} políticas encontradas"
    ],
    "1 results": [
      "1 resultado",
      "{{$count}} resultados",
      "{{$count}} resultados"
    ],
    "1 visit": [
      "1 visita",
      "{{$count}} visitas",
      "{{$count}} visitas"
    ],
    "1 word added across all domains": [
      "1 palabra agregada en todos los dominios",
      "{{$count}} palabras agregadas en todos los dominios",
      "{{$count}} palabras agregadas en todos los dominios"
    ],
    "One word found": [
      "Una palabra encontrada",
      "{{$count}} palabras encontradas",
      "{{$count}} palabras encontradas"
    ],
    "You have 1 user on your account": [
      "Tienes 1 usuario en tu cuenta",
      "Tienes {{$count}} usuarios en tu cuenta",
      "Tienes {{$count}} usuarios en tu cuenta"
    ],
    "Accessibility Compliance Scan": "Análisis de conformidad de accesibilidad",
    "Broken Links on Sitemap": "Enlaces rotos en el mapa del sitio",
    "Broken links on sitemap": "Enlaces rotos en el mapa del sitio",
    "Close Spotlight Search.": "Cerrar búsqueda de Spotlight.",
    "Requested": "Solicitado",
    "Toggle Spotlight Search.": "Activar o desactivar la búsqueda destacada.",
    "WCAG 2.2": "WCAG 2.2",
    "Newest": {
      "Exchange Center Sort by option": "El más nuevo"
    },
    "(<strong><i>[[issues]]</i></strong> unique problems)": "( <strong><i>[[issues]]</i></strong> problemas únicos)",
    "(<strong>[[issues]]</strong> unique problems)": "( <strong>[[issues]]</strong> problemas únicos)",
    "<div class=\\\\'pull-left\\\\'>' + ('Heatmaps": "<div class=\\\\'pull-left\\\\'>&#39; + (&#39;Mapas de calor",
    "<div class=\\\\'pull-left\\\\'>' + ('History Center": "<div class=\\\\'pull-left\\\\'>&#39; + (&#39;Centro de Historia",
    "<p class='warning'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached the limit of the amount of profiles allowed on your account ([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan or archive some profiles before restoring this one.</p>": "<p class='warning'>Acquia Web Governance no puede restaurar el perfil.</p><p> Has alcanzado el límite de perfiles permitidos en tu cuenta ([[maxProfiles]] perfiles). Contacta con nuestro equipo de ventas para agregar más perfiles a tu plan o archivar algunos antes de restaurar este.</p>",
    "<strong>' + (links.total | monNumber) + '</strong> ' + ('link": "<strong>&#39; + (enlaces.total | monNumber) + &#39;</strong> &#39; + (&#39;enlace",
    "<strong>' + (pages.total | monNumber) + '</strong> ' + ('page": "<strong>&#39; + (páginas.total | monNumber) + &#39;</strong> &#39; + (&#39;página",
    "A \\\"skip to content\\\" link at the start of the webpage allows screen reader and keyboard-only users to skip over potentially non-relevant links at the start of your webpage and immediately access the main content.": "Un enlace &quot;saltar al contenido&quot; al comienzo de la página web permite a los usuarios que sólo utilizan lectores de pantalla o teclado omitir enlaces potencialmente no relevantes al comienzo de su página web y acceder inmediatamente al contenido principal.",
    "A cozy room with sofa, table and laptops that have Acquia Web Governance text": "Una acogedora sala con sofá, mesa y computadoras portátiles que tienen texto de Acquia Web Governance",
    "About Acquia Web Governance": "Acerca de Acquia Web Governance",
    "Accept Acquia Web Governance Privacy Terms": "Acepte los Términos de Privacidad de Acquia Web Governance",
    "Acquia Web Governance": "Acquia Web Governance",
    "Acquia Web Governance - Accessibility": "Acquia Web Governance - Accesibilidad",
    "Acquia Web Governance - Accessibility Check List": "Acquia Web Governance - Lista de Controles de Accesibilidad",
    "Acquia Web Governance - Accessibility Guidelines": "Acquia Web Governance - Pautas de Accesibilidad",
    "Acquia Web Governance - Account Dictionary": "Acquia Web Governance - Diccionario de la Cuenta",
    "Acquia Web Governance - Admin Page Performance Profiles": "Acquia Web Governance - Perfiles de rendimiento de la página de administración",
    "Acquia Web Governance - Audit Log": "Registro de auditoría de Acquia Web Governance",
    "Acquia Web Governance - Broken Images": "Acquia Web Governance - Imágenes Rotas",
    "Acquia Web Governance - Broken Links": "Acquia Web Governance - Enlaces Rotos",
    "Acquia Web Governance - Content With Broken Links": "Acquia Web Governance - Contenido con Enlaces Rotos",
    "Acquia Web Governance - Content With QA Errors": "Acquia Web Governance - contenido con Errores de Control de Calidad",
    "Acquia Web Governance - Cookie Acceptance Rate": "Acquia Web Governance - Tasa de Aceptación de Cookies",
    "Acquia Web Governance - Cookie Consent Log": "Acquia Web Governance - Registro de Consentimiento de Cookies",
    "Acquia Web Governance - Cookie Overview": "Acquia Web Governance - Resumen de Cookies",
    "Acquia Web Governance - Dashboard": "Acquia Web Governance - Panel de control",
    "Acquia Web Governance - Data Privacy": "Acquia Web Governance - Privacidad de Datos",
    "Acquia Web Governance - Data Privacy Check List": "Acquia Web Governance - Lista de Controles de Privacidad de Datos",
    "Acquia Web Governance - Data Privacy Content": "Acquia Web Governance - Contenido de Privacidad de Datos",
    "Acquia Web Governance - Data Privacy Guidelines": "Acquia Web Governance - Pautas de privacidad de datos",
    "Acquia Web Governance - Data Privacy Issues": "Acquia Web Governance - Problemas de Privacidad de Datos",
    "Acquia Web Governance - Data Privacy Summary": "Resumen de privacidad de datos de Acquia Web Governance",
    "Acquia Web Governance - External PDF Compliance": "Acquia Web Governance - Conformidad de PDF Externos",
    "Acquia Web Governance - Fast Track": "Acquia Web Governance - Fast Track",
    "Acquia Web Governance - Heatmaps": "Acquia Web Governance - Mapas de Calor",
    "Acquia Web Governance - History Center": "Acquia Web Governance - Centro de Historia",
    "Acquia Web Governance - Ignored Misspellings": "Acquia Web Governance - Errores de Escritura Ignorados",
    "Acquia Web Governance - Internal PDF Compliance": "Acquia Web Governance - Conformidad de PDF Internos",
    "Acquia Web Governance - Labels": "Acquia Web Governance - Etiquetas",
    "Acquia Web Governance - Misspellings": "Acquia Web Governance - Errores de Escritura",
    "Acquia Web Governance - Page Performance Pages": "Acquia Web Governance - Páginas de Rendimiento",
    "Acquia Web Governance - PageCorrect": "Acquia Web Governance - PageCorrect",
    "Acquia Web Governance - PageCorrect Accessibility Fixes": "Acquia Web Governance - Correcciones de Accesibilidad de PageCorrect",
    "Acquia Web Governance - PageCorrect Content": "Acquia Web Governance - Contenido de PageCorrect",
    "Acquia Web Governance - Pages With Failing Checks": "Acquia Web Governance - Páginas con Controles Fallidos",
    "Acquia Web Governance - Pages With Ignored Checks": "Acquia Web Governance - Páginas con Controles Ignorados",
    "Acquia Web Governance - Pages With Misspellings": "Acquia Web Governance - Páginas con Errores de escritura",
    "Acquia Web Governance - Pages With Opportunity": "Acquia Web Governance - Páginas con Oportunidades",
    "Acquia Web Governance - Potential Misspellings": "Acquia Web Governance - Posibles Errores de Escritura",
    "Acquia Web Governance - Prioritized Content": "Acquia Web Governance - Contenido Prioritario",
    "Acquia Web Governance - Quality Assurance": "Acquia Web Governance - Control de Calidad",
    "Acquia Web Governance - Readability Checker": "Acquia Web Governance - Comprobador de legibilidad",
    "Acquia Web Governance - Readability Summary": "Acquia Web Governance - Resumen de Legibilidad",
    "Acquia Web Governance - SEO Checkpoints": "Acquia Web Governance - Puntos de Control de SEO",
    "Acquia Web Governance - Search Engine Optimization": "Acquia Web Governance - Optimización de Motores de Búsqueda",
    "Acquia Web Governance - Spellcheck Summary": "Acquia Web Governance - Resumen de Corrección de escritura",
    "Acquia Web Governance - User List": "Acquia Web Governance - Lista de Usuarios",
    "Acquia Web Governance Consent Manager": "Administrador de Consentimiento de Acquia Web Governance",
    "Acquia Web Governance Extension": "Extensión de Acquia Web Governance",
    "Acquia Web Governance PageAssist": "PageAssist de Acquia Web Governance",
    "Acquia Web Governance users receiving this report": "Usuarios de Acquia Web Governance que reciben este informe",
    "Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )": "Acquia Web Governance detectará automáticamente una descarga como un clic en un enlace que termina con una de las siguientes extensiones de archivo (tenga en cuenta que las extensiones distinguen entre mayúsculas y minúsculas).",
    "Add Acquia Web Governance Consent Manager": "Agregar Acquia Web Governance Consent Manager",
    "Affects [[pageCount]] pages": "Afecta a [[pageCount]] páginas",
    "An error has occurred - please try again. If the error continues, please contact Acquia Web Governance": "Se ha producido un error. Inténtelo de nuevo. Si el error persiste, póngase en contacto con Acquia Web Governance.",
    "An unexpected error occurred. Please try again.": "Se produjo un error inesperado. Inténtalo de nuevo.",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary for all languages?": "¿Estás seguro de que deseas agregar la palabra <strong>&#39; + palabra + &#39;</strong> al diccionario para todos los idiomas?",
    "Are you sure you want to add the word <strong>' + word + '</strong> to the dictionary?": "¿Estás seguro de que deseas agregar la palabra <strong>&#39; + palabra + &#39;</strong> al diccionario?",
    "Are you sure you want to confirm the misspelling <strong>' + word + '</strong>?": "¿Estás seguro de que deseas confirmar el error ortográfico <strong>&#39;+ palabra + &#39;</strong> ?",
    "Are you sure you want to remove the Profile <strong>[[profileName]]</strong>?": "¿Estás seguro de que deseas eliminar el perfil <strong>[[profileName]]</strong> ?",
    "Are you sure you want to undo review this document as reviewed?": "¿Está seguro de que desea deshacer la revisión de este documento como revisado?",
    "Calculate Readability Score": "Calcular la puntuación de legibilidad",
    "Calculate score to see results": "Calcula tu puntuación para ver los resultados",
    "Calculate the readability score of any text (based on [[testName]])": "Calcular la puntuación de legibilidad de cualquier texto (basado en [[testName]])",
    "Can\\\\'t delete label": "No se puede eliminar la etiqueta",
    "Change your &lt;b&gt; tags into something else": "Cambie sus etiquetas &lt;b&gt; por algo más",
    "Choose your own text for the Skip to Content link button<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>": "Elija su propio texto para el botón de enlace Saltar al contenido <span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Give a title to your Skip to Content button' | translate }}\\\"></span>",
    "Clear search in the domain picker": "Borrar búsqueda en el selector de dominio",
    "Click here to contact Acquia Web Governance sales department to increase your maximum page count.": "Haga clic aquí para comunicarse con el departamento de ventas de Acquia Web Governance para aumentar su número máximo de páginas.",
    "Confirmed misspelling": "Error ortográfico confirmado",
    "Copyright 2020 Acquia Web Governance. All rights reserved.": "Copyright 2020 Acquia Web Governance. Todos los derechos reservados.",
    "Couldn't find any domains": "No se pudo encontrar ningún dominio",
    "Crawled Pages ([[pageCount]])": "Páginas rastreadas ([[pageCount]])",
    "Description*": "Descripción*",
    "Domain favicon for": "Favicono de dominio para",
    "Domain groups": "Grupos de dominios",
    "Domains that have never been scanned": "Dominios que nunca han sido escaneados",
    "Domains that were not scanned in the selected date range": "Dominios que no fueron escaneados en el rango de fechas seleccionado",
    "Edit this policy rule later under the \\\"Add rule to policy\\\" tab.": "Edite esta regla de política más tarde en la pestaña &quot;Agregar regla a la política&quot;.",
    "Enable if you want to use Acquia Web Governance in Accessibility mode": "Habilite esta opción si desea utilizar Acquia Web Governance en modo de accesibilidad",
    "Export visitors screen resolutions": "Exportar resoluciones de pantalla de visitantes",
    "For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.": "Por ahora, Acquia Web Governance Pagecorrect agregará una advertencia emergente a cada enlace externo, lo que permitirá a sus visitantes elegir por sí mismos si desean navegar fuera de la página original.",
    "Found 1 audit log on your account": "Se encontró 1 registro de auditoría en su cuenta",
    "Found [[count]] audit logs on your account": "Se encontraron [[count]] registros de auditoría en su cuenta",
    "From March 1, 2022, Acquia Web Governance will no longer be supporting any version of Internet Explorer or Edge browser version 78 or below. While you will still be able to log on and use Acquia Web Governance with Internet Explorer and older versions of Edge, we are no longer testing releases and fixing bugs specifically for those browsers. We encourage you to switch to another browser such as Chrome or newer version of Edge to be sure that Acquia Optimize continues to work optimally on your device.": "A partir del 1 de marzo de 2022, Acquia Web Governance dejará de ser compatible con las versiones 78 o anteriores de Internet Explorer y Edge. Si bien podrá iniciar sesión y usar Acquia Web Governance con Internet Explorer y versiones anteriores de Edge, ya no realizamos pruebas ni correcciones de errores específicos para esos navegadores. Le recomendamos cambiar a otro navegador, como Chrome o una versión más reciente de Edge, para asegurarse de que Acquia Optimize siga funcionando de forma óptima en su dispositivo.",
    "Get the Acquia Web Governance Extension": "Obtenga la Extensión de Acquia Web Governance",
    "Go to the policy dashboard of the domain [[title]]": "Vaya al panel de políticas del dominio [[title]]",
    "Images missing alt attribute": "Imágenes sin atributo alt",
    "Insert the CSS selector targets you want your visitors to land on<span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>": "Inserte los objetivos del selector CSS en los que desea que lleguen sus visitantes <span class=\\\"fas fa-question-circle\\\" aria-hidden=\\\"true\\\" {{placement}}=\\\"'top-right'\\\" ngbtooltip=\\\"{{ 'Make sure you use correct formatting and add multiple selectors when your page design differs' | translate }}\\\"></span>",
    "Internet Explorer &amp; Edge v.78 (or below) no longer supported": "Internet Explorer y Edge v.78 (o anterior) ya no son compatibles",
    "Italics are often used in HTML to put emphasis on text. However, this is often achieved with the &lt;I&gt; tag, in which case the emphasis is not announced by screen readers. Using the &lt;I&gt; tag doesn't provide enough context and is becoming an outdated practice.": "La cursiva se usa a menudo en HTML para enfatizar el texto. Sin embargo, esto suele lograrse con la etiqueta &lt;I&gt;, en cuyo caso los lectores de pantalla no notan el énfasis. Usar la etiqueta &lt;I&gt; no proporciona suficiente contexto y se está volviendo una práctica obsoleta.",
    "Last 8 Performance Scans Scores": "Puntuaciones de los últimos 8 análisis de rendimiento",
    "Latest manual scan finished on [[scannedAt]]": "El último escaneo manual finalizó el [[scannedAt]]",
    "Mark this issue as fixed": "Marcar este problema como solucionado",
    "Monitor how visitors interact with your pages. Acquia Web Governance tracks up to a maximum of 1000 heatmaps sessions per page per month.": "Monitorea la interacción de los visitantes con tus páginas. Acquia Web Governance registra hasta un máximo de 1000 sesiones de mapas de calor por página al mes.",
    "No downloads were found. Try searching for the document URL instead of the document title.": "No se encontraron descargas. Intente buscar la URL del documento en lugar del título.",
    "No more PDF accessibility scans are available for this account. Please contact a Acquia Web Governance sales department to add more.": "No hay más escaneos de accesibilidad de PDF disponibles para esta cuenta. Para agregar más, contacte con el departamento de ventas de Acquia Web Governance.",
    "Not valid URL": "URL no válida",
    "PageCorrect failed to save, the Acquia Web Governance team has been notified of the error": "PageCorrect no se pudo guardar, el equipo de Acquia Web Governance ha sido notificado del error",
    "Pages Without Visits": "Páginas sin visitas",
    "Part of success criteria [[issueNumber]]": "Parte de los criterios de éxito [[issueNumber]]",
    "Pick any link on your website which you know opens in a new page (social media icons are usually a safe bet) and try to navigate away from the page you are on. If the pop-up doesn't appear it might be because the script has not been applied yet. Give it some time.": "Selecciona cualquier enlace de tu sitio web que sepas que abre en una página nueva (los iconos de redes sociales suelen ser una apuesta segura) e intenta salir de la página en la que te encuentras. Si la ventana emergente no aparece, podría deberse a que el script aún no se ha aplicado. Dale un tiempo.",
    "Policy Scan is no longer valid. Press Run Policy to update Policy Scan details": "El análisis de políticas ya no es válido. Pulse Ejecutar política para actualizar los detalles del análisis.",
    "Readability Checker": "Comprobador de legibilidad",
    "Readability Level": "Nivel de legibilidad",
    "Readability Summary": "Resumen de legibilidad",
    "Remove word from Ignored Misspellings": "Eliminar palabra de Errores ortográficos ignorados",
    "Remove word from dictionary": "Eliminar palabra del diccionario",
    "Request Remediation from selection": "Solicitar remediación de la selección",
    "Request failed. Please ensure you have added only text in the input field.": "Solicitud fallida. Asegúrate de haber agregado solo texto en el campo de entrada.",
    "Scan stopped successfully": "El escaneo se detuvo exitosamente",
    "Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan": "Programe informes para usted [[adminText]] por correo electrónico después de cada análisis de Acquia Web Governance",
    "Search for content that*": "Buscar contenido que*",
    "Something went wrong. The Acquia Web Governance Team has been notified of this error and will get back to you, as soon as possible.": "Algo salió mal. El equipo de Acquia Web Governance ha sido notificado de este error y se pondrá en contacto contigo lo antes posible.",
    "Start Cookie Scan": "Iniciar escaneo de cookies",
    "Start Scan": "Iniciar escaneo",
    "Start a new scan to find cookies or add them manually": "Iniciar un nuevo escaneo para encontrar cookies o agregarlas manualmente",
    "Stop scan": "Detener el escaneo",
    "Switch to Acquia Web Governance classic": "Cambiar a la versión clásica de Acquia Web Governance",
    "Test your website's compliance levels ([[level]]) and fix issues that are making it difficult for people with disabilities to use your website": "Pruebe los niveles de conformidad de su sitio web ([[level]]) y solucione los problemas que dificultan que las personas con discapacidades utilicen su sitio web.",
    "The Acquia Web Governance team is notified and are working on the issue.": "El equipo de Acquia Web Governance ha sido notificado y está trabajando en el problema.",
    "The Compound Export contains data from the first and last scans within the selected date range. The export does not include data from the following sources:": "La exportación compuesta contiene datos del primer y último escaneo dentro del rango de fechas seleccionado. La exportación no incluye datos de las siguientes fuentes:",
    "The profile has been archived.": "El perfil ha sido archivado.",
    "The profile has been restored.": "El perfil ha sido restaurado.",
    "There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.": "Solo hay una forma de hacerlo. Acquia Web Governance reemplazará todas las etiquetas &lt;I&gt; que encuentre en su sitio web por etiquetas em.",
    "Type in or paste text to be analyzed": "Escriba o pegue el texto que desea analizar",
    "URL &amp; Title": "URL y título",
    "Unignore Misspelling": "Deshacer la omisión de errores ortográficos",
    "Url &amp; Title": "URL y título",
    "Visitors screen resolutions export": "Exportación de resoluciones de pantalla de los visitantes",
    "Weight in score: [[weight]]": "Peso en la puntuación: [[weight]]",
    "Why can't I open a new window without warning?": "¿Por qué no puedo abrir una nueva ventana sin previo aviso?",
    "Why do I need a \\\"skip to content\\\" link?": "¿Por qué necesito un enlace “saltar al contenido”?",
    "Why shouldn't I use the marquee element?": "¿Por qué no debería utilizar el elemento de marquesina?",
    "You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here": "Está utilizando la nueva versión de Acquia Web Governance PageAssist. Si desea volver a la versión 1.0, haga clic aquí.",
    "You can only calculate a score for up to [[count]] characters.": "Solo puedes calcular una puntuación para hasta [[count]] caracteres.",
    "You do not have sufficient permissions to use this feature.": "No tienes permisos suficientes para usar esta función.",
    "Your current plan does not include on-demand scans. Please reach out to your Acquia Web Governance representative to learn more about this option": "Su plan actual no incluye análisis bajo demanda. Para obtener más información sobre esta opción, comuníquese con su representante de Acquia Web Governance.",
    "[[$count]] found": "[[$count]] encontrado",
    "[[count]] found": "[[count]] encontrado",
    "[[headerCount]] found": "[[headerCount]] encontrado",
    "[[pageIssues]] Pages <span>([[errorPercentage]]%)</span> to fix": "[[pageIssues]] páginas <span>([[errorPercentage]]%)</span> para corregir",
    "[[pageIssues]] Pages to fix": "[[pageIssues]] Páginas para corregir",
    "[[pagesDone]] Pages ([[compliancePercentage]]) in compliance": "[[pagesDone]] Páginas ([[compliancePercentage]]) en conformidad",
    "[[totalPageIssues]] Pages ([[compliancePercentage]]) to fix": "[[totalPageIssues]] páginas ([[compliancePercentage]]) para corregir",
    "failed when trying to ignore/review all. please try agin, or contact the Acquia Web Governance team": "Error al intentar ignorar/revisar todo. Inténtelo de nuevo o comuníquese con el equipo de Acquia Web Governance.",
    "policies": "políticas",
    "policy": "política",
    "Create issue": "Crear ticket",
    "Create issue in Jira": "Crear ticket en Jira",
    "Declared language": "Lenguage declarado",
    "Detected Languages": "Lenguages detectados",
    "Detected language": "Lenguage detectado",
    "Export documents without downloads": "Exportar documentos sin descargas",
    "Good job! No language issues were found": "Buen trabajo! No se encontraron errores de lenguaje",
    "Identify pages with incorrect or missing language tags.": "Identificar páginas con etiquetas de lenguaje incorrectas o faltantes.",
    "Issues by page": "Problemas por página",
    "Language Validation": "Validación de Lenguaje",
    "Language Validation summary": "Resumen de Validación de Lenguaje",
    "Language distribution": "Distribución de lenguajes",
    "Language mismatch": "Lenguaje incorrecto",
    "Language tag analysis": "Análisis de etiqueta de lenguaje",
    "Languages match": "Lenguajes coinciden",
    "Loading language validation data...": "Cargando datos de validación de lenguaje...",
    "Mismatch detected": "Lenguaje incorrecto detectado",
    "Multi-language": "Multilenguaje",
    "Multi-language tag": "Etiqueta Multilenguaje",
    "No language match data available for this page": "No hay datos de marcado de lenguaje disponible para esta página",
    "No language tag analysis data available.": "No hay datos de análisis de etiquetas de lenguaje.",
    "No languages detected": "No se detectaron lenguajes",
    "Not declared": "No declarado",
    "Not detected": "No detectado",
    "Pages missing language": "Páginas sin lenguaje declarado",
    "Pages with incorrect language": "Páginas con el lenguaje incorrecto",
    "Pages with incorrect language tag": "Páginas con etiquetas de lenguaje incorrectas",
    "Pages with insufficient text for language detection": "Páginas con texto insuficiente para la detección de lenguajes",
    "Pages with language issues": "Páginas con problemas de lenguaje",
    "Pages with multiple languages detected": "Páginas con múltiples lenguajes detectados",
    "Pages without issues": "Páginas sin problemas",
    "The setting \\\"Use language attribute\\\" is disabled for this domain. Please edit the domain and activate the setting to use this feature.\\\"": "El ajuste \\\"Usar atributo de lenguaje\\\" no esta habilitado para este dominio. Por favor edite el dominio y active esta opción para usar esta funcionalidad.\\\"",
    "Use language attribute is disabled for this domain, please activate it to use this module": "El uso del atributo de lenguaje esta deshabilitado para este dominio, por favor activar para usar este módulo",
    "View issue": "Ver problema",
    "View issue in Jira": "Ver ticket en Jira",
    "Start export PDF Accessibility Report": "Iniciar exportación del informe de claridad de la página",
    "No data showing? Add the Acquia Web Governance script to your website": "¿No se muestran las estadísticas? Agregue el script de Acquia Web Governance al sitio web."
  },
  "da": {
    "Search": {
      "Spotlight": "Søg",
      "$$noContext": "Søg"
    },
    "Global Policy Overview": {
      "Topmenu": "Global Policy Overblik",
      "$$noContext": "Overblik over globale policies"
    },
    "History Center": {
      "Topmenu": "Historisk overblik",
      "$$noContext": "Historisk overblik"
    },
    "Report Center": {
      "Topmenu": "Rapportcenter",
      "$$noContext": "Rapportcenter"
    },
    "Users": {
      "Topmenu": "Brugere",
      "$$noContext": "Brugere"
    },
    "No content was found": {
      "page-details -> Inventory -> links. No result message": "Intet indhold blev fundet",
      "$$noContext": "Intet indhold blev fundet"
    },
    "&nbsp;&nbsp;&nbsp;Passwords does not match": "Kodeorderne stemmer ikke overens",
    "(HTML and documents)": "(HTML og dokumenter)",
    "(No title found)": "(Ingen titel fundet)",
    "(The HTML snippet is now Marked as Reviewed/Ignored)": "(HTML-uddraget er nu markeret som gennemgået / ignoreret)",
    "(This policy is marked as unwanted content)": "(Denne policy er markeret som uønsket indhold)",
    "+ Add new check": "+ Tilføj nyt check",
    "+ Add new user": "+ Tilføj ny bruger",
    "1 min.": "1 min.",
    "1 minute": "1 minut",
    "10 min.": "10 min.",
    "10th to 12th grade": "10. til 12. klasse",
    "120 min.": "120 min.",
    "15 min.": "15 min.",
    "1st": "1.",
    "2nd": "2.",
    "30 min.": "30 min.",
    "3rd": "3.",
    "5 min.": "5 min.",
    "5 minutes": "5 minutter",
    "5th grade": "5. klasse",
    "60 min.": "60 min.",
    "6th grade": "6. klasse",
    "7th grade": "7. klasse",
    "8th to 9th grade": "8. til 9. klasse",
    "A": "A",
    "A list of all external PDF files already reviewed for accessibility issues": "En liste over alle eksterne PDF-filer, der allerede er gennemgået for tilgængelighedsproblemer",
    "A list of all external PDF files that you need to check for accessibility issues": "En liste over alle eksterne PDF-filer, som du skal kontrollere for tilgængelighedsproblemer",
    "A list of all internal PDF files already reviewed for accessibility issues": "En liste over alle interne PDF-filer, der allerede er gennemgået for tilgængelighedsproblemer",
    "A list of all internal PDF files that have been marked as failed for accessibility issues": "En liste over alle interne PDF-filer, der er markeret som ikke har bestået et check for tilgængelighedsproblemer",
    "A list of all internal PDF files that have been marked as queued for accessibility issues": "En liste over alle interne PDF-filer, der er sat i kø, fordi de har tilgængelighedsproblemer",
    "A list of all internal PDF files that you need to check for accessibility issues": "En liste over alle interne PDF-filer, som du skal kontrollere for tilgængelighedsproblemer",
    "AA": "AA",
    "AAA": "AAA",
    "ACCESSIBILITY OVERVIEW": "OVERSIGT OVER TILGÆNGELIGHED",
    "API Token": "API-token",
    "API URL": "API-URL",
    "API User": "API-bruger",
    "API User Details": "API-brugeroplysninger",
    "API Users": "API-brugere",
    "About": "Om",
    "Accept": "Accepter",
    "Accessibility": "Tilgængelighed",
    "Accessibility Check": "Tilgængeligheds-check",
    "Accessibility Diagnostics": "Tilgængelighedsdiagnostik",
    "Accessibility Fast Track": "Fast Track for tilgængelighed",
    "Accessibility Icon": "Tilgængelighedsikon",
    "Accessibility Snippet": "Berørt kodestykke",
    "Accessibility Source Code": "Kildekode for tilgængelighedscheck",
    "Accessibility checks compliance by level": "Compliance for tilgængelighed efter niveau",
    "Accessibility checks not in compliance with domain": "Tilgængeligheds-checks der ikke er i compliance med domænet",
    "Accessibility error type": "Tilgængeligheds-fejltype",
    "Accessibility errors": "Tilgængelighedsfejl",
    "Accessibility fixes": "Rettelser til tilgængelighed",
    "Accessibility help center": "Hjælp til tilgængelighed",
    "Accessibility issues": "Problemer med tilgængelighed",
    "Accessibility level": "Tilgængelighedsniveau",
    "Accessibility mode": "Tilgængelighedstilstand",
    "Accessibility review type": "Tilgængelighedstype",
    "Account dictionary": "Kontoordbog",
    "Action": "Handling",
    "Actions": "Handlinger",
    "Actions per visit": "Handlinger pr. Besøg",
    "Active": "Aktiv",
    "Add": "Tilføj",
    "Add Custom Multistep Javascript": "Tilføj tilpasset flertrins-Javascript",
    "Add Extension Name": "Tilføj udvidelsesnavn",
    "Add Heatmap rule to a Page": "Føj Heatmap-regel til en side",
    "Add Heatmaps": "Tilføj heatmaps",
    "Add PageAssist script": "Tilføj PageAssist-script",
    "Add PageCorrect": "Tilføj PageCorrect",
    "Add Profile": "Tilføj profil",
    "Add Rule": "Tilføj regel",
    "Add Skip to PageAssist": "Tilføj Spring til PageAssist",
    "Add a new exemption to your heartbeat check": "Tilføj ny undtagelse til din Heartbeat gennemgang",
    "Add a new page to start tracking individual pages' performance. Get an overview of load times and opportunities to speed up your site.": "Tilføj en ny side for at begynde at monitorere individuelle siders performance. Få et overblik over indlæsningstider og muligheder for at optimere dit websteds hastighed.",
    "Add a non-user email": "Tilføj email uden Acquia Optimize-konto",
    "Add another rule": "Tilføj en anden regel",
    "Add email": "Tilføj e-mail",
    "Add exemption": "Tilføj undtagelse",
    "Add new check": "Tilføj nyt tjek",
    "Add new domain": "Tilføj nyt domæne",
    "Add new exemption": "Tilføj ny undtagelse",
    "Add new label": "Tilføj ny etiket",
    "Add new page": "Tilføj ny side",
    "Add new policy": "Tilføj ny policy",
    "Add new user": "Tilføj ny bruger",
    "Add non users": "Tilføj ikke-brugere",
    "Add reason (Optional)": "Tilføj årsag (valgfrit)",
    "Add rule to policy": "Tilføj regel til policy",
    "Add rule to the policy": "Tilføj regel til policy",
    "Add task": "Tilføj opgave",
    "Add timeslots where you won't receive notifications on downtime and slow responsetimes.": "Tilføj timeslots, hvor du ikke modtager underretninger om nedetid og langsom responstid.",
    "Add to all languages": "Føj til alle sprog",
    "Add to dictionary": "Føj til ordbogen",
    "Add to dictionary for all languages": "Føj til ordbog for alle sprog",
    "Added": "Tilføjet",
    "Added by": "Tilføjet af",
    "Added date": "Tilføjet dato",
    "Address": "Adresse",
    "Admin": "Administrator",
    "Advanced Domain Options": "Avancerede domæneindstillinger",
    "Affected image": "Berørt billede",
    "Affected pages": "Berørte sider",
    "Affected pages by priority": "Berørte sider efter prioritet",
    "Affected pages by severity": "Berørte sider efter sværhedsgrad",
    "Affects": "Påvirker",
    "After": "Efter",
    "All": "Alle",
    "All Failed Internal PDF files": "Alle interne PDF-filer med fejl",
    "All Pending External PDF files": "Alle afventende eksterne PDF-filer",
    "All Pending Internal PDF files": "Alle afventende interne PDF-filer",
    "All Queued Internal PDF files": "Alle interne PDF-filer i kø",
    "All Reviewed External PDF files": "Alle gennemgåede eksterne PDF-filer",
    "All Reviewed Internal PDF files": "Alle gennemgåede interne PDF-filer",
    "All assets": "Alle aktiver",
    "All broken images": "Alle døde billeder",
    "All broken links": "Alle døde links",
    "All heartbeat checkpoints": "Alle Heartbeat-checks",
    "All incident checkpoints in the selected time span": "Alle hændelseskontrolpunkter i det valgte tidsrum",
    "All level A accessibility checks": "Alle check for tilgængelighed på niveau A",
    "All level AA accessibility checks": "Alle check for tilgængelighed på niveau A",
    "All level AAA accessibility checks": "Alle check for tilgængelighed på niveau AAA",
    "All levels": "Alle niveauer",
    "All modules": "Alle moduler",
    "All modules - Content with Issues": "Alle moduler - Indhold med problemer",
    "All notifications": "Alle notifikationer",
    "All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.": "Alt du skal gøre, er at indsætte nedenstående script i din websides BODY-tag. Bare kopier og indsæt det, som det er.",
    "Analytics (Last 7 days)": "Analyse (seneste 7 dage)",
    "And": "Og",
    "Appears on": "Vises den",
    "Apply": "Ansøg",
    "Archive": "Arkiv",
    "Archive files": "Arkiver filer",
    "Archived": "Arkiveret",
    "Are you sure you want to Mark this link as unignored?": "Er du sikker på, at du ikke længere ønsker at markere linket som ignoreret?",
    "Are you sure you want to Request All PDF Accessibility checks?": "Er du sikker på, at du vil anmode om alle PDF-tilgængelighedstjek?",
    "Are you sure you want to add to Request PDF Accessibility check from selection?": "Er du sikker på, at du vil tilføje til anmodning om PDF tilgængelighedstjek fra valgte?",
    "Are you sure you want to add to all the dictionaries?": "Er du sikker på, at du vil tilføje til alle ordbøgerne?",
    "Are you sure you want to add to the dictionary?": "Er du sikker på, at du vil tilføje til ordbogen?",
    "Are you sure you want to close this form without saving your changes?": "Er du sikker på, at du vil afslutte uden at gemme dine ændringer?",
    "Are you sure you want to confirm this misspelling?": "Er du sikker på, at du vil bekræfte denne stavefejl?",
    "Are you sure you want to delete the API User [[apiUserId]]": "Er du sikker på, at du vil slette API-brugeren [[apiUserId]]",
    "Are you sure you want to delete this exemption?": "Er du sikker på, at du vil slette denne undtagelse?",
    "Are you sure you want to delete this source exclude?": "Er du sikker på, at du vil slette denne kildeekskludering?",
    "Are you sure you want to ignore all errors for this check?": "Er du sikker på, at du vil ignorere alle fejl til dette tjek?",
    "Are you sure you want to ignore the selected issue on this page?": "Er du sikker på, at du vil ignorere det valgte problem på denne side?",
    "Are you sure you want to ignore this check for this domain?": "Er du sikker på, at du vil ignorere dette tjek for dette domæne?",
    "Are you sure you want to ignore this check for this page?": "Er du sikker på, at du vil ignorere dette tjek for denne side?",
    "Are you sure you want to ignore this issue?": "Er du sikker på, at du vil ignorere dette problem?",
    "Are you sure you want to ignore this misspelling?": "Er du sikker på, at du vil ignorere denne stavefejl?",
    "Are you sure you want to mark this issue as fixed?": "Er du sikker på, at du vil markere dette problem som løst?",
    "Are you sure you want to mark this issue as not fixed?": "Er du sikker på, at du vil markere dette problem som ikke løst?",
    "Are you sure you want to mark this link as fixed?": "Er du sikker på, at du vil markere dette link som rettet?",
    "Are you sure you want to mark this link as ignored?": "Er du sikker på, at du vil markere dette link som ignoreret?",
    "Are you sure you want to mark this link as not fixed?": "Er du sikker på, at du vil markere dette link som ikke rettet?",
    "Are you sure you want to remove manually added user?": "Er du sikker på, at du vil fjerne en bruger, der er tilføjet manuelt?",
    "Are you sure you want to remove review for this issue?": "Er du sikker på, at du vil fjerne gennemgangen af dette problem?",
    "Are you sure you want to remove review on all errors for this check?": "Er du sikker på, at du vil fjerne gennemgangen af alle fejl til dette tjek?",
    "Are you sure you want to remove this group?": "Er du sikker på, at du vil fjerne denne gruppe?",
    "Are you sure you want to remove this host?": "Er du sikker på, at du vil fjerne denne vært?",
    "Are you sure you want to remove this rule?": "Er du sikker på, at du vil fjerne denne regel?",
    "Are you sure you want to remove this?": "Er du sikker på, at du vil fjerne dette?",
    "Are you sure you want to review all errors for this check?": "Er du sikker på, at du vil gennemgå alle fejl til dette check?",
    "Are you sure you want to review this issue?": "Er du sikker på, at du vil gennemgå dette problem?",
    "Are you sure you want to set this document as reviewed?": "Er du sikker på, at du vil indstille dette dokument som gennemgået?",
    "Are you sure you want to start on-demand scan?": "Er du sikker på, at du vil starte en on-demand scanning?",
    "Are you sure you want to stop current crawl?": "Er du sikker på, at du vil stoppe det aktuelle crawl?",
    "Are you sure you want to the request ADA clarification for [[name]]?": "Er du sikker på, at du vil anmode om en ADA-afklaring for [[name]]?",
    "Are you sure you want to undo review of this document?": "Er du sikker på, at du vil fortryde gennemgangen af dette dokument?",
    "Are you sure you want to undo reviewing this document?": "Er du sikker på, at du vil fortryde gennemgangen af dette dokument?",
    "Are you sure you want to unignore all errors for this check?": "Er du sikker på, at du vil fjerne ignorering af alle fejl til dette tjek?",
    "Are you sure you want to unignore the selected issue on this page?": "Er du sikker på, at du vil fjerne ignoreringen af det valgte emne på denne side?",
    "Are you sure you want to unignore this check for this domain?": "Er du sikker på, at du vil fjerne ignoreringen af dette tjek for dette domæne?",
    "Are you sure you want to unignore this check for this page?": "Er du sikker på, at du vil fjerne ignoreringen af dette tjek for denne side?",
    "Are you sure you want to unignore this issue?": "Er du sikker på, at du vil fjerne ignoreringen af dette problem?",
    "Are you sure you want to unignore this link?": "Er du sikker på, at du vil fjerne ignoreringen af dette link?",
    "Are you sure you want to unignore this misspelling?": "Er du sikker på, at du vil fjerne ignoreringen af denne stavefejl?",
    "Are you sure you want to unpin this domain": "Er du sikker på, at du vil frigøre dette domæne?",
    "Are you sure you want unignore this link?": "Er du sikker på, at du vil fjerne ignoreringen af dette link?",
    "Assign Heatmap Rule": "Tildel Heatmap-regel",
    "Assign to the Performance Module": "Tildel til Performance Module",
    "Attribute": "Attribut",
    "Audit": "Revidere",
    "Audit Log": "Ændringshistorik",
    "Autoselect": "Vælg automatisk",
    "Average First Contentful Paint": "Gennemsnitlig First Contentful Paint",
    "Average First Meaningful Paint": "Gennemsnitlig First Meaningful Paint",
    "Average Performance Score": "Gennemsnitlig præstationsscore",
    "Average Performance score": "Gennemsnitlig præstationsscore",
    "Average Time to Interactive": "Gennemsnitlig tid til interaktivitet",
    "Average response time": "Gennemsnitlig svartid",
    "Average time": "Gennemsnitlig tid",
    "Average uptime": "Gennemsnitlig oppetid",
    "Average visit time": "Gennemsnitlig besøgstid",
    "Avg. Performance Score": "Gns. Performance Score",
    "Avg. Visit Time": "Gns. Besøgs Tid",
    "Avg. response": "Gns. respons",
    "BETA": "BETA",
    "Back": "Tilbage",
    "Back to Heartbeat Overview": "Tilbage til Heartbeat Oversigt",
    "Bar": "Bar",
    "Basic Auth": "Basic Auth",
    "Before": "Før",
    "Below 5th grade": "Under 5. klasse",
    "Below you can see a list of all pages that contains the title": "Nedenfor kan du se en liste over alle sider, der indeholder titlen",
    "Book online training": "Book online træning",
    "Bounce Rates": "Bounce Rates",
    "Bounce rate": "Bounce rate",
    "Bounce rates": "Bounce rates",
    "Brand name": "Brandnavn",
    "Broken Image": "Ødelagt billede",
    "Broken Image Links per page": "Ødelagte billedlinks pr. side",
    "Broken Images": "Døde billeder",
    "Broken Links": "døde links",
    "Broken Page Link": "Ødelagt sidelink",
    "Broken image affecting most content": "Ødelagt billede, der påvirker mest indhold",
    "Broken image affecting most pages": "Ødelagt billede, der påvirker flest sider",
    "Broken images": "Døde billeder",
    "Broken images with page count": "Døde billeder med sideantal",
    "Broken link": "Ødelagt link",
    "Broken link affecting most content": "Ødelagt link, der påvirker mest indhold",
    "Broken link affecting most pages": "Ødelagt link, der påvirker flest sider",
    "Broken links": "døde links",
    "Broken links per page": "Døde links pr. side",
    "Broken links with page count": "Døde links med sidetælling",
    "Browser": "Browser",
    "Browser Extension": "Browser-udvidelse",
    "Browsers": "Browsere",
    "Browsers Overview": "Browseroversigt",
    "Bubble": "Bobler",
    "Build it from scratch": "Byg den fra bunden",
    "By deleting this domain all domain groups related to this domain, will also be deleted": "Ved at slette dette domæne slettes også alle domængrupper, der er relateret til dette domæne",
    "By user": "Efter bruger",
    "CMS": "CMS",
    "CMS url": "CMS url",
    "CSS": "CSS",
    "CSS Target Selector": "CSS-selector, der skal rammes",
    "CSS id or class selector to search for": "CSS id eller class-vælger, der skal søges efter",
    "CSS selector to find submit button": "CSS-selector, der skal finde send-knappen",
    "Cache TTL": "Cache TTL",
    "Cancel": "Annuller",
    "Case sensitive": "Følsom over for små og store bogstaver",
    "Categories": "Kategorier",
    "Category": "Kategori",
    "Change password": "Skift kodeord",
    "Changed to": "Ændret til",
    "Changes": "Ændringer",
    "Changes added": "Ændringer tilføjet",
    "Changes in selected time frame:": "Ændringer i valgt tidsramme:",
    "Changes since Previous Crawl": "Ændringer siden forrige crawl",
    "Changes since previous crawl": "Ændringer siden forrige crawl",
    "Characters": "Tegn",
    "Chart": "Diagram",
    "Chart is now showing: [[name]]": "Diagrammet viser nu: [[name]]",
    "Check": "Kontrollere",
    "Check List Export": "Tjek listeeksport",
    "Check all links in this section": "Kontroller alle links i dette afsnit",
    "Check all misspellings in this section": "Kontroller alle stavefejl i dette afsnit",
    "Check all modules": "Kontroller alle moduler",
    "Check and fix content issues across your website (i.e. Misspellings, Broken links, Readability and other issues)": "Kontroller og ret indholdsproblemer på tværs af dit websted (dvs. stavefejl, døde links, læsbarhed og andre problemer)",
    "Check frequency": "Frekvens for check",
    "Check frequency:": "Frekvens for check:",
    "Check is ignored": "Kontrollen ignoreres",
    "Check is ignored for the entire domain": "Tjekket ignoreres for hele domænet",
    "Check link": "Tjek link",
    "Check misspelling": "Kontroller stavefejl",
    "Check name": "Navn på check",
    "Check off as Reviewed": "Afkryds som gennemgået",
    "Check passed": "Bestået check",
    "Check site status": "Check webstedsstatus",
    "Checking": "Checker",
    "Checkpoint exemptions": "Udeladte checks",
    "Checkpoint has been updated.": "Check er opdateret.",
    "Checkpoint information": "Oplysninger om check",
    "Checkpoint:": "Check:",
    "Checks": "Checks",
    "Checks passed": "Beståede checks",
    "Checks whether your website is responding and measures the response time of the server": "Kontrollerer om dit websted reagerer, og måler serverens responstid",
    "Choose Operator": "Vælg operatør",
    "Choose What to Scan": "Vælg hvad der skal scannes",
    "Choose a response time": "Vælg en svartid",
    "Choose a response time notification": "Vælg en notifikation ved svartid",
    "Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned": "Vælg en eksisterende dataforordning (eks. GDPR) som standardskabelon til din sikkerhedsscanning. Rediger nedenstående problemer for at udelukke, at visse tags scannes",
    "Choose checks": "Vælg checks",
    "Choose domains": "Vælg domæner",
    "Choose how to view the Heatmaps Dashboard": "Vælg hvordan du får vist Heatmaps Dashboard",
    "Choose notification time": "Vælg meddelelsestidspunkt",
    "Choose the minimum amount of words to scan for readability on a page": "Vælg den mindste mængde ord, der skal scannes for læsbarhed på en side",
    "Choose where the policy should apply": "Vælg hvor politikken skal gælde",
    "Chrome extension": "Chrome extension",
    "City": "By",
    "Clear all labels": "Ryd alle etiketter",
    "Clear and close filters": "Ryd og luk filtre",
    "Click here to create your first policy": "Klik her for at oprette din første policy",
    "Click here to edit": "Klik her for at redigere",
    "Click to create your first policy": "Klik for at oprette din første policy",
    "Clone": "Klon",
    "Close": "Luk",
    "Close filters": "Luk filtre",
    "Collapse": "Skjul",
    "Collapse menu": "Skjule menu",
    "College": "College",
    "College graduate": "Universitetsuddannet",
    "Coming soon": "Kommer snart",
    "Comment": "Kommentar",
    "Common policy violations": "Typiske policy-overtrædelser",
    "Company Info": "Virksomhedsinfo",
    "Compliance": "Compliance",
    "Compliance {{compliancePercentage}}": "Compliance {{compliancePercentage}}",
    "Compound Export": "Sammensat eksport",
    "Compound Report": "Sammensat rapport",
    "Confirm": "Bekræft",
    "Confirm as misspelling": "Bekræft som stavefejl",
    "Confirm misspelling": "Bekræft stavefejl",
    "Confirm this word as a misspelling": "Bekræft dette ord som stavefejl",
    "Confirmed": "Bekræftet",
    "Confirmed misspellings": "Bekræftede stavefejl",
    "Congratulations no violations were found": "Tillykke ingen overtrædelser blev fundet",
    "Connection Profile": "Forbindelsesprofil",
    "Connections per minute": "Forbindelser pr. Minut",
    "Constraint": "Begrænsning",
    "Constraint pattern": "Begrænsningsmønster",
    "Contact me about more Performance Pages": "Kontakt mig for flere Performance-sider",
    "Contact me about more performance profiles": "Kontakt mig for flere Performance-profiler",
    "Containing": "Indeholder",
    "Contains": "Indeholder",
    "Contains confirmed misspellings, broken links & images": "Indeholder bekræftede stavefejl, døde links og billeder",
    "Contains confirmed misspellings, broken links or images": "Indeholder bekræftede stavefejl, døde links eller billeder",
    "Contains high, medium & low opportunities for all pages": "Indeholder høje, mellem og lave muligheder for alle sider",
    "Contains high, medium & low severity issues for all pages": "Indeholder problemer med høj, medium og lav sværhedsgrad for alle sider",
    "Contains issues with high, medium and low priority for all pages": "Indeholder problemer med høj, mellem og lav prioritet for alle sider",
    "Content": "Indhold",
    "Content Links": "Links til indhold",
    "Content Policies": "Policies for indhold",
    "Content Policy Violations": "Overtrædelser af policies for indhold",
    "Content in compliance": "Indhold i compliance",
    "Content must be robust enough that it can be interpreted reliably by a wide variety of user agents, including assistive technologies.": "Indholdet skal være robust nok til, at det kan fortolkes pålideligt af en lang række brugerteknologier, herunder tekniske hjælpemidler som skærmlæsere.",
    "Content policies": "Policies for indhold",
    "Content with Broken Image": "Indhold med ødelagt billede",
    "Content with Broken Link": "Indhold med ødelagt Link",
    "Content with Broken Links": "Indhold med døde links",
    "Content with Data Issues": "Indhold med dataproblemer",
    "Content with Data Issues export": "Eksport for indhold med dataproblemer",
    "Content with Policy Matches": "Indhold med Policy-overensstemmelser",
    "Content with QA Errors": "Indhold med QA-fejl",
    "Content with broken links": "Indhold med døde links",
    "Content with issues": "Indhold med problemer",
    "Content with policy violations": "Indhold med overtrædelser af policies",
    "Content with violations": "Indhold med overtrædelser",
    "Context": "Sammenhæng",
    "Country": "Land",
    "Crawl Automatically": "Crawl automatisk",
    "Crawl Options": "Indstillinger for crawl",
    "Crawl done on": "Crawl gennemført den",
    "Crawl finalized on": "Crawl afsluttet den",
    "Crawl info": "Crawl info",
    "Crawl runtime:": "Crawl tid:",
    "Crawl started:": "Crawl startet:",
    "Crawl status": "Crawl status",
    "Crawl status:": "Crawl status:",
    "Crawled Documents ([[documentCount]])": "Crawlede dokumenter ([[documentCount]])",
    "Crawled at": "Crawlede på",
    "Crawled pages": "Crawlede sider",
    "Crawling": "Crawling",
    "Create a policy to make an email as unwanted content": "Opret en policy for at markere en e-mail som uønsket indhold",
    "Create as policy": "Opret som policy",
    "Create label": "Opret label",
    "Create new domain group": "Opret ny domænegruppe",
    "Create new group": "Opret ny gruppe",
    "Create user": "Opret bruger",
    "Create your own policy": "Opret din egen policy",
    "Created": "Oprettet",
    "Created At": "Oprettet den",
    "Created at": "Oprettet den",
    "Created date": "Oprettet dato",
    "Created:": "Oprettet:",
    "Current domain status": "Nuværende domænestatus",
    "Current status": "Nuværende status",
    "Custom": "Brugerdefinerede",
    "Custom Multistep": "Brugerdefineret i flere trin",
    "Custom Profile": "Brugerdefineret profil",
    "Custom fixes": "Brugerdefinerede rettelser",
    "Custom rule": "Brugerdefineret regel",
    "Customer": "Kunde",
    "Customer Report": "Kunderapport",
    "DATA PRIVACY OVERVIEW": "OVERSIGT OVER DATA PRIVACY",
    "DISCLAIMER": "ANSVARSFRASKRIVELSE",
    "Daily": "Daglige",
    "Danish": "Dansk",
    "Dark": "Mørk",
    "Dashboard": "Dashboard",
    "Data Issues": "Data Privacy-problemer",
    "Data Privacy": "Data Privacy",
    "Data Privacy Diagnostics": "Diagnosticering af Data Privacy",
    "Data Privacy Fast Track": "Fast Track for Data Privacy",
    "Data Privacy Help Center": "Hjælp til Data Privacy",
    "Data Privacy Info Type Icon": "Ikon for infotypen",
    "Data Privacy Issues": "Data Privacy-problemer",
    "Data Privacy Summary Export": "Eksport Data Privacy-overblik",
    "Data Privacy issues found": "Fundne Data Privacy-problemer",
    "Data Regulations": "Dataregler",
    "Data Violations": "Dataovertrædelser",
    "Data issues": "Data Privacy-problemer",
    "Data issues export": "Export af Data Privacy-problemer",
    "Data privacy": "Data Privacy",
    "Data privacy violations": "Data Privacy-overtrædelser",
    "Data protection and privacy policy statement": "Erklæring om databeskyttelse og fortrolighedspolitik",
    "Date": "Dato",
    "Day": "Dag",
    "Days": "Dage",
    "Dead": "Død",
    "Default": "Standard",
    "Default for CMS": "Standard for CMS",
    "Default value*": "Standard værdi*",
    "Define meta headers to match": "Definer meta-overskrifter, der skal matche",
    "Define size of files to look for": "Definer størrelsen på filer, der skal søges efter",
    "Define size of images to look for": "Definer størrelsen på billeder, der skal søges efter",
    "Delete": "Slet",
    "Delete All": "Slet alt",
    "Delete user": "Slet bruger",
    "Describe the exclude": "Beskriv ekskluderingen",
    "Description": "Beskrivelse",
    "Desktop": "Desktop",
    "Details": "Detaljer",
    "Device": "Enhed",
    "Device Overview": "Enhedsoversigt",
    "Device not found": "Enhed ikke fundet",
    "Device:": "Enhed:",
    "Devices": "Enheder",
    "Diagnostics": "Diagnostik",
    "Dictionary": "Ordbog",
    "Difficulty": "Vanskelighed",
    "Direct visits": "Direkte besøg",
    "Disabling": "Deaktivering",
    "Display policy in other services": "Vis policy i andre tjenester",
    "Display this policy as:": "Vis denne policy som:",
    "Distribution of Data Privacy levels": "Fordeling af Data Privacy-niveauer",
    "Distribution of PageCorrects across all change types": "Fordeling af PageCorrects på tværs af alle ændringstyper",
    "Distribution of SEO levels": "Fordeling af SEO-niveauer",
    "Distribution of policies that match their corresponding setting": "Fordeling af policies, der matcher deres tilsvarende indstilling",
    "Distribution of policies that matches their corresponding setting": "Fordeling af policies, der matcher deres tilsvarende indstilling",
    "Do you want the policy to run every time your website is crawled?": "Ønsker du, at denne policy skal køre, hver gang dit websted bliver crawled?",
    "Do you want to find pages which match the query on one or multiple lines?": "Vil du finde sider, der matcher forespørgslen på en eller flere linjer?",
    "Do you want to find pages which match the query or pages which does not match the query": "Vil du finde sider, der matcher forespørgslen, eller sider der ikke matcher forespørgslen?",
    "Do you want to update the Script Settings, for this Domain?": "Vil du opdatere indstillinger til Scripts for dette domæne?",
    "Document": "Dokument",
    "Document Class": "Dokumentklasse",
    "Document Dashboard": "Overblik over dokumenter",
    "Document Details": "Dokumentoplysninger",
    "Document Extension": "Dokument Endelse",
    "Document Ignore Class": "Ignorerer dokument class",
    "Document first detected": "Dokumentet blev først registreret",
    "Document scan": "Dokumentscanning",
    "Documents": "Dokumenter",
    "Documents Crawled": "Crawlede dokumenter",
    "Documents basic": "Grundlæggende dokumenter",
    "Documents crawled": "Crawlede dokumenter",
    "Documents extended": "Dokumenter - udvidet",
    "Documents with Broken Image": "Dokumenter med ødelagt billede",
    "Documents with Broken Link": "Dokumenter med ødelagte link",
    "Domain": "Domæne",
    "Domain Compliance": "Domænets compliance",
    "Domain Data Privacy Settings": "Indstillinger for Data Privacy på domænet",
    "Domain Detail": "Domæne detaljer",
    "Domain Details": "Domæneoplysninger",
    "Domain Groups": "Domæne grupper",
    "Domain Picker Closed": "Domænevælger lukket",
    "Domain Picker Opened": "Domænevælger åben",
    "Domain compliance": "Domænets compliance",
    "Domain group": "Domæne gruppe",
    "Domain title and URL": "Domænetitel og URL",
    "Domain:": "Domæne:",
    "Domains": "Domæner",
    "Domains/groups selected": "Domæner / grupper valgt",
    "Done": "Færdig",
    "Download": "Download",
    "Download the Chrome extension": "Download Chrome-udvidelsen",
    "Download the Edge add-on": "Download Edge-tilføjelsen",
    "Download the Firefox add-on": "Download Firefox-tilføjelsen",
    "Downloads": "Downloads",
    "Downtime": "Nedetid",
    "Downtime (Minutes)": "Nedetid (minutter)",
    "Downtime notification": "Underretning om nedetid",
    "Drag and drop the rule to add rules to the policy": "Træk og slip reglen for at tilføje regler til policy'en",
    "Dropdown": "Dropdown",
    "Duration": "Varighed",
    "Easy": "Let",
    "Easy to read pages understood by most. Example: fiction literature for adults": "Let at læse sider forstået af de fleste. Eksempel: fiktionslitteratur for voksne",
    "Edge add-on": "Edge add-on",
    "Edit": "Rediger",
    "Edit Labels": "Rediger labels",
    "Edit Performance Page": "Rediger Performance-side",
    "Edit customer information": "Rediger kundeoplysninger",
    "Edit domain": "Rediger domæne",
    "Edit domain group": "Rediger domænegruppe",
    "Edit exemption": "Rediger undtagelse",
    "Edit label": "Rediger label",
    "Edit labels": "Rediger labels",
    "Edit my profile": "Rediger min profil",
    "Edit or Delete PageCorrect": "Rediger eller slet PageCorrect",
    "Edit uptime": "Rediger oppetid",
    "Edit user": "Rediger bruger",
    "Edit users": "Rediger brugere",
    "Edit your exemption": "Rediger din undtagelse",
    "Edit:": "Rediger:",
    "Effect on compliance": "Effekt på compliance",
    "Effect on overall compliance level": "Effekt på det samlede compliance-niveau",
    "Element": "Element",
    "Element Tree Path": "Forgrening af elementer",
    "Email": "E-mail",
    "Email Notifications": "E-mail-underretninger",
    "Email addresses": "Email adresse",
    "Email receiver *": "E-mail-modtager *",
    "Email to login": "E-mail for at logge ind",
    "Emails": "E-mails",
    "Empty": "Tom",
    "Empty mailto": "Tom mailto",
    "Enable / Disable Accessibility mode": "Aktivér / deaktiver Tilgængelighedstilstand",
    "Enable Document Tracking": "Aktivér dokumentsporing",
    "Enable Export Email Notification": "Aktivér Eksporter E-mail underretninger",
    "Enable Statistics": "Aktivér statistik",
    "Enabled features": "Aktiverede funktioner",
    "Enabling": "Muliggør",
    "End at": "Slut",
    "End date": "Slutdato",
    "End time": "Sluttid",
    "English": "Engelsk",
    "Enter the full URL": "Indtast den fulde URL",
    "Entries": "Indgange",
    "Entry": "Indgang",
    "Entry Pages": "Indgangssider",
    "Entry and Exit Pages": "Indgangs- og udgangssider",
    "Error": "Fejl",
    "Error Name": "Navn på fejl",
    "Errors": "Fejl",
    "Errors ([[audits]])": "Fejl ([[audits]])",
    "Exact": "Præcis",
    "Example: academic publications": "Eksempel: akademiske publikationer",
    "Example: children's literature": "Eksempel: børnelitteratur",
    "Example: daily newspapers": "Eksempel: daglige aviser",
    "Example: fiction books": "Eksempel: fiktionsbøger",
    "Example: legal texts": "Eksempel: lov tekster",
    "Examples": "Eksempler",
    "Excel Documents": "Excel-dokumenter",
    "Exclude": "Ekskluder",
    "Exclude links that contains class name": "Udelad links, der indeholder class-navet",
    "Exclude pattern": "Ekskluderingsmønster",
    "Excluded IP addresses from statistics": "Ekskluderede IP-adresser fra statistik",
    "Exemption": "Fritagelse",
    "Exemption options": "Muligheder for fritagelse",
    "Exemption time": "Tidspunkt for fritagelse",
    "Exemptions": "Undtagelser",
    "Exit Pages": "Udgangssider",
    "Exits": "Udgange",
    "Expand": "Udvid",
    "Explain the rationale behind the policy and which actions, editors should take to correct the violation": "Forklar begrundelsen bag denne policy, og hvad der skal gøres for at rette overtrædelsen",
    "Export": "Eksport",
    "Export CSV": "Eksporter CSV",
    "Export Compound CSV": "Eksporter kombineret CSV",
    "Export Logs": "Eksporter logfiler",
    "Export list of broken images organized by page and document title": "Eksporter liste over døde billeder organiseret efter side og dokumenttitel",
    "Export list of broken links organized by page and document title": "Eksporter liste over døde links organiseret efter side og dokumenttitel",
    "Export list of downtimes for the domain": "Eksporter liste med nedetid for domænet",
    "Export list of response times": "Eksporter liste over svartid",
    "External": "Ekstern",
    "External Export": "Ekstern eksport",
    "External PDF Compliance": "Ekstern PDF-overholdelse",
    "External PDFs": "Eksterne PDF-filer",
    "External Referring Domains": "Eksterne henvisende domæner",
    "External Referring domains": "Eksterne henvisende domæner",
    "External referees overview": "Oversigt over eksterne henvisere",
    "External referring domains": "Eksterne domæne-henvisninger",
    "FCP": "FCP",
    "FMP": "FMP",
    "Facebook": "Facebook",
    "Fail Example": "Fejleksempel",
    "Failed": "Fejlet",
    "Failing accessibility checks": "Manglende tilgængelighedstjek",
    "Failing accessibility checks gives you information about the current Accessibility status of the website/group. It may vary from the history if there have been changes in ignored and review of accessibility issues": "Manglende tilgængelighedstjek giver dig oplysninger om den aktuelle tilgængelighedsstatus for hjemmesiden / gruppen. Det kan variere fra historikken, hvis der har været ændringer i de gennemgåede samt ignorerede tilgængelighedsproblemer.",
    "Failing check": "Fejlende check",
    "Failing check found": "Fundne checks med fejl",
    "Failing checks": "Fejlende checks",
    "Failing checks found": "Fundne checks med fejl",
    "Fast Track": "Fast Track",
    "Fast track html snippet": "Fast track HTML-snippet",
    "Faster": "Hurtigere",
    "Features": "Funktioner",
    "Feedback submitted": "Feedback indsendt",
    "File size": "Filstørrelse",
    "Filter": "Filter",
    "Filter by": "Sorter efter",
    "Filter by:": "Sorter efter:",
    "Filter labels list": "Filtrer etiketliste",
    "Find and address violations relating to your content guides and regulatory compliance and find outdated content across your website.": "Find og adressér overtrædelser relateret til dine indholdsvejledninger og overholdelse af lovgivningen, og find forældet indhold på tværs af dit websted.",
    "Find word(s) without specific context": "Find ord uden specifik kontekst",
    "Firefox add-on": "Firefox-tilføjelse",
    "First Contentful Paint": "First Contentful Paint",
    "First Meaningful Paint": "First Meaningful Paint",
    "First name": "Fornavn",
    "Fixed": "Rettede",
    "Fixed or ignored violations": "Rettede eller ignorerede overtrædelser",
    "Flesch Kincaid": "Flesch Kincaid",
    "For this domain": "For dette domæne",
    "Form": "Form",
    "Form fields": "Formularfelter",
    "Forms": "Formularer",
    "Found": "Fandt",
    "Four times a day": "Fire gange om dagen",
    "Frames": "Rammer",
    "Friday": "Fredag",
    "From 2 seconds to 8 seconds": "Fra 2 sekunder til 8 sekunder",
    "Generating report": "Genererer rapport",
    "Get advice on how to handle this check": "Få råd om, hvordan du håndterer dette check",
    "Getting {{ logs }} out of {{totalLogs}} logs": "Finder {{logs}} ud af i alt {{totalLogs}} logfiler",
    "Global - All Domains": "Global - Alle domæner",
    "Global Policies": "Globale policies",
    "Global Policy Dashboard": "Dashboard over globale policies",
    "Global Policy List": "Liste over globale policies",
    "Go to Global Policy List": "Gå til liste med globale policies",
    "Go to My Exports": "Gå til Mine Eksporter",
    "Go to PDFs": "Gå til PDF-filer",
    "Go to Policy List": "Gå til Liste over Policies",
    "Go to broken Links": "Gå til døde links",
    "Go to broken images": "Gå til døde billeder",
    "Go to broken links": "Gå til døde links",
    "Go to checkpoints": "Gå til checkpoints",
    "Go to data issues": "Gå til Data Privacy-problemer",
    "Go to domain": "Gå til domæne",
    "Go to help center": "Gå til hjælp",
    "Go to mispellings": "Gå til stavefejl",
    "Go to misspellings": "Gå til stavefejl",
    "Go to most visits pages": "Gå til sider med flest besøg",
    "Go to page": "Gå til side",
    "Go to page details": "Gå til sideoplysninger",
    "Go to potential misspellings": "Gå til potentielle stavefejl",
    "Go to predefined url": "Gå til foruddefineret url",
    "Go to the dashboard": "Gå til dashboard",
    "Go to traffic sources overview": "Gå til oversigt over trafikkilder",
    "Go to uptime": "Gå til oppetid",
    "Go to visitor overview": "Gå til oversigt over besøgende",
    "Good job! No incidents was registered": "Godt arbejde! Ingen hændelser blev registreret",
    "Good job! No issues were found": "Godt arbejde! Ingen problemer blev fundet",
    "Good job! No violations were found": "Godt arbejde! Ingen overtrædelser blev fundet",
    "Google": "Google",
    "Greater than 8 seconds": "Mere end 8 sekunder",
    "Grid View": "Gittervisning",
    "Groups": "Grupper",
    "Guidelines": "Retningslinier",
    "Guidelines for WCAG 2.0": "Retningslinjer for WCAG 2.0",
    "Guidelines for WCAG 2.1": "Retningslinjer for WCAG 2.1",
    "H1 on this page": "H1 på denne side",
    "HTML": "HTML",
    "HTML Pages": "HTML-sider",
    "HTML pages": "HTML-sider",
    "HTML snippet": "HTML-kodestykke",
    "HTML snippet affecting compliance level": "HTML-kodestykke, der påvirker compliance niveau",
    "HTML snippet failing check": "HTML-kodestykke med fejlende check",
    "Hard": "Svært",
    "Hard to read text. Example: popular science magazines and easier academic publications": "Teksten er svær at læse. Eksempel: populærvidenskabelige magasiner og lettere akademiske publikationer",
    "Harmony CMS": "Harmony CMS",
    "Header type": "Header-type",
    "Headers": "Headers",
    "Headlinks": "Hovedlinks",
    "Heartbeat": "Heartbeat",
    "Heartbeat Downtime": "Heartbeat Downtime",
    "Heartbeat Response Time": "Heartbeat-svartid",
    "Heartbeat status saved": "Heartbeat-status gemt",
    "Heatmaps": {
      "$$noContext": "Heatmaps",
      "Topmenu": "Heatmaps"
    },
    "Help Center": "Hjælpecenter",
    "Help center": "Hjælpecenter",
    "High": "Høj",
    "High impact": "Høj effekt",
    "High impact opportunities": "Muligheder med stor påvirkning",
    "High priority": "Høj prioritet",
    "High severity": "Høj sværhedsgrad",
    "High severity issues": "Problemer med høj sværhedsgrad",
    "Highest level of readability. Example: complex academic and legal texts": "Højeste læsbarhed. Eksempel: komplekse akademiske og juridiske tekster",
    "History": "Historie",
    "Hit": "Hit",
    "Hits": "Hits",
    "Hits across all domains and modules": "Hits på tværs af alle domæner og moduler",
    "Hits on domain": "Hits på domæne",
    "Home": "Hjem",
    "Host": "Host",
    "Hosts": "Hosts",
    "Hosts cannot be empty": "Hosts kan ikke være tomme",
    "Hours": "Timer",
    "How often the page is checked": "Hvor ofte siden gennemgås",
    "How to fix this problem": "Sådan løses dette problem",
    "How to prevent": "Sådan forhindres",
    "How to setup this policy": "Sådan sætter du denne policy op",
    "IFrames": "IFrammes",
    "IP address": "IP-adresse",
    "Icon": "Ikon",
    "Icon status": "Ikonstatus",
    "Identifier": "Identifikator",
    "Ignore": "Ignorer",
    "Ignore check": "Ignorer check",
    "Ignore misspelling": "Ignorer stavefejl",
    "Ignore on the page": "Ignorer på siden",
    "Ignore on this page": "Ignorer på denne side",
    "Ignore this SEO issue": "Ignorer dette SEO-problem",
    "Ignore this check": "Ignorer dette check",
    "Ignore this check for this domain": "Ignorer dette check for dette domæne",
    "Ignored": "Ignoreret",
    "Ignored Misspellings": "Ignoreret stavefejl",
    "Ignored Policies": "Ignorerede policies",
    "Ignored checks": "Ignorerede checks",
    "Ignored issue": "Ignoreret problem",
    "Ignored policies": "Ignorerede policies",
    "Ignoring broken link": "Ignorer broken link",
    "Image": "Billede",
    "Image Links": "Billedlink",
    "Image sources that will be fixed": "Billedkilder, der vil blive rettet",
    "Images": "Billeder",
    "Import rules": "Importregler",
    "Import rules from CSV": "Importer regler fra CSV",
    "Important Highlights": "Vigtige højdepunkter",
    "Important Notifications": "Vigtige meddelelser",
    "Important notification:": "Vigtig meddelelse:",
    "In compliance": "I compliance",
    "In progress of ignoring/reviewing all": "Igang med at ignorere / gennemgå alle",
    "Inactive": "Inaktiv",
    "Incidents": "Hændelser",
    "Includes both documents and pages": "Inkludere både dokumenter og sider",
    "Incoming Links": "Indgående links",
    "Incoming links": "Indgående links",
    "Indicates the difficulty to fix an audit error": "Angiver vanskeligheden ved at rette en audit fejl",
    "Indicates when some parts of the domain are not scanned due to Constraints / Exclusions being applied": "Angiver, hvornår nogle dele af domænet ikke scannes på grund af begrænsninger / udelukkelser, der anvendes",
    "Individual issues": "Enkeltstående problemer",
    "Information": "Information",
    "Information about this Check is not yet available": "Oplysninger om dette check er endnu ikke tilgængeligt",
    "Information and the operation of user interface must be understandable.": "Oplysninger og driften af user-infterfacet skal være forståelig.",
    "Information and user interface components must be presentable to users in ways they can perceive.": "Informationer og brugergrænseflader skal kunne præsenteres for brugerne på måder, hvor de kan opfatte dem.",
    "Inline Images": "Inline-billeder",
    "Inline images": "Integrerede billeder",
    "Input selector*": "Indsæt selector *",
    "Input user data": "Indtast brugerdata",
    "Internal": "Intern",
    "Internal Export": "Intern eksport",
    "Internal PDF Compliance": "Intern PDF-compliance",
    "Internal PDFs": "Interne PDF-filer",
    "Internal URLs": "Interne URL'er",
    "Inventory": "Indholdsoverblik",
    "Inventory Documents Export": "Eksport af indholdsoverblik",
    "Inventory History": "Historisk overblik over indhold",
    "Invite to new project": "Inviter til nyt projekt",
    "Is not a valid url": "Er ikke en gyldig url",
    "Is not crawling automatically": "Crawler ikke automatisk",
    "Is not tagged": "Er ikke mærket",
    "Issue": "Problem",
    "Issue changes": "Problemændringer",
    "Issue changes since previous crawl": "Problemer med ændringer siden forrige crawl",
    "Issue name": "Problem navn",
    "Issue type": "Problem type",
    "Issues": "Problemer",
    "Issues by Severities": "Problemer rangeret efter alvorlighed",
    "Issues changes since previous crawl": "Problemer med ændringer siden forrige gennemgang",
    "JS": "JS",
    "JavaScript": "JavaScript",
    "Javascript": "JavaScript",
    "Javascript crawl": "Javascript-crawl",
    "KB": "KB",
    "Keyword": "Nøgleord",
    "Knowledge Base": {
      "$$noContext": "Vidensbase",
      "Topmenu": "Vidensbase"
    },
    "LIX": "LIX",
    "Label": "Label",
    "Label created": "Label oprettet",
    "Label name": "Labelnavn",
    "Label overlay": "Label-overlay",
    "Label preview": "Eksempelvisning af label",
    "Label updated": "Label opdateret",
    "Labels": "Labels",
    "Language": "Sprog",
    "Language Detected": "Sprog fundet",
    "Languages": "Sprog",
    "Languages found": "Sprog fundet",
    "Last Scan": "Sidste scanning",
    "Last check: [[lastCheckTime]]": "Sidste check: [[lastCheckTime]]",
    "Last check: [[performanceScannedAt]]": "Sidste check: [[performanceScannedAt]]",
    "Last downtime:": "Sidste nedetid:",
    "Last load time": "Sidste indlæsningstid",
    "Last name": "Efternavn",
    "Last run": "Sidst kørt",
    "Last run [[date]]": "Sidste kørsel [[date]]",
    "Last run:": "Sidst kørt:",
    "Last scan": "Sidste scanning",
    "Last scan never": "Sidste scanning aldrig",
    "Last scan: [[duration]] ago": "Sidste scanning: [[duration]] siden",
    "Latest Updated PageCorrects": "Sidste opdaterede PageCorrects",
    "Latest login": "Seneste login",
    "Least Popular Pages": "Mindst populære sider",
    "Less than 10": "Mindre end 10",
    "Less than 100": "Mindre end 100",
    "Less than 2 seconds": "Mindre end 2 sekunder",
    "Less than 50": "Mindre end 50",
    "Level": "Niveau",
    "Level A": "Niveau A",
    "Level A Issues": "Niveau A-problemer",
    "Level A accessibility checks": "Niveau A tilgængelighedschecks",
    "Level A compliance": "Compliance for niveau A",
    "Level A failing checks": "Fejl for niveau A",
    "Level AA": "Niveau AA",
    "Level AA Issues": "Niveau AA-problemer",
    "Level AA accessibility checks": "Tilgængeligheds-checks for niveau AA",
    "Level AA compliance": "Compliance for niveau AA",
    "Level AA failing checks": "Fejl på niveau AA",
    "Level AAA": "Niveau AAA",
    "Level AAA Issues": "Niveau AAA-problemer",
    "Level AAA accessibility checks": "Tilgængelighedschecks på niveau AAA",
    "Level AAA compliance": "Compliance for Level AAA",
    "Level AAA failing checks": "Fejl på niveau AAA",
    "Level [[level]]": "Niveau [[level]]",
    "Levels": "Niveauer",
    "Likelihood": "Sandsynlighed",
    "Likelihood unspecified": "Uspecificeret sandsynlighed",
    "Link": "Link",
    "Link Type": "Link type",
    "Link excludes": "Link indeholder ikke",
    "Link fixes": "Link rettelser",
    "Link is broken": "Link er ødelagt",
    "Link of page": "Link til side",
    "Link to image": "Link til billede",
    "Linkedin": "Linkedin",
    "Links": "Links",
    "Links To Documents Export": "Links til eksport af dokumenter",
    "Links from other account domains": "Links fra andre kontodomæner",
    "Links from own domain": "Links fra eget domæne",
    "Links with policy matches": "Links med policy matches",
    "Links with the rel=\\\"nofollow\\\" attribute will not pass link equity/SEO value to the linked page. This can be used for pages with user generated comments where you want to avoid that a competitor posts a comment with a link to their own website thus benefiting from your original content. This is not an \\\"error\\\" per se but make sure that the link does not have this attribute as a result of an error.": "Links med attributten rel=\\\"nofollow\\\" bidrager ikke med SEO-værdi til den side, der linkes til. Det bruges eksempelvis til sider med brugergenererede kommentarer, hvor du ønsker at undgå, at en konkurrent får fordel af at linke til deres egen side og på den måde drager nytte af dit originale indhold. Der er ikke tale om en fejl, men du bør sørge for, at dit link ikke ved en fejl indeholder attributten rel=\\\"nofollow\\\".",
    "List": "Liste",
    "List of accessibility issues": "Liste over problemer med tilgængelighed",
    "List of all labels": "Liste over alle etiketter",
    "List of checks with and without issues": "Liste over checks med og uden problemer",
    "List of content containing links": "Liste over indhold, der indeholder links",
    "List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)": "Liste over lokation for alle dine aktiver på webstedet (dvs. docs, links, e-mailadresser, kodestykker osv.)",
    "List view": "Listevisning",
    "Lists all profiles available for your account": "Liste over alle tilgængelige profiler på din konto",
    "Load Times Trend": "Load times trend",
    "Loading domains, please wait": "Indlæser domæner, vent venligst",
    "Loading new domain": "Indlæser nyt domæne",
    "Loading times": "Indlæsningstider",
    "Locale": "Landeversion",
    "Location": "Beliggenhed",
    "Location not found": "Placering ikke fundet",
    "Locations": "Placeringer",
    "Log out": "Log ud",
    "Login Type": "Login Type",
    "Long": "Lang",
    "Lookup in Google": "Slå op på Google",
    "Low": "Lav",
    "Low impact": "Lav effekt",
    "Low impact opportunities": "Muligheder med lav effekt",
    "Low priority": "Lav prioritet",
    "Low severity": "Lav sværhedsgrad",
    "Low severity issues": "Problemer med lav sværhedsgrad",
    "MB": "MB",
    "META content": "META-indhold",
    "META name/property": "META-navn/egenskab",
    "Main-Thread Blocking Time": "Tid til blokering af hovedtråd",
    "Mark 403 as broken link": "Marker 403 som ødelagt link",
    "Mark all as reviewed/ignored": "Marker alle som gennemgået / ignoreret",
    "Mark as fixed": "Marker som rettet",
    "Mark as ignored": "Marker som ignoreret",
    "Mark as not fixed": "Marker som ikke rettet",
    "Marked as fixed": "Markeret som rettet",
    "Marked as reviewed": "Markeret som gennemgået",
    "Marking broken link as fixed": "Markerer ødelagt link som fikset",
    "Match": "Match",
    "Match rule": "Match-regel",
    "Matches": "Matches",
    "Max": "Maksimum",
    "Max scanned pages": "Maks. scannede sider",
    "Measure from": "Mål fra",
    "Measure from:": "Mål fra:",
    "Measurement Settings": "Måleindstillinger",
    "Measurements since [[date]]": "Målinger siden [[date]]",
    "Medium": "Mellem",
    "Medium complexity of text. Example: newspapers and magazines": "Mellem tekstkompleksitet. Eksempel: aviser og magasiner",
    "Medium impact": "Mellem effekt",
    "Medium impact opportunities": "Mellemstore muligheder for påvirkning",
    "Medium priority": "Mellem-prioritet",
    "Medium severity": "Medium sværhedsgrad",
    "Medium severity issues": "Problemer med middel sværhedsgrad",
    "Meta Header Expr": "Meta header-udtryk",
    "Meta Name": "Meta Navn",
    "Metadata": "Metadata",
    "Metadata key": "Metadata-nøgle",
    "Milliseconds": "Millisekunder",
    "Minimum words": "Minimum ord",
    "Minutes": "Minutter",
    "Minutes of slow response before you get an email": "Minutter med langsom responstid, før du får en e-mail",
    "Mispelling": "Stavefejl",
    "Misspelling": "Stavefejl",
    "Misspelling affecting the most content": "Stavefejl, der påvirker mest indhold",
    "Misspellings": "Stavefejl",
    "Misspellings history": "Stavefejls historik",
    "Mobile": "Mobil",
    "Moderate": "Moderat",
    "Module": "Modul",
    "Monday": "Mandag",
    "Monitoring": "Overvågning",
    "Monthly": "Månedlige",
    "Months": "Måneder",
    "More info": "Mere info",
    "More than": "Mere end",
    "More than [[count]]": "Mere end [[count]]",
    "Most Downloads": "Flest downloads",
    "Most Frequent": "Mest hyppige",
    "Most Popular Pages": "Mest populære sider",
    "Most common SEO checkpoint needing review": "Mest hyppige SEO-check, der kræver gennemgang",
    "Most common language": "Mest almindelige sprog",
    "Most common misspellings": "Mest almindelige stavefejl",
    "Most common opportunities found": "Mest almindelige muligheder fundet",
    "Most common policy violation on this domain": "Mest hyppige policy-overtrædelse på dette domæne",
    "Most common potential misspellings": "Mest almindelige potentielle stavefejl",
    "Most common readability level": "Mest almindelige læsbarhedsniveau",
    "Most of your pages have the readability level": "De fleste af dine sider har læsbarhedsniveauet",
    "Most pages have this readability level": "De fleste sider har dette læsbarhedsniveau",
    "Most prominent issues ranked by severity level": "Mest fremtrædende problemer rangeret efter sværhedsgrad",
    "Most serious issues found": "Mest alvorlige problemer fundet",
    "Most visited pages": "Mest besøgte sider",
    "Move focus down on domain picker": "Flyt fokus ned på domænevælgeren",
    "Move focus up on domain picker": "Flyt fokus op på domænevælgeren",
    "Multiline": "Multiline",
    "My Exports": "Min eksport",
    "My profile": "Min profil",
    "N/A": "Ikke relevant",
    "NA": "Ikke relevant",
    "NB! Connection Settings cannot be edited after save": "NB! Forbindelsesindstillinger kan ikke redigeres efter gemning",
    "NOTE: If you want to copy the Legacy Script. Click {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}here{{anchorEnd}}.": "OBS: Ønsker du at gøre brug af den tidligere udgave af scriptet? Klik {{anchorStart}} role=\\\"button\\\" ng-click=\\\"vm.openLegacy()\\\" {{gt}}her{{anchorEnd}}.",
    "Name": "Navn",
    "Network not found": "Netværket blev ikke fundet",
    "Network speed": "Netværkshastighed",
    "Network speed:": "Netværkshastighed:",
    "Never": "Aldrig",
    "Never scanned": "Aldrig scannet",
    "New": "Ny",
    "New Performance Page": "Ny Performance-side",
    "New Policy": "Ny Politik",
    "New password": "Nyt kodeord",
    "Next": "Næste",
    "No Broken Links marked as Fixed": "Ingen døde links er markeret som rettet",
    "No CSS": "Ingen CSS",
    "No Content links": "Ingen indholdslinks",
    "No Data available for selected time frame": "Ingen data tilgængelige for den valgte tidsramme",
    "No Documents found": "Ingen dokumenter fundet",
    "No Domains or Groups are yet selected for this report": "Der er endnu ikke valgt nogen domæner eller grupper til denne rapport",
    "No Frames": "Ingen frames",
    "No Frequency": "Ingen frekvens",
    "No HTML Pages found": "Ingen HTML-sider fundet",
    "No Historic data available for Accessibility Level [[lvl]]": "Ingen historiske data for tilgængelighedsniveau [[lvl]]",
    "No IFrames": "Ingen IFrames",
    "No Ignored Broken Links": "Ingen ignorerede døde links",
    "No Image Links found": "Intet billedlink fundet",
    "No PDF's failed": "Ingen PDF'er fejlede",
    "No PDF's pending": "Ingen PDF'er afventer",
    "No PDF's queued": "Ingen PDF er i kø",
    "No PDF's reviewed": "Ingen PDF'er er gennemgået",
    "No PDFs are reviewed": "Ingen PDF-filer gennemgås",
    "No Policies detected": "Ingen policies fundet",
    "No Profiles were found": "Ingen profiler blev fundet",
    "No Spreadsheet links found": "Ingen links til regneark fundet",
    "No Users are yet selected to receive this report": "Ingen brugere er endnu valgt til at modtage denne rapport",
    "No Word links found": "Ingen Word-links fundet",
    "No changes": "Ingen ændringer",
    "No changes found": "Fandt ingen ændringer",
    "No checks found for this Accessibility category": "Ingen checks fundet for denne tilgængelighedskategori",
    "No content policies have been created yet": "Ingen indholdspolicies er oprettet endnu",
    "No corrections added to PageCorrect": "Ingen rettelser føjet til PageCorrect",
    "No data available": "Ingen tilgængelig data",
    "No data present": "Ingen data til stede",
    "No diagnostics issues were found": "Fandt ingen diagnosticeringsproblemer",
    "No domains were found": "Ingen domæner blev fundet",
    "No downloads found": "Ingen downloads fundet",
    "No errors found": "Ingen fejl fundet",
    "No exemptions added to this checkpoint": "Ingen undtagelser tilføjet til dette check",
    "No exports available": "Ingen eksporter tilgængelige",
    "No groups were found for this domain": "Ingen grupper blev fundet for dette domæne",
    "No historic data available for this domain": "Ingen historiske data er tilgængelige for dette domæne",
    "No hits found": "Ingen hits fundet",
    "No ignored checks in this accessibility category": "Ingen ignorerede checks i denne tilgængelighedskategori",
    "No ignored misspellings found for this page": "Ingen ignorerede stavefejl fundet på denne side",
    "No incidents occurred in the selected time frame": "Der opstod ingen hændelser i den valgte tidsramme",
    "No issues found": "Ingen problemer fundet",
    "No javascript": "Intet JavaScript",
    "No name defined": "Intet navn defineret",
    "No new notifications": "Ingen nye notifikationer",
    "No note has been added": "Ingen note er tilføjet",
    "No notifications available": "Ingen notifikationer tilgængelige",
    "No opportunities were found": "Ingen muligheder blev fundet",
    "No outages in this period": "Ingen nedetid i denne periode",
    "No pages found": "Ingen sider fundet",
    "No pages were found": "Ingen sider blev fundet",
    "No passed checks in this accessibility category": "Ingen beståede checks i denne tilgængelighedskategori",
    "No performance scan found": "Ingen performance scan fundet",
    "No performance scans were found": "Ingen performance scan blev fundet",
    "No policies found": "Ingen policies fundet",
    "No readability score": "Ingen læsbarhedsscore",
    "No response received": "Intet svar modtaget",
    "No run present": "Ingen kørsel til stede",
    "No scan has yet been performed. Please check back later.": "Der er endnu ikke udført nogen scanning. Kom tilbage senere.",
    "No slide links found": "Ingen links til slideshows fundet",
    "No title found": "Ingen titel fundet",
    "No title found on one or more pages": "Ingen titel fundet på en eller flere sider",
    "No title is found on this page": "Ingen titel fundet på denne side",
    "No users available for this domain": "Ingen tilgængelige brugere for dette domæne",
    "No violations were found": "Ingen overtrædelser blev fundet",
    "No visitor profile selected": "Ingen besøgende-profil valgt",
    "No visits for this category in selected time frame": "Ingen besøg for denne kategori i den valgte tidsramme",
    "No words have been added to the default dictionary": "Ingen ord er føjet til standardordbogen",
    "No. Visits": "Antal besøg",
    "Non-user list": "Ikke-bruger liste",
    "None": "Ingen",
    "Normal - recommended": "Normal - anbefales",
    "Normal violations": "Normale overtrædelser",
    "Not case sensitive": "Ikke følsom for store og små bogstaver",
    "Not containing": "Indeholder ikke",
    "Not scheduled": "Ikke planlagt",
    "Not valid email": "Ikke gyldig e-mail",
    "Note": "Bemærk",
    "Notes": "Bemærkninger",
    "Notifications": "Notifikationer",
    "Number of characters in Meta Header text": "Antal tegn i Meta Header-tekst",
    "Number of characters in header text": "Antal tegn i overskriftstekst",
    "Number of characters in image text": "Antal tegn i billedtekst",
    "Number of characters in link text": "Antal tegn i linktekst",
    "Number of characters in page title": "Antal tegn i sidetitel",
    "Number of pages": "Antal sider",
    "Number too high": "Nummeret er for højt",
    "Number too low": "Nummer for lavt",
    "OK": "Okay",
    "Office 365 (BETA)": "Office 365 (BETA)",
    "Ok": "Okay",
    "Once a day": "En gang om dagen",
    "Once a week": "En gang om ugen",
    "One or more documents have already been scanned for compliance. Are you sure you want to scan the selected documents again?": "Et eller flere dokumenter er allerede blevet scannet for overholdelse af kravene. Er du sikker på, at du vil scanne de valgte dokumenter igen?",
    "One or more page on your website has the same H1 text.": "En eller flere sider på dit websted har den samme H1-tekst.",
    "One or more pages has been marked as no index": "En eller flere sider er markeret med intet indeks",
    "One or more pages on your website has this title": "En eller flere sider på dit websted har denne titel",
    "Open": "Åben",
    "Open Accessibility Decision Tree": "Åben beslutningstræ for tilgængelighed",
    "Open Data Privacy": "Åben Data Privacy",
    "Open Data Privacy Settings": "Åben indstillinger for Data Privacy",
    "Open Document Details": "Åben dokumentoplysninger",
    "Open Document details": "Åben dokumentoplysninger",
    "Open Fast Track for this HTML snippet": "Åben Fast Track for dette HTML-uddrag",
    "Open New Help Center": "Åben nyt hjælpecenter",
    "Open Page Details": "Åben sideoplysninger",
    "Open Schedule downtime": "Åben planlægning af nedetid",
    "Open document details": "Åben dokumentoplysninger",
    "Open domain policy": "Åben policy for domæne",
    "Open example": "Åben eksempel",
    "Open filters": "Åben filtre",
    "Open group": "Åben gruppe",
    "Open help center": "Åben Hjælp",
    "Open keyboard shortcuts": "Åben tastaturgenveje",
    "Open page details": "Åben sideoplysninger",
    "Open received reports": "Åben modtagne rapporter",
    "Open report": "Åben rapport",
    "Operating System": "Operativ system",
    "Operating Systems": "Operativsystemer",
    "Operating systems": "Operativsystemer",
    "Operating systems Overview": "Operativsystemer Oversigt",
    "Operator*": "Operatør*",
    "Opportunities": "Muligheder",
    "Opportunities by Priority": "Muligheder efter prioritet",
    "Optionally, you can select the primary language for the domain. If you choose English (UK), any text detected as English will be regarded as British English.": "Du kan eventuelt vælge det primære sprog for domænet. Hvis du vælger engelsk (UK), vil al tekst, der registreres som engelsk, blive betragtet som britisk engelsk.",
    "Options": "Muligheder",
    "Or": "Eller",
    "Organizations": "Organisationer",
    "Original Data": "Oprindelig data",
    "Other Documents": "Andre dokumenter",
    "Other files": "Andre filer",
    "Others": "Andre",
    "Our suggestion": "Vores forslag",
    "Our team has been notified of your request. We will soon be in touch.": "Vores team er blevet underrettet om din anmodning. Vi kontakter dig snarest.",
    "Outages during the selected time-frame": "Udfald i den valgte tidsramme",
    "Outages end": "Udfaldet slutter",
    "Outages start": "Udfaldet starter",
    "Outgoing Links": "Udgående links",
    "Outgoing links": "Udgående links",
    "Over 1000 ms.": "Over 1000 ms.",
    "Over 10000 ms.": "Over 10000 ms.",
    "Over 200 ms.": "Over 200 ms.",
    "Over 2000 ms.": "Over 2000 ms.",
    "Over 3000 ms.": "Over 3000 ms.",
    "Over 4000 ms.": "Over 4000 ms.",
    "Over 500 ms.": "Over 500 ms.",
    "Over 5000 ms.": "Over 5000 ms.",
    "Over 6000 ms.": "Over 6000 ms.",
    "Over 7000 ms.": "Over 7000 ms.",
    "Over 8000 ms.": "Over 8000 ms.",
    "Over 9000 ms.": "Over 9000 ms.",
    "Overall Data Privacy compliance for this page": "Overordnet compliance for Data Privacy på siden",
    "Overall PageCorrects": "Samlede PageCorrects",
    "Overall SEO compliance for this page": "Samlet SEO-compliance for denne side",
    "Overall accessibility compliance for this level": "Overordnet compliance for tilgængelighed på dette niveau",
    "Overall accessibility compliance level for this page": "Overordnet compliance for tilgængelighedsniveauet på denne side",
    "Overall compliance": "overordnet compliance",
    "Overall policy compliance for this page": "Overordnet compliance for policies på denne side",
    "Owner": "Ejer",
    "PAGE PERFORMANCE OVERVIEW": "OVERSIGT OVER PAGE PERFORMANCE",
    "PDF": "PDF",
    "PDF Compliance Status": "PDF-Compliance Status",
    "PDF Documents": "PDF-dokumenter",
    "PDF accessibility scan completed at [[date]]": "Scanning af PDF-tilgængelighed afsluttet [[date]]",
    "PDF accessibility scan requested": "Anmodning om scanning af PDF-tilgængelighed sendt",
    "PDF files": "PDF-filer",
    "PDF files pending": "PDF-filer afventende",
    "PDF files reviewed": "PDF-filer gennemgået",
    "PDF files that are reviewed or pending for accessibility": "PDF-filer, der er gennemgået eller afventer, for deres tilgængelighed",
    "PDFs": "PDF-filer",
    "POLICIES OVERVIEW": "POLICYOVERSIGT",
    "Page": "Side",
    "Page Dashboard": "Side Dashboard",
    "Page Details": "Sideoplysninger",
    "Page Performance": "Page Performance",
    "Page Statistics": "Sidestatistik",
    "Page URL": "Side URL",
    "Page Views": "Sidevisninger",
    "Page compliance": "Sidens compliance",
    "Page count in PDF": "Sidetælling i PDF",
    "Page dashboard": "Overblik over siden",
    "Page details": "Sideoplysninger",
    "Page first detected": "Siden blev først registreret",
    "Page links": "Sidelinks",
    "PageAssist Logo Position": "PageAssist-logo position",
    "PageAssist Theme": "PageAssist-tema",
    "PageCorrect": "PageCorrect",
    "PageCorrect Content": "PageCorrect-indhold",
    "PageCorrect Custom Phrase or Word": "PageCorrect brugerdefineret sætning eller ord",
    "PageCorrect Details": "PageCorrect detaljer",
    "PageCorrect Diagnostics": "PageCorrect diagnosticering",
    "PageCorrects categorized": "Kategoriserede PageCorrect-rettelser",
    "PageFixes": "PageFixes",
    "PageFixes Left": "PageFixes tilbage",
    "Pages": "Sider",
    "Pages & documents with confirmed misspellings, broken links or images": "Sider og dokumenter med bekræftede stavefejl, døde links eller billeder",
    "Pages Crawled": "Sider Crawlet",
    "Pages With Opportunities": "Sider med muligheder",
    "Pages and documents with policies marked as unwanted or required": "Sider og dokumenter med policies, der er markeret som uønskede eller påkrævede",
    "Pages crawled": "Sider Crawlet",
    "Pages failing check": "Sider, der ikke består check",
    "Pages in compliance": "Sider i compliance",
    "Pages related to policy link": "Sider relateret til link policy",
    "Pages that are difficult to read": "Sider, der er svære at læse",
    "Pages that are easily understood by children below 5'th grade": "Sider, der er let forståelige for børn under 5. klasse",
    "Pages that are easy to read. Conversational English for consumers": "Sider, der er lette at læse. Engelsk på samtaleniveau",
    "Pages that are fairly difficult to read": "Sider, der er vanskelige at læse",
    "Pages that are fairly easy to read": "Relativt letlæselige sider",
    "Pages that are in plain English. Easily understood by 13- to 15-year-old students": "Sider, der er på almindeligt engelsk. Let forstået af skoleelever fra 13 til 15 år",
    "Pages that are very difficult to read. Best understood by university graduates": "Sværtlæselige sider. Bedst forstået af universitetsuddannede",
    "Pages that are very easy to read. Easily understood by an average 11-year-old student": "Sider, der er meget nemme at læse. Kan forstås af en gennemsnitlig 11-årig skoleelev",
    "Pages we could not determine Readability score": "Sider, vi ikke kunne bestemme læsbarhedsscore",
    "Pages with Data Privacy issues": "Sider med Data Privacy-problemer",
    "Pages with Failing Checks": "Sider med fejlende checks",
    "Pages with Ignored Checks": "Sider med ignorerede checks",
    "Pages with Misspellings": "Sider med stavefejl",
    "Pages with Opportunities": "Sider med muligheder",
    "Pages with Policy Issues": "Sider med policy problemer",
    "Pages with QA Issues": "Sider med kvalitetssikrings-problemer",
    "Pages with QA issues": "Sider med kvalitetssikrings-problemer",
    "Pages with SEO Opportunities": "Sider med SEO-muligheder",
    "Pages with SEO opportunities": "Sider med SEO-muligheder",
    "Pages with accessibility checks not in compliance": "Sider med tilgængelighedschecks, der ikke overholder kravene",
    "Pages with failing checks": "Sider med fejlende checks",
    "Pages with high, medium or low opportunities": "Sider med høje, mellemstore eller lave muligheder",
    "Pages with ignored checks": "Sider med ignorerede checks",
    "Pages with issues": "Sider med problemer",
    "Pages with policy matches": "Sider med policy matches",
    "Pages with score:": "Sider med score:",
    "Pages with the \\\"noindex\\\" META tag will not be indexed by the search engines. This is not an \\\"error\\\" per se, but make sure that the page does not have this tag as a result of an error.": "Sider med meta-tagget \\\"noindex\\\" bliver ikke indekseret af søgemaskinerne. Det er ikke i sig selv en fejl, men vær sikker på, at tagget ikke er til stede på siden ved en fejl.",
    "Pages without H1 tags or with empty H1 tags that contain no value represent a failed SEO optimization opportunity.": "Sider uden H1-tags eller med tomme H1-tags, der ikke indeholder nogen værdi, repræsenterer en mislykket SEO-optimeringsmulighed.",
    "Pages without Visits": "Sider uden besøg",
    "Pages without Visits in last 6 months": "Sider uden besøg i de sidste 6 måneder",
    "Pageviews": "Sidevisninger",
    "Part of downtime calculation": "En del af beregningen af nedetid",
    "Part of heatmap Rules": "En del af Heatmap-reglerne",
    "Part of success criteria [[checkIssueNumber]]": "Del af succeskriteriet [[checkIssueNumber]]",
    "Pass Example": "Godkendt Eksempel",
    "Passed": "Godkendt",
    "Passed ([[audits]])": "Bestået ([[audits]])",
    "Passed Checks": "Beståede checks",
    "Passed Policy checks": "Beståede policy tjek",
    "Passed checks": "Beståede checks",
    "Passed policy checks": "Beståede policy tjek",
    "Password": "Adgangskode",
    "Password Confirmation": "Bekræftelse af adgangskode",
    "Password confirmation": "Bekræftelse af adgangskode",
    "Password to login": "Adgangskode til login",
    "Passwords does not match": "Adgangskoder stemmer ikke overens",
    "Path constraints": "Sti-begrænsninger",
    "Path template": "Skabelon til sti",
    "Pending": "Afventer",
    "Pending PDF review": "Afventer PDF-gennemgang",
    "Pending PDF reviews": "Afventende PDF-gennemgange",
    "Percentage shows number of pages that are compliant with all Data Privacy checks": "Procentdelen viser antallet af sider, der er i overensstemmelse med alle Data Privacy-checks",
    "Percentage shows number of pages that are compliant with all SEO checks": "Procentdelen viser antallet af sider, der overholder alle SEO-tjek",
    "Performance": "Ydeevne",
    "Performance Errors": "Performance Fejl",
    "Performance Pages": "Performance Sider",
    "Performance Profiles": "Performance Profiler",
    "Performance Score": "Performance Score",
    "Performance score": "Performance score",
    "Personal": "Personlig",
    "Personal information": "Personlig information",
    "Phone": "Telefon",
    "Pie": "Lagkage",
    "Pin domain": "Pin domæne",
    "Ping intervals": "Ping-intervaller",
    "Play": "Afspil",
    "Play misspelling": "Afspil stavefejl",
    "Please choose a trademark": "Vælg et varemærke",
    "Please insert correct URL:": "Indsæt korrekt URL:",
    "Please insert the correct word:": "Indsæt det rigtige ord:",
    "Please insert the missing ALT text:": "Indsæt den manglende ALT-tekst:",
    "Please select a module": "Vælg et modul",
    "Please select the module that you want to create a Source Code Exclude for": "Vælg det modul, som du ønsker at oprette en kildekodeeksklusion for",
    "Please specify word or phrase to search for": "Angiv ord eller sætning, du vil søge efter",
    "Please use CSS selectors to identify form fields and buttons": "Brug venligst CSS-selectors til at identificere formularfelter og -knapper",
    "Please wait": "Vent venligst",
    "Please wait - Adding word to dictionary": "Vent venligst - Tilføjer ord til ordbogen",
    "Please wait - Adding words to dictionary": "Vent venligst - Tilføjer ord til ordbogen",
    "Please wait - Confirming misspelling": "Vent venligst - Bekræfter stavefejl",
    "Please wait - exporting audit log &nbsp;": "Vent venligst - eksporterer ændringshistorik & nbsp;",
    "Policies": "Policies",
    "Policies - required": "Policies - påkrævede",
    "Policies - violations": "Policies - overtrædelser",
    "Policies marked as required or unwanted": "Policies markeret som påkrævet eller uønsket",
    "Policies violations": "Overtrædelser af policies",
    "Policies with most matches": "Policies med flest matches",
    "Policies with violations": "Policies med overtrædelser",
    "Policy": "Policy",
    "Policy Diagnostics": "Diagnosticering af policies",
    "Policy Distribution": "Fordeling af policies",
    "Policy Hits": "Policy Hits",
    "Policy Issues": "Problemer med policies",
    "Policy List": "Policy liste",
    "Policy Pages": "Policy-sider",
    "Policy Running": "Policy kører",
    "Policy errors": "Policyfejl",
    "Policy hits per domain": "Policy-hits per domæne",
    "Policy in queue": "Policy i kø",
    "Policy info": "Policy-info",
    "Policy note": "Policy-note",
    "Policy rules": "Policy-regler",
    "Policy scan in progress": "Policy-scanning er i gang",
    "Policy setup": "Policy-opsætning",
    "Policy violations": "Typiske policy-overtrædelser",
    "Policy with matching terms": "Policy med matchende vilkår",
    "Potential Misspelling": "Potentiel stavefejl",
    "Potential Misspellings": "Potentielle stavefejl",
    "Potential Savings": "Potentielle besparelser",
    "Potential misspelling": "Potentiel stavefejl",
    "Potential misspellings": "Potentielle stavefejl",
    "Potential misspellings found": "Potentielle stavefejl fundet",
    "Powered by Google Lighthouse": "Kører på Google Lighthouse",
    "Prefix path": "Præfiks-sti",
    "Presence": "Tilstedeværelse",
    "Previous": "Tidligere",
    "Principle 1: Perceivable": "Princip 1: Opfattelig",
    "Principle 2: Operable": "Princip 2: Betjenes",
    "Principle 3: Understandable": "Princip 3: Forståelig",
    "Principle 4: Robust": "Princip 4: Robust",
    "Principle 5: Conformance": "Princip 5: Overensstemmelse",
    "Print view": "Udskrivningsvisning",
    "Priorities": "Prioriteter",
    "Prioritized Content": "Prioriteret indhold",
    "Priority": "Prioritet",
    "Profile": "Profil",
    "Profile Description": "Profilbeskrivelse",
    "Profile Dropdown": "Profil dropdown",
    "Profile Menu": "Profilmenu",
    "Profile Name": "Profil navn",
    "Profile details": "Profiloplysninger",
    "Profile updated": "Profil opdateret",
    "QA": "Kvalitetssikring",
    "QA Issues": "Kvalitetssikrings-problemer",
    "QA errors": "Kvalitetssikrings-fejl",
    "QUALITY ASSURANCE": "Kvalitetssikring",
    "QUALITY ASSURANCE OVERVIEW": "OVERSIGT OVER KVALITETSSIKRING",
    "Quality Assurance": "Kvalitetssikring",
    "Quality Assurance Check": "Kvalitetssikring",
    "Quality Assurance Diagnostics": "Diagnosticering af kvalitetssikring",
    "Quality Assurance Export summary": "Eksport med overblik over kvalitetssikring",
    "Quality Assurance errors": "Kvalitetssikringsfejl",
    "Quality assurance": "Kvalitetssikring",
    "Queued": "I kø",
    "Quick Guide": "Hurtig guide",
    "Quick help": "Hurtig hjælp",
    "Quick info:": "Hurtig info:",
    "Re-scanning of issues for this page has started and will be finished in a few minutes.": "Genscanning af problemer for denne side er startet og afsluttes om få minutter.",
    "Readability": "Læsbarhed",
    "Readability Score": "Læsbarhedsscore",
    "Readability by score": "Læsbarhed efter score",
    "Readability levels": "Læsbarhedsniveauer",
    "Readability score": "Læsbarhedsscore",
    "Readability scores across all web pages (based on": "Læsbarhedsscore på tværs af alle websider (baseret på",
    "Readability test": "Test af læsbarhed",
    "Receive report": "Modtag rapport",
    "Received reports": "Modtagne rapporter",
    "Referring Information": "Information om referring",
    "Referring visits": "Referring",
    "Regex": "Regex",
    "Regulation": "Lovgivning",
    "Remember me": "Husk mig",
    "Remove": "Fjern",
    "Remove Custom Multistep Javascript": "Fjern Custom Multistep Javascript",
    "Remove Extension Name": "Fjern fil-typer",
    "Remove Page": "Fjern side",
    "Remove Profile": "Fjern profil",
    "Remove Rule": "Fjern regel",
    "Remove checkpoint": "Fjern kontrolpunktet",
    "Remove domain": "Fjern domæne",
    "Remove domain group": "Fjern domænegruppe",
    "Remove from dictionary": "Fjern fra ordbogen",
    "Remove group": "Fjern gruppe",
    "Remove rule": "Fjern regel",
    "Remove this IP address?": "Fjern denne IP-adresse?",
    "Remove this pattern?": "Fjern dette mønster?",
    "Remove this word from dictionary": "Fjern dette ord fra ordbogen",
    "Render pages and execute JS while crawling": "Vis sider, og kør JS, mens crawl kører",
    "Repeat": "Gentag",
    "Replace Rule": "Udskift regel",
    "Report": "Rapport",
    "Report administration": "Administrer rapporter",
    "Report overview:": "Rapport oversigt:",
    "Request PDF scan for all documents": "Anmod om PDF-scanning for alle dokumenter",
    "Requests": "Anmodninger",
    "Required": "Påkrævet",
    "Required content": "Påkrævet indhold",
    "Required count": "Antal påkrævede",
    "Rescan": "Scan igen",
    "Rescanning": "Genscanning",
    "Reset": "Nulstil",
    "Reset Preferences": "Nulstil præferencer",
    "Resolution": "Opløsning",
    "Resource Type": "Ressource type",
    "Response Time": "Responstid",
    "Response code": "Responsekode",
    "Response time": "Responstid",
    "Response time (Milliseconds)": "Svartid (millisekunder)",
    "Response time notification": "Svartids-notifikation",
    "Response time notification threshold": "Grænseværdi for svartidsnotifikation",
    "Return to heartbeat overview": "Vend tilbage til Heartbeat-overblik",
    "Returning customer": "Tilbagevendende kunde",
    "Reverting state": "Vend tilbage til tilstanden",
    "Review": "Gennemgå",
    "Reviewed": "Gennemgået",
    "Reviewed/Ok": "Gennemgået/ok",
    "Revoke token": "Tilbagekald token",
    "Robot Info": "Robotinfo",
    "Role": "Rolle",
    "Rule": "Regel",
    "Rule name": "Regelnavn",
    "Rule operator": "Regeloperatør",
    "Rule to match": "Regel at matche",
    "Rules": "Regler",
    "Run Policy": "Kør policy",
    "Run policy": "Kør policy",
    "Run policy again": "Kør policy igen",
    "Running": "Kører",
    "SEO": "SEO",
    "SEO (Search Engine Optimization)": "SEO (søgemaskineoptimering)",
    "SEO Checkpoints": "SEO kontrolpunkter",
    "SEO Diagnostics": "SEO-diagnostik",
    "SEO Issues": "SEO-problemer",
    "SEO OVERVIEW": "SEO OVERSIGT",
    "SEO Opportunities": "SEO muligheder",
    "SEO errors": "SEO-fejl",
    "SEO impact": "SEO-påvirkning",
    "SEO opportunities": "SEO-muligheder",
    "SEO opportunities - high priority": "SEO-muligheder - høj prioritet",
    "SEO opportunities - low priority": "SEO-muligheder - lav prioritet",
    "SEO opportunities - medium priority": "SEO muligheder - mellem prioritet",
    "SEO opportunities - technical SEO issues": "SEO muligheder - tekniske SEO spørgsmål",
    "SEO opportunities found": "Fundne SEO-muligheder",
    "SHOW LIST VIEW": "VIS LISTEVISNING",
    "STATISTICS OVERVIEW": "STATISTIKOVERSIGT",
    "Saturday": "Lørdag",
    "Save": "Gem",
    "Save Preferences": "Gem indstillinger",
    "Save and close": "Gem og luk",
    "Save policy": "Gem policy",
    "Scan": "Scan",
    "Scan documents": "Scan dokumenter",
    "Scan frequency": "Scanningsfrekvens",
    "Scan frequency:": "Scanningsfrekvens:",
    "Scan in progress": "Scanning er i gang",
    "Scan in progress:": "Scanning er i gang:",
    "Scan is done": "Scanningen er udført",
    "Scan subdomains": "Scan underdomæner",
    "Scanned at": "Scannet",
    "Scanned content": "Scannet indhold",
    "Scanned links:": "Scannede links:",
    "Scanned pages": "Scannede sider",
    "Scanned pages:": "Scannede sider:",
    "Scanning URL:": "Scanner URL:",
    "Scanning in progress": "Scanning er i gang",
    "Schedule Report": "Planlæg rapport",
    "Schedule supplemental reports to be delivered with each scan": "Planlæg supplerende rapporter, der skal leveres med hver scanning",
    "Scheduled": "Planlagt",
    "Scheduled Reports": "Planlagte rapporter",
    "Scopes": "Omfang",
    "Score": "Score",
    "Screen Resolutions": "Skærmopløsninger",
    "Screen Resolutions Overview": "Oversigt over skærmopløsninger",
    "Script Evaluation": "Evaluering af script",
    "Script Parse": "Fortolkning af script",
    "Script installed": "Script installeret",
    "Script installed on Domain": "Script installeret på domæne",
    "Script setup guide": "Vejledning til opsætning af script",
    "Search Engine Optimization": "Søgemaskine optimering",
    "Search Engine Optimization (SEO)": "Søgemaskineoptimering (SEO)",
    "Search Engines": "Søgemaskiner",
    "Search engine": "Søgemaskine",
    "Search engines": "Søgemaskiner",
    "Search for Pages": "Søg efter sider",
    "Search for file size that is": "Søg efter filstørrelse",
    "Search for image size that is": "Søg efter billedstørrelse",
    "Search for links, that are associated with class names and contains below mentioned class names.": "Søg efter links, der er knyttet til class-navn og indeholder nedenstående class-navne.",
    "Search for page titles or URLs across all domains": "Søg efter sidetitler eller URL'er på tværs af alle domæner",
    "Search for pages": "Søg efter sider",
    "Search icon": "Søg ikon",
    "Search in: Documents": "Søg i: Dokumenter",
    "Search in: Everything": "Søg i: Alt",
    "Search in: Links": "Søg i: Links",
    "Search in: Only HTML pages": "Søg i: Kun HTML-sider",
    "Search pages across all domains": "Søg på sider på alle domæner",
    "Search...": "Søg...",
    "Searches": "Søgninger",
    "Seconds": "Sekunder",
    "See API Token": "Se API-token",
    "See Details": "Se detaljer",
    "See changes": "Se ændringer",
    "See details": "Se detaljer",
    "See pages": "Se sider",
    "Select Domain and Module to get the Insights": "Vælg Domæne og modul for at få indsigt",
    "Select Domain on domain picker": "Vælg Domæne på domænevælger",
    "Select Page to scan": "Vælg side, der skal scannes",
    "Select a domain and recipients": "Vælg et domæne og modtagere",
    "Select a domain or group": "Vælg et domæne eller gruppe",
    "Select a profile": "Vælg en profil",
    "Select account": "Vælg konto",
    "Select all items": "Vælg alle",
    "Select domain": "Vælg domæne",
    "Select domains and groups": "Vælg domæner og grupper",
    "Select filters": "Vælg filtre",
    "Select import": "Vælg import",
    "Select item": "Vælg emne",
    "Select login type*": "Vælg login type *",
    "Select timezone": "Vælg tidszone",
    "Select users": "Vælg brugere",
    "Select what type of content the policy should search in": "Vælg hvilken type indhold policy'en skal søge i",
    "Select whether the rule should search for case sensitive text or not": "Vælg, om reglen skal søge efter store og små bogstaver eller ej",
    "Select your export file": "Vælg din eksportfil",
    "Send an email if the site is down": "Send en e-mail, hvis siden er nede",
    "Send an email if the site is slow to respond": "Send en e-mail, hvis webstedet svarer langsomt",
    "Send message": "Send besked",
    "Send report": "Send rapport",
    "Send welcome mail on creation": "Send velkomstmail ved oprettelsen",
    "Set a default value for selector": "Indstil en standardværdi for selectoren",
    "Set as Default": "Indstillet som standard",
    "Set to fixed": "Marker som rettet",
    "Settings": {
      "$$noContext": "Indstillinger",
      "Topmenu": "Indstillinger"
    },
    "Setup your domain": "Opsæt dit domæne",
    "Severity": "Alvorlighed",
    "Severity level": "Alvorlighedsniveau",
    "Short": "Kort",
    "Short Description": "Kort beskrivelse",
    "Should we check the page's current status?": "Skal vi kontrollere sidens aktuelle status?",
    "Show Details": "Vis detaljer",
    "Show all": "Vis alt",
    "Show documents with this email": "Vis dokumenter med denne e-mail",
    "Show history": "Vis historie",
    "Show label dropdown": "Dropdown til at vise labels",
    "Show less": "Vis mindre",
    "Show more": "Vis mere",
    "Show on global policy list": "Vis på den globale policy-liste",
    "Show pages": "Vis sider",
    "Show pages with issues": "Vis sider med problemer",
    "Show pages with this SEO issue": "Vis sider med dette SEO-problem",
    "Show pages with this email": "Vis sider med denne e-mail",
    "Show pages with this image": "Vis sider med dette billede",
    "Show pages with this link": "Vis sider med dette link",
    "Show pages with this misspelling": "Vis sider med denne stavefejl",
    "Show policy hits per domain": "Vis policy hits per domæne",
    "Show policy info": "Vis info om denne policy",
    "Show the Domain Picker": "Vis domænevælgeren",
    "Show/Hide filter selector": "Vis / skjul filtervælger",
    "Show/Hide the Domain Picker": "Vis / skjul domænevælgeren",
    "Shows the remaining number of Performance Profiles that can be created for this account": "Viser det resterende antal Performance Profiler, der kan oprettes til denne konto",
    "Side Navigation": "Side navigation",
    "Single line": "Enkelt linje",
    "Size": "Størrelse",
    "Skip to content": "Fortsæt til indhold",
    "Slide links": "Slide links",
    "Slides": "Slides",
    "Slow": "Langsom",
    "Snippet": "Kodevisning",
    "Social": "Social",
    "Social Networks": "Sociale netværk",
    "Social visits": "Sociale netværks besøg",
    "Source Code Exclude": "Ekskluderet kildekode",
    "Source Code Excludes": "Ekskluderede kildekoder",
    "Source code": "Kildekode",
    "Spellcheck": "Stavekontrol",
    "Spellcheck Export Summary": "Stavekontrol Eksportoversigt",
    "Spellcheck Summary": "Oversigt over stavekontrol",
    "Spelling": "Stavning",
    "Spelling Errors used": "Brugte stavefejl",
    "Spelling fixes": "Stavefejlrettelser",
    "Spelling ignore capitalized words": "Stavekontrol ignorerer store bogstaver",
    "Spreadsheet links": "Regneark-links",
    "Spreadsheets": "Regneark",
    "Start PDF accessibility scan": "Start PDF-tilgængelighedsscanning",
    "Start at": "Start ved",
    "Start compound export": "Start samlet eksport",
    "Start date": "Start dato",
    "Start export": "Start eksport",
    "Start export Pages With Specific Link": "Start eksport af Sider med specifikt link",
    "Start new scan": "Start ny scanning",
    "Start on demand scan": "Start on demand-scanning",
    "Start time": "Starttidspunkt",
    "Starts with": "Starter med",
    "State": "Stat",
    "Statistic": "Statistik",
    "Statistics": "Statistik",
    "Statistics excluded IP addresses": "IP-adresser udelukket i statistik",
    "Status": "Status",
    "Stop current crawl": "Stop det aktuelle crawl",
    "Sub Navigation": "Undermenu",
    "Submit selector*": "Indsend selector *",
    "Succeeds": "Med succes",
    "Success criteria": "Succeskriterier",
    "Suggestions and ideas": "Forslag og ideer",
    "Summarized pages and documents count": "Opsummering af antal sider og dokumenter",
    "Summary": "Resumé",
    "Sunday": "Søndag",
    "Switch account": "Skift konto",
    "Table View": "Tabelvisning",
    "Tags": "Tags",
    "Target": "Target",
    "Technical": "Tekniske",
    "Technical SEO Issues": "Tekniske SEO-problemer",
    "Text": "Tekst",
    "Text Documents": "Tekstdokumenter",
    "Text documents": "Tekstdokumenter",
    "Text to match": "Tekst der skal matches",
    "Text:": "Tekst:",
    "The Checkpoint [[checkpoint]] will be updated with data after next crawl": "Checket [[checkpoint]] opdateres med data efter næste gennemgang",
    "The Document is not tagged": "Dokumentet er ikke tagget",
    "The Path template for Umbraco CMS": "Sti-skabelonen til Umbraco CMS",
    "The Requested Page is not a part of the Performance Module": "Den anmodede side er ikke en del af Performance-modulet",
    "The Scan will take effect within the next few hours": "Scanningen træder i kraft inden for de næste par timer",
    "The URL for this page is too long": "URL'en til denne side er for lang",
    "The base url to the CMS page": "Basis url til CMS-siden",
    "The bounce rate tells you the number of visits who only see the one page they started on": "Bounce raten fortæller dig antallet af besøg, der kun ser den side, de startede på",
    "The following rules will be removed, are you sure you want to continue with this change?": "Følgende regler vil blive fjernet, er du sikker på, at du ønsker at fortsætte med denne ændring?",
    "The header 1 (H1) tag is important as it helps search engines and users to understand what content they can expect to find on the page.": "Overskrift 1 (H1-tagget) er vigtigt, da det hjælper søgemaskiner og brugere med at forstå, hvilket indhold de kan forvente at finde på siden.",
    "The likelihood of this being a Data Privacy issue": "Sandsynligheden for, at dette er et Data Pricacy-problem",
    "The lowest level of readability. Example: children's books": "Det laveste niveau af læsbarhed. Eksempel: børnebøger",
    "The meta description on this page is too long": "Metabeskrivelsen på denne side er for lang",
    "The meta description on this page is too short": "Metabeskrivelsen på denne side er for kort",
    "The misspelling will first show up after a new scan": "Stavefejlen registreres først efter en ny scanning",
    "The name of a meta entry (page metadata)": "Navnet på en meta entry (sidens metadata)",
    "The optional base url to the CMS page": "Den valgfri basis-URL til CMS-siden",
    "The privacy of your personal data is very important to us. Because of this, we have updated our data protection and privacy policy. In order to continue using our platform, we kindly ask that you read and accept the new data protection and data policy terms.": "Fortroligheden af dine personlige data er meget vigtig for os. På grund af dette har vi opdateret vores databeskyttelses- og privatlivspolitik. For at fortsætte med, at bruge vores platform beder vi dig om, at læse og acceptere de nye vilkår for databeskyttelse og datapolitik.",
    "The scan can take a few hours/days to finalise, depending on the size of the website": "Scanningen kan afhængigt af størrelsen på webstedet tage et par timer / dage at færdiggøre",
    "The scan can take a few hours/days to finalise, depending on the size of the website.<br><br>Are you sure you want to start on-demand scan?": "<br><br>Scanningen kan afhængigt af størrelsen på webstedet tage et par timer / dage at færdiggøre.   Er du sikker på, at du vil starte on-demand scanning?",
    "The scan can take a few minutes to finalise, depending on the size of the page": "Scanningen kan afhængigt af sidens størrelse tage et par minutter at gennemføre",
    "There are no META descriptions on one or more pages": "Der er ingen META-beskrivelser på en eller flere sider",
    "There are no domains assigned to this policy. Save policy anyway?": "Policyen er ikke tildelt nogen domæner. Gem policy alligevel?",
    "There are no more errors for this Snippet": "Der er ikke flere fejl til dette uddrag",
    "There are no sub headlines on one or more pages": "Der er ingen underoverskrifter på en eller flere sider",
    "There are zero META keywords on this page": "Der er nul META-nøgleord på denne side",
    "There is no H1 on one or more pages": "Der er ingen H1 på en eller flere sider",
    "There is no H1 on this page": "Der er ingen H1 på denne side",
    "There is no META descriptions on this page": "Der er ingen META-beskrivelser på denne side",
    "There is no historic data for domain groups": "Der er ingen historiske data for domænegrupper",
    "There is no historic data for this domain": "Der er ingen historiske data for dette domæne",
    "There is no sub headlines on this page": "Der er ingen underoverskrifter på denne side",
    "These are findings that cannot be automatically checked and must be reviewed manually": "Dette er fund, der ikke kan kontrolleres automatisk og skal gennemgås manuelt",
    "These are findings which are likely to be errors, requiring manual confirmation": "Dette er fund, der sandsynligvis er fejl, men som kræver manuel bekræftelse",
    "These findings are confirmed errors": "Disse fund er bekræftede fejl",
    "Third-Party": "Tredje part",
    "This field is required": "Feltet er påkrævet",
    "This is the time between when an outage is first detected and when a notification is sent.": "Dette tidspunktet, hvor en nedetid først registreres, og hvor en meddelelse sendes.",
    "This is useful if you have defined timeslots for maintenance.": "Dette er nyttigt, hvis du har defineret tidsrummet for nedetid pga. vedligeholdelse.",
    "This issue is ignored": "Dette problem ignoreres",
    "This link is marked as broken because it took more than 30 seconds to load": "Dette link er markeret som ødelagt, fordi det tog mere end 30 sekunder at indlæse",
    "This page has been marked as no index": "Denne side er markeret som no index",
    "This page has no meta description": "Denne side har ingen metabeskrivelse",
    "This page has no meta keywords": "Denne side har ingen meta-nøgleord",
    "This page has not been assigned to the Performance Module": "Denne side er ikke sat op til Performance-modulet",
    "This page is missing a title": "Denne side mangler en titel",
    "This policy is scheduled": "Denne policy er planlagt",
    "This rule doesn't contain any matches": "Denne regel indeholder ingen matches",
    "This section lists requirements for <a target='_blank' href='https://www.w3.org/TR/WCAG21/#dfn-conform'>conformance</a> to WCAG 2.1. It also gives information about how to make conformance claims, which are optional.": "<a target=\"_blank\" href=\"https://www.w3.org/TR/WCAG21/#dfn-conform\"></a>Dette afsnit indeholder krav til overensstemmelse  til WCAG 2.1. Det indeholder også oplysninger om, hvordan man fremsætter krav om overholdelse, som er valgfri.",
    "Thursday": "Torsdag",
    "Time": "Tid",
    "Time Spent": "Tid brugt",
    "Time To Interactive": "Time to Interactive",
    "Time to Warning *": "Tid til advarsel *",
    "Timeframe:": "Tidsramme:",
    "Timeline": "Tidslinje",
    "Timezone": "Tidszone",
    "Title": "Titel",
    "Title & description": "Titel og beskrivelse",
    "Title and URL": "Titel og URL",
    "Title and url": "Titel og URL",
    "To setup this policy, you need to tell us how long your max word length is": "For at opsætte denne policy skal du fortælle os, hvor lang din maksimale ordlængde er",
    "To setup this policy, you need to tell us which brand name should end with TM or ™": "For at opsætte denne policy skal du fortælle os, hvilket varemærke der skal ende med TM eller ™",
    "To toggle Quick Search:": "Sådan skifter du hurtig søgning:",
    "Toggle Dropdown": "Dropdown til ændringer",
    "Toggle dropdown": "Skift rullemenu",
    "Toggle notes": "Skift noter",
    "Toggle show filters": "Skift viste filtre",
    "Too few characters": "For få tegn",
    "Too many characters": "For mange tegn",
    "Top keywords": "Top søgeord",
    "Total": "Total",
    "Total CPU Time": "Samlet CPU-tid",
    "Total QA issues": "Samlede QA-problemer",
    "Total Visitors": "Samlede antal besøgende",
    "Total Visits": "Samlede antal besøg",
    "Total amount of content": "Samlet mængde indhold",
    "Total crawled": "Samlet crawlet",
    "Total number of issues": "Samlet antal problemer",
    "Total number of issues across all modules": "Samlet antal problemer på tværs af alle moduler",
    "Total page views over the last 30 days": "Samlet sidevisning i løbet af de sidste 30 dage",
    "Total pages:": "Antal sider i alt:",
    "Total visitors": "Antal besøgende",
    "Total visitors from Referrers": "Samlede antal besøgende fra henvisere",
    "Total visitors from Search Engines": "Samlede antal besøgende fra søgemaskiner",
    "Total visits": "Antal besøg",
    "Total visits from Referrers": "Antal besøg fra henvisere",
    "Total visits from Search Engines": "Antal besøg fra søgemaskiner",
    "Total visits in the last 30 days:": "Antal besøg i de sidste 30 dage:",
    "Total words": "Antal ord",
    "Track changes across domains and modules": "Spor ændringer på tværs af domæner og moduler",
    "Traffic Sources": "Trafikkilder",
    "Traffic Sources Summary": "Oversigt over trafikkilder",
    "Traffic sources": "Trafikkilder",
    "Transfer Size": "Overførselsstørrelse",
    "Tuesday": "Tirsdag",
    "Twice a day": "To gange om dagen",
    "Twitter": "Twitter",
    "Type": "Type",
    "Type the key for the metadata": "Indtast nøglen til metadataene",
    "Type the text to match rule": "Skriv teksten, der skal matche regel",
    "Type*": "Type*",
    "URL": "URL",
    "URL must start with a protocol. Ex. http://....": "URL skal starte med en protokol. Eks. http: // ....",
    "URL to redirect to if form is valid": "URL, der skal omdirigeres til, hvis formularen er gyldig",
    "URL:": "URL:",
    "Unable to read link": "Kan ikke læse linket",
    "Unarchive": "Fjern arkivering",
    "Undetermined": "Ubestemt",
    "Undo": "Fortryd",
    "Undo review": "Fortryd review",
    "Unignore": "Ignorer ikke længere",
    "Unignore check": "Fjern ignorering af dette check",
    "Unignore misspelling": "Fjern ignoreringen af stavefejlen",
    "Unignore on this page": "Fjern ignoreringen af denne side",
    "Unignore this SEO issue": "Fjern dette SEO-problem",
    "Unignore this check for this domain": "Fjern ignoreringen af dette check for dette domæne",
    "Unique Visitors": "Unikke besøgende",
    "Unique downloads": "Unikke downloads",
    "Unknown": "Ukendt",
    "Unknown Score": "Ukendt score",
    "Unknown title": "Ukendt titel",
    "Unpin domain": "Frigør domæne",
    "Unsaved changes": "Ikke-gemte ændringer",
    "Unwanted": "Uønsket",
    "Unwanted content": "Uønsket indhold",
    "Unwanted violations": "Uønskede overtrædelser",
    "Update": "Opdatering",
    "Update groups": "Opdater grupper",
    "Updated": "Opdateret",
    "Updated At": "Opdateret kl",
    "Updated at": "Opdateret kl",
    "Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Opdatering af grupper kan tage mere end 30 minutter. Under opdateringen vil du ikke kunne oprette og opdatere grupper.",
    "Upload CSV": "Upload CSV",
    "Upload csv file": "Upload csv-fil",
    "Uptime": "Oppetid",
    "Uptime last 30 days": "Oppetid sidste 30 dage",
    "Url*": "URL *",
    "Use * as a wildcard (ex. 192.168.1.*). Excluded IP addresses will only affect new visitors": "Brug * som et jokertegn (f.eks. 192.168.1. *). Ekskluderede IP-adresser påvirker kun nye besøgende",
    "Use language attribute": "Brug sprogattribut",
    "Use or Apply custom PageCorrect": "Brug eller anvend tilpasset PageCorrect",
    "User": "Bruger",
    "User Export": "Brugereksport",
    "User List": "Brugerliste",
    "User Loading Experience": "Brugerindlæsningsoplevelse",
    "User information": "Brugeroplysninger",
    "User interface components and navigation must be operable.": "Brugergrænsefladekomponenter og navigation skal kunne betjenes.",
    "User is account administrator": "Bruger er kontoadministrator",
    "Username": "Brugernavn",
    "Value": "Værdi",
    "Value*": "Værdi*",
    "Vat no": "CVR-nr",
    "Verify URL*": "Bekræft URL *",
    "Very easy": "Meget let",
    "Very hard": "Meget svær",
    "View options": "Indstillinger of visning",
    "Viewing as Profile:": "Viser som profil:",
    "Views": "Visninger",
    "Violation": "Overtrædelse",
    "Violation count": "Antal overtrædelser",
    "Violation's info_type name not set": "Overtrædelsens info_type navn er ikke indstillet",
    "Violations": "Overtrædelser",
    "Visible": "Synlig",
    "Visible modules": "Synlige moduler",
    "Visit the affected image": "Se det berørte billede",
    "Visitor Overview": "Oversigt over besøgende",
    "Visitor Summary": "Resumé af besøgende",
    "Visitor log": "Log over besøgende",
    "Visitor profile": "Profil af besøgende",
    "Visitor profile:": "Profil af besøgende:",
    "Visitors": "Besøgende",
    "Visitors Summary": "Oversigt over besøgende",
    "Visits": "Besøg",
    "Visual mode": "Visuel tilstand",
    "WCAG 2.0 (Level A)": "WCAG 2.0 (niveau A)",
    "WCAG 2.0 (Level AA)": "WCAG 2.0 (niveau AA)",
    "WCAG 2.0 (Level AAA)": "WCAG 2.0 (niveau AAA)",
    "WCAG 2.0 Accessibility Compliance": "Overholdelse af WCAG 2.0 tilgængelighed",
    "WCAG 2.1 (Level A)": "WCAG 2.1 (niveau A)",
    "WCAG 2.1 (Level AA)": "WCAG 2.1 (niveau AA)",
    "WCAG 2.1 (Level AAA)": "WCAG 2.1 (niveau AAA)",
    "WCAG 2.1 Accessibility Compliance": "Compliance af WCAG 2.1 tilgængelighed",
    "Want to search for": "Søg efter",
    "Warning": "Advarsel",
    "We recommend that all your pages has a number of relevant meta keywords.": "Vi anbefaler, at alle dine sider har et antal relevante meta keywords.",
    "We recommend that all your pages has a relevant and unique meta description.": "Vi anbefaler, at alle dine sider har en relevant og unik metabeskrivelse.",
    "We recommend that all your pages has an unique title.": "Vi anbefaler, at alle dine sider har en unik titel.",
    "We recommend that the meta description consists of at least 50 characters.": "Vi anbefaler, at metabeskrivelsen består af mindst 50 tegn.",
    "We recommend that the meta description consists of no more than 160 characters.": "Vi anbefaler, at metabeskrivelsen ikke består af mere end 160 tegn.",
    "We recommend that you give each page a unique title.": "Vi anbefaler, at du giver hver side en unik titel.",
    "We recommend that you have a unique H1 tag on each page.": "Vi anbefaler, at du har et unikt H1-tag på hver side.",
    "We recommend that you have at least one H2-H6": "Vi anbefaler, at du har mindst en H2-H6",
    "We recommend that you have no more than 100 internal links on each page.": "Vi anbefaler, at du ikke har mere end 100 interne links på hver side.",
    "We recommend that you keep your URL below 200 characters.": "Vi anbefaler, at du holder din URL under 200 tegn.",
    "We recommend that you only have one H1 tag on each page.": "Vi anbefaler, at du kun har et H1-tag på hver side.",
    "Wednesday": "Onsdag",
    "Weekly": "Ugentlig",
    "Well done - no accessibility issues found": "Godt gået - ingen tilgængelighedsproblemer fundet",
    "We’ve Updated our Privacy Policy!": "Vi har opdateret vores privatlivspolitik!",
    "Why is this an issue": "Hvorfor er dette et problem?",
    "With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go": "Med Fast Track kan du rette, gennemgå og ignorere HTML-uddrag på berørte sider, på én gang",
    "Word": "Ord",
    "Word Count": "Antal ord",
    "Word count": "Antal ord",
    "Word count in PDF": "Antal ord i PDF",
    "Word is added to dictionary": "Ordet er føjet til ordbogen",
    "Word is added to dictionary for all languages": "Order er føjet til ordbogen for alle sprog",
    "Word is confirmed as misspelling": "Ordet er bekræftet som stavefejl",
    "Word length": "Ordlængde",
    "Word links": "Word-links",
    "Word or Phrase": "Ord eller sætning",
    "Words": "Ord",
    "Would you like to update now? Updating groups can take more than 30 minutes. During the operation you will not be able to create and update groups": "Vil du opdatere nu? Opdatering af grupper kan tage mere end 30 minutter. Under opdateringen vil du ikke kunne oprette og opdatere grupper",
    "Written by: [[author]]": "Skrevet af: [[author]]",
    "Years": "År",
    "You are about to delete": "Du er ved at slette",
    "You are about to delete the domain": "Du er ved at slette domænet",
    "You are about to delete the domain group": "Du er ved at slette domænegruppen",
    "You are currently using Demo Data, certain features will be unavailable": "Du bruger i øjeblikket demo-data, visse funktioner vil ikke være tilgængelige",
    "You are receiving this report": "Du modtager denne rapport",
    "You can create another [[customerProfilesLimit]] profiles for your account": "Du kan oprette en anden [[customerProfilesLimit]]-profil til din konto",
    "You can pin this domain. Pinned domains will be shown at the top of your domain list": "Du kan fastgøre dette domæne. Fastgjorte domæner vises øverst på din domæneliste",
    "You have more than one H1 tag on this page": "Du har mere end én H1-overskrift på denne side",
    "You have no H2-H6 tags on the page": "Du har ingen H2-H6-tags på siden",
    "You have no available profiles": "Du har ingen tilgængelige profiler",
    "You have not received any reports": "Du har ikke modtaget nogen rapporter",
    "You have one or more pages with the \\\"noindex\\\" META tag": "Du har en eller flere sider med meta-tagget \\\"noindex\\\"",
    "You have reached the maximum number of profiles for this account.": "Du har nået det maksimale antal profiler for denne konto.",
    "You have too many internal links": "Du har for mange interne links",
    "You will receive an email when the export is ready.": "Du modtager en e-mail, når eksporten er klar.",
    "Your Users Technology": "Din brugers teknologi",
    "Zero links were found": "Der blev fundet nul links",
    "Zip code": "Postnummer",
    "achieved": "opnået",
    "affected image": "Berørt billede",
    "and": "og",
    "and does not conform with": "og er ikke i overensstemmelse med",
    "contact": "kontakt",
    "contains": "Indeholder",
    "content": "indhold",
    "diagnostics_errors.csv": "diagnosticering_errors.csv",
    "diagnostics_passed.csv": "diagnostics_passed.csv",
    "disabling": "deaktivering",
    "document": "dokument",
    "documents": "dokumenter",
    "done": "færdig",
    "enabling": "muliggør",
    "ends_with": "slutter_med",
    "excluded": "udeladt",
    "go to the matched link": "gå til det matchede link",
    "image": "Billede",
    "included": "inkluderet",
    "insert brand name": "Indsæt navn på brand",
    "insert context fx. us": "indsæt kontekst fx. os",
    "insert max word length": "indsæt maks. ordlængde",
    "insert word fx. contact": "indsæt ord fx. kontakt",
    "is": "er",
    "is_exactly": "is_exactly",
    "language": "sprog",
    "link": "link",
    "match (regex)": "Match (regex)",
    "metadata": "metadata",
    "milliseconds": "Millisekunder",
    "minutes": "minutter",
    "n/a": "Ikke relevant",
    "not": "ikke",
    "opportunities_errors.csv": "opportunities_errors.csv",
    "opportunities_passed.csv": "opportunities_passed.csv",
    "overall compliance": "overordnet compliance",
    "pages": "sider",
    "path": "sti",
    "please type": "skriv venligst",
    "reviewed": "gennemgået",
    "rows - click to change": "rækker - klik for at ændre",
    "search engines overview": "søgemaskine oversigt",
    "should always be followed by": "skal altid følges af",
    "social network overview": "sociale netværks oversigt",
    "starts_with": "starter_med",
    "that": "som",
    "title": "Titel",
    "to confirm this action": "for at bekræfte denne handling",
    "to fix": "at fikse",
    "url": "url",
    "us": "os",
    "visits": "Besøg",
    "you have one or more pages that contains links with rel=\\\"nofollow\\\"": "Du har en eller flere sider med links, som indeholder attributten rel=\\\"nofollow\\\"",
    "{{ pagesDone }} Pages ({{ compliancePercentage }}) in compliance": "{{pagesDone}} sider ({{compliancePercentage}}) i compliance",
    "{{ totalPageIssues }} Pages ({{ compliancePercentage }}) to fix": "{{totalPageIssues}} sider ({{compliancePercentage}}), der skal rettes",
    "[[label]]: [[value]] Pages": "[[label]]: [[value]] Sider",
    "[[label]]: [[value]]ms": "[[label]]: [[value]] ms",
    "[[languageName]] ([[languageCount]])": "[[languageName]] ([[languageCount]])",
    "[[ms]] ms": "[[ms]] ms",
    "[[name]] have already been scanned for compliance. Are you sure you want to scan it again?": "[[name]] er allerede scannet for compliance. Er du sikker på, at du vil scanne den igen?",
    "[[pageCount]] Pages": "[[pageCount]] sider",
    "[[pageCount]] pages found with this issue": "[[pageCount]] sider fundet med dette problem",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.0[[spanEnd]] (niveau A)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (niveau AA)",
    "[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.0[[spanEnd]] (niveau AAA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)": "[[spanStart]]WCAG 2.1[[spanEnd]] (niveau A)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (niveau AA)",
    "[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)": "[[spanStart]]WCAG 2.1[[spanEnd]] (niveau AAA)",
    "1 word found": [
      "1 ord fundet",
      "[[$count | monNumber]] ord fundet"
    ],
    "You have 1 to do": [
      "Du har 1 problem at rette op på",
      "Du har [[issues]] problemer at rette op på"
    ],
    "page": "side",
    "Are you sure you want to remove Custom PageCorrect? <br> Please type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Er du sikker på, at du ønsker at slette en brugerdefineret PageCorrect-rettelse?  Skriv venligst [[deleteTag]]Delete[[deleteTagEnd]] i feltet for at bekræfte handlingen.",
    "You are about to remove PageCorrect for this check <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du er i gang med at slette en PageCorrect-rettelse for dette check  Skriv venligst [[deleteTag]]Delete[[deleteTagEnd]] i feltet for at bekræfte handlingen.",
    "You are about to remove PageCorrect for this misspelling <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du er i gang med at slette en PageCorrect-rettelse for denne stavefejl  Skriv venligst [[deleteTag]]Delete[[deleteTagEnd]] i feltet for at bekræfte handlingen.",
    "You are about to remove PageCorrect for this [[type]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du er i gang med at slette PageCorrect for typen [[type]] Skriv venligst [[deleteTag]]Delete[[deleteTagEnd]] i feltet for at bekræfte handlingen.",
    "You are about to remove [[titleTag]][[title]][[titleTagEnd]] <br> Please Type [[deleteTag]]Delete[[deleteTagEnd]] to confirm this action": "<br>Du er i gang med at slette [[titleTag]][[title]][[titleTagEnd]]  Skriv venligst [[deleteTag]]Delete[[deleteTagEnd]] i feltet for at bekræfte handlingen.",
    "Are you sure you want to revoke the token for API User [[apiUserId]]<br><strong>Note</strong> A new token will be created in it's place": "<br><strong></strong>Er du sikker på, at du vil tilbagetrække token for API-brugeren [[apiUserId]]OBS Et nyt token vil blive genereret i stedet for",
    "Maximum critical path latency: <strong>[[latency]] ms </strong>": "<strong></strong>Maksimal latenstid for den kritiske sti: [[latency]] ms ",
    "Are you sure you want to remove <code>all</code> [[type]] PageCorrects? <br> Please type <code>Delete</code> to confirm this action": "<code></code><br><code></code>Er du sikker på at du ønsker at fjerne all [[type]] PageCorrect-rettelser?  Skriv venligst Delete i feltet for at bekræfte handlingen",
    "<strong>[[checkName]]</strong><br><br>Add reason (Optional)": "<strong></strong><br><br>[[checkName]]Tilføj begrundelse (valgfrit)",
    "Are you sure you want to confirm the misspelling <strong>' + word.word + '</strong>?": "<strong></strong>Er du sikker på, at du ønsker bekræfte ordet ' + word.word + ' som stavefejl?",
    "Are you sure you want to delete the policy <strong>[[policyName]]</strong>": "<strong></strong>Er du sikker på, du ønsker at slette policy'en [[policyName]]?",
    "Are you sure you want to mark the policy <strong>[[policyName]]</strong> as fixed?": "<strong></strong>Er du sikker på, at du vil markere denne policy [[policyName]] som rettet?",
    "Are you sure you want to remove Heatmap Rule from <strong>[[pageUrl]]</strong>": "<strong></strong>Er du sikker på, at du ønsker at fjerne denne Heatmap-regel fra [[pageUrl]]?",
    "Are you sure you want to remove the rule <strong>' + rule.name + '</strong>?": "<strong></strong>Er du sikker på, at du ønsker at fjerne reglen ' + rule.name + '?",
    "Are you sure you want to run the policy <strong>' + policy.name + '</strong>?": "<strong></strong>Er du sikker på, at du ønsker at køre denne policy ' + policy.name + '?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong> again?": "<strong></strong>Er du sikker på, at du ønsker at køre denne policy [[policyName]] igen?",
    "Are you sure you want to unignore the policy <strong>[[policyName]]</strong>?": "<strong></strong>Er du sikker på, at du ikke længere ønsker at ignorere policyen [[policyName]]?",
    "You currently have <strong>[[spellingFixes]]</strong> Spelling Errors corrections, we recommend that you keep this number to below <strong>[[spellingLimit]]</strong> to ensure the page displays without issue.": "<strong></strong><strong></strong>I øjeblikket har du [[spellingFixes]] stavefejl som bør rettes. Vi anbefaler, at du holder antallet under [[spellingLimit]], så du sikrer, at siden bliver vist uden fejl.",
    "You currently have <strong>[[totalFixes]]</strong> corrections, we recommend limiting your number of corrections to <strong>[[pageFixLimit]]</strong> to ensure optimum page performance, however, this is at your own discretion.": "<strong></strong><strong></strong>I øjeblikket har du [[totalFixes]] rettelser. Vi anbefaler, at du holder antallet af rettelser under [[pageFixLimit]], så du sikrer optimal ydeevne på din side. Det er dog op til dit eget skøn.",
    "[[users]]<strong>and [[userCountLeft]] more</strong>": "<strong></strong>[[users]]og [[userCountLeft]] yderligere",
    "Are you sure you want to ignore the policy <strong>[[policyName]]</strong>?": "<strong></strong>Er du sikker på, at du ønsker at ignorere policyen [[policyName]]?",
    "Title:": "Titel:",
    "[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]": "<strong></strong>[[msg]] [[regulationName]] resulterer i, at [[opposite]] regler for de følgende problemer bliver overskrevet. Det betyder, at de [[negate]] vil blive markeret ved fremtidige scanninger: [[list]]",
    "Admin only": "Kun admin",
    "Apply fix": "Brug rettelse",
    "Contains high, medium or low opportunities": "Indeholder høje, medium og lave muligheder",
    "Design": "Design",
    "Enable Custom PageCorrect Settings": "Tillad brugedefinerede PageCorrect-indstillinger",
    "Enable PageCorrect features below. Disabled features will not be shown on your dashboard.": "Tillad PageCorrect-valgmuligheder herunder. Fravalgte muligheder bliver ikke vist i dit Dasboard.",
    "Enable PageCorrect for Accessibility Source Codes": "Tillad PageCorrect-rettelser af tilgængeligheds-kildekoder",
    "Enable PageCorrect for Broken Links": "Tillad PageCorrect for døde links",
    "Enable PageCorrect for Misspellings": "Aktivér PageCorrect for stavefejl",
    "Enable PagedCorrect for Accessibility Checks": "Aktivér PagedCorrect for tilgængeligheds-checks",
    "Failing checks - A": "Fejlende checks - A",
    "Failing checks - AA": "Fejlende checks - AA",
    "Failing checks - AAA": "Fejlende checks - AAA",
    "Good job! Your domain contains no Accessibility Issues for this section": "Sådan! Dit domæne har ikke flere tilgængelighedsproblemer for den her sektion",
    "Indicates the difficulty to apply this fix": "Indikerer sværhedsgraden for at lave denne rettelse",
    "List of improvements that can be applied to your website to improve your Accessibility Compliance": "Liste over forbedringer, der kan anvendes på dit websted for at forbedre din compliance ift. tilgængelighed",
    "Manage": "Administrér",
    "Media": "Medier",
    "Open PageCorrect Settings": "Åben PageCorrect indstillinger",
    "PageCorrect Settings Updated": "PageCorrect indstillinger opdateret",
    "PageCorrect settings": "PageCorrect indstillinger",
    "Pages with Data Privacy violations": "Sider med Data Privacy-overtrædelser",
    "Should admin be the only one to set PageCorrect Settings": "Skal admin være den eneste, der indstiller PageCorrect-indstillinger",
    "Website Structure": "Webstedsstruktur",
    "Data Privacy violations": "Data Privacy-overtrædelser",
    "Heartbeat check": "Heartbeat-check",
    "Request PDF accessibility check from selection": "Anmod om scan af tilgængelighed af PDF ud fra valgte",
    "Total unique downloads": "Total af unikke downloads",
    "[[succeededPdfs]] out of [[pdfs]] PDF accessibility request succeeded": "[[successedPdfs]] ud af [[pdfs]] anmodninger om tilgængeligheds-scan af PDF lykkedes",
    "Accessibility Issues": "Tilgængelighedsproblemer",
    "Inspecting:": "Inspicering:",
    "Pages with Accessibility Issues": "Sider med tilgængelighedsproblemer",
    "Start advance export": "Start advanceret eksport",
    "Check whether your website is responding and measures the response times of the server": "Tjekker om dit websted responderer, og måler serverens svartider",
    "Search label": "Søgemærke",
    "Custom range": "Brugerdefineret",
    "Last Half Year": "Sidste halvår",
    "Last Month": "Sidste måned",
    "Last Quarter": "Sidste kvartal",
    "Last Week": "Sidste uge",
    "Last Year": "Sidste år",
    "Character": [
      "Tegn",
      "Tegn"
    ],
    "Image missing alt attribute": "Billede mangler alt-attribut",
    "Quick info here": "Hurtig forklaring",
    "There is 1 META description on this page": "Der er 1 META-beskrivelse på denne side",
    "There is 1 internal link on this page": [
      "Der er 1 internt link på denne side",
      "Der er [[$count | monNumber]] interne links på denne side"
    ],
    "There is one META description on this page": [
      "Der er én META-beskrivelse på denne side",
      "META beskrivelser på siden"
    ],
    "and 1 document": {
      "Documents with broken images": [
        "og 1 dokument",
        "␣og [[$count | monNumber]] dokumenter"
      ],
      "Documents with confirmed misspellings": [
        "og 1 dokument",
        "og [[$count | monNumber]] dokumenter"
      ],
      "Documents with potential misspellings": [
        "og 1 dokument",
        "og [[$count | monNumber]] dokumenter"
      ]
    },
    "and one document": {
      "Pages with broken links": [
        "og et dokument",
        "og [[$count | monNumber]] dokumenter"
      ]
    },
    "Remediation": "Rettelse",
    "Remediation quote": "Tilbud på rettelse",
    "Remediation quote has been requested": "Anmodning om tilbud på rettelse er sendt",
    "Sort by": {
      "Exchange center filter option": "Sorter efter"
    },
    "#idname.class-name1.class-name2": "# idname.class-name1.class-name2",
    "&lt;i&gt; tags as icons": "& lt; i & gt; tags som ikoner",
    ".class-name1": ".class-name1",
    "<strong>CSS styling for &lt;strong&gt; tag</strong> (turn all strong text red)": "<strong></strong> CSS-styling til strong-tag  (gør al fed tekst rødt)",
    "<strong>NOTE</strong>: Changing the text below, will override the text in all your included languages": "<strong></strong>OBS: Hvis du ændrer teksten nedenfor, tilsidesættes teksten på alle dine inkluderede sprog",
    "A newer version of PageAssist is available. Switch to version 2.0 to gain access to new customizations": "En nyere version af PageAssist er tilgængelig. Skift til version 2.0 for at få adgang til nye tilpasninger",
    "Accessibility Fixes": "Rettelser af tilgængelighed",
    "Add Policy": "Tilføj Politik",
    "Add a description of the widget to your users": "Tilføj en beskrivelse af widgeten til dine brugere",
    "Add comment (Optional)": "Tilføj kommentar (valgfrit)",
    "Add row": "Tilføj række",
    "Add text for when the button is hovered": "Tilføj tekst til, hvornår knappen er markeret",
    "Add title": "Tilføj titel",
    "Africa": "Afrika",
    "All <code>img</code> elements have an <code>alt</code> attribute": "<code></code><code></code>Alle  img  -elementer har en  alt  -attribut",
    "Alt text does not convey the same information as the image": "Alt-tekst overfører ikke de samme oplysninger som billedet",
    "Alt text for all <code>img</code> elements contains all text in the image unless the image text is decorative or appears elsewhere in the document": "<code></code>Alt-tekst til alle  img  -elementer indeholder al tekst i billedet, medmindre billedteksten er dekorativ eller vises andetsteds i dokumentet",
    "Alt text for all <code>img</code> elements is not placeholder text unless author has confirmed it is correct": "<code></code>Alt-tekst til alle  img  -elementer er ikke pladsholdertekst, medmindre forfatteren har bekræftet, at den er korrekt",
    "Alt text for all <code>img</code> elements is the empty string (\\\"\\\") if the image is decorative.": "<code></code>Alt-tekst til alle  img  -elementer er den tomme streng (\\ \"\\\"), hvis billedet er dekorativt.",
    "Alt text for all <code>img</code> elements used as source anchors is not empty when there is no other text in the anchor": "<code></code>Alt-tekst til alle  img  -elementer, der bruges som kildeankre, er ikke tom, når der ikke er nogen anden tekst i ankeret",
    "Alt text is not the same as the filename unless author has confirmed it is correct": "Alt-teksten er ikke den samme som filnavnet, medmindre forfatteren har bekræftet, at den er korrekt",
    "And how are we going to fix it?": "Og hvordan skal vi ordne det?",
    "Applying fix": "Anvender rettelse",
    "Are you sure you want to stop receiving this report?": "Er du sikker på, at du vil stoppe med at modtage denne rapport?",
    "Aria-label": "Aria-label",
    "Asia": "Asien",
    "Blink sample image": "Blink-prøvebillede",
    "Blink testing sample image": "Test af blink-prøvebillede",
    "Both of these problems can in practice cause multiple visual issues from wrong colours to awkward spaces where none should exist.": "Begge disse problemer kan i praksis forårsage flere visuelle problemer fra forkerte farver til akavede rum, hvor ingen skal eksistere.",
    "Bottom center": "Nederst i midten",
    "Bottom left": "Nederst til venstre",
    "Bottom right": "Nederst til højre",
    "Browse": "Gennemse",
    "Button hover message": "Besked ved hover på knap",
    "CSS selector": "CSS-selector",
    "Change <b> tags to a custom element": "Skift <b> tags til et tilpasset element",
    "Change <b> tags to a custom tag": "Skift <b> tags til et tilpasset tag",
    "Change <blink> tags to a custom element": "Skift <blink> tags til et tilpasset element",
    "Change <blink> tags to a custom tag": "Skift <blink> tags til et tilpasset tag",
    "Change <marquee> tags to a custom element": "Skift <marquee> -tags til et tilpasset element",
    "Change <marquee> tags to a custom tag": "Skift <marquee> -tags til et tilpasset tag",
    "Change your &lt;blink&gt; tags into something else": "Skift din & lt; blink & gt; tags til noget andet",
    "Change your &lt;i&gt; elements into something else": "Skift din & lt; i & gt; elementer til noget andet",
    "Change your &lt;marquee&gt; tags into something else": "Skift dit & lt; telt & gt; tags til noget andet",
    "Check for misspelling company name: [[company]]": "Kontroller, om firmanavn er stavet forkert: [[company]]",
    "Choose a tag to replace your b tags with": "Vælg et tag, du vil erstatte dine b-tags med",
    "Choose a tag to replace your blink tags with": "Vælg et tag, du vil erstatte dine blink-tags med",
    "Choose a tag to replace your italic tags with": "Vælg et tag, du vil erstatte dine kursive tags med",
    "Choose a tag to replace your marquee tags with": "Vælg et tag, du vil erstatte dine markeringsmærker med",
    "Choose an icon": "Vælg et ikon",
    "Choose this option to customise the fix": "Vælg denne mulighed for at tilpasse rettelsen",
    "Choose this option to customize the fix": "Vælg denne mulighed for at tilpasse rettelsen",
    "Choose your own text for the warning pop-up": "Vælg din egen tekst til pop-up advarslen",
    "Circle": "Cirkel",
    "Class": "Klasse",
    "Close PageCorrect form": "Luk Side Korrekt form",
    "Close [[groupName]]: [[labelName]]": "Luk [[groupName]]: [[labelName]]",
    "Company name *": "Firmanavn *",
    "Constraint:": "Begrænsning:",
    "Custom settings": "Brugerdefinerede indstillinger",
    "Default fix": "Standardrettelse",
    "Default language": "Standardsprog",
    "Dutch": "Hollandsk",
    "Edit Report": "Rediger rapport",
    "Education": "Uddannelse",
    "Element name is invalid": "Navn på element er ugyldigt",
    "Element name should not contain spaces": "Navn på element bør ikke indeholde mellemrum",
    "Enter aria-label name": "Indtast navnet på en aria-label",
    "Enter class name": "Indtast class-navn",
    "Enter role name": "Indtast navn på rolle",
    "Europe": "Europa",
    "Even though this is a pretty straightforward fix there are two ways this can cause some design problems on your website:": "Selvom denne løsning er lige til, er der to måder, hvor det kan forårsage designproblemer på dit websted:",
    "Example 1": "Eksempel 1",
    "Example 2": "Eksempel 2",
    "File must be below 1MB": "Filen skal være under 1 MB",
    "Filter dropdown": "Dropdown-filter",
    "Finance": "Finansiering",
    "Fix applied!": "Fix anvendt!",
    "Fix options": "Fix-muligheder",
    "French": "Fransk",
    "Give a title to your Skip to Content button": "Angiv en titel til din Spring til indhold-knap",
    "Government": "Regering",
    "Grid view": "Gittervisning",
    "Hide": "Skjul",
    "Hide text": "Skjul tekst",
    "Hitting the tab button will turn on Skip to PageAssist": "Hvis du trykker på faneknappen, aktiveres Spring til PageAssist",
    "How are we going to fix it?": "Hvordan skal vi fikse det?",
    "Icon shape": "Ikonform",
    "Image Alt text is short": "Billede Alt-tekst er kort",
    "Important images should not have spacer Alt text": "Vigtige billeder bør ikke have mellemrums Alt-tekst",
    "Info": "Info",
    "Insert company name": "Indsæt firmanavn",
    "Instead of &lt;i&gt; choose a different element name to be used instead": "I stedet for & lt; i & gt; vælg et andet elementnavn, der skal bruges i stedet",
    "It will take some time before our system will register your changes to PageCorrect": "Det vil tage et stykke tid, før vores system registrerer dine ændringer til PageCorrect",
    "Left middle": "Venstre midte",
    "Letter case *": "Bogstav-følsomhed *",
    "Light": "Lys",
    "Link excludes:": "Link-udelukkelser:",
    "Loading PageFix": "Indlæser PageFix",
    "Make sure you use correct formatting and add multiple selectors when your page design differs": "Sørg for, at du bruger korrekt formatering og tilføjer flere selektorer, når sidedesignet er forskelligt",
    "Manage options": "Administrer muligheder",
    "Marquee sample image": "Marquee-eksempelbillede",
    "Marquee testing sample image": "Marquee-test eksempelbillede",
    "Menu theme": "Menutema",
    "New Window Information": "Oplysninger om nyt vindue",
    "New Window Test": "Nyt vindue-test",
    "Non-Decorative images must have Alt text": "Ikke-dekorative billeder skal have Alt-tekst",
    "North America": "Nordamerika",
    "PageAssist Logo": "PageAssist-logo",
    "PageAssist position on Page": "PageAssists position på siden",
    "Portuguese": "Portugisisk",
    "Potential problems that can arise": "Potentielle problemer, der kan opstå",
    "Press 'Upload link' to save your URL settings": "Tryk på 'Upload link' for at gemme dine URL-indstillinger",
    "Preview": "Eksempel",
    "Proper Case": "Korrekt sag",
    "Remove input selector": "Fjern inputvælgeren",
    "Remove logo upload": "Fjern upload af logo",
    "Remove row": "Fjern række",
    "Repair Tip": "Reparationstip",
    "Repair options": "Reparationsmuligheder",
    "Replace Italic element with EM": "Udskift kursiv element med EM",
    "Replace all &lt;b&gt; tags with": "Udskift alle & lt; b & gt; tags med",
    "Replace all &lt;blink&gt; tags with": "Udskift alle & lt; blink & gt; tags med",
    "Replace all &lt;i&gt; tags": "Udskift alle & lt; i & gt; tags",
    "Replace all &lt;marquee&gt; tags with": "Udskift alle &lt;marquee&gt; tags med",
    "Report Center Image": "Centerbillede i rapport",
    "Reset Input": "Nulstil input",
    "Reset Skip to content text to its default": "Nulstil Spring til indhold til standard",
    "Reset design": "Nulstil design",
    "Reset to default": "Nulstil til standard",
    "Restore": "Gendan",
    "Restore profile?": "Gendan profil?",
    "Restoring this profile <strong>([[profileName]])</strong> will make it available in your modules.": "<strong></strong>Gendannelse af denne profil ([[profileName]]) gør den tilgængelig i dine moduler.",
    "Right middle": "Højre midte",
    "Rounded Box": "Afrundet kasse",
    "Russian": "Russisk",
    "Show": "Vis",
    "Show details": "Vis detaljer",
    "Show text": "Vis tekst",
    "Simplified Chinese": "Forenklet kinesisk",
    "Skip to Content": "Fortsæt til indhold",
    "Snippet reset": "Nulstilling af uddrag",
    "Someone have created this PageCorrect before you, on another check.": "Nogen har oprettet denne PageCorrect før dig ved et andet tjek.",
    "Spanish Mexican": "Spansk Mexicansk",
    "Start export inventory emails": "Start eksport af indholdsoverblik for e-mails",
    "Start export inventory emails extended": "Start udvidet eksport af indholdsoverblik for e-mails",
    "Testing": "Testning",
    "The subpath/subfolder the WordPress installation is under": "Understien / undermappen WordPress-installationen er under",
    "This fix requires development knowledge": "Denne løsning kræver viden om udvikling",
    "This message will be displayed when the user hovers over the PageAssist button": "Denne meddelelse vises, når brugeren holder markøren over PageAssist-knappen",
    "This option might cause problems to your icons": "Denne indstilling kan forårsage problemer med dine ikoner",
    "Title Text": "Titeltekst",
    "To setup this policy, you need to tell us the company name and the possible misspelled letter case type you want to check": "For at konfigurere denne policy skal du oplyse virksomhedens navn og den potentielle fejlstavning af bogstavtype, som du ønsker at kontrollere",
    "Top center": "Top center",
    "Top left": "Øverst til venstre",
    "Top right": "Øverst til højre",
    "Trying out the pop-up": "Afprøver pop op-vinduet",
    "UPPERCASE": "STORE BOGSTAVER",
    "Undo check review": "Fortryd checkanmeldelse",
    "Upload link": "Upload link",
    "Upload logo": "Upload logo",
    "Use Datepicker": "Brug datovælger",
    "Use PageCorrect to correct the following misspelling:<code>[[misspelling]]</code>": "<code></code>Brug PageCorrect til at rette følgende stavefejl: [[stavefejl]]",
    "Use PageCorrect to fix Broken Link": "Brug PageCorrect til at rette ødelagt link",
    "Use PageCorrect to fix these image sources": "Brug PageCorrect til at rette disse billedkilder",
    "Value:": "Værdi:",
    "View": "Se",
    "What is wrong with the &lt;b&gt; (bold) element?": "Hvad er der galt med &lt;b&gt; (fed) element?",
    "What is wrong with the &lt;i&gt; (italic) element?": "Hvad er der galt med &lt;i&gt; (kursiv) element?",
    "What to do when the link doesn't work?": "Hvad skal jeg gøre, når linket ikke fungerer?",
    "What to do when things look wrong?": "Hvad skal jeg gøre, når ting ser forkerte ud?",
    "Why shouldn't I use the blink element?": "Hvorfor bør jeg ikke bruge blinkelementet?",
    "Widget Design and Text": "Widget-design og tekst",
    "Widget Icon Setup": "Opsætning af widgetikon",
    "Without any assigned class": "Uden nogen tildelt class",
    "Write a warning to your outbound link": "Skriv en advarsel til dit udgående link",
    "Write custom tag": "Skriv tilpasset tag",
    "lowercase": "små bogstaver",
    "with": "med",
    "with &lt;em&gt;": "med & lt; em & gt;",
    "Statistics is using sample data": "Statistikker anvender prøvedata",
    "Statistics results are sample data for demo purposes - export is disabled": "Statistikresultater anvender prøvedata til demoformål - eksport er deaktiveret",
    "This section is using sample data": "I dette afsnit anvendes prøvedata",
    "&lt;i&gt; tags with these attribute values will not be changed": "&lt;i&gt; tags med disse attributværdier vil ikke blive ændret",
    "(Bad)": "(Dårlig)",
    "(Good)": "(God)",
    "<span class=\\\"mr-2\\\">Pages</span>": "<span class=\\\"mr-2\\\">Sider</span>",
    "Add API user": "Tilføj API-bruger",
    "Add attributes to be excluded in this change": "Tilføj attributter, der skal udelukkes i denne ændring",
    "Add profile": "Tilføj profil",
    "Add source code exclude": "Tilføj kildekode som skal udelukkes",
    "Are you sure?": "Er du sikker?",
    "Button hover color": "Farve på hover-knappen",
    "Calculated by no. and severity of issues, page views and links leading to this page..": "Beregnet ud fra antal og sværhedsgrad af problemer, sidevisninger og links, der fører til denne side..",
    "Choose minimum word count for a page to be included in the readability test": "Vælg det mindste antal ord for en side, der skal indgå i læsbarhedstesten",
    "Color contrast ratio": "Farvekontrastforhold",
    "Content id tag": "Id-tag for indhold",
    "Creation date": "Oprettelsesdato",
    "Custom text": "Brugerdefineret tekst",
    "Customise the Information page": "Tilpasning af informationssiden",
    "Disable": "Deaktiver",
    "Docs without downloads": "Dokumenter uden downloads",
    "Documents Without Downloads": "Dokumenter uden downloads",
    "EPI Server Path": "EPI-serversti",
    "EPIServer": "EPIServer",
    "Editor": "Editor",
    "Ex: data-currentpage, or data-pageid, or CurrentPageLink": "Fx: data-currentpage, eller data-pageid, eller CurrentPageLink",
    "Ex: lang or CurrentPageLanguage": "Fx: lang eller CurrentPageLanguage",
    "Export both pages and documents": "Eksporter både sider og dokumenter",
    "Export only documents without downloads": "Eksportér kun dokumenter uden downloads",
    "Export only html pages without visits": "Eksportér kun html-sider uden besøg",
    "Include Accessibility Statement": "Medtag en erklæring om tilgængelighed",
    "Include custom info text": "Medtag brugerdefineret informationstekst",
    "Includes a button with a link to your accessibility statement": "Indeholder en knap med et link til din tilgængelighedserklæring",
    "Indicates which language this page will be scanned in. Click underneath to change": "Angiver, hvilket sprog denne side skal scannes på. Klik nedenunder for at ændre",
    "Insert a valid URL": "Indsæt en gyldig URL",
    "Language tag": "Sprogmærke",
    "Last assigned profile on page. Page will be removed from Performance": "Sidst tildelte profil på siden. Siden vil blive fjernet fra Performance",
    "Link color": "Linkfarve",
    "Link opens in a new tab": "Link åbner i en ny fane",
    "Main color": "Primær farve",
    "Meta name": "Metanavn",
    "Mode": "Tilstand",
    "No default profile selected for this page, scoring not available.": "Der er ikke valgt nogen standardprofil for denne side, scoring ikke tilgængelig.",
    "No documents found": "Ingen dokumenter fundet",
    "No profiles selected for this page, scoring not available.": "Ingen profiler valgt til denne side, scoring ikke tilgængelig.",
    "Not a valid CSS selector": "Ikke en gyldig CSS-selektor",
    "Notification when the downtime ends": "Meddelelse, når nedetiden slutter",
    "Number of external links": "Antal eksterne links",
    "Number of incoming links": "Antal indgående links",
    "Open details": "Åbn detaljer",
    "PDF Accessibility": "Tilgængelighed af PDF-filer",
    "Passwords do not match": "Adgangskoder matcher ikke",
    "Please add a Default Profile to your Page": "Tilføj venligst en standardprofil til din side",
    "Please add a Profile to your Page": "Tilføj venligst en profil til din side",
    "Please enter a valid color code": "Indtast venligst en gyldig farvekode",
    "Please perform a PDF scan to see the results for the checks below": "Du kan foretage en PDF-scanning for at se resultaterne af nedenstående kontroller",
    "Setup": "Opsætning",
    "Show less of the code snippet": "Vis mindre af kodeudsnittet",
    "Show the full code snippet": "Vis det fulde uddrag af koden",
    "Statistics not activated. Page Views not available.": "Statistikker er ikke aktiveret. Sidevisninger ikke tilgængelige.",
    "Subdomain": "Subdomæne",
    "Subdomain url": "URL til subdomæne",
    "Superfast - Don't use unless you know what you're doing": "Superfast - Brug den ikke, medmindre du ved, hvad du gør",
    "Text color": "Tekstfarve",
    "The optional epi server path": "Den valgfrie epi-server-sti",
    "The subdomain url to the CMS page": "Subdomænets url til CMS-siden",
    "This text must be under 1000 characters": "Denne tekst skal være på under 1000 tegn",
    "Two-Factor Authentication": "To-faktor-godkendendelse",
    "Two-factor authentication is currently disabled": "To-faktor-godkendelse er i øjeblikket deaktiveret",
    "Two-factor authentication is currently enabled": "To-faktor-godkendelse er i øjeblikket aktiveret",
    "URL needs to be valid, include http:// or https:// and be under 100 characters": "URL-adressen skal være gyldig og indeholde http:// eller https:// og være under 100 tegn",
    "URL template": "URL-skabelon",
    "Unique broken links": "Unikke brudte links",
    "Very fast - Be Cautious": "Meget hurtigt - vær forsigtig",
    "WCAG 2.0": "WCAG 2.0",
    "WCAG 2.1": "WCAG 2.1",
    "Your color contrast is below the recommended score": "Din farvekontrast er under den anbefalede score",
    "labels": "labels",
    "Acceptance Rate": "Accepteringsgrad",
    "Acceptance Rate Over Time": "Accepteringsrate over tid",
    "Acceptance Rate by Category": "Godkendelsesprocent efter kategori",
    "Accepted cookies": "Accepterede cookies",
    "Add callback functions boilerplate": "Tilføj callback-funktioner som standard",
    "Add cookie": "Tilføj cookie",
    "Add empty EventListeners": "Tilføj tomme EventListeners",
    "Add empty callbacks": "Tilføj tomme callbacks",
    "Add event listeners boilerplate": "Tilføj hændelsestilhørere boilerplate",
    "Add web overlay lock": "Tilføj web-overlay-lås",
    "Alternative": "Alternativ",
    "An overview of your customer's behavior with cookies on your website": "Et overblik over dine kunders adfærd med cookies på dit websted",
    "Are you sure you want to ignore all selected misspellings?": "Er du sikker på, at du vil ignorere alle valgte stavefejl?",
    "Are you sure you want to mark this check as fixed on all pages?": "Er du sikker på, at du vil markere denne kontrol som fast på alle sider?",
    "Are you sure you want to mark this check as fixed?": "Er du sikker på, at du vil markere denne kontrol som rettet?",
    "Are you sure you want to mark this misspelling as fixed?": "Er du sikker på, at du vil markere denne stavefejl som rettet?",
    "Are you sure you want to mark this misspelling(s) as fixed?": "Er du sikker på, at du vil markere denne stavefejl (disse stavefejl) som rettet?",
    "Basic": "Basis",
    "Button color": "Knapfarve",
    "Button text color": "Tekstfarve på knap",
    "Case sensitive URLs": "URL'er med hensyn til store og små bogstaver",
    "Changes wording from only essential cookies to explicit reject": "Ændrer ordlyden fra kun væsentlige cookies til udtrykkeligt at afvise",
    "Consent Log": "Log over samtykke",
    "Consent Overview": "Oversigt over samtykke",
    "Consent results are sample data for demo purposes": "Resultaterne af samtykket er eksempler på data til demonstrationsformål",
    "Cookie Acceptance Rate": "Accept af cookies",
    "Cookie Overview": "Oversigt over cookies",
    "Cookie description": "Cookie beskrivelse",
    "Cookie duration": "Cookie-varighed",
    "Cookie name": "Cookie-navn",
    "Enter a valid CSS selector": "Indtast en gyldig CSS-selektor",
    "Essential": "Vigtigt",
    "Example 3": "Eksempel 3",
    "Example 4": "Eksempel 4",
    "Explicit reject option": "Eksplicit mulighed for at afvise",
    "Give a short description of the purpose of the cookie": "Giv en kort beskrivelse af formålet med cookien",
    "Give users more control over which categories of cookies to consent to": "Giv brugerne mere kontrol over, hvilke kategorier af cookies de vil give deres samtykke til",
    "How long is the cookie active": "Hvor længe er cookien aktiv",
    "IP Address": "IP-adresse",
    "Ignore canonical URLs": "Ignorere kanoniske URL'er",
    "Ignored by": "Ignoreret af",
    "Ignored date": "Ignoreret dato",
    "Ignored misspellings on account": "Ignorerede stavefejl på konto",
    "Include cookies": "Medtag cookies",
    "Insert CSS class or id selector": "Indsæt CSS-klasse eller id-selektor",
    "Insert a CSS selector": "Indsæt en CSS-selektor",
    "Limit or exclude": "Begræns eller udeluk",
    "Limit search": "Begræns søgning",
    "Link to your opt out page": "Link til din opt out-side",
    "Make sure you use the correct setting": "Sørg for, at du bruger den korrekte indstilling",
    "Mark check as fixed": "Markér kontrol som rettet",
    "Marketing": "Marketing",
    "No cookies found": "Der blev ikke fundet nogen cookies",
    "No misspellings have been ignored": "Der er ikke blevet ignoreret nogen stavefejl",
    "Opt out link": "Link til fravalg",
    "Original": "Original",
    "Other": "Andet",
    "Overall Acceptance Rate": "Samlet godkendelsesprocent",
    "Overall acceptance rate": "Samlet acceptprocent",
    "Per category consent": "Pr. kategori samtykke",
    "Please wait - Marking as fixed": "Vent venligst - Markering som rettet",
    "Please wait - Marking word as fixed": "Vent venligst - Markerer ord som rettet",
    "Preferences": "Indstillinger",
    "Privacy regulation": "Forordning om beskyttelse af privatlivets fred",
    "Remove cookie": "Fjern cookie",
    "Remove from Ignored": "Fjern fra Ignoreret",
    "Remove this word from Ignored Misspellings": "Fjern dette ord fra Ignorerede stavefejl",
    "URL Structure": "URL-struktur",
    "Domain Overview": {
      "Topmenu": "Oversigt over domæner",
      "$$noContext": "Oversigt over domæner"
    },
    "Admin Settings": "Admin-indstillinger",
    "Case sensitivity": "Følsomhed over for store og små bogstaver",
    "Close project search and domain picker": "Luk projektsøgning og domænevælger",
    "Domain Settings": "Domæneindstillinger",
    "In the end both &lt;i&gt; and &lt;em&gt; tags look visually the same. However, they each have a different semantic meaning. &lt;em&gt; is used to represent emphasis, while &lt;i&gt; tag represents a word or a sentence that the user might want to set in italic (a foreign word, definition of a word, etc.). For the latter CSS should be used instead.": "I sidste ende både & lt; I & gt; og & lt; em & gt; tags ser visuelt ens ud. De har dog hver sin forskellige semantiske betydning. & lt; em & gt; bruges til at repræsentere vægt, mens & lt; I & gt; tag repræsenterer et ord eller en sætning, som brugeren måske ønsker at sætte i kursiv (et fremmed ord, definition af et ord osv.). For sidstnævnte skal CSS bruges i stedet.",
    "Paste your image link (URL) here": "Indsæt dit billedlink (URL) her",
    "Set up your domain": "Opsætning af dit domæne",
    "The biggest problem with this fix can arise if the &lt;i&gt; tag is used for icons instead of, for instance, &lt;span&gt; (example: Font Awesome). If you notice that something looks wrong with your icons after applying the fix, this might be the reason. However, &lt;i&gt; tags for icons tend to use a class so make sure you have set the options to only alter the tags without altering the classes. That way your icons should be left untouched.": "Det største problem med denne rettelse kan opstå, hvis &lt;i&gt; tagget bruges til ikoner i stedet for f.eks. &lt;span&gt; (eksempel: Font Awesome). Hvis du bemærker, at noget ser forkert ud med dine ikoner efter at have anvendt rettelsen, kan dette være årsagen. Dog har &lt;i&gt; tags til ikoner tendens til at bruge en klasse, så sørg for, at du har indstillet indstillingerne til kun at ændre tagsene uden at ændre klasserne. På den måde burde dine ikoner forblive uberørte.",
    "The profile <strong>[[profileName]]</strong> is being used on the following pages below:": "<strong></strong>Profilen  [[profileName]]  bruges på de følgende sider nedenfor",
    "Add icon border": "Tilføj ikonramme",
    "Adds a 3px wide border to the PageAssist widget icon": "Tilføjer en 3px bred kant til ikonet for PageAssist-widget'en",
    "Bottom": "Bund",
    "Clear search": "Klar søgning",
    "Ensures that PageAssist is never overlapped by other elements on the page": "Sikrer, at PageAssist aldrig overlappes af andre elementer på siden",
    "Estonian": "Estisk",
    "German": "Tysk",
    "Go to overlay with details": "Gå til overlay med detaljer",
    "Guidelines for WCAG 2.2": "Retningslinjer for WCAG 2.2",
    "Heartbeat Overview": "Tilbage til Heartbeat Oversigt",
    "How far the button is from the edge. Customization dependant on position.": "Hvor langt knappen er fra kanten. Tilpasning afhænger af positionen.",
    "Insert a valid host name": "Indsæt et gyldigt værtsnavn",
    "Keep PageAssist on top": "Hold PageAssist på toppen",
    "Left": "Venstre",
    "Margin from edge in pixels": "Margen fra kanten i pixel",
    "Norwegian Bokmål": "Norsk Bokmål",
    "Norwegian Nynorsk": "Nynorsk",
    "Right": "Højre",
    "Social Media visits": "Besøg på sociale medier",
    "Social media visits": "Besøg på sociale medier",
    "Sort column": "Sorter kolonne",
    "Sort column ascending": "Sortere kolonnen opadgående",
    "Sort column descending": "Sortere kolonnen faldende",
    "Subgroup": "Undergruppe",
    "Swedish": "Svensk",
    "Toggle label text": "Skift mellem labeltekst",
    "Top": "Top",
    "Unique misspellings": "Unikke stavemåder",
    "Unique misspellings found": "Unikke stavemåder fundet",
    "WCAG 2.2 Accessibility Compliance": "Overholdelse af WCAG 2.2 om tilgængelighed",
    "Area dynamic page": "Område dynamisk side",
    "Employeepage": "Medarbejderside",
    "Language id": "Sprog-id",
    "Newspage": "Nyhedsside",
    "Standard": "Standard",
    "Standard for http(s)://edit.domain.tld/inz/<path>. Alternative for http(s)://domain.tld/<path>/edit.": "Standard for http(s)://edit.domain.tld/inz/. Alternativ til http(s)://domain.tld//edit.",
    "URL format": "URL-format",
    "Export both internal and external links": "Eksportér både interne og eksterne links",
    "Export only external links": "Eksportér kun eksterne links",
    "Export only internal links": "Eksportér kun interne links",
    "Overview of all the enabled modules for this domain": "Oversigt over alle de aktiverede moduler for dette domæne",
    "Search for a predefined policy in the Policy Exchange Center": "Søg efter en foruddefineret policy i policy-udvekslingscenteret",
    "A log of all the consents given by your website visitors": "En log over alle de samtykker, som de besøgende på dit websted har givet",
    "Action required. Click to resolve issue.": "Handling påkrævet. Klik for at løse problemet.",
    "Complete": "Afsluttet",
    "Cookie Overview buttons": "Knapper til oversigt over cookies",
    "Cookie Overview saved": "Oversigt over gemte cookies",
    "Cookie added by user": "Cookie tilføjet af brugeren",
    "Cookie domain": "Cookie-domæne",
    "Cookie not found": "Cookie ikke fundet",
    "Cookie not published. Missing:": "Cookie ikke offentliggjort. Mangler:",
    "Could not save invalid form": "Kunne ikke gemme ugyldig formular",
    "Disables interactions on website until the visitor makes a consent choice. Be aware that locking interactions prior to consent may not be compliant with certain regional privacy regulations.": "Deaktiverer interaktioner på webstedet, indtil den besøgende vælger at give sit samtykke. Vær opmærksom på, at låsning af interaktioner før samtykke muligvis ikke er i overensstemmelse med visse regionale regler om beskyttelse af personlige oplysninger.",
    "Finish the setup by adding your cookies": "Afslut opsætningen ved at tilføje dine cookies",
    "For Cookie setup please go to your <b>Data Privacy</b> module.<br> Manual cookies can be set up or edited any time and are not related to script setup.": "<b></b><br>For at opsætte cookies skal du gå til dit modul om &lt;b&gt;databeskyttelse&lt;/b&gt;.&lt;br&gt;Manuelle cookies kan opsættes eller redigeres når som helst og er ikke relateret til scriptopsætning.&lt;/br&gt; ",
    "GDPR requires that companies provide descriptions on their website for all cookies that are used.": "GDPR kræver, at virksomheder giver beskrivelser på deres websted af alle anvendte cookies.",
    "Give an overview of the cookies used on your website. Finish a domain scan or add them manually.": "Giv en oversigt over de cookies, der anvendes på dit websted. Afslut en domænescanning, eller tilføj dem manuelt.",
    "Id": "Id",
    "Include a link to your webpage's privacy policy": "Medtag et link til din websides privatlivspolitik",
    "It looks like the previously set up cookie was not found in this scan. It might be that the cookie was removed or our scan just couldn’t detect it.": "Det ser ud til, at den tidligere indstillede cookie ikke blev fundet ved denne scanning. Det kan være, at cookien er blevet fjernet, eller at vores scanning bare ikke kunne registrere den.",
    "I’ll do it later": "Jeg gør det senere",
    "Keep": "Behold",
    "Leave without saving": "Forlad uden at gemme",
    "Link to Privacy Policy": "Link til privatlivspolitik",
    "Link to your Cookie Overview": "Link til din cookieoversigt",
    "Link to your Privacy Policy": "Link til din privatlivspolitik",
    "Link where customers can opt out of sale of personal data. Mandatory for websites under the CCPA regulation.": "Link, hvor kunderne kan fravælge salg af personoplysninger. Obligatorisk for websteder i henhold til CCPA-forordningen.",
    "List of checks with and without issues categorized by [[level]] guidelines": "Liste over kontroller med og uden problemer kategoriseret efter [[level]] retningslinjer",
    "Manage Cookie": "Administrér cookie",
    "On-demand scan unavailable": "On-demand-scanning er ikke tilgængelig",
    "Pages needing to be fixed": "Sider, der skal rettes",
    "Save cookies": "Gem cookies",
    "Save existing cookies": "Gem eksisterende cookies",
    "Save this overview to publish completed cookies to the Cookie Overview.": "Gem denne oversigt for at offentliggøre færdige cookies i Cookieoversigten.",
    "Save your page before leaving to keep your progress and publish the completed cookies.": "Gem din side, inden du forlader den, for at bevare dine fremskridt og offentliggøre de færdige cookies.",
    "Scan History": "Scanningshistorik",
    "Scan Information": "Oplysninger om scanning",
    "Scan info": "Scan info",
    "Source": "Kilde",
    "This feature is not available on a demo account.": "Denne funktion er ikke tilgængelig på en demokonto.",
    "This page has been rescanned since the latest full scan.": "Denne side er blevet scannet på ny siden den seneste komplette scanning.",
    "This scan feature is not available on a demo account": "Denne scanningsfunktion er ikke tilgængelig på en demokonto",
    "UUID": "UUID",
    "You need to include a name in order to save your cookies.": "Du skal angive et navn for at kunne gemme dine cookies.",
    "[[total]] pages. Prioritize and fix all content issues across your website from one consolidated view.": "[[total]] sider. Prioritér og løs alle indholdsproblemer på hele dit websted fra én samlet visning.",
    "Distribution of policies with matches across priority levels": "Fordeling af policies med match på prioriteringsniveauer",
    "Copied!": "Kopieret!",
    "Copy": "Kopier",
    "Default language*": "Standardsprog*",
    "Don't forget to copy and update the script on your website!": "Husk at kopiere og opdatere scriptet på dit websted!",
    "Included languages*": "Inkluderede sprog*",
    "Loading Data": "Indlæser data",
    "Loading...": "Indlæser...",
    "No support": "Ingen suppport",
    "Open PageAssist script settings": "Åbn indstillingerne for PageAssist-scriptet",
    "PageAssist script settings": "Indstillinger for PageAssist-scriptet",
    "Please add the script as close to the open HEAD-tag as possible": "Tilføj scriptet så tæt på det åbne HEAD-tag som muligt",
    "Please wait - loading": "Vent venligst - indlæser",
    "Press Ctrl-C": "Tryk på Ctrl-C",
    "Press ⌘-C": "Tryk på ⌘-C",
    "This chart shows how many percent of visitors accepted the various categories of cookies on your website. Visitors who did not make a consent choice on the cookie banner are not counted": "Dette diagram viser, hvor mange procent af de besøgende der har accepteret de forskellige kategorier af cookies på dit websted. Besøgende, der ikke har valgt at give deres samtykke på cookie-banneret, er ikke inkluderet",
    "Visitor percentage": "Procentdel af besøgende",
    "Consent Manager script settings": "Script-indstillinger i Consent Manager",
    "Open consent manager script settings": "Åbn indstillingerne for scriptet i Consent Manager",
    "Scan your website for any data privacy issues that could be present": "Scan dit websted for eventuelle problemer med databeskyttelse, der kan være til stede",
    "Please enter a full UUID string. Empty or partial strings will not yield any results.": "Indtast venligst en fuld UUID-streng. Tomme eller delvise strenge vil ikke give nogen resultater.",
    "UUID can only be searched by entering the full value": "UUID kan kun søges ved at indtaste den fulde værdi",
    "Average Cumulative Layout Shift": "Gennemsnitlig Cumulative Layout Shift",
    "Average Largest Contentful Paint": "Gennemsnitlig Largest Contentful Paint",
    "Average Speed Index": "Gennemsnitlig Speed Index",
    "Average Total Blocking Time": "Gennemsnitlig Total Blocking Time",
    "CMS Path": "CMS Path",
    "Click here or drag a rule to this area": "Klik her eller træk en regel til dette område",
    "Cumulative Layout Shift": "Cumulative Layout Shift",
    "LCP": "LCP",
    "Relevant for": "Relevant for",
    "SI": "SI",
    "TBT": "TBT",
    "[[avg]]": "[[avg]]",
    "[[label]]: [[value]]": "[[label]]: [[value]]",
    "Content Authoring": "Content Authoring",
    "Responsibilities": "Ansvarsområder",
    "Responsibility": "Ansvarsområde",
    "UX Design": "UX-design",
    "Visual Design": "Visuelt design",
    "Version [[version]]": "Version [[version]]",
    "Accessibility score": "Tilgængelighedsscore",
    "Comparison to average": "Sammenligning med gennemsnittet",
    "Industry average": "Industriens gennemsnit",
    "No scores available for this domain": "Ingen score tilgængelig for dette domæne",
    "Professional services": "Professionelle tjenesteydelser",
    "Quality Assurance score": "Kvalitetssikringsscore",
    "SEO score": "SEO-score",
    "Scores": "Resultater",
    "The average score for domains within your industry.": "Den gennemsnitlige score for domæner inden for din branche.",
    "Add language": "Tilføj sprog",
    "Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.": "Er du sikker på, at du vil arkivere",
    "Are you sure you want to set these documents as reviewed?": "Er du sikker på, at du ønsker at angive disse dokumenter som reviderede?",
    "Clear selection": "Ryd valg",
    "Delete language -": "Slet sprog -",
    "Delete the language tab - [[language]]": "Slet sprogfanen - [[language]]",
    "Discovered": "Udforsket",
    "Doing this will result in removing the translations in the selected language from both your Cookie Overview and the actual banner itself.<br></br><strong>You will need to add the descriptions again when you re-add the selected language.</strong>": "Hvis du gør dette, fjernes oversættelserne på det valgte sprog fra både din Cookie-oversigt og selve banneret.<br></br><strong>Du skal tilføje beskrivelserne på ny, når du tilføjer det valgte sprog igen.</strong>",
    "Don't forget to update your languages in Script Setup!": "Husk at opdatere dine sprog i Script Setup!",
    "Edit this policy rule later under the “Add rule to policy” tab.": "Rediger denne policy-regel senere under fanen \"Tilføj regel til policy\".",
    "Front-end Development": "Front-end udvikling",
    "How to setup this policy:": "Sådan konfigureres denne policy:",
    "Insert word length": "Indsæt ordlængde",
    "Inspect page with browser extension": "Inspicér siden med browserudvidelsen",
    "Mark all as reviewed": "Markér alle som revideret",
    "Mobile only": "Kun mobil",
    "New policy": "Ny policy",
    "Please add at least one language": "Tilføj mindst ét sprog",
    "Please set the default language": "Indstil standardsproget",
    "Please wait - Adding word to ignored list": "Vent venligst - Tilføjer ord til listen over ignorerede ord",
    "Please wait - Adding words to ignored list": "Vent venligst - Tilføjer ord til listen over ignorerede ord",
    "Remove rule from policy": "Fjern regel fra policy",
    "Request PDF accessibility check for all": "Anmod om tjek af PDF-tilgængelighed for alle",
    "Request Remedition quote for all": "Anmod om et tilbud på udbedring for alle",
    "Script": "Script",
    "Select a group": "Vælg en gruppe",
    "Select a shape": "Vælg en form",
    "Select languages": "Vælg sprog",
    "Select the default language": "Vælg standardsprog",
    "To finish setting up your manual Cookie Overview go to the selected domain’s": "For at afslutte opsætningen af din manuelle Cookieoversigt skal du gå til det valgte domæne",
    "Unignore this check": "Fjern denne kontrol",
    "WCAG 2.1 (Level AA) Mobile": "WCAG 2.1 (niveau AA) Mobil",
    "WCAG 2.1 (Level AAA) Mobile": "WCAG 2.1 (niveau AAA) Mobil",
    "Are you sure you want to delete label: [[label]] ?": "Er du sikker på, at du vil slette etiketten: [[label]]?",
    "Business services": "Forretningsservices",
    "CMS template is configured for this domain": "CMS-skabelonen er konfigureret for dette domæne",
    "Consent Manager configuration": "Konfiguration af Consent Manager",
    "Consent Manager language*": "Sprog for Consent Manager*",
    "Consent Manager pop-up position on Page": "Consent Manager pop-up-position på siden",
    "Consent Manager pop-up setup": "Opsætning af pop-up til Consent Manager",
    "Construction/industrial": "Byggeri/industri",
    "Consumer services": "Forbrugertjenester",
    "Entertainment/Leisure": "Underholdning/fritid",
    "Financial services": "Finansielle tjenester",
    "German (Germany)": "Tysk (Tyskland)",
    "Healthcare": "Sundhedssektoren",
    "Label used in the groups below. Please edit or delete the groups and try again.": "Etik anvendt i nedenstående grupper. Redigér eller slet grupperne, og prøv igen.",
    "Law enforcement": "Retshåndhævelse",
    "Legal": "Juridisk",
    "Non-profit": "Non-profit",
    "Real-estate": "Ejendomme",
    "Retail/wholesale": "Detailhandel/engroshandel",
    "Spanish (Spain)": "Spansk (Spanien)",
    "Technology": "Teknologi",
    "Utilities/Natural resources": "Forsyningsselskaber/naturressourcer",
    "Widget Design": "Design af widget",
    ":": ":",
    "Accessibility issue": "Tilgængelighedsproblem",
    "Add reason (optional)": "Tilføj årsag (valgfrit)",
    "All pages with this accessibility issue": "Alle sider med dette tilgængelighedsproblem",
    "All pages with this data privacy issue": "Alle sider med dette problem med databeskyttelse",
    "Alternatively, click the button below.": "Alternativt kan du klikke på knappen nedenfor.",
    "Are you sure you want to mark this  as fixed?": "Er du sikker på, at du vil markere dette som løst?",
    "Are you sure you want to mark this  as ignored?": "Er du sikker på, at du vil markere dette som ignoreret?",
    "Are you sure you want to mark this  as not fixed?": "Er du sikker på, at du vil markere dette som ikke løst?",
    "Are you sure you want to mark this check as ignored?": "Er du sikker på, at du vil markere denne kontrol som ignoreret?",
    "Are you sure you want to mark this issue as ignored?": "Er du sikker på, at du vil markere dette problem som ignoreret?",
    "Are you sure you want to unignore this ?": "Er du sikker på, at du vil ophæve dette?",
    "Average time (comp.)": "Gennemsnitstid (komp.)",
    "Bounce rate (comp.)": "Afvisningsprocent (sammenlign.)",
    "Campaign visits": "Kampagnebesøg",
    "Code": "kode",
    "Confirmation required": "Bekræftelse påkrævet",
    "Current password": "Nuværende kodeord",
    "Data privacy issue": "Problem med databeskyttelse",
    "Data violations": "Dataovertrædelser",
    "Date found": "Dato fundet",
    "Downloads (comp.)": "Downloads (komp.)",
    "Entries (comp.)": "Indlæg (komp.)",
    "Events": "Begivenheder",
    "Exits (comp.)": "Udgange (komp.)",
    "Export visitors browsers": "Eksporter besøgendes browsere",
    "Export visitors devices": "Eksporter besøgendes enheder",
    "Export visitors language": "Eksporter besøgendes sprog",
    "Export visitors locations": "Eksporter besøgendes placeringer",
    "Export visitors operating systems": "Eksporter besøgendes operativsystemer",
    "Export visitors organization": "Eksporter besøgende organisation",
    "Found on page": "Findes på side",
    "Group name": "Gruppenavn",
    "Image URL": "Billed-URL",
    "Issue details": "Udstedelsesdetaljer",
    "Issue not found": "Problemet blev ikke fundet",
    "Legacy Browser Service changed": "Ældre browsertjeneste ændret",
    "Look up in Google": "Slå op i Google",
    "Mark as reviewed": "Markér som gennemgået",
    "Maximum word length to search for": "Maksimal ordlængde at søge efter",
    "Names": "Navne",
    "No pages were found. Try searching for the page URL instead of the page title.": "Ingen sider blev fundet. Prøv at søge efter sidens URL i stedet for sidens titel.",
    "Open browser extension": "Åbn browserudvidelsen",
    "Open issue page": "Åbn problemsiden",
    "Open misspelling page": "Åbn stavefejl side",
    "Other checks for this snippet": "Andre kontroller for dette uddrag",
    "Pages with accessibility issues": "Sider med tilgængelighedsproblemer",
    "Pages with policy issues": "Sider med politiske spørgsmål",
    "Pageviews (comp.)": "Sidevisninger (sammenlign.)",
    "Percentage shows number of pages that are compliant with all Policies": "Procent viser antallet af sider, der er i overensstemmelse med alle politikker",
    "Percentage shows number of pages that are compliant with all QA checks": "Procentdel viser antallet af sider, der er i overensstemmelse med alle QA-tjek",
    "Please enter a valid date!": "Indtast venligst en gyldig dato!",
    "Please wait - Adding word to all dictionaries": "Vent venligst - Tilføjer ord til alle ordbøger",
    "Press to toggle additional rows.": "Tryk for at skifte til flere rækker.",
    "Puppeteer Browser Service changed": "Puppeteer Browser Service ændret",
    "Reason:&nbsp;": "Årsag:&nbsp;",
    "Remember to add this source code exclude to your domain(s) through the Edit Domain screen.": "Husk at tilføje denne kildekodeekskludering til dine domæne(r) via skærmbilledet Rediger domæne.",
    "Remove review": "Fjern anmeldelse",
    "Repeat new password": "Gentag ny adgangskode",
    "Sorry, this page was not found. The issue must have been resolved.": "Beklager, denne side blev ikke fundet. Problemet skal være løst.",
    "The date cannot be in the future": "Datoen kan ikke ligge i fremtiden",
    "The end date cannot be before the start date": "Slutdatoen må ikke ligge før startdatoen",
    "The settings form contains incorrect data. Close the form anyway?": "Indstillingsformularen indeholder forkerte data. Vil du lukke formularen alligevel?",
    "The start and end date cannot be in the future, please enter the compare dates again": "Start- og slutdatoen kan ikke ligge i fremtiden. Indtast venligst sammenligningsdatoer igen",
    "This issue is marked as fixed.": "Dette problem er markeret som løst.",
    "This issue is marked as ignored.": "Dette problem er markeret som ignoreret.",
    "This issue is marked as reviewed.": "Dette problem er markeret som gennemgået.",
    "This word has been added to your dictionary": "Dette ord er blevet tilføjet til din ordbog",
    "To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class=\\\"text-bold\\\">My Exports.</span>": "For at se den aktuelle status skal du klikke på brugeravataren øverst til højre på hovedsiden og vælge <span class=\\\"text-bold\\\">Mine eksporter.</span>",
    "Total unique downloads (comp.)": "Samlede unikke downloads (komp.)",
    "Unique downloads (comp.)": "Unikke downloads (komp.)",
    "Visitors browsers export": "Besøgende browsere eksporterer",
    "Visitors devices export": "Eksport af besøgendes enheder",
    "Visitors language export": "Eksport af besøgendes sprog",
    "Visitors locations export": "Eksport af besøgendes lokationer",
    "Visitors operating systems export": "Eksport af besøgendes operativsystemer",
    "Visitors organization export": "Besøgende organisation eksport",
    "Visits (comp.)": "Besøg (komp.)",
    "WCAG 2.1 (Level A) Mobile": "WCAG 2.1 (Niveau A) Mobil",
    "Your export is currently being generated.": "Din eksport genereres i øjeblikket.",
    "+ ' + (report.targets.length - maxTargets) + ' more": "+ ' + (report.targets.length - maxTargets) + ' mere",
    "Accessibility Checklist (WCAG 2.0)": "Tilgængelighedstjekliste (WCAG 2.0)",
    "Accessibility Checklist (WCAG 2.1)": "Tilgængelighedstjekliste (WCAG 2.1)",
    "Accessibility Checklist (WCAG 2.2)": "Tilgængelighedstjekliste (WCAG 2.2)",
    "Average no. of results pages viewed": "Gennemsnitligt antal. af de viste resultatsider",
    "Checklist": "Tjekliste",
    "Email *": "e-mail *",
    "Event actions": "Begivenhedshandlinger",
    "Event categories": "Begivenhedskategorier",
    "Event names": "Begivenhedsnavne",
    "First name *": "Fornavn *",
    "Last name *": "Efternavn *",
    "Search term": "Søgeord",
    "Search terms": "Søgeord",
    "Search terms with no results": "Søgeord uden resultater",
    "Site Search": "Site Search",
    "Site Search - Search Terms": "Site Search - Søgeord",
    "Site Search No Results Search Terms": "Site Search Ingen resultater Søgeord",
    "Switch between chart and table": "Skift mellem diagram og tabel",
    "Table": "Tabel",
    "more": "mere",
    "Accessibility checks update": "Opdatering af tilgængelighedstjek",
    "Account is under maintenance": "Kontoen er under vedligeholdelse",
    "Add internal URL": "Tilføj intern URL",
    "Add the name of the platform or company who provides this cookie.": "Tilføj navnet på den platform eller virksomhed, der leverer denne cookie.",
    "All PDFs": "Alle PDF'er",
    "All scheduled reports": "Alle planlagte rapporter",
    "An error has occurred - please try again": "Der er opstået en fejl - prøv venligst igen",
    "Are you sure you want mark as fixed": "Er du sikker på, at du vil markere som fast",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary for all languages?": "Er du sikker på, at du vil tilføje ordet <strong>[[word]]</strong> til ordbogen for alle sprog?",
    "Are you sure you want to add the word <strong>[[word]]</strong> to the dictionary?": "Er du sikker på, at du vil tilføje ordet <strong>[[word]]</strong> til ordbogen?",
    "Are you sure you want to confirm the word <strong>[[word]]</strong> as misspelling?": "Er du sikker på, at du vil bekræfte ordet <strong>[[word]]</strong> som stavefejl?",
    "Are you sure you want to ignore the misspelling <strong>[[word]]</strong> for all languages?": "Er du sikker på, at du vil ignorere stavefejlen <strong>[[word]]</strong> for alle sprog?",
    "Are you sure you want to mark the misspelling <strong>[[word]]</strong> as fixed?": "Er du sikker på, at du vil markere stavefejlen <strong>[[word]]</strong> som rettet?",
    "Are you sure you want to remove the Default label?": "Er du sikker på, at du vil fjerne standardetiketten?",
    "Are you sure you want to run the policy <strong>[[policyName]]</strong>?": "Er du sikker på, at du vil køre politikken <strong>[[policyName]]</strong>?",
    "Bar chart representing data": "Søjlediagram, der repræsenterer data",
    "Bar line chart representing": "Søjlelinjediagram, der repræsenterer",
    "Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.": "Vær opmærksom på, at en tom alt-attribut kan være tilstrækkelig og passende til dekorative billeder.",
    "Bubble chart representing data": "Boblediagram, der repræsenterer data",
    "Clear the field": "Ryd feltet",
    "Close submenu": "Luk undermenu",
    "Contact Support": "Kontakt support",
    "Cookie platform": "Cookie platform",
    "Current password is incorrect please try again": "Nuværende adgangskode er forkert, prøv igen",
    "Doughnut chart representing data": "Donut-diagram, der repræsenterer data",
    "Enable Cookieless Tracking": "Aktiver sporing uden cookies",
    "Errors and": "Fejl og",
    "Errors and Warnings": "Fejl og advarsler",
    "Events filter buttons": "Hændelsesfilterknapper",
    "Every 12 weeks": "Hver 12. uge",
    "Every 2 weeks": "Hver 2. uge",
    "Every 4 weeks": "Hver 4. uge",
    "Every 8 weeks": "Hver 8. uge",
    "Frequency": "Frekvens",
    "Image details": "Billeddetaljer",
    "Image metadata": "Billedmetadata",
    "Image preview": "Forhåndsvisning af billede",
    "Inventory image preview": "Forhåndsvisning af beholdningsbillede",
    "It seems like we are experience some issues with the page you are looking at.": "Det ser ud til, at vi oplever nogle problemer med den side, du kigger på.",
    "It seems like your computer is disconnected from the internet.": "Det ser ud til, at din computer er afbrudt fra internettet.",
    "Line chart representing data": "Linjediagram, der repræsenterer data",
    "List of received reports": "Liste over modtagne rapporter",
    "Metadata and pages": "Metadata og sider",
    "Metadata property": "Metadata-egenskab",
    "My scheduled reports": "Mine planlagte rapporter",
    "No date range selected": "Der er ikke valgt noget datointerval",
    "Norwegian": "norsk",
    "Only Errors": "Kun fejl",
    "Only errors": "Kun fejl",
    "Open dropdown with filters": "Åbn dropdown med filtre",
    "Open metadata view": "Åbn metadatavisning",
    "Open submenu with filters": "Åbn undermenu med filtre",
    "Pages that contain the Email": "Sider, der indeholder e-mailen",
    "Percentage shows the average compliance score across all pages on the domain": "Procentdel viser den gennemsnitlige overholdelsesscore på tværs af alle sider på domænet",
    "Pie chart representing data": "Cirkeldiagram, der repræsenterer data",
    "Platform": "Platform",
    "Please contact the support if this issue keeps happening": "Kontakt venligst supporten, hvis dette problem bliver ved med at ske",
    "Please refresh the browser when your computer is online again.": "Opdater venligst browseren, når din computer er online igen.",
    "Please try again later": "Prøv venligst igen senere",
    "Press to remove the label.": "Tryk på for at fjerne etiketten.",
    "Puppeteer 20": "Dukkefører 20",
    "Remove internal URL": "Fjern intern URL",
    "Scan all pages for cookies": "Scan alle sider for cookies",
    "Schedule this report": "Planlæg denne rapport",
    "Search in options": "Søg i muligheder",
    "Show HTML snippet details": "Vis detaljer om HTML-uddrag",
    "Show labels": "Vis etiketter",
    "Show less of the url snippet": "Vis mindre af webadressekodestykket",
    "Show the full url snippet": "Vis hele url-uddraget",
    "Showing": "Viser",
    "The average compliance score for this module for domains from other organizations within your industry:": "Den gennemsnitlige overholdelsesscore for dette modul for domæner fra andre organisationer inden for din branche:",
    "Unsubscribe from report": "Afmeld rapport",
    "Warnings": "Advarsler",
    "We export up to a maximum of 1000 rows": "Vi eksporterer op til et maksimum på 1000 rækker",
    "We recommend that you have an alt attribute with relevant content on all image tags.": "Vi anbefaler, at du har en alt-attribut med relevant indhold på alle billedtags.",
    "You have images missing an alt attribute.": "Du har billeder, der mangler en alt-attribut.",
    "[[name]] Remove": "[[name]] Fjern",
    "[[target]]": "[[mål]]",
    "default": "misligholdelse",
    "[[label]]": "[[mærke]]",
    "% of visitors staying after a search": "% af besøgende opholder sig efter en søgning",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc. Due to the regulatory framework requirements in your country, we are not able to coordinate document remediation directly for you; however, you are invited to reach out to NetCentric directly for a quote and remediation services at dherr@allyant.com. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy and will result in a transfer of data to third parties and third countries, including but not limited to the United States, Canada, Australia, and Egypt.": "Dokumentudbedring for overholdelse af WCAG 2.1 AA, Section 508, HHS eller PDF/UA tilgængelighedsstandarder udføres af vores datterselskab, NetCentric Technologies, Inc. På grund af de lovgivningsmæssige rammekrav i dit land er vi ikke i stand til at koordinere dokumentudbedring direkte for du; du er dog inviteret til at kontakte NetCentric direkte for et tilbud og afhjælpning på dherr@allyant.com. Bemærk venligst, at alle kontrakter om udbedring er mellem dig, kunden og NetCentric og underlagt NetCentrics vilkår og betingelser og privatlivspolitik og vil resultere i en overførsel af data til tredjeparter og tredjelande, inklusive men ikke begrænset til USA , Canada, Australien og Egypten.",
    "Document remediation for compliance to WCAG 2.1 AA, Section 508, HHS or PDF/UA accessibility standards is done by our affiliate, NetCentric Technologies, Inc.For remediation, we will coordinate with NetCentric to review the document and provide you a fixed price for the remediation. Upon completion of the work, NetCentric will also provide a compliance report. NetCentric will let you know if there is any Alternative Text (Alt-Text) required for images that are not self-descriptive or any related additional information needed to remediate the document. Please note that all contracts for remediation are between you, the Customer, and NetCentric, and subject to NetCentric's Terms and Conditions and Privacy Policy.": "Dokumentudbedring for overholdelse af WCAG 2.1 AA, Section 508, HHS eller PDF/UA tilgængelighedsstandarder udføres af vores datterselskab, NetCentric Technologies, Inc. Til udbedring vil vi koordinere med NetCentric for at gennemgå dokumentet og give dig en fast pris for afhjælpning. Efter afslutning af arbejdet vil NetCentric også levere en compliance-rapport. NetCentric vil fortælle dig, om der er en alternativ tekst (Alt-Text) påkrævet for billeder, der ikke er selvbeskrivende, eller andre relaterede yderligere oplysninger, der er nødvendige for at afhjælpe dokumentet. Bemærk venligst, at alle kontrakter om afhjælpning er mellem dig, kunden og NetCentric og underlagt NetCentrics vilkår og betingelser og privatlivspolitik.",
    "Japanese": "japansk",
    "Report Administration": "Rapport Administration",
    "Submit": "Indsend",
    "You have [[domains]] domain(s) on your account": "Du har [[domains]] domæne(r) på din konto",
    "Find domains by searching for the title or URL": "Find domæner ved at søge efter titlen eller URL'en",
    "Industry average score": "Branchegennemsnitsscore",
    "Proceed to add one more check": "Fortsæt med at tilføje en kontrol mere",
    "Readability test (for English pages only)": "Læsbarhedstest (kun for engelske sider)",
    "Request quote for more pages": "Anmod om tilbud på flere sider",
    "Request quote for more profiles": "Anmod om tilbud for flere profiler",
    "Search for domain": "Søg efter domæne",
    "The user does not have access to view this domain and any reports associated with it": "Brugeren har ikke adgang til at se dette domæne og eventuelle rapporter tilknyttet det",
    "Update all domain groups": "Opdater alle domænegrupper",
    "Update domain group": "Opdater domænegruppe",
    "Updating a group can take more than 30 minutes. During the operation you will not be able to create and update groups.": "Det kan tage mere end 30 minutter at opdatere en gruppe. Under operationen vil du ikke være i stand til at oprette og opdatere grupper.",
    "WCAG 2.2 (Level A)": "WCAG 2.2 (Niveau A)",
    "WCAG 2.2 (Level A) Mobile": "WCAG 2.2 (Niveau A) Mobil",
    "WCAG 2.2 (Level AA)": "WCAG 2.2 (niveau AA)",
    "WCAG 2.2 (Level AA) Mobile": "WCAG 2.2 (Niveau AA) Mobil",
    "WCAG 2.2 (Level AAA)": "WCAG 2.2 (niveau AAA)",
    "WCAG 2.2 (Level AAA) Mobile": "WCAG 2.2 (niveau AAA) Mobil",
    "You have reached the maximum number of Performance pages in your current plan.<br/><br/>To inquire about pricing options for additional pages, please press the button \\\"Request quote for more pages\\\" and someone on our team will be in touch.": "Du har nået det maksimale antal ydeevnesider i din nuværende plan.<br/><br/>For at forespørge om prismuligheder for yderligere sider skal du trykke på knappen \\\"Anmod om tilbud for flere sider\\\", og en person på vores team vil være i kontakt.",
    "You must perform a manual review of the page to confirm if this issue is present": "Du skal udføre en manuel gennemgang af siden for at bekræfte, om dette problem er til stede",
    "Accessibility Checklist (QUALWEB)": "Tilgængelighedstjekliste (QUALWEB)",
    "Accessibility checks cannot be ignored for domain groups. To ignore this check you must do it for the entire domain.": "Tilgængelighedstjek kan ikke ignoreres for domænegrupper. For at ignorere dette tjek skal du gøre det for hele domænet.",
    "Accessibility checks cannot be unignored for domain groups. To unignore this check you must do it for the entire domain.": "Tilgængelighedstjek kan ikke ignoreres for domænegrupper. For at ignorere dette tjek skal du gøre det for hele domænet.",
    "Check your spelling or try a shorter query.": "Tjek din stavning, eller prøv en kortere forespørgsel.",
    "Guidelines for QUALWEB": "Retningslinjer for QUALWEB",
    "Language not supported": "Sprog understøttes ikke",
    "No domains found.": "Ingen domæner fundet.",
    "QUALWEB Accessibility Compliance": "Overholdelse af QUALWEB tilgængelighed",
    "QualWeb (Level A)": "QualWeb (niveau A)",
    "QualWeb (Level AA)": "QualWeb (niveau AA)",
    "Score could not be generated": "Resultatet kunne ikke genereres",
    "Searching <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>": "Søger <span class=\\\"fas fa-spinner fa-spin fa-fw\\\"></span>",
    "The language of the page is not recognized as English. The Flesch-Kincaid test only works for English language. Change to the LIX test if you wish to generate scores for non-English pages.": "Sproget på siden genkendes ikke som engelsk. Flesch-Kincaid-testen virker kun for engelsk. Skift til LIX-testen, hvis du ønsker at generere resultater for ikke-engelske sider.",
    "We could not generate an accurate score for these pages. This is typically either due to the text on a page being too short, too long, or our web crawler not picking up any text at all.": "Vi kunne ikke generere en nøjagtig score for disse sider. Det skyldes typisk enten, at teksten på en side er for kort, for lang, eller at vores webcrawler slet ikke opfanger nogen tekst.",
    "Are you sure you want to add word [[word]] to all dictionaries": "Er du sikker på, at du vil tilføje ordet [[ord]] til alle ordbøger",
    "Are you sure you want to add word [[word]] to dictionary?": "Er du sikker på, at du vil tilføje ordet [[word]] til ordbogen?",
    "Are you sure you want to confirm the word [[word]] as misspelling?": "Er du sikker på, at du vil bekræfte ordet [[ord]] som stavefejl?",
    "Are you sure you want to ignore the misspelling [[word]] for all languages?": "Er du sikker på, at du vil ignorere stavefejlen [[word]] for alle sprog?",
    "Are you sure you want to mark the misspelling [[word]] as fixed?": "Er du sikker på, at du vil markere stavefejlen [[ord]] som rettet?",
    "Cannot forward more": "Kan ikke videresende mere",
    "Choose Date": "Vælg dato",
    "Compare": "Sammenligne",
    "Confirmed errors only": "Kun bekræftede fejl",
    "Exclude checks that require manual review": "Udelad kontrol, der kræver manuel gennemgang",
    "If this option is turned on, the domain scan only includes accessibility checks that can be automatically identified as errors. Checks requiring manual review are excluded.": "Hvis denne mulighed er slået til, inkluderer domænescanningen kun tilgængelighedstjek, der automatisk kan identificeres som fejl. Kontroller, der kræver manuel gennemgang, er udelukket.",
    "One month back": "En måned tilbage",
    "One month forward": "En måned frem",
    "Press to choose the end day": "Tryk på for at vælge slutdagen",
    "Press to choose the start day": "Tryk på for at vælge startdagen",
    "Remove compare range dates": "Fjern datoer for sammenligningsinterval",
    "The date cannot be in the future.": "Datoen kan ikke ligge i fremtiden.",
    "Toggle the datepicker": "Skift datovælgeren",
    "Add Policy with AI": "Tilføj politik med AI",
    "Consolidated Reports": "Konsoliderede rapporter",
    "Created with AI policy assistant": "Oprettet med AI-politikassistent",
    "Policy Assistant": "Politisk assistent",
    "Sparkle icon": "Glitrende ikon",
    "The Policy Assistant runs on Google Vertex AI, which can make mistakes.": "Policy Assistant kører på Google Vertex AI, som kan lave fejl.",
    "You have reached the maximum number of Performance profiles in your current plan.<br/><br/>To inquire about pricing options for additional profiles, please press the button \\\"Request quote for more profiles\\\" and someone on our team will be in touch.": "Du har nået det maksimale antal Performance-profiler i din nuværende plan.<br/><br/>For at forhøre dig om prismuligheder for yderligere profiler, skal du trykke på knappen \"Anmod om tilbud på flere profiler\", så kontakter en person fra vores team dig.",
    "You are about to perform a scan of <span class='text-link'>[[pageTitle]]</span> using the profile <span class='text-link'>[[profileName]]</span>.<br>The scan can take a few minutes to finalise, depending on the size of the page.<br><br>Do you want to continue?": "Du er ved at udføre en scanning af <span class='text-link'>[[pageTitle]]</span> ved hjælp af profilen <span class='text-link'>[[profileName]]</span>.<br>Det kan tage et par minutter at færdiggøre scanningen, afhængigt af sidens størrelse.<br><br>Vil du fortsætte?",
    "Doesn't scan automatically": "Scanner ikke automatisk",
    "Scans automatically": "Scanner automatisk",
    "with this": "med dette",
    "with this PDF": "med denne PDF",
    "with this archive file": "med denne arkivfil",
    "with this slide": "med disse slides",
    "with this spreadsheet": "med dette regneark",
    "with this text file": "med denne tekstfil",
    "Errors must be fixed for compliance.": "Fejl skal rettes for at overholde reglerne.",
    "Issues to Fix": "Problemer, der skal rettes",
    "Issues to Review": "Problemer, der skal gennemgås",
    "Reviews require manual judgement.": "Anmeldelser kræver manuel vurdering.",
    "Warnings are likely to be issues, but they require manual investigation.": "Advarsler vil sandsynligvis være problemer, men de kræver manuel undersøgelse.",
    "1 content": [
      "1 indhold",
      "{{$count}} indhold"
    ],
    "1 misspelling ignored across all domains": [
      "1 stavefejl ignoreret på tværs af alle domæner",
      "{{$count}} stavefejl ignoreret på tværs af alle domæner"
    ],
    "1 new cookie on": [
      "1 ny cookie på",
      "{{$count}} nye cookies på "
    ],
    "1 page": [
      "1 side",
      "{{$count}} sider"
    ],
    "1 page with one or more failing checks {{guideline}}": [
      "1 side med en eller flere fejlende kontroller {{guideline}}",
      "{{$count}} sider med en eller flere fejlende kontroller {{guideline}}"
    ],
    "1 page with one or more ignored checks {{guideline}}": [
      "1 side med en eller flere ignorerede kontroller {{guideline}}",
      "{{$count}} sider med en eller flere ignorerede kontroller {{guideline}}"
    ],
    "1 policy found": [
      "1 politik fundet",
      "{{$count}} policies fundet"
    ],
    "1 results": [
      "1 resultater",
      "{{$count}} resultater"
    ],
    "1 visit": [
      "1 besøg",
      "{{$count}} besøg"
    ],
    "1 word added across all domains": [
      "1 ord tilføjet på tværs af alle domæner",
      "{{$count}} ord tilføjet på tværs af alle domæner"
    ],
    "One word found": [
      "Et ord fundet",
      "{{$count}} ord fundet"
    ],
    "You have 1 user on your account": [
      "Du har 1 bruger på din konto",
      "Du har {{$count}} brugere på din konto"
    ],
    "Accessibility Compliance Scan": "Tilgængelighed compliance-scan",
    "Broken Links on Sitemap": "Ødelagte links på sitemap",
    "Broken links on sitemap": "Ødelagte links på sitemap",
    "Close Spotlight Search.": "Luk søgning",
    "Requested": "Anmodet",
    "Toggle Spotlight Search.": "Slå søgning til",
    "WCAG 2.2": "\nWCAG 2.2",
    "<p class='warning'>Acquia Web Governance is unable to restore the Profile.</p><p>You have reached the limit of the amount of profiles allowed on your account ([[maxProfiles]] profiles). Please contact our sales team to add more profiles to your plan or archive some profiles before restoring this one.</p>": "<p class='warning'>Acquia Web Governance kan ikke gendanne profilen.</p><p>Du har nået grænsen for antallet af tilladte profiler på din konto ([[maxProfiles]] profiler). Kontakt venligst vores salgsteam for at tilføje flere profiler til din plan eller arkiver nogle profiler, før du gendanner denne.</p>",
    "A cozy room with sofa, table and laptops that have Acquia Web Governance text": "Et hyggeligt værelse med sofa, bord og bærbare computere med Acquia Web Governance-tekst",
    "About Acquia Web Governance": "Om Acquia Web Governance",
    "Accept Acquia Web Governance Privacy Terms": "Accepter Acquia Web Governance Privatlivsvilkår",
    "Acquia Web Governance": "Acquia Web Governance",
    "Acquia Web Governance - Accessibility": "Acquia Web Governance - Tilgængelighed",
    "Acquia Web Governance - Accessibility Check List": "Acquia Web Governance - Tilgængelighedstjekliste",
    "Acquia Web Governance - Accessibility Guidelines": "Acquia Web Governance - Tilgængelighedsretningslinjer",
    "Acquia Web Governance - Account Dictionary": "Acquia Web Governance - Kontoordbog",
    "Acquia Web Governance - Admin Page Performance Profiles": "Acquia Web Governance - administratorsidepræstationsprofiler",
    "Acquia Web Governance - Audit Log": "Acquia Web Governance - Revisionslog",
    "Acquia Web Governance - Broken Images": "Acquia Web Governance - Ødelagte billeder",
    "Acquia Web Governance - Broken Links": "Acquia Web Governance - Ødelagte links",
    "Acquia Web Governance - Content With Broken Links": "Acquia Web Governance - Indhold med ødelagte links",
    "Acquia Web Governance - Content With QA Errors": "Acquia Web Governance - Indhold med QA-fejl",
    "Acquia Web Governance - Cookie Acceptance Rate": "Acquia Web Governance - Cookie Acceptrate",
    "Acquia Web Governance - Cookie Consent Log": "Acquia Web Governance - Log over samtykke til cookies",
    "Acquia Web Governance - Cookie Overview": "Acquia Web Governance - Cookieoversigt",
    "Acquia Web Governance - Dashboard": "Acquia Web Governance - Dashboard",
    "Acquia Web Governance - Data Privacy": "Acquia Web Governance - Databeskyttelse",
    "Acquia Web Governance - Data Privacy Check List": "Acquia Web Governance - Tjekliste til databeskyttelse",
    "Acquia Web Governance - Data Privacy Content": "Acquia Web Governance - Indhold om databeskyttelse",
    "Acquia Web Governance - Data Privacy Guidelines": "Acquia Web Governance - Retningslinjer for databeskyttelse",
    "Acquia Web Governance - Data Privacy Issues": "Acquia Web Governance - Problemer med databeskyttelse",
    "Acquia Web Governance - Data Privacy Summary": "Acquia Web Governance - Oversigt over databeskyttelse",
    "Acquia Web Governance - External PDF Compliance": "Acquia Web Governance - Ekstern PDF-overholdelse",
    "Acquia Web Governance - Fast Track": "Acquia Web Governance - Fast Track",
    "Acquia Web Governance - Heatmaps": "Acquia Web Governance - Heatmaps",
    "Acquia Web Governance - History Center": "Acquia Web Governance - Historisk Center",
    "Acquia Web Governance - Ignored Misspellings": "Acquia Web Governance - Ignorerede stavefejl",
    "Acquia Web Governance - Internal PDF Compliance": "Acquia Web Governance - Intern PDF-overholdelse",
    "Acquia Web Governance - Labels": "Acquia Web Governance - Etiketter",
    "Acquia Web Governance - Misspellings": "Acquia Web Governance - Stavefejl",
    "Acquia Web Governance - Page Performance Pages": "Acquia Web Governance - Sider med sidepræstation",
    "Acquia Web Governance - PageCorrect": "Acquia Web Governance - PageCorrect",
    "Acquia Web Governance - PageCorrect Accessibility Fixes": "Acquia Web Governance - PageCorrect Tilgængelighedsrettelser",
    "Acquia Web Governance - PageCorrect Content": "Acquia Web Governance - Sidekorrekt indhold",
    "Acquia Web Governance - Pages With Failing Checks": "Acquia Web Governance - Sider med fejlende kontroller",
    "Acquia Web Governance - Pages With Ignored Checks": "Acquia Web Governance - Sider med ignorerede kontroller",
    "Acquia Web Governance - Pages With Misspellings": "Acquia Web Governance - Sider med stavefejl",
    "Acquia Web Governance - Pages With Opportunity": "Acquia Web Governance - Sider med muligheder",
    "Acquia Web Governance - Potential Misspellings": "Acquia Web Governance - Mulige stavefejl",
    "Acquia Web Governance - Prioritized Content": "Acquia Web Governance - Prioriteret indhold",
    "Acquia Web Governance - Quality Assurance": "Acquia Web Governance - Kvalitetssikring",
    "Acquia Web Governance - Readability Checker": "Acquia Web Governance - Læsbarhedskontrol",
    "Acquia Web Governance - Readability Summary": "Acquia Web Governance - Læsbarhedsoversigt",
    "Acquia Web Governance - SEO Checkpoints": "Acquia Web Governance - SEO-tjekpunkter",
    "Acquia Web Governance - Search Engine Optimization": "Acquia Web Governance - Søgemaskineoptimering",
    "Acquia Web Governance - Spellcheck Summary": "Acquia Web Governance - Stavekontrol Oversigt",
    "Acquia Web Governance - User List": "Acquia Web Governance - Brugerliste",
    "Acquia Web Governance Consent Manager": "Acquia Web Governance Samtykkeadministrator",
    "Acquia Web Governance Extension": "Acquia Web Governance-udvidelse",
    "Acquia Web Governance PageAssist": "Acquia Web Governance PageAssist",
    "Acquia Web Governance users receiving this report": "Acquia Web Governance-brugere, der modtager denne rapport",
    "Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )": "Acquia Web Governance registrerer automatisk en download som et klik på et link, der slutter med en af ​​følgende filtypenavne (vær opmærksom på, at filtypenavnene skelner mellem store og små bogstaver)",
    "Add Acquia Web Governance Consent Manager": "Tilføj Acquia Web Governance Consent Manager",
    "An error has occurred - please try again. If the error continues, please contact Acquia Web Governance": "Der er opstået en fejl - prøv igen. Hvis fejlen fortsætter, bedes du kontakte Acquia Web Governance.",
    "Click here to contact Acquia Web Governance sales department to increase your maximum page count.": "Klik her for at kontakte Acquias Web Governance salgsafdeling for at øge dit maksimale sideantal.",
    "Copyright 2020 Acquia Web Governance. All rights reserved.": "Ophavsret 2020 Acquia Web Governance. Alle rettigheder forbeholdes.",
    "Enable if you want to use Acquia Web Governance in Accessibility mode": "Aktivér, hvis du vil bruge Acquia Web Governance i tilgængelighedstilstand",
    "For now Acquia Web Governance Pagecorrect will add a pop-up warning to every external link, allowing your visitors to choose for themselves if they wish to navigate away from the original page.": "For nuværende vil Acquia Web Governance Pagecorrect tilføje en pop op-advarsel til alle eksterne links, så dine besøgende selv kan vælge, om de ønsker at navigere væk fra den oprindelige side.",
    "From March 1, 2022, Acquia Web Governance will no longer be supporting any version of Internet Explorer or Edge browser version 78 or below. While you will still be able to log on and use Acquia Web Governance with Internet Explorer and older versions of Edge, we are no longer testing releases and fixing bugs specifically for those browsers. We encourage you to switch to another browser such as Chrome or newer version of Edge to be sure that Acquia Optimize continues to work optimally on your device.": "Fra 1. marts 2022 understøtter Acquia Web Governance ikke længere nogen version af Internet Explorer eller Edge-browser version 78 eller ældre. Selvom du stadig vil kunne logge på og bruge Acquia Web Governance med Internet Explorer og ældre versioner af Edge, tester vi ikke længere udgivelser og retter fejl specifikt til disse browsere. Vi opfordrer dig til at skifte til en anden browser, f.eks. Chrome eller en nyere version af Edge, for at sikre, at Acquia Optimize fortsat fungerer optimalt på din enhed.",
    "Get the Acquia Web Governance Extension": "Hent Acquia Web Governance-udvidelsen",
    "Monitor how visitors interact with your pages. Acquia Web Governance tracks up to a maximum of 1000 heatmaps sessions per page per month.": "Overvåg, hvordan besøgende interagerer med dine sider. Acquia Web Governance sporer op til maksimalt 1000 heatmaps-sessioner pr. side pr. måned.",
    "No more PDF accessibility scans are available for this account. Please contact a Acquia Web Governance sales department to add more.": "Der er ikke flere PDF-tilgængelighedsscanninger tilgængelige for denne konto. Kontakt venligst en Acquia Web Governance-salgsafdeling for at tilføje flere.",
    "PageCorrect failed to save, the Acquia Web Governance team has been notified of the error": "PageCorrect kunne ikke gemmes. Acquia Web Governance-teamet er blevet underrettet om fejlen.",
    "Schedule reports for yourself [[adminText]] by email after every Acquia Web Governance scan": "Planlæg rapporter for dig selv [[adminText]] via e-mail efter hver Acquia Web Governance-scanning",
    "Something went wrong. The Acquia Web Governance Team has been notified of this error and will get back to you, as soon as possible.": "Noget gik galt. Acquia Web Governance-teamet er blevet underrettet om denne fejl og vender tilbage til dig hurtigst muligt.",
    "Switch to Acquia Web Governance classic": "Skift til Acquia Web Governance klassisk",
    "The Acquia Web Governance team is notified and are working on the issue.": "Acquia Web Governance-teamet er underrettet og arbejder på problemet.",
    "There's only one way of doing this. Acquia Web Governance will replace all the &lt;I&gt; tags it can find on your website with em tags instead.": "Der er kun én måde at gøre dette på. Acquia Web Governance vil erstatte alle de <I>-tags, den kan finde på dit websted, med em-tags i stedet.",
    "You are using the new version of Acquia Web Governance PageAssist. If you wish to revert back to v.1.0 click here": "Du bruger den nye version af Acquia Web Governance PageAssist. Hvis du ønsker at vende tilbage til v.1.0, skal du klikke her.",
    "Your current plan does not include on-demand scans. Please reach out to your Acquia Web Governance representative to learn more about this option": "Din nuværende plan inkluderer ikke scanninger on-demand. Kontakt venligst din Acquia Web Governance-repræsentant for at få mere at vide om denne mulighed.",
    "failed when trying to ignore/review all. please try agin, or contact the Acquia Web Governance team": "Kunne ikke ignorere/gennemgå alle. Prøv igen, eller kontakt Acquia Web Governance-teamet.",
    "Start export PDF Accessibility Report": "Start eksport af PDF Accessibility Report",
    "No data showing? Add the Acquia Web Governance script to your website": "Viser du ingen statistik? Tilføj Acquia Web Governance-scriptet til webstedet."
  }
}
